//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | null | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resolveTenantId(body: ResolveTenantIdInput | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processResolveTenantId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | null | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | null | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordOutput>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailActivationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateEmail(body: ActivateEmailInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonate(body: ImpersonateInput | null | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonateOutput>(null as any);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToImpersonator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonateOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    switchToLinkedAccount(body: SwitchToLinkedAccountInput | null | undefined): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchToLinkedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchToLinkedAccountOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchToLinkedAccountOutput>;
        }));
    }

    protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SwitchToLinkedAccountOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwitchToLinkedAccountOutput>(null as any);
    }
}

@Injectable()
export class AgendaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateSortOrder(body: SortOrderInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/CreateUpdateSortOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateSortOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateSortOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processCreateUpdateSortOrder(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateIndexedSortOrder(body: SortOrderIndexedInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/CreateUpdateIndexedSortOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateIndexedSortOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateIndexedSortOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processCreateUpdateIndexedSortOrder(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param userFilter (optional) 
     * @param teamFilter (optional) 
     * @param listView (optional) 
     * @param searchText (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTeamCardDetails(userId: number | null | undefined, tenantId: number | null | undefined, userFilter: number[] | null | undefined, teamFilter: number[] | null | undefined, listView: number | null | undefined, searchText: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<TeamCountsTeamCardListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/GetTeamCardDetails?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userFilter !== undefined && userFilter !== null)
            userFilter && userFilter.forEach(item => { url_ += "UserFilter=" + encodeURIComponent("" + item) + "&"; });
        if (teamFilter !== undefined && teamFilter !== null)
            teamFilter && teamFilter.forEach(item => { url_ += "TeamFilter=" + encodeURIComponent("" + item) + "&"; });
        if (listView !== undefined && listView !== null)
            url_ += "ListView=" + encodeURIComponent("" + listView) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamCardDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamCardDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeamCountsTeamCardListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeamCountsTeamCardListValueTupleIHandleError>;
        }));
    }

    protected processGetTeamCardDetails(response: HttpResponseBase): Observable<TeamCountsTeamCardListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TeamCountsTeamCardListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TeamCountsTeamCardListValueTupleIHandleError>(null as any);
    }

    /**
     * @param agendaDate (optional) 
     * @param userIds (optional) 
     * @param teamFilter (optional) 
     * @param activityFilter (optional) 
     * @param inOutType (optional) 
     * @param hasBlocker (optional) 
     * @param timeFilter (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getActivityCardDetail(agendaDate: string | null | undefined, userIds: string[] | null | undefined, teamFilter: string[] | null | undefined, activityFilter: number | null | undefined, inOutType: any | null | undefined, hasBlocker: boolean | null | undefined, timeFilter: number | null | undefined, filter: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<UserCheckinIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/GetActivityCardDetail?";
        if (agendaDate !== undefined && agendaDate !== null)
            url_ += "AgendaDate=" + encodeURIComponent("" + agendaDate) + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (teamFilter !== undefined && teamFilter !== null)
            teamFilter && teamFilter.forEach(item => { url_ += "TeamFilter=" + encodeURIComponent("" + item) + "&"; });
        if (activityFilter !== undefined && activityFilter !== null)
            url_ += "ActivityFilter=" + encodeURIComponent("" + activityFilter) + "&";
        if (inOutType !== undefined && inOutType !== null)
            url_ += "InOutType=" + encodeURIComponent("" + inOutType) + "&";
        if (hasBlocker !== undefined && hasBlocker !== null)
            url_ += "HasBlocker=" + encodeURIComponent("" + hasBlocker) + "&";
        if (timeFilter !== undefined && timeFilter !== null)
            url_ += "TimeFilter=" + encodeURIComponent("" + timeFilter) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityCardDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityCardDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCheckinIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCheckinIHandleError>;
        }));
    }

    protected processGetActivityCardDetail(response: HttpResponseBase): Observable<UserCheckinIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserCheckinIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCheckinIHandleError>(null as any);
    }

    /**
     * @param userid (optional) 
     * @return Success
     */
    getTeamUserReport(userid: number | null | undefined): Observable<TaskCompletionListWorkSummariesListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/GetTeamUserReport?";
        if (userid !== undefined && userid !== null)
            url_ += "userid=" + encodeURIComponent("" + userid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamUserReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamUserReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskCompletionListWorkSummariesListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskCompletionListWorkSummariesListIHandleError>;
        }));
    }

    protected processGetTeamUserReport(response: HttpResponseBase): Observable<TaskCompletionListWorkSummariesListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskCompletionListWorkSummariesListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskCompletionListWorkSummariesListIHandleError>(null as any);
    }

    /**
     * @param taskDate (optional) 
     * @param userIds (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getMyAgenda(taskDate: string | null | undefined, userIds: string | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/GetMyAgenda?";
        if (taskDate !== undefined && taskDate !== null)
            url_ += "TaskDate=" + encodeURIComponent("" + taskDate) + "&";
        if (userIds !== undefined && userIds !== null)
            url_ += "UserIds=" + encodeURIComponent("" + userIds) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyAgenda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyAgenda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError>;
        }));
    }

    protected processGetMyAgenda(response: HttpResponseBase): Observable<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskCountsListGetUserAgendaOutputListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError>(null as any);
    }

    /**
     * @param workDate (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getMyProductivity(workDate: string | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<Int32TaskCompletionListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/GetMyProductivity?";
        if (workDate !== undefined && workDate !== null)
            url_ += "WorkDate=" + encodeURIComponent("" + workDate) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyProductivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyProductivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32TaskCompletionListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32TaskCompletionListValueTupleIHandleError>;
        }));
    }

    protected processGetMyProductivity(response: HttpResponseBase): Observable<Int32TaskCompletionListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32TaskCompletionListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32TaskCompletionListValueTupleIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param filterDaysType (optional) 
     * @param filterStatusType (optional) 
     * @param projectIds (optional) 
     * @return Success
     */
    getMyAgendaHistories(searchText: string | null | undefined, filterDaysType: any | null | undefined, filterStatusType: any | null | undefined, projectIds: number[] | null | undefined): Observable<TodosTaskGroupDtoListTodosTaskListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/GetMyAgendaHistories?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (filterDaysType !== undefined && filterDaysType !== null)
            url_ += "FilterDaysType=" + encodeURIComponent("" + filterDaysType) + "&";
        if (filterStatusType !== undefined && filterStatusType !== null)
            url_ += "FilterStatusType=" + encodeURIComponent("" + filterStatusType) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyAgendaHistories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyAgendaHistories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodosTaskGroupDtoListTodosTaskListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodosTaskGroupDtoListTodosTaskListValueTupleIHandleError>;
        }));
    }

    protected processGetMyAgendaHistories(response: HttpResponseBase): Observable<TodosTaskGroupDtoListTodosTaskListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TodosTaskGroupDtoListTodosTaskListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosTaskGroupDtoListTodosTaskListValueTupleIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getMyDay(): Observable<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/GetMyDay";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError>;
        }));
    }

    protected processGetMyDay(response: HttpResponseBase): Observable<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getUserSectionIdeas(): Observable<UserSectionIdeasOutputListIdeasTitleDescriptionListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/GetUserSectionIdeas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSectionIdeas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSectionIdeas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSectionIdeasOutputListIdeasTitleDescriptionListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSectionIdeasOutputListIdeasTitleDescriptionListValueTupleIHandleError>;
        }));
    }

    protected processGetUserSectionIdeas(response: HttpResponseBase): Observable<UserSectionIdeasOutputListIdeasTitleDescriptionListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserSectionIdeasOutputListIdeasTitleDescriptionListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSectionIdeasOutputListIdeasTitleDescriptionListValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUserSections(body: CreateOrUpdateUserSectionsInput | null | undefined): Observable<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/CreateOrUpdateUserSections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUserSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUserSections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError>;
        }));
    }

    protected processCreateOrUpdateUserSections(response: HttpResponseBase): Observable<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaskMyDaySection(body: UpdateTaskMyDaySection | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/UpdateTaskMyDaySection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskMyDaySection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskMyDaySection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateTaskMyDaySection(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sectionId (optional) 
     * @return Success
     */
    deleteUserSection(userId: number | null | undefined, sectionId: number | null | undefined): Observable<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/DeleteUserSection?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sectionId !== undefined && sectionId !== null)
            url_ += "SectionId=" + encodeURIComponent("" + sectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError>;
        }));
    }

    protected processDeleteUserSection(response: HttpResponseBase): Observable<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getUserSections(): Observable<UserSectionsDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/GetUserSections";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSectionsDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSectionsDtoListIHandleError>;
        }));
    }

    protected processGetUserSections(response: HttpResponseBase): Observable<UserSectionsDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserSectionsDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSectionsDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMyDayListSort(body: DayListSorting | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/UpdateMyDayListSort";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMyDayListSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMyDayListSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateMyDayListSort(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEventIsSeenById(body: UpdateIsSeenDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/UpdateEventIsSeenById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEventIsSeenById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEventIsSeenById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateEventIsSeenById(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEventIsNewById(body: UpdateIsSeenDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/UpdateEventIsNewById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEventIsNewById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEventIsNewById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateEventIsNewById(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param eventId (optional) 
     * @param code (optional) 
     * @return Success
     */
    markCompleteInCompleteEvent(eventId: number | null | undefined, code: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/MarkCompleteInCompleteEventAsync?";
        if (eventId !== undefined && eventId !== null)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkCompleteInCompleteEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkCompleteInCompleteEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMarkCompleteInCompleteEvent(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateTaskManagementSettings(body: CreateUpdateTaskManagementSettingsInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/CreateUpdateTaskManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateTaskManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateTaskManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processCreateUpdateTaskManagementSettings(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getTaskManagementSettings(): Observable<TaskManagementSettingsListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/GetTaskManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskManagementSettingsListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskManagementSettingsListIHandleError>;
        }));
    }

    protected processGetTaskManagementSettings(response: HttpResponseBase): Observable<TaskManagementSettingsListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskManagementSettingsListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskManagementSettingsListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    smartPrioritizeMyAgenda(body: SmartPrioritizeInput | null | undefined): Observable<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/SmartPrioritizeMyAgenda";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSmartPrioritizeMyAgenda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSmartPrioritizeMyAgenda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError>;
        }));
    }

    protected processSmartPrioritizeMyAgenda(response: HttpResponseBase): Observable<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskCountsListGetUserAgendaOutputListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    undoSmartPrioritize(body: SmartPrioritizeInput | null | undefined): Observable<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Agenda/UndoSmartPrioritize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoSmartPrioritize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoSmartPrioritize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError>;
        }));
    }

    protected processUndoSmartPrioritize(response: HttpResponseBase): Observable<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskCountsListGetUserAgendaOutputListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError>(null as any);
    }
}

@Injectable()
export class AgendaConsolidatedServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getMyDayConsolidated(): Observable<GetMyDayTaskGroupedOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/AgendaConsolidated/GetMyDayConsolidated";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyDayConsolidated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyDayConsolidated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMyDayTaskGroupedOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMyDayTaskGroupedOutputListIHandleError>;
        }));
    }

    protected processGetMyDayConsolidated(response: HttpResponseBase): Observable<GetMyDayTaskGroupedOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetMyDayTaskGroupedOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyDayTaskGroupedOutputListIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getCompleted(): Observable<GetMyDayTaskGroupedOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/AgendaConsolidated/GetCompleted";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMyDayTaskGroupedOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMyDayTaskGroupedOutputListIHandleError>;
        }));
    }

    protected processGetCompleted(response: HttpResponseBase): Observable<GetMyDayTaskGroupedOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetMyDayTaskGroupedOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyDayTaskGroupedOutputListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeAssignee(body: ChangeAssigneeBulkInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/AgendaConsolidated/ChangeAssignee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeAssignee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeAssignee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processChangeAssignee(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePriority(body: SetPriorityBulkInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/AgendaConsolidated/ChangePriority";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePriority(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePriority(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processChangePriority(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDates(body: SetDateBulkInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/AgendaConsolidated/UpdateDates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateDates(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveToProject(body: MoveToProjectBulkInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/AgendaConsolidated/MoveToProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveToProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveToProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMoveToProject(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param commentList (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllComments(commentList: any | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<UnifiedCommentDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/AgendaConsolidated/GetAllComments?";
        if (commentList !== undefined && commentList !== null)
            url_ += "CommentList=" + encodeURIComponent("" + commentList) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnifiedCommentDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnifiedCommentDtoListIHandleError>;
        }));
    }

    protected processGetAllComments(response: HttpResponseBase): Observable<UnifiedCommentDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UnifiedCommentDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UnifiedCommentDtoListIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @return Success
     */
    searchComments(searchText: string | null | undefined): Observable<UnifiedCommentDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/AgendaConsolidated/SearchComments?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnifiedCommentDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnifiedCommentDtoListIHandleError>;
        }));
    }

    protected processSearchComments(response: HttpResponseBase): Observable<UnifiedCommentDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UnifiedCommentDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UnifiedCommentDtoListIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    readAllComments(): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/AgendaConsolidated/ReadAllComments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadAllComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadAllComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processReadAllComments(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTaskComments(taskId: number | null | undefined): Observable<TaskCommentDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/AgendaConsolidated/GetTaskComments?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskCommentDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskCommentDtoListIHandleError>;
        }));
    }

    protected processGetTaskComments(response: HttpResponseBase): Observable<TaskCommentDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskCommentDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskCommentDtoListIHandleError>(null as any);
    }
}

@Injectable()
export class AiStreamServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateNotes(body: StreamGenerateInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/AiStream/GenerateNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateNotes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refineNotes(body: StreamRefineInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/AiStream/RefineNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefineNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefineNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefineNotes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AnnouncementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return Success
     */
    getTenantAnnouncements(userId: number | null | undefined, tenantId: number | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined, filter: string | null | undefined): Observable<TenantAnnouncementDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Announcement/GetTenantAnnouncements?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantAnnouncements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantAnnouncements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantAnnouncementDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantAnnouncementDtoListIHandleError>;
        }));
    }

    protected processGetTenantAnnouncements(response: HttpResponseBase): Observable<TenantAnnouncementDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TenantAnnouncementDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantAnnouncementDtoListIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAnnouncement(id: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Announcement/DeleteAnnouncement?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAnnouncement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAnnouncement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteAnnouncement(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateTenantAnnouncement(body: TenantAnnouncementDto | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Announcement/CreateOrUpdateTenantAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateTenantAnnouncement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateTenantAnnouncement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processCreateOrUpdateTenantAnnouncement(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantAnnouncementById(id: number | null | undefined): Observable<TenantAnnouncementDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Announcement/GetTenantAnnouncementById?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantAnnouncementById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantAnnouncementById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantAnnouncementDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantAnnouncementDtoListIHandleError>;
        }));
    }

    protected processGetTenantAnnouncementById(response: HttpResponseBase): Observable<TenantAnnouncementDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TenantAnnouncementDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantAnnouncementDtoListIHandleError>(null as any);
    }
}

@Injectable()
export class AttachmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @param userId (optional) 
     * @param entityId (optional) 
     * @param entityType (optional) 
     * @return Success
     */
    deleteAttachment(id: number | null | undefined, userId: number | null | undefined, entityId: number | null | undefined, entityType: any | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Attachment/DeleteAttachment?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType !== undefined && entityType !== null)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAttachment(body: CommonAttachment | null | undefined): Observable<Int64IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Attachment/CreateAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int64IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int64IHandleError>;
        }));
    }

    protected processCreateAttachment(response: HttpResponseBase): Observable<Int64IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int64IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int64IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAttachment(body: CommonAttachment | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Attachment/CreateOrUpdateAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processCreateOrUpdateAttachment(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getAttachmentByTaskId(taskId: number | null | undefined): Observable<TaskAttachmentListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Attachment/GetAttachmentByTaskId?";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskAttachmentListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskAttachmentListIHandleError>;
        }));
    }

    protected processGetAttachmentByTaskId(response: HttpResponseBase): Observable<TaskAttachmentListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskAttachmentListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskAttachmentListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getAttachmentByProjectId(projectId: number | null | undefined): Observable<CommonAttachmentDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Attachment/GetAttachmentByProjectId?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonAttachmentDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonAttachmentDtoListIHandleError>;
        }));
    }

    protected processGetAttachmentByProjectId(response: HttpResponseBase): Observable<CommonAttachmentDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CommonAttachmentDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonAttachmentDtoListIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getProjectFilesAndFolders(): Observable<ProjectAttachmentOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Attachment/GetProjectFilesAndFolders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectFilesAndFolders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectFilesAndFolders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectAttachmentOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectAttachmentOutputListIHandleError>;
        }));
    }

    protected processGetProjectFilesAndFolders(response: HttpResponseBase): Observable<ProjectAttachmentOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectAttachmentOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectAttachmentOutputListIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getProjectLinks(): Observable<ProjectAttachmentOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Attachment/GetProjectLinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectAttachmentOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectAttachmentOutputListIHandleError>;
        }));
    }

    protected processGetProjectLinks(response: HttpResponseBase): Observable<ProjectAttachmentOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectAttachmentOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectAttachmentOutputListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getTaskAttachmentByProjectId(projectId: number | null | undefined): Observable<ProjectTaskAttachmentListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Attachment/GetTaskAttachmentByProjectId?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskAttachmentByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskAttachmentByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTaskAttachmentListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTaskAttachmentListIHandleError>;
        }));
    }

    protected processGetTaskAttachmentByProjectId(response: HttpResponseBase): Observable<ProjectTaskAttachmentListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectTaskAttachmentListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectTaskAttachmentListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setProjectDefaultFolder(body: SetProjectDefaultFolderInputDto | null | undefined): Observable<CommonAttachmentDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Attachment/SetProjectDefaultFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProjectDefaultFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProjectDefaultFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonAttachmentDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonAttachmentDtoListIHandleError>;
        }));
    }

    protected processSetProjectDefaultFolder(response: HttpResponseBase): Observable<CommonAttachmentDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CommonAttachmentDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonAttachmentDtoListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getProjectFolder(projectId: number | null | undefined): Observable<ProjectFolderDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Attachment/GetProjectFolder?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectFolderDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectFolderDtoListIHandleError>;
        }));
    }

    protected processGetProjectFolder(response: HttpResponseBase): Observable<ProjectFolderDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectFolderDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectFolderDtoListIHandleError>(null as any);
    }
}

@Injectable()
export class BillingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getStatus(): Observable<BillingStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingStatusDto>;
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<BillingStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BillingStatusDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillingStatusDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCheckoutSession(body: CreateCheckoutSessionInput | null | undefined): Observable<CheckoutSessionOutput> {
        let url_ = this.baseUrl + "/api/services/app/Billing/CreateCheckoutSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCheckoutSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCheckoutSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckoutSessionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckoutSessionOutput>;
        }));
    }

    protected processCreateCheckoutSession(response: HttpResponseBase): Observable<CheckoutSessionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CheckoutSessionOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckoutSessionOutput>(null as any);
    }

    /**
     * @param sessionId (optional) 
     * @return Success
     */
    getCheckoutStatus(sessionId: string | null | undefined): Observable<CheckoutStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetCheckoutStatus?";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckoutStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckoutStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckoutStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckoutStatusDto>;
        }));
    }

    protected processGetCheckoutStatus(response: HttpResponseBase): Observable<CheckoutStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CheckoutStatusDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckoutStatusDto>(null as any);
    }

    /**
     * @return Success
     */
    createBillingPortalSession(): Observable<BillingPortalSessionOutput> {
        let url_ = this.baseUrl + "/api/services/app/Billing/CreateBillingPortalSession";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBillingPortalSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBillingPortalSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingPortalSessionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingPortalSessionOutput>;
        }));
    }

    protected processCreateBillingPortalSession(response: HttpResponseBase): Observable<BillingPortalSessionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BillingPortalSessionOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillingPortalSessionOutput>(null as any);
    }

    /**
     * @return Success
     */
    askAdminToUpgrade(): Observable<AskAdminToUpgradeOutput> {
        let url_ = this.baseUrl + "/api/services/app/Billing/AskAdminToUpgrade";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAskAdminToUpgrade(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAskAdminToUpgrade(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AskAdminToUpgradeOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AskAdminToUpgradeOutput>;
        }));
    }

    protected processAskAdminToUpgrade(response: HttpResponseBase): Observable<AskAdminToUpgradeOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AskAdminToUpgradeOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AskAdminToUpgradeOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markUpgradePromptShown(body: UpgradePromptShownInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Billing/MarkUpgradePromptShown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkUpgradePromptShown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkUpgradePromptShown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkUpgradePromptShown(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getPlanChangeOptions(): Observable<PlanChangeOptionsDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetPlanChangeOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanChangeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanChangeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanChangeOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanChangeOptionsDto>;
        }));
    }

    protected processGetPlanChangeOptions(response: HttpResponseBase): Observable<PlanChangeOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PlanChangeOptionsDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanChangeOptionsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePlan(body: ChangePlanInput | null | undefined): Observable<ChangePlanOutput> {
        let url_ = this.baseUrl + "/api/services/app/Billing/ChangePlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangePlanOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangePlanOutput>;
        }));
    }

    protected processChangePlan(response: HttpResponseBase): Observable<ChangePlanOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ChangePlanOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangePlanOutput>(null as any);
    }
}

@Injectable()
export class BotFrameworkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    sendTeamsMessage(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BotFramework/SendTeamsMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTeamsMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTeamsMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTeamsMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getBotDownloadUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BotFramework/GetBotDownloadUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBotDownloadUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBotDownloadUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetBotDownloadUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    hasDownloadedBot(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BotFramework/HasDownloadedBot";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasDownloadedBot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasDownloadedBot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasDownloadedBot(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<CacheDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CacheDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CacheDtoListResultDto>;
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<CacheDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CacheDtoListResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CacheDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clearCache(body: StringEntityDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CalendarServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param currentUserId (optional) 
     * @param filterType (optional) 
     * @param startDateFilter (optional) 
     * @param endDateFilter (optional) 
     * @param searchText (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getMyCalendar(currentUserId: number | null | undefined, filterType: any | null | undefined, startDateFilter: string | null | undefined, endDateFilter: string | null | undefined, searchText: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetMyCalendar?";
        if (currentUserId !== undefined && currentUserId !== null)
            url_ += "CurrentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        if (filterType !== undefined && filterType !== null)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        if (startDateFilter !== undefined && startDateFilter !== null)
            url_ += "StartDateFilter=" + encodeURIComponent("" + startDateFilter) + "&";
        if (endDateFilter !== undefined && endDateFilter !== null)
            url_ += "EndDateFilter=" + encodeURIComponent("" + endDateFilter) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError>;
        }));
    }

    protected processGetMyCalendar(response: HttpResponseBase): Observable<CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param selectedDate (optional) 
     * @return Success
     */
    getMyMeetings(userId: number | null | undefined, selectedDate: string | null | undefined): Observable<MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetMyMeetings?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (selectedDate !== undefined && selectedDate !== null)
            url_ += "SelectedDate=" + encodeURIComponent("" + selectedDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyMeetings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyMeetings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError>;
        }));
    }

    protected processGetMyMeetings(response: HttpResponseBase): Observable<MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError>(null as any);
    }

    /**
     * @param inludeIsSeen (optional) 
     * @return Success
     */
    updateEventIsNewByUserId(inludeIsSeen: boolean | null | undefined): Observable<CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/UpdateEventIsNewByUserId?";
        if (inludeIsSeen !== undefined && inludeIsSeen !== null)
            url_ += "inludeIsSeen=" + encodeURIComponent("" + inludeIsSeen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEventIsNewByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEventIsNewByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError>;
        }));
    }

    protected processUpdateEventIsNewByUserId(response: HttpResponseBase): Observable<CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError>(null as any);
    }

    /**
     * @param eventId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getCalendarEventById(eventId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<GetCalendarEventByIdIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetCalendarEventById?";
        if (eventId !== undefined && eventId !== null)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarEventById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarEventById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCalendarEventByIdIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCalendarEventByIdIHandleError>;
        }));
    }

    protected processGetCalendarEventById(response: HttpResponseBase): Observable<GetCalendarEventByIdIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetCalendarEventByIdIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCalendarEventByIdIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    updateIsSeenByEventId(id: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/UpdateIsSeenByEventId?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIsSeenByEventId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIsSeenByEventId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processUpdateIsSeenByEventId(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getMyMeetingsForWidget(): Observable<Int32MeetingsForWidgetListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetMyMeetingsForWidget";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyMeetingsForWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyMeetingsForWidget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32MeetingsForWidgetListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32MeetingsForWidgetListValueTupleIHandleError>;
        }));
    }

    protected processGetMyMeetingsForWidget(response: HttpResponseBase): Observable<Int32MeetingsForWidgetListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32MeetingsForWidgetListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32MeetingsForWidgetListValueTupleIHandleError>(null as any);
    }

    /**
     * @param onlyOnMyday (optional) 
     * @return Success
     */
    getMyCalendarForPlanner(onlyOnMyday: boolean | null | undefined): Observable<CalendarPlannerDetailsUserCalenderForPlannerListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetMyCalendarForPlanner?";
        if (onlyOnMyday !== undefined && onlyOnMyday !== null)
            url_ += "onlyOnMyday=" + encodeURIComponent("" + onlyOnMyday) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyCalendarForPlanner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyCalendarForPlanner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarPlannerDetailsUserCalenderForPlannerListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarPlannerDetailsUserCalenderForPlannerListValueTupleIHandleError>;
        }));
    }

    protected processGetMyCalendarForPlanner(response: HttpResponseBase): Observable<CalendarPlannerDetailsUserCalenderForPlannerListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CalendarPlannerDetailsUserCalenderForPlannerListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarPlannerDetailsUserCalenderForPlannerListValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveUserEventToMyDay(body: EventAddedOnMyDay[] | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/MoveUserEventToMyDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveUserEventToMyDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveUserEventToMyDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processMoveUserEventToMyDay(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getUserFreeTime(): Observable<FreeTimeDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetUserFreeTime";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserFreeTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserFreeTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FreeTimeDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FreeTimeDtoListIHandleError>;
        }));
    }

    protected processGetUserFreeTime(response: HttpResponseBase): Observable<FreeTimeDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = FreeTimeDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FreeTimeDtoListIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param isDueToday (optional) 
     * @param isOverDue (optional) 
     * @param isUpComing (optional) 
     * @param projectIds (optional) 
     * @param isFollowUp (optional) 
     * @param isTask (optional) 
     * @param isMeeting (optional) 
     * @return Success
     */
    getTodosMeetings(searchText: string | null | undefined, isDueToday: boolean | null | undefined, isOverDue: boolean | null | undefined, isUpComing: boolean | null | undefined, projectIds: number[] | null | undefined, isFollowUp: boolean | null | undefined, isTask: boolean | null | undefined, isMeeting: boolean | null | undefined): Observable<UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetTodosMeetings?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (isDueToday !== undefined && isDueToday !== null)
            url_ += "IsDueToday=" + encodeURIComponent("" + isDueToday) + "&";
        if (isOverDue !== undefined && isOverDue !== null)
            url_ += "IsOverDue=" + encodeURIComponent("" + isOverDue) + "&";
        if (isUpComing !== undefined && isUpComing !== null)
            url_ += "IsUpComing=" + encodeURIComponent("" + isUpComing) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (isFollowUp !== undefined && isFollowUp !== null)
            url_ += "IsFollowUp=" + encodeURIComponent("" + isFollowUp) + "&";
        if (isTask !== undefined && isTask !== null)
            url_ += "IsTask=" + encodeURIComponent("" + isTask) + "&";
        if (isMeeting !== undefined && isMeeting !== null)
            url_ += "IsMeeting=" + encodeURIComponent("" + isMeeting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodosMeetings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodosMeetings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTupleIHandleError>;
        }));
    }

    protected processGetTodosMeetings(response: HttpResponseBase): Observable<UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTupleIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getTodosMeetingsToday(searchText: string | null | undefined, userId: number | null | undefined): Observable<UserMeetingsListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetTodosMeetingsToday?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodosMeetingsToday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodosMeetingsToday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMeetingsListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMeetingsListIHandleError>;
        }));
    }

    protected processGetTodosMeetingsToday(response: HttpResponseBase): Observable<UserMeetingsListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserMeetingsListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserMeetingsListIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param timezoneView (optional) 
     * @return Success
     */
    getUserActivityTodayMeetings(userId: number | null | undefined, timezoneView: number | null | undefined): Observable<GetUserActivityMeetingsOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetUserActivityTodayMeetings?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (timezoneView !== undefined && timezoneView !== null)
            url_ += "TimezoneView=" + encodeURIComponent("" + timezoneView) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityTodayMeetings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityTodayMeetings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserActivityMeetingsOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserActivityMeetingsOutputListIHandleError>;
        }));
    }

    protected processGetUserActivityTodayMeetings(response: HttpResponseBase): Observable<GetUserActivityMeetingsOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetUserActivityMeetingsOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserActivityMeetingsOutputListIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param timezoneView (optional) 
     * @return Success
     */
    getUserActivityUpComingMeetings(userId: number | null | undefined, timezoneView: number | null | undefined): Observable<UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetUserActivityUpComingMeetings?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (timezoneView !== undefined && timezoneView !== null)
            url_ += "TimezoneView=" + encodeURIComponent("" + timezoneView) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityUpComingMeetings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityUpComingMeetings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTupleIHandleError>;
        }));
    }

    protected processGetUserActivityUpComingMeetings(response: HttpResponseBase): Observable<UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptOrDeclineMeeting(body: MeetingResponseDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/AcceptOrDeclineMeeting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptOrDeclineMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptOrDeclineMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAcceptOrDeclineMeeting(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }
}

@Injectable()
export class CalendarAccessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAccessList(): Observable<CalendarAccessRowDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CalendarAccess/GetAccessList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarAccessRowDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarAccessRowDto[]>;
        }));
    }

    protected processGetAccessList(response: HttpResponseBase): Observable<CalendarAccessRowDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarAccessRowDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarAccessRowDto[]>(null as any);
    }

    /**
     * @param ownerUserId (optional) 
     * @return Success
     */
    getUserAccess(ownerUserId: number | null | undefined): Observable<UserCalendarAccessDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarAccess/GetUserAccess?";
        if (ownerUserId !== undefined && ownerUserId !== null)
            url_ += "ownerUserId=" + encodeURIComponent("" + ownerUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCalendarAccessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCalendarAccessDto>;
        }));
    }

    protected processGetUserAccess(response: HttpResponseBase): Observable<UserCalendarAccessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserCalendarAccessDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCalendarAccessDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addGrant(body: AddCalendarGrantInput | null | undefined): Observable<CalendarAccessGrantDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarAccess/AddGrant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddGrant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddGrant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarAccessGrantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarAccessGrantDto>;
        }));
    }

    protected processAddGrant(response: HttpResponseBase): Observable<CalendarAccessGrantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CalendarAccessGrantDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarAccessGrantDto>(null as any);
    }

    /**
     * @param grantId (optional) 
     * @return Success
     */
    removeGrant(grantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CalendarAccess/RemoveGrant?";
        if (grantId !== undefined && grantId !== null)
            url_ += "grantId=" + encodeURIComponent("" + grantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveGrant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveGrant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveGrant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CalendarBookingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getSchedulers(): Observable<CalendarSchedulerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CalendarBooking/GetSchedulers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchedulers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchedulers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarSchedulerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarSchedulerDto[]>;
        }));
    }

    protected processGetSchedulers(response: HttpResponseBase): Observable<CalendarSchedulerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarSchedulerDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarSchedulerDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addScheduler(body: AddSchedulerInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CalendarBooking/AddScheduler";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddScheduler(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddScheduler(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddScheduler(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removeScheduler(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CalendarBooking/RemoveScheduler?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveScheduler(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveScheduler(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveScheduler(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getDelegations(): Observable<CalendarDelegationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CalendarBooking/GetDelegations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelegations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelegations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarDelegationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarDelegationDto[]>;
        }));
    }

    protected processGetDelegations(response: HttpResponseBase): Observable<CalendarDelegationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarDelegationDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarDelegationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addDelegation(body: AddDelegationInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CalendarBooking/AddDelegation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDelegation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDelegation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddDelegation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removeDelegation(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CalendarBooking/RemoveDelegation?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDelegation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDelegation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveDelegation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CalendarSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getSettings(): Observable<CalendarSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarSettings/GetSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarSettingsDto>;
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<CalendarSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CalendarSettingsDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarSettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setEnabled(body: SetCalendarEnabledInput | null | undefined): Observable<CalendarSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarSettings/SetEnabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarSettingsDto>;
        }));
    }

    protected processSetEnabled(response: HttpResponseBase): Observable<CalendarSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CalendarSettingsDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarSettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePolicy(body: UpdateCalendarPolicyInput | null | undefined): Observable<CalendarSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/CalendarSettings/UpdatePolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarSettingsDto>;
        }));
    }

    protected processUpdatePolicy(response: HttpResponseBase): Observable<CalendarSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CalendarSettingsDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarSettingsDto>(null as any);
    }
}

@Injectable()
export class ClientAutomationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param stageId (optional) 
     * @return Success
     */
    get(stageId: number | null | undefined): Observable<ClientAutomationDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientAutomation/Get?";
        if (stageId !== undefined && stageId !== null)
            url_ += "stageId=" + encodeURIComponent("" + stageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientAutomationDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientAutomationDtoListIHandleError>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClientAutomationDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientAutomationDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientAutomationDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    add(body: ClientAutomationInputDto | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientAutomation/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ClientAutomationInputDto | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientAutomation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param stageId (optional) 
     * @return Success
     */
    delete(stageId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientAutomation/Delete?";
        if (stageId !== undefined && stageId !== null)
            url_ += "stageId=" + encodeURIComponent("" + stageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    syncPersonToCompanyType(companyId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientAutomation/SyncPersonToCompanyType?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncPersonToCompanyType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncPersonToCompanyType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSyncPersonToCompanyType(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    syncPersonToCompanySource(companyId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientAutomation/SyncPersonToCompanySource?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncPersonToCompanySource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncPersonToCompanySource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSyncPersonToCompanySource(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    syncCompanyToPersonType(contactId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientAutomation/SyncCompanyToPersonType?";
        if (contactId !== undefined && contactId !== null)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncCompanyToPersonType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCompanyToPersonType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSyncCompanyToPersonType(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    syncCompanyToPersonSource(contactId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientAutomation/SyncCompanyToPersonSource?";
        if (contactId !== undefined && contactId !== null)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncCompanyToPersonSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCompanyToPersonSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSyncCompanyToPersonSource(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }
}

@Injectable()
export class ClientRecordDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param recordId (optional) 
     * @param isCompany (optional) 
     * @return Success
     */
    get(recordId: number | null | undefined, isCompany: boolean | null | undefined): Observable<ClientRecordDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/ClientRecordDetails/GetAsync?";
        if (recordId !== undefined && recordId !== null)
            url_ += "RecordId=" + encodeURIComponent("" + recordId) + "&";
        if (isCompany !== undefined && isCompany !== null)
            url_ += "IsCompany=" + encodeURIComponent("" + isCompany) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientRecordDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientRecordDetailsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClientRecordDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientRecordDetailsDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientRecordDetailsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveField(body: SaveClientDetailFieldDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClientRecordDetails/SaveFieldAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveField(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param isCompany (optional) 
     * @return Success
     */
    getEntryTypes(kind: string, isCompany: boolean | null | undefined): Observable<ClientDetailOptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClientRecordDetails/GetEntryTypesAsync?";
        if (kind === undefined || kind === null)
            throw new globalThis.Error("The parameter 'kind' must be defined and cannot be null.");
        else
            url_ += "Kind=" + encodeURIComponent("" + kind) + "&";
        if (isCompany !== undefined && isCompany !== null)
            url_ += "IsCompany=" + encodeURIComponent("" + isCompany) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntryTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntryTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDetailOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDetailOptionDto[]>;
        }));
    }

    protected processGetEntryTypes(response: HttpResponseBase): Observable<ClientDetailOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientDetailOptionDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientDetailOptionDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEntryType(body: CreateClientDetailTypeDto | null | undefined): Observable<ClientDetailOptionDto> {
        let url_ = this.baseUrl + "/api/services/app/ClientRecordDetails/CreateEntryTypeAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEntryType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEntryType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDetailOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDetailOptionDto>;
        }));
    }

    protected processCreateEntryType(response: HttpResponseBase): Observable<ClientDetailOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientDetailOptionDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientDetailOptionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveEntry(body: ClientDetailEntryDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClientRecordDetails/SaveEntryAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param entryId (optional) 
     * @param recordId (optional) 
     * @param isCompany (optional) 
     * @return Success
     */
    deleteEntry(entryId: number | null | undefined, kind: string, recordId: number | null | undefined, isCompany: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClientRecordDetails/DeleteEntryAsync?";
        if (entryId !== undefined && entryId !== null)
            url_ += "EntryId=" + encodeURIComponent("" + entryId) + "&";
        if (kind === undefined || kind === null)
            throw new globalThis.Error("The parameter 'kind' must be defined and cannot be null.");
        else
            url_ += "Kind=" + encodeURIComponent("" + kind) + "&";
        if (recordId !== undefined && recordId !== null)
            url_ += "RecordId=" + encodeURIComponent("" + recordId) + "&";
        if (isCompany !== undefined && isCompany !== null)
            url_ += "IsCompany=" + encodeURIComponent("" + isCompany) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ClientSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getClientStageSettings(): Observable<ClientStageSettingsDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientSettings/GetClientStageSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientStageSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientStageSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientStageSettingsDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientStageSettingsDtoListIHandleError>;
        }));
    }

    protected processGetClientStageSettings(response: HttpResponseBase): Observable<ClientStageSettingsDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientStageSettingsDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientStageSettingsDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveClientStage(body: SaveClientStageInput | null | undefined): Observable<SaveClientStageOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientSettings/SaveClientStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveClientStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveClientStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveClientStageOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveClientStageOutputIHandleError>;
        }));
    }

    protected processSaveClientStage(response: HttpResponseBase): Observable<SaveClientStageOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SaveClientStageOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveClientStageOutputIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reorderClientStages(body: ReorderClientListInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientSettings/ReorderClientStages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderClientStages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderClientStages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processReorderClientStages(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getClientSourceSettings(): Observable<ClientSourceSettingsDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientSettings/GetClientSourceSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientSourceSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientSourceSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientSourceSettingsDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientSourceSettingsDtoListIHandleError>;
        }));
    }

    protected processGetClientSourceSettings(response: HttpResponseBase): Observable<ClientSourceSettingsDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientSourceSettingsDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientSourceSettingsDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveClientSource(body: SaveClientSourceInput | null | undefined): Observable<SaveClientSourceOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientSettings/SaveClientSource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveClientSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveClientSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveClientSourceOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveClientSourceOutputIHandleError>;
        }));
    }

    protected processSaveClientSource(response: HttpResponseBase): Observable<SaveClientSourceOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SaveClientSourceOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveClientSourceOutputIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reorderClientSources(body: ReorderClientListInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientSettings/ReorderClientSources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderClientSources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderClientSources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processReorderClientSources(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    suggestClientSourceGuidance(body: SuggestClientSourceGuidanceInput | null | undefined): Observable<ClientSourceGuidanceSuggestionDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientSettings/SuggestClientSourceGuidance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuggestClientSourceGuidance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuggestClientSourceGuidance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientSourceGuidanceSuggestionDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientSourceGuidanceSuggestionDtoIHandleError>;
        }));
    }

    protected processSuggestClientSourceGuidance(response: HttpResponseBase): Observable<ClientSourceGuidanceSuggestionDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientSourceGuidanceSuggestionDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientSourceGuidanceSuggestionDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectReminder(body: CreateProjectReminderInput | null | undefined): Observable<ProjectReminderDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ClientSettings/CreateProjectReminder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectReminderDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectReminderDtoIHandleError>;
        }));
    }

    protected processCreateProjectReminder(response: HttpResponseBase): Observable<ProjectReminderDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectReminderDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectReminderDtoIHandleError>(null as any);
    }
}

@Injectable()
export class CommonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditTeam(body: TeamDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Common/CreateOrEditTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateOrEditTeam(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return Success
     */
    getAllTeams(sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined, filter: string | null | undefined): Observable<TeamDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetAllTeams?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTeams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTeams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeamDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeamDtoPagedResultDto>;
        }));
    }

    protected processGetAllTeams(response: HttpResponseBase): Observable<TeamDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TeamDtoPagedResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TeamDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTeam(id: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Common/DeleteTeam?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteTeam(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditTask(body: TaskDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Common/CreateOrEditTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateOrEditTask(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return Success
     */
    getAllTasks(sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined, filter: string | null | undefined): Observable<TaskDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetAllTasks?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDtoPagedResultDto>;
        }));
    }

    protected processGetAllTasks(response: HttpResponseBase): Observable<TaskDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskDtoPagedResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getCheckInPolicy(): Observable<CheckInPolicyDto> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetCheckInPolicyAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckInPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckInPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckInPolicyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckInPolicyDto>;
        }));
    }

    protected processGetCheckInPolicy(response: HttpResponseBase): Observable<CheckInPolicyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CheckInPolicyDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckInPolicyDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditCheckInPolicy(body: CheckInPolicyDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Common/CreateOrEditCheckInPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditCheckInPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCheckInPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateOrEditCheckInPolicy(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getAllMoods(): Observable<SrcMoodOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetAllMoods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMoods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMoods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SrcMoodOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SrcMoodOutputDto[]>;
        }));
    }

    protected processGetAllMoods(response: HttpResponseBase): Observable<SrcMoodOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SrcMoodOutputDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SrcMoodOutputDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateShift(body: ShiftDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Common/CreateOrUpdateShift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateOrUpdateShift(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getAllShifts(): Observable<ShiftDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetAllShifts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllShifts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllShifts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftDto[]>;
        }));
    }

    protected processGetAllShifts(response: HttpResponseBase): Observable<ShiftDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShiftDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteShift(id: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Common/DeleteShift?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteShift(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param subject (optional) 
     * @param currentUserId (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendAcknowledgementEmail(subject: string | null | undefined, currentUserId: number | null | undefined, body: AcknowledgementType | null | undefined): Observable<Message> {
        let url_ = this.baseUrl + "/api/services/app/Common/SendAcknowledgementEmailAsync?";
        if (subject !== undefined && subject !== null)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&";
        if (currentUserId !== undefined && currentUserId !== null)
            url_ += "currentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAcknowledgementEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAcknowledgementEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Message>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Message>;
        }));
    }

    protected processSendAcknowledgementEmail(response: HttpResponseBase): Observable<Message> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Message.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Message>(null as any);
    }

    /**
     * @return Success
     */
    generateGuid(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Common/GenerateGuid";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateGuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateGuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateGuid(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    globalSearch(body: GlobalSearchInputDto | null | undefined): Observable<GlobalSearchOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Common/GlobalSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGlobalSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGlobalSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSearchOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSearchOutputDtoListIHandleError>;
        }));
    }

    protected processGlobalSearch(response: HttpResponseBase): Observable<GlobalSearchOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GlobalSearchOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlobalSearchOutputDtoListIHandleError>(null as any);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean | null | undefined): Observable<SubscribableEditionComboboxItemDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems !== undefined && onlyFreeItems !== null)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscribableEditionComboboxItemDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscribableEditionComboboxItemDtoListResultDto>;
        }));
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SubscribableEditionComboboxItemDtoListResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscribableEditionComboboxItemDtoListResultDto>(null as any);
    }

    /**
     * @param inputs (optional) 
     * @return Success
     */
    getAllForLookupTables(inputs: GetAllForLookupTableInput[] | null | undefined): Observable<LookupTableOutputDtoArrayListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetAllForLookupTables?";
        if (inputs !== undefined && inputs !== null)
            inputs && inputs.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "inputs[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForLookupTables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForLookupTables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableOutputDtoArrayListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableOutputDtoArrayListIHandleError>;
        }));
    }

    protected processGetAllForLookupTables(response: HttpResponseBase): Observable<LookupTableOutputDtoArrayListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LookupTableOutputDtoArrayListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupTableOutputDtoArrayListIHandleError>(null as any);
    }

    /**
     * @param parentId (optional) 
     * @param filter (optional) 
     * @param isEntityIdsNameRequired (optional) 
     * @param entityIds (optional) 
     * @param lookUpTableName (optional) 
     * @param isInActiveDataRequired (optional) 
     * @param excludeIds (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForCascadeLookupTable(parentId: number | null | undefined, filter: string | null | undefined, isEntityIdsNameRequired: boolean | null | undefined, entityIds: string | null | undefined, lookUpTableName: any | null | undefined, isInActiveDataRequired: boolean | null | undefined, excludeIds: number[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<LookupTableOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetAllForCascadeLookupTable?";
        if (parentId !== undefined && parentId !== null)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isEntityIdsNameRequired !== undefined && isEntityIdsNameRequired !== null)
            url_ += "IsEntityIdsNameRequired=" + encodeURIComponent("" + isEntityIdsNameRequired) + "&";
        if (entityIds !== undefined && entityIds !== null)
            url_ += "EntityIds=" + encodeURIComponent("" + entityIds) + "&";
        if (lookUpTableName !== undefined && lookUpTableName !== null)
            url_ += "LookUpTableName=" + encodeURIComponent("" + lookUpTableName) + "&";
        if (isInActiveDataRequired !== undefined && isInActiveDataRequired !== null)
            url_ += "IsInActiveDataRequired=" + encodeURIComponent("" + isInActiveDataRequired) + "&";
        if (excludeIds !== undefined && excludeIds !== null)
            excludeIds && excludeIds.forEach(item => { url_ += "ExcludeIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForCascadeLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForCascadeLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableOutputDto[]>;
        }));
    }

    protected processGetAllForCascadeLookupTable(response: HttpResponseBase): Observable<LookupTableOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableOutputDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupTableOutputDto[]>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param filter (optional) 
     * @param isEntityIdsNameRequired (optional) 
     * @param entityIds (optional) 
     * @param lookUpTableName (optional) 
     * @param isInActiveDataRequired (optional) 
     * @param excludeIds (optional) 
     * @return Success
     */
    getAllForLookupTable(sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, filter: string | null | undefined, isEntityIdsNameRequired: boolean | null | undefined, entityIds: string | null | undefined, lookUpTableName: any | null | undefined, isInActiveDataRequired: boolean | null | undefined, excludeIds: number[] | null | undefined): Observable<LookupTableOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetAllForLookupTable?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isEntityIdsNameRequired !== undefined && isEntityIdsNameRequired !== null)
            url_ += "IsEntityIdsNameRequired=" + encodeURIComponent("" + isEntityIdsNameRequired) + "&";
        if (entityIds !== undefined && entityIds !== null)
            url_ += "EntityIds=" + encodeURIComponent("" + entityIds) + "&";
        if (lookUpTableName !== undefined && lookUpTableName !== null)
            url_ += "LookUpTableName=" + encodeURIComponent("" + lookUpTableName) + "&";
        if (isInActiveDataRequired !== undefined && isInActiveDataRequired !== null)
            url_ += "IsInActiveDataRequired=" + encodeURIComponent("" + isInActiveDataRequired) + "&";
        if (excludeIds !== undefined && excludeIds !== null)
            excludeIds && excludeIds.forEach(item => { url_ += "ExcludeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableOutputDto[]>;
        }));
    }

    protected processGetAllForLookupTable(response: HttpResponseBase): Observable<LookupTableOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableOutputDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupTableOutputDto[]>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param filter (optional) 
     * @param isEntityIdsNameRequired (optional) 
     * @param entityIds (optional) 
     * @param lookUpTableName (optional) 
     * @param isInActiveDataRequired (optional) 
     * @param excludeIds (optional) 
     * @return Success
     */
    getAllMoods(sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, filter: string | null | undefined, isEntityIdsNameRequired: boolean | null | undefined, entityIds: string | null | undefined, lookUpTableName: any | null | undefined, isInActiveDataRequired: boolean | null | undefined, excludeIds: number[] | null | undefined): Observable<LookupTableOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetAllMoods?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isEntityIdsNameRequired !== undefined && isEntityIdsNameRequired !== null)
            url_ += "IsEntityIdsNameRequired=" + encodeURIComponent("" + isEntityIdsNameRequired) + "&";
        if (entityIds !== undefined && entityIds !== null)
            url_ += "EntityIds=" + encodeURIComponent("" + entityIds) + "&";
        if (lookUpTableName !== undefined && lookUpTableName !== null)
            url_ += "LookUpTableName=" + encodeURIComponent("" + lookUpTableName) + "&";
        if (isInActiveDataRequired !== undefined && isInActiveDataRequired !== null)
            url_ += "IsInActiveDataRequired=" + encodeURIComponent("" + isInActiveDataRequired) + "&";
        if (excludeIds !== undefined && excludeIds !== null)
            excludeIds && excludeIds.forEach(item => { url_ += "ExcludeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMoods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMoods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableOutputDto[]>;
        }));
    }

    protected processGetAllMoods(response: HttpResponseBase): Observable<LookupTableOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableOutputDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupTableOutputDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindUsersInput | null | undefined): Observable<NameValueIdDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueIdDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueIdDtoPagedResultDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<NameValueIdDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NameValueIdDtoPagedResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueIdDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEditionName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDefaultEditionNameOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDefaultEditionNameOutput>;
        }));
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetDefaultEditionNameOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDefaultEditionNameOutput>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param contactId (optional) 
     * @return Success
     */
    getAllCompaniesForLookup(filter: string | null | undefined, contactId: number | null | undefined): Observable<CompanyLookupTableOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetAllCompaniesForLookup?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (contactId !== undefined && contactId !== null)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompaniesForLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompaniesForLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyLookupTableOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyLookupTableOutputDtoListIHandleError>;
        }));
    }

    protected processGetAllCompaniesForLookup(response: HttpResponseBase): Observable<CompanyLookupTableOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyLookupTableOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyLookupTableOutputDtoListIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactsForLookup(searchText: string | null | undefined, maxResultCount: number | null | undefined): Observable<ContactsLookupTableOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetAllContactsForLookup?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactsForLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactsForLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactsLookupTableOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactsLookupTableOutputDtoListIHandleError>;
        }));
    }

    protected processGetAllContactsForLookup(response: HttpResponseBase): Observable<ContactsLookupTableOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactsLookupTableOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactsLookupTableOutputDtoListIHandleError>(null as any);
    }
}

@Injectable()
export class CompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCompany(body: CompanyInputDto | null | undefined): Observable<CompanyInputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/CreateOrUpdateCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyInputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyInputDtoIHandleError>;
        }));
    }

    protected processCreateOrUpdateCompany(response: HttpResponseBase): Observable<CompanyInputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyInputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyInputDtoIHandleError>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getCompanyById(companyId: number | null | undefined): Observable<CompanyInputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyById?";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyInputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyInputDtoIHandleError>;
        }));
    }

    protected processGetCompanyById(response: HttpResponseBase): Observable<CompanyInputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyInputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyInputDtoIHandleError>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param takeCount (optional) 
     * @param searchText (optional) 
     * @param sortOrder (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param tagIds (optional) 
     * @param companyTypeIds (optional) 
     * @param clientStageIds (optional) 
     * @param companyIds (optional) 
     * @param contactIds (optional) 
     * @return Success
     */
    getAllCompanies(skipCount: number | null | undefined, takeCount: number | null | undefined, searchText: string | null | undefined, sortOrder: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, tagIds: number[] | null | undefined, companyTypeIds: number[] | null | undefined, clientStageIds: number[] | null | undefined, companyIds: number[] | null | undefined, contactIds: number[] | null | undefined): Observable<Int32CompanyDtoListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAllCompanies?";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (takeCount !== undefined && takeCount !== null)
            url_ += "TakeCount=" + encodeURIComponent("" + takeCount) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (companyTypeIds !== undefined && companyTypeIds !== null)
            companyTypeIds && companyTypeIds.forEach(item => { url_ += "CompanyTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (clientStageIds !== undefined && clientStageIds !== null)
            clientStageIds && clientStageIds.forEach(item => { url_ += "ClientStageIds=" + encodeURIComponent("" + item) + "&"; });
        if (companyIds !== undefined && companyIds !== null)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        if (contactIds !== undefined && contactIds !== null)
            contactIds && contactIds.forEach(item => { url_ += "ContactIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32CompanyDtoListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32CompanyDtoListValueTupleIHandleError>;
        }));
    }

    protected processGetAllCompanies(response: HttpResponseBase): Observable<Int32CompanyDtoListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32CompanyDtoListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32CompanyDtoListValueTupleIHandleError>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getCompanyContacts(companyId: number | null | undefined): Observable<CompanyContactsDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyContacts?";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyContactsDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyContactsDtoListIHandleError>;
        }));
    }

    protected processGetCompanyContacts(response: HttpResponseBase): Observable<CompanyContactsDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyContactsDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyContactsDtoListIHandleError>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getOtherContacts(companyId: number | null | undefined): Observable<OtherContactsDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetOtherContacts?";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOtherContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOtherContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OtherContactsDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OtherContactsDtoListIHandleError>;
        }));
    }

    protected processGetOtherContacts(response: HttpResponseBase): Observable<OtherContactsDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OtherContactsDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OtherContactsDtoListIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCompany(id: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/DeleteCompany?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteCompany(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMultipleContacts(body: AddMultipleContact | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/AddMultipleContacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMultipleContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMultipleContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAddMultipleContacts(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removeContactFromCompany(id: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/RemoveContactFromCompany?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveContactFromCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveContactFromCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processRemoveContactFromCompany(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param companyTypeId (optional) 
     * @param body (optional) 
     * @return Success
     */
    assignCompanyTypeToCompanies(companyTypeId: number | null | undefined, body: number[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/AssignCompanyTypeToCompanies?";
        if (companyTypeId !== undefined && companyTypeId !== null)
            url_ += "companyTypeId=" + encodeURIComponent("" + companyTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignCompanyTypeToCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignCompanyTypeToCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAssignCompanyTypeToCompanies(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param clientStageId (optional) 
     * @param body (optional) 
     * @return Success
     */
    assignClientStageToCompanies(clientStageId: number | null | undefined, body: number[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/AssignClientStageToCompanies?";
        if (clientStageId !== undefined && clientStageId !== null)
            url_ += "clientStageId=" + encodeURIComponent("" + clientStageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignClientStageToCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignClientStageToCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAssignClientStageToCompanies(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param clientSourceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    assignClientSourceToCompanies(clientSourceId: number | null | undefined, body: number[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/AssignClientSourceToCompanies?";
        if (clientSourceId !== undefined && clientSourceId !== null)
            url_ += "clientSourceId=" + encodeURIComponent("" + clientSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignClientSourceToCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignClientSourceToCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAssignClientSourceToCompanies(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignTagsToCompanies(body: AssignTagsToCompanyInputDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/AssignTagsToCompanies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignTagsToCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignTagsToCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAssignTagsToCompanies(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteCompanies(body: DeleteClientsInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/DeleteCompanies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteCompanies(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCompanyFolder(body: CreateFolderDto | null | undefined): Observable<CompanyFolderOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/CreateCompanyFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCompanyFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCompanyFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyFolderOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyFolderOutputDtoIHandleError>;
        }));
    }

    protected processCreateCompanyFolder(response: HttpResponseBase): Observable<CompanyFolderOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyFolderOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyFolderOutputDtoIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getCompanyRootFolderDetails(): Observable<CompanyFolderOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyRootFolderDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyRootFolderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyRootFolderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyFolderOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyFolderOutputDtoIHandleError>;
        }));
    }

    protected processGetCompanyRootFolderDetails(response: HttpResponseBase): Observable<CompanyFolderOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyFolderOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyFolderOutputDtoIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompanyFolderDetails(id: number | null | undefined): Observable<CompanyFolderOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyFolderDetails?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyFolderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyFolderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyFolderOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyFolderOutputDtoIHandleError>;
        }));
    }

    protected processGetCompanyFolderDetails(response: HttpResponseBase): Observable<CompanyFolderOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyFolderOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyFolderOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resolveCompanyFolder(body: EntityDto | null | undefined): Observable<CompanyFolderOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/ResolveCompanyFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveCompanyFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveCompanyFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyFolderOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyFolderOutputDtoIHandleError>;
        }));
    }

    protected processResolveCompanyFolder(response: HttpResponseBase): Observable<CompanyFolderOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyFolderOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyFolderOutputDtoIHandleError>(null as any);
    }

    /**
     * @param folderId (optional) 
     * @param driveId (optional) 
     * @param searchInput (optional) 
     * @param companyId (optional) 
     * @return Success
     */
    getCompanyFiles(folderId: string | null | undefined, driveId: string | null | undefined, searchInput: string | null | undefined, companyId: number | null | undefined): Observable<CompanyFilesDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyFiles?";
        if (folderId !== undefined && folderId !== null)
            url_ += "FolderId=" + encodeURIComponent("" + folderId) + "&";
        if (driveId !== undefined && driveId !== null)
            url_ += "DriveId=" + encodeURIComponent("" + driveId) + "&";
        if (searchInput !== undefined && searchInput !== null)
            url_ += "SearchInput=" + encodeURIComponent("" + searchInput) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyFilesDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyFilesDtoListIHandleError>;
        }));
    }

    protected processGetCompanyFiles(response: HttpResponseBase): Observable<CompanyFilesDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyFilesDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyFilesDtoListIHandleError>(null as any);
    }

    /**
     * @param folderId (optional) 
     * @param driveId (optional) 
     * @param searchInput (optional) 
     * @param companyId (optional) 
     * @return Success
     */
    getCompanyContactFiles(folderId: string | null | undefined, driveId: string | null | undefined, searchInput: string | null | undefined, companyId: number | null | undefined): Observable<CompanyFilesDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyContactFiles?";
        if (folderId !== undefined && folderId !== null)
            url_ += "FolderId=" + encodeURIComponent("" + folderId) + "&";
        if (driveId !== undefined && driveId !== null)
            url_ += "DriveId=" + encodeURIComponent("" + driveId) + "&";
        if (searchInput !== undefined && searchInput !== null)
            url_ += "SearchInput=" + encodeURIComponent("" + searchInput) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyContactFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyContactFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyFilesDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyFilesDtoListIHandleError>;
        }));
    }

    protected processGetCompanyContactFiles(response: HttpResponseBase): Observable<CompanyFilesDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyFilesDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyFilesDtoListIHandleError>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getCompanyContactFolders(companyId: number | null | undefined): Observable<CompanyFilesDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyContactFolders?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyContactFolders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyContactFolders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyFilesDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyFilesDtoListIHandleError>;
        }));
    }

    protected processGetCompanyContactFolders(response: HttpResponseBase): Observable<CompanyFilesDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyFilesDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyFilesDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCompanyTag(body: CreateUpdateCompanyTagsDto | null | undefined): Observable<CompanyTagListDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/CreateOrUpdateCompanyTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCompanyTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCompanyTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyTagListDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyTagListDtoListIHandleError>;
        }));
    }

    protected processCreateOrUpdateCompanyTag(response: HttpResponseBase): Observable<CompanyTagListDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyTagListDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyTagListDtoListIHandleError>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getCompanyTags(companyId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<CompanyTagListDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyTags?";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyTagListDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyTagListDtoListIHandleError>;
        }));
    }

    protected processGetCompanyTags(response: HttpResponseBase): Observable<CompanyTagListDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyTagListDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyTagListDtoListIHandleError>(null as any);
    }

    /**
     * @param companyTagId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    deleteCompanyTag(companyTagId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/DeleteCompanyTag?";
        if (companyTagId !== undefined && companyTagId !== null)
            url_ += "CompanyTagId=" + encodeURIComponent("" + companyTagId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompanyTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompanyTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteCompanyTag(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param companyId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getCompanyNotes(searchText: string | null | undefined, companyId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<CompanyNotesDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyNotes?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyNotesDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyNotesDtoListIHandleError>;
        }));
    }

    protected processGetCompanyNotes(response: HttpResponseBase): Observable<CompanyNotesDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyNotesDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyNotesDtoListIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCompanyNote(id: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Company/DeleteCompanyNote?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompanyNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompanyNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteCompanyNote(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }
}

@Injectable()
export class ConnectedAppsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getMicrosoft365Status(): Observable<Microsoft365StatusDto> {
        let url_ = this.baseUrl + "/api/services/app/ConnectedApps/GetMicrosoft365Status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMicrosoft365Status(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMicrosoft365Status(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Microsoft365StatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Microsoft365StatusDto>;
        }));
    }

    protected processGetMicrosoft365Status(response: HttpResponseBase): Observable<Microsoft365StatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Microsoft365StatusDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Microsoft365StatusDto>(null as any);
    }

    /**
     * @return Success
     */
    disconnectMicrosoft365(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConnectedApps/DisconnectMicrosoft365";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisconnectMicrosoft365(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisconnectMicrosoft365(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisconnectMicrosoft365(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateContact(body: CreateOrUpdateUserContactInputDto | null | undefined): Observable<CreateOrUpdateUserContactInputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/CreateOrUpdateContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateUserContactInputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateUserContactInputDtoIHandleError>;
        }));
    }

    protected processCreateOrUpdateContact(response: HttpResponseBase): Observable<CreateOrUpdateUserContactInputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateUserContactInputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrUpdateUserContactInputDtoIHandleError>(null as any);
    }

    /**
     * @param contactTypeIds (optional) 
     * @param clientStageIds (optional) 
     * @param companyIds (optional) 
     * @param tagIds (optional) 
     * @param concactPrivacy (optional) 
     * @param searchText (optional) 
     * @param sortOrder (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param contactIds (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getAllContact(contactTypeIds: number[] | null | undefined, clientStageIds: number[] | null | undefined, companyIds: number[] | null | undefined, tagIds: number[] | null | undefined, concactPrivacy: any | null | undefined, searchText: string | null | undefined, sortOrder: number | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined, contactIds: number[] | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<Int32UserContactDtoListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetAllContact?";
        if (contactTypeIds !== undefined && contactTypeIds !== null)
            contactTypeIds && contactTypeIds.forEach(item => { url_ += "ContactTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (clientStageIds !== undefined && clientStageIds !== null)
            clientStageIds && clientStageIds.forEach(item => { url_ += "ClientStageIds=" + encodeURIComponent("" + item) + "&"; });
        if (companyIds !== undefined && companyIds !== null)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (concactPrivacy !== undefined && concactPrivacy !== null)
            url_ += "ConcactPrivacy=" + encodeURIComponent("" + concactPrivacy) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (contactIds !== undefined && contactIds !== null)
            contactIds && contactIds.forEach(item => { url_ += "ContactIds=" + encodeURIComponent("" + item) + "&"; });
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32UserContactDtoListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32UserContactDtoListValueTupleIHandleError>;
        }));
    }

    protected processGetAllContact(response: HttpResponseBase): Observable<Int32UserContactDtoListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32UserContactDtoListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32UserContactDtoListValueTupleIHandleError>(null as any);
    }

    /**
     * @param contactId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getContactById(contactId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<CreateOrUpdateUserContactInputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetContactById?";
        if (contactId !== undefined && contactId !== null)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateUserContactInputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateUserContactInputDtoIHandleError>;
        }));
    }

    protected processGetContactById(response: HttpResponseBase): Observable<CreateOrUpdateUserContactInputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateUserContactInputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrUpdateUserContactInputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addContactEmail(body: AddContactEmailInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/AddContactEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddContactEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddContactEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processAddContactEmail(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param isReImport (optional) 
     * @return Success
     */
    importOutlookContacts(isReImport: boolean | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/ImportOutlookContacts?";
        if (isReImport !== undefined && isReImport !== null)
            url_ += "IsReImport=" + encodeURIComponent("" + isReImport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportOutlookContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportOutlookContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processImportOutlookContacts(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param searchFilter (optional) 
     * @return Success
     */
    getContactFilters(searchFilter: string | null | undefined): Observable<ContactFiltersDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetContactFilters?";
        if (searchFilter !== undefined && searchFilter !== null)
            url_ += "searchFilter=" + encodeURIComponent("" + searchFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactFiltersDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactFiltersDtoIHandleError>;
        }));
    }

    protected processGetContactFilters(response: HttpResponseBase): Observable<ContactFiltersDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactFiltersDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactFiltersDtoIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/Delete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param contactId (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadContactProfilePhoto(contactId: number | null | undefined, file: FileParameter | null | undefined): Observable<StringIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/UploadContactProfilePhoto?";
        if (contactId !== undefined && contactId !== null)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadContactProfilePhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadContactProfilePhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringIHandleError>;
        }));
    }

    protected processUploadContactProfilePhoto(response: HttpResponseBase): Observable<StringIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StringIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringIHandleError>(null as any);
    }

    /**
     * @param clientTypeId (optional) 
     * @param body (optional) 
     * @return Success
     */
    assignClientTypeToContacts(clientTypeId: number | null | undefined, body: number[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/AssignClientTypeToContacts?";
        if (clientTypeId !== undefined && clientTypeId !== null)
            url_ += "clientTypeId=" + encodeURIComponent("" + clientTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignClientTypeToContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignClientTypeToContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAssignClientTypeToContacts(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param clientStageId (optional) 
     * @param lostReasonId (optional) 
     * @param lostReasonNote (optional) 
     * @param body (optional) 
     * @return Success
     */
    assignClientStageToContacts(clientStageId: number | null | undefined, lostReasonId: number | null | undefined, lostReasonNote: string | null | undefined, body: number[] | null | undefined): Observable<ClientStageTransitionDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/AssignClientStageToContacts?";
        if (clientStageId !== undefined && clientStageId !== null)
            url_ += "clientStageId=" + encodeURIComponent("" + clientStageId) + "&";
        if (lostReasonId !== undefined && lostReasonId !== null)
            url_ += "lostReasonId=" + encodeURIComponent("" + lostReasonId) + "&";
        if (lostReasonNote !== undefined && lostReasonNote !== null)
            url_ += "lostReasonNote=" + encodeURIComponent("" + lostReasonNote) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignClientStageToContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignClientStageToContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientStageTransitionDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientStageTransitionDtoListIHandleError>;
        }));
    }

    protected processAssignClientStageToContacts(response: HttpResponseBase): Observable<ClientStageTransitionDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientStageTransitionDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientStageTransitionDtoListIHandleError>(null as any);
    }

    /**
     * @param clientSourceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    assignClientSourceToContacts(clientSourceId: number | null | undefined, body: number[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/AssignClientSourceToContacts?";
        if (clientSourceId !== undefined && clientSourceId !== null)
            url_ += "clientSourceId=" + encodeURIComponent("" + clientSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignClientSourceToContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignClientSourceToContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAssignClientSourceToContacts(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignTagsToContacts(body: AssignTagsToContactInputDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/AssignTagsToContacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignTagsToContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignTagsToContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAssignTagsToContacts(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteContacts(body: DeleteClientsInput | null | undefined): Observable<DeleteClientsResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/DeleteContacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteClientsResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteClientsResultDtoIHandleError>;
        }));
    }

    protected processDeleteContacts(response: HttpResponseBase): Observable<DeleteClientsResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DeleteClientsResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteClientsResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateContactTypeStage(body: UpdateContactTypeStageInputDto | null | undefined): Observable<ClientStageTransitionDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/UpdateContactTypeStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContactTypeStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContactTypeStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientStageTransitionDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientStageTransitionDtoIHandleError>;
        }));
    }

    protected processUpdateContactTypeStage(response: HttpResponseBase): Observable<ClientStageTransitionDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientStageTransitionDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientStageTransitionDtoIHandleError>(null as any);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getContactTypeStage(contactId: number | null | undefined): Observable<ContactTypeStageDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetContactTypeStage?";
        if (contactId !== undefined && contactId !== null)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactTypeStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactTypeStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactTypeStageDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactTypeStageDtoIHandleError>;
        }));
    }

    protected processGetContactTypeStage(response: HttpResponseBase): Observable<ContactTypeStageDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactTypeStageDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactTypeStageDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateContactTypes(body: CreateUpdateTypesDto | null | undefined): Observable<Int32ListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/CreateOrUpdateContactTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateContactTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateContactTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32ListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32ListIHandleError>;
        }));
    }

    protected processCreateOrUpdateContactTypes(response: HttpResponseBase): Observable<Int32ListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32ListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32ListIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    deleteContactTypes(id: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/DeleteContactTypes?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContactTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContactTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteContactTypes(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reorderContactTypes(body: ReorderClientListInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/ReorderContactTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderContactTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderContactTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processReorderContactTypes(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getAllContactTypes(userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<ContactTypesListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetAllContactTypes?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactTypesListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactTypesListIHandleError>;
        }));
    }

    protected processGetAllContactTypes(response: HttpResponseBase): Observable<ContactTypesListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactTypesListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactTypesListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenantFolder(body: CreateFolderDto | null | undefined): Observable<TenantFolderOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/CreateTenantFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenantFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenantFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantFolderOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantFolderOutputDtoIHandleError>;
        }));
    }

    protected processCreateTenantFolder(response: HttpResponseBase): Observable<TenantFolderOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TenantFolderOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantFolderOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createContactFolder(body: CreateFolderDto | null | undefined): Observable<ContactFolderOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/CreateContactFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContactFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContactFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactFolderOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactFolderOutputDtoIHandleError>;
        }));
    }

    protected processCreateContactFolder(response: HttpResponseBase): Observable<ContactFolderOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactFolderOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactFolderOutputDtoIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getTenantFolderDetails(): Observable<TenantFolderOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetTenantFolderDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFolderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFolderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantFolderOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantFolderOutputDtoIHandleError>;
        }));
    }

    protected processGetTenantFolderDetails(response: HttpResponseBase): Observable<TenantFolderOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TenantFolderOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantFolderOutputDtoIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getTenantContactFolderDetails(): Observable<TenantFolderOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetTenantContactFolderDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantContactFolderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantContactFolderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantFolderOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantFolderOutputDtoIHandleError>;
        }));
    }

    protected processGetTenantContactFolderDetails(response: HttpResponseBase): Observable<TenantFolderOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TenantFolderOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantFolderOutputDtoIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getContactFolderDetails(id: number | null | undefined): Observable<ContactFolderOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetContactFolderDetails?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactFolderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactFolderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactFolderOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactFolderOutputDtoIHandleError>;
        }));
    }

    protected processGetContactFolderDetails(response: HttpResponseBase): Observable<ContactFolderOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactFolderOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactFolderOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resolveContactFolder(body: EntityDto | null | undefined): Observable<ContactFolderOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/ResolveContactFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveContactFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveContactFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactFolderOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactFolderOutputDtoIHandleError>;
        }));
    }

    protected processResolveContactFolder(response: HttpResponseBase): Observable<ContactFolderOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactFolderOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactFolderOutputDtoIHandleError>(null as any);
    }

    /**
     * @param folderId (optional) 
     * @param driveId (optional) 
     * @param searchInput (optional) 
     * @param contactId (optional) 
     * @return Success
     */
    getContactFiles(folderId: string | null | undefined, driveId: string | null | undefined, searchInput: string | null | undefined, contactId: number | null | undefined): Observable<ContactFilesOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetContactFiles?";
        if (folderId !== undefined && folderId !== null)
            url_ += "FolderId=" + encodeURIComponent("" + folderId) + "&";
        if (driveId !== undefined && driveId !== null)
            url_ += "DriveId=" + encodeURIComponent("" + driveId) + "&";
        if (searchInput !== undefined && searchInput !== null)
            url_ += "SearchInput=" + encodeURIComponent("" + searchInput) + "&";
        if (contactId !== undefined && contactId !== null)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactFilesOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactFilesOutputDtoListIHandleError>;
        }));
    }

    protected processGetContactFiles(response: HttpResponseBase): Observable<ContactFilesOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactFilesOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactFilesOutputDtoListIHandleError>(null as any);
    }

    /**
     * @param contactId (optional) 
     * @param searchText (optional) 
     * @param filterByCompleted (optional) 
     * @param filterBysUnfinished (optional) 
     * @param filterByOverdue (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getContactTasks(contactId: number | null | undefined, searchText: string | null | undefined, filterByCompleted: boolean | null | undefined, filterBysUnfinished: boolean | null | undefined, filterByOverdue: boolean | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<ContactTaskListDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetContactTasks?";
        if (contactId !== undefined && contactId !== null)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (filterByCompleted !== undefined && filterByCompleted !== null)
            url_ += "FilterByCompleted=" + encodeURIComponent("" + filterByCompleted) + "&";
        if (filterBysUnfinished !== undefined && filterBysUnfinished !== null)
            url_ += "FilterBysUnfinished=" + encodeURIComponent("" + filterBysUnfinished) + "&";
        if (filterByOverdue !== undefined && filterByOverdue !== null)
            url_ += "FilterByOverdue=" + encodeURIComponent("" + filterByOverdue) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactTaskListDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactTaskListDtoListIHandleError>;
        }));
    }

    protected processGetContactTasks(response: HttpResponseBase): Observable<ContactTaskListDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactTaskListDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactTaskListDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateContactNotes(body: CreateUpdateContactNotesDto | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/CreateOrUpdateContactNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateContactNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateContactNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCreateOrUpdateContactNotes(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param contactId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getContactNotes(searchText: string | null | undefined, contactId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<ContactNoteListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetContactNotes?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (contactId !== undefined && contactId !== null)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactNoteListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactNoteListIHandleError>;
        }));
    }

    protected processGetContactNotes(response: HttpResponseBase): Observable<ContactNoteListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactNoteListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactNoteListIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteContactNote(id: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/DeleteContactNote?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContactNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContactNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteContactNote(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getRecentNotes(): Observable<ContactNoteListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetRecentNotes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactNoteListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactNoteListIHandleError>;
        }));
    }

    protected processGetRecentNotes(response: HttpResponseBase): Observable<ContactNoteListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactNoteListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactNoteListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateContactTag(body: CreateUpdateContactTagsDto | null | undefined): Observable<ContactTagListDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/CreateOrUpdateContactTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateContactTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateContactTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactTagListDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactTagListDtoListIHandleError>;
        }));
    }

    protected processCreateOrUpdateContactTag(response: HttpResponseBase): Observable<ContactTagListDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactTagListDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactTagListDtoListIHandleError>(null as any);
    }

    /**
     * @param type (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getTags(type: any | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<TagListDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetTags?";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagListDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagListDtoListIHandleError>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<TagListDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TagListDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TagListDtoListIHandleError>(null as any);
    }

    /**
     * @param contactId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getContactTags(contactId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<ContactTagListDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetContactTags?";
        if (contactId !== undefined && contactId !== null)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactTagListDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactTagListDtoListIHandleError>;
        }));
    }

    protected processGetContactTags(response: HttpResponseBase): Observable<ContactTagListDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactTagListDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactTagListDtoListIHandleError>(null as any);
    }

    /**
     * @param tagId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    deleteTag(tagId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/DeleteTag?";
        if (tagId !== undefined && tagId !== null)
            url_ += "TagId=" + encodeURIComponent("" + tagId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteTag(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param contactTagId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    deleteContactTag(contactTagId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/DeleteContactTag?";
        if (contactTagId !== undefined && contactTagId !== null)
            url_ += "ContactTagId=" + encodeURIComponent("" + contactTagId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContactTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContactTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteContactTag(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createClientStage(body: ClientStageDto | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/CreateClientStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClientStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClientStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCreateClientStage(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClientStage(body: ClientStageDto | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/UpdateClientStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClientStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClientStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processUpdateClientStage(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteClientStage(id: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/DeleteClientStage?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClientStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClientStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteClientStage(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getAllClientStages(): Observable<ClientStageDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetAllClientStages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClientStages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClientStages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientStageDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientStageDtoListIHandleError>;
        }));
    }

    protected processGetAllClientStages(response: HttpResponseBase): Observable<ClientStageDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientStageDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientStageDtoListIHandleError>(null as any);
    }

    /**
     * @param source (optional) 
     * @return Success
     */
    createClientSource(source: string | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/CreateClientSource?";
        if (source !== undefined && source !== null)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClientSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClientSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCreateClientSource(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClientSource(body: ClientSourceDto | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/UpdateClientSource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClientSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClientSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processUpdateClientSource(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteClientSource(id: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/DeleteClientSource?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteClientSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteClientSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteClientSource(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getAllClientSources(): Observable<ClientSourceDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/GetAllClientSources";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClientSources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClientSources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientSourceDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientSourceDtoListIHandleError>;
        }));
    }

    protected processGetAllClientSources(response: HttpResponseBase): Observable<ClientSourceDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ClientSourceDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientSourceDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDisplayNameFormat(body: TenantClientDisplay | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Contact/UpdateDisplayNameFormat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDisplayNameFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDisplayNameFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processUpdateDisplayNameFormat(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }
}

@Injectable()
export class ConversationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFeed(body: GetConversationFeedInput | null | undefined): Observable<ConversationFeedDto> {
        let url_ = this.baseUrl + "/api/services/app/Conversation/GetFeed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConversationFeedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConversationFeedDto>;
        }));
    }

    protected processGetFeed(response: HttpResponseBase): Observable<ConversationFeedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConversationFeedDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConversationFeedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCounts(body: GetConversationCountsInput | null | undefined): Observable<ConversationCountsDto> {
        let url_ = this.baseUrl + "/api/services/app/Conversation/GetCounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConversationCountsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConversationCountsDto>;
        }));
    }

    protected processGetCounts(response: HttpResponseBase): Observable<ConversationCountsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConversationCountsDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConversationCountsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setReadState(body: SetConversationReadStateInput | null | undefined): Observable<ConversationReadStateResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Conversation/SetReadState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetReadState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetReadState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConversationReadStateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConversationReadStateResultDto>;
        }));
    }

    protected processSetReadState(response: HttpResponseBase): Observable<ConversationReadStateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConversationReadStateResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConversationReadStateResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    autoReadAmbient(body: AutoReadAmbientInput | null | undefined): Observable<ConversationReadStateResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Conversation/AutoReadAmbient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAutoReadAmbient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutoReadAmbient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConversationReadStateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConversationReadStateResultDto>;
        }));
    }

    protected processAutoReadAmbient(response: HttpResponseBase): Observable<ConversationReadStateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConversationReadStateResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConversationReadStateResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    undo(body: UndoConversationReadStateInput | null | undefined): Observable<ConversationReadStateResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Conversation/Undo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConversationReadStateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConversationReadStateResultDto>;
        }));
    }

    protected processUndo(response: HttpResponseBase): Observable<ConversationReadStateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConversationReadStateResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConversationReadStateResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getScopeProjects(body: GetConversationScopeProjectsInput | null | undefined): Observable<ConversationScopeProjectsDto> {
        let url_ = this.baseUrl + "/api/services/app/Conversation/GetScopeProjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScopeProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScopeProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConversationScopeProjectsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConversationScopeProjectsDto>;
        }));
    }

    protected processGetScopeProjects(response: HttpResponseBase): Observable<ConversationScopeProjectsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConversationScopeProjectsDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConversationScopeProjectsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recordRecentProject(body: RecordConversationRecentProjectInput | null | undefined): Observable<ConversationScopeProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/Conversation/RecordRecentProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecordRecentProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecordRecentProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConversationScopeProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConversationScopeProjectDto>;
        }));
    }

    protected processRecordRecentProject(response: HttpResponseBase): Observable<ConversationScopeProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConversationScopeProjectDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConversationScopeProjectDto>(null as any);
    }
}

@Injectable()
export class DashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getTokenForReports(): Observable<EmbedConfigOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetTokenForReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokenForReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokenForReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmbedConfigOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmbedConfigOutputDto>;
        }));
    }

    protected processGetTokenForReports(response: HttpResponseBase): Observable<EmbedConfigOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EmbedConfigOutputDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmbedConfigOutputDto>(null as any);
    }

    /**
     * @return Success
     */
    getTokenForSalesReports(): Observable<EmbedConfigOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetTokenForSalesReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokenForSalesReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokenForSalesReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmbedConfigOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmbedConfigOutputDto>;
        }));
    }

    protected processGetTokenForSalesReports(response: HttpResponseBase): Observable<EmbedConfigOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EmbedConfigOutputDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmbedConfigOutputDto>(null as any);
    }
}

@Injectable()
export class DiscoveryEvaluationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    evaluate(body: DiscoveryEvaluationInput | null | undefined): Observable<DiscoveryEvaluationReportDto> {
        let url_ = this.baseUrl + "/api/services/app/DiscoveryEvaluation/Evaluate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEvaluate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEvaluate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiscoveryEvaluationReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiscoveryEvaluationReportDto>;
        }));
    }

    protected processEvaluate(response: HttpResponseBase): Observable<DiscoveryEvaluationReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DiscoveryEvaluationReportDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiscoveryEvaluationReportDto>(null as any);
    }
}

@Injectable()
export class DiscoveryJobsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param entryPoint (optional) 
     * @return Success
     */
    getCurrent(entryPoint: any | null | undefined): Observable<DiscoveryJobDto> {
        let url_ = this.baseUrl + "/api/services/app/DiscoveryJobs/GetCurrent?";
        if (entryPoint !== undefined && entryPoint !== null)
            url_ += "EntryPoint=" + encodeURIComponent("" + entryPoint) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiscoveryJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiscoveryJobDto>;
        }));
    }

    protected processGetCurrent(response: HttpResponseBase): Observable<DiscoveryJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DiscoveryJobDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiscoveryJobDto>(null as any);
    }
}

@Injectable()
export class DriveCategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getContentManagers(): Observable<DriveCategoryManagerDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/DriveCategory/GetContentManagers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContentManagers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContentManagers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DriveCategoryManagerDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DriveCategoryManagerDtoListIHandleError>;
        }));
    }

    protected processGetContentManagers(response: HttpResponseBase): Observable<DriveCategoryManagerDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DriveCategoryManagerDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DriveCategoryManagerDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateDriveCategoryManager(body: CreateOrUpdateDriveCategoryManagerInputDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/DriveCategory/CreateOrUpdateDriveCategoryManager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateDriveCategoryManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateDriveCategoryManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateOrUpdateDriveCategoryManager(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param entityId (optional) 
     * @return Success
     */
    deleteDriveCategoryManager(entityId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/DriveCategory/DeleteDriveCategoryManager?";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDriveCategoryManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDriveCategoryManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteDriveCategoryManager(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<EditionListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionListDtoListResultDto>;
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<EditionListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EditionListDtoListResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionListDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number | null | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionEditOutput>;
        }));
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetEditionEditOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditionEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEdition(body: CreateOrUpdateEditionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateOrUpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEdition(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param selectedEditionId (optional) 
     * @param addAllItem (optional) 
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number | null | undefined, addAllItem: boolean | null | undefined, onlyFreeItems: boolean | null | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId !== undefined && selectedEditionId !== null)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem !== undefined && addAllItem !== null)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems !== undefined && onlyFreeItems !== null)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscribableEditionComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscribableEditionComboboxItemDto[]>;
        }));
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribableEditionComboboxItemDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscribableEditionComboboxItemDto[]>(null as any);
    }
}

@Injectable()
export class EmailAutomationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getBulkCompleteDecision(taskId: number | null | undefined): Observable<BulkCompleteDecisionDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetBulkCompleteDecision?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkCompleteDecision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkCompleteDecision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkCompleteDecisionDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkCompleteDecisionDtoIHandleError>;
        }));
    }

    protected processGetBulkCompleteDecision(response: HttpResponseBase): Observable<BulkCompleteDecisionDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BulkCompleteDecisionDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BulkCompleteDecisionDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeTasksInBulk(body: CompleteTasksInBulkInput | null | undefined): Observable<CompleteTasksInBulkResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/CompleteTasksInBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteTasksInBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteTasksInBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompleteTasksInBulkResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompleteTasksInBulkResultDtoIHandleError>;
        }));
    }

    protected processCompleteTasksInBulk(response: HttpResponseBase): Observable<CompleteTasksInBulkResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompleteTasksInBulkResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompleteTasksInBulkResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFollowUpTiming(body: UpdateFollowUpTimingInput | null | undefined): Observable<TaskFollowUpDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/UpdateFollowUpTiming";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFollowUpTiming(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFollowUpTiming(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskFollowUpDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskFollowUpDtoIHandleError>;
        }));
    }

    protected processUpdateFollowUpTiming(response: HttpResponseBase): Observable<TaskFollowUpDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskFollowUpDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskFollowUpDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelTaskFollowUp(body: CancelTaskFollowUpInput | null | undefined): Observable<TaskFollowUpDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/CancelTaskFollowUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelTaskFollowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelTaskFollowUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskFollowUpDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskFollowUpDtoIHandleError>;
        }));
    }

    protected processCancelTaskFollowUp(response: HttpResponseBase): Observable<TaskFollowUpDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskFollowUpDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskFollowUpDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    extendTaskFollowUp(body: ExtendTaskFollowUpInput | null | undefined): Observable<TaskFollowUpDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/ExtendTaskFollowUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendTaskFollowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendTaskFollowUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskFollowUpDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskFollowUpDtoIHandleError>;
        }));
    }

    protected processExtendTaskFollowUp(response: HttpResponseBase): Observable<TaskFollowUpDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskFollowUpDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskFollowUpDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTaskHasOutbound(taskId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetTaskHasOutbound?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskHasOutbound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskHasOutbound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processGetTaskHasOutbound(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getFirstEmailTaskId(): Observable<Int32NullableIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetFirstEmailTaskId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirstEmailTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirstEmailTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32NullableIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32NullableIHandleError>;
        }));
    }

    protected processGetFirstEmailTaskId(response: HttpResponseBase): Observable<Int32NullableIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32NullableIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32NullableIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getSuggestedContacts(projectId: number | null | undefined): Observable<SuggestedContactDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetSuggestedContacts?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestedContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestedContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuggestedContactDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuggestedContactDtoListIHandleError>;
        }));
    }

    protected processGetSuggestedContacts(response: HttpResponseBase): Observable<SuggestedContactDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SuggestedContactDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SuggestedContactDtoListIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTaskProjectCandidates(taskId: number | null | undefined): Observable<TaskProjectCandidateDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetTaskProjectCandidates?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskProjectCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskProjectCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskProjectCandidateDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskProjectCandidateDtoListIHandleError>;
        }));
    }

    protected processGetTaskProjectCandidates(response: HttpResponseBase): Observable<TaskProjectCandidateDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskProjectCandidateDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskProjectCandidateDtoListIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTaskClientCandidates(taskId: number | null | undefined): Observable<TaskClientCandidateDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetTaskClientCandidates?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskClientCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskClientCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskClientCandidateDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskClientCandidateDtoListIHandleError>;
        }));
    }

    protected processGetTaskClientCandidates(response: HttpResponseBase): Observable<TaskClientCandidateDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskClientCandidateDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskClientCandidateDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setTaskClient(body: SetTaskClientInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/SetTaskClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTaskClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTaskClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processSetTaskClient(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setTaskProject(body: SetTaskProjectInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/SetTaskProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTaskProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTaskProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processSetTaskProject(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTaskReview(taskId: number | null | undefined): Observable<ReviewInfoDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetTaskReview?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewInfoDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewInfoDtoIHandleError>;
        }));
    }

    protected processGetTaskReview(response: HttpResponseBase): Observable<ReviewInfoDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ReviewInfoDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReviewInfoDtoIHandleError>(null as any);
    }

    /**
     * @param reviewId (optional) 
     * @return Success
     */
    confirmReview(reviewId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/ConfirmReview?";
        if (reviewId !== undefined && reviewId !== null)
            url_ += "reviewId=" + encodeURIComponent("" + reviewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processConfirmReview(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param reviewId (optional) 
     * @return Success
     */
    dismissReview(reviewId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/DismissReview?";
        if (reviewId !== undefined && reviewId !== null)
            url_ += "reviewId=" + encodeURIComponent("" + reviewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDismissReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDismissReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDismissReview(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param reviewId (optional) 
     * @param automationId (optional) 
     * @return Success
     */
    resolveAmbiguousAutomation(reviewId: number | null | undefined, automationId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/ResolveAmbiguousAutomation?";
        if (reviewId !== undefined && reviewId !== null)
            url_ += "reviewId=" + encodeURIComponent("" + reviewId) + "&";
        if (automationId !== undefined && automationId !== null)
            url_ += "automationId=" + encodeURIComponent("" + automationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveAmbiguousAutomation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveAmbiguousAutomation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processResolveAmbiguousAutomation(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param reviewId (optional) 
     * @param clientId (optional) 
     * @return Success
     */
    correctReview(reviewId: number | null | undefined, clientId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/CorrectReview?";
        if (reviewId !== undefined && reviewId !== null)
            url_ += "reviewId=" + encodeURIComponent("" + reviewId) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCorrectReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCorrectReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processCorrectReview(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    resetUserEmailTuning(): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/ResetUserEmailTuning";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserEmailTuning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserEmailTuning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processResetUserEmailTuning(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getUserSenderMemory(): Observable<SenderMemoryDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetUserSenderMemory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSenderMemory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSenderMemory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SenderMemoryDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SenderMemoryDtoListIHandleError>;
        }));
    }

    protected processGetUserSenderMemory(response: HttpResponseBase): Observable<SenderMemoryDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SenderMemoryDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SenderMemoryDtoListIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removeSenderMemory(id: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/RemoveSenderMemory?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveSenderMemory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSenderMemory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processRemoveSenderMemory(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    resetUserMemory(): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/ResetUserMemory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserMemory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserMemory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processResetUserMemory(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getOpenReviews(): Observable<OpenReviewDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetOpenReviews";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpenReviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpenReviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpenReviewDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpenReviewDtoListIHandleError>;
        }));
    }

    protected processGetOpenReviews(response: HttpResponseBase): Observable<OpenReviewDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OpenReviewDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OpenReviewDtoListIHandleError>(null as any);
    }

    /**
     * @param suggestionId (optional) 
     * @return Success
     */
    confirmSuggestedContact(suggestionId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/ConfirmSuggestedContact?";
        if (suggestionId !== undefined && suggestionId !== null)
            url_ += "suggestionId=" + encodeURIComponent("" + suggestionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmSuggestedContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmSuggestedContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processConfirmSuggestedContact(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param suggestionId (optional) 
     * @return Success
     */
    dismissSuggestedContact(suggestionId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/DismissSuggestedContact?";
        if (suggestionId !== undefined && suggestionId !== null)
            url_ += "suggestionId=" + encodeURIComponent("" + suggestionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDismissSuggestedContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDismissSuggestedContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDismissSuggestedContact(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param threadKey (optional) 
     * @return Success
     */
    getTaskEmail(taskId: number | null | undefined, threadKey: string | null | undefined): Observable<TaskEmailDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetTaskEmail?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (threadKey !== undefined && threadKey !== null)
            url_ += "threadKey=" + encodeURIComponent("" + threadKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskEmailDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskEmailDtoIHandleError>;
        }));
    }

    protected processGetTaskEmail(response: HttpResponseBase): Observable<TaskEmailDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskEmailDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskEmailDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param threadKey (optional) 
     * @return Success
     */
    getOriginalEmail(taskId: number | null | undefined, threadKey: string | null | undefined): Observable<EmailBodyDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetOriginalEmail?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (threadKey !== undefined && threadKey !== null)
            url_ += "threadKey=" + encodeURIComponent("" + threadKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOriginalEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOriginalEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailBodyDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailBodyDtoIHandleError>;
        }));
    }

    protected processGetOriginalEmail(response: HttpResponseBase): Observable<EmailBodyDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EmailBodyDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailBodyDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param messageId (optional) 
     * @param attachmentId (optional) 
     * @param threadKey (optional) 
     * @return Success
     */
    getAttachmentContent(taskId: number | null | undefined, messageId: string | null | undefined, attachmentId: string | null | undefined, threadKey: string | null | undefined): Observable<EmailAttachmentContentDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetAttachmentContent?";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (messageId !== undefined && messageId !== null)
            url_ += "MessageId=" + encodeURIComponent("" + messageId) + "&";
        if (attachmentId !== undefined && attachmentId !== null)
            url_ += "AttachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        if (threadKey !== undefined && threadKey !== null)
            url_ += "ThreadKey=" + encodeURIComponent("" + threadKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAttachmentContentDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAttachmentContentDtoIHandleError>;
        }));
    }

    protected processGetAttachmentContent(response: HttpResponseBase): Observable<EmailAttachmentContentDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EmailAttachmentContentDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailAttachmentContentDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param top (optional) 
     * @param includeSummary (optional) 
     * @param threadKey (optional) 
     * @return Success
     */
    getTaskThread(taskId: number | null | undefined, top: number | null | undefined, includeSummary: boolean | null | undefined, threadKey: string | null | undefined): Observable<TaskThreadDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetTaskThread?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (top !== undefined && top !== null)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (includeSummary !== undefined && includeSummary !== null)
            url_ += "includeSummary=" + encodeURIComponent("" + includeSummary) + "&";
        if (threadKey !== undefined && threadKey !== null)
            url_ += "threadKey=" + encodeURIComponent("" + threadKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskThread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskThread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskThreadDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskThreadDtoIHandleError>;
        }));
    }

    protected processGetTaskThread(response: HttpResponseBase): Observable<TaskThreadDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskThreadDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskThreadDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param threadKey (optional) 
     * @param top (optional) 
     * @return Success
     */
    getConversationEmailThread(taskId: number | null | undefined, threadKey: string | null | undefined, top: number | null | undefined): Observable<TaskThreadDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetConversationEmailThread?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (threadKey !== undefined && threadKey !== null)
            url_ += "threadKey=" + encodeURIComponent("" + threadKey) + "&";
        if (top !== undefined && top !== null)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConversationEmailThread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConversationEmailThread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskThreadDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskThreadDtoIHandleError>;
        }));
    }

    protected processGetConversationEmailThread(response: HttpResponseBase): Observable<TaskThreadDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskThreadDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskThreadDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stampThreadOutbound(body: StampThreadOutboundInput | null | undefined): Observable<StampThreadOutboundResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/StampThreadOutbound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStampThreadOutbound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStampThreadOutbound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StampThreadOutboundResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StampThreadOutboundResultDtoIHandleError>;
        }));
    }

    protected processStampThreadOutbound(response: HttpResponseBase): Observable<StampThreadOutboundResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StampThreadOutboundResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StampThreadOutboundResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    syncTaskThreadMessages(body: SyncTaskThreadMessagesInput | null | undefined): Observable<SyncTaskThreadMessagesResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/SyncTaskThreadMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncTaskThreadMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncTaskThreadMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SyncTaskThreadMessagesResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SyncTaskThreadMessagesResultDtoIHandleError>;
        }));
    }

    protected processSyncTaskThreadMessages(response: HttpResponseBase): Observable<SyncTaskThreadMessagesResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SyncTaskThreadMessagesResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SyncTaskThreadMessagesResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshTaskConversationSummary(body: RefreshTaskConversationSummaryInput | null | undefined): Observable<ConversationSummaryDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/RefreshTaskConversationSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshTaskConversationSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshTaskConversationSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConversationSummaryDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConversationSummaryDtoIHandleError>;
        }));
    }

    protected processRefreshTaskConversationSummary(response: HttpResponseBase): Observable<ConversationSummaryDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConversationSummaryDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConversationSummaryDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param threadKey (optional) 
     * @return Success
     */
    getReplySuggestions(taskId: number | null | undefined, threadKey: string | null | undefined): Observable<ReplySuggestionDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetReplySuggestions?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (threadKey !== undefined && threadKey !== null)
            url_ += "threadKey=" + encodeURIComponent("" + threadKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReplySuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReplySuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplySuggestionDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplySuggestionDtoListIHandleError>;
        }));
    }

    protected processGetReplySuggestions(response: HttpResponseBase): Observable<ReplySuggestionDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ReplySuggestionDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReplySuggestionDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendReply(body: SendEmailReplyInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/SendReply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processSendReply(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendNewEmail(body: SendNewTaskEmailInput | null | undefined): Observable<SendNewTaskEmailResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/SendNewEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNewEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNewEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendNewTaskEmailResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendNewTaskEmailResultDtoIHandleError>;
        }));
    }

    protected processSendNewEmail(response: HttpResponseBase): Observable<SendNewTaskEmailResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SendNewTaskEmailResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendNewTaskEmailResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    suggestFollowUp(body: SuggestFollowUpInput | null | undefined): Observable<FollowUpSuggestionDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/SuggestFollowUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuggestFollowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuggestFollowUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FollowUpSuggestionDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FollowUpSuggestionDtoIHandleError>;
        }));
    }

    protected processSuggestFollowUp(response: HttpResponseBase): Observable<FollowUpSuggestionDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = FollowUpSuggestionDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FollowUpSuggestionDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getRespondSuggestionForReceivedEmail(taskId: number | null | undefined): Observable<FollowUpSuggestionDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetRespondSuggestionForReceivedEmail?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRespondSuggestionForReceivedEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRespondSuggestionForReceivedEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FollowUpSuggestionDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FollowUpSuggestionDtoIHandleError>;
        }));
    }

    protected processGetRespondSuggestionForReceivedEmail(response: HttpResponseBase): Observable<FollowUpSuggestionDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = FollowUpSuggestionDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FollowUpSuggestionDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getReplyBeforeCompleteWarning(taskId: number | null | undefined): Observable<ReplyBeforeCompleteWarningDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetReplyBeforeCompleteWarning?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReplyBeforeCompleteWarning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReplyBeforeCompleteWarning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyBeforeCompleteWarningDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyBeforeCompleteWarningDtoIHandleError>;
        }));
    }

    protected processGetReplyBeforeCompleteWarning(response: HttpResponseBase): Observable<ReplyBeforeCompleteWarningDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ReplyBeforeCompleteWarningDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReplyBeforeCompleteWarningDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkReplyBeforeComplete(body: CheckReplyBeforeCompleteInput | null | undefined): Observable<ReplyBeforeCompleteWarningDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/CheckReplyBeforeComplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckReplyBeforeComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckReplyBeforeComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyBeforeCompleteWarningDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyBeforeCompleteWarningDtoIHandleError>;
        }));
    }

    protected processCheckReplyBeforeComplete(response: HttpResponseBase): Observable<ReplyBeforeCompleteWarningDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ReplyBeforeCompleteWarningDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReplyBeforeCompleteWarningDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param contactId (optional) 
     * @param projectId (optional) 
     * @return Success
     */
    getReplyAttachContext(taskId: number | null | undefined, contactId: number | null | undefined, projectId: number | null | undefined): Observable<ReplyAttachContextDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetReplyAttachContext?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (contactId !== undefined && contactId !== null)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReplyAttachContext(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReplyAttachContext(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReplyAttachContextDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReplyAttachContextDtoIHandleError>;
        }));
    }

    protected processGetReplyAttachContext(response: HttpResponseBase): Observable<ReplyAttachContextDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ReplyAttachContextDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReplyAttachContextDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unmergeEmailThread(body: UnmergeEmailThreadInput | null | undefined): Observable<UnmergeEmailThreadResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/UnmergeEmailThread";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnmergeEmailThread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnmergeEmailThread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnmergeEmailThreadResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnmergeEmailThreadResultDtoIHandleError>;
        }));
    }

    protected processUnmergeEmailThread(response: HttpResponseBase): Observable<UnmergeEmailThreadResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UnmergeEmailThreadResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UnmergeEmailThreadResultDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTaskMergeInfo(taskId: number | null | undefined): Observable<TaskMergeInfoDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetTaskMergeInfo?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskMergeInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskMergeInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskMergeInfoDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskMergeInfoDtoIHandleError>;
        }));
    }

    protected processGetTaskMergeInfo(response: HttpResponseBase): Observable<TaskMergeInfoDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskMergeInfoDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskMergeInfoDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTaskFollowUp(taskId: number | null | undefined): Observable<TaskFollowUpDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/GetTaskFollowUp?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskFollowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskFollowUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskFollowUpDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskFollowUpDtoIHandleError>;
        }));
    }

    protected processGetTaskFollowUp(response: HttpResponseBase): Observable<TaskFollowUpDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskFollowUpDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskFollowUpDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    armTaskFollowUp(body: ArmTaskFollowUpInput | null | undefined): Observable<TaskFollowUpDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/ArmTaskFollowUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArmTaskFollowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArmTaskFollowUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskFollowUpDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskFollowUpDtoIHandleError>;
        }));
    }

    protected processArmTaskFollowUp(response: HttpResponseBase): Observable<TaskFollowUpDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskFollowUpDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskFollowUpDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    scheduleTaskFollowUp(body: ScheduleTaskFollowUpInput | null | undefined): Observable<ScheduleTaskFollowUpResultIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/ScheduleTaskFollowUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleTaskFollowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleTaskFollowUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleTaskFollowUpResultIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleTaskFollowUpResultIHandleError>;
        }));
    }

    protected processScheduleTaskFollowUp(response: HttpResponseBase): Observable<ScheduleTaskFollowUpResultIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ScheduleTaskFollowUpResultIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleTaskFollowUpResultIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeTaskWithoutFollowUp(body: CompleteTaskWithoutFollowUpInput | null | undefined): Observable<CompleteTaskWithoutFollowUpResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomation/CompleteTaskWithoutFollowUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteTaskWithoutFollowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteTaskWithoutFollowUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompleteTaskWithoutFollowUpResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompleteTaskWithoutFollowUpResultDtoIHandleError>;
        }));
    }

    protected processCompleteTaskWithoutFollowUp(response: HttpResponseBase): Observable<CompleteTaskWithoutFollowUpResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompleteTaskWithoutFollowUpResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompleteTaskWithoutFollowUpResultDtoIHandleError>(null as any);
    }
}

@Injectable()
export class EmailAutomationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAutomations(): Observable<EmailAutomationListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomations/GetAutomations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutomations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutomations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAutomationListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAutomationListItemDto[]>;
        }));
    }

    protected processGetAutomations(response: HttpResponseBase): Observable<EmailAutomationListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailAutomationListItemDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailAutomationListItemDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAutomationForEdit(id: number | null | undefined): Observable<EmailAutomationDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomations/GetAutomationForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutomationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutomationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAutomationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAutomationDto>;
        }));
    }

    protected processGetAutomationForEdit(response: HttpResponseBase): Observable<EmailAutomationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EmailAutomationDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailAutomationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAutomation(body: EmailAutomationDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomations/CreateOrUpdateAutomation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAutomation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAutomation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateAutomation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAutomation(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomations/DeleteAutomation?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAutomation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAutomation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAutomation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isEnabled (optional) 
     * @return Success
     */
    setAutomationEnabled(id: number | null | undefined, isEnabled: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomations/SetAutomationEnabled?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isEnabled !== undefined && isEnabled !== null)
            url_ += "isEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAutomationEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAutomationEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAutomationEnabled(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    interpretAutomation(body: InterpretAutomationInput | null | undefined): Observable<InterpretAutomationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomations/InterpretAutomation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInterpretAutomation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInterpretAutomation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InterpretAutomationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InterpretAutomationResultDto>;
        }));
    }

    protected processInterpretAutomation(response: HttpResponseBase): Observable<InterpretAutomationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = InterpretAutomationResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InterpretAutomationResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkAutomationOverlap(body: CheckAutomationOverlapInput | null | undefined): Observable<CheckAutomationOverlapResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomations/CheckAutomationOverlap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAutomationOverlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAutomationOverlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckAutomationOverlapResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckAutomationOverlapResultDto>;
        }));
    }

    protected processCheckAutomationOverlap(response: HttpResponseBase): Observable<CheckAutomationOverlapResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CheckAutomationOverlapResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckAutomationOverlapResultDto>(null as any);
    }
}

@Injectable()
export class EmailAutomationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getSettings(): Observable<EmailAutomationSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomationSettings/GetSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailAutomationSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailAutomationSettingsDto>;
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<EmailAutomationSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EmailAutomationSettingsDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailAutomationSettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSettings(body: EmailAutomationSettingsDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomationSettings/UpdateSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getUserSettings(): Observable<UserEmailAutomationSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomationSettings/GetUserSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEmailAutomationSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEmailAutomationSettingsDto>;
        }));
    }

    protected processGetUserSettings(response: HttpResponseBase): Observable<UserEmailAutomationSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserEmailAutomationSettingsDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserEmailAutomationSettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserSettings(body: UserEmailAutomationSettingsDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailAutomationSettings/UpdateUserSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class EmailSharedInboxServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param address (optional) 
     * @return Success
     */
    probeMailboxAccess(address: string | null | undefined): Observable<ProbeMailboxResultIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailSharedInbox/ProbeMailboxAccess?";
        if (address !== undefined && address !== null)
            url_ += "address=" + encodeURIComponent("" + address) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProbeMailboxAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProbeMailboxAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProbeMailboxResultIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProbeMailboxResultIHandleError>;
        }));
    }

    protected processProbeMailboxAccess(response: HttpResponseBase): Observable<ProbeMailboxResultIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProbeMailboxResultIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProbeMailboxResultIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    connectSharedInbox(body: ConnectSharedInboxInput | null | undefined): Observable<SharedInboxDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailSharedInbox/ConnectSharedInbox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConnectSharedInbox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConnectSharedInbox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedInboxDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedInboxDtoIHandleError>;
        }));
    }

    protected processConnectSharedInbox(response: HttpResponseBase): Observable<SharedInboxDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SharedInboxDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SharedInboxDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSharedInbox(body: UpdateSharedInboxInput | null | undefined): Observable<SharedInboxDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailSharedInbox/UpdateSharedInbox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSharedInbox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSharedInbox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedInboxDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedInboxDtoIHandleError>;
        }));
    }

    protected processUpdateSharedInbox(response: HttpResponseBase): Observable<SharedInboxDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SharedInboxDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SharedInboxDtoIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getSharedInboxes(): Observable<SharedInboxDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailSharedInbox/GetSharedInboxes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSharedInboxes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSharedInboxes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharedInboxDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharedInboxDtoListIHandleError>;
        }));
    }

    protected processGetSharedInboxes(response: HttpResponseBase): Observable<SharedInboxDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SharedInboxDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SharedInboxDtoListIHandleError>(null as any);
    }

    /**
     * @param sharedInboxId (optional) 
     * @return Success
     */
    alsoConnectMyAccess(sharedInboxId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailSharedInbox/AlsoConnectMyAccess?";
        if (sharedInboxId !== undefined && sharedInboxId !== null)
            url_ += "sharedInboxId=" + encodeURIComponent("" + sharedInboxId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAlsoConnectMyAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAlsoConnectMyAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processAlsoConnectMyAccess(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param sharedInboxId (optional) 
     * @return Success
     */
    removeSharedInbox(sharedInboxId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/EmailSharedInbox/RemoveSharedInbox?";
        if (sharedInboxId !== undefined && sharedInboxId !== null)
            url_ += "sharedInboxId=" + encodeURIComponent("" + sharedInboxId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveSharedInbox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSharedInbox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processRemoveSharedInbox(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }
}

@Injectable()
export class EventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param eventId (optional) 
     * @param scope (optional) 
     * @return Success
     */
    deleteEvent(eventId: number | null | undefined, scope: any | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Event/DeleteEvent?";
        if (eventId !== undefined && eventId !== null)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&";
        if (scope !== undefined && scope !== null)
            url_ += "Scope=" + encodeURIComponent("" + scope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    declineEvent(body: DeclineEventInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Event/DeclineEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeclineEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeclineEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeclineEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmEventProject(body: ConfirmEventProjectInput | null | undefined): Observable<EventDto> {
        let url_ = this.baseUrl + "/api/services/app/Event/ConfirmEventProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEventProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEventProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventDto>;
        }));
    }

    protected processConfirmEventProject(response: HttpResponseBase): Observable<EventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EventDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventDto>(null as any);
    }

    /**
     * @return Success
     */
    getBookableOrganizers(): Observable<BookableUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Event/GetBookableOrganizers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookableOrganizers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookableOrganizers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookableUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookableUserDto[]>;
        }));
    }

    protected processGetBookableOrganizers(response: HttpResponseBase): Observable<BookableUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookableUserDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookableUserDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getMyDefaultTimeZone(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Event/GetMyDefaultTimeZone";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyDefaultTimeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyDefaultTimeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetMyDefaultTimeZone(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getCalendarTimeZones(): Observable<CalendarTimeZoneDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Event/GetCalendarTimeZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarTimeZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarTimeZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarTimeZoneDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarTimeZoneDto[]>;
        }));
    }

    protected processGetCalendarTimeZones(response: HttpResponseBase): Observable<CalendarTimeZoneDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarTimeZoneDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarTimeZoneDto[]>(null as any);
    }

    /**
     * @return Success
     */
    syncMyOutlookCalendar(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Event/SyncMyOutlookCalendar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncMyOutlookCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncMyOutlookCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSyncMyOutlookCalendar(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @return Success
     */
    syncMyOutlookCalendarRange(start: string | null | undefined, end: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Event/SyncMyOutlookCalendarRange?";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncMyOutlookCalendarRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncMyOutlookCalendarRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSyncMyOutlookCalendarRange(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getProjectClient(projectId: number | null | undefined): Observable<EventProjectClientDto> {
        let url_ = this.baseUrl + "/api/services/app/Event/GetProjectClient?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventProjectClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventProjectClientDto>;
        }));
    }

    protected processGetProjectClient(response: HttpResponseBase): Observable<EventProjectClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EventProjectClientDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventProjectClientDto>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param eventTypeId (optional) 
     * @return Success
     */
    getProjectInheritedAddress(projectId: number | null | undefined, eventTypeId: number | null | undefined): Observable<ProjectInheritedAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/Event/GetProjectInheritedAddress?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (eventTypeId !== undefined && eventTypeId !== null)
            url_ += "eventTypeId=" + encodeURIComponent("" + eventTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectInheritedAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectInheritedAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectInheritedAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectInheritedAddressDto>;
        }));
    }

    protected processGetProjectInheritedAddress(response: HttpResponseBase): Observable<ProjectInheritedAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectInheritedAddressDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectInheritedAddressDto>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getProjectClientFieldNames(projectId: number | null | undefined): Observable<ProjectClientFieldNameDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Event/GetProjectClientFieldNames?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectClientFieldNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectClientFieldNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectClientFieldNameDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectClientFieldNameDto[]>;
        }));
    }

    protected processGetProjectClientFieldNames(response: HttpResponseBase): Observable<ProjectClientFieldNameDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectClientFieldNameDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectClientFieldNameDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getEventTypesForCalendar(): Observable<EventTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Event/GetEventTypesForCalendar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventTypesForCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventTypesForCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventTypeDto[]>;
        }));
    }

    protected processGetEventTypesForCalendar(response: HttpResponseBase): Observable<EventTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventTypeDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventTypeDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param selectedDate (optional) 
     * @return Success
     */
    getMyMeetingsBar(userId: number | null | undefined, selectedDate: string | null | undefined): Observable<MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Event/GetMyMeetingsBar?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (selectedDate !== undefined && selectedDate !== null)
            url_ += "SelectedDate=" + encodeURIComponent("" + selectedDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyMeetingsBar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyMeetingsBar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError>;
        }));
    }

    protected processGetMyMeetingsBar(response: HttpResponseBase): Observable<MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError>(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @return Success
     */
    getWorkspaceEvents(start: string | null | undefined, end: string | null | undefined): Observable<EventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Event/GetWorkspaceEvents?";
        if (start !== undefined && start !== null)
            url_ += "Start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "End=" + encodeURIComponent("" + end) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkspaceEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkspaceEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventDto[]>;
        }));
    }

    protected processGetWorkspaceEvents(response: HttpResponseBase): Observable<EventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventDto[]>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param start (optional) 
     * @param end (optional) 
     * @return Success
     */
    getProjectEvents(projectId: number | null | undefined, start: string | null | undefined, end: string | null | undefined): Observable<EventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Event/GetProjectEvents?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (start !== undefined && start !== null)
            url_ += "Start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "End=" + encodeURIComponent("" + end) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventDto[]>;
        }));
    }

    protected processGetProjectEvents(response: HttpResponseBase): Observable<EventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventDto[]>(null as any);
    }

    /**
     * @param clientId (optional) 
     * @param kind (optional) 
     * @return Success
     */
    getClientEvents(clientId: number | null | undefined, kind: any | null | undefined): Observable<EventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Event/GetClientEvents?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (kind !== undefined && kind !== null)
            url_ += "Kind=" + encodeURIComponent("" + kind) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventDto[]>;
        }));
    }

    protected processGetClientEvents(response: HttpResponseBase): Observable<EventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectNextEvents(body: GetProjectNextEventsInput | null | undefined): Observable<ProjectNextEventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Event/GetProjectNextEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectNextEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectNextEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectNextEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectNextEventDto[]>;
        }));
    }

    protected processGetProjectNextEvents(response: HttpResponseBase): Observable<ProjectNextEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectNextEventDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectNextEventDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEvent(id: number | null | undefined): Observable<EventDto> {
        let url_ = this.baseUrl + "/api/services/app/Event/GetEvent?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventDto>;
        }));
    }

    protected processGetEvent(response: HttpResponseBase): Observable<EventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EventDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveEvent(body: SaveEventInput | null | undefined): Observable<EventDto> {
        let url_ = this.baseUrl + "/api/services/app/Event/SaveEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventDto>;
        }));
    }

    protected processSaveEvent(response: HttpResponseBase): Observable<EventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EventDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventDto>(null as any);
    }
}

@Injectable()
export class EventTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getEventTypes(): Observable<EventTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EventType/GetEventTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventTypeDto[]>;
        }));
    }

    protected processGetEventTypes(response: HttpResponseBase): Observable<EventTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventTypeDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventTypeDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveEventType(body: SaveEventTypeInput | null | undefined): Observable<EventTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/EventType/SaveEventType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEventType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEventType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventTypeDto>;
        }));
    }

    protected processSaveEventType(response: HttpResponseBase): Observable<EventTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EventTypeDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventTypeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEventType(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventType/DeleteEventType?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEventType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEventType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEventType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAddressFieldOptions(): Observable<AddressFieldOptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EventType/GetAddressFieldOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressFieldOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressFieldOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressFieldOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressFieldOptionDto[]>;
        }));
    }

    protected processGetAddressFieldOptions(response: HttpResponseBase): Observable<AddressFieldOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressFieldOptionDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressFieldOptionDto[]>(null as any);
    }
}

@Injectable()
export class ExternalCompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCompanyExternal(body: CreateExtCompanyInput | null | undefined): Observable<CompanyResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalCompany/CreateCompanyExternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCompanyExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCompanyExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyResult>;
        }));
    }

    protected processCreateCompanyExternal(response: HttpResponseBase): Observable<CompanyResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CompanyResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyResult>(null as any);
    }

    /**
     * @return Success
     */
    getCompanyDetailExternal(apiKey: string, matchBy: string, matchValue: string): Observable<GetCompanyResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalCompany/GetCompanyDetailExternal?";
        if (apiKey === undefined || apiKey === null)
            throw new globalThis.Error("The parameter 'apiKey' must be defined and cannot be null.");
        else
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (matchBy === undefined || matchBy === null)
            throw new globalThis.Error("The parameter 'matchBy' must be defined and cannot be null.");
        else
            url_ += "MatchBy=" + encodeURIComponent("" + matchBy) + "&";
        if (matchValue === undefined || matchValue === null)
            throw new globalThis.Error("The parameter 'matchValue' must be defined and cannot be null.");
        else
            url_ += "MatchValue=" + encodeURIComponent("" + matchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyDetailExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyDetailExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCompanyResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCompanyResult>;
        }));
    }

    protected processGetCompanyDetailExternal(response: HttpResponseBase): Observable<GetCompanyResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCompanyResult>(null as any);
    }

    /**
     * @return Success
     */
    getCompanyContactExternal(apiKey: string, companyId: string): Observable<GetCompanyContactResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalCompany/GetCompanyContactExternal?";
        if (apiKey === undefined || apiKey === null)
            throw new globalThis.Error("The parameter 'apiKey' must be defined and cannot be null.");
        else
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined and cannot be null.");
        else
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyContactExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyContactExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCompanyContactResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCompanyContactResult>;
        }));
    }

    protected processGetCompanyContactExternal(response: HttpResponseBase): Observable<GetCompanyContactResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyContactResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCompanyContactResult>(null as any);
    }

    /**
     * @return Success
     */
    getUserTenantApi(trovveAppID: string, emailAddress: string): Observable<GetTenantApiOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ExternalCompany/GetUserTenantApi?";
        if (trovveAppID === undefined || trovveAppID === null)
            throw new globalThis.Error("The parameter 'trovveAppID' must be defined and cannot be null.");
        else
            url_ += "TrovveAppID=" + encodeURIComponent("" + trovveAppID) + "&";
        if (emailAddress === undefined || emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' must be defined and cannot be null.");
        else
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTenantApi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTenantApi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantApiOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantApiOutputIHandleError>;
        }));
    }

    protected processGetUserTenantApi(response: HttpResponseBase): Observable<GetTenantApiOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetTenantApiOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantApiOutputIHandleError>(null as any);
    }
}

@Injectable()
export class ApiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param apiKey (optional) 
     * @param duration (optional) 
     * @return Success
     */
    getRecentlyCreatedCompany(apiKey: string | null | undefined, duration: number | null | undefined): Observable<RecentlyCreatedCompanyOutputListIHandleError> {
        let url_ = this.baseUrl + "/trigger/api/GetRecentlyCreatedCompany?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (duration !== undefined && duration !== null)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyCreatedCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyCreatedCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentlyCreatedCompanyOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentlyCreatedCompanyOutputListIHandleError>;
        }));
    }

    protected processGetRecentlyCreatedCompany(response: HttpResponseBase): Observable<RecentlyCreatedCompanyOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RecentlyCreatedCompanyOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecentlyCreatedCompanyOutputListIHandleError>(null as any);
    }

    /**
     * @param apiKey (optional) 
     * @param duration (optional) 
     * @param updateFilter (optional) 
     * @return Success
     */
    getRecentlyUpdatedCompany(apiKey: string | null | undefined, duration: number | null | undefined, updateFilter: string | null | undefined): Observable<RecentlyUpdatedCompanyOutputListIHandleError> {
        let url_ = this.baseUrl + "/trigger/api/GetRecentlyUpdatedCompany?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (duration !== undefined && duration !== null)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        if (updateFilter !== undefined && updateFilter !== null)
            url_ += "UpdateFilter=" + encodeURIComponent("" + updateFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUpdatedCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUpdatedCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentlyUpdatedCompanyOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentlyUpdatedCompanyOutputListIHandleError>;
        }));
    }

    protected processGetRecentlyUpdatedCompany(response: HttpResponseBase): Observable<RecentlyUpdatedCompanyOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RecentlyUpdatedCompanyOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecentlyUpdatedCompanyOutputListIHandleError>(null as any);
    }

    /**
     * @param apiKey (optional) 
     * @param duration (optional) 
     * @return Success
     */
    getRecentlyCreatedContact(apiKey: string | null | undefined, duration: number | null | undefined): Observable<RecentlyCreatedContactOutputListIHandleError> {
        let url_ = this.baseUrl + "/trigger/api/GetRecentlyCreatedContact?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (duration !== undefined && duration !== null)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyCreatedContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyCreatedContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentlyCreatedContactOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentlyCreatedContactOutputListIHandleError>;
        }));
    }

    protected processGetRecentlyCreatedContact(response: HttpResponseBase): Observable<RecentlyCreatedContactOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RecentlyCreatedContactOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecentlyCreatedContactOutputListIHandleError>(null as any);
    }

    /**
     * @param apiKey (optional) 
     * @param duration (optional) 
     * @param updateFilter (optional) 
     * @return Success
     */
    getRecentlyUpdatedContact(apiKey: string | null | undefined, duration: number | null | undefined, updateFilter: string | null | undefined): Observable<RecentlyUpdatedContactOutputListIHandleError> {
        let url_ = this.baseUrl + "/trigger/api/GetRecentlyUpdatedContact?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (duration !== undefined && duration !== null)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        if (updateFilter !== undefined && updateFilter !== null)
            url_ += "UpdateFilter=" + encodeURIComponent("" + updateFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUpdatedContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUpdatedContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentlyUpdatedContactOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentlyUpdatedContactOutputListIHandleError>;
        }));
    }

    protected processGetRecentlyUpdatedContact(response: HttpResponseBase): Observable<RecentlyUpdatedContactOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RecentlyUpdatedContactOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecentlyUpdatedContactOutputListIHandleError>(null as any);
    }

    /**
     * @param apiKey (optional) 
     * @param duration (optional) 
     * @param stageFilter (optional) 
     * @param contactType (optional) 
     * @param tagFilter (optional) 
     * @return Success
     */
    getRecentlyUpdatedContactStage(apiKey: string | null | undefined, duration: number | null | undefined, stageFilter: string | null | undefined, contactType: string | null | undefined, tagFilter: string | null | undefined): Observable<RecentlyUpdatedContactStageOutputListIHandleError> {
        let url_ = this.baseUrl + "/trigger/api/GetRecentlyUpdatedContactStage?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (duration !== undefined && duration !== null)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        if (stageFilter !== undefined && stageFilter !== null)
            url_ += "StageFilter=" + encodeURIComponent("" + stageFilter) + "&";
        if (contactType !== undefined && contactType !== null)
            url_ += "ContactType=" + encodeURIComponent("" + contactType) + "&";
        if (tagFilter !== undefined && tagFilter !== null)
            url_ += "TagFilter=" + encodeURIComponent("" + tagFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUpdatedContactStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUpdatedContactStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentlyUpdatedContactStageOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentlyUpdatedContactStageOutputListIHandleError>;
        }));
    }

    protected processGetRecentlyUpdatedContactStage(response: HttpResponseBase): Observable<RecentlyUpdatedContactStageOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RecentlyUpdatedContactStageOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecentlyUpdatedContactStageOutputListIHandleError>(null as any);
    }

    /**
     * @param apiKey (optional) 
     * @param projectName (optional) 
     * @param projectId (optional) 
     * @param assigneeEmail (optional) 
     * @param creatorEmail (optional) 
     * @param duration (optional) 
     * @return Success
     */
    getRecentModifiedTasks(apiKey: string | null | undefined, projectName: string | null | undefined, projectId: string | null | undefined, assigneeEmail: string | null | undefined, creatorEmail: string | null | undefined, duration: number | null | undefined): Observable<RecentModifiedTasksExtOutputListIHandleError> {
        let url_ = this.baseUrl + "/trigger/api/GetRecentModifiedTasks?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (projectName !== undefined && projectName !== null)
            url_ += "ProjectName=" + encodeURIComponent("" + projectName) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (assigneeEmail !== undefined && assigneeEmail !== null)
            url_ += "AssigneeEmail=" + encodeURIComponent("" + assigneeEmail) + "&";
        if (creatorEmail !== undefined && creatorEmail !== null)
            url_ += "CreatorEmail=" + encodeURIComponent("" + creatorEmail) + "&";
        if (duration !== undefined && duration !== null)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentModifiedTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentModifiedTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentModifiedTasksExtOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentModifiedTasksExtOutputListIHandleError>;
        }));
    }

    protected processGetRecentModifiedTasks(response: HttpResponseBase): Observable<RecentModifiedTasksExtOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RecentModifiedTasksExtOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecentModifiedTasksExtOutputListIHandleError>(null as any);
    }

    /**
     * @param apiKey (optional) 
     * @param projectName (optional) 
     * @param projectId (optional) 
     * @param assigneeEmail (optional) 
     * @param creatorEmail (optional) 
     * @param duration (optional) 
     * @return Success
     */
    getRecentCompletedTasks(apiKey: string | null | undefined, projectName: string | null | undefined, projectId: string | null | undefined, assigneeEmail: string | null | undefined, creatorEmail: string | null | undefined, duration: number | null | undefined): Observable<RecentModifiedTasksExtOutputListIHandleError> {
        let url_ = this.baseUrl + "/trigger/api/GetRecentCompletedTasks?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (projectName !== undefined && projectName !== null)
            url_ += "ProjectName=" + encodeURIComponent("" + projectName) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (assigneeEmail !== undefined && assigneeEmail !== null)
            url_ += "AssigneeEmail=" + encodeURIComponent("" + assigneeEmail) + "&";
        if (creatorEmail !== undefined && creatorEmail !== null)
            url_ += "CreatorEmail=" + encodeURIComponent("" + creatorEmail) + "&";
        if (duration !== undefined && duration !== null)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentCompletedTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentCompletedTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentModifiedTasksExtOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentModifiedTasksExtOutputListIHandleError>;
        }));
    }

    protected processGetRecentCompletedTasks(response: HttpResponseBase): Observable<RecentModifiedTasksExtOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RecentModifiedTasksExtOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecentModifiedTasksExtOutputListIHandleError>(null as any);
    }

    /**
     * @param apiKey (optional) 
     * @param userEmail (optional) 
     * @param projectName (optional) 
     * @param projectId (optional) 
     * @param assigneeEmail (optional) 
     * @param taskId (optional) 
     * @param oldSectionId (optional) 
     * @param oldSectoinName (optional) 
     * @param newSectionId (optional) 
     * @param newSectoinName (optional) 
     * @param lastModificationTime (optional) 
     * @return Success
     */
    getRecentModifiedSectionTasks(apiKey: string | null | undefined, userEmail: string | null | undefined, projectName: string | null | undefined, projectId: string | null | undefined, assigneeEmail: string | null | undefined, taskId: string | null | undefined, oldSectionId: string | null | undefined, oldSectoinName: string | null | undefined, newSectionId: string | null | undefined, newSectoinName: string | null | undefined, lastModificationTime: string | null | undefined): Observable<RecentModifiedTasksExtOutputListIHandleError> {
        let url_ = this.baseUrl + "/trigger/api/GetRecentModifiedSectionTasks?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (userEmail !== undefined && userEmail !== null)
            url_ += "UserEmail=" + encodeURIComponent("" + userEmail) + "&";
        if (projectName !== undefined && projectName !== null)
            url_ += "ProjectName=" + encodeURIComponent("" + projectName) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (assigneeEmail !== undefined && assigneeEmail !== null)
            url_ += "AssigneeEmail=" + encodeURIComponent("" + assigneeEmail) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (oldSectionId !== undefined && oldSectionId !== null)
            url_ += "OldSectionId=" + encodeURIComponent("" + oldSectionId) + "&";
        if (oldSectoinName !== undefined && oldSectoinName !== null)
            url_ += "OldSectoinName=" + encodeURIComponent("" + oldSectoinName) + "&";
        if (newSectionId !== undefined && newSectionId !== null)
            url_ += "NewSectionId=" + encodeURIComponent("" + newSectionId) + "&";
        if (newSectoinName !== undefined && newSectoinName !== null)
            url_ += "NewSectoinName=" + encodeURIComponent("" + newSectoinName) + "&";
        if (lastModificationTime !== undefined && lastModificationTime !== null)
            url_ += "LastModificationTime=" + encodeURIComponent("" + lastModificationTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentModifiedSectionTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentModifiedSectionTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentModifiedTasksExtOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentModifiedTasksExtOutputListIHandleError>;
        }));
    }

    protected processGetRecentModifiedSectionTasks(response: HttpResponseBase): Observable<RecentModifiedTasksExtOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RecentModifiedTasksExtOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecentModifiedTasksExtOutputListIHandleError>(null as any);
    }

    /**
     * @param apiKey (optional) 
     * @param duration (optional) 
     * @return Success
     */
    getRecentlyCreatedTask(apiKey: string | null | undefined, duration: number | null | undefined): Observable<RecentlyCreatedTaskOutputListIHandleError> {
        let url_ = this.baseUrl + "/trigger/api/GetRecentlyCreatedTask?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (duration !== undefined && duration !== null)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyCreatedTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyCreatedTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentlyCreatedTaskOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentlyCreatedTaskOutputListIHandleError>;
        }));
    }

    protected processGetRecentlyCreatedTask(response: HttpResponseBase): Observable<RecentlyCreatedTaskOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RecentlyCreatedTaskOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecentlyCreatedTaskOutputListIHandleError>(null as any);
    }

    /**
     * @param apiKey (optional) 
     * @param duration (optional) 
     * @param updateFilter (optional) 
     * @return Success
     */
    getRecentlyUpdatedTask(apiKey: string | null | undefined, duration: number | null | undefined, updateFilter: string | null | undefined): Observable<RecentlyUpdatedTaskOutputListIHandleError> {
        let url_ = this.baseUrl + "/trigger/api/GetRecentlyUpdatedTask?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (duration !== undefined && duration !== null)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        if (updateFilter !== undefined && updateFilter !== null)
            url_ += "UpdateFilter=" + encodeURIComponent("" + updateFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUpdatedTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUpdatedTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentlyUpdatedTaskOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentlyUpdatedTaskOutputListIHandleError>;
        }));
    }

    protected processGetRecentlyUpdatedTask(response: HttpResponseBase): Observable<RecentlyUpdatedTaskOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RecentlyUpdatedTaskOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecentlyUpdatedTaskOutputListIHandleError>(null as any);
    }

    /**
     * @param apiKey (optional) 
     * @param projectName (optional) 
     * @param projectId (optional) 
     * @param assigneeEmail (optional) 
     * @param creatorEmail (optional) 
     * @param duration (optional) 
     * @return Success
     */
    getRecentlyDeletedTasks(apiKey: string | null | undefined, projectName: string | null | undefined, projectId: string | null | undefined, assigneeEmail: string | null | undefined, creatorEmail: string | null | undefined, duration: number | null | undefined): Observable<RecentDeletedTasksExtOutputListIHandleError> {
        let url_ = this.baseUrl + "/trigger/api/GetRecentlyDeletedTasks?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (projectName !== undefined && projectName !== null)
            url_ += "ProjectName=" + encodeURIComponent("" + projectName) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (assigneeEmail !== undefined && assigneeEmail !== null)
            url_ += "AssigneeEmail=" + encodeURIComponent("" + assigneeEmail) + "&";
        if (creatorEmail !== undefined && creatorEmail !== null)
            url_ += "CreatorEmail=" + encodeURIComponent("" + creatorEmail) + "&";
        if (duration !== undefined && duration !== null)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyDeletedTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyDeletedTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecentDeletedTasksExtOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecentDeletedTasksExtOutputListIHandleError>;
        }));
    }

    protected processGetRecentlyDeletedTasks(response: HttpResponseBase): Observable<RecentDeletedTasksExtOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RecentDeletedTasksExtOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecentDeletedTasksExtOutputListIHandleError>(null as any);
    }
}

@Injectable()
export class ExternalContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createContactAddressExternal(body: CreateExtContactAddressInput | null | undefined): Observable<ContactAddressResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalContact/CreateContactAddressExternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContactAddressExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContactAddressExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactAddressResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactAddressResult>;
        }));
    }

    protected processCreateContactAddressExternal(response: HttpResponseBase): Observable<ContactAddressResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactAddressResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactAddressResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createContactExternal(body: CreateExtContactsInput | null | undefined): Observable<ContactResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalContact/CreateContactExternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContactExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContactExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactResult>;
        }));
    }

    protected processCreateContactExternal(response: HttpResponseBase): Observable<ContactResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateContactExternal(body: UpdateExtContactsInput | null | undefined): Observable<ContactResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalContact/UpdateContactExternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContactExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContactExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactResult>;
        }));
    }

    protected processUpdateContactExternal(response: HttpResponseBase): Observable<ContactResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createContactFamilyExternal(body: CreateExtContactFamilyInput | null | undefined): Observable<ContactFamilyResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalContact/CreateContactFamilyExternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContactFamilyExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContactFamilyExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactFamilyResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactFamilyResult>;
        }));
    }

    protected processCreateContactFamilyExternal(response: HttpResponseBase): Observable<ContactFamilyResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactFamilyResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactFamilyResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createContactNotes(body: CreateExtNotesInput | null | undefined): Observable<NotesResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalContact/CreateContactNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContactNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContactNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotesResult>;
        }));
    }

    protected processCreateContactNotes(response: HttpResponseBase): Observable<NotesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NotesResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotesResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createContactPhoneExternal(body: CreateExtContactPhonesInput | null | undefined): Observable<ContactPhoneResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalContact/CreateContactPhoneExternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContactPhoneExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContactPhoneExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactPhoneResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactPhoneResult>;
        }));
    }

    protected processCreateContactPhoneExternal(response: HttpResponseBase): Observable<ContactPhoneResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ContactPhoneResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactPhoneResult>(null as any);
    }

    /**
     * @return Success
     */
    getContactFolderDetailExternal(apiKey: string, contactEmail: string, userEmail: string): Observable<GetContactFolderDtlResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalContact/GetContactFolderDetailExternal?";
        if (apiKey === undefined || apiKey === null)
            throw new globalThis.Error("The parameter 'apiKey' must be defined and cannot be null.");
        else
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (contactEmail === undefined || contactEmail === null)
            throw new globalThis.Error("The parameter 'contactEmail' must be defined and cannot be null.");
        else
            url_ += "ContactEmail=" + encodeURIComponent("" + contactEmail) + "&";
        if (userEmail === undefined || userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' must be defined and cannot be null.");
        else
            url_ += "UserEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactFolderDetailExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactFolderDetailExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetContactFolderDtlResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetContactFolderDtlResult>;
        }));
    }

    protected processGetContactFolderDetailExternal(response: HttpResponseBase): Observable<GetContactFolderDtlResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetContactFolderDtlResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContactFolderDtlResult>(null as any);
    }

    /**
     * @param apiKey (optional) 
     * @param contactId (optional) 
     * @param contactEmail (optional) 
     * @return Success
     */
    getContactDetailExternal(apiKey: string | null | undefined, contactId: string | null | undefined, contactEmail: string | null | undefined): Observable<GetContactDetailResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalContact/GetContactDetailExternal?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (contactId !== undefined && contactId !== null)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&";
        if (contactEmail !== undefined && contactEmail !== null)
            url_ += "ContactEmail=" + encodeURIComponent("" + contactEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactDetailExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactDetailExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetContactDetailResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetContactDetailResult>;
        }));
    }

    protected processGetContactDetailExternal(response: HttpResponseBase): Observable<GetContactDetailResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetContactDetailResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContactDetailResult>(null as any);
    }
}

@Injectable()
export class ExternalTaskServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createExternalTask(body: CreateExtTaskInput | null | undefined): Observable<Result> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/CreateExternalTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExternalTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExternalTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCreateExternalTask(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateExternalTask(body: UpdateExtTaskInput | null | undefined): Observable<Result> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/UpdateExternalTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExternalTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExternalTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processUpdateExternalTask(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    /**
     * @return Success
     */
    deleteExternalTask(apiKey: string, taskID: string): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/DeleteExternalTask?";
        if (apiKey === undefined || apiKey === null)
            throw new globalThis.Error("The parameter 'apiKey' must be defined and cannot be null.");
        else
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (taskID === undefined || taskID === null)
            throw new globalThis.Error("The parameter 'taskID' must be defined and cannot be null.");
        else
            url_ += "TaskID=" + encodeURIComponent("" + taskID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExternalTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExternalTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteExternalTask(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param source (optional) 
     * @return Success
     */
    getTaskExt(apiKey: string, getBy: string, id: string, source: string | null | undefined): Observable<GetTaskExtOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/GetTaskExt?";
        if (apiKey === undefined || apiKey === null)
            throw new globalThis.Error("The parameter 'apiKey' must be defined and cannot be null.");
        else
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (getBy === undefined || getBy === null)
            throw new globalThis.Error("The parameter 'getBy' must be defined and cannot be null.");
        else
            url_ += "GetBy=" + encodeURIComponent("" + getBy) + "&";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (source !== undefined && source !== null)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskExt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskExtOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskExtOutput>;
        }));
    }

    protected processGetTaskExt(response: HttpResponseBase): Observable<GetTaskExtOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetTaskExtOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskExtOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addTaskComment(body: BotTaskCommentInput | null | undefined): Observable<OpenReplyCommentInputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/AddTaskComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTaskComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTaskComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpenReplyCommentInputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpenReplyCommentInputIHandleError>;
        }));
    }

    protected processAddTaskComment(response: HttpResponseBase): Observable<OpenReplyCommentInputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OpenReplyCommentInputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OpenReplyCommentInputIHandleError>(null as any);
    }

    /**
     * @param apiKey (optional) 
     * @param userEmail (optional) 
     * @return Success
     */
    getTodosTaskExt(apiKey: string | null | undefined, userEmail: string | null | undefined): Observable<GetTodoTaskExtOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/GetTodosTaskExt?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (userEmail !== undefined && userEmail !== null)
            url_ += "UserEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodosTaskExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodosTaskExt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTodoTaskExtOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTodoTaskExtOutputListIHandleError>;
        }));
    }

    protected processGetTodosTaskExt(response: HttpResponseBase): Observable<GetTodoTaskExtOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetTodoTaskExtOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTodoTaskExtOutputListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTaskCommentExt(body: CreateTaskCommentExtInput | null | undefined): Observable<Result> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/CreateTaskCommentExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTaskCommentExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTaskCommentExt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCreateTaskCommentExt(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    /**
     * @return Success
     */
    getTaskByResourceExt(apiKey: string, resourceAppID: string): Observable<GetTaskByResourceExtOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/GetTaskByResourceExt?";
        if (apiKey === undefined || apiKey === null)
            throw new globalThis.Error("The parameter 'apiKey' must be defined and cannot be null.");
        else
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (resourceAppID === undefined || resourceAppID === null)
            throw new globalThis.Error("The parameter 'resourceAppID' must be defined and cannot be null.");
        else
            url_ += "ResourceAppID=" + encodeURIComponent("" + resourceAppID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskByResourceExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskByResourceExt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskByResourceExtOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskByResourceExtOutput>;
        }));
    }

    protected processGetTaskByResourceExt(response: HttpResponseBase): Observable<GetTaskByResourceExtOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetTaskByResourceExtOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskByResourceExtOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createExternalProject(body: CreateExtProjectInput | null | undefined): Observable<CreateProjectResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/CreateExternalProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExternalProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExternalProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateProjectResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateProjectResult>;
        }));
    }

    protected processCreateExternalProject(response: HttpResponseBase): Observable<CreateProjectResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateProjectResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateProjectResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectExt(body: UpdateProjectExt | null | undefined): Observable<CreateProjectResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/UpdateProjectExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectExt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateProjectResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateProjectResult>;
        }));
    }

    protected processUpdateProjectExt(response: HttpResponseBase): Observable<CreateProjectResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateProjectResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateProjectResult>(null as any);
    }

    /**
     * @param source (optional) 
     * @return Success
     */
    getProjectExt(apiKey: string, getBy: string, id: string, source: string | null | undefined): Observable<GetProjectExtOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/GetProjectExt?";
        if (apiKey === undefined || apiKey === null)
            throw new globalThis.Error("The parameter 'apiKey' must be defined and cannot be null.");
        else
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (getBy === undefined || getBy === null)
            throw new globalThis.Error("The parameter 'getBy' must be defined and cannot be null.");
        else
            url_ += "GetBy=" + encodeURIComponent("" + getBy) + "&";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (source !== undefined && source !== null)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectExt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectExtOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectExtOutput>;
        }));
    }

    protected processGetProjectExt(response: HttpResponseBase): Observable<GetProjectExtOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetProjectExtOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectExtOutput>(null as any);
    }

    /**
     * @return Success
     */
    getProjectsExt(apiKey: string, status: string): Observable<GetProjectsExtResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/GetProjectsExt?";
        if (apiKey === undefined || apiKey === null)
            throw new globalThis.Error("The parameter 'apiKey' must be defined and cannot be null.");
        else
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (status === undefined || status === null)
            throw new globalThis.Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsExt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectsExtResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectsExtResult>;
        }));
    }

    protected processGetProjectsExt(response: HttpResponseBase): Observable<GetProjectsExtResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetProjectsExtResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectsExtResult>(null as any);
    }

    /**
     * @return Success
     */
    getProjectTasksExt(apiKey: string, projectId: string): Observable<GetProjectTasksResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/GetProjectTasksExt?";
        if (apiKey === undefined || apiKey === null)
            throw new globalThis.Error("The parameter 'apiKey' must be defined and cannot be null.");
        else
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectTasksExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectTasksExt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectTasksResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectTasksResult>;
        }));
    }

    protected processGetProjectTasksExt(response: HttpResponseBase): Observable<GetProjectTasksResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetProjectTasksResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectTasksResult>(null as any);
    }

    /**
     * @return Success
     */
    getProjectSectionsExt(apiKey: string, projectId: string): Observable<GetProjectSectionsResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/GetProjectSectionsExt?";
        if (apiKey === undefined || apiKey === null)
            throw new globalThis.Error("The parameter 'apiKey' must be defined and cannot be null.");
        else
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectSectionsExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectSectionsExt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectSectionsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectSectionsResult>;
        }));
    }

    protected processGetProjectSectionsExt(response: HttpResponseBase): Observable<GetProjectSectionsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetProjectSectionsResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectSectionsResult>(null as any);
    }

    /**
     * @param customerEmail (optional) 
     * @param companyName (optional) 
     * @param domainName (optional) 
     * @return Success
     */
    getCustomerProjectsExt(apiKey: string, customerEmail: string | null | undefined, companyName: string | null | undefined, domainName: string | null | undefined): Observable<GetCustomerProjectsResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/GetCustomerProjectsExt?";
        if (apiKey === undefined || apiKey === null)
            throw new globalThis.Error("The parameter 'apiKey' must be defined and cannot be null.");
        else
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (customerEmail !== undefined && customerEmail !== null)
            url_ += "CustomerEmail=" + encodeURIComponent("" + customerEmail) + "&";
        if (companyName !== undefined && companyName !== null)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&";
        if (domainName !== undefined && domainName !== null)
            url_ += "DomainName=" + encodeURIComponent("" + domainName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerProjectsExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerProjectsExt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerProjectsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerProjectsResult>;
        }));
    }

    protected processGetCustomerProjectsExt(response: HttpResponseBase): Observable<GetCustomerProjectsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetCustomerProjectsResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerProjectsResult>(null as any);
    }

    /**
     * @return Success
     */
    getProjectTemplatesExt(apiKey: string, userEmail: string): Observable<ProjectTemplateExtListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/GetProjectTemplatesExt?";
        if (apiKey === undefined || apiKey === null)
            throw new globalThis.Error("The parameter 'apiKey' must be defined and cannot be null.");
        else
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (userEmail === undefined || userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' must be defined and cannot be null.");
        else
            url_ += "UserEmail=" + encodeURIComponent("" + userEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectTemplatesExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectTemplatesExt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTemplateExtListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTemplateExtListIHandleError>;
        }));
    }

    protected processGetProjectTemplatesExt(response: HttpResponseBase): Observable<ProjectTemplateExtListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectTemplateExtListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectTemplateExtListIHandleError>(null as any);
    }

    /**
     * @param roleType (optional) 
     * @return Success
     */
    getProjectRolesExt(apiKey: string, userEmail: string, roleType: string | null | undefined): Observable<ProjectRolesExtListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/GetProjectRolesExt?";
        if (apiKey === undefined || apiKey === null)
            throw new globalThis.Error("The parameter 'apiKey' must be defined and cannot be null.");
        else
            url_ += "ApiKey=" + encodeURIComponent("" + apiKey) + "&";
        if (userEmail === undefined || userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' must be defined and cannot be null.");
        else
            url_ += "UserEmail=" + encodeURIComponent("" + userEmail) + "&";
        if (roleType !== undefined && roleType !== null)
            url_ += "RoleType=" + encodeURIComponent("" + roleType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectRolesExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectRolesExt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectRolesExtListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectRolesExtListIHandleError>;
        }));
    }

    protected processGetProjectRolesExt(response: HttpResponseBase): Observable<ProjectRolesExtListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectRolesExtListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectRolesExtListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectFromTemplateExt(body: CreateProjectFromTemplateExt | null | undefined): Observable<ProjectFromTempResultExtIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/CreateProjectFromTemplateExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectFromTemplateExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectFromTemplateExt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectFromTempResultExtIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectFromTempResultExtIHandleError>;
        }));
    }

    protected processCreateProjectFromTemplateExt(response: HttpResponseBase): Observable<ProjectFromTempResultExtIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectFromTempResultExtIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectFromTempResultExtIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pushNotificationFromExternal(body: CreateExtAlertInput | null | undefined): Observable<Result> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/PushNotificationFromExternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPushNotificationFromExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushNotificationFromExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processPushNotificationFromExternal(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTaskFromBot(body: BotTaskInputDto | null | undefined): Observable<BotCreateTaskResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/CreateTaskFromBot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTaskFromBot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTaskFromBot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BotCreateTaskResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BotCreateTaskResult>;
        }));
    }

    protected processCreateTaskFromBot(response: HttpResponseBase): Observable<BotCreateTaskResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BotCreateTaskResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BotCreateTaskResult>(null as any);
    }

    /**
     * @param msTeamsUserId (optional) 
     * @return Success
     */
    getProjectsFromBot(msTeamsUserId: string | null | undefined): Observable<BotGetProjectsResult> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/GetProjectsFromBot?";
        if (msTeamsUserId !== undefined && msTeamsUserId !== null)
            url_ += "MsTeamsUserId=" + encodeURIComponent("" + msTeamsUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsFromBot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsFromBot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BotGetProjectsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BotGetProjectsResult>;
        }));
    }

    protected processGetProjectsFromBot(response: HttpResponseBase): Observable<BotGetProjectsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BotGetProjectsResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BotGetProjectsResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaskFromBot(body: UpdateTaskFromBotInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/UpdateTaskFromBot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskFromBot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskFromBot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateTaskFromBot(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateToDeleteTaskFromBot(body: DeleteTaskFromBotInput | null | undefined): Observable<DeleteTaskFromBotOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/UpdateToDeleteTaskFromBot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateToDeleteTaskFromBot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateToDeleteTaskFromBot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteTaskFromBotOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteTaskFromBotOutputIHandleError>;
        }));
    }

    protected processUpdateToDeleteTaskFromBot(response: HttpResponseBase): Observable<DeleteTaskFromBotOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DeleteTaskFromBotOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteTaskFromBotOutputIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMsTeamsBotNotificationSubscription(body: UserBotConversationInputDto | null | undefined): Observable<HttpResultUserBotConversationDto> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/CreateMsTeamsBotNotificationSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMsTeamsBotNotificationSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMsTeamsBotNotificationSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HttpResultUserBotConversationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HttpResultUserBotConversationDto>;
        }));
    }

    protected processCreateMsTeamsBotNotificationSubscription(response: HttpResponseBase): Observable<HttpResultUserBotConversationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = HttpResultUserBotConversationDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HttpResultUserBotConversationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateToDeleteMsTeamsBotNotificationSubscription(body: DeleteUserBotConversationInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalTask/UpdateToDeleteMsTeamsBotNotificationSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateToDeleteMsTeamsBotNotificationSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateToDeleteMsTeamsBotNotificationSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateToDeleteMsTeamsBotNotificationSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class FavoriteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAvailableApps(): Observable<AvailableAppOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Favorite/GetAvailableApps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableApps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableApps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailableAppOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailableAppOutputListIHandleError>;
        }));
    }

    protected processGetAvailableApps(response: HttpResponseBase): Observable<AvailableAppOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AvailableAppOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailableAppOutputListIHandleError>(null as any);
    }

    /**
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getFavorites(take: number | null | undefined, search: string | null | undefined): Observable<FavoriteListOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Favorite/GetFavorites?";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFavorites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFavorites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FavoriteListOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FavoriteListOutputIHandleError>;
        }));
    }

    protected processGetFavorites(response: HttpResponseBase): Observable<FavoriteListOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = FavoriteListOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FavoriteListOutputIHandleError>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getFavoritedFileKeyIds(input: FileAttachmentRefInput[] | null | undefined): Observable<FileAttachmentRefOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Favorite/GetFavoritedFileKeyIds?";
        if (input !== undefined && input !== null)
            input && input.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "input[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFavoritedFileKeyIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFavoritedFileKeyIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileAttachmentRefOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileAttachmentRefOutputListIHandleError>;
        }));
    }

    protected processGetFavoritedFileKeyIds(response: HttpResponseBase): Observable<FileAttachmentRefOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = FileAttachmentRefOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileAttachmentRefOutputListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addFavorite(body: AddFavoriteInput | null | undefined): Observable<AddFavoriteOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Favorite/AddFavorite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddFavoriteOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddFavoriteOutputIHandleError>;
        }));
    }

    protected processAddFavorite(response: HttpResponseBase): Observable<AddFavoriteOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AddFavoriteOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddFavoriteOutputIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addFavorites(body: AddFavoriteInput[] | null | undefined): Observable<AddFavoriteOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Favorite/AddFavorites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFavorites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFavorites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddFavoriteOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddFavoriteOutputListIHandleError>;
        }));
    }

    protected processAddFavorites(response: HttpResponseBase): Observable<AddFavoriteOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AddFavoriteOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddFavoriteOutputListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeFavorites(body: ProjectBulkActionInput | null | undefined): Observable<RemoveFavoriteOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Favorite/RemoveFavorites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFavorites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFavorites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoveFavoriteOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoveFavoriteOutputListIHandleError>;
        }));
    }

    protected processRemoveFavorites(response: HttpResponseBase): Observable<RemoveFavoriteOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RemoveFavoriteOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoveFavoriteOutputListIHandleError>(null as any);
    }

    /**
     * @param pinId (optional) 
     * @return Success
     */
    removeFavorite(pinId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Favorite/RemoveFavorite?";
        if (pinId !== undefined && pinId !== null)
            url_ += "pinId=" + encodeURIComponent("" + pinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processRemoveFavorite(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reorderFavorites(body: ReorderFavoritesInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Favorite/ReorderFavorites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderFavorites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderFavorites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processReorderFavorites(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }
}

@Injectable()
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    downloadTempFile(fileName: string, fileType: string, fileToken: string): Observable<void> {
        let url_ = this.baseUrl + "/api/File/DownloadTempFile?";
        if (fileName === undefined || fileName === null)
            throw new globalThis.Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType === undefined || fileType === null)
            throw new globalThis.Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        if (fileToken === undefined || fileToken === null)
            throw new globalThis.Error("The parameter 'fileToken' must be defined and cannot be null.");
        else
            url_ += "FileToken=" + encodeURIComponent("" + fileToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTempFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTempFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadTempFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param url (optional) 
     * @return Success
     */
    downloadBlobFile(url: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/File/DownloadBlobFile?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBlobFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBlobFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadBlobFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param driveId (optional) 
     * @param itemId (optional) 
     * @return Success
     */
    getOneDriveImage(driveId: string | null | undefined, itemId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/File/GetOneDriveImage?";
        if (driveId !== undefined && driveId !== null)
            url_ += "driveId=" + encodeURIComponent("" + driveId) + "&";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOneDriveImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOneDriveImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetOneDriveImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class GetHelpServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    beginIntro(body: BeginGetHelpIntroInput | null | undefined): Observable<GetHelpIntroDto> {
        let url_ = this.baseUrl + "/api/services/app/GetHelp/BeginIntro";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBeginIntro(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBeginIntro(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHelpIntroDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHelpIntroDto>;
        }));
    }

    protected processBeginIntro(response: HttpResponseBase): Observable<GetHelpIntroDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetHelpIntroDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHelpIntroDto>(null as any);
    }

    /**
     * @return Success
     */
    completeIntro(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GetHelp/CompleteIntro";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteIntro(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteIntro(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteIntro(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class GridPreferenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savePreference(body: GridPreferenceInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/GridPreference/SavePreference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePreference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePreference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSavePreference(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getPreference(name: string | null | undefined): Observable<GridPreferenceOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/GridPreference/GetPreference?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridPreferenceOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridPreferenceOutputIHandleError>;
        }));
    }

    protected processGetPreference(response: HttpResponseBase): Observable<GridPreferenceOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GridPreferenceOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GridPreferenceOutputIHandleError>(null as any);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param incomeStatisticsDateInterval (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getDashboardStatisticsData(incomeStatisticsDateInterval: any | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined): Observable<HostDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetDashboardStatisticsData?";
        if (incomeStatisticsDateInterval !== undefined && incomeStatisticsDateInterval !== null)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardStatisticsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardStatisticsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostDashboardData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostDashboardData>;
        }));
    }

    protected processGetDashboardStatisticsData(response: HttpResponseBase): Observable<HostDashboardData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = HostDashboardData.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HostDashboardData>(null as any);
    }

    /**
     * @param incomeStatisticsDateInterval (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: any | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval !== undefined && incomeStatisticsDateInterval !== null)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncomeStatisticsDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncomeStatisticsDataOutput>;
        }));
    }

    protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncomeStatisticsDataOutput>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getEditionTenantStatistics(startDate: string | null | undefined, endDate: string | null | undefined): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionTenantStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionTenantStatisticsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionTenantStatisticsOutput>;
        }));
    }

    protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditionTenantStatisticsOutput>(null as any);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsEditDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HostSettingsEditDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: HostSettingsEditDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInvoiceInfo(id: number | null | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInvoice(body: CreateInvoiceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguagesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguagesOutput>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguagesOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number | null | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguageForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguageForEditOutput>;
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageForEditOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguageForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLanguage(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param baseLanguageName (optional) 
     * @param targetValueFilter (optional) 
     * @param filterText (optional) 
     * @return Success
     */
    getLanguageTexts(maxResultCount: number | null | undefined, skipCount: number | null | undefined, sorting: string | null | undefined, sourceName: string, baseLanguageName: string | null | undefined, targetLanguageName: string, targetValueFilter: string | null | undefined, filterText: string | null | undefined): Observable<LanguageTextListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName !== undefined && baseLanguageName !== null)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new globalThis.Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter !== undefined && targetValueFilter !== null)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageTextListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageTextListDtoPagedResultDto>;
        }));
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<LanguageTextListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LanguageTextListDtoPagedResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LanguageTextListDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLanguageText(body: UpdateLanguageTextInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class LeadPipelineServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getBoard(): Observable<LeadBoardDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/GetBoard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBoard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBoard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadBoardDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadBoardDtoIHandleError>;
        }));
    }

    protected processGetBoard(response: HttpResponseBase): Observable<LeadBoardDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LeadBoardDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeadBoardDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCards(body: GetLeadBoardCardsInput | null | undefined): Observable<LeadBoardCardsDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/GetCards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadBoardCardsDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadBoardCardsDtoIHandleError>;
        }));
    }

    protected processGetCards(response: HttpResponseBase): Observable<LeadBoardCardsDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LeadBoardCardsDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeadBoardCardsDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveCard(body: MoveLeadCardInput | null | undefined): Observable<MoveLeadCardResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/MoveCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveLeadCardResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveLeadCardResultDtoIHandleError>;
        }));
    }

    protected processMoveCard(response: HttpResponseBase): Observable<MoveLeadCardResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MoveLeadCardResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MoveLeadCardResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    undoMove(body: UndoLeadMoveInput | null | undefined): Observable<UndoLeadMoveResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/UndoMove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoMove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoMove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UndoLeadMoveResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UndoLeadMoveResultDtoIHandleError>;
        }));
    }

    protected processUndoMove(response: HttpResponseBase): Observable<UndoLeadMoveResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UndoLeadMoveResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UndoLeadMoveResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setFollowUp(body: SetLeadFollowUpInput | null | undefined): Observable<SetLeadFollowUpResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/SetFollowUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFollowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFollowUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetLeadFollowUpResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetLeadFollowUpResultDtoIHandleError>;
        }));
    }

    protected processSetFollowUp(response: HttpResponseBase): Observable<SetLeadFollowUpResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SetLeadFollowUpResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetLeadFollowUpResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reassign(body: ReassignLeadInput | null | undefined): Observable<ReassignLeadResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/Reassign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReassign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReassign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReassignLeadResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReassignLeadResultDtoIHandleError>;
        }));
    }

    protected processReassign(response: HttpResponseBase): Observable<ReassignLeadResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ReassignLeadResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReassignLeadResultDtoIHandleError>(null as any);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getLeadJourney(contactId: number | null | undefined): Observable<LeadJourneyDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/GetLeadJourney?";
        if (contactId !== undefined && contactId !== null)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadJourney(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadJourney(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadJourneyDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadJourneyDtoIHandleError>;
        }));
    }

    protected processGetLeadJourney(response: HttpResponseBase): Observable<LeadJourneyDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LeadJourneyDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeadJourneyDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setEstimatedValue(body: SetLeadEstimateInput | null | undefined): Observable<SetLeadEstimateResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/SetEstimatedValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetEstimatedValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEstimatedValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetLeadEstimateResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetLeadEstimateResultDtoIHandleError>;
        }));
    }

    protected processSetEstimatedValue(response: HttpResponseBase): Observable<SetLeadEstimateResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SetLeadEstimateResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetLeadEstimateResultDtoIHandleError>(null as any);
    }

    /**
     * @param contactId (optional) 
     * @param reminderTaskId (optional) 
     * @return Success
     */
    getCaseHandoff(contactId: number | null | undefined, reminderTaskId: number | null | undefined): Observable<LeadCaseHandoffDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/GetCaseHandoff?";
        if (contactId !== undefined && contactId !== null)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        if (reminderTaskId !== undefined && reminderTaskId !== null)
            url_ += "reminderTaskId=" + encodeURIComponent("" + reminderTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseHandoff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseHandoff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadCaseHandoffDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadCaseHandoffDtoIHandleError>;
        }));
    }

    protected processGetCaseHandoff(response: HttpResponseBase): Observable<LeadCaseHandoffDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LeadCaseHandoffDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeadCaseHandoffDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    previewBulkStage(body: LeadBulkStageInput | null | undefined): Observable<LeadBulkStagePreviewDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/PreviewBulkStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewBulkStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewBulkStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadBulkStagePreviewDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadBulkStagePreviewDtoIHandleError>;
        }));
    }

    protected processPreviewBulkStage(response: HttpResponseBase): Observable<LeadBulkStagePreviewDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LeadBulkStagePreviewDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeadBulkStagePreviewDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bulkSetStage(body: LeadBulkStageInput | null | undefined): Observable<LeadBulkResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/BulkSetStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkSetStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkSetStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadBulkResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadBulkResultDtoIHandleError>;
        }));
    }

    protected processBulkSetStage(response: HttpResponseBase): Observable<LeadBulkResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LeadBulkResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeadBulkResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    previewBulkType(body: LeadBulkTypeInput | null | undefined): Observable<LeadBulkTypePreviewDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/PreviewBulkType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewBulkType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewBulkType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadBulkTypePreviewDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadBulkTypePreviewDtoIHandleError>;
        }));
    }

    protected processPreviewBulkType(response: HttpResponseBase): Observable<LeadBulkTypePreviewDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LeadBulkTypePreviewDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeadBulkTypePreviewDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bulkSetType(body: LeadBulkTypeInput | null | undefined): Observable<LeadBulkResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/BulkSetType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkSetType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkSetType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadBulkResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadBulkResultDtoIHandleError>;
        }));
    }

    protected processBulkSetType(response: HttpResponseBase): Observable<LeadBulkResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LeadBulkResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeadBulkResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    previewDeletePeople(body: LeadBulkDeletePreviewInput | null | undefined): Observable<LeadBulkDeletePreviewDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/PreviewDeletePeople";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewDeletePeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewDeletePeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadBulkDeletePreviewDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadBulkDeletePreviewDtoIHandleError>;
        }));
    }

    protected processPreviewDeletePeople(response: HttpResponseBase): Observable<LeadBulkDeletePreviewDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LeadBulkDeletePreviewDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeadBulkDeletePreviewDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLostReason(body: ChangeLostReasonInput | null | undefined): Observable<ChangeLostReasonResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LeadPipeline/ChangeLostReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLostReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLostReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeLostReasonResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeLostReasonResultDtoIHandleError>;
        }));
    }

    protected processChangeLostReason(response: HttpResponseBase): Observable<ChangeLostReasonResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ChangeLostReasonResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangeLostReasonResultDtoIHandleError>(null as any);
    }
}

@Injectable()
export class LinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param searchText (optional) 
     * @param linkType (optional) 
     * @param pinnedOnly (optional) 
     * @param entityId (optional) 
     * @return Success
     */
    getAllLinks(userId: number | null | undefined, tenantId: number | null | undefined, searchText: string | null | undefined, linkType: number | null | undefined, pinnedOnly: boolean | null | undefined, entityId: number | null | undefined): Observable<LinkDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/GetAllLinks?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (linkType !== undefined && linkType !== null)
            url_ += "LinkType=" + encodeURIComponent("" + linkType) + "&";
        if (pinnedOnly !== undefined && pinnedOnly !== null)
            url_ += "PinnedOnly=" + encodeURIComponent("" + pinnedOnly) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkDtoListIHandleError>;
        }));
    }

    protected processGetAllLinks(response: HttpResponseBase): Observable<LinkDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LinkDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LinkDtoListIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param searchText (optional) 
     * @param linkType (optional) 
     * @param pinnedOnly (optional) 
     * @param entityId (optional) 
     * @return Success
     */
    getUserShortcuts(userId: number | null | undefined, tenantId: number | null | undefined, searchText: string | null | undefined, linkType: number | null | undefined, pinnedOnly: boolean | null | undefined, entityId: number | null | undefined): Observable<ShortcutDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/GetUserShortcuts?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (linkType !== undefined && linkType !== null)
            url_ += "LinkType=" + encodeURIComponent("" + linkType) + "&";
        if (pinnedOnly !== undefined && pinnedOnly !== null)
            url_ += "PinnedOnly=" + encodeURIComponent("" + pinnedOnly) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserShortcuts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserShortcuts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShortcutDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShortcutDtoListIHandleError>;
        }));
    }

    protected processGetUserShortcuts(response: HttpResponseBase): Observable<ShortcutDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ShortcutDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShortcutDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUserShortcut(body: UserShortcutInputDto | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/CreateOrUpdateUserShortcutAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUserShortcut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUserShortcut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCreateOrUpdateUserShortcut(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUserShortcut(id: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/DeleteUserShortcut?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserShortcut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserShortcut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteUserShortcut(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param searchText (optional) 
     * @param companyId (optional) 
     * @param pinnedOnly (optional) 
     * @return Success
     */
    getCompanyLinks(userId: number | null | undefined, tenantId: number | null | undefined, searchText: string | null | undefined, companyId: number | null | undefined, pinnedOnly: boolean | null | undefined): Observable<LinkDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/GetCompanyLinks?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (pinnedOnly !== undefined && pinnedOnly !== null)
            url_ += "PinnedOnly=" + encodeURIComponent("" + pinnedOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkDtoListIHandleError>;
        }));
    }

    protected processGetCompanyLinks(response: HttpResponseBase): Observable<LinkDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LinkDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LinkDtoListIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getOnedriveLinks(): Observable<OneDriveLinksListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/GetOnedriveLinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnedriveLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnedriveLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OneDriveLinksListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OneDriveLinksListIHandleError>;
        }));
    }

    protected processGetOnedriveLinks(response: HttpResponseBase): Observable<OneDriveLinksListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OneDriveLinksListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OneDriveLinksListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLink(body: LinkDto | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/CreateOrUpdateLinkAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCreateOrUpdateLink(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLink(id: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/DeleteLink?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteLink(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    resetApps(): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/ResetApps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetApps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetApps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processResetApps(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param appId (optional) 
     * @return Success
     */
    deleteApp(userId: number | null | undefined, appId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/DeleteApp?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (appId !== undefined && appId !== null)
            url_ += "AppId=" + encodeURIComponent("" + appId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteApp(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param searchText (optional) 
     * @return Success
     */
    getAllGroupLinks(userId: number | null | undefined, tenantId: number | null | undefined, searchText: string | null | undefined): Observable<GroupLinkDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/GetAllGroupLinks?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGroupLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGroupLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupLinkDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupLinkDtoListIHandleError>;
        }));
    }

    protected processGetAllGroupLinks(response: HttpResponseBase): Observable<GroupLinkDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GroupLinkDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupLinkDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateGroupLink(body: GroupLinkDto | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/CreateOrUpdateGroupLinkAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateGroupLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateGroupLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCreateOrUpdateGroupLink(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteGroupLink(id: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/DeleteGroupLink?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteGroupLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGroupLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteGroupLink(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getDriveCategories(): Observable<DriveCategoryDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/GetDriveCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDriveCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDriveCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DriveCategoryDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DriveCategoryDtoListIHandleError>;
        }));
    }

    protected processGetDriveCategories(response: HttpResponseBase): Observable<DriveCategoryDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DriveCategoryDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DriveCategoryDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateDriveCategory(body: DriveCategoryInputDto | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/CreateOrUpdateDriveCategoryAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateDriveCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateDriveCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCreateOrUpdateDriveCategory(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteDriveCategory(id: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Link/DeleteDriveCategory?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDriveCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDriveCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteDriveCategory(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }
}

@Injectable()
export class LostReasonsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getLostReasonSettings(): Observable<LostReasonSettingsDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LostReasons/GetLostReasonSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLostReasonSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLostReasonSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LostReasonSettingsDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LostReasonSettingsDtoIHandleError>;
        }));
    }

    protected processGetLostReasonSettings(response: HttpResponseBase): Observable<LostReasonSettingsDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LostReasonSettingsDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LostReasonSettingsDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveLostReason(body: SaveLostReasonInput | null | undefined): Observable<SaveLostReasonOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LostReasons/SaveLostReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveLostReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveLostReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveLostReasonOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveLostReasonOutputIHandleError>;
        }));
    }

    protected processSaveLostReason(response: HttpResponseBase): Observable<SaveLostReasonOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SaveLostReasonOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveLostReasonOutputIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLostReasonDeleteImpact(id: number | null | undefined): Observable<LostReasonDeleteImpactDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LostReasons/GetLostReasonDeleteImpact?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLostReasonDeleteImpact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLostReasonDeleteImpact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LostReasonDeleteImpactDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LostReasonDeleteImpactDtoIHandleError>;
        }));
    }

    protected processGetLostReasonDeleteImpact(response: HttpResponseBase): Observable<LostReasonDeleteImpactDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LostReasonDeleteImpactDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LostReasonDeleteImpactDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteLostReason(body: EntityDto | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LostReasons/DeleteLostReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLostReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLostReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteLostReason(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reorderLostReasons(body: ReorderLostReasonsInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LostReasons/ReorderLostReasons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderLostReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderLostReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processReorderLostReasons(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setLostReasonRequired(body: SetLostReasonRequiredInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LostReasons/SetLostReasonRequired";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetLostReasonRequired(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetLostReasonRequired(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processSetLostReasonRequired(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    suggestLostReasonIcons(body: SuggestLostReasonIconsInput | null | undefined): Observable<LostReasonIconSuggestionDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/LostReasons/SuggestLostReasonIcons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuggestLostReasonIcons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuggestLostReasonIcons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LostReasonIconSuggestionDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LostReasonIconSuggestionDtoIHandleError>;
        }));
    }

    protected processSuggestLostReasonIcons(response: HttpResponseBase): Observable<LostReasonIconSuggestionDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LostReasonIconSuggestionDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LostReasonIconSuggestionDtoIHandleError>(null as any);
    }
}

@Injectable()
export class MyCalendarSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getMySettings(): Observable<MyCalendarSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCalendarSettings/GetMySettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyCalendarSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyCalendarSettingsDto>;
        }));
    }

    protected processGetMySettings(response: HttpResponseBase): Observable<MyCalendarSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MyCalendarSettingsDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MyCalendarSettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setMyVisibility(body: SetMyVisibilityInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MyCalendarSettings/SetMyVisibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetMyVisibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetMyVisibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetMyVisibility(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setMySyncToMyDay(body: SetMySyncToMyDayInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MyCalendarSettings/SetMySyncToMyDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetMySyncToMyDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetMySyncToMyDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetMySyncToMyDay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setMyCalendarSync(body: SetMyCalendarSyncInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MyCalendarSettings/SetMyCalendarSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetMyCalendarSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetMyCalendarSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetMyCalendarSync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getMyAccess(): Observable<UserCalendarAccessDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCalendarSettings/GetMyAccess";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCalendarAccessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCalendarAccessDto>;
        }));
    }

    protected processGetMyAccess(response: HttpResponseBase): Observable<UserCalendarAccessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserCalendarAccessDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCalendarAccessDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMyGrant(body: AddMyGrantInput | null | undefined): Observable<CalendarAccessGrantDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCalendarSettings/AddMyGrant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMyGrant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMyGrant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarAccessGrantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarAccessGrantDto>;
        }));
    }

    protected processAddMyGrant(response: HttpResponseBase): Observable<CalendarAccessGrantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CalendarAccessGrantDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarAccessGrantDto>(null as any);
    }

    /**
     * @param grantId (optional) 
     * @return Success
     */
    removeMyGrant(grantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MyCalendarSettings/RemoveMyGrant?";
        if (grantId !== undefined && grantId !== null)
            url_ += "grantId=" + encodeURIComponent("" + grantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveMyGrant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveMyGrant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveMyGrant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class NotesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateNote(body: CreateOrUpdateNotesDto | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Notes/CreateOrUpdateNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCreateOrUpdateNote(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteNote(id: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Notes/DeleteNote?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteNote(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getRecentNotes(): Observable<NotesDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Notes/GetRecentNotes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotesDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotesDtoListIHandleError>;
        }));
    }

    protected processGetRecentNotes(response: HttpResponseBase): Observable<NotesDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NotesDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotesDtoListIHandleError>(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param state (optional) 
     * @param searchText (optional) 
     * @return Success
     */
    getUserNotifications_v2(state: any | null | undefined, searchText: string | null | undefined): Observable<UserNotificationsGroupsListGetNotificationsOutputv2ListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications_v2?";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications_v2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications_v2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNotificationsGroupsListGetNotificationsOutputv2ListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNotificationsGroupsListGetNotificationsOutputv2ListValueTupleIHandleError>;
        }));
    }

    protected processGetUserNotifications_v2(response: HttpResponseBase): Observable<UserNotificationsGroupsListGetNotificationsOutputv2ListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationsGroupsListGetNotificationsOutputv2ListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserNotificationsGroupsListGetNotificationsOutputv2ListValueTupleIHandleError>(null as any);
    }

    /**
     * @param state (optional) 
     * @param searchText (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getUserNotifications_v2_WithPaging(state: any | null | undefined, searchText: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications_v2_WithPaging?";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications_v2_WithPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications_v2_WithPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTupleIHandleError>;
        }));
    }

    protected processGetUserNotifications_v2_WithPaging(response: HttpResponseBase): Observable<UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTupleIHandleError>(null as any);
    }

    /**
     * @param state (optional) 
     * @param searchText (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param cacheKey (optional) 
     * @return Success
     */
    getUserNotifications_v2_WithSkipCount(state: any | null | undefined, searchText: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, cacheKey: string | null | undefined): Observable<UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications_v2_WithSkipCount?";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (cacheKey !== undefined && cacheKey !== null)
            url_ += "CacheKey=" + encodeURIComponent("" + cacheKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications_v2_WithSkipCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications_v2_WithSkipCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTupleIHandleError>;
        }));
    }

    protected processGetUserNotifications_v2_WithSkipCount(response: HttpResponseBase): Observable<UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTupleIHandleError>(null as any);
    }

    /**
     * @param state (optional) 
     * @param searchText (optional) 
     * @return Success
     */
    getUserNotifications(state: any | null | undefined, searchText: string | null | undefined): Observable<UserNotificationsGroupsListGetNotificationsOutputListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNotificationsGroupsListGetNotificationsOutputListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNotificationsGroupsListGetNotificationsOutputListValueTupleIHandleError>;
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<UserNotificationsGroupsListGetNotificationsOutputListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationsGroupsListGetNotificationsOutputListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserNotificationsGroupsListGetNotificationsOutputListValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNotificationsAsRead(body: SetNotificationReadInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationsAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSetNotificationsAsRead(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getUnReadNotificationsCounts(): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUnReadNotificationsCounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnReadNotificationsCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnReadNotificationsCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processGetUnReadNotificationsCounts(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clearNotifications(body: ClearNotificationInputDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Notification/ClearNotifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processClearNotifications(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    markAllTaskSeen(): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Notification/MarkAllTaskSeen";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllTaskSeen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllTaskSeen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMarkAllTaskSeen(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }
}

@Injectable()
export class OfficeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return Success
     */
    getAll(maxResultCount: number | null | undefined, skipCount: number | null | undefined, filter: string | null | undefined): Observable<Int32WorkSitesDtoIEnumerableValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Office/GetAll?";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32WorkSitesDtoIEnumerableValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32WorkSitesDtoIEnumerableValueTupleIHandleError>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Int32WorkSitesDtoIEnumerableValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32WorkSitesDtoIEnumerableValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32WorkSitesDtoIEnumerableValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: WorkSitesDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Office/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteWorkSite(id: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Office/DeleteWorkSite?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWorkSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWorkSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteWorkSite(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }
}

@Injectable()
export class OnboardingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getState(): Observable<OnboardingSessionDto> {
        let url_ = this.baseUrl + "/api/services/app/Onboarding/GetState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingSessionDto>;
        }));
    }

    protected processGetState(response: HttpResponseBase): Observable<OnboardingSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingSessionDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingSessionDto>(null as any);
    }

    /**
     * @return Success
     */
    start(): Observable<OnboardingSessionDto> {
        let url_ = this.baseUrl + "/api/services/app/Onboarding/Start";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingSessionDto>;
        }));
    }

    protected processStart(response: HttpResponseBase): Observable<OnboardingSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingSessionDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingSessionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveChapterDecision(body: ChapterDecisionInput | null | undefined): Observable<OnboardingSessionDto> {
        let url_ = this.baseUrl + "/api/services/app/Onboarding/SaveChapterDecision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveChapterDecision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveChapterDecision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingSessionDto>;
        }));
    }

    protected processSaveChapterDecision(response: HttpResponseBase): Observable<OnboardingSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingSessionDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingSessionDto>(null as any);
    }

    /**
     * @return Success
     */
    startScan(): Observable<DiscoveryJobDto> {
        let url_ = this.baseUrl + "/api/services/app/Onboarding/StartScan";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartScan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartScan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiscoveryJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiscoveryJobDto>;
        }));
    }

    protected processStartScan(response: HttpResponseBase): Observable<DiscoveryJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DiscoveryJobDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiscoveryJobDto>(null as any);
    }

    /**
     * @return Success
     */
    retryScan(): Observable<DiscoveryJobDto> {
        let url_ = this.baseUrl + "/api/services/app/Onboarding/RetryScan";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetryScan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetryScan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiscoveryJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiscoveryJobDto>;
        }));
    }

    protected processRetryScan(response: HttpResponseBase): Observable<DiscoveryJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DiscoveryJobDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiscoveryJobDto>(null as any);
    }

    /**
     * @return Success
     */
    complete(): Observable<OnboardingSessionDto> {
        let url_ = this.baseUrl + "/api/services/app/Onboarding/Complete";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingSessionDto>;
        }));
    }

    protected processComplete(response: HttpResponseBase): Observable<OnboardingSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingSessionDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingSessionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fallbackComplete(body: OnboardingFallbackInput | null | undefined): Observable<OnboardingSessionDto> {
        let url_ = this.baseUrl + "/api/services/app/Onboarding/FallbackComplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFallbackComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFallbackComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingSessionDto>;
        }));
    }

    protected processFallbackComplete(response: HttpResponseBase): Observable<OnboardingSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingSessionDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingSessionDto>(null as any);
    }

    /**
     * @return Success
     */
    replay(): Observable<OnboardingSessionDto> {
        let url_ = this.baseUrl + "/api/services/app/Onboarding/Replay";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingSessionDto>;
        }));
    }

    protected processReplay(response: HttpResponseBase): Observable<OnboardingSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingSessionDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingSessionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    organize(body: OrganizeOnboardingInput | null | undefined): Observable<OnboardingApplyProgressDto> {
        let url_ = this.baseUrl + "/api/services/app/Onboarding/Organize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrganize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrganize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingApplyProgressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingApplyProgressDto>;
        }));
    }

    protected processOrganize(response: HttpResponseBase): Observable<OnboardingApplyProgressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingApplyProgressDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingApplyProgressDto>(null as any);
    }

    /**
     * @return Success
     */
    getApplyProgress(): Observable<OnboardingApplyProgressDto> {
        let url_ = this.baseUrl + "/api/services/app/Onboarding/GetApplyProgress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplyProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplyProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingApplyProgressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingApplyProgressDto>;
        }));
    }

    protected processGetApplyProgress(response: HttpResponseBase): Observable<OnboardingApplyProgressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingApplyProgressDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingApplyProgressDto>(null as any);
    }

    /**
     * @return Success
     */
    retryApply(): Observable<OnboardingApplyProgressDto> {
        let url_ = this.baseUrl + "/api/services/app/Onboarding/RetryApply";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetryApply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetryApply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingApplyProgressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingApplyProgressDto>;
        }));
    }

    protected processRetryApply(response: HttpResponseBase): Observable<OnboardingApplyProgressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingApplyProgressDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingApplyProgressDto>(null as any);
    }
}

@Injectable()
export class OnboardingConnectionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getStatus(): Observable<OnboardingConnectionStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/OnboardingConnection/GetStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingConnectionStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingConnectionStatusDto>;
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<OnboardingConnectionStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingConnectionStatusDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingConnectionStatusDto>(null as any);
    }

    /**
     * @return Success
     */
    getAdminConsentLink(): Observable<OnboardingAdminConsentLinkDto> {
        let url_ = this.baseUrl + "/api/services/app/OnboardingConnection/GetAdminConsentLink";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminConsentLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminConsentLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingAdminConsentLinkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingAdminConsentLinkDto>;
        }));
    }

    protected processGetAdminConsentLink(response: HttpResponseBase): Observable<OnboardingAdminConsentLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingAdminConsentLinkDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingAdminConsentLinkDto>(null as any);
    }

    /**
     * @return Success
     */
    getOrganizationIdentity(): Observable<OnboardingOrganizationIdentityDto> {
        let url_ = this.baseUrl + "/api/services/app/OnboardingConnection/GetOrganizationIdentity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationIdentity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationIdentity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingOrganizationIdentityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingOrganizationIdentityDto>;
        }));
    }

    protected processGetOrganizationIdentity(response: HttpResponseBase): Observable<OnboardingOrganizationIdentityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingOrganizationIdentityDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingOrganizationIdentityDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    trackConnectStep(body: TrackOnboardingConnectStepInput | null | undefined): Observable<OnboardingConnectionStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/OnboardingConnection/TrackConnectStep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrackConnectStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrackConnectStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingConnectionStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingConnectionStatusDto>;
        }));
    }

    protected processTrackConnectStep(response: HttpResponseBase): Observable<OnboardingConnectionStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingConnectionStatusDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingConnectionStatusDto>(null as any);
    }
}

@Injectable()
export class OnboardingQaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getState(): Observable<OnboardingQaStateDto> {
        let url_ = this.baseUrl + "/api/services/app/OnboardingQa/GetState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingQaStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingQaStateDto>;
        }));
    }

    protected processGetState(response: HttpResponseBase): Observable<OnboardingQaStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingQaStateDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingQaStateDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setOnboardingOptions(body: SetOnboardingQaOptionsInput | null | undefined): Observable<OnboardingQaStateDto> {
        let url_ = this.baseUrl + "/api/services/app/OnboardingQa/SetOnboardingOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOnboardingOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOnboardingOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingQaStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingQaStateDto>;
        }));
    }

    protected processSetOnboardingOptions(response: HttpResponseBase): Observable<OnboardingQaStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingQaStateDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingQaStateDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setIntelligenceOptions(body: SetIntelligenceQaOptionsInput | null | undefined): Observable<OnboardingQaStateDto> {
        let url_ = this.baseUrl + "/api/services/app/OnboardingQa/SetIntelligenceOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetIntelligenceOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIntelligenceOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingQaStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingQaStateDto>;
        }));
    }

    protected processSetIntelligenceOptions(response: HttpResponseBase): Observable<OnboardingQaStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingQaStateDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingQaStateDto>(null as any);
    }

    /**
     * @return Success
     */
    resetSession(): Observable<OnboardingQaStateDto> {
        let url_ = this.baseUrl + "/api/services/app/OnboardingQa/ResetSession";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingQaStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingQaStateDto>;
        }));
    }

    protected processResetSession(response: HttpResponseBase): Observable<OnboardingQaStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OnboardingQaStateDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingQaStateDto>(null as any);
    }
}

@Injectable()
export class OneDriveServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param file (optional) 
     * @param driveId (optional) 
     * @param folderId (optional) 
     * @param duplicateAction (optional) 
     * @return Success
     */
    uploadFile(file: FileParameter | null | undefined, driveId: string | null | undefined, folderId: string | null | undefined, duplicateAction: number | null | undefined): Observable<OneDriveUploadOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (driveId !== null && driveId !== undefined)
            content_.append("DriveId", driveId.toString());
        if (folderId !== null && folderId !== undefined)
            content_.append("FolderId", folderId.toString());
        if (duplicateAction !== null && duplicateAction !== undefined)
            content_.append("DuplicateAction", duplicateAction.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OneDriveUploadOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OneDriveUploadOutputDtoIHandleError>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<OneDriveUploadOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OneDriveUploadOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OneDriveUploadOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadFile(body: DownloadFilesInputDto | null | undefined): Observable<DownloadOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/DownloadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadOutputDtoIHandleError>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<DownloadOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DownloadOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadFolderZip(body: DownloadZipInputDto | null | undefined): Observable<DownloadOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/DownloadFolderZip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFolderZip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFolderZip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadOutputDtoIHandleError>;
        }));
    }

    protected processDownloadFolderZip(response: HttpResponseBase): Observable<DownloadOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DownloadOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DownloadOutputDtoIHandleError>(null as any);
    }

    /**
     * @param search (optional) 
     * @param isPartialData (optional) 
     * @param fromCount (optional) 
     * @return Success
     */
    getMyRecentFiles(search: string | null | undefined, isPartialData: boolean | null | undefined, fromCount: number | null | undefined): Observable<OneDriveLinksListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetMyRecentFiles?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isPartialData !== undefined && isPartialData !== null)
            url_ += "IsPartialData=" + encodeURIComponent("" + isPartialData) + "&";
        if (fromCount !== undefined && fromCount !== null)
            url_ += "FromCount=" + encodeURIComponent("" + fromCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRecentFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRecentFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OneDriveLinksListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OneDriveLinksListIHandleError>;
        }));
    }

    protected processGetMyRecentFiles(response: HttpResponseBase): Observable<OneDriveLinksListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OneDriveLinksListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OneDriveLinksListIHandleError>(null as any);
    }

    /**
     * @param searchInput (optional) 
     * @return Success
     */
    getMyRecentNotebooks(searchInput: string | null | undefined): Observable<OneNoteLinksListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetMyRecentNotebooks?";
        if (searchInput !== undefined && searchInput !== null)
            url_ += "searchInput=" + encodeURIComponent("" + searchInput) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRecentNotebooks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRecentNotebooks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OneNoteLinksListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OneNoteLinksListIHandleError>;
        }));
    }

    protected processGetMyRecentNotebooks(response: HttpResponseBase): Observable<OneNoteLinksListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OneNoteLinksListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OneNoteLinksListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOneDriveFile(body: CreateFileInputDto | null | undefined): Observable<CreateFileOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/CreateOneDriveFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOneDriveFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOneDriveFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateFileOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateFileOutputDtoIHandleError>;
        }));
    }

    protected processCreateOneDriveFile(response: HttpResponseBase): Observable<CreateFileOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateFileOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateFileOutputDtoIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @param driveId (optional) 
     * @param siteId (optional) 
     * @param folderId (optional) 
     * @return Success
     */
    getFileLocation(id: string | null | undefined, driveId: string | null | undefined, siteId: string | null | undefined, folderId: string | null | undefined): Observable<GetFileLocationOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetFileLocation?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (driveId !== undefined && driveId !== null)
            url_ += "DriveId=" + encodeURIComponent("" + driveId) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
        if (folderId !== undefined && folderId !== null)
            url_ += "FolderId=" + encodeURIComponent("" + folderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFileLocationOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFileLocationOutputDtoIHandleError>;
        }));
    }

    protected processGetFileLocation(response: HttpResponseBase): Observable<GetFileLocationOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetFileLocationOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFileLocationOutputDtoIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @param driveId (optional) 
     * @param siteId (optional) 
     * @param folderId (optional) 
     * @return Success
     */
    getFileFolderUrl(id: string | null | undefined, driveId: string | null | undefined, siteId: string | null | undefined, folderId: string | null | undefined): Observable<GetFileLocationOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetFileFolderUrl?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (driveId !== undefined && driveId !== null)
            url_ += "DriveId=" + encodeURIComponent("" + driveId) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
        if (folderId !== undefined && folderId !== null)
            url_ += "FolderId=" + encodeURIComponent("" + folderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileFolderUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileFolderUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFileLocationOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFileLocationOutputDtoIHandleError>;
        }));
    }

    protected processGetFileFolderUrl(response: HttpResponseBase): Observable<GetFileLocationOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetFileLocationOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFileLocationOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFolder(body: CreateFolderDto | null | undefined): Observable<CreateFolderDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/CreateFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateFolderDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateFolderDtoIHandleError>;
        }));
    }

    protected processCreateFolder(response: HttpResponseBase): Observable<CreateFolderDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateFolderDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateFolderDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDocumentLibrary(body: CreateFolderDto | null | undefined): Observable<CreateFolderDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/CreateDocumentLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDocumentLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDocumentLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateFolderDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateFolderDtoIHandleError>;
        }));
    }

    protected processCreateDocumentLibrary(response: HttpResponseBase): Observable<CreateFolderDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateFolderDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateFolderDtoIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @return Success
     */
    getSharePointSites(searchText: string | null | undefined): Observable<SharePointSiteListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetSharePointSites?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSharePointSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSharePointSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharePointSiteListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharePointSiteListIHandleError>;
        }));
    }

    protected processGetSharePointSites(response: HttpResponseBase): Observable<SharePointSiteListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SharePointSiteListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SharePointSiteListIHandleError>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param driveId (optional) 
     * @return Success
     */
    deleteMsFile(fileId: string | null | undefined, driveId: string | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/DeleteMsFile?";
        if (fileId !== undefined && fileId !== null)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (driveId !== undefined && driveId !== null)
            url_ += "DriveId=" + encodeURIComponent("" + driveId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMsFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMsFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteMsFile(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shareMsFileFolder(body: ShareMsFileInputDto | null | undefined): Observable<ShareMsFileOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/ShareMsFileFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShareMsFileFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShareMsFileFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShareMsFileOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShareMsFileOutputDtoIHandleError>;
        }));
    }

    protected processShareMsFileFolder(response: HttpResponseBase): Observable<ShareMsFileOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ShareMsFileOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShareMsFileOutputDtoIHandleError>(null as any);
    }

    /**
     * @param siteId (optional) 
     * @return Success
     */
    getDrivesBySiteId(siteId: string | null | undefined): Observable<SharePointSiteListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetDrivesBySiteId?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDrivesBySiteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDrivesBySiteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharePointSiteListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharePointSiteListIHandleError>;
        }));
    }

    protected processGetDrivesBySiteId(response: HttpResponseBase): Observable<SharePointSiteListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SharePointSiteListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SharePointSiteListIHandleError>(null as any);
    }

    /**
     * @param driveId (optional) 
     * @param itemId (optional) 
     * @param nextLink (optional) 
     * @param searchText (optional) 
     * @return Success
     */
    getMsFiles(driveId: string | null | undefined, itemId: string | null | undefined, nextLink: string | null | undefined, searchText: string | null | undefined): Observable<GetMsFileOutputListStringValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetMsFiles?";
        if (driveId !== undefined && driveId !== null)
            url_ += "driveId=" + encodeURIComponent("" + driveId) + "&";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (nextLink !== undefined && nextLink !== null)
            url_ += "nextLink=" + encodeURIComponent("" + nextLink) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMsFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMsFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMsFileOutputListStringValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMsFileOutputListStringValueTupleIHandleError>;
        }));
    }

    protected processGetMsFiles(response: HttpResponseBase): Observable<GetMsFileOutputListStringValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetMsFileOutputListStringValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMsFileOutputListStringValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBreadcrumbs(body: BreadcrumbRequestInput[] | null | undefined): Observable<BreadcrumbResultOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetBreadcrumbs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBreadcrumbs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBreadcrumbs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BreadcrumbResultOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BreadcrumbResultOutputListIHandleError>;
        }));
    }

    protected processGetBreadcrumbs(response: HttpResponseBase): Observable<BreadcrumbResultOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BreadcrumbResultOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BreadcrumbResultOutputListIHandleError>(null as any);
    }

    /**
     * @param driveId (optional) 
     * @param itemId (optional) 
     * @param siteId (optional) 
     * @return Success
     */
    getFolderBreadcrumb(driveId: string | null | undefined, itemId: string | null | undefined, siteId: string | null | undefined): Observable<BreadcrumbItemDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetFolderBreadcrumb?";
        if (driveId !== undefined && driveId !== null)
            url_ += "driveId=" + encodeURIComponent("" + driveId) + "&";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFolderBreadcrumb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFolderBreadcrumb(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BreadcrumbItemDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BreadcrumbItemDtoListIHandleError>;
        }));
    }

    protected processGetFolderBreadcrumb(response: HttpResponseBase): Observable<BreadcrumbItemDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BreadcrumbItemDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BreadcrumbItemDtoListIHandleError>(null as any);
    }

    /**
     * @param driveId (optional) 
     * @return Success
     */
    getSharePointDriveChildrenByDriveId(driveId: string | null | undefined): Observable<SharePointSiteListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetSharePointDriveChildrenByDriveId?";
        if (driveId !== undefined && driveId !== null)
            url_ += "driveId=" + encodeURIComponent("" + driveId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSharePointDriveChildrenByDriveId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSharePointDriveChildrenByDriveId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharePointSiteListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharePointSiteListIHandleError>;
        }));
    }

    protected processGetSharePointDriveChildrenByDriveId(response: HttpResponseBase): Observable<SharePointSiteListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SharePointSiteListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SharePointSiteListIHandleError>(null as any);
    }

    /**
     * @param driveId (optional) 
     * @param itemId (optional) 
     * @return Success
     */
    getDriveItemsByItemId(driveId: string | null | undefined, itemId: string | null | undefined): Observable<SharePointSiteListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetDriveItemsByItemId?";
        if (driveId !== undefined && driveId !== null)
            url_ += "driveId=" + encodeURIComponent("" + driveId) + "&";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDriveItemsByItemId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDriveItemsByItemId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SharePointSiteListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SharePointSiteListIHandleError>;
        }));
    }

    protected processGetDriveItemsByItemId(response: HttpResponseBase): Observable<SharePointSiteListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SharePointSiteListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SharePointSiteListIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getMyFilesOnOneDrive(): Observable<MyDriveItemOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetMyFilesOnOneDrive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyFilesOnOneDrive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyFilesOnOneDrive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyDriveItemOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyDriveItemOutputListIHandleError>;
        }));
    }

    protected processGetMyFilesOnOneDrive(response: HttpResponseBase): Observable<MyDriveItemOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MyDriveItemOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MyDriveItemOutputListIHandleError>(null as any);
    }

    /**
     * @param driveId (optional) 
     * @param siteId (optional) 
     * @param driveName (optional) 
     * @return Success
     */
    deleteDocumentLibrary(driveId: string | null | undefined, siteId: string | null | undefined, driveName: string | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/DeleteDocumentLibrary?";
        if (driveId !== undefined && driveId !== null)
            url_ += "DriveId=" + encodeURIComponent("" + driveId) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
        if (driveName !== undefined && driveName !== null)
            url_ += "DriveName=" + encodeURIComponent("" + driveName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocumentLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocumentLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteDocumentLibrary(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameMsFileFolder(body: RenameMsFileInputDto | null | undefined): Observable<StringIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/RenameMsFileFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenameMsFileFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenameMsFileFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringIHandleError>;
        }));
    }

    protected processRenameMsFileFolder(response: HttpResponseBase): Observable<StringIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StringIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringIHandleError>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param driveId (optional) 
     * @return Success
     */
    getMsFileDetails(fileId: string | null | undefined, driveId: string | null | undefined): Observable<GetMsFileDetailOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetMsFileDetails?";
        if (fileId !== undefined && fileId !== null)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (driveId !== undefined && driveId !== null)
            url_ += "DriveId=" + encodeURIComponent("" + driveId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMsFileDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMsFileDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMsFileDetailOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMsFileDetailOutputDtoIHandleError>;
        }));
    }

    protected processGetMsFileDetails(response: HttpResponseBase): Observable<GetMsFileDetailOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetMsFileDetailOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMsFileDetailOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyMsFile(body: CopyMoveMsFileInputDto | null | undefined): Observable<CreateFileOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/CopyMsFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyMsFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyMsFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateFileOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateFileOutputDtoIHandleError>;
        }));
    }

    protected processCopyMsFile(response: HttpResponseBase): Observable<CreateFileOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateFileOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateFileOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyMsFilesWithOutcomes(body: CopyMoveMsFileInputDto[] | null | undefined): Observable<CopyMsFileOutcomeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/CopyMsFilesWithOutcomes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyMsFilesWithOutcomes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyMsFilesWithOutcomes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CopyMsFileOutcomeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CopyMsFileOutcomeDto[]>;
        }));
    }

    protected processCopyMsFilesWithOutcomes(response: HttpResponseBase): Observable<CopyMsFileOutcomeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CopyMsFileOutcomeDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CopyMsFileOutcomeDto[]>(null as any);
    }

    /**
     * @param driveId (optional) 
     * @param itemId (optional) 
     * @param anyItem (optional) 
     * @return Success
     */
    getFolderLocationStatus(driveId: string | null | undefined, itemId: string | null | undefined, anyItem: boolean | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetFolderLocationStatus?";
        if (driveId !== undefined && driveId !== null)
            url_ += "driveId=" + encodeURIComponent("" + driveId) + "&";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (anyItem !== undefined && anyItem !== null)
            url_ += "anyItem=" + encodeURIComponent("" + anyItem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFolderLocationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFolderLocationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processGetFolderLocationStatus(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyMsFiles(body: CopyMoveMsFileInputDto[] | null | undefined): Observable<CreateFileOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/CopyMsFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyMsFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyMsFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateFileOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateFileOutputDtoListIHandleError>;
        }));
    }

    protected processCopyMsFiles(response: HttpResponseBase): Observable<CreateFileOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateFileOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateFileOutputDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveMsFile(body: CopyMoveMsFileInputDto | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/MoveMsFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveMsFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveMsFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processMoveMsFile(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchMsFiles(body: SearchMsFilesInput | null | undefined): Observable<SearchMsOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/SearchMsFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchMsFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMsFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchMsOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchMsOutputListIHandleError>;
        }));
    }

    protected processSearchMsFiles(response: HttpResponseBase): Observable<SearchMsOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SearchMsOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchMsOutputListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMsFilePaths(body: GetMsFilePathsInput | null | undefined): Observable<MsFilePathOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetMsFilePaths";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMsFilePaths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMsFilePaths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MsFilePathOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MsFilePathOutputListIHandleError>;
        }));
    }

    protected processGetMsFilePaths(response: HttpResponseBase): Observable<MsFilePathOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MsFilePathOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MsFilePathOutputListIHandleError>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param driveId (optional) 
     * @param requestType (optional) 
     * @return Success
     */
    getFileUrl(itemId: string | null | undefined, driveId: string | null | undefined, requestType: number | null | undefined): Observable<StringIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/GetFileUrl?";
        if (itemId !== undefined && itemId !== null)
            url_ += "ItemId=" + encodeURIComponent("" + itemId) + "&";
        if (driveId !== undefined && driveId !== null)
            url_ += "DriveId=" + encodeURIComponent("" + driveId) + "&";
        if (requestType !== undefined && requestType !== null)
            url_ += "RequestType=" + encodeURIComponent("" + requestType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringIHandleError>;
        }));
    }

    protected processGetFileUrl(response: HttpResponseBase): Observable<StringIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StringIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createExcelFile(body: CreateFileInputDto | null | undefined): Observable<OneDriveUploadOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/CreateExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExcelFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExcelFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OneDriveUploadOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OneDriveUploadOutputDtoIHandleError>;
        }));
    }

    protected processCreateExcelFile(response: HttpResponseBase): Observable<OneDriveUploadOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OneDriveUploadOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OneDriveUploadOutputDtoIHandleError>(null as any);
    }

    /**
     * @param textString (optional) 
     * @param charToRemove (optional) 
     * @param isRemoveEndingPeriod (optional) 
     * @return Success
     */
    removeUnwantedChar(textString: string | null | undefined, charToRemove: string | null | undefined, isRemoveEndingPeriod: boolean | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/OneDrive/RemoveUnwantedChar?";
        if (textString !== undefined && textString !== null)
            url_ += "textString=" + encodeURIComponent("" + textString) + "&";
        if (charToRemove !== undefined && charToRemove !== null)
            url_ += "charToRemove=" + encodeURIComponent("" + charToRemove) + "&";
        if (isRemoveEndingPeriod !== undefined && isRemoveEndingPeriod !== null)
            url_ += "isRemoveEndingPeriod=" + encodeURIComponent("" + isRemoveEndingPeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUnwantedChar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUnwantedChar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRemoveUnwantedChar(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<OrganizationUnitDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDtoListResultDto>;
        }));
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<OrganizationUnitDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDtoListResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitUsers(id: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<OrganizationUnitUserListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitUserListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitUserListDtoPagedResultDto>;
        }));
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<OrganizationUnitUserListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitUserListDtoPagedResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitUserListDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrganizationUnit(body: CreateOrganizationUnitInput | null | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrganizationUnit(body: UpdateOrganizationUnitInput | null | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveOrganizationUnit(body: MoveOrganizationUnitInput | null | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteOrganizationUnit(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number | null | undefined, organizationUnitId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId !== undefined && organizationUnitId !== null)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUsersToOrganizationUnit(body: UsersToOrganizationUnitInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindOrganizationUnitUsersInput | null | undefined): Observable<NameValueDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueDtoPagedResultDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<NameValueDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NameValueDtoPagedResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class OrgIntelligenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getIntelligence(): Observable<OrgIntelligenceDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgIntelligence/GetIntelligence";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntelligence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntelligence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgIntelligenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgIntelligenceDto>;
        }));
    }

    protected processGetIntelligence(response: HttpResponseBase): Observable<OrgIntelligenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrgIntelligenceDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgIntelligenceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setEnabled(body: SetOrgIntelligenceEnabledInput | null | undefined): Observable<OrgIntelligenceDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgIntelligence/SetEnabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgIntelligenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgIntelligenceDto>;
        }));
    }

    protected processSetEnabled(response: HttpResponseBase): Observable<OrgIntelligenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrgIntelligenceDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgIntelligenceDto>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentJob(): Observable<DiscoveryJobDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgIntelligence/GetCurrentJob";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiscoveryJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiscoveryJobDto>;
        }));
    }

    protected processGetCurrentJob(response: HttpResponseBase): Observable<DiscoveryJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DiscoveryJobDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiscoveryJobDto>(null as any);
    }

    /**
     * @return Success
     */
    retryScan(): Observable<OrgIntelligenceDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgIntelligence/RetryScan";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetryScan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetryScan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgIntelligenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgIntelligenceDto>;
        }));
    }

    protected processRetryScan(response: HttpResponseBase): Observable<OrgIntelligenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrgIntelligenceDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgIntelligenceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFact(body: CreateOrgIntelligenceFactInput | null | undefined): Observable<OrgIntelligenceDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgIntelligence/CreateFact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgIntelligenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgIntelligenceDto>;
        }));
    }

    protected processCreateFact(response: HttpResponseBase): Observable<OrgIntelligenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrgIntelligenceDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgIntelligenceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFact(body: UpdateOrgIntelligenceFactInput | null | undefined): Observable<OrgIntelligenceDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgIntelligence/UpdateFact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgIntelligenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgIntelligenceDto>;
        }));
    }

    protected processUpdateFact(response: HttpResponseBase): Observable<OrgIntelligenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrgIntelligenceDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgIntelligenceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteFact(body: DeleteOrgIntelligenceFactInput | null | undefined): Observable<OrgIntelligenceDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgIntelligence/DeleteFact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgIntelligenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgIntelligenceDto>;
        }));
    }

    protected processDeleteFact(response: HttpResponseBase): Observable<OrgIntelligenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrgIntelligenceDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgIntelligenceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptSuggestion(body: ResolveOrgIntelligenceSuggestionInput | null | undefined): Observable<OrgIntelligenceDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgIntelligence/AcceptSuggestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgIntelligenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgIntelligenceDto>;
        }));
    }

    protected processAcceptSuggestion(response: HttpResponseBase): Observable<OrgIntelligenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrgIntelligenceDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgIntelligenceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dismissSuggestion(body: ResolveOrgIntelligenceSuggestionInput | null | undefined): Observable<OrgIntelligenceDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgIntelligence/DismissSuggestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDismissSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDismissSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgIntelligenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgIntelligenceDto>;
        }));
    }

    protected processDismissSuggestion(response: HttpResponseBase): Observable<OrgIntelligenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrgIntelligenceDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgIntelligenceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveCommunicationNote(body: SaveOrgIntelligenceCommunicationNoteInput | null | undefined): Observable<OrgIntelligenceDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgIntelligence/SaveCommunicationNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCommunicationNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCommunicationNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrgIntelligenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrgIntelligenceDto>;
        }));
    }

    protected processSaveCommunicationNote(response: HttpResponseBase): Observable<OrgIntelligenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrgIntelligenceDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrgIntelligenceDto>(null as any);
    }
}

@Injectable()
export class OutlookServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getApiSettingList(): Observable<ApiOptionsListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/GetApiSettingList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApiSettingList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApiSettingList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiOptionsListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiOptionsListIHandleError>;
        }));
    }

    protected processGetApiSettingList(response: HttpResponseBase): Observable<ApiOptionsListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ApiOptionsListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiOptionsListIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getGraphApiSetting(): Observable<ApiOptionsIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/GetGraphApiSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGraphApiSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGraphApiSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiOptionsIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiOptionsIHandleError>;
        }));
    }

    protected processGetGraphApiSetting(response: HttpResponseBase): Observable<ApiOptionsIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ApiOptionsIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiOptionsIHandleError>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getToken(code: string | null | undefined): Observable<TokenDetailIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/GetToken?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenDetailIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenDetailIHandleError>;
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<TokenDetailIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TokenDetailIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenDetailIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOutlookEventById(id: number | null | undefined): Observable<OutlookEventDetailsAttendeesListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/GetOutlookEventById?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutlookEventById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutlookEventById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutlookEventDetailsAttendeesListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutlookEventDetailsAttendeesListIHandleError>;
        }));
    }

    protected processGetOutlookEventById(response: HttpResponseBase): Observable<OutlookEventDetailsAttendeesListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OutlookEventDetailsAttendeesListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutlookEventDetailsAttendeesListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    undoDeleteOutlookEvent(body: EntityDto | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/UndoDeleteOutlookEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoDeleteOutlookEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoDeleteOutlookEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processUndoDeleteOutlookEvent(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePlannerProcess(body: UpdatePlannerDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/UpdatePlannerProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePlannerProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePlannerProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdatePlannerProcess(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMeeting(body: CreateMeetingInputDto | null | undefined): Observable<StringIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/CreateMeetingAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringIHandleError>;
        }));
    }

    protected processCreateMeeting(response: HttpResponseBase): Observable<StringIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StringIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMeeting(body: CreateMeetingInputDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/UpdateMeetingAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateMeeting(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param calendarEventId (optional) 
     * @return Success
     */
    acceptMeeting(calendarEventId: string | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/AcceptMeetingAsync?";
        if (calendarEventId !== undefined && calendarEventId !== null)
            url_ += "CalendarEventId=" + encodeURIComponent("" + calendarEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAcceptMeeting(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @return Success
     */
    getPeople(searchText: string | null | undefined): Observable<MicrosoftPeopleListDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/GetPeople?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MicrosoftPeopleListDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MicrosoftPeopleListDtoListIHandleError>;
        }));
    }

    protected processGetPeople(response: HttpResponseBase): Observable<MicrosoftPeopleListDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MicrosoftPeopleListDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MicrosoftPeopleListDtoListIHandleError>(null as any);
    }

    /**
     * @param appEventId (optional) 
     * @param calendarEventId (optional) 
     * @return Success
     */
    deleteMeeting(appEventId: number | null | undefined, calendarEventId: string | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/DeleteMeeting?";
        if (appEventId !== undefined && appEventId !== null)
            url_ += "appEventId=" + encodeURIComponent("" + appEventId) + "&";
        if (calendarEventId !== undefined && calendarEventId !== null)
            url_ += "CalendarEventId=" + encodeURIComponent("" + calendarEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteMeeting(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param appEventId (optional) 
     * @param calendarEventId (optional) 
     * @return Success
     */
    cancelMeeting(appEventId: number | null | undefined, calendarEventId: string | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/CancelMeeting?";
        if (appEventId !== undefined && appEventId !== null)
            url_ += "appEventId=" + encodeURIComponent("" + appEventId) + "&";
        if (calendarEventId !== undefined && calendarEventId !== null)
            url_ += "CalendarEventId=" + encodeURIComponent("" + calendarEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelMeeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelMeeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCancelMeeting(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getMyImportantEmails(): Observable<MicrosoftEmailMessageDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/GetMyImportantEmails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyImportantEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyImportantEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MicrosoftEmailMessageDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MicrosoftEmailMessageDtoListIHandleError>;
        }));
    }

    protected processGetMyImportantEmails(response: HttpResponseBase): Observable<MicrosoftEmailMessageDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MicrosoftEmailMessageDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MicrosoftEmailMessageDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendMSTeamsMessage(body: SendMsTeamsMessageInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/SendMSTeamsMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMSTeamsMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMSTeamsMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSendMSTeamsMessage(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clearMSTeamsPresence(body: SetUserPresenceDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/ClearMSTeamsPresence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearMSTeamsPresence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearMSTeamsPresence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processClearMSTeamsPresence(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getMsTeamList(): Observable<MsTeamListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/GetMsTeamList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMsTeamList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMsTeamList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MsTeamListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MsTeamListIHandleError>;
        }));
    }

    protected processGetMsTeamList(response: HttpResponseBase): Observable<MsTeamListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MsTeamListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MsTeamListIHandleError>(null as any);
    }

    /**
     * @param teamId (optional) 
     * @param channelId (optional) 
     * @return Success
     */
    getMsTeamDetails(teamId: string | null | undefined, channelId: string | null | undefined): Observable<MsTeamIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/GetMsTeamDetails?";
        if (teamId !== undefined && teamId !== null)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&";
        if (channelId !== undefined && channelId !== null)
            url_ += "ChannelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMsTeamDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMsTeamDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MsTeamIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MsTeamIHandleError>;
        }));
    }

    protected processGetMsTeamDetails(response: HttpResponseBase): Observable<MsTeamIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MsTeamIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MsTeamIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMsTeam(body: CreateMsTeam | null | undefined): Observable<MsTeamMsTeamChannelIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/CreateMsTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMsTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMsTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MsTeamMsTeamChannelIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MsTeamMsTeamChannelIHandleError>;
        }));
    }

    protected processCreateMsTeam(response: HttpResponseBase): Observable<MsTeamMsTeamChannelIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MsTeamMsTeamChannelIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MsTeamMsTeamChannelIHandleError>(null as any);
    }

    /**
     * @param teamId (optional) 
     * @param channelId (optional) 
     * @return Success
     */
    getMsTeamChannelList(teamId: string | null | undefined, channelId: string | null | undefined): Observable<MsTeamChannelListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/GetMsTeamChannelList?";
        if (teamId !== undefined && teamId !== null)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&";
        if (channelId !== undefined && channelId !== null)
            url_ += "ChannelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMsTeamChannelList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMsTeamChannelList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MsTeamChannelListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MsTeamChannelListIHandleError>;
        }));
    }

    protected processGetMsTeamChannelList(response: HttpResponseBase): Observable<MsTeamChannelListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MsTeamChannelListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MsTeamChannelListIHandleError>(null as any);
    }

    /**
     * @param teamId (optional) 
     * @param channelId (optional) 
     * @return Success
     */
    getMsChannelDetails(teamId: string | null | undefined, channelId: string | null | undefined): Observable<MsTeamChannelIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/GetMsChannelDetails?";
        if (teamId !== undefined && teamId !== null)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&";
        if (channelId !== undefined && channelId !== null)
            url_ += "ChannelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMsChannelDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMsChannelDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MsTeamChannelIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MsTeamChannelIHandleError>;
        }));
    }

    protected processGetMsChannelDetails(response: HttpResponseBase): Observable<MsTeamChannelIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MsTeamChannelIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MsTeamChannelIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMsChannel(body: CreateMsChannel | null | undefined): Observable<MsTeamChannelIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/CreateMsChannel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMsChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMsChannel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MsTeamChannelIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MsTeamChannelIHandleError>;
        }));
    }

    protected processCreateMsChannel(response: HttpResponseBase): Observable<MsTeamChannelIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MsTeamChannelIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MsTeamChannelIHandleError>(null as any);
    }

    /**
     * @param teamId (optional) 
     * @param channelId (optional) 
     * @return Success
     */
    getMsTeamsMembers(teamId: string | null | undefined, channelId: string | null | undefined): Observable<MsTeamsMembersListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/GetMsTeamsMembers?";
        if (teamId !== undefined && teamId !== null)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&";
        if (channelId !== undefined && channelId !== null)
            url_ += "ChannelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMsTeamsMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMsTeamsMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MsTeamsMembersListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MsTeamsMembersListIHandleError>;
        }));
    }

    protected processGetMsTeamsMembers(response: HttpResponseBase): Observable<MsTeamsMembersListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MsTeamsMembersListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MsTeamsMembersListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMsTeamsMember(body: AddMsTeamsMember | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/AddMsTeamsMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMsTeamsMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMsTeamsMember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAddMsTeamsMember(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param teamId (optional) 
     * @param channelId (optional) 
     * @return Success
     */
    getMsChannelFiles(teamId: string | null | undefined, channelId: string | null | undefined): Observable<MsTeamsFolderOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Outlook/GetMsChannelFiles?";
        if (teamId !== undefined && teamId !== null)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&";
        if (channelId !== undefined && channelId !== null)
            url_ += "ChannelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMsChannelFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMsChannelFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MsTeamsFolderOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MsTeamsFolderOutputIHandleError>;
        }));
    }

    protected processGetMsChannelFiles(response: HttpResponseBase): Observable<MsTeamsFolderOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MsTeamsFolderOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MsTeamsFolderOutputIHandleError>(null as any);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param upgradeEditionId (optional) 
     * @return Success
     */
    getPaymentInfo(upgradeEditionId: number | null | undefined): Observable<PaymentInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId !== undefined && upgradeEditionId !== null)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentInfoDto>;
        }));
    }

    protected processGetPaymentInfo(response: HttpResponseBase): Observable<PaymentInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PaymentInfoDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPayment(body: CreatePaymentDto | null | undefined): Observable<CreatePaymentResponse> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePaymentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePaymentResponse>;
        }));
    }

    protected processCreatePayment(response: HttpResponseBase): Observable<CreatePaymentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreatePaymentResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePaymentResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    executePayment(body: ExecutePaymentDto | null | undefined): Observable<ExecutePaymentResponse> {
        let url_ = this.baseUrl + "/api/services/app/Payment/ExecutePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecutePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecutePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExecutePaymentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExecutePaymentResponse>;
        }));
    }

    protected processExecutePayment(response: HttpResponseBase): Observable<ExecutePaymentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ExecutePaymentResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExecutePaymentResponse>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaymentHistory(sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<SubscriptionPaymentListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPaymentListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPaymentListDtoPagedResultDto>;
        }));
    }

    protected processGetPaymentHistory(response: HttpResponseBase): Observable<SubscriptionPaymentListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentListDtoPagedResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionPaymentListDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<FlatPermissionWithLevelDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlatPermissionWithLevelDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlatPermissionWithLevelDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<FlatPermissionWithLevelDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = FlatPermissionWithLevelDtoListResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlatPermissionWithLevelDtoListResultDto>(null as any);
    }
}

@Injectable()
export class PinnedServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdatePinnedEntity(body: PinnedEntityDto | null | undefined): Observable<Int64IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Pinned/CreateUpdatePinnedEntity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdatePinnedEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdatePinnedEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int64IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int64IHandleError>;
        }));
    }

    protected processCreateUpdatePinnedEntity(response: HttpResponseBase): Observable<Int64IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int64IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int64IHandleError>(null as any);
    }
}

@Injectable()
export class ProductEventsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    track(body: TrackProductEventInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductEvents/Track";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrack(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfileForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserProfileEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserProfileEditDto>;
        }));
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserProfileEditDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentUserProfileEditDto>(null as any);
    }

    /**
     * @return Success
     */
    getEmailSignature(): Observable<EmailSignatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetEmailSignature";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailSignatureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailSignatureDto>;
        }));
    }

    protected processGetEmailSignature(response: HttpResponseBase): Observable<EmailSignatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EmailSignatureDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailSignatureDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmailSignature(body: UpdateEmailSignatureInput | null | undefined): Observable<EmailSignatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateEmailSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmailSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmailSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailSignatureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailSignatureDto>;
        }));
    }

    protected processUpdateEmailSignature(response: HttpResponseBase): Observable<EmailSignatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EmailSignatureDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailSignatureDto>(null as any);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateGoogleAuthenticatorKeyOutput>(null as any);
    }

    /**
     * @return Success
     */
    sendVerificationSms(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifySmsCode(body: VerifySmsCodeInputDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getAllAvatars(): Observable<LookupTableModalOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetAllAvatars";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvatars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvatars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableModalOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableModalOutputDto[]>;
        }));
    }

    protected processGetAllAvatars(response: HttpResponseBase): Observable<LookupTableModalOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTableModalOutputDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupTableModalOutputDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    uploadSyncUserPhoto(file: FileParameter | null | undefined): Observable<StringIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UploadSyncUserPhoto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSyncUserPhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSyncUserPhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringIHandleError>;
        }));
    }

    protected processUploadSyncUserPhoto(response: HttpResponseBase): Observable<StringIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StringIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    syncM365UserPhoto(): Observable<StringIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SyncM365UserPhoto";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncM365UserPhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncM365UserPhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringIHandleError>;
        }));
    }

    protected processSyncM365UserPhoto(response: HttpResponseBase): Observable<StringIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StringIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfilePicture(body: UpdateProfilePictureInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPasswordComplexitySettingOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
        }));
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPasswordComplexitySettingOutput>(null as any);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(null as any);
    }

    /**
     * @param profilePictureId (optional) 
     * @return Success
     */
    getProfilePictureById(profilePictureId: string | null | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId !== undefined && profilePictureId !== null)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserAvatar(body: ChangeAvatarInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeUserAvatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUserAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUserAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processChangeUserAvatar(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getProfileNotificationSettings(): Observable<NotificationSettingsDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfileNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationSettingsDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationSettingsDtoIHandleError>;
        }));
    }

    protected processGetProfileNotificationSettings(response: HttpResponseBase): Observable<NotificationSettingsDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NotificationSettingsDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationSettingsDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfileNotificationSettings(body: NotificationSettingUpdateInput | null | undefined): Observable<NotificationSettingsDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfileNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationSettingsDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationSettingsDtoIHandleError>;
        }));
    }

    protected processUpdateProfileNotificationSettings(response: HttpResponseBase): Observable<NotificationSettingsDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NotificationSettingsDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationSettingsDtoIHandleError>(null as any);
    }
}

@Injectable()
export class ProjectServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteProjects(body: ProjectBulkActionInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Project/DeleteProjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteProjects(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param code (optional) 
     * @param body (optional) 
     * @return Success
     */
    markProjectsActiveInactive(code: number | null | undefined, body: number[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Project/MarkProjectsActiveInactive?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkProjectsActiveInactive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkProjectsActiveInactive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMarkProjectsActiveInactive(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setProjectsStage(body: SetProjectsStageInput | null | undefined): Observable<Int32ListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Project/SetProjectsStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProjectsStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProjectsStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32ListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32ListIHandleError>;
        }));
    }

    protected processSetProjectsStage(response: HttpResponseBase): Observable<Int32ListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32ListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32ListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pinUnpinProjects(body: PinnedProjectsDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Project/PinUnpinProjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPinUnpinProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPinUnpinProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processPinUnpinProjects(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendSignalRForProject(body: ProjectDetailOutputDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Project/SendSignalRForProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSignalRForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSignalRForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSendSignalRForProject(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<GetRolesOuputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRolesOuputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRolesOuputListIHandleError>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<GetRolesOuputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetRolesOuputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRolesOuputListIHandleError>(null as any);
    }

    /**
     * @param roleId (optional) 
     * @return Success
     */
    getMembers(roleId: number | null | undefined): Observable<SuggestedMemberOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetMembers?";
        if (roleId !== undefined && roleId !== null)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuggestedMemberOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuggestedMemberOutputListIHandleError>;
        }));
    }

    protected processGetMembers(response: HttpResponseBase): Observable<SuggestedMemberOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SuggestedMemberOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SuggestedMemberOutputListIHandleError>(null as any);
    }
}

@Injectable()
export class ProjectCommentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional) 
     * @param taskId (optional) 
     * @return Success
     */
    getProjectComments(projectId: number | null | undefined, taskId: number | null | undefined): Observable<ProjectCommentListDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectComment/GetProjectComments?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectCommentListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectCommentListDto>;
        }));
    }

    protected processGetProjectComments(response: HttpResponseBase): Observable<ProjectCommentListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectCommentListDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectCommentListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectComment(body: CreateProjectCommentInput | null | undefined): Observable<ProjectCommentDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectComment/CreateProjectComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectCommentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectCommentDto>;
        }));
    }

    protected processCreateProjectComment(response: HttpResponseBase): Observable<ProjectCommentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectCommentDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectCommentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectCommentText(body: UpdateProjectCommentTextInput | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ProjectComment/UpdateProjectCommentText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectCommentText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectCommentText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateProjectCommentText(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param commentId (optional) 
     * @return Success
     */
    deleteProjectComment(commentId: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ProjectComment/DeleteProjectComment?";
        if (commentId !== undefined && commentId !== null)
            url_ += "CommentId=" + encodeURIComponent("" + commentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteProjectComment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markProjectCommentSeen(body: MarkProjectCommentSeenInput | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ProjectComment/MarkProjectCommentSeen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkProjectCommentSeen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkProjectCommentSeen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkProjectCommentSeen(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class ProjectFieldServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getFieldConfiguration(): Observable<ProjectFieldConfigDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ProjectField/GetFieldConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectFieldConfigDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectFieldConfigDtoIHandleError>;
        }));
    }

    protected processGetFieldConfiguration(response: HttpResponseBase): Observable<ProjectFieldConfigDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectFieldConfigDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectFieldConfigDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveFieldConfiguration(body: SaveProjectFieldConfigInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ProjectField/SaveFieldConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFieldConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFieldConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSaveFieldConfiguration(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getProjectDetails(projectId: number | null | undefined): Observable<ProjectDetailsViewDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ProjectField/GetProjectDetails?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDetailsViewDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDetailsViewDtoIHandleError>;
        }));
    }

    protected processGetProjectDetails(response: HttpResponseBase): Observable<ProjectDetailsViewDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectDetailsViewDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDetailsViewDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProjectFieldValuesForProjects(body: GetProjectFieldValuesInput | null | undefined): Observable<ProjectFieldValuesRowDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ProjectField/GetProjectFieldValuesForProjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectFieldValuesForProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectFieldValuesForProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectFieldValuesRowDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectFieldValuesRowDtoListIHandleError>;
        }));
    }

    protected processGetProjectFieldValuesForProjects(response: HttpResponseBase): Observable<ProjectFieldValuesRowDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectFieldValuesRowDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectFieldValuesRowDtoListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param take (optional) 
     * @return Success
     */
    getProjectHistory(projectId: number | null | undefined, take: number | null | undefined): Observable<ProjectHistoryEntryDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ProjectField/GetProjectHistory?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectHistoryEntryDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectHistoryEntryDtoListIHandleError>;
        }));
    }

    protected processGetProjectHistory(response: HttpResponseBase): Observable<ProjectHistoryEntryDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectHistoryEntryDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectHistoryEntryDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectFieldValue(body: UpdateProjectFieldValueInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ProjectField/UpdateProjectFieldValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectFieldValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectFieldValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateProjectFieldValue(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveProjectFieldValues(body: SaveProjectFieldValuesInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ProjectField/SaveProjectFieldValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveProjectFieldValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProjectFieldValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSaveProjectFieldValues(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    assignAutoProjectNumber(projectId: number | null | undefined): Observable<StringIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ProjectField/AssignAutoProjectNumber?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignAutoProjectNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignAutoProjectNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringIHandleError>;
        }));
    }

    protected processAssignAutoProjectNumber(response: HttpResponseBase): Observable<StringIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StringIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getNextProjectNumberPreview(): Observable<NextProjectNumberPreviewDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ProjectField/GetNextProjectNumberPreview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextProjectNumberPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextProjectNumberPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NextProjectNumberPreviewDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NextProjectNumberPreviewDtoIHandleError>;
        }));
    }

    protected processGetNextProjectNumberPreview(response: HttpResponseBase): Observable<NextProjectNumberPreviewDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NextProjectNumberPreviewDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NextProjectNumberPreviewDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    buildProjectNamePreview(body: BuildNamePreviewInput | null | undefined): Observable<StringIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/ProjectField/BuildProjectNamePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildProjectNamePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildProjectNamePreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringIHandleError>;
        }));
    }

    protected processBuildProjectNamePreview(response: HttpResponseBase): Observable<StringIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StringIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringIHandleError>(null as any);
    }
}

@Injectable()
export class ProjectTemplateFolderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param templateId (optional) 
     * @return Success
     */
    getTemplateFolders(templateId: number | null | undefined): Observable<ProjectTemplateFoldersDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTemplateFolder/GetTemplateFolders?";
        if (templateId !== undefined && templateId !== null)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateFolders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateFolders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTemplateFoldersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTemplateFoldersDto>;
        }));
    }

    protected processGetTemplateFolders(response: HttpResponseBase): Observable<ProjectTemplateFoldersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectTemplateFoldersDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectTemplateFoldersDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveTemplateFolders(body: SaveProjectTemplateFoldersInput | null | undefined): Observable<ProjectTemplateFoldersDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectTemplateFolder/SaveTemplateFolders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveTemplateFolders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTemplateFolders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTemplateFoldersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTemplateFoldersDto>;
        }));
    }

    protected processSaveTemplateFolders(response: HttpResponseBase): Observable<ProjectTemplateFoldersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectTemplateFoldersDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectTemplateFoldersDto>(null as any);
    }
}

@Injectable()
export class RecurringTaskServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getRecurringTaskTemplates(): Observable<RecurringTaskTemplateDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/RecurringTask/GetRecurringTaskTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecurringTaskTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecurringTaskTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecurringTaskTemplateDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecurringTaskTemplateDtoListIHandleError>;
        }));
    }

    protected processGetRecurringTaskTemplates(response: HttpResponseBase): Observable<RecurringTaskTemplateDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RecurringTaskTemplateDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecurringTaskTemplateDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRecurringTaskTemplate(body: RecurringTaskTemplateDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/RecurringTask/CreateOrUpdateRecurringTaskTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRecurringTaskTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRecurringTaskTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateOrUpdateRecurringTaskTemplate(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param templateId (optional) 
     * @return Success
     */
    deleteRecurringTaskTemplate(templateId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/RecurringTask/DeleteRecurringTaskTemplate?";
        if (templateId !== undefined && templateId !== null)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRecurringTaskTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRecurringTaskTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteRecurringTaskTemplate(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }
}

@Injectable()
export class ReleaseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAllReleases(): Observable<ReleaseDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Release/GetAllReleases";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReleases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReleases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseDtoListIHandleError>;
        }));
    }

    protected processGetAllReleases(response: HttpResponseBase): Observable<ReleaseDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ReleaseDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReleaseDtoListIHandleError>(null as any);
    }

    /**
     * @param releaseId (optional) 
     * @return Success
     */
    createReleaseSeen(releaseId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Release/CreateReleaseSeen?";
        if (releaseId !== undefined && releaseId !== null)
            url_ += "ReleaseId=" + encodeURIComponent("" + releaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReleaseSeen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReleaseSeen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processCreateReleaseSeen(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param permissions (optional) 
     * @return Success
     */
    getRoles(permissions: string[] | null | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permissions !== undefined && permissions !== null)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | null | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRole(body: CreateOrUpdateRoleInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteRole(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ScheduleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSchedule(body: ScheduleInputDto | null | undefined): Observable<ScheduleOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Schedule/CreateOrUpdateSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOutputDtoIHandleError>;
        }));
    }

    protected processCreateOrUpdateSchedule(response: HttpResponseBase): Observable<ScheduleOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ScheduleOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleOutputDtoIHandleError>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<Int32ScheduleOutputDtoListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Schedule/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32ScheduleOutputDtoListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32ScheduleOutputDtoListValueTupleIHandleError>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Int32ScheduleOutputDtoListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32ScheduleOutputDtoListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32ScheduleOutputDtoListValueTupleIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteSchedule(id: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Schedule/DeleteSchedule?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteSchedule(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSchedules(filter: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<Int32ScheduleOutputDtoListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Schedule/GetSchedules?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchedules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32ScheduleOutputDtoListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32ScheduleOutputDtoListValueTupleIHandleError>;
        }));
    }

    protected processGetSchedules(response: HttpResponseBase): Observable<Int32ScheduleOutputDtoListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32ScheduleOutputDtoListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32ScheduleOutputDtoListValueTupleIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getScheduleByIdForEdit(id: number | null | undefined): Observable<ScheduleOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Schedule/GetScheduleByIdForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScheduleByIdForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScheduleByIdForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleOutputDtoIHandleError>;
        }));
    }

    protected processGetScheduleByIdForEdit(response: HttpResponseBase): Observable<ScheduleOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ScheduleOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleOutputDtoIHandleError>(null as any);
    }
}

@Injectable()
export class SchedulingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param taskId (optional) 
     * @param threadKey (optional) 
     * @return Success
     */
    getSchedulingPill(taskId: number | null | undefined, threadKey: string | null | undefined): Observable<SchedulingPillDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Scheduling/GetSchedulingPill?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (threadKey !== undefined && threadKey !== null)
            url_ += "threadKey=" + encodeURIComponent("" + threadKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchedulingPill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchedulingPill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchedulingPillDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchedulingPillDtoIHandleError>;
        }));
    }

    protected processGetSchedulingPill(response: HttpResponseBase): Observable<SchedulingPillDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SchedulingPillDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SchedulingPillDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    draftSchedulingReply(body: DraftSchedulingReplyInput | null | undefined): Observable<SchedulingDraftDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Scheduling/DraftSchedulingReply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDraftSchedulingReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDraftSchedulingReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchedulingDraftDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchedulingDraftDtoIHandleError>;
        }));
    }

    protected processDraftSchedulingReply(response: HttpResponseBase): Observable<SchedulingDraftDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SchedulingDraftDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SchedulingDraftDtoIHandleError>(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserSignInTokenOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserSignInTokenOutput>;
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserSignInTokenOutput>(null as any);
    }
}

@Injectable()
export class SignalRServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notifyEventChange(body: GetUserAgendaOutput[] | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/SignalR/NotifyEventChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyEventChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyEventChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processNotifyEventChange(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notifyToDosChange(body: GetUserAgendaOutput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/SignalR/NotifyToDosChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyToDosChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyToDosChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processNotifyToDosChange(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notifyAutoCheckout(body: CheckoutDtl | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/SignalR/NotifyAutoCheckout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyAutoCheckout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyAutoCheckout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processNotifyAutoCheckout(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notifyUserCheckout(body: CheckoutDtl | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/SignalR/NotifyUserCheckout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyUserCheckout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyUserCheckout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processNotifyUserCheckout(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notifyContactsImport(body: CurrentUserInput[] | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/SignalR/NotifyContactsImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyContactsImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyContactsImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processNotifyContactsImport(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }
}

@Injectable()
export class StripeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    validateCoupon(input: string | null | undefined): Observable<CouponDetailIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Stripe/ValidateCoupon?";
        if (input !== undefined && input !== null)
            url_ += "Input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateCoupon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateCoupon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CouponDetailIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CouponDetailIHandleError>;
        }));
    }

    protected processValidateCoupon(response: HttpResponseBase): Observable<CouponDetailIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CouponDetailIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CouponDetailIHandleError>(null as any);
    }
}

@Injectable()
export class StripePaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmPayment(body: StripeConfirmPaymentInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/ConfirmPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSubscription(body: StripeCreateSubscriptionInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/CreateSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSubscription(body: StripeUpdateSubscriptionInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/UpdateSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getConfiguration(): Observable<StripeConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StripeConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StripeConfigurationDto>;
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<StripeConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StripeConfigurationDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StripeConfigurationDto>(null as any);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param upgradeEditionId (optional) 
     * @return Success
     */
    upgradeTenantToEquivalentEdition(upgradeEditionId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/UpgradeTenantToEquivalentEdition?";
        if (upgradeEditionId !== undefined && upgradeEditionId !== null)
            url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeTenantToEquivalentEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeTenantToEquivalentEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpgradeTenantToEquivalentEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TaskServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setTaskTemplate(body: SetTaskTemplateDTO | null | undefined): Observable<GetTaskTemplateDTOIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/SetTaskTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTaskTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTaskTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskTemplateDTOIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskTemplateDTOIHandleError>;
        }));
    }

    protected processSetTaskTemplate(response: HttpResponseBase): Observable<GetTaskTemplateDTOIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetTaskTemplateDTOIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskTemplateDTOIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectTemplate(body: ProjectTemplateInput | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateProjectTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCreateProjectTemplate(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectTemplate(body: UpdateProjectTemplateInput | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateProjectTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processUpdateProjectTemplate(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaskTemplate(body: UpdateTaskTemplateInput | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateTaskTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processUpdateTaskTemplate(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param searchText (optional) 
     * @param previewCount (optional) 
     * @return Success
     */
    getProjectTemplateLists(userId: number | null | undefined, tenantId: number | null | undefined, searchText: string | null | undefined, previewCount: number | null | undefined): Observable<Int32TemplateListListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectTemplateLists?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (previewCount !== undefined && previewCount !== null)
            url_ += "PreviewCount=" + encodeURIComponent("" + previewCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectTemplateLists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectTemplateLists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32TemplateListListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32TemplateListListValueTupleIHandleError>;
        }));
    }

    protected processGetProjectTemplateLists(response: HttpResponseBase): Observable<Int32TemplateListListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32TemplateListListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32TemplateListListValueTupleIHandleError>(null as any);
    }

    /**
     * @param templateId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getProjectTemplateDetails(templateId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<ProjectTemplateDetailIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectTemplateDetails?";
        if (templateId !== undefined && templateId !== null)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectTemplateDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectTemplateDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTemplateDetailIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTemplateDetailIHandleError>;
        }));
    }

    protected processGetProjectTemplateDetails(response: HttpResponseBase): Observable<ProjectTemplateDetailIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectTemplateDetailIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectTemplateDetailIHandleError>(null as any);
    }

    /**
     * @param templateId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getTaskTemplateDetails(templateId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<TaskTemplateDetailIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTaskTemplateDetails?";
        if (templateId !== undefined && templateId !== null)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskTemplateDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskTemplateDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskTemplateDetailIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskTemplateDetailIHandleError>;
        }));
    }

    protected processGetTaskTemplateDetails(response: HttpResponseBase): Observable<TaskTemplateDetailIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskTemplateDetailIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskTemplateDetailIHandleError>(null as any);
    }

    /**
     * @param templateId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    deleteProjectTemplate(templateId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/DeleteProjectTemplate?";
        if (templateId !== undefined && templateId !== null)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteProjectTemplate(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectFromTemplate(body: ProjectFromTemplateInput | null | undefined): Observable<ProjectDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateProjectFromTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectFromTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectFromTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDtoIHandleError>;
        }));
    }

    protected processCreateProjectFromTemplate(response: HttpResponseBase): Observable<ProjectDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectLinksFromTemplate(body: ProjectLinksFromTemplateInput | null | undefined): Observable<ProjectLinksFromTemplateResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateProjectLinksFromTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectLinksFromTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectLinksFromTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectLinksFromTemplateResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectLinksFromTemplateResultDtoIHandleError>;
        }));
    }

    protected processCreateProjectLinksFromTemplate(response: HttpResponseBase): Observable<ProjectLinksFromTemplateResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectLinksFromTemplateResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectLinksFromTemplateResultDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param projectId (optional) 
     * @param title (optional) 
     * @param isChanged (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getTaskSuggestedChecklists(taskId: number | null | undefined, projectId: number | null | undefined, title: string | null | undefined, isChanged: boolean | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<SuggestedChecklistOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTaskSuggestedChecklists?";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (isChanged !== undefined && isChanged !== null)
            url_ += "IsChanged=" + encodeURIComponent("" + isChanged) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskSuggestedChecklists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskSuggestedChecklists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuggestedChecklistOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuggestedChecklistOutputDtoListIHandleError>;
        }));
    }

    protected processGetTaskSuggestedChecklists(response: HttpResponseBase): Observable<SuggestedChecklistOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SuggestedChecklistOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SuggestedChecklistOutputDtoListIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param projectId (optional) 
     * @param title (optional) 
     * @param isChanged (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getSimilarTaskChecklists(taskId: number | null | undefined, projectId: number | null | undefined, title: string | null | undefined, isChanged: boolean | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<SuggestedChecklistOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetSimilarTaskChecklists?";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (isChanged !== undefined && isChanged !== null)
            url_ += "IsChanged=" + encodeURIComponent("" + isChanged) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSimilarTaskChecklists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSimilarTaskChecklists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuggestedChecklistOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuggestedChecklistOutputDtoListIHandleError>;
        }));
    }

    protected processGetSimilarTaskChecklists(response: HttpResponseBase): Observable<SuggestedChecklistOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SuggestedChecklistOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SuggestedChecklistOutputDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    aiProjectGeneratedChecklist(body: AiProjectGeneratedChecklist | null | undefined): Observable<AiChecklistOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/AiProjectGeneratedChecklist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAiProjectGeneratedChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAiProjectGeneratedChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiChecklistOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiChecklistOutputListIHandleError>;
        }));
    }

    protected processAiProjectGeneratedChecklist(response: HttpResponseBase): Observable<AiChecklistOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AiChecklistOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AiChecklistOutputListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAiProjectSuggestedTasks(body: CreateSuggestedProjectTasks | null | undefined): Observable<SuggestedProjectTaskOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateAiProjectSuggestedTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAiProjectSuggestedTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAiProjectSuggestedTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuggestedProjectTaskOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuggestedProjectTaskOutputDtoListIHandleError>;
        }));
    }

    protected processCreateAiProjectSuggestedTasks(response: HttpResponseBase): Observable<SuggestedProjectTaskOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SuggestedProjectTaskOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SuggestedProjectTaskOutputDtoListIHandleError>(null as any);
    }

    /**
     * @param projectName (optional) 
     * @param description (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isTasksIntoSections (optional) 
     * @param clientName (optional) 
     * @return Success
     */
    getAiProjectPlan(projectName: string | null | undefined, description: string | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined, isTasksIntoSections: boolean | null | undefined, clientName: string | null | undefined): Observable<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetAiProjectPlan?";
        if (projectName !== undefined && projectName !== null)
            url_ += "ProjectName=" + encodeURIComponent("" + projectName) + "&";
        if (description !== undefined && description !== null)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (isTasksIntoSections !== undefined && isTasksIntoSections !== null)
            url_ += "IsTasksIntoSections=" + encodeURIComponent("" + isTasksIntoSections) + "&";
        if (clientName !== undefined && clientName !== null)
            url_ += "ClientName=" + encodeURIComponent("" + clientName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAiProjectPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAiProjectPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError>;
        }));
    }

    protected processGetAiProjectPlan(response: HttpResponseBase): Observable<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError>(null as any);
    }

    /**
     * @param description (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getAiProjectCustomTask(description: string | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined): Observable<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetAiProjectCustomTask?";
        if (description !== undefined && description !== null)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAiProjectCustomTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAiProjectCustomTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError>;
        }));
    }

    protected processGetAiProjectCustomTask(response: HttpResponseBase): Observable<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getTodoAiSuggestedTasks(): Observable<TodosOnGoingTaskListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTodoAiSuggestedTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodoAiSuggestedTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodoAiSuggestedTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodosOnGoingTaskListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodosOnGoingTaskListIHandleError>;
        }));
    }

    protected processGetTodoAiSuggestedTasks(response: HttpResponseBase): Observable<TodosOnGoingTaskListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TodosOnGoingTaskListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosOnGoingTaskListIHandleError>(null as any);
    }

    /**
     * @param projectName (optional) 
     * @param targetAudience (optional) 
     * @param mainGoal (optional) 
     * @param keyOutcomes (optional) 
     * @return Success
     */
    getAiAssistedProjectNameDesc(projectName: string | null | undefined, targetAudience: string | null | undefined, mainGoal: string | null | undefined, keyOutcomes: string | null | undefined): Observable<GetAiAssistedProjectOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetAiAssistedProjectNameDesc?";
        if (projectName !== undefined && projectName !== null)
            url_ += "ProjectName=" + encodeURIComponent("" + projectName) + "&";
        if (targetAudience !== undefined && targetAudience !== null)
            url_ += "TargetAudience=" + encodeURIComponent("" + targetAudience) + "&";
        if (mainGoal !== undefined && mainGoal !== null)
            url_ += "MainGoal=" + encodeURIComponent("" + mainGoal) + "&";
        if (keyOutcomes !== undefined && keyOutcomes !== null)
            url_ += "KeyOutcomes=" + encodeURIComponent("" + keyOutcomes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAiAssistedProjectNameDesc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAiAssistedProjectNameDesc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAiAssistedProjectOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAiAssistedProjectOutputDtoListIHandleError>;
        }));
    }

    protected processGetAiAssistedProjectNameDesc(response: HttpResponseBase): Observable<GetAiAssistedProjectOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetAiAssistedProjectOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAiAssistedProjectOutputDtoListIHandleError>(null as any);
    }

    /**
     * @param userInput (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isLinkToProject (optional) 
     * @return Success
     */
    getAiMyDayTasks(userInput: string | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined, isLinkToProject: boolean | null | undefined): Observable<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetAiMyDayTasks?";
        if (userInput !== undefined && userInput !== null)
            url_ += "UserInput=" + encodeURIComponent("" + userInput) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (isLinkToProject !== undefined && isLinkToProject !== null)
            url_ += "IsLinkToProject=" + encodeURIComponent("" + isLinkToProject) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAiMyDayTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAiMyDayTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError>;
        }));
    }

    protected processGetAiMyDayTasks(response: HttpResponseBase): Observable<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    aiGrammarChecklist(body: AiGrammarChecklist | null | undefined): Observable<AiChecklistOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/AiGrammarChecklist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAiGrammarChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAiGrammarChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiChecklistOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiChecklistOutputIHandleError>;
        }));
    }

    protected processAiGrammarChecklist(response: HttpResponseBase): Observable<AiChecklistOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AiChecklistOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AiChecklistOutputIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    aiProofreadText(body: ProofreadTextInput | null | undefined): Observable<ProofreadTextOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/AiProofreadText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAiProofreadText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAiProofreadText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProofreadTextOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProofreadTextOutputIHandleError>;
        }));
    }

    protected processAiProofreadText(response: HttpResponseBase): Observable<ProofreadTextOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProofreadTextOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProofreadTextOutputIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    aiOptimizeWordingChecklist(body: AiOptimizeWordingChecklist | null | undefined): Observable<AiChecklistOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/AiOptimizeWordingChecklist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAiOptimizeWordingChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAiOptimizeWordingChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiChecklistOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiChecklistOutputIHandleError>;
        }));
    }

    protected processAiOptimizeWordingChecklist(response: HttpResponseBase): Observable<AiChecklistOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AiChecklistOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AiChecklistOutputIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    aiTaskGenerateDescription(body: AiTaskGenerateDescription | null | undefined): Observable<AiTaskDetailsIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/AiTaskGenerateDescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAiTaskGenerateDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAiTaskGenerateDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiTaskDetailsIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiTaskDetailsIHandleError>;
        }));
    }

    protected processAiTaskGenerateDescription(response: HttpResponseBase): Observable<AiTaskDetailsIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AiTaskDetailsIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AiTaskDetailsIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    aiProjectsHealthScore(body: ProjectListInputDto | null | undefined): Observable<AiProjectsHealthScoreOuputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/AiProjectsHealthScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAiProjectsHealthScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAiProjectsHealthScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiProjectsHealthScoreOuputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiProjectsHealthScoreOuputListIHandleError>;
        }));
    }

    protected processAiProjectsHealthScore(response: HttpResponseBase): Observable<AiProjectsHealthScoreOuputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AiProjectsHealthScoreOuputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AiProjectsHealthScoreOuputListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    aiHealthScoreByProject(projectId: number | null | undefined): Observable<AiProjectsHealthScoreOuputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/AiHealthScoreByProject?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAiHealthScoreByProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAiHealthScoreByProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiProjectsHealthScoreOuputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiProjectsHealthScoreOuputListIHandleError>;
        }));
    }

    protected processAiHealthScoreByProject(response: HttpResponseBase): Observable<AiProjectsHealthScoreOuputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AiProjectsHealthScoreOuputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AiProjectsHealthScoreOuputListIHandleError>(null as any);
    }

    /**
     * @param inputId (optional) 
     * @return Success
     */
    getIdEncrypted(inputId: number | null | undefined): Observable<StringIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetIdEncrypted?";
        if (inputId !== undefined && inputId !== null)
            url_ += "inputId=" + encodeURIComponent("" + inputId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdEncrypted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdEncrypted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringIHandleError>;
        }));
    }

    protected processGetIdEncrypted(response: HttpResponseBase): Observable<StringIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StringIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringIHandleError>(null as any);
    }

    /**
     * @param inputId (optional) 
     * @return Success
     */
    getIdDecrypted(inputId: string | null | undefined): Observable<StringIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetIdDecrypted?";
        if (inputId !== undefined && inputId !== null)
            url_ += "inputId=" + encodeURIComponent("" + inputId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdDecrypted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdDecrypted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringIHandleError>;
        }));
    }

    protected processGetIdDecrypted(response: HttpResponseBase): Observable<StringIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StringIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTaskWithRecurrenceSeries(body: CreateTaskAndRecurrenceSeriesInput | null | undefined): Observable<CreateTaskWithRecurrenceSeriesOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateTaskWithRecurrenceSeries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTaskWithRecurrenceSeries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTaskWithRecurrenceSeries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTaskWithRecurrenceSeriesOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTaskWithRecurrenceSeriesOutputIHandleError>;
        }));
    }

    protected processCreateTaskWithRecurrenceSeries(response: HttpResponseBase): Observable<CreateTaskWithRecurrenceSeriesOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateTaskWithRecurrenceSeriesOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateTaskWithRecurrenceSeriesOutputIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMyDaySectionTaskWithRecurrenceSeries(body: CreateMyDayTaskAndRecurrenceSeriesInput | null | undefined): Observable<CreateTaskWithRecurrenceSeriesOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateMyDaySectionTaskWithRecurrenceSeries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMyDaySectionTaskWithRecurrenceSeries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMyDaySectionTaskWithRecurrenceSeries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTaskWithRecurrenceSeriesOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTaskWithRecurrenceSeriesOutputIHandleError>;
        }));
    }

    protected processCreateMyDaySectionTaskWithRecurrenceSeries(response: HttpResponseBase): Observable<CreateTaskWithRecurrenceSeriesOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateTaskWithRecurrenceSeriesOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateTaskWithRecurrenceSeriesOutputIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRecurrenceSeries(body: CreateRecurrenceSeriesInputDto | null | undefined): Observable<CreateRecurrenceSeriesOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateRecurrenceSeries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRecurrenceSeries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRecurrenceSeries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateRecurrenceSeriesOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateRecurrenceSeriesOutputDtoIHandleError>;
        }));
    }

    protected processCreateRecurrenceSeries(response: HttpResponseBase): Observable<CreateRecurrenceSeriesOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateRecurrenceSeriesOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateRecurrenceSeriesOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRecurrenceSeries(body: UpdateRecurrenceSeriesInputDto | null | undefined): Observable<UpdateRecurrenceSeriesOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateRecurrenceSeries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRecurrenceSeries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRecurrenceSeries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateRecurrenceSeriesOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateRecurrenceSeriesOutputDtoIHandleError>;
        }));
    }

    protected processUpdateRecurrenceSeries(response: HttpResponseBase): Observable<UpdateRecurrenceSeriesOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UpdateRecurrenceSeriesOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateRecurrenceSeriesOutputDtoIHandleError>(null as any);
    }

    /**
     * @param seriesId (optional) 
     * @return Success
     */
    stopRecurrenceSeries(seriesId: number | null | undefined): Observable<StopRecurrenceSeriesOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/StopRecurrenceSeries?";
        if (seriesId !== undefined && seriesId !== null)
            url_ += "seriesId=" + encodeURIComponent("" + seriesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStopRecurrenceSeries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopRecurrenceSeries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StopRecurrenceSeriesOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StopRecurrenceSeriesOutputDtoIHandleError>;
        }));
    }

    protected processStopRecurrenceSeries(response: HttpResponseBase): Observable<StopRecurrenceSeriesOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StopRecurrenceSeriesOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StopRecurrenceSeriesOutputDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getRecurrenceDetails(taskId: number | null | undefined): Observable<GetRecurrenceDetailsOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetRecurrenceDetails?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecurrenceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecurrenceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecurrenceDetailsOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecurrenceDetailsOutputDtoIHandleError>;
        }));
    }

    protected processGetRecurrenceDetails(response: HttpResponseBase): Observable<GetRecurrenceDetailsOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetRecurrenceDetailsOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRecurrenceDetailsOutputDtoIHandleError>(null as any);
    }

    /**
     * @param seriesId (optional) 
     * @param includeDeleted (optional) 
     * @return Success
     */
    getSeriesInstances(seriesId: number | null | undefined, includeDeleted: boolean | null | undefined): Observable<GetSeriesInstancesOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetSeriesInstances?";
        if (seriesId !== undefined && seriesId !== null)
            url_ += "seriesId=" + encodeURIComponent("" + seriesId) + "&";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeriesInstances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeriesInstances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeriesInstancesOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeriesInstancesOutputDtoIHandleError>;
        }));
    }

    protected processGetSeriesInstances(response: HttpResponseBase): Observable<GetSeriesInstancesOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetSeriesInstancesOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSeriesInstancesOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUpcomingOccurrences(body: GetUpcomingOccurrencesInputDto | null | undefined): Observable<GetUpcomingOccurrencesOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetUpcomingOccurrences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpcomingOccurrences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpcomingOccurrences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUpcomingOccurrencesOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUpcomingOccurrencesOutputDtoIHandleError>;
        }));
    }

    protected processGetUpcomingOccurrences(response: HttpResponseBase): Observable<GetUpcomingOccurrencesOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetUpcomingOccurrencesOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUpcomingOccurrencesOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateSeriesInstances(body: GenerateSeriesInstancesInputDto | null | undefined): Observable<GenerateSeriesInstancesOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GenerateSeriesInstances";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateSeriesInstances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateSeriesInstances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateSeriesInstancesOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateSeriesInstancesOutputDtoIHandleError>;
        }));
    }

    protected processGenerateSeriesInstances(response: HttpResponseBase): Observable<GenerateSeriesInstancesOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GenerateSeriesInstancesOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenerateSeriesInstancesOutputDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTaskSeries(taskId: number | null | undefined): Observable<GetTaskSeriesOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTaskSeries?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskSeries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskSeries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskSeriesOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskSeriesOutputDtoIHandleError>;
        }));
    }

    protected processGetTaskSeries(response: HttpResponseBase): Observable<GetTaskSeriesOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetTaskSeriesOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskSeriesOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateRecurrenceRule(body: ValidateRecurrenceRuleInputDto | null | undefined): Observable<ValidateRecurrenceRuleOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/ValidateRecurrenceRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateRecurrenceRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateRecurrenceRule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateRecurrenceRuleOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateRecurrenceRuleOutputDtoIHandleError>;
        }));
    }

    protected processValidateRecurrenceRule(response: HttpResponseBase): Observable<ValidateRecurrenceRuleOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ValidateRecurrenceRuleOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidateRecurrenceRuleOutputDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getSeriesInstanceByTaskId(taskId: number | null | undefined): Observable<GetTaskSeriesOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetSeriesInstanceByTaskId?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeriesInstanceByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeriesInstanceByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskSeriesOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskSeriesOutputDtoIHandleError>;
        }));
    }

    protected processGetSeriesInstanceByTaskId(response: HttpResponseBase): Observable<GetTaskSeriesOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetTaskSeriesOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskSeriesOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendSignalR(body: SendSignalRInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/SendSignalR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSignalR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSignalR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSendSignalR(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendSignalRForProject(body: ProjectDetailOutputDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/SendSignalRForProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSignalRForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSignalRForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSendSignalRForProject(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param parentTaskId (optional) 
     * @return Success
     */
    getDependentTasks(parentTaskId: number | null | undefined): Observable<GetDependentTaskOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetDependentTasks?";
        if (parentTaskId !== undefined && parentTaskId !== null)
            url_ += "ParentTaskId=" + encodeURIComponent("" + parentTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDependentTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDependentTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDependentTaskOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDependentTaskOutputDtoListIHandleError>;
        }));
    }

    protected processGetDependentTasks(response: HttpResponseBase): Observable<GetDependentTaskOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetDependentTaskOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDependentTaskOutputDtoListIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTaskBlockers(taskId: number | null | undefined): Observable<TaskBlockerDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTaskBlockers?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskBlockers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskBlockers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskBlockerDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskBlockerDtoListIHandleError>;
        }));
    }

    protected processGetTaskBlockers(response: HttpResponseBase): Observable<TaskBlockerDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskBlockerDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskBlockerDtoListIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTaskBlockedBy(taskId: number | null | undefined): Observable<TaskBlockedByDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTaskBlockedBy?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskBlockedBy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskBlockedBy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskBlockedByDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskBlockedByDtoListIHandleError>;
        }));
    }

    protected processGetTaskBlockedBy(response: HttpResponseBase): Observable<TaskBlockedByDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskBlockedByDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskBlockedByDtoListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getProjectDependencyEdges(projectId: number | null | undefined): Observable<ProjectDependencyEdgeDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectDependencyEdges?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDependencyEdges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDependencyEdges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDependencyEdgeDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDependencyEdgeDtoListIHandleError>;
        }));
    }

    protected processGetProjectDependencyEdges(response: HttpResponseBase): Observable<ProjectDependencyEdgeDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectDependencyEdgeDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDependencyEdgeDtoListIHandleError>(null as any);
    }

    /**
     * @param blockedTaskId (optional) 
     * @param blockerTaskId (optional) 
     * @param startDelay (optional) 
     * @param sortOrder (optional) 
     * @return Success
     */
    linkBlocker(blockedTaskId: number | null | undefined, blockerTaskId: number | null | undefined, startDelay: number | null | undefined, sortOrder: number | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/LinkBlocker?";
        if (blockedTaskId !== undefined && blockedTaskId !== null)
            url_ += "blockedTaskId=" + encodeURIComponent("" + blockedTaskId) + "&";
        if (blockerTaskId !== undefined && blockerTaskId !== null)
            url_ += "blockerTaskId=" + encodeURIComponent("" + blockerTaskId) + "&";
        if (startDelay !== undefined && startDelay !== null)
            url_ += "startDelay=" + encodeURIComponent("" + startDelay) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkBlocker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkBlocker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processLinkBlocker(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param dependencyId (optional) 
     * @return Success
     */
    unlinkBlocker(dependencyId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UnlinkBlocker?";
        if (dependencyId !== undefined && dependencyId !== null)
            url_ += "dependencyId=" + encodeURIComponent("" + dependencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkBlocker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkBlocker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUnlinkBlocker(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param taskId (optional) 
     * @param mode (optional) 
     * @return Success
     */
    getProjectTasksLinkable(projectId: number | null | undefined, taskId: number | null | undefined, mode: string | null | undefined): Observable<ProjectTasksDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectTasksLinkable?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (mode !== undefined && mode !== null)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectTasksLinkable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectTasksLinkable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTasksDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTasksDtoListIHandleError>;
        }));
    }

    protected processGetProjectTasksLinkable(response: HttpResponseBase): Observable<ProjectTasksDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectTasksDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectTasksDtoListIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    unlinkChildTask(taskId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UnlinkChildTask?";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkChildTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkChildTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUnlinkChildTask(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDependentTask(body: DependentTaskEditDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateDependentTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDependentTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDependentTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateDependentTask(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param taskId (optional) 
     * @return Success
     */
    getTasksToLink(searchText: string | null | undefined, taskId: number | null | undefined): Observable<GlobalSearchOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTasksToLink?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasksToLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasksToLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSearchOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSearchOutputDtoListIHandleError>;
        }));
    }

    protected processGetTasksToLink(response: HttpResponseBase): Observable<GlobalSearchOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GlobalSearchOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlobalSearchOutputDtoListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param taskId (optional) 
     * @param mode (optional) 
     * @return Success
     */
    getProjectTasksToLink(projectId: number | null | undefined, taskId: number | null | undefined, mode: string | null | undefined): Observable<ProjectTasksDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectTasksToLink?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (mode !== undefined && mode !== null)
            url_ += "Mode=" + encodeURIComponent("" + mode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectTasksToLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectTasksToLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTasksDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTasksDtoListIHandleError>;
        }));
    }

    protected processGetProjectTasksToLink(response: HttpResponseBase): Observable<ProjectTasksDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectTasksDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectTasksDtoListIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return Success
     */
    assignTasksToUser(userId: number | null | undefined, body: number[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/AssignTasksToUser?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignTasksToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignTasksToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAssignTasksToUser(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    undoMultipleTasksAssign(body: number[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UndoMultipleTasksAssign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoMultipleTasksAssign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoMultipleTasksAssign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUndoMultipleTasksAssign(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignProjectToTasks(body: TaskProjectSectionDto[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/AssignProjectToTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignProjectToTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignProjectToTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAssignProjectToTasks(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaskDates(body: UpdateTaskDatesDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateTaskDates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateTaskDates(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    undoMultipleTasksDateUpdate(body: UndoMultipleTasksDateUpdateDto[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UndoMultipleTasksDateUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoMultipleTasksDateUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoMultipleTasksDateUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUndoMultipleTasksDateUpdate(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMultipleTasksTags(body: MultipleTasksTagDto[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateMultipleTasksTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMultipleTasksTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMultipleTasksTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateMultipleTasksTags(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    undoMultipleTasksTag(body: MultipleTasksTagDto[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UndoMultipleTasksTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoMultipleTasksTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoMultipleTasksTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUndoMultipleTasksTag(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteTasks(body: DeleteTasksInput | null | undefined): Observable<DeleteTasksResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/DeleteTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteTasksResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteTasksResultDtoIHandleError>;
        }));
    }

    protected processDeleteTasks(response: HttpResponseBase): Observable<DeleteTasksResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DeleteTasksResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteTasksResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTasksAssociations(body: UpdateTasksAssociationsInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateTasksAssociations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTasksAssociations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTasksAssociations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateTasksAssociations(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param startDate (optional) 
     * @param body (optional) 
     * @return Success
     */
    moveTodoTasksToUsersDay(userId: number | null | undefined, startDate: string | null | undefined, body: number[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/MoveTodoTasksToUsersDay?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTodoTasksToUsersDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTodoTasksToUsersDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMoveTodoTasksToUsersDay(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMultipleTasks(body: CreateMultipleTasksInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateMultipleTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMultipleTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultipleTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateMultipleTasks(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param isInActive (optional) 
     * @param isOverdue (optional) 
     * @param searchText (optional) 
     * @param filterCompanyIds (optional) 
     * @param filterPersonIds (optional) 
     * @param filterProjManagerIds (optional) 
     * @param filterProjStageIds (optional) 
     * @param includeProjWithoutStages (optional) 
     * @param filterDueDate (optional) 
     * @param filterStartDate (optional) 
     * @param filterHealthScore (optional) 
     * @param includeManagers (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getProjectLists(isActive: boolean | null | undefined, isInActive: boolean | null | undefined, isOverdue: boolean | null | undefined, searchText: string | null | undefined, filterCompanyIds: number[] | null | undefined, filterPersonIds: number[] | null | undefined, filterProjManagerIds: number[] | null | undefined, filterProjStageIds: number[] | null | undefined, includeProjWithoutStages: boolean | null | undefined, filterDueDate: number | null | undefined, filterStartDate: number | null | undefined, filterHealthScore: number | null | undefined, includeManagers: boolean | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<ProjectListDtoListProjectCountsListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectLists?";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isInActive !== undefined && isInActive !== null)
            url_ += "IsInActive=" + encodeURIComponent("" + isInActive) + "&";
        if (isOverdue !== undefined && isOverdue !== null)
            url_ += "IsOverdue=" + encodeURIComponent("" + isOverdue) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (filterCompanyIds !== undefined && filterCompanyIds !== null)
            filterCompanyIds && filterCompanyIds.forEach(item => { url_ += "FilterCompanyIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterPersonIds !== undefined && filterPersonIds !== null)
            filterPersonIds && filterPersonIds.forEach(item => { url_ += "FilterPersonIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterProjManagerIds !== undefined && filterProjManagerIds !== null)
            filterProjManagerIds && filterProjManagerIds.forEach(item => { url_ += "FilterProjManagerIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterProjStageIds !== undefined && filterProjStageIds !== null)
            filterProjStageIds && filterProjStageIds.forEach(item => { url_ += "FilterProjStageIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeProjWithoutStages !== undefined && includeProjWithoutStages !== null)
            url_ += "IncludeProjWithoutStages=" + encodeURIComponent("" + includeProjWithoutStages) + "&";
        if (filterDueDate !== undefined && filterDueDate !== null)
            url_ += "FilterDueDate=" + encodeURIComponent("" + filterDueDate) + "&";
        if (filterStartDate !== undefined && filterStartDate !== null)
            url_ += "FilterStartDate=" + encodeURIComponent("" + filterStartDate) + "&";
        if (filterHealthScore !== undefined && filterHealthScore !== null)
            url_ += "FilterHealthScore=" + encodeURIComponent("" + filterHealthScore) + "&";
        if (includeManagers !== undefined && includeManagers !== null)
            url_ += "IncludeManagers=" + encodeURIComponent("" + includeManagers) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectLists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectLists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectListDtoListProjectCountsListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectListDtoListProjectCountsListValueTupleIHandleError>;
        }));
    }

    protected processGetProjectLists(response: HttpResponseBase): Observable<ProjectListDtoListProjectCountsListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectListDtoListProjectCountsListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectListDtoListProjectCountsListValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProject(body: CreateProjectInputDto | null | undefined): Observable<ProjectDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDtoIHandleError>;
        }));
    }

    protected processCreateProject(response: HttpResponseBase): Observable<ProjectDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateProject(body: ProjectDto | null | undefined): Observable<ProjectDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateOrUpdateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDtoIHandleError>;
        }));
    }

    protected processCreateOrUpdateProject(response: HttpResponseBase): Observable<ProjectDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectWithMembers(body: ProjectDto | null | undefined): Observable<ProjectDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateProjectWithMembers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectWithMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectWithMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDtoIHandleError>;
        }));
    }

    protected processCreateProjectWithMembers(response: HttpResponseBase): Observable<ProjectDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateProjectMembers(body: CreateUpdateProjMemberInput | null | undefined): Observable<ProjectMembersListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateOrUpdateProjectMembers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateProjectMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateProjectMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectMembersListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectMembersListIHandleError>;
        }));
    }

    protected processCreateOrUpdateProjectMembers(response: HttpResponseBase): Observable<ProjectMembersListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectMembersListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectMembersListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param code (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getProjectSection(projectId: number | null | undefined, code: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<ProjectDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectSection?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDtoIHandleError>;
        }));
    }

    protected processGetProjectSection(response: HttpResponseBase): Observable<ProjectDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateProjectSection(body: CreateProjectSectionDto | null | undefined): Observable<ProjectDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateOrUpdateProjectSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateProjectSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateProjectSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDtoIHandleError>;
        }));
    }

    protected processCreateOrUpdateProjectSection(response: HttpResponseBase): Observable<ProjectDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectSection(body: ProjectSectionDto | null | undefined): Observable<SectionDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateProjectSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SectionDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SectionDtoIHandleError>;
        }));
    }

    protected processCreateProjectSection(response: HttpResponseBase): Observable<SectionDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SectionDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SectionDtoIHandleError>(null as any);
    }

    /**
     * @param sectionId (optional) 
     * @param sectionName (optional) 
     * @param bgColor (optional) 
     * @param tasksInJson (optional) 
     * @param agendaType (optional) 
     * @param sortOrder (optional) 
     * @param isHide (optional) 
     * @param isEditing (optional) 
     * @param isExpanded (optional) 
     * @param totalCompetedTasks (optional) 
     * @param totalInCompetedTasks (optional) 
     * @param tasks (optional) 
     * @param requireProjectDetails (optional) 
     * @param projectId (optional) 
     * @param projectName (optional) 
     * @param dueDate (optional) 
     * @param startDate (optional) 
     * @param projectProgress (optional) 
     * @param code (optional) 
     * @param pinnedEntityId (optional) 
     * @param isPrivate (optional) 
     * @param isSuggestAiTasks (optional) 
     * @param companyId (optional) 
     * @param companyName (optional) 
     * @param associationId (optional) 
     * @param associationName (optional) 
     * @param healthScore (optional) 
     * @param scoreExplanation (optional) 
     * @param scoreLastUpdated (optional) 
     * @param statusId (optional) 
     * @param projectStageId (optional) 
     * @param projectSectionText (optional) 
     * @param projectSections (optional) 
     * @param projectMembersAsJson (optional) 
     * @param projectMembers (optional) 
     * @param description (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    deleteProjectSection(sectionId: number | null | undefined, sectionName: string | null | undefined, bgColor: string | null | undefined, tasksInJson: string | null | undefined, agendaType: number | null | undefined, sortOrder: number | null | undefined, isHide: boolean | null | undefined, isEditing: boolean | null | undefined, isExpanded: boolean | null | undefined, totalCompetedTasks: number | null | undefined, totalInCompetedTasks: number | null | undefined, tasks: GetUserTasks[] | null | undefined, requireProjectDetails: boolean | null | undefined, projectId: number | null | undefined, projectName: string | null | undefined, dueDate: string | null | undefined, startDate: string | null | undefined, projectProgress: number | null | undefined, code: number | null | undefined, pinnedEntityId: number | null | undefined, isPrivate: boolean | null | undefined, isSuggestAiTasks: boolean | null | undefined, companyId: number | null | undefined, companyName: string | null | undefined, associationId: number | null | undefined, associationName: string | null | undefined, healthScore: number | null | undefined, scoreExplanation: string | null | undefined, scoreLastUpdated: string | null | undefined, statusId: number | null | undefined, projectStageId: number | null | undefined, projectSectionText: string | null | undefined, projectSections: ProjectSectionDto[] | null | undefined, projectMembersAsJson: string | null | undefined, projectMembers: ProjectMembers[] | null | undefined, description: string | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<ProjectDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/DeleteProjectSection?";
        if (sectionId !== undefined && sectionId !== null)
            url_ += "SectionId=" + encodeURIComponent("" + sectionId) + "&";
        if (sectionName !== undefined && sectionName !== null)
            url_ += "SectionName=" + encodeURIComponent("" + sectionName) + "&";
        if (bgColor !== undefined && bgColor !== null)
            url_ += "BgColor=" + encodeURIComponent("" + bgColor) + "&";
        if (tasksInJson !== undefined && tasksInJson !== null)
            url_ += "TasksInJson=" + encodeURIComponent("" + tasksInJson) + "&";
        if (agendaType !== undefined && agendaType !== null)
            url_ += "AgendaType=" + encodeURIComponent("" + agendaType) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (isHide !== undefined && isHide !== null)
            url_ += "IsHide=" + encodeURIComponent("" + isHide) + "&";
        if (isEditing !== undefined && isEditing !== null)
            url_ += "IsEditing=" + encodeURIComponent("" + isEditing) + "&";
        if (isExpanded !== undefined && isExpanded !== null)
            url_ += "IsExpanded=" + encodeURIComponent("" + isExpanded) + "&";
        if (totalCompetedTasks !== undefined && totalCompetedTasks !== null)
            url_ += "TotalCompetedTasks=" + encodeURIComponent("" + totalCompetedTasks) + "&";
        if (totalInCompetedTasks !== undefined && totalInCompetedTasks !== null)
            url_ += "TotalInCompetedTasks=" + encodeURIComponent("" + totalInCompetedTasks) + "&";
        if (tasks !== undefined && tasks !== null)
            tasks && tasks.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Tasks[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (requireProjectDetails !== undefined && requireProjectDetails !== null)
            url_ += "RequireProjectDetails=" + encodeURIComponent("" + requireProjectDetails) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (projectName !== undefined && projectName !== null)
            url_ += "ProjectName=" + encodeURIComponent("" + projectName) + "&";
        if (dueDate !== undefined && dueDate !== null)
            url_ += "DueDate=" + encodeURIComponent("" + dueDate) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (projectProgress !== undefined && projectProgress !== null)
            url_ += "ProjectProgress=" + encodeURIComponent("" + projectProgress) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (pinnedEntityId !== undefined && pinnedEntityId !== null)
            url_ += "PinnedEntityId=" + encodeURIComponent("" + pinnedEntityId) + "&";
        if (isPrivate !== undefined && isPrivate !== null)
            url_ += "IsPrivate=" + encodeURIComponent("" + isPrivate) + "&";
        if (isSuggestAiTasks !== undefined && isSuggestAiTasks !== null)
            url_ += "IsSuggestAiTasks=" + encodeURIComponent("" + isSuggestAiTasks) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (companyName !== undefined && companyName !== null)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&";
        if (associationId !== undefined && associationId !== null)
            url_ += "AssociationId=" + encodeURIComponent("" + associationId) + "&";
        if (associationName !== undefined && associationName !== null)
            url_ += "AssociationName=" + encodeURIComponent("" + associationName) + "&";
        if (healthScore !== undefined && healthScore !== null)
            url_ += "HealthScore=" + encodeURIComponent("" + healthScore) + "&";
        if (scoreExplanation !== undefined && scoreExplanation !== null)
            url_ += "ScoreExplanation=" + encodeURIComponent("" + scoreExplanation) + "&";
        if (scoreLastUpdated !== undefined && scoreLastUpdated !== null)
            url_ += "ScoreLastUpdated=" + encodeURIComponent("" + scoreLastUpdated) + "&";
        if (statusId !== undefined && statusId !== null)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (projectStageId !== undefined && projectStageId !== null)
            url_ += "ProjectStageId=" + encodeURIComponent("" + projectStageId) + "&";
        if (projectSectionText !== undefined && projectSectionText !== null)
            url_ += "ProjectSectionText=" + encodeURIComponent("" + projectSectionText) + "&";
        if (projectSections !== undefined && projectSections !== null)
            projectSections && projectSections.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "ProjectSections[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (projectMembersAsJson !== undefined && projectMembersAsJson !== null)
            url_ += "ProjectMembersAsJson=" + encodeURIComponent("" + projectMembersAsJson) + "&";
        if (projectMembers !== undefined && projectMembers !== null)
            projectMembers && projectMembers.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "ProjectMembers[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (description !== undefined && description !== null)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDtoIHandleError>;
        }));
    }

    protected processDeleteProjectSection(response: HttpResponseBase): Observable<ProjectDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDtoIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getProjectStatus(userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<ProjectStatusOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectStatus?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatusOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatusOutputListIHandleError>;
        }));
    }

    protected processGetProjectStatus(response: HttpResponseBase): Observable<ProjectStatusOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectStatusOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectStatusOutputListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param code (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getProjectDetails(projectId: number | null | undefined, code: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<ProjectDetailOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectDetails?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDetailOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDetailOutputDtoIHandleError>;
        }));
    }

    protected processGetProjectDetails(response: HttpResponseBase): Observable<ProjectDetailOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectDetailOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDetailOutputDtoIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    invalidateProjectDetailCache(projectId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Task/InvalidateProjectDetailCache?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvalidateProjectDetailCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvalidateProjectDetailCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInvalidateProjectDetailCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllProjectsDetailsIncompletedTasks(): Observable<ProjectTasksFlatDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetAllProjectsDetailsIncompletedTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectsDetailsIncompletedTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectsDetailsIncompletedTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTasksFlatDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTasksFlatDtoListIHandleError>;
        }));
    }

    protected processGetAllProjectsDetailsIncompletedTasks(response: HttpResponseBase): Observable<ProjectTasksFlatDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectTasksFlatDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectTasksFlatDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeAssignee(body: ChangeAssigneeBulkInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/ChangeAssignee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeAssignee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeAssignee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processChangeAssignee(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePriority(body: SetPriorityBulkInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/ChangePriority";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePriority(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePriority(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processChangePriority(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDates(body: SetDateBulkInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateDates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateDates(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    undoCascadeShift(body: CascadeShiftResult[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UndoCascadeShift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoCascadeShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoCascadeShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUndoCascadeShift(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveToProject(body: MoveToProjectBulkInput | null | undefined): Observable<MoveToProjectResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/MoveToProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveToProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveToProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveToProjectResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveToProjectResultDtoIHandleError>;
        }));
    }

    protected processMoveToProject(response: HttpResponseBase): Observable<MoveToProjectResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MoveToProjectResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MoveToProjectResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markCompleted(body: MarkCompleteBulkInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/MarkCompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMarkCompleted(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param sectionId (optional) 
     * @param code (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getProjectDetails_New(projectId: number | null | undefined, sectionId: number | null | undefined, code: number | null | undefined, skip: number | null | undefined, take: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<ProjectDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectDetails_New?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (sectionId !== undefined && sectionId !== null)
            url_ += "SectionId=" + encodeURIComponent("" + sectionId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDetails_New(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDetails_New(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDtoIHandleError>;
        }));
    }

    protected processGetProjectDetails_New(response: HttpResponseBase): Observable<ProjectDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDtoIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    exportProjectDetails(projectId: number | null | undefined): Observable<FileDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/ExportProjectDetails?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProjectDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProjectDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDtoIHandleError>;
        }));
    }

    protected processExportProjectDetails(response: HttpResponseBase): Observable<FileDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = FileDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDtoIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param code (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getAllTaskAssigneesByProject(projectId: number | null | undefined, code: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<ProjectMembersListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetAllTaskAssigneesByProject?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTaskAssigneesByProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaskAssigneesByProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectMembersListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectMembersListIHandleError>;
        }));
    }

    protected processGetAllTaskAssigneesByProject(response: HttpResponseBase): Observable<ProjectMembersListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectMembersListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectMembersListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markActiveInActiveProject(body: ProjectInputDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/MarkActiveInActiveProjectAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkActiveInActiveProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkActiveInActiveProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMarkActiveInActiveProject(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param code (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    deleteProject(projectId: number | null | undefined, code: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/DeleteProjectAsync?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteProject(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param code (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getProjectTasks(projectId: number | null | undefined, code: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<GetUserTasksListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectTasks?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserTasksListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserTasksListIHandleError>;
        }));
    }

    protected processGetProjectTasks(response: HttpResponseBase): Observable<GetUserTasksListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetUserTasksListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserTasksListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyProject(body: EntityDto | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CopyProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCopyProject(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateProjectTag(body: ProjectTagInputDto | null | undefined): Observable<ProjectTagDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateUpdateProjectTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateProjectTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateProjectTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTagDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTagDtoListIHandleError>;
        }));
    }

    protected processCreateUpdateProjectTag(response: HttpResponseBase): Observable<ProjectTagDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectTagDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectTagDtoListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getProjectTag(projectId: number | null | undefined): Observable<ProjectTagDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectTag?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTagDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTagDtoListIHandleError>;
        }));
    }

    protected processGetProjectTag(response: HttpResponseBase): Observable<ProjectTagDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectTagDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectTagDtoListIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @param userId (optional) 
     * @return Success
     */
    deleteProjectTag(id: number | null | undefined, userId: number | null | undefined): Observable<ProjectTagDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/DeleteProjectTag?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTagDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTagDtoListIHandleError>;
        }));
    }

    protected processDeleteProjectTag(response: HttpResponseBase): Observable<ProjectTagDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectTagDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectTagDtoListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param code (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getProjectProgress(projectId: number | null | undefined, code: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<ProjectProgressOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectProgress?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectProgressOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectProgressOutputDtoIHandleError>;
        }));
    }

    protected processGetProjectProgress(response: HttpResponseBase): Observable<ProjectProgressOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectProgressOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectProgressOutputDtoIHandleError>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getProjectSuggestedTasks(input: number | null | undefined): Observable<SuggestedProjectTaskOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectSuggestedTasks?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectSuggestedTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectSuggestedTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuggestedProjectTaskOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuggestedProjectTaskOutputDtoListIHandleError>;
        }));
    }

    protected processGetProjectSuggestedTasks(response: HttpResponseBase): Observable<SuggestedProjectTaskOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SuggestedProjectTaskOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SuggestedProjectTaskOutputDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectTaskFromSuggested(body: AddSuggestedTaskToProjectInputDto | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateProjectTaskFromSuggested";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectTaskFromSuggested(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectTaskFromSuggested(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processCreateProjectTaskFromSuggested(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyProjectWithOptions(body: CopyProjectInputDto | null | undefined): Observable<CopyProjectOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CopyProjectWithOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyProjectWithOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyProjectWithOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CopyProjectOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CopyProjectOutputDtoIHandleError>;
        }));
    }

    protected processCopyProjectWithOptions(response: HttpResponseBase): Observable<CopyProjectOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CopyProjectOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CopyProjectOutputDtoIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getProjectMembers(projectId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<ProjectMembersListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectMembers?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectMembersListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectMembersListIHandleError>;
        }));
    }

    protected processGetProjectMembers(response: HttpResponseBase): Observable<ProjectMembersListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectMembersListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectMembersListIHandleError>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getTenantProjectManagers(tenantId: number | null | undefined, statusFilter: number | null | undefined): Observable<ProjectMembersListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTenantProjectManagers?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantProjectManagers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantProjectManagers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectMembersListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectMembersListIHandleError>;
        }));
    }

    protected processGetTenantProjectManagers(response: HttpResponseBase): Observable<ProjectMembersListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectMembersListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectMembersListIHandleError>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getTenantProjectClients(tenantId: number | null | undefined, statusFilter: number | null | undefined): Observable<ProjectAssociationDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTenantProjectClients?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantProjectClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantProjectClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectAssociationDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectAssociationDtoListIHandleError>;
        }));
    }

    protected processGetTenantProjectClients(response: HttpResponseBase): Observable<ProjectAssociationDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectAssociationDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectAssociationDtoListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param associationType (optional) 
     * @return Success
     */
    getProjectAssociations(projectId: number | null | undefined, associationType: any | null | undefined): Observable<ProjectAssociationDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectAssociations?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (associationType !== undefined && associationType !== null)
            url_ += "AssociationType=" + encodeURIComponent("" + associationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectAssociations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectAssociations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectAssociationDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectAssociationDtoListIHandleError>;
        }));
    }

    protected processGetProjectAssociations(response: HttpResponseBase): Observable<ProjectAssociationDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectAssociationDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectAssociationDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateProjectAssociation(body: ProjectAssociationInputDto | null | undefined): Observable<ProjectAssociationDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateUpdateProjectAssociation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateProjectAssociation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateProjectAssociation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectAssociationDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectAssociationDtoListIHandleError>;
        }));
    }

    protected processCreateUpdateProjectAssociation(response: HttpResponseBase): Observable<ProjectAssociationDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectAssociationDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectAssociationDtoListIHandleError>(null as any);
    }

    /**
     * @param proAssoIds (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    deleteProjectAssociation(proAssoIds: number[] | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/DeleteProjectAssociation?";
        if (proAssoIds !== undefined && proAssoIds !== null)
            proAssoIds && proAssoIds.forEach(item => { url_ += "ProAssoIds=" + encodeURIComponent("" + item) + "&"; });
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectAssociation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectAssociation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteProjectAssociation(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getProjectSampleDescription(): Observable<ProjectSampleDescDtoListSampleTitleDescriptionListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectSampleDescription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectSampleDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectSampleDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectSampleDescDtoListSampleTitleDescriptionListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectSampleDescDtoListSampleTitleDescriptionListValueTupleIHandleError>;
        }));
    }

    protected processGetProjectSampleDescription(response: HttpResponseBase): Observable<ProjectSampleDescDtoListSampleTitleDescriptionListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectSampleDescDtoListSampleTitleDescriptionListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectSampleDescDtoListSampleTitleDescriptionListValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectBulkSectionTask(body: CreateProjectBulkSectionTaskInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateProjectBulkSectionTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectBulkSectionTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectBulkSectionTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateProjectBulkSectionTask(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getProjectChecklists(projectId: number | null | undefined): Observable<ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectChecklists?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectChecklists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectChecklists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError>;
        }));
    }

    protected processGetProjectChecklists(response: HttpResponseBase): Observable<ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateProjectChecklists(body: CreateUpdateProjectChecklists | null | undefined): Observable<ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateUpdateProjectChecklists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateProjectChecklists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateProjectChecklists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError>;
        }));
    }

    protected processCreateUpdateProjectChecklists(response: HttpResponseBase): Observable<ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMultipleProjectChecklists(body: CreateMultipleProjectChecklists | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateMultipleProjectChecklists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMultipleProjectChecklists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultipleProjectChecklists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateMultipleProjectChecklists(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param checklistId (optional) 
     * @return Success
     */
    deleteProjectChecklist(checklistId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/DeleteProjectChecklist?";
        if (checklistId !== undefined && checklistId !== null)
            url_ += "ChecklistId=" + encodeURIComponent("" + checklistId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteProjectChecklist(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param isAutoAdd (optional) 
     * @return Success
     */
    markProjectChecklistAutoAdd(projectId: number | null | undefined, isAutoAdd: boolean | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/MarkProjectChecklistAutoAdd?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (isAutoAdd !== undefined && isAutoAdd !== null)
            url_ += "IsAutoAdd=" + encodeURIComponent("" + isAutoAdd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkProjectChecklistAutoAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkProjectChecklistAutoAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processMarkProjectChecklistAutoAdd(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateRole(body: CreateUpdateRoleInput | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCreateUpdateRole(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param roleTypes (optional) 
     * @return Success
     */
    getRoles(userId: number | null | undefined, tenantId: number | null | undefined, roleTypes: number[] | null | undefined): Observable<GetRolesOuputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetRoles?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (roleTypes !== undefined && roleTypes !== null)
            roleTypes && roleTypes.forEach(item => { url_ += "RoleTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRolesOuputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRolesOuputListIHandleError>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<GetRolesOuputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetRolesOuputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRolesOuputListIHandleError>(null as any);
    }

    /**
     * @param roleID (optional) 
     * @return Success
     */
    deleteRole(roleID: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/DeleteRole?";
        if (roleID !== undefined && roleID !== null)
            url_ += "roleID=" + encodeURIComponent("" + roleID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getMembersAndRoles(): Observable<MembersAndRolesOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetMembersAndRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMembersAndRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembersAndRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MembersAndRolesOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MembersAndRolesOutputListIHandleError>;
        }));
    }

    protected processGetMembersAndRoles(response: HttpResponseBase): Observable<MembersAndRolesOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MembersAndRolesOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MembersAndRolesOutputListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addProjectMembersToMsChannel(body: AddProjectMembersToMsChannel | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/AddProjectMembersToMsChannel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProjectMembersToMsChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProjectMembersToMsChannel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processAddProjectMembersToMsChannel(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getProjectDashboard(projectId: number | null | undefined): Observable<ProjectDashboardOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectDashboard?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDashboardOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDashboardOutputDtoIHandleError>;
        }));
    }

    protected processGetProjectDashboard(response: HttpResponseBase): Observable<ProjectDashboardOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectDashboardOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDashboardOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectFields(body: UpdateProjectFieldsInputDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateProjectFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateProjectFields(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setProjectStage(body: SetProjectStageInputDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/SetProjectStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProjectStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProjectStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSetProjectStage(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getProjectStagesConfiguration(): Observable<GetProjectStagesConfigurationDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectStagesConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectStagesConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectStagesConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectStagesConfigurationDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectStagesConfigurationDtoIHandleError>;
        }));
    }

    protected processGetProjectStagesConfiguration(response: HttpResponseBase): Observable<GetProjectStagesConfigurationDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetProjectStagesConfigurationDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectStagesConfigurationDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setProjectStagesConfiguration(body: SetProjectStagesConfigurationDto | null | undefined): Observable<GetProjectStagesConfigurationDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/SetProjectStagesConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProjectStagesConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProjectStagesConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectStagesConfigurationDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectStagesConfigurationDtoIHandleError>;
        }));
    }

    protected processSetProjectStagesConfiguration(response: HttpResponseBase): Observable<GetProjectStagesConfigurationDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetProjectStagesConfigurationDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectStagesConfigurationDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setCustomProjectStageOrder(body: SetProjectStageSpecificOrder | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/SetCustomProjectStageOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCustomProjectStageOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCustomProjectStageOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSetCustomProjectStageOrder(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getTaskTemplates(projectId: number | null | undefined): Observable<GetTaskTemplateDTOIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTaskTemplates?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskTemplateDTOIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskTemplateDTOIHandleError>;
        }));
    }

    protected processGetTaskTemplates(response: HttpResponseBase): Observable<GetTaskTemplateDTOIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetTaskTemplateDTOIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskTemplateDTOIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTaskFromAgenda(body: CreateTaskFromAgendaInput | null | undefined): Observable<CreateTaskFromAgendaOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateTaskFromAgenda";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTaskFromAgenda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTaskFromAgenda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTaskFromAgendaOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTaskFromAgendaOutputDtoIHandleError>;
        }));
    }

    protected processCreateTaskFromAgenda(response: HttpResponseBase): Observable<CreateTaskFromAgendaOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateTaskFromAgendaOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateTaskFromAgendaOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEmailTask(body: CreateEmailTaskInput | null | undefined): Observable<CreateTaskFromAgendaOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateEmailTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmailTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmailTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTaskFromAgendaOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTaskFromAgendaOutputDtoIHandleError>;
        }));
    }

    protected processCreateEmailTask(response: HttpResponseBase): Observable<CreateTaskFromAgendaOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CreateTaskFromAgendaOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateTaskFromAgendaOutputDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createorUpdateManualTask(body: CreateOrUpdateManualTaskInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateorUpdateManualTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateorUpdateManualTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateorUpdateManualTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateorUpdateManualTask(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param taskDate (optional) 
     * @param userIds (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getMyTasks(taskDate: string | null | undefined, userIds: string | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<GetUserTasksListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetMyTasks?";
        if (taskDate !== undefined && taskDate !== null)
            url_ += "TaskDate=" + encodeURIComponent("" + taskDate) + "&";
        if (userIds !== undefined && userIds !== null)
            url_ += "UserIds=" + encodeURIComponent("" + userIds) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserTasksListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserTasksListIHandleError>;
        }));
    }

    protected processGetMyTasks(response: HttpResponseBase): Observable<GetUserTasksListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetUserTasksListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserTasksListIHandleError>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param takeCount (optional) 
     * @param taskDate (optional) 
     * @param dueToday (optional) 
     * @param newFilter (optional) 
     * @param overDue (optional) 
     * @param fromTeam (optional) 
     * @param searchText (optional) 
     * @return Success
     */
    getMySuggestedTasks(skipCount: number | null | undefined, takeCount: number | null | undefined, taskDate: string | null | undefined, dueToday: boolean | null | undefined, newFilter: boolean | null | undefined, overDue: boolean | null | undefined, fromTeam: boolean | null | undefined, searchText: string | null | undefined): Observable<GetUserTasksListTaskCountsListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetMySuggestedTasks?";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (takeCount !== undefined && takeCount !== null)
            url_ += "TakeCount=" + encodeURIComponent("" + takeCount) + "&";
        if (taskDate !== undefined && taskDate !== null)
            url_ += "TaskDate=" + encodeURIComponent("" + taskDate) + "&";
        if (dueToday !== undefined && dueToday !== null)
            url_ += "DueToday=" + encodeURIComponent("" + dueToday) + "&";
        if (newFilter !== undefined && newFilter !== null)
            url_ += "NewFilter=" + encodeURIComponent("" + newFilter) + "&";
        if (overDue !== undefined && overDue !== null)
            url_ += "OverDue=" + encodeURIComponent("" + overDue) + "&";
        if (fromTeam !== undefined && fromTeam !== null)
            url_ += "FromTeam=" + encodeURIComponent("" + fromTeam) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySuggestedTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySuggestedTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserTasksListTaskCountsListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserTasksListTaskCountsListValueTupleIHandleError>;
        }));
    }

    protected processGetMySuggestedTasks(response: HttpResponseBase): Observable<GetUserTasksListTaskCountsListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetUserTasksListTaskCountsListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserTasksListTaskCountsListValueTupleIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTaskHistoryById(id: number | null | undefined): Observable<TaskHistoryDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTaskHistoryById?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskHistoryDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskHistoryDtoListIHandleError>;
        }));
    }

    protected processGetTaskHistoryById(response: HttpResponseBase): Observable<TaskHistoryDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskHistoryDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskHistoryDtoListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param resultCount (optional) 
     * @return Success
     */
    getTaskAssignees(projectId: number | null | undefined, resultCount: number | null | undefined): Observable<LookupTableOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTaskAssignees?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (resultCount !== undefined && resultCount !== null)
            url_ += "resultCount=" + encodeURIComponent("" + resultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskAssignees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskAssignees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupTableOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupTableOutputDtoListIHandleError>;
        }));
    }

    protected processGetTaskAssignees(response: HttpResponseBase): Observable<LookupTableOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LookupTableOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupTableOutputDtoListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    checkProjectMembership(projectId: number | null | undefined, userId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CheckProjectMembership?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckProjectMembership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckProjectMembership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processCheckProjectMembership(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    isTaskVisibleToCurrentUser(taskId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/IsTaskVisibleToCurrentUser?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTaskVisibleToCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTaskVisibleToCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processIsTaskVisibleToCurrentUser(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTaskById(id: number | null | undefined): Observable<TaskDetailsIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTaskById?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDetailsIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDetailsIHandleError>;
        }));
    }

    protected processGetTaskById(response: HttpResponseBase): Observable<TaskDetailsIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskDetailsIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskDetailsIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getParentTaskDetails(id: number | null | undefined): Observable<ParentTaskDetailsIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetParentTaskDetails?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParentTaskDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParentTaskDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParentTaskDetailsIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParentTaskDetailsIHandleError>;
        }));
    }

    protected processGetParentTaskDetails(response: HttpResponseBase): Observable<ParentTaskDetailsIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ParentTaskDetailsIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ParentTaskDetailsIHandleError>(null as any);
    }

    /**
     * @param owner (optional) 
     * @param stepId (optional) 
     * @return Success
     */
    getStepById(owner: any | null | undefined, stepId: number | null | undefined): Observable<StepDetailsOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetStepById?";
        if (owner !== undefined && owner !== null)
            url_ += "owner=" + encodeURIComponent("" + owner) + "&";
        if (stepId !== undefined && stepId !== null)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStepById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStepById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StepDetailsOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StepDetailsOutputIHandleError>;
        }));
    }

    protected processGetStepById(response: HttpResponseBase): Observable<StepDetailsOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = StepDetailsOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StepDetailsOutputIHandleError>(null as any);
    }

    /**
     * @param commentId (optional) 
     * @return Success
     */
    readComment(commentId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/ReadComment?";
        if (commentId !== undefined && commentId !== null)
            url_ += "commentId=" + encodeURIComponent("" + commentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processReadComment(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param commentId (optional) 
     * @return Success
     */
    markCommentSeen(commentId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/MarkCommentSeen?";
        if (commentId !== undefined && commentId !== null)
            url_ += "commentId=" + encodeURIComponent("" + commentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkCommentSeen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkCommentSeen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMarkCommentSeen(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    readTaskComments(taskId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/ReadTaskComments?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadTaskComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadTaskComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processReadTaskComments(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCheckList(body: CheckLists | null | undefined): Observable<CheckListOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateOrUpdateCheckListAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCheckList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCheckList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckListOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckListOutputDtoIHandleError>;
        }));
    }

    protected processCreateOrUpdateCheckList(response: HttpResponseBase): Observable<CheckListOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CheckListOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckListOutputDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getCheckListByTaskId(taskId: number | null | undefined): Observable<CheckListsListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetCheckListByTaskId?";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckListByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckListByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckListsListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckListsListIHandleError>;
        }));
    }

    protected processGetCheckListByTaskId(response: HttpResponseBase): Observable<CheckListsListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CheckListsListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckListsListIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTask(id: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/DeleteTask?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteTask(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    undoDeleteTask(body: EntityDto | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UndoDeleteTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoDeleteTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoDeleteTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processUndoDeleteTask(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param checkListId (optional) 
     * @param taskKeyId (optional) 
     * @param checkListKeyId (optional) 
     * @param odataEtagId (optional) 
     * @param odataEtagDescId (optional) 
     * @param updateType (optional) 
     * @param taskId (optional) 
     * @return Success
     */
    deleteCheckList(checkListId: number | null | undefined, taskKeyId: string | null | undefined, checkListKeyId: string | null | undefined, odataEtagId: string | null | undefined, odataEtagDescId: string | null | undefined, updateType: any | null | undefined, taskId: number | null | undefined): Observable<CheckListOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/DeleteCheckListAsync?";
        if (checkListId !== undefined && checkListId !== null)
            url_ += "CheckListId=" + encodeURIComponent("" + checkListId) + "&";
        if (taskKeyId !== undefined && taskKeyId !== null)
            url_ += "TaskKeyId=" + encodeURIComponent("" + taskKeyId) + "&";
        if (checkListKeyId !== undefined && checkListKeyId !== null)
            url_ += "CheckListKeyId=" + encodeURIComponent("" + checkListKeyId) + "&";
        if (odataEtagId !== undefined && odataEtagId !== null)
            url_ += "OdataEtagId=" + encodeURIComponent("" + odataEtagId) + "&";
        if (odataEtagDescId !== undefined && odataEtagDescId !== null)
            url_ += "OdataEtagDescId=" + encodeURIComponent("" + odataEtagDescId) + "&";
        if (updateType !== undefined && updateType !== null)
            url_ += "UpdateType=" + encodeURIComponent("" + updateType) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCheckList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCheckList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckListOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckListOutputDtoIHandleError>;
        }));
    }

    protected processDeleteCheckList(response: HttpResponseBase): Observable<CheckListOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CheckListOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckListOutputDtoIHandleError>(null as any);
    }

    /**
     * @param checkListId (optional) 
     * @param code (optional) 
     * @param taskId (optional) 
     * @param isNotifySignalR (optional) 
     * @return Success
     */
    markCompleteInCompleteTaskCheckList(checkListId: number | null | undefined, code: number | null | undefined, taskId: number | null | undefined, isNotifySignalR: boolean | null | undefined): Observable<CheckListOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/MarkCompleteInCompleteTaskCheckListAsync?";
        if (checkListId !== undefined && checkListId !== null)
            url_ += "CheckListId=" + encodeURIComponent("" + checkListId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (isNotifySignalR !== undefined && isNotifySignalR !== null)
            url_ += "isNotifySignalR=" + encodeURIComponent("" + isNotifySignalR) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkCompleteInCompleteTaskCheckList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkCompleteInCompleteTaskCheckList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckListOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckListOutputDtoIHandleError>;
        }));
    }

    protected processMarkCompleteInCompleteTaskCheckList(response: HttpResponseBase): Observable<CheckListOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CheckListOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckListOutputDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    updateChecklistIsSeenByTaskId(taskId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateChecklistIsSeenByTaskId?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateChecklistIsSeenByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateChecklistIsSeenByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateChecklistIsSeenByTaskId(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    markChecklistsCompleted(taskId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/MarkChecklistsCompleted?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkChecklistsCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkChecklistsCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMarkChecklistsCompleted(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIsSeenByTaskId(body: UpdateIsSeenDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateIsSeenByTaskId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIsSeenByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIsSeenByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateIsSeenByTaskId(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaskIsSeenAndIsNew(body: UpdateIsSeenDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateTaskIsSeenAndIsNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskIsSeenAndIsNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskIsSeenAndIsNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateTaskIsSeenAndIsNew(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIsNewByTaskId(body: UpdateIsSeenDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateIsNewByTaskId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIsNewByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIsNewByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateIsNewByTaskId(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaskPrivacy(body: TaskPrivacyInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateTaskPrivacy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskPrivacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskPrivacy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processUpdateTaskPrivacy(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    sortCuurentUserSuggestionsTasks(): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/SortCuurentUserSuggestionsTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSortCuurentUserSuggestionsTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSortCuurentUserSuggestionsTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processSortCuurentUserSuggestionsTasks(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyTask(body: TaskCopyInput | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CopyTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCopyTask(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateComment(body: UpdateTaskCommentInputDto | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processUpdateComment(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createComment(body: TaskCommentInputDto | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCreateComment(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resolveComment(body: ResolveCommentInputDto | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/ResolveComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processResolveComment(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param commentId (optional) 
     * @return Success
     */
    deleteComment(commentId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/DeleteComment?";
        if (commentId !== undefined && commentId !== null)
            url_ += "CommentId=" + encodeURIComponent("" + commentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteComment(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCommentText(body: UpdateTaskCommentTextInputDto | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateCommentText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCommentText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCommentText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processUpdateCommentText(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetCommentStatus(body: TaskCommentResetInputDto | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/ResetCommentStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetCommentStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetCommentStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processResetCommentStatus(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpgradeSubscriptionTask(body: UpgradeSubscriptionTaskInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateUpgradeSubscriptionTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpgradeSubscriptionTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpgradeSubscriptionTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateUpgradeSubscriptionTask(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaskPriority(body: TaskPriorityInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateTaskPriority";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskPriority(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskPriority(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateTaskPriority(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaskName(body: UpdateTaskNameInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateTaskName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateTaskName(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateTaskTag(body: TaskTagInputDto | null | undefined): Observable<TaskTagDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateUpdateTaskTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateTaskTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateTaskTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskTagDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskTagDtoListIHandleError>;
        }));
    }

    protected processCreateUpdateTaskTag(response: HttpResponseBase): Observable<TaskTagDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskTagDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskTagDtoListIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTaskTags(taskId: number | null | undefined): Observable<TaskTagDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTaskTags?";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskTagDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskTagDtoListIHandleError>;
        }));
    }

    protected processGetTaskTags(response: HttpResponseBase): Observable<TaskTagDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskTagDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskTagDtoListIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @param userId (optional) 
     * @return Success
     */
    deleteTaskTag(id: number | null | undefined, userId: number | null | undefined): Observable<TaskTagDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/DeleteTaskTag?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTaskTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTaskTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskTagDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskTagDtoListIHandleError>;
        }));
    }

    protected processDeleteTaskTag(response: HttpResponseBase): Observable<TaskTagDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskTagDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskTagDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTask(body: CreateOrUpdateManualTaskInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateTask(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getIsUserMaxTask(): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetIsUserMaxTask";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIsUserMaxTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIsUserMaxTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processGetIsUserMaxTask(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBulkTaskChecklist(body: BulkChecklistInputDto | null | undefined): Observable<CheckListsListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateBulkTaskChecklist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBulkTaskChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBulkTaskChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckListsListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckListsListIHandleError>;
        }));
    }

    protected processCreateBulkTaskChecklist(response: HttpResponseBase): Observable<CheckListsListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CheckListsListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckListsListIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param isDueToday (optional) 
     * @param isOverDue (optional) 
     * @param isUpComing (optional) 
     * @param projectIds (optional) 
     * @param isFollowUp (optional) 
     * @param isTask (optional) 
     * @param isMeeting (optional) 
     * @return Success
     */
    getTodosTasks(searchText: string | null | undefined, isDueToday: boolean | null | undefined, isOverDue: boolean | null | undefined, isUpComing: boolean | null | undefined, projectIds: number[] | null | undefined, isFollowUp: boolean | null | undefined, isTask: boolean | null | undefined, isMeeting: boolean | null | undefined): Observable<TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTodosTasks?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (isDueToday !== undefined && isDueToday !== null)
            url_ += "IsDueToday=" + encodeURIComponent("" + isDueToday) + "&";
        if (isOverDue !== undefined && isOverDue !== null)
            url_ += "IsOverDue=" + encodeURIComponent("" + isOverDue) + "&";
        if (isUpComing !== undefined && isUpComing !== null)
            url_ += "IsUpComing=" + encodeURIComponent("" + isUpComing) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (isFollowUp !== undefined && isFollowUp !== null)
            url_ += "IsFollowUp=" + encodeURIComponent("" + isFollowUp) + "&";
        if (isTask !== undefined && isTask !== null)
            url_ += "IsTask=" + encodeURIComponent("" + isTask) + "&";
        if (isMeeting !== undefined && isMeeting !== null)
            url_ += "IsMeeting=" + encodeURIComponent("" + isMeeting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodosTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodosTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError>;
        }));
    }

    protected processGetTodosTasks(response: HttpResponseBase): Observable<TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param isThisWeek (optional) 
     * @param isDueToday (optional) 
     * @param isNoDates (optional) 
     * @param isOverDue (optional) 
     * @param isHighPriority (optional) 
     * @param isNew (optional) 
     * @param projectIds (optional) 
     * @return Success
     */
    getTodosTasksGroupByProjects(searchText: string | null | undefined, isThisWeek: boolean | null | undefined, isDueToday: boolean | null | undefined, isNoDates: boolean | null | undefined, isOverDue: boolean | null | undefined, isHighPriority: boolean | null | undefined, isNew: boolean | null | undefined, projectIds: number[] | null | undefined): Observable<TodosTaskByProjectGroupDtoListTodosTaskListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTodosTasksGroupByProjects?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (isThisWeek !== undefined && isThisWeek !== null)
            url_ += "IsThisWeek=" + encodeURIComponent("" + isThisWeek) + "&";
        if (isDueToday !== undefined && isDueToday !== null)
            url_ += "IsDueToday=" + encodeURIComponent("" + isDueToday) + "&";
        if (isNoDates !== undefined && isNoDates !== null)
            url_ += "IsNoDates=" + encodeURIComponent("" + isNoDates) + "&";
        if (isOverDue !== undefined && isOverDue !== null)
            url_ += "IsOverDue=" + encodeURIComponent("" + isOverDue) + "&";
        if (isHighPriority !== undefined && isHighPriority !== null)
            url_ += "IsHighPriority=" + encodeURIComponent("" + isHighPriority) + "&";
        if (isNew !== undefined && isNew !== null)
            url_ += "IsNew=" + encodeURIComponent("" + isNew) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodosTasksGroupByProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodosTasksGroupByProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodosTaskByProjectGroupDtoListTodosTaskListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodosTaskByProjectGroupDtoListTodosTaskListValueTupleIHandleError>;
        }));
    }

    protected processGetTodosTasksGroupByProjects(response: HttpResponseBase): Observable<TodosTaskByProjectGroupDtoListTodosTaskListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TodosTaskByProjectGroupDtoListTodosTaskListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosTaskByProjectGroupDtoListTodosTaskListValueTupleIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param isThisWeek (optional) 
     * @param isDueToday (optional) 
     * @param isOverDue (optional) 
     * @param isHighPriority (optional) 
     * @param isNew (optional) 
     * @param groupId (optional) 
     * @param skipCount (optional) 
     * @param takeCount (optional) 
     * @return Success
     */
    getMoreTodosTasksByGroup(searchText: string | null | undefined, isThisWeek: boolean | null | undefined, isDueToday: boolean | null | undefined, isOverDue: boolean | null | undefined, isHighPriority: boolean | null | undefined, isNew: boolean | null | undefined, groupId: number | null | undefined, skipCount: number | null | undefined, takeCount: number | null | undefined): Observable<TodosTaskListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetMoreTodosTasksByGroup?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (isThisWeek !== undefined && isThisWeek !== null)
            url_ += "IsThisWeek=" + encodeURIComponent("" + isThisWeek) + "&";
        if (isDueToday !== undefined && isDueToday !== null)
            url_ += "IsDueToday=" + encodeURIComponent("" + isDueToday) + "&";
        if (isOverDue !== undefined && isOverDue !== null)
            url_ += "IsOverDue=" + encodeURIComponent("" + isOverDue) + "&";
        if (isHighPriority !== undefined && isHighPriority !== null)
            url_ += "IsHighPriority=" + encodeURIComponent("" + isHighPriority) + "&";
        if (isNew !== undefined && isNew !== null)
            url_ += "IsNew=" + encodeURIComponent("" + isNew) + "&";
        if (groupId !== undefined && groupId !== null)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (takeCount !== undefined && takeCount !== null)
            url_ += "TakeCount=" + encodeURIComponent("" + takeCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMoreTodosTasksByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMoreTodosTasksByGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodosTaskListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodosTaskListIHandleError>;
        }));
    }

    protected processGetMoreTodosTasksByGroup(response: HttpResponseBase): Observable<TodosTaskListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TodosTaskListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosTaskListIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param isThisWeek (optional) 
     * @param isDueToday (optional) 
     * @param isNoDates (optional) 
     * @param isOverDue (optional) 
     * @param isHighPriority (optional) 
     * @param isNew (optional) 
     * @param projectIds (optional) 
     * @return Success
     */
    getTodosTaskCounts(searchText: string | null | undefined, isThisWeek: boolean | null | undefined, isDueToday: boolean | null | undefined, isNoDates: boolean | null | undefined, isOverDue: boolean | null | undefined, isHighPriority: boolean | null | undefined, isNew: boolean | null | undefined, projectIds: number[] | null | undefined): Observable<TodosTaskCountsIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTodosTaskCounts?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (isThisWeek !== undefined && isThisWeek !== null)
            url_ += "IsThisWeek=" + encodeURIComponent("" + isThisWeek) + "&";
        if (isDueToday !== undefined && isDueToday !== null)
            url_ += "IsDueToday=" + encodeURIComponent("" + isDueToday) + "&";
        if (isNoDates !== undefined && isNoDates !== null)
            url_ += "IsNoDates=" + encodeURIComponent("" + isNoDates) + "&";
        if (isOverDue !== undefined && isOverDue !== null)
            url_ += "IsOverDue=" + encodeURIComponent("" + isOverDue) + "&";
        if (isHighPriority !== undefined && isHighPriority !== null)
            url_ += "IsHighPriority=" + encodeURIComponent("" + isHighPriority) + "&";
        if (isNew !== undefined && isNew !== null)
            url_ += "IsNew=" + encodeURIComponent("" + isNew) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodosTaskCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodosTaskCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodosTaskCountsIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodosTaskCountsIHandleError>;
        }));
    }

    protected processGetTodosTaskCounts(response: HttpResponseBase): Observable<TodosTaskCountsIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TodosTaskCountsIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosTaskCountsIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param projectIds (optional) 
     * @return Success
     */
    getTodosFollowUpTasks(searchText: string | null | undefined, projectIds: number[] | null | undefined): Observable<TodosFollowUpTaskListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTodosFollowUpTasks?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodosFollowUpTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodosFollowUpTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodosFollowUpTaskListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodosFollowUpTaskListIHandleError>;
        }));
    }

    protected processGetTodosFollowUpTasks(response: HttpResponseBase): Observable<TodosFollowUpTaskListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TodosFollowUpTaskListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosFollowUpTaskListIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param projectIds (optional) 
     * @return Success
     */
    getTodosPastDueTasks(searchText: string | null | undefined, projectIds: number[] | null | undefined): Observable<TodosPastDueTaskListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTodosPastDueTasks?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodosPastDueTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodosPastDueTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodosPastDueTaskListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodosPastDueTaskListIHandleError>;
        }));
    }

    protected processGetTodosPastDueTasks(response: HttpResponseBase): Observable<TodosPastDueTaskListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TodosPastDueTaskListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosPastDueTaskListIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param projectIds (optional) 
     * @return Success
     */
    getTodosOnGoingTasks(searchText: string | null | undefined, projectIds: number[] | null | undefined): Observable<TodosOnGoingTaskListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTodosOnGoingTasks?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodosOnGoingTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodosOnGoingTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodosOnGoingTaskListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodosOnGoingTaskListIHandleError>;
        }));
    }

    protected processGetTodosOnGoingTasks(response: HttpResponseBase): Observable<TodosOnGoingTaskListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TodosOnGoingTaskListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosOnGoingTaskListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveTodoTasksToMyDay(body: MoveTodoTasksToMyDayInputDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/MoveTodoTasksToMyDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTodoTasksToMyDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTodoTasksToMyDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMoveTodoTasksToMyDay(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveMyDayTasksToTodo(body: number[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/MoveMyDayTasksToTodo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveMyDayTasksToTodo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveMyDayTasksToTodo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMoveMyDayTasksToTodo(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param projectIds (optional) 
     * @param view (optional) 
     * @return Success
     */
    getTodosTasksByViewCounts(searchText: string | null | undefined, projectIds: number[] | null | undefined, view: string | null | undefined): Observable<TodosTasksByViewCountsOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTodosTasksByViewCounts?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (view !== undefined && view !== null)
            url_ += "View=" + encodeURIComponent("" + view) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodosTasksByViewCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodosTasksByViewCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodosTasksByViewCountsOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodosTasksByViewCountsOutputDtoIHandleError>;
        }));
    }

    protected processGetTodosTasksByViewCounts(response: HttpResponseBase): Observable<TodosTasksByViewCountsOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TodosTasksByViewCountsOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosTasksByViewCountsOutputDtoIHandleError>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param projectIds (optional) 
     * @param isHighPriority (optional) 
     * @param isPastDue (optional) 
     * @param isNew (optional) 
     * @param view (optional) 
     * @param isWithoutDates (optional) 
     * @return Success
     */
    getTodosTasksByView(searchText: string | null | undefined, projectIds: number[] | null | undefined, isHighPriority: boolean | null | undefined, isPastDue: boolean | null | undefined, isNew: boolean | null | undefined, view: string | null | undefined, isWithoutDates: boolean | null | undefined): Observable<TodosTasksByViewOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTodosTasksByView?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (isHighPriority !== undefined && isHighPriority !== null)
            url_ += "IsHighPriority=" + encodeURIComponent("" + isHighPriority) + "&";
        if (isPastDue !== undefined && isPastDue !== null)
            url_ += "IsPastDue=" + encodeURIComponent("" + isPastDue) + "&";
        if (isNew !== undefined && isNew !== null)
            url_ += "IsNew=" + encodeURIComponent("" + isNew) + "&";
        if (view !== undefined && view !== null)
            url_ += "View=" + encodeURIComponent("" + view) + "&";
        if (isWithoutDates !== undefined && isWithoutDates !== null)
            url_ += "IsWithoutDates=" + encodeURIComponent("" + isWithoutDates) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodosTasksByView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodosTasksByView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodosTasksByViewOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodosTasksByViewOutputDtoIHandleError>;
        }));
    }

    protected processGetTodosTasksByView(response: HttpResponseBase): Observable<TodosTasksByViewOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TodosTasksByViewOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosTasksByViewOutputDtoIHandleError>(null as any);
    }

    /**
     * @param view (optional) 
     * @return Success
     */
    getTodosTasksProjectsByView(view: string | null | undefined): Observable<TodosTasksProjectsByViewOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetTodosTasksProjectsByView?";
        if (view !== undefined && view !== null)
            url_ += "View=" + encodeURIComponent("" + view) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodosTasksProjectsByView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodosTasksProjectsByView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodosTasksProjectsByViewOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodosTasksProjectsByViewOutputDtoIHandleError>;
        }));
    }

    protected processGetTodosTasksProjectsByView(response: HttpResponseBase): Observable<TodosTasksProjectsByViewOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TodosTasksProjectsByViewOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosTasksProjectsByViewOutputDtoIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getGanttTasksByProject(projectId: number | null | undefined): Observable<GanttTaskDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetGanttTasksByProject?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGanttTasksByProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGanttTasksByProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GanttTaskDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GanttTaskDtoListIHandleError>;
        }));
    }

    protected processGetGanttTasksByProject(response: HttpResponseBase): Observable<GanttTaskDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GanttTaskDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GanttTaskDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markAllTasksToComplete(body: number[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/MarkAllTasksToComplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllTasksToComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllTasksToComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMarkAllTasksToComplete(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param code (optional) 
     * @param isNotifySignalR (optional) 
     * @return Success
     */
    markCompleteInCompleteTask(taskId: number | null | undefined, code: number | null | undefined, isNotifySignalR: boolean | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/MarkCompleteInCompleteTaskAsync?";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (isNotifySignalR !== undefined && isNotifySignalR !== null)
            url_ += "isNotifySignalR=" + encodeURIComponent("" + isNotifySignalR) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkCompleteInCompleteTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkCompleteInCompleteTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMarkCompleteInCompleteTask(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param dueDate (optional) 
     * @param isNotifySignalR (optional) 
     * @return Success
     */
    rescheduleTask(taskId: number | null | undefined, dueDate: string | null | undefined, isNotifySignalR: boolean | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/RescheduleTaskAsync?";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (dueDate !== undefined && dueDate !== null)
            url_ += "DueDate=" + encodeURIComponent("" + dueDate) + "&";
        if (isNotifySignalR !== undefined && isNotifySignalR !== null)
            url_ += "isNotifySignalR=" + encodeURIComponent("" + isNotifySignalR) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRescheduleTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRescheduleTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processRescheduleTask(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    removeApps(taskId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/RemoveApps?";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveApps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveApps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processRemoveApps(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    markTaskAsNonSuggestedByAi(taskId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/MarkTaskAsNonSuggestedByAi?";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkTaskAsNonSuggestedByAi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkTaskAsNonSuggestedByAi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMarkTaskAsNonSuggestedByAi(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchGlobalTasks(body: SearchGlobalTaskInputDto | null | undefined): Observable<Int32TodosTaskListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/SearchGlobalTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchGlobalTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchGlobalTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32TodosTaskListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32TodosTaskListValueTupleIHandleError>;
        }));
    }

    protected processSearchGlobalTasks(response: HttpResponseBase): Observable<Int32TodosTaskListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32TodosTaskListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32TodosTaskListValueTupleIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param sectionId (optional) 
     * @param code (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getProjectSectionTasks(projectId: number | null | undefined, sectionId: number | null | undefined, code: number | null | undefined, skip: number | null | undefined, take: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<GetUserTasksListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetProjectSectionTasks?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (sectionId !== undefined && sectionId !== null)
            url_ += "SectionId=" + encodeURIComponent("" + sectionId) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectSectionTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectSectionTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserTasksListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserTasksListIHandleError>;
        }));
    }

    protected processGetProjectSectionTasks(response: HttpResponseBase): Observable<GetUserTasksListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetUserTasksListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserTasksListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTaskAssociation(body: TaskAssociation | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateTaskAssociation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTaskAssociation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTaskAssociation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateTaskAssociation(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param entityId (optional) 
     * @return Success
     */
    deleteTaskAssociation(entityId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/DeleteTaskAssociation?";
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTaskAssociation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTaskAssociation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteTaskAssociation(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserActivityTodayTasks(userId: number | null | undefined): Observable<GetUserActivityTaskOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetUserActivityTodayTasks?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityTodayTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityTodayTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserActivityTaskOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserActivityTaskOutputListIHandleError>;
        }));
    }

    protected processGetUserActivityTodayTasks(response: HttpResponseBase): Observable<GetUserActivityTaskOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetUserActivityTaskOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserActivityTaskOutputListIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserActivityUpcomingTasks(userId: number | null | undefined): Observable<TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetUserActivityUpcomingTasks?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityUpcomingTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityUpcomingTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError>;
        }));
    }

    protected processGetUserActivityUpcomingTasks(response: HttpResponseBase): Observable<TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserActivityTaskCounts(userId: number | null | undefined): Observable<ActivityTaskCountsIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetUserActivityTaskCounts?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActivityTaskCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActivityTaskCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityTaskCountsIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityTaskCountsIHandleError>;
        }));
    }

    protected processGetUserActivityTaskCounts(response: HttpResponseBase): Observable<ActivityTaskCountsIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ActivityTaskCountsIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityTaskCountsIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFileTask(body: CreateFileTask | null | undefined): Observable<Int64IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateFileTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFileTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFileTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int64IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int64IHandleError>;
        }));
    }

    protected processCreateFileTask(response: HttpResponseBase): Observable<Int64IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int64IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int64IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaskProjectSection(body: UpdateTaskProjectSection | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/UpdateTaskProjectSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskProjectSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskProjectSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateTaskProjectSection(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDependentTask(body: CreateOrUpdateManualTaskInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Task/CreateDependentTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDependentTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDependentTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateDependentTask(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }
}

@Injectable()
export class TaskAssigneServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getUsersTaskAssigneHistory(tenantId: number | null | undefined, userId: number | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskAssigne/GetUsersTaskAssigneHistory?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersTaskAssigneHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersTaskAssigneHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processGetUsersTaskAssigneHistory(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }
}

@Injectable()
export class TaskCompletionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    undoTaskCompletion(body: UndoTaskCompletionInput | null | undefined): Observable<UndoTaskCompletionResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskCompletion/UndoTaskCompletion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoTaskCompletion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoTaskCompletion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UndoTaskCompletionResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UndoTaskCompletionResultDtoIHandleError>;
        }));
    }

    protected processUndoTaskCompletion(response: HttpResponseBase): Observable<UndoTaskCompletionResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UndoTaskCompletionResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UndoTaskCompletionResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    preflightBulkCompletion(body: PreflightBulkCompletionInput | null | undefined): Observable<PreflightBulkCompletionResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskCompletion/PreflightBulkCompletion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreflightBulkCompletion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreflightBulkCompletion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreflightBulkCompletionResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreflightBulkCompletionResultDtoIHandleError>;
        }));
    }

    protected processPreflightBulkCompletion(response: HttpResponseBase): Observable<PreflightBulkCompletionResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PreflightBulkCompletionResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreflightBulkCompletionResultDtoIHandleError>(null as any);
    }
}

@Injectable()
export class TaskContextServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    readTaskContexts(body: ReadTaskContextsInput | null | undefined): Observable<TaskContextFactsDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskContext/ReadTaskContexts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadTaskContexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadTaskContexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskContextFactsDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskContextFactsDtoListIHandleError>;
        }));
    }

    protected processReadTaskContexts(response: HttpResponseBase): Observable<TaskContextFactsDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskContextFactsDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskContextFactsDtoListIHandleError>(null as any);
    }
}

@Injectable()
export class TaskConversationCalloutsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshTaskConversationCallouts(body: RefreshTaskConversationCalloutsInput | null | undefined): Observable<ConversationCalloutsDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskConversationCallouts/RefreshTaskConversationCallouts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshTaskConversationCallouts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshTaskConversationCallouts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConversationCalloutsDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConversationCalloutsDtoIHandleError>;
        }));
    }

    protected processRefreshTaskConversationCallouts(response: HttpResponseBase): Observable<ConversationCalloutsDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConversationCalloutsDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConversationCalloutsDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dismissConversationCallout(body: DismissConversationCalloutInput | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskConversationCallouts/DismissConversationCallout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDismissConversationCallout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDismissConversationCallout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDismissConversationCallout(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }
}

@Injectable()
export class TaskLeadStageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLeadStageFromTask(body: ChangeLeadStageFromTaskInput | null | undefined): Observable<ChangeLeadStageFromTaskResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskLeadStage/ChangeLeadStageFromTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLeadStageFromTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLeadStageFromTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeLeadStageFromTaskResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeLeadStageFromTaskResultDtoIHandleError>;
        }));
    }

    protected processChangeLeadStageFromTask(response: HttpResponseBase): Observable<ChangeLeadStageFromTaskResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ChangeLeadStageFromTaskResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangeLeadStageFromTaskResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setLostReason(body: SetLostReasonInput | null | undefined): Observable<SetLostReasonResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskLeadStage/SetLostReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetLostReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetLostReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetLostReasonResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetLostReasonResultDtoIHandleError>;
        }));
    }

    protected processSetLostReason(response: HttpResponseBase): Observable<SetLostReasonResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SetLostReasonResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetLostReasonResultDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    undoWon(body: UndoWonInput | null | undefined): Observable<UndoWonResultDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskLeadStage/UndoWon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoWon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoWon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UndoWonResultDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UndoWonResultDtoIHandleError>;
        }));
    }

    protected processUndoWon(response: HttpResponseBase): Observable<UndoWonResultDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UndoWonResultDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UndoWonResultDtoIHandleError>(null as any);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getPersonLeadFollowUp(contactId: number | null | undefined): Observable<PersonLeadFollowUpDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskLeadStage/GetPersonLeadFollowUp?";
        if (contactId !== undefined && contactId !== null)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonLeadFollowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonLeadFollowUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonLeadFollowUpDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonLeadFollowUpDtoIHandleError>;
        }));
    }

    protected processGetPersonLeadFollowUp(response: HttpResponseBase): Observable<PersonLeadFollowUpDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PersonLeadFollowUpDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonLeadFollowUpDtoIHandleError>(null as any);
    }
}

@Injectable()
export class TaskWatcherServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @param taskId (optional) 
     * @return Success
     */
    watchTask(userId: number | null | undefined, taskId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskWatcher/WatchTask?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processWatchTask(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param taskId (optional) 
     * @return Success
     */
    unwatchTask(userId: number | null | undefined, taskId: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskWatcher/UnwatchTask?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnwatchTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnwatchTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUnwatchTask(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param isAutoCleanUp (optional) 
     * @return Success
     */
    unwatchCompletedTasks(userId: number | null | undefined, isAutoCleanUp: boolean | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskWatcher/UnwatchCompletedTasks?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isAutoCleanUp !== undefined && isAutoCleanUp !== null)
            url_ += "isAutoCleanUp=" + encodeURIComponent("" + isAutoCleanUp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnwatchCompletedTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnwatchCompletedTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUnwatchCompletedTasks(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getWatchedTasks(userId: number | null | undefined): Observable<WatchedTaskDTOListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskWatcher/GetWatchedTasks?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWatchedTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWatchedTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchedTaskDTOListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchedTaskDTOListIHandleError>;
        }));
    }

    protected processGetWatchedTasks(response: HttpResponseBase): Observable<WatchedTaskDTOListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = WatchedTaskDTOListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WatchedTaskDTOListIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTaskWatchers(taskId: number | null | undefined): Observable<TaskWatcherDTOListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskWatcher/GetTaskWatchers?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskWatchers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskWatchers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskWatcherDTOListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskWatcherDTOListIHandleError>;
        }));
    }

    protected processGetTaskWatchers(response: HttpResponseBase): Observable<TaskWatcherDTOListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TaskWatcherDTOListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskWatcherDTOListIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param taskId (optional) 
     * @return Success
     */
    checkTaskStatus(userId: number | null | undefined, taskId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TaskWatcher/CheckTaskStatus?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckTaskStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTaskStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processCheckTaskStatus(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }
}

@Injectable()
export class TeamServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getTeams(): Observable<Int32TeamsDtoListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Team/GetTeams";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32TeamsDtoListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32TeamsDtoListValueTupleIHandleError>;
        }));
    }

    protected processGetTeams(response: HttpResponseBase): Observable<Int32TeamsDtoListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32TeamsDtoListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32TeamsDtoListValueTupleIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateTeamInputDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Team/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTeam(id: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Team/DeleteTeam?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteTeam(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param subscriptionEndDateStart (optional) 
     * @param subscriptionEndDateEnd (optional) 
     * @param subscriptionStartDateStart (optional) 
     * @param subscriptionStartDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param editionId (optional) 
     * @param editionIdSpecified (optional) 
     * @param activeUsersFilter (optional) 
     * @param inActiveUsersFilter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTenants(filter: string | null | undefined, subscriptionEndDateStart: string | null | undefined, subscriptionEndDateEnd: string | null | undefined, subscriptionStartDateStart: string | null | undefined, subscriptionStartDateEnd: string | null | undefined, creationDateStart: string | null | undefined, creationDateEnd: string | null | undefined, editionId: number | null | undefined, editionIdSpecified: boolean | null | undefined, activeUsersFilter: boolean | null | undefined, inActiveUsersFilter: boolean | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<TenantListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart !== undefined && subscriptionEndDateStart !== null)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent("" + subscriptionEndDateStart) + "&";
        if (subscriptionEndDateEnd !== undefined && subscriptionEndDateEnd !== null)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent("" + subscriptionEndDateEnd) + "&";
        if (subscriptionStartDateStart !== undefined && subscriptionStartDateStart !== null)
            url_ += "SubscriptionStartDateStart=" + encodeURIComponent("" + subscriptionStartDateStart) + "&";
        if (subscriptionStartDateEnd !== undefined && subscriptionStartDateEnd !== null)
            url_ += "SubscriptionStartDateEnd=" + encodeURIComponent("" + subscriptionStartDateEnd) + "&";
        if (creationDateStart !== undefined && creationDateStart !== null)
            url_ += "CreationDateStart=" + encodeURIComponent("" + creationDateStart) + "&";
        if (creationDateEnd !== undefined && creationDateEnd !== null)
            url_ += "CreationDateEnd=" + encodeURIComponent("" + creationDateEnd) + "&";
        if (editionId !== undefined && editionId !== null)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified !== undefined && editionIdSpecified !== null)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (activeUsersFilter !== undefined && activeUsersFilter !== null)
            url_ += "ActiveUsersFilter=" + encodeURIComponent("" + activeUsersFilter) + "&";
        if (inActiveUsersFilter !== undefined && inActiveUsersFilter !== null)
            url_ += "InActiveUsersFilter=" + encodeURIComponent("" + inActiveUsersFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantListDtoPagedResultDto>;
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<TenantListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TenantListDtoPagedResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantListDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenantOnly(body: CreateTenantInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenantOnly";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenantOnly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenantOnly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateTenantOnly(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenant(body: CreateTenantInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenantAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantForEdit(id: number | null | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantEditDto>;
        }));
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TenantEditDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantEditDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenant(body: TenantEditDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTenant(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantFeaturesForEdit(id: number | null | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeaturesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantFeaturesEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantFeaturesEditOutput>;
        }));
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetTenantFeaturesEditOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantFeaturesEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(body: EntityDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTenantSpecificFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockTenantAdmin(body: EntityDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockTenantAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getTenantDetails(): Observable<TenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantListDto>;
        }));
    }

    protected processGetTenantDetails(response: HttpResponseBase): Observable<TenantListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TenantListDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantListDto>(null as any);
    }

    /**
     * @param dbobjects (optional) 
     * @param body (optional) 
     * @return Success
     */
    replicateDataBaseObject(dbobjects: string | null | undefined, body: Tenant | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ReplicateDataBaseObject?";
        if (dbobjects !== undefined && dbobjects !== null)
            url_ += "dbobjects=" + encodeURIComponent("" + dbobjects) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplicateDataBaseObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplicateDataBaseObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReplicateDataBaseObject(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMemberActivityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMemberActivityOutput>;
        }));
    }

    protected processGetMemberActivity(response: HttpResponseBase): Observable<GetMemberActivityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetMemberActivityOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMemberActivityOutput>(null as any);
    }

    /**
     * @param salesSummaryDatePeriod (optional) 
     * @return Success
     */
    getDashboardData(salesSummaryDatePeriod: any | null | undefined): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod !== undefined && salesSummaryDatePeriod !== null)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDashboardDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDashboardDataOutput>;
        }));
    }

    protected processGetDashboardData(response: HttpResponseBase): Observable<GetDashboardDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardDataOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDashboardDataOutput>(null as any);
    }

    /**
     * @param salesSummaryDatePeriod (optional) 
     * @return Success
     */
    getSalesSummary(salesSummaryDatePeriod: any | null | undefined): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod !== undefined && salesSummaryDatePeriod !== null)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesSummaryOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesSummaryOutput>;
        }));
    }

    protected processGetSalesSummary(response: HttpResponseBase): Observable<GetSalesSummaryOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetSalesSummaryOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesSummaryOutput>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getRegionalStats(input: any | null | undefined): Observable<GetRegionalStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionalStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRegionalStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRegionalStatsOutput>;
        }));
    }

    protected processGetRegionalStats(response: HttpResponseBase): Observable<GetRegionalStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetRegionalStatsOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRegionalStatsOutput>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getGeneralStats(input: any | null | undefined): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneralStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneralStatsOutput>;
        }));
    }

    protected processGetGeneralStats(response: HttpResponseBase): Observable<GetGeneralStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralStatsOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneralStatsOutput>(null as any);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateTenantRegistration(body: RegisterTenantInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/ValidateTenantRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateTenantRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateTenantRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processValidateTenantRegistration(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerTenant(body: RegisterTenantInput | null | undefined): Observable<RegisterTenantOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterTenantOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterTenantOutputIHandleError>;
        }));
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RegisterTenantOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterTenantOutputIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerTenantStep1(body: RegisterTenantStep1Input | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenantStep1";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenantStep1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenantStep1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processRegisterTenantStep1(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerTenantStep2(body: RegisterTenantStep2Input | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenantStep2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenantStep2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenantStep2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processRegisterTenantStep2(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerTenantStep3(body: RegisterTenantStep3Input | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenantStep3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenantStep3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenantStep3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processRegisterTenantStep3(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    traceTenantRegistrationProcess(body: TraceTenantRegistrationInput | null | undefined): Observable<TraceTenantRegistrationOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/TraceTenantRegistrationProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTraceTenantRegistrationProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTraceTenantRegistrationProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TraceTenantRegistrationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TraceTenantRegistrationOutput>;
        }));
    }

    protected processTraceTenantRegistrationProcess(response: HttpResponseBase): Observable<TraceTenantRegistrationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TraceTenantRegistrationOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TraceTenantRegistrationOutput>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    reSendActivationLink(emailAddress: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/ReSendActivationLink?";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReSendActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReSendActivationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processReSendActivationLink(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionsSelectOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionsSelectOutput>;
        }));
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EditionsSelectOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionsSelectOutput>(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getEdition(editionId: number | null | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId !== undefined && editionId !== null)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionSelectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionSelectDto>;
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = EditionSelectDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionSelectDto>(null as any);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsEditDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantSettingsEditDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: TenantSettingsEditDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCustomCss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TicketServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTicket(body: CreateTicketInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/Ticket/CreateTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateTicket(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    uploadToBlob(file: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ticket/UploadToBlob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadToBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadToBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadToBlob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class TimeTrackingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startTimer(body: StartTimerInputDto | null | undefined): Observable<ActiveTimerDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TimeTracking/StartTimer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartTimer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartTimer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveTimerDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveTimerDtoIHandleError>;
        }));
    }

    protected processStartTimer(response: HttpResponseBase): Observable<ActiveTimerDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ActiveTimerDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveTimerDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stopTimer(body: StopTimerInputDto | null | undefined): Observable<TimeEntryDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TimeTracking/StopTimer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStopTimer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopTimer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeEntryDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeEntryDtoIHandleError>;
        }));
    }

    protected processStopTimer(response: HttpResponseBase): Observable<TimeEntryDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TimeEntryDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TimeEntryDtoIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getActiveTimer(): Observable<ActiveTimerDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TimeTracking/GetActiveTimer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveTimer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveTimer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveTimerDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveTimerDtoIHandleError>;
        }));
    }

    protected processGetActiveTimer(response: HttpResponseBase): Observable<ActiveTimerDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ActiveTimerDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveTimerDtoIHandleError>(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTaskTimeEntries(taskId: number | null | undefined): Observable<TimeEntryDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TimeTracking/GetTaskTimeEntries?";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskTimeEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskTimeEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeEntryDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeEntryDtoListIHandleError>;
        }));
    }

    protected processGetTaskTimeEntries(response: HttpResponseBase): Observable<TimeEntryDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TimeEntryDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TimeEntryDtoListIHandleError>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param filter (optional) 
     * @param groupBy (optional) 
     * @param searchText (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    getProjectTimeEntries(projectId: number | null | undefined, filter: string | null | undefined, groupBy: string | null | undefined, searchText: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined): Observable<ProjectTimeEntryDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TimeTracking/GetProjectTimeEntries?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (groupBy !== undefined && groupBy !== null)
            url_ += "GroupBy=" + encodeURIComponent("" + groupBy) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectTimeEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectTimeEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTimeEntryDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTimeEntryDtoListIHandleError>;
        }));
    }

    protected processGetProjectTimeEntries(response: HttpResponseBase): Observable<ProjectTimeEntryDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProjectTimeEntryDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectTimeEntryDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addTimeEntry(body: AddTimeEntryInputDto | null | undefined): Observable<TimeEntryDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TimeTracking/AddTimeEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTimeEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTimeEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeEntryDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeEntryDtoIHandleError>;
        }));
    }

    protected processAddTimeEntry(response: HttpResponseBase): Observable<TimeEntryDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TimeEntryDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TimeEntryDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTimeEntry(body: UpdateTimeEntryInputDto | null | undefined): Observable<TimeEntryDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TimeTracking/UpdateTimeEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTimeEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTimeEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeEntryDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeEntryDtoIHandleError>;
        }));
    }

    protected processUpdateTimeEntry(response: HttpResponseBase): Observable<TimeEntryDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TimeEntryDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TimeEntryDtoIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTimeEntry(id: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/TimeTracking/DeleteTimeEntry?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTimeEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTimeEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processDeleteTimeEntry(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param defaultTimezoneScope (optional) 
     * @return Success
     */
    getTimezones(defaultTimezoneScope: any | null | undefined): Observable<NameValueDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope !== undefined && defaultTimezoneScope !== null)
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueDtoListResultDto>;
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<NameValueDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = NameValueDtoListResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueDtoListResultDto>(null as any);
    }

    /**
     * @param selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | null | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined && selectedTimezoneId !== null)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezoneComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDto[]>(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | null | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTwoFactorAuthCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string | null | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken !== undefined && impersonationToken !== null)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }));
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonatedAuthenticateResultModel>(null as any);
    }

    /**
     * @param switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string | null | undefined): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken !== undefined && switchAccountToken !== null)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedAccountAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchedAccountAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchedAccountAuthenticateResultModel>;
        }));
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwitchedAccountAuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | null | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(null as any);
    }

    /**
     * @param message (optional) 
     * @param severity (optional) 
     * @return Success
     */
    testNotification(message: string | null | undefined, severity: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (severity !== undefined && severity !== null)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<UiCustomizationSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UiCustomizationSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UiCustomizationSettingsEditDto>;
        }));
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<UiCustomizationSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UiCustomizationSettingsEditDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UiCustomizationSettingsEditDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUiManagementSettings(body: UiCustomizationSettingsEditDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDefaultUiManagementSettings(body: UiCustomizationSettingsEditDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseSystemDefaultSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param schedules (optional) 
     * @param teams (optional) 
     * @param active (optional) 
     * @param inActive (optional) 
     * @param pendingInvite (optional) 
     * @param role (optional) 
     * @param manager (optional) 
     * @param tenantId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUsers(filter: string | null | undefined, schedules: number[] | null | undefined, teams: number[] | null | undefined, active: boolean | null | undefined, inActive: boolean | null | undefined, pendingInvite: boolean | null | undefined, role: number[] | null | undefined, manager: number[] | null | undefined, tenantId: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<Int32UserListDtoIEnumerableValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (schedules !== undefined && schedules !== null)
            schedules && schedules.forEach(item => { url_ += "Schedules=" + encodeURIComponent("" + item) + "&"; });
        if (teams !== undefined && teams !== null)
            teams && teams.forEach(item => { url_ += "Teams=" + encodeURIComponent("" + item) + "&"; });
        if (active !== undefined && active !== null)
            url_ += "Active=" + encodeURIComponent("" + active) + "&";
        if (inActive !== undefined && inActive !== null)
            url_ += "InActive=" + encodeURIComponent("" + inActive) + "&";
        if (pendingInvite !== undefined && pendingInvite !== null)
            url_ += "PendingInvite=" + encodeURIComponent("" + pendingInvite) + "&";
        if (role !== undefined && role !== null)
            role && role.forEach(item => { url_ += "Role=" + encodeURIComponent("" + item) + "&"; });
        if (manager !== undefined && manager !== null)
            manager && manager.forEach(item => { url_ += "Manager=" + encodeURIComponent("" + item) + "&"; });
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32UserListDtoIEnumerableValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32UserListDtoIEnumerableValueTupleIHandleError>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<Int32UserListDtoIEnumerableValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32UserListDtoIEnumerableValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32UserListDtoIEnumerableValueTupleIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getTenantUsers(): Observable<ActiveUsersListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetTenantUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveUsersListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveUsersListIHandleError>;
        }));
    }

    protected processGetTenantUsers(response: HttpResponseBase): Observable<ActiveUsersListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ActiveUsersListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveUsersListIHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserForEdit(id: number | null | undefined): Observable<UserEditDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEditDto>;
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<UserEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserEditDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserEditDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserPermissionsForEdit(id: number | null | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserPermissionsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserPermissionsForEditOutput>;
        }));
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetUserPermissionsForEditOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserPermissionsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetUserSpecificPermissions(body: Int64EntityDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserSpecificPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserPermissions(body: UpdateUserPermissionsInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUser(body: CreateOrUpdateUserInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param userid (optional) 
     * @return Success
     */
    updateActiveStatus(userid: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateActiveStatus?";
        if (userid !== undefined && userid !== null)
            url_ += "userid=" + encodeURIComponent("" + userid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActiveStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActiveStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateActiveStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    updateIsPromoVisited(): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateIsPromoVisited";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIsPromoVisited(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIsPromoVisited(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateIsPromoVisited(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param userid (optional) 
     * @return Success
     */
    toggleIsDeleteUser(userid: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ToggleIsDeleteUser?";
        if (userid !== undefined && userid !== null)
            url_ += "userid=" + encodeURIComponent("" + userid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleIsDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleIsDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToggleIsDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param userIdsToDelete (optional) 
     * @return Success
     */
    deleteMultipleUsers(userId: number | null | undefined, userIdsToDelete: number[] | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteMultipleUsers?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (userIdsToDelete !== undefined && userIdsToDelete !== null)
            userIdsToDelete && userIdsToDelete.forEach(item => { url_ += "UserIdsToDelete=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMultipleUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMultipleUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processDeleteMultipleUsers(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUser(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockUser(body: Int64EntityDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getUserTimezoneInfo(): Observable<GetUserTimezoneInfoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserTimezoneInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTimezoneInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTimezoneInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserTimezoneInfoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserTimezoneInfoIHandleError>;
        }));
    }

    protected processGetUserTimezoneInfo(response: HttpResponseBase): Observable<GetUserTimezoneInfoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetUserTimezoneInfoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserTimezoneInfoIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getNeedToRelinkUsers(): Observable<RelinkUserOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetNeedToRelinkUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNeedToRelinkUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNeedToRelinkUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelinkUserOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelinkUserOutputDtoListIHandleError>;
        }));
    }

    protected processGetNeedToRelinkUsers(response: HttpResponseBase): Observable<RelinkUserOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RelinkUserOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RelinkUserOutputDtoListIHandleError>(null as any);
    }

    /**
     * @param currentUserId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getUserHoverCardDetails(currentUserId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<UserHoverDetailsIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserHoverCardDetails?";
        if (currentUserId !== undefined && currentUserId !== null)
            url_ += "CurrentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserHoverCardDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserHoverCardDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserHoverDetailsIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserHoverDetailsIHandleError>;
        }));
    }

    protected processGetUserHoverCardDetails(response: HttpResponseBase): Observable<UserHoverDetailsIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserHoverDetailsIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserHoverDetailsIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getUserTimeDetails(): Observable<GetUserTimeDetailsIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserTimeDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserTimeDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserTimeDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserTimeDetailsIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserTimeDetailsIHandleError>;
        }));
    }

    protected processGetUserTimeDetails(response: HttpResponseBase): Observable<GetUserTimeDetailsIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetUserTimeDetailsIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserTimeDetailsIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployee(body: EmployeeEditDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateEmployeeAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateEmployee(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    inviteMember(body: InviteMember | null | undefined): Observable<InviteMemberStatusOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/InviteMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteMember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InviteMemberStatusOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InviteMemberStatusOutputListIHandleError>;
        }));
    }

    protected processInviteMember(response: HttpResponseBase): Observable<InviteMemberStatusOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = InviteMemberStatusOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InviteMemberStatusOutputListIHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getInviteMemberStatus(userId: number | null | undefined, tenantId: number | null | undefined): Observable<InviteMemberStatusOutputListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetInviteMemberStatus?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInviteMemberStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInviteMemberStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InviteMemberStatusOutputListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InviteMemberStatusOutputListIHandleError>;
        }));
    }

    protected processGetInviteMemberStatus(response: HttpResponseBase): Observable<InviteMemberStatusOutputListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = InviteMemberStatusOutputListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InviteMemberStatusOutputListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserPresence(body: UserPresence | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPresence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPresence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPresence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processUpdateUserPresence(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    markUserUnAvailable(): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/MarkUserUnAvailable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkUserUnAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkUserUnAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMarkUserUnAvailable(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param interval (optional) 
     * @return Success
     */
    markUserAutoCheckOut(interval: number | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/MarkUserAutoCheckOut?";
        if (interval !== undefined && interval !== null)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkUserAutoCheckOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkUserAutoCheckOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMarkUserAutoCheckOut(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param teams (optional) 
     * @param moods (optional) 
     * @param inOutType (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAllUsersWithPresence(userId: number | null | undefined, teams: number[] | null | undefined, moods: number[] | null | undefined, inOutType: any | null | undefined, filter: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<Int32GetUsersWithPresenceListValueTupleIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllUsersWithPresence?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (teams !== undefined && teams !== null)
            teams && teams.forEach(item => { url_ += "Teams=" + encodeURIComponent("" + item) + "&"; });
        if (moods !== undefined && moods !== null)
            moods && moods.forEach(item => { url_ += "Moods=" + encodeURIComponent("" + item) + "&"; });
        if (inOutType !== undefined && inOutType !== null)
            url_ += "InOutType=" + encodeURIComponent("" + inOutType) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined && skipCount !== null)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersWithPresence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersWithPresence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32GetUsersWithPresenceListValueTupleIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32GetUsersWithPresenceListValueTupleIHandleError>;
        }));
    }

    protected processGetAllUsersWithPresence(response: HttpResponseBase): Observable<Int32GetUsersWithPresenceListValueTupleIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32GetUsersWithPresenceListValueTupleIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32GetUsersWithPresenceListValueTupleIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getStartedUserInfo(): Observable<GetStartedUserDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetStartedUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStartedUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStartedUserInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStartedUserDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStartedUserDtoIHandleError>;
        }));
    }

    protected processGetStartedUserInfo(response: HttpResponseBase): Observable<GetStartedUserDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetStartedUserDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStartedUserDtoIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getTenantIndustries(): Observable<TenantIndustriesListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetTenantIndustries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantIndustries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantIndustries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantIndustriesListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantIndustriesListIHandleError>;
        }));
    }

    protected processGetTenantIndustries(response: HttpResponseBase): Observable<TenantIndustriesListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TenantIndustriesListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantIndustriesListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveStartedUserInfo(body: GetStartedUserDto | null | undefined): Observable<GetStartedUserDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/SaveStartedUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveStartedUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveStartedUserInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStartedUserDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStartedUserDtoIHandleError>;
        }));
    }

    protected processSaveStartedUserInfo(response: HttpResponseBase): Observable<GetStartedUserDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetStartedUserDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStartedUserDtoIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getCheckinUserInfo(): Observable<CheckinUserOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetCheckinUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckinUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckinUserInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckinUserOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckinUserOutputIHandleError>;
        }));
    }

    protected processGetCheckinUserInfo(response: HttpResponseBase): Observable<CheckinUserOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CheckinUserOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckinUserOutputIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveInMemoryStage(body: CheckinUserStage | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/SaveInMemoryStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveInMemoryStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveInMemoryStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processSaveInMemoryStage(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getCheckinUserStage(): Observable<CheckinUserStageOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetCheckinUserStage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckinUserStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckinUserStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckinUserStageOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckinUserStageOutputIHandleError>;
        }));
    }

    protected processGetCheckinUserStage(response: HttpResponseBase): Observable<CheckinUserStageOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CheckinUserStageOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckinUserStageOutputIHandleError>(null as any);
    }

    /**
     * @param taskDate (optional) 
     * @param userIds (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getUserBreakTime(taskDate: string | null | undefined, userIds: string | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<UserBreakTimeOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserBreakTime?";
        if (taskDate !== undefined && taskDate !== null)
            url_ += "TaskDate=" + encodeURIComponent("" + taskDate) + "&";
        if (userIds !== undefined && userIds !== null)
            url_ += "UserIds=" + encodeURIComponent("" + userIds) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserBreakTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserBreakTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserBreakTimeOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserBreakTimeOutputIHandleError>;
        }));
    }

    protected processGetUserBreakTime(response: HttpResponseBase): Observable<UserBreakTimeOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserBreakTimeOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserBreakTimeOutputIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getAiSuggestedBreak(): Observable<UserMeetingsIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAiSuggestedBreak";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAiSuggestedBreak(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAiSuggestedBreak(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMeetingsIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMeetingsIHandleError>;
        }));
    }

    protected processGetAiSuggestedBreak(response: HttpResponseBase): Observable<UserMeetingsIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserMeetingsIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserMeetingsIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateUserBreak(body: CurrentUserBreakInput | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateUpdateUserBreak";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateUserBreak(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateUserBreak(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCreateUpdateUserBreak(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param breakId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    deleteUserBreak(breakId: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUserBreak?";
        if (breakId !== undefined && breakId !== null)
            url_ += "BreakId=" + encodeURIComponent("" + breakId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserBreak(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserBreak(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processDeleteUserBreak(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getIsUserBreakConflict(startTime: string | null | undefined, endTime: string | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetIsUserBreakConflict?";
        if (startTime !== undefined && startTime !== null)
            url_ += "StartTime=" + encodeURIComponent("" + startTime) + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "EndTime=" + encodeURIComponent("" + endTime) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIsUserBreakConflict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIsUserBreakConflict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processGetIsUserBreakConflict(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markCompleteBreakTime(body: UserBreakDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/MarkCompleteBreakTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkCompleteBreakTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkCompleteBreakTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processMarkCompleteBreakTime(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param workDate (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getUserBreakByWorkDate(workDate: string | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<UserBreakTimeOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserBreakByWorkDate?";
        if (workDate !== undefined && workDate !== null)
            url_ += "WorkDate=" + encodeURIComponent("" + workDate) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserBreakByWorkDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserBreakByWorkDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserBreakTimeOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserBreakTimeOutputIHandleError>;
        }));
    }

    protected processGetUserBreakByWorkDate(response: HttpResponseBase): Observable<UserBreakTimeOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserBreakTimeOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserBreakTimeOutputIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserBreakTime(body: CurrentUserBreakInput | null | undefined): Observable<UserBreakTimeOutputIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserBreakTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserBreakTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserBreakTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserBreakTimeOutputIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserBreakTimeOutputIHandleError>;
        }));
    }

    protected processUpdateUserBreakTime(response: HttpResponseBase): Observable<UserBreakTimeOutputIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserBreakTimeOutputIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserBreakTimeOutputIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserCheckInOut(body: CheckInOutUserInput | null | undefined): Observable<Int32IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateUserCheckInOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserCheckInOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserCheckInOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32IHandleError>;
        }));
    }

    protected processCreateUserCheckInOut(response: HttpResponseBase): Observable<Int32IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = Int32IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getTenantSeatsCount(): Observable<LicenseSeatsCountDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetTenantSeatsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantSeatsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantSeatsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenseSeatsCountDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenseSeatsCountDtoIHandleError>;
        }));
    }

    protected processGetTenantSeatsCount(response: HttpResponseBase): Observable<LicenseSeatsCountDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = LicenseSeatsCountDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenseSeatsCountDtoIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setUserMood(body: UserMoodDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/SetUserMood";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserMood(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserMood(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSetUserMood(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNotifyInterval(body: CheckoutDtl | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/SetNotifyInterval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotifyInterval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotifyInterval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processSetNotifyInterval(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    toggleUserFavourite(body: UserFavouritesDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/ToggleUserFavourite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleUserFavourite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleUserFavourite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processToggleUserFavourite(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @param workDate (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getUserDaySummary(workDate: string | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<UserSummaryOutputDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserDaySummary?";
        if (workDate !== undefined && workDate !== null)
            url_ += "WorkDate=" + encodeURIComponent("" + workDate) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDaySummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDaySummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSummaryOutputDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSummaryOutputDtoIHandleError>;
        }));
    }

    protected processGetUserDaySummary(response: HttpResponseBase): Observable<UserSummaryOutputDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserSummaryOutputDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSummaryOutputDtoIHandleError>(null as any);
    }

    /**
     * @param workDate (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param checkinId (optional) 
     * @return Success
     */
    getUserPreviousDaySummary(workDate: string | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined, checkinId: number | null | undefined): Observable<UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPreviousDaySummary?";
        if (workDate !== undefined && workDate !== null)
            url_ += "WorkDate=" + encodeURIComponent("" + workDate) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (checkinId !== undefined && checkinId !== null)
            url_ += "CheckinId=" + encodeURIComponent("" + checkinId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPreviousDaySummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPreviousDaySummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListIHandleError>;
        }));
    }

    protected processGetUserPreviousDaySummary(response: HttpResponseBase): Observable<UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getUserPreviousDayProductivity(): Observable<UserProductivityDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPreviousDayProductivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPreviousDayProductivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPreviousDayProductivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProductivityDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProductivityDtoIHandleError>;
        }));
    }

    protected processGetUserPreviousDayProductivity(response: HttpResponseBase): Observable<UserProductivityDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserProductivityDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProductivityDtoIHandleError>(null as any);
    }

    /**
     * @param exportType (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getUserWorkHours(exportType: any | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserWorkHours?";
        if (exportType !== undefined && exportType !== null)
            url_ += "ExportType=" + encodeURIComponent("" + exportType) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWorkHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWorkHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetUserWorkHours(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getUserPlannerCategories(): Observable<UserPlannerCategoryDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPlannerCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPlannerCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPlannerCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPlannerCategoryDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPlannerCategoryDtoListIHandleError>;
        }));
    }

    protected processGetUserPlannerCategories(response: HttpResponseBase): Observable<UserPlannerCategoryDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserPlannerCategoryDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPlannerCategoryDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserPlannerCategories(body: CreateUpdateUserPlannerCategoryInputDto | null | undefined): Observable<UserPlannerCategoryDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateUserPlannerCategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserPlannerCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserPlannerCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPlannerCategoryDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPlannerCategoryDtoListIHandleError>;
        }));
    }

    protected processCreateUserPlannerCategories(response: HttpResponseBase): Observable<UserPlannerCategoryDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserPlannerCategoryDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPlannerCategoryDtoListIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    resetUserPlanner(): Observable<UserPlannerCategoryDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserPlanner";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserPlanner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserPlanner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPlannerCategoryDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPlannerCategoryDtoListIHandleError>;
        }));
    }

    protected processResetUserPlanner(response: HttpResponseBase): Observable<UserPlannerCategoryDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserPlannerCategoryDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPlannerCategoryDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUserSettings(body: UserSettingsDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUserSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUserSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUserSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateOrUpdateUserSettings(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getUserSettings(): Observable<UserSettingsDtoIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSettingsDtoIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSettingsDtoIHandleError>;
        }));
    }

    protected processGetUserSettings(response: HttpResponseBase): Observable<UserSettingsDtoIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserSettingsDtoIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSettingsDtoIHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getMyRecentNotes(): Observable<UserRecentNotesOutputDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/GetMyRecentNotes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRecentNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRecentNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRecentNotesOutputDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRecentNotesOutputDtoListIHandleError>;
        }));
    }

    protected processGetMyRecentNotes(response: HttpResponseBase): Observable<UserRecentNotesOutputDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserRecentNotesOutputDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRecentNotesOutputDtoListIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    shareFileByEmail(body: ShareFileByEmailInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/User/ShareFileByEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShareFileByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShareFileByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processShareFileByEmail(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }
}

@Injectable()
export class UserActivityHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserActivityHistory(body: CreateUserHistoryInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/UserActivityHistory/CreateUserActivityHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserActivityHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserActivityHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateUserActivityHistory(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }

    /**
     * @return Success
     */
    getUserSuggestedProject(): Observable<UserSuggestedProjectDtoListIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/UserActivityHistory/GetUserSuggestedProject";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSuggestedProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSuggestedProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSuggestedProjectDtoListIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSuggestedProjectDtoListIHandleError>;
        }));
    }

    protected processGetUserSuggestedProject(response: HttpResponseBase): Observable<UserSuggestedProjectDtoListIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserSuggestedProjectDtoListIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSuggestedProjectDtoListIHandleError>(null as any);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getRecentUserLoginAttempts(): Observable<UserLoginAttemptDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentUserLoginAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentUserLoginAttempts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLoginAttemptDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLoginAttemptDtoListResultDto>;
        }));
    }

    protected processGetRecentUserLoginAttempts(response: HttpResponseBase): Observable<UserLoginAttemptDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserLoginAttemptDtoListResultDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLoginAttemptDtoListResultDto>(null as any);
    }
}

@Injectable()
export class UserNotificationSubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUserNotificationSubscription(body: UserNotificationSubscriptionInputDto | null | undefined): Observable<BooleanIHandleError> {
        let url_ = this.baseUrl + "/api/services/app/UserNotificationSubscription/CreateOrUpdateUserNotificationSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUserNotificationSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUserNotificationSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanIHandleError>;
        }));
    }

    protected processCreateOrUpdateUserNotificationSubscription(response: HttpResponseBase): Observable<BooleanIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = BooleanIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BooleanIHandleError>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notifyUser(body: NotifyUserInput | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/UserNotificationSubscription/NotifyUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processNotifyUser(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }
}

@Injectable()
export class UserProductivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: UserProductivityInputDto | null | undefined): Observable<IHandleError> {
        let url_ = this.baseUrl + "/api/services/app/UserProductivity/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHandleError>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<IHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = IHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IHandleError>(null as any);
    }
}

@Injectable()
export class WebhookServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    stripeWebhook(): Observable<void> {
        let url_ = this.baseUrl + "/api/WebHook/Webhook/stripe-webhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStripeWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStripeWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStripeWebhook(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CheckTeamsConsentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param ssoToken (optional) 
     * @return Success
     */
    checkTeamsConsent(ssoToken: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/WebHook/CheckTeamsConsent/CheckTeamsConsent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (ssoToken !== null && ssoToken !== undefined)
            content_.append("ssoToken", ssoToken.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckTeamsConsent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTeamsConsent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckTeamsConsent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TokenViaTeamsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param access_token (optional) 
     * @return Success
     */
    tokenViaTeams(access_token: StringStringValuesKeyValuePair[] | null | undefined): Observable<TokenDetailIHandleError> {
        let url_ = this.baseUrl + "/api/WebHook/TokenViaTeams/TokenViaTeams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (access_token !== null && access_token !== undefined)
            access_token.forEach(item_ => content_.append("access_token", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTokenViaTeams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTokenViaTeams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenDetailIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenDetailIHandleError>;
        }));
    }

    protected processTokenViaTeams(response: HttpResponseBase): Observable<TokenDetailIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TokenDetailIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenDetailIHandleError>(null as any);
    }
}

@Injectable()
export class ConnectViaTeamsSsoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param form (optional) 
     * @return Success
     */
    connectViaTeamsSso(form: StringStringValuesKeyValuePair[] | null | undefined): Observable<TokenDetailIHandleError> {
        let url_ = this.baseUrl + "/api/WebHook/ConnectViaTeamsSso/ConnectViaTeamsSso";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (form !== null && form !== undefined)
            form.forEach(item_ => content_.append("form", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConnectViaTeamsSso(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConnectViaTeamsSso(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenDetailIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenDetailIHandleError>;
        }));
    }

    protected processConnectViaTeamsSso(response: HttpResponseBase): Observable<TokenDetailIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TokenDetailIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenDetailIHandleError>(null as any);
    }
}

@Injectable()
export class TokenServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param access_token (optional) 
     * @return Success
     */
    token(access_token: StringStringValuesKeyValuePair[] | null | undefined): Observable<TokenDetailIHandleError> {
        let url_ = this.baseUrl + "/api/WebHook/Token/Token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (access_token !== null && access_token !== undefined)
            access_token.forEach(item_ => content_.append("access_token", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenDetailIHandleError>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenDetailIHandleError>;
        }));
    }

    protected processToken(response: HttpResponseBase): Observable<TokenDetailIHandleError> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = TokenDetailIHandleError.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenDetailIHandleError>(null as any);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestWebLogsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestWebLogsOutput>;
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = GetLatestWebLogsOutput.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLatestWebLogsOutput>(null as any);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class WorkspaceGridLayoutServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getDefault(gridName: string): Observable<WorkspaceGridLayoutDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkspaceGridLayout/GetDefault?";
        if (gridName === undefined || gridName === null)
            throw new globalThis.Error("The parameter 'gridName' must be defined and cannot be null.");
        else
            url_ += "GridName=" + encodeURIComponent("" + gridName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceGridLayoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceGridLayoutDto>;
        }));
    }

    protected processGetDefault(response: HttpResponseBase): Observable<WorkspaceGridLayoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceGridLayoutDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkspaceGridLayoutDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveAsWorkspaceDefault(body: SaveWorkspaceGridLayoutInput | null | undefined): Observable<WorkspaceGridLayoutDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkspaceGridLayout/SaveAsWorkspaceDefault";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAsWorkspaceDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAsWorkspaceDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceGridLayoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceGridLayoutDto>;
        }));
    }

    protected processSaveAsWorkspaceDefault(response: HttpResponseBase): Observable<WorkspaceGridLayoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceGridLayoutDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkspaceGridLayoutDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetWorkspaceDefault(body: ResetWorkspaceGridLayoutInput | null | undefined): Observable<WorkspaceGridLayoutDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkspaceGridLayout/ResetWorkspaceDefault";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetWorkspaceDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetWorkspaceDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceGridLayoutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceGridLayoutDto>;
        }));
    }

    protected processResetWorkspaceDefault(response: HttpResponseBase): Observable<WorkspaceGridLayoutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceGridLayoutDto.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkspaceGridLayoutDto>(null as any);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any, _mappings?: any): IsTenantAvailableInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IsTenantAvailableInput>(data, _mappings, IsTenantAvailableInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState | undefined;
    tenantId!: number | undefined;
    serverRootAddress!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
            this.serverRootAddress = _data["serverRootAddress"];
        }
    }

    static fromJS(data: any, _mappings?: any): IsTenantAvailableOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IsTenantAvailableOutput>(data, _mappings, IsTenantAvailableOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState | undefined;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c!: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.c = _data["c"];
        }
    }

    static fromJS(data: any, _mappings?: any): ResolveTenantIdInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ResolveTenantIdInput>(data, _mappings, ResolveTenantIdInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any, _mappings?: any): RegisterInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RegisterInput>(data, _mappings, RegisterInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean | undefined;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any, _mappings?: any): RegisterOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RegisterOutput>(data, _mappings, RegisterOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }
}

export interface IRegisterOutput {
    canLogin: boolean | undefined;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any, _mappings?: any): SendPasswordResetCodeInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SendPasswordResetCodeInput>(data, _mappings, SendPasswordResetCodeInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class IHandleError implements IIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    fieldName!: string | undefined;

    constructor(data?: IIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.fieldName = _data["fieldName"];
        }
    }

    static fromJS(data: any, _mappings?: any): IHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IHandleError>(data, _mappings, IHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["fieldName"] = this.fieldName;
        return data;
    }
}

export interface IIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    fieldName: string | undefined;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number | undefined;
    resetCode!: string | undefined;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.password = _data["password"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any, _mappings?: any): ResetPasswordInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ResetPasswordInput>(data, _mappings, ResetPasswordInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    }
}

export interface IResetPasswordInput {
    userId: number | undefined;
    resetCode: string | undefined;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean | undefined;
    userName!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ResetPasswordOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ResetPasswordOutput>(data, _mappings, ResetPasswordOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean | undefined;
    userName: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any, _mappings?: any): SendEmailActivationLinkInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SendEmailActivationLinkInput>(data, _mappings, SendEmailActivationLinkInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number | undefined;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any, _mappings?: any): ActivateEmailInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ActivateEmailInput>(data, _mappings, ActivateEmailInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    }
}

export interface IActivateEmailInput {
    userId: number | undefined;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId!: number | undefined;
    userId!: number | undefined;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ImpersonateInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ImpersonateInput>(data, _mappings, ImpersonateInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateInput {
    tenantId: number | undefined;
    userId: number | undefined;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.impersonationToken = _data["impersonationToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ImpersonateOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ImpersonateOutput>(data, _mappings, ImpersonateOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId!: number | undefined;
    targetUserId!: number | undefined;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.targetTenantId = _data["targetTenantId"];
            this.targetUserId = _data["targetUserId"];
        }
    }

    static fromJS(data: any, _mappings?: any): SwitchToLinkedAccountInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SwitchToLinkedAccountInput>(data, _mappings, SwitchToLinkedAccountInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number | undefined;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.switchAccountToken = _data["switchAccountToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any, _mappings?: any): SwitchToLinkedAccountOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SwitchToLinkedAccountOutput>(data, _mappings, SwitchToLinkedAccountOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export class SortOrderInput implements ISortOrderInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    keyId!: number | undefined;
    tblId!: number | undefined;
    sortOrder!: number | undefined;
    stageCode!: number | undefined;
    taskDate!: string | undefined;

    constructor(data?: ISortOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.keyId = _data["keyId"];
            this.tblId = _data["tblId"];
            this.sortOrder = _data["sortOrder"];
            this.stageCode = _data["stageCode"];
            this.taskDate = _data["taskDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): SortOrderInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SortOrderInput>(data, _mappings, SortOrderInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["keyId"] = this.keyId;
        data["tblId"] = this.tblId;
        data["sortOrder"] = this.sortOrder;
        data["stageCode"] = this.stageCode;
        data["taskDate"] = this.taskDate;
        return data;
    }
}

export interface ISortOrderInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    keyId: number | undefined;
    tblId: number | undefined;
    sortOrder: number | undefined;
    stageCode: number | undefined;
    taskDate: string | undefined;
}

export enum ErrorTypes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class BooleanIHandleError implements IBooleanIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: boolean | undefined;
    listOfEntities!: boolean[] | undefined;

    constructor(data?: IBooleanIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"];
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): BooleanIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BooleanIHandleError>(data, _mappings, BooleanIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IBooleanIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: boolean | undefined;
    listOfEntities: boolean[] | undefined;
}

export class IndexedOrder implements IIndexedOrder {
    keyId!: number | undefined;
    tblId!: number | undefined;
    sortOrder!: number | undefined;

    constructor(data?: IIndexedOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.keyId = _data["keyId"];
            this.tblId = _data["tblId"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): IndexedOrder | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IndexedOrder>(data, _mappings, IndexedOrder);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyId"] = this.keyId;
        data["tblId"] = this.tblId;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IIndexedOrder {
    keyId: number | undefined;
    tblId: number | undefined;
    sortOrder: number | undefined;
}

export class SortOrderIndexedInput implements ISortOrderIndexedInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    orders!: IndexedOrder[] | undefined;

    constructor(data?: ISortOrderIndexedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(IndexedOrder.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SortOrderIndexedInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SortOrderIndexedInput>(data, _mappings, SortOrderIndexedInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISortOrderIndexedInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    orders: IndexedOrder[] | undefined;
}

export class TeamCountsTeamCardListValueTuple implements ITeamCountsTeamCardListValueTuple {

    constructor(data?: ITeamCountsTeamCardListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): TeamCountsTeamCardListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TeamCountsTeamCardListValueTuple>(data, _mappings, TeamCountsTeamCardListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITeamCountsTeamCardListValueTuple {
}

export class TeamCountsTeamCardListValueTupleIHandleError implements ITeamCountsTeamCardListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TeamCountsTeamCardListValueTuple | undefined;
    listOfEntities!: TeamCountsTeamCardListValueTuple[] | undefined;

    constructor(data?: ITeamCountsTeamCardListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TeamCountsTeamCardListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TeamCountsTeamCardListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TeamCountsTeamCardListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TeamCountsTeamCardListValueTupleIHandleError>(data, _mappings, TeamCountsTeamCardListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITeamCountsTeamCardListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TeamCountsTeamCardListValueTuple | undefined;
    listOfEntities: TeamCountsTeamCardListValueTuple[] | undefined;
}

export enum InOutType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class UserHoverDetails implements IUserHoverDetails {
    userId!: number | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    email!: string | undefined;
    statusCode!: number | undefined;
    profilePictureUrl!: string | undefined;
    initials!: string | undefined;
    teams!: string | undefined;
    currentBreakSchedule!: string | undefined;
    currentCheckInOutDt!: string | undefined;
    workSchedule!: string | undefined;
    jobTitle!: string | undefined;
    countryName!: string | undefined;
    cityName!: string | undefined;
    timeDifference!: number | undefined;
    dateHired!: string | undefined;
    managerId!: number | undefined;
    managerFullName!: string | undefined;
    managerInitial!: string | undefined;
    managerJobTitle!: string | undefined;
    managerProfileLink!: string | undefined;
    managerStatusCode!: number | undefined;

    constructor(data?: IUserHoverDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.statusCode = _data["statusCode"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.initials = _data["initials"];
            this.teams = _data["teams"];
            this.currentBreakSchedule = _data["currentBreakSchedule"];
            this.currentCheckInOutDt = _data["currentCheckInOutDt"];
            this.workSchedule = _data["workSchedule"];
            this.jobTitle = _data["jobTitle"];
            this.countryName = _data["countryName"];
            this.cityName = _data["cityName"];
            this.timeDifference = _data["timeDifference"];
            this.dateHired = _data["dateHired"];
            this.managerId = _data["managerId"];
            this.managerFullName = _data["managerFullName"];
            this.managerInitial = _data["managerInitial"];
            this.managerJobTitle = _data["managerJobTitle"];
            this.managerProfileLink = _data["managerProfileLink"];
            this.managerStatusCode = _data["managerStatusCode"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserHoverDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserHoverDetails>(data, _mappings, UserHoverDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["statusCode"] = this.statusCode;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["initials"] = this.initials;
        data["teams"] = this.teams;
        data["currentBreakSchedule"] = this.currentBreakSchedule;
        data["currentCheckInOutDt"] = this.currentCheckInOutDt;
        data["workSchedule"] = this.workSchedule;
        data["jobTitle"] = this.jobTitle;
        data["countryName"] = this.countryName;
        data["cityName"] = this.cityName;
        data["timeDifference"] = this.timeDifference;
        data["dateHired"] = this.dateHired;
        data["managerId"] = this.managerId;
        data["managerFullName"] = this.managerFullName;
        data["managerInitial"] = this.managerInitial;
        data["managerJobTitle"] = this.managerJobTitle;
        data["managerProfileLink"] = this.managerProfileLink;
        data["managerStatusCode"] = this.managerStatusCode;
        return data;
    }
}

export interface IUserHoverDetails {
    userId: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    email: string | undefined;
    statusCode: number | undefined;
    profilePictureUrl: string | undefined;
    initials: string | undefined;
    teams: string | undefined;
    currentBreakSchedule: string | undefined;
    currentCheckInOutDt: string | undefined;
    workSchedule: string | undefined;
    jobTitle: string | undefined;
    countryName: string | undefined;
    cityName: string | undefined;
    timeDifference: number | undefined;
    dateHired: string | undefined;
    managerId: number | undefined;
    managerFullName: string | undefined;
    managerInitial: string | undefined;
    managerJobTitle: string | undefined;
    managerProfileLink: string | undefined;
    managerStatusCode: number | undefined;
}

export class GetUsersCheckinDetail implements IGetUsersCheckinDetail {
    userId!: number | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    status!: string | undefined;
    statusCode!: number | undefined;
    checkInDateAsCurrentUserTimezone!: string | undefined;
    checkInDate!: string | undefined;
    workDate!: string | undefined;
    breakAsCompanyTimezone!: string | undefined;
    breakAsCurrentUserTimezone!: string | undefined;
    breakEndAsCompanyTimezone!: string | undefined;
    breakEndAsCurrentUserTimezone!: string | undefined;
    isBreakNow!: boolean | undefined;
    startTimeAsCurrentUserTimezone!: string | undefined;
    endTimeAsCurrentUserTimezone!: string | undefined;
    startTimeAsCompanyTimezone!: string | undefined;
    endTimeAsCompanytTimezone!: string | undefined;
    timeLeft!: string | undefined;
    workLocation!: string | undefined;
    checkInTimeAsCurrentUserTimezone!: string | undefined;
    checkInTimeAsCompanyTimezone!: string | undefined;
    isLate!: boolean | undefined;
    checkedOutTimeAsCurrentUserTimezone!: string | undefined;
    checkedOutTimeAsCompanyTimezone!: string | undefined;
    checkinId!: number | undefined;
    profileBytes!: string | undefined;
    readonly profileString!: string | undefined;
    profilePictureUrl!: string | undefined;
    initials!: string | undefined;
    workSummary!: string | undefined;
    blockerChallenges!: string | undefined;
    plansTomorrow!: string | undefined;
    userHoverDetails!: string | undefined;
    userDetails!: UserHoverDetails | undefined;
    totalTasksCount!: number | undefined;
    totalUnfinishedTasksCount!: number | undefined;
    totalCompletedTasksCount!: number | undefined;
    totalInProgressTasksCount!: number | undefined;
    totalOverDueTasksCount!: number | undefined;
    totalMeetingsCount!: number | undefined;
    taskProgressInPercentage!: number | undefined;
    isTodayCheckin!: boolean | undefined;
    isShowReport!: boolean | undefined;

    constructor(data?: IGetUsersCheckinDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.checkInDateAsCurrentUserTimezone = _data["checkInDateAsCurrentUserTimezone"];
            this.checkInDate = _data["checkInDate"];
            this.workDate = _data["workDate"];
            this.breakAsCompanyTimezone = _data["breakAsCompanyTimezone"];
            this.breakAsCurrentUserTimezone = _data["breakAsCurrentUserTimezone"];
            this.breakEndAsCompanyTimezone = _data["breakEndAsCompanyTimezone"];
            this.breakEndAsCurrentUserTimezone = _data["breakEndAsCurrentUserTimezone"];
            this.isBreakNow = _data["isBreakNow"];
            this.startTimeAsCurrentUserTimezone = _data["startTimeAsCurrentUserTimezone"];
            this.endTimeAsCurrentUserTimezone = _data["endTimeAsCurrentUserTimezone"];
            this.startTimeAsCompanyTimezone = _data["startTimeAsCompanyTimezone"];
            this.endTimeAsCompanytTimezone = _data["endTimeAsCompanytTimezone"];
            this.timeLeft = _data["timeLeft"];
            this.workLocation = _data["workLocation"];
            this.checkInTimeAsCurrentUserTimezone = _data["checkInTimeAsCurrentUserTimezone"];
            this.checkInTimeAsCompanyTimezone = _data["checkInTimeAsCompanyTimezone"];
            this.isLate = _data["isLate"];
            this.checkedOutTimeAsCurrentUserTimezone = _data["checkedOutTimeAsCurrentUserTimezone"];
            this.checkedOutTimeAsCompanyTimezone = _data["checkedOutTimeAsCompanyTimezone"];
            this.checkinId = _data["checkinId"];
            this.profileBytes = _data["profileBytes"];
            (this as any).profileString = _data["profileString"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.initials = _data["initials"];
            this.workSummary = _data["workSummary"];
            this.blockerChallenges = _data["blockerChallenges"];
            this.plansTomorrow = _data["plansTomorrow"];
            this.userHoverDetails = _data["userHoverDetails"];
            this.userDetails = _data["userDetails"] ? UserHoverDetails.fromJS(_data["userDetails"], _mappings) : undefined as any;
            this.totalTasksCount = _data["totalTasksCount"];
            this.totalUnfinishedTasksCount = _data["totalUnfinishedTasksCount"];
            this.totalCompletedTasksCount = _data["totalCompletedTasksCount"];
            this.totalInProgressTasksCount = _data["totalInProgressTasksCount"];
            this.totalOverDueTasksCount = _data["totalOverDueTasksCount"];
            this.totalMeetingsCount = _data["totalMeetingsCount"];
            this.taskProgressInPercentage = _data["taskProgressInPercentage"];
            this.isTodayCheckin = _data["isTodayCheckin"];
            this.isShowReport = _data["isShowReport"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetUsersCheckinDetail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUsersCheckinDetail>(data, _mappings, GetUsersCheckinDetail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["checkInDateAsCurrentUserTimezone"] = this.checkInDateAsCurrentUserTimezone;
        data["checkInDate"] = this.checkInDate;
        data["workDate"] = this.workDate;
        data["breakAsCompanyTimezone"] = this.breakAsCompanyTimezone;
        data["breakAsCurrentUserTimezone"] = this.breakAsCurrentUserTimezone;
        data["breakEndAsCompanyTimezone"] = this.breakEndAsCompanyTimezone;
        data["breakEndAsCurrentUserTimezone"] = this.breakEndAsCurrentUserTimezone;
        data["isBreakNow"] = this.isBreakNow;
        data["startTimeAsCurrentUserTimezone"] = this.startTimeAsCurrentUserTimezone;
        data["endTimeAsCurrentUserTimezone"] = this.endTimeAsCurrentUserTimezone;
        data["startTimeAsCompanyTimezone"] = this.startTimeAsCompanyTimezone;
        data["endTimeAsCompanytTimezone"] = this.endTimeAsCompanytTimezone;
        data["timeLeft"] = this.timeLeft;
        data["workLocation"] = this.workLocation;
        data["checkInTimeAsCurrentUserTimezone"] = this.checkInTimeAsCurrentUserTimezone;
        data["checkInTimeAsCompanyTimezone"] = this.checkInTimeAsCompanyTimezone;
        data["isLate"] = this.isLate;
        data["checkedOutTimeAsCurrentUserTimezone"] = this.checkedOutTimeAsCurrentUserTimezone;
        data["checkedOutTimeAsCompanyTimezone"] = this.checkedOutTimeAsCompanyTimezone;
        data["checkinId"] = this.checkinId;
        data["profileBytes"] = this.profileBytes;
        data["profileString"] = this.profileString;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["initials"] = this.initials;
        data["workSummary"] = this.workSummary;
        data["blockerChallenges"] = this.blockerChallenges;
        data["plansTomorrow"] = this.plansTomorrow;
        data["userHoverDetails"] = this.userHoverDetails;
        data["userDetails"] = this.userDetails ? this.userDetails.toJSON() : undefined as any;
        data["totalTasksCount"] = this.totalTasksCount;
        data["totalUnfinishedTasksCount"] = this.totalUnfinishedTasksCount;
        data["totalCompletedTasksCount"] = this.totalCompletedTasksCount;
        data["totalInProgressTasksCount"] = this.totalInProgressTasksCount;
        data["totalOverDueTasksCount"] = this.totalOverDueTasksCount;
        data["totalMeetingsCount"] = this.totalMeetingsCount;
        data["taskProgressInPercentage"] = this.taskProgressInPercentage;
        data["isTodayCheckin"] = this.isTodayCheckin;
        data["isShowReport"] = this.isShowReport;
        return data;
    }
}

export interface IGetUsersCheckinDetail {
    userId: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    status: string | undefined;
    statusCode: number | undefined;
    checkInDateAsCurrentUserTimezone: string | undefined;
    checkInDate: string | undefined;
    workDate: string | undefined;
    breakAsCompanyTimezone: string | undefined;
    breakAsCurrentUserTimezone: string | undefined;
    breakEndAsCompanyTimezone: string | undefined;
    breakEndAsCurrentUserTimezone: string | undefined;
    isBreakNow: boolean | undefined;
    startTimeAsCurrentUserTimezone: string | undefined;
    endTimeAsCurrentUserTimezone: string | undefined;
    startTimeAsCompanyTimezone: string | undefined;
    endTimeAsCompanytTimezone: string | undefined;
    timeLeft: string | undefined;
    workLocation: string | undefined;
    checkInTimeAsCurrentUserTimezone: string | undefined;
    checkInTimeAsCompanyTimezone: string | undefined;
    isLate: boolean | undefined;
    checkedOutTimeAsCurrentUserTimezone: string | undefined;
    checkedOutTimeAsCompanyTimezone: string | undefined;
    checkinId: number | undefined;
    profileBytes: string | undefined;
    profileString: string | undefined;
    profilePictureUrl: string | undefined;
    initials: string | undefined;
    workSummary: string | undefined;
    blockerChallenges: string | undefined;
    plansTomorrow: string | undefined;
    userHoverDetails: string | undefined;
    userDetails: UserHoverDetails | undefined;
    totalTasksCount: number | undefined;
    totalUnfinishedTasksCount: number | undefined;
    totalCompletedTasksCount: number | undefined;
    totalInProgressTasksCount: number | undefined;
    totalOverDueTasksCount: number | undefined;
    totalMeetingsCount: number | undefined;
    taskProgressInPercentage: number | undefined;
    isTodayCheckin: boolean | undefined;
    isShowReport: boolean | undefined;
}

export class UserAgendaDtl implements IUserAgendaDtl {
    agenda!: GetUsersCheckinDetail | undefined;

    constructor(data?: IUserAgendaDtl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.agenda = _data["agenda"] ? GetUsersCheckinDetail.fromJS(_data["agenda"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): UserAgendaDtl | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserAgendaDtl>(data, _mappings, UserAgendaDtl);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agenda"] = this.agenda ? this.agenda.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserAgendaDtl {
    agenda: GetUsersCheckinDetail | undefined;
}

export class UserCheckInDtl implements IUserCheckInDtl {
    checkinDt!: string | undefined;
    agendas!: UserAgendaDtl[] | undefined;

    constructor(data?: IUserCheckInDtl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.checkinDt = _data["checkinDt"];
            if (Array.isArray(_data["agendas"])) {
                this.agendas = [] as any;
                for (let item of _data["agendas"])
                    this.agendas!.push(UserAgendaDtl.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserCheckInDtl | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserCheckInDtl>(data, _mappings, UserCheckInDtl);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkinDt"] = this.checkinDt;
        if (Array.isArray(this.agendas)) {
            data["agendas"] = [];
            for (let item of this.agendas)
                data["agendas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserCheckInDtl {
    checkinDt: string | undefined;
    agendas: UserAgendaDtl[] | undefined;
}

export class GetUserCounts implements IGetUserCounts {
    countType!: string | undefined;
    counts!: number | undefined;

    constructor(data?: IGetUserCounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.countType = _data["countType"];
            this.counts = _data["counts"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserCounts | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserCounts>(data, _mappings, GetUserCounts);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countType"] = this.countType;
        data["counts"] = this.counts;
        return data;
    }
}

export interface IGetUserCounts {
    countType: string | undefined;
    counts: number | undefined;
}

export class UserCheckin implements IUserCheckin {
    thoughtOfTheDay!: string | undefined;
    userCheckinDtl!: UserCheckInDtl[] | undefined;
    counts!: GetUserCounts[] | undefined;
    total!: number | undefined;
    writtenBy!: string | undefined;

    constructor(data?: IUserCheckin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.thoughtOfTheDay = _data["thoughtOfTheDay"];
            if (Array.isArray(_data["userCheckinDtl"])) {
                this.userCheckinDtl = [] as any;
                for (let item of _data["userCheckinDtl"])
                    this.userCheckinDtl!.push(UserCheckInDtl.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["counts"])) {
                this.counts = [] as any;
                for (let item of _data["counts"])
                    this.counts!.push(GetUserCounts.fromJS(item, _mappings));
            }
            this.total = _data["total"];
            this.writtenBy = _data["writtenBy"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserCheckin | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserCheckin>(data, _mappings, UserCheckin);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thoughtOfTheDay"] = this.thoughtOfTheDay;
        if (Array.isArray(this.userCheckinDtl)) {
            data["userCheckinDtl"] = [];
            for (let item of this.userCheckinDtl)
                data["userCheckinDtl"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.counts)) {
            data["counts"] = [];
            for (let item of this.counts)
                data["counts"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["writtenBy"] = this.writtenBy;
        return data;
    }
}

export interface IUserCheckin {
    thoughtOfTheDay: string | undefined;
    userCheckinDtl: UserCheckInDtl[] | undefined;
    counts: GetUserCounts[] | undefined;
    total: number | undefined;
    writtenBy: string | undefined;
}

export class UserCheckinIHandleError implements IUserCheckinIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserCheckin | undefined;
    listOfEntities!: UserCheckin[] | undefined;

    constructor(data?: IUserCheckinIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserCheckin.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserCheckin.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserCheckinIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserCheckinIHandleError>(data, _mappings, UserCheckinIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserCheckinIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserCheckin | undefined;
    listOfEntities: UserCheckin[] | undefined;
}

export class TaskCompletionListWorkSummariesListValueTuple implements ITaskCompletionListWorkSummariesListValueTuple {

    constructor(data?: ITaskCompletionListWorkSummariesListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): TaskCompletionListWorkSummariesListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskCompletionListWorkSummariesListValueTuple>(data, _mappings, TaskCompletionListWorkSummariesListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITaskCompletionListWorkSummariesListValueTuple {
}

export class TaskCompletionListWorkSummariesListIHandleError implements ITaskCompletionListWorkSummariesListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    message_Info!: string | undefined;
    responseData!: TaskCompletionListWorkSummariesListValueTuple | undefined;

    constructor(data?: ITaskCompletionListWorkSummariesListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TaskCompletionListWorkSummariesListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): TaskCompletionListWorkSummariesListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskCompletionListWorkSummariesListIHandleError>(data, _mappings, TaskCompletionListWorkSummariesListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaskCompletionListWorkSummariesListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    message_Info: string | undefined;
    responseData: TaskCompletionListWorkSummariesListValueTuple | undefined;
}

export class TaskCountsListGetUserAgendaOutputListValueTuple implements ITaskCountsListGetUserAgendaOutputListValueTuple {

    constructor(data?: ITaskCountsListGetUserAgendaOutputListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): TaskCountsListGetUserAgendaOutputListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskCountsListGetUserAgendaOutputListValueTuple>(data, _mappings, TaskCountsListGetUserAgendaOutputListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITaskCountsListGetUserAgendaOutputListValueTuple {
}

export class TaskCountsListGetUserAgendaOutputListValueTupleIHandleError implements ITaskCountsListGetUserAgendaOutputListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskCountsListGetUserAgendaOutputListValueTuple | undefined;
    listOfEntities!: TaskCountsListGetUserAgendaOutputListValueTuple[] | undefined;

    constructor(data?: ITaskCountsListGetUserAgendaOutputListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TaskCountsListGetUserAgendaOutputListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TaskCountsListGetUserAgendaOutputListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskCountsListGetUserAgendaOutputListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskCountsListGetUserAgendaOutputListValueTupleIHandleError>(data, _mappings, TaskCountsListGetUserAgendaOutputListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskCountsListGetUserAgendaOutputListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskCountsListGetUserAgendaOutputListValueTuple | undefined;
    listOfEntities: TaskCountsListGetUserAgendaOutputListValueTuple[] | undefined;
}

export class Int32TaskCompletionListValueTuple implements IInt32TaskCompletionListValueTuple {

    constructor(data?: IInt32TaskCompletionListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): Int32TaskCompletionListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32TaskCompletionListValueTuple>(data, _mappings, Int32TaskCompletionListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IInt32TaskCompletionListValueTuple {
}

export class Int32TaskCompletionListValueTupleIHandleError implements IInt32TaskCompletionListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: Int32TaskCompletionListValueTuple | undefined;
    listOfEntities!: Int32TaskCompletionListValueTuple[] | undefined;

    constructor(data?: IInt32TaskCompletionListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? Int32TaskCompletionListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(Int32TaskCompletionListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32TaskCompletionListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32TaskCompletionListValueTupleIHandleError>(data, _mappings, Int32TaskCompletionListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInt32TaskCompletionListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: Int32TaskCompletionListValueTuple | undefined;
    listOfEntities: Int32TaskCompletionListValueTuple[] | undefined;
}

export enum TaskFilterDaysType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum TaskFilterStatusType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TodosTaskGroupDtoListTodosTaskListValueTuple implements ITodosTaskGroupDtoListTodosTaskListValueTuple {

    constructor(data?: ITodosTaskGroupDtoListTodosTaskListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): TodosTaskGroupDtoListTodosTaskListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTaskGroupDtoListTodosTaskListValueTuple>(data, _mappings, TodosTaskGroupDtoListTodosTaskListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITodosTaskGroupDtoListTodosTaskListValueTuple {
}

export class TodosTaskGroupDtoListTodosTaskListValueTupleIHandleError implements ITodosTaskGroupDtoListTodosTaskListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TodosTaskGroupDtoListTodosTaskListValueTuple | undefined;
    listOfEntities!: TodosTaskGroupDtoListTodosTaskListValueTuple[] | undefined;

    constructor(data?: ITodosTaskGroupDtoListTodosTaskListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TodosTaskGroupDtoListTodosTaskListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TodosTaskGroupDtoListTodosTaskListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TodosTaskGroupDtoListTodosTaskListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTaskGroupDtoListTodosTaskListValueTupleIHandleError>(data, _mappings, TodosTaskGroupDtoListTodosTaskListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITodosTaskGroupDtoListTodosTaskListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TodosTaskGroupDtoListTodosTaskListValueTuple | undefined;
    listOfEntities: TodosTaskGroupDtoListTodosTaskListValueTuple[] | undefined;
}

export class UserSectionsDtoListGetMyDayOutputListValueTuple implements IUserSectionsDtoListGetMyDayOutputListValueTuple {

    constructor(data?: IUserSectionsDtoListGetMyDayOutputListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): UserSectionsDtoListGetMyDayOutputListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserSectionsDtoListGetMyDayOutputListValueTuple>(data, _mappings, UserSectionsDtoListGetMyDayOutputListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUserSectionsDtoListGetMyDayOutputListValueTuple {
}

export class UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError implements IUserSectionsDtoListGetMyDayOutputListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserSectionsDtoListGetMyDayOutputListValueTuple | undefined;
    listOfEntities!: UserSectionsDtoListGetMyDayOutputListValueTuple[] | undefined;

    constructor(data?: IUserSectionsDtoListGetMyDayOutputListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserSectionsDtoListGetMyDayOutputListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserSectionsDtoListGetMyDayOutputListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError>(data, _mappings, UserSectionsDtoListGetMyDayOutputListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserSectionsDtoListGetMyDayOutputListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserSectionsDtoListGetMyDayOutputListValueTuple | undefined;
    listOfEntities: UserSectionsDtoListGetMyDayOutputListValueTuple[] | undefined;
}

export class UserSectionIdeasOutputListIdeasTitleDescriptionListValueTuple implements IUserSectionIdeasOutputListIdeasTitleDescriptionListValueTuple {

    constructor(data?: IUserSectionIdeasOutputListIdeasTitleDescriptionListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): UserSectionIdeasOutputListIdeasTitleDescriptionListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserSectionIdeasOutputListIdeasTitleDescriptionListValueTuple>(data, _mappings, UserSectionIdeasOutputListIdeasTitleDescriptionListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUserSectionIdeasOutputListIdeasTitleDescriptionListValueTuple {
}

export class UserSectionIdeasOutputListIdeasTitleDescriptionListValueTupleIHandleError implements IUserSectionIdeasOutputListIdeasTitleDescriptionListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserSectionIdeasOutputListIdeasTitleDescriptionListValueTuple | undefined;
    listOfEntities!: UserSectionIdeasOutputListIdeasTitleDescriptionListValueTuple[] | undefined;

    constructor(data?: IUserSectionIdeasOutputListIdeasTitleDescriptionListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserSectionIdeasOutputListIdeasTitleDescriptionListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserSectionIdeasOutputListIdeasTitleDescriptionListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserSectionIdeasOutputListIdeasTitleDescriptionListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserSectionIdeasOutputListIdeasTitleDescriptionListValueTupleIHandleError>(data, _mappings, UserSectionIdeasOutputListIdeasTitleDescriptionListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserSectionIdeasOutputListIdeasTitleDescriptionListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserSectionIdeasOutputListIdeasTitleDescriptionListValueTuple | undefined;
    listOfEntities: UserSectionIdeasOutputListIdeasTitleDescriptionListValueTuple[] | undefined;
}

export class CreateOrUpdateUserSectionsInput implements ICreateOrUpdateUserSectionsInput {
    userId!: number | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;

    constructor(data?: ICreateOrUpdateUserSectionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateOrUpdateUserSectionsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateOrUpdateUserSectionsInput>(data, _mappings, CreateOrUpdateUserSectionsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        return data;
    }
}

export interface ICreateOrUpdateUserSectionsInput {
    userId: number | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
}

export class UpdateTaskMyDaySection implements IUpdateTaskMyDaySection {
    userId!: number | undefined;
    taskId!: number | undefined;
    sectionId!: number | undefined;

    constructor(data?: IUpdateTaskMyDaySection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.taskId = _data["taskId"];
            this.sectionId = _data["sectionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateTaskMyDaySection | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateTaskMyDaySection>(data, _mappings, UpdateTaskMyDaySection);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["taskId"] = this.taskId;
        data["sectionId"] = this.sectionId;
        return data;
    }
}

export interface IUpdateTaskMyDaySection {
    userId: number | undefined;
    taskId: number | undefined;
    sectionId: number | undefined;
}

export class UserSectionsDto implements IUserSectionsDto {
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    taskCount!: number | undefined;
    sortOrder!: number | undefined;

    constructor(data?: IUserSectionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.taskCount = _data["taskCount"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserSectionsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserSectionsDto>(data, _mappings, UserSectionsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["taskCount"] = this.taskCount;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IUserSectionsDto {
    sectionId: number | undefined;
    sectionName: string | undefined;
    taskCount: number | undefined;
    sortOrder: number | undefined;
}

export class UserSectionsDtoListIHandleError implements IUserSectionsDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserSectionsDto[] | undefined;
    listOfEntities!: UserSectionsDto[][] | undefined;

    constructor(data?: IUserSectionsDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(UserSectionsDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserSectionsDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserSectionsDtoListIHandleError>(data, _mappings, UserSectionsDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IUserSectionsDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserSectionsDto[] | undefined;
    listOfEntities: UserSectionsDto[][] | undefined;
}

export enum DayListSorting {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class UpdateIsSeenDto implements IUpdateIsSeenDto {
    id!: number | undefined;
    userId!: number | undefined;
    isUpdateAll!: boolean | undefined;

    constructor(data?: IUpdateIsSeenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.isUpdateAll = _data["isUpdateAll"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateIsSeenDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateIsSeenDto>(data, _mappings, UpdateIsSeenDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["isUpdateAll"] = this.isUpdateAll;
        return data;
    }
}

export interface IUpdateIsSeenDto {
    id: number | undefined;
    userId: number | undefined;
    isUpdateAll: boolean | undefined;
}

export class TaskManagementSettings implements ITaskManagementSettings {
    code!: number | undefined;
    value!: number | undefined;

    constructor(data?: ITaskManagementSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.code = _data["code"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskManagementSettings | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskManagementSettings>(data, _mappings, TaskManagementSettings);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["value"] = this.value;
        return data;
    }
}

export interface ITaskManagementSettings {
    code: number | undefined;
    value: number | undefined;
}

export class CreateUpdateTaskManagementSettingsInput implements ICreateUpdateTaskManagementSettingsInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    managementSettings!: TaskManagementSettings[] | undefined;

    constructor(data?: ICreateUpdateTaskManagementSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            if (Array.isArray(_data["managementSettings"])) {
                this.managementSettings = [] as any;
                for (let item of _data["managementSettings"])
                    this.managementSettings!.push(TaskManagementSettings.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateUpdateTaskManagementSettingsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateUpdateTaskManagementSettingsInput>(data, _mappings, CreateUpdateTaskManagementSettingsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        if (Array.isArray(this.managementSettings)) {
            data["managementSettings"] = [];
            for (let item of this.managementSettings)
                data["managementSettings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateUpdateTaskManagementSettingsInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    managementSettings: TaskManagementSettings[] | undefined;
}

export class TaskManagementSettingsListIHandleError implements ITaskManagementSettingsListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskManagementSettings[] | undefined;
    listOfEntities!: TaskManagementSettings[][] | undefined;

    constructor(data?: ITaskManagementSettingsListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TaskManagementSettings.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskManagementSettingsListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskManagementSettingsListIHandleError>(data, _mappings, TaskManagementSettingsListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITaskManagementSettingsListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskManagementSettings[] | undefined;
    listOfEntities: TaskManagementSettings[][] | undefined;
}

export class SmartPrioritizeInput implements ISmartPrioritizeInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    taskDate!: string | undefined;
    taskIds!: IndexedOrder[] | undefined;

    constructor(data?: ISmartPrioritizeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.taskDate = _data["taskDate"];
            if (Array.isArray(_data["taskIds"])) {
                this.taskIds = [] as any;
                for (let item of _data["taskIds"])
                    this.taskIds!.push(IndexedOrder.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SmartPrioritizeInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SmartPrioritizeInput>(data, _mappings, SmartPrioritizeInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["taskDate"] = this.taskDate;
        if (Array.isArray(this.taskIds)) {
            data["taskIds"] = [];
            for (let item of this.taskIds)
                data["taskIds"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISmartPrioritizeInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    taskDate: string | undefined;
    taskIds: IndexedOrder[] | undefined;
}

export enum ProjectAssociationType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum TaskPriority {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum TaskTypes {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum TaskEntityType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _5 = 5,
}

export class GetMyDayLastFileGroupedOutput implements IGetMyDayLastFileGroupedOutput {
    id!: number | undefined;
    title!: string | undefined;
    path!: string | undefined;
    type!: string | undefined;
    keyId!: string | undefined;
    driveId!: string | undefined;

    constructor(data?: IGetMyDayLastFileGroupedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.path = _data["path"];
            this.type = _data["type"];
            this.keyId = _data["keyId"];
            this.driveId = _data["driveId"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetMyDayLastFileGroupedOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetMyDayLastFileGroupedOutput>(data, _mappings, GetMyDayLastFileGroupedOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["path"] = this.path;
        data["type"] = this.type;
        data["keyId"] = this.keyId;
        data["driveId"] = this.driveId;
        return data;
    }
}

export interface IGetMyDayLastFileGroupedOutput {
    id: number | undefined;
    title: string | undefined;
    path: string | undefined;
    type: string | undefined;
    keyId: string | undefined;
    driveId: string | undefined;
}

export class TaskContributorDto implements ITaskContributorDto {
    assignedToId!: number | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    profilePictureUrl!: string | undefined;
    taskId!: number | undefined;
    hasOpenStep!: boolean | undefined;

    constructor(data?: ITaskContributorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.assignedToId = _data["assignedToId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.taskId = _data["taskId"];
            this.hasOpenStep = _data["hasOpenStep"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskContributorDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskContributorDto>(data, _mappings, TaskContributorDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedToId"] = this.assignedToId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["taskId"] = this.taskId;
        data["hasOpenStep"] = this.hasOpenStep;
        return data;
    }
}

export interface ITaskContributorDto {
    assignedToId: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    profilePictureUrl: string | undefined;
    taskId: number | undefined;
    hasOpenStep: boolean | undefined;
}

export class ProjectTag implements IProjectTag {
    tagId!: number | undefined;
    tag!: string | undefined;

    constructor(data?: IProjectTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.tag = _data["tag"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTag | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTag>(data, _mappings, ProjectTag);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["tag"] = this.tag;
        return data;
    }
}

export interface IProjectTag {
    tagId: number | undefined;
    tag: string | undefined;
}

export enum ClientStageAct {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class GetMyDayTaskGroupedOutput implements IGetMyDayTaskGroupedOutput {
    associationId!: number | undefined;
    associationName!: string | undefined;
    associationType!: ProjectAssociationType | undefined;
    id!: number | undefined;
    title!: string | undefined;
    projectId!: number | undefined;
    projectTitle!: string | undefined;
    sortOrder!: number | undefined;
    taskSortOrder!: number | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    completionDate!: string | undefined;
    stageId!: number | undefined;
    code!: number | undefined;
    progressCompleted!: number | undefined;
    checklistCompleted!: number | undefined;
    checklistTotal!: number | undefined;
    isSeen!: boolean | undefined;
    isPrivate!: boolean | undefined;
    priority!: TaskPriority | undefined;
    taskType!: TaskTypes | undefined;
    entityType!: TaskEntityType | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    bgColor!: string | undefined;
    file!: GetMyDayLastFileGroupedOutput | undefined;
    contributors!: TaskContributorDto[] | undefined;
    taskTags!: ProjectTag[] | undefined;
    assignedToUserId!: number | undefined;
    parentId!: number | undefined;
    parentCode!: number | undefined;
    isBlocked!: boolean | undefined;
    clientStageAct!: number | undefined;
    hasFiredFollowUp!: boolean | undefined;
    hasUnansweredReply!: boolean | undefined;
    isLeadContact!: boolean | undefined;
    lastInboundAt!: string | undefined;
    followUpAnchorAt!: string | undefined;
    followUpRoundCount!: number | undefined;
    isPrimaryLeadTask!: boolean | undefined;
    leadContactId!: number | undefined;
    leadStageId!: number | undefined;
    leadStageName!: string | undefined;
    leadStageAct!: ClientStageAct | undefined;
    leadStageOrder!: number | undefined;
    hasActiveFollowUp!: boolean | undefined;
    isNewLead!: boolean | undefined;
    leadSinceUtc!: string | undefined;
    openReviewKind!: number | undefined;
    reviewCreatedAtUtc!: string | undefined;
    isCaseHandoffTask!: boolean | undefined;
    createdAtUtc!: string | undefined;
    lastOutboundAtUtc!: string | undefined;
    lastActivityAtUtc!: string | undefined;

    constructor(data?: IGetMyDayTaskGroupedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.associationId = _data["associationId"];
            this.associationName = _data["associationName"];
            this.associationType = _data["associationType"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.projectId = _data["projectId"];
            this.projectTitle = _data["projectTitle"];
            this.sortOrder = _data["sortOrder"];
            this.taskSortOrder = _data["taskSortOrder"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.completionDate = _data["completionDate"];
            this.stageId = _data["stageId"];
            this.code = _data["code"];
            this.progressCompleted = _data["progressCompleted"];
            this.checklistCompleted = _data["checklistCompleted"];
            this.checklistTotal = _data["checklistTotal"];
            this.isSeen = _data["isSeen"];
            this.isPrivate = _data["isPrivate"];
            this.priority = _data["priority"];
            this.taskType = _data["taskType"];
            this.entityType = _data["entityType"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.bgColor = _data["bgColor"];
            this.file = _data["file"] ? GetMyDayLastFileGroupedOutput.fromJS(_data["file"], _mappings) : undefined as any;
            if (Array.isArray(_data["contributors"])) {
                this.contributors = [] as any;
                for (let item of _data["contributors"])
                    this.contributors!.push(TaskContributorDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["taskTags"])) {
                this.taskTags = [] as any;
                for (let item of _data["taskTags"])
                    this.taskTags!.push(ProjectTag.fromJS(item, _mappings));
            }
            this.assignedToUserId = _data["assignedToUserId"];
            this.parentId = _data["parentId"];
            this.parentCode = _data["parentCode"];
            this.isBlocked = _data["isBlocked"];
            this.clientStageAct = _data["clientStageAct"];
            this.hasFiredFollowUp = _data["hasFiredFollowUp"];
            this.hasUnansweredReply = _data["hasUnansweredReply"];
            this.isLeadContact = _data["isLeadContact"];
            this.lastInboundAt = _data["lastInboundAt"];
            this.followUpAnchorAt = _data["followUpAnchorAt"];
            this.followUpRoundCount = _data["followUpRoundCount"];
            this.isPrimaryLeadTask = _data["isPrimaryLeadTask"];
            this.leadContactId = _data["leadContactId"];
            this.leadStageId = _data["leadStageId"];
            this.leadStageName = _data["leadStageName"];
            this.leadStageAct = _data["leadStageAct"];
            this.leadStageOrder = _data["leadStageOrder"];
            this.hasActiveFollowUp = _data["hasActiveFollowUp"];
            this.isNewLead = _data["isNewLead"];
            this.leadSinceUtc = _data["leadSinceUtc"];
            this.openReviewKind = _data["openReviewKind"];
            this.reviewCreatedAtUtc = _data["reviewCreatedAtUtc"];
            this.isCaseHandoffTask = _data["isCaseHandoffTask"];
            this.createdAtUtc = _data["createdAtUtc"];
            this.lastOutboundAtUtc = _data["lastOutboundAtUtc"];
            this.lastActivityAtUtc = _data["lastActivityAtUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetMyDayTaskGroupedOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetMyDayTaskGroupedOutput>(data, _mappings, GetMyDayTaskGroupedOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["associationId"] = this.associationId;
        data["associationName"] = this.associationName;
        data["associationType"] = this.associationType;
        data["id"] = this.id;
        data["title"] = this.title;
        data["projectId"] = this.projectId;
        data["projectTitle"] = this.projectTitle;
        data["sortOrder"] = this.sortOrder;
        data["taskSortOrder"] = this.taskSortOrder;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["completionDate"] = this.completionDate;
        data["stageId"] = this.stageId;
        data["code"] = this.code;
        data["progressCompleted"] = this.progressCompleted;
        data["checklistCompleted"] = this.checklistCompleted;
        data["checklistTotal"] = this.checklistTotal;
        data["isSeen"] = this.isSeen;
        data["isPrivate"] = this.isPrivate;
        data["priority"] = this.priority;
        data["taskType"] = this.taskType;
        data["entityType"] = this.entityType;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["bgColor"] = this.bgColor;
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        if (Array.isArray(this.contributors)) {
            data["contributors"] = [];
            for (let item of this.contributors)
                data["contributors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taskTags)) {
            data["taskTags"] = [];
            for (let item of this.taskTags)
                data["taskTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["assignedToUserId"] = this.assignedToUserId;
        data["parentId"] = this.parentId;
        data["parentCode"] = this.parentCode;
        data["isBlocked"] = this.isBlocked;
        data["clientStageAct"] = this.clientStageAct;
        data["hasFiredFollowUp"] = this.hasFiredFollowUp;
        data["hasUnansweredReply"] = this.hasUnansweredReply;
        data["isLeadContact"] = this.isLeadContact;
        data["lastInboundAt"] = this.lastInboundAt;
        data["followUpAnchorAt"] = this.followUpAnchorAt;
        data["followUpRoundCount"] = this.followUpRoundCount;
        data["isPrimaryLeadTask"] = this.isPrimaryLeadTask;
        data["leadContactId"] = this.leadContactId;
        data["leadStageId"] = this.leadStageId;
        data["leadStageName"] = this.leadStageName;
        data["leadStageAct"] = this.leadStageAct;
        data["leadStageOrder"] = this.leadStageOrder;
        data["hasActiveFollowUp"] = this.hasActiveFollowUp;
        data["isNewLead"] = this.isNewLead;
        data["leadSinceUtc"] = this.leadSinceUtc;
        data["openReviewKind"] = this.openReviewKind;
        data["reviewCreatedAtUtc"] = this.reviewCreatedAtUtc;
        data["isCaseHandoffTask"] = this.isCaseHandoffTask;
        data["createdAtUtc"] = this.createdAtUtc;
        data["lastOutboundAtUtc"] = this.lastOutboundAtUtc;
        data["lastActivityAtUtc"] = this.lastActivityAtUtc;
        return data;
    }
}

export interface IGetMyDayTaskGroupedOutput {
    associationId: number | undefined;
    associationName: string | undefined;
    associationType: ProjectAssociationType | undefined;
    id: number | undefined;
    title: string | undefined;
    projectId: number | undefined;
    projectTitle: string | undefined;
    sortOrder: number | undefined;
    taskSortOrder: number | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    completionDate: string | undefined;
    stageId: number | undefined;
    code: number | undefined;
    progressCompleted: number | undefined;
    checklistCompleted: number | undefined;
    checklistTotal: number | undefined;
    isSeen: boolean | undefined;
    isPrivate: boolean | undefined;
    priority: TaskPriority | undefined;
    taskType: TaskTypes | undefined;
    entityType: TaskEntityType | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    bgColor: string | undefined;
    file: GetMyDayLastFileGroupedOutput | undefined;
    contributors: TaskContributorDto[] | undefined;
    taskTags: ProjectTag[] | undefined;
    assignedToUserId: number | undefined;
    parentId: number | undefined;
    parentCode: number | undefined;
    isBlocked: boolean | undefined;
    clientStageAct: number | undefined;
    hasFiredFollowUp: boolean | undefined;
    hasUnansweredReply: boolean | undefined;
    isLeadContact: boolean | undefined;
    lastInboundAt: string | undefined;
    followUpAnchorAt: string | undefined;
    followUpRoundCount: number | undefined;
    isPrimaryLeadTask: boolean | undefined;
    leadContactId: number | undefined;
    leadStageId: number | undefined;
    leadStageName: string | undefined;
    leadStageAct: ClientStageAct | undefined;
    leadStageOrder: number | undefined;
    hasActiveFollowUp: boolean | undefined;
    isNewLead: boolean | undefined;
    leadSinceUtc: string | undefined;
    openReviewKind: number | undefined;
    reviewCreatedAtUtc: string | undefined;
    isCaseHandoffTask: boolean | undefined;
    createdAtUtc: string | undefined;
    lastOutboundAtUtc: string | undefined;
    lastActivityAtUtc: string | undefined;
}

export class GetMyDayTaskGroupedOutputListIHandleError implements IGetMyDayTaskGroupedOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetMyDayTaskGroupedOutput[] | undefined;
    listOfEntities!: GetMyDayTaskGroupedOutput[][] | undefined;

    constructor(data?: IGetMyDayTaskGroupedOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(GetMyDayTaskGroupedOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetMyDayTaskGroupedOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetMyDayTaskGroupedOutputListIHandleError>(data, _mappings, GetMyDayTaskGroupedOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IGetMyDayTaskGroupedOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetMyDayTaskGroupedOutput[] | undefined;
    listOfEntities: GetMyDayTaskGroupedOutput[][] | undefined;
}

export class ChangeAssigneeBulkInput implements IChangeAssigneeBulkInput {
    tasksIds!: number[] | undefined;
    stageCode!: number | undefined;
    assigneeId!: number | undefined;

    constructor(data?: IChangeAssigneeBulkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["tasksIds"])) {
                this.tasksIds = [] as any;
                for (let item of _data["tasksIds"])
                    this.tasksIds!.push(item);
            }
            this.stageCode = _data["stageCode"];
            this.assigneeId = _data["assigneeId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ChangeAssigneeBulkInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangeAssigneeBulkInput>(data, _mappings, ChangeAssigneeBulkInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasksIds)) {
            data["tasksIds"] = [];
            for (let item of this.tasksIds)
                data["tasksIds"].push(item);
        }
        data["stageCode"] = this.stageCode;
        data["assigneeId"] = this.assigneeId;
        return data;
    }
}

export interface IChangeAssigneeBulkInput {
    tasksIds: number[] | undefined;
    stageCode: number | undefined;
    assigneeId: number | undefined;
}

export class SetPriorityBulkInput implements ISetPriorityBulkInput {
    tasksIds!: number[] | undefined;
    priority!: TaskPriority | undefined;

    constructor(data?: ISetPriorityBulkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["tasksIds"])) {
                this.tasksIds = [] as any;
                for (let item of _data["tasksIds"])
                    this.tasksIds!.push(item);
            }
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetPriorityBulkInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetPriorityBulkInput>(data, _mappings, SetPriorityBulkInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasksIds)) {
            data["tasksIds"] = [];
            for (let item of this.tasksIds)
                data["tasksIds"].push(item);
        }
        data["priority"] = this.priority;
        return data;
    }
}

export interface ISetPriorityBulkInput {
    tasksIds: number[] | undefined;
    priority: TaskPriority | undefined;
}

export class SetDateBulkInput implements ISetDateBulkInput {
    tasksIds!: number[] | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    isShift!: boolean | undefined;

    constructor(data?: ISetDateBulkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["tasksIds"])) {
                this.tasksIds = [] as any;
                for (let item of _data["tasksIds"])
                    this.tasksIds!.push(item);
            }
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.isShift = _data["isShift"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetDateBulkInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetDateBulkInput>(data, _mappings, SetDateBulkInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasksIds)) {
            data["tasksIds"] = [];
            for (let item of this.tasksIds)
                data["tasksIds"].push(item);
        }
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isShift"] = this.isShift;
        return data;
    }
}

export interface ISetDateBulkInput {
    tasksIds: number[] | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    isShift: boolean | undefined;
}

export class MoveToProjectBulkInput implements IMoveToProjectBulkInput {
    tasksIds!: number[] | undefined;
    projectId!: number | undefined;
    sectionId!: number | undefined;
    skipAutoChecklist!: boolean | undefined;

    constructor(data?: IMoveToProjectBulkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["tasksIds"])) {
                this.tasksIds = [] as any;
                for (let item of _data["tasksIds"])
                    this.tasksIds!.push(item);
            }
            this.projectId = _data["projectId"];
            this.sectionId = _data["sectionId"];
            this.skipAutoChecklist = _data["skipAutoChecklist"];
        }
    }

    static fromJS(data: any, _mappings?: any): MoveToProjectBulkInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MoveToProjectBulkInput>(data, _mappings, MoveToProjectBulkInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasksIds)) {
            data["tasksIds"] = [];
            for (let item of this.tasksIds)
                data["tasksIds"].push(item);
        }
        data["projectId"] = this.projectId;
        data["sectionId"] = this.sectionId;
        data["skipAutoChecklist"] = this.skipAutoChecklist;
        return data;
    }
}

export interface IMoveToProjectBulkInput {
    tasksIds: number[] | undefined;
    projectId: number | undefined;
    sectionId: number | undefined;
    skipAutoChecklist: boolean | undefined;
}

export enum CommentList {
    _1 = 1,
    _2 = 2,
}

export class CommentAttachment implements ICommentAttachment {
    id!: number | undefined;
    keyId!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    fileType!: string | undefined;
    isHide!: boolean | undefined;
    isLink!: boolean | undefined;
    extension!: string | undefined;
    msDriveId!: string | undefined;
    msSiteId!: string | undefined;
    msFolderId!: string | undefined;
    creationTime!: string | undefined;
    createdBy!: string | undefined;
    isAddToShortcut!: boolean | undefined;
    commentId!: number | undefined;

    constructor(data?: ICommentAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.keyId = _data["keyId"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.isHide = _data["isHide"];
            this.isLink = _data["isLink"];
            this.extension = _data["extension"];
            this.msDriveId = _data["msDriveId"];
            this.msSiteId = _data["msSiteId"];
            this.msFolderId = _data["msFolderId"];
            this.creationTime = _data["creationTime"];
            this.createdBy = _data["createdBy"];
            this.isAddToShortcut = _data["isAddToShortcut"];
            this.commentId = _data["commentId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CommentAttachment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CommentAttachment>(data, _mappings, CommentAttachment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["keyId"] = this.keyId;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["isHide"] = this.isHide;
        data["isLink"] = this.isLink;
        data["extension"] = this.extension;
        data["msDriveId"] = this.msDriveId;
        data["msSiteId"] = this.msSiteId;
        data["msFolderId"] = this.msFolderId;
        data["creationTime"] = this.creationTime;
        data["createdBy"] = this.createdBy;
        data["isAddToShortcut"] = this.isAddToShortcut;
        data["commentId"] = this.commentId;
        return data;
    }
}

export interface ICommentAttachment {
    id: number | undefined;
    keyId: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    isHide: boolean | undefined;
    isLink: boolean | undefined;
    extension: string | undefined;
    msDriveId: string | undefined;
    msSiteId: string | undefined;
    msFolderId: string | undefined;
    creationTime: string | undefined;
    createdBy: string | undefined;
    isAddToShortcut: boolean | undefined;
    commentId: number | undefined;
}

export class UnifiedCommentDto implements IUnifiedCommentDto {
    id!: number | undefined;
    comment!: string | undefined;
    createdBy!: string | undefined;
    userImg!: string | undefined;
    userInitials!: string | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    duration!: string | undefined;
    isNew!: boolean | undefined;
    isSeen!: boolean | undefined;
    isJustAdded!: boolean | undefined;
    isDeleted!: boolean | undefined;
    taskIsDeleted!: boolean | undefined;
    statusCode!: number | undefined;
    attachments!: CommentAttachment[] | undefined;
    parentCommentId!: number | undefined;
    anchorQuote!: string | undefined;
    anchorRangeJson!: string | undefined;
    anchorOrphaned!: boolean | undefined;
    resolvedAt!: string | undefined;
    resolvedByUserId!: number | undefined;
    resolvedBy!: string | undefined;
    editedAt!: string | undefined;
    taskId!: number | undefined;
    taskName!: string | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;

    constructor(data?: IUnifiedCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.createdBy = _data["createdBy"];
            this.userImg = _data["userImg"];
            this.userInitials = _data["userInitials"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.duration = _data["duration"];
            this.isNew = _data["isNew"];
            this.isSeen = _data["isSeen"];
            this.isJustAdded = _data["isJustAdded"];
            this.isDeleted = _data["isDeleted"];
            this.taskIsDeleted = _data["taskIsDeleted"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CommentAttachment.fromJS(item, _mappings));
            }
            this.parentCommentId = _data["parentCommentId"];
            this.anchorQuote = _data["anchorQuote"];
            this.anchorRangeJson = _data["anchorRangeJson"];
            this.anchorOrphaned = _data["anchorOrphaned"];
            this.resolvedAt = _data["resolvedAt"];
            this.resolvedByUserId = _data["resolvedByUserId"];
            this.resolvedBy = _data["resolvedBy"];
            this.editedAt = _data["editedAt"];
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any, _mappings?: any): UnifiedCommentDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UnifiedCommentDto>(data, _mappings, UnifiedCommentDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["createdBy"] = this.createdBy;
        data["userImg"] = this.userImg;
        data["userInitials"] = this.userInitials;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["duration"] = this.duration;
        data["isNew"] = this.isNew;
        data["isSeen"] = this.isSeen;
        data["isJustAdded"] = this.isJustAdded;
        data["isDeleted"] = this.isDeleted;
        data["taskIsDeleted"] = this.taskIsDeleted;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentCommentId"] = this.parentCommentId;
        data["anchorQuote"] = this.anchorQuote;
        data["anchorRangeJson"] = this.anchorRangeJson;
        data["anchorOrphaned"] = this.anchorOrphaned;
        data["resolvedAt"] = this.resolvedAt;
        data["resolvedByUserId"] = this.resolvedByUserId;
        data["resolvedBy"] = this.resolvedBy;
        data["editedAt"] = this.editedAt;
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IUnifiedCommentDto {
    id: number | undefined;
    comment: string | undefined;
    createdBy: string | undefined;
    userImg: string | undefined;
    userInitials: string | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    duration: string | undefined;
    isNew: boolean | undefined;
    isSeen: boolean | undefined;
    isJustAdded: boolean | undefined;
    isDeleted: boolean | undefined;
    taskIsDeleted: boolean | undefined;
    statusCode: number | undefined;
    attachments: CommentAttachment[] | undefined;
    parentCommentId: number | undefined;
    anchorQuote: string | undefined;
    anchorRangeJson: string | undefined;
    anchorOrphaned: boolean | undefined;
    resolvedAt: string | undefined;
    resolvedByUserId: number | undefined;
    resolvedBy: string | undefined;
    editedAt: string | undefined;
    taskId: number | undefined;
    taskName: string | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
}

export class UnifiedCommentDtoListIHandleError implements IUnifiedCommentDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UnifiedCommentDto[] | undefined;
    listOfEntities!: UnifiedCommentDto[][] | undefined;

    constructor(data?: IUnifiedCommentDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(UnifiedCommentDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UnifiedCommentDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UnifiedCommentDtoListIHandleError>(data, _mappings, UnifiedCommentDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IUnifiedCommentDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UnifiedCommentDto[] | undefined;
    listOfEntities: UnifiedCommentDto[][] | undefined;
}

export class TaskCommentDto implements ITaskCommentDto {
    id!: number | undefined;
    comment!: string | undefined;
    createdBy!: string | undefined;
    userImg!: string | undefined;
    userInitials!: string | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    duration!: string | undefined;
    isNew!: boolean | undefined;
    isSeen!: boolean | undefined;
    taskId!: number | undefined;
    isJustAdded!: boolean | undefined;
    isDeleted!: boolean | undefined;
    taskIsDeleted!: boolean | undefined;
    statusCode!: number | undefined;
    attachments!: CommentAttachment[] | undefined;
    parentCommentId!: number | undefined;
    anchorQuote!: string | undefined;
    anchorRangeJson!: string | undefined;
    anchorOrphaned!: boolean | undefined;
    resolvedAt!: string | undefined;
    resolvedByUserId!: number | undefined;
    resolvedBy!: string | undefined;
    editedAt!: string | undefined;

    constructor(data?: ITaskCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.createdBy = _data["createdBy"];
            this.userImg = _data["userImg"];
            this.userInitials = _data["userInitials"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.duration = _data["duration"];
            this.isNew = _data["isNew"];
            this.isSeen = _data["isSeen"];
            this.taskId = _data["taskId"];
            this.isJustAdded = _data["isJustAdded"];
            this.isDeleted = _data["isDeleted"];
            this.taskIsDeleted = _data["taskIsDeleted"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CommentAttachment.fromJS(item, _mappings));
            }
            this.parentCommentId = _data["parentCommentId"];
            this.anchorQuote = _data["anchorQuote"];
            this.anchorRangeJson = _data["anchorRangeJson"];
            this.anchorOrphaned = _data["anchorOrphaned"];
            this.resolvedAt = _data["resolvedAt"];
            this.resolvedByUserId = _data["resolvedByUserId"];
            this.resolvedBy = _data["resolvedBy"];
            this.editedAt = _data["editedAt"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskCommentDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskCommentDto>(data, _mappings, TaskCommentDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["createdBy"] = this.createdBy;
        data["userImg"] = this.userImg;
        data["userInitials"] = this.userInitials;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["duration"] = this.duration;
        data["isNew"] = this.isNew;
        data["isSeen"] = this.isSeen;
        data["taskId"] = this.taskId;
        data["isJustAdded"] = this.isJustAdded;
        data["isDeleted"] = this.isDeleted;
        data["taskIsDeleted"] = this.taskIsDeleted;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentCommentId"] = this.parentCommentId;
        data["anchorQuote"] = this.anchorQuote;
        data["anchorRangeJson"] = this.anchorRangeJson;
        data["anchorOrphaned"] = this.anchorOrphaned;
        data["resolvedAt"] = this.resolvedAt;
        data["resolvedByUserId"] = this.resolvedByUserId;
        data["resolvedBy"] = this.resolvedBy;
        data["editedAt"] = this.editedAt;
        return data;
    }
}

export interface ITaskCommentDto {
    id: number | undefined;
    comment: string | undefined;
    createdBy: string | undefined;
    userImg: string | undefined;
    userInitials: string | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    duration: string | undefined;
    isNew: boolean | undefined;
    isSeen: boolean | undefined;
    taskId: number | undefined;
    isJustAdded: boolean | undefined;
    isDeleted: boolean | undefined;
    taskIsDeleted: boolean | undefined;
    statusCode: number | undefined;
    attachments: CommentAttachment[] | undefined;
    parentCommentId: number | undefined;
    anchorQuote: string | undefined;
    anchorRangeJson: string | undefined;
    anchorOrphaned: boolean | undefined;
    resolvedAt: string | undefined;
    resolvedByUserId: number | undefined;
    resolvedBy: string | undefined;
    editedAt: string | undefined;
}

export class TaskCommentDtoListIHandleError implements ITaskCommentDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskCommentDto[] | undefined;
    listOfEntities!: TaskCommentDto[][] | undefined;

    constructor(data?: ITaskCommentDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TaskCommentDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskCommentDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskCommentDtoListIHandleError>(data, _mappings, TaskCommentDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITaskCommentDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskCommentDto[] | undefined;
    listOfEntities: TaskCommentDto[][] | undefined;
}

export class StreamGenerateInput implements IStreamGenerateInput {
    prompt!: string | undefined;
    sourceNotesHtml!: string | undefined;
    useNotesAsContext!: boolean | undefined;

    constructor(data?: IStreamGenerateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.prompt = _data["prompt"];
            this.sourceNotesHtml = _data["sourceNotesHtml"];
            this.useNotesAsContext = _data["useNotesAsContext"];
        }
    }

    static fromJS(data: any, _mappings?: any): StreamGenerateInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StreamGenerateInput>(data, _mappings, StreamGenerateInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prompt"] = this.prompt;
        data["sourceNotesHtml"] = this.sourceNotesHtml;
        data["useNotesAsContext"] = this.useNotesAsContext;
        return data;
    }
}

export interface IStreamGenerateInput {
    prompt: string | undefined;
    sourceNotesHtml: string | undefined;
    useNotesAsContext: boolean | undefined;
}

export class StreamRefineInput implements IStreamRefineInput {
    instruction!: string | undefined;
    currentDraftHtml!: string | undefined;
    sourceNotesHtml!: string | undefined;
    useNotesAsContext!: boolean | undefined;
    originalPrompt!: string | undefined;

    constructor(data?: IStreamRefineInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.instruction = _data["instruction"];
            this.currentDraftHtml = _data["currentDraftHtml"];
            this.sourceNotesHtml = _data["sourceNotesHtml"];
            this.useNotesAsContext = _data["useNotesAsContext"];
            this.originalPrompt = _data["originalPrompt"];
        }
    }

    static fromJS(data: any, _mappings?: any): StreamRefineInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StreamRefineInput>(data, _mappings, StreamRefineInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instruction"] = this.instruction;
        data["currentDraftHtml"] = this.currentDraftHtml;
        data["sourceNotesHtml"] = this.sourceNotesHtml;
        data["useNotesAsContext"] = this.useNotesAsContext;
        data["originalPrompt"] = this.originalPrompt;
        return data;
    }
}

export interface IStreamRefineInput {
    instruction: string | undefined;
    currentDraftHtml: string | undefined;
    sourceNotesHtml: string | undefined;
    useNotesAsContext: boolean | undefined;
    originalPrompt: string | undefined;
}

export class TenantAnnouncementDto implements ITenantAnnouncementDto {
    id!: number | undefined;
    subject!: string | undefined;
    announcement!: string | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    isActive!: boolean | undefined;
    isDeleted!: boolean | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;

    constructor(data?: ITenantAnnouncementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.announcement = _data["announcement"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any, _mappings?: any): TenantAnnouncementDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantAnnouncementDto>(data, _mappings, TenantAnnouncementDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["announcement"] = this.announcement;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ITenantAnnouncementDto {
    id: number | undefined;
    subject: string | undefined;
    announcement: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
}

export class TenantAnnouncementDtoListIHandleError implements ITenantAnnouncementDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TenantAnnouncementDto[] | undefined;
    listOfEntities!: TenantAnnouncementDto[][] | undefined;

    constructor(data?: ITenantAnnouncementDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TenantAnnouncementDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TenantAnnouncementDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantAnnouncementDtoListIHandleError>(data, _mappings, TenantAnnouncementDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITenantAnnouncementDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TenantAnnouncementDto[] | undefined;
    listOfEntities: TenantAnnouncementDto[][] | undefined;
}

export enum LookUpTables {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _20 = 20,
    _21 = 21,
    _22 = 22,
    _23 = 23,
    _24 = 24,
    _25 = 25,
    _26 = 26,
    _27 = 27,
    _28 = 28,
    _29 = 29,
    _30 = 30,
    _31 = 31,
    _32 = 32,
    _33 = 33,
    _34 = 34,
    _35 = 35,
    _36 = 36,
}

export class CommonAttachment implements ICommonAttachment {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    entityId!: number | undefined;
    entity!: LookUpTables | undefined;
    id!: number | undefined;
    keyId!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    fileType!: string | undefined;
    webLink!: string | undefined;
    isLink!: boolean | undefined;
    isShareFile!: boolean | undefined;
    isAddToShortcut!: boolean | undefined;
    isDefault!: boolean | undefined;
    msDriveId!: string | undefined;
    msSiteId!: string | undefined;
    msFolderId!: string | undefined;

    constructor(data?: ICommonAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.entityId = _data["entityId"];
            this.entity = _data["entity"];
            this.id = _data["id"];
            this.keyId = _data["keyId"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.webLink = _data["webLink"];
            this.isLink = _data["isLink"];
            this.isShareFile = _data["isShareFile"];
            this.isAddToShortcut = _data["isAddToShortcut"];
            this.isDefault = _data["isDefault"];
            this.msDriveId = _data["msDriveId"];
            this.msSiteId = _data["msSiteId"];
            this.msFolderId = _data["msFolderId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CommonAttachment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CommonAttachment>(data, _mappings, CommonAttachment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["entityId"] = this.entityId;
        data["entity"] = this.entity;
        data["id"] = this.id;
        data["keyId"] = this.keyId;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["webLink"] = this.webLink;
        data["isLink"] = this.isLink;
        data["isShareFile"] = this.isShareFile;
        data["isAddToShortcut"] = this.isAddToShortcut;
        data["isDefault"] = this.isDefault;
        data["msDriveId"] = this.msDriveId;
        data["msSiteId"] = this.msSiteId;
        data["msFolderId"] = this.msFolderId;
        return data;
    }
}

export interface ICommonAttachment {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    entityId: number | undefined;
    entity: LookUpTables | undefined;
    id: number | undefined;
    keyId: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    webLink: string | undefined;
    isLink: boolean | undefined;
    isShareFile: boolean | undefined;
    isAddToShortcut: boolean | undefined;
    isDefault: boolean | undefined;
    msDriveId: string | undefined;
    msSiteId: string | undefined;
    msFolderId: string | undefined;
}

export class Int64IHandleError implements IInt64IHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: number | undefined;
    listOfEntities!: number[] | undefined;

    constructor(data?: IInt64IHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"];
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int64IHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int64IHandleError>(data, _mappings, Int64IHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IInt64IHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: number | undefined;
    listOfEntities: number[] | undefined;
}

export class TaskAttachment implements ITaskAttachment {
    id!: number | undefined;
    keyId!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    fileType!: string | undefined;
    isHide!: boolean | undefined;
    isLink!: boolean | undefined;
    extension!: string | undefined;
    msDriveId!: string | undefined;
    msSiteId!: string | undefined;
    msFolderId!: string | undefined;
    creationTime!: string | undefined;
    createdBy!: string | undefined;
    isAddToShortcut!: boolean | undefined;

    constructor(data?: ITaskAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.keyId = _data["keyId"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.isHide = _data["isHide"];
            this.isLink = _data["isLink"];
            this.extension = _data["extension"];
            this.msDriveId = _data["msDriveId"];
            this.msSiteId = _data["msSiteId"];
            this.msFolderId = _data["msFolderId"];
            this.creationTime = _data["creationTime"];
            this.createdBy = _data["createdBy"];
            this.isAddToShortcut = _data["isAddToShortcut"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskAttachment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskAttachment>(data, _mappings, TaskAttachment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["keyId"] = this.keyId;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["isHide"] = this.isHide;
        data["isLink"] = this.isLink;
        data["extension"] = this.extension;
        data["msDriveId"] = this.msDriveId;
        data["msSiteId"] = this.msSiteId;
        data["msFolderId"] = this.msFolderId;
        data["creationTime"] = this.creationTime;
        data["createdBy"] = this.createdBy;
        data["isAddToShortcut"] = this.isAddToShortcut;
        return data;
    }
}

export interface ITaskAttachment {
    id: number | undefined;
    keyId: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    isHide: boolean | undefined;
    isLink: boolean | undefined;
    extension: string | undefined;
    msDriveId: string | undefined;
    msSiteId: string | undefined;
    msFolderId: string | undefined;
    creationTime: string | undefined;
    createdBy: string | undefined;
    isAddToShortcut: boolean | undefined;
}

export class TaskAttachmentListIHandleError implements ITaskAttachmentListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskAttachment[] | undefined;
    listOfEntities!: TaskAttachment[][] | undefined;

    constructor(data?: ITaskAttachmentListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TaskAttachment.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskAttachmentListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskAttachmentListIHandleError>(data, _mappings, TaskAttachmentListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITaskAttachmentListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskAttachment[] | undefined;
    listOfEntities: TaskAttachment[][] | undefined;
}

export class CommonAttachmentDto implements ICommonAttachmentDto {
    id!: number | undefined;
    keyId!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    fileType!: string | undefined;
    isLink!: boolean | undefined;
    isHide!: boolean | undefined;
    isShareFile!: boolean | undefined;
    isAddToShortcut!: boolean | undefined;
    extension!: string | undefined;
    isDefault!: boolean | undefined;
    msDriveId!: string | undefined;
    msSiteId!: string | undefined;
    msFolderId!: string | undefined;
    creationTime!: string | undefined;
    createdBy!: string | undefined;

    constructor(data?: ICommonAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.keyId = _data["keyId"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.isLink = _data["isLink"];
            this.isHide = _data["isHide"];
            this.isShareFile = _data["isShareFile"];
            this.isAddToShortcut = _data["isAddToShortcut"];
            this.extension = _data["extension"];
            this.isDefault = _data["isDefault"];
            this.msDriveId = _data["msDriveId"];
            this.msSiteId = _data["msSiteId"];
            this.msFolderId = _data["msFolderId"];
            this.creationTime = _data["creationTime"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any, _mappings?: any): CommonAttachmentDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CommonAttachmentDto>(data, _mappings, CommonAttachmentDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["keyId"] = this.keyId;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["isLink"] = this.isLink;
        data["isHide"] = this.isHide;
        data["isShareFile"] = this.isShareFile;
        data["isAddToShortcut"] = this.isAddToShortcut;
        data["extension"] = this.extension;
        data["isDefault"] = this.isDefault;
        data["msDriveId"] = this.msDriveId;
        data["msSiteId"] = this.msSiteId;
        data["msFolderId"] = this.msFolderId;
        data["creationTime"] = this.creationTime;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface ICommonAttachmentDto {
    id: number | undefined;
    keyId: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    isLink: boolean | undefined;
    isHide: boolean | undefined;
    isShareFile: boolean | undefined;
    isAddToShortcut: boolean | undefined;
    extension: string | undefined;
    isDefault: boolean | undefined;
    msDriveId: string | undefined;
    msSiteId: string | undefined;
    msFolderId: string | undefined;
    creationTime: string | undefined;
    createdBy: string | undefined;
}

export class CommonAttachmentDtoListIHandleError implements ICommonAttachmentDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CommonAttachmentDto[] | undefined;
    listOfEntities!: CommonAttachmentDto[][] | undefined;

    constructor(data?: ICommonAttachmentDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(CommonAttachmentDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CommonAttachmentDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CommonAttachmentDtoListIHandleError>(data, _mappings, CommonAttachmentDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ICommonAttachmentDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CommonAttachmentDto[] | undefined;
    listOfEntities: CommonAttachmentDto[][] | undefined;
}

export class ProjectAttachmentOutput implements IProjectAttachmentOutput {
    id!: number | undefined;
    keyId!: string | undefined;
    fileName!: string | undefined;
    filePath!: string | undefined;
    fileType!: string | undefined;
    isLink!: boolean | undefined;
    isDefault!: boolean | undefined;
    msSiteId!: string | undefined;
    msDriveId!: string | undefined;
    msFolderId!: string | undefined;
    creationTime!: string | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;

    constructor(data?: IProjectAttachmentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.keyId = _data["keyId"];
            this.fileName = _data["fileName"];
            this.filePath = _data["filePath"];
            this.fileType = _data["fileType"];
            this.isLink = _data["isLink"];
            this.isDefault = _data["isDefault"];
            this.msSiteId = _data["msSiteId"];
            this.msDriveId = _data["msDriveId"];
            this.msFolderId = _data["msFolderId"];
            this.creationTime = _data["creationTime"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectAttachmentOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectAttachmentOutput>(data, _mappings, ProjectAttachmentOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["keyId"] = this.keyId;
        data["fileName"] = this.fileName;
        data["filePath"] = this.filePath;
        data["fileType"] = this.fileType;
        data["isLink"] = this.isLink;
        data["isDefault"] = this.isDefault;
        data["msSiteId"] = this.msSiteId;
        data["msDriveId"] = this.msDriveId;
        data["msFolderId"] = this.msFolderId;
        data["creationTime"] = this.creationTime;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IProjectAttachmentOutput {
    id: number | undefined;
    keyId: string | undefined;
    fileName: string | undefined;
    filePath: string | undefined;
    fileType: string | undefined;
    isLink: boolean | undefined;
    isDefault: boolean | undefined;
    msSiteId: string | undefined;
    msDriveId: string | undefined;
    msFolderId: string | undefined;
    creationTime: string | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
}

export class ProjectAttachmentOutputListIHandleError implements IProjectAttachmentOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectAttachmentOutput[] | undefined;
    listOfEntities!: ProjectAttachmentOutput[][] | undefined;

    constructor(data?: IProjectAttachmentOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectAttachmentOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectAttachmentOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectAttachmentOutputListIHandleError>(data, _mappings, ProjectAttachmentOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectAttachmentOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectAttachmentOutput[] | undefined;
    listOfEntities: ProjectAttachmentOutput[][] | undefined;
}

export class ProjectTaskAttachment implements IProjectTaskAttachment {
    taskId!: number | undefined;
    taskName!: string | undefined;
    taskDocumentsAsJson!: string | undefined;
    isHide!: boolean | undefined;
    readonly taskDocuments!: TaskAttachment[] | undefined;

    constructor(data?: IProjectTaskAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.taskDocumentsAsJson = _data["taskDocumentsAsJson"];
            this.isHide = _data["isHide"];
            if (Array.isArray(_data["taskDocuments"])) {
                (this as any).taskDocuments = [] as any;
                for (let item of _data["taskDocuments"])
                    (this as any).taskDocuments!.push(TaskAttachment.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTaskAttachment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTaskAttachment>(data, _mappings, ProjectTaskAttachment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["taskDocumentsAsJson"] = this.taskDocumentsAsJson;
        data["isHide"] = this.isHide;
        if (Array.isArray(this.taskDocuments)) {
            data["taskDocuments"] = [];
            for (let item of this.taskDocuments)
                data["taskDocuments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTaskAttachment {
    taskId: number | undefined;
    taskName: string | undefined;
    taskDocumentsAsJson: string | undefined;
    isHide: boolean | undefined;
    taskDocuments: TaskAttachment[] | undefined;
}

export class ProjectTaskAttachmentListIHandleError implements IProjectTaskAttachmentListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectTaskAttachment[] | undefined;
    listOfEntities!: ProjectTaskAttachment[][] | undefined;

    constructor(data?: IProjectTaskAttachmentListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectTaskAttachment.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTaskAttachmentListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTaskAttachmentListIHandleError>(data, _mappings, ProjectTaskAttachmentListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectTaskAttachmentListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectTaskAttachment[] | undefined;
    listOfEntities: ProjectTaskAttachment[][] | undefined;
}

export class SetProjectDefaultFolderInputDto implements ISetProjectDefaultFolderInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    attachmentId!: number | undefined;
    isDefault!: boolean | undefined;

    constructor(data?: ISetProjectDefaultFolderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            this.attachmentId = _data["attachmentId"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetProjectDefaultFolderInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetProjectDefaultFolderInputDto>(data, _mappings, SetProjectDefaultFolderInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        data["attachmentId"] = this.attachmentId;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface ISetProjectDefaultFolderInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    attachmentId: number | undefined;
    isDefault: boolean | undefined;
}

export class ProjectFolderDto implements IProjectFolderDto {
    id!: number | undefined;
    keyId!: string | undefined;
    folderName!: string | undefined;
    folderPath!: string | undefined;
    fileType!: string | undefined;
    isOneDrive!: boolean | undefined;
    isDefault!: boolean | undefined;
    msDriveId!: string | undefined;
    msSiteId!: string | undefined;
    msFolderId!: string | undefined;

    constructor(data?: IProjectFolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.keyId = _data["keyId"];
            this.folderName = _data["folderName"];
            this.folderPath = _data["folderPath"];
            this.fileType = _data["fileType"];
            this.isOneDrive = _data["isOneDrive"];
            this.isDefault = _data["isDefault"];
            this.msDriveId = _data["msDriveId"];
            this.msSiteId = _data["msSiteId"];
            this.msFolderId = _data["msFolderId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectFolderDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectFolderDto>(data, _mappings, ProjectFolderDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["keyId"] = this.keyId;
        data["folderName"] = this.folderName;
        data["folderPath"] = this.folderPath;
        data["fileType"] = this.fileType;
        data["isOneDrive"] = this.isOneDrive;
        data["isDefault"] = this.isDefault;
        data["msDriveId"] = this.msDriveId;
        data["msSiteId"] = this.msSiteId;
        data["msFolderId"] = this.msFolderId;
        return data;
    }
}

export interface IProjectFolderDto {
    id: number | undefined;
    keyId: string | undefined;
    folderName: string | undefined;
    folderPath: string | undefined;
    fileType: string | undefined;
    isOneDrive: boolean | undefined;
    isDefault: boolean | undefined;
    msDriveId: string | undefined;
    msSiteId: string | undefined;
    msFolderId: string | undefined;
}

export class ProjectFolderDtoListIHandleError implements IProjectFolderDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectFolderDto[] | undefined;
    listOfEntities!: ProjectFolderDto[][] | undefined;

    constructor(data?: IProjectFolderDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectFolderDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectFolderDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectFolderDtoListIHandleError>(data, _mappings, ProjectFolderDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectFolderDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectFolderDto[] | undefined;
    listOfEntities: ProjectFolderDto[][] | undefined;
}

export class BillingPlanDto implements IBillingPlanDto {
    plan!: string | undefined;
    priceId!: string | undefined;
    unitAmount!: number | undefined;
    monthlyEquivalent!: number | undefined;
    currency!: string | undefined;

    constructor(data?: IBillingPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.plan = _data["plan"];
            this.priceId = _data["priceId"];
            this.unitAmount = _data["unitAmount"];
            this.monthlyEquivalent = _data["monthlyEquivalent"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any, _mappings?: any): BillingPlanDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BillingPlanDto>(data, _mappings, BillingPlanDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plan"] = this.plan;
        data["priceId"] = this.priceId;
        data["unitAmount"] = this.unitAmount;
        data["monthlyEquivalent"] = this.monthlyEquivalent;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IBillingPlanDto {
    plan: string | undefined;
    priceId: string | undefined;
    unitAmount: number | undefined;
    monthlyEquivalent: number | undefined;
    currency: string | undefined;
}

export class BillingStatusDto implements IBillingStatusDto {
    state!: string | undefined;
    isBlocked!: boolean | undefined;
    isBillingAdmin!: boolean | undefined;
    trialDaysLeft!: number | undefined;
    teamSize!: number | undefined;
    maxPeople!: number | undefined;
    plan!: string | undefined;
    people!: number | undefined;
    periodEnd!: string | undefined;
    paymentDueBy!: string | undefined;
    cardBrand!: string | undefined;
    cardLast4!: string | undefined;
    declinedOn!: string | undefined;
    amountDue!: number | undefined;
    ownerName!: string | undefined;
    ownerFirstName!: string | undefined;
    ownerProfilePictureUrl!: string | undefined;
    plans!: BillingPlanDto[] | undefined;
    yearlySavingsPerPerson!: number | undefined;
    upgradePromptsShown!: number[] | undefined;
    askAdminSentToday!: boolean | undefined;

    constructor(data?: IBillingStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.state = _data["state"];
            this.isBlocked = _data["isBlocked"];
            this.isBillingAdmin = _data["isBillingAdmin"];
            this.trialDaysLeft = _data["trialDaysLeft"];
            this.teamSize = _data["teamSize"];
            this.maxPeople = _data["maxPeople"];
            this.plan = _data["plan"];
            this.people = _data["people"];
            this.periodEnd = _data["periodEnd"];
            this.paymentDueBy = _data["paymentDueBy"];
            this.cardBrand = _data["cardBrand"];
            this.cardLast4 = _data["cardLast4"];
            this.declinedOn = _data["declinedOn"];
            this.amountDue = _data["amountDue"];
            this.ownerName = _data["ownerName"];
            this.ownerFirstName = _data["ownerFirstName"];
            this.ownerProfilePictureUrl = _data["ownerProfilePictureUrl"];
            if (Array.isArray(_data["plans"])) {
                this.plans = [] as any;
                for (let item of _data["plans"])
                    this.plans!.push(BillingPlanDto.fromJS(item, _mappings));
            }
            this.yearlySavingsPerPerson = _data["yearlySavingsPerPerson"];
            if (Array.isArray(_data["upgradePromptsShown"])) {
                this.upgradePromptsShown = [] as any;
                for (let item of _data["upgradePromptsShown"])
                    this.upgradePromptsShown!.push(item);
            }
            this.askAdminSentToday = _data["askAdminSentToday"];
        }
    }

    static fromJS(data: any, _mappings?: any): BillingStatusDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BillingStatusDto>(data, _mappings, BillingStatusDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["isBlocked"] = this.isBlocked;
        data["isBillingAdmin"] = this.isBillingAdmin;
        data["trialDaysLeft"] = this.trialDaysLeft;
        data["teamSize"] = this.teamSize;
        data["maxPeople"] = this.maxPeople;
        data["plan"] = this.plan;
        data["people"] = this.people;
        data["periodEnd"] = this.periodEnd;
        data["paymentDueBy"] = this.paymentDueBy;
        data["cardBrand"] = this.cardBrand;
        data["cardLast4"] = this.cardLast4;
        data["declinedOn"] = this.declinedOn;
        data["amountDue"] = this.amountDue;
        data["ownerName"] = this.ownerName;
        data["ownerFirstName"] = this.ownerFirstName;
        data["ownerProfilePictureUrl"] = this.ownerProfilePictureUrl;
        if (Array.isArray(this.plans)) {
            data["plans"] = [];
            for (let item of this.plans)
                data["plans"].push(item ? item.toJSON() : undefined as any);
        }
        data["yearlySavingsPerPerson"] = this.yearlySavingsPerPerson;
        if (Array.isArray(this.upgradePromptsShown)) {
            data["upgradePromptsShown"] = [];
            for (let item of this.upgradePromptsShown)
                data["upgradePromptsShown"].push(item);
        }
        data["askAdminSentToday"] = this.askAdminSentToday;
        return data;
    }
}

export interface IBillingStatusDto {
    state: string | undefined;
    isBlocked: boolean | undefined;
    isBillingAdmin: boolean | undefined;
    trialDaysLeft: number | undefined;
    teamSize: number | undefined;
    maxPeople: number | undefined;
    plan: string | undefined;
    people: number | undefined;
    periodEnd: string | undefined;
    paymentDueBy: string | undefined;
    cardBrand: string | undefined;
    cardLast4: string | undefined;
    declinedOn: string | undefined;
    amountDue: number | undefined;
    ownerName: string | undefined;
    ownerFirstName: string | undefined;
    ownerProfilePictureUrl: string | undefined;
    plans: BillingPlanDto[] | undefined;
    yearlySavingsPerPerson: number | undefined;
    upgradePromptsShown: number[] | undefined;
    askAdminSentToday: boolean | undefined;
}

export class CreateCheckoutSessionInput implements ICreateCheckoutSessionInput {
    plan!: string;
    people!: number | undefined;
    fromTeams!: boolean | undefined;

    constructor(data?: ICreateCheckoutSessionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.plan = _data["plan"];
            this.people = _data["people"];
            this.fromTeams = _data["fromTeams"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateCheckoutSessionInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateCheckoutSessionInput>(data, _mappings, CreateCheckoutSessionInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plan"] = this.plan;
        data["people"] = this.people;
        data["fromTeams"] = this.fromTeams;
        return data;
    }
}

export interface ICreateCheckoutSessionInput {
    plan: string;
    people: number | undefined;
    fromTeams: boolean | undefined;
}

export class CheckoutSessionOutput implements ICheckoutSessionOutput {
    url!: string | undefined;
    sessionId!: string | undefined;

    constructor(data?: ICheckoutSessionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.url = _data["url"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CheckoutSessionOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckoutSessionOutput>(data, _mappings, CheckoutSessionOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface ICheckoutSessionOutput {
    url: string | undefined;
    sessionId: string | undefined;
}

export class CheckoutStatusDto implements ICheckoutStatusDto {
    confirmed!: boolean | undefined;
    paid!: boolean | undefined;
    plan!: string | undefined;
    people!: number | undefined;
    nextPaymentAmount!: number | undefined;
    nextPaymentDate!: string | undefined;

    constructor(data?: ICheckoutStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.confirmed = _data["confirmed"];
            this.paid = _data["paid"];
            this.plan = _data["plan"];
            this.people = _data["people"];
            this.nextPaymentAmount = _data["nextPaymentAmount"];
            this.nextPaymentDate = _data["nextPaymentDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): CheckoutStatusDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckoutStatusDto>(data, _mappings, CheckoutStatusDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmed"] = this.confirmed;
        data["paid"] = this.paid;
        data["plan"] = this.plan;
        data["people"] = this.people;
        data["nextPaymentAmount"] = this.nextPaymentAmount;
        data["nextPaymentDate"] = this.nextPaymentDate;
        return data;
    }
}

export interface ICheckoutStatusDto {
    confirmed: boolean | undefined;
    paid: boolean | undefined;
    plan: string | undefined;
    people: number | undefined;
    nextPaymentAmount: number | undefined;
    nextPaymentDate: string | undefined;
}

export class BillingPortalSessionOutput implements IBillingPortalSessionOutput {
    url!: string | undefined;

    constructor(data?: IBillingPortalSessionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any, _mappings?: any): BillingPortalSessionOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BillingPortalSessionOutput>(data, _mappings, BillingPortalSessionOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IBillingPortalSessionOutput {
    url: string | undefined;
}

export class AskAdminToUpgradeOutput implements IAskAdminToUpgradeOutput {
    sent!: boolean | undefined;
    alreadySentToday!: boolean | undefined;
    adminFirstName!: string | undefined;

    constructor(data?: IAskAdminToUpgradeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sent = _data["sent"];
            this.alreadySentToday = _data["alreadySentToday"];
            this.adminFirstName = _data["adminFirstName"];
        }
    }

    static fromJS(data: any, _mappings?: any): AskAdminToUpgradeOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AskAdminToUpgradeOutput>(data, _mappings, AskAdminToUpgradeOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sent"] = this.sent;
        data["alreadySentToday"] = this.alreadySentToday;
        data["adminFirstName"] = this.adminFirstName;
        return data;
    }
}

export interface IAskAdminToUpgradeOutput {
    sent: boolean | undefined;
    alreadySentToday: boolean | undefined;
    adminFirstName: string | undefined;
}

export class UpgradePromptShownInput implements IUpgradePromptShownInput {
    daysMark!: number | undefined;

    constructor(data?: IUpgradePromptShownInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.daysMark = _data["daysMark"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpgradePromptShownInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpgradePromptShownInput>(data, _mappings, UpgradePromptShownInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daysMark"] = this.daysMark;
        return data;
    }
}

export interface IUpgradePromptShownInput {
    daysMark: number | undefined;
}

export class PlanChangeOptionsDto implements IPlanChangeOptionsDto {
    canChange!: boolean | undefined;
    cannotChangeReason!: string | undefined;
    currentPlan!: string | undefined;
    people!: number | undefined;
    periodEnd!: string | undefined;
    plans!: BillingPlanDto[] | undefined;
    yearlySavingsPerPerson!: number | undefined;
    pendingPlan!: string | undefined;
    pendingPlanDate!: string | undefined;

    constructor(data?: IPlanChangeOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.canChange = _data["canChange"];
            this.cannotChangeReason = _data["cannotChangeReason"];
            this.currentPlan = _data["currentPlan"];
            this.people = _data["people"];
            this.periodEnd = _data["periodEnd"];
            if (Array.isArray(_data["plans"])) {
                this.plans = [] as any;
                for (let item of _data["plans"])
                    this.plans!.push(BillingPlanDto.fromJS(item, _mappings));
            }
            this.yearlySavingsPerPerson = _data["yearlySavingsPerPerson"];
            this.pendingPlan = _data["pendingPlan"];
            this.pendingPlanDate = _data["pendingPlanDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): PlanChangeOptionsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PlanChangeOptionsDto>(data, _mappings, PlanChangeOptionsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canChange"] = this.canChange;
        data["cannotChangeReason"] = this.cannotChangeReason;
        data["currentPlan"] = this.currentPlan;
        data["people"] = this.people;
        data["periodEnd"] = this.periodEnd;
        if (Array.isArray(this.plans)) {
            data["plans"] = [];
            for (let item of this.plans)
                data["plans"].push(item ? item.toJSON() : undefined as any);
        }
        data["yearlySavingsPerPerson"] = this.yearlySavingsPerPerson;
        data["pendingPlan"] = this.pendingPlan;
        data["pendingPlanDate"] = this.pendingPlanDate;
        return data;
    }
}

export interface IPlanChangeOptionsDto {
    canChange: boolean | undefined;
    cannotChangeReason: string | undefined;
    currentPlan: string | undefined;
    people: number | undefined;
    periodEnd: string | undefined;
    plans: BillingPlanDto[] | undefined;
    yearlySavingsPerPerson: number | undefined;
    pendingPlan: string | undefined;
    pendingPlanDate: string | undefined;
}

export class ChangePlanInput implements IChangePlanInput {
    plan!: string;

    constructor(data?: IChangePlanInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.plan = _data["plan"];
        }
    }

    static fromJS(data: any, _mappings?: any): ChangePlanInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangePlanInput>(data, _mappings, ChangePlanInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plan"] = this.plan;
        return data;
    }
}

export interface IChangePlanInput {
    plan: string;
}

export class ChangePlanOutput implements IChangePlanOutput {
    outcome!: string | undefined;
    effectiveDate!: string | undefined;

    constructor(data?: IChangePlanOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.outcome = _data["outcome"];
            this.effectiveDate = _data["effectiveDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): ChangePlanOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangePlanOutput>(data, _mappings, ChangePlanOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outcome"] = this.outcome;
        data["effectiveDate"] = this.effectiveDate;
        return data;
    }
}

export interface IChangePlanOutput {
    outcome: string | undefined;
    effectiveDate: string | undefined;
}

export class CacheDto implements ICacheDto {
    name!: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): CacheDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CacheDto>(data, _mappings, CacheDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class CacheDtoListResultDto implements ICacheDtoListResultDto {
    items!: CacheDto[] | undefined;

    constructor(data?: ICacheDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CacheDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CacheDtoListResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CacheDtoListResultDto>(data, _mappings, CacheDtoListResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICacheDtoListResultDto {
    items: CacheDto[] | undefined;
}

export class StringEntityDto implements IStringEntityDto {
    id!: string | undefined;

    constructor(data?: IStringEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): StringEntityDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StringEntityDto>(data, _mappings, StringEntityDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IStringEntityDto {
    id: string | undefined;
}

export enum EventFilterType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTuple implements ICalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTuple {

    constructor(data?: ICalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTuple>(data, _mappings, CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTuple {
}

export class CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError implements ICalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTuple | undefined;
    listOfEntities!: CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTuple[] | undefined;

    constructor(data?: ICalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError>(data, _mappings, CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTuple | undefined;
    listOfEntities: CalendarHeaderDtoGetUserCalendarListCalendarGroupDtoListFilterCountsListValueTuple[] | undefined;
}

export class MeetingsGroupDtoListMeetingsListDtoListValueTuple implements IMeetingsGroupDtoListMeetingsListDtoListValueTuple {

    constructor(data?: IMeetingsGroupDtoListMeetingsListDtoListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): MeetingsGroupDtoListMeetingsListDtoListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MeetingsGroupDtoListMeetingsListDtoListValueTuple>(data, _mappings, MeetingsGroupDtoListMeetingsListDtoListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMeetingsGroupDtoListMeetingsListDtoListValueTuple {
}

export class MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError implements IMeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MeetingsGroupDtoListMeetingsListDtoListValueTuple | undefined;
    listOfEntities!: MeetingsGroupDtoListMeetingsListDtoListValueTuple[] | undefined;

    constructor(data?: IMeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? MeetingsGroupDtoListMeetingsListDtoListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(MeetingsGroupDtoListMeetingsListDtoListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError>(data, _mappings, MeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMeetingsGroupDtoListMeetingsListDtoListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MeetingsGroupDtoListMeetingsListDtoListValueTuple | undefined;
    listOfEntities: MeetingsGroupDtoListMeetingsListDtoListValueTuple[] | undefined;
}

export class EventAttendee implements IEventAttendee {
    userId!: number | undefined;
    isOnBreak!: boolean | undefined;
    profilePictureUrl!: string | undefined;
    fullName!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    initials!: string | undefined;
    isAvailable!: boolean | undefined;
    isExistingContact!: boolean | undefined;
    statusCode!: number | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IEventAttendee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.isOnBreak = _data["isOnBreak"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.fullName = _data["fullName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.initials = _data["initials"];
            this.isAvailable = _data["isAvailable"];
            this.isExistingContact = _data["isExistingContact"];
            this.statusCode = _data["statusCode"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any, _mappings?: any): EventAttendee | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EventAttendee>(data, _mappings, EventAttendee);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["isOnBreak"] = this.isOnBreak;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["fullName"] = this.fullName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["initials"] = this.initials;
        data["isAvailable"] = this.isAvailable;
        data["isExistingContact"] = this.isExistingContact;
        data["statusCode"] = this.statusCode;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IEventAttendee {
    userId: number | undefined;
    isOnBreak: boolean | undefined;
    profilePictureUrl: string | undefined;
    fullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    initials: string | undefined;
    isAvailable: boolean | undefined;
    isExistingContact: boolean | undefined;
    statusCode: number | undefined;
    emailAddress: string | undefined;
}

export enum RecurrencePatternType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class GetCalendarEventById implements IGetCalendarEventById {
    id!: number | undefined;
    eventId!: string | undefined;
    subject!: string | undefined;
    organizerUserId!: number | undefined;
    organizerFullName!: string | undefined;
    organizerFirstName!: string | undefined;
    organizerLastName!: string | undefined;
    organizerEmail!: string | undefined;
    organizerImage!: string | undefined;
    organizerInitials!: string | undefined;
    organizerStatusCode!: number | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    duration!: string | undefined;
    description!: string | undefined;
    onlineMeetingUrl!: string | undefined;
    meetingType!: string | undefined;
    weblink!: string | undefined;
    attendees!: string | undefined;
    readonly eventAttendees!: EventAttendee[] | undefined;
    isStartEndDateSame!: boolean | undefined;
    reminderMinutesBeforeStart!: number | undefined;
    isReminderOn!: boolean | undefined;
    isExistingContact!: boolean | undefined;
    recurrencePatternType!: RecurrencePatternType | undefined;
    isAddedOnMyDay!: boolean | undefined;

    constructor(data?: IGetCalendarEventById) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventId = _data["eventId"];
            this.subject = _data["subject"];
            this.organizerUserId = _data["organizerUserId"];
            this.organizerFullName = _data["organizerFullName"];
            this.organizerFirstName = _data["organizerFirstName"];
            this.organizerLastName = _data["organizerLastName"];
            this.organizerEmail = _data["organizerEmail"];
            this.organizerImage = _data["organizerImage"];
            this.organizerInitials = _data["organizerInitials"];
            this.organizerStatusCode = _data["organizerStatusCode"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.duration = _data["duration"];
            this.description = _data["description"];
            this.onlineMeetingUrl = _data["onlineMeetingUrl"];
            this.meetingType = _data["meetingType"];
            this.weblink = _data["weblink"];
            this.attendees = _data["attendees"];
            if (Array.isArray(_data["eventAttendees"])) {
                (this as any).eventAttendees = [] as any;
                for (let item of _data["eventAttendees"])
                    (this as any).eventAttendees!.push(EventAttendee.fromJS(item, _mappings));
            }
            this.isStartEndDateSame = _data["isStartEndDateSame"];
            this.reminderMinutesBeforeStart = _data["reminderMinutesBeforeStart"];
            this.isReminderOn = _data["isReminderOn"];
            this.isExistingContact = _data["isExistingContact"];
            this.recurrencePatternType = _data["recurrencePatternType"];
            this.isAddedOnMyDay = _data["isAddedOnMyDay"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetCalendarEventById | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetCalendarEventById>(data, _mappings, GetCalendarEventById);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventId"] = this.eventId;
        data["subject"] = this.subject;
        data["organizerUserId"] = this.organizerUserId;
        data["organizerFullName"] = this.organizerFullName;
        data["organizerFirstName"] = this.organizerFirstName;
        data["organizerLastName"] = this.organizerLastName;
        data["organizerEmail"] = this.organizerEmail;
        data["organizerImage"] = this.organizerImage;
        data["organizerInitials"] = this.organizerInitials;
        data["organizerStatusCode"] = this.organizerStatusCode;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["duration"] = this.duration;
        data["description"] = this.description;
        data["onlineMeetingUrl"] = this.onlineMeetingUrl;
        data["meetingType"] = this.meetingType;
        data["weblink"] = this.weblink;
        data["attendees"] = this.attendees;
        if (Array.isArray(this.eventAttendees)) {
            data["eventAttendees"] = [];
            for (let item of this.eventAttendees)
                data["eventAttendees"].push(item ? item.toJSON() : undefined as any);
        }
        data["isStartEndDateSame"] = this.isStartEndDateSame;
        data["reminderMinutesBeforeStart"] = this.reminderMinutesBeforeStart;
        data["isReminderOn"] = this.isReminderOn;
        data["isExistingContact"] = this.isExistingContact;
        data["recurrencePatternType"] = this.recurrencePatternType;
        data["isAddedOnMyDay"] = this.isAddedOnMyDay;
        return data;
    }
}

export interface IGetCalendarEventById {
    id: number | undefined;
    eventId: string | undefined;
    subject: string | undefined;
    organizerUserId: number | undefined;
    organizerFullName: string | undefined;
    organizerFirstName: string | undefined;
    organizerLastName: string | undefined;
    organizerEmail: string | undefined;
    organizerImage: string | undefined;
    organizerInitials: string | undefined;
    organizerStatusCode: number | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    duration: string | undefined;
    description: string | undefined;
    onlineMeetingUrl: string | undefined;
    meetingType: string | undefined;
    weblink: string | undefined;
    attendees: string | undefined;
    eventAttendees: EventAttendee[] | undefined;
    isStartEndDateSame: boolean | undefined;
    reminderMinutesBeforeStart: number | undefined;
    isReminderOn: boolean | undefined;
    isExistingContact: boolean | undefined;
    recurrencePatternType: RecurrencePatternType | undefined;
    isAddedOnMyDay: boolean | undefined;
}

export class GetCalendarEventByIdIHandleError implements IGetCalendarEventByIdIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetCalendarEventById | undefined;
    listOfEntities!: GetCalendarEventById[] | undefined;

    constructor(data?: IGetCalendarEventByIdIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetCalendarEventById.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetCalendarEventById.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetCalendarEventByIdIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetCalendarEventByIdIHandleError>(data, _mappings, GetCalendarEventByIdIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCalendarEventByIdIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetCalendarEventById | undefined;
    listOfEntities: GetCalendarEventById[] | undefined;
}

export class Int32MeetingsForWidgetListValueTuple implements IInt32MeetingsForWidgetListValueTuple {

    constructor(data?: IInt32MeetingsForWidgetListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): Int32MeetingsForWidgetListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32MeetingsForWidgetListValueTuple>(data, _mappings, Int32MeetingsForWidgetListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IInt32MeetingsForWidgetListValueTuple {
}

export class Int32MeetingsForWidgetListValueTupleIHandleError implements IInt32MeetingsForWidgetListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: Int32MeetingsForWidgetListValueTuple | undefined;
    listOfEntities!: Int32MeetingsForWidgetListValueTuple[] | undefined;

    constructor(data?: IInt32MeetingsForWidgetListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? Int32MeetingsForWidgetListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(Int32MeetingsForWidgetListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32MeetingsForWidgetListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32MeetingsForWidgetListValueTupleIHandleError>(data, _mappings, Int32MeetingsForWidgetListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInt32MeetingsForWidgetListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: Int32MeetingsForWidgetListValueTuple | undefined;
    listOfEntities: Int32MeetingsForWidgetListValueTuple[] | undefined;
}

export class CalendarPlannerDetailsUserCalenderForPlannerListValueTuple implements ICalendarPlannerDetailsUserCalenderForPlannerListValueTuple {

    constructor(data?: ICalendarPlannerDetailsUserCalenderForPlannerListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): CalendarPlannerDetailsUserCalenderForPlannerListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CalendarPlannerDetailsUserCalenderForPlannerListValueTuple>(data, _mappings, CalendarPlannerDetailsUserCalenderForPlannerListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICalendarPlannerDetailsUserCalenderForPlannerListValueTuple {
}

export class CalendarPlannerDetailsUserCalenderForPlannerListValueTupleIHandleError implements ICalendarPlannerDetailsUserCalenderForPlannerListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CalendarPlannerDetailsUserCalenderForPlannerListValueTuple | undefined;
    listOfEntities!: CalendarPlannerDetailsUserCalenderForPlannerListValueTuple[] | undefined;

    constructor(data?: ICalendarPlannerDetailsUserCalenderForPlannerListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CalendarPlannerDetailsUserCalenderForPlannerListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CalendarPlannerDetailsUserCalenderForPlannerListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CalendarPlannerDetailsUserCalenderForPlannerListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CalendarPlannerDetailsUserCalenderForPlannerListValueTupleIHandleError>(data, _mappings, CalendarPlannerDetailsUserCalenderForPlannerListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICalendarPlannerDetailsUserCalenderForPlannerListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CalendarPlannerDetailsUserCalenderForPlannerListValueTuple | undefined;
    listOfEntities: CalendarPlannerDetailsUserCalenderForPlannerListValueTuple[] | undefined;
}

export class EventAddedOnMyDay implements IEventAddedOnMyDay {
    eventId!: number | undefined;
    isAddedOnMyDay!: boolean | undefined;
    calendarEventId!: string | undefined;

    constructor(data?: IEventAddedOnMyDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.isAddedOnMyDay = _data["isAddedOnMyDay"];
            this.calendarEventId = _data["calendarEventId"];
        }
    }

    static fromJS(data: any, _mappings?: any): EventAddedOnMyDay | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EventAddedOnMyDay>(data, _mappings, EventAddedOnMyDay);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["isAddedOnMyDay"] = this.isAddedOnMyDay;
        data["calendarEventId"] = this.calendarEventId;
        return data;
    }
}

export interface IEventAddedOnMyDay {
    eventId: number | undefined;
    isAddedOnMyDay: boolean | undefined;
    calendarEventId: string | undefined;
}

export class FreeTimeDto implements IFreeTimeDto {
    startDate!: string | undefined;
    endDate!: string | undefined;
    duration!: string | undefined;
    timezoneAbbreviation!: string | undefined;

    constructor(data?: IFreeTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.duration = _data["duration"];
            this.timezoneAbbreviation = _data["timezoneAbbreviation"];
        }
    }

    static fromJS(data: any, _mappings?: any): FreeTimeDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FreeTimeDto>(data, _mappings, FreeTimeDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["duration"] = this.duration;
        data["timezoneAbbreviation"] = this.timezoneAbbreviation;
        return data;
    }
}

export interface IFreeTimeDto {
    startDate: string | undefined;
    endDate: string | undefined;
    duration: string | undefined;
    timezoneAbbreviation: string | undefined;
}

export class FreeTimeDtoListIHandleError implements IFreeTimeDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: FreeTimeDto[] | undefined;
    listOfEntities!: FreeTimeDto[][] | undefined;

    constructor(data?: IFreeTimeDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(FreeTimeDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): FreeTimeDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FreeTimeDtoListIHandleError>(data, _mappings, FreeTimeDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IFreeTimeDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: FreeTimeDto[] | undefined;
    listOfEntities: FreeTimeDto[][] | undefined;
}

export class UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTuple implements IUserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTuple {

    constructor(data?: IUserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTuple>(data, _mappings, UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTuple {
}

export class UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTupleIHandleError implements IUserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTuple | undefined;
    listOfEntities!: UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTuple[] | undefined;

    constructor(data?: IUserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTupleIHandleError>(data, _mappings, UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTuple | undefined;
    listOfEntities: UserMeetingMonthsDtoListUserMeetingsGroupDtoListUserMeetingsListValueTuple[] | undefined;
}

export enum EventStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class UserMeetings implements IUserMeetings {
    id!: number | undefined;
    subject!: string | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    duration!: string | undefined;
    dayName!: string | undefined;
    sourceAppName!: string | undefined;
    sourceAppIconURL!: string | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    monthName!: string | undefined;
    groupId!: number | undefined;
    meetingType!: string | undefined;
    meetingName!: string | undefined;
    isSeen!: boolean | undefined;
    isNew!: boolean | undefined;
    attendees!: string | undefined;
    attendeesCount!: number | undefined;
    readonly eventAttendees!: EventAttendee[] | undefined;
    onlineMeetingUrl!: string | undefined;
    eventStatus!: EventStatus | undefined;
    eventStatusDescription!: string | undefined;
    organizerUserId!: number | undefined;
    organizerFullName!: string | undefined;
    eventStartDateAtUserTz!: string | undefined;
    originalStartDateUserTz!: string | undefined;
    actualDayName!: string | undefined;
    description!: string | undefined;
    weblink!: string | undefined;
    durationInMinutes!: number | undefined;
    startDateTimeUTC!: string | undefined;
    isCompleted!: boolean | undefined;
    isAddedOnMyDay!: boolean | undefined;
    calendarEventId!: string | undefined;
    isBreak!: boolean | undefined;

    constructor(data?: IUserMeetings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.duration = _data["duration"];
            this.dayName = _data["dayName"];
            this.sourceAppName = _data["sourceAppName"];
            this.sourceAppIconURL = _data["sourceAppIconURL"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.monthName = _data["monthName"];
            this.groupId = _data["groupId"];
            this.meetingType = _data["meetingType"];
            this.meetingName = _data["meetingName"];
            this.isSeen = _data["isSeen"];
            this.isNew = _data["isNew"];
            this.attendees = _data["attendees"];
            this.attendeesCount = _data["attendeesCount"];
            if (Array.isArray(_data["eventAttendees"])) {
                (this as any).eventAttendees = [] as any;
                for (let item of _data["eventAttendees"])
                    (this as any).eventAttendees!.push(EventAttendee.fromJS(item, _mappings));
            }
            this.onlineMeetingUrl = _data["onlineMeetingUrl"];
            this.eventStatus = _data["eventStatus"];
            this.eventStatusDescription = _data["eventStatusDescription"];
            this.organizerUserId = _data["organizerUserId"];
            this.organizerFullName = _data["organizerFullName"];
            this.eventStartDateAtUserTz = _data["eventStartDateAtUserTz"];
            this.originalStartDateUserTz = _data["originalStartDateUserTz"];
            this.actualDayName = _data["actualDayName"];
            this.description = _data["description"];
            this.weblink = _data["weblink"];
            this.durationInMinutes = _data["durationInMinutes"];
            this.startDateTimeUTC = _data["startDateTimeUTC"];
            this.isCompleted = _data["isCompleted"];
            this.isAddedOnMyDay = _data["isAddedOnMyDay"];
            this.calendarEventId = _data["calendarEventId"];
            this.isBreak = _data["isBreak"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserMeetings | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserMeetings>(data, _mappings, UserMeetings);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["duration"] = this.duration;
        data["dayName"] = this.dayName;
        data["sourceAppName"] = this.sourceAppName;
        data["sourceAppIconURL"] = this.sourceAppIconURL;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["monthName"] = this.monthName;
        data["groupId"] = this.groupId;
        data["meetingType"] = this.meetingType;
        data["meetingName"] = this.meetingName;
        data["isSeen"] = this.isSeen;
        data["isNew"] = this.isNew;
        data["attendees"] = this.attendees;
        data["attendeesCount"] = this.attendeesCount;
        if (Array.isArray(this.eventAttendees)) {
            data["eventAttendees"] = [];
            for (let item of this.eventAttendees)
                data["eventAttendees"].push(item ? item.toJSON() : undefined as any);
        }
        data["onlineMeetingUrl"] = this.onlineMeetingUrl;
        data["eventStatus"] = this.eventStatus;
        data["eventStatusDescription"] = this.eventStatusDescription;
        data["organizerUserId"] = this.organizerUserId;
        data["organizerFullName"] = this.organizerFullName;
        data["eventStartDateAtUserTz"] = this.eventStartDateAtUserTz;
        data["originalStartDateUserTz"] = this.originalStartDateUserTz;
        data["actualDayName"] = this.actualDayName;
        data["description"] = this.description;
        data["weblink"] = this.weblink;
        data["durationInMinutes"] = this.durationInMinutes;
        data["startDateTimeUTC"] = this.startDateTimeUTC;
        data["isCompleted"] = this.isCompleted;
        data["isAddedOnMyDay"] = this.isAddedOnMyDay;
        data["calendarEventId"] = this.calendarEventId;
        data["isBreak"] = this.isBreak;
        return data;
    }
}

export interface IUserMeetings {
    id: number | undefined;
    subject: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    duration: string | undefined;
    dayName: string | undefined;
    sourceAppName: string | undefined;
    sourceAppIconURL: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    monthName: string | undefined;
    groupId: number | undefined;
    meetingType: string | undefined;
    meetingName: string | undefined;
    isSeen: boolean | undefined;
    isNew: boolean | undefined;
    attendees: string | undefined;
    attendeesCount: number | undefined;
    eventAttendees: EventAttendee[] | undefined;
    onlineMeetingUrl: string | undefined;
    eventStatus: EventStatus | undefined;
    eventStatusDescription: string | undefined;
    organizerUserId: number | undefined;
    organizerFullName: string | undefined;
    eventStartDateAtUserTz: string | undefined;
    originalStartDateUserTz: string | undefined;
    actualDayName: string | undefined;
    description: string | undefined;
    weblink: string | undefined;
    durationInMinutes: number | undefined;
    startDateTimeUTC: string | undefined;
    isCompleted: boolean | undefined;
    isAddedOnMyDay: boolean | undefined;
    calendarEventId: string | undefined;
    isBreak: boolean | undefined;
}

export class UserMeetingsListIHandleError implements IUserMeetingsListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserMeetings[] | undefined;
    listOfEntities!: UserMeetings[][] | undefined;

    constructor(data?: IUserMeetingsListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(UserMeetings.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserMeetingsListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserMeetingsListIHandleError>(data, _mappings, UserMeetingsListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IUserMeetingsListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserMeetings[] | undefined;
    listOfEntities: UserMeetings[][] | undefined;
}

export class GetUserActivityMeetingsOutput implements IGetUserActivityMeetingsOutput {
    id!: number | undefined;
    subject!: string | undefined;
    startTime!: string | undefined;
    duration!: string | undefined;
    isMeetingDone!: boolean | undefined;
    isAllDay!: boolean | undefined;
    groupId!: number | undefined;

    constructor(data?: IGetUserActivityMeetingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.startTime = _data["startTime"];
            this.duration = _data["duration"];
            this.isMeetingDone = _data["isMeetingDone"];
            this.isAllDay = _data["isAllDay"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserActivityMeetingsOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserActivityMeetingsOutput>(data, _mappings, GetUserActivityMeetingsOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["startTime"] = this.startTime;
        data["duration"] = this.duration;
        data["isMeetingDone"] = this.isMeetingDone;
        data["isAllDay"] = this.isAllDay;
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface IGetUserActivityMeetingsOutput {
    id: number | undefined;
    subject: string | undefined;
    startTime: string | undefined;
    duration: string | undefined;
    isMeetingDone: boolean | undefined;
    isAllDay: boolean | undefined;
    groupId: number | undefined;
}

export class GetUserActivityMeetingsOutputListIHandleError implements IGetUserActivityMeetingsOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetUserActivityMeetingsOutput[] | undefined;
    listOfEntities!: GetUserActivityMeetingsOutput[][] | undefined;

    constructor(data?: IGetUserActivityMeetingsOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(GetUserActivityMeetingsOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserActivityMeetingsOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserActivityMeetingsOutputListIHandleError>(data, _mappings, GetUserActivityMeetingsOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IGetUserActivityMeetingsOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetUserActivityMeetingsOutput[] | undefined;
    listOfEntities: GetUserActivityMeetingsOutput[][] | undefined;
}

export class UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTuple implements IUserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTuple {

    constructor(data?: IUserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTuple>(data, _mappings, UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTuple {
}

export class UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTupleIHandleError implements IUserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTuple | undefined;
    listOfEntities!: UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTuple[] | undefined;

    constructor(data?: IUserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTupleIHandleError>(data, _mappings, UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTuple | undefined;
    listOfEntities: UserMeetingMonthsDtoListUserMeetingsGroupDtoListGetUserActivityMeetingsOutputListValueTuple[] | undefined;
}

export class MeetingResponseDto implements IMeetingResponseDto {
    appMeetingId!: number | undefined;
    meetingId!: string | undefined;
    comment!: string | undefined;
    isAccepted!: boolean | undefined;
    isAcceptTentatively!: boolean | undefined;
    sendEmailToOrganizer!: boolean | undefined;

    constructor(data?: IMeetingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.appMeetingId = _data["appMeetingId"];
            this.meetingId = _data["meetingId"];
            this.comment = _data["comment"];
            this.isAccepted = _data["isAccepted"];
            this.isAcceptTentatively = _data["isAcceptTentatively"];
            this.sendEmailToOrganizer = _data["sendEmailToOrganizer"];
        }
    }

    static fromJS(data: any, _mappings?: any): MeetingResponseDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MeetingResponseDto>(data, _mappings, MeetingResponseDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appMeetingId"] = this.appMeetingId;
        data["meetingId"] = this.meetingId;
        data["comment"] = this.comment;
        data["isAccepted"] = this.isAccepted;
        data["isAcceptTentatively"] = this.isAcceptTentatively;
        data["sendEmailToOrganizer"] = this.sendEmailToOrganizer;
        return data;
    }
}

export interface IMeetingResponseDto {
    appMeetingId: number | undefined;
    meetingId: string | undefined;
    comment: string | undefined;
    isAccepted: boolean | undefined;
    isAcceptTentatively: boolean | undefined;
    sendEmailToOrganizer: boolean | undefined;
}

export class CalendarAccessRowDto implements ICalendarAccessRowDto {
    userId!: number | undefined;
    name!: string | undefined;
    bookerNames!: string[] | undefined;

    constructor(data?: ICalendarAccessRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            if (Array.isArray(_data["bookerNames"])) {
                this.bookerNames = [] as any;
                for (let item of _data["bookerNames"])
                    this.bookerNames!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CalendarAccessRowDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CalendarAccessRowDto>(data, _mappings, CalendarAccessRowDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        if (Array.isArray(this.bookerNames)) {
            data["bookerNames"] = [];
            for (let item of this.bookerNames)
                data["bookerNames"].push(item);
        }
        return data;
    }
}

export interface ICalendarAccessRowDto {
    userId: number | undefined;
    name: string | undefined;
    bookerNames: string[] | undefined;
}

export class CalendarAccessGrantDto implements ICalendarAccessGrantDto {
    id!: number | undefined;
    grantedUserId!: number | undefined;
    grantedName!: string | undefined;
    addedByAdmin!: boolean | undefined;

    constructor(data?: ICalendarAccessGrantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.grantedUserId = _data["grantedUserId"];
            this.grantedName = _data["grantedName"];
            this.addedByAdmin = _data["addedByAdmin"];
        }
    }

    static fromJS(data: any, _mappings?: any): CalendarAccessGrantDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CalendarAccessGrantDto>(data, _mappings, CalendarAccessGrantDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["grantedUserId"] = this.grantedUserId;
        data["grantedName"] = this.grantedName;
        data["addedByAdmin"] = this.addedByAdmin;
        return data;
    }
}

export interface ICalendarAccessGrantDto {
    id: number | undefined;
    grantedUserId: number | undefined;
    grantedName: string | undefined;
    addedByAdmin: boolean | undefined;
}

export class UserCalendarAccessDto implements IUserCalendarAccessDto {
    ownerUserId!: number | undefined;
    ownerName!: string | undefined;
    grants!: CalendarAccessGrantDto[] | undefined;

    constructor(data?: IUserCalendarAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.ownerUserId = _data["ownerUserId"];
            this.ownerName = _data["ownerName"];
            if (Array.isArray(_data["grants"])) {
                this.grants = [] as any;
                for (let item of _data["grants"])
                    this.grants!.push(CalendarAccessGrantDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserCalendarAccessDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserCalendarAccessDto>(data, _mappings, UserCalendarAccessDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerUserId"] = this.ownerUserId;
        data["ownerName"] = this.ownerName;
        if (Array.isArray(this.grants)) {
            data["grants"] = [];
            for (let item of this.grants)
                data["grants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserCalendarAccessDto {
    ownerUserId: number | undefined;
    ownerName: string | undefined;
    grants: CalendarAccessGrantDto[] | undefined;
}

export class AddCalendarGrantInput implements IAddCalendarGrantInput {
    ownerUserId!: number | undefined;
    grantedUserId!: number | undefined;

    constructor(data?: IAddCalendarGrantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.ownerUserId = _data["ownerUserId"];
            this.grantedUserId = _data["grantedUserId"];
        }
    }

    static fromJS(data: any, _mappings?: any): AddCalendarGrantInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddCalendarGrantInput>(data, _mappings, AddCalendarGrantInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerUserId"] = this.ownerUserId;
        data["grantedUserId"] = this.grantedUserId;
        return data;
    }
}

export interface IAddCalendarGrantInput {
    ownerUserId: number | undefined;
    grantedUserId: number | undefined;
}

export class CalendarSchedulerDto implements ICalendarSchedulerDto {
    id!: number | undefined;
    userId!: number | undefined;
    userName!: string | undefined;

    constructor(data?: ICalendarSchedulerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any, _mappings?: any): CalendarSchedulerDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CalendarSchedulerDto>(data, _mappings, CalendarSchedulerDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ICalendarSchedulerDto {
    id: number | undefined;
    userId: number | undefined;
    userName: string | undefined;
}

export class AddSchedulerInput implements IAddSchedulerInput {
    userId!: number | undefined;

    constructor(data?: IAddSchedulerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any, _mappings?: any): AddSchedulerInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddSchedulerInput>(data, _mappings, AddSchedulerInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAddSchedulerInput {
    userId: number | undefined;
}

export class CalendarDelegationDto implements ICalendarDelegationDto {
    id!: number | undefined;
    delegateUserId!: number | undefined;
    delegateName!: string | undefined;
    principalUserId!: number | undefined;
    principalName!: string | undefined;

    constructor(data?: ICalendarDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.delegateUserId = _data["delegateUserId"];
            this.delegateName = _data["delegateName"];
            this.principalUserId = _data["principalUserId"];
            this.principalName = _data["principalName"];
        }
    }

    static fromJS(data: any, _mappings?: any): CalendarDelegationDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CalendarDelegationDto>(data, _mappings, CalendarDelegationDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["delegateUserId"] = this.delegateUserId;
        data["delegateName"] = this.delegateName;
        data["principalUserId"] = this.principalUserId;
        data["principalName"] = this.principalName;
        return data;
    }
}

export interface ICalendarDelegationDto {
    id: number | undefined;
    delegateUserId: number | undefined;
    delegateName: string | undefined;
    principalUserId: number | undefined;
    principalName: string | undefined;
}

export class AddDelegationInput implements IAddDelegationInput {
    delegateUserId!: number | undefined;
    principalUserId!: number | undefined;

    constructor(data?: IAddDelegationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.delegateUserId = _data["delegateUserId"];
            this.principalUserId = _data["principalUserId"];
        }
    }

    static fromJS(data: any, _mappings?: any): AddDelegationInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddDelegationInput>(data, _mappings, AddDelegationInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegateUserId"] = this.delegateUserId;
        data["principalUserId"] = this.principalUserId;
        return data;
    }
}

export interface IAddDelegationInput {
    delegateUserId: number | undefined;
    principalUserId: number | undefined;
}

export enum CalendarVisibility {
    _1 = 1,
    _2 = 2,
}

export enum CalendarBookingMode {
    _1 = 1,
    _2 = 2,
}

export class CalendarSettingsDto implements ICalendarSettingsDto {
    featureEnabled!: boolean | undefined;
    isEnabled!: boolean | undefined;
    defaultVisibility!: CalendarVisibility | undefined;
    bookingMode!: CalendarBookingMode | undefined;

    constructor(data?: ICalendarSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.featureEnabled = _data["featureEnabled"];
            this.isEnabled = _data["isEnabled"];
            this.defaultVisibility = _data["defaultVisibility"];
            this.bookingMode = _data["bookingMode"];
        }
    }

    static fromJS(data: any, _mappings?: any): CalendarSettingsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CalendarSettingsDto>(data, _mappings, CalendarSettingsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureEnabled"] = this.featureEnabled;
        data["isEnabled"] = this.isEnabled;
        data["defaultVisibility"] = this.defaultVisibility;
        data["bookingMode"] = this.bookingMode;
        return data;
    }
}

export interface ICalendarSettingsDto {
    featureEnabled: boolean | undefined;
    isEnabled: boolean | undefined;
    defaultVisibility: CalendarVisibility | undefined;
    bookingMode: CalendarBookingMode | undefined;
}

export class SetCalendarEnabledInput implements ISetCalendarEnabledInput {
    isEnabled!: boolean | undefined;

    constructor(data?: ISetCalendarEnabledInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetCalendarEnabledInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetCalendarEnabledInput>(data, _mappings, SetCalendarEnabledInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface ISetCalendarEnabledInput {
    isEnabled: boolean | undefined;
}

export class UpdateCalendarPolicyInput implements IUpdateCalendarPolicyInput {
    defaultVisibility!: CalendarVisibility | undefined;
    bookingMode!: CalendarBookingMode | undefined;

    constructor(data?: IUpdateCalendarPolicyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.defaultVisibility = _data["defaultVisibility"];
            this.bookingMode = _data["bookingMode"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateCalendarPolicyInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateCalendarPolicyInput>(data, _mappings, UpdateCalendarPolicyInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultVisibility"] = this.defaultVisibility;
        data["bookingMode"] = this.bookingMode;
        return data;
    }
}

export interface IUpdateCalendarPolicyInput {
    defaultVisibility: CalendarVisibility | undefined;
    bookingMode: CalendarBookingMode | undefined;
}

export class ClientAutomationDto implements IClientAutomationDto {
    clientStageId!: number | undefined;
    clientTypeId!: number | undefined;
    projectCreationEnabled!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: IClientAutomationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.clientStageId = _data["clientStageId"];
            this.clientTypeId = _data["clientTypeId"];
            this.projectCreationEnabled = _data["projectCreationEnabled"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientAutomationDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientAutomationDto>(data, _mappings, ClientAutomationDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientStageId"] = this.clientStageId;
        data["clientTypeId"] = this.clientTypeId;
        data["projectCreationEnabled"] = this.projectCreationEnabled;
        data["id"] = this.id;
        return data;
    }
}

export interface IClientAutomationDto {
    clientStageId: number | undefined;
    clientTypeId: number | undefined;
    projectCreationEnabled: boolean | undefined;
    id: number | undefined;
}

export class ClientAutomationDtoListIHandleError implements IClientAutomationDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ClientAutomationDto[] | undefined;
    listOfEntities!: ClientAutomationDto[][] | undefined;

    constructor(data?: IClientAutomationDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ClientAutomationDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ClientAutomationDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientAutomationDtoListIHandleError>(data, _mappings, ClientAutomationDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IClientAutomationDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ClientAutomationDto[] | undefined;
    listOfEntities: ClientAutomationDto[][] | undefined;
}

export class ClientAutomationInputDto implements IClientAutomationInputDto {
    clientStageId!: number | undefined;
    clientTypeId!: number | undefined;
    projectCreationEnabled!: boolean | undefined;

    constructor(data?: IClientAutomationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.clientStageId = _data["clientStageId"];
            this.clientTypeId = _data["clientTypeId"];
            this.projectCreationEnabled = _data["projectCreationEnabled"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientAutomationInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientAutomationInputDto>(data, _mappings, ClientAutomationInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientStageId"] = this.clientStageId;
        data["clientTypeId"] = this.clientTypeId;
        data["projectCreationEnabled"] = this.projectCreationEnabled;
        return data;
    }
}

export interface IClientAutomationInputDto {
    clientStageId: number | undefined;
    clientTypeId: number | undefined;
    projectCreationEnabled: boolean | undefined;
}

export class ClientDetailEntryDto implements IClientDetailEntryDto {
    recordId!: number | undefined;
    isCompany!: boolean | undefined;
    id!: number | undefined;
    kind!: string;
    type!: number | undefined;
    customTypeId!: number | undefined;
    typeName!: string | undefined;
    isPrimary!: boolean | undefined;
    value!: string | undefined;
    countryCode!: string | undefined;
    extension!: string | undefined;
    countryId!: number | undefined;
    street!: string | undefined;
    suite!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    postalCode!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthDay!: number | undefined;
    birthMonth!: number | undefined;
    birthYear!: number | undefined;
    citizenshipId!: number | undefined;

    constructor(data?: IClientDetailEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.recordId = _data["recordId"];
            this.isCompany = _data["isCompany"];
            this.id = _data["id"];
            this.kind = _data["kind"];
            this.type = _data["type"];
            this.customTypeId = _data["customTypeId"];
            this.typeName = _data["typeName"];
            this.isPrimary = _data["isPrimary"];
            this.value = _data["value"];
            this.countryCode = _data["countryCode"];
            this.extension = _data["extension"];
            this.countryId = _data["countryId"];
            this.street = _data["street"];
            this.suite = _data["suite"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthDay = _data["birthDay"];
            this.birthMonth = _data["birthMonth"];
            this.birthYear = _data["birthYear"];
            this.citizenshipId = _data["citizenshipId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientDetailEntryDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientDetailEntryDto>(data, _mappings, ClientDetailEntryDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordId"] = this.recordId;
        data["isCompany"] = this.isCompany;
        data["id"] = this.id;
        data["kind"] = this.kind;
        data["type"] = this.type;
        data["customTypeId"] = this.customTypeId;
        data["typeName"] = this.typeName;
        data["isPrimary"] = this.isPrimary;
        data["value"] = this.value;
        data["countryCode"] = this.countryCode;
        data["extension"] = this.extension;
        data["countryId"] = this.countryId;
        data["street"] = this.street;
        data["suite"] = this.suite;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthDay"] = this.birthDay;
        data["birthMonth"] = this.birthMonth;
        data["birthYear"] = this.birthYear;
        data["citizenshipId"] = this.citizenshipId;
        return data;
    }
}

export interface IClientDetailEntryDto {
    recordId: number | undefined;
    isCompany: boolean | undefined;
    id: number | undefined;
    kind: string;
    type: number | undefined;
    customTypeId: number | undefined;
    typeName: string | undefined;
    isPrimary: boolean | undefined;
    value: string | undefined;
    countryCode: string | undefined;
    extension: string | undefined;
    countryId: number | undefined;
    street: string | undefined;
    suite: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postalCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    birthDay: number | undefined;
    birthMonth: number | undefined;
    birthYear: number | undefined;
    citizenshipId: number | undefined;
}

export class ClientDetailOptionDto implements IClientDetailOptionDto {
    id!: number | undefined;
    name!: string | undefined;
    code!: string | undefined;
    isCustom!: boolean | undefined;

    constructor(data?: IClientDetailOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isCustom = _data["isCustom"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientDetailOptionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientDetailOptionDto>(data, _mappings, ClientDetailOptionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isCustom"] = this.isCustom;
        return data;
    }
}

export interface IClientDetailOptionDto {
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
    isCustom: boolean | undefined;
}

export class ClientRecordDetailsDto implements IClientRecordDetailsDto {
    recordId!: number | undefined;
    isCompany!: boolean | undefined;
    jobTitle!: string | undefined;
    website!: string | undefined;
    linkedInUrl!: string | undefined;
    driverLicenceState!: string | undefined;
    driverLicenceNumber!: string | undefined;
    birthDay!: string | undefined;
    birthMonth!: string | undefined;
    birthYear!: string | undefined;
    socialSecurityNumber!: string | undefined;
    accountNumber!: string | undefined;
    taxId!: string | undefined;
    industryId!: number | undefined;
    entries!: ClientDetailEntryDto[] | undefined;
    countries!: ClientDetailOptionDto[] | undefined;
    industries!: ClientDetailOptionDto[] | undefined;

    constructor(data?: IClientRecordDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.recordId = _data["recordId"];
            this.isCompany = _data["isCompany"];
            this.jobTitle = _data["jobTitle"];
            this.website = _data["website"];
            this.linkedInUrl = _data["linkedInUrl"];
            this.driverLicenceState = _data["driverLicenceState"];
            this.driverLicenceNumber = _data["driverLicenceNumber"];
            this.birthDay = _data["birthDay"];
            this.birthMonth = _data["birthMonth"];
            this.birthYear = _data["birthYear"];
            this.socialSecurityNumber = _data["socialSecurityNumber"];
            this.accountNumber = _data["accountNumber"];
            this.taxId = _data["taxId"];
            this.industryId = _data["industryId"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(ClientDetailEntryDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(ClientDetailOptionDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["industries"])) {
                this.industries = [] as any;
                for (let item of _data["industries"])
                    this.industries!.push(ClientDetailOptionDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ClientRecordDetailsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientRecordDetailsDto>(data, _mappings, ClientRecordDetailsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordId"] = this.recordId;
        data["isCompany"] = this.isCompany;
        data["jobTitle"] = this.jobTitle;
        data["website"] = this.website;
        data["linkedInUrl"] = this.linkedInUrl;
        data["driverLicenceState"] = this.driverLicenceState;
        data["driverLicenceNumber"] = this.driverLicenceNumber;
        data["birthDay"] = this.birthDay;
        data["birthMonth"] = this.birthMonth;
        data["birthYear"] = this.birthYear;
        data["socialSecurityNumber"] = this.socialSecurityNumber;
        data["accountNumber"] = this.accountNumber;
        data["taxId"] = this.taxId;
        data["industryId"] = this.industryId;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.industries)) {
            data["industries"] = [];
            for (let item of this.industries)
                data["industries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClientRecordDetailsDto {
    recordId: number | undefined;
    isCompany: boolean | undefined;
    jobTitle: string | undefined;
    website: string | undefined;
    linkedInUrl: string | undefined;
    driverLicenceState: string | undefined;
    driverLicenceNumber: string | undefined;
    birthDay: string | undefined;
    birthMonth: string | undefined;
    birthYear: string | undefined;
    socialSecurityNumber: string | undefined;
    accountNumber: string | undefined;
    taxId: string | undefined;
    industryId: number | undefined;
    entries: ClientDetailEntryDto[] | undefined;
    countries: ClientDetailOptionDto[] | undefined;
    industries: ClientDetailOptionDto[] | undefined;
}

export class SaveClientDetailFieldDto implements ISaveClientDetailFieldDto {
    recordId!: number | undefined;
    isCompany!: boolean | undefined;
    field!: string;
    value!: string | undefined;
    driverLicenceState!: string | undefined;
    birthDay!: number | undefined;
    birthMonth!: number | undefined;
    birthYear!: number | undefined;

    constructor(data?: ISaveClientDetailFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.recordId = _data["recordId"];
            this.isCompany = _data["isCompany"];
            this.field = _data["field"];
            this.value = _data["value"];
            this.driverLicenceState = _data["driverLicenceState"];
            this.birthDay = _data["birthDay"];
            this.birthMonth = _data["birthMonth"];
            this.birthYear = _data["birthYear"];
        }
    }

    static fromJS(data: any, _mappings?: any): SaveClientDetailFieldDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveClientDetailFieldDto>(data, _mappings, SaveClientDetailFieldDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordId"] = this.recordId;
        data["isCompany"] = this.isCompany;
        data["field"] = this.field;
        data["value"] = this.value;
        data["driverLicenceState"] = this.driverLicenceState;
        data["birthDay"] = this.birthDay;
        data["birthMonth"] = this.birthMonth;
        data["birthYear"] = this.birthYear;
        return data;
    }
}

export interface ISaveClientDetailFieldDto {
    recordId: number | undefined;
    isCompany: boolean | undefined;
    field: string;
    value: string | undefined;
    driverLicenceState: string | undefined;
    birthDay: number | undefined;
    birthMonth: number | undefined;
    birthYear: number | undefined;
}

export class CreateClientDetailTypeDto implements ICreateClientDetailTypeDto {
    kind!: string;
    isCompany!: boolean | undefined;
    name!: string;

    constructor(data?: ICreateClientDetailTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.isCompany = _data["isCompany"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateClientDetailTypeDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateClientDetailTypeDto>(data, _mappings, CreateClientDetailTypeDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["isCompany"] = this.isCompany;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateClientDetailTypeDto {
    kind: string;
    isCompany: boolean | undefined;
    name: string;
}

export enum ClientStageBoardVisibility {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ClientStageSettingsDto implements IClientStageSettingsDto {
    id!: number | undefined;
    name!: string | undefined;
    act!: ClientStageAct | undefined;
    sortOrder!: number | undefined;
    suggestFollowUpDays!: number | undefined;
    boardVisibility!: ClientStageBoardVisibility | undefined;
    hideAfterDays!: number | undefined;
    changeClientTypeId!: number | undefined;
    promptCreateProject!: boolean | undefined;
    nextStep!: string | undefined;
    nextStepNotes!: string | undefined;
    noFollowUp!: boolean | undefined;
    clientCount!: number | undefined;
    defaultLostReasonId!: number | undefined;

    constructor(data?: IClientStageSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.act = _data["act"];
            this.sortOrder = _data["sortOrder"];
            this.suggestFollowUpDays = _data["suggestFollowUpDays"];
            this.boardVisibility = _data["boardVisibility"];
            this.hideAfterDays = _data["hideAfterDays"];
            this.changeClientTypeId = _data["changeClientTypeId"];
            this.promptCreateProject = _data["promptCreateProject"];
            this.nextStep = _data["nextStep"];
            this.nextStepNotes = _data["nextStepNotes"];
            this.noFollowUp = _data["noFollowUp"];
            this.clientCount = _data["clientCount"];
            this.defaultLostReasonId = _data["defaultLostReasonId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientStageSettingsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientStageSettingsDto>(data, _mappings, ClientStageSettingsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["act"] = this.act;
        data["sortOrder"] = this.sortOrder;
        data["suggestFollowUpDays"] = this.suggestFollowUpDays;
        data["boardVisibility"] = this.boardVisibility;
        data["hideAfterDays"] = this.hideAfterDays;
        data["changeClientTypeId"] = this.changeClientTypeId;
        data["promptCreateProject"] = this.promptCreateProject;
        data["nextStep"] = this.nextStep;
        data["nextStepNotes"] = this.nextStepNotes;
        data["noFollowUp"] = this.noFollowUp;
        data["clientCount"] = this.clientCount;
        data["defaultLostReasonId"] = this.defaultLostReasonId;
        return data;
    }
}

export interface IClientStageSettingsDto {
    id: number | undefined;
    name: string | undefined;
    act: ClientStageAct | undefined;
    sortOrder: number | undefined;
    suggestFollowUpDays: number | undefined;
    boardVisibility: ClientStageBoardVisibility | undefined;
    hideAfterDays: number | undefined;
    changeClientTypeId: number | undefined;
    promptCreateProject: boolean | undefined;
    nextStep: string | undefined;
    nextStepNotes: string | undefined;
    noFollowUp: boolean | undefined;
    clientCount: number | undefined;
    defaultLostReasonId: number | undefined;
}

export class ClientStageSettingsDtoListIHandleError implements IClientStageSettingsDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ClientStageSettingsDto[] | undefined;
    listOfEntities!: ClientStageSettingsDto[][] | undefined;

    constructor(data?: IClientStageSettingsDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ClientStageSettingsDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ClientStageSettingsDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientStageSettingsDtoListIHandleError>(data, _mappings, ClientStageSettingsDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IClientStageSettingsDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ClientStageSettingsDto[] | undefined;
    listOfEntities: ClientStageSettingsDto[][] | undefined;
}

export class SaveClientStageInput implements ISaveClientStageInput {
    id!: number | undefined;
    name!: string | undefined;
    act!: ClientStageAct | undefined;
    suggestFollowUpDays!: number | undefined;
    boardVisibility!: ClientStageBoardVisibility | undefined;
    hideAfterDays!: number | undefined;
    changeClientTypeId!: number | undefined;
    promptCreateProject!: boolean | undefined;
    nextStep!: string | undefined;
    nextStepNotes!: string | undefined;
    noFollowUp!: boolean | undefined;
    defaultLostReasonId!: number | undefined;

    constructor(data?: ISaveClientStageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.act = _data["act"];
            this.suggestFollowUpDays = _data["suggestFollowUpDays"];
            this.boardVisibility = _data["boardVisibility"];
            this.hideAfterDays = _data["hideAfterDays"];
            this.changeClientTypeId = _data["changeClientTypeId"];
            this.promptCreateProject = _data["promptCreateProject"];
            this.nextStep = _data["nextStep"];
            this.nextStepNotes = _data["nextStepNotes"];
            this.noFollowUp = _data["noFollowUp"];
            this.defaultLostReasonId = _data["defaultLostReasonId"];
        }
    }

    static fromJS(data: any, _mappings?: any): SaveClientStageInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveClientStageInput>(data, _mappings, SaveClientStageInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["act"] = this.act;
        data["suggestFollowUpDays"] = this.suggestFollowUpDays;
        data["boardVisibility"] = this.boardVisibility;
        data["hideAfterDays"] = this.hideAfterDays;
        data["changeClientTypeId"] = this.changeClientTypeId;
        data["promptCreateProject"] = this.promptCreateProject;
        data["nextStep"] = this.nextStep;
        data["nextStepNotes"] = this.nextStepNotes;
        data["noFollowUp"] = this.noFollowUp;
        data["defaultLostReasonId"] = this.defaultLostReasonId;
        return data;
    }
}

export interface ISaveClientStageInput {
    id: number | undefined;
    name: string | undefined;
    act: ClientStageAct | undefined;
    suggestFollowUpDays: number | undefined;
    boardVisibility: ClientStageBoardVisibility | undefined;
    hideAfterDays: number | undefined;
    changeClientTypeId: number | undefined;
    promptCreateProject: boolean | undefined;
    nextStep: string | undefined;
    nextStepNotes: string | undefined;
    noFollowUp: boolean | undefined;
    defaultLostReasonId: number | undefined;
}

export class SaveClientStageOutput implements ISaveClientStageOutput {
    stage!: ClientStageSettingsDto | undefined;
    invalidField!: string | undefined;

    constructor(data?: ISaveClientStageOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.stage = _data["stage"] ? ClientStageSettingsDto.fromJS(_data["stage"], _mappings) : undefined as any;
            this.invalidField = _data["invalidField"];
        }
    }

    static fromJS(data: any, _mappings?: any): SaveClientStageOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveClientStageOutput>(data, _mappings, SaveClientStageOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage ? this.stage.toJSON() : undefined as any;
        data["invalidField"] = this.invalidField;
        return data;
    }
}

export interface ISaveClientStageOutput {
    stage: ClientStageSettingsDto | undefined;
    invalidField: string | undefined;
}

export class SaveClientStageOutputIHandleError implements ISaveClientStageOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SaveClientStageOutput | undefined;
    listOfEntities!: SaveClientStageOutput[] | undefined;

    constructor(data?: ISaveClientStageOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SaveClientStageOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SaveClientStageOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SaveClientStageOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveClientStageOutputIHandleError>(data, _mappings, SaveClientStageOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveClientStageOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SaveClientStageOutput | undefined;
    listOfEntities: SaveClientStageOutput[] | undefined;
}

export class SortOrderPosition implements ISortOrderPosition {
    keyId!: number | undefined;
    sortOrder!: number | undefined;

    constructor(data?: ISortOrderPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.keyId = _data["keyId"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): SortOrderPosition | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SortOrderPosition>(data, _mappings, SortOrderPosition);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyId"] = this.keyId;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ISortOrderPosition {
    keyId: number | undefined;
    sortOrder: number | undefined;
}

export class ReorderClientListInput implements IReorderClientListInput {
    positions!: SortOrderPosition[] | undefined;

    constructor(data?: IReorderClientListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(SortOrderPosition.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ReorderClientListInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReorderClientListInput>(data, _mappings, ReorderClientListInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReorderClientListInput {
    positions: SortOrderPosition[] | undefined;
}

export class ClientSourceSettingsDto implements IClientSourceSettingsDto {
    id!: number | undefined;
    name!: string | undefined;
    guidance!: string | undefined;
    sortOrder!: number | undefined;

    constructor(data?: IClientSourceSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.guidance = _data["guidance"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientSourceSettingsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientSourceSettingsDto>(data, _mappings, ClientSourceSettingsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["guidance"] = this.guidance;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IClientSourceSettingsDto {
    id: number | undefined;
    name: string | undefined;
    guidance: string | undefined;
    sortOrder: number | undefined;
}

export class ClientSourceSettingsDtoListIHandleError implements IClientSourceSettingsDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ClientSourceSettingsDto[] | undefined;
    listOfEntities!: ClientSourceSettingsDto[][] | undefined;

    constructor(data?: IClientSourceSettingsDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ClientSourceSettingsDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ClientSourceSettingsDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientSourceSettingsDtoListIHandleError>(data, _mappings, ClientSourceSettingsDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IClientSourceSettingsDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ClientSourceSettingsDto[] | undefined;
    listOfEntities: ClientSourceSettingsDto[][] | undefined;
}

export class SaveClientSourceInput implements ISaveClientSourceInput {
    id!: number | undefined;
    name!: string | undefined;
    guidance!: string | undefined;

    constructor(data?: ISaveClientSourceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.guidance = _data["guidance"];
        }
    }

    static fromJS(data: any, _mappings?: any): SaveClientSourceInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveClientSourceInput>(data, _mappings, SaveClientSourceInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["guidance"] = this.guidance;
        return data;
    }
}

export interface ISaveClientSourceInput {
    id: number | undefined;
    name: string | undefined;
    guidance: string | undefined;
}

export class SaveClientSourceOutput implements ISaveClientSourceOutput {
    source!: ClientSourceSettingsDto | undefined;
    invalidField!: string | undefined;

    constructor(data?: ISaveClientSourceOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.source = _data["source"] ? ClientSourceSettingsDto.fromJS(_data["source"], _mappings) : undefined as any;
            this.invalidField = _data["invalidField"];
        }
    }

    static fromJS(data: any, _mappings?: any): SaveClientSourceOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveClientSourceOutput>(data, _mappings, SaveClientSourceOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source ? this.source.toJSON() : undefined as any;
        data["invalidField"] = this.invalidField;
        return data;
    }
}

export interface ISaveClientSourceOutput {
    source: ClientSourceSettingsDto | undefined;
    invalidField: string | undefined;
}

export class SaveClientSourceOutputIHandleError implements ISaveClientSourceOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SaveClientSourceOutput | undefined;
    listOfEntities!: SaveClientSourceOutput[] | undefined;

    constructor(data?: ISaveClientSourceOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SaveClientSourceOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SaveClientSourceOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SaveClientSourceOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveClientSourceOutputIHandleError>(data, _mappings, SaveClientSourceOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveClientSourceOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SaveClientSourceOutput | undefined;
    listOfEntities: SaveClientSourceOutput[] | undefined;
}

export class SuggestClientSourceGuidanceInput implements ISuggestClientSourceGuidanceInput {
    name!: string | undefined;

    constructor(data?: ISuggestClientSourceGuidanceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): SuggestClientSourceGuidanceInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SuggestClientSourceGuidanceInput>(data, _mappings, SuggestClientSourceGuidanceInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISuggestClientSourceGuidanceInput {
    name: string | undefined;
}

export class ClientSourceGuidanceSuggestionDto implements IClientSourceGuidanceSuggestionDto {
    name!: string | undefined;
    guidance!: string | undefined;

    constructor(data?: IClientSourceGuidanceSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.guidance = _data["guidance"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientSourceGuidanceSuggestionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientSourceGuidanceSuggestionDto>(data, _mappings, ClientSourceGuidanceSuggestionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["guidance"] = this.guidance;
        return data;
    }
}

export interface IClientSourceGuidanceSuggestionDto {
    name: string | undefined;
    guidance: string | undefined;
}

export class ClientSourceGuidanceSuggestionDtoIHandleError implements IClientSourceGuidanceSuggestionDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ClientSourceGuidanceSuggestionDto | undefined;
    listOfEntities!: ClientSourceGuidanceSuggestionDto[] | undefined;

    constructor(data?: IClientSourceGuidanceSuggestionDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ClientSourceGuidanceSuggestionDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ClientSourceGuidanceSuggestionDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ClientSourceGuidanceSuggestionDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientSourceGuidanceSuggestionDtoIHandleError>(data, _mappings, ClientSourceGuidanceSuggestionDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClientSourceGuidanceSuggestionDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ClientSourceGuidanceSuggestionDto | undefined;
    listOfEntities: ClientSourceGuidanceSuggestionDto[] | undefined;
}

export class CreateProjectReminderInput implements ICreateProjectReminderInput {
    transitionId!: number | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    clientName!: string | undefined;

    constructor(data?: ICreateProjectReminderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transitionId = _data["transitionId"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.clientName = _data["clientName"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateProjectReminderInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateProjectReminderInput>(data, _mappings, CreateProjectReminderInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transitionId"] = this.transitionId;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["clientName"] = this.clientName;
        return data;
    }
}

export interface ICreateProjectReminderInput {
    transitionId: number | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    clientName: string | undefined;
}

export class ProjectReminderDto implements IProjectReminderDto {
    taskId!: number | undefined;
    created!: boolean | undefined;
    caseCreated!: boolean | undefined;
    caseProjectId!: number | undefined;

    constructor(data?: IProjectReminderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.created = _data["created"];
            this.caseCreated = _data["caseCreated"];
            this.caseProjectId = _data["caseProjectId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectReminderDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectReminderDto>(data, _mappings, ProjectReminderDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["created"] = this.created;
        data["caseCreated"] = this.caseCreated;
        data["caseProjectId"] = this.caseProjectId;
        return data;
    }
}

export interface IProjectReminderDto {
    taskId: number | undefined;
    created: boolean | undefined;
    caseCreated: boolean | undefined;
    caseProjectId: number | undefined;
}

export class ProjectReminderDtoIHandleError implements IProjectReminderDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectReminderDto | undefined;
    listOfEntities!: ProjectReminderDto[] | undefined;

    constructor(data?: IProjectReminderDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProjectReminderDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProjectReminderDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectReminderDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectReminderDtoIHandleError>(data, _mappings, ProjectReminderDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectReminderDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectReminderDto | undefined;
    listOfEntities: ProjectReminderDto[] | undefined;
}

export class TeamUserDto implements ITeamUserDto {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    userId!: number | undefined;
    teamId!: number | undefined;
    userName!: string | undefined;

    constructor(data?: ITeamUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.userId = _data["userId"];
            this.teamId = _data["teamId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any, _mappings?: any): TeamUserDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TeamUserDto>(data, _mappings, TeamUserDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["userId"] = this.userId;
        data["teamId"] = this.teamId;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ITeamUserDto {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    userId: number | undefined;
    teamId: number | undefined;
    userName: string | undefined;
}

export class TeamDto implements ITeamDto {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    name!: string | undefined;
    teamUsers!: TeamUserDto[] | undefined;
    tenantId!: number | undefined;
    readonly totalUser!: number | undefined;

    constructor(data?: ITeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.name = _data["name"];
            if (Array.isArray(_data["teamUsers"])) {
                this.teamUsers = [] as any;
                for (let item of _data["teamUsers"])
                    this.teamUsers!.push(TeamUserDto.fromJS(item, _mappings));
            }
            this.tenantId = _data["tenantId"];
            (this as any).totalUser = _data["totalUser"];
        }
    }

    static fromJS(data: any, _mappings?: any): TeamDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TeamDto>(data, _mappings, TeamDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["name"] = this.name;
        if (Array.isArray(this.teamUsers)) {
            data["teamUsers"] = [];
            for (let item of this.teamUsers)
                data["teamUsers"].push(item ? item.toJSON() : undefined as any);
        }
        data["tenantId"] = this.tenantId;
        data["totalUser"] = this.totalUser;
        return data;
    }
}

export interface ITeamDto {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    name: string | undefined;
    teamUsers: TeamUserDto[] | undefined;
    tenantId: number | undefined;
    totalUser: number | undefined;
}

export class TeamDtoPagedResultDto implements ITeamDtoPagedResultDto {
    items!: TeamDto[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: ITeamDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TeamDto.fromJS(item, _mappings));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): TeamDtoPagedResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TeamDtoPagedResultDto>(data, _mappings, TeamDtoPagedResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ITeamDtoPagedResultDto {
    items: TeamDto[] | undefined;
    totalCount: number | undefined;
}

export class TaskDto implements ITaskDto {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    tenantId!: number | undefined;
    title!: string | undefined;
    description!: string | undefined;

    constructor(data?: ITaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.tenantId = _data["tenantId"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskDto>(data, _mappings, TaskDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["tenantId"] = this.tenantId;
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface ITaskDto {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    tenantId: number | undefined;
    title: string | undefined;
    description: string | undefined;
}

export class TaskDtoPagedResultDto implements ITaskDtoPagedResultDto {
    items!: TaskDto[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: ITaskDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TaskDto.fromJS(item, _mappings));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskDtoPagedResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskDtoPagedResultDto>(data, _mappings, TaskDtoPagedResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ITaskDtoPagedResultDto {
    items: TaskDto[] | undefined;
    totalCount: number | undefined;
}

export enum ReminderFrequency {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class TimeSpan implements ITimeSpan {
    readonly ticks!: number | undefined;
    readonly days!: number | undefined;
    readonly hours!: number | undefined;
    readonly milliseconds!: number | undefined;
    readonly minutes!: number | undefined;
    readonly seconds!: number | undefined;
    readonly totalDays!: number | undefined;
    readonly totalHours!: number | undefined;
    readonly totalMilliseconds!: number | undefined;
    readonly totalMinutes!: number | undefined;
    readonly totalSeconds!: number | undefined;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (this as any).ticks = _data["ticks"];
            (this as any).days = _data["days"];
            (this as any).hours = _data["hours"];
            (this as any).milliseconds = _data["milliseconds"];
            (this as any).minutes = _data["minutes"];
            (this as any).seconds = _data["seconds"];
            (this as any).totalDays = _data["totalDays"];
            (this as any).totalHours = _data["totalHours"];
            (this as any).totalMilliseconds = _data["totalMilliseconds"];
            (this as any).totalMinutes = _data["totalMinutes"];
            (this as any).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any, _mappings?: any): TimeSpan | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TimeSpan>(data, _mappings, TimeSpan);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }
}

export interface ITimeSpan {
    ticks: number | undefined;
    days: number | undefined;
    hours: number | undefined;
    milliseconds: number | undefined;
    minutes: number | undefined;
    seconds: number | undefined;
    totalDays: number | undefined;
    totalHours: number | undefined;
    totalMilliseconds: number | undefined;
    totalMinutes: number | undefined;
    totalSeconds: number | undefined;
}

export class ShiftDto implements IShiftDto {
    id!: number | undefined;
    shiftName!: string | undefined;
    startTime!: TimeSpan | undefined;
    isShiftSpanMultiDays!: boolean | undefined;

    constructor(data?: IShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shiftName = _data["shiftName"];
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"], _mappings) : undefined as any;
            this.isShiftSpanMultiDays = _data["isShiftSpanMultiDays"];
        }
    }

    static fromJS(data: any, _mappings?: any): ShiftDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ShiftDto>(data, _mappings, ShiftDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shiftName"] = this.shiftName;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : undefined as any;
        data["isShiftSpanMultiDays"] = this.isShiftSpanMultiDays;
        return data;
    }
}

export interface IShiftDto {
    id: number | undefined;
    shiftName: string | undefined;
    startTime: TimeSpan | undefined;
    isShiftSpanMultiDays: boolean | undefined;
}

export class CheckInPolicyDto implements ICheckInPolicyDto {
    id!: number | undefined;
    companyWorkDays!: string[] | undefined;
    checkInTime!: string | undefined;
    reminderFrequency!: ReminderFrequency | undefined;
    isSendEmail!: boolean | undefined;
    isSendSms!: boolean | undefined;
    terms!: string | undefined;
    timeZoneId!: number | undefined;
    timezoneName!: string | undefined;
    shifts!: ShiftDto[] | undefined;

    constructor(data?: ICheckInPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["companyWorkDays"])) {
                this.companyWorkDays = [] as any;
                for (let item of _data["companyWorkDays"])
                    this.companyWorkDays!.push(item);
            }
            this.checkInTime = _data["checkInTime"];
            this.reminderFrequency = _data["reminderFrequency"];
            this.isSendEmail = _data["isSendEmail"];
            this.isSendSms = _data["isSendSms"];
            this.terms = _data["terms"];
            this.timeZoneId = _data["timeZoneId"];
            this.timezoneName = _data["timezoneName"];
            if (Array.isArray(_data["shifts"])) {
                this.shifts = [] as any;
                for (let item of _data["shifts"])
                    this.shifts!.push(ShiftDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CheckInPolicyDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckInPolicyDto>(data, _mappings, CheckInPolicyDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.companyWorkDays)) {
            data["companyWorkDays"] = [];
            for (let item of this.companyWorkDays)
                data["companyWorkDays"].push(item);
        }
        data["checkInTime"] = this.checkInTime;
        data["reminderFrequency"] = this.reminderFrequency;
        data["isSendEmail"] = this.isSendEmail;
        data["isSendSms"] = this.isSendSms;
        data["terms"] = this.terms;
        data["timeZoneId"] = this.timeZoneId;
        data["timezoneName"] = this.timezoneName;
        if (Array.isArray(this.shifts)) {
            data["shifts"] = [];
            for (let item of this.shifts)
                data["shifts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICheckInPolicyDto {
    id: number | undefined;
    companyWorkDays: string[] | undefined;
    checkInTime: string | undefined;
    reminderFrequency: ReminderFrequency | undefined;
    isSendEmail: boolean | undefined;
    isSendSms: boolean | undefined;
    terms: string | undefined;
    timeZoneId: number | undefined;
    timezoneName: string | undefined;
    shifts: ShiftDto[] | undefined;
}

export class SrcMoodOutputDto implements ISrcMoodOutputDto {
    id!: number | undefined;
    isDeleted!: boolean | undefined;
    tenantId!: number | undefined;
    moodName!: string | undefined;
    moodIcon!: string | undefined;
    moodClass!: string | undefined;

    constructor(data?: ISrcMoodOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.tenantId = _data["tenantId"];
            this.moodName = _data["moodName"];
            this.moodIcon = _data["moodIcon"];
            this.moodClass = _data["moodClass"];
        }
    }

    static fromJS(data: any, _mappings?: any): SrcMoodOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SrcMoodOutputDto>(data, _mappings, SrcMoodOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["tenantId"] = this.tenantId;
        data["moodName"] = this.moodName;
        data["moodIcon"] = this.moodIcon;
        data["moodClass"] = this.moodClass;
        return data;
    }
}

export interface ISrcMoodOutputDto {
    id: number | undefined;
    isDeleted: boolean | undefined;
    tenantId: number | undefined;
    moodName: string | undefined;
    moodIcon: string | undefined;
    moodClass: string | undefined;
}

export enum AcknowledgementType {
    _1 = 1,
    _2 = 2,
}

export class EmailAddress implements IEmailAddress {
    address!: string | undefined;
    name!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IEmailAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.address = _data["address"];
            this.name = _data["name"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): EmailAddress | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmailAddress>(data, _mappings, EmailAddress);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["name"] = this.name;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IEmailAddress {
    address: string | undefined;
    name: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export class Recipient implements IRecipient {
    emailAddress!: EmailAddress | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IRecipient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"] ? EmailAddress.fromJS(_data["emailAddress"], _mappings) : undefined as any;
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): Recipient | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Recipient>(data, _mappings, Recipient);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress ? this.emailAddress.toJSON() : undefined as any;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IRecipient {
    emailAddress: EmailAddress | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export enum BodyType {
    _0 = 0,
    _1 = 1,
}

export class ItemBody implements IItemBody {
    content!: string | undefined;
    contentType!: BodyType | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IItemBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.content = _data["content"];
            this.contentType = _data["contentType"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): ItemBody | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ItemBody>(data, _mappings, ItemBody);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["contentType"] = this.contentType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IItemBody {
    content: string | undefined;
    contentType: BodyType | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export class DateTimeTimeZone implements IDateTimeTimeZone {
    dateTime!: string | undefined;
    timeZone!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IDateTimeTimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"];
            this.timeZone = _data["timeZone"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): DateTimeTimeZone | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DateTimeTimeZone>(data, _mappings, DateTimeTimeZone);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime;
        data["timeZone"] = this.timeZone;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IDateTimeTimeZone {
    dateTime: string | undefined;
    timeZone: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export enum FollowupFlagStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class FollowupFlag implements IFollowupFlag {
    completedDateTime!: DateTimeTimeZone | undefined;
    dueDateTime!: DateTimeTimeZone | undefined;
    flagStatus!: FollowupFlagStatus | undefined;
    startDateTime!: DateTimeTimeZone | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IFollowupFlag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.completedDateTime = _data["completedDateTime"] ? DateTimeTimeZone.fromJS(_data["completedDateTime"], _mappings) : undefined as any;
            this.dueDateTime = _data["dueDateTime"] ? DateTimeTimeZone.fromJS(_data["dueDateTime"], _mappings) : undefined as any;
            this.flagStatus = _data["flagStatus"];
            this.startDateTime = _data["startDateTime"] ? DateTimeTimeZone.fromJS(_data["startDateTime"], _mappings) : undefined as any;
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): FollowupFlag | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FollowupFlag>(data, _mappings, FollowupFlag);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedDateTime"] = this.completedDateTime ? this.completedDateTime.toJSON() : undefined as any;
        data["dueDateTime"] = this.dueDateTime ? this.dueDateTime.toJSON() : undefined as any;
        data["flagStatus"] = this.flagStatus;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toJSON() : undefined as any;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IFollowupFlag {
    completedDateTime: DateTimeTimeZone | undefined;
    dueDateTime: DateTimeTimeZone | undefined;
    flagStatus: FollowupFlagStatus | undefined;
    startDateTime: DateTimeTimeZone | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export enum Importance {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum InferenceClassificationType {
    _0 = 0,
    _1 = 1,
}

export class InternetMessageHeader implements IInternetMessageHeader {
    name!: string | undefined;
    value!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IInternetMessageHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): InternetMessageHeader | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InternetMessageHeader>(data, _mappings, InternetMessageHeader);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IInternetMessageHeader {
    name: string | undefined;
    value: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export class Attachment implements IAttachment {
    id!: string | undefined;
    oDataType!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    contentType!: string | undefined;
    isInline!: boolean | undefined;
    lastModifiedDateTime!: string | undefined;
    name!: string | undefined;
    size!: number | undefined;

    constructor(data?: IAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.oDataType = _data["oDataType"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.contentType = _data["contentType"];
            this.isInline = _data["isInline"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"];
            this.name = _data["name"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any, _mappings?: any): Attachment | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Attachment>(data, _mappings, Attachment);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["oDataType"] = this.oDataType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["contentType"] = this.contentType;
        data["isInline"] = this.isInline;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime;
        data["name"] = this.name;
        data["size"] = this.size;
        return data;
    }
}

export interface IAttachment {
    id: string | undefined;
    oDataType: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
    contentType: string | undefined;
    isInline: boolean | undefined;
    lastModifiedDateTime: string | undefined;
    name: string | undefined;
    size: number | undefined;
}

export class Extension implements IExtension {
    id!: string | undefined;
    oDataType!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;

    constructor(data?: IExtension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.oDataType = _data["oDataType"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Extension | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Extension>(data, _mappings, Extension);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["oDataType"] = this.oDataType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        return data;
    }
}

export interface IExtension {
    id: string | undefined;
    oDataType: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
}

export class MultiValueLegacyExtendedProperty implements IMultiValueLegacyExtendedProperty {
    id!: string | undefined;
    oDataType!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    value!: string[] | undefined;

    constructor(data?: IMultiValueLegacyExtendedProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.oDataType = _data["oDataType"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MultiValueLegacyExtendedProperty | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MultiValueLegacyExtendedProperty>(data, _mappings, MultiValueLegacyExtendedProperty);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["oDataType"] = this.oDataType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IMultiValueLegacyExtendedProperty {
    id: string | undefined;
    oDataType: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
    value: string[] | undefined;
}

export class SingleValueLegacyExtendedProperty implements ISingleValueLegacyExtendedProperty {
    id!: string | undefined;
    oDataType!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    value!: string | undefined;

    constructor(data?: ISingleValueLegacyExtendedProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.oDataType = _data["oDataType"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): SingleValueLegacyExtendedProperty | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SingleValueLegacyExtendedProperty>(data, _mappings, SingleValueLegacyExtendedProperty);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["oDataType"] = this.oDataType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["value"] = this.value;
        return data;
    }
}

export interface ISingleValueLegacyExtendedProperty {
    id: string | undefined;
    oDataType: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
    value: string | undefined;
}

export class Message implements IMessage {
    id!: string | undefined;
    oDataType!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    categories!: string[] | undefined;
    changeKey!: string | undefined;
    createdDateTime!: string | undefined;
    lastModifiedDateTime!: string | undefined;
    bccRecipients!: Recipient[] | undefined;
    body!: ItemBody | undefined;
    bodyPreview!: string | undefined;
    ccRecipients!: Recipient[] | undefined;
    conversationId!: string | undefined;
    conversationIndex!: string | undefined;
    flag!: FollowupFlag | undefined;
    from!: Recipient | undefined;
    hasAttachments!: boolean | undefined;
    importance!: Importance | undefined;
    inferenceClassification!: InferenceClassificationType | undefined;
    internetMessageHeaders!: InternetMessageHeader[] | undefined;
    internetMessageId!: string | undefined;
    isDeliveryReceiptRequested!: boolean | undefined;
    isDraft!: boolean | undefined;
    isRead!: boolean | undefined;
    isReadReceiptRequested!: boolean | undefined;
    parentFolderId!: string | undefined;
    receivedDateTime!: string | undefined;
    replyTo!: Recipient[] | undefined;
    sender!: Recipient | undefined;
    sentDateTime!: string | undefined;
    subject!: string | undefined;
    toRecipients!: Recipient[] | undefined;
    uniqueBody!: ItemBody | undefined;
    webLink!: string | undefined;
    attachments!: Attachment[] | undefined;
    extensions!: Extension[] | undefined;
    multiValueExtendedProperties!: MultiValueLegacyExtendedProperty[] | undefined;
    singleValueExtendedProperties!: SingleValueLegacyExtendedProperty[] | undefined;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.oDataType = _data["oDataType"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            this.changeKey = _data["changeKey"];
            this.createdDateTime = _data["createdDateTime"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"];
            if (Array.isArray(_data["bccRecipients"])) {
                this.bccRecipients = [] as any;
                for (let item of _data["bccRecipients"])
                    this.bccRecipients!.push(Recipient.fromJS(item, _mappings));
            }
            this.body = _data["body"] ? ItemBody.fromJS(_data["body"], _mappings) : undefined as any;
            this.bodyPreview = _data["bodyPreview"];
            if (Array.isArray(_data["ccRecipients"])) {
                this.ccRecipients = [] as any;
                for (let item of _data["ccRecipients"])
                    this.ccRecipients!.push(Recipient.fromJS(item, _mappings));
            }
            this.conversationId = _data["conversationId"];
            this.conversationIndex = _data["conversationIndex"];
            this.flag = _data["flag"] ? FollowupFlag.fromJS(_data["flag"], _mappings) : undefined as any;
            this.from = _data["from"] ? Recipient.fromJS(_data["from"], _mappings) : undefined as any;
            this.hasAttachments = _data["hasAttachments"];
            this.importance = _data["importance"];
            this.inferenceClassification = _data["inferenceClassification"];
            if (Array.isArray(_data["internetMessageHeaders"])) {
                this.internetMessageHeaders = [] as any;
                for (let item of _data["internetMessageHeaders"])
                    this.internetMessageHeaders!.push(InternetMessageHeader.fromJS(item, _mappings));
            }
            this.internetMessageId = _data["internetMessageId"];
            this.isDeliveryReceiptRequested = _data["isDeliveryReceiptRequested"];
            this.isDraft = _data["isDraft"];
            this.isRead = _data["isRead"];
            this.isReadReceiptRequested = _data["isReadReceiptRequested"];
            this.parentFolderId = _data["parentFolderId"];
            this.receivedDateTime = _data["receivedDateTime"];
            if (Array.isArray(_data["replyTo"])) {
                this.replyTo = [] as any;
                for (let item of _data["replyTo"])
                    this.replyTo!.push(Recipient.fromJS(item, _mappings));
            }
            this.sender = _data["sender"] ? Recipient.fromJS(_data["sender"], _mappings) : undefined as any;
            this.sentDateTime = _data["sentDateTime"];
            this.subject = _data["subject"];
            if (Array.isArray(_data["toRecipients"])) {
                this.toRecipients = [] as any;
                for (let item of _data["toRecipients"])
                    this.toRecipients!.push(Recipient.fromJS(item, _mappings));
            }
            this.uniqueBody = _data["uniqueBody"] ? ItemBody.fromJS(_data["uniqueBody"], _mappings) : undefined as any;
            this.webLink = _data["webLink"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["extensions"])) {
                this.extensions = [] as any;
                for (let item of _data["extensions"])
                    this.extensions!.push(Extension.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["multiValueExtendedProperties"])) {
                this.multiValueExtendedProperties = [] as any;
                for (let item of _data["multiValueExtendedProperties"])
                    this.multiValueExtendedProperties!.push(MultiValueLegacyExtendedProperty.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["singleValueExtendedProperties"])) {
                this.singleValueExtendedProperties = [] as any;
                for (let item of _data["singleValueExtendedProperties"])
                    this.singleValueExtendedProperties!.push(SingleValueLegacyExtendedProperty.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Message | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Message>(data, _mappings, Message);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["oDataType"] = this.oDataType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        data["changeKey"] = this.changeKey;
        data["createdDateTime"] = this.createdDateTime;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime;
        if (Array.isArray(this.bccRecipients)) {
            data["bccRecipients"] = [];
            for (let item of this.bccRecipients)
                data["bccRecipients"].push(item ? item.toJSON() : undefined as any);
        }
        data["body"] = this.body ? this.body.toJSON() : undefined as any;
        data["bodyPreview"] = this.bodyPreview;
        if (Array.isArray(this.ccRecipients)) {
            data["ccRecipients"] = [];
            for (let item of this.ccRecipients)
                data["ccRecipients"].push(item ? item.toJSON() : undefined as any);
        }
        data["conversationId"] = this.conversationId;
        data["conversationIndex"] = this.conversationIndex;
        data["flag"] = this.flag ? this.flag.toJSON() : undefined as any;
        data["from"] = this.from ? this.from.toJSON() : undefined as any;
        data["hasAttachments"] = this.hasAttachments;
        data["importance"] = this.importance;
        data["inferenceClassification"] = this.inferenceClassification;
        if (Array.isArray(this.internetMessageHeaders)) {
            data["internetMessageHeaders"] = [];
            for (let item of this.internetMessageHeaders)
                data["internetMessageHeaders"].push(item ? item.toJSON() : undefined as any);
        }
        data["internetMessageId"] = this.internetMessageId;
        data["isDeliveryReceiptRequested"] = this.isDeliveryReceiptRequested;
        data["isDraft"] = this.isDraft;
        data["isRead"] = this.isRead;
        data["isReadReceiptRequested"] = this.isReadReceiptRequested;
        data["parentFolderId"] = this.parentFolderId;
        data["receivedDateTime"] = this.receivedDateTime;
        if (Array.isArray(this.replyTo)) {
            data["replyTo"] = [];
            for (let item of this.replyTo)
                data["replyTo"].push(item ? item.toJSON() : undefined as any);
        }
        data["sender"] = this.sender ? this.sender.toJSON() : undefined as any;
        data["sentDateTime"] = this.sentDateTime;
        data["subject"] = this.subject;
        if (Array.isArray(this.toRecipients)) {
            data["toRecipients"] = [];
            for (let item of this.toRecipients)
                data["toRecipients"].push(item ? item.toJSON() : undefined as any);
        }
        data["uniqueBody"] = this.uniqueBody ? this.uniqueBody.toJSON() : undefined as any;
        data["webLink"] = this.webLink;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.extensions)) {
            data["extensions"] = [];
            for (let item of this.extensions)
                data["extensions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.multiValueExtendedProperties)) {
            data["multiValueExtendedProperties"] = [];
            for (let item of this.multiValueExtendedProperties)
                data["multiValueExtendedProperties"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.singleValueExtendedProperties)) {
            data["singleValueExtendedProperties"] = [];
            for (let item of this.singleValueExtendedProperties)
                data["singleValueExtendedProperties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMessage {
    id: string | undefined;
    oDataType: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
    categories: string[] | undefined;
    changeKey: string | undefined;
    createdDateTime: string | undefined;
    lastModifiedDateTime: string | undefined;
    bccRecipients: Recipient[] | undefined;
    body: ItemBody | undefined;
    bodyPreview: string | undefined;
    ccRecipients: Recipient[] | undefined;
    conversationId: string | undefined;
    conversationIndex: string | undefined;
    flag: FollowupFlag | undefined;
    from: Recipient | undefined;
    hasAttachments: boolean | undefined;
    importance: Importance | undefined;
    inferenceClassification: InferenceClassificationType | undefined;
    internetMessageHeaders: InternetMessageHeader[] | undefined;
    internetMessageId: string | undefined;
    isDeliveryReceiptRequested: boolean | undefined;
    isDraft: boolean | undefined;
    isRead: boolean | undefined;
    isReadReceiptRequested: boolean | undefined;
    parentFolderId: string | undefined;
    receivedDateTime: string | undefined;
    replyTo: Recipient[] | undefined;
    sender: Recipient | undefined;
    sentDateTime: string | undefined;
    subject: string | undefined;
    toRecipients: Recipient[] | undefined;
    uniqueBody: ItemBody | undefined;
    webLink: string | undefined;
    attachments: Attachment[] | undefined;
    extensions: Extension[] | undefined;
    multiValueExtendedProperties: MultiValueLegacyExtendedProperty[] | undefined;
    singleValueExtendedProperties: SingleValueLegacyExtendedProperty[] | undefined;
}

export class GlobalSearchInputDto implements IGlobalSearchInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    searchText!: string | undefined;
    isTasks!: boolean | undefined;
    isProjects!: boolean | undefined;
    isContacts!: boolean | undefined;
    isFiles!: boolean | undefined;
    assigneeIds!: number[] | undefined;
    projectIds!: number[] | undefined;
    contactTypeIds!: number[] | undefined;
    tagIds!: number[] | undefined;
    taskStatusType!: number | undefined;
    projectStatusType!: number | undefined;
    fileTypes!: number[] | undefined;
    teamResourceIds!: number[] | undefined;
    stageIds!: number[] | undefined;
    taskTypes!: number[] | undefined;
    completedRange!: number | undefined;
    filterCompanyIds!: number[] | undefined;
    filterPersonIds!: number[] | undefined;
    skipCount!: number | undefined;
    takeCount!: number | undefined;

    constructor(data?: IGlobalSearchInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.searchText = _data["searchText"];
            this.isTasks = _data["isTasks"];
            this.isProjects = _data["isProjects"];
            this.isContacts = _data["isContacts"];
            this.isFiles = _data["isFiles"];
            if (Array.isArray(_data["assigneeIds"])) {
                this.assigneeIds = [] as any;
                for (let item of _data["assigneeIds"])
                    this.assigneeIds!.push(item);
            }
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
            if (Array.isArray(_data["contactTypeIds"])) {
                this.contactTypeIds = [] as any;
                for (let item of _data["contactTypeIds"])
                    this.contactTypeIds!.push(item);
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.taskStatusType = _data["taskStatusType"];
            this.projectStatusType = _data["projectStatusType"];
            if (Array.isArray(_data["fileTypes"])) {
                this.fileTypes = [] as any;
                for (let item of _data["fileTypes"])
                    this.fileTypes!.push(item);
            }
            if (Array.isArray(_data["teamResourceIds"])) {
                this.teamResourceIds = [] as any;
                for (let item of _data["teamResourceIds"])
                    this.teamResourceIds!.push(item);
            }
            if (Array.isArray(_data["stageIds"])) {
                this.stageIds = [] as any;
                for (let item of _data["stageIds"])
                    this.stageIds!.push(item);
            }
            if (Array.isArray(_data["taskTypes"])) {
                this.taskTypes = [] as any;
                for (let item of _data["taskTypes"])
                    this.taskTypes!.push(item);
            }
            this.completedRange = _data["completedRange"];
            if (Array.isArray(_data["filterCompanyIds"])) {
                this.filterCompanyIds = [] as any;
                for (let item of _data["filterCompanyIds"])
                    this.filterCompanyIds!.push(item);
            }
            if (Array.isArray(_data["filterPersonIds"])) {
                this.filterPersonIds = [] as any;
                for (let item of _data["filterPersonIds"])
                    this.filterPersonIds!.push(item);
            }
            this.skipCount = _data["skipCount"];
            this.takeCount = _data["takeCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): GlobalSearchInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GlobalSearchInputDto>(data, _mappings, GlobalSearchInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["searchText"] = this.searchText;
        data["isTasks"] = this.isTasks;
        data["isProjects"] = this.isProjects;
        data["isContacts"] = this.isContacts;
        data["isFiles"] = this.isFiles;
        if (Array.isArray(this.assigneeIds)) {
            data["assigneeIds"] = [];
            for (let item of this.assigneeIds)
                data["assigneeIds"].push(item);
        }
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        if (Array.isArray(this.contactTypeIds)) {
            data["contactTypeIds"] = [];
            for (let item of this.contactTypeIds)
                data["contactTypeIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["taskStatusType"] = this.taskStatusType;
        data["projectStatusType"] = this.projectStatusType;
        if (Array.isArray(this.fileTypes)) {
            data["fileTypes"] = [];
            for (let item of this.fileTypes)
                data["fileTypes"].push(item);
        }
        if (Array.isArray(this.teamResourceIds)) {
            data["teamResourceIds"] = [];
            for (let item of this.teamResourceIds)
                data["teamResourceIds"].push(item);
        }
        if (Array.isArray(this.stageIds)) {
            data["stageIds"] = [];
            for (let item of this.stageIds)
                data["stageIds"].push(item);
        }
        if (Array.isArray(this.taskTypes)) {
            data["taskTypes"] = [];
            for (let item of this.taskTypes)
                data["taskTypes"].push(item);
        }
        data["completedRange"] = this.completedRange;
        if (Array.isArray(this.filterCompanyIds)) {
            data["filterCompanyIds"] = [];
            for (let item of this.filterCompanyIds)
                data["filterCompanyIds"].push(item);
        }
        if (Array.isArray(this.filterPersonIds)) {
            data["filterPersonIds"] = [];
            for (let item of this.filterPersonIds)
                data["filterPersonIds"].push(item);
        }
        data["skipCount"] = this.skipCount;
        data["takeCount"] = this.takeCount;
        return data;
    }
}

export interface IGlobalSearchInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    searchText: string | undefined;
    isTasks: boolean | undefined;
    isProjects: boolean | undefined;
    isContacts: boolean | undefined;
    isFiles: boolean | undefined;
    assigneeIds: number[] | undefined;
    projectIds: number[] | undefined;
    contactTypeIds: number[] | undefined;
    tagIds: number[] | undefined;
    taskStatusType: number | undefined;
    projectStatusType: number | undefined;
    fileTypes: number[] | undefined;
    teamResourceIds: number[] | undefined;
    stageIds: number[] | undefined;
    taskTypes: number[] | undefined;
    completedRange: number | undefined;
    filterCompanyIds: number[] | undefined;
    filterPersonIds: number[] | undefined;
    skipCount: number | undefined;
    takeCount: number | undefined;
}

export enum TaskAssociationType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class TaskAssociation implements ITaskAssociation {
    id!: number | undefined;
    taskId!: number | undefined;
    associationName!: string | undefined;
    associationSubId!: number | undefined;
    associationSubName!: string | undefined;
    extension!: string | undefined;
    isLink!: boolean | undefined;
    keyId!: string | undefined;
    fileType!: string | undefined;
    projectStageId!: number | undefined;
    associationType!: TaskAssociationType | undefined;
    associationId!: string | undefined;
    associationUrl!: string | undefined;
    sortOrder!: number | undefined;
    driveId!: string | undefined;
    resourceUrl!: string | undefined;
    color!: string | undefined;

    constructor(data?: ITaskAssociation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.associationName = _data["associationName"];
            this.associationSubId = _data["associationSubId"];
            this.associationSubName = _data["associationSubName"];
            this.extension = _data["extension"];
            this.isLink = _data["isLink"];
            this.keyId = _data["keyId"];
            this.fileType = _data["fileType"];
            this.projectStageId = _data["projectStageId"];
            this.associationType = _data["associationType"];
            this.associationId = _data["associationId"];
            this.associationUrl = _data["associationUrl"];
            this.sortOrder = _data["sortOrder"];
            this.driveId = _data["driveId"];
            this.resourceUrl = _data["resourceUrl"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskAssociation | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskAssociation>(data, _mappings, TaskAssociation);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["associationName"] = this.associationName;
        data["associationSubId"] = this.associationSubId;
        data["associationSubName"] = this.associationSubName;
        data["extension"] = this.extension;
        data["isLink"] = this.isLink;
        data["keyId"] = this.keyId;
        data["fileType"] = this.fileType;
        data["projectStageId"] = this.projectStageId;
        data["associationType"] = this.associationType;
        data["associationId"] = this.associationId;
        data["associationUrl"] = this.associationUrl;
        data["sortOrder"] = this.sortOrder;
        data["driveId"] = this.driveId;
        data["resourceUrl"] = this.resourceUrl;
        data["color"] = this.color;
        return data;
    }
}

export interface ITaskAssociation {
    id: number | undefined;
    taskId: number | undefined;
    associationName: string | undefined;
    associationSubId: number | undefined;
    associationSubName: string | undefined;
    extension: string | undefined;
    isLink: boolean | undefined;
    keyId: string | undefined;
    fileType: string | undefined;
    projectStageId: number | undefined;
    associationType: TaskAssociationType | undefined;
    associationId: string | undefined;
    associationUrl: string | undefined;
    sortOrder: number | undefined;
    driveId: string | undefined;
    resourceUrl: string | undefined;
    color: string | undefined;
}

export class TagListDto implements ITagListDto {
    tagId!: number | undefined;
    tagName!: string | undefined;
    creationTime!: string | undefined;
    creatorName!: string | undefined;

    constructor(data?: ITagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
            this.creationTime = _data["creationTime"];
            this.creatorName = _data["creatorName"];
        }
    }

    static fromJS(data: any, _mappings?: any): TagListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TagListDto>(data, _mappings, TagListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        data["creationTime"] = this.creationTime;
        data["creatorName"] = this.creatorName;
        return data;
    }
}

export interface ITagListDto {
    tagId: number | undefined;
    tagName: string | undefined;
    creationTime: string | undefined;
    creatorName: string | undefined;
}

export class GlobalSearchOutputDto implements IGlobalSearchOutputDto {
    entityType!: number | undefined;
    taskId!: number | undefined;
    title!: string | undefined;
    isPrivate!: boolean | undefined;
    isActive!: boolean | undefined;
    code!: number | undefined;
    taskAssociationsAsJson!: string | undefined;
    readonly taskAssociations!: TaskAssociation[] | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    projectStatusCode!: number | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactEmail!: string | undefined;
    contactCompanyId!: number | undefined;
    contactCompanyName!: string | undefined;
    contactTypeId!: number | undefined;
    contactType!: string | undefined;
    contactTypeColor!: string | undefined;
    contactProfileUrl!: string | undefined;
    contactTagList!: string | undefined;
    readonly contactTags!: TagListDto[] | undefined;
    companyContactCount!: number | undefined;
    fileId!: number | undefined;
    fileName!: string | undefined;
    filePath!: string | undefined;
    fileType!: string | undefined;
    fileSourceType!: number | undefined;
    fileSourceName!: string | undefined;
    isLink!: boolean | undefined;
    extension!: string | undefined;
    msDriveId!: string | undefined;
    msSiteId!: string | undefined;
    msFolderId!: string | undefined;
    keyId!: string | undefined;
    priority!: number | undefined;
    driveCategoryId!: number | undefined;
    isEveryone!: boolean | undefined;
    parentId!: number | undefined;
    assignedToUserId!: number | undefined;
    clientName!: string | undefined;
    clientStage!: string | undefined;
    taskCount!: number | undefined;
    progress!: number | undefined;
    duration!: string | undefined;
    contributors!: TaskContributorDto[] | undefined;
    isBlocked!: boolean | undefined;
    totalCount!: number | undefined;

    constructor(data?: IGlobalSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.taskId = _data["taskId"];
            this.title = _data["title"];
            this.isPrivate = _data["isPrivate"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.taskAssociationsAsJson = _data["taskAssociationsAsJson"];
            if (Array.isArray(_data["taskAssociations"])) {
                (this as any).taskAssociations = [] as any;
                for (let item of _data["taskAssociations"])
                    (this as any).taskAssociations!.push(TaskAssociation.fromJS(item, _mappings));
            }
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectStatusCode = _data["projectStatusCode"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactCompanyId = _data["contactCompanyId"];
            this.contactCompanyName = _data["contactCompanyName"];
            this.contactTypeId = _data["contactTypeId"];
            this.contactType = _data["contactType"];
            this.contactTypeColor = _data["contactTypeColor"];
            this.contactProfileUrl = _data["contactProfileUrl"];
            this.contactTagList = _data["contactTagList"];
            if (Array.isArray(_data["contactTags"])) {
                (this as any).contactTags = [] as any;
                for (let item of _data["contactTags"])
                    (this as any).contactTags!.push(TagListDto.fromJS(item, _mappings));
            }
            this.companyContactCount = _data["companyContactCount"];
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.filePath = _data["filePath"];
            this.fileType = _data["fileType"];
            this.fileSourceType = _data["fileSourceType"];
            this.fileSourceName = _data["fileSourceName"];
            this.isLink = _data["isLink"];
            this.extension = _data["extension"];
            this.msDriveId = _data["msDriveId"];
            this.msSiteId = _data["msSiteId"];
            this.msFolderId = _data["msFolderId"];
            this.keyId = _data["keyId"];
            this.priority = _data["priority"];
            this.driveCategoryId = _data["driveCategoryId"];
            this.isEveryone = _data["isEveryone"];
            this.parentId = _data["parentId"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.clientName = _data["clientName"];
            this.clientStage = _data["clientStage"];
            this.taskCount = _data["taskCount"];
            this.progress = _data["progress"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["contributors"])) {
                this.contributors = [] as any;
                for (let item of _data["contributors"])
                    this.contributors!.push(TaskContributorDto.fromJS(item, _mappings));
            }
            this.isBlocked = _data["isBlocked"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): GlobalSearchOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GlobalSearchOutputDto>(data, _mappings, GlobalSearchOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["taskId"] = this.taskId;
        data["title"] = this.title;
        data["isPrivate"] = this.isPrivate;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["taskAssociationsAsJson"] = this.taskAssociationsAsJson;
        if (Array.isArray(this.taskAssociations)) {
            data["taskAssociations"] = [];
            for (let item of this.taskAssociations)
                data["taskAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectStatusCode"] = this.projectStatusCode;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactCompanyId"] = this.contactCompanyId;
        data["contactCompanyName"] = this.contactCompanyName;
        data["contactTypeId"] = this.contactTypeId;
        data["contactType"] = this.contactType;
        data["contactTypeColor"] = this.contactTypeColor;
        data["contactProfileUrl"] = this.contactProfileUrl;
        data["contactTagList"] = this.contactTagList;
        if (Array.isArray(this.contactTags)) {
            data["contactTags"] = [];
            for (let item of this.contactTags)
                data["contactTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["companyContactCount"] = this.companyContactCount;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["filePath"] = this.filePath;
        data["fileType"] = this.fileType;
        data["fileSourceType"] = this.fileSourceType;
        data["fileSourceName"] = this.fileSourceName;
        data["isLink"] = this.isLink;
        data["extension"] = this.extension;
        data["msDriveId"] = this.msDriveId;
        data["msSiteId"] = this.msSiteId;
        data["msFolderId"] = this.msFolderId;
        data["keyId"] = this.keyId;
        data["priority"] = this.priority;
        data["driveCategoryId"] = this.driveCategoryId;
        data["isEveryone"] = this.isEveryone;
        data["parentId"] = this.parentId;
        data["assignedToUserId"] = this.assignedToUserId;
        data["clientName"] = this.clientName;
        data["clientStage"] = this.clientStage;
        data["taskCount"] = this.taskCount;
        data["progress"] = this.progress;
        data["duration"] = this.duration;
        if (Array.isArray(this.contributors)) {
            data["contributors"] = [];
            for (let item of this.contributors)
                data["contributors"].push(item ? item.toJSON() : undefined as any);
        }
        data["isBlocked"] = this.isBlocked;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IGlobalSearchOutputDto {
    entityType: number | undefined;
    taskId: number | undefined;
    title: string | undefined;
    isPrivate: boolean | undefined;
    isActive: boolean | undefined;
    code: number | undefined;
    taskAssociationsAsJson: string | undefined;
    taskAssociations: TaskAssociation[] | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    projectStatusCode: number | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactEmail: string | undefined;
    contactCompanyId: number | undefined;
    contactCompanyName: string | undefined;
    contactTypeId: number | undefined;
    contactType: string | undefined;
    contactTypeColor: string | undefined;
    contactProfileUrl: string | undefined;
    contactTagList: string | undefined;
    contactTags: TagListDto[] | undefined;
    companyContactCount: number | undefined;
    fileId: number | undefined;
    fileName: string | undefined;
    filePath: string | undefined;
    fileType: string | undefined;
    fileSourceType: number | undefined;
    fileSourceName: string | undefined;
    isLink: boolean | undefined;
    extension: string | undefined;
    msDriveId: string | undefined;
    msSiteId: string | undefined;
    msFolderId: string | undefined;
    keyId: string | undefined;
    priority: number | undefined;
    driveCategoryId: number | undefined;
    isEveryone: boolean | undefined;
    parentId: number | undefined;
    assignedToUserId: number | undefined;
    clientName: string | undefined;
    clientStage: string | undefined;
    taskCount: number | undefined;
    progress: number | undefined;
    duration: string | undefined;
    contributors: TaskContributorDto[] | undefined;
    isBlocked: boolean | undefined;
    totalCount: number | undefined;
}

export class GlobalSearchOutputDtoListIHandleError implements IGlobalSearchOutputDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GlobalSearchOutputDto[] | undefined;
    listOfEntities!: GlobalSearchOutputDto[][] | undefined;

    constructor(data?: IGlobalSearchOutputDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(GlobalSearchOutputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GlobalSearchOutputDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GlobalSearchOutputDtoListIHandleError>(data, _mappings, GlobalSearchOutputDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IGlobalSearchOutputDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GlobalSearchOutputDto[] | undefined;
    listOfEntities: GlobalSearchOutputDto[][] | undefined;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean | undefined;
    isFree!: boolean | undefined;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
            this.isFree = _data["isFree"];
        }
    }

    static fromJS(data: any, _mappings?: any): SubscribableEditionComboboxItemDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SubscribableEditionComboboxItemDto>(data, _mappings, SubscribableEditionComboboxItemDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        data["isFree"] = this.isFree;
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean | undefined;
    isFree: boolean | undefined;
}

export class SubscribableEditionComboboxItemDtoListResultDto implements ISubscribableEditionComboboxItemDtoListResultDto {
    items!: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: ISubscribableEditionComboboxItemDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscribableEditionComboboxItemDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SubscribableEditionComboboxItemDtoListResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SubscribableEditionComboboxItemDtoListResultDto>(data, _mappings, SubscribableEditionComboboxItemDtoListResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDtoListResultDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class GetAllForLookupTableInput implements IGetAllForLookupTableInput {
    maxResultCount!: number | undefined;
    skipCount!: number | undefined;
    sorting!: string | undefined;
    filter!: string | undefined;
    isEntityIdsNameRequired!: boolean | undefined;
    entityIds!: string | undefined;
    lookUpTableName!: LookUpTables | undefined;
    isInActiveDataRequired!: boolean | undefined;
    excludeIds!: number[] | undefined;

    constructor(data?: IGetAllForLookupTableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            this.isEntityIdsNameRequired = _data["isEntityIdsNameRequired"];
            this.entityIds = _data["entityIds"];
            this.lookUpTableName = _data["lookUpTableName"];
            this.isInActiveDataRequired = _data["isInActiveDataRequired"];
            if (Array.isArray(_data["excludeIds"])) {
                this.excludeIds = [] as any;
                for (let item of _data["excludeIds"])
                    this.excludeIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetAllForLookupTableInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetAllForLookupTableInput>(data, _mappings, GetAllForLookupTableInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        data["isEntityIdsNameRequired"] = this.isEntityIdsNameRequired;
        data["entityIds"] = this.entityIds;
        data["lookUpTableName"] = this.lookUpTableName;
        data["isInActiveDataRequired"] = this.isInActiveDataRequired;
        if (Array.isArray(this.excludeIds)) {
            data["excludeIds"] = [];
            for (let item of this.excludeIds)
                data["excludeIds"].push(item);
        }
        return data;
    }
}

export interface IGetAllForLookupTableInput {
    maxResultCount: number | undefined;
    skipCount: number | undefined;
    sorting: string | undefined;
    filter: string | undefined;
    isEntityIdsNameRequired: boolean | undefined;
    entityIds: string | undefined;
    lookUpTableName: LookUpTables | undefined;
    isInActiveDataRequired: boolean | undefined;
    excludeIds: number[] | undefined;
}

export class LookupTableOutputDto implements ILookupTableOutputDto {
    id!: number | undefined;
    code!: number | undefined;
    no!: string | undefined;
    name!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    isDeleted!: boolean | undefined;
    abbreviation!: string | undefined;
    cssClass!: string | undefined;
    iconUrl!: string | undefined;
    profilePictureId!: string | undefined;
    profilePicture!: string | undefined;
    profilePictureUrl!: string | undefined;
    isChecked!: boolean | undefined;
    bgColor!: string | undefined;
    color!: string | undefined;
    isSuggestAiTasks!: boolean | undefined;
    isPrivate!: boolean | undefined;
    isAutoAdd!: boolean | undefined;
    haveChecklistTemplate!: boolean | undefined;
    companyName!: string | undefined;

    constructor(data?: ILookupTableOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.no = _data["no"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.isDeleted = _data["isDeleted"];
            this.abbreviation = _data["abbreviation"];
            this.cssClass = _data["cssClass"];
            this.iconUrl = _data["iconUrl"];
            this.profilePictureId = _data["profilePictureId"];
            this.profilePicture = _data["profilePicture"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.isChecked = _data["isChecked"];
            this.bgColor = _data["bgColor"];
            this.color = _data["color"];
            this.isSuggestAiTasks = _data["isSuggestAiTasks"];
            this.isPrivate = _data["isPrivate"];
            this.isAutoAdd = _data["isAutoAdd"];
            this.haveChecklistTemplate = _data["haveChecklistTemplate"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any, _mappings?: any): LookupTableOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LookupTableOutputDto>(data, _mappings, LookupTableOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["no"] = this.no;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["isDeleted"] = this.isDeleted;
        data["abbreviation"] = this.abbreviation;
        data["cssClass"] = this.cssClass;
        data["iconUrl"] = this.iconUrl;
        data["profilePictureId"] = this.profilePictureId;
        data["profilePicture"] = this.profilePicture;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["isChecked"] = this.isChecked;
        data["bgColor"] = this.bgColor;
        data["color"] = this.color;
        data["isSuggestAiTasks"] = this.isSuggestAiTasks;
        data["isPrivate"] = this.isPrivate;
        data["isAutoAdd"] = this.isAutoAdd;
        data["haveChecklistTemplate"] = this.haveChecklistTemplate;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface ILookupTableOutputDto {
    id: number | undefined;
    code: number | undefined;
    no: string | undefined;
    name: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    isDeleted: boolean | undefined;
    abbreviation: string | undefined;
    cssClass: string | undefined;
    iconUrl: string | undefined;
    profilePictureId: string | undefined;
    profilePicture: string | undefined;
    profilePictureUrl: string | undefined;
    isChecked: boolean | undefined;
    bgColor: string | undefined;
    color: string | undefined;
    isSuggestAiTasks: boolean | undefined;
    isPrivate: boolean | undefined;
    isAutoAdd: boolean | undefined;
    haveChecklistTemplate: boolean | undefined;
    companyName: string | undefined;
}

export class LookupTableOutputDtoArrayListIHandleError implements ILookupTableOutputDtoArrayListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LookupTableOutputDto[][] | undefined;
    listOfEntities!: LookupTableOutputDto[][][] | undefined;

    constructor(data?: ILookupTableOutputDtoArrayListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(item);
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LookupTableOutputDtoArrayListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LookupTableOutputDtoArrayListIHandleError>(data, _mappings, LookupTableOutputDtoArrayListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ILookupTableOutputDtoArrayListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LookupTableOutputDto[][] | undefined;
    listOfEntities: LookupTableOutputDto[][][] | undefined;
}

export class FindUsersInput implements IFindUsersInput {
    maxResultCount!: number | undefined;
    skipCount!: number | undefined;
    filter!: string | undefined;
    tenantId!: number | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any, _mappings?: any): FindUsersInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FindUsersInput>(data, _mappings, FindUsersInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IFindUsersInput {
    maxResultCount: number | undefined;
    skipCount: number | undefined;
    filter: string | undefined;
    tenantId: number | undefined;
}

export class NameValueIdDto implements INameValueIdDto {
    name!: string | undefined;
    value!: string | undefined;
    id!: number | undefined;

    constructor(data?: INameValueIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): NameValueIdDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NameValueIdDto>(data, _mappings, NameValueIdDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface INameValueIdDto {
    name: string | undefined;
    value: string | undefined;
    id: number | undefined;
}

export class NameValueIdDtoPagedResultDto implements INameValueIdDtoPagedResultDto {
    items!: NameValueIdDto[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: INameValueIdDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueIdDto.fromJS(item, _mappings));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): NameValueIdDtoPagedResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NameValueIdDtoPagedResultDto>(data, _mappings, NameValueIdDtoPagedResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface INameValueIdDtoPagedResultDto {
    items: NameValueIdDto[] | undefined;
    totalCount: number | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name!: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetDefaultEditionNameOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetDefaultEditionNameOutput>(data, _mappings, GetDefaultEditionNameOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class CompanyLookupTableOutputDto implements ICompanyLookupTableOutputDto {
    id!: number | undefined;
    companyName!: string | undefined;
    taxId!: string | undefined;
    streetAddress!: string | undefined;
    suite_UnitNumber!: string | undefined;
    isDeleted!: boolean | undefined;

    constructor(data?: ICompanyLookupTableOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyName = _data["companyName"];
            this.taxId = _data["taxId"];
            this.streetAddress = _data["streetAddress"];
            this.suite_UnitNumber = _data["suite_UnitNumber"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyLookupTableOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyLookupTableOutputDto>(data, _mappings, CompanyLookupTableOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyName"] = this.companyName;
        data["taxId"] = this.taxId;
        data["streetAddress"] = this.streetAddress;
        data["suite_UnitNumber"] = this.suite_UnitNumber;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ICompanyLookupTableOutputDto {
    id: number | undefined;
    companyName: string | undefined;
    taxId: string | undefined;
    streetAddress: string | undefined;
    suite_UnitNumber: string | undefined;
    isDeleted: boolean | undefined;
}

export class CompanyLookupTableOutputDtoListIHandleError implements ICompanyLookupTableOutputDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CompanyLookupTableOutputDto[] | undefined;
    listOfEntities!: CompanyLookupTableOutputDto[][] | undefined;

    constructor(data?: ICompanyLookupTableOutputDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(CompanyLookupTableOutputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyLookupTableOutputDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyLookupTableOutputDtoListIHandleError>(data, _mappings, CompanyLookupTableOutputDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ICompanyLookupTableOutputDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CompanyLookupTableOutputDto[] | undefined;
    listOfEntities: CompanyLookupTableOutputDto[][] | undefined;
}

export class ContactsLookupTableOutputDto implements IContactsLookupTableOutputDto {
    id!: number | undefined;
    name!: string | undefined;
    type!: number | undefined;
    initialBgColor!: string | undefined;
    email!: string | undefined;
    jobTitle!: string | undefined;

    constructor(data?: IContactsLookupTableOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.initialBgColor = _data["initialBgColor"];
            this.email = _data["email"];
            this.jobTitle = _data["jobTitle"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactsLookupTableOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactsLookupTableOutputDto>(data, _mappings, ContactsLookupTableOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["initialBgColor"] = this.initialBgColor;
        data["email"] = this.email;
        data["jobTitle"] = this.jobTitle;
        return data;
    }
}

export interface IContactsLookupTableOutputDto {
    id: number | undefined;
    name: string | undefined;
    type: number | undefined;
    initialBgColor: string | undefined;
    email: string | undefined;
    jobTitle: string | undefined;
}

export class ContactsLookupTableOutputDtoListIHandleError implements IContactsLookupTableOutputDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ContactsLookupTableOutputDto[] | undefined;
    listOfEntities!: ContactsLookupTableOutputDto[][] | undefined;

    constructor(data?: IContactsLookupTableOutputDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ContactsLookupTableOutputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ContactsLookupTableOutputDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactsLookupTableOutputDtoListIHandleError>(data, _mappings, ContactsLookupTableOutputDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IContactsLookupTableOutputDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ContactsLookupTableOutputDto[] | undefined;
    listOfEntities: ContactsLookupTableOutputDto[][] | undefined;
}

export enum CompanyAddressType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class CompanyAddressDto implements ICompanyAddressDto {
    id!: number | undefined;
    contactId!: number | undefined;
    type!: CompanyAddressType | undefined;
    street!: string | undefined;
    suiteUnitNumber!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    countryId!: number | undefined;
    countryName!: string | undefined;

    constructor(data?: ICompanyAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.type = _data["type"];
            this.street = _data["street"];
            this.suiteUnitNumber = _data["suiteUnitNumber"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyAddressDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyAddressDto>(data, _mappings, CompanyAddressDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["type"] = this.type;
        data["street"] = this.street;
        data["suiteUnitNumber"] = this.suiteUnitNumber;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        return data;
    }
}

export interface ICompanyAddressDto {
    id: number | undefined;
    contactId: number | undefined;
    type: CompanyAddressType | undefined;
    street: string | undefined;
    suiteUnitNumber: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    countryId: number | undefined;
    countryName: string | undefined;
}

export enum ConcactPrivacyType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class CompanyContactsDto implements ICompanyContactsDto {
    id!: number | undefined;
    contactId!: number | undefined;
    contactTypeId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    primaryEmail!: string | undefined;
    mobilePhoneNumber!: string | undefined;
    mobilePhoneNumberCountryCode!: string | undefined;
    mobilePhoneNumberExtension!: string | undefined;
    countryId!: number | undefined;
    countryName!: string | undefined;
    contactType!: string | undefined;
    company!: string | undefined;
    profileUrl!: string | undefined;
    pinnedEntityId!: number | undefined;
    isLocationCreated!: boolean | undefined;
    bgColor!: string | undefined;
    color!: string | undefined;
    initialBgColor!: string | undefined;
    privacyType!: ConcactPrivacyType | undefined;
    jobTitle!: string | undefined;

    constructor(data?: ICompanyContactsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.contactTypeId = _data["contactTypeId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.primaryEmail = _data["primaryEmail"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.mobilePhoneNumberCountryCode = _data["mobilePhoneNumberCountryCode"];
            this.mobilePhoneNumberExtension = _data["mobilePhoneNumberExtension"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.contactType = _data["contactType"];
            this.company = _data["company"];
            this.profileUrl = _data["profileUrl"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.isLocationCreated = _data["isLocationCreated"];
            this.bgColor = _data["bgColor"];
            this.color = _data["color"];
            this.initialBgColor = _data["initialBgColor"];
            this.privacyType = _data["privacyType"];
            this.jobTitle = _data["jobTitle"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyContactsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyContactsDto>(data, _mappings, CompanyContactsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["contactTypeId"] = this.contactTypeId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["primaryEmail"] = this.primaryEmail;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["mobilePhoneNumberCountryCode"] = this.mobilePhoneNumberCountryCode;
        data["mobilePhoneNumberExtension"] = this.mobilePhoneNumberExtension;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["contactType"] = this.contactType;
        data["company"] = this.company;
        data["profileUrl"] = this.profileUrl;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["isLocationCreated"] = this.isLocationCreated;
        data["bgColor"] = this.bgColor;
        data["color"] = this.color;
        data["initialBgColor"] = this.initialBgColor;
        data["privacyType"] = this.privacyType;
        data["jobTitle"] = this.jobTitle;
        return data;
    }
}

export interface ICompanyContactsDto {
    id: number | undefined;
    contactId: number | undefined;
    contactTypeId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    primaryEmail: string | undefined;
    mobilePhoneNumber: string | undefined;
    mobilePhoneNumberCountryCode: string | undefined;
    mobilePhoneNumberExtension: string | undefined;
    countryId: number | undefined;
    countryName: string | undefined;
    contactType: string | undefined;
    company: string | undefined;
    profileUrl: string | undefined;
    pinnedEntityId: number | undefined;
    isLocationCreated: boolean | undefined;
    bgColor: string | undefined;
    color: string | undefined;
    initialBgColor: string | undefined;
    privacyType: ConcactPrivacyType | undefined;
    jobTitle: string | undefined;
}

export class CompanyTagListDto implements ICompanyTagListDto {
    id!: number | undefined;
    tagId!: number | undefined;
    tagName!: string | undefined;

    constructor(data?: ICompanyTagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyTagListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyTagListDto>(data, _mappings, CompanyTagListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        return data;
    }
}

export interface ICompanyTagListDto {
    id: number | undefined;
    tagId: number | undefined;
    tagName: string | undefined;
}

export class CompanyDomainDto implements ICompanyDomainDto {
    id!: number | undefined;
    domain!: string | undefined;

    constructor(data?: ICompanyDomainDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyDomainDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyDomainDto>(data, _mappings, CompanyDomainDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["domain"] = this.domain;
        return data;
    }
}

export interface ICompanyDomainDto {
    id: number | undefined;
    domain: string | undefined;
}

export class CompanyInputDto implements ICompanyInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    id!: number | undefined;
    companyName!: string | undefined;
    siteUrl!: string | undefined;
    taxId!: string | undefined;
    suiteUnitNumber!: string | undefined;
    street!: string | undefined;
    city!: string | undefined;
    postalCode!: string | undefined;
    countryId!: number | undefined;
    state!: string | undefined;
    companyAddressesAsJson!: string | undefined;
    companyContactsAsJson!: string | undefined;
    companyNotesAsJson!: string | undefined;
    companyFilesAsJson!: string | undefined;
    companyDomainsAsJson!: string | undefined;
    createFolder!: boolean | undefined;
    industryId!: number | undefined;
    companyTypeId!: number | undefined;
    clientStageId!: number | undefined;
    clientSourceId!: number | undefined;
    accountNumber!: string | undefined;
    details!: string | undefined;
    ownerId!: number | undefined;
    pinnedEntityId!: number | undefined;
    initialBgColor!: string | undefined;
    companyAddresses!: CompanyAddressDto[] | undefined;
    companyContacts!: CompanyContactsDto[] | undefined;
    companyTags!: CompanyTagListDto[] | undefined;
    companyDomains!: CompanyDomainDto[] | undefined;
    manageDomains!: boolean | undefined;
    folderId!: string | undefined;
    driveId!: string | undefined;
    folderUrl!: string | undefined;

    constructor(data?: ICompanyInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.id = _data["id"];
            this.companyName = _data["companyName"];
            this.siteUrl = _data["siteUrl"];
            this.taxId = _data["taxId"];
            this.suiteUnitNumber = _data["suiteUnitNumber"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.countryId = _data["countryId"];
            this.state = _data["state"];
            this.companyAddressesAsJson = _data["companyAddressesAsJson"];
            this.companyContactsAsJson = _data["companyContactsAsJson"];
            this.companyNotesAsJson = _data["companyNotesAsJson"];
            this.companyFilesAsJson = _data["companyFilesAsJson"];
            this.companyDomainsAsJson = _data["companyDomainsAsJson"];
            this.createFolder = _data["createFolder"];
            this.industryId = _data["industryId"];
            this.companyTypeId = _data["companyTypeId"];
            this.clientStageId = _data["clientStageId"];
            this.clientSourceId = _data["clientSourceId"];
            this.accountNumber = _data["accountNumber"];
            this.details = _data["details"];
            this.ownerId = _data["ownerId"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.initialBgColor = _data["initialBgColor"];
            if (Array.isArray(_data["companyAddresses"])) {
                this.companyAddresses = [] as any;
                for (let item of _data["companyAddresses"])
                    this.companyAddresses!.push(CompanyAddressDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["companyContacts"])) {
                this.companyContacts = [] as any;
                for (let item of _data["companyContacts"])
                    this.companyContacts!.push(CompanyContactsDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["companyTags"])) {
                this.companyTags = [] as any;
                for (let item of _data["companyTags"])
                    this.companyTags!.push(CompanyTagListDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["companyDomains"])) {
                this.companyDomains = [] as any;
                for (let item of _data["companyDomains"])
                    this.companyDomains!.push(CompanyDomainDto.fromJS(item, _mappings));
            }
            this.manageDomains = _data["manageDomains"];
            this.folderId = _data["folderId"];
            this.driveId = _data["driveId"];
            this.folderUrl = _data["folderUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyInputDto>(data, _mappings, CompanyInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["id"] = this.id;
        data["companyName"] = this.companyName;
        data["siteUrl"] = this.siteUrl;
        data["taxId"] = this.taxId;
        data["suiteUnitNumber"] = this.suiteUnitNumber;
        data["street"] = this.street;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["countryId"] = this.countryId;
        data["state"] = this.state;
        data["companyAddressesAsJson"] = this.companyAddressesAsJson;
        data["companyContactsAsJson"] = this.companyContactsAsJson;
        data["companyNotesAsJson"] = this.companyNotesAsJson;
        data["companyFilesAsJson"] = this.companyFilesAsJson;
        data["companyDomainsAsJson"] = this.companyDomainsAsJson;
        data["createFolder"] = this.createFolder;
        data["industryId"] = this.industryId;
        data["companyTypeId"] = this.companyTypeId;
        data["clientStageId"] = this.clientStageId;
        data["clientSourceId"] = this.clientSourceId;
        data["accountNumber"] = this.accountNumber;
        data["details"] = this.details;
        data["ownerId"] = this.ownerId;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["initialBgColor"] = this.initialBgColor;
        if (Array.isArray(this.companyAddresses)) {
            data["companyAddresses"] = [];
            for (let item of this.companyAddresses)
                data["companyAddresses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.companyContacts)) {
            data["companyContacts"] = [];
            for (let item of this.companyContacts)
                data["companyContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.companyTags)) {
            data["companyTags"] = [];
            for (let item of this.companyTags)
                data["companyTags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.companyDomains)) {
            data["companyDomains"] = [];
            for (let item of this.companyDomains)
                data["companyDomains"].push(item ? item.toJSON() : undefined as any);
        }
        data["manageDomains"] = this.manageDomains;
        data["folderId"] = this.folderId;
        data["driveId"] = this.driveId;
        data["folderUrl"] = this.folderUrl;
        return data;
    }
}

export interface ICompanyInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    id: number | undefined;
    companyName: string | undefined;
    siteUrl: string | undefined;
    taxId: string | undefined;
    suiteUnitNumber: string | undefined;
    street: string | undefined;
    city: string | undefined;
    postalCode: string | undefined;
    countryId: number | undefined;
    state: string | undefined;
    companyAddressesAsJson: string | undefined;
    companyContactsAsJson: string | undefined;
    companyNotesAsJson: string | undefined;
    companyFilesAsJson: string | undefined;
    companyDomainsAsJson: string | undefined;
    createFolder: boolean | undefined;
    industryId: number | undefined;
    companyTypeId: number | undefined;
    clientStageId: number | undefined;
    clientSourceId: number | undefined;
    accountNumber: string | undefined;
    details: string | undefined;
    ownerId: number | undefined;
    pinnedEntityId: number | undefined;
    initialBgColor: string | undefined;
    companyAddresses: CompanyAddressDto[] | undefined;
    companyContacts: CompanyContactsDto[] | undefined;
    companyTags: CompanyTagListDto[] | undefined;
    companyDomains: CompanyDomainDto[] | undefined;
    manageDomains: boolean | undefined;
    folderId: string | undefined;
    driveId: string | undefined;
    folderUrl: string | undefined;
}

export class CompanyInputDtoIHandleError implements ICompanyInputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CompanyInputDto | undefined;
    listOfEntities!: CompanyInputDto[] | undefined;

    constructor(data?: ICompanyInputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CompanyInputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CompanyInputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyInputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyInputDtoIHandleError>(data, _mappings, CompanyInputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICompanyInputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CompanyInputDto | undefined;
    listOfEntities: CompanyInputDto[] | undefined;
}

export class Int32CompanyDtoListValueTuple implements IInt32CompanyDtoListValueTuple {

    constructor(data?: IInt32CompanyDtoListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): Int32CompanyDtoListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32CompanyDtoListValueTuple>(data, _mappings, Int32CompanyDtoListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IInt32CompanyDtoListValueTuple {
}

export class Int32CompanyDtoListValueTupleIHandleError implements IInt32CompanyDtoListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: Int32CompanyDtoListValueTuple | undefined;
    listOfEntities!: Int32CompanyDtoListValueTuple[] | undefined;

    constructor(data?: IInt32CompanyDtoListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? Int32CompanyDtoListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(Int32CompanyDtoListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32CompanyDtoListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32CompanyDtoListValueTupleIHandleError>(data, _mappings, Int32CompanyDtoListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInt32CompanyDtoListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: Int32CompanyDtoListValueTuple | undefined;
    listOfEntities: Int32CompanyDtoListValueTuple[] | undefined;
}

export class CompanyContactsDtoListIHandleError implements ICompanyContactsDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CompanyContactsDto[] | undefined;
    listOfEntities!: CompanyContactsDto[][] | undefined;

    constructor(data?: ICompanyContactsDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(CompanyContactsDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyContactsDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyContactsDtoListIHandleError>(data, _mappings, CompanyContactsDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ICompanyContactsDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CompanyContactsDto[] | undefined;
    listOfEntities: CompanyContactsDto[][] | undefined;
}

export class OtherContactsDto implements IOtherContactsDto {
    contactId!: number | undefined;
    fullName!: string | undefined;
    profileUrl!: string | undefined;

    constructor(data?: IOtherContactsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.fullName = _data["fullName"];
            this.profileUrl = _data["profileUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): OtherContactsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OtherContactsDto>(data, _mappings, OtherContactsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["fullName"] = this.fullName;
        data["profileUrl"] = this.profileUrl;
        return data;
    }
}

export interface IOtherContactsDto {
    contactId: number | undefined;
    fullName: string | undefined;
    profileUrl: string | undefined;
}

export class OtherContactsDtoListIHandleError implements IOtherContactsDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: OtherContactsDto[] | undefined;
    listOfEntities!: OtherContactsDto[][] | undefined;

    constructor(data?: IOtherContactsDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(OtherContactsDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OtherContactsDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OtherContactsDtoListIHandleError>(data, _mappings, OtherContactsDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IOtherContactsDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: OtherContactsDto[] | undefined;
    listOfEntities: OtherContactsDto[][] | undefined;
}

export class AddMultipleContact implements IAddMultipleContact {
    userId!: number | undefined;
    tenantId!: number | undefined;
    companyId!: number | undefined;
    contactIds!: number[] | undefined;

    constructor(data?: IAddMultipleContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AddMultipleContact | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddMultipleContact>(data, _mappings, AddMultipleContact);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        return data;
    }
}

export interface IAddMultipleContact {
    userId: number | undefined;
    tenantId: number | undefined;
    companyId: number | undefined;
    contactIds: number[] | undefined;
}

export class AssignTagsToCompanyInputDto implements IAssignTagsToCompanyInputDto {
    tagIds!: number[] | undefined;
    companyIds!: number[] | undefined;

    constructor(data?: IAssignTagsToCompanyInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["companyIds"])) {
                this.companyIds = [] as any;
                for (let item of _data["companyIds"])
                    this.companyIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AssignTagsToCompanyInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AssignTagsToCompanyInputDto>(data, _mappings, AssignTagsToCompanyInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.companyIds)) {
            data["companyIds"] = [];
            for (let item of this.companyIds)
                data["companyIds"].push(item);
        }
        return data;
    }
}

export interface IAssignTagsToCompanyInputDto {
    tagIds: number[] | undefined;
    companyIds: number[] | undefined;
}

export class DeleteClientsInput implements IDeleteClientsInput {
    clientIds!: number[] | undefined;

    constructor(data?: IDeleteClientsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["clientIds"])) {
                this.clientIds = [] as any;
                for (let item of _data["clientIds"])
                    this.clientIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DeleteClientsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DeleteClientsInput>(data, _mappings, DeleteClientsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientIds)) {
            data["clientIds"] = [];
            for (let item of this.clientIds)
                data["clientIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteClientsInput {
    clientIds: number[] | undefined;
}

export enum FolderType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class CreateFolderDto implements ICreateFolderDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    name!: string | undefined;
    folderUrl!: string | undefined;
    folderId!: string | undefined;
    driveId!: string | undefined;
    itemId!: string | undefined;
    siteId!: string | undefined;
    isDocLibrary!: boolean | undefined;
    isSharePoint!: boolean | undefined;
    isUseExisting!: boolean | undefined;
    isRename!: boolean | undefined;
    duplicateAction!: number | undefined;
    folderType!: FolderType | undefined;
    entityId!: number | undefined;

    constructor(data?: ICreateFolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.name = _data["name"];
            this.folderUrl = _data["folderUrl"];
            this.folderId = _data["folderId"];
            this.driveId = _data["driveId"];
            this.itemId = _data["itemId"];
            this.siteId = _data["siteId"];
            this.isDocLibrary = _data["isDocLibrary"];
            this.isSharePoint = _data["isSharePoint"];
            this.isUseExisting = _data["isUseExisting"];
            this.isRename = _data["isRename"];
            this.duplicateAction = _data["duplicateAction"];
            this.folderType = _data["folderType"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateFolderDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateFolderDto>(data, _mappings, CreateFolderDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["name"] = this.name;
        data["folderUrl"] = this.folderUrl;
        data["folderId"] = this.folderId;
        data["driveId"] = this.driveId;
        data["itemId"] = this.itemId;
        data["siteId"] = this.siteId;
        data["isDocLibrary"] = this.isDocLibrary;
        data["isSharePoint"] = this.isSharePoint;
        data["isUseExisting"] = this.isUseExisting;
        data["isRename"] = this.isRename;
        data["duplicateAction"] = this.duplicateAction;
        data["folderType"] = this.folderType;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface ICreateFolderDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    name: string | undefined;
    folderUrl: string | undefined;
    folderId: string | undefined;
    driveId: string | undefined;
    itemId: string | undefined;
    siteId: string | undefined;
    isDocLibrary: boolean | undefined;
    isSharePoint: boolean | undefined;
    isUseExisting: boolean | undefined;
    isRename: boolean | undefined;
    duplicateAction: number | undefined;
    folderType: FolderType | undefined;
    entityId: number | undefined;
}

export class CompanyFolderOutputDto implements ICompanyFolderOutputDto {
    folderName!: string | undefined;
    folderUrl!: string | undefined;
    folderId!: string | undefined;
    driveId!: string | undefined;
    siteId!: string | undefined;
    isDocLibrary!: boolean | undefined;
    isSharePoint!: boolean | undefined;

    constructor(data?: ICompanyFolderOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.folderName = _data["folderName"];
            this.folderUrl = _data["folderUrl"];
            this.folderId = _data["folderId"];
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
            this.isDocLibrary = _data["isDocLibrary"];
            this.isSharePoint = _data["isSharePoint"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyFolderOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyFolderOutputDto>(data, _mappings, CompanyFolderOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderName"] = this.folderName;
        data["folderUrl"] = this.folderUrl;
        data["folderId"] = this.folderId;
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        data["isDocLibrary"] = this.isDocLibrary;
        data["isSharePoint"] = this.isSharePoint;
        return data;
    }
}

export interface ICompanyFolderOutputDto {
    folderName: string | undefined;
    folderUrl: string | undefined;
    folderId: string | undefined;
    driveId: string | undefined;
    siteId: string | undefined;
    isDocLibrary: boolean | undefined;
    isSharePoint: boolean | undefined;
}

export class CompanyFolderOutputDtoIHandleError implements ICompanyFolderOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CompanyFolderOutputDto | undefined;
    listOfEntities!: CompanyFolderOutputDto[] | undefined;

    constructor(data?: ICompanyFolderOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CompanyFolderOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CompanyFolderOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyFolderOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyFolderOutputDtoIHandleError>(data, _mappings, CompanyFolderOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICompanyFolderOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CompanyFolderOutputDto | undefined;
    listOfEntities: CompanyFolderOutputDto[] | undefined;
}

export class EntityDto implements IEntityDto {
    id!: number | undefined;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): EntityDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EntityDto>(data, _mappings, EntityDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDto {
    id: number | undefined;
}

export class CompanyFilesDto implements ICompanyFilesDto {
    modifiedDate!: string | undefined;
    itemCount!: number | undefined;
    fileId!: string | undefined;
    fileName!: string | undefined;
    fileUrl!: string | undefined;
    extension!: string | undefined;
    isFolder!: boolean | undefined;
    isCompanyFile!: boolean | undefined;
    isAddToShortcut!: boolean | undefined;
    driveId!: string | undefined;
    driveName!: string | undefined;
    siteName!: string | undefined;
    folderFiles!: CompanyFilesDto[] | undefined;

    constructor(data?: ICompanyFilesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.modifiedDate = _data["modifiedDate"];
            this.itemCount = _data["itemCount"];
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.extension = _data["extension"];
            this.isFolder = _data["isFolder"];
            this.isCompanyFile = _data["isCompanyFile"];
            this.isAddToShortcut = _data["isAddToShortcut"];
            this.driveId = _data["driveId"];
            this.driveName = _data["driveName"];
            this.siteName = _data["siteName"];
            if (Array.isArray(_data["folderFiles"])) {
                this.folderFiles = [] as any;
                for (let item of _data["folderFiles"])
                    this.folderFiles!.push(CompanyFilesDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyFilesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyFilesDto>(data, _mappings, CompanyFilesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modifiedDate"] = this.modifiedDate;
        data["itemCount"] = this.itemCount;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["extension"] = this.extension;
        data["isFolder"] = this.isFolder;
        data["isCompanyFile"] = this.isCompanyFile;
        data["isAddToShortcut"] = this.isAddToShortcut;
        data["driveId"] = this.driveId;
        data["driveName"] = this.driveName;
        data["siteName"] = this.siteName;
        if (Array.isArray(this.folderFiles)) {
            data["folderFiles"] = [];
            for (let item of this.folderFiles)
                data["folderFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompanyFilesDto {
    modifiedDate: string | undefined;
    itemCount: number | undefined;
    fileId: string | undefined;
    fileName: string | undefined;
    fileUrl: string | undefined;
    extension: string | undefined;
    isFolder: boolean | undefined;
    isCompanyFile: boolean | undefined;
    isAddToShortcut: boolean | undefined;
    driveId: string | undefined;
    driveName: string | undefined;
    siteName: string | undefined;
    folderFiles: CompanyFilesDto[] | undefined;
}

export class CompanyFilesDtoListIHandleError implements ICompanyFilesDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CompanyFilesDto[] | undefined;
    listOfEntities!: CompanyFilesDto[][] | undefined;

    constructor(data?: ICompanyFilesDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(CompanyFilesDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyFilesDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyFilesDtoListIHandleError>(data, _mappings, CompanyFilesDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ICompanyFilesDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CompanyFilesDto[] | undefined;
    listOfEntities: CompanyFilesDto[][] | undefined;
}

export class CreateUpdateCompanyTagsDto implements ICreateUpdateCompanyTagsDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    companyId!: number | undefined;
    tagId!: number | undefined;
    tagName!: string | undefined;

    constructor(data?: ICreateUpdateCompanyTagsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.companyId = _data["companyId"];
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateUpdateCompanyTagsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateUpdateCompanyTagsDto>(data, _mappings, CreateUpdateCompanyTagsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["companyId"] = this.companyId;
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        return data;
    }
}

export interface ICreateUpdateCompanyTagsDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    companyId: number | undefined;
    tagId: number | undefined;
    tagName: string | undefined;
}

export class CompanyTagListDtoListIHandleError implements ICompanyTagListDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CompanyTagListDto[] | undefined;
    listOfEntities!: CompanyTagListDto[][] | undefined;

    constructor(data?: ICompanyTagListDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(CompanyTagListDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyTagListDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyTagListDtoListIHandleError>(data, _mappings, CompanyTagListDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ICompanyTagListDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CompanyTagListDto[] | undefined;
    listOfEntities: CompanyTagListDto[][] | undefined;
}

export class CompanyNotesDto implements ICompanyNotesDto {
    id!: number | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    notes!: string | undefined;
    pinnedEntityId!: number | undefined;
    sortOrder!: number | undefined;
    companyId!: number | undefined;
    creationTime!: string | undefined;
    createdBy!: string | undefined;
    createdByProfileUrl!: string | undefined;
    createdByStatusCode!: number | undefined;
    colorClassName!: string | undefined;
    readonly createdTimeAgo!: string | undefined;
    readonly title!: string | undefined;

    constructor(data?: ICompanyNotesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.notes = _data["notes"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.sortOrder = _data["sortOrder"];
            this.companyId = _data["companyId"];
            this.creationTime = _data["creationTime"];
            this.createdBy = _data["createdBy"];
            this.createdByProfileUrl = _data["createdByProfileUrl"];
            this.createdByStatusCode = _data["createdByStatusCode"];
            this.colorClassName = _data["colorClassName"];
            (this as any).createdTimeAgo = _data["createdTimeAgo"];
            (this as any).title = _data["title"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyNotesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyNotesDto>(data, _mappings, CompanyNotesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["notes"] = this.notes;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["sortOrder"] = this.sortOrder;
        data["companyId"] = this.companyId;
        data["creationTime"] = this.creationTime;
        data["createdBy"] = this.createdBy;
        data["createdByProfileUrl"] = this.createdByProfileUrl;
        data["createdByStatusCode"] = this.createdByStatusCode;
        data["colorClassName"] = this.colorClassName;
        data["createdTimeAgo"] = this.createdTimeAgo;
        data["title"] = this.title;
        return data;
    }
}

export interface ICompanyNotesDto {
    id: number | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    notes: string | undefined;
    pinnedEntityId: number | undefined;
    sortOrder: number | undefined;
    companyId: number | undefined;
    creationTime: string | undefined;
    createdBy: string | undefined;
    createdByProfileUrl: string | undefined;
    createdByStatusCode: number | undefined;
    colorClassName: string | undefined;
    createdTimeAgo: string | undefined;
    title: string | undefined;
}

export class CompanyNotesDtoListIHandleError implements ICompanyNotesDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CompanyNotesDto[] | undefined;
    listOfEntities!: CompanyNotesDto[][] | undefined;

    constructor(data?: ICompanyNotesDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(CompanyNotesDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyNotesDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyNotesDtoListIHandleError>(data, _mappings, CompanyNotesDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ICompanyNotesDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CompanyNotesDto[] | undefined;
    listOfEntities: CompanyNotesDto[][] | undefined;
}

export class Microsoft365StatusDto implements IMicrosoft365StatusDto {
    isConnected!: boolean | undefined;
    email!: string | undefined;

    constructor(data?: IMicrosoft365StatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isConnected = _data["isConnected"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any, _mappings?: any): Microsoft365StatusDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Microsoft365StatusDto>(data, _mappings, Microsoft365StatusDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isConnected"] = this.isConnected;
        data["email"] = this.email;
        return data;
    }
}

export interface IMicrosoft365StatusDto {
    isConnected: boolean | undefined;
    email: string | undefined;
}

export enum ContactAddressType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class ContactAddress implements IContactAddress {
    id!: number | undefined;
    contactId!: number | undefined;
    type!: ContactAddressType | undefined;
    street!: string | undefined;
    suiteUnitNumber!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    countryId!: number | undefined;
    countryName!: string | undefined;

    constructor(data?: IContactAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.type = _data["type"];
            this.street = _data["street"];
            this.suiteUnitNumber = _data["suiteUnitNumber"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactAddress | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactAddress>(data, _mappings, ContactAddress);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["type"] = this.type;
        data["street"] = this.street;
        data["suiteUnitNumber"] = this.suiteUnitNumber;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        return data;
    }
}

export interface IContactAddress {
    id: number | undefined;
    contactId: number | undefined;
    type: ContactAddressType | undefined;
    street: string | undefined;
    suiteUnitNumber: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    countryId: number | undefined;
    countryName: string | undefined;
}

export enum ContactEmailType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ContactEmails implements IContactEmails {
    id!: number | undefined;
    contactId!: number | undefined;
    emailAddress!: string | undefined;
    emailType!: ContactEmailType | undefined;

    constructor(data?: IContactEmails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.emailAddress = _data["emailAddress"];
            this.emailType = _data["emailType"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactEmails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactEmails>(data, _mappings, ContactEmails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["emailAddress"] = this.emailAddress;
        data["emailType"] = this.emailType;
        return data;
    }
}

export interface IContactEmails {
    id: number | undefined;
    contactId: number | undefined;
    emailAddress: string | undefined;
    emailType: ContactEmailType | undefined;
}

export enum FamilyRelationType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

export class ContactFamilies implements IContactFamilies {
    id!: number | undefined;
    contactId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    relationship!: FamilyRelationType | undefined;
    readonly relationshipName!: string | undefined;
    birthDate!: string | undefined;
    birthMonth!: string | undefined;
    birthYear!: string | undefined;
    readonly birthDateAsDatetime!: string | undefined;
    countryCityzenshipId!: number | undefined;
    countryCityzenshipName!: string | undefined;

    constructor(data?: IContactFamilies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.relationship = _data["relationship"];
            (this as any).relationshipName = _data["relationshipName"];
            this.birthDate = _data["birthDate"];
            this.birthMonth = _data["birthMonth"];
            this.birthYear = _data["birthYear"];
            (this as any).birthDateAsDatetime = _data["birthDateAsDatetime"];
            this.countryCityzenshipId = _data["countryCityzenshipId"];
            this.countryCityzenshipName = _data["countryCityzenshipName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactFamilies | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactFamilies>(data, _mappings, ContactFamilies);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["relationship"] = this.relationship;
        data["relationshipName"] = this.relationshipName;
        data["birthDate"] = this.birthDate;
        data["birthMonth"] = this.birthMonth;
        data["birthYear"] = this.birthYear;
        data["birthDateAsDatetime"] = this.birthDateAsDatetime;
        data["countryCityzenshipId"] = this.countryCityzenshipId;
        data["countryCityzenshipName"] = this.countryCityzenshipName;
        return data;
    }
}

export interface IContactFamilies {
    id: number | undefined;
    contactId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    relationship: FamilyRelationType | undefined;
    relationshipName: string | undefined;
    birthDate: string | undefined;
    birthMonth: string | undefined;
    birthYear: string | undefined;
    birthDateAsDatetime: string | undefined;
    countryCityzenshipId: number | undefined;
    countryCityzenshipName: string | undefined;
}

export enum ContactNumberType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class ContactNumbers implements IContactNumbers {
    id!: number | undefined;
    contactId!: number | undefined;
    type!: ContactNumberType | undefined;
    countryCode!: string | undefined;
    number!: string | undefined;
    extension!: string | undefined;

    constructor(data?: IContactNumbers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.type = _data["type"];
            this.countryCode = _data["countryCode"];
            this.number = _data["number"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactNumbers | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactNumbers>(data, _mappings, ContactNumbers);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["type"] = this.type;
        data["countryCode"] = this.countryCode;
        data["number"] = this.number;
        data["extension"] = this.extension;
        return data;
    }
}

export interface IContactNumbers {
    id: number | undefined;
    contactId: number | undefined;
    type: ContactNumberType | undefined;
    countryCode: string | undefined;
    number: string | undefined;
    extension: string | undefined;
}

export class ContactCompanies implements IContactCompanies {
    id!: number | undefined;
    contactId!: number | undefined;
    companyId!: number | undefined;
    companyName!: string | undefined;
    taxId!: string | undefined;
    street!: string | undefined;
    suite_UnitNumber!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    postalCode!: string | undefined;
    countryId!: number | undefined;
    countryName!: string | undefined;
    isDeleted!: boolean | undefined;
    siteUrl!: string | undefined;

    constructor(data?: IContactCompanies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.taxId = _data["taxId"];
            this.street = _data["street"];
            this.suite_UnitNumber = _data["suite_UnitNumber"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.isDeleted = _data["isDeleted"];
            this.siteUrl = _data["siteUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactCompanies | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactCompanies>(data, _mappings, ContactCompanies);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["taxId"] = this.taxId;
        data["street"] = this.street;
        data["suite_UnitNumber"] = this.suite_UnitNumber;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["isDeleted"] = this.isDeleted;
        data["siteUrl"] = this.siteUrl;
        return data;
    }
}

export interface IContactCompanies {
    id: number | undefined;
    contactId: number | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    taxId: string | undefined;
    street: string | undefined;
    suite_UnitNumber: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postalCode: string | undefined;
    countryId: number | undefined;
    countryName: string | undefined;
    isDeleted: boolean | undefined;
    siteUrl: string | undefined;
}

export class CreateOrUpdateUserContactInputDto implements ICreateOrUpdateUserContactInputDto {
    id!: number | undefined;
    tenantId!: number | undefined;
    ownerId!: number | undefined;
    contactTypeId!: number | undefined;
    clientStageId!: number | undefined;
    clientSourceId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    jobTitle!: string | undefined;
    birthDate!: string | undefined;
    birthMonth!: string | undefined;
    birthYear!: string | undefined;
    readonly birthDateAsDatetime!: string | undefined;
    isLocationCreated!: boolean | undefined;
    folderUrl!: string | undefined;
    folderId!: string | undefined;
    driveId!: string | undefined;
    tenantFolderId!: string | undefined;
    tenantDriveId!: string | undefined;
    profileUrl!: string | undefined;
    accountNumber!: string | undefined;
    socialSecurityNumber!: string | undefined;
    privacyType!: ConcactPrivacyType | undefined;
    contactAddressesAsJson!: string | undefined;
    contactEmailsAsJson!: string | undefined;
    contactFamiliesAsJson!: string | undefined;
    contactNumbersAsJson!: string | undefined;
    contactCompaniesAsJson!: string | undefined;
    contactAddresses!: ContactAddress[] | undefined;
    contactEmails!: ContactEmails[] | undefined;
    contactFamilies!: ContactFamilies[] | undefined;
    contactNumbers!: ContactNumbers[] | undefined;
    contactCompanies!: ContactCompanies[] | undefined;
    initialBgColor!: string | undefined;
    pinnedEntityId!: number | undefined;
    leadOwnerUserId!: number | undefined;
    intakeNotes!: string | undefined;
    leadFirstFollowUpDate!: string | undefined;
    lostReasonId!: number | undefined;
    lostReasonNote!: string | undefined;
    lostReasonAsked!: boolean | undefined;
    leadPrimaryTaskId!: number | undefined;
    leadFollowUpDate!: string | undefined;
    leadFollowUpResult!: string | undefined;
    leadFollowUpFailed!: boolean | undefined;
    pendingIntakeNoteId!: number | undefined;

    constructor(data?: ICreateOrUpdateUserContactInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.ownerId = _data["ownerId"];
            this.contactTypeId = _data["contactTypeId"];
            this.clientStageId = _data["clientStageId"];
            this.clientSourceId = _data["clientSourceId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.jobTitle = _data["jobTitle"];
            this.birthDate = _data["birthDate"];
            this.birthMonth = _data["birthMonth"];
            this.birthYear = _data["birthYear"];
            (this as any).birthDateAsDatetime = _data["birthDateAsDatetime"];
            this.isLocationCreated = _data["isLocationCreated"];
            this.folderUrl = _data["folderUrl"];
            this.folderId = _data["folderId"];
            this.driveId = _data["driveId"];
            this.tenantFolderId = _data["tenantFolderId"];
            this.tenantDriveId = _data["tenantDriveId"];
            this.profileUrl = _data["profileUrl"];
            this.accountNumber = _data["accountNumber"];
            this.socialSecurityNumber = _data["socialSecurityNumber"];
            this.privacyType = _data["privacyType"];
            this.contactAddressesAsJson = _data["contactAddressesAsJson"];
            this.contactEmailsAsJson = _data["contactEmailsAsJson"];
            this.contactFamiliesAsJson = _data["contactFamiliesAsJson"];
            this.contactNumbersAsJson = _data["contactNumbersAsJson"];
            this.contactCompaniesAsJson = _data["contactCompaniesAsJson"];
            if (Array.isArray(_data["contactAddresses"])) {
                this.contactAddresses = [] as any;
                for (let item of _data["contactAddresses"])
                    this.contactAddresses!.push(ContactAddress.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["contactEmails"])) {
                this.contactEmails = [] as any;
                for (let item of _data["contactEmails"])
                    this.contactEmails!.push(ContactEmails.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["contactFamilies"])) {
                this.contactFamilies = [] as any;
                for (let item of _data["contactFamilies"])
                    this.contactFamilies!.push(ContactFamilies.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["contactNumbers"])) {
                this.contactNumbers = [] as any;
                for (let item of _data["contactNumbers"])
                    this.contactNumbers!.push(ContactNumbers.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["contactCompanies"])) {
                this.contactCompanies = [] as any;
                for (let item of _data["contactCompanies"])
                    this.contactCompanies!.push(ContactCompanies.fromJS(item, _mappings));
            }
            this.initialBgColor = _data["initialBgColor"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.leadOwnerUserId = _data["leadOwnerUserId"];
            this.intakeNotes = _data["intakeNotes"];
            this.leadFirstFollowUpDate = _data["leadFirstFollowUpDate"];
            this.lostReasonId = _data["lostReasonId"];
            this.lostReasonNote = _data["lostReasonNote"];
            this.lostReasonAsked = _data["lostReasonAsked"];
            this.leadPrimaryTaskId = _data["leadPrimaryTaskId"];
            this.leadFollowUpDate = _data["leadFollowUpDate"];
            this.leadFollowUpResult = _data["leadFollowUpResult"];
            this.leadFollowUpFailed = _data["leadFollowUpFailed"];
            this.pendingIntakeNoteId = _data["pendingIntakeNoteId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateOrUpdateUserContactInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateOrUpdateUserContactInputDto>(data, _mappings, CreateOrUpdateUserContactInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["ownerId"] = this.ownerId;
        data["contactTypeId"] = this.contactTypeId;
        data["clientStageId"] = this.clientStageId;
        data["clientSourceId"] = this.clientSourceId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["jobTitle"] = this.jobTitle;
        data["birthDate"] = this.birthDate;
        data["birthMonth"] = this.birthMonth;
        data["birthYear"] = this.birthYear;
        data["birthDateAsDatetime"] = this.birthDateAsDatetime;
        data["isLocationCreated"] = this.isLocationCreated;
        data["folderUrl"] = this.folderUrl;
        data["folderId"] = this.folderId;
        data["driveId"] = this.driveId;
        data["tenantFolderId"] = this.tenantFolderId;
        data["tenantDriveId"] = this.tenantDriveId;
        data["profileUrl"] = this.profileUrl;
        data["accountNumber"] = this.accountNumber;
        data["socialSecurityNumber"] = this.socialSecurityNumber;
        data["privacyType"] = this.privacyType;
        data["contactAddressesAsJson"] = this.contactAddressesAsJson;
        data["contactEmailsAsJson"] = this.contactEmailsAsJson;
        data["contactFamiliesAsJson"] = this.contactFamiliesAsJson;
        data["contactNumbersAsJson"] = this.contactNumbersAsJson;
        data["contactCompaniesAsJson"] = this.contactCompaniesAsJson;
        if (Array.isArray(this.contactAddresses)) {
            data["contactAddresses"] = [];
            for (let item of this.contactAddresses)
                data["contactAddresses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contactEmails)) {
            data["contactEmails"] = [];
            for (let item of this.contactEmails)
                data["contactEmails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contactFamilies)) {
            data["contactFamilies"] = [];
            for (let item of this.contactFamilies)
                data["contactFamilies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contactNumbers)) {
            data["contactNumbers"] = [];
            for (let item of this.contactNumbers)
                data["contactNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contactCompanies)) {
            data["contactCompanies"] = [];
            for (let item of this.contactCompanies)
                data["contactCompanies"].push(item ? item.toJSON() : undefined as any);
        }
        data["initialBgColor"] = this.initialBgColor;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["leadOwnerUserId"] = this.leadOwnerUserId;
        data["intakeNotes"] = this.intakeNotes;
        data["leadFirstFollowUpDate"] = this.leadFirstFollowUpDate;
        data["lostReasonId"] = this.lostReasonId;
        data["lostReasonNote"] = this.lostReasonNote;
        data["lostReasonAsked"] = this.lostReasonAsked;
        data["leadPrimaryTaskId"] = this.leadPrimaryTaskId;
        data["leadFollowUpDate"] = this.leadFollowUpDate;
        data["leadFollowUpResult"] = this.leadFollowUpResult;
        data["leadFollowUpFailed"] = this.leadFollowUpFailed;
        data["pendingIntakeNoteId"] = this.pendingIntakeNoteId;
        return data;
    }
}

export interface ICreateOrUpdateUserContactInputDto {
    id: number | undefined;
    tenantId: number | undefined;
    ownerId: number | undefined;
    contactTypeId: number | undefined;
    clientStageId: number | undefined;
    clientSourceId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    jobTitle: string | undefined;
    birthDate: string | undefined;
    birthMonth: string | undefined;
    birthYear: string | undefined;
    birthDateAsDatetime: string | undefined;
    isLocationCreated: boolean | undefined;
    folderUrl: string | undefined;
    folderId: string | undefined;
    driveId: string | undefined;
    tenantFolderId: string | undefined;
    tenantDriveId: string | undefined;
    profileUrl: string | undefined;
    accountNumber: string | undefined;
    socialSecurityNumber: string | undefined;
    privacyType: ConcactPrivacyType | undefined;
    contactAddressesAsJson: string | undefined;
    contactEmailsAsJson: string | undefined;
    contactFamiliesAsJson: string | undefined;
    contactNumbersAsJson: string | undefined;
    contactCompaniesAsJson: string | undefined;
    contactAddresses: ContactAddress[] | undefined;
    contactEmails: ContactEmails[] | undefined;
    contactFamilies: ContactFamilies[] | undefined;
    contactNumbers: ContactNumbers[] | undefined;
    contactCompanies: ContactCompanies[] | undefined;
    initialBgColor: string | undefined;
    pinnedEntityId: number | undefined;
    leadOwnerUserId: number | undefined;
    intakeNotes: string | undefined;
    leadFirstFollowUpDate: string | undefined;
    lostReasonId: number | undefined;
    lostReasonNote: string | undefined;
    lostReasonAsked: boolean | undefined;
    leadPrimaryTaskId: number | undefined;
    leadFollowUpDate: string | undefined;
    leadFollowUpResult: string | undefined;
    leadFollowUpFailed: boolean | undefined;
    pendingIntakeNoteId: number | undefined;
}

export class CreateOrUpdateUserContactInputDtoIHandleError implements ICreateOrUpdateUserContactInputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CreateOrUpdateUserContactInputDto | undefined;
    listOfEntities!: CreateOrUpdateUserContactInputDto[] | undefined;

    constructor(data?: ICreateOrUpdateUserContactInputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CreateOrUpdateUserContactInputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CreateOrUpdateUserContactInputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateOrUpdateUserContactInputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateOrUpdateUserContactInputDtoIHandleError>(data, _mappings, CreateOrUpdateUserContactInputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateOrUpdateUserContactInputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CreateOrUpdateUserContactInputDto | undefined;
    listOfEntities: CreateOrUpdateUserContactInputDto[] | undefined;
}

export class Int32UserContactDtoListValueTuple implements IInt32UserContactDtoListValueTuple {

    constructor(data?: IInt32UserContactDtoListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): Int32UserContactDtoListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32UserContactDtoListValueTuple>(data, _mappings, Int32UserContactDtoListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IInt32UserContactDtoListValueTuple {
}

export class Int32UserContactDtoListValueTupleIHandleError implements IInt32UserContactDtoListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: Int32UserContactDtoListValueTuple | undefined;
    listOfEntities!: Int32UserContactDtoListValueTuple[] | undefined;

    constructor(data?: IInt32UserContactDtoListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? Int32UserContactDtoListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(Int32UserContactDtoListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32UserContactDtoListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32UserContactDtoListValueTupleIHandleError>(data, _mappings, Int32UserContactDtoListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInt32UserContactDtoListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: Int32UserContactDtoListValueTuple | undefined;
    listOfEntities: Int32UserContactDtoListValueTuple[] | undefined;
}

export class AddContactEmailInput implements IAddContactEmailInput {
    contactId!: number | undefined;
    emailAddress!: string | undefined;
    emailType!: number | undefined;

    constructor(data?: IAddContactEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.emailAddress = _data["emailAddress"];
            this.emailType = _data["emailType"];
        }
    }

    static fromJS(data: any, _mappings?: any): AddContactEmailInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddContactEmailInput>(data, _mappings, AddContactEmailInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["emailAddress"] = this.emailAddress;
        data["emailType"] = this.emailType;
        return data;
    }
}

export interface IAddContactEmailInput {
    contactId: number | undefined;
    emailAddress: string | undefined;
    emailType: number | undefined;
}

export enum ContactTypeAct {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ContactTypes implements IContactTypes {
    id!: number | undefined;
    name!: string | undefined;
    color!: string | undefined;
    bgColor!: string | undefined;
    isActive!: boolean | undefined;
    act!: ContactTypeAct | undefined;
    sortOrder!: number | undefined;

    constructor(data?: IContactTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.bgColor = _data["bgColor"];
            this.isActive = _data["isActive"];
            this.act = _data["act"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactTypes | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactTypes>(data, _mappings, ContactTypes);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["bgColor"] = this.bgColor;
        data["isActive"] = this.isActive;
        data["act"] = this.act;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IContactTypes {
    id: number | undefined;
    name: string | undefined;
    color: string | undefined;
    bgColor: string | undefined;
    isActive: boolean | undefined;
    act: ContactTypeAct | undefined;
    sortOrder: number | undefined;
}

export class CompanyDto implements ICompanyDto {
    companyId!: number | undefined;
    companyName!: string | undefined;
    tenantId!: number | undefined;
    siteUrl!: string | undefined;
    street!: string | undefined;
    city!: string | undefined;
    postalCode!: string | undefined;
    countryId!: number | undefined;
    state!: string | undefined;
    taxId!: string | undefined;
    defaultContact!: string | undefined;
    industryId!: number | undefined;
    industryName!: string | undefined;
    totalContacts!: number | undefined;
    companyTypeId!: number | undefined;
    companyType!: string | undefined;
    bgColor!: string | undefined;
    color!: string | undefined;
    clientStageId!: number | undefined;
    clientStage!: string | undefined;
    stageBgColor!: string | undefined;
    stageColor!: string | undefined;
    clientSourceId!: number | undefined;
    initialBgColor!: string | undefined;
    pinnedEntityId!: number | undefined;
    totalTags!: number | undefined;
    companyTagsAsJson!: string | undefined;
    readonly companyTags!: CompanyTagListDto[] | undefined;
    lastModificationTime!: string | undefined;
    creationTime!: string | undefined;
    createdByName!: string | undefined;
    lastModifiedByName!: string | undefined;
    sortOrder!: number | undefined;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.tenantId = _data["tenantId"];
            this.siteUrl = _data["siteUrl"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.countryId = _data["countryId"];
            this.state = _data["state"];
            this.taxId = _data["taxId"];
            this.defaultContact = _data["defaultContact"];
            this.industryId = _data["industryId"];
            this.industryName = _data["industryName"];
            this.totalContacts = _data["totalContacts"];
            this.companyTypeId = _data["companyTypeId"];
            this.companyType = _data["companyType"];
            this.bgColor = _data["bgColor"];
            this.color = _data["color"];
            this.clientStageId = _data["clientStageId"];
            this.clientStage = _data["clientStage"];
            this.stageBgColor = _data["stageBgColor"];
            this.stageColor = _data["stageColor"];
            this.clientSourceId = _data["clientSourceId"];
            this.initialBgColor = _data["initialBgColor"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.totalTags = _data["totalTags"];
            this.companyTagsAsJson = _data["companyTagsAsJson"];
            if (Array.isArray(_data["companyTags"])) {
                (this as any).companyTags = [] as any;
                for (let item of _data["companyTags"])
                    (this as any).companyTags!.push(CompanyTagListDto.fromJS(item, _mappings));
            }
            this.lastModificationTime = _data["lastModificationTime"];
            this.creationTime = _data["creationTime"];
            this.createdByName = _data["createdByName"];
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyDto>(data, _mappings, CompanyDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["tenantId"] = this.tenantId;
        data["siteUrl"] = this.siteUrl;
        data["street"] = this.street;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["countryId"] = this.countryId;
        data["state"] = this.state;
        data["taxId"] = this.taxId;
        data["defaultContact"] = this.defaultContact;
        data["industryId"] = this.industryId;
        data["industryName"] = this.industryName;
        data["totalContacts"] = this.totalContacts;
        data["companyTypeId"] = this.companyTypeId;
        data["companyType"] = this.companyType;
        data["bgColor"] = this.bgColor;
        data["color"] = this.color;
        data["clientStageId"] = this.clientStageId;
        data["clientStage"] = this.clientStage;
        data["stageBgColor"] = this.stageBgColor;
        data["stageColor"] = this.stageColor;
        data["clientSourceId"] = this.clientSourceId;
        data["initialBgColor"] = this.initialBgColor;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["totalTags"] = this.totalTags;
        data["companyTagsAsJson"] = this.companyTagsAsJson;
        if (Array.isArray(this.companyTags)) {
            data["companyTags"] = [];
            for (let item of this.companyTags)
                data["companyTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["lastModificationTime"] = this.lastModificationTime;
        data["creationTime"] = this.creationTime;
        data["createdByName"] = this.createdByName;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICompanyDto {
    companyId: number | undefined;
    companyName: string | undefined;
    tenantId: number | undefined;
    siteUrl: string | undefined;
    street: string | undefined;
    city: string | undefined;
    postalCode: string | undefined;
    countryId: number | undefined;
    state: string | undefined;
    taxId: string | undefined;
    defaultContact: string | undefined;
    industryId: number | undefined;
    industryName: string | undefined;
    totalContacts: number | undefined;
    companyTypeId: number | undefined;
    companyType: string | undefined;
    bgColor: string | undefined;
    color: string | undefined;
    clientStageId: number | undefined;
    clientStage: string | undefined;
    stageBgColor: string | undefined;
    stageColor: string | undefined;
    clientSourceId: number | undefined;
    initialBgColor: string | undefined;
    pinnedEntityId: number | undefined;
    totalTags: number | undefined;
    companyTagsAsJson: string | undefined;
    companyTags: CompanyTagListDto[] | undefined;
    lastModificationTime: string | undefined;
    creationTime: string | undefined;
    createdByName: string | undefined;
    lastModifiedByName: string | undefined;
    sortOrder: number | undefined;
}

export class ContactFiltersDto implements IContactFiltersDto {
    contactTypes!: ContactTypes[] | undefined;
    companies!: CompanyDto[] | undefined;
    tags!: TagListDto[] | undefined;

    constructor(data?: IContactFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["contactTypes"])) {
                this.contactTypes = [] as any;
                for (let item of _data["contactTypes"])
                    this.contactTypes!.push(ContactTypes.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(CompanyDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagListDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ContactFiltersDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactFiltersDto>(data, _mappings, ContactFiltersDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactTypes)) {
            data["contactTypes"] = [];
            for (let item of this.contactTypes)
                data["contactTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContactFiltersDto {
    contactTypes: ContactTypes[] | undefined;
    companies: CompanyDto[] | undefined;
    tags: TagListDto[] | undefined;
}

export class ContactFiltersDtoIHandleError implements IContactFiltersDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ContactFiltersDto | undefined;
    listOfEntities!: ContactFiltersDto[] | undefined;

    constructor(data?: IContactFiltersDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ContactFiltersDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ContactFiltersDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ContactFiltersDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactFiltersDtoIHandleError>(data, _mappings, ContactFiltersDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContactFiltersDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ContactFiltersDto | undefined;
    listOfEntities: ContactFiltersDto[] | undefined;
}

export class StringIHandleError implements IStringIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: string | undefined;
    listOfEntities!: string[] | undefined;

    constructor(data?: IStringIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"];
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): StringIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StringIHandleError>(data, _mappings, StringIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IStringIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: string | undefined;
    listOfEntities: string[] | undefined;
}

export enum ClientKind {
    _1 = 1,
    _2 = 2,
}

export class ClientStageTransitionDto implements IClientStageTransitionDto {
    clientKind!: ClientKind | undefined;
    clientId!: number | undefined;
    fromStageId!: number | undefined;
    toStageId!: number | undefined;
    toStageName!: string | undefined;
    toStageAct!: ClientStageAct | undefined;
    isTransition!: boolean | undefined;
    transitionId!: number | undefined;
    promptProject!: boolean | undefined;
    appliedContactTypeId!: number | undefined;
    leadFollowUpEnded!: boolean | undefined;
    endedLeadTaskId!: number | undefined;
    leadTaskCompleted!: boolean | undefined;
    leadCycleAction!: string | undefined;
    leadCycleId!: number | undefined;
    primaryTaskId!: number | undefined;
    followUpDate!: string | undefined;
    followUpResult!: string | undefined;
    primaryHasUnansweredReply!: boolean | undefined;
    stageClearedByTypeChange!: boolean | undefined;
    intakeCommentPosted!: boolean | undefined;
    primaryCreated!: boolean | undefined;

    constructor(data?: IClientStageTransitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.clientKind = _data["clientKind"];
            this.clientId = _data["clientId"];
            this.fromStageId = _data["fromStageId"];
            this.toStageId = _data["toStageId"];
            this.toStageName = _data["toStageName"];
            this.toStageAct = _data["toStageAct"];
            this.isTransition = _data["isTransition"];
            this.transitionId = _data["transitionId"];
            this.promptProject = _data["promptProject"];
            this.appliedContactTypeId = _data["appliedContactTypeId"];
            this.leadFollowUpEnded = _data["leadFollowUpEnded"];
            this.endedLeadTaskId = _data["endedLeadTaskId"];
            this.leadTaskCompleted = _data["leadTaskCompleted"];
            this.leadCycleAction = _data["leadCycleAction"];
            this.leadCycleId = _data["leadCycleId"];
            this.primaryTaskId = _data["primaryTaskId"];
            this.followUpDate = _data["followUpDate"];
            this.followUpResult = _data["followUpResult"];
            this.primaryHasUnansweredReply = _data["primaryHasUnansweredReply"];
            this.stageClearedByTypeChange = _data["stageClearedByTypeChange"];
            this.intakeCommentPosted = _data["intakeCommentPosted"];
            this.primaryCreated = _data["primaryCreated"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientStageTransitionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientStageTransitionDto>(data, _mappings, ClientStageTransitionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientKind"] = this.clientKind;
        data["clientId"] = this.clientId;
        data["fromStageId"] = this.fromStageId;
        data["toStageId"] = this.toStageId;
        data["toStageName"] = this.toStageName;
        data["toStageAct"] = this.toStageAct;
        data["isTransition"] = this.isTransition;
        data["transitionId"] = this.transitionId;
        data["promptProject"] = this.promptProject;
        data["appliedContactTypeId"] = this.appliedContactTypeId;
        data["leadFollowUpEnded"] = this.leadFollowUpEnded;
        data["endedLeadTaskId"] = this.endedLeadTaskId;
        data["leadTaskCompleted"] = this.leadTaskCompleted;
        data["leadCycleAction"] = this.leadCycleAction;
        data["leadCycleId"] = this.leadCycleId;
        data["primaryTaskId"] = this.primaryTaskId;
        data["followUpDate"] = this.followUpDate;
        data["followUpResult"] = this.followUpResult;
        data["primaryHasUnansweredReply"] = this.primaryHasUnansweredReply;
        data["stageClearedByTypeChange"] = this.stageClearedByTypeChange;
        data["intakeCommentPosted"] = this.intakeCommentPosted;
        data["primaryCreated"] = this.primaryCreated;
        return data;
    }
}

export interface IClientStageTransitionDto {
    clientKind: ClientKind | undefined;
    clientId: number | undefined;
    fromStageId: number | undefined;
    toStageId: number | undefined;
    toStageName: string | undefined;
    toStageAct: ClientStageAct | undefined;
    isTransition: boolean | undefined;
    transitionId: number | undefined;
    promptProject: boolean | undefined;
    appliedContactTypeId: number | undefined;
    leadFollowUpEnded: boolean | undefined;
    endedLeadTaskId: number | undefined;
    leadTaskCompleted: boolean | undefined;
    leadCycleAction: string | undefined;
    leadCycleId: number | undefined;
    primaryTaskId: number | undefined;
    followUpDate: string | undefined;
    followUpResult: string | undefined;
    primaryHasUnansweredReply: boolean | undefined;
    stageClearedByTypeChange: boolean | undefined;
    intakeCommentPosted: boolean | undefined;
    primaryCreated: boolean | undefined;
}

export class ClientStageTransitionDtoListIHandleError implements IClientStageTransitionDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ClientStageTransitionDto[] | undefined;
    listOfEntities!: ClientStageTransitionDto[][] | undefined;

    constructor(data?: IClientStageTransitionDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ClientStageTransitionDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ClientStageTransitionDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientStageTransitionDtoListIHandleError>(data, _mappings, ClientStageTransitionDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IClientStageTransitionDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ClientStageTransitionDto[] | undefined;
    listOfEntities: ClientStageTransitionDto[][] | undefined;
}

export class AssignTagsToContactInputDto implements IAssignTagsToContactInputDto {
    tagIds!: number[] | undefined;
    contactIds!: number[] | undefined;

    constructor(data?: IAssignTagsToContactInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AssignTagsToContactInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AssignTagsToContactInputDto>(data, _mappings, AssignTagsToContactInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        return data;
    }
}

export interface IAssignTagsToContactInputDto {
    tagIds: number[] | undefined;
    contactIds: number[] | undefined;
}

export class ClientBulkRecordDto implements IClientBulkRecordDto {
    contactId!: number | undefined;
    name!: string | undefined;
    reason!: string | undefined;
    message!: string | undefined;

    constructor(data?: IClientBulkRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.name = _data["name"];
            this.reason = _data["reason"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientBulkRecordDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientBulkRecordDto>(data, _mappings, ClientBulkRecordDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["name"] = this.name;
        data["reason"] = this.reason;
        data["message"] = this.message;
        return data;
    }
}

export interface IClientBulkRecordDto {
    contactId: number | undefined;
    name: string | undefined;
    reason: string | undefined;
    message: string | undefined;
}

export class DeleteClientsResultDto implements IDeleteClientsResultDto {
    deletedIds!: number[] | undefined;
    skipped!: ClientBulkRecordDto[] | undefined;
    failed!: ClientBulkRecordDto[] | undefined;

    constructor(data?: IDeleteClientsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedIds"])) {
                this.deletedIds = [] as any;
                for (let item of _data["deletedIds"])
                    this.deletedIds!.push(item);
            }
            if (Array.isArray(_data["skipped"])) {
                this.skipped = [] as any;
                for (let item of _data["skipped"])
                    this.skipped!.push(ClientBulkRecordDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["failed"])) {
                this.failed = [] as any;
                for (let item of _data["failed"])
                    this.failed!.push(ClientBulkRecordDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DeleteClientsResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DeleteClientsResultDto>(data, _mappings, DeleteClientsResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedIds)) {
            data["deletedIds"] = [];
            for (let item of this.deletedIds)
                data["deletedIds"].push(item);
        }
        if (Array.isArray(this.skipped)) {
            data["skipped"] = [];
            for (let item of this.skipped)
                data["skipped"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.failed)) {
            data["failed"] = [];
            for (let item of this.failed)
                data["failed"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDeleteClientsResultDto {
    deletedIds: number[] | undefined;
    skipped: ClientBulkRecordDto[] | undefined;
    failed: ClientBulkRecordDto[] | undefined;
}

export class DeleteClientsResultDtoIHandleError implements IDeleteClientsResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: DeleteClientsResultDto | undefined;
    listOfEntities!: DeleteClientsResultDto[] | undefined;

    constructor(data?: IDeleteClientsResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? DeleteClientsResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(DeleteClientsResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DeleteClientsResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DeleteClientsResultDtoIHandleError>(data, _mappings, DeleteClientsResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDeleteClientsResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: DeleteClientsResultDto | undefined;
    listOfEntities: DeleteClientsResultDto[] | undefined;
}

export class UpdateContactTypeStageInputDto implements IUpdateContactTypeStageInputDto {
    contactId!: number | undefined;
    contactTypeId!: number | undefined;
    clientStageId!: number | undefined;
    lostReasonId!: number | undefined;
    lostReasonNote!: string | undefined;

    constructor(data?: IUpdateContactTypeStageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.contactTypeId = _data["contactTypeId"];
            this.clientStageId = _data["clientStageId"];
            this.lostReasonId = _data["lostReasonId"];
            this.lostReasonNote = _data["lostReasonNote"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateContactTypeStageInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateContactTypeStageInputDto>(data, _mappings, UpdateContactTypeStageInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["contactTypeId"] = this.contactTypeId;
        data["clientStageId"] = this.clientStageId;
        data["lostReasonId"] = this.lostReasonId;
        data["lostReasonNote"] = this.lostReasonNote;
        return data;
    }
}

export interface IUpdateContactTypeStageInputDto {
    contactId: number | undefined;
    contactTypeId: number | undefined;
    clientStageId: number | undefined;
    lostReasonId: number | undefined;
    lostReasonNote: string | undefined;
}

export class ClientStageTransitionDtoIHandleError implements IClientStageTransitionDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ClientStageTransitionDto | undefined;
    listOfEntities!: ClientStageTransitionDto[] | undefined;

    constructor(data?: IClientStageTransitionDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ClientStageTransitionDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ClientStageTransitionDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ClientStageTransitionDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientStageTransitionDtoIHandleError>(data, _mappings, ClientStageTransitionDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClientStageTransitionDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ClientStageTransitionDto | undefined;
    listOfEntities: ClientStageTransitionDto[] | undefined;
}

export class ContactTypeStageDto implements IContactTypeStageDto {
    contactTypeId!: number | undefined;
    clientStageId!: number | undefined;

    constructor(data?: IContactTypeStageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactTypeId = _data["contactTypeId"];
            this.clientStageId = _data["clientStageId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactTypeStageDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactTypeStageDto>(data, _mappings, ContactTypeStageDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactTypeId"] = this.contactTypeId;
        data["clientStageId"] = this.clientStageId;
        return data;
    }
}

export interface IContactTypeStageDto {
    contactTypeId: number | undefined;
    clientStageId: number | undefined;
}

export class ContactTypeStageDtoIHandleError implements IContactTypeStageDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ContactTypeStageDto | undefined;
    listOfEntities!: ContactTypeStageDto[] | undefined;

    constructor(data?: IContactTypeStageDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ContactTypeStageDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ContactTypeStageDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ContactTypeStageDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactTypeStageDtoIHandleError>(data, _mappings, ContactTypeStageDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContactTypeStageDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ContactTypeStageDto | undefined;
    listOfEntities: ContactTypeStageDto[] | undefined;
}

export class CreateUpdateTypesDto implements ICreateUpdateTypesDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    contactTypes!: ContactTypes[] | undefined;

    constructor(data?: ICreateUpdateTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            if (Array.isArray(_data["contactTypes"])) {
                this.contactTypes = [] as any;
                for (let item of _data["contactTypes"])
                    this.contactTypes!.push(ContactTypes.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateUpdateTypesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateUpdateTypesDto>(data, _mappings, CreateUpdateTypesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        if (Array.isArray(this.contactTypes)) {
            data["contactTypes"] = [];
            for (let item of this.contactTypes)
                data["contactTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateUpdateTypesDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    contactTypes: ContactTypes[] | undefined;
}

export class Int32ListIHandleError implements IInt32ListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: number[] | undefined;
    listOfEntities!: number[][] | undefined;

    constructor(data?: IInt32ListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(item);
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32ListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32ListIHandleError>(data, _mappings, Int32ListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IInt32ListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: number[] | undefined;
    listOfEntities: number[][] | undefined;
}

export class ContactTypesListIHandleError implements IContactTypesListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ContactTypes[] | undefined;
    listOfEntities!: ContactTypes[][] | undefined;

    constructor(data?: IContactTypesListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ContactTypes.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ContactTypesListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactTypesListIHandleError>(data, _mappings, ContactTypesListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IContactTypesListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ContactTypes[] | undefined;
    listOfEntities: ContactTypes[][] | undefined;
}

export class TenantFolderOutputDto implements ITenantFolderOutputDto {
    folderName!: string | undefined;
    folderUrl!: string | undefined;
    folderId!: string | undefined;
    driveId!: string | undefined;
    siteId!: string | undefined;
    isDocLibrary!: boolean | undefined;
    isSharePoint!: boolean | undefined;

    constructor(data?: ITenantFolderOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.folderName = _data["folderName"];
            this.folderUrl = _data["folderUrl"];
            this.folderId = _data["folderId"];
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
            this.isDocLibrary = _data["isDocLibrary"];
            this.isSharePoint = _data["isSharePoint"];
        }
    }

    static fromJS(data: any, _mappings?: any): TenantFolderOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantFolderOutputDto>(data, _mappings, TenantFolderOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderName"] = this.folderName;
        data["folderUrl"] = this.folderUrl;
        data["folderId"] = this.folderId;
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        data["isDocLibrary"] = this.isDocLibrary;
        data["isSharePoint"] = this.isSharePoint;
        return data;
    }
}

export interface ITenantFolderOutputDto {
    folderName: string | undefined;
    folderUrl: string | undefined;
    folderId: string | undefined;
    driveId: string | undefined;
    siteId: string | undefined;
    isDocLibrary: boolean | undefined;
    isSharePoint: boolean | undefined;
}

export class TenantFolderOutputDtoIHandleError implements ITenantFolderOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TenantFolderOutputDto | undefined;
    listOfEntities!: TenantFolderOutputDto[] | undefined;

    constructor(data?: ITenantFolderOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TenantFolderOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TenantFolderOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TenantFolderOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantFolderOutputDtoIHandleError>(data, _mappings, TenantFolderOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITenantFolderOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TenantFolderOutputDto | undefined;
    listOfEntities: TenantFolderOutputDto[] | undefined;
}

export class ContactFolderOutputDto implements IContactFolderOutputDto {
    folderName!: string | undefined;
    folderUrl!: string | undefined;
    folderId!: string | undefined;
    driveId!: string | undefined;
    siteId!: string | undefined;
    isDocLibrary!: boolean | undefined;
    isSharePoint!: boolean | undefined;

    constructor(data?: IContactFolderOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.folderName = _data["folderName"];
            this.folderUrl = _data["folderUrl"];
            this.folderId = _data["folderId"];
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
            this.isDocLibrary = _data["isDocLibrary"];
            this.isSharePoint = _data["isSharePoint"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactFolderOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactFolderOutputDto>(data, _mappings, ContactFolderOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderName"] = this.folderName;
        data["folderUrl"] = this.folderUrl;
        data["folderId"] = this.folderId;
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        data["isDocLibrary"] = this.isDocLibrary;
        data["isSharePoint"] = this.isSharePoint;
        return data;
    }
}

export interface IContactFolderOutputDto {
    folderName: string | undefined;
    folderUrl: string | undefined;
    folderId: string | undefined;
    driveId: string | undefined;
    siteId: string | undefined;
    isDocLibrary: boolean | undefined;
    isSharePoint: boolean | undefined;
}

export class ContactFolderOutputDtoIHandleError implements IContactFolderOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ContactFolderOutputDto | undefined;
    listOfEntities!: ContactFolderOutputDto[] | undefined;

    constructor(data?: IContactFolderOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ContactFolderOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ContactFolderOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ContactFolderOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactFolderOutputDtoIHandleError>(data, _mappings, ContactFolderOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContactFolderOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ContactFolderOutputDto | undefined;
    listOfEntities: ContactFolderOutputDto[] | undefined;
}

export class ContactFilesOutputDto implements IContactFilesOutputDto {
    modifiedDate!: string | undefined;
    itemCount!: number | undefined;
    fileId!: string | undefined;
    fileName!: string | undefined;
    fileUrl!: string | undefined;
    extension!: string | undefined;
    isFolder!: boolean | undefined;
    driveId!: string | undefined;
    isAddToShortcut!: boolean | undefined;

    constructor(data?: IContactFilesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.modifiedDate = _data["modifiedDate"];
            this.itemCount = _data["itemCount"];
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.extension = _data["extension"];
            this.isFolder = _data["isFolder"];
            this.driveId = _data["driveId"];
            this.isAddToShortcut = _data["isAddToShortcut"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactFilesOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactFilesOutputDto>(data, _mappings, ContactFilesOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modifiedDate"] = this.modifiedDate;
        data["itemCount"] = this.itemCount;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["extension"] = this.extension;
        data["isFolder"] = this.isFolder;
        data["driveId"] = this.driveId;
        data["isAddToShortcut"] = this.isAddToShortcut;
        return data;
    }
}

export interface IContactFilesOutputDto {
    modifiedDate: string | undefined;
    itemCount: number | undefined;
    fileId: string | undefined;
    fileName: string | undefined;
    fileUrl: string | undefined;
    extension: string | undefined;
    isFolder: boolean | undefined;
    driveId: string | undefined;
    isAddToShortcut: boolean | undefined;
}

export class ContactFilesOutputDtoListIHandleError implements IContactFilesOutputDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ContactFilesOutputDto[] | undefined;
    listOfEntities!: ContactFilesOutputDto[][] | undefined;

    constructor(data?: IContactFilesOutputDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ContactFilesOutputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ContactFilesOutputDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactFilesOutputDtoListIHandleError>(data, _mappings, ContactFilesOutputDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IContactFilesOutputDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ContactFilesOutputDto[] | undefined;
    listOfEntities: ContactFilesOutputDto[][] | undefined;
}

export class ContactTaskListDto implements IContactTaskListDto {
    id!: number | undefined;
    ownerId!: number | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    code!: number | undefined;
    name!: string | undefined;
    sortOrder!: number | undefined;
    isSeen!: boolean | undefined;
    isNewlyAssigned!: boolean | undefined;
    assignedByUserId!: number | undefined;
    assignedByUser!: string | undefined;
    assignedToUserId!: number | undefined;
    assignedToUser!: string | undefined;
    assignedToUserProfilePictureUrl!: string | undefined;
    assignedTime!: string | undefined;
    completedOn!: string | undefined;
    projectName!: string | undefined;
    progressCompleted!: number | undefined;
    projectId!: number | undefined;
    isPrivateProject!: boolean | undefined;
    taskProjectName!: string | undefined;
    projectSectionId!: number | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    isPrivate!: boolean | undefined;
    priority!: TaskPriority | undefined;
    tags!: string | undefined;
    readonly projectTags!: ProjectTag[] | undefined;
    statusCode!: number | undefined;
    isAddedOnMyDay!: boolean | undefined;
    isDueDatePassed!: boolean | undefined;
    entityType!: TaskEntityType | undefined;
    taskType!: TaskTypes | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactCompanyId!: number | undefined;
    contactCompanyName!: string | undefined;
    contributors!: TaskContributorDto[] | undefined;

    constructor(data?: IContactTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerId = _data["ownerId"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isSeen = _data["isSeen"];
            this.isNewlyAssigned = _data["isNewlyAssigned"];
            this.assignedByUserId = _data["assignedByUserId"];
            this.assignedByUser = _data["assignedByUser"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"];
            this.assignedToUserProfilePictureUrl = _data["assignedToUserProfilePictureUrl"];
            this.assignedTime = _data["assignedTime"];
            this.completedOn = _data["completedOn"];
            this.projectName = _data["projectName"];
            this.progressCompleted = _data["progressCompleted"];
            this.projectId = _data["projectId"];
            this.isPrivateProject = _data["isPrivateProject"];
            this.taskProjectName = _data["taskProjectName"];
            this.projectSectionId = _data["projectSectionId"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.isPrivate = _data["isPrivate"];
            this.priority = _data["priority"];
            this.tags = _data["tags"];
            if (Array.isArray(_data["projectTags"])) {
                (this as any).projectTags = [] as any;
                for (let item of _data["projectTags"])
                    (this as any).projectTags!.push(ProjectTag.fromJS(item, _mappings));
            }
            this.statusCode = _data["statusCode"];
            this.isAddedOnMyDay = _data["isAddedOnMyDay"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.entityType = _data["entityType"];
            this.taskType = _data["taskType"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactCompanyId = _data["contactCompanyId"];
            this.contactCompanyName = _data["contactCompanyName"];
            if (Array.isArray(_data["contributors"])) {
                this.contributors = [] as any;
                for (let item of _data["contributors"])
                    this.contributors!.push(TaskContributorDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ContactTaskListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactTaskListDto>(data, _mappings, ContactTaskListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerId"] = this.ownerId;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isSeen"] = this.isSeen;
        data["isNewlyAssigned"] = this.isNewlyAssigned;
        data["assignedByUserId"] = this.assignedByUserId;
        data["assignedByUser"] = this.assignedByUser;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser;
        data["assignedToUserProfilePictureUrl"] = this.assignedToUserProfilePictureUrl;
        data["assignedTime"] = this.assignedTime;
        data["completedOn"] = this.completedOn;
        data["projectName"] = this.projectName;
        data["progressCompleted"] = this.progressCompleted;
        data["projectId"] = this.projectId;
        data["isPrivateProject"] = this.isPrivateProject;
        data["taskProjectName"] = this.taskProjectName;
        data["projectSectionId"] = this.projectSectionId;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["isPrivate"] = this.isPrivate;
        data["priority"] = this.priority;
        data["tags"] = this.tags;
        if (Array.isArray(this.projectTags)) {
            data["projectTags"] = [];
            for (let item of this.projectTags)
                data["projectTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["statusCode"] = this.statusCode;
        data["isAddedOnMyDay"] = this.isAddedOnMyDay;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["entityType"] = this.entityType;
        data["taskType"] = this.taskType;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactCompanyId"] = this.contactCompanyId;
        data["contactCompanyName"] = this.contactCompanyName;
        if (Array.isArray(this.contributors)) {
            data["contributors"] = [];
            for (let item of this.contributors)
                data["contributors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContactTaskListDto {
    id: number | undefined;
    ownerId: number | undefined;
    title: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    code: number | undefined;
    name: string | undefined;
    sortOrder: number | undefined;
    isSeen: boolean | undefined;
    isNewlyAssigned: boolean | undefined;
    assignedByUserId: number | undefined;
    assignedByUser: string | undefined;
    assignedToUserId: number | undefined;
    assignedToUser: string | undefined;
    assignedToUserProfilePictureUrl: string | undefined;
    assignedTime: string | undefined;
    completedOn: string | undefined;
    projectName: string | undefined;
    progressCompleted: number | undefined;
    projectId: number | undefined;
    isPrivateProject: boolean | undefined;
    taskProjectName: string | undefined;
    projectSectionId: number | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    isPrivate: boolean | undefined;
    priority: TaskPriority | undefined;
    tags: string | undefined;
    projectTags: ProjectTag[] | undefined;
    statusCode: number | undefined;
    isAddedOnMyDay: boolean | undefined;
    isDueDatePassed: boolean | undefined;
    entityType: TaskEntityType | undefined;
    taskType: TaskTypes | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactCompanyId: number | undefined;
    contactCompanyName: string | undefined;
    contributors: TaskContributorDto[] | undefined;
}

export class ContactTaskListDtoListIHandleError implements IContactTaskListDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ContactTaskListDto[] | undefined;
    listOfEntities!: ContactTaskListDto[][] | undefined;

    constructor(data?: IContactTaskListDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ContactTaskListDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ContactTaskListDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactTaskListDtoListIHandleError>(data, _mappings, ContactTaskListDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IContactTaskListDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ContactTaskListDto[] | undefined;
    listOfEntities: ContactTaskListDto[][] | undefined;
}

export class CreateUpdateContactNotesDto implements ICreateUpdateContactNotesDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    id!: number | undefined;
    contactId!: number | undefined;
    notes!: string | undefined;

    constructor(data?: ICreateUpdateContactNotesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateUpdateContactNotesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateUpdateContactNotesDto>(data, _mappings, CreateUpdateContactNotesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateUpdateContactNotesDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    id: number | undefined;
    contactId: number | undefined;
    notes: string | undefined;
}

export class Int32IHandleError implements IInt32IHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: number | undefined;
    listOfEntities!: number[] | undefined;

    constructor(data?: IInt32IHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"];
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32IHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32IHandleError>(data, _mappings, Int32IHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IInt32IHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: number | undefined;
    listOfEntities: number[] | undefined;
}

export class ContactNote implements IContactNote {
    id!: number | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    notes!: string | undefined;
    pinnedEntityId!: number | undefined;
    sortOrder!: number | undefined;
    companyId!: number | undefined;
    companyName!: string | undefined;
    creationTime!: string | undefined;
    createdBy!: string | undefined;
    createdByProfileUrl!: string | undefined;
    createdByStatusCode!: number | undefined;
    colorClassName!: string | undefined;
    readonly createdTimeAgo!: string | undefined;
    readonly title!: string | undefined;
    readonly taskTitle!: string | undefined;

    constructor(data?: IContactNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.notes = _data["notes"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.sortOrder = _data["sortOrder"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.creationTime = _data["creationTime"];
            this.createdBy = _data["createdBy"];
            this.createdByProfileUrl = _data["createdByProfileUrl"];
            this.createdByStatusCode = _data["createdByStatusCode"];
            this.colorClassName = _data["colorClassName"];
            (this as any).createdTimeAgo = _data["createdTimeAgo"];
            (this as any).title = _data["title"];
            (this as any).taskTitle = _data["taskTitle"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactNote | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactNote>(data, _mappings, ContactNote);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["notes"] = this.notes;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["sortOrder"] = this.sortOrder;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["creationTime"] = this.creationTime;
        data["createdBy"] = this.createdBy;
        data["createdByProfileUrl"] = this.createdByProfileUrl;
        data["createdByStatusCode"] = this.createdByStatusCode;
        data["colorClassName"] = this.colorClassName;
        data["createdTimeAgo"] = this.createdTimeAgo;
        data["title"] = this.title;
        data["taskTitle"] = this.taskTitle;
        return data;
    }
}

export interface IContactNote {
    id: number | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    notes: string | undefined;
    pinnedEntityId: number | undefined;
    sortOrder: number | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    creationTime: string | undefined;
    createdBy: string | undefined;
    createdByProfileUrl: string | undefined;
    createdByStatusCode: number | undefined;
    colorClassName: string | undefined;
    createdTimeAgo: string | undefined;
    title: string | undefined;
    taskTitle: string | undefined;
}

export class ContactNoteListIHandleError implements IContactNoteListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ContactNote[] | undefined;
    listOfEntities!: ContactNote[][] | undefined;

    constructor(data?: IContactNoteListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ContactNote.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ContactNoteListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactNoteListIHandleError>(data, _mappings, ContactNoteListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IContactNoteListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ContactNote[] | undefined;
    listOfEntities: ContactNote[][] | undefined;
}

export class CreateUpdateContactTagsDto implements ICreateUpdateContactTagsDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    contactId!: number | undefined;
    tagId!: number | undefined;
    tagName!: string | undefined;

    constructor(data?: ICreateUpdateContactTagsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.contactId = _data["contactId"];
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateUpdateContactTagsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateUpdateContactTagsDto>(data, _mappings, CreateUpdateContactTagsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["contactId"] = this.contactId;
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        return data;
    }
}

export interface ICreateUpdateContactTagsDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    contactId: number | undefined;
    tagId: number | undefined;
    tagName: string | undefined;
}

export class ContactTagListDto implements IContactTagListDto {
    id!: number | undefined;
    tagId!: number | undefined;
    tagName!: string | undefined;

    constructor(data?: IContactTagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactTagListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactTagListDto>(data, _mappings, ContactTagListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        return data;
    }
}

export interface IContactTagListDto {
    id: number | undefined;
    tagId: number | undefined;
    tagName: string | undefined;
}

export class ContactTagListDtoListIHandleError implements IContactTagListDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ContactTagListDto[] | undefined;
    listOfEntities!: ContactTagListDto[][] | undefined;

    constructor(data?: IContactTagListDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ContactTagListDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ContactTagListDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactTagListDtoListIHandleError>(data, _mappings, ContactTagListDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IContactTagListDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ContactTagListDto[] | undefined;
    listOfEntities: ContactTagListDto[][] | undefined;
}

export enum TagType {
    _1 = 1,
    _2 = 2,
}

export class TagListDtoListIHandleError implements ITagListDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TagListDto[] | undefined;
    listOfEntities!: TagListDto[][] | undefined;

    constructor(data?: ITagListDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TagListDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TagListDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TagListDtoListIHandleError>(data, _mappings, TagListDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITagListDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TagListDto[] | undefined;
    listOfEntities: TagListDto[][] | undefined;
}

export class ClientStageDto implements IClientStageDto {
    id!: number | undefined;
    stage!: string | undefined;
    act!: ClientStageAct | undefined;
    bgColor!: string | undefined;
    isActive!: boolean | undefined;
    sortOrder!: number | undefined;
    suggestFollowUpDays!: number | undefined;
    nextStep!: string | undefined;
    nextStepNotes!: string | undefined;
    noFollowUp!: boolean | undefined;

    constructor(data?: IClientStageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stage = _data["stage"];
            this.act = _data["act"];
            this.bgColor = _data["bgColor"];
            this.isActive = _data["isActive"];
            this.sortOrder = _data["sortOrder"];
            this.suggestFollowUpDays = _data["suggestFollowUpDays"];
            this.nextStep = _data["nextStep"];
            this.nextStepNotes = _data["nextStepNotes"];
            this.noFollowUp = _data["noFollowUp"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientStageDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientStageDto>(data, _mappings, ClientStageDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stage"] = this.stage;
        data["act"] = this.act;
        data["bgColor"] = this.bgColor;
        data["isActive"] = this.isActive;
        data["sortOrder"] = this.sortOrder;
        data["suggestFollowUpDays"] = this.suggestFollowUpDays;
        data["nextStep"] = this.nextStep;
        data["nextStepNotes"] = this.nextStepNotes;
        data["noFollowUp"] = this.noFollowUp;
        return data;
    }
}

export interface IClientStageDto {
    id: number | undefined;
    stage: string | undefined;
    act: ClientStageAct | undefined;
    bgColor: string | undefined;
    isActive: boolean | undefined;
    sortOrder: number | undefined;
    suggestFollowUpDays: number | undefined;
    nextStep: string | undefined;
    nextStepNotes: string | undefined;
    noFollowUp: boolean | undefined;
}

export class ClientStageDtoListIHandleError implements IClientStageDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ClientStageDto[] | undefined;
    listOfEntities!: ClientStageDto[][] | undefined;

    constructor(data?: IClientStageDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ClientStageDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ClientStageDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientStageDtoListIHandleError>(data, _mappings, ClientStageDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IClientStageDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ClientStageDto[] | undefined;
    listOfEntities: ClientStageDto[][] | undefined;
}

export class ClientSourceDto implements IClientSourceDto {
    id!: number | undefined;
    source!: string | undefined;
    sortOrder!: number | undefined;

    constructor(data?: IClientSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.source = _data["source"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientSourceDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientSourceDto>(data, _mappings, ClientSourceDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["source"] = this.source;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IClientSourceDto {
    id: number | undefined;
    source: string | undefined;
    sortOrder: number | undefined;
}

export class ClientSourceDtoListIHandleError implements IClientSourceDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ClientSourceDto[] | undefined;
    listOfEntities!: ClientSourceDto[][] | undefined;

    constructor(data?: IClientSourceDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ClientSourceDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ClientSourceDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientSourceDtoListIHandleError>(data, _mappings, ClientSourceDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IClientSourceDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ClientSourceDto[] | undefined;
    listOfEntities: ClientSourceDto[][] | undefined;
}

export enum TenantClientDisplay {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ConversationScope {
    _1 = 1,
    _2 = 2,
}

export enum ConversationTab {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum ConversationViewMode {
    _1 = 1,
    _2 = 2,
}

export enum ConversationEntryKind {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ConversationReason {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
}

export enum ConversationClientKind {
    _1 = 1,
    _2 = 2,
}

export class ConversationClientRefDto implements IConversationClientRefDto {
    kind!: ConversationClientKind | undefined;
    id!: string | undefined;

    constructor(data?: IConversationClientRefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationClientRefDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationClientRefDto>(data, _mappings, ConversationClientRefDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["id"] = this.id;
        return data;
    }
}

export interface IConversationClientRefDto {
    kind: ConversationClientKind | undefined;
    id: string | undefined;
}

export enum ConversationTimeRange {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ConversationFeedCursorDto implements IConversationFeedCursorDto {
    entryTimeUtc!: string | undefined;
    entryKind!: ConversationEntryKind | undefined;
    entryId!: number | undefined;

    constructor(data?: IConversationFeedCursorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.entryTimeUtc = _data["entryTimeUtc"];
            this.entryKind = _data["entryKind"];
            this.entryId = _data["entryId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationFeedCursorDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationFeedCursorDto>(data, _mappings, ConversationFeedCursorDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entryTimeUtc"] = this.entryTimeUtc;
        data["entryKind"] = this.entryKind;
        data["entryId"] = this.entryId;
        return data;
    }
}

export interface IConversationFeedCursorDto {
    entryTimeUtc: string | undefined;
    entryKind: ConversationEntryKind | undefined;
    entryId: number | undefined;
}

export class ConversationEntryRefDto implements IConversationEntryRefDto {
    kind!: ConversationEntryKind | undefined;
    entryId!: number | undefined;

    constructor(data?: IConversationEntryRefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.entryId = _data["entryId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationEntryRefDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationEntryRefDto>(data, _mappings, ConversationEntryRefDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["entryId"] = this.entryId;
        return data;
    }
}

export interface IConversationEntryRefDto {
    kind: ConversationEntryKind | undefined;
    entryId: number | undefined;
}

export class GetConversationFeedInput implements IGetConversationFeedInput {
    scope!: ConversationScope | undefined;
    projectId!: number | undefined;
    tab!: ConversationTab | undefined;
    viewMode!: ConversationViewMode | undefined;
    taskId!: number | undefined;
    searchText!: string | undefined;
    kinds!: ConversationEntryKind[] | undefined;
    reasons!: ConversationReason[] | undefined;
    projectIds!: number[] | undefined;
    clients!: ConversationClientRefDto[] | undefined;
    timeRange!: ConversationTimeRange | undefined;
    fromDate!: string | undefined;
    toDate!: string | undefined;
    pageSize!: number | undefined;
    cursor!: ConversationFeedCursorDto | undefined;
    entryRefs!: ConversationEntryRefDto[] | undefined;

    constructor(data?: IGetConversationFeedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.scope = _data["scope"];
            this.projectId = _data["projectId"];
            this.tab = _data["tab"];
            this.viewMode = _data["viewMode"];
            this.taskId = _data["taskId"];
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["kinds"])) {
                this.kinds = [] as any;
                for (let item of _data["kinds"])
                    this.kinds!.push(item);
            }
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(item);
            }
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(ConversationClientRefDto.fromJS(item, _mappings));
            }
            this.timeRange = _data["timeRange"];
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.pageSize = _data["pageSize"];
            this.cursor = _data["cursor"] ? ConversationFeedCursorDto.fromJS(_data["cursor"], _mappings) : undefined as any;
            if (Array.isArray(_data["entryRefs"])) {
                this.entryRefs = [] as any;
                for (let item of _data["entryRefs"])
                    this.entryRefs!.push(ConversationEntryRefDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetConversationFeedInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetConversationFeedInput>(data, _mappings, GetConversationFeedInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope;
        data["projectId"] = this.projectId;
        data["tab"] = this.tab;
        data["viewMode"] = this.viewMode;
        data["taskId"] = this.taskId;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.kinds)) {
            data["kinds"] = [];
            for (let item of this.kinds)
                data["kinds"].push(item);
        }
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item);
        }
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item ? item.toJSON() : undefined as any);
        }
        data["timeRange"] = this.timeRange;
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["pageSize"] = this.pageSize;
        data["cursor"] = this.cursor ? this.cursor.toJSON() : undefined as any;
        if (Array.isArray(this.entryRefs)) {
            data["entryRefs"] = [];
            for (let item of this.entryRefs)
                data["entryRefs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetConversationFeedInput {
    scope: ConversationScope | undefined;
    projectId: number | undefined;
    tab: ConversationTab | undefined;
    viewMode: ConversationViewMode | undefined;
    taskId: number | undefined;
    searchText: string | undefined;
    kinds: ConversationEntryKind[] | undefined;
    reasons: ConversationReason[] | undefined;
    projectIds: number[] | undefined;
    clients: ConversationClientRefDto[] | undefined;
    timeRange: ConversationTimeRange | undefined;
    fromDate: string | undefined;
    toDate: string | undefined;
    pageSize: number | undefined;
    cursor: ConversationFeedCursorDto | undefined;
    entryRefs: ConversationEntryRefDto[] | undefined;
}

export class ConversationAttachmentDto implements IConversationAttachmentDto {
    id!: number | undefined;
    fileName!: string | undefined;
    webLink!: string | undefined;
    filePath!: string | undefined;
    fileType!: string | undefined;
    keyId!: string | undefined;
    msDriveId!: string | undefined;
    msSiteId!: string | undefined;
    isLink!: boolean | undefined;

    constructor(data?: IConversationAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.webLink = _data["webLink"];
            this.filePath = _data["filePath"];
            this.fileType = _data["fileType"];
            this.keyId = _data["keyId"];
            this.msDriveId = _data["msDriveId"];
            this.msSiteId = _data["msSiteId"];
            this.isLink = _data["isLink"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationAttachmentDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationAttachmentDto>(data, _mappings, ConversationAttachmentDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["webLink"] = this.webLink;
        data["filePath"] = this.filePath;
        data["fileType"] = this.fileType;
        data["keyId"] = this.keyId;
        data["msDriveId"] = this.msDriveId;
        data["msSiteId"] = this.msSiteId;
        data["isLink"] = this.isLink;
        return data;
    }
}

export interface IConversationAttachmentDto {
    id: number | undefined;
    fileName: string | undefined;
    webLink: string | undefined;
    filePath: string | undefined;
    fileType: string | undefined;
    keyId: string | undefined;
    msDriveId: string | undefined;
    msSiteId: string | undefined;
    isLink: boolean | undefined;
}

export class EmailPartyDto implements IEmailPartyDto {
    name!: string | undefined;
    address!: string | undefined;

    constructor(data?: IEmailPartyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any, _mappings?: any): EmailPartyDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmailPartyDto>(data, _mappings, EmailPartyDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        return data;
    }
}

export interface IEmailPartyDto {
    name: string | undefined;
    address: string | undefined;
}

export class ConversationMessageDto implements IConversationMessageDto {
    messageId!: number | undefined;
    parentId!: number | undefined;
    authorUserId!: number | undefined;
    authorName!: string | undefined;
    authorInitials!: string | undefined;
    authorPictureUrl!: string | undefined;
    creationTimeUtc!: string | undefined;
    editedAtUtc!: string | undefined;
    bodyHtml!: string | undefined;
    isUnreadForMe!: boolean | undefined;
    canDelete!: boolean | undefined;
    attachments!: ConversationAttachmentDto[] | undefined;
    isSent!: boolean | undefined;
    isFirm!: boolean | undefined;
    fromAddress!: string | undefined;
    subject!: string | undefined;
    preview!: string | undefined;
    hasAttachments!: boolean | undefined;
    toRecipients!: EmailPartyDto[] | undefined;
    ccRecipients!: EmailPartyDto[] | undefined;
    graphMessageId!: string | undefined;
    replyKind!: string | undefined;
    messageKey!: string | undefined;

    constructor(data?: IConversationMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.parentId = _data["parentId"];
            this.authorUserId = _data["authorUserId"];
            this.authorName = _data["authorName"];
            this.authorInitials = _data["authorInitials"];
            this.authorPictureUrl = _data["authorPictureUrl"];
            this.creationTimeUtc = _data["creationTimeUtc"];
            this.editedAtUtc = _data["editedAtUtc"];
            this.bodyHtml = _data["bodyHtml"];
            this.isUnreadForMe = _data["isUnreadForMe"];
            this.canDelete = _data["canDelete"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(ConversationAttachmentDto.fromJS(item, _mappings));
            }
            this.isSent = _data["isSent"];
            this.isFirm = _data["isFirm"];
            this.fromAddress = _data["fromAddress"];
            this.subject = _data["subject"];
            this.preview = _data["preview"];
            this.hasAttachments = _data["hasAttachments"];
            if (Array.isArray(_data["toRecipients"])) {
                this.toRecipients = [] as any;
                for (let item of _data["toRecipients"])
                    this.toRecipients!.push(EmailPartyDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["ccRecipients"])) {
                this.ccRecipients = [] as any;
                for (let item of _data["ccRecipients"])
                    this.ccRecipients!.push(EmailPartyDto.fromJS(item, _mappings));
            }
            this.graphMessageId = _data["graphMessageId"];
            this.replyKind = _data["replyKind"];
            this.messageKey = _data["messageKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationMessageDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationMessageDto>(data, _mappings, ConversationMessageDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["parentId"] = this.parentId;
        data["authorUserId"] = this.authorUserId;
        data["authorName"] = this.authorName;
        data["authorInitials"] = this.authorInitials;
        data["authorPictureUrl"] = this.authorPictureUrl;
        data["creationTimeUtc"] = this.creationTimeUtc;
        data["editedAtUtc"] = this.editedAtUtc;
        data["bodyHtml"] = this.bodyHtml;
        data["isUnreadForMe"] = this.isUnreadForMe;
        data["canDelete"] = this.canDelete;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSent"] = this.isSent;
        data["isFirm"] = this.isFirm;
        data["fromAddress"] = this.fromAddress;
        data["subject"] = this.subject;
        data["preview"] = this.preview;
        data["hasAttachments"] = this.hasAttachments;
        if (Array.isArray(this.toRecipients)) {
            data["toRecipients"] = [];
            for (let item of this.toRecipients)
                data["toRecipients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ccRecipients)) {
            data["ccRecipients"] = [];
            for (let item of this.ccRecipients)
                data["ccRecipients"].push(item ? item.toJSON() : undefined as any);
        }
        data["graphMessageId"] = this.graphMessageId;
        data["replyKind"] = this.replyKind;
        data["messageKey"] = this.messageKey;
        return data;
    }
}

export interface IConversationMessageDto {
    messageId: number | undefined;
    parentId: number | undefined;
    authorUserId: number | undefined;
    authorName: string | undefined;
    authorInitials: string | undefined;
    authorPictureUrl: string | undefined;
    creationTimeUtc: string | undefined;
    editedAtUtc: string | undefined;
    bodyHtml: string | undefined;
    isUnreadForMe: boolean | undefined;
    canDelete: boolean | undefined;
    attachments: ConversationAttachmentDto[] | undefined;
    isSent: boolean | undefined;
    isFirm: boolean | undefined;
    fromAddress: string | undefined;
    subject: string | undefined;
    preview: string | undefined;
    hasAttachments: boolean | undefined;
    toRecipients: EmailPartyDto[] | undefined;
    ccRecipients: EmailPartyDto[] | undefined;
    graphMessageId: string | undefined;
    replyKind: string | undefined;
    messageKey: string | undefined;
}

export class ConversationEntryDto implements IConversationEntryDto {
    kind!: ConversationEntryKind | undefined;
    entryId!: number | undefined;
    key!: string | undefined;
    taskId!: number | undefined;
    taskTitle!: string | undefined;
    isTaskCompleted!: boolean | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    canOpenProject!: boolean | undefined;
    clientKind!: ConversationClientKind | undefined;
    clientId!: string | undefined;
    clientName!: string | undefined;
    rootAuthorUserId!: number | undefined;
    rootAuthorName!: string | undefined;
    isOwn!: boolean | undefined;
    isNoteComment!: boolean | undefined;
    anchorQuote!: string | undefined;
    isResolved!: boolean | undefined;
    resolvedAtUtc!: string | undefined;
    resolvedByUserId!: number | undefined;
    resolvedByName!: string | undefined;
    entryTimeUtc!: string | undefined;
    messageCount!: number | undefined;
    lastMessageId!: number | undefined;
    reasonMask!: number | undefined;
    topReason!: ConversationReason | undefined;
    reasonLabel!: string | undefined;
    isDirect!: boolean | undefined;
    isUnread!: boolean | undefined;
    canMarkRead!: boolean | undefined;
    canMarkUnread!: boolean | undefined;
    canReply!: boolean | undefined;
    canResolve!: boolean | undefined;
    canReopen!: boolean | undefined;
    canDelete!: boolean | undefined;
    groupKey!: number | undefined;
    messages!: ConversationMessageDto[] | undefined;
    threadKey!: string | undefined;
    threadSubject!: string | undefined;
    replyAnchorMessageId!: string | undefined;

    constructor(data?: IConversationEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.entryId = _data["entryId"];
            this.key = _data["key"];
            this.taskId = _data["taskId"];
            this.taskTitle = _data["taskTitle"];
            this.isTaskCompleted = _data["isTaskCompleted"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.canOpenProject = _data["canOpenProject"];
            this.clientKind = _data["clientKind"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.rootAuthorUserId = _data["rootAuthorUserId"];
            this.rootAuthorName = _data["rootAuthorName"];
            this.isOwn = _data["isOwn"];
            this.isNoteComment = _data["isNoteComment"];
            this.anchorQuote = _data["anchorQuote"];
            this.isResolved = _data["isResolved"];
            this.resolvedAtUtc = _data["resolvedAtUtc"];
            this.resolvedByUserId = _data["resolvedByUserId"];
            this.resolvedByName = _data["resolvedByName"];
            this.entryTimeUtc = _data["entryTimeUtc"];
            this.messageCount = _data["messageCount"];
            this.lastMessageId = _data["lastMessageId"];
            this.reasonMask = _data["reasonMask"];
            this.topReason = _data["topReason"];
            this.reasonLabel = _data["reasonLabel"];
            this.isDirect = _data["isDirect"];
            this.isUnread = _data["isUnread"];
            this.canMarkRead = _data["canMarkRead"];
            this.canMarkUnread = _data["canMarkUnread"];
            this.canReply = _data["canReply"];
            this.canResolve = _data["canResolve"];
            this.canReopen = _data["canReopen"];
            this.canDelete = _data["canDelete"];
            this.groupKey = _data["groupKey"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ConversationMessageDto.fromJS(item, _mappings));
            }
            this.threadKey = _data["threadKey"];
            this.threadSubject = _data["threadSubject"];
            this.replyAnchorMessageId = _data["replyAnchorMessageId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationEntryDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationEntryDto>(data, _mappings, ConversationEntryDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["entryId"] = this.entryId;
        data["key"] = this.key;
        data["taskId"] = this.taskId;
        data["taskTitle"] = this.taskTitle;
        data["isTaskCompleted"] = this.isTaskCompleted;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["canOpenProject"] = this.canOpenProject;
        data["clientKind"] = this.clientKind;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["rootAuthorUserId"] = this.rootAuthorUserId;
        data["rootAuthorName"] = this.rootAuthorName;
        data["isOwn"] = this.isOwn;
        data["isNoteComment"] = this.isNoteComment;
        data["anchorQuote"] = this.anchorQuote;
        data["isResolved"] = this.isResolved;
        data["resolvedAtUtc"] = this.resolvedAtUtc;
        data["resolvedByUserId"] = this.resolvedByUserId;
        data["resolvedByName"] = this.resolvedByName;
        data["entryTimeUtc"] = this.entryTimeUtc;
        data["messageCount"] = this.messageCount;
        data["lastMessageId"] = this.lastMessageId;
        data["reasonMask"] = this.reasonMask;
        data["topReason"] = this.topReason;
        data["reasonLabel"] = this.reasonLabel;
        data["isDirect"] = this.isDirect;
        data["isUnread"] = this.isUnread;
        data["canMarkRead"] = this.canMarkRead;
        data["canMarkUnread"] = this.canMarkUnread;
        data["canReply"] = this.canReply;
        data["canResolve"] = this.canResolve;
        data["canReopen"] = this.canReopen;
        data["canDelete"] = this.canDelete;
        data["groupKey"] = this.groupKey;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        data["threadKey"] = this.threadKey;
        data["threadSubject"] = this.threadSubject;
        data["replyAnchorMessageId"] = this.replyAnchorMessageId;
        return data;
    }
}

export interface IConversationEntryDto {
    kind: ConversationEntryKind | undefined;
    entryId: number | undefined;
    key: string | undefined;
    taskId: number | undefined;
    taskTitle: string | undefined;
    isTaskCompleted: boolean | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    canOpenProject: boolean | undefined;
    clientKind: ConversationClientKind | undefined;
    clientId: string | undefined;
    clientName: string | undefined;
    rootAuthorUserId: number | undefined;
    rootAuthorName: string | undefined;
    isOwn: boolean | undefined;
    isNoteComment: boolean | undefined;
    anchorQuote: string | undefined;
    isResolved: boolean | undefined;
    resolvedAtUtc: string | undefined;
    resolvedByUserId: number | undefined;
    resolvedByName: string | undefined;
    entryTimeUtc: string | undefined;
    messageCount: number | undefined;
    lastMessageId: number | undefined;
    reasonMask: number | undefined;
    topReason: ConversationReason | undefined;
    reasonLabel: string | undefined;
    isDirect: boolean | undefined;
    isUnread: boolean | undefined;
    canMarkRead: boolean | undefined;
    canMarkUnread: boolean | undefined;
    canReply: boolean | undefined;
    canResolve: boolean | undefined;
    canReopen: boolean | undefined;
    canDelete: boolean | undefined;
    groupKey: number | undefined;
    messages: ConversationMessageDto[] | undefined;
    threadKey: string | undefined;
    threadSubject: string | undefined;
    replyAnchorMessageId: string | undefined;
}

export class ConversationTabCountsDto implements IConversationTabCountsDto {
    attentionCount!: number | undefined;
    allCount!: number | undefined;
    commentCount!: number | undefined;
    emailCount!: number | undefined;
    projectCommentCount!: number | undefined;
    navBadgeCount!: number | undefined;

    constructor(data?: IConversationTabCountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.attentionCount = _data["attentionCount"];
            this.allCount = _data["allCount"];
            this.commentCount = _data["commentCount"];
            this.emailCount = _data["emailCount"];
            this.projectCommentCount = _data["projectCommentCount"];
            this.navBadgeCount = _data["navBadgeCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationTabCountsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationTabCountsDto>(data, _mappings, ConversationTabCountsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attentionCount"] = this.attentionCount;
        data["allCount"] = this.allCount;
        data["commentCount"] = this.commentCount;
        data["emailCount"] = this.emailCount;
        data["projectCommentCount"] = this.projectCommentCount;
        data["navBadgeCount"] = this.navBadgeCount;
        return data;
    }
}

export interface IConversationTabCountsDto {
    attentionCount: number | undefined;
    allCount: number | undefined;
    commentCount: number | undefined;
    emailCount: number | undefined;
    projectCommentCount: number | undefined;
    navBadgeCount: number | undefined;
}

export class ConversationTaskOptionDto implements IConversationTaskOptionDto {
    taskId!: number | undefined;
    taskTitle!: string | undefined;
    isTaskCompleted!: boolean | undefined;
    entryCount!: number | undefined;

    constructor(data?: IConversationTaskOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskTitle = _data["taskTitle"];
            this.isTaskCompleted = _data["isTaskCompleted"];
            this.entryCount = _data["entryCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationTaskOptionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationTaskOptionDto>(data, _mappings, ConversationTaskOptionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskTitle"] = this.taskTitle;
        data["isTaskCompleted"] = this.isTaskCompleted;
        data["entryCount"] = this.entryCount;
        return data;
    }
}

export interface IConversationTaskOptionDto {
    taskId: number | undefined;
    taskTitle: string | undefined;
    isTaskCompleted: boolean | undefined;
    entryCount: number | undefined;
}

export class ConversationFeedDto implements IConversationFeedDto {
    entries!: ConversationEntryDto[] | undefined;
    counts!: ConversationTabCountsDto | undefined;
    tasks!: ConversationTaskOptionDto[] | undefined;
    nextCursor!: ConversationFeedCursorDto | undefined;
    isTruncated!: boolean | undefined;
    projectAccessible!: boolean | undefined;
    asOfUtc!: string | undefined;

    constructor(data?: IConversationFeedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(ConversationEntryDto.fromJS(item, _mappings));
            }
            this.counts = _data["counts"] ? ConversationTabCountsDto.fromJS(_data["counts"], _mappings) : undefined as any;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ConversationTaskOptionDto.fromJS(item, _mappings));
            }
            this.nextCursor = _data["nextCursor"] ? ConversationFeedCursorDto.fromJS(_data["nextCursor"], _mappings) : undefined as any;
            this.isTruncated = _data["isTruncated"];
            this.projectAccessible = _data["projectAccessible"];
            this.asOfUtc = _data["asOfUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationFeedDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationFeedDto>(data, _mappings, ConversationFeedDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : undefined as any);
        }
        data["counts"] = this.counts ? this.counts.toJSON() : undefined as any;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextCursor"] = this.nextCursor ? this.nextCursor.toJSON() : undefined as any;
        data["isTruncated"] = this.isTruncated;
        data["projectAccessible"] = this.projectAccessible;
        data["asOfUtc"] = this.asOfUtc;
        return data;
    }
}

export interface IConversationFeedDto {
    entries: ConversationEntryDto[] | undefined;
    counts: ConversationTabCountsDto | undefined;
    tasks: ConversationTaskOptionDto[] | undefined;
    nextCursor: ConversationFeedCursorDto | undefined;
    isTruncated: boolean | undefined;
    projectAccessible: boolean | undefined;
    asOfUtc: string | undefined;
}

export class GetConversationCountsInput implements IGetConversationCountsInput {
    includeBadge!: boolean | undefined;
    projectIds!: number[] | undefined;

    constructor(data?: IGetConversationCountsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.includeBadge = _data["includeBadge"];
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetConversationCountsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetConversationCountsInput>(data, _mappings, GetConversationCountsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeBadge"] = this.includeBadge;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface IGetConversationCountsInput {
    includeBadge: boolean | undefined;
    projectIds: number[] | undefined;
}

export class ProjectConversationCountDto implements IProjectConversationCountDto {
    projectId!: number | undefined;
    entryCount!: number | undefined;
    unreadCount!: number | undefined;

    constructor(data?: IProjectConversationCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.entryCount = _data["entryCount"];
            this.unreadCount = _data["unreadCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectConversationCountDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectConversationCountDto>(data, _mappings, ProjectConversationCountDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["entryCount"] = this.entryCount;
        data["unreadCount"] = this.unreadCount;
        return data;
    }
}

export interface IProjectConversationCountDto {
    projectId: number | undefined;
    entryCount: number | undefined;
    unreadCount: number | undefined;
}

export class ConversationCountsDto implements IConversationCountsDto {
    navBadgeCount!: number | undefined;
    projects!: ProjectConversationCountDto[] | undefined;
    asOfUtc!: string | undefined;

    constructor(data?: IConversationCountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.navBadgeCount = _data["navBadgeCount"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectConversationCountDto.fromJS(item, _mappings));
            }
            this.asOfUtc = _data["asOfUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationCountsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationCountsDto>(data, _mappings, ConversationCountsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["navBadgeCount"] = this.navBadgeCount;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        data["asOfUtc"] = this.asOfUtc;
        return data;
    }
}

export interface IConversationCountsDto {
    navBadgeCount: number | undefined;
    projects: ProjectConversationCountDto[] | undefined;
    asOfUtc: string | undefined;
}

export enum ConversationReadAction {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class ConversationReadItemDto implements IConversationReadItemDto {
    kind!: ConversationEntryKind | undefined;
    entryId!: number | undefined;
    throughMessageId!: number | undefined;

    constructor(data?: IConversationReadItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.entryId = _data["entryId"];
            this.throughMessageId = _data["throughMessageId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationReadItemDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationReadItemDto>(data, _mappings, ConversationReadItemDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["entryId"] = this.entryId;
        data["throughMessageId"] = this.throughMessageId;
        return data;
    }
}

export interface IConversationReadItemDto {
    kind: ConversationEntryKind | undefined;
    entryId: number | undefined;
    throughMessageId: number | undefined;
}

export class SetConversationReadStateInput implements ISetConversationReadStateInput {
    action!: ConversationReadAction | undefined;
    entries!: ConversationReadItemDto[] | undefined;
    asOfUtc!: string | undefined;

    constructor(data?: ISetConversationReadStateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.action = _data["action"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(ConversationReadItemDto.fromJS(item, _mappings));
            }
            this.asOfUtc = _data["asOfUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetConversationReadStateInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetConversationReadStateInput>(data, _mappings, SetConversationReadStateInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : undefined as any);
        }
        data["asOfUtc"] = this.asOfUtc;
        return data;
    }
}

export interface ISetConversationReadStateInput {
    action: ConversationReadAction | undefined;
    entries: ConversationReadItemDto[] | undefined;
    asOfUtc: string | undefined;
}

export class ConversationReadStateResultDto implements IConversationReadStateResultDto {
    actionId!: number | undefined;
    affectedCount!: number | undefined;
    undone!: boolean | undefined;
    navBadgeCount!: number | undefined;
    projects!: ProjectConversationCountDto[] | undefined;

    constructor(data?: IConversationReadStateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.actionId = _data["actionId"];
            this.affectedCount = _data["affectedCount"];
            this.undone = _data["undone"];
            this.navBadgeCount = _data["navBadgeCount"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectConversationCountDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationReadStateResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationReadStateResultDto>(data, _mappings, ConversationReadStateResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionId"] = this.actionId;
        data["affectedCount"] = this.affectedCount;
        data["undone"] = this.undone;
        data["navBadgeCount"] = this.navBadgeCount;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConversationReadStateResultDto {
    actionId: number | undefined;
    affectedCount: number | undefined;
    undone: boolean | undefined;
    navBadgeCount: number | undefined;
    projects: ProjectConversationCountDto[] | undefined;
}

export class AutoReadAmbientInput implements IAutoReadAmbientInput {
    asOfUtc!: string | undefined;

    constructor(data?: IAutoReadAmbientInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.asOfUtc = _data["asOfUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): AutoReadAmbientInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AutoReadAmbientInput>(data, _mappings, AutoReadAmbientInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asOfUtc"] = this.asOfUtc;
        return data;
    }
}

export interface IAutoReadAmbientInput {
    asOfUtc: string | undefined;
}

export class UndoConversationReadStateInput implements IUndoConversationReadStateInput {
    actionId!: number | undefined;

    constructor(data?: IUndoConversationReadStateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.actionId = _data["actionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UndoConversationReadStateInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UndoConversationReadStateInput>(data, _mappings, UndoConversationReadStateInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionId"] = this.actionId;
        return data;
    }
}

export interface IUndoConversationReadStateInput {
    actionId: number | undefined;
}

export class GetConversationScopeProjectsInput implements IGetConversationScopeProjectsInput {
    searchText!: string | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetConversationScopeProjectsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetConversationScopeProjectsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetConversationScopeProjectsInput>(data, _mappings, GetConversationScopeProjectsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetConversationScopeProjectsInput {
    searchText: string | undefined;
    maxResultCount: number | undefined;
}

export class ConversationScopeProjectDto implements IConversationScopeProjectDto {
    projectId!: number | undefined;
    projectName!: string | undefined;
    projectNumber!: string | undefined;
    isActive!: boolean | undefined;
    isFavorite!: boolean | undefined;
    clientKind!: ConversationClientKind | undefined;
    clientId!: string | undefined;
    clientName!: string | undefined;
    companyName!: string | undefined;

    constructor(data?: IConversationScopeProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectNumber = _data["projectNumber"];
            this.isActive = _data["isActive"];
            this.isFavorite = _data["isFavorite"];
            this.clientKind = _data["clientKind"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationScopeProjectDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationScopeProjectDto>(data, _mappings, ConversationScopeProjectDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectNumber"] = this.projectNumber;
        data["isActive"] = this.isActive;
        data["isFavorite"] = this.isFavorite;
        data["clientKind"] = this.clientKind;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IConversationScopeProjectDto {
    projectId: number | undefined;
    projectName: string | undefined;
    projectNumber: string | undefined;
    isActive: boolean | undefined;
    isFavorite: boolean | undefined;
    clientKind: ConversationClientKind | undefined;
    clientId: string | undefined;
    clientName: string | undefined;
    companyName: string | undefined;
}

export class ConversationScopeProjectsDto implements IConversationScopeProjectsDto {
    recent!: ConversationScopeProjectDto[] | undefined;
    favorites!: ConversationScopeProjectDto[] | undefined;
    matches!: ConversationScopeProjectDto[] | undefined;
    isSearch!: boolean | undefined;

    constructor(data?: IConversationScopeProjectsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["recent"])) {
                this.recent = [] as any;
                for (let item of _data["recent"])
                    this.recent!.push(ConversationScopeProjectDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["favorites"])) {
                this.favorites = [] as any;
                for (let item of _data["favorites"])
                    this.favorites!.push(ConversationScopeProjectDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(ConversationScopeProjectDto.fromJS(item, _mappings));
            }
            this.isSearch = _data["isSearch"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationScopeProjectsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationScopeProjectsDto>(data, _mappings, ConversationScopeProjectsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recent)) {
            data["recent"] = [];
            for (let item of this.recent)
                data["recent"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.favorites)) {
            data["favorites"] = [];
            for (let item of this.favorites)
                data["favorites"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSearch"] = this.isSearch;
        return data;
    }
}

export interface IConversationScopeProjectsDto {
    recent: ConversationScopeProjectDto[] | undefined;
    favorites: ConversationScopeProjectDto[] | undefined;
    matches: ConversationScopeProjectDto[] | undefined;
    isSearch: boolean | undefined;
}

export class RecordConversationRecentProjectInput implements IRecordConversationRecentProjectInput {
    projectId!: number | undefined;

    constructor(data?: IRecordConversationRecentProjectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecordConversationRecentProjectInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecordConversationRecentProjectInput>(data, _mappings, RecordConversationRecentProjectInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IRecordConversationRecentProjectInput {
    projectId: number | undefined;
}

export class EmbedToken implements IEmbedToken {
    token!: string | undefined;
    tokenId!: string | undefined;
    expiration!: string | undefined;

    constructor(data?: IEmbedToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tokenId = _data["tokenId"];
            this.expiration = _data["expiration"];
        }
    }

    static fromJS(data: any, _mappings?: any): EmbedToken | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmbedToken>(data, _mappings, EmbedToken);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenId"] = this.tokenId;
        data["expiration"] = this.expiration;
        return data;
    }
}

export interface IEmbedToken {
    token: string | undefined;
    tokenId: string | undefined;
    expiration: string | undefined;
}

export class EmbedConfigOutputDto implements IEmbedConfigOutputDto {
    embedToken!: EmbedToken | undefined;
    accessToken!: string | undefined;
    embedUrl!: string | undefined;
    id!: string | undefined;
    errorMessage!: string | undefined;

    constructor(data?: IEmbedConfigOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.embedToken = _data["embedToken"] ? EmbedToken.fromJS(_data["embedToken"], _mappings) : undefined as any;
            this.accessToken = _data["accessToken"];
            this.embedUrl = _data["embedUrl"];
            this.id = _data["id"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any, _mappings?: any): EmbedConfigOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmbedConfigOutputDto>(data, _mappings, EmbedConfigOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["embedToken"] = this.embedToken ? this.embedToken.toJSON() : undefined as any;
        data["accessToken"] = this.accessToken;
        data["embedUrl"] = this.embedUrl;
        data["id"] = this.id;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IEmbedConfigOutputDto {
    embedToken: EmbedToken | undefined;
    accessToken: string | undefined;
    embedUrl: string | undefined;
    id: string | undefined;
    errorMessage: string | undefined;
}

export class DiscoveryEvaluationInput implements IDiscoveryEvaluationInput {
    jobId!: number | undefined;
    sessionId!: number | undefined;
    expectationKey!: string;
    iteration!: number | undefined;
    engineSummaryLine!: string | undefined;

    constructor(data?: IDiscoveryEvaluationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.sessionId = _data["sessionId"];
            this.expectationKey = _data["expectationKey"];
            this.iteration = _data["iteration"];
            this.engineSummaryLine = _data["engineSummaryLine"];
        }
    }

    static fromJS(data: any, _mappings?: any): DiscoveryEvaluationInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DiscoveryEvaluationInput>(data, _mappings, DiscoveryEvaluationInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["sessionId"] = this.sessionId;
        data["expectationKey"] = this.expectationKey;
        data["iteration"] = this.iteration;
        data["engineSummaryLine"] = this.engineSummaryLine;
        return data;
    }
}

export interface IDiscoveryEvaluationInput {
    jobId: number | undefined;
    sessionId: number | undefined;
    expectationKey: string;
    iteration: number | undefined;
    engineSummaryLine: string | undefined;
}

export enum DiscoveryEntryPoint {
    _1 = 1,
    _2 = 2,
}

export enum DiscoveryOutcome {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum DiscoveryEvaluationChapter {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class DiscoveryEvaluationChapterDto implements IDiscoveryEvaluationChapterDto {
    chapter!: DiscoveryEvaluationChapter | undefined;
    expectedItems!: number | undefined;
    matchedItems!: number | undefined;
    scorePercent!: number | undefined;
    evaluated!: boolean | undefined;
    meetsThreshold!: boolean | undefined;

    constructor(data?: IDiscoveryEvaluationChapterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.chapter = _data["chapter"];
            this.expectedItems = _data["expectedItems"];
            this.matchedItems = _data["matchedItems"];
            this.scorePercent = _data["scorePercent"];
            this.evaluated = _data["evaluated"];
            this.meetsThreshold = _data["meetsThreshold"];
        }
    }

    static fromJS(data: any, _mappings?: any): DiscoveryEvaluationChapterDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DiscoveryEvaluationChapterDto>(data, _mappings, DiscoveryEvaluationChapterDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chapter"] = this.chapter;
        data["expectedItems"] = this.expectedItems;
        data["matchedItems"] = this.matchedItems;
        data["scorePercent"] = this.scorePercent;
        data["evaluated"] = this.evaluated;
        data["meetsThreshold"] = this.meetsThreshold;
        return data;
    }
}

export interface IDiscoveryEvaluationChapterDto {
    chapter: DiscoveryEvaluationChapter | undefined;
    expectedItems: number | undefined;
    matchedItems: number | undefined;
    scorePercent: number | undefined;
    evaluated: boolean | undefined;
    meetsThreshold: boolean | undefined;
}

export enum DiscoveryEvaluationSection {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
}

export class DiscoveryEvaluationSectionDto implements IDiscoveryEvaluationSectionDto {
    section!: DiscoveryEvaluationSection | undefined;
    chapter!: DiscoveryEvaluationChapter | undefined;
    evaluated!: boolean | undefined;
    expectedItems!: number | undefined;
    matchedItems!: number | undefined;
    missingItems!: number | undefined;
    extraItems!: number | undefined;
    scorePercent!: number | undefined;
    missingItemIds!: string[] | undefined;

    constructor(data?: IDiscoveryEvaluationSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.section = _data["section"];
            this.chapter = _data["chapter"];
            this.evaluated = _data["evaluated"];
            this.expectedItems = _data["expectedItems"];
            this.matchedItems = _data["matchedItems"];
            this.missingItems = _data["missingItems"];
            this.extraItems = _data["extraItems"];
            this.scorePercent = _data["scorePercent"];
            if (Array.isArray(_data["missingItemIds"])) {
                this.missingItemIds = [] as any;
                for (let item of _data["missingItemIds"])
                    this.missingItemIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DiscoveryEvaluationSectionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DiscoveryEvaluationSectionDto>(data, _mappings, DiscoveryEvaluationSectionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["section"] = this.section;
        data["chapter"] = this.chapter;
        data["evaluated"] = this.evaluated;
        data["expectedItems"] = this.expectedItems;
        data["matchedItems"] = this.matchedItems;
        data["missingItems"] = this.missingItems;
        data["extraItems"] = this.extraItems;
        data["scorePercent"] = this.scorePercent;
        if (Array.isArray(this.missingItemIds)) {
            data["missingItemIds"] = [];
            for (let item of this.missingItemIds)
                data["missingItemIds"].push(item);
        }
        return data;
    }
}

export interface IDiscoveryEvaluationSectionDto {
    section: DiscoveryEvaluationSection | undefined;
    chapter: DiscoveryEvaluationChapter | undefined;
    evaluated: boolean | undefined;
    expectedItems: number | undefined;
    matchedItems: number | undefined;
    missingItems: number | undefined;
    extraItems: number | undefined;
    scorePercent: number | undefined;
    missingItemIds: string[] | undefined;
}

export enum DiscoveryEvaluationFindingKind {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class DiscoveryEvaluationFindingDto implements IDiscoveryEvaluationFindingDto {
    kind!: DiscoveryEvaluationFindingKind | undefined;
    location!: string | undefined;

    constructor(data?: IDiscoveryEvaluationFindingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any, _mappings?: any): DiscoveryEvaluationFindingDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DiscoveryEvaluationFindingDto>(data, _mappings, DiscoveryEvaluationFindingDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["location"] = this.location;
        return data;
    }
}

export interface IDiscoveryEvaluationFindingDto {
    kind: DiscoveryEvaluationFindingKind | undefined;
    location: string | undefined;
}

export class DiscoveryEvaluationCountsDto implements IDiscoveryEvaluationCountsDto {
    diagnosticsAvailable!: boolean | undefined;
    windowDays!: number | undefined;
    mailboxesRead!: number | undefined;
    inboxMessagesRead!: number | undefined;
    sentMessagesRead!: number | undefined;
    lookBackInboxMessagesRead!: number | undefined;
    lookBackSentMessagesRead!: number | undefined;
    lookBackUsed!: boolean | undefined;
    threadsSampled!: number | undefined;
    aiThreads!: number | undefined;
    aiCalls!: number | undefined;
    duplicatesCollapsed!: number | undefined;
    proofEligibleCount!: number | undefined;
    proofCards!: number | undefined;
    repeatedProofMessages!: number | undefined;
    draftItems!: number | undefined;
    withinWindow!: boolean | undefined;
    withinMessageCap!: boolean | undefined;
    withinAiThreadCap!: boolean | undefined;

    constructor(data?: IDiscoveryEvaluationCountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.diagnosticsAvailable = _data["diagnosticsAvailable"];
            this.windowDays = _data["windowDays"];
            this.mailboxesRead = _data["mailboxesRead"];
            this.inboxMessagesRead = _data["inboxMessagesRead"];
            this.sentMessagesRead = _data["sentMessagesRead"];
            this.lookBackInboxMessagesRead = _data["lookBackInboxMessagesRead"];
            this.lookBackSentMessagesRead = _data["lookBackSentMessagesRead"];
            this.lookBackUsed = _data["lookBackUsed"];
            this.threadsSampled = _data["threadsSampled"];
            this.aiThreads = _data["aiThreads"];
            this.aiCalls = _data["aiCalls"];
            this.duplicatesCollapsed = _data["duplicatesCollapsed"];
            this.proofEligibleCount = _data["proofEligibleCount"];
            this.proofCards = _data["proofCards"];
            this.repeatedProofMessages = _data["repeatedProofMessages"];
            this.draftItems = _data["draftItems"];
            this.withinWindow = _data["withinWindow"];
            this.withinMessageCap = _data["withinMessageCap"];
            this.withinAiThreadCap = _data["withinAiThreadCap"];
        }
    }

    static fromJS(data: any, _mappings?: any): DiscoveryEvaluationCountsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DiscoveryEvaluationCountsDto>(data, _mappings, DiscoveryEvaluationCountsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagnosticsAvailable"] = this.diagnosticsAvailable;
        data["windowDays"] = this.windowDays;
        data["mailboxesRead"] = this.mailboxesRead;
        data["inboxMessagesRead"] = this.inboxMessagesRead;
        data["sentMessagesRead"] = this.sentMessagesRead;
        data["lookBackInboxMessagesRead"] = this.lookBackInboxMessagesRead;
        data["lookBackSentMessagesRead"] = this.lookBackSentMessagesRead;
        data["lookBackUsed"] = this.lookBackUsed;
        data["threadsSampled"] = this.threadsSampled;
        data["aiThreads"] = this.aiThreads;
        data["aiCalls"] = this.aiCalls;
        data["duplicatesCollapsed"] = this.duplicatesCollapsed;
        data["proofEligibleCount"] = this.proofEligibleCount;
        data["proofCards"] = this.proofCards;
        data["repeatedProofMessages"] = this.repeatedProofMessages;
        data["draftItems"] = this.draftItems;
        data["withinWindow"] = this.withinWindow;
        data["withinMessageCap"] = this.withinMessageCap;
        data["withinAiThreadCap"] = this.withinAiThreadCap;
        return data;
    }
}

export interface IDiscoveryEvaluationCountsDto {
    diagnosticsAvailable: boolean | undefined;
    windowDays: number | undefined;
    mailboxesRead: number | undefined;
    inboxMessagesRead: number | undefined;
    sentMessagesRead: number | undefined;
    lookBackInboxMessagesRead: number | undefined;
    lookBackSentMessagesRead: number | undefined;
    lookBackUsed: boolean | undefined;
    threadsSampled: number | undefined;
    aiThreads: number | undefined;
    aiCalls: number | undefined;
    duplicatesCollapsed: number | undefined;
    proofEligibleCount: number | undefined;
    proofCards: number | undefined;
    repeatedProofMessages: number | undefined;
    draftItems: number | undefined;
    withinWindow: boolean | undefined;
    withinMessageCap: boolean | undefined;
    withinAiThreadCap: boolean | undefined;
}

export enum DiscoveryStage {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export class DiscoveryEvaluationStageTimingDto implements IDiscoveryEvaluationStageTimingDto {
    stage!: DiscoveryStage | undefined;
    milliseconds!: number | undefined;

    constructor(data?: IDiscoveryEvaluationStageTimingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.stage = _data["stage"];
            this.milliseconds = _data["milliseconds"];
        }
    }

    static fromJS(data: any, _mappings?: any): DiscoveryEvaluationStageTimingDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DiscoveryEvaluationStageTimingDto>(data, _mappings, DiscoveryEvaluationStageTimingDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage;
        data["milliseconds"] = this.milliseconds;
        return data;
    }
}

export interface IDiscoveryEvaluationStageTimingDto {
    stage: DiscoveryStage | undefined;
    milliseconds: number | undefined;
}

export class DiscoveryEvaluationTimingDto implements IDiscoveryEvaluationTimingDto {
    totalMs!: number | undefined;
    queueMs!: number | undefined;
    runMs!: number | undefined;
    targetSeconds!: number | undefined;
    hardDeadlineSeconds!: number | undefined;
    withinTarget!: boolean | undefined;
    withinHardDeadline!: boolean | undefined;
    engineSummaryRead!: boolean | undefined;
    promptTokens!: number | undefined;
    completionTokens!: number | undefined;
    totalTokens!: number | undefined;
    stages!: DiscoveryEvaluationStageTimingDto[] | undefined;

    constructor(data?: IDiscoveryEvaluationTimingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.totalMs = _data["totalMs"];
            this.queueMs = _data["queueMs"];
            this.runMs = _data["runMs"];
            this.targetSeconds = _data["targetSeconds"];
            this.hardDeadlineSeconds = _data["hardDeadlineSeconds"];
            this.withinTarget = _data["withinTarget"];
            this.withinHardDeadline = _data["withinHardDeadline"];
            this.engineSummaryRead = _data["engineSummaryRead"];
            this.promptTokens = _data["promptTokens"];
            this.completionTokens = _data["completionTokens"];
            this.totalTokens = _data["totalTokens"];
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(DiscoveryEvaluationStageTimingDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DiscoveryEvaluationTimingDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DiscoveryEvaluationTimingDto>(data, _mappings, DiscoveryEvaluationTimingDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalMs"] = this.totalMs;
        data["queueMs"] = this.queueMs;
        data["runMs"] = this.runMs;
        data["targetSeconds"] = this.targetSeconds;
        data["hardDeadlineSeconds"] = this.hardDeadlineSeconds;
        data["withinTarget"] = this.withinTarget;
        data["withinHardDeadline"] = this.withinHardDeadline;
        data["engineSummaryRead"] = this.engineSummaryRead;
        data["promptTokens"] = this.promptTokens;
        data["completionTokens"] = this.completionTokens;
        data["totalTokens"] = this.totalTokens;
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDiscoveryEvaluationTimingDto {
    totalMs: number | undefined;
    queueMs: number | undefined;
    runMs: number | undefined;
    targetSeconds: number | undefined;
    hardDeadlineSeconds: number | undefined;
    withinTarget: boolean | undefined;
    withinHardDeadline: boolean | undefined;
    engineSummaryRead: boolean | undefined;
    promptTokens: number | undefined;
    completionTokens: number | undefined;
    totalTokens: number | undefined;
    stages: DiscoveryEvaluationStageTimingDto[] | undefined;
}

export class DiscoveryEvaluationReportDto implements IDiscoveryEvaluationReportDto {
    stopRule!: string | undefined;
    expectationKey!: string | undefined;
    jobId!: number | undefined;
    sessionId!: number | undefined;
    entryPoint!: DiscoveryEntryPoint | undefined;
    isFixture!: boolean | undefined;
    outcome!: DiscoveryOutcome | undefined;
    profileEvaluated!: boolean | undefined;
    evaluatedAtUtc!: string | undefined;
    iteration!: number | undefined;
    maxIterations!: number | undefined;
    thresholdPercent!: number | undefined;
    expectedItems!: number | undefined;
    matchedItems!: number | undefined;
    scorePercent!: number | undefined;
    chapters!: DiscoveryEvaluationChapterDto[] | undefined;
    sections!: DiscoveryEvaluationSectionDto[] | undefined;
    privacyViolations!: number | undefined;
    injectedTermHits!: number | undefined;
    findings!: DiscoveryEvaluationFindingDto[] | undefined;
    counts!: DiscoveryEvaluationCountsDto | undefined;
    timing!: DiscoveryEvaluationTimingDto | undefined;
    meetsStopRule!: boolean | undefined;
    iterationLimitReached!: boolean | undefined;
    stopTuning!: boolean | undefined;
    notes!: string[] | undefined;

    constructor(data?: IDiscoveryEvaluationReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.stopRule = _data["stopRule"];
            this.expectationKey = _data["expectationKey"];
            this.jobId = _data["jobId"];
            this.sessionId = _data["sessionId"];
            this.entryPoint = _data["entryPoint"];
            this.isFixture = _data["isFixture"];
            this.outcome = _data["outcome"];
            this.profileEvaluated = _data["profileEvaluated"];
            this.evaluatedAtUtc = _data["evaluatedAtUtc"];
            this.iteration = _data["iteration"];
            this.maxIterations = _data["maxIterations"];
            this.thresholdPercent = _data["thresholdPercent"];
            this.expectedItems = _data["expectedItems"];
            this.matchedItems = _data["matchedItems"];
            this.scorePercent = _data["scorePercent"];
            if (Array.isArray(_data["chapters"])) {
                this.chapters = [] as any;
                for (let item of _data["chapters"])
                    this.chapters!.push(DiscoveryEvaluationChapterDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(DiscoveryEvaluationSectionDto.fromJS(item, _mappings));
            }
            this.privacyViolations = _data["privacyViolations"];
            this.injectedTermHits = _data["injectedTermHits"];
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(DiscoveryEvaluationFindingDto.fromJS(item, _mappings));
            }
            this.counts = _data["counts"] ? DiscoveryEvaluationCountsDto.fromJS(_data["counts"], _mappings) : undefined as any;
            this.timing = _data["timing"] ? DiscoveryEvaluationTimingDto.fromJS(_data["timing"], _mappings) : undefined as any;
            this.meetsStopRule = _data["meetsStopRule"];
            this.iterationLimitReached = _data["iterationLimitReached"];
            this.stopTuning = _data["stopTuning"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DiscoveryEvaluationReportDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DiscoveryEvaluationReportDto>(data, _mappings, DiscoveryEvaluationReportDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stopRule"] = this.stopRule;
        data["expectationKey"] = this.expectationKey;
        data["jobId"] = this.jobId;
        data["sessionId"] = this.sessionId;
        data["entryPoint"] = this.entryPoint;
        data["isFixture"] = this.isFixture;
        data["outcome"] = this.outcome;
        data["profileEvaluated"] = this.profileEvaluated;
        data["evaluatedAtUtc"] = this.evaluatedAtUtc;
        data["iteration"] = this.iteration;
        data["maxIterations"] = this.maxIterations;
        data["thresholdPercent"] = this.thresholdPercent;
        data["expectedItems"] = this.expectedItems;
        data["matchedItems"] = this.matchedItems;
        data["scorePercent"] = this.scorePercent;
        if (Array.isArray(this.chapters)) {
            data["chapters"] = [];
            for (let item of this.chapters)
                data["chapters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        data["privacyViolations"] = this.privacyViolations;
        data["injectedTermHits"] = this.injectedTermHits;
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item ? item.toJSON() : undefined as any);
        }
        data["counts"] = this.counts ? this.counts.toJSON() : undefined as any;
        data["timing"] = this.timing ? this.timing.toJSON() : undefined as any;
        data["meetsStopRule"] = this.meetsStopRule;
        data["iterationLimitReached"] = this.iterationLimitReached;
        data["stopTuning"] = this.stopTuning;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item);
        }
        return data;
    }
}

export interface IDiscoveryEvaluationReportDto {
    stopRule: string | undefined;
    expectationKey: string | undefined;
    jobId: number | undefined;
    sessionId: number | undefined;
    entryPoint: DiscoveryEntryPoint | undefined;
    isFixture: boolean | undefined;
    outcome: DiscoveryOutcome | undefined;
    profileEvaluated: boolean | undefined;
    evaluatedAtUtc: string | undefined;
    iteration: number | undefined;
    maxIterations: number | undefined;
    thresholdPercent: number | undefined;
    expectedItems: number | undefined;
    matchedItems: number | undefined;
    scorePercent: number | undefined;
    chapters: DiscoveryEvaluationChapterDto[] | undefined;
    sections: DiscoveryEvaluationSectionDto[] | undefined;
    privacyViolations: number | undefined;
    injectedTermHits: number | undefined;
    findings: DiscoveryEvaluationFindingDto[] | undefined;
    counts: DiscoveryEvaluationCountsDto | undefined;
    timing: DiscoveryEvaluationTimingDto | undefined;
    meetsStopRule: boolean | undefined;
    iterationLimitReached: boolean | undefined;
    stopTuning: boolean | undefined;
    notes: string[] | undefined;
}

export enum DiscoveryJobKind {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum DiscoveryJobStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum ScanMomentKind {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class ScanMomentDto implements IScanMomentDto {
    sequence!: number | undefined;
    stage!: DiscoveryStage | undefined;
    kind!: ScanMomentKind | undefined;
    label!: string | undefined;
    variants!: string[] | undefined;
    refKey!: string | undefined;

    constructor(data?: IScanMomentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sequence = _data["sequence"];
            this.stage = _data["stage"];
            this.kind = _data["kind"];
            this.label = _data["label"];
            if (Array.isArray(_data["variants"])) {
                this.variants = [] as any;
                for (let item of _data["variants"])
                    this.variants!.push(item);
            }
            this.refKey = _data["refKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): ScanMomentDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ScanMomentDto>(data, _mappings, ScanMomentDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequence"] = this.sequence;
        data["stage"] = this.stage;
        data["kind"] = this.kind;
        data["label"] = this.label;
        if (Array.isArray(this.variants)) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item);
        }
        data["refKey"] = this.refKey;
        return data;
    }
}

export interface IScanMomentDto {
    sequence: number | undefined;
    stage: DiscoveryStage | undefined;
    kind: ScanMomentKind | undefined;
    label: string | undefined;
    variants: string[] | undefined;
    refKey: string | undefined;
}

export class DiscoveryJobDto implements IDiscoveryJobDto {
    jobId!: number | undefined;
    entryPoint!: DiscoveryEntryPoint | undefined;
    kind!: DiscoveryJobKind | undefined;
    status!: DiscoveryJobStatus | undefined;
    stage!: DiscoveryStage | undefined;
    outcome!: DiscoveryOutcome | undefined;
    failureCode!: string | undefined;
    isFixture!: boolean | undefined;
    startedAtUtc!: string | undefined;
    completedAtUtc!: string | undefined;
    asOfUtc!: string | undefined;
    moments!: ScanMomentDto[] | undefined;

    constructor(data?: IDiscoveryJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.entryPoint = _data["entryPoint"];
            this.kind = _data["kind"];
            this.status = _data["status"];
            this.stage = _data["stage"];
            this.outcome = _data["outcome"];
            this.failureCode = _data["failureCode"];
            this.isFixture = _data["isFixture"];
            this.startedAtUtc = _data["startedAtUtc"];
            this.completedAtUtc = _data["completedAtUtc"];
            this.asOfUtc = _data["asOfUtc"];
            if (Array.isArray(_data["moments"])) {
                this.moments = [] as any;
                for (let item of _data["moments"])
                    this.moments!.push(ScanMomentDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DiscoveryJobDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DiscoveryJobDto>(data, _mappings, DiscoveryJobDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["entryPoint"] = this.entryPoint;
        data["kind"] = this.kind;
        data["status"] = this.status;
        data["stage"] = this.stage;
        data["outcome"] = this.outcome;
        data["failureCode"] = this.failureCode;
        data["isFixture"] = this.isFixture;
        data["startedAtUtc"] = this.startedAtUtc;
        data["completedAtUtc"] = this.completedAtUtc;
        data["asOfUtc"] = this.asOfUtc;
        if (Array.isArray(this.moments)) {
            data["moments"] = [];
            for (let item of this.moments)
                data["moments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDiscoveryJobDto {
    jobId: number | undefined;
    entryPoint: DiscoveryEntryPoint | undefined;
    kind: DiscoveryJobKind | undefined;
    status: DiscoveryJobStatus | undefined;
    stage: DiscoveryStage | undefined;
    outcome: DiscoveryOutcome | undefined;
    failureCode: string | undefined;
    isFixture: boolean | undefined;
    startedAtUtc: string | undefined;
    completedAtUtc: string | undefined;
    asOfUtc: string | undefined;
    moments: ScanMomentDto[] | undefined;
}

export class DriveCategoryManagerDto implements IDriveCategoryManagerDto {
    id!: number | undefined;
    managerId!: number | undefined;
    managerName!: string | undefined;

    constructor(data?: IDriveCategoryManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.managerId = _data["managerId"];
            this.managerName = _data["managerName"];
        }
    }

    static fromJS(data: any, _mappings?: any): DriveCategoryManagerDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DriveCategoryManagerDto>(data, _mappings, DriveCategoryManagerDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["managerId"] = this.managerId;
        data["managerName"] = this.managerName;
        return data;
    }
}

export interface IDriveCategoryManagerDto {
    id: number | undefined;
    managerId: number | undefined;
    managerName: string | undefined;
}

export class DriveCategoryManagerDtoListIHandleError implements IDriveCategoryManagerDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: DriveCategoryManagerDto[] | undefined;
    listOfEntities!: DriveCategoryManagerDto[][] | undefined;

    constructor(data?: IDriveCategoryManagerDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(DriveCategoryManagerDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DriveCategoryManagerDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DriveCategoryManagerDtoListIHandleError>(data, _mappings, DriveCategoryManagerDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IDriveCategoryManagerDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: DriveCategoryManagerDto[] | undefined;
    listOfEntities: DriveCategoryManagerDto[][] | undefined;
}

export class CreateOrUpdateDriveCategoryManagerInputDto implements ICreateOrUpdateDriveCategoryManagerInputDto {
    id!: number | undefined;
    userId!: number | undefined;

    constructor(data?: ICreateOrUpdateDriveCategoryManagerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateOrUpdateDriveCategoryManagerInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateOrUpdateDriveCategoryManagerInputDto>(data, _mappings, CreateOrUpdateDriveCategoryManagerInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ICreateOrUpdateDriveCategoryManagerInputDto {
    id: number | undefined;
    userId: number | undefined;
}

export class EditionListDto implements IEditionListDto {
    id!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    creationTime!: string | undefined;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.creationTime = _data["creationTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): EditionListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EditionListDto>(data, _mappings, EditionListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["creationTime"] = this.creationTime;
        return data;
    }
}

export interface IEditionListDto {
    id: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    creationTime: string | undefined;
}

export class EditionListDtoListResultDto implements IEditionListDtoListResultDto {
    items!: EditionListDto[] | undefined;

    constructor(data?: IEditionListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EditionListDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): EditionListDtoListResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EditionListDtoListResultDto>(data, _mappings, EditionListDtoListResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEditionListDtoListResultDto {
    items: EditionListDto[] | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id!: number | undefined;
    displayName!: string;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): EditionEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EditionEditDto>(data, _mappings, EditionEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): NameValueDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NameValueDto>(data, _mappings, NameValueDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class IValueValidator implements IIValueValidator {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            if (_data["attributes"]) {
                (this as any).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        ((this as any).attributes as any)![key] = _data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any, _mappings?: any): IValueValidator | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IValueValidator>(data, _mappings, IValueValidator);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (data["attributes"] as any)[key] = (this.attributes as any)[key];
            }
        }
        return data;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any, _mappings?: any): LocalizableComboboxItemDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LocalizableComboboxItemDto>(data, _mappings, LocalizableComboboxItemDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items!: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocalizableComboboxItemDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LocalizableComboboxItemSourceDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LocalizableComboboxItemSourceDto>(data, _mappings, LocalizableComboboxItemSourceDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator | undefined;
    itemSource!: LocalizableComboboxItemSourceDto | undefined;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (this.attributes as any)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"], _mappings) : undefined as any;
            this.itemSource = _data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(_data["itemSource"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): FeatureInputTypeDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FeatureInputTypeDto>(data, _mappings, FeatureInputTypeDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (data["attributes"] as any)[key] = (this.attributes as any)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : undefined as any;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : undefined as any;
        return data;
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator | undefined;
    itemSource: LocalizableComboboxItemSourceDto | undefined;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: FeatureInputTypeDto | undefined;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? FeatureInputTypeDto.fromJS(_data["inputType"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): FlatFeatureDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FlatFeatureDto>(data, _mappings, FlatFeatureDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined as any;
        return data;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto | undefined;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition!: EditionEditDto | undefined;
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"], _mappings) : undefined as any;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetEditionEditOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetEditionEditOutput>(data, _mappings, GetEditionEditOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto | undefined;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class CreateOrUpdateEditionDto implements ICreateOrUpdateEditionDto {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[];

    constructor(data?: ICreateOrUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"], _mappings) : new EditionEditDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateOrUpdateEditionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateOrUpdateEditionDto>(data, _mappings, CreateOrUpdateEditionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateOrUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export enum BulkCompleteDecision {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class BulkCompleteDecisionDto implements IBulkCompleteDecisionDto {
    taskId!: number | undefined;
    decision!: BulkCompleteDecision | undefined;
    reason!: string | undefined;
    expectsReply!: boolean | undefined;
    aiDecided!: boolean | undefined;
    stageName!: string | undefined;
    suggestedTimingKind!: string | undefined;
    suggestedTimingValue!: string | undefined;
    monitorReplies!: boolean | undefined;
    anchorSentAtUtc!: string | undefined;
    checkedAtUtc!: string | undefined;
    keptFollowUpDate!: string | undefined;
    waitingName!: string | undefined;

    constructor(data?: IBulkCompleteDecisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.decision = _data["decision"];
            this.reason = _data["reason"];
            this.expectsReply = _data["expectsReply"];
            this.aiDecided = _data["aiDecided"];
            this.stageName = _data["stageName"];
            this.suggestedTimingKind = _data["suggestedTimingKind"];
            this.suggestedTimingValue = _data["suggestedTimingValue"];
            this.monitorReplies = _data["monitorReplies"];
            this.anchorSentAtUtc = _data["anchorSentAtUtc"];
            this.checkedAtUtc = _data["checkedAtUtc"];
            this.keptFollowUpDate = _data["keptFollowUpDate"];
            this.waitingName = _data["waitingName"];
        }
    }

    static fromJS(data: any, _mappings?: any): BulkCompleteDecisionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BulkCompleteDecisionDto>(data, _mappings, BulkCompleteDecisionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["decision"] = this.decision;
        data["reason"] = this.reason;
        data["expectsReply"] = this.expectsReply;
        data["aiDecided"] = this.aiDecided;
        data["stageName"] = this.stageName;
        data["suggestedTimingKind"] = this.suggestedTimingKind;
        data["suggestedTimingValue"] = this.suggestedTimingValue;
        data["monitorReplies"] = this.monitorReplies;
        data["anchorSentAtUtc"] = this.anchorSentAtUtc;
        data["checkedAtUtc"] = this.checkedAtUtc;
        data["keptFollowUpDate"] = this.keptFollowUpDate;
        data["waitingName"] = this.waitingName;
        return data;
    }
}

export interface IBulkCompleteDecisionDto {
    taskId: number | undefined;
    decision: BulkCompleteDecision | undefined;
    reason: string | undefined;
    expectsReply: boolean | undefined;
    aiDecided: boolean | undefined;
    stageName: string | undefined;
    suggestedTimingKind: string | undefined;
    suggestedTimingValue: string | undefined;
    monitorReplies: boolean | undefined;
    anchorSentAtUtc: string | undefined;
    checkedAtUtc: string | undefined;
    keptFollowUpDate: string | undefined;
    waitingName: string | undefined;
}

export class BulkCompleteDecisionDtoIHandleError implements IBulkCompleteDecisionDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: BulkCompleteDecisionDto | undefined;
    listOfEntities!: BulkCompleteDecisionDto[] | undefined;

    constructor(data?: IBulkCompleteDecisionDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? BulkCompleteDecisionDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(BulkCompleteDecisionDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): BulkCompleteDecisionDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BulkCompleteDecisionDtoIHandleError>(data, _mappings, BulkCompleteDecisionDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBulkCompleteDecisionDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: BulkCompleteDecisionDto | undefined;
    listOfEntities: BulkCompleteDecisionDto[] | undefined;
}

export class BulkFollowUpItemInput implements IBulkFollowUpItemInput {
    taskId!: number | undefined;
    timingKind!: string | undefined;
    timingValue!: string | undefined;
    expectsReply!: boolean | undefined;
    aiReason!: string | undefined;
    monitorReplies!: boolean | undefined;
    anchorSentAtUtc!: string | undefined;

    constructor(data?: IBulkFollowUpItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.timingKind = _data["timingKind"];
            this.timingValue = _data["timingValue"];
            this.expectsReply = _data["expectsReply"];
            this.aiReason = _data["aiReason"];
            this.monitorReplies = _data["monitorReplies"];
            this.anchorSentAtUtc = _data["anchorSentAtUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): BulkFollowUpItemInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BulkFollowUpItemInput>(data, _mappings, BulkFollowUpItemInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["timingKind"] = this.timingKind;
        data["timingValue"] = this.timingValue;
        data["expectsReply"] = this.expectsReply;
        data["aiReason"] = this.aiReason;
        data["monitorReplies"] = this.monitorReplies;
        data["anchorSentAtUtc"] = this.anchorSentAtUtc;
        return data;
    }
}

export interface IBulkFollowUpItemInput {
    taskId: number | undefined;
    timingKind: string | undefined;
    timingValue: string | undefined;
    expectsReply: boolean | undefined;
    aiReason: string | undefined;
    monitorReplies: boolean | undefined;
    anchorSentAtUtc: string | undefined;
}

export class CompleteTasksInBulkInput implements ICompleteTasksInBulkInput {
    followUps!: BulkFollowUpItemInput[] | undefined;
    completeTaskIds!: number[] | undefined;
    repliesSinceUtc!: string | undefined;
    safeOnly!: boolean | undefined;

    constructor(data?: ICompleteTasksInBulkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["followUps"])) {
                this.followUps = [] as any;
                for (let item of _data["followUps"])
                    this.followUps!.push(BulkFollowUpItemInput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["completeTaskIds"])) {
                this.completeTaskIds = [] as any;
                for (let item of _data["completeTaskIds"])
                    this.completeTaskIds!.push(item);
            }
            this.repliesSinceUtc = _data["repliesSinceUtc"];
            this.safeOnly = _data["safeOnly"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompleteTasksInBulkInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompleteTasksInBulkInput>(data, _mappings, CompleteTasksInBulkInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.followUps)) {
            data["followUps"] = [];
            for (let item of this.followUps)
                data["followUps"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.completeTaskIds)) {
            data["completeTaskIds"] = [];
            for (let item of this.completeTaskIds)
                data["completeTaskIds"].push(item);
        }
        data["repliesSinceUtc"] = this.repliesSinceUtc;
        data["safeOnly"] = this.safeOnly;
        return data;
    }
}

export interface ICompleteTasksInBulkInput {
    followUps: BulkFollowUpItemInput[] | undefined;
    completeTaskIds: number[] | undefined;
    repliesSinceUtc: string | undefined;
    safeOnly: boolean | undefined;
}

export enum BulkCompleteOutcome {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class BulkCompleteItemResultDto implements IBulkCompleteItemResultDto {
    taskId!: number | undefined;
    outcome!: BulkCompleteOutcome | undefined;
    followUpDate!: string | undefined;
    message!: string | undefined;

    constructor(data?: IBulkCompleteItemResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.outcome = _data["outcome"];
            this.followUpDate = _data["followUpDate"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any, _mappings?: any): BulkCompleteItemResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BulkCompleteItemResultDto>(data, _mappings, BulkCompleteItemResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["outcome"] = this.outcome;
        data["followUpDate"] = this.followUpDate;
        data["message"] = this.message;
        return data;
    }
}

export interface IBulkCompleteItemResultDto {
    taskId: number | undefined;
    outcome: BulkCompleteOutcome | undefined;
    followUpDate: string | undefined;
    message: string | undefined;
}

export class CompleteTasksInBulkResultDto implements ICompleteTasksInBulkResultDto {
    items!: BulkCompleteItemResultDto[] | undefined;
    reloadAdvised!: boolean | undefined;

    constructor(data?: ICompleteTasksInBulkResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BulkCompleteItemResultDto.fromJS(item, _mappings));
            }
            this.reloadAdvised = _data["reloadAdvised"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompleteTasksInBulkResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompleteTasksInBulkResultDto>(data, _mappings, CompleteTasksInBulkResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["reloadAdvised"] = this.reloadAdvised;
        return data;
    }
}

export interface ICompleteTasksInBulkResultDto {
    items: BulkCompleteItemResultDto[] | undefined;
    reloadAdvised: boolean | undefined;
}

export class CompleteTasksInBulkResultDtoIHandleError implements ICompleteTasksInBulkResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CompleteTasksInBulkResultDto | undefined;
    listOfEntities!: CompleteTasksInBulkResultDto[] | undefined;

    constructor(data?: ICompleteTasksInBulkResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CompleteTasksInBulkResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CompleteTasksInBulkResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CompleteTasksInBulkResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompleteTasksInBulkResultDtoIHandleError>(data, _mappings, CompleteTasksInBulkResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICompleteTasksInBulkResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CompleteTasksInBulkResultDto | undefined;
    listOfEntities: CompleteTasksInBulkResultDto[] | undefined;
}

export class UpdateFollowUpTimingInput implements IUpdateFollowUpTimingInput {
    taskId!: number | undefined;
    timingKind!: string | undefined;
    timingValue!: string | undefined;

    constructor(data?: IUpdateFollowUpTimingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.timingKind = _data["timingKind"];
            this.timingValue = _data["timingValue"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateFollowUpTimingInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateFollowUpTimingInput>(data, _mappings, UpdateFollowUpTimingInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["timingKind"] = this.timingKind;
        data["timingValue"] = this.timingValue;
        return data;
    }
}

export interface IUpdateFollowUpTimingInput {
    taskId: number | undefined;
    timingKind: string | undefined;
    timingValue: string | undefined;
}

export class TaskFollowUpDto implements ITaskFollowUpDto {
    armed!: boolean | undefined;
    fired!: boolean | undefined;
    fireDateUtc!: string | undefined;
    firedAtUtc!: string | undefined;
    timingKind!: string | undefined;
    timingValue!: string | undefined;
    aiReason!: string | undefined;
    contactFirstName!: string | undefined;
    reopenTitlePreview!: string | undefined;
    clientAlreadyReplied!: boolean | undefined;
    hasClientLink!: boolean | undefined;
    isClientTerminal!: boolean | undefined;
    firedRoundsCount!: number | undefined;
    armedAtUtc!: string | undefined;
    isLeadContact!: boolean | undefined;
    isReminder!: boolean | undefined;
    fireLocalDate!: string | undefined;
    canMonitorReplies!: boolean | undefined;
    anchorSentAtUtc!: string | undefined;
    watchedThreadCount!: number | undefined;

    constructor(data?: ITaskFollowUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.armed = _data["armed"];
            this.fired = _data["fired"];
            this.fireDateUtc = _data["fireDateUtc"];
            this.firedAtUtc = _data["firedAtUtc"];
            this.timingKind = _data["timingKind"];
            this.timingValue = _data["timingValue"];
            this.aiReason = _data["aiReason"];
            this.contactFirstName = _data["contactFirstName"];
            this.reopenTitlePreview = _data["reopenTitlePreview"];
            this.clientAlreadyReplied = _data["clientAlreadyReplied"];
            this.hasClientLink = _data["hasClientLink"];
            this.isClientTerminal = _data["isClientTerminal"];
            this.firedRoundsCount = _data["firedRoundsCount"];
            this.armedAtUtc = _data["armedAtUtc"];
            this.isLeadContact = _data["isLeadContact"];
            this.isReminder = _data["isReminder"];
            this.fireLocalDate = _data["fireLocalDate"];
            this.canMonitorReplies = _data["canMonitorReplies"];
            this.anchorSentAtUtc = _data["anchorSentAtUtc"];
            this.watchedThreadCount = _data["watchedThreadCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskFollowUpDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskFollowUpDto>(data, _mappings, TaskFollowUpDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["armed"] = this.armed;
        data["fired"] = this.fired;
        data["fireDateUtc"] = this.fireDateUtc;
        data["firedAtUtc"] = this.firedAtUtc;
        data["timingKind"] = this.timingKind;
        data["timingValue"] = this.timingValue;
        data["aiReason"] = this.aiReason;
        data["contactFirstName"] = this.contactFirstName;
        data["reopenTitlePreview"] = this.reopenTitlePreview;
        data["clientAlreadyReplied"] = this.clientAlreadyReplied;
        data["hasClientLink"] = this.hasClientLink;
        data["isClientTerminal"] = this.isClientTerminal;
        data["firedRoundsCount"] = this.firedRoundsCount;
        data["armedAtUtc"] = this.armedAtUtc;
        data["isLeadContact"] = this.isLeadContact;
        data["isReminder"] = this.isReminder;
        data["fireLocalDate"] = this.fireLocalDate;
        data["canMonitorReplies"] = this.canMonitorReplies;
        data["anchorSentAtUtc"] = this.anchorSentAtUtc;
        data["watchedThreadCount"] = this.watchedThreadCount;
        return data;
    }
}

export interface ITaskFollowUpDto {
    armed: boolean | undefined;
    fired: boolean | undefined;
    fireDateUtc: string | undefined;
    firedAtUtc: string | undefined;
    timingKind: string | undefined;
    timingValue: string | undefined;
    aiReason: string | undefined;
    contactFirstName: string | undefined;
    reopenTitlePreview: string | undefined;
    clientAlreadyReplied: boolean | undefined;
    hasClientLink: boolean | undefined;
    isClientTerminal: boolean | undefined;
    firedRoundsCount: number | undefined;
    armedAtUtc: string | undefined;
    isLeadContact: boolean | undefined;
    isReminder: boolean | undefined;
    fireLocalDate: string | undefined;
    canMonitorReplies: boolean | undefined;
    anchorSentAtUtc: string | undefined;
    watchedThreadCount: number | undefined;
}

export class TaskFollowUpDtoIHandleError implements ITaskFollowUpDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskFollowUpDto | undefined;
    listOfEntities!: TaskFollowUpDto[] | undefined;

    constructor(data?: ITaskFollowUpDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TaskFollowUpDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TaskFollowUpDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskFollowUpDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskFollowUpDtoIHandleError>(data, _mappings, TaskFollowUpDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskFollowUpDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskFollowUpDto | undefined;
    listOfEntities: TaskFollowUpDto[] | undefined;
}

export class CancelTaskFollowUpInput implements ICancelTaskFollowUpInput {
    taskId!: number | undefined;
    reason!: string | undefined;

    constructor(data?: ICancelTaskFollowUpInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any, _mappings?: any): CancelTaskFollowUpInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CancelTaskFollowUpInput>(data, _mappings, CancelTaskFollowUpInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ICancelTaskFollowUpInput {
    taskId: number | undefined;
    reason: string | undefined;
}

export class ExtendTaskFollowUpInput implements IExtendTaskFollowUpInput {
    taskId!: number | undefined;
    timingKind!: string | undefined;
    timingValue!: string | undefined;

    constructor(data?: IExtendTaskFollowUpInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.timingKind = _data["timingKind"];
            this.timingValue = _data["timingValue"];
        }
    }

    static fromJS(data: any, _mappings?: any): ExtendTaskFollowUpInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ExtendTaskFollowUpInput>(data, _mappings, ExtendTaskFollowUpInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["timingKind"] = this.timingKind;
        data["timingValue"] = this.timingValue;
        return data;
    }
}

export interface IExtendTaskFollowUpInput {
    taskId: number | undefined;
    timingKind: string | undefined;
    timingValue: string | undefined;
}

export class Int32NullableIHandleError implements IInt32NullableIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: number | undefined;
    listOfEntities!: number[] | undefined;

    constructor(data?: IInt32NullableIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"];
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32NullableIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32NullableIHandleError>(data, _mappings, Int32NullableIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IInt32NullableIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: number | undefined;
    listOfEntities: number[] | undefined;
}

export class SuggestedContactDto implements ISuggestedContactDto {
    id!: number | undefined;
    projectId!: number | undefined;
    email!: string | undefined;
    sourceTaskId!: number | undefined;
    createdAt!: string | undefined;

    constructor(data?: ISuggestedContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.email = _data["email"];
            this.sourceTaskId = _data["sourceTaskId"];
            this.createdAt = _data["createdAt"];
        }
    }

    static fromJS(data: any, _mappings?: any): SuggestedContactDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SuggestedContactDto>(data, _mappings, SuggestedContactDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["email"] = this.email;
        data["sourceTaskId"] = this.sourceTaskId;
        data["createdAt"] = this.createdAt;
        return data;
    }
}

export interface ISuggestedContactDto {
    id: number | undefined;
    projectId: number | undefined;
    email: string | undefined;
    sourceTaskId: number | undefined;
    createdAt: string | undefined;
}

export class SuggestedContactDtoListIHandleError implements ISuggestedContactDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SuggestedContactDto[] | undefined;
    listOfEntities!: SuggestedContactDto[][] | undefined;

    constructor(data?: ISuggestedContactDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(SuggestedContactDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SuggestedContactDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SuggestedContactDtoListIHandleError>(data, _mappings, SuggestedContactDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ISuggestedContactDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SuggestedContactDto[] | undefined;
    listOfEntities: SuggestedContactDto[][] | undefined;
}

export class TaskProjectCandidateDto implements ITaskProjectCandidateDto {
    id!: number | undefined;
    taskId!: number | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    clientName!: string | undefined;
    tier!: number | undefined;

    constructor(data?: ITaskProjectCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.clientName = _data["clientName"];
            this.tier = _data["tier"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskProjectCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskProjectCandidateDto>(data, _mappings, TaskProjectCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["clientName"] = this.clientName;
        data["tier"] = this.tier;
        return data;
    }
}

export interface ITaskProjectCandidateDto {
    id: number | undefined;
    taskId: number | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    clientName: string | undefined;
    tier: number | undefined;
}

export class TaskProjectCandidateDtoListIHandleError implements ITaskProjectCandidateDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskProjectCandidateDto[] | undefined;
    listOfEntities!: TaskProjectCandidateDto[][] | undefined;

    constructor(data?: ITaskProjectCandidateDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TaskProjectCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskProjectCandidateDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskProjectCandidateDtoListIHandleError>(data, _mappings, TaskProjectCandidateDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITaskProjectCandidateDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskProjectCandidateDto[] | undefined;
    listOfEntities: TaskProjectCandidateDto[][] | undefined;
}

export class TaskClientCandidateDto implements ITaskClientCandidateDto {
    id!: number | undefined;
    taskId!: number | undefined;
    entityType!: number | undefined;
    clientId!: number | undefined;
    clientName!: string | undefined;
    companyName!: string | undefined;

    constructor(data?: ITaskClientCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.entityType = _data["entityType"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskClientCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskClientCandidateDto>(data, _mappings, TaskClientCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["entityType"] = this.entityType;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface ITaskClientCandidateDto {
    id: number | undefined;
    taskId: number | undefined;
    entityType: number | undefined;
    clientId: number | undefined;
    clientName: string | undefined;
    companyName: string | undefined;
}

export class TaskClientCandidateDtoListIHandleError implements ITaskClientCandidateDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskClientCandidateDto[] | undefined;
    listOfEntities!: TaskClientCandidateDto[][] | undefined;

    constructor(data?: ITaskClientCandidateDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TaskClientCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskClientCandidateDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskClientCandidateDtoListIHandleError>(data, _mappings, TaskClientCandidateDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITaskClientCandidateDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskClientCandidateDto[] | undefined;
    listOfEntities: TaskClientCandidateDto[][] | undefined;
}

export class SetTaskClientInput implements ISetTaskClientInput {
    taskId!: number | undefined;
    entityType!: number | undefined;
    clientId!: number | undefined;

    constructor(data?: ISetTaskClientInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.entityType = _data["entityType"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetTaskClientInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetTaskClientInput>(data, _mappings, SetTaskClientInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["entityType"] = this.entityType;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface ISetTaskClientInput {
    taskId: number | undefined;
    entityType: number | undefined;
    clientId: number | undefined;
}

export class SetTaskProjectInput implements ISetTaskProjectInput {
    taskId!: number | undefined;
    projectId!: number | undefined;

    constructor(data?: ISetTaskProjectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetTaskProjectInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetTaskProjectInput>(data, _mappings, SetTaskProjectInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ISetTaskProjectInput {
    taskId: number | undefined;
    projectId: number | undefined;
}

export class ReviewAutomationCandidateDto implements IReviewAutomationCandidateDto {
    id!: number | undefined;
    name!: string | undefined;

    constructor(data?: IReviewAutomationCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): ReviewAutomationCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReviewAutomationCandidateDto>(data, _mappings, ReviewAutomationCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IReviewAutomationCandidateDto {
    id: number | undefined;
    name: string | undefined;
}

export class ReviewInfoDto implements IReviewInfoDto {
    hasReview!: boolean | undefined;
    reviewId!: number | undefined;
    reviewType!: number | undefined;
    state!: number | undefined;
    leadName!: string | undefined;
    leadEmail!: string | undefined;
    matchedClientName!: string | undefined;
    senderName!: string | undefined;
    spf!: string | undefined;
    dkim!: string | undefined;
    dmarc!: string | undefined;
    automationCandidates!: ReviewAutomationCandidateDto[] | undefined;
    chosenAutomationId!: number | undefined;

    constructor(data?: IReviewInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.hasReview = _data["hasReview"];
            this.reviewId = _data["reviewId"];
            this.reviewType = _data["reviewType"];
            this.state = _data["state"];
            this.leadName = _data["leadName"];
            this.leadEmail = _data["leadEmail"];
            this.matchedClientName = _data["matchedClientName"];
            this.senderName = _data["senderName"];
            this.spf = _data["spf"];
            this.dkim = _data["dkim"];
            this.dmarc = _data["dmarc"];
            if (Array.isArray(_data["automationCandidates"])) {
                this.automationCandidates = [] as any;
                for (let item of _data["automationCandidates"])
                    this.automationCandidates!.push(ReviewAutomationCandidateDto.fromJS(item, _mappings));
            }
            this.chosenAutomationId = _data["chosenAutomationId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ReviewInfoDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReviewInfoDto>(data, _mappings, ReviewInfoDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasReview"] = this.hasReview;
        data["reviewId"] = this.reviewId;
        data["reviewType"] = this.reviewType;
        data["state"] = this.state;
        data["leadName"] = this.leadName;
        data["leadEmail"] = this.leadEmail;
        data["matchedClientName"] = this.matchedClientName;
        data["senderName"] = this.senderName;
        data["spf"] = this.spf;
        data["dkim"] = this.dkim;
        data["dmarc"] = this.dmarc;
        if (Array.isArray(this.automationCandidates)) {
            data["automationCandidates"] = [];
            for (let item of this.automationCandidates)
                data["automationCandidates"].push(item ? item.toJSON() : undefined as any);
        }
        data["chosenAutomationId"] = this.chosenAutomationId;
        return data;
    }
}

export interface IReviewInfoDto {
    hasReview: boolean | undefined;
    reviewId: number | undefined;
    reviewType: number | undefined;
    state: number | undefined;
    leadName: string | undefined;
    leadEmail: string | undefined;
    matchedClientName: string | undefined;
    senderName: string | undefined;
    spf: string | undefined;
    dkim: string | undefined;
    dmarc: string | undefined;
    automationCandidates: ReviewAutomationCandidateDto[] | undefined;
    chosenAutomationId: number | undefined;
}

export class ReviewInfoDtoIHandleError implements IReviewInfoDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ReviewInfoDto | undefined;
    listOfEntities!: ReviewInfoDto[] | undefined;

    constructor(data?: IReviewInfoDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ReviewInfoDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ReviewInfoDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ReviewInfoDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReviewInfoDtoIHandleError>(data, _mappings, ReviewInfoDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReviewInfoDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ReviewInfoDto | undefined;
    listOfEntities: ReviewInfoDto[] | undefined;
}

export class SenderMemoryDto implements ISenderMemoryDto {
    id!: number | undefined;
    senderEmail!: string | undefined;
    senderDomain!: string | undefined;
    disposition!: string | undefined;
    seenCount!: number | undefined;
    lastSeenUtc!: string | undefined;
    setByAction!: string | undefined;

    constructor(data?: ISenderMemoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.senderEmail = _data["senderEmail"];
            this.senderDomain = _data["senderDomain"];
            this.disposition = _data["disposition"];
            this.seenCount = _data["seenCount"];
            this.lastSeenUtc = _data["lastSeenUtc"];
            this.setByAction = _data["setByAction"];
        }
    }

    static fromJS(data: any, _mappings?: any): SenderMemoryDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SenderMemoryDto>(data, _mappings, SenderMemoryDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["senderEmail"] = this.senderEmail;
        data["senderDomain"] = this.senderDomain;
        data["disposition"] = this.disposition;
        data["seenCount"] = this.seenCount;
        data["lastSeenUtc"] = this.lastSeenUtc;
        data["setByAction"] = this.setByAction;
        return data;
    }
}

export interface ISenderMemoryDto {
    id: number | undefined;
    senderEmail: string | undefined;
    senderDomain: string | undefined;
    disposition: string | undefined;
    seenCount: number | undefined;
    lastSeenUtc: string | undefined;
    setByAction: string | undefined;
}

export class SenderMemoryDtoListIHandleError implements ISenderMemoryDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SenderMemoryDto[] | undefined;
    listOfEntities!: SenderMemoryDto[][] | undefined;

    constructor(data?: ISenderMemoryDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(SenderMemoryDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SenderMemoryDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SenderMemoryDtoListIHandleError>(data, _mappings, SenderMemoryDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ISenderMemoryDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SenderMemoryDto[] | undefined;
    listOfEntities: SenderMemoryDto[][] | undefined;
}

export class OpenReviewDto implements IOpenReviewDto {
    taskId!: number | undefined;
    reviewId!: number | undefined;
    reviewType!: number | undefined;
    ageDays!: number | undefined;
    createdAtUtc!: string | undefined;

    constructor(data?: IOpenReviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.reviewId = _data["reviewId"];
            this.reviewType = _data["reviewType"];
            this.ageDays = _data["ageDays"];
            this.createdAtUtc = _data["createdAtUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): OpenReviewDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OpenReviewDto>(data, _mappings, OpenReviewDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["reviewId"] = this.reviewId;
        data["reviewType"] = this.reviewType;
        data["ageDays"] = this.ageDays;
        data["createdAtUtc"] = this.createdAtUtc;
        return data;
    }
}

export interface IOpenReviewDto {
    taskId: number | undefined;
    reviewId: number | undefined;
    reviewType: number | undefined;
    ageDays: number | undefined;
    createdAtUtc: string | undefined;
}

export class OpenReviewDtoListIHandleError implements IOpenReviewDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: OpenReviewDto[] | undefined;
    listOfEntities!: OpenReviewDto[][] | undefined;

    constructor(data?: IOpenReviewDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(OpenReviewDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OpenReviewDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OpenReviewDtoListIHandleError>(data, _mappings, OpenReviewDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IOpenReviewDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: OpenReviewDto[] | undefined;
    listOfEntities: OpenReviewDto[][] | undefined;
}

export class TaskEmailDto implements ITaskEmailDto {
    hasEmail!: boolean | undefined;
    messageImmutableId!: string | undefined;
    from!: string | undefined;
    fromName!: string | undefined;
    to!: string[] | undefined;
    cc!: string[] | undefined;
    subject!: string | undefined;
    receivedDate!: string | undefined;
    conversationId!: string | undefined;
    webLink!: string | undefined;
    subType!: string | undefined;
    referrerName!: string | undefined;
    referrerEmail!: string | undefined;
    threadKey!: string | undefined;
    normalizedSubject!: string | undefined;

    constructor(data?: ITaskEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.hasEmail = _data["hasEmail"];
            this.messageImmutableId = _data["messageImmutableId"];
            this.from = _data["from"];
            this.fromName = _data["fromName"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            this.subject = _data["subject"];
            this.receivedDate = _data["receivedDate"];
            this.conversationId = _data["conversationId"];
            this.webLink = _data["webLink"];
            this.subType = _data["subType"];
            this.referrerName = _data["referrerName"];
            this.referrerEmail = _data["referrerEmail"];
            this.threadKey = _data["threadKey"];
            this.normalizedSubject = _data["normalizedSubject"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskEmailDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskEmailDto>(data, _mappings, TaskEmailDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasEmail"] = this.hasEmail;
        data["messageImmutableId"] = this.messageImmutableId;
        data["from"] = this.from;
        data["fromName"] = this.fromName;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        data["subject"] = this.subject;
        data["receivedDate"] = this.receivedDate;
        data["conversationId"] = this.conversationId;
        data["webLink"] = this.webLink;
        data["subType"] = this.subType;
        data["referrerName"] = this.referrerName;
        data["referrerEmail"] = this.referrerEmail;
        data["threadKey"] = this.threadKey;
        data["normalizedSubject"] = this.normalizedSubject;
        return data;
    }
}

export interface ITaskEmailDto {
    hasEmail: boolean | undefined;
    messageImmutableId: string | undefined;
    from: string | undefined;
    fromName: string | undefined;
    to: string[] | undefined;
    cc: string[] | undefined;
    subject: string | undefined;
    receivedDate: string | undefined;
    conversationId: string | undefined;
    webLink: string | undefined;
    subType: string | undefined;
    referrerName: string | undefined;
    referrerEmail: string | undefined;
    threadKey: string | undefined;
    normalizedSubject: string | undefined;
}

export class TaskEmailDtoIHandleError implements ITaskEmailDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskEmailDto | undefined;
    listOfEntities!: TaskEmailDto[] | undefined;

    constructor(data?: ITaskEmailDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TaskEmailDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TaskEmailDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskEmailDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskEmailDtoIHandleError>(data, _mappings, TaskEmailDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskEmailDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskEmailDto | undefined;
    listOfEntities: TaskEmailDto[] | undefined;
}

export class EmailBodyDto implements IEmailBodyDto {
    subject!: string | undefined;
    from!: string | undefined;
    fromName!: string | undefined;
    to!: string[] | undefined;
    receivedDate!: string | undefined;
    isHtml!: boolean | undefined;
    body!: string | undefined;

    constructor(data?: IEmailBodyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.from = _data["from"];
            this.fromName = _data["fromName"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            this.receivedDate = _data["receivedDate"];
            this.isHtml = _data["isHtml"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any, _mappings?: any): EmailBodyDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmailBodyDto>(data, _mappings, EmailBodyDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["from"] = this.from;
        data["fromName"] = this.fromName;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        data["receivedDate"] = this.receivedDate;
        data["isHtml"] = this.isHtml;
        data["body"] = this.body;
        return data;
    }
}

export interface IEmailBodyDto {
    subject: string | undefined;
    from: string | undefined;
    fromName: string | undefined;
    to: string[] | undefined;
    receivedDate: string | undefined;
    isHtml: boolean | undefined;
    body: string | undefined;
}

export class EmailBodyDtoIHandleError implements IEmailBodyDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: EmailBodyDto | undefined;
    listOfEntities!: EmailBodyDto[] | undefined;

    constructor(data?: IEmailBodyDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? EmailBodyDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(EmailBodyDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): EmailBodyDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmailBodyDtoIHandleError>(data, _mappings, EmailBodyDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEmailBodyDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: EmailBodyDto | undefined;
    listOfEntities: EmailBodyDto[] | undefined;
}

export class EmailAttachmentContentDto implements IEmailAttachmentContentDto {
    fileName!: string | undefined;
    contentType!: string | undefined;
    contentBase64!: string | undefined;
    tooLarge!: boolean | undefined;

    constructor(data?: IEmailAttachmentContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.contentBase64 = _data["contentBase64"];
            this.tooLarge = _data["tooLarge"];
        }
    }

    static fromJS(data: any, _mappings?: any): EmailAttachmentContentDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmailAttachmentContentDto>(data, _mappings, EmailAttachmentContentDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["contentBase64"] = this.contentBase64;
        data["tooLarge"] = this.tooLarge;
        return data;
    }
}

export interface IEmailAttachmentContentDto {
    fileName: string | undefined;
    contentType: string | undefined;
    contentBase64: string | undefined;
    tooLarge: boolean | undefined;
}

export class EmailAttachmentContentDtoIHandleError implements IEmailAttachmentContentDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: EmailAttachmentContentDto | undefined;
    listOfEntities!: EmailAttachmentContentDto[] | undefined;

    constructor(data?: IEmailAttachmentContentDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? EmailAttachmentContentDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(EmailAttachmentContentDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): EmailAttachmentContentDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmailAttachmentContentDtoIHandleError>(data, _mappings, EmailAttachmentContentDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEmailAttachmentContentDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: EmailAttachmentContentDto | undefined;
    listOfEntities: EmailAttachmentContentDto[] | undefined;
}

export class AttachmentDto implements IAttachmentDto {
    id!: string | undefined;
    name!: string | undefined;
    contentType!: string | undefined;
    size!: number | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.contentType = _data["contentType"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any, _mappings?: any): AttachmentDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AttachmentDto>(data, _mappings, AttachmentDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        return data;
    }
}

export interface IAttachmentDto {
    id: string | undefined;
    name: string | undefined;
    contentType: string | undefined;
    size: number | undefined;
}

export class ThreadMessageDto implements IThreadMessageDto {
    id!: string | undefined;
    from!: string | undefined;
    fromName!: string | undefined;
    to!: string[] | undefined;
    cc!: string[] | undefined;
    bcc!: string[] | undefined;
    subject!: string | undefined;
    date!: string | undefined;
    isSent!: boolean | undefined;
    isUnread!: boolean | undefined;
    isLatest!: boolean | undefined;
    bodyPreview!: string | undefined;
    isHtml!: boolean | undefined;
    body!: string | undefined;
    hasAttachments!: boolean | undefined;
    attachments!: AttachmentDto[] | undefined;
    filedFolderName!: string | undefined;
    filedFolderUrl!: string | undefined;
    filedFolderKeyId!: string | undefined;
    filedFolderDriveId!: string | undefined;
    filedFolderSiteId!: string | undefined;
    filedEmailBody!: boolean | undefined;
    toRecipients!: EmailPartyDto[] | undefined;
    ccRecipients!: EmailPartyDto[] | undefined;
    isFirm!: boolean | undefined;
    replyKind!: string | undefined;
    attachmentsFiled!: boolean | undefined;
    threadKey!: string | undefined;
    threadSubject!: string | undefined;
    isLatestInThread!: boolean | undefined;
    webLink!: string | undefined;
    messageKey!: string | undefined;

    constructor(data?: IThreadMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"];
            this.fromName = _data["fromName"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            if (Array.isArray(_data["bcc"])) {
                this.bcc = [] as any;
                for (let item of _data["bcc"])
                    this.bcc!.push(item);
            }
            this.subject = _data["subject"];
            this.date = _data["date"];
            this.isSent = _data["isSent"];
            this.isUnread = _data["isUnread"];
            this.isLatest = _data["isLatest"];
            this.bodyPreview = _data["bodyPreview"];
            this.isHtml = _data["isHtml"];
            this.body = _data["body"];
            this.hasAttachments = _data["hasAttachments"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item, _mappings));
            }
            this.filedFolderName = _data["filedFolderName"];
            this.filedFolderUrl = _data["filedFolderUrl"];
            this.filedFolderKeyId = _data["filedFolderKeyId"];
            this.filedFolderDriveId = _data["filedFolderDriveId"];
            this.filedFolderSiteId = _data["filedFolderSiteId"];
            this.filedEmailBody = _data["filedEmailBody"];
            if (Array.isArray(_data["toRecipients"])) {
                this.toRecipients = [] as any;
                for (let item of _data["toRecipients"])
                    this.toRecipients!.push(EmailPartyDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["ccRecipients"])) {
                this.ccRecipients = [] as any;
                for (let item of _data["ccRecipients"])
                    this.ccRecipients!.push(EmailPartyDto.fromJS(item, _mappings));
            }
            this.isFirm = _data["isFirm"];
            this.replyKind = _data["replyKind"];
            this.attachmentsFiled = _data["attachmentsFiled"];
            this.threadKey = _data["threadKey"];
            this.threadSubject = _data["threadSubject"];
            this.isLatestInThread = _data["isLatestInThread"];
            this.webLink = _data["webLink"];
            this.messageKey = _data["messageKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): ThreadMessageDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ThreadMessageDto>(data, _mappings, ThreadMessageDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from;
        data["fromName"] = this.fromName;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        if (Array.isArray(this.bcc)) {
            data["bcc"] = [];
            for (let item of this.bcc)
                data["bcc"].push(item);
        }
        data["subject"] = this.subject;
        data["date"] = this.date;
        data["isSent"] = this.isSent;
        data["isUnread"] = this.isUnread;
        data["isLatest"] = this.isLatest;
        data["bodyPreview"] = this.bodyPreview;
        data["isHtml"] = this.isHtml;
        data["body"] = this.body;
        data["hasAttachments"] = this.hasAttachments;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["filedFolderName"] = this.filedFolderName;
        data["filedFolderUrl"] = this.filedFolderUrl;
        data["filedFolderKeyId"] = this.filedFolderKeyId;
        data["filedFolderDriveId"] = this.filedFolderDriveId;
        data["filedFolderSiteId"] = this.filedFolderSiteId;
        data["filedEmailBody"] = this.filedEmailBody;
        if (Array.isArray(this.toRecipients)) {
            data["toRecipients"] = [];
            for (let item of this.toRecipients)
                data["toRecipients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ccRecipients)) {
            data["ccRecipients"] = [];
            for (let item of this.ccRecipients)
                data["ccRecipients"].push(item ? item.toJSON() : undefined as any);
        }
        data["isFirm"] = this.isFirm;
        data["replyKind"] = this.replyKind;
        data["attachmentsFiled"] = this.attachmentsFiled;
        data["threadKey"] = this.threadKey;
        data["threadSubject"] = this.threadSubject;
        data["isLatestInThread"] = this.isLatestInThread;
        data["webLink"] = this.webLink;
        data["messageKey"] = this.messageKey;
        return data;
    }
}

export interface IThreadMessageDto {
    id: string | undefined;
    from: string | undefined;
    fromName: string | undefined;
    to: string[] | undefined;
    cc: string[] | undefined;
    bcc: string[] | undefined;
    subject: string | undefined;
    date: string | undefined;
    isSent: boolean | undefined;
    isUnread: boolean | undefined;
    isLatest: boolean | undefined;
    bodyPreview: string | undefined;
    isHtml: boolean | undefined;
    body: string | undefined;
    hasAttachments: boolean | undefined;
    attachments: AttachmentDto[] | undefined;
    filedFolderName: string | undefined;
    filedFolderUrl: string | undefined;
    filedFolderKeyId: string | undefined;
    filedFolderDriveId: string | undefined;
    filedFolderSiteId: string | undefined;
    filedEmailBody: boolean | undefined;
    toRecipients: EmailPartyDto[] | undefined;
    ccRecipients: EmailPartyDto[] | undefined;
    isFirm: boolean | undefined;
    replyKind: string | undefined;
    attachmentsFiled: boolean | undefined;
    threadKey: string | undefined;
    threadSubject: string | undefined;
    isLatestInThread: boolean | undefined;
    webLink: string | undefined;
    messageKey: string | undefined;
}

export class FollowUpEventDto implements IFollowUpEventDto {
    firedAtUtc!: string | undefined;
    anchorSentAtUtc!: string | undefined;
    fireDateUtc!: string | undefined;
    state!: string | undefined;
    resolvedReason!: string | undefined;
    resolvedAtUtc!: string | undefined;
    anchorThreadKey!: string | undefined;

    constructor(data?: IFollowUpEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.firedAtUtc = _data["firedAtUtc"];
            this.anchorSentAtUtc = _data["anchorSentAtUtc"];
            this.fireDateUtc = _data["fireDateUtc"];
            this.state = _data["state"];
            this.resolvedReason = _data["resolvedReason"];
            this.resolvedAtUtc = _data["resolvedAtUtc"];
            this.anchorThreadKey = _data["anchorThreadKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): FollowUpEventDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FollowUpEventDto>(data, _mappings, FollowUpEventDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firedAtUtc"] = this.firedAtUtc;
        data["anchorSentAtUtc"] = this.anchorSentAtUtc;
        data["fireDateUtc"] = this.fireDateUtc;
        data["state"] = this.state;
        data["resolvedReason"] = this.resolvedReason;
        data["resolvedAtUtc"] = this.resolvedAtUtc;
        data["anchorThreadKey"] = this.anchorThreadKey;
        return data;
    }
}

export interface IFollowUpEventDto {
    firedAtUtc: string | undefined;
    anchorSentAtUtc: string | undefined;
    fireDateUtc: string | undefined;
    state: string | undefined;
    resolvedReason: string | undefined;
    resolvedAtUtc: string | undefined;
    anchorThreadKey: string | undefined;
}

export class TaskThreadSummaryDto implements ITaskThreadSummaryDto {
    key!: string | undefined;
    subject!: string | undefined;
    messageCount!: number | undefined;
    unreadCount!: number | undefined;
    lastActivity!: string | undefined;
    lastFromName!: string | undefined;
    lastFromAddress!: string | undefined;
    lastIsSent!: boolean | undefined;
    lastFromIsFirm!: boolean | undefined;
    isNewest!: boolean | undefined;
    isDefaultReply!: boolean | undefined;
    inboxAddress!: string | undefined;
    unavailable!: boolean | undefined;

    constructor(data?: ITaskThreadSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.subject = _data["subject"];
            this.messageCount = _data["messageCount"];
            this.unreadCount = _data["unreadCount"];
            this.lastActivity = _data["lastActivity"];
            this.lastFromName = _data["lastFromName"];
            this.lastFromAddress = _data["lastFromAddress"];
            this.lastIsSent = _data["lastIsSent"];
            this.lastFromIsFirm = _data["lastFromIsFirm"];
            this.isNewest = _data["isNewest"];
            this.isDefaultReply = _data["isDefaultReply"];
            this.inboxAddress = _data["inboxAddress"];
            this.unavailable = _data["unavailable"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskThreadSummaryDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskThreadSummaryDto>(data, _mappings, TaskThreadSummaryDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["subject"] = this.subject;
        data["messageCount"] = this.messageCount;
        data["unreadCount"] = this.unreadCount;
        data["lastActivity"] = this.lastActivity;
        data["lastFromName"] = this.lastFromName;
        data["lastFromAddress"] = this.lastFromAddress;
        data["lastIsSent"] = this.lastIsSent;
        data["lastFromIsFirm"] = this.lastFromIsFirm;
        data["isNewest"] = this.isNewest;
        data["isDefaultReply"] = this.isDefaultReply;
        data["inboxAddress"] = this.inboxAddress;
        data["unavailable"] = this.unavailable;
        return data;
    }
}

export interface ITaskThreadSummaryDto {
    key: string | undefined;
    subject: string | undefined;
    messageCount: number | undefined;
    unreadCount: number | undefined;
    lastActivity: string | undefined;
    lastFromName: string | undefined;
    lastFromAddress: string | undefined;
    lastIsSent: boolean | undefined;
    lastFromIsFirm: boolean | undefined;
    isNewest: boolean | undefined;
    isDefaultReply: boolean | undefined;
    inboxAddress: string | undefined;
    unavailable: boolean | undefined;
}

export class TaskThreadDto implements ITaskThreadDto {
    hasThread!: boolean | undefined;
    subject!: string | undefined;
    conversationId!: string | undefined;
    inboxAddress!: string | undefined;
    totalCount!: number | undefined;
    hasMore!: boolean | undefined;
    participantCount!: number | undefined;
    lastActivity!: string | undefined;
    aiThreadSummary!: string | undefined;
    aiThreadSummaryBullets!: string[] | undefined;
    filedFolderName!: string | undefined;
    filedFolderUrl!: string | undefined;
    filedFolderKeyId!: string | undefined;
    filedFolderDriveId!: string | undefined;
    filedFolderSiteId!: string | undefined;
    subType!: string | undefined;
    referrerName!: string | undefined;
    referrerEmail!: string | undefined;
    messages!: ThreadMessageDto[] | undefined;
    followUpEvents!: FollowUpEventDto[] | undefined;
    threads!: TaskThreadSummaryDto[] | undefined;
    defaultReplyThreadKey!: string | undefined;
    activeThreadKey!: string | undefined;
    scopeCount!: number | undefined;
    totalCountCapped!: boolean | undefined;
    threadsOmittedCount!: number | undefined;
    threadsLookupFailed!: boolean | undefined;

    constructor(data?: ITaskThreadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.hasThread = _data["hasThread"];
            this.subject = _data["subject"];
            this.conversationId = _data["conversationId"];
            this.inboxAddress = _data["inboxAddress"];
            this.totalCount = _data["totalCount"];
            this.hasMore = _data["hasMore"];
            this.participantCount = _data["participantCount"];
            this.lastActivity = _data["lastActivity"];
            this.aiThreadSummary = _data["aiThreadSummary"];
            if (Array.isArray(_data["aiThreadSummaryBullets"])) {
                this.aiThreadSummaryBullets = [] as any;
                for (let item of _data["aiThreadSummaryBullets"])
                    this.aiThreadSummaryBullets!.push(item);
            }
            this.filedFolderName = _data["filedFolderName"];
            this.filedFolderUrl = _data["filedFolderUrl"];
            this.filedFolderKeyId = _data["filedFolderKeyId"];
            this.filedFolderDriveId = _data["filedFolderDriveId"];
            this.filedFolderSiteId = _data["filedFolderSiteId"];
            this.subType = _data["subType"];
            this.referrerName = _data["referrerName"];
            this.referrerEmail = _data["referrerEmail"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ThreadMessageDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["followUpEvents"])) {
                this.followUpEvents = [] as any;
                for (let item of _data["followUpEvents"])
                    this.followUpEvents!.push(FollowUpEventDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["threads"])) {
                this.threads = [] as any;
                for (let item of _data["threads"])
                    this.threads!.push(TaskThreadSummaryDto.fromJS(item, _mappings));
            }
            this.defaultReplyThreadKey = _data["defaultReplyThreadKey"];
            this.activeThreadKey = _data["activeThreadKey"];
            this.scopeCount = _data["scopeCount"];
            this.totalCountCapped = _data["totalCountCapped"];
            this.threadsOmittedCount = _data["threadsOmittedCount"];
            this.threadsLookupFailed = _data["threadsLookupFailed"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskThreadDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskThreadDto>(data, _mappings, TaskThreadDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasThread"] = this.hasThread;
        data["subject"] = this.subject;
        data["conversationId"] = this.conversationId;
        data["inboxAddress"] = this.inboxAddress;
        data["totalCount"] = this.totalCount;
        data["hasMore"] = this.hasMore;
        data["participantCount"] = this.participantCount;
        data["lastActivity"] = this.lastActivity;
        data["aiThreadSummary"] = this.aiThreadSummary;
        if (Array.isArray(this.aiThreadSummaryBullets)) {
            data["aiThreadSummaryBullets"] = [];
            for (let item of this.aiThreadSummaryBullets)
                data["aiThreadSummaryBullets"].push(item);
        }
        data["filedFolderName"] = this.filedFolderName;
        data["filedFolderUrl"] = this.filedFolderUrl;
        data["filedFolderKeyId"] = this.filedFolderKeyId;
        data["filedFolderDriveId"] = this.filedFolderDriveId;
        data["filedFolderSiteId"] = this.filedFolderSiteId;
        data["subType"] = this.subType;
        data["referrerName"] = this.referrerName;
        data["referrerEmail"] = this.referrerEmail;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.followUpEvents)) {
            data["followUpEvents"] = [];
            for (let item of this.followUpEvents)
                data["followUpEvents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.threads)) {
            data["threads"] = [];
            for (let item of this.threads)
                data["threads"].push(item ? item.toJSON() : undefined as any);
        }
        data["defaultReplyThreadKey"] = this.defaultReplyThreadKey;
        data["activeThreadKey"] = this.activeThreadKey;
        data["scopeCount"] = this.scopeCount;
        data["totalCountCapped"] = this.totalCountCapped;
        data["threadsOmittedCount"] = this.threadsOmittedCount;
        data["threadsLookupFailed"] = this.threadsLookupFailed;
        return data;
    }
}

export interface ITaskThreadDto {
    hasThread: boolean | undefined;
    subject: string | undefined;
    conversationId: string | undefined;
    inboxAddress: string | undefined;
    totalCount: number | undefined;
    hasMore: boolean | undefined;
    participantCount: number | undefined;
    lastActivity: string | undefined;
    aiThreadSummary: string | undefined;
    aiThreadSummaryBullets: string[] | undefined;
    filedFolderName: string | undefined;
    filedFolderUrl: string | undefined;
    filedFolderKeyId: string | undefined;
    filedFolderDriveId: string | undefined;
    filedFolderSiteId: string | undefined;
    subType: string | undefined;
    referrerName: string | undefined;
    referrerEmail: string | undefined;
    messages: ThreadMessageDto[] | undefined;
    followUpEvents: FollowUpEventDto[] | undefined;
    threads: TaskThreadSummaryDto[] | undefined;
    defaultReplyThreadKey: string | undefined;
    activeThreadKey: string | undefined;
    scopeCount: number | undefined;
    totalCountCapped: boolean | undefined;
    threadsOmittedCount: number | undefined;
    threadsLookupFailed: boolean | undefined;
}

export class TaskThreadDtoIHandleError implements ITaskThreadDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskThreadDto | undefined;
    listOfEntities!: TaskThreadDto[] | undefined;

    constructor(data?: ITaskThreadDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TaskThreadDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TaskThreadDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskThreadDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskThreadDtoIHandleError>(data, _mappings, TaskThreadDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskThreadDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskThreadDto | undefined;
    listOfEntities: TaskThreadDto[] | undefined;
}

export class StampThreadOutboundInput implements IStampThreadOutboundInput {
    taskId!: number | undefined;

    constructor(data?: IStampThreadOutboundInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any, _mappings?: any): StampThreadOutboundInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StampThreadOutboundInput>(data, _mappings, StampThreadOutboundInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface IStampThreadOutboundInput {
    taskId: number | undefined;
}

export class StampThreadOutboundResultDto implements IStampThreadOutboundResultDto {
    stamped!: boolean | undefined;
    lastOutboundAtUtc!: string | undefined;
    lastActivityAtUtc!: string | undefined;

    constructor(data?: IStampThreadOutboundResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.stamped = _data["stamped"];
            this.lastOutboundAtUtc = _data["lastOutboundAtUtc"];
            this.lastActivityAtUtc = _data["lastActivityAtUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): StampThreadOutboundResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StampThreadOutboundResultDto>(data, _mappings, StampThreadOutboundResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stamped"] = this.stamped;
        data["lastOutboundAtUtc"] = this.lastOutboundAtUtc;
        data["lastActivityAtUtc"] = this.lastActivityAtUtc;
        return data;
    }
}

export interface IStampThreadOutboundResultDto {
    stamped: boolean | undefined;
    lastOutboundAtUtc: string | undefined;
    lastActivityAtUtc: string | undefined;
}

export class StampThreadOutboundResultDtoIHandleError implements IStampThreadOutboundResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: StampThreadOutboundResultDto | undefined;
    listOfEntities!: StampThreadOutboundResultDto[] | undefined;

    constructor(data?: IStampThreadOutboundResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? StampThreadOutboundResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(StampThreadOutboundResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): StampThreadOutboundResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StampThreadOutboundResultDtoIHandleError>(data, _mappings, StampThreadOutboundResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStampThreadOutboundResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: StampThreadOutboundResultDto | undefined;
    listOfEntities: StampThreadOutboundResultDto[] | undefined;
}

export class SyncTaskThreadItemDto implements ISyncTaskThreadItemDto {
    taskId!: number | undefined;
    threadKey!: string | undefined;

    constructor(data?: ISyncTaskThreadItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.threadKey = _data["threadKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): SyncTaskThreadItemDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SyncTaskThreadItemDto>(data, _mappings, SyncTaskThreadItemDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["threadKey"] = this.threadKey;
        return data;
    }
}

export interface ISyncTaskThreadItemDto {
    taskId: number | undefined;
    threadKey: string | undefined;
}

export class SyncTaskThreadMessagesInput implements ISyncTaskThreadMessagesInput {
    items!: SyncTaskThreadItemDto[] | undefined;

    constructor(data?: ISyncTaskThreadMessagesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SyncTaskThreadItemDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SyncTaskThreadMessagesInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SyncTaskThreadMessagesInput>(data, _mappings, SyncTaskThreadMessagesInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISyncTaskThreadMessagesInput {
    items: SyncTaskThreadItemDto[] | undefined;
}

export class SyncTaskThreadMessagesResultDto implements ISyncTaskThreadMessagesResultDto {
    rowsAdded!: number | undefined;
    skippedItems!: number | undefined;
    changedEntries!: ConversationEntryRefDto[] | undefined;

    constructor(data?: ISyncTaskThreadMessagesResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.rowsAdded = _data["rowsAdded"];
            this.skippedItems = _data["skippedItems"];
            if (Array.isArray(_data["changedEntries"])) {
                this.changedEntries = [] as any;
                for (let item of _data["changedEntries"])
                    this.changedEntries!.push(ConversationEntryRefDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SyncTaskThreadMessagesResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SyncTaskThreadMessagesResultDto>(data, _mappings, SyncTaskThreadMessagesResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowsAdded"] = this.rowsAdded;
        data["skippedItems"] = this.skippedItems;
        if (Array.isArray(this.changedEntries)) {
            data["changedEntries"] = [];
            for (let item of this.changedEntries)
                data["changedEntries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISyncTaskThreadMessagesResultDto {
    rowsAdded: number | undefined;
    skippedItems: number | undefined;
    changedEntries: ConversationEntryRefDto[] | undefined;
}

export class SyncTaskThreadMessagesResultDtoIHandleError implements ISyncTaskThreadMessagesResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SyncTaskThreadMessagesResultDto | undefined;
    listOfEntities!: SyncTaskThreadMessagesResultDto[] | undefined;

    constructor(data?: ISyncTaskThreadMessagesResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SyncTaskThreadMessagesResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SyncTaskThreadMessagesResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SyncTaskThreadMessagesResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SyncTaskThreadMessagesResultDtoIHandleError>(data, _mappings, SyncTaskThreadMessagesResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISyncTaskThreadMessagesResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SyncTaskThreadMessagesResultDto | undefined;
    listOfEntities: SyncTaskThreadMessagesResultDto[] | undefined;
}

export class RefreshTaskConversationSummaryInput implements IRefreshTaskConversationSummaryInput {
    taskId!: number | undefined;
    force!: boolean | undefined;

    constructor(data?: IRefreshTaskConversationSummaryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.force = _data["force"];
        }
    }

    static fromJS(data: any, _mappings?: any): RefreshTaskConversationSummaryInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RefreshTaskConversationSummaryInput>(data, _mappings, RefreshTaskConversationSummaryInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["force"] = this.force;
        return data;
    }
}

export interface IRefreshTaskConversationSummaryInput {
    taskId: number | undefined;
    force: boolean | undefined;
}

export class ConversationSummarySourceDto implements IConversationSummarySourceDto {
    kind!: string | undefined;
    id!: string | undefined;

    constructor(data?: IConversationSummarySourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationSummarySourceDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationSummarySourceDto>(data, _mappings, ConversationSummarySourceDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["id"] = this.id;
        return data;
    }
}

export interface IConversationSummarySourceDto {
    kind: string | undefined;
    id: string | undefined;
}

export class ConversationSummaryItemDto implements IConversationSummaryItemDto {
    text!: string | undefined;
    sources!: ConversationSummarySourceDto[] | undefined;

    constructor(data?: IConversationSummaryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.text = _data["text"];
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(ConversationSummarySourceDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationSummaryItemDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationSummaryItemDto>(data, _mappings, ConversationSummaryItemDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConversationSummaryItemDto {
    text: string | undefined;
    sources: ConversationSummarySourceDto[] | undefined;
}

export class ConversationSummarySectionDto implements IConversationSummarySectionDto {
    key!: string | undefined;
    title!: string | undefined;
    items!: ConversationSummaryItemDto[] | undefined;

    constructor(data?: IConversationSummarySectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.title = _data["title"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConversationSummaryItemDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationSummarySectionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationSummarySectionDto>(data, _mappings, ConversationSummarySectionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["title"] = this.title;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConversationSummarySectionDto {
    key: string | undefined;
    title: string | undefined;
    items: ConversationSummaryItemDto[] | undefined;
}

export class ConversationLatestExternalDto implements IConversationLatestExternalDto {
    label!: string | undefined;
    day!: string | undefined;
    source!: ConversationSummarySourceDto | undefined;

    constructor(data?: IConversationLatestExternalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.label = _data["label"];
            this.day = _data["day"];
            this.source = _data["source"] ? ConversationSummarySourceDto.fromJS(_data["source"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationLatestExternalDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationLatestExternalDto>(data, _mappings, ConversationLatestExternalDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["day"] = this.day;
        data["source"] = this.source ? this.source.toJSON() : undefined as any;
        return data;
    }
}

export interface IConversationLatestExternalDto {
    label: string | undefined;
    day: string | undefined;
    source: ConversationSummarySourceDto | undefined;
}

export class ConversationSummaryDto implements IConversationSummaryDto {
    leadIn!: string | undefined;
    bullets!: string[] | undefined;
    requiresThreadReload!: boolean | undefined;
    status!: string | undefined;
    leadSources!: ConversationSummarySourceDto[] | undefined;
    sub!: string | undefined;
    subSources!: ConversationSummarySourceDto[] | undefined;
    sections!: ConversationSummarySectionDto[] | undefined;
    latestExternal!: ConversationLatestExternalDto | undefined;
    inboxName!: string | undefined;
    inboxKind!: string | undefined;

    constructor(data?: IConversationSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.leadIn = _data["leadIn"];
            if (Array.isArray(_data["bullets"])) {
                this.bullets = [] as any;
                for (let item of _data["bullets"])
                    this.bullets!.push(item);
            }
            this.requiresThreadReload = _data["requiresThreadReload"];
            this.status = _data["status"];
            if (Array.isArray(_data["leadSources"])) {
                this.leadSources = [] as any;
                for (let item of _data["leadSources"])
                    this.leadSources!.push(ConversationSummarySourceDto.fromJS(item, _mappings));
            }
            this.sub = _data["sub"];
            if (Array.isArray(_data["subSources"])) {
                this.subSources = [] as any;
                for (let item of _data["subSources"])
                    this.subSources!.push(ConversationSummarySourceDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(ConversationSummarySectionDto.fromJS(item, _mappings));
            }
            this.latestExternal = _data["latestExternal"] ? ConversationLatestExternalDto.fromJS(_data["latestExternal"], _mappings) : undefined as any;
            this.inboxName = _data["inboxName"];
            this.inboxKind = _data["inboxKind"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationSummaryDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationSummaryDto>(data, _mappings, ConversationSummaryDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadIn"] = this.leadIn;
        if (Array.isArray(this.bullets)) {
            data["bullets"] = [];
            for (let item of this.bullets)
                data["bullets"].push(item);
        }
        data["requiresThreadReload"] = this.requiresThreadReload;
        data["status"] = this.status;
        if (Array.isArray(this.leadSources)) {
            data["leadSources"] = [];
            for (let item of this.leadSources)
                data["leadSources"].push(item ? item.toJSON() : undefined as any);
        }
        data["sub"] = this.sub;
        if (Array.isArray(this.subSources)) {
            data["subSources"] = [];
            for (let item of this.subSources)
                data["subSources"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        data["latestExternal"] = this.latestExternal ? this.latestExternal.toJSON() : undefined as any;
        data["inboxName"] = this.inboxName;
        data["inboxKind"] = this.inboxKind;
        return data;
    }
}

export interface IConversationSummaryDto {
    leadIn: string | undefined;
    bullets: string[] | undefined;
    requiresThreadReload: boolean | undefined;
    status: string | undefined;
    leadSources: ConversationSummarySourceDto[] | undefined;
    sub: string | undefined;
    subSources: ConversationSummarySourceDto[] | undefined;
    sections: ConversationSummarySectionDto[] | undefined;
    latestExternal: ConversationLatestExternalDto | undefined;
    inboxName: string | undefined;
    inboxKind: string | undefined;
}

export class ConversationSummaryDtoIHandleError implements IConversationSummaryDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ConversationSummaryDto | undefined;
    listOfEntities!: ConversationSummaryDto[] | undefined;

    constructor(data?: IConversationSummaryDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ConversationSummaryDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ConversationSummaryDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationSummaryDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationSummaryDtoIHandleError>(data, _mappings, ConversationSummaryDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConversationSummaryDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ConversationSummaryDto | undefined;
    listOfEntities: ConversationSummaryDto[] | undefined;
}

export class ReplySuggestionDto implements IReplySuggestionDto {
    label!: string | undefined;
    prompt!: string | undefined;

    constructor(data?: IReplySuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.label = _data["label"];
            this.prompt = _data["prompt"];
        }
    }

    static fromJS(data: any, _mappings?: any): ReplySuggestionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReplySuggestionDto>(data, _mappings, ReplySuggestionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["prompt"] = this.prompt;
        return data;
    }
}

export interface IReplySuggestionDto {
    label: string | undefined;
    prompt: string | undefined;
}

export class ReplySuggestionDtoListIHandleError implements IReplySuggestionDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ReplySuggestionDto[] | undefined;
    listOfEntities!: ReplySuggestionDto[][] | undefined;

    constructor(data?: IReplySuggestionDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ReplySuggestionDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ReplySuggestionDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReplySuggestionDtoListIHandleError>(data, _mappings, ReplySuggestionDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IReplySuggestionDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ReplySuggestionDto[] | undefined;
    listOfEntities: ReplySuggestionDto[][] | undefined;
}

export enum EmailReplyMode {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ReplyAttachmentDto implements IReplyAttachmentDto {
    name!: string | undefined;
    link!: string | undefined;
    scopeLabel!: string | undefined;
    permissionLabel!: string | undefined;
    isFolder!: boolean | undefined;

    constructor(data?: IReplyAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.link = _data["link"];
            this.scopeLabel = _data["scopeLabel"];
            this.permissionLabel = _data["permissionLabel"];
            this.isFolder = _data["isFolder"];
        }
    }

    static fromJS(data: any, _mappings?: any): ReplyAttachmentDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReplyAttachmentDto>(data, _mappings, ReplyAttachmentDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["link"] = this.link;
        data["scopeLabel"] = this.scopeLabel;
        data["permissionLabel"] = this.permissionLabel;
        data["isFolder"] = this.isFolder;
        return data;
    }
}

export interface IReplyAttachmentDto {
    name: string | undefined;
    link: string | undefined;
    scopeLabel: string | undefined;
    permissionLabel: string | undefined;
    isFolder: boolean | undefined;
}

export class SendEmailReplyInput implements ISendEmailReplyInput {
    taskId!: number | undefined;
    mode!: EmailReplyMode | undefined;
    body!: string | undefined;
    to!: string[] | undefined;
    cc!: string[] | undefined;
    bcc!: string[] | undefined;
    subject!: string | undefined;
    attachments!: ReplyAttachmentDto[] | undefined;
    threadKey!: string | undefined;
    anchorMessageId!: string | undefined;

    constructor(data?: ISendEmailReplyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.mode = _data["mode"];
            this.body = _data["body"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            if (Array.isArray(_data["bcc"])) {
                this.bcc = [] as any;
                for (let item of _data["bcc"])
                    this.bcc!.push(item);
            }
            this.subject = _data["subject"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(ReplyAttachmentDto.fromJS(item, _mappings));
            }
            this.threadKey = _data["threadKey"];
            this.anchorMessageId = _data["anchorMessageId"];
        }
    }

    static fromJS(data: any, _mappings?: any): SendEmailReplyInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SendEmailReplyInput>(data, _mappings, SendEmailReplyInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["mode"] = this.mode;
        data["body"] = this.body;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        if (Array.isArray(this.bcc)) {
            data["bcc"] = [];
            for (let item of this.bcc)
                data["bcc"].push(item);
        }
        data["subject"] = this.subject;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["threadKey"] = this.threadKey;
        data["anchorMessageId"] = this.anchorMessageId;
        return data;
    }
}

export interface ISendEmailReplyInput {
    taskId: number | undefined;
    mode: EmailReplyMode | undefined;
    body: string | undefined;
    to: string[] | undefined;
    cc: string[] | undefined;
    bcc: string[] | undefined;
    subject: string | undefined;
    attachments: ReplyAttachmentDto[] | undefined;
    threadKey: string | undefined;
    anchorMessageId: string | undefined;
}

export class SendNewTaskEmailInput implements ISendNewTaskEmailInput {
    taskId!: number | undefined;
    body!: string | undefined;
    to!: string[] | undefined;
    cc!: string[] | undefined;
    bcc!: string[] | undefined;
    subject!: string | undefined;
    taskTitle!: string | undefined;

    constructor(data?: ISendNewTaskEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.body = _data["body"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            if (Array.isArray(_data["bcc"])) {
                this.bcc = [] as any;
                for (let item of _data["bcc"])
                    this.bcc!.push(item);
            }
            this.subject = _data["subject"];
            this.taskTitle = _data["taskTitle"];
        }
    }

    static fromJS(data: any, _mappings?: any): SendNewTaskEmailInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SendNewTaskEmailInput>(data, _mappings, SendNewTaskEmailInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["body"] = this.body;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        if (Array.isArray(this.bcc)) {
            data["bcc"] = [];
            for (let item of this.bcc)
                data["bcc"].push(item);
        }
        data["subject"] = this.subject;
        data["taskTitle"] = this.taskTitle;
        return data;
    }
}

export interface ISendNewTaskEmailInput {
    taskId: number | undefined;
    body: string | undefined;
    to: string[] | undefined;
    cc: string[] | undefined;
    bcc: string[] | undefined;
    subject: string | undefined;
    taskTitle: string | undefined;
}

export class SendNewTaskEmailResultDto implements ISendNewTaskEmailResultDto {
    sent!: boolean | undefined;
    linked!: boolean | undefined;
    threadKey!: string | undefined;
    taskType!: number | undefined;
    taskTitle!: string | undefined;

    constructor(data?: ISendNewTaskEmailResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sent = _data["sent"];
            this.linked = _data["linked"];
            this.threadKey = _data["threadKey"];
            this.taskType = _data["taskType"];
            this.taskTitle = _data["taskTitle"];
        }
    }

    static fromJS(data: any, _mappings?: any): SendNewTaskEmailResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SendNewTaskEmailResultDto>(data, _mappings, SendNewTaskEmailResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sent"] = this.sent;
        data["linked"] = this.linked;
        data["threadKey"] = this.threadKey;
        data["taskType"] = this.taskType;
        data["taskTitle"] = this.taskTitle;
        return data;
    }
}

export interface ISendNewTaskEmailResultDto {
    sent: boolean | undefined;
    linked: boolean | undefined;
    threadKey: string | undefined;
    taskType: number | undefined;
    taskTitle: string | undefined;
}

export class SendNewTaskEmailResultDtoIHandleError implements ISendNewTaskEmailResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SendNewTaskEmailResultDto | undefined;
    listOfEntities!: SendNewTaskEmailResultDto[] | undefined;

    constructor(data?: ISendNewTaskEmailResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SendNewTaskEmailResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SendNewTaskEmailResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SendNewTaskEmailResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SendNewTaskEmailResultDtoIHandleError>(data, _mappings, SendNewTaskEmailResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISendNewTaskEmailResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SendNewTaskEmailResultDto | undefined;
    listOfEntities: SendNewTaskEmailResultDto[] | undefined;
}

export class SuggestFollowUpInput implements ISuggestFollowUpInput {
    taskId!: number | undefined;
    sentBodyHtml!: string | undefined;

    constructor(data?: ISuggestFollowUpInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.sentBodyHtml = _data["sentBodyHtml"];
        }
    }

    static fromJS(data: any, _mappings?: any): SuggestFollowUpInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SuggestFollowUpInput>(data, _mappings, SuggestFollowUpInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["sentBodyHtml"] = this.sentBodyHtml;
        return data;
    }
}

export interface ISuggestFollowUpInput {
    taskId: number | undefined;
    sentBodyHtml: string | undefined;
}

export class FollowUpSuggestionDto implements IFollowUpSuggestionDto {
    expectsReply!: boolean | undefined;
    reason!: string | undefined;

    constructor(data?: IFollowUpSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.expectsReply = _data["expectsReply"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any, _mappings?: any): FollowUpSuggestionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FollowUpSuggestionDto>(data, _mappings, FollowUpSuggestionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectsReply"] = this.expectsReply;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IFollowUpSuggestionDto {
    expectsReply: boolean | undefined;
    reason: string | undefined;
}

export class FollowUpSuggestionDtoIHandleError implements IFollowUpSuggestionDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: FollowUpSuggestionDto | undefined;
    listOfEntities!: FollowUpSuggestionDto[] | undefined;

    constructor(data?: IFollowUpSuggestionDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? FollowUpSuggestionDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(FollowUpSuggestionDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): FollowUpSuggestionDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FollowUpSuggestionDtoIHandleError>(data, _mappings, FollowUpSuggestionDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFollowUpSuggestionDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: FollowUpSuggestionDto | undefined;
    listOfEntities: FollowUpSuggestionDto[] | undefined;
}

export enum ReplyWarningOutcome {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ReplyBeforeCompleteWarningDto implements IReplyBeforeCompleteWarningDto {
    shouldWarn!: boolean | undefined;
    firstName!: string | undefined;
    waitingName!: string | undefined;
    waiterEmail!: string | undefined;
    suggestArmFollowUp!: boolean | undefined;
    noWatchableThread!: boolean | undefined;
    outcome!: ReplyWarningOutcome | undefined;
    newestOutboundSentAtUtc!: string | undefined;
    newestOutboundToName!: string | undefined;
    newestOutboundToAddress!: string | undefined;
    newestOutboundMessageId!: string | undefined;
    threadKey!: string | undefined;
    waitingThreadKey!: string | undefined;

    constructor(data?: IReplyBeforeCompleteWarningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.shouldWarn = _data["shouldWarn"];
            this.firstName = _data["firstName"];
            this.waitingName = _data["waitingName"];
            this.waiterEmail = _data["waiterEmail"];
            this.suggestArmFollowUp = _data["suggestArmFollowUp"];
            this.noWatchableThread = _data["noWatchableThread"];
            this.outcome = _data["outcome"];
            this.newestOutboundSentAtUtc = _data["newestOutboundSentAtUtc"];
            this.newestOutboundToName = _data["newestOutboundToName"];
            this.newestOutboundToAddress = _data["newestOutboundToAddress"];
            this.newestOutboundMessageId = _data["newestOutboundMessageId"];
            this.threadKey = _data["threadKey"];
            this.waitingThreadKey = _data["waitingThreadKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): ReplyBeforeCompleteWarningDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReplyBeforeCompleteWarningDto>(data, _mappings, ReplyBeforeCompleteWarningDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shouldWarn"] = this.shouldWarn;
        data["firstName"] = this.firstName;
        data["waitingName"] = this.waitingName;
        data["waiterEmail"] = this.waiterEmail;
        data["suggestArmFollowUp"] = this.suggestArmFollowUp;
        data["noWatchableThread"] = this.noWatchableThread;
        data["outcome"] = this.outcome;
        data["newestOutboundSentAtUtc"] = this.newestOutboundSentAtUtc;
        data["newestOutboundToName"] = this.newestOutboundToName;
        data["newestOutboundToAddress"] = this.newestOutboundToAddress;
        data["newestOutboundMessageId"] = this.newestOutboundMessageId;
        data["threadKey"] = this.threadKey;
        data["waitingThreadKey"] = this.waitingThreadKey;
        return data;
    }
}

export interface IReplyBeforeCompleteWarningDto {
    shouldWarn: boolean | undefined;
    firstName: string | undefined;
    waitingName: string | undefined;
    waiterEmail: string | undefined;
    suggestArmFollowUp: boolean | undefined;
    noWatchableThread: boolean | undefined;
    outcome: ReplyWarningOutcome | undefined;
    newestOutboundSentAtUtc: string | undefined;
    newestOutboundToName: string | undefined;
    newestOutboundToAddress: string | undefined;
    newestOutboundMessageId: string | undefined;
    threadKey: string | undefined;
    waitingThreadKey: string | undefined;
}

export class ReplyBeforeCompleteWarningDtoIHandleError implements IReplyBeforeCompleteWarningDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ReplyBeforeCompleteWarningDto | undefined;
    listOfEntities!: ReplyBeforeCompleteWarningDto[] | undefined;

    constructor(data?: IReplyBeforeCompleteWarningDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ReplyBeforeCompleteWarningDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ReplyBeforeCompleteWarningDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ReplyBeforeCompleteWarningDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReplyBeforeCompleteWarningDtoIHandleError>(data, _mappings, ReplyBeforeCompleteWarningDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReplyBeforeCompleteWarningDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ReplyBeforeCompleteWarningDto | undefined;
    listOfEntities: ReplyBeforeCompleteWarningDto[] | undefined;
}

export class CheckReplyBeforeCompleteInput implements ICheckReplyBeforeCompleteInput {
    taskId!: number | undefined;
    boundAi!: boolean | undefined;

    constructor(data?: ICheckReplyBeforeCompleteInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.boundAi = _data["boundAi"];
        }
    }

    static fromJS(data: any, _mappings?: any): CheckReplyBeforeCompleteInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckReplyBeforeCompleteInput>(data, _mappings, CheckReplyBeforeCompleteInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["boundAi"] = this.boundAi;
        return data;
    }
}

export interface ICheckReplyBeforeCompleteInput {
    taskId: number | undefined;
    boundAi: boolean | undefined;
}

export class ReplyAttachTarget implements IReplyAttachTarget {
    name!: string | undefined;
    driveId!: string | undefined;
    itemId!: string | undefined;
    siteId!: string | undefined;
    exists!: boolean | undefined;

    constructor(data?: IReplyAttachTarget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.driveId = _data["driveId"];
            this.itemId = _data["itemId"];
            this.siteId = _data["siteId"];
            this.exists = _data["exists"];
        }
    }

    static fromJS(data: any, _mappings?: any): ReplyAttachTarget | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReplyAttachTarget>(data, _mappings, ReplyAttachTarget);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["driveId"] = this.driveId;
        data["itemId"] = this.itemId;
        data["siteId"] = this.siteId;
        data["exists"] = this.exists;
        return data;
    }
}

export interface IReplyAttachTarget {
    name: string | undefined;
    driveId: string | undefined;
    itemId: string | undefined;
    siteId: string | undefined;
    exists: boolean | undefined;
}

export class ReplyAttachContextDto implements IReplyAttachContextDto {
    contact!: ReplyAttachTarget | undefined;
    company!: ReplyAttachTarget | undefined;
    project!: ReplyAttachTarget | undefined;

    constructor(data?: IReplyAttachContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contact = _data["contact"] ? ReplyAttachTarget.fromJS(_data["contact"], _mappings) : undefined as any;
            this.company = _data["company"] ? ReplyAttachTarget.fromJS(_data["company"], _mappings) : undefined as any;
            this.project = _data["project"] ? ReplyAttachTarget.fromJS(_data["project"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): ReplyAttachContextDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReplyAttachContextDto>(data, _mappings, ReplyAttachContextDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        data["company"] = this.company ? this.company.toJSON() : undefined as any;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        return data;
    }
}

export interface IReplyAttachContextDto {
    contact: ReplyAttachTarget | undefined;
    company: ReplyAttachTarget | undefined;
    project: ReplyAttachTarget | undefined;
}

export class ReplyAttachContextDtoIHandleError implements IReplyAttachContextDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ReplyAttachContextDto | undefined;
    listOfEntities!: ReplyAttachContextDto[] | undefined;

    constructor(data?: IReplyAttachContextDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ReplyAttachContextDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ReplyAttachContextDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ReplyAttachContextDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReplyAttachContextDtoIHandleError>(data, _mappings, ReplyAttachContextDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReplyAttachContextDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ReplyAttachContextDto | undefined;
    listOfEntities: ReplyAttachContextDto[] | undefined;
}

export class UnmergeEmailThreadInput implements IUnmergeEmailThreadInput {
    taskId!: number | undefined;
    threadKey!: string | undefined;

    constructor(data?: IUnmergeEmailThreadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.threadKey = _data["threadKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): UnmergeEmailThreadInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UnmergeEmailThreadInput>(data, _mappings, UnmergeEmailThreadInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["threadKey"] = this.threadKey;
        return data;
    }
}

export interface IUnmergeEmailThreadInput {
    taskId: number | undefined;
    threadKey: string | undefined;
}

export class UnmergeEmailThreadLeftAloneDto implements IUnmergeEmailThreadLeftAloneDto {
    field!: string | undefined;
    reason!: string | undefined;

    constructor(data?: IUnmergeEmailThreadLeftAloneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.field = _data["field"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any, _mappings?: any): UnmergeEmailThreadLeftAloneDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UnmergeEmailThreadLeftAloneDto>(data, _mappings, UnmergeEmailThreadLeftAloneDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IUnmergeEmailThreadLeftAloneDto {
    field: string | undefined;
    reason: string | undefined;
}

export class UnmergeEmailThreadResultDto implements IUnmergeEmailThreadResultDto {
    sourceTaskId!: number | undefined;
    newTaskId!: number | undefined;
    alreadyUnmerged!: boolean | undefined;
    movedIngestCount!: number | undefined;
    undoneAt!: string | undefined;
    undoneByUserId!: number | undefined;
    restored!: string[] | undefined;
    leftAlone!: UnmergeEmailThreadLeftAloneDto[] | undefined;
    notReversible!: string[] | undefined;
    modeLoweredToShadow!: boolean | undefined;
    message!: string | undefined;

    constructor(data?: IUnmergeEmailThreadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sourceTaskId = _data["sourceTaskId"];
            this.newTaskId = _data["newTaskId"];
            this.alreadyUnmerged = _data["alreadyUnmerged"];
            this.movedIngestCount = _data["movedIngestCount"];
            this.undoneAt = _data["undoneAt"];
            this.undoneByUserId = _data["undoneByUserId"];
            if (Array.isArray(_data["restored"])) {
                this.restored = [] as any;
                for (let item of _data["restored"])
                    this.restored!.push(item);
            }
            if (Array.isArray(_data["leftAlone"])) {
                this.leftAlone = [] as any;
                for (let item of _data["leftAlone"])
                    this.leftAlone!.push(UnmergeEmailThreadLeftAloneDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["notReversible"])) {
                this.notReversible = [] as any;
                for (let item of _data["notReversible"])
                    this.notReversible!.push(item);
            }
            this.modeLoweredToShadow = _data["modeLoweredToShadow"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any, _mappings?: any): UnmergeEmailThreadResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UnmergeEmailThreadResultDto>(data, _mappings, UnmergeEmailThreadResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceTaskId"] = this.sourceTaskId;
        data["newTaskId"] = this.newTaskId;
        data["alreadyUnmerged"] = this.alreadyUnmerged;
        data["movedIngestCount"] = this.movedIngestCount;
        data["undoneAt"] = this.undoneAt;
        data["undoneByUserId"] = this.undoneByUserId;
        if (Array.isArray(this.restored)) {
            data["restored"] = [];
            for (let item of this.restored)
                data["restored"].push(item);
        }
        if (Array.isArray(this.leftAlone)) {
            data["leftAlone"] = [];
            for (let item of this.leftAlone)
                data["leftAlone"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.notReversible)) {
            data["notReversible"] = [];
            for (let item of this.notReversible)
                data["notReversible"].push(item);
        }
        data["modeLoweredToShadow"] = this.modeLoweredToShadow;
        data["message"] = this.message;
        return data;
    }
}

export interface IUnmergeEmailThreadResultDto {
    sourceTaskId: number | undefined;
    newTaskId: number | undefined;
    alreadyUnmerged: boolean | undefined;
    movedIngestCount: number | undefined;
    undoneAt: string | undefined;
    undoneByUserId: number | undefined;
    restored: string[] | undefined;
    leftAlone: UnmergeEmailThreadLeftAloneDto[] | undefined;
    notReversible: string[] | undefined;
    modeLoweredToShadow: boolean | undefined;
    message: string | undefined;
}

export class UnmergeEmailThreadResultDtoIHandleError implements IUnmergeEmailThreadResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UnmergeEmailThreadResultDto | undefined;
    listOfEntities!: UnmergeEmailThreadResultDto[] | undefined;

    constructor(data?: IUnmergeEmailThreadResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UnmergeEmailThreadResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UnmergeEmailThreadResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UnmergeEmailThreadResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UnmergeEmailThreadResultDtoIHandleError>(data, _mappings, UnmergeEmailThreadResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUnmergeEmailThreadResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UnmergeEmailThreadResultDto | undefined;
    listOfEntities: UnmergeEmailThreadResultDto[] | undefined;
}

export class TaskMergeInfoItemDto implements ITaskMergeInfoItemDto {
    ingestId!: number | undefined;
    outcomeCode!: number | undefined;
    outcomeName!: string | undefined;
    outcomeText!: string | undefined;
    source!: string | undefined;
    rule!: number | undefined;
    confidence!: number | undefined;
    reason!: string | undefined;
    newQuote!: string | undefined;
    taskQuote!: string | undefined;
    guard!: string | undefined;
    tier!: string | undefined;
    reopened!: boolean | undefined;
    threadKey!: string | undefined;
    receivedAtUtc!: string | undefined;
    processedAtUtc!: string | undefined;
    mergedIntoTaskId!: number | undefined;
    undoneAtUtc!: string | undefined;
    undoneByUserId!: number | undefined;
    undoneByName!: string | undefined;

    constructor(data?: ITaskMergeInfoItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.ingestId = _data["ingestId"];
            this.outcomeCode = _data["outcomeCode"];
            this.outcomeName = _data["outcomeName"];
            this.outcomeText = _data["outcomeText"];
            this.source = _data["source"];
            this.rule = _data["rule"];
            this.confidence = _data["confidence"];
            this.reason = _data["reason"];
            this.newQuote = _data["newQuote"];
            this.taskQuote = _data["taskQuote"];
            this.guard = _data["guard"];
            this.tier = _data["tier"];
            this.reopened = _data["reopened"];
            this.threadKey = _data["threadKey"];
            this.receivedAtUtc = _data["receivedAtUtc"];
            this.processedAtUtc = _data["processedAtUtc"];
            this.mergedIntoTaskId = _data["mergedIntoTaskId"];
            this.undoneAtUtc = _data["undoneAtUtc"];
            this.undoneByUserId = _data["undoneByUserId"];
            this.undoneByName = _data["undoneByName"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskMergeInfoItemDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskMergeInfoItemDto>(data, _mappings, TaskMergeInfoItemDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingestId"] = this.ingestId;
        data["outcomeCode"] = this.outcomeCode;
        data["outcomeName"] = this.outcomeName;
        data["outcomeText"] = this.outcomeText;
        data["source"] = this.source;
        data["rule"] = this.rule;
        data["confidence"] = this.confidence;
        data["reason"] = this.reason;
        data["newQuote"] = this.newQuote;
        data["taskQuote"] = this.taskQuote;
        data["guard"] = this.guard;
        data["tier"] = this.tier;
        data["reopened"] = this.reopened;
        data["threadKey"] = this.threadKey;
        data["receivedAtUtc"] = this.receivedAtUtc;
        data["processedAtUtc"] = this.processedAtUtc;
        data["mergedIntoTaskId"] = this.mergedIntoTaskId;
        data["undoneAtUtc"] = this.undoneAtUtc;
        data["undoneByUserId"] = this.undoneByUserId;
        data["undoneByName"] = this.undoneByName;
        return data;
    }
}

export interface ITaskMergeInfoItemDto {
    ingestId: number | undefined;
    outcomeCode: number | undefined;
    outcomeName: string | undefined;
    outcomeText: string | undefined;
    source: string | undefined;
    rule: number | undefined;
    confidence: number | undefined;
    reason: string | undefined;
    newQuote: string | undefined;
    taskQuote: string | undefined;
    guard: string | undefined;
    tier: string | undefined;
    reopened: boolean | undefined;
    threadKey: string | undefined;
    receivedAtUtc: string | undefined;
    processedAtUtc: string | undefined;
    mergedIntoTaskId: number | undefined;
    undoneAtUtc: string | undefined;
    undoneByUserId: number | undefined;
    undoneByName: string | undefined;
}

export class TaskMergeInfoDto implements ITaskMergeInfoDto {
    taskId!: number | undefined;
    items!: TaskMergeInfoItemDto[] | undefined;
    truncated!: boolean | undefined;

    constructor(data?: ITaskMergeInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TaskMergeInfoItemDto.fromJS(item, _mappings));
            }
            this.truncated = _data["truncated"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskMergeInfoDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskMergeInfoDto>(data, _mappings, TaskMergeInfoDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["truncated"] = this.truncated;
        return data;
    }
}

export interface ITaskMergeInfoDto {
    taskId: number | undefined;
    items: TaskMergeInfoItemDto[] | undefined;
    truncated: boolean | undefined;
}

export class TaskMergeInfoDtoIHandleError implements ITaskMergeInfoDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskMergeInfoDto | undefined;
    listOfEntities!: TaskMergeInfoDto[] | undefined;

    constructor(data?: ITaskMergeInfoDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TaskMergeInfoDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TaskMergeInfoDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskMergeInfoDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskMergeInfoDtoIHandleError>(data, _mappings, TaskMergeInfoDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskMergeInfoDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskMergeInfoDto | undefined;
    listOfEntities: TaskMergeInfoDto[] | undefined;
}

export class ArmTaskFollowUpInput implements IArmTaskFollowUpInput {
    taskId!: number | undefined;
    timingKind!: string | undefined;
    timingValue!: string | undefined;
    anchorSentAtUtc!: string | undefined;
    origin!: string | undefined;
    expectsReply!: boolean | undefined;
    aiReason!: string | undefined;
    allowWithoutClient!: boolean | undefined;
    moveTaskDates!: boolean | undefined;
    threadKey!: string | undefined;

    constructor(data?: IArmTaskFollowUpInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.timingKind = _data["timingKind"];
            this.timingValue = _data["timingValue"];
            this.anchorSentAtUtc = _data["anchorSentAtUtc"];
            this.origin = _data["origin"];
            this.expectsReply = _data["expectsReply"];
            this.aiReason = _data["aiReason"];
            this.allowWithoutClient = _data["allowWithoutClient"];
            this.moveTaskDates = _data["moveTaskDates"];
            this.threadKey = _data["threadKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): ArmTaskFollowUpInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ArmTaskFollowUpInput>(data, _mappings, ArmTaskFollowUpInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["timingKind"] = this.timingKind;
        data["timingValue"] = this.timingValue;
        data["anchorSentAtUtc"] = this.anchorSentAtUtc;
        data["origin"] = this.origin;
        data["expectsReply"] = this.expectsReply;
        data["aiReason"] = this.aiReason;
        data["allowWithoutClient"] = this.allowWithoutClient;
        data["moveTaskDates"] = this.moveTaskDates;
        data["threadKey"] = this.threadKey;
        return data;
    }
}

export interface IArmTaskFollowUpInput {
    taskId: number | undefined;
    timingKind: string | undefined;
    timingValue: string | undefined;
    anchorSentAtUtc: string | undefined;
    origin: string | undefined;
    expectsReply: boolean | undefined;
    aiReason: string | undefined;
    allowWithoutClient: boolean | undefined;
    moveTaskDates: boolean | undefined;
    threadKey: string | undefined;
}

export enum TaskHandlingKind {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class ScheduleTaskFollowUpInput implements IScheduleTaskFollowUpInput {
    taskId!: number | undefined;
    timingKind!: string | undefined;
    timingValue!: string | undefined;
    anchorSentAtUtc!: string | undefined;
    origin!: string | undefined;
    expectsReply!: boolean | undefined;
    aiReason!: string | undefined;
    monitorReplies!: boolean | undefined;
    note!: string | undefined;
    threadKey!: string | undefined;
    handling!: TaskHandlingKind | undefined;
    keepUnansweredReply!: boolean | undefined;

    constructor(data?: IScheduleTaskFollowUpInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.timingKind = _data["timingKind"];
            this.timingValue = _data["timingValue"];
            this.anchorSentAtUtc = _data["anchorSentAtUtc"];
            this.origin = _data["origin"];
            this.expectsReply = _data["expectsReply"];
            this.aiReason = _data["aiReason"];
            this.monitorReplies = _data["monitorReplies"];
            this.note = _data["note"];
            this.threadKey = _data["threadKey"];
            this.handling = _data["handling"];
            this.keepUnansweredReply = _data["keepUnansweredReply"];
        }
    }

    static fromJS(data: any, _mappings?: any): ScheduleTaskFollowUpInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ScheduleTaskFollowUpInput>(data, _mappings, ScheduleTaskFollowUpInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["timingKind"] = this.timingKind;
        data["timingValue"] = this.timingValue;
        data["anchorSentAtUtc"] = this.anchorSentAtUtc;
        data["origin"] = this.origin;
        data["expectsReply"] = this.expectsReply;
        data["aiReason"] = this.aiReason;
        data["monitorReplies"] = this.monitorReplies;
        data["note"] = this.note;
        data["threadKey"] = this.threadKey;
        data["handling"] = this.handling;
        data["keepUnansweredReply"] = this.keepUnansweredReply;
        return data;
    }
}

export interface IScheduleTaskFollowUpInput {
    taskId: number | undefined;
    timingKind: string | undefined;
    timingValue: string | undefined;
    anchorSentAtUtc: string | undefined;
    origin: string | undefined;
    expectsReply: boolean | undefined;
    aiReason: string | undefined;
    monitorReplies: boolean | undefined;
    note: string | undefined;
    threadKey: string | undefined;
    handling: TaskHandlingKind | undefined;
    keepUnansweredReply: boolean | undefined;
}

export class ScheduleTaskFollowUpResult implements IScheduleTaskFollowUpResult {
    followUp!: TaskFollowUpDto | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    noteSaved!: boolean | undefined;
    clientAlreadyReplied!: boolean | undefined;

    constructor(data?: IScheduleTaskFollowUpResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.followUp = _data["followUp"] ? TaskFollowUpDto.fromJS(_data["followUp"], _mappings) : undefined as any;
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.noteSaved = _data["noteSaved"];
            this.clientAlreadyReplied = _data["clientAlreadyReplied"];
        }
    }

    static fromJS(data: any, _mappings?: any): ScheduleTaskFollowUpResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ScheduleTaskFollowUpResult>(data, _mappings, ScheduleTaskFollowUpResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["followUp"] = this.followUp ? this.followUp.toJSON() : undefined as any;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["noteSaved"] = this.noteSaved;
        data["clientAlreadyReplied"] = this.clientAlreadyReplied;
        return data;
    }
}

export interface IScheduleTaskFollowUpResult {
    followUp: TaskFollowUpDto | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    noteSaved: boolean | undefined;
    clientAlreadyReplied: boolean | undefined;
}

export class ScheduleTaskFollowUpResultIHandleError implements IScheduleTaskFollowUpResultIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ScheduleTaskFollowUpResult | undefined;
    listOfEntities!: ScheduleTaskFollowUpResult[] | undefined;

    constructor(data?: IScheduleTaskFollowUpResultIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ScheduleTaskFollowUpResult.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ScheduleTaskFollowUpResult.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ScheduleTaskFollowUpResultIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ScheduleTaskFollowUpResultIHandleError>(data, _mappings, ScheduleTaskFollowUpResultIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScheduleTaskFollowUpResultIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ScheduleTaskFollowUpResult | undefined;
    listOfEntities: ScheduleTaskFollowUpResult[] | undefined;
}

export class CompleteTaskWithoutFollowUpInput implements ICompleteTaskWithoutFollowUpInput {
    taskId!: number | undefined;
    note!: string | undefined;
    handling!: TaskHandlingKind | undefined;

    constructor(data?: ICompleteTaskWithoutFollowUpInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.note = _data["note"];
            this.handling = _data["handling"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompleteTaskWithoutFollowUpInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompleteTaskWithoutFollowUpInput>(data, _mappings, CompleteTaskWithoutFollowUpInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["note"] = this.note;
        data["handling"] = this.handling;
        return data;
    }
}

export interface ICompleteTaskWithoutFollowUpInput {
    taskId: number | undefined;
    note: string | undefined;
    handling: TaskHandlingKind | undefined;
}

export class CompleteTaskWithoutFollowUpResultDto implements ICompleteTaskWithoutFollowUpResultDto {
    completed!: boolean | undefined;
    noteSaved!: boolean | undefined;

    constructor(data?: ICompleteTaskWithoutFollowUpResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.completed = _data["completed"];
            this.noteSaved = _data["noteSaved"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompleteTaskWithoutFollowUpResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompleteTaskWithoutFollowUpResultDto>(data, _mappings, CompleteTaskWithoutFollowUpResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completed"] = this.completed;
        data["noteSaved"] = this.noteSaved;
        return data;
    }
}

export interface ICompleteTaskWithoutFollowUpResultDto {
    completed: boolean | undefined;
    noteSaved: boolean | undefined;
}

export class CompleteTaskWithoutFollowUpResultDtoIHandleError implements ICompleteTaskWithoutFollowUpResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CompleteTaskWithoutFollowUpResultDto | undefined;
    listOfEntities!: CompleteTaskWithoutFollowUpResultDto[] | undefined;

    constructor(data?: ICompleteTaskWithoutFollowUpResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CompleteTaskWithoutFollowUpResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CompleteTaskWithoutFollowUpResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CompleteTaskWithoutFollowUpResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompleteTaskWithoutFollowUpResultDtoIHandleError>(data, _mappings, CompleteTaskWithoutFollowUpResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICompleteTaskWithoutFollowUpResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CompleteTaskWithoutFollowUpResultDto | undefined;
    listOfEntities: CompleteTaskWithoutFollowUpResultDto[] | undefined;
}

export enum EmailAutomationKind {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum EmailAutomationAudience {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class EmailAutomationListItemDto implements IEmailAutomationListItemDto {
    id!: number | undefined;
    kind!: EmailAutomationKind | undefined;
    name!: string | undefined;
    description!: string | undefined;
    isEnabled!: boolean | undefined;
    sortOrder!: number | undefined;
    needsAdminReview!: boolean | undefined;
    isBuiltIn!: boolean | undefined;
    inboxTokens!: string[] | undefined;
    audience!: EmailAutomationAudience | undefined;
    tagInOutlook!: boolean | undefined;
    tagName!: string | undefined;
    tagColorKey!: string | undefined;

    constructor(data?: IEmailAutomationListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kind = _data["kind"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
            this.sortOrder = _data["sortOrder"];
            this.needsAdminReview = _data["needsAdminReview"];
            this.isBuiltIn = _data["isBuiltIn"];
            if (Array.isArray(_data["inboxTokens"])) {
                this.inboxTokens = [] as any;
                for (let item of _data["inboxTokens"])
                    this.inboxTokens!.push(item);
            }
            this.audience = _data["audience"];
            this.tagInOutlook = _data["tagInOutlook"];
            this.tagName = _data["tagName"];
            this.tagColorKey = _data["tagColorKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): EmailAutomationListItemDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmailAutomationListItemDto>(data, _mappings, EmailAutomationListItemDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kind"] = this.kind;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        data["sortOrder"] = this.sortOrder;
        data["needsAdminReview"] = this.needsAdminReview;
        data["isBuiltIn"] = this.isBuiltIn;
        if (Array.isArray(this.inboxTokens)) {
            data["inboxTokens"] = [];
            for (let item of this.inboxTokens)
                data["inboxTokens"].push(item);
        }
        data["audience"] = this.audience;
        data["tagInOutlook"] = this.tagInOutlook;
        data["tagName"] = this.tagName;
        data["tagColorKey"] = this.tagColorKey;
        return data;
    }
}

export interface IEmailAutomationListItemDto {
    id: number | undefined;
    kind: EmailAutomationKind | undefined;
    name: string | undefined;
    description: string | undefined;
    isEnabled: boolean | undefined;
    sortOrder: number | undefined;
    needsAdminReview: boolean | undefined;
    isBuiltIn: boolean | undefined;
    inboxTokens: string[] | undefined;
    audience: EmailAutomationAudience | undefined;
    tagInOutlook: boolean | undefined;
    tagName: string | undefined;
    tagColorKey: string | undefined;
}

export enum EmailAutomationHandler {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum EmailAutomationCreateTaskMode {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum EmailAutomationProjectMatchMode {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum EmailAutomationSectionMode {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum EmailAutomationSaveIntoMode {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum EmailAutomationMovedToProjectMode {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class EmailAutomationDto implements IEmailAutomationDto {
    id!: number | undefined;
    kind!: EmailAutomationKind | undefined;
    name!: string | undefined;
    isEnabled!: boolean | undefined;
    sortOrder!: number | undefined;
    description!: string | undefined;
    userWrittenText!: string | undefined;
    audience!: EmailAutomationAudience | undefined;
    inboxTokens!: string[] | undefined;
    handlerStrategy!: EmailAutomationHandler | undefined;
    handlerUserId!: number | undefined;
    handlerProjectRoleId!: number | undefined;
    notifyUserIds!: number[] | undefined;
    addSenderAsClient!: boolean | undefined;
    senderContactTypeId!: number | undefined;
    senderClientStageId!: number | undefined;
    createTaskMode!: EmailAutomationCreateTaskMode | undefined;
    projectMatchMode!: EmailAutomationProjectMatchMode | undefined;
    projectId!: number | undefined;
    sectionMode!: EmailAutomationSectionMode | undefined;
    sectionName!: string | undefined;
    saveEmail!: boolean | undefined;
    saveAttachments!: boolean | undefined;
    saveIntoMode!: EmailAutomationSaveIntoMode | undefined;
    movedToProjectMode!: EmailAutomationMovedToProjectMode | undefined;
    tagInOutlook!: boolean | undefined;
    tagName!: string | undefined;
    tagColorKey!: string | undefined;
    needsAdminReview!: boolean | undefined;
    isBuiltIn!: boolean | undefined;
    canDelete!: boolean | undefined;
    projectName!: string | undefined;
    acceptedOverlapAutomationIds!: number[] | undefined;

    constructor(data?: IEmailAutomationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kind = _data["kind"];
            this.name = _data["name"];
            this.isEnabled = _data["isEnabled"];
            this.sortOrder = _data["sortOrder"];
            this.description = _data["description"];
            this.userWrittenText = _data["userWrittenText"];
            this.audience = _data["audience"];
            if (Array.isArray(_data["inboxTokens"])) {
                this.inboxTokens = [] as any;
                for (let item of _data["inboxTokens"])
                    this.inboxTokens!.push(item);
            }
            this.handlerStrategy = _data["handlerStrategy"];
            this.handlerUserId = _data["handlerUserId"];
            this.handlerProjectRoleId = _data["handlerProjectRoleId"];
            if (Array.isArray(_data["notifyUserIds"])) {
                this.notifyUserIds = [] as any;
                for (let item of _data["notifyUserIds"])
                    this.notifyUserIds!.push(item);
            }
            this.addSenderAsClient = _data["addSenderAsClient"];
            this.senderContactTypeId = _data["senderContactTypeId"];
            this.senderClientStageId = _data["senderClientStageId"];
            this.createTaskMode = _data["createTaskMode"];
            this.projectMatchMode = _data["projectMatchMode"];
            this.projectId = _data["projectId"];
            this.sectionMode = _data["sectionMode"];
            this.sectionName = _data["sectionName"];
            this.saveEmail = _data["saveEmail"];
            this.saveAttachments = _data["saveAttachments"];
            this.saveIntoMode = _data["saveIntoMode"];
            this.movedToProjectMode = _data["movedToProjectMode"];
            this.tagInOutlook = _data["tagInOutlook"];
            this.tagName = _data["tagName"];
            this.tagColorKey = _data["tagColorKey"];
            this.needsAdminReview = _data["needsAdminReview"];
            this.isBuiltIn = _data["isBuiltIn"];
            this.canDelete = _data["canDelete"];
            this.projectName = _data["projectName"];
            if (Array.isArray(_data["acceptedOverlapAutomationIds"])) {
                this.acceptedOverlapAutomationIds = [] as any;
                for (let item of _data["acceptedOverlapAutomationIds"])
                    this.acceptedOverlapAutomationIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): EmailAutomationDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmailAutomationDto>(data, _mappings, EmailAutomationDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kind"] = this.kind;
        data["name"] = this.name;
        data["isEnabled"] = this.isEnabled;
        data["sortOrder"] = this.sortOrder;
        data["description"] = this.description;
        data["userWrittenText"] = this.userWrittenText;
        data["audience"] = this.audience;
        if (Array.isArray(this.inboxTokens)) {
            data["inboxTokens"] = [];
            for (let item of this.inboxTokens)
                data["inboxTokens"].push(item);
        }
        data["handlerStrategy"] = this.handlerStrategy;
        data["handlerUserId"] = this.handlerUserId;
        data["handlerProjectRoleId"] = this.handlerProjectRoleId;
        if (Array.isArray(this.notifyUserIds)) {
            data["notifyUserIds"] = [];
            for (let item of this.notifyUserIds)
                data["notifyUserIds"].push(item);
        }
        data["addSenderAsClient"] = this.addSenderAsClient;
        data["senderContactTypeId"] = this.senderContactTypeId;
        data["senderClientStageId"] = this.senderClientStageId;
        data["createTaskMode"] = this.createTaskMode;
        data["projectMatchMode"] = this.projectMatchMode;
        data["projectId"] = this.projectId;
        data["sectionMode"] = this.sectionMode;
        data["sectionName"] = this.sectionName;
        data["saveEmail"] = this.saveEmail;
        data["saveAttachments"] = this.saveAttachments;
        data["saveIntoMode"] = this.saveIntoMode;
        data["movedToProjectMode"] = this.movedToProjectMode;
        data["tagInOutlook"] = this.tagInOutlook;
        data["tagName"] = this.tagName;
        data["tagColorKey"] = this.tagColorKey;
        data["needsAdminReview"] = this.needsAdminReview;
        data["isBuiltIn"] = this.isBuiltIn;
        data["canDelete"] = this.canDelete;
        data["projectName"] = this.projectName;
        if (Array.isArray(this.acceptedOverlapAutomationIds)) {
            data["acceptedOverlapAutomationIds"] = [];
            for (let item of this.acceptedOverlapAutomationIds)
                data["acceptedOverlapAutomationIds"].push(item);
        }
        return data;
    }
}

export interface IEmailAutomationDto {
    id: number | undefined;
    kind: EmailAutomationKind | undefined;
    name: string | undefined;
    isEnabled: boolean | undefined;
    sortOrder: number | undefined;
    description: string | undefined;
    userWrittenText: string | undefined;
    audience: EmailAutomationAudience | undefined;
    inboxTokens: string[] | undefined;
    handlerStrategy: EmailAutomationHandler | undefined;
    handlerUserId: number | undefined;
    handlerProjectRoleId: number | undefined;
    notifyUserIds: number[] | undefined;
    addSenderAsClient: boolean | undefined;
    senderContactTypeId: number | undefined;
    senderClientStageId: number | undefined;
    createTaskMode: EmailAutomationCreateTaskMode | undefined;
    projectMatchMode: EmailAutomationProjectMatchMode | undefined;
    projectId: number | undefined;
    sectionMode: EmailAutomationSectionMode | undefined;
    sectionName: string | undefined;
    saveEmail: boolean | undefined;
    saveAttachments: boolean | undefined;
    saveIntoMode: EmailAutomationSaveIntoMode | undefined;
    movedToProjectMode: EmailAutomationMovedToProjectMode | undefined;
    tagInOutlook: boolean | undefined;
    tagName: string | undefined;
    tagColorKey: string | undefined;
    needsAdminReview: boolean | undefined;
    isBuiltIn: boolean | undefined;
    canDelete: boolean | undefined;
    projectName: string | undefined;
    acceptedOverlapAutomationIds: number[] | undefined;
}

export class InterpretAutomationInput implements IInterpretAutomationInput {
    text!: string | undefined;

    constructor(data?: IInterpretAutomationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any, _mappings?: any): InterpretAutomationInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InterpretAutomationInput>(data, _mappings, InterpretAutomationInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }
}

export interface IInterpretAutomationInput {
    text: string | undefined;
}

export class AutomationInterpretationDto implements IAutomationInterpretationDto {
    title!: string | undefined;
    description!: string | undefined;
    suggestedAudience!: EmailAutomationAudience | undefined;
    suggestedCreateTaskMode!: EmailAutomationCreateTaskMode | undefined;
    suggestedSaveEmail!: boolean | undefined;
    suggestedTagName!: string | undefined;

    constructor(data?: IAutomationInterpretationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.suggestedAudience = _data["suggestedAudience"];
            this.suggestedCreateTaskMode = _data["suggestedCreateTaskMode"];
            this.suggestedSaveEmail = _data["suggestedSaveEmail"];
            this.suggestedTagName = _data["suggestedTagName"];
        }
    }

    static fromJS(data: any, _mappings?: any): AutomationInterpretationDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AutomationInterpretationDto>(data, _mappings, AutomationInterpretationDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["suggestedAudience"] = this.suggestedAudience;
        data["suggestedCreateTaskMode"] = this.suggestedCreateTaskMode;
        data["suggestedSaveEmail"] = this.suggestedSaveEmail;
        data["suggestedTagName"] = this.suggestedTagName;
        return data;
    }
}

export interface IAutomationInterpretationDto {
    title: string | undefined;
    description: string | undefined;
    suggestedAudience: EmailAutomationAudience | undefined;
    suggestedCreateTaskMode: EmailAutomationCreateTaskMode | undefined;
    suggestedSaveEmail: boolean | undefined;
    suggestedTagName: string | undefined;
}

export class InterpretAutomationResultDto implements IInterpretAutomationResultDto {
    interpretations!: AutomationInterpretationDto[] | undefined;
    aiUnavailable!: boolean | undefined;
    userWrittenText!: string | undefined;

    constructor(data?: IInterpretAutomationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["interpretations"])) {
                this.interpretations = [] as any;
                for (let item of _data["interpretations"])
                    this.interpretations!.push(AutomationInterpretationDto.fromJS(item, _mappings));
            }
            this.aiUnavailable = _data["aiUnavailable"];
            this.userWrittenText = _data["userWrittenText"];
        }
    }

    static fromJS(data: any, _mappings?: any): InterpretAutomationResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InterpretAutomationResultDto>(data, _mappings, InterpretAutomationResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.interpretations)) {
            data["interpretations"] = [];
            for (let item of this.interpretations)
                data["interpretations"].push(item ? item.toJSON() : undefined as any);
        }
        data["aiUnavailable"] = this.aiUnavailable;
        data["userWrittenText"] = this.userWrittenText;
        return data;
    }
}

export interface IInterpretAutomationResultDto {
    interpretations: AutomationInterpretationDto[] | undefined;
    aiUnavailable: boolean | undefined;
    userWrittenText: string | undefined;
}

export class CheckAutomationOverlapInput implements ICheckAutomationOverlapInput {
    id!: number | undefined;
    description!: string | undefined;
    audience!: EmailAutomationAudience | undefined;

    constructor(data?: ICheckAutomationOverlapInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.audience = _data["audience"];
        }
    }

    static fromJS(data: any, _mappings?: any): CheckAutomationOverlapInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckAutomationOverlapInput>(data, _mappings, CheckAutomationOverlapInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["audience"] = this.audience;
        return data;
    }
}

export interface ICheckAutomationOverlapInput {
    id: number | undefined;
    description: string | undefined;
    audience: EmailAutomationAudience | undefined;
}

export class AutomationOverlapDto implements IAutomationOverlapDto {
    id!: number | undefined;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: IAutomationOverlapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any, _mappings?: any): AutomationOverlapDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AutomationOverlapDto>(data, _mappings, AutomationOverlapDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IAutomationOverlapDto {
    id: number | undefined;
    name: string | undefined;
    description: string | undefined;
}

export class CheckAutomationOverlapResultDto implements ICheckAutomationOverlapResultDto {
    overlaps!: AutomationOverlapDto[] | undefined;
    checkUnavailable!: boolean | undefined;

    constructor(data?: ICheckAutomationOverlapResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["overlaps"])) {
                this.overlaps = [] as any;
                for (let item of _data["overlaps"])
                    this.overlaps!.push(AutomationOverlapDto.fromJS(item, _mappings));
            }
            this.checkUnavailable = _data["checkUnavailable"];
        }
    }

    static fromJS(data: any, _mappings?: any): CheckAutomationOverlapResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckAutomationOverlapResultDto>(data, _mappings, CheckAutomationOverlapResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.overlaps)) {
            data["overlaps"] = [];
            for (let item of this.overlaps)
                data["overlaps"].push(item ? item.toJSON() : undefined as any);
        }
        data["checkUnavailable"] = this.checkUnavailable;
        return data;
    }
}

export interface ICheckAutomationOverlapResultDto {
    overlaps: AutomationOverlapDto[] | undefined;
    checkUnavailable: boolean | undefined;
}

export class EmailAutomationSettingsDto implements IEmailAutomationSettingsDto {
    isEnabled!: boolean | undefined;
    catchNewClientInquiries!: boolean | undefined;
    inquiryAssigneeUserId!: number | undefined;
    inquiryWatcherUserIds!: number[] | undefined;
    inquiryContactTypeId!: number | undefined;
    inquiryStartingStageId!: number | undefined;
    screenSelectedInboxesOnly!: boolean | undefined;
    inquiryScreeningUserIds!: number[] | undefined;
    catchClientResponses!: boolean | undefined;
    autoMatchTasksToProjects!: boolean | undefined;
    fileEmails!: boolean | undefined;
    tagFiledEmails!: boolean | undefined;
    personalInboxesEnabled!: boolean | undefined;
    fileIntoCompanyFolder!: boolean | undefined;
    moveEmailOnProjectAssign!: boolean | undefined;
    leadConfidenceThreshold!: number | undefined;
    defaultTaskType!: number | undefined;
    internalDomain!: string | undefined;

    constructor(data?: IEmailAutomationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.catchNewClientInquiries = _data["catchNewClientInquiries"];
            this.inquiryAssigneeUserId = _data["inquiryAssigneeUserId"];
            if (Array.isArray(_data["inquiryWatcherUserIds"])) {
                this.inquiryWatcherUserIds = [] as any;
                for (let item of _data["inquiryWatcherUserIds"])
                    this.inquiryWatcherUserIds!.push(item);
            }
            this.inquiryContactTypeId = _data["inquiryContactTypeId"];
            this.inquiryStartingStageId = _data["inquiryStartingStageId"];
            this.screenSelectedInboxesOnly = _data["screenSelectedInboxesOnly"];
            if (Array.isArray(_data["inquiryScreeningUserIds"])) {
                this.inquiryScreeningUserIds = [] as any;
                for (let item of _data["inquiryScreeningUserIds"])
                    this.inquiryScreeningUserIds!.push(item);
            }
            this.catchClientResponses = _data["catchClientResponses"];
            this.autoMatchTasksToProjects = _data["autoMatchTasksToProjects"];
            this.fileEmails = _data["fileEmails"];
            this.tagFiledEmails = _data["tagFiledEmails"];
            this.personalInboxesEnabled = _data["personalInboxesEnabled"];
            this.fileIntoCompanyFolder = _data["fileIntoCompanyFolder"];
            this.moveEmailOnProjectAssign = _data["moveEmailOnProjectAssign"];
            this.leadConfidenceThreshold = _data["leadConfidenceThreshold"];
            this.defaultTaskType = _data["defaultTaskType"];
            this.internalDomain = _data["internalDomain"];
        }
    }

    static fromJS(data: any, _mappings?: any): EmailAutomationSettingsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmailAutomationSettingsDto>(data, _mappings, EmailAutomationSettingsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["catchNewClientInquiries"] = this.catchNewClientInquiries;
        data["inquiryAssigneeUserId"] = this.inquiryAssigneeUserId;
        if (Array.isArray(this.inquiryWatcherUserIds)) {
            data["inquiryWatcherUserIds"] = [];
            for (let item of this.inquiryWatcherUserIds)
                data["inquiryWatcherUserIds"].push(item);
        }
        data["inquiryContactTypeId"] = this.inquiryContactTypeId;
        data["inquiryStartingStageId"] = this.inquiryStartingStageId;
        data["screenSelectedInboxesOnly"] = this.screenSelectedInboxesOnly;
        if (Array.isArray(this.inquiryScreeningUserIds)) {
            data["inquiryScreeningUserIds"] = [];
            for (let item of this.inquiryScreeningUserIds)
                data["inquiryScreeningUserIds"].push(item);
        }
        data["catchClientResponses"] = this.catchClientResponses;
        data["autoMatchTasksToProjects"] = this.autoMatchTasksToProjects;
        data["fileEmails"] = this.fileEmails;
        data["tagFiledEmails"] = this.tagFiledEmails;
        data["personalInboxesEnabled"] = this.personalInboxesEnabled;
        data["fileIntoCompanyFolder"] = this.fileIntoCompanyFolder;
        data["moveEmailOnProjectAssign"] = this.moveEmailOnProjectAssign;
        data["leadConfidenceThreshold"] = this.leadConfidenceThreshold;
        data["defaultTaskType"] = this.defaultTaskType;
        data["internalDomain"] = this.internalDomain;
        return data;
    }
}

export interface IEmailAutomationSettingsDto {
    isEnabled: boolean | undefined;
    catchNewClientInquiries: boolean | undefined;
    inquiryAssigneeUserId: number | undefined;
    inquiryWatcherUserIds: number[] | undefined;
    inquiryContactTypeId: number | undefined;
    inquiryStartingStageId: number | undefined;
    screenSelectedInboxesOnly: boolean | undefined;
    inquiryScreeningUserIds: number[] | undefined;
    catchClientResponses: boolean | undefined;
    autoMatchTasksToProjects: boolean | undefined;
    fileEmails: boolean | undefined;
    tagFiledEmails: boolean | undefined;
    personalInboxesEnabled: boolean | undefined;
    fileIntoCompanyFolder: boolean | undefined;
    moveEmailOnProjectAssign: boolean | undefined;
    leadConfidenceThreshold: number | undefined;
    defaultTaskType: number | undefined;
    internalDomain: string | undefined;
}

export class UserEmailAutomationSettingsDto implements IUserEmailAutomationSettingsDto {
    emailProcessingEnabled!: boolean | undefined;
    processFlaggedEmailsEnabled!: boolean | undefined;

    constructor(data?: IUserEmailAutomationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.emailProcessingEnabled = _data["emailProcessingEnabled"];
            this.processFlaggedEmailsEnabled = _data["processFlaggedEmailsEnabled"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserEmailAutomationSettingsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserEmailAutomationSettingsDto>(data, _mappings, UserEmailAutomationSettingsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailProcessingEnabled"] = this.emailProcessingEnabled;
        data["processFlaggedEmailsEnabled"] = this.processFlaggedEmailsEnabled;
        return data;
    }
}

export interface IUserEmailAutomationSettingsDto {
    emailProcessingEnabled: boolean | undefined;
    processFlaggedEmailsEnabled: boolean | undefined;
}

export class ProbeMailboxResult implements IProbeMailboxResult {
    canRead!: boolean | undefined;
    reason!: string | undefined;

    constructor(data?: IProbeMailboxResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.canRead = _data["canRead"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProbeMailboxResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProbeMailboxResult>(data, _mappings, ProbeMailboxResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IProbeMailboxResult {
    canRead: boolean | undefined;
    reason: string | undefined;
}

export class ProbeMailboxResultIHandleError implements IProbeMailboxResultIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProbeMailboxResult | undefined;
    listOfEntities!: ProbeMailboxResult[] | undefined;

    constructor(data?: IProbeMailboxResultIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProbeMailboxResult.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProbeMailboxResult.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProbeMailboxResultIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProbeMailboxResultIHandleError>(data, _mappings, ProbeMailboxResultIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProbeMailboxResultIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProbeMailboxResult | undefined;
    listOfEntities: ProbeMailboxResult[] | undefined;
}

export enum SharedInboxMode {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ConnectSharedInboxInput implements IConnectSharedInboxInput {
    address!: string | undefined;
    displayName!: string | undefined;
    mode!: SharedInboxMode | undefined;
    defaultAssigneeUserId!: number | undefined;
    defaultProjectId!: number | undefined;

    constructor(data?: IConnectSharedInboxInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.address = _data["address"];
            this.displayName = _data["displayName"];
            this.mode = _data["mode"];
            this.defaultAssigneeUserId = _data["defaultAssigneeUserId"];
            this.defaultProjectId = _data["defaultProjectId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConnectSharedInboxInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConnectSharedInboxInput>(data, _mappings, ConnectSharedInboxInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["displayName"] = this.displayName;
        data["mode"] = this.mode;
        data["defaultAssigneeUserId"] = this.defaultAssigneeUserId;
        data["defaultProjectId"] = this.defaultProjectId;
        return data;
    }
}

export interface IConnectSharedInboxInput {
    address: string | undefined;
    displayName: string | undefined;
    mode: SharedInboxMode | undefined;
    defaultAssigneeUserId: number | undefined;
    defaultProjectId: number | undefined;
}

export enum SharedInboxConnectionState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class SharedInboxDto implements ISharedInboxDto {
    id!: number | undefined;
    mailboxAddress!: string | undefined;
    displayName!: string | undefined;
    mode!: SharedInboxMode | undefined;
    defaultAssigneeUserId!: number | undefined;
    defaultProjectId!: number | undefined;
    connectionState!: SharedInboxConnectionState | undefined;
    isActive!: boolean | undefined;
    activeWatcherUserId!: number | undefined;
    activeWatcherName!: string | undefined;
    standbyCount!: number | undefined;

    constructor(data?: ISharedInboxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mailboxAddress = _data["mailboxAddress"];
            this.displayName = _data["displayName"];
            this.mode = _data["mode"];
            this.defaultAssigneeUserId = _data["defaultAssigneeUserId"];
            this.defaultProjectId = _data["defaultProjectId"];
            this.connectionState = _data["connectionState"];
            this.isActive = _data["isActive"];
            this.activeWatcherUserId = _data["activeWatcherUserId"];
            this.activeWatcherName = _data["activeWatcherName"];
            this.standbyCount = _data["standbyCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): SharedInboxDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SharedInboxDto>(data, _mappings, SharedInboxDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mailboxAddress"] = this.mailboxAddress;
        data["displayName"] = this.displayName;
        data["mode"] = this.mode;
        data["defaultAssigneeUserId"] = this.defaultAssigneeUserId;
        data["defaultProjectId"] = this.defaultProjectId;
        data["connectionState"] = this.connectionState;
        data["isActive"] = this.isActive;
        data["activeWatcherUserId"] = this.activeWatcherUserId;
        data["activeWatcherName"] = this.activeWatcherName;
        data["standbyCount"] = this.standbyCount;
        return data;
    }
}

export interface ISharedInboxDto {
    id: number | undefined;
    mailboxAddress: string | undefined;
    displayName: string | undefined;
    mode: SharedInboxMode | undefined;
    defaultAssigneeUserId: number | undefined;
    defaultProjectId: number | undefined;
    connectionState: SharedInboxConnectionState | undefined;
    isActive: boolean | undefined;
    activeWatcherUserId: number | undefined;
    activeWatcherName: string | undefined;
    standbyCount: number | undefined;
}

export class SharedInboxDtoIHandleError implements ISharedInboxDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SharedInboxDto | undefined;
    listOfEntities!: SharedInboxDto[] | undefined;

    constructor(data?: ISharedInboxDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SharedInboxDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SharedInboxDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SharedInboxDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SharedInboxDtoIHandleError>(data, _mappings, SharedInboxDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISharedInboxDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SharedInboxDto | undefined;
    listOfEntities: SharedInboxDto[] | undefined;
}

export class UpdateSharedInboxInput implements IUpdateSharedInboxInput {
    id!: number | undefined;
    mode!: SharedInboxMode | undefined;
    defaultAssigneeUserId!: number | undefined;
    defaultProjectId!: number | undefined;

    constructor(data?: IUpdateSharedInboxInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mode = _data["mode"];
            this.defaultAssigneeUserId = _data["defaultAssigneeUserId"];
            this.defaultProjectId = _data["defaultProjectId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateSharedInboxInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateSharedInboxInput>(data, _mappings, UpdateSharedInboxInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mode"] = this.mode;
        data["defaultAssigneeUserId"] = this.defaultAssigneeUserId;
        data["defaultProjectId"] = this.defaultProjectId;
        return data;
    }
}

export interface IUpdateSharedInboxInput {
    id: number | undefined;
    mode: SharedInboxMode | undefined;
    defaultAssigneeUserId: number | undefined;
    defaultProjectId: number | undefined;
}

export class SharedInboxDtoListIHandleError implements ISharedInboxDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SharedInboxDto[] | undefined;
    listOfEntities!: SharedInboxDto[][] | undefined;

    constructor(data?: ISharedInboxDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(SharedInboxDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SharedInboxDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SharedInboxDtoListIHandleError>(data, _mappings, SharedInboxDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ISharedInboxDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SharedInboxDto[] | undefined;
    listOfEntities: SharedInboxDto[][] | undefined;
}

export enum EventDeleteScope {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class DeclineEventInput implements IDeclineEventInput {
    eventId!: number | undefined;
    scope!: EventDeleteScope | undefined;

    constructor(data?: IDeclineEventInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.scope = _data["scope"];
        }
    }

    static fromJS(data: any, _mappings?: any): DeclineEventInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DeclineEventInput>(data, _mappings, DeclineEventInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["scope"] = this.scope;
        return data;
    }
}

export interface IDeclineEventInput {
    eventId: number | undefined;
    scope: EventDeleteScope | undefined;
}

export enum EventEditScope {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ConfirmEventProjectInput implements IConfirmEventProjectInput {
    eventId!: number | undefined;
    projectId!: number | undefined;
    scope!: EventEditScope | undefined;

    constructor(data?: IConfirmEventProjectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.projectId = _data["projectId"];
            this.scope = _data["scope"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConfirmEventProjectInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfirmEventProjectInput>(data, _mappings, ConfirmEventProjectInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["projectId"] = this.projectId;
        data["scope"] = this.scope;
        return data;
    }
}

export interface IConfirmEventProjectInput {
    eventId: number | undefined;
    projectId: number | undefined;
    scope: EventEditScope | undefined;
}

export enum EventClientKind {
    _1 = 1,
    _2 = 2,
}

export enum EventLocationMode {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum EventSyncState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum EventOrigin {
    _1 = 1,
    _2 = 2,
}

export class EventProjectCandidateDto implements IEventProjectCandidateDto {
    projectId!: number | undefined;
    projectName!: string | undefined;

    constructor(data?: IEventProjectCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any, _mappings?: any): EventProjectCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EventProjectCandidateDto>(data, _mappings, EventProjectCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IEventProjectCandidateDto {
    projectId: number | undefined;
    projectName: string | undefined;
}

export enum EventAttendeeRole {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum EventRsvpStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class EventAttendeeDto implements IEventAttendeeDto {
    id!: number | undefined;
    role!: EventAttendeeRole | undefined;
    userId!: number | undefined;
    name!: string | undefined;
    email!: string | undefined;
    profilePictureUrl!: string | undefined;
    rsvp!: EventRsvpStatus | undefined;

    constructor(data?: IEventAttendeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.role = _data["role"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.rsvp = _data["rsvp"];
        }
    }

    static fromJS(data: any, _mappings?: any): EventAttendeeDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EventAttendeeDto>(data, _mappings, EventAttendeeDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["role"] = this.role;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["rsvp"] = this.rsvp;
        return data;
    }
}

export interface IEventAttendeeDto {
    id: number | undefined;
    role: EventAttendeeRole | undefined;
    userId: number | undefined;
    name: string | undefined;
    email: string | undefined;
    profilePictureUrl: string | undefined;
    rsvp: EventRsvpStatus | undefined;
}

export enum EventOccurrenceType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum RecurrenceFrequency {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum RecurrenceMonthMode {
    _1 = 1,
    _2 = 2,
}

export enum RecurrenceEndMode {
    _1 = 1,
    _2 = 2,
}

export class RecurrencePattern implements IRecurrencePattern {
    frequency!: RecurrenceFrequency | undefined;
    interval!: number | undefined;
    daysOfWeek!: number[] | undefined;
    monthMode!: RecurrenceMonthMode | undefined;
    dayOfMonth!: number | undefined;
    weekIndex!: number | undefined;
    month!: number | undefined;
    endMode!: RecurrenceEndMode | undefined;
    endDate!: string | undefined;

    constructor(data?: IRecurrencePattern) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.frequency = _data["frequency"];
            this.interval = _data["interval"];
            if (Array.isArray(_data["daysOfWeek"])) {
                this.daysOfWeek = [] as any;
                for (let item of _data["daysOfWeek"])
                    this.daysOfWeek!.push(item);
            }
            this.monthMode = _data["monthMode"];
            this.dayOfMonth = _data["dayOfMonth"];
            this.weekIndex = _data["weekIndex"];
            this.month = _data["month"];
            this.endMode = _data["endMode"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecurrencePattern | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecurrencePattern>(data, _mappings, RecurrencePattern);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frequency"] = this.frequency;
        data["interval"] = this.interval;
        if (Array.isArray(this.daysOfWeek)) {
            data["daysOfWeek"] = [];
            for (let item of this.daysOfWeek)
                data["daysOfWeek"].push(item);
        }
        data["monthMode"] = this.monthMode;
        data["dayOfMonth"] = this.dayOfMonth;
        data["weekIndex"] = this.weekIndex;
        data["month"] = this.month;
        data["endMode"] = this.endMode;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IRecurrencePattern {
    frequency: RecurrenceFrequency | undefined;
    interval: number | undefined;
    daysOfWeek: number[] | undefined;
    monthMode: RecurrenceMonthMode | undefined;
    dayOfMonth: number | undefined;
    weekIndex: number | undefined;
    month: number | undefined;
    endMode: RecurrenceEndMode | undefined;
    endDate: string | undefined;
}

export class EventDto implements IEventDto {
    id!: number | undefined;
    eventTypeId!: number | undefined;
    typeName!: string | undefined;
    typeColor!: string | undefined;
    marksOutOfOffice!: boolean | undefined;
    projectOnForm!: boolean | undefined;
    clientOnForm!: boolean | undefined;
    name!: string | undefined;
    isNameOverridden!: boolean | undefined;
    description!: string | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    clientId!: number | undefined;
    clientName!: string | undefined;
    clientKind!: EventClientKind | undefined;
    linkedTaskId!: number | undefined;
    linkedTaskName!: string | undefined;
    organizerUserId!: number | undefined;
    organizerName!: string | undefined;
    organizerProfilePictureUrl!: string | undefined;
    isAllDay!: boolean | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    timeZone!: string | undefined;
    eventTimeZone!: string | undefined;
    locationMode!: EventLocationMode | undefined;
    locationAddress!: string | undefined;
    locationCounty!: string | undefined;
    locationAddressData!: string | undefined;
    locationAddressIsInherited!: boolean | undefined;
    locationJoinLink!: string | undefined;
    isBillable!: boolean | undefined;
    syncState!: EventSyncState | undefined;
    origin!: EventOrigin | undefined;
    isBusyOnly!: boolean | undefined;
    isMine!: boolean | undefined;
    organizerEmail!: string | undefined;
    canEdit!: boolean | undefined;
    isAttendee!: boolean | undefined;
    projectCandidateOptions!: EventProjectCandidateDto[] | undefined;
    attendees!: EventAttendeeDto[] | undefined;
    isRecurring!: boolean | undefined;
    occurrenceType!: EventOccurrenceType | undefined;
    seriesMasterId!: number | undefined;
    originalStart!: string | undefined;
    isException!: boolean | undefined;
    recurrence!: RecurrencePattern | undefined;
    recurrenceSummary!: string | undefined;
    companyPeopleOnEvent!: string[] | undefined;

    constructor(data?: IEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventTypeId = _data["eventTypeId"];
            this.typeName = _data["typeName"];
            this.typeColor = _data["typeColor"];
            this.marksOutOfOffice = _data["marksOutOfOffice"];
            this.projectOnForm = _data["projectOnForm"];
            this.clientOnForm = _data["clientOnForm"];
            this.name = _data["name"];
            this.isNameOverridden = _data["isNameOverridden"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.clientKind = _data["clientKind"];
            this.linkedTaskId = _data["linkedTaskId"];
            this.linkedTaskName = _data["linkedTaskName"];
            this.organizerUserId = _data["organizerUserId"];
            this.organizerName = _data["organizerName"];
            this.organizerProfilePictureUrl = _data["organizerProfilePictureUrl"];
            this.isAllDay = _data["isAllDay"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.timeZone = _data["timeZone"];
            this.eventTimeZone = _data["eventTimeZone"];
            this.locationMode = _data["locationMode"];
            this.locationAddress = _data["locationAddress"];
            this.locationCounty = _data["locationCounty"];
            this.locationAddressData = _data["locationAddressData"];
            this.locationAddressIsInherited = _data["locationAddressIsInherited"];
            this.locationJoinLink = _data["locationJoinLink"];
            this.isBillable = _data["isBillable"];
            this.syncState = _data["syncState"];
            this.origin = _data["origin"];
            this.isBusyOnly = _data["isBusyOnly"];
            this.isMine = _data["isMine"];
            this.organizerEmail = _data["organizerEmail"];
            this.canEdit = _data["canEdit"];
            this.isAttendee = _data["isAttendee"];
            if (Array.isArray(_data["projectCandidateOptions"])) {
                this.projectCandidateOptions = [] as any;
                for (let item of _data["projectCandidateOptions"])
                    this.projectCandidateOptions!.push(EventProjectCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["attendees"])) {
                this.attendees = [] as any;
                for (let item of _data["attendees"])
                    this.attendees!.push(EventAttendeeDto.fromJS(item, _mappings));
            }
            this.isRecurring = _data["isRecurring"];
            this.occurrenceType = _data["occurrenceType"];
            this.seriesMasterId = _data["seriesMasterId"];
            this.originalStart = _data["originalStart"];
            this.isException = _data["isException"];
            this.recurrence = _data["recurrence"] ? RecurrencePattern.fromJS(_data["recurrence"], _mappings) : undefined as any;
            this.recurrenceSummary = _data["recurrenceSummary"];
            if (Array.isArray(_data["companyPeopleOnEvent"])) {
                this.companyPeopleOnEvent = [] as any;
                for (let item of _data["companyPeopleOnEvent"])
                    this.companyPeopleOnEvent!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): EventDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EventDto>(data, _mappings, EventDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventTypeId"] = this.eventTypeId;
        data["typeName"] = this.typeName;
        data["typeColor"] = this.typeColor;
        data["marksOutOfOffice"] = this.marksOutOfOffice;
        data["projectOnForm"] = this.projectOnForm;
        data["clientOnForm"] = this.clientOnForm;
        data["name"] = this.name;
        data["isNameOverridden"] = this.isNameOverridden;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["clientKind"] = this.clientKind;
        data["linkedTaskId"] = this.linkedTaskId;
        data["linkedTaskName"] = this.linkedTaskName;
        data["organizerUserId"] = this.organizerUserId;
        data["organizerName"] = this.organizerName;
        data["organizerProfilePictureUrl"] = this.organizerProfilePictureUrl;
        data["isAllDay"] = this.isAllDay;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["timeZone"] = this.timeZone;
        data["eventTimeZone"] = this.eventTimeZone;
        data["locationMode"] = this.locationMode;
        data["locationAddress"] = this.locationAddress;
        data["locationCounty"] = this.locationCounty;
        data["locationAddressData"] = this.locationAddressData;
        data["locationAddressIsInherited"] = this.locationAddressIsInherited;
        data["locationJoinLink"] = this.locationJoinLink;
        data["isBillable"] = this.isBillable;
        data["syncState"] = this.syncState;
        data["origin"] = this.origin;
        data["isBusyOnly"] = this.isBusyOnly;
        data["isMine"] = this.isMine;
        data["organizerEmail"] = this.organizerEmail;
        data["canEdit"] = this.canEdit;
        data["isAttendee"] = this.isAttendee;
        if (Array.isArray(this.projectCandidateOptions)) {
            data["projectCandidateOptions"] = [];
            for (let item of this.projectCandidateOptions)
                data["projectCandidateOptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attendees)) {
            data["attendees"] = [];
            for (let item of this.attendees)
                data["attendees"].push(item ? item.toJSON() : undefined as any);
        }
        data["isRecurring"] = this.isRecurring;
        data["occurrenceType"] = this.occurrenceType;
        data["seriesMasterId"] = this.seriesMasterId;
        data["originalStart"] = this.originalStart;
        data["isException"] = this.isException;
        data["recurrence"] = this.recurrence ? this.recurrence.toJSON() : undefined as any;
        data["recurrenceSummary"] = this.recurrenceSummary;
        if (Array.isArray(this.companyPeopleOnEvent)) {
            data["companyPeopleOnEvent"] = [];
            for (let item of this.companyPeopleOnEvent)
                data["companyPeopleOnEvent"].push(item);
        }
        return data;
    }
}

export interface IEventDto {
    id: number | undefined;
    eventTypeId: number | undefined;
    typeName: string | undefined;
    typeColor: string | undefined;
    marksOutOfOffice: boolean | undefined;
    projectOnForm: boolean | undefined;
    clientOnForm: boolean | undefined;
    name: string | undefined;
    isNameOverridden: boolean | undefined;
    description: string | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    clientId: number | undefined;
    clientName: string | undefined;
    clientKind: EventClientKind | undefined;
    linkedTaskId: number | undefined;
    linkedTaskName: string | undefined;
    organizerUserId: number | undefined;
    organizerName: string | undefined;
    organizerProfilePictureUrl: string | undefined;
    isAllDay: boolean | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    timeZone: string | undefined;
    eventTimeZone: string | undefined;
    locationMode: EventLocationMode | undefined;
    locationAddress: string | undefined;
    locationCounty: string | undefined;
    locationAddressData: string | undefined;
    locationAddressIsInherited: boolean | undefined;
    locationJoinLink: string | undefined;
    isBillable: boolean | undefined;
    syncState: EventSyncState | undefined;
    origin: EventOrigin | undefined;
    isBusyOnly: boolean | undefined;
    isMine: boolean | undefined;
    organizerEmail: string | undefined;
    canEdit: boolean | undefined;
    isAttendee: boolean | undefined;
    projectCandidateOptions: EventProjectCandidateDto[] | undefined;
    attendees: EventAttendeeDto[] | undefined;
    isRecurring: boolean | undefined;
    occurrenceType: EventOccurrenceType | undefined;
    seriesMasterId: number | undefined;
    originalStart: string | undefined;
    isException: boolean | undefined;
    recurrence: RecurrencePattern | undefined;
    recurrenceSummary: string | undefined;
    companyPeopleOnEvent: string[] | undefined;
}

export class BookableUserDto implements IBookableUserDto {
    id!: number | undefined;
    name!: string | undefined;

    constructor(data?: IBookableUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): BookableUserDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BookableUserDto>(data, _mappings, BookableUserDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBookableUserDto {
    id: number | undefined;
    name: string | undefined;
}

export class CalendarTimeZoneDto implements ICalendarTimeZoneDto {
    id!: string | undefined;
    name!: string | undefined;

    constructor(data?: ICalendarTimeZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): CalendarTimeZoneDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CalendarTimeZoneDto>(data, _mappings, CalendarTimeZoneDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICalendarTimeZoneDto {
    id: string | undefined;
    name: string | undefined;
}

export class EventProjectClientDto implements IEventProjectClientDto {
    clientId!: number | undefined;
    kind!: EventClientKind | undefined;

    constructor(data?: IEventProjectClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.kind = _data["kind"];
        }
    }

    static fromJS(data: any, _mappings?: any): EventProjectClientDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EventProjectClientDto>(data, _mappings, EventProjectClientDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["kind"] = this.kind;
        return data;
    }
}

export interface IEventProjectClientDto {
    clientId: number | undefined;
    kind: EventClientKind | undefined;
}

export class ClientAddressOptionDto implements IClientAddressOptionDto {
    typeLabel!: string | undefined;
    address!: string | undefined;
    addressData!: string | undefined;
    isPrimary!: boolean | undefined;

    constructor(data?: IClientAddressOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.typeLabel = _data["typeLabel"];
            this.address = _data["address"];
            this.addressData = _data["addressData"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClientAddressOptionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClientAddressOptionDto>(data, _mappings, ClientAddressOptionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeLabel"] = this.typeLabel;
        data["address"] = this.address;
        data["addressData"] = this.addressData;
        data["isPrimary"] = this.isPrimary;
        return data;
    }
}

export interface IClientAddressOptionDto {
    typeLabel: string | undefined;
    address: string | undefined;
    addressData: string | undefined;
    isPrimary: boolean | undefined;
}

export class ProjectInheritedAddressDto implements IProjectInheritedAddressDto {
    isInherited!: boolean | undefined;
    isClientSource!: boolean | undefined;
    address!: string | undefined;
    addressData!: string | undefined;
    clientId!: number | undefined;
    clientKind!: EventClientKind | undefined;
    clientName!: string | undefined;
    options!: ClientAddressOptionDto[] | undefined;

    constructor(data?: IProjectInheritedAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isInherited = _data["isInherited"];
            this.isClientSource = _data["isClientSource"];
            this.address = _data["address"];
            this.addressData = _data["addressData"];
            this.clientId = _data["clientId"];
            this.clientKind = _data["clientKind"];
            this.clientName = _data["clientName"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(ClientAddressOptionDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectInheritedAddressDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectInheritedAddressDto>(data, _mappings, ProjectInheritedAddressDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInherited"] = this.isInherited;
        data["isClientSource"] = this.isClientSource;
        data["address"] = this.address;
        data["addressData"] = this.addressData;
        data["clientId"] = this.clientId;
        data["clientKind"] = this.clientKind;
        data["clientName"] = this.clientName;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectInheritedAddressDto {
    isInherited: boolean | undefined;
    isClientSource: boolean | undefined;
    address: string | undefined;
    addressData: string | undefined;
    clientId: number | undefined;
    clientKind: EventClientKind | undefined;
    clientName: string | undefined;
    options: ClientAddressOptionDto[] | undefined;
}

export class ProjectClientFieldNameDto implements IProjectClientFieldNameDto {
    fieldId!: number | undefined;
    clientName!: string | undefined;

    constructor(data?: IProjectClientFieldNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.clientName = _data["clientName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectClientFieldNameDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectClientFieldNameDto>(data, _mappings, ProjectClientFieldNameDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["clientName"] = this.clientName;
        return data;
    }
}

export interface IProjectClientFieldNameDto {
    fieldId: number | undefined;
    clientName: string | undefined;
}

export enum EventNameMode {
    _1 = 1,
    _2 = 2,
}

export enum EventNameFieldKey {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class EventNameFieldItemDto implements IEventNameFieldItemDto {
    key!: EventNameFieldKey | undefined;
    projectFieldId!: number | undefined;

    constructor(data?: IEventNameFieldItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.projectFieldId = _data["projectFieldId"];
        }
    }

    static fromJS(data: any, _mappings?: any): EventNameFieldItemDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EventNameFieldItemDto>(data, _mappings, EventNameFieldItemDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["projectFieldId"] = this.projectFieldId;
        return data;
    }
}

export interface IEventNameFieldItemDto {
    key: EventNameFieldKey | undefined;
    projectFieldId: number | undefined;
}

export class EventNameFormatDto implements IEventNameFormatDto {
    fields!: EventNameFieldKey[] | undefined;
    items!: EventNameFieldItemDto[] | undefined;
    separator!: string | undefined;

    constructor(data?: IEventNameFormatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(item);
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EventNameFieldItemDto.fromJS(item, _mappings));
            }
            this.separator = _data["separator"];
        }
    }

    static fromJS(data: any, _mappings?: any): EventNameFormatDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EventNameFormatDto>(data, _mappings, EventNameFormatDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["separator"] = this.separator;
        return data;
    }
}

export interface IEventNameFormatDto {
    fields: EventNameFieldKey[] | undefined;
    items: EventNameFieldItemDto[] | undefined;
    separator: string | undefined;
}

export class EventTypeDto implements IEventTypeDto {
    id!: number | undefined;
    name!: string | undefined;
    color!: string | undefined;
    displayOrder!: number | undefined;
    isSystem!: boolean | undefined;
    systemKey!: string | undefined;
    defaultBillable!: boolean | undefined;
    defaultAllDay!: boolean | undefined;
    marksOutOfOffice!: boolean | undefined;
    projectOnForm!: boolean | undefined;
    projectRequired!: boolean | undefined;
    clientOnForm!: boolean | undefined;
    clientRequired!: boolean | undefined;
    locationOnForm!: boolean | undefined;
    locationRequired!: boolean | undefined;
    watchersOnForm!: boolean | undefined;
    watchersRequired!: boolean | undefined;
    nameMode!: EventNameMode | undefined;
    nameFormat!: EventNameFormatDto | undefined;
    locationAllowTeams!: boolean | undefined;
    locationAllowPhysical!: boolean | undefined;
    locationPrefillFromProject!: boolean | undefined;
    locationPrefillFieldId!: number | undefined;

    constructor(data?: IEventTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.displayOrder = _data["displayOrder"];
            this.isSystem = _data["isSystem"];
            this.systemKey = _data["systemKey"];
            this.defaultBillable = _data["defaultBillable"];
            this.defaultAllDay = _data["defaultAllDay"];
            this.marksOutOfOffice = _data["marksOutOfOffice"];
            this.projectOnForm = _data["projectOnForm"];
            this.projectRequired = _data["projectRequired"];
            this.clientOnForm = _data["clientOnForm"];
            this.clientRequired = _data["clientRequired"];
            this.locationOnForm = _data["locationOnForm"];
            this.locationRequired = _data["locationRequired"];
            this.watchersOnForm = _data["watchersOnForm"];
            this.watchersRequired = _data["watchersRequired"];
            this.nameMode = _data["nameMode"];
            this.nameFormat = _data["nameFormat"] ? EventNameFormatDto.fromJS(_data["nameFormat"], _mappings) : undefined as any;
            this.locationAllowTeams = _data["locationAllowTeams"];
            this.locationAllowPhysical = _data["locationAllowPhysical"];
            this.locationPrefillFromProject = _data["locationPrefillFromProject"];
            this.locationPrefillFieldId = _data["locationPrefillFieldId"];
        }
    }

    static fromJS(data: any, _mappings?: any): EventTypeDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EventTypeDto>(data, _mappings, EventTypeDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["displayOrder"] = this.displayOrder;
        data["isSystem"] = this.isSystem;
        data["systemKey"] = this.systemKey;
        data["defaultBillable"] = this.defaultBillable;
        data["defaultAllDay"] = this.defaultAllDay;
        data["marksOutOfOffice"] = this.marksOutOfOffice;
        data["projectOnForm"] = this.projectOnForm;
        data["projectRequired"] = this.projectRequired;
        data["clientOnForm"] = this.clientOnForm;
        data["clientRequired"] = this.clientRequired;
        data["locationOnForm"] = this.locationOnForm;
        data["locationRequired"] = this.locationRequired;
        data["watchersOnForm"] = this.watchersOnForm;
        data["watchersRequired"] = this.watchersRequired;
        data["nameMode"] = this.nameMode;
        data["nameFormat"] = this.nameFormat ? this.nameFormat.toJSON() : undefined as any;
        data["locationAllowTeams"] = this.locationAllowTeams;
        data["locationAllowPhysical"] = this.locationAllowPhysical;
        data["locationPrefillFromProject"] = this.locationPrefillFromProject;
        data["locationPrefillFieldId"] = this.locationPrefillFieldId;
        return data;
    }
}

export interface IEventTypeDto {
    id: number | undefined;
    name: string | undefined;
    color: string | undefined;
    displayOrder: number | undefined;
    isSystem: boolean | undefined;
    systemKey: string | undefined;
    defaultBillable: boolean | undefined;
    defaultAllDay: boolean | undefined;
    marksOutOfOffice: boolean | undefined;
    projectOnForm: boolean | undefined;
    projectRequired: boolean | undefined;
    clientOnForm: boolean | undefined;
    clientRequired: boolean | undefined;
    locationOnForm: boolean | undefined;
    locationRequired: boolean | undefined;
    watchersOnForm: boolean | undefined;
    watchersRequired: boolean | undefined;
    nameMode: EventNameMode | undefined;
    nameFormat: EventNameFormatDto | undefined;
    locationAllowTeams: boolean | undefined;
    locationAllowPhysical: boolean | undefined;
    locationPrefillFromProject: boolean | undefined;
    locationPrefillFieldId: number | undefined;
}

export class GetProjectNextEventsInput implements IGetProjectNextEventsInput {
    projectIds!: number[] | undefined;

    constructor(data?: IGetProjectNextEventsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetProjectNextEventsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetProjectNextEventsInput>(data, _mappings, GetProjectNextEventsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface IGetProjectNextEventsInput {
    projectIds: number[] | undefined;
}

export class ProjectNextEventDto implements IProjectNextEventDto {
    projectId!: number | undefined;
    eventId!: number | undefined;
    start!: string | undefined;
    end!: string | undefined;
    sortInstantUtc!: string | undefined;
    isAllDay!: boolean | undefined;
    isBusyOnly!: boolean | undefined;
    title!: string | undefined;
    typeId!: number | undefined;
    typeLabel!: string | undefined;
    typeColor!: string | undefined;
    canOpen!: boolean | undefined;
    conflictCount!: number | undefined;
    conflictTooltip!: string | undefined;

    constructor(data?: IProjectNextEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.eventId = _data["eventId"];
            this.start = _data["start"];
            this.end = _data["end"];
            this.sortInstantUtc = _data["sortInstantUtc"];
            this.isAllDay = _data["isAllDay"];
            this.isBusyOnly = _data["isBusyOnly"];
            this.title = _data["title"];
            this.typeId = _data["typeId"];
            this.typeLabel = _data["typeLabel"];
            this.typeColor = _data["typeColor"];
            this.canOpen = _data["canOpen"];
            this.conflictCount = _data["conflictCount"];
            this.conflictTooltip = _data["conflictTooltip"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectNextEventDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectNextEventDto>(data, _mappings, ProjectNextEventDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["eventId"] = this.eventId;
        data["start"] = this.start;
        data["end"] = this.end;
        data["sortInstantUtc"] = this.sortInstantUtc;
        data["isAllDay"] = this.isAllDay;
        data["isBusyOnly"] = this.isBusyOnly;
        data["title"] = this.title;
        data["typeId"] = this.typeId;
        data["typeLabel"] = this.typeLabel;
        data["typeColor"] = this.typeColor;
        data["canOpen"] = this.canOpen;
        data["conflictCount"] = this.conflictCount;
        data["conflictTooltip"] = this.conflictTooltip;
        return data;
    }
}

export interface IProjectNextEventDto {
    projectId: number | undefined;
    eventId: number | undefined;
    start: string | undefined;
    end: string | undefined;
    sortInstantUtc: string | undefined;
    isAllDay: boolean | undefined;
    isBusyOnly: boolean | undefined;
    title: string | undefined;
    typeId: number | undefined;
    typeLabel: string | undefined;
    typeColor: string | undefined;
    canOpen: boolean | undefined;
    conflictCount: number | undefined;
    conflictTooltip: string | undefined;
}

export class SaveEventAttendeeInput implements ISaveEventAttendeeInput {
    role!: EventAttendeeRole | undefined;
    userId!: number | undefined;
    name!: string | undefined;
    email!: string | undefined;

    constructor(data?: ISaveEventAttendeeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.role = _data["role"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any, _mappings?: any): SaveEventAttendeeInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveEventAttendeeInput>(data, _mappings, SaveEventAttendeeInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface ISaveEventAttendeeInput {
    role: EventAttendeeRole | undefined;
    userId: number | undefined;
    name: string | undefined;
    email: string | undefined;
}

export class SaveEventInput implements ISaveEventInput {
    id!: number | undefined;
    eventTypeId!: number | undefined;
    organizerUserId!: number | undefined;
    name!: string | undefined;
    isNameOverridden!: boolean | undefined;
    description!: string | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    clientId!: number | undefined;
    clientName!: string | undefined;
    clientKind!: EventClientKind | undefined;
    linkedTaskId!: number | undefined;
    linkedTaskName!: string | undefined;
    isAllDay!: boolean | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    timeZone!: string | undefined;
    locationMode!: EventLocationMode | undefined;
    locationAddress!: string | undefined;
    locationCounty!: string | undefined;
    locationAddressData!: string | undefined;
    isBillable!: boolean | undefined;
    attendees!: SaveEventAttendeeInput[] | undefined;
    recurrence!: RecurrencePattern | undefined;
    editScope!: EventEditScope | undefined;

    constructor(data?: ISaveEventInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventTypeId = _data["eventTypeId"];
            this.organizerUserId = _data["organizerUserId"];
            this.name = _data["name"];
            this.isNameOverridden = _data["isNameOverridden"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.clientKind = _data["clientKind"];
            this.linkedTaskId = _data["linkedTaskId"];
            this.linkedTaskName = _data["linkedTaskName"];
            this.isAllDay = _data["isAllDay"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.timeZone = _data["timeZone"];
            this.locationMode = _data["locationMode"];
            this.locationAddress = _data["locationAddress"];
            this.locationCounty = _data["locationCounty"];
            this.locationAddressData = _data["locationAddressData"];
            this.isBillable = _data["isBillable"];
            if (Array.isArray(_data["attendees"])) {
                this.attendees = [] as any;
                for (let item of _data["attendees"])
                    this.attendees!.push(SaveEventAttendeeInput.fromJS(item, _mappings));
            }
            this.recurrence = _data["recurrence"] ? RecurrencePattern.fromJS(_data["recurrence"], _mappings) : undefined as any;
            this.editScope = _data["editScope"];
        }
    }

    static fromJS(data: any, _mappings?: any): SaveEventInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveEventInput>(data, _mappings, SaveEventInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventTypeId"] = this.eventTypeId;
        data["organizerUserId"] = this.organizerUserId;
        data["name"] = this.name;
        data["isNameOverridden"] = this.isNameOverridden;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["clientKind"] = this.clientKind;
        data["linkedTaskId"] = this.linkedTaskId;
        data["linkedTaskName"] = this.linkedTaskName;
        data["isAllDay"] = this.isAllDay;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["timeZone"] = this.timeZone;
        data["locationMode"] = this.locationMode;
        data["locationAddress"] = this.locationAddress;
        data["locationCounty"] = this.locationCounty;
        data["locationAddressData"] = this.locationAddressData;
        data["isBillable"] = this.isBillable;
        if (Array.isArray(this.attendees)) {
            data["attendees"] = [];
            for (let item of this.attendees)
                data["attendees"].push(item ? item.toJSON() : undefined as any);
        }
        data["recurrence"] = this.recurrence ? this.recurrence.toJSON() : undefined as any;
        data["editScope"] = this.editScope;
        return data;
    }
}

export interface ISaveEventInput {
    id: number | undefined;
    eventTypeId: number | undefined;
    organizerUserId: number | undefined;
    name: string | undefined;
    isNameOverridden: boolean | undefined;
    description: string | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    clientId: number | undefined;
    clientName: string | undefined;
    clientKind: EventClientKind | undefined;
    linkedTaskId: number | undefined;
    linkedTaskName: string | undefined;
    isAllDay: boolean | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    timeZone: string | undefined;
    locationMode: EventLocationMode | undefined;
    locationAddress: string | undefined;
    locationCounty: string | undefined;
    locationAddressData: string | undefined;
    isBillable: boolean | undefined;
    attendees: SaveEventAttendeeInput[] | undefined;
    recurrence: RecurrencePattern | undefined;
    editScope: EventEditScope | undefined;
}

export class SaveEventTypeInput implements ISaveEventTypeInput {
    id!: number | undefined;
    name!: string | undefined;
    color!: string | undefined;
    defaultBillable!: boolean | undefined;
    defaultAllDay!: boolean | undefined;
    marksOutOfOffice!: boolean | undefined;
    projectOnForm!: boolean | undefined;
    projectRequired!: boolean | undefined;
    clientOnForm!: boolean | undefined;
    clientRequired!: boolean | undefined;
    locationOnForm!: boolean | undefined;
    locationRequired!: boolean | undefined;
    watchersOnForm!: boolean | undefined;
    watchersRequired!: boolean | undefined;
    nameMode!: EventNameMode | undefined;
    nameFormat!: EventNameFormatDto | undefined;
    locationAllowTeams!: boolean | undefined;
    locationAllowPhysical!: boolean | undefined;
    locationPrefillFromProject!: boolean | undefined;
    locationPrefillFieldId!: number | undefined;

    constructor(data?: ISaveEventTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.defaultBillable = _data["defaultBillable"];
            this.defaultAllDay = _data["defaultAllDay"];
            this.marksOutOfOffice = _data["marksOutOfOffice"];
            this.projectOnForm = _data["projectOnForm"];
            this.projectRequired = _data["projectRequired"];
            this.clientOnForm = _data["clientOnForm"];
            this.clientRequired = _data["clientRequired"];
            this.locationOnForm = _data["locationOnForm"];
            this.locationRequired = _data["locationRequired"];
            this.watchersOnForm = _data["watchersOnForm"];
            this.watchersRequired = _data["watchersRequired"];
            this.nameMode = _data["nameMode"];
            this.nameFormat = _data["nameFormat"] ? EventNameFormatDto.fromJS(_data["nameFormat"], _mappings) : undefined as any;
            this.locationAllowTeams = _data["locationAllowTeams"];
            this.locationAllowPhysical = _data["locationAllowPhysical"];
            this.locationPrefillFromProject = _data["locationPrefillFromProject"];
            this.locationPrefillFieldId = _data["locationPrefillFieldId"];
        }
    }

    static fromJS(data: any, _mappings?: any): SaveEventTypeInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveEventTypeInput>(data, _mappings, SaveEventTypeInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["defaultBillable"] = this.defaultBillable;
        data["defaultAllDay"] = this.defaultAllDay;
        data["marksOutOfOffice"] = this.marksOutOfOffice;
        data["projectOnForm"] = this.projectOnForm;
        data["projectRequired"] = this.projectRequired;
        data["clientOnForm"] = this.clientOnForm;
        data["clientRequired"] = this.clientRequired;
        data["locationOnForm"] = this.locationOnForm;
        data["locationRequired"] = this.locationRequired;
        data["watchersOnForm"] = this.watchersOnForm;
        data["watchersRequired"] = this.watchersRequired;
        data["nameMode"] = this.nameMode;
        data["nameFormat"] = this.nameFormat ? this.nameFormat.toJSON() : undefined as any;
        data["locationAllowTeams"] = this.locationAllowTeams;
        data["locationAllowPhysical"] = this.locationAllowPhysical;
        data["locationPrefillFromProject"] = this.locationPrefillFromProject;
        data["locationPrefillFieldId"] = this.locationPrefillFieldId;
        return data;
    }
}

export interface ISaveEventTypeInput {
    id: number | undefined;
    name: string | undefined;
    color: string | undefined;
    defaultBillable: boolean | undefined;
    defaultAllDay: boolean | undefined;
    marksOutOfOffice: boolean | undefined;
    projectOnForm: boolean | undefined;
    projectRequired: boolean | undefined;
    clientOnForm: boolean | undefined;
    clientRequired: boolean | undefined;
    locationOnForm: boolean | undefined;
    locationRequired: boolean | undefined;
    watchersOnForm: boolean | undefined;
    watchersRequired: boolean | undefined;
    nameMode: EventNameMode | undefined;
    nameFormat: EventNameFormatDto | undefined;
    locationAllowTeams: boolean | undefined;
    locationAllowPhysical: boolean | undefined;
    locationPrefillFromProject: boolean | undefined;
    locationPrefillFieldId: number | undefined;
}

export enum ProjectFieldType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

export class AddressFieldOptionDto implements IAddressFieldOptionDto {
    id!: number | undefined;
    label!: string | undefined;
    isPrimary!: boolean | undefined;
    fieldType!: ProjectFieldType | undefined;
    isClientSource!: boolean | undefined;
    isNative!: boolean | undefined;

    constructor(data?: IAddressFieldOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.isPrimary = _data["isPrimary"];
            this.fieldType = _data["fieldType"];
            this.isClientSource = _data["isClientSource"];
            this.isNative = _data["isNative"];
        }
    }

    static fromJS(data: any, _mappings?: any): AddressFieldOptionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddressFieldOptionDto>(data, _mappings, AddressFieldOptionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["isPrimary"] = this.isPrimary;
        data["fieldType"] = this.fieldType;
        data["isClientSource"] = this.isClientSource;
        data["isNative"] = this.isNative;
        return data;
    }
}

export interface IAddressFieldOptionDto {
    id: number | undefined;
    label: string | undefined;
    isPrimary: boolean | undefined;
    fieldType: ProjectFieldType | undefined;
    isClientSource: boolean | undefined;
    isNative: boolean | undefined;
}

export class CreateExtCompanyInput implements ICreateExtCompanyInput {
    apiKey!: string;
    companyName!: string;
    userEmail!: string;
    companyType!: string | undefined;
    clientStage!: string | undefined;
    street!: string | undefined;
    suite_UnitNumber!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    postalCode!: string | undefined;
    countryName!: string | undefined;
    accountNo!: string | undefined;
    taxId!: string | undefined;
    siteUrl!: string | undefined;

    constructor(data?: ICreateExtCompanyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.companyName = _data["companyName"];
            this.userEmail = _data["userEmail"];
            this.companyType = _data["companyType"];
            this.clientStage = _data["clientStage"];
            this.street = _data["street"];
            this.suite_UnitNumber = _data["suite_UnitNumber"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.countryName = _data["countryName"];
            this.accountNo = _data["accountNo"];
            this.taxId = _data["taxId"];
            this.siteUrl = _data["siteUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateExtCompanyInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateExtCompanyInput>(data, _mappings, CreateExtCompanyInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["companyName"] = this.companyName;
        data["userEmail"] = this.userEmail;
        data["companyType"] = this.companyType;
        data["clientStage"] = this.clientStage;
        data["street"] = this.street;
        data["suite_UnitNumber"] = this.suite_UnitNumber;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["countryName"] = this.countryName;
        data["accountNo"] = this.accountNo;
        data["taxId"] = this.taxId;
        data["siteUrl"] = this.siteUrl;
        return data;
    }
}

export interface ICreateExtCompanyInput {
    apiKey: string;
    companyName: string;
    userEmail: string;
    companyType: string | undefined;
    clientStage: string | undefined;
    street: string | undefined;
    suite_UnitNumber: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postalCode: string | undefined;
    countryName: string | undefined;
    accountNo: string | undefined;
    taxId: string | undefined;
    siteUrl: string | undefined;
}

export class CompanyResult implements ICompanyResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    companyId!: any | undefined;

    constructor(data?: ICompanyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyResult>(data, _mappings, CompanyResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface ICompanyResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    companyId: any | undefined;
}

export class GetCompanyResult implements IGetCompanyResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    companyId!: any | undefined;
    companyName!: string | undefined;
    companyType!: string | undefined;
    clientStage!: string | undefined;
    street!: string | undefined;
    suiteUnitNumber!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    postalCode!: string | undefined;
    country!: string | undefined;
    accountNo!: string | undefined;
    taxID!: string | undefined;
    siteUrl!: string | undefined;
    folderPath!: string | undefined;
    isSharepointDrive!: boolean | undefined;

    constructor(data?: IGetCompanyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.companyType = _data["companyType"];
            this.clientStage = _data["clientStage"];
            this.street = _data["street"];
            this.suiteUnitNumber = _data["suiteUnitNumber"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.accountNo = _data["accountNo"];
            this.taxID = _data["taxID"];
            this.siteUrl = _data["siteUrl"];
            this.folderPath = _data["folderPath"];
            this.isSharepointDrive = _data["isSharepointDrive"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetCompanyResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetCompanyResult>(data, _mappings, GetCompanyResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["companyType"] = this.companyType;
        data["clientStage"] = this.clientStage;
        data["street"] = this.street;
        data["suiteUnitNumber"] = this.suiteUnitNumber;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["accountNo"] = this.accountNo;
        data["taxID"] = this.taxID;
        data["siteUrl"] = this.siteUrl;
        data["folderPath"] = this.folderPath;
        data["isSharepointDrive"] = this.isSharepointDrive;
        return data;
    }
}

export interface IGetCompanyResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    companyId: any | undefined;
    companyName: string | undefined;
    companyType: string | undefined;
    clientStage: string | undefined;
    street: string | undefined;
    suiteUnitNumber: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postalCode: string | undefined;
    country: string | undefined;
    accountNo: string | undefined;
    taxID: string | undefined;
    siteUrl: string | undefined;
    folderPath: string | undefined;
    isSharepointDrive: boolean | undefined;
}

export class CompanyContactResult implements ICompanyContactResult {
    contactId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    contactType!: string | undefined;
    jobTitle!: string | undefined;

    constructor(data?: ICompanyContactResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.contactType = _data["contactType"];
            this.jobTitle = _data["jobTitle"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompanyContactResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompanyContactResult>(data, _mappings, CompanyContactResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["contactType"] = this.contactType;
        data["jobTitle"] = this.jobTitle;
        return data;
    }
}

export interface ICompanyContactResult {
    contactId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    contactType: string | undefined;
    jobTitle: string | undefined;
}

export class GetCompanyContactResult implements IGetCompanyContactResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    contacts!: CompanyContactResult[] | undefined;

    constructor(data?: IGetCompanyContactResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(CompanyContactResult.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetCompanyContactResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetCompanyContactResult>(data, _mappings, GetCompanyContactResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCompanyContactResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    contacts: CompanyContactResult[] | undefined;
}

export class RecentlyCreatedCompanyOutput implements IRecentlyCreatedCompanyOutput {
    companyId!: string | undefined;
    companyName!: string | undefined;
    creationTime!: string | undefined;

    constructor(data?: IRecentlyCreatedCompanyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.creationTime = _data["creationTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyCreatedCompanyOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyCreatedCompanyOutput>(data, _mappings, RecentlyCreatedCompanyOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["creationTime"] = this.creationTime;
        return data;
    }
}

export interface IRecentlyCreatedCompanyOutput {
    companyId: string | undefined;
    companyName: string | undefined;
    creationTime: string | undefined;
}

export class RecentlyCreatedCompanyOutputListIHandleError implements IRecentlyCreatedCompanyOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: RecentlyCreatedCompanyOutput[] | undefined;
    listOfEntities!: RecentlyCreatedCompanyOutput[][] | undefined;

    constructor(data?: IRecentlyCreatedCompanyOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(RecentlyCreatedCompanyOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyCreatedCompanyOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyCreatedCompanyOutputListIHandleError>(data, _mappings, RecentlyCreatedCompanyOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IRecentlyCreatedCompanyOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: RecentlyCreatedCompanyOutput[] | undefined;
    listOfEntities: RecentlyCreatedCompanyOutput[][] | undefined;
}

export class RecentlyUpdatedCompanyOutput implements IRecentlyUpdatedCompanyOutput {
    companyId!: string | undefined;
    companyName!: string | undefined;
    companyType!: string | undefined;
    updatedField!: string | undefined;
    updatedDate!: string | undefined;
    updatedBy!: string | undefined;
    folderPath!: string | undefined;

    constructor(data?: IRecentlyUpdatedCompanyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.companyType = _data["companyType"];
            this.updatedField = _data["updatedField"];
            this.updatedDate = _data["updatedDate"];
            this.updatedBy = _data["updatedBy"];
            this.folderPath = _data["folderPath"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyUpdatedCompanyOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyUpdatedCompanyOutput>(data, _mappings, RecentlyUpdatedCompanyOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["companyType"] = this.companyType;
        data["updatedField"] = this.updatedField;
        data["updatedDate"] = this.updatedDate;
        data["updatedBy"] = this.updatedBy;
        data["folderPath"] = this.folderPath;
        return data;
    }
}

export interface IRecentlyUpdatedCompanyOutput {
    companyId: string | undefined;
    companyName: string | undefined;
    companyType: string | undefined;
    updatedField: string | undefined;
    updatedDate: string | undefined;
    updatedBy: string | undefined;
    folderPath: string | undefined;
}

export class RecentlyUpdatedCompanyOutputListIHandleError implements IRecentlyUpdatedCompanyOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: RecentlyUpdatedCompanyOutput[] | undefined;
    listOfEntities!: RecentlyUpdatedCompanyOutput[][] | undefined;

    constructor(data?: IRecentlyUpdatedCompanyOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(RecentlyUpdatedCompanyOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyUpdatedCompanyOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyUpdatedCompanyOutputListIHandleError>(data, _mappings, RecentlyUpdatedCompanyOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IRecentlyUpdatedCompanyOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: RecentlyUpdatedCompanyOutput[] | undefined;
    listOfEntities: RecentlyUpdatedCompanyOutput[][] | undefined;
}

export class GetTenantApiOutput implements IGetTenantApiOutput {
    companyName!: string | undefined;
    apiKey!: string | undefined;
    activeSubscriberStatus!: string | undefined;

    constructor(data?: IGetTenantApiOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.apiKey = _data["apiKey"];
            this.activeSubscriberStatus = _data["activeSubscriberStatus"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetTenantApiOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetTenantApiOutput>(data, _mappings, GetTenantApiOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["apiKey"] = this.apiKey;
        data["activeSubscriberStatus"] = this.activeSubscriberStatus;
        return data;
    }
}

export interface IGetTenantApiOutput {
    companyName: string | undefined;
    apiKey: string | undefined;
    activeSubscriberStatus: string | undefined;
}

export class GetTenantApiOutputIHandleError implements IGetTenantApiOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetTenantApiOutput | undefined;
    listOfEntities!: GetTenantApiOutput[] | undefined;

    constructor(data?: IGetTenantApiOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetTenantApiOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetTenantApiOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetTenantApiOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetTenantApiOutputIHandleError>(data, _mappings, GetTenantApiOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTenantApiOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetTenantApiOutput | undefined;
    listOfEntities: GetTenantApiOutput[] | undefined;
}

export class CreateExtContactAddressInput implements ICreateExtContactAddressInput {
    apiKey!: string;
    contactEmail!: string;
    userEmail!: string;
    addressType!: string | undefined;
    street!: string | undefined;
    suiteUnitNumber!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    countryName!: string | undefined;

    constructor(data?: ICreateExtContactAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.contactEmail = _data["contactEmail"];
            this.userEmail = _data["userEmail"];
            this.addressType = _data["addressType"];
            this.street = _data["street"];
            this.suiteUnitNumber = _data["suiteUnitNumber"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateExtContactAddressInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateExtContactAddressInput>(data, _mappings, CreateExtContactAddressInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["contactEmail"] = this.contactEmail;
        data["userEmail"] = this.userEmail;
        data["addressType"] = this.addressType;
        data["street"] = this.street;
        data["suiteUnitNumber"] = this.suiteUnitNumber;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["countryName"] = this.countryName;
        return data;
    }
}

export interface ICreateExtContactAddressInput {
    apiKey: string;
    contactEmail: string;
    userEmail: string;
    addressType: string | undefined;
    street: string | undefined;
    suiteUnitNumber: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    countryName: string | undefined;
}

export class ContactAddressResult implements IContactAddressResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    addressId!: any | undefined;

    constructor(data?: IContactAddressResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.addressId = _data["addressId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactAddressResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactAddressResult>(data, _mappings, ContactAddressResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["addressId"] = this.addressId;
        return data;
    }
}

export interface IContactAddressResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    addressId: any | undefined;
}

export class CreateExtContactsInput implements ICreateExtContactsInput {
    id!: number | undefined;
    apiKey!: string | undefined;
    ownerEmailAddress!: string | undefined;
    contactEmailAddress1!: string;
    contactEmailAddress2!: string | undefined;
    contactEmailAddress3!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    jobTitle!: string | undefined;
    birthDay!: number | undefined;
    birthMonth!: number | undefined;
    birthYear!: number | undefined;
    contactType!: string | undefined;
    clientStage!: string | undefined;
    source!: string | undefined;
    tags!: string | undefined;
    companyID1!: string | undefined;
    companyID2!: string | undefined;
    companyID3!: string | undefined;
    accountNumber!: string | undefined;
    socialSecurityNumber!: string | undefined;
    isLocationCreated!: boolean | undefined;

    constructor(data?: ICreateExtContactsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.apiKey = _data["apiKey"];
            this.ownerEmailAddress = _data["ownerEmailAddress"];
            this.contactEmailAddress1 = _data["contactEmailAddress1"];
            this.contactEmailAddress2 = _data["contactEmailAddress2"];
            this.contactEmailAddress3 = _data["contactEmailAddress3"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.jobTitle = _data["jobTitle"];
            this.birthDay = _data["birthDay"];
            this.birthMonth = _data["birthMonth"];
            this.birthYear = _data["birthYear"];
            this.contactType = _data["contactType"];
            this.clientStage = _data["clientStage"];
            this.source = _data["source"];
            this.tags = _data["tags"];
            this.companyID1 = _data["companyID1"];
            this.companyID2 = _data["companyID2"];
            this.companyID3 = _data["companyID3"];
            this.accountNumber = _data["accountNumber"];
            this.socialSecurityNumber = _data["socialSecurityNumber"];
            this.isLocationCreated = _data["isLocationCreated"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateExtContactsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateExtContactsInput>(data, _mappings, CreateExtContactsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["apiKey"] = this.apiKey;
        data["ownerEmailAddress"] = this.ownerEmailAddress;
        data["contactEmailAddress1"] = this.contactEmailAddress1;
        data["contactEmailAddress2"] = this.contactEmailAddress2;
        data["contactEmailAddress3"] = this.contactEmailAddress3;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["jobTitle"] = this.jobTitle;
        data["birthDay"] = this.birthDay;
        data["birthMonth"] = this.birthMonth;
        data["birthYear"] = this.birthYear;
        data["contactType"] = this.contactType;
        data["clientStage"] = this.clientStage;
        data["source"] = this.source;
        data["tags"] = this.tags;
        data["companyID1"] = this.companyID1;
        data["companyID2"] = this.companyID2;
        data["companyID3"] = this.companyID3;
        data["accountNumber"] = this.accountNumber;
        data["socialSecurityNumber"] = this.socialSecurityNumber;
        data["isLocationCreated"] = this.isLocationCreated;
        return data;
    }
}

export interface ICreateExtContactsInput {
    id: number | undefined;
    apiKey: string | undefined;
    ownerEmailAddress: string | undefined;
    contactEmailAddress1: string;
    contactEmailAddress2: string | undefined;
    contactEmailAddress3: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    jobTitle: string | undefined;
    birthDay: number | undefined;
    birthMonth: number | undefined;
    birthYear: number | undefined;
    contactType: string | undefined;
    clientStage: string | undefined;
    source: string | undefined;
    tags: string | undefined;
    companyID1: string | undefined;
    companyID2: string | undefined;
    companyID3: string | undefined;
    accountNumber: string | undefined;
    socialSecurityNumber: string | undefined;
    isLocationCreated: boolean | undefined;
}

export class ContactResult implements IContactResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    contactId!: any | undefined;

    constructor(data?: IContactResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.contactId = _data["contactId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactResult>(data, _mappings, ContactResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["contactId"] = this.contactId;
        return data;
    }
}

export interface IContactResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    contactId: any | undefined;
}

export class UpdateExtContactsInput implements IUpdateExtContactsInput {
    apiKey!: string | undefined;
    ownerEmailAddress!: string | undefined;
    contactId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    jobTitle!: string | undefined;
    birthDay!: number | undefined;
    birthMonth!: number | undefined;
    birthYear!: number | undefined;
    contactType!: string | undefined;
    clientStage!: string | undefined;
    source!: string | undefined;
    tags!: string | undefined;
    contactEmailAddress1!: string | undefined;
    contactEmailAddress2!: string | undefined;
    contactEmailAddress3!: string | undefined;
    companyID1!: string | undefined;
    companyID2!: string | undefined;
    companyID3!: string | undefined;
    accountNumber!: string | undefined;
    socialSecurityNumber!: string | undefined;

    constructor(data?: IUpdateExtContactsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.ownerEmailAddress = _data["ownerEmailAddress"];
            this.contactId = _data["contactId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.jobTitle = _data["jobTitle"];
            this.birthDay = _data["birthDay"];
            this.birthMonth = _data["birthMonth"];
            this.birthYear = _data["birthYear"];
            this.contactType = _data["contactType"];
            this.clientStage = _data["clientStage"];
            this.source = _data["source"];
            this.tags = _data["tags"];
            this.contactEmailAddress1 = _data["contactEmailAddress1"];
            this.contactEmailAddress2 = _data["contactEmailAddress2"];
            this.contactEmailAddress3 = _data["contactEmailAddress3"];
            this.companyID1 = _data["companyID1"];
            this.companyID2 = _data["companyID2"];
            this.companyID3 = _data["companyID3"];
            this.accountNumber = _data["accountNumber"];
            this.socialSecurityNumber = _data["socialSecurityNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateExtContactsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateExtContactsInput>(data, _mappings, UpdateExtContactsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["ownerEmailAddress"] = this.ownerEmailAddress;
        data["contactId"] = this.contactId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["jobTitle"] = this.jobTitle;
        data["birthDay"] = this.birthDay;
        data["birthMonth"] = this.birthMonth;
        data["birthYear"] = this.birthYear;
        data["contactType"] = this.contactType;
        data["clientStage"] = this.clientStage;
        data["source"] = this.source;
        data["tags"] = this.tags;
        data["contactEmailAddress1"] = this.contactEmailAddress1;
        data["contactEmailAddress2"] = this.contactEmailAddress2;
        data["contactEmailAddress3"] = this.contactEmailAddress3;
        data["companyID1"] = this.companyID1;
        data["companyID2"] = this.companyID2;
        data["companyID3"] = this.companyID3;
        data["accountNumber"] = this.accountNumber;
        data["socialSecurityNumber"] = this.socialSecurityNumber;
        return data;
    }
}

export interface IUpdateExtContactsInput {
    apiKey: string | undefined;
    ownerEmailAddress: string | undefined;
    contactId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    jobTitle: string | undefined;
    birthDay: number | undefined;
    birthMonth: number | undefined;
    birthYear: number | undefined;
    contactType: string | undefined;
    clientStage: string | undefined;
    source: string | undefined;
    tags: string | undefined;
    contactEmailAddress1: string | undefined;
    contactEmailAddress2: string | undefined;
    contactEmailAddress3: string | undefined;
    companyID1: string | undefined;
    companyID2: string | undefined;
    companyID3: string | undefined;
    accountNumber: string | undefined;
    socialSecurityNumber: string | undefined;
}

export class CreateExtContactFamilyInput implements ICreateExtContactFamilyInput {
    apiKey!: string;
    contactEmail!: string;
    userEmail!: string;
    firstName!: string | undefined;
    lastName!: string | undefined;
    relationship!: string | undefined;
    birthDate!: string | undefined;
    birthMonth!: number | undefined;
    birthYear!: number | undefined;
    countryName!: string | undefined;

    constructor(data?: ICreateExtContactFamilyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.contactEmail = _data["contactEmail"];
            this.userEmail = _data["userEmail"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.relationship = _data["relationship"];
            this.birthDate = _data["birthDate"];
            this.birthMonth = _data["birthMonth"];
            this.birthYear = _data["birthYear"];
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateExtContactFamilyInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateExtContactFamilyInput>(data, _mappings, CreateExtContactFamilyInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["contactEmail"] = this.contactEmail;
        data["userEmail"] = this.userEmail;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["relationship"] = this.relationship;
        data["birthDate"] = this.birthDate;
        data["birthMonth"] = this.birthMonth;
        data["birthYear"] = this.birthYear;
        data["countryName"] = this.countryName;
        return data;
    }
}

export interface ICreateExtContactFamilyInput {
    apiKey: string;
    contactEmail: string;
    userEmail: string;
    firstName: string | undefined;
    lastName: string | undefined;
    relationship: string | undefined;
    birthDate: string | undefined;
    birthMonth: number | undefined;
    birthYear: number | undefined;
    countryName: string | undefined;
}

export class ContactFamilyResult implements IContactFamilyResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    familyId!: any | undefined;

    constructor(data?: IContactFamilyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.familyId = _data["familyId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactFamilyResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactFamilyResult>(data, _mappings, ContactFamilyResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["familyId"] = this.familyId;
        return data;
    }
}

export interface IContactFamilyResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    familyId: any | undefined;
}

export class CreateExtNotesInput implements ICreateExtNotesInput {
    apiKey!: string;
    ownerEmail!: string;
    contactEmail!: string;
    notes!: string;

    constructor(data?: ICreateExtNotesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.ownerEmail = _data["ownerEmail"];
            this.contactEmail = _data["contactEmail"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateExtNotesInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateExtNotesInput>(data, _mappings, CreateExtNotesInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["ownerEmail"] = this.ownerEmail;
        data["contactEmail"] = this.contactEmail;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateExtNotesInput {
    apiKey: string;
    ownerEmail: string;
    contactEmail: string;
    notes: string;
}

export class NotesResult implements INotesResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    noteId!: any | undefined;

    constructor(data?: INotesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.noteId = _data["noteId"];
        }
    }

    static fromJS(data: any, _mappings?: any): NotesResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NotesResult>(data, _mappings, NotesResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["noteId"] = this.noteId;
        return data;
    }
}

export interface INotesResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    noteId: any | undefined;
}

export class CreateExtContactPhonesInput implements ICreateExtContactPhonesInput {
    apiKey!: string;
    contactEmail!: string;
    userEmail!: string;
    phone!: string | undefined;
    phoneType!: string | undefined;
    extension!: string | undefined;

    constructor(data?: ICreateExtContactPhonesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.contactEmail = _data["contactEmail"];
            this.userEmail = _data["userEmail"];
            this.phone = _data["phone"];
            this.phoneType = _data["phoneType"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateExtContactPhonesInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateExtContactPhonesInput>(data, _mappings, CreateExtContactPhonesInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["contactEmail"] = this.contactEmail;
        data["userEmail"] = this.userEmail;
        data["phone"] = this.phone;
        data["phoneType"] = this.phoneType;
        data["extension"] = this.extension;
        return data;
    }
}

export interface ICreateExtContactPhonesInput {
    apiKey: string;
    contactEmail: string;
    userEmail: string;
    phone: string | undefined;
    phoneType: string | undefined;
    extension: string | undefined;
}

export class ContactPhoneResult implements IContactPhoneResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    phoneId!: any | undefined;

    constructor(data?: IContactPhoneResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.phoneId = _data["phoneId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ContactPhoneResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ContactPhoneResult>(data, _mappings, ContactPhoneResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["phoneId"] = this.phoneId;
        return data;
    }
}

export interface IContactPhoneResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    phoneId: any | undefined;
}

export class GetContactFolderDtlResult implements IGetContactFolderDtlResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    folderPath!: any | undefined;
    isSharePointDrive!: any | undefined;

    constructor(data?: IGetContactFolderDtlResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.folderPath = _data["folderPath"];
            this.isSharePointDrive = _data["isSharePointDrive"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetContactFolderDtlResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetContactFolderDtlResult>(data, _mappings, GetContactFolderDtlResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["folderPath"] = this.folderPath;
        data["isSharePointDrive"] = this.isSharePointDrive;
        return data;
    }
}

export interface IGetContactFolderDtlResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    folderPath: any | undefined;
    isSharePointDrive: any | undefined;
}

export class GetContactDetailResult implements IGetContactDetailResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    contactId!: string | undefined;
    contactType!: string | undefined;
    clientStage!: string | undefined;
    source!: string | undefined;
    tags!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    jobTitle!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    companyId!: string | undefined;
    companyName!: string | undefined;

    constructor(data?: IGetContactDetailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.contactId = _data["contactId"];
            this.contactType = _data["contactType"];
            this.clientStage = _data["clientStage"];
            this.source = _data["source"];
            this.tags = _data["tags"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.jobTitle = _data["jobTitle"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetContactDetailResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetContactDetailResult>(data, _mappings, GetContactDetailResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["contactId"] = this.contactId;
        data["contactType"] = this.contactType;
        data["clientStage"] = this.clientStage;
        data["source"] = this.source;
        data["tags"] = this.tags;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["jobTitle"] = this.jobTitle;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IGetContactDetailResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    contactId: string | undefined;
    contactType: string | undefined;
    clientStage: string | undefined;
    source: string | undefined;
    tags: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    jobTitle: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    companyId: string | undefined;
    companyName: string | undefined;
}

export class RecentlyCreatedContactOutput implements IRecentlyCreatedContactOutput {
    contactId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    emailAddress!: string | undefined;
    companyId!: string | undefined;
    creationTime!: string | undefined;

    constructor(data?: IRecentlyCreatedContactOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.companyId = _data["companyId"];
            this.creationTime = _data["creationTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyCreatedContactOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyCreatedContactOutput>(data, _mappings, RecentlyCreatedContactOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["companyId"] = this.companyId;
        data["creationTime"] = this.creationTime;
        return data;
    }
}

export interface IRecentlyCreatedContactOutput {
    contactId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    emailAddress: string | undefined;
    companyId: string | undefined;
    creationTime: string | undefined;
}

export class RecentlyCreatedContactOutputListIHandleError implements IRecentlyCreatedContactOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: RecentlyCreatedContactOutput[] | undefined;
    listOfEntities!: RecentlyCreatedContactOutput[][] | undefined;

    constructor(data?: IRecentlyCreatedContactOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(RecentlyCreatedContactOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyCreatedContactOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyCreatedContactOutputListIHandleError>(data, _mappings, RecentlyCreatedContactOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IRecentlyCreatedContactOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: RecentlyCreatedContactOutput[] | undefined;
    listOfEntities: RecentlyCreatedContactOutput[][] | undefined;
}

export class RecentlyUpdatedContactOutput implements IRecentlyUpdatedContactOutput {
    contactId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    contactEmail!: string | undefined;
    contactType!: string | undefined;
    clientStage!: string | undefined;
    updatedField!: string | undefined;
    updatedDate!: string | undefined;
    updatedBy!: string | undefined;
    source!: string | undefined;
    tags!: string | undefined;

    constructor(data?: IRecentlyUpdatedContactOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.contactEmail = _data["contactEmail"];
            this.contactType = _data["contactType"];
            this.clientStage = _data["clientStage"];
            this.updatedField = _data["updatedField"];
            this.updatedDate = _data["updatedDate"];
            this.updatedBy = _data["updatedBy"];
            this.source = _data["source"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyUpdatedContactOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyUpdatedContactOutput>(data, _mappings, RecentlyUpdatedContactOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["contactEmail"] = this.contactEmail;
        data["contactType"] = this.contactType;
        data["clientStage"] = this.clientStage;
        data["updatedField"] = this.updatedField;
        data["updatedDate"] = this.updatedDate;
        data["updatedBy"] = this.updatedBy;
        data["source"] = this.source;
        data["tags"] = this.tags;
        return data;
    }
}

export interface IRecentlyUpdatedContactOutput {
    contactId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    contactEmail: string | undefined;
    contactType: string | undefined;
    clientStage: string | undefined;
    updatedField: string | undefined;
    updatedDate: string | undefined;
    updatedBy: string | undefined;
    source: string | undefined;
    tags: string | undefined;
}

export class RecentlyUpdatedContactOutputListIHandleError implements IRecentlyUpdatedContactOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: RecentlyUpdatedContactOutput[] | undefined;
    listOfEntities!: RecentlyUpdatedContactOutput[][] | undefined;

    constructor(data?: IRecentlyUpdatedContactOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(RecentlyUpdatedContactOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyUpdatedContactOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyUpdatedContactOutputListIHandleError>(data, _mappings, RecentlyUpdatedContactOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IRecentlyUpdatedContactOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: RecentlyUpdatedContactOutput[] | undefined;
    listOfEntities: RecentlyUpdatedContactOutput[][] | undefined;
}

export class RecentlyUpdatedContactStageOutput implements IRecentlyUpdatedContactStageOutput {
    contactId!: string | undefined;
    historyId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    contactEmail!: string | undefined;

    constructor(data?: IRecentlyUpdatedContactStageOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.historyId = _data["historyId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.contactEmail = _data["contactEmail"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyUpdatedContactStageOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyUpdatedContactStageOutput>(data, _mappings, RecentlyUpdatedContactStageOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["historyId"] = this.historyId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["contactEmail"] = this.contactEmail;
        return data;
    }
}

export interface IRecentlyUpdatedContactStageOutput {
    contactId: string | undefined;
    historyId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    contactEmail: string | undefined;
}

export class RecentlyUpdatedContactStageOutputListIHandleError implements IRecentlyUpdatedContactStageOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: RecentlyUpdatedContactStageOutput[] | undefined;
    listOfEntities!: RecentlyUpdatedContactStageOutput[][] | undefined;

    constructor(data?: IRecentlyUpdatedContactStageOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(RecentlyUpdatedContactStageOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyUpdatedContactStageOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyUpdatedContactStageOutputListIHandleError>(data, _mappings, RecentlyUpdatedContactStageOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IRecentlyUpdatedContactStageOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: RecentlyUpdatedContactStageOutput[] | undefined;
    listOfEntities: RecentlyUpdatedContactStageOutput[][] | undefined;
}

export class CreateExtTaskChecklistInput implements ICreateExtTaskChecklistInput {
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: ICreateExtTaskChecklistInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateExtTaskChecklistInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateExtTaskChecklistInput>(data, _mappings, CreateExtTaskChecklistInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateExtTaskChecklistInput {
    name: string | undefined;
    description: string | undefined;
}

export class CreateExtTaskFileInput implements ICreateExtTaskFileInput {
    fileName!: string | undefined;
    filePath!: string | undefined;
    fileType!: string | undefined;
    fileItemId!: string | undefined;
    fileDriveId!: string | undefined;
    isDefault!: boolean | undefined;

    constructor(data?: ICreateExtTaskFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.filePath = _data["filePath"];
            this.fileType = _data["fileType"];
            this.fileItemId = _data["fileItemId"];
            this.fileDriveId = _data["fileDriveId"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateExtTaskFileInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateExtTaskFileInput>(data, _mappings, CreateExtTaskFileInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["filePath"] = this.filePath;
        data["fileType"] = this.fileType;
        data["fileItemId"] = this.fileItemId;
        data["fileDriveId"] = this.fileDriveId;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface ICreateExtTaskFileInput {
    fileName: string | undefined;
    filePath: string | undefined;
    fileType: string | undefined;
    fileItemId: string | undefined;
    fileDriveId: string | undefined;
    isDefault: boolean | undefined;
}

export class CreateExtTaskInput implements ICreateExtTaskInput {
    fromEmail!: string | undefined;
    toEmail!: string | undefined;
    title!: string;
    description!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    resourceAppName!: string | undefined;
    resourceAppUrl!: string | undefined;
    resourceAppID!: string | undefined;
    resourceAppData!: string | undefined;
    referenceId!: string | undefined;
    referenceData!: string | undefined;
    referenceSource!: string | undefined;
    projectName!: string | undefined;
    projectSectionName!: string | undefined;
    projectTags!: string | undefined;
    apiKey!: string;
    priorityText!: string | undefined;
    priority!: TaskPriority | undefined;
    associatedContactEmail!: string | undefined;
    taskType!: string | undefined;
    checklists!: CreateExtTaskChecklistInput[] | undefined;
    files!: CreateExtTaskFileInput[] | undefined;

    constructor(data?: ICreateExtTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fromEmail = _data["fromEmail"];
            this.toEmail = _data["toEmail"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.resourceAppName = _data["resourceAppName"];
            this.resourceAppUrl = _data["resourceAppUrl"];
            this.resourceAppID = _data["resourceAppID"];
            this.resourceAppData = _data["resourceAppData"];
            this.referenceId = _data["referenceId"];
            this.referenceData = _data["referenceData"];
            this.referenceSource = _data["referenceSource"];
            this.projectName = _data["projectName"];
            this.projectSectionName = _data["projectSectionName"];
            this.projectTags = _data["projectTags"];
            this.apiKey = _data["apiKey"];
            this.priorityText = _data["priorityText"];
            this.priority = _data["priority"];
            this.associatedContactEmail = _data["associatedContactEmail"];
            this.taskType = _data["taskType"];
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(CreateExtTaskChecklistInput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(CreateExtTaskFileInput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateExtTaskInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateExtTaskInput>(data, _mappings, CreateExtTaskInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromEmail"] = this.fromEmail;
        data["toEmail"] = this.toEmail;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["resourceAppName"] = this.resourceAppName;
        data["resourceAppUrl"] = this.resourceAppUrl;
        data["resourceAppID"] = this.resourceAppID;
        data["resourceAppData"] = this.resourceAppData;
        data["referenceId"] = this.referenceId;
        data["referenceData"] = this.referenceData;
        data["referenceSource"] = this.referenceSource;
        data["projectName"] = this.projectName;
        data["projectSectionName"] = this.projectSectionName;
        data["projectTags"] = this.projectTags;
        data["apiKey"] = this.apiKey;
        data["priorityText"] = this.priorityText;
        data["priority"] = this.priority;
        data["associatedContactEmail"] = this.associatedContactEmail;
        data["taskType"] = this.taskType;
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateExtTaskInput {
    fromEmail: string | undefined;
    toEmail: string | undefined;
    title: string;
    description: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    resourceAppName: string | undefined;
    resourceAppUrl: string | undefined;
    resourceAppID: string | undefined;
    resourceAppData: string | undefined;
    referenceId: string | undefined;
    referenceData: string | undefined;
    referenceSource: string | undefined;
    projectName: string | undefined;
    projectSectionName: string | undefined;
    projectTags: string | undefined;
    apiKey: string;
    priorityText: string | undefined;
    priority: TaskPriority | undefined;
    associatedContactEmail: string | undefined;
    taskType: string | undefined;
    checklists: CreateExtTaskChecklistInput[] | undefined;
    files: CreateExtTaskFileInput[] | undefined;
}

export class Result implements IResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    taskID!: any | undefined;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.taskID = _data["taskID"];
        }
    }

    static fromJS(data: any, _mappings?: any): Result | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Result>(data, _mappings, Result);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["taskID"] = this.taskID;
        return data;
    }
}

export interface IResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    taskID: any | undefined;
}

export class UpdateExtTaskChecklistInput implements IUpdateExtTaskChecklistInput {
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: IUpdateExtTaskChecklistInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateExtTaskChecklistInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateExtTaskChecklistInput>(data, _mappings, UpdateExtTaskChecklistInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateExtTaskChecklistInput {
    name: string | undefined;
    description: string | undefined;
}

export class UpdateExtTaskFileInput implements IUpdateExtTaskFileInput {
    fileName!: string | undefined;
    filePath!: string | undefined;
    fileType!: string | undefined;
    fileItemId!: string | undefined;
    fileDriveId!: string | undefined;

    constructor(data?: IUpdateExtTaskFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.filePath = _data["filePath"];
            this.fileType = _data["fileType"];
            this.fileItemId = _data["fileItemId"];
            this.fileDriveId = _data["fileDriveId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateExtTaskFileInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateExtTaskFileInput>(data, _mappings, UpdateExtTaskFileInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["filePath"] = this.filePath;
        data["fileType"] = this.fileType;
        data["fileItemId"] = this.fileItemId;
        data["fileDriveId"] = this.fileDriveId;
        return data;
    }
}

export interface IUpdateExtTaskFileInput {
    fileName: string | undefined;
    filePath: string | undefined;
    fileType: string | undefined;
    fileItemId: string | undefined;
    fileDriveId: string | undefined;
}

export class UpdateExtTaskInput implements IUpdateExtTaskInput {
    fromEmail!: string | undefined;
    toEmail!: string;
    title!: string;
    taskId!: string;
    description!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    resourceAppName!: string | undefined;
    resourceAppUrl!: string | undefined;
    resourceAppID!: string | undefined;
    resourceAppData!: string | undefined;
    referenceId!: string | undefined;
    referenceData!: string | undefined;
    referenceSource!: string | undefined;
    projectName!: string | undefined;
    projectSectionName!: string | undefined;
    projectTags!: string | undefined;
    apiKey!: string;
    priorityText!: string | undefined;
    priority!: TaskPriority | undefined;
    associatedContactEmail!: string | undefined;
    taskType!: string | undefined;
    taskStatus!: string | undefined;
    checklists!: UpdateExtTaskChecklistInput[] | undefined;
    files!: UpdateExtTaskFileInput[] | undefined;

    constructor(data?: IUpdateExtTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fromEmail = _data["fromEmail"];
            this.toEmail = _data["toEmail"];
            this.title = _data["title"];
            this.taskId = _data["taskId"];
            this.description = _data["description"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.resourceAppName = _data["resourceAppName"];
            this.resourceAppUrl = _data["resourceAppUrl"];
            this.resourceAppID = _data["resourceAppID"];
            this.resourceAppData = _data["resourceAppData"];
            this.referenceId = _data["referenceId"];
            this.referenceData = _data["referenceData"];
            this.referenceSource = _data["referenceSource"];
            this.projectName = _data["projectName"];
            this.projectSectionName = _data["projectSectionName"];
            this.projectTags = _data["projectTags"];
            this.apiKey = _data["apiKey"];
            this.priorityText = _data["priorityText"];
            this.priority = _data["priority"];
            this.associatedContactEmail = _data["associatedContactEmail"];
            this.taskType = _data["taskType"];
            this.taskStatus = _data["taskStatus"];
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(UpdateExtTaskChecklistInput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(UpdateExtTaskFileInput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateExtTaskInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateExtTaskInput>(data, _mappings, UpdateExtTaskInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromEmail"] = this.fromEmail;
        data["toEmail"] = this.toEmail;
        data["title"] = this.title;
        data["taskId"] = this.taskId;
        data["description"] = this.description;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["resourceAppName"] = this.resourceAppName;
        data["resourceAppUrl"] = this.resourceAppUrl;
        data["resourceAppID"] = this.resourceAppID;
        data["resourceAppData"] = this.resourceAppData;
        data["referenceId"] = this.referenceId;
        data["referenceData"] = this.referenceData;
        data["referenceSource"] = this.referenceSource;
        data["projectName"] = this.projectName;
        data["projectSectionName"] = this.projectSectionName;
        data["projectTags"] = this.projectTags;
        data["apiKey"] = this.apiKey;
        data["priorityText"] = this.priorityText;
        data["priority"] = this.priority;
        data["associatedContactEmail"] = this.associatedContactEmail;
        data["taskType"] = this.taskType;
        data["taskStatus"] = this.taskStatus;
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateExtTaskInput {
    fromEmail: string | undefined;
    toEmail: string;
    title: string;
    taskId: string;
    description: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    resourceAppName: string | undefined;
    resourceAppUrl: string | undefined;
    resourceAppID: string | undefined;
    resourceAppData: string | undefined;
    referenceId: string | undefined;
    referenceData: string | undefined;
    referenceSource: string | undefined;
    projectName: string | undefined;
    projectSectionName: string | undefined;
    projectTags: string | undefined;
    apiKey: string;
    priorityText: string | undefined;
    priority: TaskPriority | undefined;
    associatedContactEmail: string | undefined;
    taskType: string | undefined;
    taskStatus: string | undefined;
    checklists: UpdateExtTaskChecklistInput[] | undefined;
    files: UpdateExtTaskFileInput[] | undefined;
}

export class GetTaskExtOutput implements IGetTaskExtOutput {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    taskID!: any | undefined;
    assigneeEmail!: string | undefined;
    assigneeName!: string | undefined;
    title!: string | undefined;
    taskStatus!: string | undefined;
    description!: string | undefined;
    dueDate!: string | undefined;
    priority!: string | undefined;
    project!: string | undefined;
    projectSection!: string | undefined;
    assoContactEmail!: string | undefined;
    assoContactName!: string | undefined;
    referenceId!: string | undefined;
    referenceData!: string | undefined;
    referenceSource!: string | undefined;

    constructor(data?: IGetTaskExtOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.taskID = _data["taskID"];
            this.assigneeEmail = _data["assigneeEmail"];
            this.assigneeName = _data["assigneeName"];
            this.title = _data["title"];
            this.taskStatus = _data["taskStatus"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"];
            this.priority = _data["priority"];
            this.project = _data["project"];
            this.projectSection = _data["projectSection"];
            this.assoContactEmail = _data["assoContactEmail"];
            this.assoContactName = _data["assoContactName"];
            this.referenceId = _data["referenceId"];
            this.referenceData = _data["referenceData"];
            this.referenceSource = _data["referenceSource"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetTaskExtOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetTaskExtOutput>(data, _mappings, GetTaskExtOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["taskID"] = this.taskID;
        data["assigneeEmail"] = this.assigneeEmail;
        data["assigneeName"] = this.assigneeName;
        data["title"] = this.title;
        data["taskStatus"] = this.taskStatus;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate;
        data["priority"] = this.priority;
        data["project"] = this.project;
        data["projectSection"] = this.projectSection;
        data["assoContactEmail"] = this.assoContactEmail;
        data["assoContactName"] = this.assoContactName;
        data["referenceId"] = this.referenceId;
        data["referenceData"] = this.referenceData;
        data["referenceSource"] = this.referenceSource;
        return data;
    }
}

export interface IGetTaskExtOutput {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    taskID: any | undefined;
    assigneeEmail: string | undefined;
    assigneeName: string | undefined;
    title: string | undefined;
    taskStatus: string | undefined;
    description: string | undefined;
    dueDate: string | undefined;
    priority: string | undefined;
    project: string | undefined;
    projectSection: string | undefined;
    assoContactEmail: string | undefined;
    assoContactName: string | undefined;
    referenceId: string | undefined;
    referenceData: string | undefined;
    referenceSource: string | undefined;
}

export class BotTaskCommentInput implements IBotTaskCommentInput {
    taskId!: number | undefined;
    tenantId!: number | undefined;
    apiKey!: string | undefined;
    msTeamsUserId!: string | undefined;
    action!: string | undefined;
    comment!: string | undefined;
    replyToId!: string | undefined;
    isValid!: boolean | undefined;

    constructor(data?: IBotTaskCommentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.tenantId = _data["tenantId"];
            this.apiKey = _data["apiKey"];
            this.msTeamsUserId = _data["msTeamsUserId"];
            this.action = _data["action"];
            this.comment = _data["comment"];
            this.replyToId = _data["replyToId"];
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any, _mappings?: any): BotTaskCommentInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BotTaskCommentInput>(data, _mappings, BotTaskCommentInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["tenantId"] = this.tenantId;
        data["apiKey"] = this.apiKey;
        data["msTeamsUserId"] = this.msTeamsUserId;
        data["action"] = this.action;
        data["comment"] = this.comment;
        data["replyToId"] = this.replyToId;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IBotTaskCommentInput {
    taskId: number | undefined;
    tenantId: number | undefined;
    apiKey: string | undefined;
    msTeamsUserId: string | undefined;
    action: string | undefined;
    comment: string | undefined;
    replyToId: string | undefined;
    isValid: boolean | undefined;
}

export class OpenReplyCommentInput implements IOpenReplyCommentInput {
    taskId!: number | undefined;
    tenantId!: number | undefined;
    apiKey!: string | undefined;
    msTeamsUserId!: string | undefined;
    isValidComment!: boolean | undefined;
    commentId!: number | undefined;
    comment!: string | undefined;
    creatorUserId!: number | undefined;
    creatorName!: string | undefined;
    profileAvatar!: string | undefined;
    mentioned!: string | undefined;
    replyToId!: number | undefined;
    replyToEmail!: string | undefined;
    projectName!: string | undefined;
    taskTitle!: string | undefined;
    replyMsTeamUserId!: string | undefined;
    conversationId!: string | undefined;
    newComment!: string | undefined;
    teamsDeepLinkUrl!: string | undefined;
    creationTimeUtc!: string | undefined;

    constructor(data?: IOpenReplyCommentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.tenantId = _data["tenantId"];
            this.apiKey = _data["apiKey"];
            this.msTeamsUserId = _data["msTeamsUserId"];
            this.isValidComment = _data["isValidComment"];
            this.commentId = _data["commentId"];
            this.comment = _data["comment"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorName = _data["creatorName"];
            this.profileAvatar = _data["profileAvatar"];
            this.mentioned = _data["mentioned"];
            this.replyToId = _data["replyToId"];
            this.replyToEmail = _data["replyToEmail"];
            this.projectName = _data["projectName"];
            this.taskTitle = _data["taskTitle"];
            this.replyMsTeamUserId = _data["replyMsTeamUserId"];
            this.conversationId = _data["conversationId"];
            this.newComment = _data["newComment"];
            this.teamsDeepLinkUrl = _data["teamsDeepLinkUrl"];
            this.creationTimeUtc = _data["creationTimeUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): OpenReplyCommentInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OpenReplyCommentInput>(data, _mappings, OpenReplyCommentInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["tenantId"] = this.tenantId;
        data["apiKey"] = this.apiKey;
        data["msTeamsUserId"] = this.msTeamsUserId;
        data["isValidComment"] = this.isValidComment;
        data["commentId"] = this.commentId;
        data["comment"] = this.comment;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorName"] = this.creatorName;
        data["profileAvatar"] = this.profileAvatar;
        data["mentioned"] = this.mentioned;
        data["replyToId"] = this.replyToId;
        data["replyToEmail"] = this.replyToEmail;
        data["projectName"] = this.projectName;
        data["taskTitle"] = this.taskTitle;
        data["replyMsTeamUserId"] = this.replyMsTeamUserId;
        data["conversationId"] = this.conversationId;
        data["newComment"] = this.newComment;
        data["teamsDeepLinkUrl"] = this.teamsDeepLinkUrl;
        data["creationTimeUtc"] = this.creationTimeUtc;
        return data;
    }
}

export interface IOpenReplyCommentInput {
    taskId: number | undefined;
    tenantId: number | undefined;
    apiKey: string | undefined;
    msTeamsUserId: string | undefined;
    isValidComment: boolean | undefined;
    commentId: number | undefined;
    comment: string | undefined;
    creatorUserId: number | undefined;
    creatorName: string | undefined;
    profileAvatar: string | undefined;
    mentioned: string | undefined;
    replyToId: number | undefined;
    replyToEmail: string | undefined;
    projectName: string | undefined;
    taskTitle: string | undefined;
    replyMsTeamUserId: string | undefined;
    conversationId: string | undefined;
    newComment: string | undefined;
    teamsDeepLinkUrl: string | undefined;
    creationTimeUtc: string | undefined;
}

export class OpenReplyCommentInputIHandleError implements IOpenReplyCommentInputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: OpenReplyCommentInput | undefined;
    listOfEntities!: OpenReplyCommentInput[] | undefined;

    constructor(data?: IOpenReplyCommentInputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? OpenReplyCommentInput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(OpenReplyCommentInput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OpenReplyCommentInputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OpenReplyCommentInputIHandleError>(data, _mappings, OpenReplyCommentInputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOpenReplyCommentInputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: OpenReplyCommentInput | undefined;
    listOfEntities: OpenReplyCommentInput[] | undefined;
}

export class GetTodoTaskExtOutput implements IGetTodoTaskExtOutput {
    taskId!: number | undefined;
    taskName!: string | undefined;
    dueDate!: string | undefined;

    constructor(data?: IGetTodoTaskExtOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.dueDate = _data["dueDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetTodoTaskExtOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetTodoTaskExtOutput>(data, _mappings, GetTodoTaskExtOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["dueDate"] = this.dueDate;
        return data;
    }
}

export interface IGetTodoTaskExtOutput {
    taskId: number | undefined;
    taskName: string | undefined;
    dueDate: string | undefined;
}

export class GetTodoTaskExtOutputListIHandleError implements IGetTodoTaskExtOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetTodoTaskExtOutput[] | undefined;
    listOfEntities!: GetTodoTaskExtOutput[][] | undefined;

    constructor(data?: IGetTodoTaskExtOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(GetTodoTaskExtOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetTodoTaskExtOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetTodoTaskExtOutputListIHandleError>(data, _mappings, GetTodoTaskExtOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IGetTodoTaskExtOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetTodoTaskExtOutput[] | undefined;
    listOfEntities: GetTodoTaskExtOutput[][] | undefined;
}

export class CreateTaskCommentExtInput implements ICreateTaskCommentExtInput {
    apiKey!: string;
    userEmail!: string;
    taskId!: string;
    comment!: string;

    constructor(data?: ICreateTaskCommentExtInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.userEmail = _data["userEmail"];
            this.taskId = _data["taskId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateTaskCommentExtInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateTaskCommentExtInput>(data, _mappings, CreateTaskCommentExtInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["userEmail"] = this.userEmail;
        data["taskId"] = this.taskId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ICreateTaskCommentExtInput {
    apiKey: string;
    userEmail: string;
    taskId: string;
    comment: string;
}

export class GetTaskByResourceExtOutput implements IGetTaskByResourceExtOutput {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    taskID!: any | undefined;
    assigneeEmail!: string | undefined;
    assigneeName!: string | undefined;
    title!: string | undefined;
    taskStatus!: string | undefined;
    description!: string | undefined;
    dueDate!: string | undefined;
    priority!: string | undefined;
    project!: string | undefined;
    projectSection!: string | undefined;
    assoContactEmail!: string | undefined;
    assoContactName!: string | undefined;

    constructor(data?: IGetTaskByResourceExtOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.taskID = _data["taskID"];
            this.assigneeEmail = _data["assigneeEmail"];
            this.assigneeName = _data["assigneeName"];
            this.title = _data["title"];
            this.taskStatus = _data["taskStatus"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"];
            this.priority = _data["priority"];
            this.project = _data["project"];
            this.projectSection = _data["projectSection"];
            this.assoContactEmail = _data["assoContactEmail"];
            this.assoContactName = _data["assoContactName"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetTaskByResourceExtOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetTaskByResourceExtOutput>(data, _mappings, GetTaskByResourceExtOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["taskID"] = this.taskID;
        data["assigneeEmail"] = this.assigneeEmail;
        data["assigneeName"] = this.assigneeName;
        data["title"] = this.title;
        data["taskStatus"] = this.taskStatus;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate;
        data["priority"] = this.priority;
        data["project"] = this.project;
        data["projectSection"] = this.projectSection;
        data["assoContactEmail"] = this.assoContactEmail;
        data["assoContactName"] = this.assoContactName;
        return data;
    }
}

export interface IGetTaskByResourceExtOutput {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    taskID: any | undefined;
    assigneeEmail: string | undefined;
    assigneeName: string | undefined;
    title: string | undefined;
    taskStatus: string | undefined;
    description: string | undefined;
    dueDate: string | undefined;
    priority: string | undefined;
    project: string | undefined;
    projectSection: string | undefined;
    assoContactEmail: string | undefined;
    assoContactName: string | undefined;
}

export class RecentModifiedTasksExtOutput implements IRecentModifiedTasksExtOutput {
    taskId!: string | undefined;
    assigneeEmail!: string | undefined;
    assigneeName!: string | undefined;
    title!: string | undefined;
    taskStatus!: string | undefined;
    dueDate!: string | undefined;
    project!: string | undefined;
    projectSection!: string | undefined;
    assoContactEmail!: string | undefined;
    assoContactName!: string | undefined;
    apiKey!: string | undefined;
    userEmail!: string | undefined;
    lastModificationTime!: string | undefined;
    isImportant!: boolean | undefined;
    externalReferenceId!: string | undefined;
    externalReferenceSource!: string | undefined;
    externalReferenceData!: string | undefined;

    constructor(data?: IRecentModifiedTasksExtOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.assigneeEmail = _data["assigneeEmail"];
            this.assigneeName = _data["assigneeName"];
            this.title = _data["title"];
            this.taskStatus = _data["taskStatus"];
            this.dueDate = _data["dueDate"];
            this.project = _data["project"];
            this.projectSection = _data["projectSection"];
            this.assoContactEmail = _data["assoContactEmail"];
            this.assoContactName = _data["assoContactName"];
            this.apiKey = _data["apiKey"];
            this.userEmail = _data["userEmail"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.isImportant = _data["isImportant"];
            this.externalReferenceId = _data["externalReferenceId"];
            this.externalReferenceSource = _data["externalReferenceSource"];
            this.externalReferenceData = _data["externalReferenceData"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecentModifiedTasksExtOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentModifiedTasksExtOutput>(data, _mappings, RecentModifiedTasksExtOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["assigneeEmail"] = this.assigneeEmail;
        data["assigneeName"] = this.assigneeName;
        data["title"] = this.title;
        data["taskStatus"] = this.taskStatus;
        data["dueDate"] = this.dueDate;
        data["project"] = this.project;
        data["projectSection"] = this.projectSection;
        data["assoContactEmail"] = this.assoContactEmail;
        data["assoContactName"] = this.assoContactName;
        data["apiKey"] = this.apiKey;
        data["userEmail"] = this.userEmail;
        data["lastModificationTime"] = this.lastModificationTime;
        data["isImportant"] = this.isImportant;
        data["externalReferenceId"] = this.externalReferenceId;
        data["externalReferenceSource"] = this.externalReferenceSource;
        data["externalReferenceData"] = this.externalReferenceData;
        return data;
    }
}

export interface IRecentModifiedTasksExtOutput {
    taskId: string | undefined;
    assigneeEmail: string | undefined;
    assigneeName: string | undefined;
    title: string | undefined;
    taskStatus: string | undefined;
    dueDate: string | undefined;
    project: string | undefined;
    projectSection: string | undefined;
    assoContactEmail: string | undefined;
    assoContactName: string | undefined;
    apiKey: string | undefined;
    userEmail: string | undefined;
    lastModificationTime: string | undefined;
    isImportant: boolean | undefined;
    externalReferenceId: string | undefined;
    externalReferenceSource: string | undefined;
    externalReferenceData: string | undefined;
}

export class RecentModifiedTasksExtOutputListIHandleError implements IRecentModifiedTasksExtOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: RecentModifiedTasksExtOutput[] | undefined;
    listOfEntities!: RecentModifiedTasksExtOutput[][] | undefined;

    constructor(data?: IRecentModifiedTasksExtOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(RecentModifiedTasksExtOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RecentModifiedTasksExtOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentModifiedTasksExtOutputListIHandleError>(data, _mappings, RecentModifiedTasksExtOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IRecentModifiedTasksExtOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: RecentModifiedTasksExtOutput[] | undefined;
    listOfEntities: RecentModifiedTasksExtOutput[][] | undefined;
}

export class RecentlyCreatedTaskOutput implements IRecentlyCreatedTaskOutput {
    taskId!: string | undefined;
    taskName!: string | undefined;
    assigneeEmail!: string | undefined;
    projectId!: string | undefined;
    projectName!: string | undefined;
    sectionName!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    creationTime!: string | undefined;

    constructor(data?: IRecentlyCreatedTaskOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.assigneeEmail = _data["assigneeEmail"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.sectionName = _data["sectionName"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.creationTime = _data["creationTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyCreatedTaskOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyCreatedTaskOutput>(data, _mappings, RecentlyCreatedTaskOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["assigneeEmail"] = this.assigneeEmail;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["sectionName"] = this.sectionName;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["creationTime"] = this.creationTime;
        return data;
    }
}

export interface IRecentlyCreatedTaskOutput {
    taskId: string | undefined;
    taskName: string | undefined;
    assigneeEmail: string | undefined;
    projectId: string | undefined;
    projectName: string | undefined;
    sectionName: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    creationTime: string | undefined;
}

export class RecentlyCreatedTaskOutputListIHandleError implements IRecentlyCreatedTaskOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: RecentlyCreatedTaskOutput[] | undefined;
    listOfEntities!: RecentlyCreatedTaskOutput[][] | undefined;

    constructor(data?: IRecentlyCreatedTaskOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(RecentlyCreatedTaskOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyCreatedTaskOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyCreatedTaskOutputListIHandleError>(data, _mappings, RecentlyCreatedTaskOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IRecentlyCreatedTaskOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: RecentlyCreatedTaskOutput[] | undefined;
    listOfEntities: RecentlyCreatedTaskOutput[][] | undefined;
}

export class TaskChanges implements ITaskChanges {
    changeType!: string | undefined;
    oldValue!: string | undefined;
    newValue!: string | undefined;
    date!: string | undefined;

    constructor(data?: ITaskChanges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.changeType = _data["changeType"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskChanges | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskChanges>(data, _mappings, TaskChanges);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeType"] = this.changeType;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["date"] = this.date;
        return data;
    }
}

export interface ITaskChanges {
    changeType: string | undefined;
    oldValue: string | undefined;
    newValue: string | undefined;
    date: string | undefined;
}

export class RecentlyUpdatedTaskOutput implements IRecentlyUpdatedTaskOutput {
    taskId!: string | undefined;
    taskName!: string | undefined;
    assigneeEmail!: string | undefined;
    projectId!: string | undefined;
    projectName!: string | undefined;
    sectionName!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    creationTime!: string | undefined;
    changes!: string | undefined;
    readonly taskChanges!: TaskChanges[] | undefined;

    constructor(data?: IRecentlyUpdatedTaskOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.assigneeEmail = _data["assigneeEmail"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.sectionName = _data["sectionName"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.creationTime = _data["creationTime"];
            this.changes = _data["changes"];
            if (Array.isArray(_data["taskChanges"])) {
                (this as any).taskChanges = [] as any;
                for (let item of _data["taskChanges"])
                    (this as any).taskChanges!.push(TaskChanges.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyUpdatedTaskOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyUpdatedTaskOutput>(data, _mappings, RecentlyUpdatedTaskOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["assigneeEmail"] = this.assigneeEmail;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["sectionName"] = this.sectionName;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["creationTime"] = this.creationTime;
        data["changes"] = this.changes;
        if (Array.isArray(this.taskChanges)) {
            data["taskChanges"] = [];
            for (let item of this.taskChanges)
                data["taskChanges"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRecentlyUpdatedTaskOutput {
    taskId: string | undefined;
    taskName: string | undefined;
    assigneeEmail: string | undefined;
    projectId: string | undefined;
    projectName: string | undefined;
    sectionName: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    creationTime: string | undefined;
    changes: string | undefined;
    taskChanges: TaskChanges[] | undefined;
}

export class RecentlyUpdatedTaskOutputListIHandleError implements IRecentlyUpdatedTaskOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: RecentlyUpdatedTaskOutput[] | undefined;
    listOfEntities!: RecentlyUpdatedTaskOutput[][] | undefined;

    constructor(data?: IRecentlyUpdatedTaskOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(RecentlyUpdatedTaskOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RecentlyUpdatedTaskOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentlyUpdatedTaskOutputListIHandleError>(data, _mappings, RecentlyUpdatedTaskOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IRecentlyUpdatedTaskOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: RecentlyUpdatedTaskOutput[] | undefined;
    listOfEntities: RecentlyUpdatedTaskOutput[][] | undefined;
}

export class RecentDeletedTasksExtOutput implements IRecentDeletedTasksExtOutput {
    taskId!: string | undefined;
    assigneeEmail!: string | undefined;
    assigneeName!: string | undefined;
    title!: string | undefined;
    taskStatus!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    description!: string | undefined;
    project!: string | undefined;
    projectSection!: string | undefined;
    assoContactEmail!: string | undefined;
    assoContactName!: string | undefined;
    apiKey!: string | undefined;
    userEmail!: string | undefined;
    lastModificationTime!: string | undefined;
    isImportant!: boolean | undefined;
    externalReferenceId!: string | undefined;
    externalReferenceSource!: string | undefined;
    externalReferenceData!: string | undefined;

    constructor(data?: IRecentDeletedTasksExtOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.assigneeEmail = _data["assigneeEmail"];
            this.assigneeName = _data["assigneeName"];
            this.title = _data["title"];
            this.taskStatus = _data["taskStatus"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.description = _data["description"];
            this.project = _data["project"];
            this.projectSection = _data["projectSection"];
            this.assoContactEmail = _data["assoContactEmail"];
            this.assoContactName = _data["assoContactName"];
            this.apiKey = _data["apiKey"];
            this.userEmail = _data["userEmail"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.isImportant = _data["isImportant"];
            this.externalReferenceId = _data["externalReferenceId"];
            this.externalReferenceSource = _data["externalReferenceSource"];
            this.externalReferenceData = _data["externalReferenceData"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecentDeletedTasksExtOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentDeletedTasksExtOutput>(data, _mappings, RecentDeletedTasksExtOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["assigneeEmail"] = this.assigneeEmail;
        data["assigneeName"] = this.assigneeName;
        data["title"] = this.title;
        data["taskStatus"] = this.taskStatus;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["description"] = this.description;
        data["project"] = this.project;
        data["projectSection"] = this.projectSection;
        data["assoContactEmail"] = this.assoContactEmail;
        data["assoContactName"] = this.assoContactName;
        data["apiKey"] = this.apiKey;
        data["userEmail"] = this.userEmail;
        data["lastModificationTime"] = this.lastModificationTime;
        data["isImportant"] = this.isImportant;
        data["externalReferenceId"] = this.externalReferenceId;
        data["externalReferenceSource"] = this.externalReferenceSource;
        data["externalReferenceData"] = this.externalReferenceData;
        return data;
    }
}

export interface IRecentDeletedTasksExtOutput {
    taskId: string | undefined;
    assigneeEmail: string | undefined;
    assigneeName: string | undefined;
    title: string | undefined;
    taskStatus: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    description: string | undefined;
    project: string | undefined;
    projectSection: string | undefined;
    assoContactEmail: string | undefined;
    assoContactName: string | undefined;
    apiKey: string | undefined;
    userEmail: string | undefined;
    lastModificationTime: string | undefined;
    isImportant: boolean | undefined;
    externalReferenceId: string | undefined;
    externalReferenceSource: string | undefined;
    externalReferenceData: string | undefined;
}

export class RecentDeletedTasksExtOutputListIHandleError implements IRecentDeletedTasksExtOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: RecentDeletedTasksExtOutput[] | undefined;
    listOfEntities!: RecentDeletedTasksExtOutput[][] | undefined;

    constructor(data?: IRecentDeletedTasksExtOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(RecentDeletedTasksExtOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RecentDeletedTasksExtOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentDeletedTasksExtOutputListIHandleError>(data, _mappings, RecentDeletedTasksExtOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IRecentDeletedTasksExtOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: RecentDeletedTasksExtOutput[] | undefined;
    listOfEntities: RecentDeletedTasksExtOutput[][] | undefined;
}

export class CreateExtProjectInput implements ICreateExtProjectInput {
    projectName!: string;
    creatorEmail!: string;
    apiKey!: string;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isPrivate!: boolean | undefined;
    description!: string | undefined;
    contactEmail!: string | undefined;
    members!: string | undefined;
    sections!: string | undefined;
    files!: CreateExtTaskFileInput[] | undefined;
    referenceId!: string | undefined;
    referenceData!: string | undefined;
    referenceSource!: string | undefined;

    constructor(data?: ICreateExtProjectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            this.creatorEmail = _data["creatorEmail"];
            this.apiKey = _data["apiKey"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isPrivate = _data["isPrivate"];
            this.description = _data["description"];
            this.contactEmail = _data["contactEmail"];
            this.members = _data["members"];
            this.sections = _data["sections"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(CreateExtTaskFileInput.fromJS(item, _mappings));
            }
            this.referenceId = _data["referenceId"];
            this.referenceData = _data["referenceData"];
            this.referenceSource = _data["referenceSource"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateExtProjectInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateExtProjectInput>(data, _mappings, CreateExtProjectInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["creatorEmail"] = this.creatorEmail;
        data["apiKey"] = this.apiKey;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isPrivate"] = this.isPrivate;
        data["description"] = this.description;
        data["contactEmail"] = this.contactEmail;
        data["members"] = this.members;
        data["sections"] = this.sections;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        data["referenceId"] = this.referenceId;
        data["referenceData"] = this.referenceData;
        data["referenceSource"] = this.referenceSource;
        return data;
    }
}

export interface ICreateExtProjectInput {
    projectName: string;
    creatorEmail: string;
    apiKey: string;
    startDate: string | undefined;
    dueDate: string | undefined;
    isPrivate: boolean | undefined;
    description: string | undefined;
    contactEmail: string | undefined;
    members: string | undefined;
    sections: string | undefined;
    files: CreateExtTaskFileInput[] | undefined;
    referenceId: string | undefined;
    referenceData: string | undefined;
    referenceSource: string | undefined;
}

export class CreateProjectResult implements ICreateProjectResult {
    statusCode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    projectId!: any | undefined;

    constructor(data?: ICreateProjectResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateProjectResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateProjectResult>(data, _mappings, CreateProjectResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ICreateProjectResult {
    statusCode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    projectId: any | undefined;
}

export class UpdateProjectExt implements IUpdateProjectExt {
    projectId!: string;
    projectName!: string;
    currentUserEmail!: string;
    apiKey!: string;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    status!: string | undefined;
    isPrivate!: boolean | undefined;
    description!: string | undefined;
    referenceId!: string | undefined;
    referenceData!: string | undefined;
    referenceSource!: string | undefined;

    constructor(data?: IUpdateProjectExt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.currentUserEmail = _data["currentUserEmail"];
            this.apiKey = _data["apiKey"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.status = _data["status"];
            this.isPrivate = _data["isPrivate"];
            this.description = _data["description"];
            this.referenceId = _data["referenceId"];
            this.referenceData = _data["referenceData"];
            this.referenceSource = _data["referenceSource"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateProjectExt | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateProjectExt>(data, _mappings, UpdateProjectExt);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["currentUserEmail"] = this.currentUserEmail;
        data["apiKey"] = this.apiKey;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["status"] = this.status;
        data["isPrivate"] = this.isPrivate;
        data["description"] = this.description;
        data["referenceId"] = this.referenceId;
        data["referenceData"] = this.referenceData;
        data["referenceSource"] = this.referenceSource;
        return data;
    }
}

export interface IUpdateProjectExt {
    projectId: string;
    projectName: string;
    currentUserEmail: string;
    apiKey: string;
    startDate: string | undefined;
    dueDate: string | undefined;
    status: string | undefined;
    isPrivate: boolean | undefined;
    description: string | undefined;
    referenceId: string | undefined;
    referenceData: string | undefined;
    referenceSource: string | undefined;
}

export class GetProjectExtOutput implements IGetProjectExtOutput {
    statusCode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    projectId!: any | undefined;
    projectName!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    status!: string | undefined;
    isPrivate!: boolean | undefined;
    description!: string | undefined;
    managerEmails!: string | undefined;
    folderLocPath!: string | undefined;
    referenceId!: string | undefined;
    referenceData!: string | undefined;
    referenceSource!: string | undefined;

    constructor(data?: IGetProjectExtOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.status = _data["status"];
            this.isPrivate = _data["isPrivate"];
            this.description = _data["description"];
            this.managerEmails = _data["managerEmails"];
            this.folderLocPath = _data["folderLocPath"];
            this.referenceId = _data["referenceId"];
            this.referenceData = _data["referenceData"];
            this.referenceSource = _data["referenceSource"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetProjectExtOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetProjectExtOutput>(data, _mappings, GetProjectExtOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["status"] = this.status;
        data["isPrivate"] = this.isPrivate;
        data["description"] = this.description;
        data["managerEmails"] = this.managerEmails;
        data["folderLocPath"] = this.folderLocPath;
        data["referenceId"] = this.referenceId;
        data["referenceData"] = this.referenceData;
        data["referenceSource"] = this.referenceSource;
        return data;
    }
}

export interface IGetProjectExtOutput {
    statusCode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    projectId: any | undefined;
    projectName: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    status: string | undefined;
    isPrivate: boolean | undefined;
    description: string | undefined;
    managerEmails: string | undefined;
    folderLocPath: string | undefined;
    referenceId: string | undefined;
    referenceData: string | undefined;
    referenceSource: string | undefined;
}

export class GetProjectsExtOutput implements IGetProjectsExtOutput {
    projectId!: string | undefined;
    projectName!: string | undefined;
    dueDate!: string | undefined;
    startDate!: string | undefined;
    projectProgress!: number | undefined;
    status!: string | undefined;
    isPrivate!: boolean | undefined;
    inactiveSinceDate!: string | undefined;
    healthScore!: number | undefined;
    scoreExplanation!: string | undefined;
    scoreLastUpdated!: string | undefined;

    constructor(data?: IGetProjectsExtOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.dueDate = _data["dueDate"];
            this.startDate = _data["startDate"];
            this.projectProgress = _data["projectProgress"];
            this.status = _data["status"];
            this.isPrivate = _data["isPrivate"];
            this.inactiveSinceDate = _data["inactiveSinceDate"];
            this.healthScore = _data["healthScore"];
            this.scoreExplanation = _data["scoreExplanation"];
            this.scoreLastUpdated = _data["scoreLastUpdated"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetProjectsExtOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetProjectsExtOutput>(data, _mappings, GetProjectsExtOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["dueDate"] = this.dueDate;
        data["startDate"] = this.startDate;
        data["projectProgress"] = this.projectProgress;
        data["status"] = this.status;
        data["isPrivate"] = this.isPrivate;
        data["inactiveSinceDate"] = this.inactiveSinceDate;
        data["healthScore"] = this.healthScore;
        data["scoreExplanation"] = this.scoreExplanation;
        data["scoreLastUpdated"] = this.scoreLastUpdated;
        return data;
    }
}

export interface IGetProjectsExtOutput {
    projectId: string | undefined;
    projectName: string | undefined;
    dueDate: string | undefined;
    startDate: string | undefined;
    projectProgress: number | undefined;
    status: string | undefined;
    isPrivate: boolean | undefined;
    inactiveSinceDate: string | undefined;
    healthScore: number | undefined;
    scoreExplanation: string | undefined;
    scoreLastUpdated: string | undefined;
}

export class GetProjectsExtResult implements IGetProjectsExtResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    projects!: GetProjectsExtOutput[] | undefined;

    constructor(data?: IGetProjectsExtResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(GetProjectsExtOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetProjectsExtResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetProjectsExtResult>(data, _mappings, GetProjectsExtResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetProjectsExtResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    projects: GetProjectsExtOutput[] | undefined;
}

export class GetProjectTasksExtOutput implements IGetProjectTasksExtOutput {
    taskId!: string | undefined;
    ownerId!: number | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isDueDatePassed!: boolean | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    code!: number | undefined;
    name!: string | undefined;
    isNewlyAssigned!: boolean | undefined;
    assignedByUserId!: number | undefined;
    assignedByUser!: string | undefined;
    assignedToUserId!: number | undefined;
    assignedToUser!: string | undefined;
    assignedToUserProfilePictureUrl!: string | undefined;
    assignedTime!: string | undefined;
    completedOn!: string | undefined;
    isAddedOnMyDay!: boolean | undefined;
    endDate!: string | undefined;
    integrationId!: string | undefined;
    integratedFrom!: string | undefined;
    integrationIcon!: string | undefined;
    integrationCode!: number | undefined;
    projectName!: string | undefined;
    isPrivateProject!: boolean | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    tag1!: string | undefined;
    tag2!: string | undefined;
    tag3!: string | undefined;
    color!: string | undefined;
    keyId!: string | undefined;
    webUrl!: string | undefined;
    projectId!: number | undefined;
    taskProjectName!: string | undefined;
    projectSectionId!: number | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    pinnedEntityId!: number | undefined;
    resourceName!: string | undefined;
    resourceIconUrl!: string | undefined;
    resourceGreyIconUrl!: string | undefined;
    resourceAppIntegrationId!: number | undefined;
    resourceAppUrl!: string | undefined;
    isCustom!: boolean | undefined;
    hasUnreadComments!: boolean | undefined;
    isPrivate!: boolean | undefined;
    isAssignedToProject!: boolean | undefined;
    priority!: TaskPriority | undefined;
    readonly projectTags!: ProjectTag[] | undefined;
    statusCode!: number | undefined;
    entityType!: TaskEntityType | undefined;
    taskType!: TaskTypes | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactCompanyId!: number | undefined;
    contactCompanyName!: string | undefined;
    contactTypeColor!: string | undefined;
    readonly taskAssociations!: TaskAssociation[] | undefined;
    parentId!: number | undefined;
    isPartOfTaskTree!: boolean | undefined;

    constructor(data?: IGetProjectTasksExtOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.ownerId = _data["ownerId"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isNewlyAssigned = _data["isNewlyAssigned"];
            this.assignedByUserId = _data["assignedByUserId"];
            this.assignedByUser = _data["assignedByUser"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"];
            this.assignedToUserProfilePictureUrl = _data["assignedToUserProfilePictureUrl"];
            this.assignedTime = _data["assignedTime"];
            this.completedOn = _data["completedOn"];
            this.isAddedOnMyDay = _data["isAddedOnMyDay"];
            this.endDate = _data["endDate"];
            this.integrationId = _data["integrationId"];
            this.integratedFrom = _data["integratedFrom"];
            this.integrationIcon = _data["integrationIcon"];
            this.integrationCode = _data["integrationCode"];
            this.projectName = _data["projectName"];
            this.isPrivateProject = _data["isPrivateProject"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.tag1 = _data["tag1"];
            this.tag2 = _data["tag2"];
            this.tag3 = _data["tag3"];
            this.color = _data["color"];
            this.keyId = _data["keyId"];
            this.webUrl = _data["webUrl"];
            this.projectId = _data["projectId"];
            this.taskProjectName = _data["taskProjectName"];
            this.projectSectionId = _data["projectSectionId"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.resourceName = _data["resourceName"];
            this.resourceIconUrl = _data["resourceIconUrl"];
            this.resourceGreyIconUrl = _data["resourceGreyIconUrl"];
            this.resourceAppIntegrationId = _data["resourceAppIntegrationId"];
            this.resourceAppUrl = _data["resourceAppUrl"];
            this.isCustom = _data["isCustom"];
            this.hasUnreadComments = _data["hasUnreadComments"];
            this.isPrivate = _data["isPrivate"];
            this.isAssignedToProject = _data["isAssignedToProject"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["projectTags"])) {
                (this as any).projectTags = [] as any;
                for (let item of _data["projectTags"])
                    (this as any).projectTags!.push(ProjectTag.fromJS(item, _mappings));
            }
            this.statusCode = _data["statusCode"];
            this.entityType = _data["entityType"];
            this.taskType = _data["taskType"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactCompanyId = _data["contactCompanyId"];
            this.contactCompanyName = _data["contactCompanyName"];
            this.contactTypeColor = _data["contactTypeColor"];
            if (Array.isArray(_data["taskAssociations"])) {
                (this as any).taskAssociations = [] as any;
                for (let item of _data["taskAssociations"])
                    (this as any).taskAssociations!.push(TaskAssociation.fromJS(item, _mappings));
            }
            this.parentId = _data["parentId"];
            this.isPartOfTaskTree = _data["isPartOfTaskTree"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetProjectTasksExtOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetProjectTasksExtOutput>(data, _mappings, GetProjectTasksExtOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["ownerId"] = this.ownerId;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isNewlyAssigned"] = this.isNewlyAssigned;
        data["assignedByUserId"] = this.assignedByUserId;
        data["assignedByUser"] = this.assignedByUser;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser;
        data["assignedToUserProfilePictureUrl"] = this.assignedToUserProfilePictureUrl;
        data["assignedTime"] = this.assignedTime;
        data["completedOn"] = this.completedOn;
        data["isAddedOnMyDay"] = this.isAddedOnMyDay;
        data["endDate"] = this.endDate;
        data["integrationId"] = this.integrationId;
        data["integratedFrom"] = this.integratedFrom;
        data["integrationIcon"] = this.integrationIcon;
        data["integrationCode"] = this.integrationCode;
        data["projectName"] = this.projectName;
        data["isPrivateProject"] = this.isPrivateProject;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["tag1"] = this.tag1;
        data["tag2"] = this.tag2;
        data["tag3"] = this.tag3;
        data["color"] = this.color;
        data["keyId"] = this.keyId;
        data["webUrl"] = this.webUrl;
        data["projectId"] = this.projectId;
        data["taskProjectName"] = this.taskProjectName;
        data["projectSectionId"] = this.projectSectionId;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["resourceName"] = this.resourceName;
        data["resourceIconUrl"] = this.resourceIconUrl;
        data["resourceGreyIconUrl"] = this.resourceGreyIconUrl;
        data["resourceAppIntegrationId"] = this.resourceAppIntegrationId;
        data["resourceAppUrl"] = this.resourceAppUrl;
        data["isCustom"] = this.isCustom;
        data["hasUnreadComments"] = this.hasUnreadComments;
        data["isPrivate"] = this.isPrivate;
        data["isAssignedToProject"] = this.isAssignedToProject;
        data["priority"] = this.priority;
        if (Array.isArray(this.projectTags)) {
            data["projectTags"] = [];
            for (let item of this.projectTags)
                data["projectTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["statusCode"] = this.statusCode;
        data["entityType"] = this.entityType;
        data["taskType"] = this.taskType;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactCompanyId"] = this.contactCompanyId;
        data["contactCompanyName"] = this.contactCompanyName;
        data["contactTypeColor"] = this.contactTypeColor;
        if (Array.isArray(this.taskAssociations)) {
            data["taskAssociations"] = [];
            for (let item of this.taskAssociations)
                data["taskAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentId"] = this.parentId;
        data["isPartOfTaskTree"] = this.isPartOfTaskTree;
        return data;
    }
}

export interface IGetProjectTasksExtOutput {
    taskId: string | undefined;
    ownerId: number | undefined;
    title: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isDueDatePassed: boolean | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    code: number | undefined;
    name: string | undefined;
    isNewlyAssigned: boolean | undefined;
    assignedByUserId: number | undefined;
    assignedByUser: string | undefined;
    assignedToUserId: number | undefined;
    assignedToUser: string | undefined;
    assignedToUserProfilePictureUrl: string | undefined;
    assignedTime: string | undefined;
    completedOn: string | undefined;
    isAddedOnMyDay: boolean | undefined;
    endDate: string | undefined;
    integrationId: string | undefined;
    integratedFrom: string | undefined;
    integrationIcon: string | undefined;
    integrationCode: number | undefined;
    projectName: string | undefined;
    isPrivateProject: boolean | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    tag1: string | undefined;
    tag2: string | undefined;
    tag3: string | undefined;
    color: string | undefined;
    keyId: string | undefined;
    webUrl: string | undefined;
    projectId: number | undefined;
    taskProjectName: string | undefined;
    projectSectionId: number | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    pinnedEntityId: number | undefined;
    resourceName: string | undefined;
    resourceIconUrl: string | undefined;
    resourceGreyIconUrl: string | undefined;
    resourceAppIntegrationId: number | undefined;
    resourceAppUrl: string | undefined;
    isCustom: boolean | undefined;
    hasUnreadComments: boolean | undefined;
    isPrivate: boolean | undefined;
    isAssignedToProject: boolean | undefined;
    priority: TaskPriority | undefined;
    projectTags: ProjectTag[] | undefined;
    statusCode: number | undefined;
    entityType: TaskEntityType | undefined;
    taskType: TaskTypes | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactCompanyId: number | undefined;
    contactCompanyName: string | undefined;
    contactTypeColor: string | undefined;
    taskAssociations: TaskAssociation[] | undefined;
    parentId: number | undefined;
    isPartOfTaskTree: boolean | undefined;
}

export class GetProjectTasksResult implements IGetProjectTasksResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    tasks!: GetProjectTasksExtOutput[] | undefined;

    constructor(data?: IGetProjectTasksResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(GetProjectTasksExtOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetProjectTasksResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetProjectTasksResult>(data, _mappings, GetProjectTasksResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetProjectTasksResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    tasks: GetProjectTasksExtOutput[] | undefined;
}

export class GetProjectSectionsExtOutput implements IGetProjectSectionsExtOutput {
    sectionId!: string | undefined;
    sectionName!: string | undefined;
    sortOrder!: number | undefined;

    constructor(data?: IGetProjectSectionsExtOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetProjectSectionsExtOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetProjectSectionsExtOutput>(data, _mappings, GetProjectSectionsExtOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IGetProjectSectionsExtOutput {
    sectionId: string | undefined;
    sectionName: string | undefined;
    sortOrder: number | undefined;
}

export class GetProjectSectionsResult implements IGetProjectSectionsResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    sections!: GetProjectSectionsExtOutput[] | undefined;

    constructor(data?: IGetProjectSectionsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(GetProjectSectionsExtOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetProjectSectionsResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetProjectSectionsResult>(data, _mappings, GetProjectSectionsResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetProjectSectionsResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    sections: GetProjectSectionsExtOutput[] | undefined;
}

export class GetCustomerProjectsExtOutput implements IGetCustomerProjectsExtOutput {
    projectId!: string | undefined;
    projectName!: string | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    stage!: string | undefined;
    status!: string | undefined;

    constructor(data?: IGetCustomerProjectsExtOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.stage = _data["stage"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetCustomerProjectsExtOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetCustomerProjectsExtOutput>(data, _mappings, GetCustomerProjectsExtOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["stage"] = this.stage;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetCustomerProjectsExtOutput {
    projectId: string | undefined;
    projectName: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    stage: string | undefined;
    status: string | undefined;
}

export class GetCustomerProjectsResult implements IGetCustomerProjectsResult {
    statuscode!: number | undefined;
    targetUrl!: any | undefined;
    success!: boolean | undefined;
    error!: any | undefined;
    unAuthorizedRequest!: boolean | undefined;
    __abp!: boolean | undefined;
    projects!: GetCustomerProjectsExtOutput[] | undefined;

    constructor(data?: IGetCustomerProjectsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statuscode = _data["statuscode"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"];
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(GetCustomerProjectsExtOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetCustomerProjectsResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetCustomerProjectsResult>(data, _mappings, GetCustomerProjectsResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statuscode"] = this.statuscode;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCustomerProjectsResult {
    statuscode: number | undefined;
    targetUrl: any | undefined;
    success: boolean | undefined;
    error: any | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
    projects: GetCustomerProjectsExtOutput[] | undefined;
}

export class ProjectTemplateExt implements IProjectTemplateExt {
    templateId!: string | undefined;
    templateName!: string | undefined;
    createdBy!: string | undefined;
    createdOn!: string | undefined;

    constructor(data?: IProjectTemplateExt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.templateName = _data["templateName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTemplateExt | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTemplateExt>(data, _mappings, ProjectTemplateExt);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["templateName"] = this.templateName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn;
        return data;
    }
}

export interface IProjectTemplateExt {
    templateId: string | undefined;
    templateName: string | undefined;
    createdBy: string | undefined;
    createdOn: string | undefined;
}

export class ProjectTemplateExtListIHandleError implements IProjectTemplateExtListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectTemplateExt[] | undefined;
    listOfEntities!: ProjectTemplateExt[][] | undefined;

    constructor(data?: IProjectTemplateExtListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectTemplateExt.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTemplateExtListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTemplateExtListIHandleError>(data, _mappings, ProjectTemplateExtListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectTemplateExtListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectTemplateExt[] | undefined;
    listOfEntities: ProjectTemplateExt[][] | undefined;
}

export class ProjectRolesExt implements IProjectRolesExt {
    roleId!: string | undefined;
    roleName!: string | undefined;
    roleType!: string | undefined;

    constructor(data?: IProjectRolesExt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleType = _data["roleType"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectRolesExt | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectRolesExt>(data, _mappings, ProjectRolesExt);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleType"] = this.roleType;
        return data;
    }
}

export interface IProjectRolesExt {
    roleId: string | undefined;
    roleName: string | undefined;
    roleType: string | undefined;
}

export class ProjectRolesExtListIHandleError implements IProjectRolesExtListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectRolesExt[] | undefined;
    listOfEntities!: ProjectRolesExt[][] | undefined;

    constructor(data?: IProjectRolesExtListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectRolesExt.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectRolesExtListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectRolesExtListIHandleError>(data, _mappings, ProjectRolesExtListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectRolesExtListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectRolesExt[] | undefined;
    listOfEntities: ProjectRolesExt[][] | undefined;
}

export class ProjectMembersExt implements IProjectMembersExt {
    roleId!: string | undefined;
    memberEmail!: string | undefined;

    constructor(data?: IProjectMembersExt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.memberEmail = _data["memberEmail"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectMembersExt | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectMembersExt>(data, _mappings, ProjectMembersExt);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["memberEmail"] = this.memberEmail;
        return data;
    }
}

export interface IProjectMembersExt {
    roleId: string | undefined;
    memberEmail: string | undefined;
}

export class CreateProjectFromTemplateExt implements ICreateProjectFromTemplateExt {
    templateId!: string;
    creatorEmail!: string;
    apiKey!: string;
    projectName!: string;
    startDate!: string | undefined;
    endDate!: string | undefined;
    clientName!: string | undefined;
    isPrivate!: boolean | undefined;
    members!: ProjectMembersExt[] | undefined;
    filesLinks!: CreateExtTaskFileInput[] | undefined;

    constructor(data?: ICreateProjectFromTemplateExt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.creatorEmail = _data["creatorEmail"];
            this.apiKey = _data["apiKey"];
            this.projectName = _data["projectName"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.clientName = _data["clientName"];
            this.isPrivate = _data["isPrivate"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(ProjectMembersExt.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["filesLinks"])) {
                this.filesLinks = [] as any;
                for (let item of _data["filesLinks"])
                    this.filesLinks!.push(CreateExtTaskFileInput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateProjectFromTemplateExt | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateProjectFromTemplateExt>(data, _mappings, CreateProjectFromTemplateExt);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["creatorEmail"] = this.creatorEmail;
        data["apiKey"] = this.apiKey;
        data["projectName"] = this.projectName;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["clientName"] = this.clientName;
        data["isPrivate"] = this.isPrivate;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.filesLinks)) {
            data["filesLinks"] = [];
            for (let item of this.filesLinks)
                data["filesLinks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateProjectFromTemplateExt {
    templateId: string;
    creatorEmail: string;
    apiKey: string;
    projectName: string;
    startDate: string | undefined;
    endDate: string | undefined;
    clientName: string | undefined;
    isPrivate: boolean | undefined;
    members: ProjectMembersExt[] | undefined;
    filesLinks: CreateExtTaskFileInput[] | undefined;
}

export class ProjectFromTempResultExt implements IProjectFromTempResultExt {
    projectId!: string | undefined;
    projectName!: string | undefined;

    constructor(data?: IProjectFromTempResultExt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectFromTempResultExt | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectFromTempResultExt>(data, _mappings, ProjectFromTempResultExt);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IProjectFromTempResultExt {
    projectId: string | undefined;
    projectName: string | undefined;
}

export class ProjectFromTempResultExtIHandleError implements IProjectFromTempResultExtIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectFromTempResultExt | undefined;
    listOfEntities!: ProjectFromTempResultExt[] | undefined;

    constructor(data?: IProjectFromTempResultExtIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProjectFromTempResultExt.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProjectFromTempResultExt.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectFromTempResultExtIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectFromTempResultExtIHandleError>(data, _mappings, ProjectFromTempResultExtIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectFromTempResultExtIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectFromTempResultExt | undefined;
    listOfEntities: ProjectFromTempResultExt[] | undefined;
}

export class CreateExtAlertInput implements ICreateExtAlertInput {
    alertToEmail!: string | undefined;
    title!: string;
    message!: string | undefined;
    resourceName!: string | undefined;
    resourceUrl!: string | undefined;
    apiKey!: string | undefined;

    constructor(data?: ICreateExtAlertInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.alertToEmail = _data["alertToEmail"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.resourceName = _data["resourceName"];
            this.resourceUrl = _data["resourceUrl"];
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateExtAlertInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateExtAlertInput>(data, _mappings, CreateExtAlertInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertToEmail"] = this.alertToEmail;
        data["title"] = this.title;
        data["message"] = this.message;
        data["resourceName"] = this.resourceName;
        data["resourceUrl"] = this.resourceUrl;
        data["apiKey"] = this.apiKey;
        return data;
    }
}

export interface ICreateExtAlertInput {
    alertToEmail: string | undefined;
    title: string;
    message: string | undefined;
    resourceName: string | undefined;
    resourceUrl: string | undefined;
    apiKey: string | undefined;
}

export class BotTaskInputDto implements IBotTaskInputDto {
    description!: string | undefined;
    msTeamsUserId!: string | undefined;
    toEmail!: string | undefined;
    taskName!: string | undefined;
    resourceAppUrl!: string | undefined;
    resourceAppName!: string | undefined;
    originalTaskTitle!: string | undefined;
    dueDate!: string | undefined;
    projectId!: number | undefined;

    constructor(data?: IBotTaskInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.description = _data["description"];
            this.msTeamsUserId = _data["msTeamsUserId"];
            this.toEmail = _data["toEmail"];
            this.taskName = _data["taskName"];
            this.resourceAppUrl = _data["resourceAppUrl"];
            this.resourceAppName = _data["resourceAppName"];
            this.originalTaskTitle = _data["originalTaskTitle"];
            this.dueDate = _data["dueDate"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any, _mappings?: any): BotTaskInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BotTaskInputDto>(data, _mappings, BotTaskInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["msTeamsUserId"] = this.msTeamsUserId;
        data["toEmail"] = this.toEmail;
        data["taskName"] = this.taskName;
        data["resourceAppUrl"] = this.resourceAppUrl;
        data["resourceAppName"] = this.resourceAppName;
        data["originalTaskTitle"] = this.originalTaskTitle;
        data["dueDate"] = this.dueDate;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IBotTaskInputDto {
    description: string | undefined;
    msTeamsUserId: string | undefined;
    toEmail: string | undefined;
    taskName: string | undefined;
    resourceAppUrl: string | undefined;
    resourceAppName: string | undefined;
    originalTaskTitle: string | undefined;
    dueDate: string | undefined;
    projectId: number | undefined;
}

export class BotCreateTaskOutputDto implements IBotCreateTaskOutputDto {
    taskId!: number | undefined;
    checkInId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    isCreate!: boolean | undefined;
    userEmail!: string | undefined;
    taskTitle!: string | undefined;
    apiKey!: string | undefined;

    constructor(data?: IBotCreateTaskOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.checkInId = _data["checkInId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.isCreate = _data["isCreate"];
            this.userEmail = _data["userEmail"];
            this.taskTitle = _data["taskTitle"];
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): BotCreateTaskOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BotCreateTaskOutputDto>(data, _mappings, BotCreateTaskOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["checkInId"] = this.checkInId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["isCreate"] = this.isCreate;
        data["userEmail"] = this.userEmail;
        data["taskTitle"] = this.taskTitle;
        data["apiKey"] = this.apiKey;
        return data;
    }
}

export interface IBotCreateTaskOutputDto {
    taskId: number | undefined;
    checkInId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    isCreate: boolean | undefined;
    userEmail: string | undefined;
    taskTitle: string | undefined;
    apiKey: string | undefined;
}

export class BotCreateTaskResult implements IBotCreateTaskResult {
    statusCode!: number | undefined;
    content!: BotCreateTaskOutputDto | undefined;

    constructor(data?: IBotCreateTaskResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.content = _data["content"] ? BotCreateTaskOutputDto.fromJS(_data["content"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): BotCreateTaskResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BotCreateTaskResult>(data, _mappings, BotCreateTaskResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["content"] = this.content ? this.content.toJSON() : undefined as any;
        return data;
    }
}

export interface IBotCreateTaskResult {
    statusCode: number | undefined;
    content: BotCreateTaskOutputDto | undefined;
}

export class BotGetProjectsOutputDto implements IBotGetProjectsOutputDto {
    projectId!: number | undefined;
    projectName!: string | undefined;

    constructor(data?: IBotGetProjectsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any, _mappings?: any): BotGetProjectsOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BotGetProjectsOutputDto>(data, _mappings, BotGetProjectsOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IBotGetProjectsOutputDto {
    projectId: number | undefined;
    projectName: string | undefined;
}

export class BotGetProjectsResult implements IBotGetProjectsResult {
    statusCode!: number | undefined;
    content!: BotGetProjectsOutputDto[] | undefined;

    constructor(data?: IBotGetProjectsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(BotGetProjectsOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): BotGetProjectsResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BotGetProjectsResult>(data, _mappings, BotGetProjectsResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBotGetProjectsResult {
    statusCode: number | undefined;
    content: BotGetProjectsOutputDto[] | undefined;
}

export class UpdateTaskFromBotInput implements IUpdateTaskFromBotInput {
    taskId!: number | undefined;
    tenantId!: number | undefined;
    apiKey!: string | undefined;
    toUserId!: number | undefined;
    msTeamsUserId!: string | undefined;
    dueDate!: string | undefined;
    sectionId!: number | undefined;
    projectId!: number | undefined;
    currentUserId!: number | undefined;

    constructor(data?: IUpdateTaskFromBotInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.tenantId = _data["tenantId"];
            this.apiKey = _data["apiKey"];
            this.toUserId = _data["toUserId"];
            this.msTeamsUserId = _data["msTeamsUserId"];
            this.dueDate = _data["dueDate"];
            this.sectionId = _data["sectionId"];
            this.projectId = _data["projectId"];
            this.currentUserId = _data["currentUserId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateTaskFromBotInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateTaskFromBotInput>(data, _mappings, UpdateTaskFromBotInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["tenantId"] = this.tenantId;
        data["apiKey"] = this.apiKey;
        data["toUserId"] = this.toUserId;
        data["msTeamsUserId"] = this.msTeamsUserId;
        data["dueDate"] = this.dueDate;
        data["sectionId"] = this.sectionId;
        data["projectId"] = this.projectId;
        data["currentUserId"] = this.currentUserId;
        return data;
    }
}

export interface IUpdateTaskFromBotInput {
    taskId: number | undefined;
    tenantId: number | undefined;
    apiKey: string | undefined;
    toUserId: number | undefined;
    msTeamsUserId: string | undefined;
    dueDate: string | undefined;
    sectionId: number | undefined;
    projectId: number | undefined;
    currentUserId: number | undefined;
}

export class DeleteTaskFromBotInput implements IDeleteTaskFromBotInput {
    taskId!: number | undefined;
    tenantId!: number | undefined;
    apiKey!: string | undefined;
    msTeamsUserId!: string | undefined;
    userId!: number | undefined;
    checkInId!: number | undefined;

    constructor(data?: IDeleteTaskFromBotInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.tenantId = _data["tenantId"];
            this.apiKey = _data["apiKey"];
            this.msTeamsUserId = _data["msTeamsUserId"];
            this.userId = _data["userId"];
            this.checkInId = _data["checkInId"];
        }
    }

    static fromJS(data: any, _mappings?: any): DeleteTaskFromBotInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DeleteTaskFromBotInput>(data, _mappings, DeleteTaskFromBotInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["tenantId"] = this.tenantId;
        data["apiKey"] = this.apiKey;
        data["msTeamsUserId"] = this.msTeamsUserId;
        data["userId"] = this.userId;
        data["checkInId"] = this.checkInId;
        return data;
    }
}

export interface IDeleteTaskFromBotInput {
    taskId: number | undefined;
    tenantId: number | undefined;
    apiKey: string | undefined;
    msTeamsUserId: string | undefined;
    userId: number | undefined;
    checkInId: number | undefined;
}

export class DeleteTaskFromBotOutput implements IDeleteTaskFromBotOutput {
    userId!: number | undefined;
    taskId!: number | undefined;
    isDeleted!: boolean | undefined;
    hasAccess!: boolean | undefined;
    result!: boolean | undefined;
    taskTitle!: string | undefined;

    constructor(data?: IDeleteTaskFromBotOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.taskId = _data["taskId"];
            this.isDeleted = _data["isDeleted"];
            this.hasAccess = _data["hasAccess"];
            this.result = _data["result"];
            this.taskTitle = _data["taskTitle"];
        }
    }

    static fromJS(data: any, _mappings?: any): DeleteTaskFromBotOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DeleteTaskFromBotOutput>(data, _mappings, DeleteTaskFromBotOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["taskId"] = this.taskId;
        data["isDeleted"] = this.isDeleted;
        data["hasAccess"] = this.hasAccess;
        data["result"] = this.result;
        data["taskTitle"] = this.taskTitle;
        return data;
    }
}

export interface IDeleteTaskFromBotOutput {
    userId: number | undefined;
    taskId: number | undefined;
    isDeleted: boolean | undefined;
    hasAccess: boolean | undefined;
    result: boolean | undefined;
    taskTitle: string | undefined;
}

export class DeleteTaskFromBotOutputIHandleError implements IDeleteTaskFromBotOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: DeleteTaskFromBotOutput | undefined;
    listOfEntities!: DeleteTaskFromBotOutput[] | undefined;

    constructor(data?: IDeleteTaskFromBotOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? DeleteTaskFromBotOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(DeleteTaskFromBotOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DeleteTaskFromBotOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DeleteTaskFromBotOutputIHandleError>(data, _mappings, DeleteTaskFromBotOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDeleteTaskFromBotOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: DeleteTaskFromBotOutput | undefined;
    listOfEntities: DeleteTaskFromBotOutput[] | undefined;
}

export class UserBotConversationInputDto implements IUserBotConversationInputDto {
    msTeamsUserId!: string | undefined;
    botTenantId!: string | undefined;
    conversationId!: string | undefined;
    serviceUrl!: string | undefined;
    botUserId!: string | undefined;
    msTeamsUserEmail!: string | undefined;

    constructor(data?: IUserBotConversationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.msTeamsUserId = _data["msTeamsUserId"];
            this.botTenantId = _data["botTenantId"];
            this.conversationId = _data["conversationId"];
            this.serviceUrl = _data["serviceUrl"];
            this.botUserId = _data["botUserId"];
            this.msTeamsUserEmail = _data["msTeamsUserEmail"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserBotConversationInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserBotConversationInputDto>(data, _mappings, UserBotConversationInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msTeamsUserId"] = this.msTeamsUserId;
        data["botTenantId"] = this.botTenantId;
        data["conversationId"] = this.conversationId;
        data["serviceUrl"] = this.serviceUrl;
        data["botUserId"] = this.botUserId;
        data["msTeamsUserEmail"] = this.msTeamsUserEmail;
        return data;
    }
}

export interface IUserBotConversationInputDto {
    msTeamsUserId: string | undefined;
    botTenantId: string | undefined;
    conversationId: string | undefined;
    serviceUrl: string | undefined;
    botUserId: string | undefined;
    msTeamsUserEmail: string | undefined;
}

export class UserBotConservationDto implements IUserBotConservationDto {
    userId!: number | undefined;
    msTeamsUserId!: string | undefined;
    botTenantId!: string | undefined;
    conversationId!: string | undefined;
    serviceUrl!: string | undefined;
    botUserId!: string | undefined;
    firstName!: string | undefined;
    tenantId!: number | undefined;

    constructor(data?: IUserBotConservationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.msTeamsUserId = _data["msTeamsUserId"];
            this.botTenantId = _data["botTenantId"];
            this.conversationId = _data["conversationId"];
            this.serviceUrl = _data["serviceUrl"];
            this.botUserId = _data["botUserId"];
            this.firstName = _data["firstName"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserBotConservationDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserBotConservationDto>(data, _mappings, UserBotConservationDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["msTeamsUserId"] = this.msTeamsUserId;
        data["botTenantId"] = this.botTenantId;
        data["conversationId"] = this.conversationId;
        data["serviceUrl"] = this.serviceUrl;
        data["botUserId"] = this.botUserId;
        data["firstName"] = this.firstName;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IUserBotConservationDto {
    userId: number | undefined;
    msTeamsUserId: string | undefined;
    botTenantId: string | undefined;
    conversationId: string | undefined;
    serviceUrl: string | undefined;
    botUserId: string | undefined;
    firstName: string | undefined;
    tenantId: number | undefined;
}

export class HttpResultUserBotConversationDto implements IHttpResultUserBotConversationDto {
    reseponseData!: UserBotConservationDto | undefined;
    statusCode!: number | undefined;
    isError!: boolean | undefined;
    errorMessage!: string | undefined;

    constructor(data?: IHttpResultUserBotConversationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.reseponseData = _data["reseponseData"] ? UserBotConservationDto.fromJS(_data["reseponseData"], _mappings) : undefined as any;
            this.statusCode = _data["statusCode"];
            this.isError = _data["isError"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any, _mappings?: any): HttpResultUserBotConversationDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<HttpResultUserBotConversationDto>(data, _mappings, HttpResultUserBotConversationDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reseponseData"] = this.reseponseData ? this.reseponseData.toJSON() : undefined as any;
        data["statusCode"] = this.statusCode;
        data["isError"] = this.isError;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IHttpResultUserBotConversationDto {
    reseponseData: UserBotConservationDto | undefined;
    statusCode: number | undefined;
    isError: boolean | undefined;
    errorMessage: string | undefined;
}

export class DeleteUserBotConversationInput implements IDeleteUserBotConversationInput {
    msTeamsUserId!: string | undefined;

    constructor(data?: IDeleteUserBotConversationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.msTeamsUserId = _data["msTeamsUserId"];
        }
    }

    static fromJS(data: any, _mappings?: any): DeleteUserBotConversationInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DeleteUserBotConversationInput>(data, _mappings, DeleteUserBotConversationInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msTeamsUserId"] = this.msTeamsUserId;
        return data;
    }
}

export interface IDeleteUserBotConversationInput {
    msTeamsUserId: string | undefined;
}

export class AvailableAppOutput implements IAvailableAppOutput {
    defaultAppId!: number | undefined;
    name!: string | undefined;
    subText!: string | undefined;
    iconUrl!: string | undefined;
    link!: string | undefined;
    isLicensed!: boolean | undefined;

    constructor(data?: IAvailableAppOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.defaultAppId = _data["defaultAppId"];
            this.name = _data["name"];
            this.subText = _data["subText"];
            this.iconUrl = _data["iconUrl"];
            this.link = _data["link"];
            this.isLicensed = _data["isLicensed"];
        }
    }

    static fromJS(data: any, _mappings?: any): AvailableAppOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AvailableAppOutput>(data, _mappings, AvailableAppOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultAppId"] = this.defaultAppId;
        data["name"] = this.name;
        data["subText"] = this.subText;
        data["iconUrl"] = this.iconUrl;
        data["link"] = this.link;
        data["isLicensed"] = this.isLicensed;
        return data;
    }
}

export interface IAvailableAppOutput {
    defaultAppId: number | undefined;
    name: string | undefined;
    subText: string | undefined;
    iconUrl: string | undefined;
    link: string | undefined;
    isLicensed: boolean | undefined;
}

export class AvailableAppOutputListIHandleError implements IAvailableAppOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: AvailableAppOutput[] | undefined;
    listOfEntities!: AvailableAppOutput[][] | undefined;

    constructor(data?: IAvailableAppOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(AvailableAppOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AvailableAppOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AvailableAppOutputListIHandleError>(data, _mappings, AvailableAppOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IAvailableAppOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: AvailableAppOutput[] | undefined;
    listOfEntities: AvailableAppOutput[][] | undefined;
}

export enum EntityType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class FavoriteItemOutput implements IFavoriteItemOutput {
    pinId!: number | undefined;
    entityId!: number | undefined;
    type!: EntityType | undefined;
    name!: string | undefined;
    segments!: string[] | undefined;
    sortOrder!: number | undefined;
    url!: string | undefined;
    path!: string | undefined;
    msFileId!: string | undefined;
    msDriveId!: string | undefined;
    msSiteId!: string | undefined;
    msFolderId!: string | undefined;
    fileType!: string | undefined;
    isLink!: boolean | undefined;
    iconUrl!: string | undefined;

    constructor(data?: IFavoriteItemOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.pinId = _data["pinId"];
            this.entityId = _data["entityId"];
            this.type = _data["type"];
            this.name = _data["name"];
            if (Array.isArray(_data["segments"])) {
                this.segments = [] as any;
                for (let item of _data["segments"])
                    this.segments!.push(item);
            }
            this.sortOrder = _data["sortOrder"];
            this.url = _data["url"];
            this.path = _data["path"];
            this.msFileId = _data["msFileId"];
            this.msDriveId = _data["msDriveId"];
            this.msSiteId = _data["msSiteId"];
            this.msFolderId = _data["msFolderId"];
            this.fileType = _data["fileType"];
            this.isLink = _data["isLink"];
            this.iconUrl = _data["iconUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): FavoriteItemOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FavoriteItemOutput>(data, _mappings, FavoriteItemOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pinId"] = this.pinId;
        data["entityId"] = this.entityId;
        data["type"] = this.type;
        data["name"] = this.name;
        if (Array.isArray(this.segments)) {
            data["segments"] = [];
            for (let item of this.segments)
                data["segments"].push(item);
        }
        data["sortOrder"] = this.sortOrder;
        data["url"] = this.url;
        data["path"] = this.path;
        data["msFileId"] = this.msFileId;
        data["msDriveId"] = this.msDriveId;
        data["msSiteId"] = this.msSiteId;
        data["msFolderId"] = this.msFolderId;
        data["fileType"] = this.fileType;
        data["isLink"] = this.isLink;
        data["iconUrl"] = this.iconUrl;
        return data;
    }
}

export interface IFavoriteItemOutput {
    pinId: number | undefined;
    entityId: number | undefined;
    type: EntityType | undefined;
    name: string | undefined;
    segments: string[] | undefined;
    sortOrder: number | undefined;
    url: string | undefined;
    path: string | undefined;
    msFileId: string | undefined;
    msDriveId: string | undefined;
    msSiteId: string | undefined;
    msFolderId: string | undefined;
    fileType: string | undefined;
    isLink: boolean | undefined;
    iconUrl: string | undefined;
}

export class FavoriteListOutput implements IFavoriteListOutput {
    totalCount!: number | undefined;
    items!: FavoriteItemOutput[] | undefined;

    constructor(data?: IFavoriteListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FavoriteItemOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): FavoriteListOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FavoriteListOutput>(data, _mappings, FavoriteListOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFavoriteListOutput {
    totalCount: number | undefined;
    items: FavoriteItemOutput[] | undefined;
}

export class FavoriteListOutputIHandleError implements IFavoriteListOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: FavoriteListOutput | undefined;
    listOfEntities!: FavoriteListOutput[] | undefined;

    constructor(data?: IFavoriteListOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? FavoriteListOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(FavoriteListOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): FavoriteListOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FavoriteListOutputIHandleError>(data, _mappings, FavoriteListOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFavoriteListOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: FavoriteListOutput | undefined;
    listOfEntities: FavoriteListOutput[] | undefined;
}

export class FileAttachmentRefInput implements IFileAttachmentRefInput {
    msFileId!: string | undefined;
    msDriveId!: string | undefined;

    constructor(data?: IFileAttachmentRefInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.msFileId = _data["msFileId"];
            this.msDriveId = _data["msDriveId"];
        }
    }

    static fromJS(data: any, _mappings?: any): FileAttachmentRefInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FileAttachmentRefInput>(data, _mappings, FileAttachmentRefInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msFileId"] = this.msFileId;
        data["msDriveId"] = this.msDriveId;
        return data;
    }
}

export interface IFileAttachmentRefInput {
    msFileId: string | undefined;
    msDriveId: string | undefined;
}

export class FileAttachmentRefOutput implements IFileAttachmentRefOutput {
    msFileId!: string | undefined;
    attachmentId!: number | undefined;
    msDriveId!: string | undefined;

    constructor(data?: IFileAttachmentRefOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.msFileId = _data["msFileId"];
            this.attachmentId = _data["attachmentId"];
            this.msDriveId = _data["msDriveId"];
        }
    }

    static fromJS(data: any, _mappings?: any): FileAttachmentRefOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FileAttachmentRefOutput>(data, _mappings, FileAttachmentRefOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msFileId"] = this.msFileId;
        data["attachmentId"] = this.attachmentId;
        data["msDriveId"] = this.msDriveId;
        return data;
    }
}

export interface IFileAttachmentRefOutput {
    msFileId: string | undefined;
    attachmentId: number | undefined;
    msDriveId: string | undefined;
}

export class FileAttachmentRefOutputListIHandleError implements IFileAttachmentRefOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: FileAttachmentRefOutput[] | undefined;
    listOfEntities!: FileAttachmentRefOutput[][] | undefined;

    constructor(data?: IFileAttachmentRefOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(FileAttachmentRefOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): FileAttachmentRefOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FileAttachmentRefOutputListIHandleError>(data, _mappings, FileAttachmentRefOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IFileAttachmentRefOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: FileAttachmentRefOutput[] | undefined;
    listOfEntities: FileAttachmentRefOutput[][] | undefined;
}

export class AddFavoriteInput implements IAddFavoriteInput {
    entityId!: number | undefined;
    type!: EntityType | undefined;

    constructor(data?: IAddFavoriteInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any, _mappings?: any): AddFavoriteInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddFavoriteInput>(data, _mappings, AddFavoriteInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["type"] = this.type;
        return data;
    }
}

export interface IAddFavoriteInput {
    entityId: number | undefined;
    type: EntityType | undefined;
}

export class AddFavoriteOutput implements IAddFavoriteOutput {
    pinId!: number | undefined;
    entityId!: number | undefined;
    sortOrder!: number | undefined;

    constructor(data?: IAddFavoriteOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.pinId = _data["pinId"];
            this.entityId = _data["entityId"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): AddFavoriteOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddFavoriteOutput>(data, _mappings, AddFavoriteOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pinId"] = this.pinId;
        data["entityId"] = this.entityId;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IAddFavoriteOutput {
    pinId: number | undefined;
    entityId: number | undefined;
    sortOrder: number | undefined;
}

export class AddFavoriteOutputIHandleError implements IAddFavoriteOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: AddFavoriteOutput | undefined;
    listOfEntities!: AddFavoriteOutput[] | undefined;

    constructor(data?: IAddFavoriteOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? AddFavoriteOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(AddFavoriteOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AddFavoriteOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddFavoriteOutputIHandleError>(data, _mappings, AddFavoriteOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddFavoriteOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: AddFavoriteOutput | undefined;
    listOfEntities: AddFavoriteOutput[] | undefined;
}

export class AddFavoriteOutputListIHandleError implements IAddFavoriteOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: AddFavoriteOutput[] | undefined;
    listOfEntities!: AddFavoriteOutput[][] | undefined;

    constructor(data?: IAddFavoriteOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(AddFavoriteOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AddFavoriteOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddFavoriteOutputListIHandleError>(data, _mappings, AddFavoriteOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IAddFavoriteOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: AddFavoriteOutput[] | undefined;
    listOfEntities: AddFavoriteOutput[][] | undefined;
}

export class ProjectBulkActionInput implements IProjectBulkActionInput {
    ids!: number[] | undefined;

    constructor(data?: IProjectBulkActionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectBulkActionInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectBulkActionInput>(data, _mappings, ProjectBulkActionInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IProjectBulkActionInput {
    ids: number[] | undefined;
}

export class RemoveFavoriteOutput implements IRemoveFavoriteOutput {
    pinId!: number | undefined;
    type!: EntityType | undefined;
    entityId!: number | undefined;
    removed!: boolean | undefined;

    constructor(data?: IRemoveFavoriteOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.pinId = _data["pinId"];
            this.type = _data["type"];
            this.entityId = _data["entityId"];
            this.removed = _data["removed"];
        }
    }

    static fromJS(data: any, _mappings?: any): RemoveFavoriteOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RemoveFavoriteOutput>(data, _mappings, RemoveFavoriteOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pinId"] = this.pinId;
        data["type"] = this.type;
        data["entityId"] = this.entityId;
        data["removed"] = this.removed;
        return data;
    }
}

export interface IRemoveFavoriteOutput {
    pinId: number | undefined;
    type: EntityType | undefined;
    entityId: number | undefined;
    removed: boolean | undefined;
}

export class RemoveFavoriteOutputListIHandleError implements IRemoveFavoriteOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: RemoveFavoriteOutput[] | undefined;
    listOfEntities!: RemoveFavoriteOutput[][] | undefined;

    constructor(data?: IRemoveFavoriteOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(RemoveFavoriteOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RemoveFavoriteOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RemoveFavoriteOutputListIHandleError>(data, _mappings, RemoveFavoriteOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IRemoveFavoriteOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: RemoveFavoriteOutput[] | undefined;
    listOfEntities: RemoveFavoriteOutput[][] | undefined;
}

export class FavoriteOrderInput implements IFavoriteOrderInput {
    type!: EntityType | undefined;
    entityId!: number | undefined;
    pinId!: number | undefined;
    sortOrder!: number | undefined;

    constructor(data?: IFavoriteOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.type = _data["type"];
            this.entityId = _data["entityId"];
            this.pinId = _data["pinId"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): FavoriteOrderInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FavoriteOrderInput>(data, _mappings, FavoriteOrderInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["entityId"] = this.entityId;
        data["pinId"] = this.pinId;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IFavoriteOrderInput {
    type: EntityType | undefined;
    entityId: number | undefined;
    pinId: number | undefined;
    sortOrder: number | undefined;
}

export class ReorderFavoritesInput implements IReorderFavoritesInput {
    orders!: FavoriteOrderInput[] | undefined;

    constructor(data?: IReorderFavoritesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(FavoriteOrderInput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ReorderFavoritesInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReorderFavoritesInput>(data, _mappings, ReorderFavoritesInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReorderFavoritesInput {
    orders: FavoriteOrderInput[] | undefined;
}

export class BeginGetHelpIntroInput implements IBeginGetHelpIntroInput {
    sessionId!: string;

    constructor(data?: IBeginGetHelpIntroInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): BeginGetHelpIntroInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BeginGetHelpIntroInput>(data, _mappings, BeginGetHelpIntroInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IBeginGetHelpIntroInput {
    sessionId: string;
}

export class GetHelpIntroDto implements IGetHelpIntroDto {
    showBanner!: boolean | undefined;
    isExistingUser!: boolean | undefined;

    constructor(data?: IGetHelpIntroDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.showBanner = _data["showBanner"];
            this.isExistingUser = _data["isExistingUser"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetHelpIntroDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetHelpIntroDto>(data, _mappings, GetHelpIntroDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showBanner"] = this.showBanner;
        data["isExistingUser"] = this.isExistingUser;
        return data;
    }
}

export interface IGetHelpIntroDto {
    showBanner: boolean | undefined;
    isExistingUser: boolean | undefined;
}

export class GridPreferenceInput implements IGridPreferenceInput {
    name!: string | undefined;
    preferences!: string | undefined;

    constructor(data?: IGridPreferenceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.preferences = _data["preferences"];
        }
    }

    static fromJS(data: any, _mappings?: any): GridPreferenceInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GridPreferenceInput>(data, _mappings, GridPreferenceInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["preferences"] = this.preferences;
        return data;
    }
}

export interface IGridPreferenceInput {
    name: string | undefined;
    preferences: string | undefined;
}

export class GridPreferenceOutput implements IGridPreferenceOutput {
    id!: number | undefined;
    preferences!: string | undefined;

    constructor(data?: IGridPreferenceOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.preferences = _data["preferences"];
        }
    }

    static fromJS(data: any, _mappings?: any): GridPreferenceOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GridPreferenceOutput>(data, _mappings, GridPreferenceOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["preferences"] = this.preferences;
        return data;
    }
}

export interface IGridPreferenceOutput {
    id: number | undefined;
    preferences: string | undefined;
}

export class GridPreferenceOutputIHandleError implements IGridPreferenceOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GridPreferenceOutput | undefined;
    listOfEntities!: GridPreferenceOutput[] | undefined;

    constructor(data?: IGridPreferenceOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GridPreferenceOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GridPreferenceOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GridPreferenceOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GridPreferenceOutputIHandleError>(data, _mappings, GridPreferenceOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGridPreferenceOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GridPreferenceOutput | undefined;
    listOfEntities: GridPreferenceOutput[] | undefined;
}

export enum ChartDateInterval {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class IncomeStastistic implements IIncomeStastistic {
    label!: string | undefined;
    date!: string | undefined;
    amount!: number | undefined;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.label = _data["label"];
            this.date = _data["date"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any, _mappings?: any): IncomeStastistic | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IncomeStastistic>(data, _mappings, IncomeStastistic);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IIncomeStastistic {
    label: string | undefined;
    date: string | undefined;
    amount: number | undefined;
}

export class TenantEdition implements ITenantEdition {
    label!: string | undefined;
    value!: number | undefined;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): TenantEdition | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantEdition>(data, _mappings, TenantEdition);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number | undefined;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName!: string | undefined;
    remainingDayCount!: number | undefined;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.remainingDayCount = _data["remainingDayCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): ExpiringTenant | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ExpiringTenant>(data, _mappings, ExpiringTenant);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number | undefined;
}

export class RecentTenant implements IRecentTenant {
    id!: number | undefined;
    name!: string | undefined;
    creationTime!: string | undefined;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecentTenant | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecentTenant>(data, _mappings, RecentTenant);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime;
        return data;
    }
}

export interface IRecentTenant {
    id: number | undefined;
    name: string | undefined;
    creationTime: string | undefined;
}

export class HostDashboardData implements IHostDashboardData {
    newTenantsCount!: number | undefined;
    newSubscriptionAmount!: number | undefined;
    dashboardPlaceholder1!: number | undefined;
    dashboardPlaceholder2!: number | undefined;
    incomeStatistics!: IncomeStastistic[] | undefined;
    editionStatistics!: TenantEdition[] | undefined;
    expiringTenants!: ExpiringTenant[] | undefined;
    recentTenants!: RecentTenant[] | undefined;
    maxExpiringTenantsShownCount!: number | undefined;
    maxRecentTenantsShownCount!: number | undefined;
    subscriptionEndAlertDayCount!: number | undefined;
    recentTenantsDayCount!: number | undefined;
    subscriptionEndDateStart!: string | undefined;
    subscriptionEndDateEnd!: string | undefined;
    tenantCreationStartDate!: string | undefined;

    constructor(data?: IHostDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.newTenantsCount = _data["newTenantsCount"];
            this.newSubscriptionAmount = _data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = _data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = _data["dashboardPlaceholder2"];
            if (Array.isArray(_data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of _data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStastistic.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of _data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["expiringTenants"])) {
                this.expiringTenants = [] as any;
                for (let item of _data["expiringTenants"])
                    this.expiringTenants!.push(ExpiringTenant.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["recentTenants"])) {
                this.recentTenants = [] as any;
                for (let item of _data["recentTenants"])
                    this.recentTenants!.push(RecentTenant.fromJS(item, _mappings));
            }
            this.maxExpiringTenantsShownCount = _data["maxExpiringTenantsShownCount"];
            this.maxRecentTenantsShownCount = _data["maxRecentTenantsShownCount"];
            this.subscriptionEndAlertDayCount = _data["subscriptionEndAlertDayCount"];
            this.recentTenantsDayCount = _data["recentTenantsDayCount"];
            this.subscriptionEndDateStart = _data["subscriptionEndDateStart"];
            this.subscriptionEndDateEnd = _data["subscriptionEndDateEnd"];
            this.tenantCreationStartDate = _data["tenantCreationStartDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): HostDashboardData | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<HostDashboardData>(data, _mappings, HostDashboardData);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.expiringTenants)) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.recentTenants)) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item ? item.toJSON() : undefined as any);
        }
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate;
        return data;
    }
}

export interface IHostDashboardData {
    newTenantsCount: number | undefined;
    newSubscriptionAmount: number | undefined;
    dashboardPlaceholder1: number | undefined;
    dashboardPlaceholder2: number | undefined;
    incomeStatistics: IncomeStastistic[] | undefined;
    editionStatistics: TenantEdition[] | undefined;
    expiringTenants: ExpiringTenant[] | undefined;
    recentTenants: RecentTenant[] | undefined;
    maxExpiringTenantsShownCount: number | undefined;
    maxRecentTenantsShownCount: number | undefined;
    subscriptionEndAlertDayCount: number | undefined;
    recentTenantsDayCount: number | undefined;
    subscriptionEndDateStart: string | undefined;
    subscriptionEndDateEnd: string | undefined;
    tenantCreationStartDate: string | undefined;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics!: IncomeStastistic[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of _data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStastistic.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetIncomeStatisticsDataOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetIncomeStatisticsDataOutput>(data, _mappings, GetIncomeStatisticsDataOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics!: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of _data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetEditionTenantStatisticsOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetEditionTenantStatisticsOutput>(data, _mappings, GetEditionTenantStatisticsOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone!: string | undefined;
    timezoneForComparison!: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.timezoneForComparison = _data["timezoneForComparison"];
        }
    }

    static fromJS(data: any, _mappings?: any): GeneralSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GeneralSettingsEditDto>(data, _mappings, GeneralSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin!: boolean | undefined;
    smsVerificationEnabled!: boolean | undefined;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = _data["smsVerificationEnabled"];
        }
    }

    static fromJS(data: any, _mappings?: any): HostUserManagementSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<HostUserManagementSettingsEditDto>(data, _mappings, HostUserManagementSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        return data;
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean | undefined;
    smsVerificationEnabled: boolean | undefined;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number | undefined;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean | undefined;
    smtpUseDefaultCredentials!: boolean | undefined;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any, _mappings?: any): EmailSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmailSettingsEditDto>(data, _mappings, EmailSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number | undefined;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean | undefined;
    smtpUseDefaultCredentials: boolean | undefined;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration!: boolean | undefined;
    isNewRegisteredTenantActiveByDefault!: boolean | undefined;
    useCaptchaOnRegistration!: boolean | undefined;
    defaultEditionId!: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = _data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.defaultEditionId = _data["defaultEditionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): TenantManagementSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantManagementSettingsEditDto>(data, _mappings, TenantManagementSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean | undefined;
    isNewRegisteredTenantActiveByDefault: boolean | undefined;
    useCaptchaOnRegistration: boolean | undefined;
    defaultEditionId: number | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit!: boolean | undefined;
    requireLowercase!: boolean | undefined;
    requireNonAlphanumeric!: boolean | undefined;
    requireUppercase!: boolean | undefined;
    requiredLength!: number | undefined;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requireDigit = _data["requireDigit"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"];
            this.requireUppercase = _data["requireUppercase"];
            this.requiredLength = _data["requiredLength"];
        }
    }

    static fromJS(data: any, _mappings?: any): PasswordComplexitySetting | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PasswordComplexitySetting>(data, _mappings, PasswordComplexitySetting);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean | undefined;
    requireLowercase: boolean | undefined;
    requireNonAlphanumeric: boolean | undefined;
    requireUppercase: boolean | undefined;
    requiredLength: number | undefined;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled!: boolean | undefined;
    maxFailedAccessAttemptsBeforeLockout!: number | undefined;
    defaultAccountLockoutSeconds!: number | undefined;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = _data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = _data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserLockOutSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserLockOutSettingsEditDto>(data, _mappings, UserLockOutSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean | undefined;
    maxFailedAccessAttemptsBeforeLockout: number | undefined;
    defaultAccountLockoutSeconds: number | undefined;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication!: boolean | undefined;
    isEnabled!: boolean | undefined;
    isEmailProviderEnabled!: boolean | undefined;
    isSmsProviderEnabled!: boolean | undefined;
    isRememberBrowserEnabled!: boolean | undefined;
    isGoogleAuthenticatorEnabled!: boolean | undefined;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isEnabledForApplication = _data["isEnabledForApplication"];
            this.isEnabled = _data["isEnabled"];
            this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = _data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any, _mappings?: any): TwoFactorLoginSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TwoFactorLoginSettingsEditDto>(data, _mappings, TwoFactorLoginSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean | undefined;
    isEnabled: boolean | undefined;
    isEmailProviderEnabled: boolean | undefined;
    isSmsProviderEnabled: boolean | undefined;
    isRememberBrowserEnabled: boolean | undefined;
    isGoogleAuthenticatorEnabled: boolean | undefined;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings!: boolean | undefined;
    passwordComplexity!: PasswordComplexitySetting | undefined;
    defaultPasswordComplexity!: PasswordComplexitySetting | undefined;
    userLockOut!: UserLockOutSettingsEditDto | undefined;
    twoFactorLogin!: TwoFactorLoginSettingsEditDto | undefined;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.useDefaultPasswordComplexitySettings = _data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(_data["passwordComplexity"], _mappings) : undefined as any;
            this.defaultPasswordComplexity = _data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(_data["defaultPasswordComplexity"], _mappings) : undefined as any;
            this.userLockOut = _data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(_data["userLockOut"], _mappings) : undefined as any;
            this.twoFactorLogin = _data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(_data["twoFactorLogin"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): SecuritySettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SecuritySettingsEditDto>(data, _mappings, SecuritySettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : undefined as any;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : undefined as any;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : undefined as any;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : undefined as any;
        return data;
    }
}

export interface ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean | undefined;
    passwordComplexity: PasswordComplexitySetting | undefined;
    defaultPasswordComplexity: PasswordComplexitySetting | undefined;
    userLockOut: UserLockOutSettingsEditDto | undefined;
    twoFactorLogin: TwoFactorLoginSettingsEditDto | undefined;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any, _mappings?: any): HostBillingSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<HostBillingSettingsEditDto>(data, _mappings, HostBillingSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: HostUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto;
    tenantManagement!: TenantManagementSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: HostBillingSettingsEditDto | undefined;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"], _mappings) : new GeneralSettingsEditDto();
            this.userManagement = _data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(_data["userManagement"], _mappings) : new HostUserManagementSettingsEditDto();
            this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"], _mappings) : new EmailSettingsEditDto();
            this.tenantManagement = _data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(_data["tenantManagement"], _mappings) : new TenantManagementSettingsEditDto();
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"], _mappings) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? HostBillingSettingsEditDto.fromJS(_data["billing"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): HostSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<HostSettingsEditDto>(data, _mappings, HostSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : undefined as any;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : undefined as any;
        data["email"] = this.email ? this.email.toJSON() : undefined as any;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : undefined as any;
        data["security"] = this.security ? this.security.toJSON() : undefined as any;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined as any;
        return data;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto | undefined;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress!: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any, _mappings?: any): SendTestEmailInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SendTestEmailInput>(data, _mappings, SendTestEmailInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class InvoiceDto implements IInvoiceDto {
    amount!: number | undefined;
    editionDisplayName!: string | undefined;
    invoiceNo!: string | undefined;
    invoiceDate!: string | undefined;
    tenantLegalName!: string | undefined;
    tenantAddress!: string[] | undefined;
    tenantTaxNo!: string | undefined;
    hostLegalName!: string | undefined;
    hostAddress!: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceDate = _data["invoiceDate"];
            this.tenantLegalName = _data["tenantLegalName"];
            if (Array.isArray(_data["tenantAddress"])) {
                this.tenantAddress = [] as any;
                for (let item of _data["tenantAddress"])
                    this.tenantAddress!.push(item);
            }
            this.tenantTaxNo = _data["tenantTaxNo"];
            this.hostLegalName = _data["hostLegalName"];
            if (Array.isArray(_data["hostAddress"])) {
                this.hostAddress = [] as any;
                for (let item of _data["hostAddress"])
                    this.hostAddress!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): InvoiceDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InvoiceDto>(data, _mappings, InvoiceDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate;
        data["tenantLegalName"] = this.tenantLegalName;
        if (Array.isArray(this.tenantAddress)) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (Array.isArray(this.hostAddress)) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data;
    }
}

export interface IInvoiceDto {
    amount: number | undefined;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: string | undefined;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId!: number | undefined;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.subscriptionPaymentId = _data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateInvoiceDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateInvoiceDto>(data, _mappings, CreateInvoiceDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data;
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number | undefined;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    icon!: string | undefined;
    isDisabled!: boolean | undefined;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.icon = _data["icon"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any, _mappings?: any): ApplicationLanguageListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApplicationLanguageListDto>(data, _mappings, ApplicationLanguageListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        return data;
    }
}

export interface IApplicationLanguageListDto {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    items!: ApplicationLanguageListDto[] | undefined;
    defaultLanguageName!: string | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicationLanguageListDto.fromJS(item, _mappings));
            }
            this.defaultLanguageName = _data["defaultLanguageName"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetLanguagesOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetLanguagesOutput>(data, _mappings, GetLanguagesOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["defaultLanguageName"] = this.defaultLanguageName;
        return data;
    }
}

export interface IGetLanguagesOutput {
    items: ApplicationLanguageListDto[] | undefined;
    defaultLanguageName: string | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id!: number | undefined;
    name!: string;
    icon!: string | undefined;
    isEnabled!: boolean | undefined;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any, _mappings?: any): ApplicationLanguageEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApplicationLanguageEditDto>(data, _mappings, ApplicationLanguageEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean | undefined;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean | undefined;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any, _mappings?: any): ComboboxItemDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ComboboxItemDto>(data, _mappings, ComboboxItemDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean | undefined;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language!: ApplicationLanguageEditDto | undefined;
    languageNames!: ComboboxItemDto[] | undefined;
    flags!: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"], _mappings) : undefined as any;
            if (Array.isArray(_data["languageNames"])) {
                this.languageNames = [] as any;
                for (let item of _data["languageNames"])
                    this.languageNames!.push(ComboboxItemDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(ComboboxItemDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetLanguageForEditOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetLanguageForEditOutput>(data, _mappings, GetLanguageForEditOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : undefined as any;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto | undefined;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language!: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"], _mappings) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any, _mappings?: any): CreateOrUpdateLanguageInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateOrUpdateLanguageInput>(data, _mappings, CreateOrUpdateLanguageInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name!: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetDefaultLanguageInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetDefaultLanguageInput>(data, _mappings, SetDefaultLanguageInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key!: string | undefined;
    baseValue!: string | undefined;
    targetValue!: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.baseValue = _data["baseValue"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any, _mappings?: any): LanguageTextListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LanguageTextListDto>(data, _mappings, LanguageTextListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class LanguageTextListDtoPagedResultDto implements ILanguageTextListDtoPagedResultDto {
    items!: LanguageTextListDto[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: ILanguageTextListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageTextListDto.fromJS(item, _mappings));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): LanguageTextListDtoPagedResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LanguageTextListDtoPagedResultDto>(data, _mappings, LanguageTextListDtoPagedResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ILanguageTextListDtoPagedResultDto {
    items: LanguageTextListDto[] | undefined;
    totalCount: number | undefined;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName!: string;
    sourceName!: string;
    key!: string;
    value!: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
            this.sourceName = _data["sourceName"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateLanguageTextInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateLanguageTextInput>(data, _mappings, UpdateLanguageTextInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class LeadBoardStageDto implements ILeadBoardStageDto {
    id!: number | undefined;
    name!: string | undefined;
    act!: ClientStageAct | undefined;
    isActive!: boolean | undefined;
    rank!: number | undefined;
    color!: string | undefined;
    nextStep!: string | undefined;
    followUpDays!: number | undefined;
    noFollowUp!: boolean | undefined;
    boardVisibility!: ClientStageBoardVisibility | undefined;
    hideAfterDays!: number | undefined;

    constructor(data?: ILeadBoardStageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.act = _data["act"];
            this.isActive = _data["isActive"];
            this.rank = _data["rank"];
            this.color = _data["color"];
            this.nextStep = _data["nextStep"];
            this.followUpDays = _data["followUpDays"];
            this.noFollowUp = _data["noFollowUp"];
            this.boardVisibility = _data["boardVisibility"];
            this.hideAfterDays = _data["hideAfterDays"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBoardStageDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBoardStageDto>(data, _mappings, LeadBoardStageDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["act"] = this.act;
        data["isActive"] = this.isActive;
        data["rank"] = this.rank;
        data["color"] = this.color;
        data["nextStep"] = this.nextStep;
        data["followUpDays"] = this.followUpDays;
        data["noFollowUp"] = this.noFollowUp;
        data["boardVisibility"] = this.boardVisibility;
        data["hideAfterDays"] = this.hideAfterDays;
        return data;
    }
}

export interface ILeadBoardStageDto {
    id: number | undefined;
    name: string | undefined;
    act: ClientStageAct | undefined;
    isActive: boolean | undefined;
    rank: number | undefined;
    color: string | undefined;
    nextStep: string | undefined;
    followUpDays: number | undefined;
    noFollowUp: boolean | undefined;
    boardVisibility: ClientStageBoardVisibility | undefined;
    hideAfterDays: number | undefined;
}

export class LeadBoardSourceDto implements ILeadBoardSourceDto {
    id!: number | undefined;
    name!: string | undefined;

    constructor(data?: ILeadBoardSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBoardSourceDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBoardSourceDto>(data, _mappings, LeadBoardSourceDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILeadBoardSourceDto {
    id: number | undefined;
    name: string | undefined;
}

export enum LeadBoardCardKind {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum LeadCycleEndReason {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum LeadBoardHandoff {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum LeadBoardValueKind {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class LeadBoardCardDto implements ILeadBoardCardDto {
    contactId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    companyId!: number | undefined;
    companyName!: string | undefined;
    email!: string | undefined;
    sourceId!: number | undefined;
    sourceName!: string | undefined;
    stageId!: number | undefined;
    kind!: LeadBoardCardKind | undefined;
    isCustomer!: boolean | undefined;
    stageEnteredAtUtc!: string | undefined;
    updatedAtUtc!: string | undefined;
    primaryTaskId!: number | undefined;
    primaryTaskType!: TaskTypes | undefined;
    primaryCompleted!: boolean | undefined;
    primaryDueDate!: string | undefined;
    ownerUserId!: number | undefined;
    ownerName!: string | undefined;
    hasUnansweredReply!: boolean | undefined;
    lastInboundAtUtc!: string | undefined;
    replyUnseen!: boolean | undefined;
    isNewLead!: boolean | undefined;
    leadSinceUtc!: string | undefined;
    aiNextAction!: string | undefined;
    aiNextActionPendingMs!: number | undefined;
    hasActiveFollowUp!: boolean | undefined;
    lastOutboundAtUtc!: string | undefined;
    lastActivityAtUtc!: string | undefined;
    leadHandledAtUtc!: string | undefined;
    cycleId!: number | undefined;
    endReason!: LeadCycleEndReason | undefined;
    endedAtUtc!: string | undefined;
    lostReason!: string | undefined;
    lostReasonId!: number | undefined;
    lostReasonName!: string | undefined;
    lostReasonRemoved!: boolean | undefined;
    lostReasonNote!: string | undefined;
    canChangeLostReason!: boolean | undefined;
    handoff!: LeadBoardHandoff | undefined;
    wonTransitionId!: number | undefined;
    reminderDueDate!: string | undefined;
    caseProjectId!: number | undefined;
    valueAmount!: number | undefined;
    valueCurrency!: string | undefined;
    valueKind!: LeadBoardValueKind | undefined;
    summaryShort!: string | undefined;
    summaryPendingMs!: number | undefined;

    constructor(data?: ILeadBoardCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.sourceId = _data["sourceId"];
            this.sourceName = _data["sourceName"];
            this.stageId = _data["stageId"];
            this.kind = _data["kind"];
            this.isCustomer = _data["isCustomer"];
            this.stageEnteredAtUtc = _data["stageEnteredAtUtc"];
            this.updatedAtUtc = _data["updatedAtUtc"];
            this.primaryTaskId = _data["primaryTaskId"];
            this.primaryTaskType = _data["primaryTaskType"];
            this.primaryCompleted = _data["primaryCompleted"];
            this.primaryDueDate = _data["primaryDueDate"];
            this.ownerUserId = _data["ownerUserId"];
            this.ownerName = _data["ownerName"];
            this.hasUnansweredReply = _data["hasUnansweredReply"];
            this.lastInboundAtUtc = _data["lastInboundAtUtc"];
            this.replyUnseen = _data["replyUnseen"];
            this.isNewLead = _data["isNewLead"];
            this.leadSinceUtc = _data["leadSinceUtc"];
            this.aiNextAction = _data["aiNextAction"];
            this.aiNextActionPendingMs = _data["aiNextActionPendingMs"];
            this.hasActiveFollowUp = _data["hasActiveFollowUp"];
            this.lastOutboundAtUtc = _data["lastOutboundAtUtc"];
            this.lastActivityAtUtc = _data["lastActivityAtUtc"];
            this.leadHandledAtUtc = _data["leadHandledAtUtc"];
            this.cycleId = _data["cycleId"];
            this.endReason = _data["endReason"];
            this.endedAtUtc = _data["endedAtUtc"];
            this.lostReason = _data["lostReason"];
            this.lostReasonId = _data["lostReasonId"];
            this.lostReasonName = _data["lostReasonName"];
            this.lostReasonRemoved = _data["lostReasonRemoved"];
            this.lostReasonNote = _data["lostReasonNote"];
            this.canChangeLostReason = _data["canChangeLostReason"];
            this.handoff = _data["handoff"];
            this.wonTransitionId = _data["wonTransitionId"];
            this.reminderDueDate = _data["reminderDueDate"];
            this.caseProjectId = _data["caseProjectId"];
            this.valueAmount = _data["valueAmount"];
            this.valueCurrency = _data["valueCurrency"];
            this.valueKind = _data["valueKind"];
            this.summaryShort = _data["summaryShort"];
            this.summaryPendingMs = _data["summaryPendingMs"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBoardCardDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBoardCardDto>(data, _mappings, LeadBoardCardDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["sourceId"] = this.sourceId;
        data["sourceName"] = this.sourceName;
        data["stageId"] = this.stageId;
        data["kind"] = this.kind;
        data["isCustomer"] = this.isCustomer;
        data["stageEnteredAtUtc"] = this.stageEnteredAtUtc;
        data["updatedAtUtc"] = this.updatedAtUtc;
        data["primaryTaskId"] = this.primaryTaskId;
        data["primaryTaskType"] = this.primaryTaskType;
        data["primaryCompleted"] = this.primaryCompleted;
        data["primaryDueDate"] = this.primaryDueDate;
        data["ownerUserId"] = this.ownerUserId;
        data["ownerName"] = this.ownerName;
        data["hasUnansweredReply"] = this.hasUnansweredReply;
        data["lastInboundAtUtc"] = this.lastInboundAtUtc;
        data["replyUnseen"] = this.replyUnseen;
        data["isNewLead"] = this.isNewLead;
        data["leadSinceUtc"] = this.leadSinceUtc;
        data["aiNextAction"] = this.aiNextAction;
        data["aiNextActionPendingMs"] = this.aiNextActionPendingMs;
        data["hasActiveFollowUp"] = this.hasActiveFollowUp;
        data["lastOutboundAtUtc"] = this.lastOutboundAtUtc;
        data["lastActivityAtUtc"] = this.lastActivityAtUtc;
        data["leadHandledAtUtc"] = this.leadHandledAtUtc;
        data["cycleId"] = this.cycleId;
        data["endReason"] = this.endReason;
        data["endedAtUtc"] = this.endedAtUtc;
        data["lostReason"] = this.lostReason;
        data["lostReasonId"] = this.lostReasonId;
        data["lostReasonName"] = this.lostReasonName;
        data["lostReasonRemoved"] = this.lostReasonRemoved;
        data["lostReasonNote"] = this.lostReasonNote;
        data["canChangeLostReason"] = this.canChangeLostReason;
        data["handoff"] = this.handoff;
        data["wonTransitionId"] = this.wonTransitionId;
        data["reminderDueDate"] = this.reminderDueDate;
        data["caseProjectId"] = this.caseProjectId;
        data["valueAmount"] = this.valueAmount;
        data["valueCurrency"] = this.valueCurrency;
        data["valueKind"] = this.valueKind;
        data["summaryShort"] = this.summaryShort;
        data["summaryPendingMs"] = this.summaryPendingMs;
        return data;
    }
}

export interface ILeadBoardCardDto {
    contactId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    email: string | undefined;
    sourceId: number | undefined;
    sourceName: string | undefined;
    stageId: number | undefined;
    kind: LeadBoardCardKind | undefined;
    isCustomer: boolean | undefined;
    stageEnteredAtUtc: string | undefined;
    updatedAtUtc: string | undefined;
    primaryTaskId: number | undefined;
    primaryTaskType: TaskTypes | undefined;
    primaryCompleted: boolean | undefined;
    primaryDueDate: string | undefined;
    ownerUserId: number | undefined;
    ownerName: string | undefined;
    hasUnansweredReply: boolean | undefined;
    lastInboundAtUtc: string | undefined;
    replyUnseen: boolean | undefined;
    isNewLead: boolean | undefined;
    leadSinceUtc: string | undefined;
    aiNextAction: string | undefined;
    aiNextActionPendingMs: number | undefined;
    hasActiveFollowUp: boolean | undefined;
    lastOutboundAtUtc: string | undefined;
    lastActivityAtUtc: string | undefined;
    leadHandledAtUtc: string | undefined;
    cycleId: number | undefined;
    endReason: LeadCycleEndReason | undefined;
    endedAtUtc: string | undefined;
    lostReason: string | undefined;
    lostReasonId: number | undefined;
    lostReasonName: string | undefined;
    lostReasonRemoved: boolean | undefined;
    lostReasonNote: string | undefined;
    canChangeLostReason: boolean | undefined;
    handoff: LeadBoardHandoff | undefined;
    wonTransitionId: number | undefined;
    reminderDueDate: string | undefined;
    caseProjectId: number | undefined;
    valueAmount: number | undefined;
    valueCurrency: string | undefined;
    valueKind: LeadBoardValueKind | undefined;
    summaryShort: string | undefined;
    summaryPendingMs: number | undefined;
}

export class LeadBoardDto implements ILeadBoardDto {
    stages!: LeadBoardStageDto[] | undefined;
    sources!: LeadBoardSourceDto[] | undefined;
    cards!: LeadBoardCardDto[] | undefined;
    today!: string | undefined;
    defaultCurrency!: string | undefined;

    constructor(data?: ILeadBoardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(LeadBoardStageDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(LeadBoardSourceDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(LeadBoardCardDto.fromJS(item, _mappings));
            }
            this.today = _data["today"];
            this.defaultCurrency = _data["defaultCurrency"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBoardDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBoardDto>(data, _mappings, LeadBoardDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item ? item.toJSON() : undefined as any);
        }
        data["today"] = this.today;
        data["defaultCurrency"] = this.defaultCurrency;
        return data;
    }
}

export interface ILeadBoardDto {
    stages: LeadBoardStageDto[] | undefined;
    sources: LeadBoardSourceDto[] | undefined;
    cards: LeadBoardCardDto[] | undefined;
    today: string | undefined;
    defaultCurrency: string | undefined;
}

export class LeadBoardDtoIHandleError implements ILeadBoardDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LeadBoardDto | undefined;
    listOfEntities!: LeadBoardDto[] | undefined;

    constructor(data?: ILeadBoardDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? LeadBoardDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(LeadBoardDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBoardDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBoardDtoIHandleError>(data, _mappings, LeadBoardDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILeadBoardDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LeadBoardDto | undefined;
    listOfEntities: LeadBoardDto[] | undefined;
}

export class GetLeadBoardCardsInput implements IGetLeadBoardCardsInput {
    contactIds!: number[] | undefined;

    constructor(data?: IGetLeadBoardCardsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetLeadBoardCardsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetLeadBoardCardsInput>(data, _mappings, GetLeadBoardCardsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        return data;
    }
}

export interface IGetLeadBoardCardsInput {
    contactIds: number[] | undefined;
}

export class LeadBoardCardsDto implements ILeadBoardCardsDto {
    cards!: LeadBoardCardDto[] | undefined;
    missingContactIds!: number[] | undefined;

    constructor(data?: ILeadBoardCardsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(LeadBoardCardDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["missingContactIds"])) {
                this.missingContactIds = [] as any;
                for (let item of _data["missingContactIds"])
                    this.missingContactIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBoardCardsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBoardCardsDto>(data, _mappings, LeadBoardCardsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.missingContactIds)) {
            data["missingContactIds"] = [];
            for (let item of this.missingContactIds)
                data["missingContactIds"].push(item);
        }
        return data;
    }
}

export interface ILeadBoardCardsDto {
    cards: LeadBoardCardDto[] | undefined;
    missingContactIds: number[] | undefined;
}

export class LeadBoardCardsDtoIHandleError implements ILeadBoardCardsDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LeadBoardCardsDto | undefined;
    listOfEntities!: LeadBoardCardsDto[] | undefined;

    constructor(data?: ILeadBoardCardsDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? LeadBoardCardsDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(LeadBoardCardsDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBoardCardsDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBoardCardsDtoIHandleError>(data, _mappings, LeadBoardCardsDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILeadBoardCardsDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LeadBoardCardsDto | undefined;
    listOfEntities: LeadBoardCardsDto[] | undefined;
}

export class MoveLeadCardInput implements IMoveLeadCardInput {
    contactId!: number | undefined;
    stageId!: number | undefined;
    lostReason!: string | undefined;
    lostReasonId!: number | undefined;
    lostReasonNote!: string | undefined;
    origin!: string | undefined;

    constructor(data?: IMoveLeadCardInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.stageId = _data["stageId"];
            this.lostReason = _data["lostReason"];
            this.lostReasonId = _data["lostReasonId"];
            this.lostReasonNote = _data["lostReasonNote"];
            this.origin = _data["origin"];
        }
    }

    static fromJS(data: any, _mappings?: any): MoveLeadCardInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MoveLeadCardInput>(data, _mappings, MoveLeadCardInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["stageId"] = this.stageId;
        data["lostReason"] = this.lostReason;
        data["lostReasonId"] = this.lostReasonId;
        data["lostReasonNote"] = this.lostReasonNote;
        data["origin"] = this.origin;
        return data;
    }
}

export interface IMoveLeadCardInput {
    contactId: number | undefined;
    stageId: number | undefined;
    lostReason: string | undefined;
    lostReasonId: number | undefined;
    lostReasonNote: string | undefined;
    origin: string | undefined;
}

export enum LeadBoardMoveKind {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class MoveLeadCardResultDto implements IMoveLeadCardResultDto {
    transition!: ClientStageTransitionDto | undefined;
    moveKind!: LeadBoardMoveKind | undefined;
    canUndo!: boolean | undefined;
    card!: LeadBoardCardDto | undefined;

    constructor(data?: IMoveLeadCardResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transition = _data["transition"] ? ClientStageTransitionDto.fromJS(_data["transition"], _mappings) : undefined as any;
            this.moveKind = _data["moveKind"];
            this.canUndo = _data["canUndo"];
            this.card = _data["card"] ? LeadBoardCardDto.fromJS(_data["card"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): MoveLeadCardResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MoveLeadCardResultDto>(data, _mappings, MoveLeadCardResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transition"] = this.transition ? this.transition.toJSON() : undefined as any;
        data["moveKind"] = this.moveKind;
        data["canUndo"] = this.canUndo;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        return data;
    }
}

export interface IMoveLeadCardResultDto {
    transition: ClientStageTransitionDto | undefined;
    moveKind: LeadBoardMoveKind | undefined;
    canUndo: boolean | undefined;
    card: LeadBoardCardDto | undefined;
}

export class MoveLeadCardResultDtoIHandleError implements IMoveLeadCardResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MoveLeadCardResultDto | undefined;
    listOfEntities!: MoveLeadCardResultDto[] | undefined;

    constructor(data?: IMoveLeadCardResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? MoveLeadCardResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(MoveLeadCardResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MoveLeadCardResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MoveLeadCardResultDtoIHandleError>(data, _mappings, MoveLeadCardResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMoveLeadCardResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MoveLeadCardResultDto | undefined;
    listOfEntities: MoveLeadCardResultDto[] | undefined;
}

export class UndoLeadMoveInput implements IUndoLeadMoveInput {
    transitionId!: number | undefined;

    constructor(data?: IUndoLeadMoveInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transitionId = _data["transitionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UndoLeadMoveInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UndoLeadMoveInput>(data, _mappings, UndoLeadMoveInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transitionId"] = this.transitionId;
        return data;
    }
}

export interface IUndoLeadMoveInput {
    transitionId: number | undefined;
}

export class UndoLeadMoveResultDto implements IUndoLeadMoveResultDto {
    contactId!: number | undefined;
    undoTransitionId!: number | undefined;
    stageId!: number | undefined;
    stageName!: string | undefined;
    card!: LeadBoardCardDto | undefined;

    constructor(data?: IUndoLeadMoveResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.undoTransitionId = _data["undoTransitionId"];
            this.stageId = _data["stageId"];
            this.stageName = _data["stageName"];
            this.card = _data["card"] ? LeadBoardCardDto.fromJS(_data["card"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): UndoLeadMoveResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UndoLeadMoveResultDto>(data, _mappings, UndoLeadMoveResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["undoTransitionId"] = this.undoTransitionId;
        data["stageId"] = this.stageId;
        data["stageName"] = this.stageName;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        return data;
    }
}

export interface IUndoLeadMoveResultDto {
    contactId: number | undefined;
    undoTransitionId: number | undefined;
    stageId: number | undefined;
    stageName: string | undefined;
    card: LeadBoardCardDto | undefined;
}

export class UndoLeadMoveResultDtoIHandleError implements IUndoLeadMoveResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UndoLeadMoveResultDto | undefined;
    listOfEntities!: UndoLeadMoveResultDto[] | undefined;

    constructor(data?: IUndoLeadMoveResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UndoLeadMoveResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UndoLeadMoveResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UndoLeadMoveResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UndoLeadMoveResultDtoIHandleError>(data, _mappings, UndoLeadMoveResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUndoLeadMoveResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UndoLeadMoveResultDto | undefined;
    listOfEntities: UndoLeadMoveResultDto[] | undefined;
}

export class SetLeadFollowUpInput implements ISetLeadFollowUpInput {
    contactId!: number | undefined;
    date!: string | undefined;

    constructor(data?: ISetLeadFollowUpInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetLeadFollowUpInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetLeadFollowUpInput>(data, _mappings, SetLeadFollowUpInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["date"] = this.date;
        return data;
    }
}

export interface ISetLeadFollowUpInput {
    contactId: number | undefined;
    date: string | undefined;
}

export class SetLeadFollowUpResultDto implements ISetLeadFollowUpResultDto {
    reopened!: boolean | undefined;
    dueDate!: string | undefined;
    card!: LeadBoardCardDto | undefined;

    constructor(data?: ISetLeadFollowUpResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.reopened = _data["reopened"];
            this.dueDate = _data["dueDate"];
            this.card = _data["card"] ? LeadBoardCardDto.fromJS(_data["card"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): SetLeadFollowUpResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetLeadFollowUpResultDto>(data, _mappings, SetLeadFollowUpResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reopened"] = this.reopened;
        data["dueDate"] = this.dueDate;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        return data;
    }
}

export interface ISetLeadFollowUpResultDto {
    reopened: boolean | undefined;
    dueDate: string | undefined;
    card: LeadBoardCardDto | undefined;
}

export class SetLeadFollowUpResultDtoIHandleError implements ISetLeadFollowUpResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SetLeadFollowUpResultDto | undefined;
    listOfEntities!: SetLeadFollowUpResultDto[] | undefined;

    constructor(data?: ISetLeadFollowUpResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SetLeadFollowUpResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SetLeadFollowUpResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SetLeadFollowUpResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetLeadFollowUpResultDtoIHandleError>(data, _mappings, SetLeadFollowUpResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISetLeadFollowUpResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SetLeadFollowUpResultDto | undefined;
    listOfEntities: SetLeadFollowUpResultDto[] | undefined;
}

export class ReassignLeadInput implements IReassignLeadInput {
    contactId!: number | undefined;
    userId!: number | undefined;

    constructor(data?: IReassignLeadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ReassignLeadInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReassignLeadInput>(data, _mappings, ReassignLeadInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IReassignLeadInput {
    contactId: number | undefined;
    userId: number | undefined;
}

export class ReassignLeadResultDto implements IReassignLeadResultDto {
    changed!: boolean | undefined;
    card!: LeadBoardCardDto | undefined;

    constructor(data?: IReassignLeadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.changed = _data["changed"];
            this.card = _data["card"] ? LeadBoardCardDto.fromJS(_data["card"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): ReassignLeadResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReassignLeadResultDto>(data, _mappings, ReassignLeadResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changed"] = this.changed;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        return data;
    }
}

export interface IReassignLeadResultDto {
    changed: boolean | undefined;
    card: LeadBoardCardDto | undefined;
}

export class ReassignLeadResultDtoIHandleError implements IReassignLeadResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ReassignLeadResultDto | undefined;
    listOfEntities!: ReassignLeadResultDto[] | undefined;

    constructor(data?: IReassignLeadResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ReassignLeadResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ReassignLeadResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ReassignLeadResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReassignLeadResultDtoIHandleError>(data, _mappings, ReassignLeadResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReassignLeadResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ReassignLeadResultDto | undefined;
    listOfEntities: ReassignLeadResultDto[] | undefined;
}

export class LeadJourneyBannerDto implements ILeadJourneyBannerDto {
    card!: LeadBoardCardDto | undefined;
    stageName!: string | undefined;
    stageAct!: ClientStageAct | undefined;
    nextStep!: string | undefined;
    nextStepNotes!: string | undefined;
    followUpDays!: number | undefined;
    noFollowUp!: boolean | undefined;
    summaryLong!: string | undefined;
    inWindow!: boolean | undefined;

    constructor(data?: ILeadJourneyBannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.card = _data["card"] ? LeadBoardCardDto.fromJS(_data["card"], _mappings) : undefined as any;
            this.stageName = _data["stageName"];
            this.stageAct = _data["stageAct"];
            this.nextStep = _data["nextStep"];
            this.nextStepNotes = _data["nextStepNotes"];
            this.followUpDays = _data["followUpDays"];
            this.noFollowUp = _data["noFollowUp"];
            this.summaryLong = _data["summaryLong"];
            this.inWindow = _data["inWindow"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadJourneyBannerDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadJourneyBannerDto>(data, _mappings, LeadJourneyBannerDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["stageName"] = this.stageName;
        data["stageAct"] = this.stageAct;
        data["nextStep"] = this.nextStep;
        data["nextStepNotes"] = this.nextStepNotes;
        data["followUpDays"] = this.followUpDays;
        data["noFollowUp"] = this.noFollowUp;
        data["summaryLong"] = this.summaryLong;
        data["inWindow"] = this.inWindow;
        return data;
    }
}

export interface ILeadJourneyBannerDto {
    card: LeadBoardCardDto | undefined;
    stageName: string | undefined;
    stageAct: ClientStageAct | undefined;
    nextStep: string | undefined;
    nextStepNotes: string | undefined;
    followUpDays: number | undefined;
    noFollowUp: boolean | undefined;
    summaryLong: string | undefined;
    inWindow: boolean | undefined;
}

export class LeadJourneyCaseDto implements ILeadJourneyCaseDto {
    projectId!: number | undefined;
    name!: string | undefined;
    amount!: number | undefined;
    currency!: string | undefined;
    createdAtUtc!: string | undefined;

    constructor(data?: ILeadJourneyCaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.createdAtUtc = _data["createdAtUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadJourneyCaseDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadJourneyCaseDto>(data, _mappings, LeadJourneyCaseDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["createdAtUtc"] = this.createdAtUtc;
        return data;
    }
}

export interface ILeadJourneyCaseDto {
    projectId: number | undefined;
    name: string | undefined;
    amount: number | undefined;
    currency: string | undefined;
    createdAtUtc: string | undefined;
}

export class LeadJourneyValuesDto implements ILeadJourneyValuesDto {
    hasOpenCycle!: boolean | undefined;
    cycleId!: number | undefined;
    estimatedValueAmount!: number | undefined;
    estimatedValueCurrency!: string | undefined;
    cases!: LeadJourneyCaseDto[] | undefined;

    constructor(data?: ILeadJourneyValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.hasOpenCycle = _data["hasOpenCycle"];
            this.cycleId = _data["cycleId"];
            this.estimatedValueAmount = _data["estimatedValueAmount"];
            this.estimatedValueCurrency = _data["estimatedValueCurrency"];
            if (Array.isArray(_data["cases"])) {
                this.cases = [] as any;
                for (let item of _data["cases"])
                    this.cases!.push(LeadJourneyCaseDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeadJourneyValuesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadJourneyValuesDto>(data, _mappings, LeadJourneyValuesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasOpenCycle"] = this.hasOpenCycle;
        data["cycleId"] = this.cycleId;
        data["estimatedValueAmount"] = this.estimatedValueAmount;
        data["estimatedValueCurrency"] = this.estimatedValueCurrency;
        if (Array.isArray(this.cases)) {
            data["cases"] = [];
            for (let item of this.cases)
                data["cases"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILeadJourneyValuesDto {
    hasOpenCycle: boolean | undefined;
    cycleId: number | undefined;
    estimatedValueAmount: number | undefined;
    estimatedValueCurrency: string | undefined;
    cases: LeadJourneyCaseDto[] | undefined;
}

export class LeadJourneyDto implements ILeadJourneyDto {
    contactId!: number | undefined;
    banner!: LeadJourneyBannerDto | undefined;
    finalSummary!: string | undefined;
    values!: LeadJourneyValuesDto | undefined;
    today!: string | undefined;
    defaultCurrency!: string | undefined;

    constructor(data?: ILeadJourneyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.banner = _data["banner"] ? LeadJourneyBannerDto.fromJS(_data["banner"], _mappings) : undefined as any;
            this.finalSummary = _data["finalSummary"];
            this.values = _data["values"] ? LeadJourneyValuesDto.fromJS(_data["values"], _mappings) : undefined as any;
            this.today = _data["today"];
            this.defaultCurrency = _data["defaultCurrency"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadJourneyDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadJourneyDto>(data, _mappings, LeadJourneyDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        data["finalSummary"] = this.finalSummary;
        data["values"] = this.values ? this.values.toJSON() : undefined as any;
        data["today"] = this.today;
        data["defaultCurrency"] = this.defaultCurrency;
        return data;
    }
}

export interface ILeadJourneyDto {
    contactId: number | undefined;
    banner: LeadJourneyBannerDto | undefined;
    finalSummary: string | undefined;
    values: LeadJourneyValuesDto | undefined;
    today: string | undefined;
    defaultCurrency: string | undefined;
}

export class LeadJourneyDtoIHandleError implements ILeadJourneyDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LeadJourneyDto | undefined;
    listOfEntities!: LeadJourneyDto[] | undefined;

    constructor(data?: ILeadJourneyDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? LeadJourneyDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(LeadJourneyDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeadJourneyDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadJourneyDtoIHandleError>(data, _mappings, LeadJourneyDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILeadJourneyDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LeadJourneyDto | undefined;
    listOfEntities: LeadJourneyDto[] | undefined;
}

export class SetLeadEstimateInput implements ISetLeadEstimateInput {
    contactId!: number | undefined;
    amount!: number | undefined;
    cycleId!: number | undefined;

    constructor(data?: ISetLeadEstimateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.amount = _data["amount"];
            this.cycleId = _data["cycleId"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetLeadEstimateInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetLeadEstimateInput>(data, _mappings, SetLeadEstimateInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["amount"] = this.amount;
        data["cycleId"] = this.cycleId;
        return data;
    }
}

export interface ISetLeadEstimateInput {
    contactId: number | undefined;
    amount: number | undefined;
    cycleId: number | undefined;
}

export class SetLeadEstimateResultDto implements ISetLeadEstimateResultDto {
    cycleId!: number | undefined;
    amount!: number | undefined;
    currency!: string | undefined;

    constructor(data?: ISetLeadEstimateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.cycleId = _data["cycleId"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetLeadEstimateResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetLeadEstimateResultDto>(data, _mappings, SetLeadEstimateResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycleId"] = this.cycleId;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ISetLeadEstimateResultDto {
    cycleId: number | undefined;
    amount: number | undefined;
    currency: string | undefined;
}

export class SetLeadEstimateResultDtoIHandleError implements ISetLeadEstimateResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SetLeadEstimateResultDto | undefined;
    listOfEntities!: SetLeadEstimateResultDto[] | undefined;

    constructor(data?: ISetLeadEstimateResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SetLeadEstimateResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SetLeadEstimateResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SetLeadEstimateResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetLeadEstimateResultDtoIHandleError>(data, _mappings, SetLeadEstimateResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISetLeadEstimateResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SetLeadEstimateResultDto | undefined;
    listOfEntities: SetLeadEstimateResultDto[] | undefined;
}

export class LeadCaseClientOptionDto implements ILeadCaseClientOptionDto {
    kind!: string | undefined;
    id!: number | undefined;
    name!: string | undefined;

    constructor(data?: ILeadCaseClientOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadCaseClientOptionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadCaseClientOptionDto>(data, _mappings, LeadCaseClientOptionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILeadCaseClientOptionDto {
    kind: string | undefined;
    id: number | undefined;
    name: string | undefined;
}

export class LeadCaseHandoffDto implements ILeadCaseHandoffDto {
    contactId!: number | undefined;
    firstName!: string | undefined;
    fullName!: string | undefined;
    cycleId!: number | undefined;
    handoff!: LeadBoardHandoff | undefined;
    wonTransitionId!: number | undefined;
    reminderTaskId!: number | undefined;
    reminderDueDate!: string | undefined;
    caseProjectId!: number | undefined;
    estimateAmount!: number | undefined;
    estimateCurrency!: string | undefined;
    hasSummary!: boolean | undefined;
    primaryInCase!: boolean | undefined;
    clients!: LeadCaseClientOptionDto[] | undefined;

    constructor(data?: ILeadCaseHandoffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.firstName = _data["firstName"];
            this.fullName = _data["fullName"];
            this.cycleId = _data["cycleId"];
            this.handoff = _data["handoff"];
            this.wonTransitionId = _data["wonTransitionId"];
            this.reminderTaskId = _data["reminderTaskId"];
            this.reminderDueDate = _data["reminderDueDate"];
            this.caseProjectId = _data["caseProjectId"];
            this.estimateAmount = _data["estimateAmount"];
            this.estimateCurrency = _data["estimateCurrency"];
            this.hasSummary = _data["hasSummary"];
            this.primaryInCase = _data["primaryInCase"];
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(LeadCaseClientOptionDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeadCaseHandoffDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadCaseHandoffDto>(data, _mappings, LeadCaseHandoffDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["firstName"] = this.firstName;
        data["fullName"] = this.fullName;
        data["cycleId"] = this.cycleId;
        data["handoff"] = this.handoff;
        data["wonTransitionId"] = this.wonTransitionId;
        data["reminderTaskId"] = this.reminderTaskId;
        data["reminderDueDate"] = this.reminderDueDate;
        data["caseProjectId"] = this.caseProjectId;
        data["estimateAmount"] = this.estimateAmount;
        data["estimateCurrency"] = this.estimateCurrency;
        data["hasSummary"] = this.hasSummary;
        data["primaryInCase"] = this.primaryInCase;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILeadCaseHandoffDto {
    contactId: number | undefined;
    firstName: string | undefined;
    fullName: string | undefined;
    cycleId: number | undefined;
    handoff: LeadBoardHandoff | undefined;
    wonTransitionId: number | undefined;
    reminderTaskId: number | undefined;
    reminderDueDate: string | undefined;
    caseProjectId: number | undefined;
    estimateAmount: number | undefined;
    estimateCurrency: string | undefined;
    hasSummary: boolean | undefined;
    primaryInCase: boolean | undefined;
    clients: LeadCaseClientOptionDto[] | undefined;
}

export class LeadCaseHandoffDtoIHandleError implements ILeadCaseHandoffDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LeadCaseHandoffDto | undefined;
    listOfEntities!: LeadCaseHandoffDto[] | undefined;

    constructor(data?: ILeadCaseHandoffDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? LeadCaseHandoffDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(LeadCaseHandoffDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeadCaseHandoffDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadCaseHandoffDtoIHandleError>(data, _mappings, LeadCaseHandoffDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILeadCaseHandoffDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LeadCaseHandoffDto | undefined;
    listOfEntities: LeadCaseHandoffDto[] | undefined;
}

export class LeadBulkLostReasonDto implements ILeadBulkLostReasonDto {
    contactId!: number | undefined;
    lostReasonId!: number | undefined;
    lostReasonNote!: string | undefined;

    constructor(data?: ILeadBulkLostReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.lostReasonId = _data["lostReasonId"];
            this.lostReasonNote = _data["lostReasonNote"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBulkLostReasonDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBulkLostReasonDto>(data, _mappings, LeadBulkLostReasonDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["lostReasonId"] = this.lostReasonId;
        data["lostReasonNote"] = this.lostReasonNote;
        return data;
    }
}

export interface ILeadBulkLostReasonDto {
    contactId: number | undefined;
    lostReasonId: number | undefined;
    lostReasonNote: string | undefined;
}

export class LeadBulkStageInput implements ILeadBulkStageInput {
    contactIds!: number[] | undefined;
    stageId!: number | undefined;
    lostReasonId!: number | undefined;
    lostReasonNote!: string | undefined;
    lostReasons!: LeadBulkLostReasonDto[] | undefined;

    constructor(data?: ILeadBulkStageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
            this.stageId = _data["stageId"];
            this.lostReasonId = _data["lostReasonId"];
            this.lostReasonNote = _data["lostReasonNote"];
            if (Array.isArray(_data["lostReasons"])) {
                this.lostReasons = [] as any;
                for (let item of _data["lostReasons"])
                    this.lostReasons!.push(LeadBulkLostReasonDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBulkStageInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBulkStageInput>(data, _mappings, LeadBulkStageInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        data["stageId"] = this.stageId;
        data["lostReasonId"] = this.lostReasonId;
        data["lostReasonNote"] = this.lostReasonNote;
        if (Array.isArray(this.lostReasons)) {
            data["lostReasons"] = [];
            for (let item of this.lostReasons)
                data["lostReasons"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILeadBulkStageInput {
    contactIds: number[] | undefined;
    stageId: number | undefined;
    lostReasonId: number | undefined;
    lostReasonNote: string | undefined;
    lostReasons: LeadBulkLostReasonDto[] | undefined;
}

export class LeadBulkStagePreviewDto implements ILeadBulkStagePreviewDto {
    stageName!: string | undefined;
    stageCategory!: string | undefined;
    leads!: number | undefined;
    rescheduled!: number | undefined;
    reopened!: number | undefined;
    customReplaced!: number | undefined;
    tasksCompleted!: number | undefined;
    cyclesCompleted!: number | undefined;
    caseReminders!: number | undefined;
    leadsRemoved!: number | undefined;
    stageOnly!: number | undefined;
    skipped!: number | undefined;

    constructor(data?: ILeadBulkStagePreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.stageName = _data["stageName"];
            this.stageCategory = _data["stageCategory"];
            this.leads = _data["leads"];
            this.rescheduled = _data["rescheduled"];
            this.reopened = _data["reopened"];
            this.customReplaced = _data["customReplaced"];
            this.tasksCompleted = _data["tasksCompleted"];
            this.cyclesCompleted = _data["cyclesCompleted"];
            this.caseReminders = _data["caseReminders"];
            this.leadsRemoved = _data["leadsRemoved"];
            this.stageOnly = _data["stageOnly"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBulkStagePreviewDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBulkStagePreviewDto>(data, _mappings, LeadBulkStagePreviewDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stageName"] = this.stageName;
        data["stageCategory"] = this.stageCategory;
        data["leads"] = this.leads;
        data["rescheduled"] = this.rescheduled;
        data["reopened"] = this.reopened;
        data["customReplaced"] = this.customReplaced;
        data["tasksCompleted"] = this.tasksCompleted;
        data["cyclesCompleted"] = this.cyclesCompleted;
        data["caseReminders"] = this.caseReminders;
        data["leadsRemoved"] = this.leadsRemoved;
        data["stageOnly"] = this.stageOnly;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface ILeadBulkStagePreviewDto {
    stageName: string | undefined;
    stageCategory: string | undefined;
    leads: number | undefined;
    rescheduled: number | undefined;
    reopened: number | undefined;
    customReplaced: number | undefined;
    tasksCompleted: number | undefined;
    cyclesCompleted: number | undefined;
    caseReminders: number | undefined;
    leadsRemoved: number | undefined;
    stageOnly: number | undefined;
    skipped: number | undefined;
}

export class LeadBulkStagePreviewDtoIHandleError implements ILeadBulkStagePreviewDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LeadBulkStagePreviewDto | undefined;
    listOfEntities!: LeadBulkStagePreviewDto[] | undefined;

    constructor(data?: ILeadBulkStagePreviewDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? LeadBulkStagePreviewDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(LeadBulkStagePreviewDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBulkStagePreviewDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBulkStagePreviewDtoIHandleError>(data, _mappings, LeadBulkStagePreviewDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILeadBulkStagePreviewDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LeadBulkStagePreviewDto | undefined;
    listOfEntities: LeadBulkStagePreviewDto[] | undefined;
}

export class LeadBulkResultDto implements ILeadBulkResultDto {
    updatedIds!: number[] | undefined;
    skipped!: ClientBulkRecordDto[] | undefined;
    failed!: ClientBulkRecordDto[] | undefined;
    transitions!: ClientStageTransitionDto[] | undefined;
    caseRemindersFiled!: number | undefined;

    constructor(data?: ILeadBulkResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["updatedIds"])) {
                this.updatedIds = [] as any;
                for (let item of _data["updatedIds"])
                    this.updatedIds!.push(item);
            }
            if (Array.isArray(_data["skipped"])) {
                this.skipped = [] as any;
                for (let item of _data["skipped"])
                    this.skipped!.push(ClientBulkRecordDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["failed"])) {
                this.failed = [] as any;
                for (let item of _data["failed"])
                    this.failed!.push(ClientBulkRecordDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["transitions"])) {
                this.transitions = [] as any;
                for (let item of _data["transitions"])
                    this.transitions!.push(ClientStageTransitionDto.fromJS(item, _mappings));
            }
            this.caseRemindersFiled = _data["caseRemindersFiled"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBulkResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBulkResultDto>(data, _mappings, LeadBulkResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.updatedIds)) {
            data["updatedIds"] = [];
            for (let item of this.updatedIds)
                data["updatedIds"].push(item);
        }
        if (Array.isArray(this.skipped)) {
            data["skipped"] = [];
            for (let item of this.skipped)
                data["skipped"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.failed)) {
            data["failed"] = [];
            for (let item of this.failed)
                data["failed"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transitions)) {
            data["transitions"] = [];
            for (let item of this.transitions)
                data["transitions"].push(item ? item.toJSON() : undefined as any);
        }
        data["caseRemindersFiled"] = this.caseRemindersFiled;
        return data;
    }
}

export interface ILeadBulkResultDto {
    updatedIds: number[] | undefined;
    skipped: ClientBulkRecordDto[] | undefined;
    failed: ClientBulkRecordDto[] | undefined;
    transitions: ClientStageTransitionDto[] | undefined;
    caseRemindersFiled: number | undefined;
}

export class LeadBulkResultDtoIHandleError implements ILeadBulkResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LeadBulkResultDto | undefined;
    listOfEntities!: LeadBulkResultDto[] | undefined;

    constructor(data?: ILeadBulkResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? LeadBulkResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(LeadBulkResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBulkResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBulkResultDtoIHandleError>(data, _mappings, LeadBulkResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILeadBulkResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LeadBulkResultDto | undefined;
    listOfEntities: LeadBulkResultDto[] | undefined;
}

export class LeadBulkTypeInput implements ILeadBulkTypeInput {
    contactIds!: number[] | undefined;
    typeId!: number | undefined;

    constructor(data?: ILeadBulkTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBulkTypeInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBulkTypeInput>(data, _mappings, LeadBulkTypeInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        data["typeId"] = this.typeId;
        return data;
    }
}

export interface ILeadBulkTypeInput {
    contactIds: number[] | undefined;
    typeId: number | undefined;
}

export class LeadBulkTypePreviewDto implements ILeadBulkTypePreviewDto {
    typeName!: string | undefined;
    leavesWorkflow!: number | undefined;
    startsCycle!: number | undefined;
    typeOnly!: number | undefined;
    skipped!: number | undefined;

    constructor(data?: ILeadBulkTypePreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.typeName = _data["typeName"];
            this.leavesWorkflow = _data["leavesWorkflow"];
            this.startsCycle = _data["startsCycle"];
            this.typeOnly = _data["typeOnly"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBulkTypePreviewDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBulkTypePreviewDto>(data, _mappings, LeadBulkTypePreviewDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeName"] = this.typeName;
        data["leavesWorkflow"] = this.leavesWorkflow;
        data["startsCycle"] = this.startsCycle;
        data["typeOnly"] = this.typeOnly;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface ILeadBulkTypePreviewDto {
    typeName: string | undefined;
    leavesWorkflow: number | undefined;
    startsCycle: number | undefined;
    typeOnly: number | undefined;
    skipped: number | undefined;
}

export class LeadBulkTypePreviewDtoIHandleError implements ILeadBulkTypePreviewDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LeadBulkTypePreviewDto | undefined;
    listOfEntities!: LeadBulkTypePreviewDto[] | undefined;

    constructor(data?: ILeadBulkTypePreviewDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? LeadBulkTypePreviewDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(LeadBulkTypePreviewDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBulkTypePreviewDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBulkTypePreviewDtoIHandleError>(data, _mappings, LeadBulkTypePreviewDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILeadBulkTypePreviewDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LeadBulkTypePreviewDto | undefined;
    listOfEntities: LeadBulkTypePreviewDto[] | undefined;
}

export class LeadBulkDeletePreviewInput implements ILeadBulkDeletePreviewInput {
    contactIds!: number[] | undefined;

    constructor(data?: ILeadBulkDeletePreviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBulkDeletePreviewInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBulkDeletePreviewInput>(data, _mappings, LeadBulkDeletePreviewInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        return data;
    }
}

export interface ILeadBulkDeletePreviewInput {
    contactIds: number[] | undefined;
}

export class LeadBulkDeletePreviewDto implements ILeadBulkDeletePreviewDto {
    activeLeads!: number | undefined;

    constructor(data?: ILeadBulkDeletePreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.activeLeads = _data["activeLeads"];
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBulkDeletePreviewDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBulkDeletePreviewDto>(data, _mappings, LeadBulkDeletePreviewDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeLeads"] = this.activeLeads;
        return data;
    }
}

export interface ILeadBulkDeletePreviewDto {
    activeLeads: number | undefined;
}

export class LeadBulkDeletePreviewDtoIHandleError implements ILeadBulkDeletePreviewDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LeadBulkDeletePreviewDto | undefined;
    listOfEntities!: LeadBulkDeletePreviewDto[] | undefined;

    constructor(data?: ILeadBulkDeletePreviewDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? LeadBulkDeletePreviewDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(LeadBulkDeletePreviewDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeadBulkDeletePreviewDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeadBulkDeletePreviewDtoIHandleError>(data, _mappings, LeadBulkDeletePreviewDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILeadBulkDeletePreviewDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LeadBulkDeletePreviewDto | undefined;
    listOfEntities: LeadBulkDeletePreviewDto[] | undefined;
}

export class ChangeLostReasonInput implements IChangeLostReasonInput {
    contactId!: number | undefined;
    lostReasonId!: number | undefined;
    lostReasonNote!: string | undefined;

    constructor(data?: IChangeLostReasonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.lostReasonId = _data["lostReasonId"];
            this.lostReasonNote = _data["lostReasonNote"];
        }
    }

    static fromJS(data: any, _mappings?: any): ChangeLostReasonInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangeLostReasonInput>(data, _mappings, ChangeLostReasonInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["lostReasonId"] = this.lostReasonId;
        data["lostReasonNote"] = this.lostReasonNote;
        return data;
    }
}

export interface IChangeLostReasonInput {
    contactId: number | undefined;
    lostReasonId: number | undefined;
    lostReasonNote: string | undefined;
}

export class ChangeLostReasonResultDto implements IChangeLostReasonResultDto {
    contactId!: number | undefined;
    transitionId!: number | undefined;
    oldLostReasonId!: number | undefined;
    oldLostReasonName!: string | undefined;
    lostReasonId!: number | undefined;
    lostReasonName!: string | undefined;
    lostReasonNote!: string | undefined;
    logged!: boolean | undefined;

    constructor(data?: IChangeLostReasonResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.transitionId = _data["transitionId"];
            this.oldLostReasonId = _data["oldLostReasonId"];
            this.oldLostReasonName = _data["oldLostReasonName"];
            this.lostReasonId = _data["lostReasonId"];
            this.lostReasonName = _data["lostReasonName"];
            this.lostReasonNote = _data["lostReasonNote"];
            this.logged = _data["logged"];
        }
    }

    static fromJS(data: any, _mappings?: any): ChangeLostReasonResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangeLostReasonResultDto>(data, _mappings, ChangeLostReasonResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["transitionId"] = this.transitionId;
        data["oldLostReasonId"] = this.oldLostReasonId;
        data["oldLostReasonName"] = this.oldLostReasonName;
        data["lostReasonId"] = this.lostReasonId;
        data["lostReasonName"] = this.lostReasonName;
        data["lostReasonNote"] = this.lostReasonNote;
        data["logged"] = this.logged;
        return data;
    }
}

export interface IChangeLostReasonResultDto {
    contactId: number | undefined;
    transitionId: number | undefined;
    oldLostReasonId: number | undefined;
    oldLostReasonName: string | undefined;
    lostReasonId: number | undefined;
    lostReasonName: string | undefined;
    lostReasonNote: string | undefined;
    logged: boolean | undefined;
}

export class ChangeLostReasonResultDtoIHandleError implements IChangeLostReasonResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ChangeLostReasonResultDto | undefined;
    listOfEntities!: ChangeLostReasonResultDto[] | undefined;

    constructor(data?: IChangeLostReasonResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ChangeLostReasonResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ChangeLostReasonResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ChangeLostReasonResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangeLostReasonResultDtoIHandleError>(data, _mappings, ChangeLostReasonResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IChangeLostReasonResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ChangeLostReasonResultDto | undefined;
    listOfEntities: ChangeLostReasonResultDto[] | undefined;
}

export enum LinkType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum LinkScope {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class LinkDto implements ILinkDto {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    name!: string | undefined;
    url!: string | undefined;
    type!: LinkType | undefined;
    scope!: LinkScope | undefined;
    isCompanyLink!: boolean | undefined;
    pinnedEntityId!: number | undefined;
    sortOrder!: number | undefined;
    isShareFile!: boolean | undefined;
    isAddToShortcut!: boolean | undefined;
    keyId!: string | undefined;
    extension!: string | undefined;
    driveId!: string | undefined;
    siteId!: string | undefined;
    folderId!: string | undefined;
    driveName!: string | undefined;
    siteName!: string | undefined;
    tblId!: number | undefined;
    appSubText!: string | undefined;
    appIconUrl!: string | undefined;
    entityId!: number | undefined;
    contactName!: string | undefined;
    companyName!: string | undefined;
    linkId!: number | undefined;

    constructor(data?: ILinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.type = _data["type"];
            this.scope = _data["scope"];
            this.isCompanyLink = _data["isCompanyLink"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.sortOrder = _data["sortOrder"];
            this.isShareFile = _data["isShareFile"];
            this.isAddToShortcut = _data["isAddToShortcut"];
            this.keyId = _data["keyId"];
            this.extension = _data["extension"];
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
            this.folderId = _data["folderId"];
            this.driveName = _data["driveName"];
            this.siteName = _data["siteName"];
            this.tblId = _data["tblId"];
            this.appSubText = _data["appSubText"];
            this.appIconUrl = _data["appIconUrl"];
            this.entityId = _data["entityId"];
            this.contactName = _data["contactName"];
            this.companyName = _data["companyName"];
            this.linkId = _data["linkId"];
        }
    }

    static fromJS(data: any, _mappings?: any): LinkDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LinkDto>(data, _mappings, LinkDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["url"] = this.url;
        data["type"] = this.type;
        data["scope"] = this.scope;
        data["isCompanyLink"] = this.isCompanyLink;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["sortOrder"] = this.sortOrder;
        data["isShareFile"] = this.isShareFile;
        data["isAddToShortcut"] = this.isAddToShortcut;
        data["keyId"] = this.keyId;
        data["extension"] = this.extension;
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        data["folderId"] = this.folderId;
        data["driveName"] = this.driveName;
        data["siteName"] = this.siteName;
        data["tblId"] = this.tblId;
        data["appSubText"] = this.appSubText;
        data["appIconUrl"] = this.appIconUrl;
        data["entityId"] = this.entityId;
        data["contactName"] = this.contactName;
        data["companyName"] = this.companyName;
        data["linkId"] = this.linkId;
        return data;
    }
}

export interface ILinkDto {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    url: string | undefined;
    type: LinkType | undefined;
    scope: LinkScope | undefined;
    isCompanyLink: boolean | undefined;
    pinnedEntityId: number | undefined;
    sortOrder: number | undefined;
    isShareFile: boolean | undefined;
    isAddToShortcut: boolean | undefined;
    keyId: string | undefined;
    extension: string | undefined;
    driveId: string | undefined;
    siteId: string | undefined;
    folderId: string | undefined;
    driveName: string | undefined;
    siteName: string | undefined;
    tblId: number | undefined;
    appSubText: string | undefined;
    appIconUrl: string | undefined;
    entityId: number | undefined;
    contactName: string | undefined;
    companyName: string | undefined;
    linkId: number | undefined;
}

export class LinkDtoListIHandleError implements ILinkDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LinkDto[] | undefined;
    listOfEntities!: LinkDto[][] | undefined;

    constructor(data?: ILinkDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(LinkDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LinkDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LinkDtoListIHandleError>(data, _mappings, LinkDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ILinkDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LinkDto[] | undefined;
    listOfEntities: LinkDto[][] | undefined;
}

export enum ShortcutType {
    _1 = 1,
    _2 = 2,
}

export class ShortcutDto implements IShortcutDto {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    linkId!: number | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    name!: string | undefined;
    url!: string | undefined;
    type!: LinkType | undefined;
    scope!: LinkScope | undefined;
    isCompanyLink!: boolean | undefined;
    pinnedEntityId!: number | undefined;
    sortOrder!: number | undefined;
    keyId!: string | undefined;
    extension!: string | undefined;
    driveId!: string | undefined;
    siteId!: string | undefined;
    folderId!: string | undefined;
    folderName!: string | undefined;
    tblId!: number | undefined;
    isAddToShortcut!: boolean | undefined;
    appSubText!: string | undefined;
    appIconUrl!: string | undefined;
    entity!: ShortcutType | undefined;

    constructor(data?: IShortcutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.linkId = _data["linkId"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.type = _data["type"];
            this.scope = _data["scope"];
            this.isCompanyLink = _data["isCompanyLink"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.sortOrder = _data["sortOrder"];
            this.keyId = _data["keyId"];
            this.extension = _data["extension"];
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
            this.folderId = _data["folderId"];
            this.folderName = _data["folderName"];
            this.tblId = _data["tblId"];
            this.isAddToShortcut = _data["isAddToShortcut"];
            this.appSubText = _data["appSubText"];
            this.appIconUrl = _data["appIconUrl"];
            this.entity = _data["entity"];
        }
    }

    static fromJS(data: any, _mappings?: any): ShortcutDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ShortcutDto>(data, _mappings, ShortcutDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["linkId"] = this.linkId;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["url"] = this.url;
        data["type"] = this.type;
        data["scope"] = this.scope;
        data["isCompanyLink"] = this.isCompanyLink;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["sortOrder"] = this.sortOrder;
        data["keyId"] = this.keyId;
        data["extension"] = this.extension;
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        data["folderId"] = this.folderId;
        data["folderName"] = this.folderName;
        data["tblId"] = this.tblId;
        data["isAddToShortcut"] = this.isAddToShortcut;
        data["appSubText"] = this.appSubText;
        data["appIconUrl"] = this.appIconUrl;
        data["entity"] = this.entity;
        return data;
    }
}

export interface IShortcutDto {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    linkId: number | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    url: string | undefined;
    type: LinkType | undefined;
    scope: LinkScope | undefined;
    isCompanyLink: boolean | undefined;
    pinnedEntityId: number | undefined;
    sortOrder: number | undefined;
    keyId: string | undefined;
    extension: string | undefined;
    driveId: string | undefined;
    siteId: string | undefined;
    folderId: string | undefined;
    folderName: string | undefined;
    tblId: number | undefined;
    isAddToShortcut: boolean | undefined;
    appSubText: string | undefined;
    appIconUrl: string | undefined;
    entity: ShortcutType | undefined;
}

export class ShortcutDtoListIHandleError implements IShortcutDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ShortcutDto[] | undefined;
    listOfEntities!: ShortcutDto[][] | undefined;

    constructor(data?: IShortcutDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ShortcutDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ShortcutDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ShortcutDtoListIHandleError>(data, _mappings, ShortcutDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IShortcutDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ShortcutDto[] | undefined;
    listOfEntities: ShortcutDto[][] | undefined;
}

export class UserShortcutInputDto implements IUserShortcutInputDto {
    entityId!: number | undefined;
    entity!: ShortcutType | undefined;
    linkId!: number | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;

    constructor(data?: IUserShortcutInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.entity = _data["entity"];
            this.linkId = _data["linkId"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserShortcutInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserShortcutInputDto>(data, _mappings, UserShortcutInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entity"] = this.entity;
        data["linkId"] = this.linkId;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IUserShortcutInputDto {
    entityId: number | undefined;
    entity: ShortcutType | undefined;
    linkId: number | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
}

export class OneDriveLinks implements IOneDriveLinks {
    id!: string | undefined;
    linkId!: number | undefined;
    name!: string | undefined;
    webUrl!: string | undefined;
    extension!: string | undefined;
    lastModifiedBy!: string | undefined;
    lastModifiedDateTime!: string | undefined;
    modificationTimeAgo!: string | undefined;
    driveId!: string | undefined;
    siteId!: string | undefined;
    folderId!: string | undefined;
    driveName!: string | undefined;
    siteName!: string | undefined;
    isPinned!: boolean | undefined;

    constructor(data?: IOneDriveLinks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.linkId = _data["linkId"];
            this.name = _data["name"];
            this.webUrl = _data["webUrl"];
            this.extension = _data["extension"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"];
            this.modificationTimeAgo = _data["modificationTimeAgo"];
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
            this.folderId = _data["folderId"];
            this.driveName = _data["driveName"];
            this.siteName = _data["siteName"];
            this.isPinned = _data["isPinned"];
        }
    }

    static fromJS(data: any, _mappings?: any): OneDriveLinks | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OneDriveLinks>(data, _mappings, OneDriveLinks);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["linkId"] = this.linkId;
        data["name"] = this.name;
        data["webUrl"] = this.webUrl;
        data["extension"] = this.extension;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime;
        data["modificationTimeAgo"] = this.modificationTimeAgo;
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        data["folderId"] = this.folderId;
        data["driveName"] = this.driveName;
        data["siteName"] = this.siteName;
        data["isPinned"] = this.isPinned;
        return data;
    }
}

export interface IOneDriveLinks {
    id: string | undefined;
    linkId: number | undefined;
    name: string | undefined;
    webUrl: string | undefined;
    extension: string | undefined;
    lastModifiedBy: string | undefined;
    lastModifiedDateTime: string | undefined;
    modificationTimeAgo: string | undefined;
    driveId: string | undefined;
    siteId: string | undefined;
    folderId: string | undefined;
    driveName: string | undefined;
    siteName: string | undefined;
    isPinned: boolean | undefined;
}

export class OneDriveLinksListIHandleError implements IOneDriveLinksListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: OneDriveLinks[] | undefined;
    listOfEntities!: OneDriveLinks[][] | undefined;

    constructor(data?: IOneDriveLinksListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(OneDriveLinks.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OneDriveLinksListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OneDriveLinksListIHandleError>(data, _mappings, OneDriveLinksListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IOneDriveLinksListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: OneDriveLinks[] | undefined;
    listOfEntities: OneDriveLinks[][] | undefined;
}

export class GroupDto implements IGroupDto {
    groupId!: number | undefined;
    groupName!: string | undefined;

    constructor(data?: IGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
        }
    }

    static fromJS(data: any, _mappings?: any): GroupDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GroupDto>(data, _mappings, GroupDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        return data;
    }
}

export interface IGroupDto {
    groupId: number | undefined;
    groupName: string | undefined;
}

export class GroupLinkDto implements IGroupLinkDto {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    name!: string | undefined;
    url!: string | undefined;
    path!: string | undefined;
    modifiedByName!: string | undefined;
    modifiedDate!: string | undefined;
    type!: LinkType | undefined;
    isShareFile!: boolean | undefined;
    keyId!: string | undefined;
    extension!: string | undefined;
    driveId!: string | undefined;
    siteId!: string | undefined;
    folderId!: string | undefined;
    driveName!: string | undefined;
    siteName!: string | undefined;
    isEveryone!: boolean | undefined;
    groupArr!: string | undefined;
    readonly group!: GroupDto[] | undefined;
    driveCategoryId!: number | undefined;
    sortOrder!: number | undefined;

    constructor(data?: IGroupLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.path = _data["path"];
            this.modifiedByName = _data["modifiedByName"];
            this.modifiedDate = _data["modifiedDate"];
            this.type = _data["type"];
            this.isShareFile = _data["isShareFile"];
            this.keyId = _data["keyId"];
            this.extension = _data["extension"];
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
            this.folderId = _data["folderId"];
            this.driveName = _data["driveName"];
            this.siteName = _data["siteName"];
            this.isEveryone = _data["isEveryone"];
            this.groupArr = _data["groupArr"];
            if (Array.isArray(_data["group"])) {
                (this as any).group = [] as any;
                for (let item of _data["group"])
                    (this as any).group!.push(GroupDto.fromJS(item, _mappings));
            }
            this.driveCategoryId = _data["driveCategoryId"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): GroupLinkDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GroupLinkDto>(data, _mappings, GroupLinkDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["url"] = this.url;
        data["path"] = this.path;
        data["modifiedByName"] = this.modifiedByName;
        data["modifiedDate"] = this.modifiedDate;
        data["type"] = this.type;
        data["isShareFile"] = this.isShareFile;
        data["keyId"] = this.keyId;
        data["extension"] = this.extension;
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        data["folderId"] = this.folderId;
        data["driveName"] = this.driveName;
        data["siteName"] = this.siteName;
        data["isEveryone"] = this.isEveryone;
        data["groupArr"] = this.groupArr;
        if (Array.isArray(this.group)) {
            data["group"] = [];
            for (let item of this.group)
                data["group"].push(item ? item.toJSON() : undefined as any);
        }
        data["driveCategoryId"] = this.driveCategoryId;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IGroupLinkDto {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    url: string | undefined;
    path: string | undefined;
    modifiedByName: string | undefined;
    modifiedDate: string | undefined;
    type: LinkType | undefined;
    isShareFile: boolean | undefined;
    keyId: string | undefined;
    extension: string | undefined;
    driveId: string | undefined;
    siteId: string | undefined;
    folderId: string | undefined;
    driveName: string | undefined;
    siteName: string | undefined;
    isEveryone: boolean | undefined;
    groupArr: string | undefined;
    group: GroupDto[] | undefined;
    driveCategoryId: number | undefined;
    sortOrder: number | undefined;
}

export class GroupLinkDtoListIHandleError implements IGroupLinkDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GroupLinkDto[] | undefined;
    listOfEntities!: GroupLinkDto[][] | undefined;

    constructor(data?: IGroupLinkDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(GroupLinkDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GroupLinkDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GroupLinkDtoListIHandleError>(data, _mappings, GroupLinkDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IGroupLinkDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GroupLinkDto[] | undefined;
    listOfEntities: GroupLinkDto[][] | undefined;
}

export enum DriveCategoryScope {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class EntityIdDto implements IEntityIdDto {
    entityId!: number | undefined;

    constructor(data?: IEntityIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any, _mappings?: any): EntityIdDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EntityIdDto>(data, _mappings, EntityIdDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface IEntityIdDto {
    entityId: number | undefined;
}

export class DriveCategoryDto implements IDriveCategoryDto {
    id!: number | undefined;
    name!: string | undefined;
    isDeleted!: boolean | undefined;
    sortOrder!: number | undefined;
    scope!: DriveCategoryScope | undefined;
    entityIdsArr!: string | undefined;
    readonly entityIds!: EntityIdDto[] | undefined;

    constructor(data?: IDriveCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
            this.sortOrder = _data["sortOrder"];
            this.scope = _data["scope"];
            this.entityIdsArr = _data["entityIdsArr"];
            if (Array.isArray(_data["entityIds"])) {
                (this as any).entityIds = [] as any;
                for (let item of _data["entityIds"])
                    (this as any).entityIds!.push(EntityIdDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DriveCategoryDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DriveCategoryDto>(data, _mappings, DriveCategoryDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["sortOrder"] = this.sortOrder;
        data["scope"] = this.scope;
        data["entityIdsArr"] = this.entityIdsArr;
        if (Array.isArray(this.entityIds)) {
            data["entityIds"] = [];
            for (let item of this.entityIds)
                data["entityIds"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDriveCategoryDto {
    id: number | undefined;
    name: string | undefined;
    isDeleted: boolean | undefined;
    sortOrder: number | undefined;
    scope: DriveCategoryScope | undefined;
    entityIdsArr: string | undefined;
    entityIds: EntityIdDto[] | undefined;
}

export class DriveCategoryDtoListIHandleError implements IDriveCategoryDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: DriveCategoryDto[] | undefined;
    listOfEntities!: DriveCategoryDto[][] | undefined;

    constructor(data?: IDriveCategoryDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(DriveCategoryDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DriveCategoryDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DriveCategoryDtoListIHandleError>(data, _mappings, DriveCategoryDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IDriveCategoryDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: DriveCategoryDto[] | undefined;
    listOfEntities: DriveCategoryDto[][] | undefined;
}

export class DriveCategoryInputDto implements IDriveCategoryInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    id!: number | undefined;
    name!: string | undefined;
    scope!: DriveCategoryScope | undefined;
    entityIdsArr!: string | undefined;
    readonly entityIds!: EntityIdDto[] | undefined;

    constructor(data?: IDriveCategoryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.scope = _data["scope"];
            this.entityIdsArr = _data["entityIdsArr"];
            if (Array.isArray(_data["entityIds"])) {
                (this as any).entityIds = [] as any;
                for (let item of _data["entityIds"])
                    (this as any).entityIds!.push(EntityIdDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DriveCategoryInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DriveCategoryInputDto>(data, _mappings, DriveCategoryInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["scope"] = this.scope;
        data["entityIdsArr"] = this.entityIdsArr;
        if (Array.isArray(this.entityIds)) {
            data["entityIds"] = [];
            for (let item of this.entityIds)
                data["entityIds"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDriveCategoryInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    id: number | undefined;
    name: string | undefined;
    scope: DriveCategoryScope | undefined;
    entityIdsArr: string | undefined;
    entityIds: EntityIdDto[] | undefined;
}

export class LostReasonDto implements ILostReasonDto {
    id!: number | undefined;
    name!: string | undefined;
    icon!: string | undefined;
    sortOrder!: number | undefined;
    leadCount!: number | undefined;
    takesNote!: boolean | undefined;

    constructor(data?: ILostReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.sortOrder = _data["sortOrder"];
            this.leadCount = _data["leadCount"];
            this.takesNote = _data["takesNote"];
        }
    }

    static fromJS(data: any, _mappings?: any): LostReasonDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LostReasonDto>(data, _mappings, LostReasonDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["sortOrder"] = this.sortOrder;
        data["leadCount"] = this.leadCount;
        data["takesNote"] = this.takesNote;
        return data;
    }
}

export interface ILostReasonDto {
    id: number | undefined;
    name: string | undefined;
    icon: string | undefined;
    sortOrder: number | undefined;
    leadCount: number | undefined;
    takesNote: boolean | undefined;
}

export class LostReasonStageDefaultDto implements ILostReasonStageDefaultDto {
    stageId!: number | undefined;
    lostReasonId!: number | undefined;

    constructor(data?: ILostReasonStageDefaultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.stageId = _data["stageId"];
            this.lostReasonId = _data["lostReasonId"];
        }
    }

    static fromJS(data: any, _mappings?: any): LostReasonStageDefaultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LostReasonStageDefaultDto>(data, _mappings, LostReasonStageDefaultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stageId"] = this.stageId;
        data["lostReasonId"] = this.lostReasonId;
        return data;
    }
}

export interface ILostReasonStageDefaultDto {
    stageId: number | undefined;
    lostReasonId: number | undefined;
}

export class LostReasonSettingsDto implements ILostReasonSettingsDto {
    reasons!: LostReasonDto[] | undefined;
    requireReason!: boolean | undefined;
    stageDefaults!: LostReasonStageDefaultDto[] | undefined;
    maxReasons!: number | undefined;
    maxNameLength!: number | undefined;
    maxNoteLength!: number | undefined;
    pickerVisibleCount!: number | undefined;

    constructor(data?: ILostReasonSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(LostReasonDto.fromJS(item, _mappings));
            }
            this.requireReason = _data["requireReason"];
            if (Array.isArray(_data["stageDefaults"])) {
                this.stageDefaults = [] as any;
                for (let item of _data["stageDefaults"])
                    this.stageDefaults!.push(LostReasonStageDefaultDto.fromJS(item, _mappings));
            }
            this.maxReasons = _data["maxReasons"];
            this.maxNameLength = _data["maxNameLength"];
            this.maxNoteLength = _data["maxNoteLength"];
            this.pickerVisibleCount = _data["pickerVisibleCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): LostReasonSettingsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LostReasonSettingsDto>(data, _mappings, LostReasonSettingsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item ? item.toJSON() : undefined as any);
        }
        data["requireReason"] = this.requireReason;
        if (Array.isArray(this.stageDefaults)) {
            data["stageDefaults"] = [];
            for (let item of this.stageDefaults)
                data["stageDefaults"].push(item ? item.toJSON() : undefined as any);
        }
        data["maxReasons"] = this.maxReasons;
        data["maxNameLength"] = this.maxNameLength;
        data["maxNoteLength"] = this.maxNoteLength;
        data["pickerVisibleCount"] = this.pickerVisibleCount;
        return data;
    }
}

export interface ILostReasonSettingsDto {
    reasons: LostReasonDto[] | undefined;
    requireReason: boolean | undefined;
    stageDefaults: LostReasonStageDefaultDto[] | undefined;
    maxReasons: number | undefined;
    maxNameLength: number | undefined;
    maxNoteLength: number | undefined;
    pickerVisibleCount: number | undefined;
}

export class LostReasonSettingsDtoIHandleError implements ILostReasonSettingsDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LostReasonSettingsDto | undefined;
    listOfEntities!: LostReasonSettingsDto[] | undefined;

    constructor(data?: ILostReasonSettingsDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? LostReasonSettingsDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(LostReasonSettingsDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LostReasonSettingsDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LostReasonSettingsDtoIHandleError>(data, _mappings, LostReasonSettingsDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILostReasonSettingsDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LostReasonSettingsDto | undefined;
    listOfEntities: LostReasonSettingsDto[] | undefined;
}

export class SaveLostReasonInput implements ISaveLostReasonInput {
    id!: number | undefined;
    name!: string | undefined;
    icon!: string | undefined;

    constructor(data?: ISaveLostReasonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any, _mappings?: any): SaveLostReasonInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveLostReasonInput>(data, _mappings, SaveLostReasonInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        return data;
    }
}

export interface ISaveLostReasonInput {
    id: number | undefined;
    name: string | undefined;
    icon: string | undefined;
}

export class SaveLostReasonOutput implements ISaveLostReasonOutput {
    reason!: LostReasonDto | undefined;
    restored!: boolean | undefined;
    invalidField!: string | undefined;

    constructor(data?: ISaveLostReasonOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.reason = _data["reason"] ? LostReasonDto.fromJS(_data["reason"], _mappings) : undefined as any;
            this.restored = _data["restored"];
            this.invalidField = _data["invalidField"];
        }
    }

    static fromJS(data: any, _mappings?: any): SaveLostReasonOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveLostReasonOutput>(data, _mappings, SaveLostReasonOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason ? this.reason.toJSON() : undefined as any;
        data["restored"] = this.restored;
        data["invalidField"] = this.invalidField;
        return data;
    }
}

export interface ISaveLostReasonOutput {
    reason: LostReasonDto | undefined;
    restored: boolean | undefined;
    invalidField: string | undefined;
}

export class SaveLostReasonOutputIHandleError implements ISaveLostReasonOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SaveLostReasonOutput | undefined;
    listOfEntities!: SaveLostReasonOutput[] | undefined;

    constructor(data?: ISaveLostReasonOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SaveLostReasonOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SaveLostReasonOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SaveLostReasonOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveLostReasonOutputIHandleError>(data, _mappings, SaveLostReasonOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveLostReasonOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SaveLostReasonOutput | undefined;
    listOfEntities: SaveLostReasonOutput[] | undefined;
}

export class LostReasonDeleteImpactDto implements ILostReasonDeleteImpactDto {
    id!: number | undefined;
    name!: string | undefined;
    leadCount!: number | undefined;
    stageNames!: string[] | undefined;
    canDelete!: boolean | undefined;

    constructor(data?: ILostReasonDeleteImpactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.leadCount = _data["leadCount"];
            if (Array.isArray(_data["stageNames"])) {
                this.stageNames = [] as any;
                for (let item of _data["stageNames"])
                    this.stageNames!.push(item);
            }
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any, _mappings?: any): LostReasonDeleteImpactDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LostReasonDeleteImpactDto>(data, _mappings, LostReasonDeleteImpactDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["leadCount"] = this.leadCount;
        if (Array.isArray(this.stageNames)) {
            data["stageNames"] = [];
            for (let item of this.stageNames)
                data["stageNames"].push(item);
        }
        data["canDelete"] = this.canDelete;
        return data;
    }
}

export interface ILostReasonDeleteImpactDto {
    id: number | undefined;
    name: string | undefined;
    leadCount: number | undefined;
    stageNames: string[] | undefined;
    canDelete: boolean | undefined;
}

export class LostReasonDeleteImpactDtoIHandleError implements ILostReasonDeleteImpactDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LostReasonDeleteImpactDto | undefined;
    listOfEntities!: LostReasonDeleteImpactDto[] | undefined;

    constructor(data?: ILostReasonDeleteImpactDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? LostReasonDeleteImpactDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(LostReasonDeleteImpactDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LostReasonDeleteImpactDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LostReasonDeleteImpactDtoIHandleError>(data, _mappings, LostReasonDeleteImpactDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILostReasonDeleteImpactDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LostReasonDeleteImpactDto | undefined;
    listOfEntities: LostReasonDeleteImpactDto[] | undefined;
}

export class ReorderLostReasonsInput implements IReorderLostReasonsInput {
    ids!: number[] | undefined;

    constructor(data?: IReorderLostReasonsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ReorderLostReasonsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReorderLostReasonsInput>(data, _mappings, ReorderLostReasonsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IReorderLostReasonsInput {
    ids: number[] | undefined;
}

export class SetLostReasonRequiredInput implements ISetLostReasonRequiredInput {
    required!: boolean | undefined;

    constructor(data?: ISetLostReasonRequiredInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.required = _data["required"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetLostReasonRequiredInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetLostReasonRequiredInput>(data, _mappings, SetLostReasonRequiredInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["required"] = this.required;
        return data;
    }
}

export interface ISetLostReasonRequiredInput {
    required: boolean | undefined;
}

export class SuggestLostReasonIconsInput implements ISuggestLostReasonIconsInput {
    name!: string | undefined;

    constructor(data?: ISuggestLostReasonIconsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): SuggestLostReasonIconsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SuggestLostReasonIconsInput>(data, _mappings, SuggestLostReasonIconsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISuggestLostReasonIconsInput {
    name: string | undefined;
}

export class LostReasonIconSuggestionDto implements ILostReasonIconSuggestionDto {
    name!: string | undefined;
    icons!: string[] | undefined;
    fromAi!: boolean | undefined;

    constructor(data?: ILostReasonIconSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["icons"])) {
                this.icons = [] as any;
                for (let item of _data["icons"])
                    this.icons!.push(item);
            }
            this.fromAi = _data["fromAi"];
        }
    }

    static fromJS(data: any, _mappings?: any): LostReasonIconSuggestionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LostReasonIconSuggestionDto>(data, _mappings, LostReasonIconSuggestionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.icons)) {
            data["icons"] = [];
            for (let item of this.icons)
                data["icons"].push(item);
        }
        data["fromAi"] = this.fromAi;
        return data;
    }
}

export interface ILostReasonIconSuggestionDto {
    name: string | undefined;
    icons: string[] | undefined;
    fromAi: boolean | undefined;
}

export class LostReasonIconSuggestionDtoIHandleError implements ILostReasonIconSuggestionDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LostReasonIconSuggestionDto | undefined;
    listOfEntities!: LostReasonIconSuggestionDto[] | undefined;

    constructor(data?: ILostReasonIconSuggestionDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? LostReasonIconSuggestionDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(LostReasonIconSuggestionDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LostReasonIconSuggestionDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LostReasonIconSuggestionDtoIHandleError>(data, _mappings, LostReasonIconSuggestionDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILostReasonIconSuggestionDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LostReasonIconSuggestionDto | undefined;
    listOfEntities: LostReasonIconSuggestionDto[] | undefined;
}

export class MyCalendarSettingsDto implements IMyCalendarSettingsDto {
    featureEnabled!: boolean | undefined;
    defaultVisibility!: CalendarVisibility | undefined;
    bookingMode!: CalendarBookingMode | undefined;
    ownVisibility!: CalendarVisibility | undefined;
    canChooseFull!: boolean | undefined;
    syncToMyDay!: boolean | undefined;
    calendarSyncEnabled!: boolean | undefined;
    accessGrantCount!: number | undefined;

    constructor(data?: IMyCalendarSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.featureEnabled = _data["featureEnabled"];
            this.defaultVisibility = _data["defaultVisibility"];
            this.bookingMode = _data["bookingMode"];
            this.ownVisibility = _data["ownVisibility"];
            this.canChooseFull = _data["canChooseFull"];
            this.syncToMyDay = _data["syncToMyDay"];
            this.calendarSyncEnabled = _data["calendarSyncEnabled"];
            this.accessGrantCount = _data["accessGrantCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): MyCalendarSettingsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MyCalendarSettingsDto>(data, _mappings, MyCalendarSettingsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureEnabled"] = this.featureEnabled;
        data["defaultVisibility"] = this.defaultVisibility;
        data["bookingMode"] = this.bookingMode;
        data["ownVisibility"] = this.ownVisibility;
        data["canChooseFull"] = this.canChooseFull;
        data["syncToMyDay"] = this.syncToMyDay;
        data["calendarSyncEnabled"] = this.calendarSyncEnabled;
        data["accessGrantCount"] = this.accessGrantCount;
        return data;
    }
}

export interface IMyCalendarSettingsDto {
    featureEnabled: boolean | undefined;
    defaultVisibility: CalendarVisibility | undefined;
    bookingMode: CalendarBookingMode | undefined;
    ownVisibility: CalendarVisibility | undefined;
    canChooseFull: boolean | undefined;
    syncToMyDay: boolean | undefined;
    calendarSyncEnabled: boolean | undefined;
    accessGrantCount: number | undefined;
}

export class SetMyVisibilityInput implements ISetMyVisibilityInput {
    visibility!: CalendarVisibility | undefined;

    constructor(data?: ISetMyVisibilityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.visibility = _data["visibility"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetMyVisibilityInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetMyVisibilityInput>(data, _mappings, SetMyVisibilityInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visibility"] = this.visibility;
        return data;
    }
}

export interface ISetMyVisibilityInput {
    visibility: CalendarVisibility | undefined;
}

export class SetMySyncToMyDayInput implements ISetMySyncToMyDayInput {
    enabled!: boolean | undefined;

    constructor(data?: ISetMySyncToMyDayInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetMySyncToMyDayInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetMySyncToMyDayInput>(data, _mappings, SetMySyncToMyDayInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface ISetMySyncToMyDayInput {
    enabled: boolean | undefined;
}

export class SetMyCalendarSyncInput implements ISetMyCalendarSyncInput {
    enabled!: boolean | undefined;

    constructor(data?: ISetMyCalendarSyncInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetMyCalendarSyncInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetMyCalendarSyncInput>(data, _mappings, SetMyCalendarSyncInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface ISetMyCalendarSyncInput {
    enabled: boolean | undefined;
}

export class AddMyGrantInput implements IAddMyGrantInput {
    grantedUserId!: number | undefined;

    constructor(data?: IAddMyGrantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.grantedUserId = _data["grantedUserId"];
        }
    }

    static fromJS(data: any, _mappings?: any): AddMyGrantInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddMyGrantInput>(data, _mappings, AddMyGrantInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grantedUserId"] = this.grantedUserId;
        return data;
    }
}

export interface IAddMyGrantInput {
    grantedUserId: number | undefined;
}

export class CreateOrUpdateNotesDto implements ICreateOrUpdateNotesDto {
    id!: number | undefined;
    entityId!: number | undefined;
    entityType!: EntityType | undefined;
    notes!: string | undefined;

    constructor(data?: ICreateOrUpdateNotesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateOrUpdateNotesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateOrUpdateNotesDto>(data, _mappings, CreateOrUpdateNotesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateOrUpdateNotesDto {
    id: number | undefined;
    entityId: number | undefined;
    entityType: EntityType | undefined;
    notes: string | undefined;
}

export class NotesDto implements INotesDto {
    id!: number | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    notes!: string | undefined;
    pinnedEntityId!: number | undefined;
    sortOrder!: number | undefined;
    companyId!: number | undefined;
    companyName!: string | undefined;
    creationTime!: string | undefined;
    colorClassName!: string | undefined;
    readonly createdTimeAgo!: string | undefined;
    readonly title!: string | undefined;
    readonly taskTitle!: string | undefined;

    constructor(data?: INotesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.notes = _data["notes"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.sortOrder = _data["sortOrder"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.creationTime = _data["creationTime"];
            this.colorClassName = _data["colorClassName"];
            (this as any).createdTimeAgo = _data["createdTimeAgo"];
            (this as any).title = _data["title"];
            (this as any).taskTitle = _data["taskTitle"];
        }
    }

    static fromJS(data: any, _mappings?: any): NotesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NotesDto>(data, _mappings, NotesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["notes"] = this.notes;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["sortOrder"] = this.sortOrder;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["creationTime"] = this.creationTime;
        data["colorClassName"] = this.colorClassName;
        data["createdTimeAgo"] = this.createdTimeAgo;
        data["title"] = this.title;
        data["taskTitle"] = this.taskTitle;
        return data;
    }
}

export interface INotesDto {
    id: number | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    notes: string | undefined;
    pinnedEntityId: number | undefined;
    sortOrder: number | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    creationTime: string | undefined;
    colorClassName: string | undefined;
    createdTimeAgo: string | undefined;
    title: string | undefined;
    taskTitle: string | undefined;
}

export class NotesDtoListIHandleError implements INotesDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: NotesDto[] | undefined;
    listOfEntities!: NotesDto[][] | undefined;

    constructor(data?: INotesDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(NotesDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): NotesDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NotesDtoListIHandleError>(data, _mappings, NotesDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface INotesDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: NotesDto[] | undefined;
    listOfEntities: NotesDto[][] | undefined;
}

export enum UserNotificationState {
    _0 = 0,
    _1 = 1,
}

export class UserNotificationsGroupsListGetNotificationsOutputv2ListValueTuple implements IUserNotificationsGroupsListGetNotificationsOutputv2ListValueTuple {

    constructor(data?: IUserNotificationsGroupsListGetNotificationsOutputv2ListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): UserNotificationsGroupsListGetNotificationsOutputv2ListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserNotificationsGroupsListGetNotificationsOutputv2ListValueTuple>(data, _mappings, UserNotificationsGroupsListGetNotificationsOutputv2ListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUserNotificationsGroupsListGetNotificationsOutputv2ListValueTuple {
}

export class UserNotificationsGroupsListGetNotificationsOutputv2ListValueTupleIHandleError implements IUserNotificationsGroupsListGetNotificationsOutputv2ListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserNotificationsGroupsListGetNotificationsOutputv2ListValueTuple | undefined;
    listOfEntities!: UserNotificationsGroupsListGetNotificationsOutputv2ListValueTuple[] | undefined;

    constructor(data?: IUserNotificationsGroupsListGetNotificationsOutputv2ListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserNotificationsGroupsListGetNotificationsOutputv2ListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserNotificationsGroupsListGetNotificationsOutputv2ListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserNotificationsGroupsListGetNotificationsOutputv2ListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserNotificationsGroupsListGetNotificationsOutputv2ListValueTupleIHandleError>(data, _mappings, UserNotificationsGroupsListGetNotificationsOutputv2ListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserNotificationsGroupsListGetNotificationsOutputv2ListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserNotificationsGroupsListGetNotificationsOutputv2ListValueTuple | undefined;
    listOfEntities: UserNotificationsGroupsListGetNotificationsOutputv2ListValueTuple[] | undefined;
}

export class UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTuple implements IUserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTuple {

    constructor(data?: IUserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTuple>(data, _mappings, UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTuple {
}

export class UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTupleIHandleError implements IUserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTuple | undefined;
    listOfEntities!: UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTuple[] | undefined;

    constructor(data?: IUserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTupleIHandleError>(data, _mappings, UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTuple | undefined;
    listOfEntities: UserNotificationsGroupsListGetNotificationsOutputv2ListNotificationPaginationInfoValueTuple[] | undefined;
}

export class UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTuple implements IUserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTuple {

    constructor(data?: IUserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTuple>(data, _mappings, UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTuple {
}

export class UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTupleIHandleError implements IUserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTuple | undefined;
    listOfEntities!: UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTuple[] | undefined;

    constructor(data?: IUserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTupleIHandleError>(data, _mappings, UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTuple | undefined;
    listOfEntities: UserNotificationsGroupsListGetNotificationsOutputv2ListInt32ValueTuple[] | undefined;
}

export class UserNotificationsGroupsListGetNotificationsOutputListValueTuple implements IUserNotificationsGroupsListGetNotificationsOutputListValueTuple {

    constructor(data?: IUserNotificationsGroupsListGetNotificationsOutputListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): UserNotificationsGroupsListGetNotificationsOutputListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserNotificationsGroupsListGetNotificationsOutputListValueTuple>(data, _mappings, UserNotificationsGroupsListGetNotificationsOutputListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUserNotificationsGroupsListGetNotificationsOutputListValueTuple {
}

export class UserNotificationsGroupsListGetNotificationsOutputListValueTupleIHandleError implements IUserNotificationsGroupsListGetNotificationsOutputListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserNotificationsGroupsListGetNotificationsOutputListValueTuple | undefined;
    listOfEntities!: UserNotificationsGroupsListGetNotificationsOutputListValueTuple[] | undefined;

    constructor(data?: IUserNotificationsGroupsListGetNotificationsOutputListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserNotificationsGroupsListGetNotificationsOutputListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserNotificationsGroupsListGetNotificationsOutputListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserNotificationsGroupsListGetNotificationsOutputListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserNotificationsGroupsListGetNotificationsOutputListValueTupleIHandleError>(data, _mappings, UserNotificationsGroupsListGetNotificationsOutputListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserNotificationsGroupsListGetNotificationsOutputListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserNotificationsGroupsListGetNotificationsOutputListValueTuple | undefined;
    listOfEntities: UserNotificationsGroupsListGetNotificationsOutputListValueTuple[] | undefined;
}

export class SetNotificationReadInput implements ISetNotificationReadInput {
    notificationId!: number | undefined;
    markAllRead!: boolean | undefined;

    constructor(data?: ISetNotificationReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.notificationId = _data["notificationId"];
            this.markAllRead = _data["markAllRead"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetNotificationReadInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetNotificationReadInput>(data, _mappings, SetNotificationReadInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationId"] = this.notificationId;
        data["markAllRead"] = this.markAllRead;
        return data;
    }
}

export interface ISetNotificationReadInput {
    notificationId: number | undefined;
    markAllRead: boolean | undefined;
}

export class ClearNotificationInputDto implements IClearNotificationInputDto {
    notificationId!: number | undefined;
    isClearAll!: boolean | undefined;

    constructor(data?: IClearNotificationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.notificationId = _data["notificationId"];
            this.isClearAll = _data["isClearAll"];
        }
    }

    static fromJS(data: any, _mappings?: any): ClearNotificationInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ClearNotificationInputDto>(data, _mappings, ClearNotificationInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationId"] = this.notificationId;
        data["isClearAll"] = this.isClearAll;
        return data;
    }
}

export interface IClearNotificationInputDto {
    notificationId: number | undefined;
    isClearAll: boolean | undefined;
}

export class Int32WorkSitesDtoIEnumerableValueTuple implements IInt32WorkSitesDtoIEnumerableValueTuple {

    constructor(data?: IInt32WorkSitesDtoIEnumerableValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): Int32WorkSitesDtoIEnumerableValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32WorkSitesDtoIEnumerableValueTuple>(data, _mappings, Int32WorkSitesDtoIEnumerableValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IInt32WorkSitesDtoIEnumerableValueTuple {
}

export class Int32WorkSitesDtoIEnumerableValueTupleIHandleError implements IInt32WorkSitesDtoIEnumerableValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: Int32WorkSitesDtoIEnumerableValueTuple | undefined;
    listOfEntities!: Int32WorkSitesDtoIEnumerableValueTuple[] | undefined;

    constructor(data?: IInt32WorkSitesDtoIEnumerableValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? Int32WorkSitesDtoIEnumerableValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(Int32WorkSitesDtoIEnumerableValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32WorkSitesDtoIEnumerableValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32WorkSitesDtoIEnumerableValueTupleIHandleError>(data, _mappings, Int32WorkSitesDtoIEnumerableValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInt32WorkSitesDtoIEnumerableValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: Int32WorkSitesDtoIEnumerableValueTuple | undefined;
    listOfEntities: Int32WorkSitesDtoIEnumerableValueTuple[] | undefined;
}

export class WorkSitesDto implements IWorkSitesDto {
    id!: number | undefined;
    name!: string | undefined;
    address!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipcode!: string | undefined;
    countryId!: number | undefined;
    country!: string | undefined;

    constructor(data?: IWorkSitesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipcode = _data["zipcode"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any, _mappings?: any): WorkSitesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<WorkSitesDto>(data, _mappings, WorkSitesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipcode"] = this.zipcode;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        return data;
    }
}

export interface IWorkSitesDto {
    id: number | undefined;
    name: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    countryId: number | undefined;
    country: string | undefined;
}

export enum OnboardingStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum OnboardingChapter {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum OnboardingStep {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
}

export enum OnboardingScanState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum OnboardingConsentState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum CandidateState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum ConfidenceBand {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class OnboardingTerminologyCandidateDto implements IOnboardingTerminologyCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    singular!: string | undefined;
    plural!: string | undefined;
    presetKey!: string | undefined;
    isConfirmedByUser!: boolean | undefined;

    constructor(data?: IOnboardingTerminologyCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.singular = _data["singular"];
            this.plural = _data["plural"];
            this.presetKey = _data["presetKey"];
            this.isConfirmedByUser = _data["isConfirmedByUser"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingTerminologyCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingTerminologyCandidateDto>(data, _mappings, OnboardingTerminologyCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["singular"] = this.singular;
        data["plural"] = this.plural;
        data["presetKey"] = this.presetKey;
        data["isConfirmedByUser"] = this.isConfirmedByUser;
        return data;
    }
}

export interface IOnboardingTerminologyCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    singular: string | undefined;
    plural: string | undefined;
    presetKey: string | undefined;
    isConfirmedByUser: boolean | undefined;
}

export class OnboardingWorkspaceUserDto implements IOnboardingWorkspaceUserDto {
    userId!: number | undefined;
    name!: string | undefined;
    email!: string | undefined;
    isOwner!: boolean | undefined;

    constructor(data?: IOnboardingWorkspaceUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.isOwner = _data["isOwner"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingWorkspaceUserDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingWorkspaceUserDto>(data, _mappings, OnboardingWorkspaceUserDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["isOwner"] = this.isOwner;
        return data;
    }
}

export interface IOnboardingWorkspaceUserDto {
    userId: number | undefined;
    name: string | undefined;
    email: string | undefined;
    isOwner: boolean | undefined;
}

export enum KnowledgeOrigin {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
}

export enum FirmCategory {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class OnboardingFirmCandidateDto implements IOnboardingFirmCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    organizationName!: string | undefined;
    organizationNameOrigin!: KnowledgeOrigin | undefined;
    domain!: string | undefined;
    firmType!: string | undefined;
    primaryWork!: string | undefined;
    firmCategory!: FirmCategory | undefined;
    evidenceNotes!: string[] | undefined;
    isConfirmedByUser!: boolean | undefined;

    constructor(data?: IOnboardingFirmCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.organizationName = _data["organizationName"];
            this.organizationNameOrigin = _data["organizationNameOrigin"];
            this.domain = _data["domain"];
            this.firmType = _data["firmType"];
            this.primaryWork = _data["primaryWork"];
            this.firmCategory = _data["firmCategory"];
            if (Array.isArray(_data["evidenceNotes"])) {
                this.evidenceNotes = [] as any;
                for (let item of _data["evidenceNotes"])
                    this.evidenceNotes!.push(item);
            }
            this.isConfirmedByUser = _data["isConfirmedByUser"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingFirmCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingFirmCandidateDto>(data, _mappings, OnboardingFirmCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["organizationName"] = this.organizationName;
        data["organizationNameOrigin"] = this.organizationNameOrigin;
        data["domain"] = this.domain;
        data["firmType"] = this.firmType;
        data["primaryWork"] = this.primaryWork;
        data["firmCategory"] = this.firmCategory;
        if (Array.isArray(this.evidenceNotes)) {
            data["evidenceNotes"] = [];
            for (let item of this.evidenceNotes)
                data["evidenceNotes"].push(item);
        }
        data["isConfirmedByUser"] = this.isConfirmedByUser;
        return data;
    }
}

export interface IOnboardingFirmCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    organizationName: string | undefined;
    organizationNameOrigin: KnowledgeOrigin | undefined;
    domain: string | undefined;
    firmType: string | undefined;
    primaryWork: string | undefined;
    firmCategory: FirmCategory | undefined;
    evidenceNotes: string[] | undefined;
    isConfirmedByUser: boolean | undefined;
}

export class OnboardingWorkModelLinkDto implements IOnboardingWorkModelLinkDto {
    key!: string;
    label!: string | undefined;
    exampleValue!: string | undefined;
    fieldKey!: string | undefined;

    constructor(data?: IOnboardingWorkModelLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.exampleValue = _data["exampleValue"];
            this.fieldKey = _data["fieldKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingWorkModelLinkDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingWorkModelLinkDto>(data, _mappings, OnboardingWorkModelLinkDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["exampleValue"] = this.exampleValue;
        data["fieldKey"] = this.fieldKey;
        return data;
    }
}

export interface IOnboardingWorkModelLinkDto {
    key: string;
    label: string | undefined;
    exampleValue: string | undefined;
    fieldKey: string | undefined;
}

export class OnboardingWorkModelCandidateDto implements IOnboardingWorkModelCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    chain!: OnboardingWorkModelLinkDto[] | undefined;
    oneClientHasManyWorkItems!: boolean | undefined;

    constructor(data?: IOnboardingWorkModelCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            if (Array.isArray(_data["chain"])) {
                this.chain = [] as any;
                for (let item of _data["chain"])
                    this.chain!.push(OnboardingWorkModelLinkDto.fromJS(item, _mappings));
            }
            this.oneClientHasManyWorkItems = _data["oneClientHasManyWorkItems"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingWorkModelCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingWorkModelCandidateDto>(data, _mappings, OnboardingWorkModelCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        if (Array.isArray(this.chain)) {
            data["chain"] = [];
            for (let item of this.chain)
                data["chain"].push(item ? item.toJSON() : undefined as any);
        }
        data["oneClientHasManyWorkItems"] = this.oneClientHasManyWorkItems;
        return data;
    }
}

export interface IOnboardingWorkModelCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    chain: OnboardingWorkModelLinkDto[] | undefined;
    oneClientHasManyWorkItems: boolean | undefined;
}

export class OnboardingClientTypeCandidateDto implements IOnboardingClientTypeCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    name!: string | undefined;
    act!: ContactTypeAct | undefined;

    constructor(data?: IOnboardingClientTypeCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.name = _data["name"];
            this.act = _data["act"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingClientTypeCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingClientTypeCandidateDto>(data, _mappings, OnboardingClientTypeCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["name"] = this.name;
        data["act"] = this.act;
        return data;
    }
}

export interface IOnboardingClientTypeCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    name: string | undefined;
    act: ContactTypeAct | undefined;
}

export class OnboardingSourceCandidateDto implements IOnboardingSourceCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    name!: string | undefined;
    guidance!: string | undefined;

    constructor(data?: IOnboardingSourceCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.name = _data["name"];
            this.guidance = _data["guidance"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingSourceCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingSourceCandidateDto>(data, _mappings, OnboardingSourceCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["name"] = this.name;
        data["guidance"] = this.guidance;
        return data;
    }
}

export interface IOnboardingSourceCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    name: string | undefined;
    guidance: string | undefined;
}

export class OnboardingLeadStageCandidateDto implements IOnboardingLeadStageCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    name!: string | undefined;
    act!: ClientStageAct | undefined;
    isHidden!: boolean | undefined;

    constructor(data?: IOnboardingLeadStageCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.name = _data["name"];
            this.act = _data["act"];
            this.isHidden = _data["isHidden"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingLeadStageCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingLeadStageCandidateDto>(data, _mappings, OnboardingLeadStageCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["name"] = this.name;
        data["act"] = this.act;
        data["isHidden"] = this.isHidden;
        return data;
    }
}

export interface IOnboardingLeadStageCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    name: string | undefined;
    act: ClientStageAct | undefined;
    isHidden: boolean | undefined;
}

export class OnboardingWorkStageCandidateDto implements IOnboardingWorkStageCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    name!: string | undefined;
    isOpen!: boolean | undefined;

    constructor(data?: IOnboardingWorkStageCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.name = _data["name"];
            this.isOpen = _data["isOpen"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingWorkStageCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingWorkStageCandidateDto>(data, _mappings, OnboardingWorkStageCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["name"] = this.name;
        data["isOpen"] = this.isOpen;
        return data;
    }
}

export interface IOnboardingWorkStageCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    name: string | undefined;
    isOpen: boolean | undefined;
}

export class OnboardingFieldSectionCandidateDto implements IOnboardingFieldSectionCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    name!: string | undefined;

    constructor(data?: IOnboardingFieldSectionCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingFieldSectionCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingFieldSectionCandidateDto>(data, _mappings, OnboardingFieldSectionCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["name"] = this.name;
        return data;
    }
}

export interface IOnboardingFieldSectionCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    name: string | undefined;
}

export enum NativeFieldKey {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export class OnboardingFieldCandidateDto implements IOnboardingFieldCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    label!: string | undefined;
    fieldType!: ProjectFieldType | undefined;
    nativeKey!: NativeFieldKey | undefined;
    removed!: boolean | undefined;
    isLocked!: boolean | undefined;
    sectionKey!: string | undefined;
    options!: string[] | undefined;

    constructor(data?: IOnboardingFieldCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.label = _data["label"];
            this.fieldType = _data["fieldType"];
            this.nativeKey = _data["nativeKey"];
            this.removed = _data["removed"];
            this.isLocked = _data["isLocked"];
            this.sectionKey = _data["sectionKey"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingFieldCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingFieldCandidateDto>(data, _mappings, OnboardingFieldCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["label"] = this.label;
        data["fieldType"] = this.fieldType;
        data["nativeKey"] = this.nativeKey;
        data["removed"] = this.removed;
        data["isLocked"] = this.isLocked;
        data["sectionKey"] = this.sectionKey;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data;
    }
}

export interface IOnboardingFieldCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    label: string | undefined;
    fieldType: ProjectFieldType | undefined;
    nativeKey: NativeFieldKey | undefined;
    removed: boolean | undefined;
    isLocked: boolean | undefined;
    sectionKey: string | undefined;
    options: string[] | undefined;
}

export class OnboardingListColumnCandidateDto implements IOnboardingListColumnCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    columnId!: string | undefined;
    fieldKey!: string | undefined;
    hidden!: boolean | undefined;

    constructor(data?: IOnboardingListColumnCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.columnId = _data["columnId"];
            this.fieldKey = _data["fieldKey"];
            this.hidden = _data["hidden"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingListColumnCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingListColumnCandidateDto>(data, _mappings, OnboardingListColumnCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["columnId"] = this.columnId;
        data["fieldKey"] = this.fieldKey;
        data["hidden"] = this.hidden;
        return data;
    }
}

export interface IOnboardingListColumnCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    columnId: string | undefined;
    fieldKey: string | undefined;
    hidden: boolean | undefined;
}

export class OnboardingPersonCandidateDto implements IOnboardingPersonCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    name!: string | undefined;
    email!: string | undefined;
    isInternal!: boolean | undefined;
    isSourceUser!: boolean | undefined;
    trovveUserId!: number | undefined;
    isOwner!: boolean | undefined;

    constructor(data?: IOnboardingPersonCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.name = _data["name"];
            this.email = _data["email"];
            this.isInternal = _data["isInternal"];
            this.isSourceUser = _data["isSourceUser"];
            this.trovveUserId = _data["trovveUserId"];
            this.isOwner = _data["isOwner"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingPersonCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingPersonCandidateDto>(data, _mappings, OnboardingPersonCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["name"] = this.name;
        data["email"] = this.email;
        data["isInternal"] = this.isInternal;
        data["isSourceUser"] = this.isSourceUser;
        data["trovveUserId"] = this.trovveUserId;
        data["isOwner"] = this.isOwner;
        return data;
    }
}

export interface IOnboardingPersonCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    name: string | undefined;
    email: string | undefined;
    isInternal: boolean | undefined;
    isSourceUser: boolean | undefined;
    trovveUserId: number | undefined;
    isOwner: boolean | undefined;
}

export enum RoleType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class OnboardingRoleAssigneeDto implements IOnboardingRoleAssigneeDto {
    personKey!: string | undefined;
    userId!: number | undefined;
    isPrimary!: boolean | undefined;

    constructor(data?: IOnboardingRoleAssigneeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.personKey = _data["personKey"];
            this.userId = _data["userId"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingRoleAssigneeDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingRoleAssigneeDto>(data, _mappings, OnboardingRoleAssigneeDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personKey"] = this.personKey;
        data["userId"] = this.userId;
        data["isPrimary"] = this.isPrimary;
        return data;
    }
}

export interface IOnboardingRoleAssigneeDto {
    personKey: string | undefined;
    userId: number | undefined;
    isPrimary: boolean | undefined;
}

export class OnboardingRoleCandidateDto implements IOnboardingRoleCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    name!: string | undefined;
    roleType!: RoleType | undefined;
    activitySummary!: string | undefined;
    assignees!: OnboardingRoleAssigneeDto[] | undefined;

    constructor(data?: IOnboardingRoleCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.name = _data["name"];
            this.roleType = _data["roleType"];
            this.activitySummary = _data["activitySummary"];
            if (Array.isArray(_data["assignees"])) {
                this.assignees = [] as any;
                for (let item of _data["assignees"])
                    this.assignees!.push(OnboardingRoleAssigneeDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingRoleCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingRoleCandidateDto>(data, _mappings, OnboardingRoleCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["name"] = this.name;
        data["roleType"] = this.roleType;
        data["activitySummary"] = this.activitySummary;
        if (Array.isArray(this.assignees)) {
            data["assignees"] = [];
            for (let item of this.assignees)
                data["assignees"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingRoleCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    name: string | undefined;
    roleType: RoleType | undefined;
    activitySummary: string | undefined;
    assignees: OnboardingRoleAssigneeDto[] | undefined;
}

export class OnboardingTemplateSectionDto implements IOnboardingTemplateSectionDto {
    key!: string;
    name!: string | undefined;

    constructor(data?: IOnboardingTemplateSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingTemplateSectionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingTemplateSectionDto>(data, _mappings, OnboardingTemplateSectionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        return data;
    }
}

export interface IOnboardingTemplateSectionDto {
    key: string;
    name: string | undefined;
}

export class OnboardingTemplateStepDto implements IOnboardingTemplateStepDto {
    key!: string;
    title!: string | undefined;
    roleKey!: string | undefined;

    constructor(data?: IOnboardingTemplateStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.title = _data["title"];
            this.roleKey = _data["roleKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingTemplateStepDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingTemplateStepDto>(data, _mappings, OnboardingTemplateStepDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["title"] = this.title;
        data["roleKey"] = this.roleKey;
        return data;
    }
}

export interface IOnboardingTemplateStepDto {
    key: string;
    title: string | undefined;
    roleKey: string | undefined;
}

export class OnboardingTemplateTaskDto implements IOnboardingTemplateTaskDto {
    key!: string;
    title!: string | undefined;
    sectionKey!: string | undefined;
    roleKey!: string | undefined;
    startDayOffset!: number | undefined;
    durationDays!: number | undefined;
    steps!: OnboardingTemplateStepDto[] | undefined;

    constructor(data?: IOnboardingTemplateTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.title = _data["title"];
            this.sectionKey = _data["sectionKey"];
            this.roleKey = _data["roleKey"];
            this.startDayOffset = _data["startDayOffset"];
            this.durationDays = _data["durationDays"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(OnboardingTemplateStepDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingTemplateTaskDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingTemplateTaskDto>(data, _mappings, OnboardingTemplateTaskDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["title"] = this.title;
        data["sectionKey"] = this.sectionKey;
        data["roleKey"] = this.roleKey;
        data["startDayOffset"] = this.startDayOffset;
        data["durationDays"] = this.durationDays;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingTemplateTaskDto {
    key: string;
    title: string | undefined;
    sectionKey: string | undefined;
    roleKey: string | undefined;
    startDayOffset: number | undefined;
    durationDays: number | undefined;
    steps: OnboardingTemplateStepDto[] | undefined;
}

export class TemplateFolderDto implements ITemplateFolderDto {
    id!: number | undefined;
    tempId!: string | undefined;
    parentId!: number | undefined;
    parentTempId!: string | undefined;
    name!: string;
    order!: number | undefined;

    constructor(data?: ITemplateFolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tempId = _data["tempId"];
            this.parentId = _data["parentId"];
            this.parentTempId = _data["parentTempId"];
            this.name = _data["name"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any, _mappings?: any): TemplateFolderDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TemplateFolderDto>(data, _mappings, TemplateFolderDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tempId"] = this.tempId;
        data["parentId"] = this.parentId;
        data["parentTempId"] = this.parentTempId;
        data["name"] = this.name;
        data["order"] = this.order;
        return data;
    }
}

export interface ITemplateFolderDto {
    id: number | undefined;
    tempId: string | undefined;
    parentId: number | undefined;
    parentTempId: string | undefined;
    name: string;
    order: number | undefined;
}

export class OnboardingTemplateCandidateDto implements IOnboardingTemplateCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    name!: string | undefined;
    sections!: OnboardingTemplateSectionDto[] | undefined;
    tasks!: OnboardingTemplateTaskDto[] | undefined;
    folders!: TemplateFolderDto[] | undefined;

    constructor(data?: IOnboardingTemplateCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.name = _data["name"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(OnboardingTemplateSectionDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(OnboardingTemplateTaskDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["folders"])) {
                this.folders = [] as any;
                for (let item of _data["folders"])
                    this.folders!.push(TemplateFolderDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingTemplateCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingTemplateCandidateDto>(data, _mappings, OnboardingTemplateCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["name"] = this.name;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.folders)) {
            data["folders"] = [];
            for (let item of this.folders)
                data["folders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingTemplateCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    name: string | undefined;
    sections: OnboardingTemplateSectionDto[] | undefined;
    tasks: OnboardingTemplateTaskDto[] | undefined;
    folders: TemplateFolderDto[] | undefined;
}

export class OnboardingTemplateHintDto implements IOnboardingTemplateHintDto {
    key!: string;
    name!: string | undefined;

    constructor(data?: IOnboardingTemplateHintDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingTemplateHintDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingTemplateHintDto>(data, _mappings, OnboardingTemplateHintDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        return data;
    }
}

export interface IOnboardingTemplateHintDto {
    key: string;
    name: string | undefined;
}

export class OnboardingCapabilityNoteDto implements IOnboardingCapabilityNoteDto {
    label!: string | undefined;
    capabilityKey!: string | undefined;
    supportedNow!: boolean | undefined;

    constructor(data?: IOnboardingCapabilityNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.label = _data["label"];
            this.capabilityKey = _data["capabilityKey"];
            this.supportedNow = _data["supportedNow"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingCapabilityNoteDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingCapabilityNoteDto>(data, _mappings, OnboardingCapabilityNoteDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["capabilityKey"] = this.capabilityKey;
        data["supportedNow"] = this.supportedNow;
        return data;
    }
}

export interface IOnboardingCapabilityNoteDto {
    label: string | undefined;
    capabilityKey: string | undefined;
    supportedNow: boolean | undefined;
}

export class OnboardingEmailRuleCandidateDto implements IOnboardingEmailRuleCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    kind!: EmailAutomationKind | undefined;
    name!: string | undefined;
    description!: string | undefined;
    userWrittenText!: string | undefined;
    audience!: EmailAutomationAudience | undefined;
    inboxTokens!: string[] | undefined;
    handlerStrategy!: EmailAutomationHandler | undefined;
    handlerPersonKey!: string | undefined;
    handlerUserId!: number | undefined;
    handlerIsTrovveUser!: boolean | undefined;
    handlerRoleKey!: string | undefined;
    notifyUserIds!: number[] | undefined;
    addSenderAsClient!: boolean | undefined;
    senderTypeAct!: ContactTypeAct | undefined;
    senderTypeKey!: string | undefined;
    senderStageKey!: string | undefined;
    createTaskMode!: EmailAutomationCreateTaskMode | undefined;
    projectMatchMode!: EmailAutomationProjectMatchMode | undefined;
    sectionMode!: EmailAutomationSectionMode | undefined;
    saveEmail!: boolean | undefined;
    saveAttachments!: boolean | undefined;
    saveIntoMode!: EmailAutomationSaveIntoMode | undefined;
    movedToProjectMode!: EmailAutomationMovedToProjectMode | undefined;
    tagInOutlook!: boolean | undefined;
    tagName!: string | undefined;
    tagColorKey!: string | undefined;
    acceptedOverlapRuleKeys!: string[] | undefined;
    proposedFeatures!: OnboardingCapabilityNoteDto[] | undefined;

    constructor(data?: IOnboardingEmailRuleCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.kind = _data["kind"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.userWrittenText = _data["userWrittenText"];
            this.audience = _data["audience"];
            if (Array.isArray(_data["inboxTokens"])) {
                this.inboxTokens = [] as any;
                for (let item of _data["inboxTokens"])
                    this.inboxTokens!.push(item);
            }
            this.handlerStrategy = _data["handlerStrategy"];
            this.handlerPersonKey = _data["handlerPersonKey"];
            this.handlerUserId = _data["handlerUserId"];
            this.handlerIsTrovveUser = _data["handlerIsTrovveUser"];
            this.handlerRoleKey = _data["handlerRoleKey"];
            if (Array.isArray(_data["notifyUserIds"])) {
                this.notifyUserIds = [] as any;
                for (let item of _data["notifyUserIds"])
                    this.notifyUserIds!.push(item);
            }
            this.addSenderAsClient = _data["addSenderAsClient"];
            this.senderTypeAct = _data["senderTypeAct"];
            this.senderTypeKey = _data["senderTypeKey"];
            this.senderStageKey = _data["senderStageKey"];
            this.createTaskMode = _data["createTaskMode"];
            this.projectMatchMode = _data["projectMatchMode"];
            this.sectionMode = _data["sectionMode"];
            this.saveEmail = _data["saveEmail"];
            this.saveAttachments = _data["saveAttachments"];
            this.saveIntoMode = _data["saveIntoMode"];
            this.movedToProjectMode = _data["movedToProjectMode"];
            this.tagInOutlook = _data["tagInOutlook"];
            this.tagName = _data["tagName"];
            this.tagColorKey = _data["tagColorKey"];
            if (Array.isArray(_data["acceptedOverlapRuleKeys"])) {
                this.acceptedOverlapRuleKeys = [] as any;
                for (let item of _data["acceptedOverlapRuleKeys"])
                    this.acceptedOverlapRuleKeys!.push(item);
            }
            if (Array.isArray(_data["proposedFeatures"])) {
                this.proposedFeatures = [] as any;
                for (let item of _data["proposedFeatures"])
                    this.proposedFeatures!.push(OnboardingCapabilityNoteDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingEmailRuleCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingEmailRuleCandidateDto>(data, _mappings, OnboardingEmailRuleCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["kind"] = this.kind;
        data["name"] = this.name;
        data["description"] = this.description;
        data["userWrittenText"] = this.userWrittenText;
        data["audience"] = this.audience;
        if (Array.isArray(this.inboxTokens)) {
            data["inboxTokens"] = [];
            for (let item of this.inboxTokens)
                data["inboxTokens"].push(item);
        }
        data["handlerStrategy"] = this.handlerStrategy;
        data["handlerPersonKey"] = this.handlerPersonKey;
        data["handlerUserId"] = this.handlerUserId;
        data["handlerIsTrovveUser"] = this.handlerIsTrovveUser;
        data["handlerRoleKey"] = this.handlerRoleKey;
        if (Array.isArray(this.notifyUserIds)) {
            data["notifyUserIds"] = [];
            for (let item of this.notifyUserIds)
                data["notifyUserIds"].push(item);
        }
        data["addSenderAsClient"] = this.addSenderAsClient;
        data["senderTypeAct"] = this.senderTypeAct;
        data["senderTypeKey"] = this.senderTypeKey;
        data["senderStageKey"] = this.senderStageKey;
        data["createTaskMode"] = this.createTaskMode;
        data["projectMatchMode"] = this.projectMatchMode;
        data["sectionMode"] = this.sectionMode;
        data["saveEmail"] = this.saveEmail;
        data["saveAttachments"] = this.saveAttachments;
        data["saveIntoMode"] = this.saveIntoMode;
        data["movedToProjectMode"] = this.movedToProjectMode;
        data["tagInOutlook"] = this.tagInOutlook;
        data["tagName"] = this.tagName;
        data["tagColorKey"] = this.tagColorKey;
        if (Array.isArray(this.acceptedOverlapRuleKeys)) {
            data["acceptedOverlapRuleKeys"] = [];
            for (let item of this.acceptedOverlapRuleKeys)
                data["acceptedOverlapRuleKeys"].push(item);
        }
        if (Array.isArray(this.proposedFeatures)) {
            data["proposedFeatures"] = [];
            for (let item of this.proposedFeatures)
                data["proposedFeatures"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingEmailRuleCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    kind: EmailAutomationKind | undefined;
    name: string | undefined;
    description: string | undefined;
    userWrittenText: string | undefined;
    audience: EmailAutomationAudience | undefined;
    inboxTokens: string[] | undefined;
    handlerStrategy: EmailAutomationHandler | undefined;
    handlerPersonKey: string | undefined;
    handlerUserId: number | undefined;
    handlerIsTrovveUser: boolean | undefined;
    handlerRoleKey: string | undefined;
    notifyUserIds: number[] | undefined;
    addSenderAsClient: boolean | undefined;
    senderTypeAct: ContactTypeAct | undefined;
    senderTypeKey: string | undefined;
    senderStageKey: string | undefined;
    createTaskMode: EmailAutomationCreateTaskMode | undefined;
    projectMatchMode: EmailAutomationProjectMatchMode | undefined;
    sectionMode: EmailAutomationSectionMode | undefined;
    saveEmail: boolean | undefined;
    saveAttachments: boolean | undefined;
    saveIntoMode: EmailAutomationSaveIntoMode | undefined;
    movedToProjectMode: EmailAutomationMovedToProjectMode | undefined;
    tagInOutlook: boolean | undefined;
    tagName: string | undefined;
    tagColorKey: string | undefined;
    acceptedOverlapRuleKeys: string[] | undefined;
    proposedFeatures: OnboardingCapabilityNoteDto[] | undefined;
}

export class OnboardingClientCandidateDto implements IOnboardingClientCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    kind!: ClientKind | undefined;
    name!: string | undefined;
    email!: string | undefined;
    personKey!: string | undefined;
    typeAct!: ContactTypeAct | undefined;
    typeKey!: string | undefined;
    sourceKey!: string | undefined;
    stageKey!: string | undefined;

    constructor(data?: IOnboardingClientCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.kind = _data["kind"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.personKey = _data["personKey"];
            this.typeAct = _data["typeAct"];
            this.typeKey = _data["typeKey"];
            this.sourceKey = _data["sourceKey"];
            this.stageKey = _data["stageKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingClientCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingClientCandidateDto>(data, _mappings, OnboardingClientCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["kind"] = this.kind;
        data["name"] = this.name;
        data["email"] = this.email;
        data["personKey"] = this.personKey;
        data["typeAct"] = this.typeAct;
        data["typeKey"] = this.typeKey;
        data["sourceKey"] = this.sourceKey;
        data["stageKey"] = this.stageKey;
        return data;
    }
}

export interface IOnboardingClientCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    kind: ClientKind | undefined;
    name: string | undefined;
    email: string | undefined;
    personKey: string | undefined;
    typeAct: ContactTypeAct | undefined;
    typeKey: string | undefined;
    sourceKey: string | undefined;
    stageKey: string | undefined;
}

export enum WorkIdentifierSource {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class OnboardingFieldValueDto implements IOnboardingFieldValueDto {
    fieldKey!: string;
    value!: string | undefined;

    constructor(data?: IOnboardingFieldValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fieldKey = _data["fieldKey"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingFieldValueDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingFieldValueDto>(data, _mappings, OnboardingFieldValueDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldKey"] = this.fieldKey;
        data["value"] = this.value;
        return data;
    }
}

export interface IOnboardingFieldValueDto {
    fieldKey: string;
    value: string | undefined;
}

export class OnboardingWorkItemCandidateDto implements IOnboardingWorkItemCandidateDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    name!: string | undefined;
    clientKey!: string | undefined;
    identifier!: string | undefined;
    identifierSource!: WorkIdentifierSource | undefined;
    templateKey!: string | undefined;
    isOpen!: boolean | undefined;
    fieldValues!: OnboardingFieldValueDto[] | undefined;

    constructor(data?: IOnboardingWorkItemCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.name = _data["name"];
            this.clientKey = _data["clientKey"];
            this.identifier = _data["identifier"];
            this.identifierSource = _data["identifierSource"];
            this.templateKey = _data["templateKey"];
            this.isOpen = _data["isOpen"];
            if (Array.isArray(_data["fieldValues"])) {
                this.fieldValues = [] as any;
                for (let item of _data["fieldValues"])
                    this.fieldValues!.push(OnboardingFieldValueDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingWorkItemCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingWorkItemCandidateDto>(data, _mappings, OnboardingWorkItemCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["name"] = this.name;
        data["clientKey"] = this.clientKey;
        data["identifier"] = this.identifier;
        data["identifierSource"] = this.identifierSource;
        data["templateKey"] = this.templateKey;
        data["isOpen"] = this.isOpen;
        if (Array.isArray(this.fieldValues)) {
            data["fieldValues"] = [];
            for (let item of this.fieldValues)
                data["fieldValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingWorkItemCandidateDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    name: string | undefined;
    clientKey: string | undefined;
    identifier: string | undefined;
    identifierSource: WorkIdentifierSource | undefined;
    templateKey: string | undefined;
    isOpen: boolean | undefined;
    fieldValues: OnboardingFieldValueDto[] | undefined;
}

export enum ProofCandidateKind {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ProofDecisionState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ProofKnowledgeKind {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class ProofKnowledgeItemDto implements IProofKnowledgeItemDto {
    kind!: ProofKnowledgeKind | undefined;
    refKey!: string | undefined;
    fieldKey!: string | undefined;
    value!: string | undefined;

    constructor(data?: IProofKnowledgeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.refKey = _data["refKey"];
            this.fieldKey = _data["fieldKey"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProofKnowledgeItemDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProofKnowledgeItemDto>(data, _mappings, ProofKnowledgeItemDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["refKey"] = this.refKey;
        data["fieldKey"] = this.fieldKey;
        data["value"] = this.value;
        return data;
    }
}

export interface IProofKnowledgeItemDto {
    kind: ProofKnowledgeKind | undefined;
    refKey: string | undefined;
    fieldKey: string | undefined;
    value: string | undefined;
}

export enum ProofActionType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

export class ProofActionDto implements IProofActionDto {
    type!: ProofActionType | undefined;
    supportedNow!: boolean | undefined;
    capabilityKey!: string | undefined;
    targetKey!: string | undefined;
    isTrovveUser!: boolean | undefined;
    taskTitle!: string | undefined;
    taskType!: TaskTypes | undefined;
    dueWeekday!: number | undefined;
    fieldKey!: string | undefined;
    fieldValue!: string | undefined;

    constructor(data?: IProofActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.type = _data["type"];
            this.supportedNow = _data["supportedNow"];
            this.capabilityKey = _data["capabilityKey"];
            this.targetKey = _data["targetKey"];
            this.isTrovveUser = _data["isTrovveUser"];
            this.taskTitle = _data["taskTitle"];
            this.taskType = _data["taskType"];
            this.dueWeekday = _data["dueWeekday"];
            this.fieldKey = _data["fieldKey"];
            this.fieldValue = _data["fieldValue"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProofActionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProofActionDto>(data, _mappings, ProofActionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["supportedNow"] = this.supportedNow;
        data["capabilityKey"] = this.capabilityKey;
        data["targetKey"] = this.targetKey;
        data["isTrovveUser"] = this.isTrovveUser;
        data["taskTitle"] = this.taskTitle;
        data["taskType"] = this.taskType;
        data["dueWeekday"] = this.dueWeekday;
        data["fieldKey"] = this.fieldKey;
        data["fieldValue"] = this.fieldValue;
        return data;
    }
}

export interface IProofActionDto {
    type: ProofActionType | undefined;
    supportedNow: boolean | undefined;
    capabilityKey: string | undefined;
    targetKey: string | undefined;
    isTrovveUser: boolean | undefined;
    taskTitle: string | undefined;
    taskType: TaskTypes | undefined;
    dueWeekday: number | undefined;
    fieldKey: string | undefined;
    fieldValue: string | undefined;
}

export class OnboardingProofRefDto implements IOnboardingProofRefDto {
    candidateId!: string;
    state!: CandidateState | undefined;
    confidence!: ConfidenceBand | undefined;
    evidenceIds!: string[] | undefined;
    kind!: ProofCandidateKind | undefined;
    decision!: ProofDecisionState | undefined;
    graphMessageImmutableId!: string | undefined;
    internetMessageId!: string | undefined;
    conversationId!: string | undefined;
    mailboxUserId!: number | undefined;
    receivedAtUtc!: string | undefined;
    senderKey!: string | undefined;
    clientKey!: string | undefined;
    workItemKey!: string | undefined;
    sourceKey!: string | undefined;
    stageKey!: string | undefined;
    templateKey!: string | undefined;
    knowledge!: ProofKnowledgeItemDto[] | undefined;
    actions!: ProofActionDto[] | undefined;

    constructor(data?: IOnboardingProofRefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.state = _data["state"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["evidenceIds"])) {
                this.evidenceIds = [] as any;
                for (let item of _data["evidenceIds"])
                    this.evidenceIds!.push(item);
            }
            this.kind = _data["kind"];
            this.decision = _data["decision"];
            this.graphMessageImmutableId = _data["graphMessageImmutableId"];
            this.internetMessageId = _data["internetMessageId"];
            this.conversationId = _data["conversationId"];
            this.mailboxUserId = _data["mailboxUserId"];
            this.receivedAtUtc = _data["receivedAtUtc"];
            this.senderKey = _data["senderKey"];
            this.clientKey = _data["clientKey"];
            this.workItemKey = _data["workItemKey"];
            this.sourceKey = _data["sourceKey"];
            this.stageKey = _data["stageKey"];
            this.templateKey = _data["templateKey"];
            if (Array.isArray(_data["knowledge"])) {
                this.knowledge = [] as any;
                for (let item of _data["knowledge"])
                    this.knowledge!.push(ProofKnowledgeItemDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(ProofActionDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingProofRefDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingProofRefDto>(data, _mappings, OnboardingProofRefDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["state"] = this.state;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.evidenceIds)) {
            data["evidenceIds"] = [];
            for (let item of this.evidenceIds)
                data["evidenceIds"].push(item);
        }
        data["kind"] = this.kind;
        data["decision"] = this.decision;
        data["graphMessageImmutableId"] = this.graphMessageImmutableId;
        data["internetMessageId"] = this.internetMessageId;
        data["conversationId"] = this.conversationId;
        data["mailboxUserId"] = this.mailboxUserId;
        data["receivedAtUtc"] = this.receivedAtUtc;
        data["senderKey"] = this.senderKey;
        data["clientKey"] = this.clientKey;
        data["workItemKey"] = this.workItemKey;
        data["sourceKey"] = this.sourceKey;
        data["stageKey"] = this.stageKey;
        data["templateKey"] = this.templateKey;
        if (Array.isArray(this.knowledge)) {
            data["knowledge"] = [];
            for (let item of this.knowledge)
                data["knowledge"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingProofRefDto {
    candidateId: string;
    state: CandidateState | undefined;
    confidence: ConfidenceBand | undefined;
    evidenceIds: string[] | undefined;
    kind: ProofCandidateKind | undefined;
    decision: ProofDecisionState | undefined;
    graphMessageImmutableId: string | undefined;
    internetMessageId: string | undefined;
    conversationId: string | undefined;
    mailboxUserId: number | undefined;
    receivedAtUtc: string | undefined;
    senderKey: string | undefined;
    clientKey: string | undefined;
    workItemKey: string | undefined;
    sourceKey: string | undefined;
    stageKey: string | undefined;
    templateKey: string | undefined;
    knowledge: ProofKnowledgeItemDto[] | undefined;
    actions: ProofActionDto[] | undefined;
}

export class ConfigurationPlanDto implements IConfigurationPlanDto {
    schemaVersion!: number | undefined;
    firm!: OnboardingFirmCandidateDto | undefined;
    terminology!: OnboardingTerminologyCandidateDto | undefined;
    workModel!: OnboardingWorkModelCandidateDto | undefined;
    clientTypes!: OnboardingClientTypeCandidateDto[] | undefined;
    sources!: OnboardingSourceCandidateDto[] | undefined;
    leadStages!: OnboardingLeadStageCandidateDto[] | undefined;
    workStages!: OnboardingWorkStageCandidateDto[] | undefined;
    fieldSections!: OnboardingFieldSectionCandidateDto[] | undefined;
    fields!: OnboardingFieldCandidateDto[] | undefined;
    listColumns!: OnboardingListColumnCandidateDto[] | undefined;
    people!: OnboardingPersonCandidateDto[] | undefined;
    roles!: OnboardingRoleCandidateDto[] | undefined;
    template!: OnboardingTemplateCandidateDto | undefined;
    templateEvidenceIsWeak!: boolean | undefined;
    alsoFoundTemplates!: OnboardingTemplateHintDto[] | undefined;
    emailAutomations!: OnboardingEmailRuleCandidateDto[] | undefined;
    clients!: OnboardingClientCandidateDto[] | undefined;
    workItems!: OnboardingWorkItemCandidateDto[] | undefined;
    proofs!: OnboardingProofRefDto[] | undefined;
    confirmedSteps!: OnboardingStep[] | undefined;

    constructor(data?: IConfigurationPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.schemaVersion = _data["schemaVersion"];
            this.firm = _data["firm"] ? OnboardingFirmCandidateDto.fromJS(_data["firm"], _mappings) : undefined as any;
            this.terminology = _data["terminology"] ? OnboardingTerminologyCandidateDto.fromJS(_data["terminology"], _mappings) : undefined as any;
            this.workModel = _data["workModel"] ? OnboardingWorkModelCandidateDto.fromJS(_data["workModel"], _mappings) : undefined as any;
            if (Array.isArray(_data["clientTypes"])) {
                this.clientTypes = [] as any;
                for (let item of _data["clientTypes"])
                    this.clientTypes!.push(OnboardingClientTypeCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(OnboardingSourceCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["leadStages"])) {
                this.leadStages = [] as any;
                for (let item of _data["leadStages"])
                    this.leadStages!.push(OnboardingLeadStageCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["workStages"])) {
                this.workStages = [] as any;
                for (let item of _data["workStages"])
                    this.workStages!.push(OnboardingWorkStageCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["fieldSections"])) {
                this.fieldSections = [] as any;
                for (let item of _data["fieldSections"])
                    this.fieldSections!.push(OnboardingFieldSectionCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(OnboardingFieldCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listColumns"])) {
                this.listColumns = [] as any;
                for (let item of _data["listColumns"])
                    this.listColumns!.push(OnboardingListColumnCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["people"])) {
                this.people = [] as any;
                for (let item of _data["people"])
                    this.people!.push(OnboardingPersonCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(OnboardingRoleCandidateDto.fromJS(item, _mappings));
            }
            this.template = _data["template"] ? OnboardingTemplateCandidateDto.fromJS(_data["template"], _mappings) : undefined as any;
            this.templateEvidenceIsWeak = _data["templateEvidenceIsWeak"];
            if (Array.isArray(_data["alsoFoundTemplates"])) {
                this.alsoFoundTemplates = [] as any;
                for (let item of _data["alsoFoundTemplates"])
                    this.alsoFoundTemplates!.push(OnboardingTemplateHintDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["emailAutomations"])) {
                this.emailAutomations = [] as any;
                for (let item of _data["emailAutomations"])
                    this.emailAutomations!.push(OnboardingEmailRuleCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(OnboardingClientCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["workItems"])) {
                this.workItems = [] as any;
                for (let item of _data["workItems"])
                    this.workItems!.push(OnboardingWorkItemCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["proofs"])) {
                this.proofs = [] as any;
                for (let item of _data["proofs"])
                    this.proofs!.push(OnboardingProofRefDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["confirmedSteps"])) {
                this.confirmedSteps = [] as any;
                for (let item of _data["confirmedSteps"])
                    this.confirmedSteps!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ConfigurationPlanDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfigurationPlanDto>(data, _mappings, ConfigurationPlanDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schemaVersion"] = this.schemaVersion;
        data["firm"] = this.firm ? this.firm.toJSON() : undefined as any;
        data["terminology"] = this.terminology ? this.terminology.toJSON() : undefined as any;
        data["workModel"] = this.workModel ? this.workModel.toJSON() : undefined as any;
        if (Array.isArray(this.clientTypes)) {
            data["clientTypes"] = [];
            for (let item of this.clientTypes)
                data["clientTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.leadStages)) {
            data["leadStages"] = [];
            for (let item of this.leadStages)
                data["leadStages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workStages)) {
            data["workStages"] = [];
            for (let item of this.workStages)
                data["workStages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.fieldSections)) {
            data["fieldSections"] = [];
            for (let item of this.fieldSections)
                data["fieldSections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listColumns)) {
            data["listColumns"] = [];
            for (let item of this.listColumns)
                data["listColumns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.people)) {
            data["people"] = [];
            for (let item of this.people)
                data["people"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        data["templateEvidenceIsWeak"] = this.templateEvidenceIsWeak;
        if (Array.isArray(this.alsoFoundTemplates)) {
            data["alsoFoundTemplates"] = [];
            for (let item of this.alsoFoundTemplates)
                data["alsoFoundTemplates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.emailAutomations)) {
            data["emailAutomations"] = [];
            for (let item of this.emailAutomations)
                data["emailAutomations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workItems)) {
            data["workItems"] = [];
            for (let item of this.workItems)
                data["workItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proofs)) {
            data["proofs"] = [];
            for (let item of this.proofs)
                data["proofs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.confirmedSteps)) {
            data["confirmedSteps"] = [];
            for (let item of this.confirmedSteps)
                data["confirmedSteps"].push(item);
        }
        return data;
    }
}

export interface IConfigurationPlanDto {
    schemaVersion: number | undefined;
    firm: OnboardingFirmCandidateDto | undefined;
    terminology: OnboardingTerminologyCandidateDto | undefined;
    workModel: OnboardingWorkModelCandidateDto | undefined;
    clientTypes: OnboardingClientTypeCandidateDto[] | undefined;
    sources: OnboardingSourceCandidateDto[] | undefined;
    leadStages: OnboardingLeadStageCandidateDto[] | undefined;
    workStages: OnboardingWorkStageCandidateDto[] | undefined;
    fieldSections: OnboardingFieldSectionCandidateDto[] | undefined;
    fields: OnboardingFieldCandidateDto[] | undefined;
    listColumns: OnboardingListColumnCandidateDto[] | undefined;
    people: OnboardingPersonCandidateDto[] | undefined;
    roles: OnboardingRoleCandidateDto[] | undefined;
    template: OnboardingTemplateCandidateDto | undefined;
    templateEvidenceIsWeak: boolean | undefined;
    alsoFoundTemplates: OnboardingTemplateHintDto[] | undefined;
    emailAutomations: OnboardingEmailRuleCandidateDto[] | undefined;
    clients: OnboardingClientCandidateDto[] | undefined;
    workItems: OnboardingWorkItemCandidateDto[] | undefined;
    proofs: OnboardingProofRefDto[] | undefined;
    confirmedSteps: OnboardingStep[] | undefined;
}

export class ProofCandidateDto implements IProofCandidateDto {
    proofKey!: string;
    kind!: ProofCandidateKind | undefined;
    graphMessageImmutableId!: string | undefined;
    internetMessageId!: string | undefined;
    conversationId!: string | undefined;
    mailboxUserId!: number | undefined;
    receivedAtUtc!: string | undefined;
    senderKey!: string | undefined;
    senderName!: string | undefined;
    senderEmail!: string | undefined;
    excerpt!: string | undefined;

    constructor(data?: IProofCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.proofKey = _data["proofKey"];
            this.kind = _data["kind"];
            this.graphMessageImmutableId = _data["graphMessageImmutableId"];
            this.internetMessageId = _data["internetMessageId"];
            this.conversationId = _data["conversationId"];
            this.mailboxUserId = _data["mailboxUserId"];
            this.receivedAtUtc = _data["receivedAtUtc"];
            this.senderKey = _data["senderKey"];
            this.senderName = _data["senderName"];
            this.senderEmail = _data["senderEmail"];
            this.excerpt = _data["excerpt"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProofCandidateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProofCandidateDto>(data, _mappings, ProofCandidateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proofKey"] = this.proofKey;
        data["kind"] = this.kind;
        data["graphMessageImmutableId"] = this.graphMessageImmutableId;
        data["internetMessageId"] = this.internetMessageId;
        data["conversationId"] = this.conversationId;
        data["mailboxUserId"] = this.mailboxUserId;
        data["receivedAtUtc"] = this.receivedAtUtc;
        data["senderKey"] = this.senderKey;
        data["senderName"] = this.senderName;
        data["senderEmail"] = this.senderEmail;
        data["excerpt"] = this.excerpt;
        return data;
    }
}

export interface IProofCandidateDto {
    proofKey: string;
    kind: ProofCandidateKind | undefined;
    graphMessageImmutableId: string | undefined;
    internetMessageId: string | undefined;
    conversationId: string | undefined;
    mailboxUserId: number | undefined;
    receivedAtUtc: string | undefined;
    senderKey: string | undefined;
    senderName: string | undefined;
    senderEmail: string | undefined;
    excerpt: string | undefined;
}

export enum EmailRuleExampleOutcome {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class OnboardingRuleExampleDto implements IOnboardingRuleExampleDto {
    text!: string;
    outcome!: EmailRuleExampleOutcome | undefined;

    constructor(data?: IOnboardingRuleExampleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.text = _data["text"];
            this.outcome = _data["outcome"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingRuleExampleDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingRuleExampleDto>(data, _mappings, OnboardingRuleExampleDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["outcome"] = this.outcome;
        return data;
    }
}

export interface IOnboardingRuleExampleDto {
    text: string;
    outcome: EmailRuleExampleOutcome | undefined;
}

export class OnboardingRuleExampleSetDto implements IOnboardingRuleExampleSetDto {
    ruleKey!: string;
    examples!: OnboardingRuleExampleDto[] | undefined;

    constructor(data?: IOnboardingRuleExampleSetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.ruleKey = _data["ruleKey"];
            if (Array.isArray(_data["examples"])) {
                this.examples = [] as any;
                for (let item of _data["examples"])
                    this.examples!.push(OnboardingRuleExampleDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingRuleExampleSetDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingRuleExampleSetDto>(data, _mappings, OnboardingRuleExampleSetDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleKey"] = this.ruleKey;
        if (Array.isArray(this.examples)) {
            data["examples"] = [];
            for (let item of this.examples)
                data["examples"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingRuleExampleSetDto {
    ruleKey: string;
    examples: OnboardingRuleExampleDto[] | undefined;
}

export class OnboardingSessionDto implements IOnboardingSessionDto {
    sessionId!: number | undefined;
    status!: OnboardingStatus | undefined;
    chapter!: OnboardingChapter | undefined;
    currentStep!: OnboardingStep | undefined;
    completedSteps!: OnboardingStep[] | undefined;
    planRevision!: number | undefined;
    scanState!: OnboardingScanState | undefined;
    scanFailureCode!: string | undefined;
    consentState!: OnboardingConsentState | undefined;
    organizationName!: string | undefined;
    organizationDomain!: string | undefined;
    isFixture!: boolean | undefined;
    isReplay!: boolean | undefined;
    terminology!: OnboardingTerminologyCandidateDto | undefined;
    workspaceUsers!: OnboardingWorkspaceUserDto[] | undefined;
    plan!: ConfigurationPlanDto | undefined;
    proofs!: ProofCandidateDto[] | undefined;
    ruleExamples!: OnboardingRuleExampleSetDto[] | undefined;
    startedAtUtc!: string | undefined;
    completedAtUtc!: string | undefined;

    constructor(data?: IOnboardingSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.status = _data["status"];
            this.chapter = _data["chapter"];
            this.currentStep = _data["currentStep"];
            if (Array.isArray(_data["completedSteps"])) {
                this.completedSteps = [] as any;
                for (let item of _data["completedSteps"])
                    this.completedSteps!.push(item);
            }
            this.planRevision = _data["planRevision"];
            this.scanState = _data["scanState"];
            this.scanFailureCode = _data["scanFailureCode"];
            this.consentState = _data["consentState"];
            this.organizationName = _data["organizationName"];
            this.organizationDomain = _data["organizationDomain"];
            this.isFixture = _data["isFixture"];
            this.isReplay = _data["isReplay"];
            this.terminology = _data["terminology"] ? OnboardingTerminologyCandidateDto.fromJS(_data["terminology"], _mappings) : undefined as any;
            if (Array.isArray(_data["workspaceUsers"])) {
                this.workspaceUsers = [] as any;
                for (let item of _data["workspaceUsers"])
                    this.workspaceUsers!.push(OnboardingWorkspaceUserDto.fromJS(item, _mappings));
            }
            this.plan = _data["plan"] ? ConfigurationPlanDto.fromJS(_data["plan"], _mappings) : undefined as any;
            if (Array.isArray(_data["proofs"])) {
                this.proofs = [] as any;
                for (let item of _data["proofs"])
                    this.proofs!.push(ProofCandidateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["ruleExamples"])) {
                this.ruleExamples = [] as any;
                for (let item of _data["ruleExamples"])
                    this.ruleExamples!.push(OnboardingRuleExampleSetDto.fromJS(item, _mappings));
            }
            this.startedAtUtc = _data["startedAtUtc"];
            this.completedAtUtc = _data["completedAtUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingSessionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingSessionDto>(data, _mappings, OnboardingSessionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["status"] = this.status;
        data["chapter"] = this.chapter;
        data["currentStep"] = this.currentStep;
        if (Array.isArray(this.completedSteps)) {
            data["completedSteps"] = [];
            for (let item of this.completedSteps)
                data["completedSteps"].push(item);
        }
        data["planRevision"] = this.planRevision;
        data["scanState"] = this.scanState;
        data["scanFailureCode"] = this.scanFailureCode;
        data["consentState"] = this.consentState;
        data["organizationName"] = this.organizationName;
        data["organizationDomain"] = this.organizationDomain;
        data["isFixture"] = this.isFixture;
        data["isReplay"] = this.isReplay;
        data["terminology"] = this.terminology ? this.terminology.toJSON() : undefined as any;
        if (Array.isArray(this.workspaceUsers)) {
            data["workspaceUsers"] = [];
            for (let item of this.workspaceUsers)
                data["workspaceUsers"].push(item ? item.toJSON() : undefined as any);
        }
        data["plan"] = this.plan ? this.plan.toJSON() : undefined as any;
        if (Array.isArray(this.proofs)) {
            data["proofs"] = [];
            for (let item of this.proofs)
                data["proofs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ruleExamples)) {
            data["ruleExamples"] = [];
            for (let item of this.ruleExamples)
                data["ruleExamples"].push(item ? item.toJSON() : undefined as any);
        }
        data["startedAtUtc"] = this.startedAtUtc;
        data["completedAtUtc"] = this.completedAtUtc;
        return data;
    }
}

export interface IOnboardingSessionDto {
    sessionId: number | undefined;
    status: OnboardingStatus | undefined;
    chapter: OnboardingChapter | undefined;
    currentStep: OnboardingStep | undefined;
    completedSteps: OnboardingStep[] | undefined;
    planRevision: number | undefined;
    scanState: OnboardingScanState | undefined;
    scanFailureCode: string | undefined;
    consentState: OnboardingConsentState | undefined;
    organizationName: string | undefined;
    organizationDomain: string | undefined;
    isFixture: boolean | undefined;
    isReplay: boolean | undefined;
    terminology: OnboardingTerminologyCandidateDto | undefined;
    workspaceUsers: OnboardingWorkspaceUserDto[] | undefined;
    plan: ConfigurationPlanDto | undefined;
    proofs: ProofCandidateDto[] | undefined;
    ruleExamples: OnboardingRuleExampleSetDto[] | undefined;
    startedAtUtc: string | undefined;
    completedAtUtc: string | undefined;
}

export enum ChapterDecisionAction {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class OnboardingFirmDecisionDto implements IOnboardingFirmDecisionDto {
    firmType!: string | undefined;
    primaryWork!: string | undefined;
    firmCategory!: FirmCategory | undefined;
    terminologySingular!: string | undefined;
    terminologyPlural!: string | undefined;
    terminologyPresetKey!: string | undefined;

    constructor(data?: IOnboardingFirmDecisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.firmType = _data["firmType"];
            this.primaryWork = _data["primaryWork"];
            this.firmCategory = _data["firmCategory"];
            this.terminologySingular = _data["terminologySingular"];
            this.terminologyPlural = _data["terminologyPlural"];
            this.terminologyPresetKey = _data["terminologyPresetKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingFirmDecisionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingFirmDecisionDto>(data, _mappings, OnboardingFirmDecisionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firmType"] = this.firmType;
        data["primaryWork"] = this.primaryWork;
        data["firmCategory"] = this.firmCategory;
        data["terminologySingular"] = this.terminologySingular;
        data["terminologyPlural"] = this.terminologyPlural;
        data["terminologyPresetKey"] = this.terminologyPresetKey;
        return data;
    }
}

export interface IOnboardingFirmDecisionDto {
    firmType: string | undefined;
    primaryWork: string | undefined;
    firmCategory: FirmCategory | undefined;
    terminologySingular: string | undefined;
    terminologyPlural: string | undefined;
    terminologyPresetKey: string | undefined;
}

export class OnboardingListItemEditDto implements IOnboardingListItemEditDto {
    key!: string;
    name!: string | undefined;

    constructor(data?: IOnboardingListItemEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingListItemEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingListItemEditDto>(data, _mappings, OnboardingListItemEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        return data;
    }
}

export interface IOnboardingListItemEditDto {
    key: string;
    name: string | undefined;
}

export class OnboardingSourcesDecisionDto implements IOnboardingSourcesDecisionDto {
    sources!: OnboardingListItemEditDto[] | undefined;

    constructor(data?: IOnboardingSourcesDecisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(OnboardingListItemEditDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingSourcesDecisionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingSourcesDecisionDto>(data, _mappings, OnboardingSourcesDecisionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingSourcesDecisionDto {
    sources: OnboardingListItemEditDto[] | undefined;
}

export class OnboardingClientTypeEditDto implements IOnboardingClientTypeEditDto {
    key!: string;
    name!: string | undefined;
    act!: ContactTypeAct | undefined;

    constructor(data?: IOnboardingClientTypeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
            this.act = _data["act"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingClientTypeEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingClientTypeEditDto>(data, _mappings, OnboardingClientTypeEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        data["act"] = this.act;
        return data;
    }
}

export interface IOnboardingClientTypeEditDto {
    key: string;
    name: string | undefined;
    act: ContactTypeAct | undefined;
}

export class OnboardingClientTypesDecisionDto implements IOnboardingClientTypesDecisionDto {
    types!: OnboardingClientTypeEditDto[] | undefined;

    constructor(data?: IOnboardingClientTypesDecisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(OnboardingClientTypeEditDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingClientTypesDecisionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingClientTypesDecisionDto>(data, _mappings, OnboardingClientTypesDecisionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingClientTypesDecisionDto {
    types: OnboardingClientTypeEditDto[] | undefined;
}

export class OnboardingPipelineDecisionDto implements IOnboardingPipelineDecisionDto {
    stages!: OnboardingListItemEditDto[] | undefined;

    constructor(data?: IOnboardingPipelineDecisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(OnboardingListItemEditDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingPipelineDecisionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingPipelineDecisionDto>(data, _mappings, OnboardingPipelineDecisionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingPipelineDecisionDto {
    stages: OnboardingListItemEditDto[] | undefined;
}

export class OnboardingFieldEditDto implements IOnboardingFieldEditDto {
    key!: string;
    label!: string | undefined;
    removed!: boolean | undefined;

    constructor(data?: IOnboardingFieldEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.removed = _data["removed"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingFieldEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingFieldEditDto>(data, _mappings, OnboardingFieldEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["removed"] = this.removed;
        return data;
    }
}

export interface IOnboardingFieldEditDto {
    key: string;
    label: string | undefined;
    removed: boolean | undefined;
}

export class OnboardingWorkStructureDecisionDto implements IOnboardingWorkStructureDecisionDto {
    fields!: OnboardingFieldEditDto[] | undefined;

    constructor(data?: IOnboardingWorkStructureDecisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(OnboardingFieldEditDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingWorkStructureDecisionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingWorkStructureDecisionDto>(data, _mappings, OnboardingWorkStructureDecisionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingWorkStructureDecisionDto {
    fields: OnboardingFieldEditDto[] | undefined;
}

export class OnboardingWorkStageEditDto implements IOnboardingWorkStageEditDto {
    key!: string;
    name!: string | undefined;
    isOpen!: boolean | undefined;

    constructor(data?: IOnboardingWorkStageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
            this.isOpen = _data["isOpen"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingWorkStageEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingWorkStageEditDto>(data, _mappings, OnboardingWorkStageEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        data["isOpen"] = this.isOpen;
        return data;
    }
}

export interface IOnboardingWorkStageEditDto {
    key: string;
    name: string | undefined;
    isOpen: boolean | undefined;
}

export class OnboardingWorkStagesDecisionDto implements IOnboardingWorkStagesDecisionDto {
    stages!: OnboardingWorkStageEditDto[] | undefined;

    constructor(data?: IOnboardingWorkStagesDecisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(OnboardingWorkStageEditDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingWorkStagesDecisionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingWorkStagesDecisionDto>(data, _mappings, OnboardingWorkStagesDecisionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingWorkStagesDecisionDto {
    stages: OnboardingWorkStageEditDto[] | undefined;
}

export class OnboardingRoleEditDto implements IOnboardingRoleEditDto {
    key!: string;
    name!: string | undefined;
    assignees!: OnboardingRoleAssigneeDto[] | undefined;

    constructor(data?: IOnboardingRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
            if (Array.isArray(_data["assignees"])) {
                this.assignees = [] as any;
                for (let item of _data["assignees"])
                    this.assignees!.push(OnboardingRoleAssigneeDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingRoleEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingRoleEditDto>(data, _mappings, OnboardingRoleEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        if (Array.isArray(this.assignees)) {
            data["assignees"] = [];
            for (let item of this.assignees)
                data["assignees"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingRoleEditDto {
    key: string;
    name: string | undefined;
    assignees: OnboardingRoleAssigneeDto[] | undefined;
}

export class OnboardingRolesDecisionDto implements IOnboardingRolesDecisionDto {
    roles!: OnboardingRoleEditDto[] | undefined;

    constructor(data?: IOnboardingRolesDecisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(OnboardingRoleEditDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingRolesDecisionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingRolesDecisionDto>(data, _mappings, OnboardingRolesDecisionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingRolesDecisionDto {
    roles: OnboardingRoleEditDto[] | undefined;
}

export class OnboardingTemplateDecisionDto implements IOnboardingTemplateDecisionDto {
    name!: string | undefined;
    sections!: OnboardingTemplateSectionDto[] | undefined;
    tasks!: OnboardingTemplateTaskDto[] | undefined;
    folders!: TemplateFolderDto[] | undefined;

    constructor(data?: IOnboardingTemplateDecisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(OnboardingTemplateSectionDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(OnboardingTemplateTaskDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["folders"])) {
                this.folders = [] as any;
                for (let item of _data["folders"])
                    this.folders!.push(TemplateFolderDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingTemplateDecisionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingTemplateDecisionDto>(data, _mappings, OnboardingTemplateDecisionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.folders)) {
            data["folders"] = [];
            for (let item of this.folders)
                data["folders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnboardingTemplateDecisionDto {
    name: string | undefined;
    sections: OnboardingTemplateSectionDto[] | undefined;
    tasks: OnboardingTemplateTaskDto[] | undefined;
    folders: TemplateFolderDto[] | undefined;
}

export class OnboardingEmailRuleDecisionDto implements IOnboardingEmailRuleDecisionDto {
    name!: string | undefined;
    description!: string | undefined;
    userWrittenText!: string | undefined;
    audience!: EmailAutomationAudience | undefined;
    inboxTokens!: string[] | undefined;
    handlerStrategy!: EmailAutomationHandler | undefined;
    handlerPersonKey!: string | undefined;
    handlerUserId!: number | undefined;
    handlerRoleKey!: string | undefined;
    notifyUserIds!: number[] | undefined;
    addSenderAsClient!: boolean | undefined;
    senderTypeAct!: ContactTypeAct | undefined;
    senderTypeKey!: string | undefined;
    senderStageKey!: string | undefined;
    createTaskMode!: EmailAutomationCreateTaskMode | undefined;
    projectMatchMode!: EmailAutomationProjectMatchMode | undefined;
    sectionMode!: EmailAutomationSectionMode | undefined;
    saveEmail!: boolean | undefined;
    saveAttachments!: boolean | undefined;
    saveIntoMode!: EmailAutomationSaveIntoMode | undefined;
    movedToProjectMode!: EmailAutomationMovedToProjectMode | undefined;
    tagInOutlook!: boolean | undefined;
    tagName!: string | undefined;
    tagColorKey!: string | undefined;

    constructor(data?: IOnboardingEmailRuleDecisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.userWrittenText = _data["userWrittenText"];
            this.audience = _data["audience"];
            if (Array.isArray(_data["inboxTokens"])) {
                this.inboxTokens = [] as any;
                for (let item of _data["inboxTokens"])
                    this.inboxTokens!.push(item);
            }
            this.handlerStrategy = _data["handlerStrategy"];
            this.handlerPersonKey = _data["handlerPersonKey"];
            this.handlerUserId = _data["handlerUserId"];
            this.handlerRoleKey = _data["handlerRoleKey"];
            if (Array.isArray(_data["notifyUserIds"])) {
                this.notifyUserIds = [] as any;
                for (let item of _data["notifyUserIds"])
                    this.notifyUserIds!.push(item);
            }
            this.addSenderAsClient = _data["addSenderAsClient"];
            this.senderTypeAct = _data["senderTypeAct"];
            this.senderTypeKey = _data["senderTypeKey"];
            this.senderStageKey = _data["senderStageKey"];
            this.createTaskMode = _data["createTaskMode"];
            this.projectMatchMode = _data["projectMatchMode"];
            this.sectionMode = _data["sectionMode"];
            this.saveEmail = _data["saveEmail"];
            this.saveAttachments = _data["saveAttachments"];
            this.saveIntoMode = _data["saveIntoMode"];
            this.movedToProjectMode = _data["movedToProjectMode"];
            this.tagInOutlook = _data["tagInOutlook"];
            this.tagName = _data["tagName"];
            this.tagColorKey = _data["tagColorKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingEmailRuleDecisionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingEmailRuleDecisionDto>(data, _mappings, OnboardingEmailRuleDecisionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["userWrittenText"] = this.userWrittenText;
        data["audience"] = this.audience;
        if (Array.isArray(this.inboxTokens)) {
            data["inboxTokens"] = [];
            for (let item of this.inboxTokens)
                data["inboxTokens"].push(item);
        }
        data["handlerStrategy"] = this.handlerStrategy;
        data["handlerPersonKey"] = this.handlerPersonKey;
        data["handlerUserId"] = this.handlerUserId;
        data["handlerRoleKey"] = this.handlerRoleKey;
        if (Array.isArray(this.notifyUserIds)) {
            data["notifyUserIds"] = [];
            for (let item of this.notifyUserIds)
                data["notifyUserIds"].push(item);
        }
        data["addSenderAsClient"] = this.addSenderAsClient;
        data["senderTypeAct"] = this.senderTypeAct;
        data["senderTypeKey"] = this.senderTypeKey;
        data["senderStageKey"] = this.senderStageKey;
        data["createTaskMode"] = this.createTaskMode;
        data["projectMatchMode"] = this.projectMatchMode;
        data["sectionMode"] = this.sectionMode;
        data["saveEmail"] = this.saveEmail;
        data["saveAttachments"] = this.saveAttachments;
        data["saveIntoMode"] = this.saveIntoMode;
        data["movedToProjectMode"] = this.movedToProjectMode;
        data["tagInOutlook"] = this.tagInOutlook;
        data["tagName"] = this.tagName;
        data["tagColorKey"] = this.tagColorKey;
        return data;
    }
}

export interface IOnboardingEmailRuleDecisionDto {
    name: string | undefined;
    description: string | undefined;
    userWrittenText: string | undefined;
    audience: EmailAutomationAudience | undefined;
    inboxTokens: string[] | undefined;
    handlerStrategy: EmailAutomationHandler | undefined;
    handlerPersonKey: string | undefined;
    handlerUserId: number | undefined;
    handlerRoleKey: string | undefined;
    notifyUserIds: number[] | undefined;
    addSenderAsClient: boolean | undefined;
    senderTypeAct: ContactTypeAct | undefined;
    senderTypeKey: string | undefined;
    senderStageKey: string | undefined;
    createTaskMode: EmailAutomationCreateTaskMode | undefined;
    projectMatchMode: EmailAutomationProjectMatchMode | undefined;
    sectionMode: EmailAutomationSectionMode | undefined;
    saveEmail: boolean | undefined;
    saveAttachments: boolean | undefined;
    saveIntoMode: EmailAutomationSaveIntoMode | undefined;
    movedToProjectMode: EmailAutomationMovedToProjectMode | undefined;
    tagInOutlook: boolean | undefined;
    tagName: string | undefined;
    tagColorKey: string | undefined;
}

export class ChapterDecisionInput implements IChapterDecisionInput {
    step!: OnboardingStep | undefined;
    action!: ChapterDecisionAction | undefined;
    targetKey!: string | undefined;
    expectedPlanRevision!: number | undefined;
    firm!: OnboardingFirmDecisionDto | undefined;
    sources!: OnboardingSourcesDecisionDto | undefined;
    clientTypes!: OnboardingClientTypesDecisionDto | undefined;
    pipeline!: OnboardingPipelineDecisionDto | undefined;
    workStructure!: OnboardingWorkStructureDecisionDto | undefined;
    workStages!: OnboardingWorkStagesDecisionDto | undefined;
    roles!: OnboardingRolesDecisionDto | undefined;
    template!: OnboardingTemplateDecisionDto | undefined;
    emailRule!: OnboardingEmailRuleDecisionDto | undefined;

    constructor(data?: IChapterDecisionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.step = _data["step"];
            this.action = _data["action"];
            this.targetKey = _data["targetKey"];
            this.expectedPlanRevision = _data["expectedPlanRevision"];
            this.firm = _data["firm"] ? OnboardingFirmDecisionDto.fromJS(_data["firm"], _mappings) : undefined as any;
            this.sources = _data["sources"] ? OnboardingSourcesDecisionDto.fromJS(_data["sources"], _mappings) : undefined as any;
            this.clientTypes = _data["clientTypes"] ? OnboardingClientTypesDecisionDto.fromJS(_data["clientTypes"], _mappings) : undefined as any;
            this.pipeline = _data["pipeline"] ? OnboardingPipelineDecisionDto.fromJS(_data["pipeline"], _mappings) : undefined as any;
            this.workStructure = _data["workStructure"] ? OnboardingWorkStructureDecisionDto.fromJS(_data["workStructure"], _mappings) : undefined as any;
            this.workStages = _data["workStages"] ? OnboardingWorkStagesDecisionDto.fromJS(_data["workStages"], _mappings) : undefined as any;
            this.roles = _data["roles"] ? OnboardingRolesDecisionDto.fromJS(_data["roles"], _mappings) : undefined as any;
            this.template = _data["template"] ? OnboardingTemplateDecisionDto.fromJS(_data["template"], _mappings) : undefined as any;
            this.emailRule = _data["emailRule"] ? OnboardingEmailRuleDecisionDto.fromJS(_data["emailRule"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): ChapterDecisionInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChapterDecisionInput>(data, _mappings, ChapterDecisionInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["action"] = this.action;
        data["targetKey"] = this.targetKey;
        data["expectedPlanRevision"] = this.expectedPlanRevision;
        data["firm"] = this.firm ? this.firm.toJSON() : undefined as any;
        data["sources"] = this.sources ? this.sources.toJSON() : undefined as any;
        data["clientTypes"] = this.clientTypes ? this.clientTypes.toJSON() : undefined as any;
        data["pipeline"] = this.pipeline ? this.pipeline.toJSON() : undefined as any;
        data["workStructure"] = this.workStructure ? this.workStructure.toJSON() : undefined as any;
        data["workStages"] = this.workStages ? this.workStages.toJSON() : undefined as any;
        data["roles"] = this.roles ? this.roles.toJSON() : undefined as any;
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        data["emailRule"] = this.emailRule ? this.emailRule.toJSON() : undefined as any;
        return data;
    }
}

export interface IChapterDecisionInput {
    step: OnboardingStep | undefined;
    action: ChapterDecisionAction | undefined;
    targetKey: string | undefined;
    expectedPlanRevision: number | undefined;
    firm: OnboardingFirmDecisionDto | undefined;
    sources: OnboardingSourcesDecisionDto | undefined;
    clientTypes: OnboardingClientTypesDecisionDto | undefined;
    pipeline: OnboardingPipelineDecisionDto | undefined;
    workStructure: OnboardingWorkStructureDecisionDto | undefined;
    workStages: OnboardingWorkStagesDecisionDto | undefined;
    roles: OnboardingRolesDecisionDto | undefined;
    template: OnboardingTemplateDecisionDto | undefined;
    emailRule: OnboardingEmailRuleDecisionDto | undefined;
}

export enum OnboardingFallbackReason {
    _1 = 1,
    _2 = 2,
}

export class OnboardingFallbackInput implements IOnboardingFallbackInput {
    reason!: OnboardingFallbackReason | undefined;

    constructor(data?: IOnboardingFallbackInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingFallbackInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingFallbackInput>(data, _mappings, OnboardingFallbackInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        return data;
    }
}

export interface IOnboardingFallbackInput {
    reason: OnboardingFallbackReason | undefined;
}

export class OrganizeOnboardingInput implements IOrganizeOnboardingInput {
    expectedPlanRevision!: number | undefined;

    constructor(data?: IOrganizeOnboardingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.expectedPlanRevision = _data["expectedPlanRevision"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrganizeOnboardingInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrganizeOnboardingInput>(data, _mappings, OrganizeOnboardingInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectedPlanRevision"] = this.expectedPlanRevision;
        return data;
    }
}

export interface IOrganizeOnboardingInput {
    expectedPlanRevision: number | undefined;
}

export enum OnboardingApplyUnitState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class OnboardingApplyUnitDto implements IOnboardingApplyUnitDto {
    unitKey!: string | undefined;
    order!: number | undefined;
    state!: OnboardingApplyUnitState | undefined;
    errorCode!: string | undefined;

    constructor(data?: IOnboardingApplyUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.unitKey = _data["unitKey"];
            this.order = _data["order"];
            this.state = _data["state"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingApplyUnitDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingApplyUnitDto>(data, _mappings, OnboardingApplyUnitDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitKey"] = this.unitKey;
        data["order"] = this.order;
        data["state"] = this.state;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IOnboardingApplyUnitDto {
    unitKey: string | undefined;
    order: number | undefined;
    state: OnboardingApplyUnitState | undefined;
    errorCode: string | undefined;
}

export class OnboardingApplyProgressDto implements IOnboardingApplyProgressDto {
    sessionId!: number | undefined;
    status!: OnboardingStatus | undefined;
    isRunning!: boolean | undefined;
    units!: OnboardingApplyUnitDto[] | undefined;
    createdTaskIds!: number[] | undefined;
    createdProjectIds!: number[] | undefined;
    asOfUtc!: string | undefined;

    constructor(data?: IOnboardingApplyProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.status = _data["status"];
            this.isRunning = _data["isRunning"];
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(OnboardingApplyUnitDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["createdTaskIds"])) {
                this.createdTaskIds = [] as any;
                for (let item of _data["createdTaskIds"])
                    this.createdTaskIds!.push(item);
            }
            if (Array.isArray(_data["createdProjectIds"])) {
                this.createdProjectIds = [] as any;
                for (let item of _data["createdProjectIds"])
                    this.createdProjectIds!.push(item);
            }
            this.asOfUtc = _data["asOfUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingApplyProgressDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingApplyProgressDto>(data, _mappings, OnboardingApplyProgressDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["status"] = this.status;
        data["isRunning"] = this.isRunning;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.createdTaskIds)) {
            data["createdTaskIds"] = [];
            for (let item of this.createdTaskIds)
                data["createdTaskIds"].push(item);
        }
        if (Array.isArray(this.createdProjectIds)) {
            data["createdProjectIds"] = [];
            for (let item of this.createdProjectIds)
                data["createdProjectIds"].push(item);
        }
        data["asOfUtc"] = this.asOfUtc;
        return data;
    }
}

export interface IOnboardingApplyProgressDto {
    sessionId: number | undefined;
    status: OnboardingStatus | undefined;
    isRunning: boolean | undefined;
    units: OnboardingApplyUnitDto[] | undefined;
    createdTaskIds: number[] | undefined;
    createdProjectIds: number[] | undefined;
    asOfUtc: string | undefined;
}

export class OnboardingConnectionStatusDto implements IOnboardingConnectionStatusDto {
    isMicrosoftConnected!: boolean | undefined;
    hasMailAccess!: boolean | undefined;
    consentState!: OnboardingConsentState | undefined;
    adminRequired!: boolean | undefined;
    adminConsentPending!: boolean | undefined;
    accountName!: string | undefined;
    accountEmail!: string | undefined;

    constructor(data?: IOnboardingConnectionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isMicrosoftConnected = _data["isMicrosoftConnected"];
            this.hasMailAccess = _data["hasMailAccess"];
            this.consentState = _data["consentState"];
            this.adminRequired = _data["adminRequired"];
            this.adminConsentPending = _data["adminConsentPending"];
            this.accountName = _data["accountName"];
            this.accountEmail = _data["accountEmail"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingConnectionStatusDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingConnectionStatusDto>(data, _mappings, OnboardingConnectionStatusDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMicrosoftConnected"] = this.isMicrosoftConnected;
        data["hasMailAccess"] = this.hasMailAccess;
        data["consentState"] = this.consentState;
        data["adminRequired"] = this.adminRequired;
        data["adminConsentPending"] = this.adminConsentPending;
        data["accountName"] = this.accountName;
        data["accountEmail"] = this.accountEmail;
        return data;
    }
}

export interface IOnboardingConnectionStatusDto {
    isMicrosoftConnected: boolean | undefined;
    hasMailAccess: boolean | undefined;
    consentState: OnboardingConsentState | undefined;
    adminRequired: boolean | undefined;
    adminConsentPending: boolean | undefined;
    accountName: string | undefined;
    accountEmail: string | undefined;
}

export class OnboardingAdminConsentLinkDto implements IOnboardingAdminConsentLinkDto {
    url!: string | undefined;
    organizationName!: string | undefined;
    requesterFirstName!: string | undefined;

    constructor(data?: IOnboardingAdminConsentLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.url = _data["url"];
            this.organizationName = _data["organizationName"];
            this.requesterFirstName = _data["requesterFirstName"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingAdminConsentLinkDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingAdminConsentLinkDto>(data, _mappings, OnboardingAdminConsentLinkDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["organizationName"] = this.organizationName;
        data["requesterFirstName"] = this.requesterFirstName;
        return data;
    }
}

export interface IOnboardingAdminConsentLinkDto {
    url: string | undefined;
    organizationName: string | undefined;
    requesterFirstName: string | undefined;
}

export class OnboardingOrganizationIdentityDto implements IOnboardingOrganizationIdentityDto {
    organizationId!: string | undefined;
    displayName!: string | undefined;
    verifiedDomains!: string[] | undefined;
    isFallback!: boolean | undefined;

    constructor(data?: IOnboardingOrganizationIdentityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["verifiedDomains"])) {
                this.verifiedDomains = [] as any;
                for (let item of _data["verifiedDomains"])
                    this.verifiedDomains!.push(item);
            }
            this.isFallback = _data["isFallback"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingOrganizationIdentityDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingOrganizationIdentityDto>(data, _mappings, OnboardingOrganizationIdentityDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.verifiedDomains)) {
            data["verifiedDomains"] = [];
            for (let item of this.verifiedDomains)
                data["verifiedDomains"].push(item);
        }
        data["isFallback"] = this.isFallback;
        return data;
    }
}

export interface IOnboardingOrganizationIdentityDto {
    organizationId: string | undefined;
    displayName: string | undefined;
    verifiedDomains: string[] | undefined;
    isFallback: boolean | undefined;
}

export enum OnboardingConnectStep {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
}

export enum OnboardingConnectSurface {
    _1 = 1,
    _2 = 2,
}

export class TrackOnboardingConnectStepInput implements ITrackOnboardingConnectStepInput {
    step!: OnboardingConnectStep | undefined;
    surface!: OnboardingConnectSurface | undefined;
    entryPoint!: DiscoveryEntryPoint | undefined;

    constructor(data?: ITrackOnboardingConnectStepInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.step = _data["step"];
            this.surface = _data["surface"];
            this.entryPoint = _data["entryPoint"];
        }
    }

    static fromJS(data: any, _mappings?: any): TrackOnboardingConnectStepInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TrackOnboardingConnectStepInput>(data, _mappings, TrackOnboardingConnectStepInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["surface"] = this.surface;
        data["entryPoint"] = this.entryPoint;
        return data;
    }
}

export interface ITrackOnboardingConnectStepInput {
    step: OnboardingConnectStep | undefined;
    surface: OnboardingConnectSurface | undefined;
    entryPoint: DiscoveryEntryPoint | undefined;
}

export class OnboardingQaFixtureDto implements IOnboardingQaFixtureDto {
    key!: string | undefined;
    label!: string | undefined;
    forOnboarding!: boolean | undefined;
    forIntelligence!: boolean | undefined;

    constructor(data?: IOnboardingQaFixtureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.forOnboarding = _data["forOnboarding"];
            this.forIntelligence = _data["forIntelligence"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingQaFixtureDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingQaFixtureDto>(data, _mappings, OnboardingQaFixtureDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["forOnboarding"] = this.forOnboarding;
        data["forIntelligence"] = this.forIntelligence;
        return data;
    }
}

export interface IOnboardingQaFixtureDto {
    key: string | undefined;
    label: string | undefined;
    forOnboarding: boolean | undefined;
    forIntelligence: boolean | undefined;
}

export enum OnboardingQaAdminApproval {
    _1 = 1,
    _2 = 2,
}

export enum OnboardingQaScanMode {
    _1 = 1,
    _2 = 2,
}

export class OnboardingQaOptionsDto implements IOnboardingQaOptionsDto {
    schemaVersion!: number | undefined;
    fixtureKey!: string | undefined;
    startAt!: OnboardingStep | undefined;
    adminApproval!: OnboardingQaAdminApproval | undefined;
    scanMode!: OnboardingQaScanMode | undefined;

    constructor(data?: IOnboardingQaOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.schemaVersion = _data["schemaVersion"];
            this.fixtureKey = _data["fixtureKey"];
            this.startAt = _data["startAt"];
            this.adminApproval = _data["adminApproval"];
            this.scanMode = _data["scanMode"];
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingQaOptionsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingQaOptionsDto>(data, _mappings, OnboardingQaOptionsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schemaVersion"] = this.schemaVersion;
        data["fixtureKey"] = this.fixtureKey;
        data["startAt"] = this.startAt;
        data["adminApproval"] = this.adminApproval;
        data["scanMode"] = this.scanMode;
        return data;
    }
}

export interface IOnboardingQaOptionsDto {
    schemaVersion: number | undefined;
    fixtureKey: string | undefined;
    startAt: OnboardingStep | undefined;
    adminApproval: OnboardingQaAdminApproval | undefined;
    scanMode: OnboardingQaScanMode | undefined;
}

export enum OrgIntelligenceQaEvidence {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class IntelligenceQaOptionsDto implements IIntelligenceQaOptionsDto {
    schemaVersion!: number | undefined;
    fixtureKey!: string | undefined;
    evidence!: OrgIntelligenceQaEvidence | undefined;
    scanMode!: OnboardingQaScanMode | undefined;

    constructor(data?: IIntelligenceQaOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.schemaVersion = _data["schemaVersion"];
            this.fixtureKey = _data["fixtureKey"];
            this.evidence = _data["evidence"];
            this.scanMode = _data["scanMode"];
        }
    }

    static fromJS(data: any, _mappings?: any): IntelligenceQaOptionsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IntelligenceQaOptionsDto>(data, _mappings, IntelligenceQaOptionsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schemaVersion"] = this.schemaVersion;
        data["fixtureKey"] = this.fixtureKey;
        data["evidence"] = this.evidence;
        data["scanMode"] = this.scanMode;
        return data;
    }
}

export interface IIntelligenceQaOptionsDto {
    schemaVersion: number | undefined;
    fixtureKey: string | undefined;
    evidence: OrgIntelligenceQaEvidence | undefined;
    scanMode: OnboardingQaScanMode | undefined;
}

export class OnboardingQaStateDto implements IOnboardingQaStateDto {
    fixturesEnabled!: boolean | undefined;
    fixtures!: OnboardingQaFixtureDto[] | undefined;
    onboarding!: OnboardingQaOptionsDto | undefined;
    intelligence!: IntelligenceQaOptionsDto | undefined;

    constructor(data?: IOnboardingQaStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fixturesEnabled = _data["fixturesEnabled"];
            if (Array.isArray(_data["fixtures"])) {
                this.fixtures = [] as any;
                for (let item of _data["fixtures"])
                    this.fixtures!.push(OnboardingQaFixtureDto.fromJS(item, _mappings));
            }
            this.onboarding = _data["onboarding"] ? OnboardingQaOptionsDto.fromJS(_data["onboarding"], _mappings) : undefined as any;
            this.intelligence = _data["intelligence"] ? IntelligenceQaOptionsDto.fromJS(_data["intelligence"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): OnboardingQaStateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OnboardingQaStateDto>(data, _mappings, OnboardingQaStateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixturesEnabled"] = this.fixturesEnabled;
        if (Array.isArray(this.fixtures)) {
            data["fixtures"] = [];
            for (let item of this.fixtures)
                data["fixtures"].push(item ? item.toJSON() : undefined as any);
        }
        data["onboarding"] = this.onboarding ? this.onboarding.toJSON() : undefined as any;
        data["intelligence"] = this.intelligence ? this.intelligence.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnboardingQaStateDto {
    fixturesEnabled: boolean | undefined;
    fixtures: OnboardingQaFixtureDto[] | undefined;
    onboarding: OnboardingQaOptionsDto | undefined;
    intelligence: IntelligenceQaOptionsDto | undefined;
}

export class SetOnboardingQaOptionsInput implements ISetOnboardingQaOptionsInput {
    fixtureKey!: string;
    startAt!: OnboardingStep | undefined;
    adminApproval!: OnboardingQaAdminApproval | undefined;
    scanMode!: OnboardingQaScanMode | undefined;

    constructor(data?: ISetOnboardingQaOptionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fixtureKey = _data["fixtureKey"];
            this.startAt = _data["startAt"];
            this.adminApproval = _data["adminApproval"];
            this.scanMode = _data["scanMode"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetOnboardingQaOptionsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetOnboardingQaOptionsInput>(data, _mappings, SetOnboardingQaOptionsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixtureKey"] = this.fixtureKey;
        data["startAt"] = this.startAt;
        data["adminApproval"] = this.adminApproval;
        data["scanMode"] = this.scanMode;
        return data;
    }
}

export interface ISetOnboardingQaOptionsInput {
    fixtureKey: string;
    startAt: OnboardingStep | undefined;
    adminApproval: OnboardingQaAdminApproval | undefined;
    scanMode: OnboardingQaScanMode | undefined;
}

export class SetIntelligenceQaOptionsInput implements ISetIntelligenceQaOptionsInput {
    fixtureKey!: string;
    evidence!: OrgIntelligenceQaEvidence | undefined;
    scanMode!: OnboardingQaScanMode | undefined;

    constructor(data?: ISetIntelligenceQaOptionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fixtureKey = _data["fixtureKey"];
            this.evidence = _data["evidence"];
            this.scanMode = _data["scanMode"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetIntelligenceQaOptionsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetIntelligenceQaOptionsInput>(data, _mappings, SetIntelligenceQaOptionsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixtureKey"] = this.fixtureKey;
        data["evidence"] = this.evidence;
        data["scanMode"] = this.scanMode;
        return data;
    }
}

export interface ISetIntelligenceQaOptionsInput {
    fixtureKey: string;
    evidence: OrgIntelligenceQaEvidence | undefined;
    scanMode: OnboardingQaScanMode | undefined;
}

export class OneDriveUploadOutputDto implements IOneDriveUploadOutputDto {
    id!: string | undefined;
    name!: string | undefined;
    webUrl!: string | undefined;
    driveId!: string | undefined;
    siteId!: string | undefined;
    folderId!: string | undefined;
    downloadUrl!: string | undefined;

    constructor(data?: IOneDriveUploadOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.webUrl = _data["webUrl"];
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
            this.folderId = _data["folderId"];
            this.downloadUrl = _data["downloadUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): OneDriveUploadOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OneDriveUploadOutputDto>(data, _mappings, OneDriveUploadOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["webUrl"] = this.webUrl;
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        data["folderId"] = this.folderId;
        data["downloadUrl"] = this.downloadUrl;
        return data;
    }
}

export interface IOneDriveUploadOutputDto {
    id: string | undefined;
    name: string | undefined;
    webUrl: string | undefined;
    driveId: string | undefined;
    siteId: string | undefined;
    folderId: string | undefined;
    downloadUrl: string | undefined;
}

export class OneDriveUploadOutputDtoIHandleError implements IOneDriveUploadOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: OneDriveUploadOutputDto | undefined;
    listOfEntities!: OneDriveUploadOutputDto[] | undefined;

    constructor(data?: IOneDriveUploadOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? OneDriveUploadOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(OneDriveUploadOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OneDriveUploadOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OneDriveUploadOutputDtoIHandleError>(data, _mappings, OneDriveUploadOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOneDriveUploadOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: OneDriveUploadOutputDto | undefined;
    listOfEntities: OneDriveUploadOutputDto[] | undefined;
}

export class DownloadFileInputDto implements IDownloadFileInputDto {
    keyId!: string | undefined;
    msDriveId!: string | undefined;

    constructor(data?: IDownloadFileInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.keyId = _data["keyId"];
            this.msDriveId = _data["msDriveId"];
        }
    }

    static fromJS(data: any, _mappings?: any): DownloadFileInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DownloadFileInputDto>(data, _mappings, DownloadFileInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyId"] = this.keyId;
        data["msDriveId"] = this.msDriveId;
        return data;
    }
}

export interface IDownloadFileInputDto {
    keyId: string | undefined;
    msDriveId: string | undefined;
}

export class DownloadFilesInputDto implements IDownloadFilesInputDto {
    files!: DownloadFileInputDto[] | undefined;
    zipName!: string | undefined;

    constructor(data?: IDownloadFilesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(DownloadFileInputDto.fromJS(item, _mappings));
            }
            this.zipName = _data["zipName"];
        }
    }

    static fromJS(data: any, _mappings?: any): DownloadFilesInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DownloadFilesInputDto>(data, _mappings, DownloadFilesInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        data["zipName"] = this.zipName;
        return data;
    }
}

export interface IDownloadFilesInputDto {
    files: DownloadFileInputDto[] | undefined;
    zipName: string | undefined;
}

export class DownloadOutputDto implements IDownloadOutputDto {
    fileBytes!: string | undefined;
    fileName!: string | undefined;

    constructor(data?: IDownloadOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fileBytes = _data["fileBytes"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any, _mappings?: any): DownloadOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DownloadOutputDto>(data, _mappings, DownloadOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileBytes"] = this.fileBytes;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IDownloadOutputDto {
    fileBytes: string | undefined;
    fileName: string | undefined;
}

export class DownloadOutputDtoIHandleError implements IDownloadOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: DownloadOutputDto | undefined;
    listOfEntities!: DownloadOutputDto[] | undefined;

    constructor(data?: IDownloadOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? DownloadOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(DownloadOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DownloadOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DownloadOutputDtoIHandleError>(data, _mappings, DownloadOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDownloadOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: DownloadOutputDto | undefined;
    listOfEntities: DownloadOutputDto[] | undefined;
}

export class DownloadZipInputDto implements IDownloadZipInputDto {
    keyId!: string | undefined;
    msDriveId!: string | undefined;
    zipName!: string | undefined;

    constructor(data?: IDownloadZipInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.keyId = _data["keyId"];
            this.msDriveId = _data["msDriveId"];
            this.zipName = _data["zipName"];
        }
    }

    static fromJS(data: any, _mappings?: any): DownloadZipInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DownloadZipInputDto>(data, _mappings, DownloadZipInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyId"] = this.keyId;
        data["msDriveId"] = this.msDriveId;
        data["zipName"] = this.zipName;
        return data;
    }
}

export interface IDownloadZipInputDto {
    keyId: string | undefined;
    msDriveId: string | undefined;
    zipName: string | undefined;
}

export class OneNoteLinks implements IOneNoteLinks {
    srcService!: string | undefined;
    name!: string | undefined;
    webUrl!: string | undefined;
    lastAccessedTime!: string | undefined;
    lastAccessedTimeAgo!: string | undefined;
    isPinned!: boolean | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    companyName!: string | undefined;
    colorClassName!: string | undefined;

    constructor(data?: IOneNoteLinks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.srcService = _data["srcService"];
            this.name = _data["name"];
            this.webUrl = _data["webUrl"];
            this.lastAccessedTime = _data["lastAccessedTime"];
            this.lastAccessedTimeAgo = _data["lastAccessedTimeAgo"];
            this.isPinned = _data["isPinned"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.companyName = _data["companyName"];
            this.colorClassName = _data["colorClassName"];
        }
    }

    static fromJS(data: any, _mappings?: any): OneNoteLinks | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OneNoteLinks>(data, _mappings, OneNoteLinks);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["srcService"] = this.srcService;
        data["name"] = this.name;
        data["webUrl"] = this.webUrl;
        data["lastAccessedTime"] = this.lastAccessedTime;
        data["lastAccessedTimeAgo"] = this.lastAccessedTimeAgo;
        data["isPinned"] = this.isPinned;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["companyName"] = this.companyName;
        data["colorClassName"] = this.colorClassName;
        return data;
    }
}

export interface IOneNoteLinks {
    srcService: string | undefined;
    name: string | undefined;
    webUrl: string | undefined;
    lastAccessedTime: string | undefined;
    lastAccessedTimeAgo: string | undefined;
    isPinned: boolean | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    companyName: string | undefined;
    colorClassName: string | undefined;
}

export class OneNoteLinksListIHandleError implements IOneNoteLinksListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: OneNoteLinks[] | undefined;
    listOfEntities!: OneNoteLinks[][] | undefined;

    constructor(data?: IOneNoteLinksListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(OneNoteLinks.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OneNoteLinksListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OneNoteLinksListIHandleError>(data, _mappings, OneNoteLinksListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IOneNoteLinksListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: OneNoteLinks[] | undefined;
    listOfEntities: OneNoteLinks[][] | undefined;
}

export class CreateFileInputDto implements ICreateFileInputDto {
    name!: string | undefined;
    extension!: string | undefined;
    driveId!: string | undefined;
    itemId!: string | undefined;
    isOneNote!: boolean | undefined;
    isShareFile!: boolean | undefined;
    duplicateAction!: number | undefined;

    constructor(data?: ICreateFileInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.driveId = _data["driveId"];
            this.itemId = _data["itemId"];
            this.isOneNote = _data["isOneNote"];
            this.isShareFile = _data["isShareFile"];
            this.duplicateAction = _data["duplicateAction"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateFileInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateFileInputDto>(data, _mappings, CreateFileInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["driveId"] = this.driveId;
        data["itemId"] = this.itemId;
        data["isOneNote"] = this.isOneNote;
        data["isShareFile"] = this.isShareFile;
        data["duplicateAction"] = this.duplicateAction;
        return data;
    }
}

export interface ICreateFileInputDto {
    name: string | undefined;
    extension: string | undefined;
    driveId: string | undefined;
    itemId: string | undefined;
    isOneNote: boolean | undefined;
    isShareFile: boolean | undefined;
    duplicateAction: number | undefined;
}

export class CreateFileOutputDto implements ICreateFileOutputDto {
    fileName!: string | undefined;
    url!: string | undefined;
    keyId!: string | undefined;
    driveId!: string | undefined;
    siteId!: string | undefined;

    constructor(data?: ICreateFileOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.url = _data["url"];
            this.keyId = _data["keyId"];
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateFileOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateFileOutputDto>(data, _mappings, CreateFileOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["url"] = this.url;
        data["keyId"] = this.keyId;
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        return data;
    }
}

export interface ICreateFileOutputDto {
    fileName: string | undefined;
    url: string | undefined;
    keyId: string | undefined;
    driveId: string | undefined;
    siteId: string | undefined;
}

export class CreateFileOutputDtoIHandleError implements ICreateFileOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CreateFileOutputDto | undefined;
    listOfEntities!: CreateFileOutputDto[] | undefined;

    constructor(data?: ICreateFileOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CreateFileOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CreateFileOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateFileOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateFileOutputDtoIHandleError>(data, _mappings, CreateFileOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateFileOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CreateFileOutputDto | undefined;
    listOfEntities: CreateFileOutputDto[] | undefined;
}

export class GetFileLocationOutputDto implements IGetFileLocationOutputDto {
    id!: string | undefined;
    driveName!: string | undefined;
    siteName!: string | undefined;
    folderUrl!: string | undefined;

    constructor(data?: IGetFileLocationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.driveName = _data["driveName"];
            this.siteName = _data["siteName"];
            this.folderUrl = _data["folderUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetFileLocationOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetFileLocationOutputDto>(data, _mappings, GetFileLocationOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["driveName"] = this.driveName;
        data["siteName"] = this.siteName;
        data["folderUrl"] = this.folderUrl;
        return data;
    }
}

export interface IGetFileLocationOutputDto {
    id: string | undefined;
    driveName: string | undefined;
    siteName: string | undefined;
    folderUrl: string | undefined;
}

export class GetFileLocationOutputDtoIHandleError implements IGetFileLocationOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetFileLocationOutputDto | undefined;
    listOfEntities!: GetFileLocationOutputDto[] | undefined;

    constructor(data?: IGetFileLocationOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetFileLocationOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetFileLocationOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetFileLocationOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetFileLocationOutputDtoIHandleError>(data, _mappings, GetFileLocationOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetFileLocationOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetFileLocationOutputDto | undefined;
    listOfEntities: GetFileLocationOutputDto[] | undefined;
}

export class CreateFolderDtoIHandleError implements ICreateFolderDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CreateFolderDto | undefined;
    listOfEntities!: CreateFolderDto[] | undefined;

    constructor(data?: ICreateFolderDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CreateFolderDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CreateFolderDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateFolderDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateFolderDtoIHandleError>(data, _mappings, CreateFolderDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateFolderDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CreateFolderDto | undefined;
    listOfEntities: CreateFolderDto[] | undefined;
}

export class Identity implements IIdentity {
    displayName!: string | undefined;
    id!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.id = _data["id"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): Identity | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Identity>(data, _mappings, Identity);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["id"] = this.id;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IIdentity {
    displayName: string | undefined;
    id: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export class IdentitySet implements IIdentitySet {
    application!: Identity | undefined;
    device!: Identity | undefined;
    user!: Identity | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IIdentitySet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.application = _data["application"] ? Identity.fromJS(_data["application"], _mappings) : undefined as any;
            this.device = _data["device"] ? Identity.fromJS(_data["device"], _mappings) : undefined as any;
            this.user = _data["user"] ? Identity.fromJS(_data["user"], _mappings) : undefined as any;
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): IdentitySet | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IdentitySet>(data, _mappings, IdentitySet);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : undefined as any;
        data["device"] = this.device ? this.device.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IIdentitySet {
    application: Identity | undefined;
    device: Identity | undefined;
    user: Identity | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export class SiteCollection implements ISiteCollection {
    hostname!: string | undefined;

    constructor(data?: ISiteCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.hostname = _data["hostname"];
        }
    }

    static fromJS(data: any, _mappings?: any): SiteCollection | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SiteCollection>(data, _mappings, SiteCollection);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hostname"] = this.hostname;
        return data;
    }
}

export interface ISiteCollection {
    hostname: string | undefined;
}

export class ParentReference implements IParentReference {
    driveType!: string | undefined;
    driveId!: string | undefined;
    id!: string | undefined;
    name!: string | undefined;
    siteId!: string | undefined;

    constructor(data?: IParentReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.driveType = _data["driveType"];
            this.driveId = _data["driveId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.siteId = _data["siteId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ParentReference | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ParentReference>(data, _mappings, ParentReference);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driveType"] = this.driveType;
        data["driveId"] = this.driveId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["siteId"] = this.siteId;
        return data;
    }
}

export interface IParentReference {
    driveType: string | undefined;
    driveId: string | undefined;
    id: string | undefined;
    name: string | undefined;
    siteId: string | undefined;
}

export class FileInfoObj implements IFileInfoObj {
    mimeType!: string | undefined;

    constructor(data?: IFileInfoObj) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any, _mappings?: any): FileInfoObj | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FileInfoObj>(data, _mappings, FileInfoObj);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface IFileInfoObj {
    mimeType: string | undefined;
}

export class FolderView implements IFolderView {
    sortBy!: string | undefined;
    sortOrder!: string | undefined;
    viewType!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IFolderView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sortBy = _data["sortBy"];
            this.sortOrder = _data["sortOrder"];
            this.viewType = _data["viewType"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): FolderView | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FolderView>(data, _mappings, FolderView);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortBy"] = this.sortBy;
        data["sortOrder"] = this.sortOrder;
        data["viewType"] = this.viewType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IFolderView {
    sortBy: string | undefined;
    sortOrder: string | undefined;
    viewType: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export class Folder implements IFolder {
    childCount!: number | undefined;
    view!: FolderView | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IFolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.childCount = _data["childCount"];
            this.view = _data["view"] ? FolderView.fromJS(_data["view"], _mappings) : undefined as any;
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): Folder | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Folder>(data, _mappings, Folder);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["childCount"] = this.childCount;
        data["view"] = this.view ? this.view.toJSON() : undefined as any;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IFolder {
    childCount: number | undefined;
    view: FolderView | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export class PackageInfo implements IPackageInfo {
    type!: string | undefined;

    constructor(data?: IPackageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any, _mappings?: any): PackageInfo | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PackageInfo>(data, _mappings, PackageInfo);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        return data;
    }
}

export interface IPackageInfo {
    type: string | undefined;
}

export class SharePointSite implements ISharePointSite {
    createdDateTime!: string | undefined;
    description!: string | undefined;
    id!: string | undefined;
    lastModifiedDateTime!: string | undefined;
    lastModifiedBy!: IdentitySet | undefined;
    name!: string | undefined;
    webUrl!: string | undefined;
    displayName!: string | undefined;
    siteCollection!: SiteCollection | undefined;
    parentReference!: ParentReference | undefined;
    file!: FileInfoObj | undefined;
    folder!: Folder | undefined;
    package!: PackageInfo | undefined;
    size!: number | undefined;
    extension!: string | undefined;

    constructor(data?: ISharePointSite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.createdDateTime = _data["createdDateTime"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"];
            this.lastModifiedBy = _data["lastModifiedBy"] ? IdentitySet.fromJS(_data["lastModifiedBy"], _mappings) : undefined as any;
            this.name = _data["name"];
            this.webUrl = _data["webUrl"];
            this.displayName = _data["displayName"];
            this.siteCollection = _data["siteCollection"] ? SiteCollection.fromJS(_data["siteCollection"], _mappings) : undefined as any;
            this.parentReference = _data["parentReference"] ? ParentReference.fromJS(_data["parentReference"], _mappings) : undefined as any;
            this.file = _data["file"] ? FileInfoObj.fromJS(_data["file"], _mappings) : undefined as any;
            this.folder = _data["folder"] ? Folder.fromJS(_data["folder"], _mappings) : undefined as any;
            this.package = _data["package"] ? PackageInfo.fromJS(_data["package"], _mappings) : undefined as any;
            this.size = _data["size"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any, _mappings?: any): SharePointSite | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SharePointSite>(data, _mappings, SharePointSite);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdDateTime"] = this.createdDateTime;
        data["description"] = this.description;
        data["id"] = this.id;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : undefined as any;
        data["name"] = this.name;
        data["webUrl"] = this.webUrl;
        data["displayName"] = this.displayName;
        data["siteCollection"] = this.siteCollection ? this.siteCollection.toJSON() : undefined as any;
        data["parentReference"] = this.parentReference ? this.parentReference.toJSON() : undefined as any;
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        data["folder"] = this.folder ? this.folder.toJSON() : undefined as any;
        data["package"] = this.package ? this.package.toJSON() : undefined as any;
        data["size"] = this.size;
        data["extension"] = this.extension;
        return data;
    }
}

export interface ISharePointSite {
    createdDateTime: string | undefined;
    description: string | undefined;
    id: string | undefined;
    lastModifiedDateTime: string | undefined;
    lastModifiedBy: IdentitySet | undefined;
    name: string | undefined;
    webUrl: string | undefined;
    displayName: string | undefined;
    siteCollection: SiteCollection | undefined;
    parentReference: ParentReference | undefined;
    file: FileInfoObj | undefined;
    folder: Folder | undefined;
    package: PackageInfo | undefined;
    size: number | undefined;
    extension: string | undefined;
}

export class SharePointSiteListIHandleError implements ISharePointSiteListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SharePointSite[] | undefined;
    listOfEntities!: SharePointSite[][] | undefined;

    constructor(data?: ISharePointSiteListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(SharePointSite.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SharePointSiteListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SharePointSiteListIHandleError>(data, _mappings, SharePointSiteListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ISharePointSiteListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SharePointSite[] | undefined;
    listOfEntities: SharePointSite[][] | undefined;
}

export enum ShareFileScope {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ShareMsFileInputDto implements IShareMsFileInputDto {
    scope!: ShareFileScope | undefined;
    isEdit!: boolean | undefined;
    fileId!: string | undefined;
    driveId!: string | undefined;
    accessLevel!: string | undefined;
    permission!: string | undefined;
    preventsDownload!: boolean | undefined;
    recipients!: string[] | undefined;
    expirationDateTime!: string | undefined;

    constructor(data?: IShareMsFileInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.scope = _data["scope"];
            this.isEdit = _data["isEdit"];
            this.fileId = _data["fileId"];
            this.driveId = _data["driveId"];
            this.accessLevel = _data["accessLevel"];
            this.permission = _data["permission"];
            this.preventsDownload = _data["preventsDownload"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            this.expirationDateTime = _data["expirationDateTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): ShareMsFileInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ShareMsFileInputDto>(data, _mappings, ShareMsFileInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope;
        data["isEdit"] = this.isEdit;
        data["fileId"] = this.fileId;
        data["driveId"] = this.driveId;
        data["accessLevel"] = this.accessLevel;
        data["permission"] = this.permission;
        data["preventsDownload"] = this.preventsDownload;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        data["expirationDateTime"] = this.expirationDateTime;
        return data;
    }
}

export interface IShareMsFileInputDto {
    scope: ShareFileScope | undefined;
    isEdit: boolean | undefined;
    fileId: string | undefined;
    driveId: string | undefined;
    accessLevel: string | undefined;
    permission: string | undefined;
    preventsDownload: boolean | undefined;
    recipients: string[] | undefined;
    expirationDateTime: string | undefined;
}

export class ShareMsFileOutputDto implements IShareMsFileOutputDto {
    link!: string | undefined;
    name!: string | undefined;

    constructor(data?: IShareMsFileOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.link = _data["link"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): ShareMsFileOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ShareMsFileOutputDto>(data, _mappings, ShareMsFileOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link;
        data["name"] = this.name;
        return data;
    }
}

export interface IShareMsFileOutputDto {
    link: string | undefined;
    name: string | undefined;
}

export class ShareMsFileOutputDtoIHandleError implements IShareMsFileOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ShareMsFileOutputDto | undefined;
    listOfEntities!: ShareMsFileOutputDto[] | undefined;

    constructor(data?: IShareMsFileOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ShareMsFileOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ShareMsFileOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ShareMsFileOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ShareMsFileOutputDtoIHandleError>(data, _mappings, ShareMsFileOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IShareMsFileOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ShareMsFileOutputDto | undefined;
    listOfEntities: ShareMsFileOutputDto[] | undefined;
}

export class GetMsFileOutputListStringValueTuple implements IGetMsFileOutputListStringValueTuple {

    constructor(data?: IGetMsFileOutputListStringValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): GetMsFileOutputListStringValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetMsFileOutputListStringValueTuple>(data, _mappings, GetMsFileOutputListStringValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetMsFileOutputListStringValueTuple {
}

export class GetMsFileOutputListStringValueTupleIHandleError implements IGetMsFileOutputListStringValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetMsFileOutputListStringValueTuple | undefined;
    listOfEntities!: GetMsFileOutputListStringValueTuple[] | undefined;

    constructor(data?: IGetMsFileOutputListStringValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetMsFileOutputListStringValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetMsFileOutputListStringValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetMsFileOutputListStringValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetMsFileOutputListStringValueTupleIHandleError>(data, _mappings, GetMsFileOutputListStringValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMsFileOutputListStringValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetMsFileOutputListStringValueTuple | undefined;
    listOfEntities: GetMsFileOutputListStringValueTuple[] | undefined;
}

export class BreadcrumbRequestInput implements IBreadcrumbRequestInput {
    key!: string | undefined;
    driveId!: string | undefined;
    itemId!: string | undefined;
    siteId!: string | undefined;

    constructor(data?: IBreadcrumbRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.driveId = _data["driveId"];
            this.itemId = _data["itemId"];
            this.siteId = _data["siteId"];
        }
    }

    static fromJS(data: any, _mappings?: any): BreadcrumbRequestInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BreadcrumbRequestInput>(data, _mappings, BreadcrumbRequestInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["driveId"] = this.driveId;
        data["itemId"] = this.itemId;
        data["siteId"] = this.siteId;
        return data;
    }
}

export interface IBreadcrumbRequestInput {
    key: string | undefined;
    driveId: string | undefined;
    itemId: string | undefined;
    siteId: string | undefined;
}

export class BreadcrumbItemDto implements IBreadcrumbItemDto {
    id!: string | undefined;
    name!: string | undefined;
    driveId!: string | undefined;
    type!: string | undefined;

    constructor(data?: IBreadcrumbItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.driveId = _data["driveId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any, _mappings?: any): BreadcrumbItemDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BreadcrumbItemDto>(data, _mappings, BreadcrumbItemDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["driveId"] = this.driveId;
        data["type"] = this.type;
        return data;
    }
}

export interface IBreadcrumbItemDto {
    id: string | undefined;
    name: string | undefined;
    driveId: string | undefined;
    type: string | undefined;
}

export class BreadcrumbResultOutput implements IBreadcrumbResultOutput {
    key!: string | undefined;
    driveId!: string | undefined;
    itemId!: string | undefined;
    breadcrumb!: BreadcrumbItemDto[] | undefined;
    errorMessage!: string | undefined;

    constructor(data?: IBreadcrumbResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.driveId = _data["driveId"];
            this.itemId = _data["itemId"];
            if (Array.isArray(_data["breadcrumb"])) {
                this.breadcrumb = [] as any;
                for (let item of _data["breadcrumb"])
                    this.breadcrumb!.push(BreadcrumbItemDto.fromJS(item, _mappings));
            }
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any, _mappings?: any): BreadcrumbResultOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BreadcrumbResultOutput>(data, _mappings, BreadcrumbResultOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["driveId"] = this.driveId;
        data["itemId"] = this.itemId;
        if (Array.isArray(this.breadcrumb)) {
            data["breadcrumb"] = [];
            for (let item of this.breadcrumb)
                data["breadcrumb"].push(item ? item.toJSON() : undefined as any);
        }
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IBreadcrumbResultOutput {
    key: string | undefined;
    driveId: string | undefined;
    itemId: string | undefined;
    breadcrumb: BreadcrumbItemDto[] | undefined;
    errorMessage: string | undefined;
}

export class BreadcrumbResultOutputListIHandleError implements IBreadcrumbResultOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: BreadcrumbResultOutput[] | undefined;
    listOfEntities!: BreadcrumbResultOutput[][] | undefined;

    constructor(data?: IBreadcrumbResultOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(BreadcrumbResultOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): BreadcrumbResultOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BreadcrumbResultOutputListIHandleError>(data, _mappings, BreadcrumbResultOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IBreadcrumbResultOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: BreadcrumbResultOutput[] | undefined;
    listOfEntities: BreadcrumbResultOutput[][] | undefined;
}

export class BreadcrumbItemDtoListIHandleError implements IBreadcrumbItemDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: BreadcrumbItemDto[] | undefined;
    listOfEntities!: BreadcrumbItemDto[][] | undefined;

    constructor(data?: IBreadcrumbItemDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(BreadcrumbItemDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): BreadcrumbItemDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BreadcrumbItemDtoListIHandleError>(data, _mappings, BreadcrumbItemDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IBreadcrumbItemDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: BreadcrumbItemDto[] | undefined;
    listOfEntities: BreadcrumbItemDto[][] | undefined;
}

export class MyDriveItemOutput implements IMyDriveItemOutput {
    id!: string | undefined;
    name!: string | undefined;
    webUrl!: string | undefined;
    extension!: string | undefined;
    isFolder!: boolean | undefined;
    msDriveId!: string | undefined;
    msSiteId!: string | undefined;
    msFolderId!: string | undefined;
    size!: number | undefined;
    createdDateTime!: string | undefined;
    lastModifiedDateTime!: string | undefined;

    constructor(data?: IMyDriveItemOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.webUrl = _data["webUrl"];
            this.extension = _data["extension"];
            this.isFolder = _data["isFolder"];
            this.msDriveId = _data["msDriveId"];
            this.msSiteId = _data["msSiteId"];
            this.msFolderId = _data["msFolderId"];
            this.size = _data["size"];
            this.createdDateTime = _data["createdDateTime"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): MyDriveItemOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MyDriveItemOutput>(data, _mappings, MyDriveItemOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["webUrl"] = this.webUrl;
        data["extension"] = this.extension;
        data["isFolder"] = this.isFolder;
        data["msDriveId"] = this.msDriveId;
        data["msSiteId"] = this.msSiteId;
        data["msFolderId"] = this.msFolderId;
        data["size"] = this.size;
        data["createdDateTime"] = this.createdDateTime;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime;
        return data;
    }
}

export interface IMyDriveItemOutput {
    id: string | undefined;
    name: string | undefined;
    webUrl: string | undefined;
    extension: string | undefined;
    isFolder: boolean | undefined;
    msDriveId: string | undefined;
    msSiteId: string | undefined;
    msFolderId: string | undefined;
    size: number | undefined;
    createdDateTime: string | undefined;
    lastModifiedDateTime: string | undefined;
}

export class MyDriveItemOutputListIHandleError implements IMyDriveItemOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MyDriveItemOutput[] | undefined;
    listOfEntities!: MyDriveItemOutput[][] | undefined;

    constructor(data?: IMyDriveItemOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(MyDriveItemOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MyDriveItemOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MyDriveItemOutputListIHandleError>(data, _mappings, MyDriveItemOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IMyDriveItemOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MyDriveItemOutput[] | undefined;
    listOfEntities: MyDriveItemOutput[][] | undefined;
}

export class RenameMsFileInputDto implements IRenameMsFileInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    id!: number | undefined;
    type!: number | undefined;
    newName!: string | undefined;
    link!: string | undefined;
    fileId!: string | undefined;
    driveId!: string | undefined;
    driveName!: string | undefined;
    siteId!: string | undefined;
    duplicateAction!: number | undefined;

    constructor(data?: IRenameMsFileInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.id = _data["id"];
            this.type = _data["type"];
            this.newName = _data["newName"];
            this.link = _data["link"];
            this.fileId = _data["fileId"];
            this.driveId = _data["driveId"];
            this.driveName = _data["driveName"];
            this.siteId = _data["siteId"];
            this.duplicateAction = _data["duplicateAction"];
        }
    }

    static fromJS(data: any, _mappings?: any): RenameMsFileInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RenameMsFileInputDto>(data, _mappings, RenameMsFileInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["id"] = this.id;
        data["type"] = this.type;
        data["newName"] = this.newName;
        data["link"] = this.link;
        data["fileId"] = this.fileId;
        data["driveId"] = this.driveId;
        data["driveName"] = this.driveName;
        data["siteId"] = this.siteId;
        data["duplicateAction"] = this.duplicateAction;
        return data;
    }
}

export interface IRenameMsFileInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    id: number | undefined;
    type: number | undefined;
    newName: string | undefined;
    link: string | undefined;
    fileId: string | undefined;
    driveId: string | undefined;
    driveName: string | undefined;
    siteId: string | undefined;
    duplicateAction: number | undefined;
}

export class GetMsFileDetailOutputDto implements IGetMsFileDetailOutputDto {
    fileName!: string | undefined;
    link!: string | undefined;
    fileId!: string | undefined;
    driveId!: string | undefined;
    siteId!: string | undefined;
    parentId!: string | undefined;
    parentName!: string | undefined;
    parentDriveId!: string | undefined;
    parentSiteId!: string | undefined;

    constructor(data?: IGetMsFileDetailOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.link = _data["link"];
            this.fileId = _data["fileId"];
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
            this.parentId = _data["parentId"];
            this.parentName = _data["parentName"];
            this.parentDriveId = _data["parentDriveId"];
            this.parentSiteId = _data["parentSiteId"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetMsFileDetailOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetMsFileDetailOutputDto>(data, _mappings, GetMsFileDetailOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["link"] = this.link;
        data["fileId"] = this.fileId;
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["parentDriveId"] = this.parentDriveId;
        data["parentSiteId"] = this.parentSiteId;
        return data;
    }
}

export interface IGetMsFileDetailOutputDto {
    fileName: string | undefined;
    link: string | undefined;
    fileId: string | undefined;
    driveId: string | undefined;
    siteId: string | undefined;
    parentId: string | undefined;
    parentName: string | undefined;
    parentDriveId: string | undefined;
    parentSiteId: string | undefined;
}

export class GetMsFileDetailOutputDtoIHandleError implements IGetMsFileDetailOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetMsFileDetailOutputDto | undefined;
    listOfEntities!: GetMsFileDetailOutputDto[] | undefined;

    constructor(data?: IGetMsFileDetailOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetMsFileDetailOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetMsFileDetailOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetMsFileDetailOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetMsFileDetailOutputDtoIHandleError>(data, _mappings, GetMsFileDetailOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMsFileDetailOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetMsFileDetailOutputDto | undefined;
    listOfEntities: GetMsFileDetailOutputDto[] | undefined;
}

export class CopyMoveMsFileInputDto implements ICopyMoveMsFileInputDto {
    fileName!: string | undefined;
    fileId!: string | undefined;
    fromDriveId!: string | undefined;
    fromSiteId!: string | undefined;
    toItemId!: string | undefined;
    toDriveId!: string | undefined;
    toSiteId!: string | undefined;
    duplicateAction!: number | undefined;
    requestFrom!: number | undefined;

    constructor(data?: ICopyMoveMsFileInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileId = _data["fileId"];
            this.fromDriveId = _data["fromDriveId"];
            this.fromSiteId = _data["fromSiteId"];
            this.toItemId = _data["toItemId"];
            this.toDriveId = _data["toDriveId"];
            this.toSiteId = _data["toSiteId"];
            this.duplicateAction = _data["duplicateAction"];
            this.requestFrom = _data["requestFrom"];
        }
    }

    static fromJS(data: any, _mappings?: any): CopyMoveMsFileInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CopyMoveMsFileInputDto>(data, _mappings, CopyMoveMsFileInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileId"] = this.fileId;
        data["fromDriveId"] = this.fromDriveId;
        data["fromSiteId"] = this.fromSiteId;
        data["toItemId"] = this.toItemId;
        data["toDriveId"] = this.toDriveId;
        data["toSiteId"] = this.toSiteId;
        data["duplicateAction"] = this.duplicateAction;
        data["requestFrom"] = this.requestFrom;
        return data;
    }
}

export interface ICopyMoveMsFileInputDto {
    fileName: string | undefined;
    fileId: string | undefined;
    fromDriveId: string | undefined;
    fromSiteId: string | undefined;
    toItemId: string | undefined;
    toDriveId: string | undefined;
    toSiteId: string | undefined;
    duplicateAction: number | undefined;
    requestFrom: number | undefined;
}

export class CopyMsFileOutcomeDto implements ICopyMsFileOutcomeDto {
    input!: CopyMoveMsFileInputDto | undefined;
    isError!: boolean | undefined;
    code!: string | undefined;
    reason!: string | undefined;
    supportRef!: string | undefined;
    retryable!: boolean | undefined;
    result!: CreateFileOutputDto | undefined;

    constructor(data?: ICopyMsFileOutcomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.input = _data["input"] ? CopyMoveMsFileInputDto.fromJS(_data["input"], _mappings) : undefined as any;
            this.isError = _data["isError"];
            this.code = _data["code"];
            this.reason = _data["reason"];
            this.supportRef = _data["supportRef"];
            this.retryable = _data["retryable"];
            this.result = _data["result"] ? CreateFileOutputDto.fromJS(_data["result"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): CopyMsFileOutcomeDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CopyMsFileOutcomeDto>(data, _mappings, CopyMsFileOutcomeDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["input"] = this.input ? this.input.toJSON() : undefined as any;
        data["isError"] = this.isError;
        data["code"] = this.code;
        data["reason"] = this.reason;
        data["supportRef"] = this.supportRef;
        data["retryable"] = this.retryable;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface ICopyMsFileOutcomeDto {
    input: CopyMoveMsFileInputDto | undefined;
    isError: boolean | undefined;
    code: string | undefined;
    reason: string | undefined;
    supportRef: string | undefined;
    retryable: boolean | undefined;
    result: CreateFileOutputDto | undefined;
}

export class CreateFileOutputDtoListIHandleError implements ICreateFileOutputDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CreateFileOutputDto[] | undefined;
    listOfEntities!: CreateFileOutputDto[][] | undefined;

    constructor(data?: ICreateFileOutputDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(CreateFileOutputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateFileOutputDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateFileOutputDtoListIHandleError>(data, _mappings, CreateFileOutputDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ICreateFileOutputDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CreateFileOutputDto[] | undefined;
    listOfEntities: CreateFileOutputDto[][] | undefined;
}

export class SearchMsFilesInput implements ISearchMsFilesInput {
    searchText!: string | undefined;
    pathType!: number | undefined;
    path!: string | undefined;
    pathId!: string | undefined;
    fileType!: number | undefined;
    isHidePath!: boolean | undefined;
    skip!: number | undefined;
    take!: number | undefined;

    constructor(data?: ISearchMsFilesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            this.pathType = _data["pathType"];
            this.path = _data["path"];
            this.pathId = _data["pathId"];
            this.fileType = _data["fileType"];
            this.isHidePath = _data["isHidePath"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any, _mappings?: any): SearchMsFilesInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SearchMsFilesInput>(data, _mappings, SearchMsFilesInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["pathType"] = this.pathType;
        data["path"] = this.path;
        data["pathId"] = this.pathId;
        data["fileType"] = this.fileType;
        data["isHidePath"] = this.isHidePath;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface ISearchMsFilesInput {
    searchText: string | undefined;
    pathType: number | undefined;
    path: string | undefined;
    pathId: string | undefined;
    fileType: number | undefined;
    isHidePath: boolean | undefined;
    skip: number | undefined;
    take: number | undefined;
}

export class SearchMsOutput implements ISearchMsOutput {
    id!: string | undefined;
    name!: string | undefined;
    webUrl!: string | undefined;
    extension!: string | undefined;
    driveId!: string | undefined;
    siteId!: string | undefined;
    folderId!: string | undefined;
    folderName!: string | undefined;
    siteName!: string | undefined;

    constructor(data?: ISearchMsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.webUrl = _data["webUrl"];
            this.extension = _data["extension"];
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
            this.folderId = _data["folderId"];
            this.folderName = _data["folderName"];
            this.siteName = _data["siteName"];
        }
    }

    static fromJS(data: any, _mappings?: any): SearchMsOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SearchMsOutput>(data, _mappings, SearchMsOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["webUrl"] = this.webUrl;
        data["extension"] = this.extension;
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        data["folderId"] = this.folderId;
        data["folderName"] = this.folderName;
        data["siteName"] = this.siteName;
        return data;
    }
}

export interface ISearchMsOutput {
    id: string | undefined;
    name: string | undefined;
    webUrl: string | undefined;
    extension: string | undefined;
    driveId: string | undefined;
    siteId: string | undefined;
    folderId: string | undefined;
    folderName: string | undefined;
    siteName: string | undefined;
}

export class SearchMsOutputListIHandleError implements ISearchMsOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SearchMsOutput[] | undefined;
    listOfEntities!: SearchMsOutput[][] | undefined;

    constructor(data?: ISearchMsOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(SearchMsOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SearchMsOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SearchMsOutputListIHandleError>(data, _mappings, SearchMsOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ISearchMsOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SearchMsOutput[] | undefined;
    listOfEntities: SearchMsOutput[][] | undefined;
}

export class MsFilePathItemInput implements IMsFilePathItemInput {
    driveId!: string | undefined;
    siteId!: string | undefined;
    folderId!: string | undefined;

    constructor(data?: IMsFilePathItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
            this.folderId = _data["folderId"];
        }
    }

    static fromJS(data: any, _mappings?: any): MsFilePathItemInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsFilePathItemInput>(data, _mappings, MsFilePathItemInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        data["folderId"] = this.folderId;
        return data;
    }
}

export interface IMsFilePathItemInput {
    driveId: string | undefined;
    siteId: string | undefined;
    folderId: string | undefined;
}

export class GetMsFilePathsInput implements IGetMsFilePathsInput {
    items!: MsFilePathItemInput[] | undefined;

    constructor(data?: IGetMsFilePathsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MsFilePathItemInput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetMsFilePathsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetMsFilePathsInput>(data, _mappings, GetMsFilePathsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMsFilePathsInput {
    items: MsFilePathItemInput[] | undefined;
}

export class MsFilePathOutput implements IMsFilePathOutput {
    driveId!: string | undefined;
    siteId!: string | undefined;
    folderId!: string | undefined;
    folderName!: string | undefined;
    siteName!: string | undefined;

    constructor(data?: IMsFilePathOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
            this.folderId = _data["folderId"];
            this.folderName = _data["folderName"];
            this.siteName = _data["siteName"];
        }
    }

    static fromJS(data: any, _mappings?: any): MsFilePathOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsFilePathOutput>(data, _mappings, MsFilePathOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        data["folderId"] = this.folderId;
        data["folderName"] = this.folderName;
        data["siteName"] = this.siteName;
        return data;
    }
}

export interface IMsFilePathOutput {
    driveId: string | undefined;
    siteId: string | undefined;
    folderId: string | undefined;
    folderName: string | undefined;
    siteName: string | undefined;
}

export class MsFilePathOutputListIHandleError implements IMsFilePathOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MsFilePathOutput[] | undefined;
    listOfEntities!: MsFilePathOutput[][] | undefined;

    constructor(data?: IMsFilePathOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(MsFilePathOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MsFilePathOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsFilePathOutputListIHandleError>(data, _mappings, MsFilePathOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IMsFilePathOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MsFilePathOutput[] | undefined;
    listOfEntities: MsFilePathOutput[][] | undefined;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    parentId!: number | undefined;
    code!: string | undefined;
    displayName!: string | undefined;
    memberCount!: number | undefined;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.memberCount = _data["memberCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrganizationUnitDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrganizationUnitDto>(data, _mappings, OrganizationUnitDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        return data;
    }
}

export interface IOrganizationUnitDto {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number | undefined;
}

export class OrganizationUnitDtoListResultDto implements IOrganizationUnitDtoListResultDto {
    items!: OrganizationUnitDto[] | undefined;

    constructor(data?: IOrganizationUnitDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OrganizationUnitDtoListResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrganizationUnitDtoListResultDto>(data, _mappings, OrganizationUnitDtoListResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganizationUnitDtoListResultDto {
    items: OrganizationUnitDto[] | undefined;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    id!: number | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    addedTime!: string | undefined;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.addedTime = _data["addedTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrganizationUnitUserListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrganizationUnitUserListDto>(data, _mappings, OrganizationUnitUserListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime;
        return data;
    }
}

export interface IOrganizationUnitUserListDto {
    id: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: string | undefined;
}

export class OrganizationUnitUserListDtoPagedResultDto implements IOrganizationUnitUserListDtoPagedResultDto {
    items!: OrganizationUnitUserListDto[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IOrganizationUnitUserListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitUserListDto.fromJS(item, _mappings));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrganizationUnitUserListDtoPagedResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrganizationUnitUserListDtoPagedResultDto>(data, _mappings, OrganizationUnitUserListDtoPagedResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IOrganizationUnitUserListDtoPagedResultDto {
    items: OrganizationUnitUserListDto[] | undefined;
    totalCount: number | undefined;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId!: number | undefined;
    displayName!: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateOrganizationUnitInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateOrganizationUnitInput>(data, _mappings, CreateOrganizationUnitInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id!: number | undefined;
    displayName!: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateOrganizationUnitInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateOrganizationUnitInput>(data, _mappings, UpdateOrganizationUnitInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number | undefined;
    displayName: string;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id!: number | undefined;
    newParentId!: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newParentId = _data["newParentId"];
        }
    }

    static fromJS(data: any, _mappings?: any): MoveOrganizationUnitInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MoveOrganizationUnitInput>(data, _mappings, MoveOrganizationUnitInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number | undefined;
    newParentId: number | undefined;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds!: number[] | undefined;
    organizationUnitId!: number | undefined;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UsersToOrganizationUnitInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UsersToOrganizationUnitInput>(data, _mappings, UsersToOrganizationUnitInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number | undefined;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    maxResultCount!: number | undefined;
    skipCount!: number | undefined;
    filter!: string | undefined;
    organizationUnitId!: number | undefined;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any, _mappings?: any): FindOrganizationUnitUsersInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FindOrganizationUnitUsersInput>(data, _mappings, FindOrganizationUnitUsersInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IFindOrganizationUnitUsersInput {
    maxResultCount: number | undefined;
    skipCount: number | undefined;
    filter: string | undefined;
    organizationUnitId: number | undefined;
}

export class NameValueDtoPagedResultDto implements INameValueDtoPagedResultDto {
    items!: NameValueDto[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: INameValueDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item, _mappings));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): NameValueDtoPagedResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NameValueDtoPagedResultDto>(data, _mappings, NameValueDtoPagedResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface INameValueDtoPagedResultDto {
    items: NameValueDto[] | undefined;
    totalCount: number | undefined;
}

export enum IntelligenceStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

export enum IntelligenceCategory {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum IntelligenceStrength {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum IntelligenceFactSourceKind {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class OrgIntelligenceFactDto implements IOrgIntelligenceFactDto {
    id!: number | undefined;
    category!: IntelligenceCategory | undefined;
    factKey!: string | undefined;
    label!: string | undefined;
    value!: string | undefined;
    strength!: IntelligenceStrength | undefined;
    originFlags!: KnowledgeOrigin | undefined;
    primaryOrigin!: KnowledgeOrigin | undefined;
    isConfirmedByUser!: boolean | undefined;
    sourceKind!: IntelligenceFactSourceKind | undefined;
    canEdit!: boolean | undefined;
    canRemove!: boolean | undefined;
    revision!: number | undefined;
    sortOrder!: number | undefined;

    constructor(data?: IOrgIntelligenceFactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.factKey = _data["factKey"];
            this.label = _data["label"];
            this.value = _data["value"];
            this.strength = _data["strength"];
            this.originFlags = _data["originFlags"];
            this.primaryOrigin = _data["primaryOrigin"];
            this.isConfirmedByUser = _data["isConfirmedByUser"];
            this.sourceKind = _data["sourceKind"];
            this.canEdit = _data["canEdit"];
            this.canRemove = _data["canRemove"];
            this.revision = _data["revision"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrgIntelligenceFactDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrgIntelligenceFactDto>(data, _mappings, OrgIntelligenceFactDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["factKey"] = this.factKey;
        data["label"] = this.label;
        data["value"] = this.value;
        data["strength"] = this.strength;
        data["originFlags"] = this.originFlags;
        data["primaryOrigin"] = this.primaryOrigin;
        data["isConfirmedByUser"] = this.isConfirmedByUser;
        data["sourceKind"] = this.sourceKind;
        data["canEdit"] = this.canEdit;
        data["canRemove"] = this.canRemove;
        data["revision"] = this.revision;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IOrgIntelligenceFactDto {
    id: number | undefined;
    category: IntelligenceCategory | undefined;
    factKey: string | undefined;
    label: string | undefined;
    value: string | undefined;
    strength: IntelligenceStrength | undefined;
    originFlags: KnowledgeOrigin | undefined;
    primaryOrigin: KnowledgeOrigin | undefined;
    isConfirmedByUser: boolean | undefined;
    sourceKind: IntelligenceFactSourceKind | undefined;
    canEdit: boolean | undefined;
    canRemove: boolean | undefined;
    revision: number | undefined;
    sortOrder: number | undefined;
}

export class OrgIntelligenceSuggestionDto implements IOrgIntelligenceSuggestionDto {
    id!: number | undefined;
    category!: IntelligenceCategory | undefined;
    factKey!: string | undefined;
    label!: string | undefined;
    proposedValue!: string | undefined;
    existingFactId!: number | undefined;
    existingValue!: string | undefined;
    existingFactRevision!: number | undefined;

    constructor(data?: IOrgIntelligenceSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.factKey = _data["factKey"];
            this.label = _data["label"];
            this.proposedValue = _data["proposedValue"];
            this.existingFactId = _data["existingFactId"];
            this.existingValue = _data["existingValue"];
            this.existingFactRevision = _data["existingFactRevision"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrgIntelligenceSuggestionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrgIntelligenceSuggestionDto>(data, _mappings, OrgIntelligenceSuggestionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["factKey"] = this.factKey;
        data["label"] = this.label;
        data["proposedValue"] = this.proposedValue;
        data["existingFactId"] = this.existingFactId;
        data["existingValue"] = this.existingValue;
        data["existingFactRevision"] = this.existingFactRevision;
        return data;
    }
}

export interface IOrgIntelligenceSuggestionDto {
    id: number | undefined;
    category: IntelligenceCategory | undefined;
    factKey: string | undefined;
    label: string | undefined;
    proposedValue: string | undefined;
    existingFactId: number | undefined;
    existingValue: string | undefined;
    existingFactRevision: number | undefined;
}

export enum IntelligenceSourceType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class OrgIntelligenceSourceDto implements IOrgIntelligenceSourceDto {
    sourceType!: IntelligenceSourceType | undefined;
    isAuthorized!: boolean | undefined;
    isUsed!: boolean | undefined;

    constructor(data?: IOrgIntelligenceSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sourceType = _data["sourceType"];
            this.isAuthorized = _data["isAuthorized"];
            this.isUsed = _data["isUsed"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrgIntelligenceSourceDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrgIntelligenceSourceDto>(data, _mappings, OrgIntelligenceSourceDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceType"] = this.sourceType;
        data["isAuthorized"] = this.isAuthorized;
        data["isUsed"] = this.isUsed;
        return data;
    }
}

export interface IOrgIntelligenceSourceDto {
    sourceType: IntelligenceSourceType | undefined;
    isAuthorized: boolean | undefined;
    isUsed: boolean | undefined;
}

export class OrgIntelligenceDto implements IOrgIntelligenceDto {
    isEnabled!: boolean | undefined;
    status!: IntelligenceStatus | undefined;
    revision!: number | undefined;
    firmCategory!: FirmCategory | undefined;
    lastSuccessfulScanAtUtc!: string | undefined;
    lastKnowledgeChangedAtUtc!: string | undefined;
    currentJobId!: number | undefined;
    currentStage!: DiscoveryStage | undefined;
    lastErrorCode!: string | undefined;
    facts!: OrgIntelligenceFactDto[] | undefined;
    pendingSuggestion!: OrgIntelligenceSuggestionDto | undefined;
    sources!: OrgIntelligenceSourceDto[] | undefined;
    projectLabelPlural!: string | undefined;
    canToggle!: boolean | undefined;
    canEdit!: boolean | undefined;
    asOfUtc!: string | undefined;

    constructor(data?: IOrgIntelligenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.status = _data["status"];
            this.revision = _data["revision"];
            this.firmCategory = _data["firmCategory"];
            this.lastSuccessfulScanAtUtc = _data["lastSuccessfulScanAtUtc"];
            this.lastKnowledgeChangedAtUtc = _data["lastKnowledgeChangedAtUtc"];
            this.currentJobId = _data["currentJobId"];
            this.currentStage = _data["currentStage"];
            this.lastErrorCode = _data["lastErrorCode"];
            if (Array.isArray(_data["facts"])) {
                this.facts = [] as any;
                for (let item of _data["facts"])
                    this.facts!.push(OrgIntelligenceFactDto.fromJS(item, _mappings));
            }
            this.pendingSuggestion = _data["pendingSuggestion"] ? OrgIntelligenceSuggestionDto.fromJS(_data["pendingSuggestion"], _mappings) : undefined as any;
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(OrgIntelligenceSourceDto.fromJS(item, _mappings));
            }
            this.projectLabelPlural = _data["projectLabelPlural"];
            this.canToggle = _data["canToggle"];
            this.canEdit = _data["canEdit"];
            this.asOfUtc = _data["asOfUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrgIntelligenceDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrgIntelligenceDto>(data, _mappings, OrgIntelligenceDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["status"] = this.status;
        data["revision"] = this.revision;
        data["firmCategory"] = this.firmCategory;
        data["lastSuccessfulScanAtUtc"] = this.lastSuccessfulScanAtUtc;
        data["lastKnowledgeChangedAtUtc"] = this.lastKnowledgeChangedAtUtc;
        data["currentJobId"] = this.currentJobId;
        data["currentStage"] = this.currentStage;
        data["lastErrorCode"] = this.lastErrorCode;
        if (Array.isArray(this.facts)) {
            data["facts"] = [];
            for (let item of this.facts)
                data["facts"].push(item ? item.toJSON() : undefined as any);
        }
        data["pendingSuggestion"] = this.pendingSuggestion ? this.pendingSuggestion.toJSON() : undefined as any;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectLabelPlural"] = this.projectLabelPlural;
        data["canToggle"] = this.canToggle;
        data["canEdit"] = this.canEdit;
        data["asOfUtc"] = this.asOfUtc;
        return data;
    }
}

export interface IOrgIntelligenceDto {
    isEnabled: boolean | undefined;
    status: IntelligenceStatus | undefined;
    revision: number | undefined;
    firmCategory: FirmCategory | undefined;
    lastSuccessfulScanAtUtc: string | undefined;
    lastKnowledgeChangedAtUtc: string | undefined;
    currentJobId: number | undefined;
    currentStage: DiscoveryStage | undefined;
    lastErrorCode: string | undefined;
    facts: OrgIntelligenceFactDto[] | undefined;
    pendingSuggestion: OrgIntelligenceSuggestionDto | undefined;
    sources: OrgIntelligenceSourceDto[] | undefined;
    projectLabelPlural: string | undefined;
    canToggle: boolean | undefined;
    canEdit: boolean | undefined;
    asOfUtc: string | undefined;
}

export class SetOrgIntelligenceEnabledInput implements ISetOrgIntelligenceEnabledInput {
    enabled!: boolean | undefined;
    expectedRevision!: number | undefined;

    constructor(data?: ISetOrgIntelligenceEnabledInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.expectedRevision = _data["expectedRevision"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetOrgIntelligenceEnabledInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetOrgIntelligenceEnabledInput>(data, _mappings, SetOrgIntelligenceEnabledInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["expectedRevision"] = this.expectedRevision;
        return data;
    }
}

export interface ISetOrgIntelligenceEnabledInput {
    enabled: boolean | undefined;
    expectedRevision: number | undefined;
}

export class CreateOrgIntelligenceFactInput implements ICreateOrgIntelligenceFactInput {
    category!: IntelligenceCategory | undefined;
    factKey!: string | undefined;
    label!: string | undefined;
    value!: string;

    constructor(data?: ICreateOrgIntelligenceFactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.category = _data["category"];
            this.factKey = _data["factKey"];
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateOrgIntelligenceFactInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateOrgIntelligenceFactInput>(data, _mappings, CreateOrgIntelligenceFactInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["factKey"] = this.factKey;
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ICreateOrgIntelligenceFactInput {
    category: IntelligenceCategory | undefined;
    factKey: string | undefined;
    label: string | undefined;
    value: string;
}

export class UpdateOrgIntelligenceFactInput implements IUpdateOrgIntelligenceFactInput {
    factId!: number | undefined;
    expectedRevision!: number | undefined;
    label!: string | undefined;
    value!: string;

    constructor(data?: IUpdateOrgIntelligenceFactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.factId = _data["factId"];
            this.expectedRevision = _data["expectedRevision"];
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateOrgIntelligenceFactInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateOrgIntelligenceFactInput>(data, _mappings, UpdateOrgIntelligenceFactInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factId"] = this.factId;
        data["expectedRevision"] = this.expectedRevision;
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateOrgIntelligenceFactInput {
    factId: number | undefined;
    expectedRevision: number | undefined;
    label: string | undefined;
    value: string;
}

export class DeleteOrgIntelligenceFactInput implements IDeleteOrgIntelligenceFactInput {
    factId!: number | undefined;
    expectedRevision!: number | undefined;

    constructor(data?: IDeleteOrgIntelligenceFactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.factId = _data["factId"];
            this.expectedRevision = _data["expectedRevision"];
        }
    }

    static fromJS(data: any, _mappings?: any): DeleteOrgIntelligenceFactInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DeleteOrgIntelligenceFactInput>(data, _mappings, DeleteOrgIntelligenceFactInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factId"] = this.factId;
        data["expectedRevision"] = this.expectedRevision;
        return data;
    }
}

export interface IDeleteOrgIntelligenceFactInput {
    factId: number | undefined;
    expectedRevision: number | undefined;
}

export class ResolveOrgIntelligenceSuggestionInput implements IResolveOrgIntelligenceSuggestionInput {
    suggestionId!: number | undefined;
    expectedExistingFactRevision!: number | undefined;

    constructor(data?: IResolveOrgIntelligenceSuggestionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.suggestionId = _data["suggestionId"];
            this.expectedExistingFactRevision = _data["expectedExistingFactRevision"];
        }
    }

    static fromJS(data: any, _mappings?: any): ResolveOrgIntelligenceSuggestionInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ResolveOrgIntelligenceSuggestionInput>(data, _mappings, ResolveOrgIntelligenceSuggestionInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggestionId"] = this.suggestionId;
        data["expectedExistingFactRevision"] = this.expectedExistingFactRevision;
        return data;
    }
}

export interface IResolveOrgIntelligenceSuggestionInput {
    suggestionId: number | undefined;
    expectedExistingFactRevision: number | undefined;
}

export class SaveOrgIntelligenceCommunicationNoteInput implements ISaveOrgIntelligenceCommunicationNoteInput {
    text!: string | undefined;
    expectedRevision!: number | undefined;

    constructor(data?: ISaveOrgIntelligenceCommunicationNoteInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.text = _data["text"];
            this.expectedRevision = _data["expectedRevision"];
        }
    }

    static fromJS(data: any, _mappings?: any): SaveOrgIntelligenceCommunicationNoteInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveOrgIntelligenceCommunicationNoteInput>(data, _mappings, SaveOrgIntelligenceCommunicationNoteInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["expectedRevision"] = this.expectedRevision;
        return data;
    }
}

export interface ISaveOrgIntelligenceCommunicationNoteInput {
    text: string | undefined;
    expectedRevision: number | undefined;
}

export class ApiOptions implements IApiOptions {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    integrationId!: number | undefined;
    integrationUserId!: string | undefined;
    linkedEmail!: string | undefined;
    isConfigured!: boolean | undefined;
    integrationCode!: number | undefined;
    scope!: string | undefined;
    defaultScope!: string | undefined;
    name!: string | undefined;
    redirectUri!: string | undefined;
    code!: string | undefined;
    grantType!: string | undefined;
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    graphApiTokenUrl!: string | undefined;
    graphApiAuthorizeUrl!: string | undefined;
    graphApiEventUrl!: string | undefined;
    isOutlookConfig!: boolean | undefined;
    graphApiCalendarsUrl!: string | undefined;
    responseType!: string | undefined;
    responseMode!: string | undefined;

    constructor(data?: IApiOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.integrationId = _data["integrationId"];
            this.integrationUserId = _data["integrationUserId"];
            this.linkedEmail = _data["linkedEmail"];
            this.isConfigured = _data["isConfigured"];
            this.integrationCode = _data["integrationCode"];
            this.scope = _data["scope"];
            this.defaultScope = _data["defaultScope"];
            this.name = _data["name"];
            this.redirectUri = _data["redirectUri"];
            this.code = _data["code"];
            this.grantType = _data["grantType"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.graphApiTokenUrl = _data["graphApiTokenUrl"];
            this.graphApiAuthorizeUrl = _data["graphApiAuthorizeUrl"];
            this.graphApiEventUrl = _data["graphApiEventUrl"];
            this.isOutlookConfig = _data["isOutlookConfig"];
            this.graphApiCalendarsUrl = _data["graphApiCalendarsUrl"];
            this.responseType = _data["responseType"];
            this.responseMode = _data["responseMode"];
        }
    }

    static fromJS(data: any, _mappings?: any): ApiOptions | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApiOptions>(data, _mappings, ApiOptions);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["integrationId"] = this.integrationId;
        data["integrationUserId"] = this.integrationUserId;
        data["linkedEmail"] = this.linkedEmail;
        data["isConfigured"] = this.isConfigured;
        data["integrationCode"] = this.integrationCode;
        data["scope"] = this.scope;
        data["defaultScope"] = this.defaultScope;
        data["name"] = this.name;
        data["redirectUri"] = this.redirectUri;
        data["code"] = this.code;
        data["grantType"] = this.grantType;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["graphApiTokenUrl"] = this.graphApiTokenUrl;
        data["graphApiAuthorizeUrl"] = this.graphApiAuthorizeUrl;
        data["graphApiEventUrl"] = this.graphApiEventUrl;
        data["isOutlookConfig"] = this.isOutlookConfig;
        data["graphApiCalendarsUrl"] = this.graphApiCalendarsUrl;
        data["responseType"] = this.responseType;
        data["responseMode"] = this.responseMode;
        return data;
    }
}

export interface IApiOptions {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    integrationId: number | undefined;
    integrationUserId: string | undefined;
    linkedEmail: string | undefined;
    isConfigured: boolean | undefined;
    integrationCode: number | undefined;
    scope: string | undefined;
    defaultScope: string | undefined;
    name: string | undefined;
    redirectUri: string | undefined;
    code: string | undefined;
    grantType: string | undefined;
    clientId: string | undefined;
    clientSecret: string | undefined;
    graphApiTokenUrl: string | undefined;
    graphApiAuthorizeUrl: string | undefined;
    graphApiEventUrl: string | undefined;
    isOutlookConfig: boolean | undefined;
    graphApiCalendarsUrl: string | undefined;
    responseType: string | undefined;
    responseMode: string | undefined;
}

export class ApiOptionsListIHandleError implements IApiOptionsListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ApiOptions[] | undefined;
    listOfEntities!: ApiOptions[][] | undefined;

    constructor(data?: IApiOptionsListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ApiOptions.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ApiOptionsListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApiOptionsListIHandleError>(data, _mappings, ApiOptionsListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IApiOptionsListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ApiOptions[] | undefined;
    listOfEntities: ApiOptions[][] | undefined;
}

export class ApiOptionsIHandleError implements IApiOptionsIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ApiOptions | undefined;
    listOfEntities!: ApiOptions[] | undefined;

    constructor(data?: IApiOptionsIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ApiOptions.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ApiOptions.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ApiOptionsIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApiOptionsIHandleError>(data, _mappings, ApiOptionsIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IApiOptionsIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ApiOptions | undefined;
    listOfEntities: ApiOptions[] | undefined;
}

export class UserProfile implements IUserProfile {
    odatacontext!: string | undefined;
    businessPhones!: string[] | undefined;
    displayName!: string | undefined;
    givenName!: string | undefined;
    jobTitle!: string | undefined;
    mail!: string | undefined;
    mobilePhone!: string | undefined;
    officeLocation!: string | undefined;
    preferredLanguage!: string | undefined;
    surname!: string | undefined;
    userPrincipalName!: string | undefined;
    id!: string | undefined;
    userId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    middleName!: string | undefined;
    emailAddress!: string | undefined;
    userName!: string | undefined;
    profilePictureUrl!: string | undefined;
    city!: string | undefined;
    country!: string | undefined;
    companyTZ!: string | undefined;
    birthday!: string | undefined;
    birthDate!: string | undefined;
    birthMonth!: string | undefined;

    constructor(data?: IUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.odatacontext = _data["odatacontext"];
            if (Array.isArray(_data["businessPhones"])) {
                this.businessPhones = [] as any;
                for (let item of _data["businessPhones"])
                    this.businessPhones!.push(item);
            }
            this.displayName = _data["displayName"];
            this.givenName = _data["givenName"];
            this.jobTitle = _data["jobTitle"];
            this.mail = _data["mail"];
            this.mobilePhone = _data["mobilePhone"];
            this.officeLocation = _data["officeLocation"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.surname = _data["surname"];
            this.userPrincipalName = _data["userPrincipalName"];
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.emailAddress = _data["emailAddress"];
            this.userName = _data["userName"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.companyTZ = _data["companyTZ"];
            this.birthday = _data["birthday"];
            this.birthDate = _data["birthDate"];
            this.birthMonth = _data["birthMonth"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserProfile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserProfile>(data, _mappings, UserProfile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["odatacontext"] = this.odatacontext;
        if (Array.isArray(this.businessPhones)) {
            data["businessPhones"] = [];
            for (let item of this.businessPhones)
                data["businessPhones"].push(item);
        }
        data["displayName"] = this.displayName;
        data["givenName"] = this.givenName;
        data["jobTitle"] = this.jobTitle;
        data["mail"] = this.mail;
        data["mobilePhone"] = this.mobilePhone;
        data["officeLocation"] = this.officeLocation;
        data["preferredLanguage"] = this.preferredLanguage;
        data["surname"] = this.surname;
        data["userPrincipalName"] = this.userPrincipalName;
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["emailAddress"] = this.emailAddress;
        data["userName"] = this.userName;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["city"] = this.city;
        data["country"] = this.country;
        data["companyTZ"] = this.companyTZ;
        data["birthday"] = this.birthday;
        data["birthDate"] = this.birthDate;
        data["birthMonth"] = this.birthMonth;
        return data;
    }
}

export interface IUserProfile {
    odatacontext: string | undefined;
    businessPhones: string[] | undefined;
    displayName: string | undefined;
    givenName: string | undefined;
    jobTitle: string | undefined;
    mail: string | undefined;
    mobilePhone: string | undefined;
    officeLocation: string | undefined;
    preferredLanguage: string | undefined;
    surname: string | undefined;
    userPrincipalName: string | undefined;
    id: string | undefined;
    userId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    middleName: string | undefined;
    emailAddress: string | undefined;
    userName: string | undefined;
    profilePictureUrl: string | undefined;
    city: string | undefined;
    country: string | undefined;
    companyTZ: string | undefined;
    birthday: string | undefined;
    birthDate: string | undefined;
    birthMonth: string | undefined;
}

export class TokenDetail implements ITokenDetail {
    token_type!: string | undefined;
    scope!: string | undefined;
    expires_in!: number | undefined;
    ext_expires_in!: number | undefined;
    access_token!: string | undefined;
    refresh_token!: string | undefined;
    id_token!: string | undefined;
    user_id!: number | undefined;
    tenant_id!: number | undefined;
    integration_id!: number | undefined;
    integration_code!: number | undefined;
    email!: string | undefined;
    code!: string | undefined;
    userProfile!: UserProfile | undefined;
    profilePictureId!: string | undefined;
    expiresAtUtc!: string | undefined;

    constructor(data?: ITokenDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.token_type = _data["token_type"];
            this.scope = _data["scope"];
            this.expires_in = _data["expires_in"];
            this.ext_expires_in = _data["ext_expires_in"];
            this.access_token = _data["access_token"];
            this.refresh_token = _data["refresh_token"];
            this.id_token = _data["id_token"];
            this.user_id = _data["user_id"];
            this.tenant_id = _data["tenant_id"];
            this.integration_id = _data["integration_id"];
            this.integration_code = _data["integration_code"];
            this.email = _data["email"];
            this.code = _data["code"];
            this.userProfile = _data["userProfile"] ? UserProfile.fromJS(_data["userProfile"], _mappings) : undefined as any;
            this.profilePictureId = _data["profilePictureId"];
            this.expiresAtUtc = _data["expiresAtUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): TokenDetail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TokenDetail>(data, _mappings, TokenDetail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token_type"] = this.token_type;
        data["scope"] = this.scope;
        data["expires_in"] = this.expires_in;
        data["ext_expires_in"] = this.ext_expires_in;
        data["access_token"] = this.access_token;
        data["refresh_token"] = this.refresh_token;
        data["id_token"] = this.id_token;
        data["user_id"] = this.user_id;
        data["tenant_id"] = this.tenant_id;
        data["integration_id"] = this.integration_id;
        data["integration_code"] = this.integration_code;
        data["email"] = this.email;
        data["code"] = this.code;
        data["userProfile"] = this.userProfile ? this.userProfile.toJSON() : undefined as any;
        data["profilePictureId"] = this.profilePictureId;
        data["expiresAtUtc"] = this.expiresAtUtc;
        return data;
    }
}

export interface ITokenDetail {
    token_type: string | undefined;
    scope: string | undefined;
    expires_in: number | undefined;
    ext_expires_in: number | undefined;
    access_token: string | undefined;
    refresh_token: string | undefined;
    id_token: string | undefined;
    user_id: number | undefined;
    tenant_id: number | undefined;
    integration_id: number | undefined;
    integration_code: number | undefined;
    email: string | undefined;
    code: string | undefined;
    userProfile: UserProfile | undefined;
    profilePictureId: string | undefined;
    expiresAtUtc: string | undefined;
}

export class TokenDetailIHandleError implements ITokenDetailIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TokenDetail | undefined;
    listOfEntities!: TokenDetail[] | undefined;

    constructor(data?: ITokenDetailIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TokenDetail.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TokenDetail.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TokenDetailIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TokenDetailIHandleError>(data, _mappings, TokenDetailIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITokenDetailIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TokenDetail | undefined;
    listOfEntities: TokenDetail[] | undefined;
}

export class OutlookEventDetailsAttendeesListValueTuple implements IOutlookEventDetailsAttendeesListValueTuple {

    constructor(data?: IOutlookEventDetailsAttendeesListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): OutlookEventDetailsAttendeesListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OutlookEventDetailsAttendeesListValueTuple>(data, _mappings, OutlookEventDetailsAttendeesListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IOutlookEventDetailsAttendeesListValueTuple {
}

export class OutlookEventDetailsAttendeesListIHandleError implements IOutlookEventDetailsAttendeesListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    message_Info!: string | undefined;
    responseData!: OutlookEventDetailsAttendeesListValueTuple | undefined;

    constructor(data?: IOutlookEventDetailsAttendeesListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? OutlookEventDetailsAttendeesListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): OutlookEventDetailsAttendeesListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OutlookEventDetailsAttendeesListIHandleError>(data, _mappings, OutlookEventDetailsAttendeesListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        return data;
    }
}

export interface IOutlookEventDetailsAttendeesListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    message_Info: string | undefined;
    responseData: OutlookEventDetailsAttendeesListValueTuple | undefined;
}

export enum UpdateType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class UpdatePlannerDto implements IUpdatePlannerDto {
    taskId!: string | undefined;
    bucketId!: string | undefined;
    odataEtagId!: string | undefined;
    odataEtagDescId!: string | undefined;
    updateType!: UpdateType | undefined;
    title!: string | undefined;
    description!: string | undefined;
    startDateTime!: string | undefined;
    dueDateTime!: string | undefined;
    percentComplete!: number | undefined;
    checkListId!: string | undefined;
    isChecked!: boolean | undefined;
    checkListTitle!: string | undefined;
    attachmentName!: string | undefined;
    attachmentUrl!: string | undefined;
    attachmentType!: string | undefined;
    isAttachmentDelete!: boolean | undefined;
    isCheckListDelete!: boolean | undefined;

    constructor(data?: IUpdatePlannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.bucketId = _data["bucketId"];
            this.odataEtagId = _data["odataEtagId"];
            this.odataEtagDescId = _data["odataEtagDescId"];
            this.updateType = _data["updateType"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startDateTime = _data["startDateTime"];
            this.dueDateTime = _data["dueDateTime"];
            this.percentComplete = _data["percentComplete"];
            this.checkListId = _data["checkListId"];
            this.isChecked = _data["isChecked"];
            this.checkListTitle = _data["checkListTitle"];
            this.attachmentName = _data["attachmentName"];
            this.attachmentUrl = _data["attachmentUrl"];
            this.attachmentType = _data["attachmentType"];
            this.isAttachmentDelete = _data["isAttachmentDelete"];
            this.isCheckListDelete = _data["isCheckListDelete"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdatePlannerDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdatePlannerDto>(data, _mappings, UpdatePlannerDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["bucketId"] = this.bucketId;
        data["odataEtagId"] = this.odataEtagId;
        data["odataEtagDescId"] = this.odataEtagDescId;
        data["updateType"] = this.updateType;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startDateTime"] = this.startDateTime;
        data["dueDateTime"] = this.dueDateTime;
        data["percentComplete"] = this.percentComplete;
        data["checkListId"] = this.checkListId;
        data["isChecked"] = this.isChecked;
        data["checkListTitle"] = this.checkListTitle;
        data["attachmentName"] = this.attachmentName;
        data["attachmentUrl"] = this.attachmentUrl;
        data["attachmentType"] = this.attachmentType;
        data["isAttachmentDelete"] = this.isAttachmentDelete;
        data["isCheckListDelete"] = this.isCheckListDelete;
        return data;
    }
}

export interface IUpdatePlannerDto {
    taskId: string | undefined;
    bucketId: string | undefined;
    odataEtagId: string | undefined;
    odataEtagDescId: string | undefined;
    updateType: UpdateType | undefined;
    title: string | undefined;
    description: string | undefined;
    startDateTime: string | undefined;
    dueDateTime: string | undefined;
    percentComplete: number | undefined;
    checkListId: string | undefined;
    isChecked: boolean | undefined;
    checkListTitle: string | undefined;
    attachmentName: string | undefined;
    attachmentUrl: string | undefined;
    attachmentType: string | undefined;
    isAttachmentDelete: boolean | undefined;
    isCheckListDelete: boolean | undefined;
}

export enum AttendeeType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class TimeSlot implements ITimeSlot {
    end!: DateTimeTimeZone | undefined;
    start!: DateTimeTimeZone | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: ITimeSlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.end = _data["end"] ? DateTimeTimeZone.fromJS(_data["end"], _mappings) : undefined as any;
            this.start = _data["start"] ? DateTimeTimeZone.fromJS(_data["start"], _mappings) : undefined as any;
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): TimeSlot | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TimeSlot>(data, _mappings, TimeSlot);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["end"] = this.end ? this.end.toJSON() : undefined as any;
        data["start"] = this.start ? this.start.toJSON() : undefined as any;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface ITimeSlot {
    end: DateTimeTimeZone | undefined;
    start: DateTimeTimeZone | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export enum ResponseType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class ResponseStatus implements IResponseStatus {
    response!: ResponseType | undefined;
    time!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IResponseStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.response = _data["response"];
            this.time = _data["time"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): ResponseStatus | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ResponseStatus>(data, _mappings, ResponseStatus);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response;
        data["time"] = this.time;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IResponseStatus {
    response: ResponseType | undefined;
    time: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export class MeetingAttendees implements IMeetingAttendees {
    emailAddress!: EmailAddress | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;
    type!: AttendeeType | undefined;
    proposedNewTime!: TimeSlot | undefined;
    status!: ResponseStatus | undefined;

    constructor(data?: IMeetingAttendees) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"] ? EmailAddress.fromJS(_data["emailAddress"], _mappings) : undefined as any;
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
            this.type = _data["type"];
            this.proposedNewTime = _data["proposedNewTime"] ? TimeSlot.fromJS(_data["proposedNewTime"], _mappings) : undefined as any;
            this.status = _data["status"] ? ResponseStatus.fromJS(_data["status"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): MeetingAttendees | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MeetingAttendees>(data, _mappings, MeetingAttendees);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress ? this.emailAddress.toJSON() : undefined as any;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        data["type"] = this.type;
        data["proposedNewTime"] = this.proposedNewTime ? this.proposedNewTime.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        return data;
    }
}

export interface IMeetingAttendees {
    emailAddress: EmailAddress | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
    type: AttendeeType | undefined;
    proposedNewTime: TimeSlot | undefined;
    status: ResponseStatus | undefined;
}

export class CreateMeetingInputDto implements ICreateMeetingInputDto {
    id!: number | undefined;
    eventId!: string | undefined;
    subject!: string | undefined;
    description!: string | undefined;
    startDate!: string | undefined;
    startTime!: string | undefined;
    endDate!: string | undefined;
    endTime!: string | undefined;
    recurrencePatternType!: RecurrencePatternType | undefined;
    attendees!: MeetingAttendees[] | undefined;
    reminderMinutesBeforeStart!: number | undefined;
    projectId!: number | undefined;
    meetingType!: number | undefined;
    isOnlineMeeting!: boolean | undefined;
    isAddToMyDay!: boolean | undefined;

    constructor(data?: ICreateMeetingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventId = _data["eventId"];
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.startDate = _data["startDate"];
            this.startTime = _data["startTime"];
            this.endDate = _data["endDate"];
            this.endTime = _data["endTime"];
            this.recurrencePatternType = _data["recurrencePatternType"];
            if (Array.isArray(_data["attendees"])) {
                this.attendees = [] as any;
                for (let item of _data["attendees"])
                    this.attendees!.push(MeetingAttendees.fromJS(item, _mappings));
            }
            this.reminderMinutesBeforeStart = _data["reminderMinutesBeforeStart"];
            this.projectId = _data["projectId"];
            this.meetingType = _data["meetingType"];
            this.isOnlineMeeting = _data["isOnlineMeeting"];
            this.isAddToMyDay = _data["isAddToMyDay"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateMeetingInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateMeetingInputDto>(data, _mappings, CreateMeetingInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventId"] = this.eventId;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["startDate"] = this.startDate;
        data["startTime"] = this.startTime;
        data["endDate"] = this.endDate;
        data["endTime"] = this.endTime;
        data["recurrencePatternType"] = this.recurrencePatternType;
        if (Array.isArray(this.attendees)) {
            data["attendees"] = [];
            for (let item of this.attendees)
                data["attendees"].push(item ? item.toJSON() : undefined as any);
        }
        data["reminderMinutesBeforeStart"] = this.reminderMinutesBeforeStart;
        data["projectId"] = this.projectId;
        data["meetingType"] = this.meetingType;
        data["isOnlineMeeting"] = this.isOnlineMeeting;
        data["isAddToMyDay"] = this.isAddToMyDay;
        return data;
    }
}

export interface ICreateMeetingInputDto {
    id: number | undefined;
    eventId: string | undefined;
    subject: string | undefined;
    description: string | undefined;
    startDate: string | undefined;
    startTime: string | undefined;
    endDate: string | undefined;
    endTime: string | undefined;
    recurrencePatternType: RecurrencePatternType | undefined;
    attendees: MeetingAttendees[] | undefined;
    reminderMinutesBeforeStart: number | undefined;
    projectId: number | undefined;
    meetingType: number | undefined;
    isOnlineMeeting: boolean | undefined;
    isAddToMyDay: boolean | undefined;
}

export enum SelectionLikelihoodInfo {
    _0 = 0,
    _1 = 1,
}

export class ScoredEmailAddress implements IScoredEmailAddress {
    address!: string | undefined;
    itemId!: string | undefined;
    relevanceScore!: number | undefined;
    selectionLikelihood!: SelectionLikelihoodInfo | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IScoredEmailAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.address = _data["address"];
            this.itemId = _data["itemId"];
            this.relevanceScore = _data["relevanceScore"];
            this.selectionLikelihood = _data["selectionLikelihood"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): ScoredEmailAddress | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ScoredEmailAddress>(data, _mappings, ScoredEmailAddress);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["itemId"] = this.itemId;
        data["relevanceScore"] = this.relevanceScore;
        data["selectionLikelihood"] = this.selectionLikelihood;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IScoredEmailAddress {
    address: string | undefined;
    itemId: string | undefined;
    relevanceScore: number | undefined;
    selectionLikelihood: SelectionLikelihoodInfo | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export class PhysicalAddress implements IPhysicalAddress {
    city!: string | undefined;
    countryOrRegion!: string | undefined;
    postalCode!: string | undefined;
    state!: string | undefined;
    street!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IPhysicalAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.city = _data["city"];
            this.countryOrRegion = _data["countryOrRegion"];
            this.postalCode = _data["postalCode"];
            this.state = _data["state"];
            this.street = _data["street"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): PhysicalAddress | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PhysicalAddress>(data, _mappings, PhysicalAddress);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["countryOrRegion"] = this.countryOrRegion;
        data["postalCode"] = this.postalCode;
        data["state"] = this.state;
        data["street"] = this.street;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IPhysicalAddress {
    city: string | undefined;
    countryOrRegion: string | undefined;
    postalCode: string | undefined;
    state: string | undefined;
    street: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export class OutlookGeoCoordinates implements IOutlookGeoCoordinates {
    accuracy!: number | undefined;
    altitude!: number | undefined;
    altitudeAccuracy!: number | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IOutlookGeoCoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.accuracy = _data["accuracy"];
            this.altitude = _data["altitude"];
            this.altitudeAccuracy = _data["altitudeAccuracy"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): OutlookGeoCoordinates | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OutlookGeoCoordinates>(data, _mappings, OutlookGeoCoordinates);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accuracy"] = this.accuracy;
        data["altitude"] = this.altitude;
        data["altitudeAccuracy"] = this.altitudeAccuracy;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IOutlookGeoCoordinates {
    accuracy: number | undefined;
    altitude: number | undefined;
    altitudeAccuracy: number | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export enum LocationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export enum LocationUniqueIdType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class Location implements ILocation {
    address!: PhysicalAddress | undefined;
    coordinates!: OutlookGeoCoordinates | undefined;
    displayName!: string | undefined;
    locationEmailAddress!: string | undefined;
    locationType!: LocationType | undefined;
    locationUri!: string | undefined;
    uniqueId!: string | undefined;
    uniqueIdType!: LocationUniqueIdType | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.address = _data["address"] ? PhysicalAddress.fromJS(_data["address"], _mappings) : undefined as any;
            this.coordinates = _data["coordinates"] ? OutlookGeoCoordinates.fromJS(_data["coordinates"], _mappings) : undefined as any;
            this.displayName = _data["displayName"];
            this.locationEmailAddress = _data["locationEmailAddress"];
            this.locationType = _data["locationType"];
            this.locationUri = _data["locationUri"];
            this.uniqueId = _data["uniqueId"];
            this.uniqueIdType = _data["uniqueIdType"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): Location | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Location>(data, _mappings, Location);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : undefined as any;
        data["displayName"] = this.displayName;
        data["locationEmailAddress"] = this.locationEmailAddress;
        data["locationType"] = this.locationType;
        data["locationUri"] = this.locationUri;
        data["uniqueId"] = this.uniqueId;
        data["uniqueIdType"] = this.uniqueIdType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface ILocation {
    address: PhysicalAddress | undefined;
    coordinates: OutlookGeoCoordinates | undefined;
    displayName: string | undefined;
    locationEmailAddress: string | undefined;
    locationType: LocationType | undefined;
    locationUri: string | undefined;
    uniqueId: string | undefined;
    uniqueIdType: LocationUniqueIdType | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export enum PhoneType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export class Phone implements IPhone {
    language!: string | undefined;
    number!: string | undefined;
    region!: string | undefined;
    type!: PhoneType | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.language = _data["language"];
            this.number = _data["number"];
            this.region = _data["region"];
            this.type = _data["type"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): Phone | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Phone>(data, _mappings, Phone);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["number"] = this.number;
        data["region"] = this.region;
        data["type"] = this.type;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IPhone {
    language: string | undefined;
    number: string | undefined;
    region: string | undefined;
    type: PhoneType | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export class PersonType implements IPersonType {
    class!: string | undefined;
    subclass!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IPersonType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.class = _data["class"];
            this.subclass = _data["subclass"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): PersonType | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PersonType>(data, _mappings, PersonType);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["class"] = this.class;
        data["subclass"] = this.subclass;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IPersonType {
    class: string | undefined;
    subclass: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export enum WebsiteType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class Website implements IWebsite {
    address!: string | undefined;
    displayName!: string | undefined;
    type!: WebsiteType | undefined;
    additionalData!: { [key: string]: any; } | undefined;
    oDataType!: string | undefined;

    constructor(data?: IWebsite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.address = _data["address"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
            this.oDataType = _data["oDataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): Website | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Website>(data, _mappings, Website);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        data["oDataType"] = this.oDataType;
        return data;
    }
}

export interface IWebsite {
    address: string | undefined;
    displayName: string | undefined;
    type: WebsiteType | undefined;
    additionalData: { [key: string]: any; } | undefined;
    oDataType: string | undefined;
}

export class MicrosoftPeopleListDto implements IMicrosoftPeopleListDto {
    userPrincipalName!: string | undefined;
    surname!: string | undefined;
    scoredEmailAddresses!: ScoredEmailAddress[] | undefined;
    profession!: string | undefined;
    postalAddresses!: Location[] | undefined;
    phones!: Phone[] | undefined;
    personType!: PersonType | undefined;
    personNotes!: string | undefined;
    officeLocation!: string | undefined;
    jobTitle!: string | undefined;
    isFavorite!: boolean | undefined;
    imAddress!: string | undefined;
    givenName!: string | undefined;
    displayName!: string | undefined;
    department!: string | undefined;
    companyName!: string | undefined;
    birthday!: string | undefined;
    websites!: Website[] | undefined;
    yomiCompany!: string | undefined;

    constructor(data?: IMicrosoftPeopleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userPrincipalName = _data["userPrincipalName"];
            this.surname = _data["surname"];
            if (Array.isArray(_data["scoredEmailAddresses"])) {
                this.scoredEmailAddresses = [] as any;
                for (let item of _data["scoredEmailAddresses"])
                    this.scoredEmailAddresses!.push(ScoredEmailAddress.fromJS(item, _mappings));
            }
            this.profession = _data["profession"];
            if (Array.isArray(_data["postalAddresses"])) {
                this.postalAddresses = [] as any;
                for (let item of _data["postalAddresses"])
                    this.postalAddresses!.push(Location.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(Phone.fromJS(item, _mappings));
            }
            this.personType = _data["personType"] ? PersonType.fromJS(_data["personType"], _mappings) : undefined as any;
            this.personNotes = _data["personNotes"];
            this.officeLocation = _data["officeLocation"];
            this.jobTitle = _data["jobTitle"];
            this.isFavorite = _data["isFavorite"];
            this.imAddress = _data["imAddress"];
            this.givenName = _data["givenName"];
            this.displayName = _data["displayName"];
            this.department = _data["department"];
            this.companyName = _data["companyName"];
            this.birthday = _data["birthday"];
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(Website.fromJS(item, _mappings));
            }
            this.yomiCompany = _data["yomiCompany"];
        }
    }

    static fromJS(data: any, _mappings?: any): MicrosoftPeopleListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MicrosoftPeopleListDto>(data, _mappings, MicrosoftPeopleListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userPrincipalName"] = this.userPrincipalName;
        data["surname"] = this.surname;
        if (Array.isArray(this.scoredEmailAddresses)) {
            data["scoredEmailAddresses"] = [];
            for (let item of this.scoredEmailAddresses)
                data["scoredEmailAddresses"].push(item ? item.toJSON() : undefined as any);
        }
        data["profession"] = this.profession;
        if (Array.isArray(this.postalAddresses)) {
            data["postalAddresses"] = [];
            for (let item of this.postalAddresses)
                data["postalAddresses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item ? item.toJSON() : undefined as any);
        }
        data["personType"] = this.personType ? this.personType.toJSON() : undefined as any;
        data["personNotes"] = this.personNotes;
        data["officeLocation"] = this.officeLocation;
        data["jobTitle"] = this.jobTitle;
        data["isFavorite"] = this.isFavorite;
        data["imAddress"] = this.imAddress;
        data["givenName"] = this.givenName;
        data["displayName"] = this.displayName;
        data["department"] = this.department;
        data["companyName"] = this.companyName;
        data["birthday"] = this.birthday;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item ? item.toJSON() : undefined as any);
        }
        data["yomiCompany"] = this.yomiCompany;
        return data;
    }
}

export interface IMicrosoftPeopleListDto {
    userPrincipalName: string | undefined;
    surname: string | undefined;
    scoredEmailAddresses: ScoredEmailAddress[] | undefined;
    profession: string | undefined;
    postalAddresses: Location[] | undefined;
    phones: Phone[] | undefined;
    personType: PersonType | undefined;
    personNotes: string | undefined;
    officeLocation: string | undefined;
    jobTitle: string | undefined;
    isFavorite: boolean | undefined;
    imAddress: string | undefined;
    givenName: string | undefined;
    displayName: string | undefined;
    department: string | undefined;
    companyName: string | undefined;
    birthday: string | undefined;
    websites: Website[] | undefined;
    yomiCompany: string | undefined;
}

export class MicrosoftPeopleListDtoListIHandleError implements IMicrosoftPeopleListDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MicrosoftPeopleListDto[] | undefined;
    listOfEntities!: MicrosoftPeopleListDto[][] | undefined;

    constructor(data?: IMicrosoftPeopleListDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(MicrosoftPeopleListDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MicrosoftPeopleListDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MicrosoftPeopleListDtoListIHandleError>(data, _mappings, MicrosoftPeopleListDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IMicrosoftPeopleListDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MicrosoftPeopleListDto[] | undefined;
    listOfEntities: MicrosoftPeopleListDto[][] | undefined;
}

export class MicrosoftEmailMessageDto implements IMicrosoftEmailMessageDto {
    extensions!: Extension[] | undefined;
    attachments!: Attachment[] | undefined;
    webLink!: string | undefined;
    uniqueBody!: ItemBody | undefined;
    toRecipients!: Recipient[] | undefined;
    subject!: string | undefined;
    sentDateTime!: string | undefined;
    sender!: Recipient | undefined;
    replyTo!: Recipient[] | undefined;
    receivedDateTime!: string | undefined;
    parentFolderId!: string | undefined;
    isReadReceiptRequested!: boolean | undefined;
    isRead!: boolean | undefined;
    multiValueExtendedProperties!: MultiValueLegacyExtendedProperty[] | undefined;
    isDraft!: boolean | undefined;
    internetMessageId!: string | undefined;
    internetMessageHeaders!: InternetMessageHeader[] | undefined;
    inferenceClassification!: InferenceClassificationType | undefined;
    importance!: Importance | undefined;
    hasAttachments!: boolean | undefined;
    from!: Recipient | undefined;
    flag!: FollowupFlag | undefined;
    conversationIndex!: string | undefined;
    conversationId!: string | undefined;
    ccRecipients!: Recipient[] | undefined;
    bodyPreview!: string | undefined;
    body!: ItemBody | undefined;
    bccRecipients!: Recipient[] | undefined;
    isDeliveryReceiptRequested!: boolean | undefined;
    singleValueExtendedProperties!: SingleValueLegacyExtendedProperty[] | undefined;
    userName!: string | undefined;
    contactId!: number | undefined;
    companyName!: string | undefined;

    constructor(data?: IMicrosoftEmailMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["extensions"])) {
                this.extensions = [] as any;
                for (let item of _data["extensions"])
                    this.extensions!.push(Extension.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item, _mappings));
            }
            this.webLink = _data["webLink"];
            this.uniqueBody = _data["uniqueBody"] ? ItemBody.fromJS(_data["uniqueBody"], _mappings) : undefined as any;
            if (Array.isArray(_data["toRecipients"])) {
                this.toRecipients = [] as any;
                for (let item of _data["toRecipients"])
                    this.toRecipients!.push(Recipient.fromJS(item, _mappings));
            }
            this.subject = _data["subject"];
            this.sentDateTime = _data["sentDateTime"];
            this.sender = _data["sender"] ? Recipient.fromJS(_data["sender"], _mappings) : undefined as any;
            if (Array.isArray(_data["replyTo"])) {
                this.replyTo = [] as any;
                for (let item of _data["replyTo"])
                    this.replyTo!.push(Recipient.fromJS(item, _mappings));
            }
            this.receivedDateTime = _data["receivedDateTime"];
            this.parentFolderId = _data["parentFolderId"];
            this.isReadReceiptRequested = _data["isReadReceiptRequested"];
            this.isRead = _data["isRead"];
            if (Array.isArray(_data["multiValueExtendedProperties"])) {
                this.multiValueExtendedProperties = [] as any;
                for (let item of _data["multiValueExtendedProperties"])
                    this.multiValueExtendedProperties!.push(MultiValueLegacyExtendedProperty.fromJS(item, _mappings));
            }
            this.isDraft = _data["isDraft"];
            this.internetMessageId = _data["internetMessageId"];
            if (Array.isArray(_data["internetMessageHeaders"])) {
                this.internetMessageHeaders = [] as any;
                for (let item of _data["internetMessageHeaders"])
                    this.internetMessageHeaders!.push(InternetMessageHeader.fromJS(item, _mappings));
            }
            this.inferenceClassification = _data["inferenceClassification"];
            this.importance = _data["importance"];
            this.hasAttachments = _data["hasAttachments"];
            this.from = _data["from"] ? Recipient.fromJS(_data["from"], _mappings) : undefined as any;
            this.flag = _data["flag"] ? FollowupFlag.fromJS(_data["flag"], _mappings) : undefined as any;
            this.conversationIndex = _data["conversationIndex"];
            this.conversationId = _data["conversationId"];
            if (Array.isArray(_data["ccRecipients"])) {
                this.ccRecipients = [] as any;
                for (let item of _data["ccRecipients"])
                    this.ccRecipients!.push(Recipient.fromJS(item, _mappings));
            }
            this.bodyPreview = _data["bodyPreview"];
            this.body = _data["body"] ? ItemBody.fromJS(_data["body"], _mappings) : undefined as any;
            if (Array.isArray(_data["bccRecipients"])) {
                this.bccRecipients = [] as any;
                for (let item of _data["bccRecipients"])
                    this.bccRecipients!.push(Recipient.fromJS(item, _mappings));
            }
            this.isDeliveryReceiptRequested = _data["isDeliveryReceiptRequested"];
            if (Array.isArray(_data["singleValueExtendedProperties"])) {
                this.singleValueExtendedProperties = [] as any;
                for (let item of _data["singleValueExtendedProperties"])
                    this.singleValueExtendedProperties!.push(SingleValueLegacyExtendedProperty.fromJS(item, _mappings));
            }
            this.userName = _data["userName"];
            this.contactId = _data["contactId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any, _mappings?: any): MicrosoftEmailMessageDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MicrosoftEmailMessageDto>(data, _mappings, MicrosoftEmailMessageDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.extensions)) {
            data["extensions"] = [];
            for (let item of this.extensions)
                data["extensions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["webLink"] = this.webLink;
        data["uniqueBody"] = this.uniqueBody ? this.uniqueBody.toJSON() : undefined as any;
        if (Array.isArray(this.toRecipients)) {
            data["toRecipients"] = [];
            for (let item of this.toRecipients)
                data["toRecipients"].push(item ? item.toJSON() : undefined as any);
        }
        data["subject"] = this.subject;
        data["sentDateTime"] = this.sentDateTime;
        data["sender"] = this.sender ? this.sender.toJSON() : undefined as any;
        if (Array.isArray(this.replyTo)) {
            data["replyTo"] = [];
            for (let item of this.replyTo)
                data["replyTo"].push(item ? item.toJSON() : undefined as any);
        }
        data["receivedDateTime"] = this.receivedDateTime;
        data["parentFolderId"] = this.parentFolderId;
        data["isReadReceiptRequested"] = this.isReadReceiptRequested;
        data["isRead"] = this.isRead;
        if (Array.isArray(this.multiValueExtendedProperties)) {
            data["multiValueExtendedProperties"] = [];
            for (let item of this.multiValueExtendedProperties)
                data["multiValueExtendedProperties"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDraft"] = this.isDraft;
        data["internetMessageId"] = this.internetMessageId;
        if (Array.isArray(this.internetMessageHeaders)) {
            data["internetMessageHeaders"] = [];
            for (let item of this.internetMessageHeaders)
                data["internetMessageHeaders"].push(item ? item.toJSON() : undefined as any);
        }
        data["inferenceClassification"] = this.inferenceClassification;
        data["importance"] = this.importance;
        data["hasAttachments"] = this.hasAttachments;
        data["from"] = this.from ? this.from.toJSON() : undefined as any;
        data["flag"] = this.flag ? this.flag.toJSON() : undefined as any;
        data["conversationIndex"] = this.conversationIndex;
        data["conversationId"] = this.conversationId;
        if (Array.isArray(this.ccRecipients)) {
            data["ccRecipients"] = [];
            for (let item of this.ccRecipients)
                data["ccRecipients"].push(item ? item.toJSON() : undefined as any);
        }
        data["bodyPreview"] = this.bodyPreview;
        data["body"] = this.body ? this.body.toJSON() : undefined as any;
        if (Array.isArray(this.bccRecipients)) {
            data["bccRecipients"] = [];
            for (let item of this.bccRecipients)
                data["bccRecipients"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeliveryReceiptRequested"] = this.isDeliveryReceiptRequested;
        if (Array.isArray(this.singleValueExtendedProperties)) {
            data["singleValueExtendedProperties"] = [];
            for (let item of this.singleValueExtendedProperties)
                data["singleValueExtendedProperties"].push(item ? item.toJSON() : undefined as any);
        }
        data["userName"] = this.userName;
        data["contactId"] = this.contactId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IMicrosoftEmailMessageDto {
    extensions: Extension[] | undefined;
    attachments: Attachment[] | undefined;
    webLink: string | undefined;
    uniqueBody: ItemBody | undefined;
    toRecipients: Recipient[] | undefined;
    subject: string | undefined;
    sentDateTime: string | undefined;
    sender: Recipient | undefined;
    replyTo: Recipient[] | undefined;
    receivedDateTime: string | undefined;
    parentFolderId: string | undefined;
    isReadReceiptRequested: boolean | undefined;
    isRead: boolean | undefined;
    multiValueExtendedProperties: MultiValueLegacyExtendedProperty[] | undefined;
    isDraft: boolean | undefined;
    internetMessageId: string | undefined;
    internetMessageHeaders: InternetMessageHeader[] | undefined;
    inferenceClassification: InferenceClassificationType | undefined;
    importance: Importance | undefined;
    hasAttachments: boolean | undefined;
    from: Recipient | undefined;
    flag: FollowupFlag | undefined;
    conversationIndex: string | undefined;
    conversationId: string | undefined;
    ccRecipients: Recipient[] | undefined;
    bodyPreview: string | undefined;
    body: ItemBody | undefined;
    bccRecipients: Recipient[] | undefined;
    isDeliveryReceiptRequested: boolean | undefined;
    singleValueExtendedProperties: SingleValueLegacyExtendedProperty[] | undefined;
    userName: string | undefined;
    contactId: number | undefined;
    companyName: string | undefined;
}

export class MicrosoftEmailMessageDtoListIHandleError implements IMicrosoftEmailMessageDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MicrosoftEmailMessageDto[] | undefined;
    listOfEntities!: MicrosoftEmailMessageDto[][] | undefined;

    constructor(data?: IMicrosoftEmailMessageDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(MicrosoftEmailMessageDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MicrosoftEmailMessageDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MicrosoftEmailMessageDtoListIHandleError>(data, _mappings, MicrosoftEmailMessageDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IMicrosoftEmailMessageDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MicrosoftEmailMessageDto[] | undefined;
    listOfEntities: MicrosoftEmailMessageDto[][] | undefined;
}

export class SendMsTeamsMessageInput implements ISendMsTeamsMessageInput {
    fromUserEmail!: string | undefined;
    toUserEmail!: string | undefined;
    message!: string | undefined;

    constructor(data?: ISendMsTeamsMessageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fromUserEmail = _data["fromUserEmail"];
            this.toUserEmail = _data["toUserEmail"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any, _mappings?: any): SendMsTeamsMessageInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SendMsTeamsMessageInput>(data, _mappings, SendMsTeamsMessageInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromUserEmail"] = this.fromUserEmail;
        data["toUserEmail"] = this.toUserEmail;
        data["message"] = this.message;
        return data;
    }
}

export interface ISendMsTeamsMessageInput {
    fromUserEmail: string | undefined;
    toUserEmail: string | undefined;
    message: string | undefined;
}

export class SetUserPresenceDto implements ISetUserPresenceDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    duration!: number | undefined;

    constructor(data?: ISetUserPresenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetUserPresenceDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetUserPresenceDto>(data, _mappings, SetUserPresenceDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["duration"] = this.duration;
        return data;
    }
}

export interface ISetUserPresenceDto {
    userId: number | undefined;
    tenantId: number | undefined;
    duration: number | undefined;
}

export class MsTeam implements IMsTeam {
    id!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    url!: string | undefined;
    teamType!: number | undefined;
    isArchived!: boolean | undefined;

    constructor(data?: IMsTeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.teamType = _data["teamType"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any, _mappings?: any): MsTeam | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsTeam>(data, _mappings, MsTeam);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["url"] = this.url;
        data["teamType"] = this.teamType;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IMsTeam {
    id: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    url: string | undefined;
    teamType: number | undefined;
    isArchived: boolean | undefined;
}

export class MsTeamListIHandleError implements IMsTeamListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MsTeam[] | undefined;
    listOfEntities!: MsTeam[][] | undefined;

    constructor(data?: IMsTeamListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(MsTeam.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MsTeamListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsTeamListIHandleError>(data, _mappings, MsTeamListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IMsTeamListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MsTeam[] | undefined;
    listOfEntities: MsTeam[][] | undefined;
}

export class MsTeamIHandleError implements IMsTeamIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MsTeam | undefined;
    listOfEntities!: MsTeam[] | undefined;

    constructor(data?: IMsTeamIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? MsTeam.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(MsTeam.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MsTeamIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsTeamIHandleError>(data, _mappings, MsTeamIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMsTeamIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MsTeam | undefined;
    listOfEntities: MsTeam[] | undefined;
}

export class CreateMsTeam implements ICreateMsTeam {
    displayName!: string | undefined;
    description!: string | undefined;
    teamType!: number | undefined;
    channelDisplayName!: string | undefined;
    channelType!: number | undefined;

    constructor(data?: ICreateMsTeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.teamType = _data["teamType"];
            this.channelDisplayName = _data["channelDisplayName"];
            this.channelType = _data["channelType"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateMsTeam | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateMsTeam>(data, _mappings, CreateMsTeam);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["teamType"] = this.teamType;
        data["channelDisplayName"] = this.channelDisplayName;
        data["channelType"] = this.channelType;
        return data;
    }
}

export interface ICreateMsTeam {
    displayName: string | undefined;
    description: string | undefined;
    teamType: number | undefined;
    channelDisplayName: string | undefined;
    channelType: number | undefined;
}

export class MsTeamMsTeamChannelValueTuple implements IMsTeamMsTeamChannelValueTuple {

    constructor(data?: IMsTeamMsTeamChannelValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): MsTeamMsTeamChannelValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsTeamMsTeamChannelValueTuple>(data, _mappings, MsTeamMsTeamChannelValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMsTeamMsTeamChannelValueTuple {
}

export class MsTeamMsTeamChannelIHandleError implements IMsTeamMsTeamChannelIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    message_Info!: string | undefined;
    responseData!: MsTeamMsTeamChannelValueTuple | undefined;

    constructor(data?: IMsTeamMsTeamChannelIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? MsTeamMsTeamChannelValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): MsTeamMsTeamChannelIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsTeamMsTeamChannelIHandleError>(data, _mappings, MsTeamMsTeamChannelIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        return data;
    }
}

export interface IMsTeamMsTeamChannelIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    message_Info: string | undefined;
    responseData: MsTeamMsTeamChannelValueTuple | undefined;
}

export class MsTeamChannel implements IMsTeamChannel {
    id!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    url!: string | undefined;
    channelType!: number | undefined;
    isArchived!: boolean | undefined;

    constructor(data?: IMsTeamChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.channelType = _data["channelType"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any, _mappings?: any): MsTeamChannel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsTeamChannel>(data, _mappings, MsTeamChannel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["url"] = this.url;
        data["channelType"] = this.channelType;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IMsTeamChannel {
    id: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    url: string | undefined;
    channelType: number | undefined;
    isArchived: boolean | undefined;
}

export class MsTeamChannelListIHandleError implements IMsTeamChannelListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MsTeamChannel[] | undefined;
    listOfEntities!: MsTeamChannel[][] | undefined;

    constructor(data?: IMsTeamChannelListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(MsTeamChannel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MsTeamChannelListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsTeamChannelListIHandleError>(data, _mappings, MsTeamChannelListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IMsTeamChannelListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MsTeamChannel[] | undefined;
    listOfEntities: MsTeamChannel[][] | undefined;
}

export class MsTeamChannelIHandleError implements IMsTeamChannelIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MsTeamChannel | undefined;
    listOfEntities!: MsTeamChannel[] | undefined;

    constructor(data?: IMsTeamChannelIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? MsTeamChannel.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(MsTeamChannel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MsTeamChannelIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsTeamChannelIHandleError>(data, _mappings, MsTeamChannelIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMsTeamChannelIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MsTeamChannel | undefined;
    listOfEntities: MsTeamChannel[] | undefined;
}

export class CreateMsChannel implements ICreateMsChannel {
    displayName!: string | undefined;
    description!: string | undefined;
    channelType!: number | undefined;
    teamId!: string | undefined;

    constructor(data?: ICreateMsChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.channelType = _data["channelType"];
            this.teamId = _data["teamId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateMsChannel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateMsChannel>(data, _mappings, CreateMsChannel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["channelType"] = this.channelType;
        data["teamId"] = this.teamId;
        return data;
    }
}

export interface ICreateMsChannel {
    displayName: string | undefined;
    description: string | undefined;
    channelType: number | undefined;
    teamId: string | undefined;
}

export class MsTeamsMembers implements IMsTeamsMembers {
    id!: string | undefined;
    roles!: string[] | undefined;
    displayName!: string | undefined;
    msUserId!: string | undefined;
    email!: string | undefined;

    constructor(data?: IMsTeamsMembers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.displayName = _data["displayName"];
            this.msUserId = _data["msUserId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any, _mappings?: any): MsTeamsMembers | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsTeamsMembers>(data, _mappings, MsTeamsMembers);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["displayName"] = this.displayName;
        data["msUserId"] = this.msUserId;
        data["email"] = this.email;
        return data;
    }
}

export interface IMsTeamsMembers {
    id: string | undefined;
    roles: string[] | undefined;
    displayName: string | undefined;
    msUserId: string | undefined;
    email: string | undefined;
}

export class MsTeamsMembersListIHandleError implements IMsTeamsMembersListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MsTeamsMembers[] | undefined;
    listOfEntities!: MsTeamsMembers[][] | undefined;

    constructor(data?: IMsTeamsMembersListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(MsTeamsMembers.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MsTeamsMembersListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsTeamsMembersListIHandleError>(data, _mappings, MsTeamsMembersListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IMsTeamsMembersListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MsTeamsMembers[] | undefined;
    listOfEntities: MsTeamsMembers[][] | undefined;
}

export class AddMsTeamsMember implements IAddMsTeamsMember {
    teamId!: string | undefined;
    channelId!: string | undefined;
    userEmail!: string | undefined;
    memberyType!: number | undefined;

    constructor(data?: IAddMsTeamsMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.channelId = _data["channelId"];
            this.userEmail = _data["userEmail"];
            this.memberyType = _data["memberyType"];
        }
    }

    static fromJS(data: any, _mappings?: any): AddMsTeamsMember | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddMsTeamsMember>(data, _mappings, AddMsTeamsMember);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["channelId"] = this.channelId;
        data["userEmail"] = this.userEmail;
        data["memberyType"] = this.memberyType;
        return data;
    }
}

export interface IAddMsTeamsMember {
    teamId: string | undefined;
    channelId: string | undefined;
    userEmail: string | undefined;
    memberyType: number | undefined;
}

export class MsTeamsFolderOutput implements IMsTeamsFolderOutput {
    folderName!: string | undefined;
    folderUrl!: string | undefined;
    folderId!: string | undefined;
    driveId!: string | undefined;
    siteId!: string | undefined;
    isDocLibrary!: boolean | undefined;
    isSharePoint!: boolean | undefined;

    constructor(data?: IMsTeamsFolderOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.folderName = _data["folderName"];
            this.folderUrl = _data["folderUrl"];
            this.folderId = _data["folderId"];
            this.driveId = _data["driveId"];
            this.siteId = _data["siteId"];
            this.isDocLibrary = _data["isDocLibrary"];
            this.isSharePoint = _data["isSharePoint"];
        }
    }

    static fromJS(data: any, _mappings?: any): MsTeamsFolderOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsTeamsFolderOutput>(data, _mappings, MsTeamsFolderOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderName"] = this.folderName;
        data["folderUrl"] = this.folderUrl;
        data["folderId"] = this.folderId;
        data["driveId"] = this.driveId;
        data["siteId"] = this.siteId;
        data["isDocLibrary"] = this.isDocLibrary;
        data["isSharePoint"] = this.isSharePoint;
        return data;
    }
}

export interface IMsTeamsFolderOutput {
    folderName: string | undefined;
    folderUrl: string | undefined;
    folderId: string | undefined;
    driveId: string | undefined;
    siteId: string | undefined;
    isDocLibrary: boolean | undefined;
    isSharePoint: boolean | undefined;
}

export class MsTeamsFolderOutputIHandleError implements IMsTeamsFolderOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MsTeamsFolderOutput | undefined;
    listOfEntities!: MsTeamsFolderOutput[] | undefined;

    constructor(data?: IMsTeamsFolderOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? MsTeamsFolderOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(MsTeamsFolderOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MsTeamsFolderOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MsTeamsFolderOutputIHandleError>(data, _mappings, MsTeamsFolderOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMsTeamsFolderOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MsTeamsFolderOutput | undefined;
    listOfEntities: MsTeamsFolderOutput[] | undefined;
}

export class EditionSelectDto implements IEditionSelectDto {
    id!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    isFree!: boolean | undefined;
    additionalData!: { [key: string]: { [key: string]: string; }; } | undefined;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.isFree = _data["isFree"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key] !== undefined ? _data["additionalData"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any, _mappings?: any): EditionSelectDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EditionSelectDto>(data, _mappings, EditionSelectDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        return data;
    }
}

export interface IEditionSelectDto {
    id: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean | undefined;
    additionalData: { [key: string]: { [key: string]: string; }; } | undefined;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    edition!: EditionSelectDto | undefined;
    additionalPrice!: number | undefined;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"], _mappings) : undefined as any;
            this.additionalPrice = _data["additionalPrice"];
        }
    }

    static fromJS(data: any, _mappings?: any): PaymentInfoDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PaymentInfoDto>(data, _mappings, PaymentInfoDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        data["additionalPrice"] = this.additionalPrice;
        return data;
    }
}

export interface IPaymentInfoDto {
    edition: EditionSelectDto | undefined;
    additionalPrice: number | undefined;
}

export enum EditionPaymentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum PaymentPeriodType {
    _1 = 1,
    _7 = 7,
    _30 = 30,
    _365 = 365,
}

export class CreatePaymentDto implements ICreatePaymentDto {
    editionId!: number | undefined;
    editionPaymentType!: EditionPaymentType | undefined;
    paymentPeriodType!: PaymentPeriodType | undefined;
    subscriptionPaymentGatewayType!: any | undefined;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.editionId = _data["editionId"];
            this.editionPaymentType = _data["editionPaymentType"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = _data["subscriptionPaymentGatewayType"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreatePaymentDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreatePaymentDto>(data, _mappings, CreatePaymentDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        return data;
    }
}

export interface ICreatePaymentDto {
    editionId: number | undefined;
    editionPaymentType: EditionPaymentType | undefined;
    paymentPeriodType: PaymentPeriodType | undefined;
    subscriptionPaymentGatewayType: any | undefined;
}

export class CreatePaymentResponse implements ICreatePaymentResponse {

    constructor(data?: ICreatePaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): CreatePaymentResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreatePaymentResponse>(data, _mappings, CreatePaymentResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICreatePaymentResponse {
}

export class ExecutePaymentDto implements IExecutePaymentDto {
    gateway!: any | undefined;
    editionPaymentType!: EditionPaymentType | undefined;
    editionId!: number | undefined;
    paymentPeriodType!: PaymentPeriodType | undefined;
    additionalData!: { [key: string]: string; } | undefined;

    constructor(data?: IExecutePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.gateway = _data["gateway"];
            this.editionPaymentType = _data["editionPaymentType"];
            this.editionId = _data["editionId"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ExecutePaymentDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ExecutePaymentDto>(data, _mappings, ExecutePaymentDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["editionPaymentType"] = this.editionPaymentType;
        data["editionId"] = this.editionId;
        data["paymentPeriodType"] = this.paymentPeriodType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        return data;
    }
}

export interface IExecutePaymentDto {
    gateway: any | undefined;
    editionPaymentType: EditionPaymentType | undefined;
    editionId: number | undefined;
    paymentPeriodType: PaymentPeriodType | undefined;
    additionalData: { [key: string]: string; } | undefined;
}

export class ExecutePaymentResponse implements IExecutePaymentResponse {

    constructor(data?: IExecutePaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): ExecutePaymentResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ExecutePaymentResponse>(data, _mappings, ExecutePaymentResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IExecutePaymentResponse {
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    gateway!: string | undefined;
    amount!: number | undefined;
    editionId!: number | undefined;
    dayCount!: number | undefined;
    paymentPeriodType!: string | undefined;
    paymentId!: string | undefined;
    payerId!: string | undefined;
    status!: string | undefined;
    editionDisplayName!: string | undefined;
    tenantId!: number | undefined;
    invoiceNo!: string | undefined;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.gateway = _data["gateway"];
            this.amount = _data["amount"];
            this.editionId = _data["editionId"];
            this.dayCount = _data["dayCount"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.paymentId = _data["paymentId"];
            this.payerId = _data["payerId"];
            this.status = _data["status"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.tenantId = _data["tenantId"];
            this.invoiceNo = _data["invoiceNo"];
        }
    }

    static fromJS(data: any, _mappings?: any): SubscriptionPaymentListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SubscriptionPaymentListDto>(data, _mappings, SubscriptionPaymentListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        return data;
    }
}

export interface ISubscriptionPaymentListDto {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    gateway: string | undefined;
    amount: number | undefined;
    editionId: number | undefined;
    dayCount: number | undefined;
    paymentPeriodType: string | undefined;
    paymentId: string | undefined;
    payerId: string | undefined;
    status: string | undefined;
    editionDisplayName: string | undefined;
    tenantId: number | undefined;
    invoiceNo: string | undefined;
}

export class SubscriptionPaymentListDtoPagedResultDto implements ISubscriptionPaymentListDtoPagedResultDto {
    items!: SubscriptionPaymentListDto[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: ISubscriptionPaymentListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscriptionPaymentListDto.fromJS(item, _mappings));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): SubscriptionPaymentListDtoPagedResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SubscriptionPaymentListDtoPagedResultDto>(data, _mappings, SubscriptionPaymentListDtoPagedResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ISubscriptionPaymentListDtoPagedResultDto {
    items: SubscriptionPaymentListDto[] | undefined;
    totalCount: number | undefined;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean | undefined;
    level!: number | undefined;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any, _mappings?: any): FlatPermissionWithLevelDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FlatPermissionWithLevelDto>(data, _mappings, FlatPermissionWithLevelDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        data["level"] = this.level;
        return data;
    }
}

export interface IFlatPermissionWithLevelDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean | undefined;
    level: number | undefined;
}

export class FlatPermissionWithLevelDtoListResultDto implements IFlatPermissionWithLevelDtoListResultDto {
    items!: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IFlatPermissionWithLevelDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FlatPermissionWithLevelDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): FlatPermissionWithLevelDtoListResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FlatPermissionWithLevelDtoListResultDto>(data, _mappings, FlatPermissionWithLevelDtoListResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFlatPermissionWithLevelDtoListResultDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class PinnedEntityDto implements IPinnedEntityDto {
    id!: number | undefined;
    entityId!: number | undefined;
    entityType!: EntityType | undefined;

    constructor(data?: IPinnedEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
        }
    }

    static fromJS(data: any, _mappings?: any): PinnedEntityDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PinnedEntityDto>(data, _mappings, PinnedEntityDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        return data;
    }
}

export interface IPinnedEntityDto {
    id: number | undefined;
    entityId: number | undefined;
    entityType: EntityType | undefined;
}

export class ProductEventUnitCountDto implements IProductEventUnitCountDto {
    unitKey!: string | undefined;
    count!: number | undefined;

    constructor(data?: IProductEventUnitCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.unitKey = _data["unitKey"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProductEventUnitCountDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductEventUnitCountDto>(data, _mappings, ProductEventUnitCountDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitKey"] = this.unitKey;
        data["count"] = this.count;
        return data;
    }
}

export interface IProductEventUnitCountDto {
    unitKey: string | undefined;
    count: number | undefined;
}

export class ProductEventCategoryCountDto implements IProductEventCategoryCountDto {
    category!: IntelligenceCategory | undefined;
    count!: number | undefined;

    constructor(data?: IProductEventCategoryCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.category = _data["category"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProductEventCategoryCountDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductEventCategoryCountDto>(data, _mappings, ProductEventCategoryCountDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["count"] = this.count;
        return data;
    }
}

export interface IProductEventCategoryCountDto {
    category: IntelligenceCategory | undefined;
    count: number | undefined;
}

export class ProductEventPropertiesDto implements IProductEventPropertiesDto {
    chapter!: OnboardingChapter | undefined;
    step!: OnboardingStep | undefined;
    decisionAction!: ChapterDecisionAction | undefined;
    proofDecision!: ProofDecisionState | undefined;
    entryPoint!: DiscoveryEntryPoint | undefined;
    jobId!: number | undefined;
    jobKind!: DiscoveryJobKind | undefined;
    jobStatus!: DiscoveryJobStatus | undefined;
    stage!: DiscoveryStage | undefined;
    outcome!: DiscoveryOutcome | undefined;
    fallbackReason!: OnboardingFallbackReason | undefined;
    connectStep!: OnboardingConnectStep | undefined;
    surface!: OnboardingConnectSurface | undefined;
    adminApprovalRequired!: boolean | undefined;
    isFixture!: boolean | undefined;
    sessionId!: number | undefined;
    factId!: number | undefined;
    suggestionId!: number | undefined;
    durationMs!: number | undefined;
    evidenceCount!: number | undefined;
    confirmedCount!: number | undefined;
    editedCount!: number | undefined;
    rejectedCount!: number | undefined;
    skippedCount!: number | undefined;
    proofCount!: number | undefined;
    approvedCount!: number | undefined;
    unitKey!: string | undefined;
    errorClass!: string | undefined;
    category!: IntelligenceCategory | undefined;
    appliedCounts!: ProductEventUnitCountDto[] | undefined;
    categoryCounts!: ProductEventCategoryCountDto[] | undefined;
    sourceTypes!: IntelligenceSourceType[] | undefined;

    constructor(data?: IProductEventPropertiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.chapter = _data["chapter"];
            this.step = _data["step"];
            this.decisionAction = _data["decisionAction"];
            this.proofDecision = _data["proofDecision"];
            this.entryPoint = _data["entryPoint"];
            this.jobId = _data["jobId"];
            this.jobKind = _data["jobKind"];
            this.jobStatus = _data["jobStatus"];
            this.stage = _data["stage"];
            this.outcome = _data["outcome"];
            this.fallbackReason = _data["fallbackReason"];
            this.connectStep = _data["connectStep"];
            this.surface = _data["surface"];
            this.adminApprovalRequired = _data["adminApprovalRequired"];
            this.isFixture = _data["isFixture"];
            this.sessionId = _data["sessionId"];
            this.factId = _data["factId"];
            this.suggestionId = _data["suggestionId"];
            this.durationMs = _data["durationMs"];
            this.evidenceCount = _data["evidenceCount"];
            this.confirmedCount = _data["confirmedCount"];
            this.editedCount = _data["editedCount"];
            this.rejectedCount = _data["rejectedCount"];
            this.skippedCount = _data["skippedCount"];
            this.proofCount = _data["proofCount"];
            this.approvedCount = _data["approvedCount"];
            this.unitKey = _data["unitKey"];
            this.errorClass = _data["errorClass"];
            this.category = _data["category"];
            if (Array.isArray(_data["appliedCounts"])) {
                this.appliedCounts = [] as any;
                for (let item of _data["appliedCounts"])
                    this.appliedCounts!.push(ProductEventUnitCountDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["categoryCounts"])) {
                this.categoryCounts = [] as any;
                for (let item of _data["categoryCounts"])
                    this.categoryCounts!.push(ProductEventCategoryCountDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["sourceTypes"])) {
                this.sourceTypes = [] as any;
                for (let item of _data["sourceTypes"])
                    this.sourceTypes!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProductEventPropertiesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductEventPropertiesDto>(data, _mappings, ProductEventPropertiesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chapter"] = this.chapter;
        data["step"] = this.step;
        data["decisionAction"] = this.decisionAction;
        data["proofDecision"] = this.proofDecision;
        data["entryPoint"] = this.entryPoint;
        data["jobId"] = this.jobId;
        data["jobKind"] = this.jobKind;
        data["jobStatus"] = this.jobStatus;
        data["stage"] = this.stage;
        data["outcome"] = this.outcome;
        data["fallbackReason"] = this.fallbackReason;
        data["connectStep"] = this.connectStep;
        data["surface"] = this.surface;
        data["adminApprovalRequired"] = this.adminApprovalRequired;
        data["isFixture"] = this.isFixture;
        data["sessionId"] = this.sessionId;
        data["factId"] = this.factId;
        data["suggestionId"] = this.suggestionId;
        data["durationMs"] = this.durationMs;
        data["evidenceCount"] = this.evidenceCount;
        data["confirmedCount"] = this.confirmedCount;
        data["editedCount"] = this.editedCount;
        data["rejectedCount"] = this.rejectedCount;
        data["skippedCount"] = this.skippedCount;
        data["proofCount"] = this.proofCount;
        data["approvedCount"] = this.approvedCount;
        data["unitKey"] = this.unitKey;
        data["errorClass"] = this.errorClass;
        data["category"] = this.category;
        if (Array.isArray(this.appliedCounts)) {
            data["appliedCounts"] = [];
            for (let item of this.appliedCounts)
                data["appliedCounts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.categoryCounts)) {
            data["categoryCounts"] = [];
            for (let item of this.categoryCounts)
                data["categoryCounts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sourceTypes)) {
            data["sourceTypes"] = [];
            for (let item of this.sourceTypes)
                data["sourceTypes"].push(item);
        }
        return data;
    }
}

export interface IProductEventPropertiesDto {
    chapter: OnboardingChapter | undefined;
    step: OnboardingStep | undefined;
    decisionAction: ChapterDecisionAction | undefined;
    proofDecision: ProofDecisionState | undefined;
    entryPoint: DiscoveryEntryPoint | undefined;
    jobId: number | undefined;
    jobKind: DiscoveryJobKind | undefined;
    jobStatus: DiscoveryJobStatus | undefined;
    stage: DiscoveryStage | undefined;
    outcome: DiscoveryOutcome | undefined;
    fallbackReason: OnboardingFallbackReason | undefined;
    connectStep: OnboardingConnectStep | undefined;
    surface: OnboardingConnectSurface | undefined;
    adminApprovalRequired: boolean | undefined;
    isFixture: boolean | undefined;
    sessionId: number | undefined;
    factId: number | undefined;
    suggestionId: number | undefined;
    durationMs: number | undefined;
    evidenceCount: number | undefined;
    confirmedCount: number | undefined;
    editedCount: number | undefined;
    rejectedCount: number | undefined;
    skippedCount: number | undefined;
    proofCount: number | undefined;
    approvedCount: number | undefined;
    unitKey: string | undefined;
    errorClass: string | undefined;
    category: IntelligenceCategory | undefined;
    appliedCounts: ProductEventUnitCountDto[] | undefined;
    categoryCounts: ProductEventCategoryCountDto[] | undefined;
    sourceTypes: IntelligenceSourceType[] | undefined;
}

export class TrackProductEventInput implements ITrackProductEventInput {
    eventName!: string;
    properties!: ProductEventPropertiesDto | undefined;

    constructor(data?: ITrackProductEventInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.eventName = _data["eventName"];
            this.properties = _data["properties"] ? ProductEventPropertiesDto.fromJS(_data["properties"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): TrackProductEventInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TrackProductEventInput>(data, _mappings, TrackProductEventInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventName"] = this.eventName;
        data["properties"] = this.properties ? this.properties.toJSON() : undefined as any;
        return data;
    }
}

export interface ITrackProductEventInput {
    eventName: string;
    properties: ProductEventPropertiesDto | undefined;
}

export enum LangCode {
    _1001 = 1001,
    _1002 = 1002,
    _1003 = 1003,
    _1004 = 1004,
    _1005 = 1005,
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    id!: number | undefined;
    name!: string;
    surname!: string | undefined;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean | undefined;
    timezone!: string | undefined;
    qrCodeSetupImageUrl!: string | undefined;
    isGoogleAuthenticatorEnabled!: boolean | undefined;
    roles!: string[] | undefined;
    employeeId!: string | undefined;
    premise!: string | undefined;
    hasProfileView!: boolean | undefined;
    profilePictureId!: string | undefined;
    managerId!: number | undefined;
    managerName!: string | undefined;
    teamsId!: number[] | undefined;
    teamName!: string | undefined;
    workSiteId!: number | undefined;
    workSiteName!: string | undefined;
    profilePictureUrl!: string | undefined;
    lastCheckedIn!: string | undefined;
    isRequireCheckin!: boolean | undefined;
    isCaseCreated!: boolean | undefined;
    isCanWorkFromHome!: boolean | undefined;
    lastCheckedInTz!: string | undefined;
    currentDateTz!: string | undefined;
    tenantTimeZoneAbbr!: string | undefined;
    shiftStarted!: boolean | undefined;
    shiftEnded!: boolean | undefined;
    languageCode!: LangCode | undefined;
    shiftName!: string | undefined;
    shiftId!: number | undefined;
    countryId!: number | undefined;
    newPassword!: string | undefined;
    currentPassword!: string | undefined;
    iconUrl!: string | undefined;
    timeZoneId!: number | undefined;
    city!: string | undefined;
    jobTitle!: string | undefined;
    dateHired!: string | undefined;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.timezone = _data["timezone"];
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.employeeId = _data["employeeId"];
            this.premise = _data["premise"];
            this.hasProfileView = _data["hasProfileView"];
            this.profilePictureId = _data["profilePictureId"];
            this.managerId = _data["managerId"];
            this.managerName = _data["managerName"];
            if (Array.isArray(_data["teamsId"])) {
                this.teamsId = [] as any;
                for (let item of _data["teamsId"])
                    this.teamsId!.push(item);
            }
            this.teamName = _data["teamName"];
            this.workSiteId = _data["workSiteId"];
            this.workSiteName = _data["workSiteName"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.lastCheckedIn = _data["lastCheckedIn"];
            this.isRequireCheckin = _data["isRequireCheckin"];
            this.isCaseCreated = _data["isCaseCreated"];
            this.isCanWorkFromHome = _data["isCanWorkFromHome"];
            this.lastCheckedInTz = _data["lastCheckedInTz"];
            this.currentDateTz = _data["currentDateTz"];
            this.tenantTimeZoneAbbr = _data["tenantTimeZoneAbbr"];
            this.shiftStarted = _data["shiftStarted"];
            this.shiftEnded = _data["shiftEnded"];
            this.languageCode = _data["languageCode"];
            this.shiftName = _data["shiftName"];
            this.shiftId = _data["shiftId"];
            this.countryId = _data["countryId"];
            this.newPassword = _data["newPassword"];
            this.currentPassword = _data["currentPassword"];
            this.iconUrl = _data["iconUrl"];
            this.timeZoneId = _data["timeZoneId"];
            this.city = _data["city"];
            this.jobTitle = _data["jobTitle"];
            this.dateHired = _data["dateHired"];
        }
    }

    static fromJS(data: any, _mappings?: any): CurrentUserProfileEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CurrentUserProfileEditDto>(data, _mappings, CurrentUserProfileEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["employeeId"] = this.employeeId;
        data["premise"] = this.premise;
        data["hasProfileView"] = this.hasProfileView;
        data["profilePictureId"] = this.profilePictureId;
        data["managerId"] = this.managerId;
        data["managerName"] = this.managerName;
        if (Array.isArray(this.teamsId)) {
            data["teamsId"] = [];
            for (let item of this.teamsId)
                data["teamsId"].push(item);
        }
        data["teamName"] = this.teamName;
        data["workSiteId"] = this.workSiteId;
        data["workSiteName"] = this.workSiteName;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["lastCheckedIn"] = this.lastCheckedIn;
        data["isRequireCheckin"] = this.isRequireCheckin;
        data["isCaseCreated"] = this.isCaseCreated;
        data["isCanWorkFromHome"] = this.isCanWorkFromHome;
        data["lastCheckedInTz"] = this.lastCheckedInTz;
        data["currentDateTz"] = this.currentDateTz;
        data["tenantTimeZoneAbbr"] = this.tenantTimeZoneAbbr;
        data["shiftStarted"] = this.shiftStarted;
        data["shiftEnded"] = this.shiftEnded;
        data["languageCode"] = this.languageCode;
        data["shiftName"] = this.shiftName;
        data["shiftId"] = this.shiftId;
        data["countryId"] = this.countryId;
        data["newPassword"] = this.newPassword;
        data["currentPassword"] = this.currentPassword;
        data["iconUrl"] = this.iconUrl;
        data["timeZoneId"] = this.timeZoneId;
        data["city"] = this.city;
        data["jobTitle"] = this.jobTitle;
        data["dateHired"] = this.dateHired;
        return data;
    }
}

export interface ICurrentUserProfileEditDto {
    id: number | undefined;
    name: string;
    surname: string | undefined;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean | undefined;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean | undefined;
    roles: string[] | undefined;
    employeeId: string | undefined;
    premise: string | undefined;
    hasProfileView: boolean | undefined;
    profilePictureId: string | undefined;
    managerId: number | undefined;
    managerName: string | undefined;
    teamsId: number[] | undefined;
    teamName: string | undefined;
    workSiteId: number | undefined;
    workSiteName: string | undefined;
    profilePictureUrl: string | undefined;
    lastCheckedIn: string | undefined;
    isRequireCheckin: boolean | undefined;
    isCaseCreated: boolean | undefined;
    isCanWorkFromHome: boolean | undefined;
    lastCheckedInTz: string | undefined;
    currentDateTz: string | undefined;
    tenantTimeZoneAbbr: string | undefined;
    shiftStarted: boolean | undefined;
    shiftEnded: boolean | undefined;
    languageCode: LangCode | undefined;
    shiftName: string | undefined;
    shiftId: number | undefined;
    countryId: number | undefined;
    newPassword: string | undefined;
    currentPassword: string | undefined;
    iconUrl: string | undefined;
    timeZoneId: number | undefined;
    city: string | undefined;
    jobTitle: string | undefined;
    dateHired: string | undefined;
}

export class EmailSignatureDto implements IEmailSignatureDto {
    html!: string | undefined;
    hasSignature!: boolean | undefined;
    addToNewEmails!: boolean | undefined;
    addToRepliesAndForwards!: boolean | undefined;

    constructor(data?: IEmailSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.html = _data["html"];
            this.hasSignature = _data["hasSignature"];
            this.addToNewEmails = _data["addToNewEmails"];
            this.addToRepliesAndForwards = _data["addToRepliesAndForwards"];
        }
    }

    static fromJS(data: any, _mappings?: any): EmailSignatureDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmailSignatureDto>(data, _mappings, EmailSignatureDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["html"] = this.html;
        data["hasSignature"] = this.hasSignature;
        data["addToNewEmails"] = this.addToNewEmails;
        data["addToRepliesAndForwards"] = this.addToRepliesAndForwards;
        return data;
    }
}

export interface IEmailSignatureDto {
    html: string | undefined;
    hasSignature: boolean | undefined;
    addToNewEmails: boolean | undefined;
    addToRepliesAndForwards: boolean | undefined;
}

export class UpdateEmailSignatureInput implements IUpdateEmailSignatureInput {
    html!: string | undefined;
    addToNewEmails!: boolean | undefined;
    addToRepliesAndForwards!: boolean | undefined;

    constructor(data?: IUpdateEmailSignatureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.html = _data["html"];
            this.addToNewEmails = _data["addToNewEmails"];
            this.addToRepliesAndForwards = _data["addToRepliesAndForwards"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateEmailSignatureInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateEmailSignatureInput>(data, _mappings, UpdateEmailSignatureInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["html"] = this.html;
        data["addToNewEmails"] = this.addToNewEmails;
        data["addToRepliesAndForwards"] = this.addToRepliesAndForwards;
        return data;
    }
}

export interface IUpdateEmailSignatureInput {
    html: string | undefined;
    addToNewEmails: boolean | undefined;
    addToRepliesAndForwards: boolean | undefined;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl!: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateGoogleAuthenticatorKeyOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateGoogleAuthenticatorKeyOutput>(data, _mappings, UpdateGoogleAuthenticatorKeyOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code!: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any, _mappings?: any): VerifySmsCodeInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<VerifySmsCodeInputDto>(data, _mappings, VerifySmsCodeInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
}

export class LookupTableModalOutputDto implements ILookupTableModalOutputDto {
    id!: number | undefined;
    code!: number | undefined;
    no!: string | undefined;
    name!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    isDeleted!: boolean | undefined;
    abbreviation!: string | undefined;
    cssClass!: string | undefined;
    iconUrl!: string | undefined;
    profilePictureId!: string | undefined;
    profilePicture!: string | undefined;
    profilePictureUrl!: string | undefined;
    isChecked!: boolean | undefined;
    bgColor!: string | undefined;
    color!: string | undefined;
    isSuggestAiTasks!: boolean | undefined;
    isPrivate!: boolean | undefined;
    isAutoAdd!: boolean | undefined;
    haveChecklistTemplate!: boolean | undefined;
    companyName!: string | undefined;
    url!: string | undefined;

    constructor(data?: ILookupTableModalOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.no = _data["no"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.isDeleted = _data["isDeleted"];
            this.abbreviation = _data["abbreviation"];
            this.cssClass = _data["cssClass"];
            this.iconUrl = _data["iconUrl"];
            this.profilePictureId = _data["profilePictureId"];
            this.profilePicture = _data["profilePicture"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.isChecked = _data["isChecked"];
            this.bgColor = _data["bgColor"];
            this.color = _data["color"];
            this.isSuggestAiTasks = _data["isSuggestAiTasks"];
            this.isPrivate = _data["isPrivate"];
            this.isAutoAdd = _data["isAutoAdd"];
            this.haveChecklistTemplate = _data["haveChecklistTemplate"];
            this.companyName = _data["companyName"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any, _mappings?: any): LookupTableModalOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LookupTableModalOutputDto>(data, _mappings, LookupTableModalOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["no"] = this.no;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["isDeleted"] = this.isDeleted;
        data["abbreviation"] = this.abbreviation;
        data["cssClass"] = this.cssClass;
        data["iconUrl"] = this.iconUrl;
        data["profilePictureId"] = this.profilePictureId;
        data["profilePicture"] = this.profilePicture;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["isChecked"] = this.isChecked;
        data["bgColor"] = this.bgColor;
        data["color"] = this.color;
        data["isSuggestAiTasks"] = this.isSuggestAiTasks;
        data["isPrivate"] = this.isPrivate;
        data["isAutoAdd"] = this.isAutoAdd;
        data["haveChecklistTemplate"] = this.haveChecklistTemplate;
        data["companyName"] = this.companyName;
        data["url"] = this.url;
        return data;
    }
}

export interface ILookupTableModalOutputDto {
    id: number | undefined;
    code: number | undefined;
    no: string | undefined;
    name: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    isDeleted: boolean | undefined;
    abbreviation: string | undefined;
    cssClass: string | undefined;
    iconUrl: string | undefined;
    profilePictureId: string | undefined;
    profilePicture: string | undefined;
    profilePictureUrl: string | undefined;
    isChecked: boolean | undefined;
    bgColor: string | undefined;
    color: string | undefined;
    isSuggestAiTasks: boolean | undefined;
    isPrivate: boolean | undefined;
    isAutoAdd: boolean | undefined;
    haveChecklistTemplate: boolean | undefined;
    companyName: string | undefined;
    url: string | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any, _mappings?: any): ChangePasswordInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangePasswordInput>(data, _mappings, ChangePasswordInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileName!: string;
    x!: number | undefined;
    y!: number | undefined;
    width!: number | undefined;
    height!: number | undefined;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateProfilePictureInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateProfilePictureInput>(data, _mappings, UpdateProfilePictureInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IUpdateProfilePictureInput {
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting!: PasswordComplexitySetting | undefined;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.setting = _data["setting"] ? PasswordComplexitySetting.fromJS(_data["setting"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): GetPasswordComplexitySettingOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetPasswordComplexitySettingOutput>(data, _mappings, GetPasswordComplexitySettingOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting | undefined;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture!: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetProfilePictureOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetProfilePictureOutput>(data, _mappings, GetProfilePictureOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ChangeUserLanguageDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangeUserLanguageDto>(data, _mappings, ChangeUserLanguageDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChangeAvatarInput implements IChangeAvatarInput {
    avatarId!: number | undefined;
    iconUrl!: string | undefined;

    constructor(data?: IChangeAvatarInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.avatarId = _data["avatarId"];
            this.iconUrl = _data["iconUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): ChangeAvatarInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangeAvatarInput>(data, _mappings, ChangeAvatarInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatarId"] = this.avatarId;
        data["iconUrl"] = this.iconUrl;
        return data;
    }
}

export interface IChangeAvatarInput {
    avatarId: number | undefined;
    iconUrl: string | undefined;
}

export class NotificationSettingsDto implements INotificationSettingsDto {
    isVinnyInstalled!: boolean | undefined;
    isEmailNotificationEnabled!: boolean | undefined;
    isTeamsNotificationEnabled!: boolean | undefined;

    constructor(data?: INotificationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isVinnyInstalled = _data["isVinnyInstalled"];
            this.isEmailNotificationEnabled = _data["isEmailNotificationEnabled"];
            this.isTeamsNotificationEnabled = _data["isTeamsNotificationEnabled"];
        }
    }

    static fromJS(data: any, _mappings?: any): NotificationSettingsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NotificationSettingsDto>(data, _mappings, NotificationSettingsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVinnyInstalled"] = this.isVinnyInstalled;
        data["isEmailNotificationEnabled"] = this.isEmailNotificationEnabled;
        data["isTeamsNotificationEnabled"] = this.isTeamsNotificationEnabled;
        return data;
    }
}

export interface INotificationSettingsDto {
    isVinnyInstalled: boolean | undefined;
    isEmailNotificationEnabled: boolean | undefined;
    isTeamsNotificationEnabled: boolean | undefined;
}

export class NotificationSettingsDtoIHandleError implements INotificationSettingsDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: NotificationSettingsDto | undefined;
    listOfEntities!: NotificationSettingsDto[] | undefined;

    constructor(data?: INotificationSettingsDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? NotificationSettingsDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(NotificationSettingsDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): NotificationSettingsDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NotificationSettingsDtoIHandleError>(data, _mappings, NotificationSettingsDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INotificationSettingsDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: NotificationSettingsDto | undefined;
    listOfEntities: NotificationSettingsDto[] | undefined;
}

export class NotificationSettingUpdateInput implements INotificationSettingUpdateInput {
    isEmailNotificationEnabled!: boolean | undefined;
    isTeamsNotificationEnabled!: boolean | undefined;

    constructor(data?: INotificationSettingUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isEmailNotificationEnabled = _data["isEmailNotificationEnabled"];
            this.isTeamsNotificationEnabled = _data["isTeamsNotificationEnabled"];
        }
    }

    static fromJS(data: any, _mappings?: any): NotificationSettingUpdateInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NotificationSettingUpdateInput>(data, _mappings, NotificationSettingUpdateInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailNotificationEnabled"] = this.isEmailNotificationEnabled;
        data["isTeamsNotificationEnabled"] = this.isTeamsNotificationEnabled;
        return data;
    }
}

export interface INotificationSettingUpdateInput {
    isEmailNotificationEnabled: boolean | undefined;
    isTeamsNotificationEnabled: boolean | undefined;
}

export class SetProjectsStageInput implements ISetProjectsStageInput {
    projectIds!: number[] | undefined;
    projectStageId!: number | undefined;

    constructor(data?: ISetProjectsStageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
            this.projectStageId = _data["projectStageId"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetProjectsStageInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetProjectsStageInput>(data, _mappings, SetProjectsStageInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        data["projectStageId"] = this.projectStageId;
        return data;
    }
}

export interface ISetProjectsStageInput {
    projectIds: number[] | undefined;
    projectStageId: number | undefined;
}

export class PinnedProjectsDto implements IPinnedProjectsDto {
    projectsIds!: number[] | undefined;
    pinsIds!: number[] | undefined;

    constructor(data?: IPinnedProjectsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["projectsIds"])) {
                this.projectsIds = [] as any;
                for (let item of _data["projectsIds"])
                    this.projectsIds!.push(item);
            }
            if (Array.isArray(_data["pinsIds"])) {
                this.pinsIds = [] as any;
                for (let item of _data["pinsIds"])
                    this.pinsIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PinnedProjectsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PinnedProjectsDto>(data, _mappings, PinnedProjectsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectsIds)) {
            data["projectsIds"] = [];
            for (let item of this.projectsIds)
                data["projectsIds"].push(item);
        }
        if (Array.isArray(this.pinsIds)) {
            data["pinsIds"] = [];
            for (let item of this.pinsIds)
                data["pinsIds"].push(item);
        }
        return data;
    }
}

export interface IPinnedProjectsDto {
    projectsIds: number[] | undefined;
    pinsIds: number[] | undefined;
}

export class ProjectStageDto implements IProjectStageDto {
    id!: number | undefined;
    name!: string | undefined;
    isActive!: boolean | undefined;
    isAssociatedToProject!: boolean | undefined;
    orderNumber!: number | undefined;

    constructor(data?: IProjectStageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.isAssociatedToProject = _data["isAssociatedToProject"];
            this.orderNumber = _data["orderNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectStageDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectStageDto>(data, _mappings, ProjectStageDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["isAssociatedToProject"] = this.isAssociatedToProject;
        data["orderNumber"] = this.orderNumber;
        return data;
    }
}

export interface IProjectStageDto {
    id: number | undefined;
    name: string | undefined;
    isActive: boolean | undefined;
    isAssociatedToProject: boolean | undefined;
    orderNumber: number | undefined;
}

export class ProjectTasksDto implements IProjectTasksDto {
    id!: number | undefined;
    creationTime!: string | undefined;
    ownerId!: number | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    completedOn!: string | undefined;
    isActive!: boolean | undefined;
    code!: number | undefined;
    sortOrder!: number | undefined;
    assignedToUserId!: number | undefined;
    assignedToUser!: string | undefined;
    assignedToUserProfilePictureUrl!: string | undefined;
    assignedToUserStatusCode!: number | undefined;
    isAddedOnMyDay!: boolean | undefined;
    isDueDatePassed!: boolean | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    priority!: TaskPriority | undefined;
    color!: string | undefined;
    tags!: string | undefined;
    projectTags!: ProjectTag[] | undefined;
    taskType!: TaskTypes | undefined;
    parentId!: number | undefined;
    isPartOfTaskTree!: boolean | undefined;
    isBlocked!: boolean | undefined;
    blockedByCount!: number | undefined;
    blockerTaskId!: number | undefined;
    blockerTitle!: string | undefined;
    blockerAssigneeName!: string | undefined;
    blockerDueDate!: string | undefined;
    completionDate!: string | undefined;
    contactId!: string | undefined;
    isSeen!: boolean | undefined;
    lastModificationTime!: string | undefined;
    createdByName!: string | undefined;
    lastModifiedByName!: string | undefined;
    totalTimeMinutes!: number | undefined;
    lastLoggedTime!: string | undefined;
    lastEntryMinutes!: number | undefined;
    taskNotes!: string | undefined;
    hasFiredFollowUp!: boolean | undefined;
    contributors!: TaskContributorDto[] | undefined;

    constructor(data?: IProjectTasksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.ownerId = _data["ownerId"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.completedOn = _data["completedOn"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.sortOrder = _data["sortOrder"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"];
            this.assignedToUserProfilePictureUrl = _data["assignedToUserProfilePictureUrl"];
            this.assignedToUserStatusCode = _data["assignedToUserStatusCode"];
            this.isAddedOnMyDay = _data["isAddedOnMyDay"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.priority = _data["priority"];
            this.color = _data["color"];
            this.tags = _data["tags"];
            if (Array.isArray(_data["projectTags"])) {
                this.projectTags = [] as any;
                for (let item of _data["projectTags"])
                    this.projectTags!.push(ProjectTag.fromJS(item, _mappings));
            }
            this.taskType = _data["taskType"];
            this.parentId = _data["parentId"];
            this.isPartOfTaskTree = _data["isPartOfTaskTree"];
            this.isBlocked = _data["isBlocked"];
            this.blockedByCount = _data["blockedByCount"];
            this.blockerTaskId = _data["blockerTaskId"];
            this.blockerTitle = _data["blockerTitle"];
            this.blockerAssigneeName = _data["blockerAssigneeName"];
            this.blockerDueDate = _data["blockerDueDate"];
            this.completionDate = _data["completionDate"];
            this.contactId = _data["contactId"];
            this.isSeen = _data["isSeen"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.createdByName = _data["createdByName"];
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.totalTimeMinutes = _data["totalTimeMinutes"];
            this.lastLoggedTime = _data["lastLoggedTime"];
            this.lastEntryMinutes = _data["lastEntryMinutes"];
            this.taskNotes = _data["taskNotes"];
            this.hasFiredFollowUp = _data["hasFiredFollowUp"];
            if (Array.isArray(_data["contributors"])) {
                this.contributors = [] as any;
                for (let item of _data["contributors"])
                    this.contributors!.push(TaskContributorDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTasksDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTasksDto>(data, _mappings, ProjectTasksDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["ownerId"] = this.ownerId;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["completedOn"] = this.completedOn;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["sortOrder"] = this.sortOrder;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser;
        data["assignedToUserProfilePictureUrl"] = this.assignedToUserProfilePictureUrl;
        data["assignedToUserStatusCode"] = this.assignedToUserStatusCode;
        data["isAddedOnMyDay"] = this.isAddedOnMyDay;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["priority"] = this.priority;
        data["color"] = this.color;
        data["tags"] = this.tags;
        if (Array.isArray(this.projectTags)) {
            data["projectTags"] = [];
            for (let item of this.projectTags)
                data["projectTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["taskType"] = this.taskType;
        data["parentId"] = this.parentId;
        data["isPartOfTaskTree"] = this.isPartOfTaskTree;
        data["isBlocked"] = this.isBlocked;
        data["blockedByCount"] = this.blockedByCount;
        data["blockerTaskId"] = this.blockerTaskId;
        data["blockerTitle"] = this.blockerTitle;
        data["blockerAssigneeName"] = this.blockerAssigneeName;
        data["blockerDueDate"] = this.blockerDueDate;
        data["completionDate"] = this.completionDate;
        data["contactId"] = this.contactId;
        data["isSeen"] = this.isSeen;
        data["lastModificationTime"] = this.lastModificationTime;
        data["createdByName"] = this.createdByName;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["totalTimeMinutes"] = this.totalTimeMinutes;
        data["lastLoggedTime"] = this.lastLoggedTime;
        data["lastEntryMinutes"] = this.lastEntryMinutes;
        data["taskNotes"] = this.taskNotes;
        data["hasFiredFollowUp"] = this.hasFiredFollowUp;
        if (Array.isArray(this.contributors)) {
            data["contributors"] = [];
            for (let item of this.contributors)
                data["contributors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTasksDto {
    id: number | undefined;
    creationTime: string | undefined;
    ownerId: number | undefined;
    title: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    completedOn: string | undefined;
    isActive: boolean | undefined;
    code: number | undefined;
    sortOrder: number | undefined;
    assignedToUserId: number | undefined;
    assignedToUser: string | undefined;
    assignedToUserProfilePictureUrl: string | undefined;
    assignedToUserStatusCode: number | undefined;
    isAddedOnMyDay: boolean | undefined;
    isDueDatePassed: boolean | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    priority: TaskPriority | undefined;
    color: string | undefined;
    tags: string | undefined;
    projectTags: ProjectTag[] | undefined;
    taskType: TaskTypes | undefined;
    parentId: number | undefined;
    isPartOfTaskTree: boolean | undefined;
    isBlocked: boolean | undefined;
    blockedByCount: number | undefined;
    blockerTaskId: number | undefined;
    blockerTitle: string | undefined;
    blockerAssigneeName: string | undefined;
    blockerDueDate: string | undefined;
    completionDate: string | undefined;
    contactId: string | undefined;
    isSeen: boolean | undefined;
    lastModificationTime: string | undefined;
    createdByName: string | undefined;
    lastModifiedByName: string | undefined;
    totalTimeMinutes: number | undefined;
    lastLoggedTime: string | undefined;
    lastEntryMinutes: number | undefined;
    taskNotes: string | undefined;
    hasFiredFollowUp: boolean | undefined;
    contributors: TaskContributorDto[] | undefined;
}

export class ProjectSectionsDto implements IProjectSectionsDto {
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    bgColor!: string | undefined;
    sortOrder!: number | undefined;
    isHide!: boolean | undefined;
    isExpanded!: boolean | undefined;
    totalCompetedTasks!: number | undefined;
    totalInCompetedTasks!: number | undefined;
    tasksInJson!: string | undefined;
    tasks!: ProjectTasksDto[] | undefined;

    constructor(data?: IProjectSectionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.bgColor = _data["bgColor"];
            this.sortOrder = _data["sortOrder"];
            this.isHide = _data["isHide"];
            this.isExpanded = _data["isExpanded"];
            this.totalCompetedTasks = _data["totalCompetedTasks"];
            this.totalInCompetedTasks = _data["totalInCompetedTasks"];
            this.tasksInJson = _data["tasksInJson"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ProjectTasksDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectSectionsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectSectionsDto>(data, _mappings, ProjectSectionsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["bgColor"] = this.bgColor;
        data["sortOrder"] = this.sortOrder;
        data["isHide"] = this.isHide;
        data["isExpanded"] = this.isExpanded;
        data["totalCompetedTasks"] = this.totalCompetedTasks;
        data["totalInCompetedTasks"] = this.totalInCompetedTasks;
        data["tasksInJson"] = this.tasksInJson;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectSectionsDto {
    sectionId: number | undefined;
    sectionName: string | undefined;
    bgColor: string | undefined;
    sortOrder: number | undefined;
    isHide: boolean | undefined;
    isExpanded: boolean | undefined;
    totalCompetedTasks: number | undefined;
    totalInCompetedTasks: number | undefined;
    tasksInJson: string | undefined;
    tasks: ProjectTasksDto[] | undefined;
}

export class ProjectDetailOutputDto implements IProjectDetailOutputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    sortOrder!: number | undefined;
    statusId!: number | undefined;
    code!: number | undefined;
    projectName!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isPrivate!: boolean | undefined;
    pinnedEntityId!: number | undefined;
    projectStageJson!: string | undefined;
    projectStage!: ProjectStageDto | undefined;
    projectSectionText!: string | undefined;
    projectSections!: ProjectSectionsDto[] | undefined;
    isSuggestAiTasks!: boolean | undefined;
    description!: string | undefined;
    haveChecklistTemplate!: boolean | undefined;
    isAutoAdd!: boolean | undefined;
    isDueDatePassed!: boolean | undefined;
    healthScore!: number | undefined;
    scoreExplanation!: string | undefined;
    scoreLastUpdated!: string | undefined;

    constructor(data?: IProjectDetailOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            this.sortOrder = _data["sortOrder"];
            this.statusId = _data["statusId"];
            this.code = _data["code"];
            this.projectName = _data["projectName"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isPrivate = _data["isPrivate"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.projectStageJson = _data["projectStageJson"];
            this.projectStage = _data["projectStage"] ? ProjectStageDto.fromJS(_data["projectStage"], _mappings) : undefined as any;
            this.projectSectionText = _data["projectSectionText"];
            if (Array.isArray(_data["projectSections"])) {
                this.projectSections = [] as any;
                for (let item of _data["projectSections"])
                    this.projectSections!.push(ProjectSectionsDto.fromJS(item, _mappings));
            }
            this.isSuggestAiTasks = _data["isSuggestAiTasks"];
            this.description = _data["description"];
            this.haveChecklistTemplate = _data["haveChecklistTemplate"];
            this.isAutoAdd = _data["isAutoAdd"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.healthScore = _data["healthScore"];
            this.scoreExplanation = _data["scoreExplanation"];
            this.scoreLastUpdated = _data["scoreLastUpdated"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectDetailOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectDetailOutputDto>(data, _mappings, ProjectDetailOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        data["sortOrder"] = this.sortOrder;
        data["statusId"] = this.statusId;
        data["code"] = this.code;
        data["projectName"] = this.projectName;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isPrivate"] = this.isPrivate;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["projectStageJson"] = this.projectStageJson;
        data["projectStage"] = this.projectStage ? this.projectStage.toJSON() : undefined as any;
        data["projectSectionText"] = this.projectSectionText;
        if (Array.isArray(this.projectSections)) {
            data["projectSections"] = [];
            for (let item of this.projectSections)
                data["projectSections"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSuggestAiTasks"] = this.isSuggestAiTasks;
        data["description"] = this.description;
        data["haveChecklistTemplate"] = this.haveChecklistTemplate;
        data["isAutoAdd"] = this.isAutoAdd;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["healthScore"] = this.healthScore;
        data["scoreExplanation"] = this.scoreExplanation;
        data["scoreLastUpdated"] = this.scoreLastUpdated;
        return data;
    }
}

export interface IProjectDetailOutputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    sortOrder: number | undefined;
    statusId: number | undefined;
    code: number | undefined;
    projectName: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isPrivate: boolean | undefined;
    pinnedEntityId: number | undefined;
    projectStageJson: string | undefined;
    projectStage: ProjectStageDto | undefined;
    projectSectionText: string | undefined;
    projectSections: ProjectSectionsDto[] | undefined;
    isSuggestAiTasks: boolean | undefined;
    description: string | undefined;
    haveChecklistTemplate: boolean | undefined;
    isAutoAdd: boolean | undefined;
    isDueDatePassed: boolean | undefined;
    healthScore: number | undefined;
    scoreExplanation: string | undefined;
    scoreLastUpdated: string | undefined;
}

export class GetRolesOuput implements IGetRolesOuput {
    roleId!: number | undefined;
    roleName!: string | undefined;
    roleType!: RoleType | undefined;

    constructor(data?: IGetRolesOuput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleType = _data["roleType"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetRolesOuput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetRolesOuput>(data, _mappings, GetRolesOuput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleType"] = this.roleType;
        return data;
    }
}

export interface IGetRolesOuput {
    roleId: number | undefined;
    roleName: string | undefined;
    roleType: RoleType | undefined;
}

export class GetRolesOuputListIHandleError implements IGetRolesOuputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetRolesOuput[] | undefined;
    listOfEntities!: GetRolesOuput[][] | undefined;

    constructor(data?: IGetRolesOuputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(GetRolesOuput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetRolesOuputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetRolesOuputListIHandleError>(data, _mappings, GetRolesOuputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IGetRolesOuputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetRolesOuput[] | undefined;
    listOfEntities: GetRolesOuput[][] | undefined;
}

export class SuggestedMemberOutput implements ISuggestedMemberOutput {
    id!: number | undefined;
    lastName!: string | undefined;
    firstName!: string | undefined;
    profilePictureUrl!: string | undefined;
    initials!: string | undefined;

    constructor(data?: ISuggestedMemberOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.initials = _data["initials"];
        }
    }

    static fromJS(data: any, _mappings?: any): SuggestedMemberOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SuggestedMemberOutput>(data, _mappings, SuggestedMemberOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["initials"] = this.initials;
        return data;
    }
}

export interface ISuggestedMemberOutput {
    id: number | undefined;
    lastName: string | undefined;
    firstName: string | undefined;
    profilePictureUrl: string | undefined;
    initials: string | undefined;
}

export class SuggestedMemberOutputListIHandleError implements ISuggestedMemberOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SuggestedMemberOutput[] | undefined;
    listOfEntities!: SuggestedMemberOutput[][] | undefined;

    constructor(data?: ISuggestedMemberOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(SuggestedMemberOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SuggestedMemberOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SuggestedMemberOutputListIHandleError>(data, _mappings, SuggestedMemberOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ISuggestedMemberOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SuggestedMemberOutput[] | undefined;
    listOfEntities: SuggestedMemberOutput[][] | undefined;
}

export class ProjectCommentDto implements IProjectCommentDto {
    id!: number | undefined;
    projectId!: number | undefined;
    parentCommentId!: number | undefined;
    isReply!: boolean | undefined;
    comment!: string | undefined;
    creatorUserId!: number | undefined;
    createdBy!: string | undefined;
    userImg!: string | undefined;
    userInitials!: string | undefined;
    creationTime!: string | undefined;
    editedAt!: string | undefined;
    canEdit!: boolean | undefined;
    canDelete!: boolean | undefined;
    editExpiresAtUtc!: string | undefined;
    isNew!: boolean | undefined;

    constructor(data?: IProjectCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.parentCommentId = _data["parentCommentId"];
            this.isReply = _data["isReply"];
            this.comment = _data["comment"];
            this.creatorUserId = _data["creatorUserId"];
            this.createdBy = _data["createdBy"];
            this.userImg = _data["userImg"];
            this.userInitials = _data["userInitials"];
            this.creationTime = _data["creationTime"];
            this.editedAt = _data["editedAt"];
            this.canEdit = _data["canEdit"];
            this.canDelete = _data["canDelete"];
            this.editExpiresAtUtc = _data["editExpiresAtUtc"];
            this.isNew = _data["isNew"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectCommentDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectCommentDto>(data, _mappings, ProjectCommentDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["parentCommentId"] = this.parentCommentId;
        data["isReply"] = this.isReply;
        data["comment"] = this.comment;
        data["creatorUserId"] = this.creatorUserId;
        data["createdBy"] = this.createdBy;
        data["userImg"] = this.userImg;
        data["userInitials"] = this.userInitials;
        data["creationTime"] = this.creationTime;
        data["editedAt"] = this.editedAt;
        data["canEdit"] = this.canEdit;
        data["canDelete"] = this.canDelete;
        data["editExpiresAtUtc"] = this.editExpiresAtUtc;
        data["isNew"] = this.isNew;
        return data;
    }
}

export interface IProjectCommentDto {
    id: number | undefined;
    projectId: number | undefined;
    parentCommentId: number | undefined;
    isReply: boolean | undefined;
    comment: string | undefined;
    creatorUserId: number | undefined;
    createdBy: string | undefined;
    userImg: string | undefined;
    userInitials: string | undefined;
    creationTime: string | undefined;
    editedAt: string | undefined;
    canEdit: boolean | undefined;
    canDelete: boolean | undefined;
    editExpiresAtUtc: string | undefined;
    isNew: boolean | undefined;
}

export class ProjectCommentListDto implements IProjectCommentListDto {
    projectId!: number | undefined;
    projectName!: string | undefined;
    canPost!: boolean | undefined;
    comments!: ProjectCommentDto[] | undefined;

    constructor(data?: IProjectCommentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.canPost = _data["canPost"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(ProjectCommentDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectCommentListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectCommentListDto>(data, _mappings, ProjectCommentListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["canPost"] = this.canPost;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectCommentListDto {
    projectId: number | undefined;
    projectName: string | undefined;
    canPost: boolean | undefined;
    comments: ProjectCommentDto[] | undefined;
}

export class CreateProjectCommentInput implements ICreateProjectCommentInput {
    projectId!: number | undefined;
    parentCommentId!: number | undefined;
    comment!: string;

    constructor(data?: ICreateProjectCommentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.parentCommentId = _data["parentCommentId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateProjectCommentInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateProjectCommentInput>(data, _mappings, CreateProjectCommentInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["parentCommentId"] = this.parentCommentId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ICreateProjectCommentInput {
    projectId: number | undefined;
    parentCommentId: number | undefined;
    comment: string;
}

export class UpdateProjectCommentTextInput implements IUpdateProjectCommentTextInput {
    commentId!: number | undefined;
    comment!: string;

    constructor(data?: IUpdateProjectCommentTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.commentId = _data["commentId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateProjectCommentTextInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateProjectCommentTextInput>(data, _mappings, UpdateProjectCommentTextInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentId"] = this.commentId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateProjectCommentTextInput {
    commentId: number | undefined;
    comment: string;
}

export class MarkProjectCommentSeenInput implements IMarkProjectCommentSeenInput {
    commentId!: number | undefined;

    constructor(data?: IMarkProjectCommentSeenInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.commentId = _data["commentId"];
        }
    }

    static fromJS(data: any, _mappings?: any): MarkProjectCommentSeenInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MarkProjectCommentSeenInput>(data, _mappings, MarkProjectCommentSeenInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentId"] = this.commentId;
        return data;
    }
}

export interface IMarkProjectCommentSeenInput {
    commentId: number | undefined;
}

export enum ClientFieldScope {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ProjectNameMode {
    _1 = 1,
    _2 = 2,
}

export class NameSourceFieldDto implements INameSourceFieldDto {
    fieldDefinitionId!: number | undefined;
    nativeKey!: NativeFieldKey | undefined;

    constructor(data?: INameSourceFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fieldDefinitionId = _data["fieldDefinitionId"];
            this.nativeKey = _data["nativeKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): NameSourceFieldDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NameSourceFieldDto>(data, _mappings, NameSourceFieldDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldDefinitionId"] = this.fieldDefinitionId;
        data["nativeKey"] = this.nativeKey;
        return data;
    }
}

export interface INameSourceFieldDto {
    fieldDefinitionId: number | undefined;
    nativeKey: NativeFieldKey | undefined;
}

export enum ProjectNumberMode {
    _1 = 1,
    _2 = 2,
}

export class ProjectFieldSettingsDto implements IProjectFieldSettingsDto {
    options!: string[] | undefined;
    clientScope!: ClientFieldScope | undefined;
    defaultCurrency!: string | undefined;
    nameMode!: ProjectNameMode | undefined;
    nameSourceFields!: NameSourceFieldDto[] | undefined;
    nameSeparator!: string | undefined;
    numberMode!: ProjectNumberMode | undefined;
    numberPrefix!: string | undefined;
    numberSuffix!: string | undefined;
    numberStart!: number | undefined;
    numberDigits!: number | undefined;
    numberResetAnnually!: boolean | undefined;

    constructor(data?: IProjectFieldSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            this.clientScope = _data["clientScope"];
            this.defaultCurrency = _data["defaultCurrency"];
            this.nameMode = _data["nameMode"];
            if (Array.isArray(_data["nameSourceFields"])) {
                this.nameSourceFields = [] as any;
                for (let item of _data["nameSourceFields"])
                    this.nameSourceFields!.push(NameSourceFieldDto.fromJS(item, _mappings));
            }
            this.nameSeparator = _data["nameSeparator"];
            this.numberMode = _data["numberMode"];
            this.numberPrefix = _data["numberPrefix"];
            this.numberSuffix = _data["numberSuffix"];
            this.numberStart = _data["numberStart"];
            this.numberDigits = _data["numberDigits"];
            this.numberResetAnnually = _data["numberResetAnnually"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectFieldSettingsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectFieldSettingsDto>(data, _mappings, ProjectFieldSettingsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["clientScope"] = this.clientScope;
        data["defaultCurrency"] = this.defaultCurrency;
        data["nameMode"] = this.nameMode;
        if (Array.isArray(this.nameSourceFields)) {
            data["nameSourceFields"] = [];
            for (let item of this.nameSourceFields)
                data["nameSourceFields"].push(item ? item.toJSON() : undefined as any);
        }
        data["nameSeparator"] = this.nameSeparator;
        data["numberMode"] = this.numberMode;
        data["numberPrefix"] = this.numberPrefix;
        data["numberSuffix"] = this.numberSuffix;
        data["numberStart"] = this.numberStart;
        data["numberDigits"] = this.numberDigits;
        data["numberResetAnnually"] = this.numberResetAnnually;
        return data;
    }
}

export interface IProjectFieldSettingsDto {
    options: string[] | undefined;
    clientScope: ClientFieldScope | undefined;
    defaultCurrency: string | undefined;
    nameMode: ProjectNameMode | undefined;
    nameSourceFields: NameSourceFieldDto[] | undefined;
    nameSeparator: string | undefined;
    numberMode: ProjectNumberMode | undefined;
    numberPrefix: string | undefined;
    numberSuffix: string | undefined;
    numberStart: number | undefined;
    numberDigits: number | undefined;
    numberResetAnnually: boolean | undefined;
}

export class ProjectFieldDefinitionDto implements IProjectFieldDefinitionDto {
    id!: number | undefined;
    sectionId!: number | undefined;
    label!: string | undefined;
    fieldType!: ProjectFieldType | undefined;
    orderNumber!: number | undefined;
    isRequired!: boolean | undefined;
    isNative!: boolean | undefined;
    isLocked!: boolean | undefined;
    nativeKey!: NativeFieldKey | undefined;
    settings!: ProjectFieldSettingsDto | undefined;

    constructor(data?: IProjectFieldDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sectionId = _data["sectionId"];
            this.label = _data["label"];
            this.fieldType = _data["fieldType"];
            this.orderNumber = _data["orderNumber"];
            this.isRequired = _data["isRequired"];
            this.isNative = _data["isNative"];
            this.isLocked = _data["isLocked"];
            this.nativeKey = _data["nativeKey"];
            this.settings = _data["settings"] ? ProjectFieldSettingsDto.fromJS(_data["settings"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectFieldDefinitionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectFieldDefinitionDto>(data, _mappings, ProjectFieldDefinitionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sectionId"] = this.sectionId;
        data["label"] = this.label;
        data["fieldType"] = this.fieldType;
        data["orderNumber"] = this.orderNumber;
        data["isRequired"] = this.isRequired;
        data["isNative"] = this.isNative;
        data["isLocked"] = this.isLocked;
        data["nativeKey"] = this.nativeKey;
        data["settings"] = this.settings ? this.settings.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectFieldDefinitionDto {
    id: number | undefined;
    sectionId: number | undefined;
    label: string | undefined;
    fieldType: ProjectFieldType | undefined;
    orderNumber: number | undefined;
    isRequired: boolean | undefined;
    isNative: boolean | undefined;
    isLocked: boolean | undefined;
    nativeKey: NativeFieldKey | undefined;
    settings: ProjectFieldSettingsDto | undefined;
}

export class ProjectFieldSectionDto implements IProjectFieldSectionDto {
    id!: number | undefined;
    name!: string | undefined;
    orderNumber!: number | undefined;
    isGeneral!: boolean | undefined;
    fields!: ProjectFieldDefinitionDto[] | undefined;

    constructor(data?: IProjectFieldSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.orderNumber = _data["orderNumber"];
            this.isGeneral = _data["isGeneral"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(ProjectFieldDefinitionDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectFieldSectionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectFieldSectionDto>(data, _mappings, ProjectFieldSectionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["orderNumber"] = this.orderNumber;
        data["isGeneral"] = this.isGeneral;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectFieldSectionDto {
    id: number | undefined;
    name: string | undefined;
    orderNumber: number | undefined;
    isGeneral: boolean | undefined;
    fields: ProjectFieldDefinitionDto[] | undefined;
}

export class AvailablePredefinedFieldDto implements IAvailablePredefinedFieldDto {
    nativeKey!: NativeFieldKey | undefined;
    label!: string | undefined;
    fieldType!: ProjectFieldType | undefined;

    constructor(data?: IAvailablePredefinedFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.nativeKey = _data["nativeKey"];
            this.label = _data["label"];
            this.fieldType = _data["fieldType"];
        }
    }

    static fromJS(data: any, _mappings?: any): AvailablePredefinedFieldDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AvailablePredefinedFieldDto>(data, _mappings, AvailablePredefinedFieldDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nativeKey"] = this.nativeKey;
        data["label"] = this.label;
        data["fieldType"] = this.fieldType;
        return data;
    }
}

export interface IAvailablePredefinedFieldDto {
    nativeKey: NativeFieldKey | undefined;
    label: string | undefined;
    fieldType: ProjectFieldType | undefined;
}

export class ProjectFieldConfigDto implements IProjectFieldConfigDto {
    sections!: ProjectFieldSectionDto[] | undefined;
    availableFields!: AvailablePredefinedFieldDto[] | undefined;

    constructor(data?: IProjectFieldConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(ProjectFieldSectionDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["availableFields"])) {
                this.availableFields = [] as any;
                for (let item of _data["availableFields"])
                    this.availableFields!.push(AvailablePredefinedFieldDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectFieldConfigDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectFieldConfigDto>(data, _mappings, ProjectFieldConfigDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.availableFields)) {
            data["availableFields"] = [];
            for (let item of this.availableFields)
                data["availableFields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectFieldConfigDto {
    sections: ProjectFieldSectionDto[] | undefined;
    availableFields: AvailablePredefinedFieldDto[] | undefined;
}

export class ProjectFieldConfigDtoIHandleError implements IProjectFieldConfigDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectFieldConfigDto | undefined;
    listOfEntities!: ProjectFieldConfigDto[] | undefined;

    constructor(data?: IProjectFieldConfigDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProjectFieldConfigDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProjectFieldConfigDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectFieldConfigDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectFieldConfigDtoIHandleError>(data, _mappings, ProjectFieldConfigDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectFieldConfigDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectFieldConfigDto | undefined;
    listOfEntities: ProjectFieldConfigDto[] | undefined;
}

export class SaveFieldInput implements ISaveFieldInput {
    id!: number | undefined;
    label!: string | undefined;
    fieldType!: ProjectFieldType | undefined;
    orderNumber!: number | undefined;
    isRequired!: boolean | undefined;
    isNative!: boolean | undefined;
    isLocked!: boolean | undefined;
    nativeKey!: NativeFieldKey | undefined;
    settings!: ProjectFieldSettingsDto | undefined;

    constructor(data?: ISaveFieldInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.fieldType = _data["fieldType"];
            this.orderNumber = _data["orderNumber"];
            this.isRequired = _data["isRequired"];
            this.isNative = _data["isNative"];
            this.isLocked = _data["isLocked"];
            this.nativeKey = _data["nativeKey"];
            this.settings = _data["settings"] ? ProjectFieldSettingsDto.fromJS(_data["settings"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): SaveFieldInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveFieldInput>(data, _mappings, SaveFieldInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["fieldType"] = this.fieldType;
        data["orderNumber"] = this.orderNumber;
        data["isRequired"] = this.isRequired;
        data["isNative"] = this.isNative;
        data["isLocked"] = this.isLocked;
        data["nativeKey"] = this.nativeKey;
        data["settings"] = this.settings ? this.settings.toJSON() : undefined as any;
        return data;
    }
}

export interface ISaveFieldInput {
    id: number | undefined;
    label: string | undefined;
    fieldType: ProjectFieldType | undefined;
    orderNumber: number | undefined;
    isRequired: boolean | undefined;
    isNative: boolean | undefined;
    isLocked: boolean | undefined;
    nativeKey: NativeFieldKey | undefined;
    settings: ProjectFieldSettingsDto | undefined;
}

export class SaveSectionInput implements ISaveSectionInput {
    id!: number | undefined;
    name!: string | undefined;
    orderNumber!: number | undefined;
    isGeneral!: boolean | undefined;
    fields!: SaveFieldInput[] | undefined;

    constructor(data?: ISaveSectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.orderNumber = _data["orderNumber"];
            this.isGeneral = _data["isGeneral"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(SaveFieldInput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SaveSectionInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveSectionInput>(data, _mappings, SaveSectionInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["orderNumber"] = this.orderNumber;
        data["isGeneral"] = this.isGeneral;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveSectionInput {
    id: number | undefined;
    name: string | undefined;
    orderNumber: number | undefined;
    isGeneral: boolean | undefined;
    fields: SaveFieldInput[] | undefined;
}

export class SaveProjectFieldConfigInput implements ISaveProjectFieldConfigInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    sections!: SaveSectionInput[] | undefined;

    constructor(data?: ISaveProjectFieldConfigInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SaveSectionInput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SaveProjectFieldConfigInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveProjectFieldConfigInput>(data, _mappings, SaveProjectFieldConfigInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveProjectFieldConfigInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    sections: SaveSectionInput[] | undefined;
}

export class ProjectDetailsFieldDto implements IProjectDetailsFieldDto {
    fieldDefinitionId!: number | undefined;
    label!: string | undefined;
    fieldType!: ProjectFieldType | undefined;
    orderNumber!: number | undefined;
    isRequired!: boolean | undefined;
    isNative!: boolean | undefined;
    isLocked!: boolean | undefined;
    nativeKey!: NativeFieldKey | undefined;
    settings!: ProjectFieldSettingsDto | undefined;
    valueJson!: string | undefined;

    constructor(data?: IProjectDetailsFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fieldDefinitionId = _data["fieldDefinitionId"];
            this.label = _data["label"];
            this.fieldType = _data["fieldType"];
            this.orderNumber = _data["orderNumber"];
            this.isRequired = _data["isRequired"];
            this.isNative = _data["isNative"];
            this.isLocked = _data["isLocked"];
            this.nativeKey = _data["nativeKey"];
            this.settings = _data["settings"] ? ProjectFieldSettingsDto.fromJS(_data["settings"], _mappings) : undefined as any;
            this.valueJson = _data["valueJson"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectDetailsFieldDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectDetailsFieldDto>(data, _mappings, ProjectDetailsFieldDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldDefinitionId"] = this.fieldDefinitionId;
        data["label"] = this.label;
        data["fieldType"] = this.fieldType;
        data["orderNumber"] = this.orderNumber;
        data["isRequired"] = this.isRequired;
        data["isNative"] = this.isNative;
        data["isLocked"] = this.isLocked;
        data["nativeKey"] = this.nativeKey;
        data["settings"] = this.settings ? this.settings.toJSON() : undefined as any;
        data["valueJson"] = this.valueJson;
        return data;
    }
}

export interface IProjectDetailsFieldDto {
    fieldDefinitionId: number | undefined;
    label: string | undefined;
    fieldType: ProjectFieldType | undefined;
    orderNumber: number | undefined;
    isRequired: boolean | undefined;
    isNative: boolean | undefined;
    isLocked: boolean | undefined;
    nativeKey: NativeFieldKey | undefined;
    settings: ProjectFieldSettingsDto | undefined;
    valueJson: string | undefined;
}

export class ProjectDetailsSectionDto implements IProjectDetailsSectionDto {
    sectionId!: number | undefined;
    name!: string | undefined;
    orderNumber!: number | undefined;
    isGeneral!: boolean | undefined;
    fields!: ProjectDetailsFieldDto[] | undefined;

    constructor(data?: IProjectDetailsSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.name = _data["name"];
            this.orderNumber = _data["orderNumber"];
            this.isGeneral = _data["isGeneral"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(ProjectDetailsFieldDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectDetailsSectionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectDetailsSectionDto>(data, _mappings, ProjectDetailsSectionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["name"] = this.name;
        data["orderNumber"] = this.orderNumber;
        data["isGeneral"] = this.isGeneral;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectDetailsSectionDto {
    sectionId: number | undefined;
    name: string | undefined;
    orderNumber: number | undefined;
    isGeneral: boolean | undefined;
    fields: ProjectDetailsFieldDto[] | undefined;
}

export class ProjectDetailsViewDto implements IProjectDetailsViewDto {
    projectId!: number | undefined;
    sections!: ProjectDetailsSectionDto[] | undefined;

    constructor(data?: IProjectDetailsViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(ProjectDetailsSectionDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectDetailsViewDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectDetailsViewDto>(data, _mappings, ProjectDetailsViewDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectDetailsViewDto {
    projectId: number | undefined;
    sections: ProjectDetailsSectionDto[] | undefined;
}

export class ProjectDetailsViewDtoIHandleError implements IProjectDetailsViewDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectDetailsViewDto | undefined;
    listOfEntities!: ProjectDetailsViewDto[] | undefined;

    constructor(data?: IProjectDetailsViewDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProjectDetailsViewDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProjectDetailsViewDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectDetailsViewDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectDetailsViewDtoIHandleError>(data, _mappings, ProjectDetailsViewDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectDetailsViewDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectDetailsViewDto | undefined;
    listOfEntities: ProjectDetailsViewDto[] | undefined;
}

export class GetProjectFieldValuesInput implements IGetProjectFieldValuesInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectIds!: number[] | undefined;

    constructor(data?: IGetProjectFieldValuesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetProjectFieldValuesInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetProjectFieldValuesInput>(data, _mappings, GetProjectFieldValuesInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface IGetProjectFieldValuesInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectIds: number[] | undefined;
}

export class ProjectFieldValueInput implements IProjectFieldValueInput {
    fieldDefinitionId!: number | undefined;
    valueJson!: string | undefined;

    constructor(data?: IProjectFieldValueInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fieldDefinitionId = _data["fieldDefinitionId"];
            this.valueJson = _data["valueJson"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectFieldValueInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectFieldValueInput>(data, _mappings, ProjectFieldValueInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldDefinitionId"] = this.fieldDefinitionId;
        data["valueJson"] = this.valueJson;
        return data;
    }
}

export interface IProjectFieldValueInput {
    fieldDefinitionId: number | undefined;
    valueJson: string | undefined;
}

export class ProjectFieldValuesRowDto implements IProjectFieldValuesRowDto {
    projectId!: number | undefined;
    values!: ProjectFieldValueInput[] | undefined;

    constructor(data?: IProjectFieldValuesRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ProjectFieldValueInput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectFieldValuesRowDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectFieldValuesRowDto>(data, _mappings, ProjectFieldValuesRowDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectFieldValuesRowDto {
    projectId: number | undefined;
    values: ProjectFieldValueInput[] | undefined;
}

export class ProjectFieldValuesRowDtoListIHandleError implements IProjectFieldValuesRowDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectFieldValuesRowDto[] | undefined;
    listOfEntities!: ProjectFieldValuesRowDto[][] | undefined;

    constructor(data?: IProjectFieldValuesRowDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectFieldValuesRowDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectFieldValuesRowDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectFieldValuesRowDtoListIHandleError>(data, _mappings, ProjectFieldValuesRowDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectFieldValuesRowDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectFieldValuesRowDto[] | undefined;
    listOfEntities: ProjectFieldValuesRowDto[][] | undefined;
}

export class ProjectHistoryEntryDto implements IProjectHistoryEntryDto {
    id!: number | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    description!: string | undefined;
    creationTime!: string | undefined;

    constructor(data?: IProjectHistoryEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectHistoryEntryDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectHistoryEntryDto>(data, _mappings, ProjectHistoryEntryDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime;
        return data;
    }
}

export interface IProjectHistoryEntryDto {
    id: number | undefined;
    userId: number | undefined;
    userName: string | undefined;
    description: string | undefined;
    creationTime: string | undefined;
}

export class ProjectHistoryEntryDtoListIHandleError implements IProjectHistoryEntryDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectHistoryEntryDto[] | undefined;
    listOfEntities!: ProjectHistoryEntryDto[][] | undefined;

    constructor(data?: IProjectHistoryEntryDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectHistoryEntryDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectHistoryEntryDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectHistoryEntryDtoListIHandleError>(data, _mappings, ProjectHistoryEntryDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectHistoryEntryDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectHistoryEntryDto[] | undefined;
    listOfEntities: ProjectHistoryEntryDto[][] | undefined;
}

export class UpdateProjectFieldValueInput implements IUpdateProjectFieldValueInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    fieldDefinitionId!: number | undefined;
    valueJson!: string | undefined;

    constructor(data?: IUpdateProjectFieldValueInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            this.fieldDefinitionId = _data["fieldDefinitionId"];
            this.valueJson = _data["valueJson"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateProjectFieldValueInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateProjectFieldValueInput>(data, _mappings, UpdateProjectFieldValueInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        data["fieldDefinitionId"] = this.fieldDefinitionId;
        data["valueJson"] = this.valueJson;
        return data;
    }
}

export interface IUpdateProjectFieldValueInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    fieldDefinitionId: number | undefined;
    valueJson: string | undefined;
}

export class SaveProjectFieldValuesInput implements ISaveProjectFieldValuesInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    values!: ProjectFieldValueInput[] | undefined;

    constructor(data?: ISaveProjectFieldValuesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ProjectFieldValueInput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SaveProjectFieldValuesInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveProjectFieldValuesInput>(data, _mappings, SaveProjectFieldValuesInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveProjectFieldValuesInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    values: ProjectFieldValueInput[] | undefined;
}

export class NextProjectNumberPreviewDto implements INextProjectNumberPreviewDto {
    mode!: ProjectNumberMode | undefined;
    number!: string | undefined;

    constructor(data?: INextProjectNumberPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.mode = _data["mode"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any, _mappings?: any): NextProjectNumberPreviewDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NextProjectNumberPreviewDto>(data, _mappings, NextProjectNumberPreviewDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        data["number"] = this.number;
        return data;
    }
}

export interface INextProjectNumberPreviewDto {
    mode: ProjectNumberMode | undefined;
    number: string | undefined;
}

export class NextProjectNumberPreviewDtoIHandleError implements INextProjectNumberPreviewDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: NextProjectNumberPreviewDto | undefined;
    listOfEntities!: NextProjectNumberPreviewDto[] | undefined;

    constructor(data?: INextProjectNumberPreviewDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? NextProjectNumberPreviewDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(NextProjectNumberPreviewDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): NextProjectNumberPreviewDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NextProjectNumberPreviewDtoIHandleError>(data, _mappings, NextProjectNumberPreviewDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INextProjectNumberPreviewDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: NextProjectNumberPreviewDto | undefined;
    listOfEntities: NextProjectNumberPreviewDto[] | undefined;
}

export class NativeValuePreviewInput implements INativeValuePreviewInput {
    nativeKey!: NativeFieldKey | undefined;
    displayValue!: string | undefined;

    constructor(data?: INativeValuePreviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.nativeKey = _data["nativeKey"];
            this.displayValue = _data["displayValue"];
        }
    }

    static fromJS(data: any, _mappings?: any): NativeValuePreviewInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NativeValuePreviewInput>(data, _mappings, NativeValuePreviewInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nativeKey"] = this.nativeKey;
        data["displayValue"] = this.displayValue;
        return data;
    }
}

export interface INativeValuePreviewInput {
    nativeKey: NativeFieldKey | undefined;
    displayValue: string | undefined;
}

export class BuildNamePreviewInput implements IBuildNamePreviewInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    mode!: ProjectNameMode | undefined;
    values!: ProjectFieldValueInput[] | undefined;
    nativeValues!: NativeValuePreviewInput[] | undefined;

    constructor(data?: IBuildNamePreviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.mode = _data["mode"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ProjectFieldValueInput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["nativeValues"])) {
                this.nativeValues = [] as any;
                for (let item of _data["nativeValues"])
                    this.nativeValues!.push(NativeValuePreviewInput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): BuildNamePreviewInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BuildNamePreviewInput>(data, _mappings, BuildNamePreviewInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["mode"] = this.mode;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.nativeValues)) {
            data["nativeValues"] = [];
            for (let item of this.nativeValues)
                data["nativeValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBuildNamePreviewInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    mode: ProjectNameMode | undefined;
    values: ProjectFieldValueInput[] | undefined;
    nativeValues: NativeValuePreviewInput[] | undefined;
}

export class ProjectTemplateFoldersDto implements IProjectTemplateFoldersDto {
    templateId!: number | undefined;
    folders!: TemplateFolderDto[] | undefined;

    constructor(data?: IProjectTemplateFoldersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            if (Array.isArray(_data["folders"])) {
                this.folders = [] as any;
                for (let item of _data["folders"])
                    this.folders!.push(TemplateFolderDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTemplateFoldersDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTemplateFoldersDto>(data, _mappings, ProjectTemplateFoldersDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        if (Array.isArray(this.folders)) {
            data["folders"] = [];
            for (let item of this.folders)
                data["folders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTemplateFoldersDto {
    templateId: number | undefined;
    folders: TemplateFolderDto[] | undefined;
}

export class SaveProjectTemplateFoldersInput implements ISaveProjectTemplateFoldersInput {
    templateId!: number | undefined;
    folders!: TemplateFolderDto[] | undefined;

    constructor(data?: ISaveProjectTemplateFoldersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            if (Array.isArray(_data["folders"])) {
                this.folders = [] as any;
                for (let item of _data["folders"])
                    this.folders!.push(TemplateFolderDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SaveProjectTemplateFoldersInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveProjectTemplateFoldersInput>(data, _mappings, SaveProjectTemplateFoldersInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        if (Array.isArray(this.folders)) {
            data["folders"] = [];
            for (let item of this.folders)
                data["folders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveProjectTemplateFoldersInput {
    templateId: number | undefined;
    folders: TemplateFolderDto[] | undefined;
}

export enum RecurringTaskTemplateFrequency {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class RecurringTaskTemplateDto implements IRecurringTaskTemplateDto {
    id!: number | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    frequency!: RecurringTaskTemplateFrequency | undefined;
    taskId!: number | undefined;
    lastOccurenceDate!: string | undefined;
    nextOccuranceDate!: string | undefined;

    constructor(data?: IRecurringTaskTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.frequency = _data["frequency"];
            this.taskId = _data["taskId"];
            this.lastOccurenceDate = _data["lastOccurenceDate"];
            this.nextOccuranceDate = _data["nextOccuranceDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecurringTaskTemplateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecurringTaskTemplateDto>(data, _mappings, RecurringTaskTemplateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["frequency"] = this.frequency;
        data["taskId"] = this.taskId;
        data["lastOccurenceDate"] = this.lastOccurenceDate;
        data["nextOccuranceDate"] = this.nextOccuranceDate;
        return data;
    }
}

export interface IRecurringTaskTemplateDto {
    id: number | undefined;
    title: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    frequency: RecurringTaskTemplateFrequency | undefined;
    taskId: number | undefined;
    lastOccurenceDate: string | undefined;
    nextOccuranceDate: string | undefined;
}

export class RecurringTaskTemplateDtoListIHandleError implements IRecurringTaskTemplateDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: RecurringTaskTemplateDto[] | undefined;
    listOfEntities!: RecurringTaskTemplateDto[][] | undefined;

    constructor(data?: IRecurringTaskTemplateDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(RecurringTaskTemplateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RecurringTaskTemplateDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecurringTaskTemplateDtoListIHandleError>(data, _mappings, RecurringTaskTemplateDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IRecurringTaskTemplateDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: RecurringTaskTemplateDto[] | undefined;
    listOfEntities: RecurringTaskTemplateDto[][] | undefined;
}

export class ReleaseDto implements IReleaseDto {
    title!: string | undefined;
    releaseDate!: string | undefined;
    areas!: string | undefined;
    articleLink!: string | undefined;
    id!: number | undefined;
    profilePictureUrl!: string | undefined;
    isNew!: boolean | undefined;
    userInitials!: string | undefined;

    constructor(data?: IReleaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.releaseDate = _data["releaseDate"];
            this.areas = _data["areas"];
            this.articleLink = _data["articleLink"];
            this.id = _data["id"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.isNew = _data["isNew"];
            this.userInitials = _data["userInitials"];
        }
    }

    static fromJS(data: any, _mappings?: any): ReleaseDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReleaseDto>(data, _mappings, ReleaseDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["releaseDate"] = this.releaseDate;
        data["areas"] = this.areas;
        data["articleLink"] = this.articleLink;
        data["id"] = this.id;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["isNew"] = this.isNew;
        data["userInitials"] = this.userInitials;
        return data;
    }
}

export interface IReleaseDto {
    title: string | undefined;
    releaseDate: string | undefined;
    areas: string | undefined;
    articleLink: string | undefined;
    id: number | undefined;
    profilePictureUrl: string | undefined;
    isNew: boolean | undefined;
    userInitials: string | undefined;
}

export class ReleaseDtoListIHandleError implements IReleaseDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ReleaseDto[] | undefined;
    listOfEntities!: ReleaseDto[][] | undefined;

    constructor(data?: IReleaseDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ReleaseDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ReleaseDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReleaseDtoListIHandleError>(data, _mappings, ReleaseDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IReleaseDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ReleaseDto[] | undefined;
    listOfEntities: ReleaseDto[][] | undefined;
}

export class RoleListDto implements IRoleListDto {
    id!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean | undefined;
    isDefault!: boolean | undefined;
    creationTime!: string | undefined;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): RoleListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RoleListDto>(data, _mappings, RoleListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime;
        return data;
    }
}

export interface IRoleListDto {
    id: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    creationTime: string | undefined;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RoleListDtoListResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RoleListDtoListResultDto>(data, _mappings, RoleListDtoListResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number | undefined;
    displayName!: string;
    isDefault!: boolean | undefined;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any, _mappings?: any): RoleEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RoleEditDto>(data, _mappings, RoleEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any, _mappings?: any): FlatPermissionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FlatPermissionDto>(data, _mappings, FlatPermissionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto | undefined;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"], _mappings) : undefined as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetRoleForEditOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetRoleForEditOutput>(data, _mappings, GetRoleForEditOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto | undefined;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role!: RoleEditDto;
    grantedPermissionNames!: string[];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"], _mappings) : new RoleEditDto();
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateOrUpdateRoleInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateOrUpdateRoleInput>(data, _mappings, CreateOrUpdateRoleInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class ScheduleInputDto implements IScheduleInputDto {
    id!: number | undefined;
    shiftName!: string | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    breakStartTime!: string | undefined;
    duration!: number | undefined;
    workDays!: number[] | undefined;
    isShiftSpanMultiDays!: boolean | undefined;
    isBreakRequired!: boolean | undefined;

    constructor(data?: IScheduleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shiftName = _data["shiftName"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.breakStartTime = _data["breakStartTime"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["workDays"])) {
                this.workDays = [] as any;
                for (let item of _data["workDays"])
                    this.workDays!.push(item);
            }
            this.isShiftSpanMultiDays = _data["isShiftSpanMultiDays"];
            this.isBreakRequired = _data["isBreakRequired"];
        }
    }

    static fromJS(data: any, _mappings?: any): ScheduleInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ScheduleInputDto>(data, _mappings, ScheduleInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shiftName"] = this.shiftName;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["breakStartTime"] = this.breakStartTime;
        data["duration"] = this.duration;
        if (Array.isArray(this.workDays)) {
            data["workDays"] = [];
            for (let item of this.workDays)
                data["workDays"].push(item);
        }
        data["isShiftSpanMultiDays"] = this.isShiftSpanMultiDays;
        data["isBreakRequired"] = this.isBreakRequired;
        return data;
    }
}

export interface IScheduleInputDto {
    id: number | undefined;
    shiftName: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    breakStartTime: string | undefined;
    duration: number | undefined;
    workDays: number[] | undefined;
    isShiftSpanMultiDays: boolean | undefined;
    isBreakRequired: boolean | undefined;
}

export class ScheduleOutputDto implements IScheduleOutputDto {
    id!: number | undefined;
    shiftName!: string | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    breakStartTime!: string | undefined;
    duration!: number | undefined;
    workDays!: string | undefined;
    workDaysArr!: number[] | undefined;
    isShiftSpanMultiDays!: boolean | undefined;
    isBreakRequired!: boolean | undefined;
    isAssigned!: boolean | undefined;

    constructor(data?: IScheduleOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shiftName = _data["shiftName"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.breakStartTime = _data["breakStartTime"];
            this.duration = _data["duration"];
            this.workDays = _data["workDays"];
            if (Array.isArray(_data["workDaysArr"])) {
                this.workDaysArr = [] as any;
                for (let item of _data["workDaysArr"])
                    this.workDaysArr!.push(item);
            }
            this.isShiftSpanMultiDays = _data["isShiftSpanMultiDays"];
            this.isBreakRequired = _data["isBreakRequired"];
            this.isAssigned = _data["isAssigned"];
        }
    }

    static fromJS(data: any, _mappings?: any): ScheduleOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ScheduleOutputDto>(data, _mappings, ScheduleOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shiftName"] = this.shiftName;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["breakStartTime"] = this.breakStartTime;
        data["duration"] = this.duration;
        data["workDays"] = this.workDays;
        if (Array.isArray(this.workDaysArr)) {
            data["workDaysArr"] = [];
            for (let item of this.workDaysArr)
                data["workDaysArr"].push(item);
        }
        data["isShiftSpanMultiDays"] = this.isShiftSpanMultiDays;
        data["isBreakRequired"] = this.isBreakRequired;
        data["isAssigned"] = this.isAssigned;
        return data;
    }
}

export interface IScheduleOutputDto {
    id: number | undefined;
    shiftName: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    breakStartTime: string | undefined;
    duration: number | undefined;
    workDays: string | undefined;
    workDaysArr: number[] | undefined;
    isShiftSpanMultiDays: boolean | undefined;
    isBreakRequired: boolean | undefined;
    isAssigned: boolean | undefined;
}

export class ScheduleOutputDtoIHandleError implements IScheduleOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ScheduleOutputDto | undefined;
    listOfEntities!: ScheduleOutputDto[] | undefined;

    constructor(data?: IScheduleOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ScheduleOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ScheduleOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ScheduleOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ScheduleOutputDtoIHandleError>(data, _mappings, ScheduleOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScheduleOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ScheduleOutputDto | undefined;
    listOfEntities: ScheduleOutputDto[] | undefined;
}

export class Int32ScheduleOutputDtoListValueTuple implements IInt32ScheduleOutputDtoListValueTuple {

    constructor(data?: IInt32ScheduleOutputDtoListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): Int32ScheduleOutputDtoListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32ScheduleOutputDtoListValueTuple>(data, _mappings, Int32ScheduleOutputDtoListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IInt32ScheduleOutputDtoListValueTuple {
}

export class Int32ScheduleOutputDtoListValueTupleIHandleError implements IInt32ScheduleOutputDtoListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: Int32ScheduleOutputDtoListValueTuple | undefined;
    listOfEntities!: Int32ScheduleOutputDtoListValueTuple[] | undefined;

    constructor(data?: IInt32ScheduleOutputDtoListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? Int32ScheduleOutputDtoListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(Int32ScheduleOutputDtoListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32ScheduleOutputDtoListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32ScheduleOutputDtoListValueTupleIHandleError>(data, _mappings, Int32ScheduleOutputDtoListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInt32ScheduleOutputDtoListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: Int32ScheduleOutputDtoListValueTuple | undefined;
    listOfEntities: Int32ScheduleOutputDtoListValueTuple[] | undefined;
}

export enum SchedulingPillAction {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class SchedulingPillDto implements ISchedulingPillDto {
    kind!: string | undefined;
    action!: SchedulingPillAction | undefined;
    label!: string | undefined;
    isVerified!: boolean | undefined;
    eventId!: number | undefined;

    constructor(data?: ISchedulingPillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.action = _data["action"];
            this.label = _data["label"];
            this.isVerified = _data["isVerified"];
            this.eventId = _data["eventId"];
        }
    }

    static fromJS(data: any, _mappings?: any): SchedulingPillDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SchedulingPillDto>(data, _mappings, SchedulingPillDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["action"] = this.action;
        data["label"] = this.label;
        data["isVerified"] = this.isVerified;
        data["eventId"] = this.eventId;
        return data;
    }
}

export interface ISchedulingPillDto {
    kind: string | undefined;
    action: SchedulingPillAction | undefined;
    label: string | undefined;
    isVerified: boolean | undefined;
    eventId: number | undefined;
}

export class SchedulingPillDtoIHandleError implements ISchedulingPillDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SchedulingPillDto | undefined;
    listOfEntities!: SchedulingPillDto[] | undefined;

    constructor(data?: ISchedulingPillDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SchedulingPillDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SchedulingPillDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SchedulingPillDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SchedulingPillDtoIHandleError>(data, _mappings, SchedulingPillDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISchedulingPillDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SchedulingPillDto | undefined;
    listOfEntities: SchedulingPillDto[] | undefined;
}

export class DraftSchedulingReplyInput implements IDraftSchedulingReplyInput {
    taskId!: number | undefined;
    threadKey!: string | undefined;
    hasExistingText!: boolean | undefined;

    constructor(data?: IDraftSchedulingReplyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.threadKey = _data["threadKey"];
            this.hasExistingText = _data["hasExistingText"];
        }
    }

    static fromJS(data: any, _mappings?: any): DraftSchedulingReplyInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DraftSchedulingReplyInput>(data, _mappings, DraftSchedulingReplyInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["threadKey"] = this.threadKey;
        data["hasExistingText"] = this.hasExistingText;
        return data;
    }
}

export interface IDraftSchedulingReplyInput {
    taskId: number | undefined;
    threadKey: string | undefined;
    hasExistingText: boolean | undefined;
}

export class SchedulingDraftDto implements ISchedulingDraftDto {
    html!: string | undefined;
    signOffHtml!: string | undefined;
    label!: string | undefined;

    constructor(data?: ISchedulingDraftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.html = _data["html"];
            this.signOffHtml = _data["signOffHtml"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any, _mappings?: any): SchedulingDraftDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SchedulingDraftDto>(data, _mappings, SchedulingDraftDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["html"] = this.html;
        data["signOffHtml"] = this.signOffHtml;
        data["label"] = this.label;
        return data;
    }
}

export interface ISchedulingDraftDto {
    html: string | undefined;
    signOffHtml: string | undefined;
    label: string | undefined;
}

export class SchedulingDraftDtoIHandleError implements ISchedulingDraftDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SchedulingDraftDto | undefined;
    listOfEntities!: SchedulingDraftDto[] | undefined;

    constructor(data?: ISchedulingDraftDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SchedulingDraftDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SchedulingDraftDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SchedulingDraftDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SchedulingDraftDtoIHandleError>(data, _mappings, SchedulingDraftDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISchedulingDraftDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SchedulingDraftDto | undefined;
    listOfEntities: SchedulingDraftDto[] | undefined;
}

export enum UserStage {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id!: number | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    profilePictureUrl!: string | undefined;
    currentUserStage!: UserStage | undefined;
    managerId!: number | undefined;
    currentTimeAsUserTz!: string | undefined;
    currentTimeAsCompanyTz!: string | undefined;
    companyTzWorkDate!: string | undefined;
    companyTimeZoneAbbreviation!: string | undefined;
    userTimeZoneAbbreviation!: string | undefined;
    companyTimeZoneOffset!: string | undefined;
    userTimeZoneOffset!: string | undefined;
    isWorkSummaryRequired!: boolean | undefined;
    isDoneWithPlanning!: boolean | undefined;
    isPromoVisited!: boolean | undefined;
    isProjectPromoVisited!: boolean | undefined;
    canManageContentManagers!: boolean | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.currentUserStage = _data["currentUserStage"];
            this.managerId = _data["managerId"];
            this.currentTimeAsUserTz = _data["currentTimeAsUserTz"];
            this.currentTimeAsCompanyTz = _data["currentTimeAsCompanyTz"];
            this.companyTzWorkDate = _data["companyTzWorkDate"];
            this.companyTimeZoneAbbreviation = _data["companyTimeZoneAbbreviation"];
            this.userTimeZoneAbbreviation = _data["userTimeZoneAbbreviation"];
            this.companyTimeZoneOffset = _data["companyTimeZoneOffset"];
            this.userTimeZoneOffset = _data["userTimeZoneOffset"];
            this.isWorkSummaryRequired = _data["isWorkSummaryRequired"];
            this.isDoneWithPlanning = _data["isDoneWithPlanning"];
            this.isPromoVisited = _data["isPromoVisited"];
            this.isProjectPromoVisited = _data["isProjectPromoVisited"];
            this.canManageContentManagers = _data["canManageContentManagers"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserLoginInfoDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserLoginInfoDto>(data, _mappings, UserLoginInfoDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["currentUserStage"] = this.currentUserStage;
        data["managerId"] = this.managerId;
        data["currentTimeAsUserTz"] = this.currentTimeAsUserTz;
        data["currentTimeAsCompanyTz"] = this.currentTimeAsCompanyTz;
        data["companyTzWorkDate"] = this.companyTzWorkDate;
        data["companyTimeZoneAbbreviation"] = this.companyTimeZoneAbbreviation;
        data["userTimeZoneAbbreviation"] = this.userTimeZoneAbbreviation;
        data["companyTimeZoneOffset"] = this.companyTimeZoneOffset;
        data["userTimeZoneOffset"] = this.userTimeZoneOffset;
        data["isWorkSummaryRequired"] = this.isWorkSummaryRequired;
        data["isDoneWithPlanning"] = this.isDoneWithPlanning;
        data["isPromoVisited"] = this.isPromoVisited;
        data["isProjectPromoVisited"] = this.isProjectPromoVisited;
        data["canManageContentManagers"] = this.canManageContentManagers;
        return data;
    }
}

export interface IUserLoginInfoDto {
    id: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    profilePictureUrl: string | undefined;
    currentUserStage: UserStage | undefined;
    managerId: number | undefined;
    currentTimeAsUserTz: string | undefined;
    currentTimeAsCompanyTz: string | undefined;
    companyTzWorkDate: string | undefined;
    companyTimeZoneAbbreviation: string | undefined;
    userTimeZoneAbbreviation: string | undefined;
    companyTimeZoneOffset: string | undefined;
    userTimeZoneOffset: string | undefined;
    isWorkSummaryRequired: boolean | undefined;
    isDoneWithPlanning: boolean | undefined;
    isPromoVisited: boolean | undefined;
    isProjectPromoVisited: boolean | undefined;
    canManageContentManagers: boolean | undefined;
}

export class EditionInfoDto implements IEditionInfoDto {
    id!: number | undefined;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): EditionInfoDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EditionInfoDto>(data, _mappings, EditionInfoDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionInfoDto {
    id: number | undefined;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id!: number | undefined;
    tenancyName!: string | undefined;
    name!: string | undefined;
    logoId!: string | undefined;
    customCssId!: string | undefined;
    subscriptionEndDateUtc!: string | undefined;
    isInTrialPeriod!: boolean | undefined;
    isSubscriptionExpired!: boolean | undefined;
    edition!: EditionInfoDto | undefined;
    creationTime!: string | undefined;
    ownerId!: number | undefined;
    subscriptionDaysLeftCount!: number | undefined;
    ownerName!: string | undefined;
    isWorkSummaryRequired!: boolean | undefined;
    licenseUsers!: number | undefined;
    clientDisplayFormat!: TenantClientDisplay | undefined;
    apiKey!: string | undefined;
    projectLabelSingular!: string | undefined;
    projectLabelPlural!: string | undefined;
    projectLabelPreset!: string | undefined;
    isGetStartedCompleted!: boolean | undefined;
    usedSeats!: number | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.logoId = _data["logoId"];
            this.customCssId = _data["customCssId"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.isSubscriptionExpired = _data["isSubscriptionExpired"];
            this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"], _mappings) : undefined as any;
            this.creationTime = _data["creationTime"];
            this.ownerId = _data["ownerId"];
            this.subscriptionDaysLeftCount = _data["subscriptionDaysLeftCount"];
            this.ownerName = _data["ownerName"];
            this.isWorkSummaryRequired = _data["isWorkSummaryRequired"];
            this.licenseUsers = _data["licenseUsers"];
            this.clientDisplayFormat = _data["clientDisplayFormat"];
            this.apiKey = _data["apiKey"];
            this.projectLabelSingular = _data["projectLabelSingular"];
            this.projectLabelPlural = _data["projectLabelPlural"];
            this.projectLabelPreset = _data["projectLabelPreset"];
            this.isGetStartedCompleted = _data["isGetStartedCompleted"];
            this.usedSeats = _data["usedSeats"];
        }
    }

    static fromJS(data: any, _mappings?: any): TenantLoginInfoDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantLoginInfoDto>(data, _mappings, TenantLoginInfoDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["isSubscriptionExpired"] = this.isSubscriptionExpired;
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        data["creationTime"] = this.creationTime;
        data["ownerId"] = this.ownerId;
        data["subscriptionDaysLeftCount"] = this.subscriptionDaysLeftCount;
        data["ownerName"] = this.ownerName;
        data["isWorkSummaryRequired"] = this.isWorkSummaryRequired;
        data["licenseUsers"] = this.licenseUsers;
        data["clientDisplayFormat"] = this.clientDisplayFormat;
        data["apiKey"] = this.apiKey;
        data["projectLabelSingular"] = this.projectLabelSingular;
        data["projectLabelPlural"] = this.projectLabelPlural;
        data["projectLabelPreset"] = this.projectLabelPreset;
        data["isGetStartedCompleted"] = this.isGetStartedCompleted;
        data["usedSeats"] = this.usedSeats;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    id: number | undefined;
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: string | undefined;
    isInTrialPeriod: boolean | undefined;
    isSubscriptionExpired: boolean | undefined;
    edition: EditionInfoDto | undefined;
    creationTime: string | undefined;
    ownerId: number | undefined;
    subscriptionDaysLeftCount: number | undefined;
    ownerName: string | undefined;
    isWorkSummaryRequired: boolean | undefined;
    licenseUsers: number | undefined;
    clientDisplayFormat: TenantClientDisplay | undefined;
    apiKey: string | undefined;
    projectLabelSingular: string | undefined;
    projectLabelPlural: string | undefined;
    projectLabelPreset: string | undefined;
    isGetStartedCompleted: boolean | undefined;
    usedSeats: number | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: string | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): ApplicationInfoDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApplicationInfoDto>(data, _mappings, ApplicationInfoDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate;
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: string | undefined;
}

export enum UserRedirect {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum CheckinStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum CheckinUserStage {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class CheckinUserOutput implements ICheckinUserOutput {
    userId!: number | undefined;
    userName!: string | undefined;
    tenantId!: number | undefined;
    redirect!: UserRedirect | undefined;
    loginTime!: string | undefined;
    nextShiftStartTime!: string | undefined;
    checkinStatus!: CheckinStatus | undefined;
    checkinStage!: CheckinUserStage | undefined;
    workDate!: string | undefined;
    hasPreviousShiftCheckin!: boolean | undefined;
    isMultiDayShiftAtUserTime!: boolean | undefined;
    shiftStartDtAtUserTime!: string | undefined;
    shiftEndDtAtUserTime!: string | undefined;
    rangeStartDtAtUserTime!: string | undefined;
    rangeEndDtAtUserTime!: string | undefined;
    doneWithPlanning!: boolean | undefined;
    isBreakAllowed!: boolean | undefined;

    constructor(data?: ICheckinUserOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.redirect = _data["redirect"];
            this.loginTime = _data["loginTime"];
            this.nextShiftStartTime = _data["nextShiftStartTime"];
            this.checkinStatus = _data["checkinStatus"];
            this.checkinStage = _data["checkinStage"];
            this.workDate = _data["workDate"];
            this.hasPreviousShiftCheckin = _data["hasPreviousShiftCheckin"];
            this.isMultiDayShiftAtUserTime = _data["isMultiDayShiftAtUserTime"];
            this.shiftStartDtAtUserTime = _data["shiftStartDtAtUserTime"];
            this.shiftEndDtAtUserTime = _data["shiftEndDtAtUserTime"];
            this.rangeStartDtAtUserTime = _data["rangeStartDtAtUserTime"];
            this.rangeEndDtAtUserTime = _data["rangeEndDtAtUserTime"];
            this.doneWithPlanning = _data["doneWithPlanning"];
            this.isBreakAllowed = _data["isBreakAllowed"];
        }
    }

    static fromJS(data: any, _mappings?: any): CheckinUserOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckinUserOutput>(data, _mappings, CheckinUserOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["redirect"] = this.redirect;
        data["loginTime"] = this.loginTime;
        data["nextShiftStartTime"] = this.nextShiftStartTime;
        data["checkinStatus"] = this.checkinStatus;
        data["checkinStage"] = this.checkinStage;
        data["workDate"] = this.workDate;
        data["hasPreviousShiftCheckin"] = this.hasPreviousShiftCheckin;
        data["isMultiDayShiftAtUserTime"] = this.isMultiDayShiftAtUserTime;
        data["shiftStartDtAtUserTime"] = this.shiftStartDtAtUserTime;
        data["shiftEndDtAtUserTime"] = this.shiftEndDtAtUserTime;
        data["rangeStartDtAtUserTime"] = this.rangeStartDtAtUserTime;
        data["rangeEndDtAtUserTime"] = this.rangeEndDtAtUserTime;
        data["doneWithPlanning"] = this.doneWithPlanning;
        data["isBreakAllowed"] = this.isBreakAllowed;
        return data;
    }
}

export interface ICheckinUserOutput {
    userId: number | undefined;
    userName: string | undefined;
    tenantId: number | undefined;
    redirect: UserRedirect | undefined;
    loginTime: string | undefined;
    nextShiftStartTime: string | undefined;
    checkinStatus: CheckinStatus | undefined;
    checkinStage: CheckinUserStage | undefined;
    workDate: string | undefined;
    hasPreviousShiftCheckin: boolean | undefined;
    isMultiDayShiftAtUserTime: boolean | undefined;
    shiftStartDtAtUserTime: string | undefined;
    shiftEndDtAtUserTime: string | undefined;
    rangeStartDtAtUserTime: string | undefined;
    rangeEndDtAtUserTime: string | undefined;
    doneWithPlanning: boolean | undefined;
    isBreakAllowed: boolean | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto | undefined;
    tenant!: TenantLoginInfoDto | undefined;
    application!: ApplicationInfoDto | undefined;
    checkinUser!: CheckinUserOutput | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"], _mappings) : undefined as any;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"], _mappings) : undefined as any;
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"], _mappings) : undefined as any;
            this.checkinUser = _data["checkinUser"] ? CheckinUserOutput.fromJS(_data["checkinUser"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): GetCurrentLoginInformationsOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetCurrentLoginInformationsOutput>(data, _mappings, GetCurrentLoginInformationsOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        data["application"] = this.application ? this.application.toJSON() : undefined as any;
        data["checkinUser"] = this.checkinUser ? this.checkinUser.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;
    application: ApplicationInfoDto | undefined;
    checkinUser: CheckinUserOutput | undefined;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"];
            this.encodedUserId = _data["encodedUserId"];
            this.encodedTenantId = _data["encodedTenantId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateUserSignInTokenOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateUserSignInTokenOutput>(data, _mappings, UpdateUserSignInTokenOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export enum AgendaType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum EventType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class UserAssigne implements IUserAssigne {
    userId!: number | undefined;
    checkinId!: number | undefined;
    workDate!: string | undefined;

    constructor(data?: IUserAssigne) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.checkinId = _data["checkinId"];
            this.workDate = _data["workDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserAssigne | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserAssigne>(data, _mappings, UserAssigne);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["checkinId"] = this.checkinId;
        data["workDate"] = this.workDate;
        return data;
    }
}

export interface IUserAssigne {
    userId: number | undefined;
    checkinId: number | undefined;
    workDate: string | undefined;
}

export enum TaskType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class GetUserAgendaOutput implements IGetUserAgendaOutput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    id!: number | undefined;
    agendaType!: AgendaType | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    startDateAsCurrentUserTimezone!: string | undefined;
    dueDate!: string | undefined;
    isDueDatePassed!: boolean | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    eventType!: EventType | undefined;
    assignedToUserId!: number | undefined;
    completedOn!: string | undefined;
    code!: number | undefined;
    name!: string | undefined;
    sortOrder!: number | undefined;
    endDate!: string | undefined;
    eventCreatedByUserId!: number | undefined;
    eventCreatedByUser!: string | undefined;
    integrationId!: string | undefined;
    integratedFrom!: string | undefined;
    integrationIcon!: string | undefined;
    integrationCode!: number | undefined;
    projectName!: string | undefined;
    priority!: string | undefined;
    color!: string | undefined;
    keyId!: string | undefined;
    bucketId!: string | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    odataEtagId!: string | undefined;
    webUrl!: string | undefined;
    assignes!: string | undefined;
    readonly userAssignes!: UserAssigne[] | undefined;
    state!: number | undefined;
    scheduleDate!: string | undefined;
    projectId!: number | undefined;
    taskProjectName!: string | undefined;
    isPrivateProject!: boolean | undefined;
    projectSectionId!: number | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    isDeleted!: boolean | undefined;
    isSeen!: boolean | undefined;
    isNew!: boolean | undefined;
    isNewlyAssigned!: boolean | undefined;
    resourceAppUrl!: string | undefined;
    resourceName!: string | undefined;
    resourceIconUrl!: string | undefined;
    resourceGreyIconUrl!: string | undefined;
    resourceDescription!: string | undefined;
    resourceAppIntegrationId!: number | undefined;
    isCustom!: boolean | undefined;
    isPrivate!: boolean | undefined;
    isAssignedToProject!: boolean | undefined;
    isAssignedToPrivateProject!: boolean | undefined;
    meetingType!: string | undefined;
    isReAssigned!: boolean | undefined;
    reAssignedToUserName!: string | undefined;
    assignedToUserName!: string | undefined;
    hasUnreadComments!: boolean | undefined;
    onlineMeetingUrl!: string | undefined;
    eventId!: string | undefined;
    taskType!: TaskType | undefined;
    duration!: number | undefined;
    entityType!: TaskEntityType | undefined;
    entityId!: number | undefined;
    entityName!: string | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactCompanyId!: number | undefined;
    contactCompanyName!: string | undefined;
    contactTypeColor!: string | undefined;
    projectColor!: string | undefined;
    tags!: string | undefined;
    readonly taskTags!: ProjectTag[] | undefined;
    isUpdatedFromApp!: boolean | undefined;
    latestAttachmentAsJson!: string | undefined;
    latestTaskAttachment!: TaskAttachment | undefined;
    taskAssociationsAsJson!: string | undefined;
    readonly taskAssociations!: TaskAssociation[] | undefined;
    parentId!: number | undefined;
    isPartOfTaskTree!: boolean | undefined;

    constructor(data?: IGetUserAgendaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.id = _data["id"];
            this.agendaType = _data["agendaType"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.startDateAsCurrentUserTimezone = _data["startDateAsCurrentUserTimezone"];
            this.dueDate = _data["dueDate"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.eventType = _data["eventType"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.completedOn = _data["completedOn"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.endDate = _data["endDate"];
            this.eventCreatedByUserId = _data["eventCreatedByUserId"];
            this.eventCreatedByUser = _data["eventCreatedByUser"];
            this.integrationId = _data["integrationId"];
            this.integratedFrom = _data["integratedFrom"];
            this.integrationIcon = _data["integrationIcon"];
            this.integrationCode = _data["integrationCode"];
            this.projectName = _data["projectName"];
            this.priority = _data["priority"];
            this.color = _data["color"];
            this.keyId = _data["keyId"];
            this.bucketId = _data["bucketId"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.odataEtagId = _data["odataEtagId"];
            this.webUrl = _data["webUrl"];
            this.assignes = _data["assignes"];
            if (Array.isArray(_data["userAssignes"])) {
                (this as any).userAssignes = [] as any;
                for (let item of _data["userAssignes"])
                    (this as any).userAssignes!.push(UserAssigne.fromJS(item, _mappings));
            }
            this.state = _data["state"];
            this.scheduleDate = _data["scheduleDate"];
            this.projectId = _data["projectId"];
            this.taskProjectName = _data["taskProjectName"];
            this.isPrivateProject = _data["isPrivateProject"];
            this.projectSectionId = _data["projectSectionId"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.isDeleted = _data["isDeleted"];
            this.isSeen = _data["isSeen"];
            this.isNew = _data["isNew"];
            this.isNewlyAssigned = _data["isNewlyAssigned"];
            this.resourceAppUrl = _data["resourceAppUrl"];
            this.resourceName = _data["resourceName"];
            this.resourceIconUrl = _data["resourceIconUrl"];
            this.resourceGreyIconUrl = _data["resourceGreyIconUrl"];
            this.resourceDescription = _data["resourceDescription"];
            this.resourceAppIntegrationId = _data["resourceAppIntegrationId"];
            this.isCustom = _data["isCustom"];
            this.isPrivate = _data["isPrivate"];
            this.isAssignedToProject = _data["isAssignedToProject"];
            this.isAssignedToPrivateProject = _data["isAssignedToPrivateProject"];
            this.meetingType = _data["meetingType"];
            this.isReAssigned = _data["isReAssigned"];
            this.reAssignedToUserName = _data["reAssignedToUserName"];
            this.assignedToUserName = _data["assignedToUserName"];
            this.hasUnreadComments = _data["hasUnreadComments"];
            this.onlineMeetingUrl = _data["onlineMeetingUrl"];
            this.eventId = _data["eventId"];
            this.taskType = _data["taskType"];
            this.duration = _data["duration"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.entityName = _data["entityName"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactCompanyId = _data["contactCompanyId"];
            this.contactCompanyName = _data["contactCompanyName"];
            this.contactTypeColor = _data["contactTypeColor"];
            this.projectColor = _data["projectColor"];
            this.tags = _data["tags"];
            if (Array.isArray(_data["taskTags"])) {
                (this as any).taskTags = [] as any;
                for (let item of _data["taskTags"])
                    (this as any).taskTags!.push(ProjectTag.fromJS(item, _mappings));
            }
            this.isUpdatedFromApp = _data["isUpdatedFromApp"];
            this.latestAttachmentAsJson = _data["latestAttachmentAsJson"];
            this.latestTaskAttachment = _data["latestTaskAttachment"] ? TaskAttachment.fromJS(_data["latestTaskAttachment"], _mappings) : undefined as any;
            this.taskAssociationsAsJson = _data["taskAssociationsAsJson"];
            if (Array.isArray(_data["taskAssociations"])) {
                (this as any).taskAssociations = [] as any;
                for (let item of _data["taskAssociations"])
                    (this as any).taskAssociations!.push(TaskAssociation.fromJS(item, _mappings));
            }
            this.parentId = _data["parentId"];
            this.isPartOfTaskTree = _data["isPartOfTaskTree"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserAgendaOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserAgendaOutput>(data, _mappings, GetUserAgendaOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["id"] = this.id;
        data["agendaType"] = this.agendaType;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["startDateAsCurrentUserTimezone"] = this.startDateAsCurrentUserTimezone;
        data["dueDate"] = this.dueDate;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["eventType"] = this.eventType;
        data["assignedToUserId"] = this.assignedToUserId;
        data["completedOn"] = this.completedOn;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["endDate"] = this.endDate;
        data["eventCreatedByUserId"] = this.eventCreatedByUserId;
        data["eventCreatedByUser"] = this.eventCreatedByUser;
        data["integrationId"] = this.integrationId;
        data["integratedFrom"] = this.integratedFrom;
        data["integrationIcon"] = this.integrationIcon;
        data["integrationCode"] = this.integrationCode;
        data["projectName"] = this.projectName;
        data["priority"] = this.priority;
        data["color"] = this.color;
        data["keyId"] = this.keyId;
        data["bucketId"] = this.bucketId;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["odataEtagId"] = this.odataEtagId;
        data["webUrl"] = this.webUrl;
        data["assignes"] = this.assignes;
        if (Array.isArray(this.userAssignes)) {
            data["userAssignes"] = [];
            for (let item of this.userAssignes)
                data["userAssignes"].push(item ? item.toJSON() : undefined as any);
        }
        data["state"] = this.state;
        data["scheduleDate"] = this.scheduleDate;
        data["projectId"] = this.projectId;
        data["taskProjectName"] = this.taskProjectName;
        data["isPrivateProject"] = this.isPrivateProject;
        data["projectSectionId"] = this.projectSectionId;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["isDeleted"] = this.isDeleted;
        data["isSeen"] = this.isSeen;
        data["isNew"] = this.isNew;
        data["isNewlyAssigned"] = this.isNewlyAssigned;
        data["resourceAppUrl"] = this.resourceAppUrl;
        data["resourceName"] = this.resourceName;
        data["resourceIconUrl"] = this.resourceIconUrl;
        data["resourceGreyIconUrl"] = this.resourceGreyIconUrl;
        data["resourceDescription"] = this.resourceDescription;
        data["resourceAppIntegrationId"] = this.resourceAppIntegrationId;
        data["isCustom"] = this.isCustom;
        data["isPrivate"] = this.isPrivate;
        data["isAssignedToProject"] = this.isAssignedToProject;
        data["isAssignedToPrivateProject"] = this.isAssignedToPrivateProject;
        data["meetingType"] = this.meetingType;
        data["isReAssigned"] = this.isReAssigned;
        data["reAssignedToUserName"] = this.reAssignedToUserName;
        data["assignedToUserName"] = this.assignedToUserName;
        data["hasUnreadComments"] = this.hasUnreadComments;
        data["onlineMeetingUrl"] = this.onlineMeetingUrl;
        data["eventId"] = this.eventId;
        data["taskType"] = this.taskType;
        data["duration"] = this.duration;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["entityName"] = this.entityName;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactCompanyId"] = this.contactCompanyId;
        data["contactCompanyName"] = this.contactCompanyName;
        data["contactTypeColor"] = this.contactTypeColor;
        data["projectColor"] = this.projectColor;
        data["tags"] = this.tags;
        if (Array.isArray(this.taskTags)) {
            data["taskTags"] = [];
            for (let item of this.taskTags)
                data["taskTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["isUpdatedFromApp"] = this.isUpdatedFromApp;
        data["latestAttachmentAsJson"] = this.latestAttachmentAsJson;
        data["latestTaskAttachment"] = this.latestTaskAttachment ? this.latestTaskAttachment.toJSON() : undefined as any;
        data["taskAssociationsAsJson"] = this.taskAssociationsAsJson;
        if (Array.isArray(this.taskAssociations)) {
            data["taskAssociations"] = [];
            for (let item of this.taskAssociations)
                data["taskAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentId"] = this.parentId;
        data["isPartOfTaskTree"] = this.isPartOfTaskTree;
        return data;
    }
}

export interface IGetUserAgendaOutput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    id: number | undefined;
    agendaType: AgendaType | undefined;
    title: string | undefined;
    startDate: string | undefined;
    startDateAsCurrentUserTimezone: string | undefined;
    dueDate: string | undefined;
    isDueDatePassed: boolean | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    eventType: EventType | undefined;
    assignedToUserId: number | undefined;
    completedOn: string | undefined;
    code: number | undefined;
    name: string | undefined;
    sortOrder: number | undefined;
    endDate: string | undefined;
    eventCreatedByUserId: number | undefined;
    eventCreatedByUser: string | undefined;
    integrationId: string | undefined;
    integratedFrom: string | undefined;
    integrationIcon: string | undefined;
    integrationCode: number | undefined;
    projectName: string | undefined;
    priority: string | undefined;
    color: string | undefined;
    keyId: string | undefined;
    bucketId: string | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    odataEtagId: string | undefined;
    webUrl: string | undefined;
    assignes: string | undefined;
    userAssignes: UserAssigne[] | undefined;
    state: number | undefined;
    scheduleDate: string | undefined;
    projectId: number | undefined;
    taskProjectName: string | undefined;
    isPrivateProject: boolean | undefined;
    projectSectionId: number | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    isDeleted: boolean | undefined;
    isSeen: boolean | undefined;
    isNew: boolean | undefined;
    isNewlyAssigned: boolean | undefined;
    resourceAppUrl: string | undefined;
    resourceName: string | undefined;
    resourceIconUrl: string | undefined;
    resourceGreyIconUrl: string | undefined;
    resourceDescription: string | undefined;
    resourceAppIntegrationId: number | undefined;
    isCustom: boolean | undefined;
    isPrivate: boolean | undefined;
    isAssignedToProject: boolean | undefined;
    isAssignedToPrivateProject: boolean | undefined;
    meetingType: string | undefined;
    isReAssigned: boolean | undefined;
    reAssignedToUserName: string | undefined;
    assignedToUserName: string | undefined;
    hasUnreadComments: boolean | undefined;
    onlineMeetingUrl: string | undefined;
    eventId: string | undefined;
    taskType: TaskType | undefined;
    duration: number | undefined;
    entityType: TaskEntityType | undefined;
    entityId: number | undefined;
    entityName: string | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactCompanyId: number | undefined;
    contactCompanyName: string | undefined;
    contactTypeColor: string | undefined;
    projectColor: string | undefined;
    tags: string | undefined;
    taskTags: ProjectTag[] | undefined;
    isUpdatedFromApp: boolean | undefined;
    latestAttachmentAsJson: string | undefined;
    latestTaskAttachment: TaskAttachment | undefined;
    taskAssociationsAsJson: string | undefined;
    taskAssociations: TaskAssociation[] | undefined;
    parentId: number | undefined;
    isPartOfTaskTree: boolean | undefined;
}

export class CheckoutDtl implements ICheckoutDtl {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    scheduleTime!: string | undefined;
    nextNotificationInterval!: number | undefined;
    checkInOutType!: InOutType | undefined;
    isAutoCheckoutNotified!: boolean | undefined;

    constructor(data?: ICheckoutDtl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.scheduleTime = _data["scheduleTime"];
            this.nextNotificationInterval = _data["nextNotificationInterval"];
            this.checkInOutType = _data["checkInOutType"];
            this.isAutoCheckoutNotified = _data["isAutoCheckoutNotified"];
        }
    }

    static fromJS(data: any, _mappings?: any): CheckoutDtl | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckoutDtl>(data, _mappings, CheckoutDtl);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["scheduleTime"] = this.scheduleTime;
        data["nextNotificationInterval"] = this.nextNotificationInterval;
        data["checkInOutType"] = this.checkInOutType;
        data["isAutoCheckoutNotified"] = this.isAutoCheckoutNotified;
        return data;
    }
}

export interface ICheckoutDtl {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    scheduleTime: string | undefined;
    nextNotificationInterval: number | undefined;
    checkInOutType: InOutType | undefined;
    isAutoCheckoutNotified: boolean | undefined;
}

export class CurrentUserInput implements ICurrentUserInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;

    constructor(data?: ICurrentUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CurrentUserInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CurrentUserInput>(data, _mappings, CurrentUserInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        return data;
    }
}

export interface ICurrentUserInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
}

export class ConfigResponse implements IConfigResponse {
    publishableKey!: string | undefined;

    constructor(data?: IConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.publishableKey = _data["publishableKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConfigResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfigResponse>(data, _mappings, ConfigResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishableKey"] = this.publishableKey;
        return data;
    }
}

export interface IConfigResponse {
    publishableKey: string | undefined;
}

export class StringStringIEnumerableKeyValuePair implements IStringStringIEnumerableKeyValuePair {
    readonly key!: string | undefined;
    readonly value!: string[] | undefined;

    constructor(data?: IStringStringIEnumerableKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (this as any).key = _data["key"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): StringStringIEnumerableKeyValuePair | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StringStringIEnumerableKeyValuePair>(data, _mappings, StringStringIEnumerableKeyValuePair);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IStringStringIEnumerableKeyValuePair {
    key: string | undefined;
    value: string[] | undefined;
}

export class StripeResponse implements IStripeResponse {
    statusCode!: number | undefined;
    readonly headers!: StringStringIEnumerableKeyValuePair[] | undefined;
    readonly content!: string | undefined;
    readonly date!: string | undefined;
    readonly idempotencyKey!: string | undefined;
    readonly requestId!: string | undefined;

    constructor(data?: IStripeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["headers"])) {
                (this as any).headers = [] as any;
                for (let item of _data["headers"])
                    (this as any).headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item, _mappings));
            }
            (this as any).content = _data["content"];
            (this as any).date = _data["date"];
            (this as any).idempotencyKey = _data["idempotencyKey"];
            (this as any).requestId = _data["requestId"];
        }
    }

    static fromJS(data: any, _mappings?: any): StripeResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StripeResponse>(data, _mappings, StripeResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item ? item.toJSON() : undefined as any);
        }
        data["content"] = this.content;
        data["date"] = this.date;
        data["idempotencyKey"] = this.idempotencyKey;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IStripeResponse {
    statusCode: number | undefined;
    headers: StringStringIEnumerableKeyValuePair[] | undefined;
    content: string | undefined;
    date: string | undefined;
    idempotencyKey: string | undefined;
    requestId: string | undefined;
}

export class Address implements IAddress {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    city!: string | undefined;
    country!: string | undefined;
    line1!: string | undefined;
    line2!: string | undefined;
    postalCode!: string | undefined;
    state!: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.city = _data["city"];
            this.country = _data["country"];
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.postalCode = _data["postalCode"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any, _mappings?: any): Address | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Address>(data, _mappings, Address);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["city"] = this.city;
        data["country"] = this.country;
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["postalCode"] = this.postalCode;
        data["state"] = this.state;
        return data;
    }
}

export interface IAddress {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    city: string | undefined;
    country: string | undefined;
    line1: string | undefined;
    line2: string | undefined;
    postalCode: string | undefined;
    state: string | undefined;
}

export class IPaymentSource implements IIPaymentSource {

    constructor(data?: IIPaymentSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): IPaymentSource | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IPaymentSource>(data, _mappings, IPaymentSource);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIPaymentSource {
}

export class PromotionCodeRestrictions implements IPromotionCodeRestrictions {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    firstTimeTransaction!: boolean | undefined;
    minimumAmount!: number | undefined;
    minimumAmountCurrency!: string | undefined;

    constructor(data?: IPromotionCodeRestrictions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.firstTimeTransaction = _data["firstTimeTransaction"];
            this.minimumAmount = _data["minimumAmount"];
            this.minimumAmountCurrency = _data["minimumAmountCurrency"];
        }
    }

    static fromJS(data: any, _mappings?: any): PromotionCodeRestrictions | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PromotionCodeRestrictions>(data, _mappings, PromotionCodeRestrictions);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["firstTimeTransaction"] = this.firstTimeTransaction;
        data["minimumAmount"] = this.minimumAmount;
        data["minimumAmountCurrency"] = this.minimumAmountCurrency;
        return data;
    }
}

export interface IPromotionCodeRestrictions {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    firstTimeTransaction: boolean | undefined;
    minimumAmount: number | undefined;
    minimumAmountCurrency: string | undefined;
}

export class BillingDetails implements IBillingDetails {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    address!: Address | undefined;
    email!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;

    constructor(data?: IBillingDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.address = _data["address"] ? Address.fromJS(_data["address"], _mappings) : undefined as any;
            this.email = _data["email"];
            this.name = _data["name"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any, _mappings?: any): BillingDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BillingDetails>(data, _mappings, BillingDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IBillingDetails {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    address: Address | undefined;
    email: string | undefined;
    name: string | undefined;
    phone: string | undefined;
}

export class Shipping implements IShipping {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    address!: Address | undefined;
    carrier!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    trackingNumber!: string | undefined;

    constructor(data?: IShipping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.address = _data["address"] ? Address.fromJS(_data["address"], _mappings) : undefined as any;
            this.carrier = _data["carrier"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.trackingNumber = _data["trackingNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): Shipping | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Shipping>(data, _mappings, Shipping);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["carrier"] = this.carrier;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["trackingNumber"] = this.trackingNumber;
        return data;
    }
}

export interface IShipping {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    address: Address | undefined;
    carrier: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    trackingNumber: string | undefined;
}

export class PackageDimensions implements IPackageDimensions {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    height!: number | undefined;
    length!: number | undefined;
    weight!: number | undefined;
    width!: number | undefined;

    constructor(data?: IPackageDimensions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.height = _data["height"];
            this.length = _data["length"];
            this.weight = _data["weight"];
            this.width = _data["width"];
        }
    }

    static fromJS(data: any, _mappings?: any): PackageDimensions | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PackageDimensions>(data, _mappings, PackageDimensions);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["height"] = this.height;
        data["length"] = this.length;
        data["weight"] = this.weight;
        data["width"] = this.width;
        return data;
    }
}

export interface IPackageDimensions {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    height: number | undefined;
    length: number | undefined;
    weight: number | undefined;
    width: number | undefined;
}

export class Application implements IApplication {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    id!: string | undefined;
    object!: string | undefined;
    name!: string | undefined;

    constructor(data?: IApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.id = _data["id"];
            this.object = _data["object"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): Application | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Application>(data, _mappings, Application);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["id"] = this.id;
        data["object"] = this.object;
        data["name"] = this.name;
        return data;
    }
}

export interface IApplication {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    id: string | undefined;
    object: string | undefined;
    name: string | undefined;
}

export class AccountBusinessProfile implements IAccountBusinessProfile {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    mcc!: string | undefined;
    name!: string | undefined;
    productDescription!: string | undefined;
    supportAddress!: Address | undefined;
    supportEmail!: string | undefined;
    supportPhone!: string | undefined;
    supportUrl!: string | undefined;
    url!: string | undefined;

    constructor(data?: IAccountBusinessProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.mcc = _data["mcc"];
            this.name = _data["name"];
            this.productDescription = _data["productDescription"];
            this.supportAddress = _data["supportAddress"] ? Address.fromJS(_data["supportAddress"], _mappings) : undefined as any;
            this.supportEmail = _data["supportEmail"];
            this.supportPhone = _data["supportPhone"];
            this.supportUrl = _data["supportUrl"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountBusinessProfile | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountBusinessProfile>(data, _mappings, AccountBusinessProfile);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["mcc"] = this.mcc;
        data["name"] = this.name;
        data["productDescription"] = this.productDescription;
        data["supportAddress"] = this.supportAddress ? this.supportAddress.toJSON() : undefined as any;
        data["supportEmail"] = this.supportEmail;
        data["supportPhone"] = this.supportPhone;
        data["supportUrl"] = this.supportUrl;
        data["url"] = this.url;
        return data;
    }
}

export interface IAccountBusinessProfile {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    mcc: string | undefined;
    name: string | undefined;
    productDescription: string | undefined;
    supportAddress: Address | undefined;
    supportEmail: string | undefined;
    supportPhone: string | undefined;
    supportUrl: string | undefined;
    url: string | undefined;
}

export class AccountCapabilities implements IAccountCapabilities {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    auBecsDebitPayments!: string | undefined;
    bacsDebitPayments!: string | undefined;
    cardIssuing!: string | undefined;
    cardPayments!: string | undefined;
    cartesBancairesPayments!: string | undefined;
    fpxPayments!: string | undefined;
    jcbPayments!: string | undefined;
    legacyPayments!: string | undefined;
    taxReportingUs1099K!: string | undefined;
    taxReportingUs1099Misc!: string | undefined;
    transfers!: string | undefined;

    constructor(data?: IAccountCapabilities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.auBecsDebitPayments = _data["auBecsDebitPayments"];
            this.bacsDebitPayments = _data["bacsDebitPayments"];
            this.cardIssuing = _data["cardIssuing"];
            this.cardPayments = _data["cardPayments"];
            this.cartesBancairesPayments = _data["cartesBancairesPayments"];
            this.fpxPayments = _data["fpxPayments"];
            this.jcbPayments = _data["jcbPayments"];
            this.legacyPayments = _data["legacyPayments"];
            this.taxReportingUs1099K = _data["taxReportingUs1099K"];
            this.taxReportingUs1099Misc = _data["taxReportingUs1099Misc"];
            this.transfers = _data["transfers"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountCapabilities | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountCapabilities>(data, _mappings, AccountCapabilities);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["auBecsDebitPayments"] = this.auBecsDebitPayments;
        data["bacsDebitPayments"] = this.bacsDebitPayments;
        data["cardIssuing"] = this.cardIssuing;
        data["cardPayments"] = this.cardPayments;
        data["cartesBancairesPayments"] = this.cartesBancairesPayments;
        data["fpxPayments"] = this.fpxPayments;
        data["jcbPayments"] = this.jcbPayments;
        data["legacyPayments"] = this.legacyPayments;
        data["taxReportingUs1099K"] = this.taxReportingUs1099K;
        data["taxReportingUs1099Misc"] = this.taxReportingUs1099Misc;
        data["transfers"] = this.transfers;
        return data;
    }
}

export interface IAccountCapabilities {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    auBecsDebitPayments: string | undefined;
    bacsDebitPayments: string | undefined;
    cardIssuing: string | undefined;
    cardPayments: string | undefined;
    cartesBancairesPayments: string | undefined;
    fpxPayments: string | undefined;
    jcbPayments: string | undefined;
    legacyPayments: string | undefined;
    taxReportingUs1099K: string | undefined;
    taxReportingUs1099Misc: string | undefined;
    transfers: string | undefined;
}

export class AddressJapan implements IAddressJapan {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    city!: string | undefined;
    country!: string | undefined;
    line1!: string | undefined;
    line2!: string | undefined;
    postalCode!: string | undefined;
    state!: string | undefined;
    town!: string | undefined;

    constructor(data?: IAddressJapan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.city = _data["city"];
            this.country = _data["country"];
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.postalCode = _data["postalCode"];
            this.state = _data["state"];
            this.town = _data["town"];
        }
    }

    static fromJS(data: any, _mappings?: any): AddressJapan | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddressJapan>(data, _mappings, AddressJapan);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["city"] = this.city;
        data["country"] = this.country;
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["postalCode"] = this.postalCode;
        data["state"] = this.state;
        data["town"] = this.town;
        return data;
    }
}

export interface IAddressJapan {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    city: string | undefined;
    country: string | undefined;
    line1: string | undefined;
    line2: string | undefined;
    postalCode: string | undefined;
    state: string | undefined;
    town: string | undefined;
}

export class FileLink implements IFileLink {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    id!: string | undefined;
    object!: string | undefined;
    created!: string | undefined;
    expired!: boolean | undefined;
    expiresAt!: string | undefined;
    fileId!: string | undefined;
    file!: File | undefined;
    livemode!: boolean | undefined;
    metadata!: { [key: string]: string; } | undefined;
    url!: string | undefined;

    constructor(data?: IFileLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.id = _data["id"];
            this.object = _data["object"];
            this.created = _data["created"];
            this.expired = _data["expired"];
            this.expiresAt = _data["expiresAt"];
            this.fileId = _data["fileId"];
            this.file = _data["file"] ? File.fromJS(_data["file"], _mappings) : undefined as any;
            this.livemode = _data["livemode"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (this.metadata as any)![key] = _data["metadata"][key];
                }
            }
            this.url = _data["url"];
        }
    }

    static fromJS(data: any, _mappings?: any): FileLink | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FileLink>(data, _mappings, FileLink);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["id"] = this.id;
        data["object"] = this.object;
        data["created"] = this.created;
        data["expired"] = this.expired;
        data["expiresAt"] = this.expiresAt;
        data["fileId"] = this.fileId;
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        data["livemode"] = this.livemode;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (data["metadata"] as any)[key] = (this.metadata as any)[key];
            }
        }
        data["url"] = this.url;
        return data;
    }
}

export interface IFileLink {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    id: string | undefined;
    object: string | undefined;
    created: string | undefined;
    expired: boolean | undefined;
    expiresAt: string | undefined;
    fileId: string | undefined;
    file: File | undefined;
    livemode: boolean | undefined;
    metadata: { [key: string]: string; } | undefined;
    url: string | undefined;
}

export class File implements IFile {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    id!: string | undefined;
    object!: string | undefined;
    created!: string | undefined;
    expiresAt!: string | undefined;
    filename!: string | undefined;
    links!: any[] | undefined;
    purpose!: string | undefined;
    size!: number | undefined;
    title!: string | undefined;
    type!: string | undefined;
    url!: string | undefined;

    constructor(data?: IFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.id = _data["id"];
            this.object = _data["object"];
            this.created = _data["created"];
            this.expiresAt = _data["expiresAt"];
            this.filename = _data["filename"];
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(item);
            }
            this.purpose = _data["purpose"];
            this.size = _data["size"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any, _mappings?: any): File | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<File>(data, _mappings, File);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["id"] = this.id;
        data["object"] = this.object;
        data["created"] = this.created;
        data["expiresAt"] = this.expiresAt;
        data["filename"] = this.filename;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item);
        }
        data["purpose"] = this.purpose;
        data["size"] = this.size;
        data["title"] = this.title;
        data["type"] = this.type;
        data["url"] = this.url;
        return data;
    }
}

export interface IFile {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    id: string | undefined;
    object: string | undefined;
    created: string | undefined;
    expiresAt: string | undefined;
    filename: string | undefined;
    links: any[] | undefined;
    purpose: string | undefined;
    size: number | undefined;
    title: string | undefined;
    type: string | undefined;
    url: string | undefined;
}

export class AccountCompanyVerificationDocument implements IAccountCompanyVerificationDocument {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    backId!: string | undefined;
    back!: File | undefined;
    details!: string | undefined;
    detailsCode!: string | undefined;
    frontId!: string | undefined;
    front!: File | undefined;

    constructor(data?: IAccountCompanyVerificationDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.backId = _data["backId"];
            this.back = _data["back"] ? File.fromJS(_data["back"], _mappings) : undefined as any;
            this.details = _data["details"];
            this.detailsCode = _data["detailsCode"];
            this.frontId = _data["frontId"];
            this.front = _data["front"] ? File.fromJS(_data["front"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): AccountCompanyVerificationDocument | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountCompanyVerificationDocument>(data, _mappings, AccountCompanyVerificationDocument);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["backId"] = this.backId;
        data["back"] = this.back ? this.back.toJSON() : undefined as any;
        data["details"] = this.details;
        data["detailsCode"] = this.detailsCode;
        data["frontId"] = this.frontId;
        data["front"] = this.front ? this.front.toJSON() : undefined as any;
        return data;
    }
}

export interface IAccountCompanyVerificationDocument {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    backId: string | undefined;
    back: File | undefined;
    details: string | undefined;
    detailsCode: string | undefined;
    frontId: string | undefined;
    front: File | undefined;
}

export class AccountCompanyVerification implements IAccountCompanyVerification {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    document!: AccountCompanyVerificationDocument | undefined;

    constructor(data?: IAccountCompanyVerification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.document = _data["document"] ? AccountCompanyVerificationDocument.fromJS(_data["document"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): AccountCompanyVerification | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountCompanyVerification>(data, _mappings, AccountCompanyVerification);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        return data;
    }
}

export interface IAccountCompanyVerification {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    document: AccountCompanyVerificationDocument | undefined;
}

export class AccountCompany implements IAccountCompany {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    address!: Address | undefined;
    addressKana!: AddressJapan | undefined;
    addressKanji!: AddressJapan | undefined;
    directorsProvided!: boolean | undefined;
    executivesProvided!: boolean | undefined;
    name!: string | undefined;
    nameKana!: string | undefined;
    nameKanji!: string | undefined;
    ownersProvided!: boolean | undefined;
    phone!: string | undefined;
    structure!: string | undefined;
    taxIdProvided!: boolean | undefined;
    taxIdRegistrar!: string | undefined;
    vatIdProvided!: boolean | undefined;
    verification!: AccountCompanyVerification | undefined;

    constructor(data?: IAccountCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.address = _data["address"] ? Address.fromJS(_data["address"], _mappings) : undefined as any;
            this.addressKana = _data["addressKana"] ? AddressJapan.fromJS(_data["addressKana"], _mappings) : undefined as any;
            this.addressKanji = _data["addressKanji"] ? AddressJapan.fromJS(_data["addressKanji"], _mappings) : undefined as any;
            this.directorsProvided = _data["directorsProvided"];
            this.executivesProvided = _data["executivesProvided"];
            this.name = _data["name"];
            this.nameKana = _data["nameKana"];
            this.nameKanji = _data["nameKanji"];
            this.ownersProvided = _data["ownersProvided"];
            this.phone = _data["phone"];
            this.structure = _data["structure"];
            this.taxIdProvided = _data["taxIdProvided"];
            this.taxIdRegistrar = _data["taxIdRegistrar"];
            this.vatIdProvided = _data["vatIdProvided"];
            this.verification = _data["verification"] ? AccountCompanyVerification.fromJS(_data["verification"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): AccountCompany | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountCompany>(data, _mappings, AccountCompany);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["addressKana"] = this.addressKana ? this.addressKana.toJSON() : undefined as any;
        data["addressKanji"] = this.addressKanji ? this.addressKanji.toJSON() : undefined as any;
        data["directorsProvided"] = this.directorsProvided;
        data["executivesProvided"] = this.executivesProvided;
        data["name"] = this.name;
        data["nameKana"] = this.nameKana;
        data["nameKanji"] = this.nameKanji;
        data["ownersProvided"] = this.ownersProvided;
        data["phone"] = this.phone;
        data["structure"] = this.structure;
        data["taxIdProvided"] = this.taxIdProvided;
        data["taxIdRegistrar"] = this.taxIdRegistrar;
        data["vatIdProvided"] = this.vatIdProvided;
        data["verification"] = this.verification ? this.verification.toJSON() : undefined as any;
        return data;
    }
}

export interface IAccountCompany {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    address: Address | undefined;
    addressKana: AddressJapan | undefined;
    addressKanji: AddressJapan | undefined;
    directorsProvided: boolean | undefined;
    executivesProvided: boolean | undefined;
    name: string | undefined;
    nameKana: string | undefined;
    nameKanji: string | undefined;
    ownersProvided: boolean | undefined;
    phone: string | undefined;
    structure: string | undefined;
    taxIdProvided: boolean | undefined;
    taxIdRegistrar: string | undefined;
    vatIdProvided: boolean | undefined;
    verification: AccountCompanyVerification | undefined;
}

export class Dob implements IDob {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    day!: number | undefined;
    month!: number | undefined;
    year!: number | undefined;

    constructor(data?: IDob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.day = _data["day"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any, _mappings?: any): Dob | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Dob>(data, _mappings, Dob);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["day"] = this.day;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface IDob {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    day: number | undefined;
    month: number | undefined;
    year: number | undefined;
}

export class PersonRelationship implements IPersonRelationship {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    director!: boolean | undefined;
    executive!: boolean | undefined;
    owner!: boolean | undefined;
    percentOwnership!: number | undefined;
    representative!: boolean | undefined;
    title!: string | undefined;

    constructor(data?: IPersonRelationship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.director = _data["director"];
            this.executive = _data["executive"];
            this.owner = _data["owner"];
            this.percentOwnership = _data["percentOwnership"];
            this.representative = _data["representative"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any, _mappings?: any): PersonRelationship | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PersonRelationship>(data, _mappings, PersonRelationship);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["director"] = this.director;
        data["executive"] = this.executive;
        data["owner"] = this.owner;
        data["percentOwnership"] = this.percentOwnership;
        data["representative"] = this.representative;
        data["title"] = this.title;
        return data;
    }
}

export interface IPersonRelationship {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    director: boolean | undefined;
    executive: boolean | undefined;
    owner: boolean | undefined;
    percentOwnership: number | undefined;
    representative: boolean | undefined;
    title: string | undefined;
}

export class AccountRequirementsError implements IAccountRequirementsError {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    code!: string | undefined;
    reason!: string | undefined;
    requirement!: string | undefined;

    constructor(data?: IAccountRequirementsError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.code = _data["code"];
            this.reason = _data["reason"];
            this.requirement = _data["requirement"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountRequirementsError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountRequirementsError>(data, _mappings, AccountRequirementsError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["code"] = this.code;
        data["reason"] = this.reason;
        data["requirement"] = this.requirement;
        return data;
    }
}

export interface IAccountRequirementsError {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    code: string | undefined;
    reason: string | undefined;
    requirement: string | undefined;
}

export class PersonRequirements implements IPersonRequirements {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    currentlyDue!: string[] | undefined;
    errors!: AccountRequirementsError[] | undefined;
    eventuallyDue!: string[] | undefined;
    pastDue!: string[] | undefined;
    pendingVerification!: string[] | undefined;

    constructor(data?: IPersonRequirements) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            if (Array.isArray(_data["currentlyDue"])) {
                this.currentlyDue = [] as any;
                for (let item of _data["currentlyDue"])
                    this.currentlyDue!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(AccountRequirementsError.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["eventuallyDue"])) {
                this.eventuallyDue = [] as any;
                for (let item of _data["eventuallyDue"])
                    this.eventuallyDue!.push(item);
            }
            if (Array.isArray(_data["pastDue"])) {
                this.pastDue = [] as any;
                for (let item of _data["pastDue"])
                    this.pastDue!.push(item);
            }
            if (Array.isArray(_data["pendingVerification"])) {
                this.pendingVerification = [] as any;
                for (let item of _data["pendingVerification"])
                    this.pendingVerification!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PersonRequirements | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PersonRequirements>(data, _mappings, PersonRequirements);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        if (Array.isArray(this.currentlyDue)) {
            data["currentlyDue"] = [];
            for (let item of this.currentlyDue)
                data["currentlyDue"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.eventuallyDue)) {
            data["eventuallyDue"] = [];
            for (let item of this.eventuallyDue)
                data["eventuallyDue"].push(item);
        }
        if (Array.isArray(this.pastDue)) {
            data["pastDue"] = [];
            for (let item of this.pastDue)
                data["pastDue"].push(item);
        }
        if (Array.isArray(this.pendingVerification)) {
            data["pendingVerification"] = [];
            for (let item of this.pendingVerification)
                data["pendingVerification"].push(item);
        }
        return data;
    }
}

export interface IPersonRequirements {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    currentlyDue: string[] | undefined;
    errors: AccountRequirementsError[] | undefined;
    eventuallyDue: string[] | undefined;
    pastDue: string[] | undefined;
    pendingVerification: string[] | undefined;
}

export class PersonVerificationDocument implements IPersonVerificationDocument {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    backId!: string | undefined;
    back!: File | undefined;
    details!: string | undefined;
    detailsCode!: string | undefined;
    frontId!: string | undefined;
    front!: File | undefined;

    constructor(data?: IPersonVerificationDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.backId = _data["backId"];
            this.back = _data["back"] ? File.fromJS(_data["back"], _mappings) : undefined as any;
            this.details = _data["details"];
            this.detailsCode = _data["detailsCode"];
            this.frontId = _data["frontId"];
            this.front = _data["front"] ? File.fromJS(_data["front"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): PersonVerificationDocument | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PersonVerificationDocument>(data, _mappings, PersonVerificationDocument);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["backId"] = this.backId;
        data["back"] = this.back ? this.back.toJSON() : undefined as any;
        data["details"] = this.details;
        data["detailsCode"] = this.detailsCode;
        data["frontId"] = this.frontId;
        data["front"] = this.front ? this.front.toJSON() : undefined as any;
        return data;
    }
}

export interface IPersonVerificationDocument {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    backId: string | undefined;
    back: File | undefined;
    details: string | undefined;
    detailsCode: string | undefined;
    frontId: string | undefined;
    front: File | undefined;
}

export class PersonVerification implements IPersonVerification {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    additionalDocument!: PersonVerificationDocument | undefined;
    details!: string | undefined;
    detailsCode!: string | undefined;
    document!: PersonVerificationDocument | undefined;
    status!: string | undefined;

    constructor(data?: IPersonVerification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.additionalDocument = _data["additionalDocument"] ? PersonVerificationDocument.fromJS(_data["additionalDocument"], _mappings) : undefined as any;
            this.details = _data["details"];
            this.detailsCode = _data["detailsCode"];
            this.document = _data["document"] ? PersonVerificationDocument.fromJS(_data["document"], _mappings) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any, _mappings?: any): PersonVerification | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PersonVerification>(data, _mappings, PersonVerification);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["additionalDocument"] = this.additionalDocument ? this.additionalDocument.toJSON() : undefined as any;
        data["details"] = this.details;
        data["detailsCode"] = this.detailsCode;
        data["document"] = this.document ? this.document.toJSON() : undefined as any;
        data["status"] = this.status;
        return data;
    }
}

export interface IPersonVerification {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    additionalDocument: PersonVerificationDocument | undefined;
    details: string | undefined;
    detailsCode: string | undefined;
    document: PersonVerificationDocument | undefined;
    status: string | undefined;
}

export class Person implements IPerson {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    id!: string | undefined;
    object!: string | undefined;
    account!: string | undefined;
    address!: Address | undefined;
    addressKana!: AddressJapan | undefined;
    addressKanji!: AddressJapan | undefined;
    created!: string | undefined;
    deleted!: boolean | undefined;
    dob!: Dob | undefined;
    email!: string | undefined;
    firstName!: string | undefined;
    firstNameKana!: string | undefined;
    firstNameKanji!: string | undefined;
    gender!: string | undefined;
    idNumberProvided!: boolean | undefined;
    lastName!: string | undefined;
    lastNameKana!: string | undefined;
    lastNameKanji!: string | undefined;
    maidenName!: string | undefined;
    metadata!: { [key: string]: string; } | undefined;
    phone!: string | undefined;
    politicalExposure!: string | undefined;
    relationship!: PersonRelationship | undefined;
    requirements!: PersonRequirements | undefined;
    ssnLast4Provided!: boolean | undefined;
    verification!: PersonVerification | undefined;

    constructor(data?: IPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.id = _data["id"];
            this.object = _data["object"];
            this.account = _data["account"];
            this.address = _data["address"] ? Address.fromJS(_data["address"], _mappings) : undefined as any;
            this.addressKana = _data["addressKana"] ? AddressJapan.fromJS(_data["addressKana"], _mappings) : undefined as any;
            this.addressKanji = _data["addressKanji"] ? AddressJapan.fromJS(_data["addressKanji"], _mappings) : undefined as any;
            this.created = _data["created"];
            this.deleted = _data["deleted"];
            this.dob = _data["dob"] ? Dob.fromJS(_data["dob"], _mappings) : undefined as any;
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.firstNameKana = _data["firstNameKana"];
            this.firstNameKanji = _data["firstNameKanji"];
            this.gender = _data["gender"];
            this.idNumberProvided = _data["idNumberProvided"];
            this.lastName = _data["lastName"];
            this.lastNameKana = _data["lastNameKana"];
            this.lastNameKanji = _data["lastNameKanji"];
            this.maidenName = _data["maidenName"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (this.metadata as any)![key] = _data["metadata"][key];
                }
            }
            this.phone = _data["phone"];
            this.politicalExposure = _data["politicalExposure"];
            this.relationship = _data["relationship"] ? PersonRelationship.fromJS(_data["relationship"], _mappings) : undefined as any;
            this.requirements = _data["requirements"] ? PersonRequirements.fromJS(_data["requirements"], _mappings) : undefined as any;
            this.ssnLast4Provided = _data["ssnLast4Provided"];
            this.verification = _data["verification"] ? PersonVerification.fromJS(_data["verification"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): Person | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Person>(data, _mappings, Person);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["id"] = this.id;
        data["object"] = this.object;
        data["account"] = this.account;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["addressKana"] = this.addressKana ? this.addressKana.toJSON() : undefined as any;
        data["addressKanji"] = this.addressKanji ? this.addressKanji.toJSON() : undefined as any;
        data["created"] = this.created;
        data["deleted"] = this.deleted;
        data["dob"] = this.dob ? this.dob.toJSON() : undefined as any;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["firstNameKana"] = this.firstNameKana;
        data["firstNameKanji"] = this.firstNameKanji;
        data["gender"] = this.gender;
        data["idNumberProvided"] = this.idNumberProvided;
        data["lastName"] = this.lastName;
        data["lastNameKana"] = this.lastNameKana;
        data["lastNameKanji"] = this.lastNameKanji;
        data["maidenName"] = this.maidenName;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (data["metadata"] as any)[key] = (this.metadata as any)[key];
            }
        }
        data["phone"] = this.phone;
        data["politicalExposure"] = this.politicalExposure;
        data["relationship"] = this.relationship ? this.relationship.toJSON() : undefined as any;
        data["requirements"] = this.requirements ? this.requirements.toJSON() : undefined as any;
        data["ssnLast4Provided"] = this.ssnLast4Provided;
        data["verification"] = this.verification ? this.verification.toJSON() : undefined as any;
        return data;
    }
}

export interface IPerson {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    id: string | undefined;
    object: string | undefined;
    account: string | undefined;
    address: Address | undefined;
    addressKana: AddressJapan | undefined;
    addressKanji: AddressJapan | undefined;
    created: string | undefined;
    deleted: boolean | undefined;
    dob: Dob | undefined;
    email: string | undefined;
    firstName: string | undefined;
    firstNameKana: string | undefined;
    firstNameKanji: string | undefined;
    gender: string | undefined;
    idNumberProvided: boolean | undefined;
    lastName: string | undefined;
    lastNameKana: string | undefined;
    lastNameKanji: string | undefined;
    maidenName: string | undefined;
    metadata: { [key: string]: string; } | undefined;
    phone: string | undefined;
    politicalExposure: string | undefined;
    relationship: PersonRelationship | undefined;
    requirements: PersonRequirements | undefined;
    ssnLast4Provided: boolean | undefined;
    verification: PersonVerification | undefined;
}

export class AccountRequirements implements IAccountRequirements {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    currentDeadline!: string | undefined;
    currentlyDue!: string[] | undefined;
    disabledReason!: string | undefined;
    errors!: AccountRequirementsError[] | undefined;
    eventuallyDue!: string[] | undefined;
    pastDue!: string[] | undefined;
    pendingVerification!: string[] | undefined;

    constructor(data?: IAccountRequirements) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.currentDeadline = _data["currentDeadline"];
            if (Array.isArray(_data["currentlyDue"])) {
                this.currentlyDue = [] as any;
                for (let item of _data["currentlyDue"])
                    this.currentlyDue!.push(item);
            }
            this.disabledReason = _data["disabledReason"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(AccountRequirementsError.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["eventuallyDue"])) {
                this.eventuallyDue = [] as any;
                for (let item of _data["eventuallyDue"])
                    this.eventuallyDue!.push(item);
            }
            if (Array.isArray(_data["pastDue"])) {
                this.pastDue = [] as any;
                for (let item of _data["pastDue"])
                    this.pastDue!.push(item);
            }
            if (Array.isArray(_data["pendingVerification"])) {
                this.pendingVerification = [] as any;
                for (let item of _data["pendingVerification"])
                    this.pendingVerification!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AccountRequirements | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountRequirements>(data, _mappings, AccountRequirements);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["currentDeadline"] = this.currentDeadline;
        if (Array.isArray(this.currentlyDue)) {
            data["currentlyDue"] = [];
            for (let item of this.currentlyDue)
                data["currentlyDue"].push(item);
        }
        data["disabledReason"] = this.disabledReason;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.eventuallyDue)) {
            data["eventuallyDue"] = [];
            for (let item of this.eventuallyDue)
                data["eventuallyDue"].push(item);
        }
        if (Array.isArray(this.pastDue)) {
            data["pastDue"] = [];
            for (let item of this.pastDue)
                data["pastDue"].push(item);
        }
        if (Array.isArray(this.pendingVerification)) {
            data["pendingVerification"] = [];
            for (let item of this.pendingVerification)
                data["pendingVerification"].push(item);
        }
        return data;
    }
}

export interface IAccountRequirements {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    currentDeadline: string | undefined;
    currentlyDue: string[] | undefined;
    disabledReason: string | undefined;
    errors: AccountRequirementsError[] | undefined;
    eventuallyDue: string[] | undefined;
    pastDue: string[] | undefined;
    pendingVerification: string[] | undefined;
}

export class AccountSettingsBacsDebitPayments implements IAccountSettingsBacsDebitPayments {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    displayName!: string | undefined;

    constructor(data?: IAccountSettingsBacsDebitPayments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountSettingsBacsDebitPayments | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountSettingsBacsDebitPayments>(data, _mappings, AccountSettingsBacsDebitPayments);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IAccountSettingsBacsDebitPayments {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    displayName: string | undefined;
}

export class AccountSettingsBranding implements IAccountSettingsBranding {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    iconId!: string | undefined;
    icon!: File | undefined;
    logoId!: string | undefined;
    logo!: File | undefined;
    primaryColor!: string | undefined;
    secondaryColor!: string | undefined;

    constructor(data?: IAccountSettingsBranding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.iconId = _data["iconId"];
            this.icon = _data["icon"] ? File.fromJS(_data["icon"], _mappings) : undefined as any;
            this.logoId = _data["logoId"];
            this.logo = _data["logo"] ? File.fromJS(_data["logo"], _mappings) : undefined as any;
            this.primaryColor = _data["primaryColor"];
            this.secondaryColor = _data["secondaryColor"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountSettingsBranding | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountSettingsBranding>(data, _mappings, AccountSettingsBranding);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["iconId"] = this.iconId;
        data["icon"] = this.icon ? this.icon.toJSON() : undefined as any;
        data["logoId"] = this.logoId;
        data["logo"] = this.logo ? this.logo.toJSON() : undefined as any;
        data["primaryColor"] = this.primaryColor;
        data["secondaryColor"] = this.secondaryColor;
        return data;
    }
}

export interface IAccountSettingsBranding {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    iconId: string | undefined;
    icon: File | undefined;
    logoId: string | undefined;
    logo: File | undefined;
    primaryColor: string | undefined;
    secondaryColor: string | undefined;
}

export class AccountSettingsDeclineOn implements IAccountSettingsDeclineOn {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    avsFailure!: boolean | undefined;
    cvcFailure!: boolean | undefined;

    constructor(data?: IAccountSettingsDeclineOn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.avsFailure = _data["avsFailure"];
            this.cvcFailure = _data["cvcFailure"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountSettingsDeclineOn | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountSettingsDeclineOn>(data, _mappings, AccountSettingsDeclineOn);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["avsFailure"] = this.avsFailure;
        data["cvcFailure"] = this.cvcFailure;
        return data;
    }
}

export interface IAccountSettingsDeclineOn {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    avsFailure: boolean | undefined;
    cvcFailure: boolean | undefined;
}

export class AccountSettingsCardPayments implements IAccountSettingsCardPayments {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    declineOn!: AccountSettingsDeclineOn | undefined;
    statementDescriptorPrefix!: string | undefined;

    constructor(data?: IAccountSettingsCardPayments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.declineOn = _data["declineOn"] ? AccountSettingsDeclineOn.fromJS(_data["declineOn"], _mappings) : undefined as any;
            this.statementDescriptorPrefix = _data["statementDescriptorPrefix"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountSettingsCardPayments | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountSettingsCardPayments>(data, _mappings, AccountSettingsCardPayments);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["declineOn"] = this.declineOn ? this.declineOn.toJSON() : undefined as any;
        data["statementDescriptorPrefix"] = this.statementDescriptorPrefix;
        return data;
    }
}

export interface IAccountSettingsCardPayments {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    declineOn: AccountSettingsDeclineOn | undefined;
    statementDescriptorPrefix: string | undefined;
}

export class AccountSettingsDashboard implements IAccountSettingsDashboard {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    displayName!: string | undefined;
    timezone!: string | undefined;

    constructor(data?: IAccountSettingsDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.displayName = _data["displayName"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountSettingsDashboard | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountSettingsDashboard>(data, _mappings, AccountSettingsDashboard);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["displayName"] = this.displayName;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IAccountSettingsDashboard {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    displayName: string | undefined;
    timezone: string | undefined;
}

export class AccountSettingsPayments implements IAccountSettingsPayments {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    statementDescriptor!: string | undefined;
    statementDescriptorKana!: string | undefined;
    statementDescriptorKanji!: string | undefined;

    constructor(data?: IAccountSettingsPayments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.statementDescriptor = _data["statementDescriptor"];
            this.statementDescriptorKana = _data["statementDescriptorKana"];
            this.statementDescriptorKanji = _data["statementDescriptorKanji"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountSettingsPayments | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountSettingsPayments>(data, _mappings, AccountSettingsPayments);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["statementDescriptor"] = this.statementDescriptor;
        data["statementDescriptorKana"] = this.statementDescriptorKana;
        data["statementDescriptorKanji"] = this.statementDescriptorKanji;
        return data;
    }
}

export interface IAccountSettingsPayments {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    statementDescriptor: string | undefined;
    statementDescriptorKana: string | undefined;
    statementDescriptorKanji: string | undefined;
}

export class AccountSettingsPayoutsSchedule implements IAccountSettingsPayoutsSchedule {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    delayDays!: number | undefined;
    interval!: string | undefined;
    monthlyAnchor!: number | undefined;
    weeklyAnchor!: string | undefined;

    constructor(data?: IAccountSettingsPayoutsSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.delayDays = _data["delayDays"];
            this.interval = _data["interval"];
            this.monthlyAnchor = _data["monthlyAnchor"];
            this.weeklyAnchor = _data["weeklyAnchor"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountSettingsPayoutsSchedule | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountSettingsPayoutsSchedule>(data, _mappings, AccountSettingsPayoutsSchedule);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["delayDays"] = this.delayDays;
        data["interval"] = this.interval;
        data["monthlyAnchor"] = this.monthlyAnchor;
        data["weeklyAnchor"] = this.weeklyAnchor;
        return data;
    }
}

export interface IAccountSettingsPayoutsSchedule {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    delayDays: number | undefined;
    interval: string | undefined;
    monthlyAnchor: number | undefined;
    weeklyAnchor: string | undefined;
}

export class AccountSettingsPayouts implements IAccountSettingsPayouts {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    debitNegativeBalances!: boolean | undefined;
    schedule!: AccountSettingsPayoutsSchedule | undefined;
    statementDescriptor!: string | undefined;

    constructor(data?: IAccountSettingsPayouts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.debitNegativeBalances = _data["debitNegativeBalances"];
            this.schedule = _data["schedule"] ? AccountSettingsPayoutsSchedule.fromJS(_data["schedule"], _mappings) : undefined as any;
            this.statementDescriptor = _data["statementDescriptor"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountSettingsPayouts | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountSettingsPayouts>(data, _mappings, AccountSettingsPayouts);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["debitNegativeBalances"] = this.debitNegativeBalances;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : undefined as any;
        data["statementDescriptor"] = this.statementDescriptor;
        return data;
    }
}

export interface IAccountSettingsPayouts {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    debitNegativeBalances: boolean | undefined;
    schedule: AccountSettingsPayoutsSchedule | undefined;
    statementDescriptor: string | undefined;
}

export class AccountSettingsSepaDebitPayments implements IAccountSettingsSepaDebitPayments {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    creditorId!: string | undefined;

    constructor(data?: IAccountSettingsSepaDebitPayments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.creditorId = _data["creditorId"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountSettingsSepaDebitPayments | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountSettingsSepaDebitPayments>(data, _mappings, AccountSettingsSepaDebitPayments);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["creditorId"] = this.creditorId;
        return data;
    }
}

export interface IAccountSettingsSepaDebitPayments {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    creditorId: string | undefined;
}

export class AccountSettings implements IAccountSettings {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    bacsDebitPayments!: AccountSettingsBacsDebitPayments | undefined;
    branding!: AccountSettingsBranding | undefined;
    cardPayments!: AccountSettingsCardPayments | undefined;
    dashboard!: AccountSettingsDashboard | undefined;
    payments!: AccountSettingsPayments | undefined;
    payouts!: AccountSettingsPayouts | undefined;
    sepaDebitPayments!: AccountSettingsSepaDebitPayments | undefined;

    constructor(data?: IAccountSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.bacsDebitPayments = _data["bacsDebitPayments"] ? AccountSettingsBacsDebitPayments.fromJS(_data["bacsDebitPayments"], _mappings) : undefined as any;
            this.branding = _data["branding"] ? AccountSettingsBranding.fromJS(_data["branding"], _mappings) : undefined as any;
            this.cardPayments = _data["cardPayments"] ? AccountSettingsCardPayments.fromJS(_data["cardPayments"], _mappings) : undefined as any;
            this.dashboard = _data["dashboard"] ? AccountSettingsDashboard.fromJS(_data["dashboard"], _mappings) : undefined as any;
            this.payments = _data["payments"] ? AccountSettingsPayments.fromJS(_data["payments"], _mappings) : undefined as any;
            this.payouts = _data["payouts"] ? AccountSettingsPayouts.fromJS(_data["payouts"], _mappings) : undefined as any;
            this.sepaDebitPayments = _data["sepaDebitPayments"] ? AccountSettingsSepaDebitPayments.fromJS(_data["sepaDebitPayments"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): AccountSettings | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountSettings>(data, _mappings, AccountSettings);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["bacsDebitPayments"] = this.bacsDebitPayments ? this.bacsDebitPayments.toJSON() : undefined as any;
        data["branding"] = this.branding ? this.branding.toJSON() : undefined as any;
        data["cardPayments"] = this.cardPayments ? this.cardPayments.toJSON() : undefined as any;
        data["dashboard"] = this.dashboard ? this.dashboard.toJSON() : undefined as any;
        data["payments"] = this.payments ? this.payments.toJSON() : undefined as any;
        data["payouts"] = this.payouts ? this.payouts.toJSON() : undefined as any;
        data["sepaDebitPayments"] = this.sepaDebitPayments ? this.sepaDebitPayments.toJSON() : undefined as any;
        return data;
    }
}

export interface IAccountSettings {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    bacsDebitPayments: AccountSettingsBacsDebitPayments | undefined;
    branding: AccountSettingsBranding | undefined;
    cardPayments: AccountSettingsCardPayments | undefined;
    dashboard: AccountSettingsDashboard | undefined;
    payments: AccountSettingsPayments | undefined;
    payouts: AccountSettingsPayouts | undefined;
    sepaDebitPayments: AccountSettingsSepaDebitPayments | undefined;
}

export class AccountTosAcceptance implements IAccountTosAcceptance {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    date!: string | undefined;
    ip!: string | undefined;
    userAgent!: string | undefined;

    constructor(data?: IAccountTosAcceptance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.date = _data["date"];
            this.ip = _data["ip"];
            this.userAgent = _data["userAgent"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountTosAcceptance | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountTosAcceptance>(data, _mappings, AccountTosAcceptance);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["date"] = this.date;
        data["ip"] = this.ip;
        data["userAgent"] = this.userAgent;
        return data;
    }
}

export interface IAccountTosAcceptance {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    date: string | undefined;
    ip: string | undefined;
    userAgent: string | undefined;
}

export class SkuInventory implements ISkuInventory {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    quantity!: number | undefined;
    type!: string | undefined;
    value!: string | undefined;

    constructor(data?: ISkuInventory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.quantity = _data["quantity"];
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): SkuInventory | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SkuInventory>(data, _mappings, SkuInventory);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["quantity"] = this.quantity;
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface ISkuInventory {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    quantity: number | undefined;
    type: string | undefined;
    value: string | undefined;
}

export class Sku implements ISku {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    id!: string | undefined;
    object!: string | undefined;
    active!: boolean | undefined;
    attributes!: { [key: string]: string; } | undefined;
    created!: string | undefined;
    currency!: string | undefined;
    deleted!: boolean | undefined;
    image!: string | undefined;
    inventory!: SkuInventory | undefined;
    livemode!: boolean | undefined;
    metadata!: { [key: string]: string; } | undefined;
    packageDimensions!: PackageDimensions | undefined;
    price!: number | undefined;
    productId!: string | undefined;
    product!: any | undefined;
    updated!: string | undefined;

    constructor(data?: ISku) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.id = _data["id"];
            this.object = _data["object"];
            this.active = _data["active"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (this.attributes as any)![key] = _data["attributes"][key];
                }
            }
            this.created = _data["created"];
            this.currency = _data["currency"];
            this.deleted = _data["deleted"];
            this.image = _data["image"];
            this.inventory = _data["inventory"] ? SkuInventory.fromJS(_data["inventory"], _mappings) : undefined as any;
            this.livemode = _data["livemode"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (this.metadata as any)![key] = _data["metadata"][key];
                }
            }
            this.packageDimensions = _data["packageDimensions"] ? PackageDimensions.fromJS(_data["packageDimensions"], _mappings) : undefined as any;
            this.price = _data["price"];
            this.productId = _data["productId"];
            this.product = _data["product"];
            this.updated = _data["updated"];
        }
    }

    static fromJS(data: any, _mappings?: any): Sku | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Sku>(data, _mappings, Sku);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["id"] = this.id;
        data["object"] = this.object;
        data["active"] = this.active;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (data["attributes"] as any)[key] = (this.attributes as any)[key];
            }
        }
        data["created"] = this.created;
        data["currency"] = this.currency;
        data["deleted"] = this.deleted;
        data["image"] = this.image;
        data["inventory"] = this.inventory ? this.inventory.toJSON() : undefined as any;
        data["livemode"] = this.livemode;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (data["metadata"] as any)[key] = (this.metadata as any)[key];
            }
        }
        data["packageDimensions"] = this.packageDimensions ? this.packageDimensions.toJSON() : undefined as any;
        data["price"] = this.price;
        data["productId"] = this.productId;
        data["product"] = this.product;
        data["updated"] = this.updated;
        return data;
    }
}

export interface ISku {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    id: string | undefined;
    object: string | undefined;
    active: boolean | undefined;
    attributes: { [key: string]: string; } | undefined;
    created: string | undefined;
    currency: string | undefined;
    deleted: boolean | undefined;
    image: string | undefined;
    inventory: SkuInventory | undefined;
    livemode: boolean | undefined;
    metadata: { [key: string]: string; } | undefined;
    packageDimensions: PackageDimensions | undefined;
    price: number | undefined;
    productId: string | undefined;
    product: any | undefined;
    updated: string | undefined;
}

export class Rule implements IRule {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    id!: string | undefined;
    action!: string | undefined;
    deleted!: boolean | undefined;
    predicate!: string | undefined;

    constructor(data?: IRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.id = _data["id"];
            this.action = _data["action"];
            this.deleted = _data["deleted"];
            this.predicate = _data["predicate"];
        }
    }

    static fromJS(data: any, _mappings?: any): Rule | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Rule>(data, _mappings, Rule);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["id"] = this.id;
        data["action"] = this.action;
        data["deleted"] = this.deleted;
        data["predicate"] = this.predicate;
        return data;
    }
}

export interface IRule {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    id: string | undefined;
    action: string | undefined;
    deleted: boolean | undefined;
    predicate: string | undefined;
}

export class Period implements IPeriod {
    readonly rawJObject!: { [key: string]: any[]; } | undefined;
    stripeResponse!: StripeResponse | undefined;
    start!: string | undefined;
    end!: string | undefined;

    constructor(data?: IPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (_data["rawJObject"]) {
                (this as any).rawJObject = {} as any;
                for (let key in _data["rawJObject"]) {
                    if (_data["rawJObject"].hasOwnProperty(key))
                        ((this as any).rawJObject as any)![key] = _data["rawJObject"][key] !== undefined ? _data["rawJObject"][key] : [];
                }
            }
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"], _mappings) : undefined as any;
            this.start = _data["start"];
            this.end = _data["end"];
        }
    }

    static fromJS(data: any, _mappings?: any): Period | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Period>(data, _mappings, Period);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rawJObject) {
            data["rawJObject"] = {};
            for (let key in this.rawJObject) {
                if (this.rawJObject.hasOwnProperty(key))
                    (data["rawJObject"] as any)[key] = (this.rawJObject as any)[key];
            }
        }
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : undefined as any;
        data["start"] = this.start;
        data["end"] = this.end;
        return data;
    }
}

export interface IPeriod {
    rawJObject: { [key: string]: any[]; } | undefined;
    stripeResponse: StripeResponse | undefined;
    start: string | undefined;
    end: string | undefined;
}

export class UpdateSubscriptionResponse implements IUpdateSubscriptionResponse {
    subscription!: any | undefined;

    constructor(data?: IUpdateSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.subscription = _data["subscription"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateSubscriptionResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateSubscriptionResponse>(data, _mappings, UpdateSubscriptionResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscription"] = this.subscription;
        return data;
    }
}

export interface IUpdateSubscriptionResponse {
    subscription: any | undefined;
}

export class SubscriptionResponse implements ISubscriptionResponse {
    subscriptionId!: string | undefined;
    productId!: string | undefined;
    planName!: string | undefined;
    currency!: string | undefined;
    priceId!: string | undefined;
    amount!: number | undefined;
    quantity!: number | undefined;
    subscriptionEndDate!: string | undefined;
    subscriptionStartDate!: string | undefined;
    cardLast4!: string | undefined;
    unit!: string | undefined;
    noOfUsers!: number | undefined;
    status!: string | undefined;
    created!: string | undefined;
    readonly cancelAtPeriodEnd!: boolean | undefined;

    constructor(data?: ISubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.productId = _data["productId"];
            this.planName = _data["planName"];
            this.currency = _data["currency"];
            this.priceId = _data["priceId"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.subscriptionEndDate = _data["subscriptionEndDate"];
            this.subscriptionStartDate = _data["subscriptionStartDate"];
            this.cardLast4 = _data["cardLast4"];
            this.unit = _data["unit"];
            this.noOfUsers = _data["noOfUsers"];
            this.status = _data["status"];
            this.created = _data["created"];
            (this as any).cancelAtPeriodEnd = _data["cancelAtPeriodEnd"];
        }
    }

    static fromJS(data: any, _mappings?: any): SubscriptionResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SubscriptionResponse>(data, _mappings, SubscriptionResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["productId"] = this.productId;
        data["planName"] = this.planName;
        data["currency"] = this.currency;
        data["priceId"] = this.priceId;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["subscriptionEndDate"] = this.subscriptionEndDate;
        data["subscriptionStartDate"] = this.subscriptionStartDate;
        data["cardLast4"] = this.cardLast4;
        data["unit"] = this.unit;
        data["noOfUsers"] = this.noOfUsers;
        data["status"] = this.status;
        data["created"] = this.created;
        data["cancelAtPeriodEnd"] = this.cancelAtPeriodEnd;
        return data;
    }
}

export interface ISubscriptionResponse {
    subscriptionId: string | undefined;
    productId: string | undefined;
    planName: string | undefined;
    currency: string | undefined;
    priceId: string | undefined;
    amount: number | undefined;
    quantity: number | undefined;
    subscriptionEndDate: string | undefined;
    subscriptionStartDate: string | undefined;
    cardLast4: string | undefined;
    unit: string | undefined;
    noOfUsers: number | undefined;
    status: string | undefined;
    created: string | undefined;
    cancelAtPeriodEnd: boolean | undefined;
}

export class SubscriptionDetailsOutput implements ISubscriptionDetailsOutput {
    subscriptionType!: any | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    numberOfUsers!: number | undefined;
    usedSeatsCount!: number | undefined;
    freeSeats!: number | undefined;
    costPerUser!: number | undefined;
    amount!: number | undefined;
    status!: string | undefined;
    productName!: string | undefined;
    subscriptionId!: string | undefined;
    couponId!: number | undefined;
    coupon!: string | undefined;
    trialEnd!: string | undefined;
    nextInvoiceDate!: string | undefined;
    nextInvoiceAmount!: number | undefined;
    cancelAtPeriodEnd!: boolean | undefined;
    cardBrand!: string | undefined;
    cardLast4!: string | undefined;
    priceId!: string | undefined;
    productId!: string | undefined;
    billingType!: string | undefined;
    discountAmount!: number | undefined;

    constructor(data?: ISubscriptionDetailsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.subscriptionType = _data["subscriptionType"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.numberOfUsers = _data["numberOfUsers"];
            this.usedSeatsCount = _data["usedSeatsCount"];
            this.freeSeats = _data["freeSeats"];
            this.costPerUser = _data["costPerUser"];
            this.amount = _data["amount"];
            this.status = _data["status"];
            this.productName = _data["productName"];
            this.subscriptionId = _data["subscriptionId"];
            this.couponId = _data["couponId"];
            this.coupon = _data["coupon"];
            this.trialEnd = _data["trialEnd"];
            this.nextInvoiceDate = _data["nextInvoiceDate"];
            this.nextInvoiceAmount = _data["nextInvoiceAmount"];
            this.cancelAtPeriodEnd = _data["cancelAtPeriodEnd"];
            this.cardBrand = _data["cardBrand"];
            this.cardLast4 = _data["cardLast4"];
            this.priceId = _data["priceId"];
            this.productId = _data["productId"];
            this.billingType = _data["billingType"];
            this.discountAmount = _data["discountAmount"];
        }
    }

    static fromJS(data: any, _mappings?: any): SubscriptionDetailsOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SubscriptionDetailsOutput>(data, _mappings, SubscriptionDetailsOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionType"] = this.subscriptionType;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["numberOfUsers"] = this.numberOfUsers;
        data["usedSeatsCount"] = this.usedSeatsCount;
        data["freeSeats"] = this.freeSeats;
        data["costPerUser"] = this.costPerUser;
        data["amount"] = this.amount;
        data["status"] = this.status;
        data["productName"] = this.productName;
        data["subscriptionId"] = this.subscriptionId;
        data["couponId"] = this.couponId;
        data["coupon"] = this.coupon;
        data["trialEnd"] = this.trialEnd;
        data["nextInvoiceDate"] = this.nextInvoiceDate;
        data["nextInvoiceAmount"] = this.nextInvoiceAmount;
        data["cancelAtPeriodEnd"] = this.cancelAtPeriodEnd;
        data["cardBrand"] = this.cardBrand;
        data["cardLast4"] = this.cardLast4;
        data["priceId"] = this.priceId;
        data["productId"] = this.productId;
        data["billingType"] = this.billingType;
        data["discountAmount"] = this.discountAmount;
        return data;
    }
}

export interface ISubscriptionDetailsOutput {
    subscriptionType: any | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    numberOfUsers: number | undefined;
    usedSeatsCount: number | undefined;
    freeSeats: number | undefined;
    costPerUser: number | undefined;
    amount: number | undefined;
    status: string | undefined;
    productName: string | undefined;
    subscriptionId: string | undefined;
    couponId: number | undefined;
    coupon: string | undefined;
    trialEnd: string | undefined;
    nextInvoiceDate: string | undefined;
    nextInvoiceAmount: number | undefined;
    cancelAtPeriodEnd: boolean | undefined;
    cardBrand: string | undefined;
    cardLast4: string | undefined;
    priceId: string | undefined;
    productId: string | undefined;
    billingType: string | undefined;
    discountAmount: number | undefined;
}

export class LocalBillingDetail implements ILocalBillingDetail {
    name!: string | undefined;
    cardNo!: string | undefined;
    year!: number | undefined;
    month!: number | undefined;
    cvv!: number | undefined;
    addressLine1!: string | undefined;
    addressLine2!: string | undefined;
    country!: string | undefined;
    state!: string | undefined;
    city!: string | undefined;
    postalCode!: string | undefined;
    noOfUsers!: number | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    isActive!: boolean | undefined;
    id!: number | undefined;
    discountAmount!: number | undefined;
    isDiscountApplied!: boolean | undefined;

    constructor(data?: ILocalBillingDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cardNo = _data["cardNo"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.cvv = _data["cvv"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.noOfUsers = _data["noOfUsers"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
            this.discountAmount = _data["discountAmount"];
            this.isDiscountApplied = _data["isDiscountApplied"];
        }
    }

    static fromJS(data: any, _mappings?: any): LocalBillingDetail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LocalBillingDetail>(data, _mappings, LocalBillingDetail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cardNo"] = this.cardNo;
        data["year"] = this.year;
        data["month"] = this.month;
        data["cvv"] = this.cvv;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["country"] = this.country;
        data["state"] = this.state;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["noOfUsers"] = this.noOfUsers;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        data["discountAmount"] = this.discountAmount;
        data["isDiscountApplied"] = this.isDiscountApplied;
        return data;
    }
}

export interface ILocalBillingDetail {
    name: string | undefined;
    cardNo: string | undefined;
    year: number | undefined;
    month: number | undefined;
    cvv: number | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    country: string | undefined;
    state: string | undefined;
    city: string | undefined;
    postalCode: string | undefined;
    noOfUsers: number | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
    discountAmount: number | undefined;
    isDiscountApplied: boolean | undefined;
}

export class SubscriptionDetailResponse implements ISubscriptionDetailResponse {
    subscription!: SubscriptionResponse | undefined;
    localSubscription!: SubscriptionDetailsOutput | undefined;
    localBillingDetail!: LocalBillingDetail | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    isOwner!: boolean | undefined;

    constructor(data?: ISubscriptionDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.subscription = _data["subscription"] ? SubscriptionResponse.fromJS(_data["subscription"], _mappings) : undefined as any;
            this.localSubscription = _data["localSubscription"] ? SubscriptionDetailsOutput.fromJS(_data["localSubscription"], _mappings) : undefined as any;
            this.localBillingDetail = _data["localBillingDetail"] ? LocalBillingDetail.fromJS(_data["localBillingDetail"], _mappings) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.isOwner = _data["isOwner"];
        }
    }

    static fromJS(data: any, _mappings?: any): SubscriptionDetailResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SubscriptionDetailResponse>(data, _mappings, SubscriptionDetailResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscription"] = this.subscription ? this.subscription.toJSON() : undefined as any;
        data["localSubscription"] = this.localSubscription ? this.localSubscription.toJSON() : undefined as any;
        data["localBillingDetail"] = this.localBillingDetail ? this.localBillingDetail.toJSON() : undefined as any;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["isOwner"] = this.isOwner;
        return data;
    }
}

export interface ISubscriptionDetailResponse {
    subscription: SubscriptionResponse | undefined;
    localSubscription: SubscriptionDetailsOutput | undefined;
    localBillingDetail: LocalBillingDetail | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    isOwner: boolean | undefined;
}

export class SubscriptionDetailResponseIHandleError implements ISubscriptionDetailResponseIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SubscriptionDetailResponse | undefined;
    listOfEntities!: SubscriptionDetailResponse[] | undefined;

    constructor(data?: ISubscriptionDetailResponseIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SubscriptionDetailResponse.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SubscriptionDetailResponse.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SubscriptionDetailResponseIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SubscriptionDetailResponseIHandleError>(data, _mappings, SubscriptionDetailResponseIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISubscriptionDetailResponseIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SubscriptionDetailResponse | undefined;
    listOfEntities: SubscriptionDetailResponse[] | undefined;
}

export class SubscriptionDetailsOutputIHandleError implements ISubscriptionDetailsOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SubscriptionDetailsOutput | undefined;
    listOfEntities!: SubscriptionDetailsOutput[] | undefined;

    constructor(data?: ISubscriptionDetailsOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SubscriptionDetailsOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SubscriptionDetailsOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SubscriptionDetailsOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SubscriptionDetailsOutputIHandleError>(data, _mappings, SubscriptionDetailsOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISubscriptionDetailsOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SubscriptionDetailsOutput | undefined;
    listOfEntities: SubscriptionDetailsOutput[] | undefined;
}

export class CreateCustomerResponse implements ICreateCustomerResponse {
    customer!: any | undefined;

    constructor(data?: ICreateCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.customer = _data["customer"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateCustomerResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateCustomerResponse>(data, _mappings, CreateCustomerResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer;
        return data;
    }
}

export interface ICreateCustomerResponse {
    customer: any | undefined;
}

export class CreateCustomerResponseIHandleError implements ICreateCustomerResponseIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CreateCustomerResponse | undefined;
    listOfEntities!: CreateCustomerResponse[] | undefined;

    constructor(data?: ICreateCustomerResponseIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CreateCustomerResponse.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CreateCustomerResponse.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateCustomerResponseIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateCustomerResponseIHandleError>(data, _mappings, CreateCustomerResponseIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateCustomerResponseIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CreateCustomerResponse | undefined;
    listOfEntities: CreateCustomerResponse[] | undefined;
}

export class GetCustomerRequest implements IGetCustomerRequest {
    customerId!: string | undefined;

    constructor(data?: IGetCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetCustomerRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetCustomerRequest>(data, _mappings, GetCustomerRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IGetCustomerRequest {
    customerId: string | undefined;
}

export class CreateSubscriptionInputDto implements ICreateSubscriptionInputDto {
    type!: any | undefined;
    quantity!: number | undefined;
    coupon!: string | undefined;
    couponId!: number | undefined;

    constructor(data?: ICreateSubscriptionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.type = _data["type"];
            this.quantity = _data["quantity"];
            this.coupon = _data["coupon"];
            this.couponId = _data["couponId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateSubscriptionInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateSubscriptionInputDto>(data, _mappings, CreateSubscriptionInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["quantity"] = this.quantity;
        data["coupon"] = this.coupon;
        data["couponId"] = this.couponId;
        return data;
    }
}

export interface ICreateSubscriptionInputDto {
    type: any | undefined;
    quantity: number | undefined;
    coupon: string | undefined;
    couponId: number | undefined;
}

export class LocalBillingDetailInput implements ILocalBillingDetailInput {
    name!: string | undefined;
    cardNo!: string | undefined;
    year!: number | undefined;
    month!: number | undefined;
    cvv!: number | undefined;
    addressLine1!: string | undefined;
    addressLine2!: string | undefined;
    country!: string | undefined;
    state!: string | undefined;
    city!: string | undefined;
    postalCode!: string | undefined;
    noOfUsers!: number | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    isActive!: boolean | undefined;
    id!: number | undefined;
    discountAmount!: number | undefined;
    isDiscountApplied!: boolean | undefined;
    subscriptionId!: string | undefined;
    type!: any | undefined;
    couponId!: number | undefined;
    coupon!: string | undefined;
    freeSeats!: number | undefined;
    costPerUser!: number | undefined;
    customerId!: string | undefined;
    paymentMethodId!: string | undefined;

    constructor(data?: ILocalBillingDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cardNo = _data["cardNo"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.cvv = _data["cvv"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.noOfUsers = _data["noOfUsers"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
            this.discountAmount = _data["discountAmount"];
            this.isDiscountApplied = _data["isDiscountApplied"];
            this.subscriptionId = _data["subscriptionId"];
            this.type = _data["type"];
            this.couponId = _data["couponId"];
            this.coupon = _data["coupon"];
            this.freeSeats = _data["freeSeats"];
            this.costPerUser = _data["costPerUser"];
            this.customerId = _data["customerId"];
            this.paymentMethodId = _data["paymentMethodId"];
        }
    }

    static fromJS(data: any, _mappings?: any): LocalBillingDetailInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LocalBillingDetailInput>(data, _mappings, LocalBillingDetailInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cardNo"] = this.cardNo;
        data["year"] = this.year;
        data["month"] = this.month;
        data["cvv"] = this.cvv;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["country"] = this.country;
        data["state"] = this.state;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["noOfUsers"] = this.noOfUsers;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        data["discountAmount"] = this.discountAmount;
        data["isDiscountApplied"] = this.isDiscountApplied;
        data["subscriptionId"] = this.subscriptionId;
        data["type"] = this.type;
        data["couponId"] = this.couponId;
        data["coupon"] = this.coupon;
        data["freeSeats"] = this.freeSeats;
        data["costPerUser"] = this.costPerUser;
        data["customerId"] = this.customerId;
        data["paymentMethodId"] = this.paymentMethodId;
        return data;
    }
}

export interface ILocalBillingDetailInput {
    name: string | undefined;
    cardNo: string | undefined;
    year: number | undefined;
    month: number | undefined;
    cvv: number | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    country: string | undefined;
    state: string | undefined;
    city: string | undefined;
    postalCode: string | undefined;
    noOfUsers: number | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
    discountAmount: number | undefined;
    isDiscountApplied: boolean | undefined;
    subscriptionId: string | undefined;
    type: any | undefined;
    couponId: number | undefined;
    coupon: string | undefined;
    freeSeats: number | undefined;
    costPerUser: number | undefined;
    customerId: string | undefined;
    paymentMethodId: string | undefined;
}

export class CreateSubscriptionRequest implements ICreateSubscriptionRequest {
    paymentMethod!: string | undefined;
    customer!: string | undefined;
    price!: string | undefined;
    quantity!: number | undefined;
    localBillingDetail!: LocalBillingDetailInput | undefined;
    coupon!: string | undefined;
    discountAmount!: number | undefined;

    constructor(data?: ICreateSubscriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.paymentMethod = _data["paymentMethod"];
            this.customer = _data["customer"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.localBillingDetail = _data["localBillingDetail"] ? LocalBillingDetailInput.fromJS(_data["localBillingDetail"], _mappings) : undefined as any;
            this.coupon = _data["coupon"];
            this.discountAmount = _data["discountAmount"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateSubscriptionRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateSubscriptionRequest>(data, _mappings, CreateSubscriptionRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethod"] = this.paymentMethod;
        data["customer"] = this.customer;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["localBillingDetail"] = this.localBillingDetail ? this.localBillingDetail.toJSON() : undefined as any;
        data["coupon"] = this.coupon;
        data["discountAmount"] = this.discountAmount;
        return data;
    }
}

export interface ICreateSubscriptionRequest {
    paymentMethod: string | undefined;
    customer: string | undefined;
    price: string | undefined;
    quantity: number | undefined;
    localBillingDetail: LocalBillingDetailInput | undefined;
    coupon: string | undefined;
    discountAmount: number | undefined;
}

export class SubscriptionIHandleError implements ISubscriptionIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: any | undefined;
    listOfEntities!: any[] | undefined;

    constructor(data?: ISubscriptionIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"];
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SubscriptionIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SubscriptionIHandleError>(data, _mappings, SubscriptionIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ISubscriptionIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: any | undefined;
    listOfEntities: any[] | undefined;
}

export class RetryInvoiceRequest implements IRetryInvoiceRequest {
    customer!: string | undefined;
    paymentMethod!: string | undefined;
    invoice!: string | undefined;

    constructor(data?: IRetryInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.customer = _data["customer"];
            this.paymentMethod = _data["paymentMethod"];
            this.invoice = _data["invoice"];
        }
    }

    static fromJS(data: any, _mappings?: any): RetryInvoiceRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RetryInvoiceRequest>(data, _mappings, RetryInvoiceRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer;
        data["paymentMethod"] = this.paymentMethod;
        data["invoice"] = this.invoice;
        return data;
    }
}

export interface IRetryInvoiceRequest {
    customer: string | undefined;
    paymentMethod: string | undefined;
    invoice: string | undefined;
}

export class RetrieveSubscriptionInformationRequest implements IRetrieveSubscriptionInformationRequest {
    subscription!: string | undefined;

    constructor(data?: IRetrieveSubscriptionInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.subscription = _data["subscription"];
        }
    }

    static fromJS(data: any, _mappings?: any): RetrieveSubscriptionInformationRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RetrieveSubscriptionInformationRequest>(data, _mappings, RetrieveSubscriptionInformationRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscription"] = this.subscription;
        return data;
    }
}

export interface IRetrieveSubscriptionInformationRequest {
    subscription: string | undefined;
}

export class RetrieveSubscriptionInformationResponse implements IRetrieveSubscriptionInformationResponse {
    card!: any | undefined;
    productDescription!: string | undefined;
    currentPrice!: string | undefined;
    currentQuantity!: number | undefined;
    latestInvoice!: any | undefined;
    upcomingInvoice!: any | undefined;

    constructor(data?: IRetrieveSubscriptionInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.card = _data["card"];
            this.productDescription = _data["productDescription"];
            this.currentPrice = _data["currentPrice"];
            this.currentQuantity = _data["currentQuantity"];
            this.latestInvoice = _data["latestInvoice"];
            this.upcomingInvoice = _data["upcomingInvoice"];
        }
    }

    static fromJS(data: any, _mappings?: any): RetrieveSubscriptionInformationResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RetrieveSubscriptionInformationResponse>(data, _mappings, RetrieveSubscriptionInformationResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["card"] = this.card;
        data["productDescription"] = this.productDescription;
        data["currentPrice"] = this.currentPrice;
        data["currentQuantity"] = this.currentQuantity;
        data["latestInvoice"] = this.latestInvoice;
        data["upcomingInvoice"] = this.upcomingInvoice;
        return data;
    }
}

export interface IRetrieveSubscriptionInformationResponse {
    card: any | undefined;
    productDescription: string | undefined;
    currentPrice: string | undefined;
    currentQuantity: number | undefined;
    latestInvoice: any | undefined;
    upcomingInvoice: any | undefined;
}

export class RetrieveUpcomingInvoiceRequest implements IRetrieveUpcomingInvoiceRequest {
    customer!: string | undefined;
    subscription!: string | undefined;
    newPrice!: string | undefined;
    quantity!: number | undefined;

    constructor(data?: IRetrieveUpcomingInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.customer = _data["customer"];
            this.subscription = _data["subscription"];
            this.newPrice = _data["newPrice"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any, _mappings?: any): RetrieveUpcomingInvoiceRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RetrieveUpcomingInvoiceRequest>(data, _mappings, RetrieveUpcomingInvoiceRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer;
        data["subscription"] = this.subscription;
        data["newPrice"] = this.newPrice;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IRetrieveUpcomingInvoiceRequest {
    customer: string | undefined;
    subscription: string | undefined;
    newPrice: string | undefined;
    quantity: number | undefined;
}

export class RetrieveUpcomingInvoiceResponse implements IRetrieveUpcomingInvoiceResponse {
    immediateTotal!: number | undefined;
    nextInvoiceSum!: number | undefined;

    constructor(data?: IRetrieveUpcomingInvoiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.immediateTotal = _data["immediateTotal"];
            this.nextInvoiceSum = _data["nextInvoiceSum"];
        }
    }

    static fromJS(data: any, _mappings?: any): RetrieveUpcomingInvoiceResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RetrieveUpcomingInvoiceResponse>(data, _mappings, RetrieveUpcomingInvoiceResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["immediateTotal"] = this.immediateTotal;
        data["nextInvoiceSum"] = this.nextInvoiceSum;
        return data;
    }
}

export interface IRetrieveUpcomingInvoiceResponse {
    immediateTotal: number | undefined;
    nextInvoiceSum: number | undefined;
}

export class CancelSubscriptionRequest implements ICancelSubscriptionRequest {
    subscriptionId!: string | undefined;
    selectedReason!: string | undefined;
    optionalText!: string | undefined;
    mrrAtCancellation!: number | undefined;

    constructor(data?: ICancelSubscriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.selectedReason = _data["selectedReason"];
            this.optionalText = _data["optionalText"];
            this.mrrAtCancellation = _data["mrrAtCancellation"];
        }
    }

    static fromJS(data: any, _mappings?: any): CancelSubscriptionRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CancelSubscriptionRequest>(data, _mappings, CancelSubscriptionRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["selectedReason"] = this.selectedReason;
        data["optionalText"] = this.optionalText;
        data["mrrAtCancellation"] = this.mrrAtCancellation;
        return data;
    }
}

export interface ICancelSubscriptionRequest {
    subscriptionId: string | undefined;
    selectedReason: string | undefined;
    optionalText: string | undefined;
    mrrAtCancellation: number | undefined;
}

export class UpdateSubscriptionInputDto implements IUpdateSubscriptionInputDto {
    subscriptionId!: string | undefined;
    quantity!: number | undefined;

    constructor(data?: IUpdateSubscriptionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateSubscriptionInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateSubscriptionInputDto>(data, _mappings, UpdateSubscriptionInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IUpdateSubscriptionInputDto {
    subscriptionId: string | undefined;
    quantity: number | undefined;
}

export class UpComingInvoiceRequest implements IUpComingInvoiceRequest {
    subscription!: string | undefined;
    newPrice!: string | undefined;
    quantity!: number | undefined;
    customerId!: string | undefined;

    constructor(data?: IUpComingInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.subscription = _data["subscription"];
            this.newPrice = _data["newPrice"];
            this.quantity = _data["quantity"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpComingInvoiceRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpComingInvoiceRequest>(data, _mappings, UpComingInvoiceRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscription"] = this.subscription;
        data["newPrice"] = this.newPrice;
        data["quantity"] = this.quantity;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IUpComingInvoiceRequest {
    subscription: string | undefined;
    newPrice: string | undefined;
    quantity: number | undefined;
    customerId: string | undefined;
}

export class InvoiceIHandleError implements IInvoiceIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: any | undefined;
    listOfEntities!: any[] | undefined;

    constructor(data?: IInvoiceIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"];
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): InvoiceIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InvoiceIHandleError>(data, _mappings, InvoiceIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IInvoiceIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: any | undefined;
    listOfEntities: any[] | undefined;
}

export class StripeResponseIHandleError implements IStripeResponseIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: StripeResponse | undefined;
    listOfEntities!: StripeResponse[] | undefined;

    constructor(data?: IStripeResponseIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? StripeResponse.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(StripeResponse.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): StripeResponseIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StripeResponseIHandleError>(data, _mappings, StripeResponseIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStripeResponseIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: StripeResponse | undefined;
    listOfEntities: StripeResponse[] | undefined;
}

export class AttachCustomerPaymentMethodRequest implements IAttachCustomerPaymentMethodRequest {
    customer!: string | undefined;
    paymentMethod!: string | undefined;

    constructor(data?: IAttachCustomerPaymentMethodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.customer = _data["customer"];
            this.paymentMethod = _data["paymentMethod"];
        }
    }

    static fromJS(data: any, _mappings?: any): AttachCustomerPaymentMethodRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AttachCustomerPaymentMethodRequest>(data, _mappings, AttachCustomerPaymentMethodRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer;
        data["paymentMethod"] = this.paymentMethod;
        return data;
    }
}

export interface IAttachCustomerPaymentMethodRequest {
    customer: string | undefined;
    paymentMethod: string | undefined;
}

export class PaymentMethodIHandleError implements IPaymentMethodIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: any | undefined;
    listOfEntities!: any[] | undefined;

    constructor(data?: IPaymentMethodIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"];
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PaymentMethodIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PaymentMethodIHandleError>(data, _mappings, PaymentMethodIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IPaymentMethodIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: any | undefined;
    listOfEntities: any[] | undefined;
}

export class RetrieveCustomerPaymentMethodRequest implements IRetrieveCustomerPaymentMethodRequest {
    paymentMethod!: string | undefined;

    constructor(data?: IRetrieveCustomerPaymentMethodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.paymentMethod = _data["paymentMethod"];
        }
    }

    static fromJS(data: any, _mappings?: any): RetrieveCustomerPaymentMethodRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RetrieveCustomerPaymentMethodRequest>(data, _mappings, RetrieveCustomerPaymentMethodRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethod"] = this.paymentMethod;
        return data;
    }
}

export interface IRetrieveCustomerPaymentMethodRequest {
    paymentMethod: string | undefined;
}

export class PriceStripeListIHandleError implements IPriceStripeListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: any[] | undefined;
    listOfEntities!: any[][] | undefined;

    constructor(data?: IPriceStripeListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(item);
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PriceStripeListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PriceStripeListIHandleError>(data, _mappings, PriceStripeListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IPriceStripeListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: any[] | undefined;
    listOfEntities: any[][] | undefined;
}

export class ProductDetailListIHandleError implements IProductDetailListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: any[] | undefined;
    listOfEntities!: any[][] | undefined;

    constructor(data?: IProductDetailListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(item);
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProductDetailListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductDetailListIHandleError>(data, _mappings, ProductDetailListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProductDetailListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: any[] | undefined;
    listOfEntities: any[][] | undefined;
}

export class CouponDetailIHandleError implements ICouponDetailIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: any | undefined;
    listOfEntities!: any[] | undefined;

    constructor(data?: ICouponDetailIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"];
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CouponDetailIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CouponDetailIHandleError>(data, _mappings, CouponDetailIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ICouponDetailIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: any | undefined;
    listOfEntities: any[] | undefined;
}

export class StripeConfirmPaymentInput implements IStripeConfirmPaymentInput {
    paymentId!: number | undefined;
    stripeToken!: string | undefined;

    constructor(data?: IStripeConfirmPaymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.stripeToken = _data["stripeToken"];
        }
    }

    static fromJS(data: any, _mappings?: any): StripeConfirmPaymentInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StripeConfirmPaymentInput>(data, _mappings, StripeConfirmPaymentInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["stripeToken"] = this.stripeToken;
        return data;
    }
}

export interface IStripeConfirmPaymentInput {
    paymentId: number | undefined;
    stripeToken: string | undefined;
}

export class StripeCreateSubscriptionInput implements IStripeCreateSubscriptionInput {
    paymentId!: number | undefined;
    stripeToken!: string | undefined;

    constructor(data?: IStripeCreateSubscriptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.stripeToken = _data["stripeToken"];
        }
    }

    static fromJS(data: any, _mappings?: any): StripeCreateSubscriptionInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StripeCreateSubscriptionInput>(data, _mappings, StripeCreateSubscriptionInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["stripeToken"] = this.stripeToken;
        return data;
    }
}

export interface IStripeCreateSubscriptionInput {
    paymentId: number | undefined;
    stripeToken: string | undefined;
}

export class StripeUpdateSubscriptionInput implements IStripeUpdateSubscriptionInput {
    paymentId!: number | undefined;

    constructor(data?: IStripeUpdateSubscriptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
        }
    }

    static fromJS(data: any, _mappings?: any): StripeUpdateSubscriptionInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StripeUpdateSubscriptionInput>(data, _mappings, StripeUpdateSubscriptionInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        return data;
    }
}

export interface IStripeUpdateSubscriptionInput {
    paymentId: number | undefined;
}

export class StripeConfigurationDto implements IStripeConfigurationDto {
    publishableKey!: string | undefined;

    constructor(data?: IStripeConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.publishableKey = _data["publishableKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): StripeConfigurationDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StripeConfigurationDto>(data, _mappings, StripeConfigurationDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishableKey"] = this.publishableKey;
        return data;
    }
}

export interface IStripeConfigurationDto {
    publishableKey: string | undefined;
}

export class ChecklistTemplate implements IChecklistTemplate {
    id!: number | undefined;
    title!: string | undefined;
    description!: string | undefined;
    isAutoAdd!: boolean | undefined;
    order!: number | undefined;
    assigneeId!: number | undefined;
    roleId!: number | undefined;

    constructor(data?: IChecklistTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.isAutoAdd = _data["isAutoAdd"];
            this.order = _data["order"];
            this.assigneeId = _data["assigneeId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ChecklistTemplate | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChecklistTemplate>(data, _mappings, ChecklistTemplate);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["isAutoAdd"] = this.isAutoAdd;
        data["order"] = this.order;
        data["assigneeId"] = this.assigneeId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IChecklistTemplate {
    id: number | undefined;
    title: string | undefined;
    description: string | undefined;
    isAutoAdd: boolean | undefined;
    order: number | undefined;
    assigneeId: number | undefined;
    roleId: number | undefined;
}

export class TaskTemplateDependency implements ITaskTemplateDependency {
    blockerId!: number | undefined;
    blockerTempId!: number | undefined;
    startDelay!: number | undefined;
    sortOrder!: number | undefined;

    constructor(data?: ITaskTemplateDependency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.blockerId = _data["blockerId"];
            this.blockerTempId = _data["blockerTempId"];
            this.startDelay = _data["startDelay"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskTemplateDependency | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskTemplateDependency>(data, _mappings, TaskTemplateDependency);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blockerId"] = this.blockerId;
        data["blockerTempId"] = this.blockerTempId;
        data["startDelay"] = this.startDelay;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ITaskTemplateDependency {
    blockerId: number | undefined;
    blockerTempId: number | undefined;
    startDelay: number | undefined;
    sortOrder: number | undefined;
}

export class ProjectStageStatus implements IProjectStageStatus {
    projectId!: number | undefined;
    projectStageId!: number | undefined;
    status!: number | undefined;

    constructor(data?: IProjectStageStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectStageId = _data["projectStageId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectStageStatus | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectStageStatus>(data, _mappings, ProjectStageStatus);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectStageId"] = this.projectStageId;
        data["status"] = this.status;
        return data;
    }
}

export interface IProjectStageStatus {
    projectId: number | undefined;
    projectStageId: number | undefined;
    status: number | undefined;
}

export class TaskTemplateOutput implements ITaskTemplateOutput {
    id!: number | undefined;
    title!: string | undefined;
    parentTaskId!: number | undefined;
    parentStageId!: number | undefined;
    startDelay!: number | undefined;
    duration!: number | undefined;
    assignedTo!: number | undefined;
    roleId!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    description!: string | undefined;
    sectionTemplateId!: number | undefined;
    sectionTemplateName!: string | undefined;
    order!: number | undefined;
    tempId!: number | undefined;
    tempParentId!: number | undefined;
    checklistsAsJson!: string | undefined;
    readonly checklists!: ChecklistTemplate[] | undefined;
    dependenciesAsJson!: string | undefined;
    readonly dependencies!: TaskTemplateDependency[] | undefined;
    projectStageStatus!: string | undefined;
    projectStageStatusObject!: ProjectStageStatus | undefined;

    constructor(data?: ITaskTemplateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.parentTaskId = _data["parentTaskId"];
            this.parentStageId = _data["parentStageId"];
            this.startDelay = _data["startDelay"];
            this.duration = _data["duration"];
            this.assignedTo = _data["assignedTo"];
            this.roleId = _data["roleId"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.description = _data["description"];
            this.sectionTemplateId = _data["sectionTemplateId"];
            this.sectionTemplateName = _data["sectionTemplateName"];
            this.order = _data["order"];
            this.tempId = _data["tempId"];
            this.tempParentId = _data["tempParentId"];
            this.checklistsAsJson = _data["checklistsAsJson"];
            if (Array.isArray(_data["checklists"])) {
                (this as any).checklists = [] as any;
                for (let item of _data["checklists"])
                    (this as any).checklists!.push(ChecklistTemplate.fromJS(item, _mappings));
            }
            this.dependenciesAsJson = _data["dependenciesAsJson"];
            if (Array.isArray(_data["dependencies"])) {
                (this as any).dependencies = [] as any;
                for (let item of _data["dependencies"])
                    (this as any).dependencies!.push(TaskTemplateDependency.fromJS(item, _mappings));
            }
            this.projectStageStatus = _data["projectStageStatus"];
            this.projectStageStatusObject = _data["projectStageStatusObject"] ? ProjectStageStatus.fromJS(_data["projectStageStatusObject"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): TaskTemplateOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskTemplateOutput>(data, _mappings, TaskTemplateOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["parentTaskId"] = this.parentTaskId;
        data["parentStageId"] = this.parentStageId;
        data["startDelay"] = this.startDelay;
        data["duration"] = this.duration;
        data["assignedTo"] = this.assignedTo;
        data["roleId"] = this.roleId;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["description"] = this.description;
        data["sectionTemplateId"] = this.sectionTemplateId;
        data["sectionTemplateName"] = this.sectionTemplateName;
        data["order"] = this.order;
        data["tempId"] = this.tempId;
        data["tempParentId"] = this.tempParentId;
        data["checklistsAsJson"] = this.checklistsAsJson;
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item ? item.toJSON() : undefined as any);
        }
        data["dependenciesAsJson"] = this.dependenciesAsJson;
        if (Array.isArray(this.dependencies)) {
            data["dependencies"] = [];
            for (let item of this.dependencies)
                data["dependencies"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectStageStatus"] = this.projectStageStatus;
        data["projectStageStatusObject"] = this.projectStageStatusObject ? this.projectStageStatusObject.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaskTemplateOutput {
    id: number | undefined;
    title: string | undefined;
    parentTaskId: number | undefined;
    parentStageId: number | undefined;
    startDelay: number | undefined;
    duration: number | undefined;
    assignedTo: number | undefined;
    roleId: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    description: string | undefined;
    sectionTemplateId: number | undefined;
    sectionTemplateName: string | undefined;
    order: number | undefined;
    tempId: number | undefined;
    tempParentId: number | undefined;
    checklistsAsJson: string | undefined;
    checklists: ChecklistTemplate[] | undefined;
    dependenciesAsJson: string | undefined;
    dependencies: TaskTemplateDependency[] | undefined;
    projectStageStatus: string | undefined;
    projectStageStatusObject: ProjectStageStatus | undefined;
}

export class SetTaskTemplateDTO implements ISetTaskTemplateDTO {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    projectStageStatusId!: number | undefined;
    taskTemplates!: TaskTemplateOutput[] | undefined;

    constructor(data?: ISetTaskTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            this.projectStageStatusId = _data["projectStageStatusId"];
            if (Array.isArray(_data["taskTemplates"])) {
                this.taskTemplates = [] as any;
                for (let item of _data["taskTemplates"])
                    this.taskTemplates!.push(TaskTemplateOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SetTaskTemplateDTO | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetTaskTemplateDTO>(data, _mappings, SetTaskTemplateDTO);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        data["projectStageStatusId"] = this.projectStageStatusId;
        if (Array.isArray(this.taskTemplates)) {
            data["taskTemplates"] = [];
            for (let item of this.taskTemplates)
                data["taskTemplates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISetTaskTemplateDTO {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    projectStageStatusId: number | undefined;
    taskTemplates: TaskTemplateOutput[] | undefined;
}

export class GetTaskTemplateDTO implements IGetTaskTemplateDTO {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    taskTemplatesAsJson!: string | undefined;
    readonly taskTemplates!: TaskTemplateOutput[] | undefined;

    constructor(data?: IGetTaskTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            this.taskTemplatesAsJson = _data["taskTemplatesAsJson"];
            if (Array.isArray(_data["taskTemplates"])) {
                (this as any).taskTemplates = [] as any;
                for (let item of _data["taskTemplates"])
                    (this as any).taskTemplates!.push(TaskTemplateOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetTaskTemplateDTO | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetTaskTemplateDTO>(data, _mappings, GetTaskTemplateDTO);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        data["taskTemplatesAsJson"] = this.taskTemplatesAsJson;
        if (Array.isArray(this.taskTemplates)) {
            data["taskTemplates"] = [];
            for (let item of this.taskTemplates)
                data["taskTemplates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTaskTemplateDTO {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    taskTemplatesAsJson: string | undefined;
    taskTemplates: TaskTemplateOutput[] | undefined;
}

export class GetTaskTemplateDTOIHandleError implements IGetTaskTemplateDTOIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetTaskTemplateDTO | undefined;
    listOfEntities!: GetTaskTemplateDTO[] | undefined;

    constructor(data?: IGetTaskTemplateDTOIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetTaskTemplateDTO.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetTaskTemplateDTO.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetTaskTemplateDTOIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetTaskTemplateDTOIHandleError>(data, _mappings, GetTaskTemplateDTOIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTaskTemplateDTOIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetTaskTemplateDTO | undefined;
    listOfEntities: GetTaskTemplateDTO[] | undefined;
}

export class TaskTemplate implements ITaskTemplate {
    id!: number | undefined;
    title!: string | undefined;
    parentId!: number | undefined;
    parentTaskId!: number | undefined;
    parentStageId!: number | undefined;
    startDelay!: number | undefined;
    duration!: number | undefined;
    assignedTo!: number | undefined;
    roleId!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    description!: string | undefined;
    sectionTemplateId!: number | undefined;
    sectionTemplateName!: string | undefined;
    order!: number | undefined;
    tempId!: number | undefined;
    tempParentId!: number | undefined;
    projectStageId!: number | undefined;
    checklists!: ChecklistTemplate[] | undefined;
    dependencies!: TaskTemplateDependency[] | undefined;

    constructor(data?: ITaskTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.parentId = _data["parentId"];
            this.parentTaskId = _data["parentTaskId"];
            this.parentStageId = _data["parentStageId"];
            this.startDelay = _data["startDelay"];
            this.duration = _data["duration"];
            this.assignedTo = _data["assignedTo"];
            this.roleId = _data["roleId"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.description = _data["description"];
            this.sectionTemplateId = _data["sectionTemplateId"];
            this.sectionTemplateName = _data["sectionTemplateName"];
            this.order = _data["order"];
            this.tempId = _data["tempId"];
            this.tempParentId = _data["tempParentId"];
            this.projectStageId = _data["projectStageId"];
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(ChecklistTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["dependencies"])) {
                this.dependencies = [] as any;
                for (let item of _data["dependencies"])
                    this.dependencies!.push(TaskTemplateDependency.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskTemplate | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskTemplate>(data, _mappings, TaskTemplate);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["parentId"] = this.parentId;
        data["parentTaskId"] = this.parentTaskId;
        data["parentStageId"] = this.parentStageId;
        data["startDelay"] = this.startDelay;
        data["duration"] = this.duration;
        data["assignedTo"] = this.assignedTo;
        data["roleId"] = this.roleId;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["description"] = this.description;
        data["sectionTemplateId"] = this.sectionTemplateId;
        data["sectionTemplateName"] = this.sectionTemplateName;
        data["order"] = this.order;
        data["tempId"] = this.tempId;
        data["tempParentId"] = this.tempParentId;
        data["projectStageId"] = this.projectStageId;
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dependencies)) {
            data["dependencies"] = [];
            for (let item of this.dependencies)
                data["dependencies"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskTemplate {
    id: number | undefined;
    title: string | undefined;
    parentId: number | undefined;
    parentTaskId: number | undefined;
    parentStageId: number | undefined;
    startDelay: number | undefined;
    duration: number | undefined;
    assignedTo: number | undefined;
    roleId: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    description: string | undefined;
    sectionTemplateId: number | undefined;
    sectionTemplateName: string | undefined;
    order: number | undefined;
    tempId: number | undefined;
    tempParentId: number | undefined;
    projectStageId: number | undefined;
    checklists: ChecklistTemplate[] | undefined;
    dependencies: TaskTemplateDependency[] | undefined;
}

export class SectionTemplate implements ISectionTemplate {
    id!: number | undefined;
    name!: string | undefined;
    bgColor!: string | undefined;
    projectTemplateId!: number | undefined;
    order!: number | undefined;

    constructor(data?: ISectionTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.bgColor = _data["bgColor"];
            this.projectTemplateId = _data["projectTemplateId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any, _mappings?: any): SectionTemplate | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SectionTemplate>(data, _mappings, SectionTemplate);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["bgColor"] = this.bgColor;
        data["projectTemplateId"] = this.projectTemplateId;
        data["order"] = this.order;
        return data;
    }
}

export interface ISectionTemplate {
    id: number | undefined;
    name: string | undefined;
    bgColor: string | undefined;
    projectTemplateId: number | undefined;
    order: number | undefined;
}

export class FileLinkTemplate implements IFileLinkTemplate {
    id!: number | undefined;
    name!: string | undefined;
    url!: string | undefined;
    fileType!: string | undefined;
    action!: number | undefined;
    isLink!: boolean | undefined;
    isDefault!: boolean | undefined;
    msFileId!: string | undefined;
    msFolderId!: string | undefined;
    msDriveId!: string | undefined;
    msSiteId!: string | undefined;

    constructor(data?: IFileLinkTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.fileType = _data["fileType"];
            this.action = _data["action"];
            this.isLink = _data["isLink"];
            this.isDefault = _data["isDefault"];
            this.msFileId = _data["msFileId"];
            this.msFolderId = _data["msFolderId"];
            this.msDriveId = _data["msDriveId"];
            this.msSiteId = _data["msSiteId"];
        }
    }

    static fromJS(data: any, _mappings?: any): FileLinkTemplate | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FileLinkTemplate>(data, _mappings, FileLinkTemplate);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["fileType"] = this.fileType;
        data["action"] = this.action;
        data["isLink"] = this.isLink;
        data["isDefault"] = this.isDefault;
        data["msFileId"] = this.msFileId;
        data["msFolderId"] = this.msFolderId;
        data["msDriveId"] = this.msDriveId;
        data["msSiteId"] = this.msSiteId;
        return data;
    }
}

export interface IFileLinkTemplate {
    id: number | undefined;
    name: string | undefined;
    url: string | undefined;
    fileType: string | undefined;
    action: number | undefined;
    isLink: boolean | undefined;
    isDefault: boolean | undefined;
    msFileId: string | undefined;
    msFolderId: string | undefined;
    msDriveId: string | undefined;
    msSiteId: string | undefined;
}

export class ProjectTemplateInput implements IProjectTemplateInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    templateName!: string | undefined;
    createdFrom!: number | undefined;
    saveSections!: boolean | undefined;
    saveTags!: boolean | undefined;
    saveTeams!: boolean | undefined;
    saveContacts!: boolean | undefined;
    saveFileLinks!: boolean | undefined;
    saveChecklists!: boolean | undefined;
    saveTasks!: boolean | undefined;
    saveTaskDate!: boolean | undefined;
    saveTaskAssignee!: boolean | undefined;
    saveTaskDescription!: boolean | undefined;
    saveTaskChecklists!: boolean | undefined;
    saveTaskCheckLDesc!: boolean | undefined;
    saveTaskFileLinks!: boolean | undefined;
    tasks!: TaskTemplate[] | undefined;
    sections!: SectionTemplate[] | undefined;
    fileLinks!: FileLinkTemplate[] | undefined;
    checklists!: ChecklistTemplate[] | undefined;
    autoCreateParent!: FileLinkTemplate | undefined;

    constructor(data?: IProjectTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            this.templateName = _data["templateName"];
            this.createdFrom = _data["createdFrom"];
            this.saveSections = _data["saveSections"];
            this.saveTags = _data["saveTags"];
            this.saveTeams = _data["saveTeams"];
            this.saveContacts = _data["saveContacts"];
            this.saveFileLinks = _data["saveFileLinks"];
            this.saveChecklists = _data["saveChecklists"];
            this.saveTasks = _data["saveTasks"];
            this.saveTaskDate = _data["saveTaskDate"];
            this.saveTaskAssignee = _data["saveTaskAssignee"];
            this.saveTaskDescription = _data["saveTaskDescription"];
            this.saveTaskChecklists = _data["saveTaskChecklists"];
            this.saveTaskCheckLDesc = _data["saveTaskCheckLDesc"];
            this.saveTaskFileLinks = _data["saveTaskFileLinks"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SectionTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["fileLinks"])) {
                this.fileLinks = [] as any;
                for (let item of _data["fileLinks"])
                    this.fileLinks!.push(FileLinkTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(ChecklistTemplate.fromJS(item, _mappings));
            }
            this.autoCreateParent = _data["autoCreateParent"] ? FileLinkTemplate.fromJS(_data["autoCreateParent"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTemplateInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTemplateInput>(data, _mappings, ProjectTemplateInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        data["templateName"] = this.templateName;
        data["createdFrom"] = this.createdFrom;
        data["saveSections"] = this.saveSections;
        data["saveTags"] = this.saveTags;
        data["saveTeams"] = this.saveTeams;
        data["saveContacts"] = this.saveContacts;
        data["saveFileLinks"] = this.saveFileLinks;
        data["saveChecklists"] = this.saveChecklists;
        data["saveTasks"] = this.saveTasks;
        data["saveTaskDate"] = this.saveTaskDate;
        data["saveTaskAssignee"] = this.saveTaskAssignee;
        data["saveTaskDescription"] = this.saveTaskDescription;
        data["saveTaskChecklists"] = this.saveTaskChecklists;
        data["saveTaskCheckLDesc"] = this.saveTaskCheckLDesc;
        data["saveTaskFileLinks"] = this.saveTaskFileLinks;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.fileLinks)) {
            data["fileLinks"] = [];
            for (let item of this.fileLinks)
                data["fileLinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item ? item.toJSON() : undefined as any);
        }
        data["autoCreateParent"] = this.autoCreateParent ? this.autoCreateParent.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectTemplateInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    templateName: string | undefined;
    createdFrom: number | undefined;
    saveSections: boolean | undefined;
    saveTags: boolean | undefined;
    saveTeams: boolean | undefined;
    saveContacts: boolean | undefined;
    saveFileLinks: boolean | undefined;
    saveChecklists: boolean | undefined;
    saveTasks: boolean | undefined;
    saveTaskDate: boolean | undefined;
    saveTaskAssignee: boolean | undefined;
    saveTaskDescription: boolean | undefined;
    saveTaskChecklists: boolean | undefined;
    saveTaskCheckLDesc: boolean | undefined;
    saveTaskFileLinks: boolean | undefined;
    tasks: TaskTemplate[] | undefined;
    sections: SectionTemplate[] | undefined;
    fileLinks: FileLinkTemplate[] | undefined;
    checklists: ChecklistTemplate[] | undefined;
    autoCreateParent: FileLinkTemplate | undefined;
}

export class UpdateProjectTemplateInput implements IUpdateProjectTemplateInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    id!: number | undefined;
    templateName!: string | undefined;
    tasks!: TaskTemplate[] | undefined;
    sections!: SectionTemplate[] | undefined;
    fileLinks!: FileLinkTemplate[] | undefined;
    checklists!: ChecklistTemplate[] | undefined;

    constructor(data?: IUpdateProjectTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SectionTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["fileLinks"])) {
                this.fileLinks = [] as any;
                for (let item of _data["fileLinks"])
                    this.fileLinks!.push(FileLinkTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(ChecklistTemplate.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateProjectTemplateInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateProjectTemplateInput>(data, _mappings, UpdateProjectTemplateInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.fileLinks)) {
            data["fileLinks"] = [];
            for (let item of this.fileLinks)
                data["fileLinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateProjectTemplateInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    id: number | undefined;
    templateName: string | undefined;
    tasks: TaskTemplate[] | undefined;
    sections: SectionTemplate[] | undefined;
    fileLinks: FileLinkTemplate[] | undefined;
    checklists: ChecklistTemplate[] | undefined;
}

export class UpdateTaskTemplateInput implements IUpdateTaskTemplateInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    id!: number | undefined;
    title!: string | undefined;
    startDelay!: number | undefined;
    duration!: number | undefined;
    assignedTo!: number | undefined;
    roleId!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    description!: string | undefined;
    sectionTemplateId!: number | undefined;
    filesLinks!: FileLinkTemplate[] | undefined;
    checklists!: ChecklistTemplate[] | undefined;

    constructor(data?: IUpdateTaskTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.startDelay = _data["startDelay"];
            this.duration = _data["duration"];
            this.assignedTo = _data["assignedTo"];
            this.roleId = _data["roleId"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.description = _data["description"];
            this.sectionTemplateId = _data["sectionTemplateId"];
            if (Array.isArray(_data["filesLinks"])) {
                this.filesLinks = [] as any;
                for (let item of _data["filesLinks"])
                    this.filesLinks!.push(FileLinkTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(ChecklistTemplate.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateTaskTemplateInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateTaskTemplateInput>(data, _mappings, UpdateTaskTemplateInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["id"] = this.id;
        data["title"] = this.title;
        data["startDelay"] = this.startDelay;
        data["duration"] = this.duration;
        data["assignedTo"] = this.assignedTo;
        data["roleId"] = this.roleId;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["description"] = this.description;
        data["sectionTemplateId"] = this.sectionTemplateId;
        if (Array.isArray(this.filesLinks)) {
            data["filesLinks"] = [];
            for (let item of this.filesLinks)
                data["filesLinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateTaskTemplateInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    id: number | undefined;
    title: string | undefined;
    startDelay: number | undefined;
    duration: number | undefined;
    assignedTo: number | undefined;
    roleId: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    description: string | undefined;
    sectionTemplateId: number | undefined;
    filesLinks: FileLinkTemplate[] | undefined;
    checklists: ChecklistTemplate[] | undefined;
}

export class Int32TemplateListListValueTuple implements IInt32TemplateListListValueTuple {

    constructor(data?: IInt32TemplateListListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): Int32TemplateListListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32TemplateListListValueTuple>(data, _mappings, Int32TemplateListListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IInt32TemplateListListValueTuple {
}

export class Int32TemplateListListValueTupleIHandleError implements IInt32TemplateListListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: Int32TemplateListListValueTuple | undefined;
    listOfEntities!: Int32TemplateListListValueTuple[] | undefined;

    constructor(data?: IInt32TemplateListListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? Int32TemplateListListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(Int32TemplateListListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32TemplateListListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32TemplateListListValueTupleIHandleError>(data, _mappings, Int32TemplateListListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInt32TemplateListListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: Int32TemplateListListValueTuple | undefined;
    listOfEntities: Int32TemplateListListValueTuple[] | undefined;
}

export enum ProjectMemberType {
    _1 = 1,
    _2 = 2,
}

export class MemberTemplate implements IMemberTemplate {
    id!: number | undefined;
    userId!: number | undefined;
    memberName!: string | undefined;
    profilePictureUrl!: string | undefined;
    allowDelete!: boolean | undefined;
    cssClass!: string | undefined;
    memberType!: ProjectMemberType | undefined;
    roleId!: number | undefined;
    roleName!: string | undefined;
    isPrimary!: boolean | undefined;

    constructor(data?: IMemberTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.memberName = _data["memberName"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.allowDelete = _data["allowDelete"];
            this.cssClass = _data["cssClass"];
            this.memberType = _data["memberType"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any, _mappings?: any): MemberTemplate | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MemberTemplate>(data, _mappings, MemberTemplate);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["memberName"] = this.memberName;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["allowDelete"] = this.allowDelete;
        data["cssClass"] = this.cssClass;
        data["memberType"] = this.memberType;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["isPrimary"] = this.isPrimary;
        return data;
    }
}

export interface IMemberTemplate {
    id: number | undefined;
    userId: number | undefined;
    memberName: string | undefined;
    profilePictureUrl: string | undefined;
    allowDelete: boolean | undefined;
    cssClass: string | undefined;
    memberType: ProjectMemberType | undefined;
    roleId: number | undefined;
    roleName: string | undefined;
    isPrimary: boolean | undefined;
}

export enum TemplateAssociationType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class AssociationTemplate implements IAssociationTemplate {
    id!: number | undefined;
    associationId!: number | undefined;
    associationName!: string | undefined;
    associationType!: TemplateAssociationType | undefined;
    profilePictureUrl!: string | undefined;
    roleId!: number | undefined;
    roleName!: string | undefined;

    constructor(data?: IAssociationTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.associationId = _data["associationId"];
            this.associationName = _data["associationName"];
            this.associationType = _data["associationType"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any, _mappings?: any): AssociationTemplate | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AssociationTemplate>(data, _mappings, AssociationTemplate);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["associationId"] = this.associationId;
        data["associationName"] = this.associationName;
        data["associationType"] = this.associationType;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IAssociationTemplate {
    id: number | undefined;
    associationId: number | undefined;
    associationName: string | undefined;
    associationType: TemplateAssociationType | undefined;
    profilePictureUrl: string | undefined;
    roleId: number | undefined;
    roleName: string | undefined;
}

export class ProjectTemplateDetail implements IProjectTemplateDetail {
    templateId!: number | undefined;
    templateName!: string | undefined;
    lastUsed!: string | undefined;
    memberTemplate!: string | undefined;
    associationTemplate!: string | undefined;
    filesLinksTemplate!: string | undefined;
    checklistTemplate!: string | undefined;
    sectionTemplate!: string | undefined;
    taskTemplate!: string | undefined;
    members!: MemberTemplate[] | undefined;
    associations!: AssociationTemplate[] | undefined;
    filesLinks!: FileLinkTemplate[] | undefined;
    checklists!: ChecklistTemplate[] | undefined;
    tasks!: TaskTemplate[] | undefined;
    sections!: SectionTemplate[] | undefined;

    constructor(data?: IProjectTemplateDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.templateName = _data["templateName"];
            this.lastUsed = _data["lastUsed"];
            this.memberTemplate = _data["memberTemplate"];
            this.associationTemplate = _data["associationTemplate"];
            this.filesLinksTemplate = _data["filesLinksTemplate"];
            this.checklistTemplate = _data["checklistTemplate"];
            this.sectionTemplate = _data["sectionTemplate"];
            this.taskTemplate = _data["taskTemplate"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(MemberTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["associations"])) {
                this.associations = [] as any;
                for (let item of _data["associations"])
                    this.associations!.push(AssociationTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["filesLinks"])) {
                this.filesLinks = [] as any;
                for (let item of _data["filesLinks"])
                    this.filesLinks!.push(FileLinkTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(ChecklistTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SectionTemplate.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTemplateDetail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTemplateDetail>(data, _mappings, ProjectTemplateDetail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["templateName"] = this.templateName;
        data["lastUsed"] = this.lastUsed;
        data["memberTemplate"] = this.memberTemplate;
        data["associationTemplate"] = this.associationTemplate;
        data["filesLinksTemplate"] = this.filesLinksTemplate;
        data["checklistTemplate"] = this.checklistTemplate;
        data["sectionTemplate"] = this.sectionTemplate;
        data["taskTemplate"] = this.taskTemplate;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.associations)) {
            data["associations"] = [];
            for (let item of this.associations)
                data["associations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.filesLinks)) {
            data["filesLinks"] = [];
            for (let item of this.filesLinks)
                data["filesLinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTemplateDetail {
    templateId: number | undefined;
    templateName: string | undefined;
    lastUsed: string | undefined;
    memberTemplate: string | undefined;
    associationTemplate: string | undefined;
    filesLinksTemplate: string | undefined;
    checklistTemplate: string | undefined;
    sectionTemplate: string | undefined;
    taskTemplate: string | undefined;
    members: MemberTemplate[] | undefined;
    associations: AssociationTemplate[] | undefined;
    filesLinks: FileLinkTemplate[] | undefined;
    checklists: ChecklistTemplate[] | undefined;
    tasks: TaskTemplate[] | undefined;
    sections: SectionTemplate[] | undefined;
}

export class ProjectTemplateDetailIHandleError implements IProjectTemplateDetailIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectTemplateDetail | undefined;
    listOfEntities!: ProjectTemplateDetail[] | undefined;

    constructor(data?: IProjectTemplateDetailIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProjectTemplateDetail.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProjectTemplateDetail.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTemplateDetailIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTemplateDetailIHandleError>(data, _mappings, ProjectTemplateDetailIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTemplateDetailIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectTemplateDetail | undefined;
    listOfEntities: ProjectTemplateDetail[] | undefined;
}

export class TaskTemplateDetail implements ITaskTemplateDetail {
    id!: number | undefined;
    title!: string | undefined;
    parentId!: number | undefined;
    parentTaskId!: number | undefined;
    parentStageId!: number | undefined;
    startDelay!: number | undefined;
    duration!: number | undefined;
    assignedTo!: number | undefined;
    roleId!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    description!: string | undefined;
    sectionTemplateId!: number | undefined;
    filesLinksTemplates!: string | undefined;
    checklistTemplate!: string | undefined;
    filesLinks!: FileLinkTemplate[] | undefined;
    checklists!: ChecklistTemplate[] | undefined;

    constructor(data?: ITaskTemplateDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.parentId = _data["parentId"];
            this.parentTaskId = _data["parentTaskId"];
            this.parentStageId = _data["parentStageId"];
            this.startDelay = _data["startDelay"];
            this.duration = _data["duration"];
            this.assignedTo = _data["assignedTo"];
            this.roleId = _data["roleId"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.description = _data["description"];
            this.sectionTemplateId = _data["sectionTemplateId"];
            this.filesLinksTemplates = _data["filesLinksTemplates"];
            this.checklistTemplate = _data["checklistTemplate"];
            if (Array.isArray(_data["filesLinks"])) {
                this.filesLinks = [] as any;
                for (let item of _data["filesLinks"])
                    this.filesLinks!.push(FileLinkTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(ChecklistTemplate.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskTemplateDetail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskTemplateDetail>(data, _mappings, TaskTemplateDetail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["parentId"] = this.parentId;
        data["parentTaskId"] = this.parentTaskId;
        data["parentStageId"] = this.parentStageId;
        data["startDelay"] = this.startDelay;
        data["duration"] = this.duration;
        data["assignedTo"] = this.assignedTo;
        data["roleId"] = this.roleId;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["description"] = this.description;
        data["sectionTemplateId"] = this.sectionTemplateId;
        data["filesLinksTemplates"] = this.filesLinksTemplates;
        data["checklistTemplate"] = this.checklistTemplate;
        if (Array.isArray(this.filesLinks)) {
            data["filesLinks"] = [];
            for (let item of this.filesLinks)
                data["filesLinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskTemplateDetail {
    id: number | undefined;
    title: string | undefined;
    parentId: number | undefined;
    parentTaskId: number | undefined;
    parentStageId: number | undefined;
    startDelay: number | undefined;
    duration: number | undefined;
    assignedTo: number | undefined;
    roleId: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    description: string | undefined;
    sectionTemplateId: number | undefined;
    filesLinksTemplates: string | undefined;
    checklistTemplate: string | undefined;
    filesLinks: FileLinkTemplate[] | undefined;
    checklists: ChecklistTemplate[] | undefined;
}

export class TaskTemplateDetailIHandleError implements ITaskTemplateDetailIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskTemplateDetail | undefined;
    listOfEntities!: TaskTemplateDetail[] | undefined;

    constructor(data?: ITaskTemplateDetailIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TaskTemplateDetail.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TaskTemplateDetail.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskTemplateDetailIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskTemplateDetailIHandleError>(data, _mappings, TaskTemplateDetailIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskTemplateDetailIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskTemplateDetail | undefined;
    listOfEntities: TaskTemplateDetail[] | undefined;
}

export class ProjectFromTemplateInput implements IProjectFromTemplateInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    templateId!: number | undefined;
    projectStageId!: number | undefined;
    projectName!: string | undefined;
    description!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isPrivate!: boolean | undefined;
    members!: MemberTemplate[] | undefined;
    associations!: AssociationTemplate[] | undefined;
    checklists!: ChecklistTemplate[] | undefined;
    leadCycleId!: number | undefined;
    caseValueFieldOnForm!: boolean | undefined;

    constructor(data?: IProjectFromTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.templateId = _data["templateId"];
            this.projectStageId = _data["projectStageId"];
            this.projectName = _data["projectName"];
            this.description = _data["description"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isPrivate = _data["isPrivate"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(MemberTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["associations"])) {
                this.associations = [] as any;
                for (let item of _data["associations"])
                    this.associations!.push(AssociationTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(ChecklistTemplate.fromJS(item, _mappings));
            }
            this.leadCycleId = _data["leadCycleId"];
            this.caseValueFieldOnForm = _data["caseValueFieldOnForm"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectFromTemplateInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectFromTemplateInput>(data, _mappings, ProjectFromTemplateInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["templateId"] = this.templateId;
        data["projectStageId"] = this.projectStageId;
        data["projectName"] = this.projectName;
        data["description"] = this.description;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isPrivate"] = this.isPrivate;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.associations)) {
            data["associations"] = [];
            for (let item of this.associations)
                data["associations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item ? item.toJSON() : undefined as any);
        }
        data["leadCycleId"] = this.leadCycleId;
        data["caseValueFieldOnForm"] = this.caseValueFieldOnForm;
        return data;
    }
}

export interface IProjectFromTemplateInput {
    userId: number | undefined;
    tenantId: number | undefined;
    templateId: number | undefined;
    projectStageId: number | undefined;
    projectName: string | undefined;
    description: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isPrivate: boolean | undefined;
    members: MemberTemplate[] | undefined;
    associations: AssociationTemplate[] | undefined;
    checklists: ChecklistTemplate[] | undefined;
    leadCycleId: number | undefined;
    caseValueFieldOnForm: boolean | undefined;
}

export class ProjectMembers implements IProjectMembers {
    id!: number | undefined;
    userId!: number | undefined;
    memberName!: string | undefined;
    profilePictureUrl!: string | undefined;
    allowDelete!: boolean | undefined;
    isDeleted!: boolean | undefined;
    isChecked!: boolean | undefined;
    cssClass!: string | undefined;
    memberType!: ProjectMemberType | undefined;
    roleId!: number | undefined;
    roleName!: string | undefined;
    isPrimary!: boolean | undefined;

    constructor(data?: IProjectMembers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.memberName = _data["memberName"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.allowDelete = _data["allowDelete"];
            this.isDeleted = _data["isDeleted"];
            this.isChecked = _data["isChecked"];
            this.cssClass = _data["cssClass"];
            this.memberType = _data["memberType"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectMembers | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectMembers>(data, _mappings, ProjectMembers);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["memberName"] = this.memberName;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["allowDelete"] = this.allowDelete;
        data["isDeleted"] = this.isDeleted;
        data["isChecked"] = this.isChecked;
        data["cssClass"] = this.cssClass;
        data["memberType"] = this.memberType;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["isPrimary"] = this.isPrimary;
        return data;
    }
}

export interface IProjectMembers {
    id: number | undefined;
    userId: number | undefined;
    memberName: string | undefined;
    profilePictureUrl: string | undefined;
    allowDelete: boolean | undefined;
    isDeleted: boolean | undefined;
    isChecked: boolean | undefined;
    cssClass: string | undefined;
    memberType: ProjectMemberType | undefined;
    roleId: number | undefined;
    roleName: string | undefined;
    isPrimary: boolean | undefined;
}

export class GetUserTasks implements IGetUserTasks {
    id!: number | undefined;
    ownerId!: number | undefined;
    agendaType!: AgendaType | undefined;
    title!: string | undefined;
    isHide!: boolean | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isDueDatePassed!: boolean | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    code!: number | undefined;
    name!: string | undefined;
    sortOrder!: number | undefined;
    isSeen!: boolean | undefined;
    isNewlyAssigned!: boolean | undefined;
    assignedByUserId!: number | undefined;
    assignedByUser!: string | undefined;
    assignedToUserId!: number | undefined;
    assignedToUser!: string | undefined;
    assignedToUserProfilePictureUrl!: string | undefined;
    assignedTime!: string | undefined;
    completedOn!: string | undefined;
    isAddedOnMyDay!: boolean | undefined;
    endDate!: string | undefined;
    eventCreatedByUserId!: number | undefined;
    eventCreatedByUser!: string | undefined;
    integrationId!: string | undefined;
    integratedFrom!: string | undefined;
    integrationIcon!: string | undefined;
    integrationCode!: number | undefined;
    projectName!: string | undefined;
    isPrivateProject!: boolean | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    tag1!: string | undefined;
    tag2!: string | undefined;
    tag3!: string | undefined;
    color!: string | undefined;
    keyId!: string | undefined;
    webUrl!: string | undefined;
    assignes!: string | undefined;
    projectId!: number | undefined;
    taskProjectName!: string | undefined;
    projectSectionId!: number | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    pinnedEntityId!: number | undefined;
    resourceName!: string | undefined;
    resourceIconUrl!: string | undefined;
    resourceGreyIconUrl!: string | undefined;
    resourceAppIntegrationId!: number | undefined;
    resourceAppUrl!: string | undefined;
    isCustom!: boolean | undefined;
    hasUnreadComments!: boolean | undefined;
    isPrivate!: boolean | undefined;
    isAssignedToProject!: boolean | undefined;
    priority!: TaskPriority | undefined;
    tags!: string | undefined;
    readonly projectTags!: ProjectTag[] | undefined;
    statusCode!: number | undefined;
    entityType!: TaskEntityType | undefined;
    taskType!: TaskTypes | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactCompanyId!: number | undefined;
    contactCompanyName!: string | undefined;
    contactTypeColor!: string | undefined;
    taskAssociationsAsJson!: string | undefined;
    readonly taskAssociations!: TaskAssociation[] | undefined;
    parentId!: number | undefined;
    isPartOfTaskTree!: boolean | undefined;

    constructor(data?: IGetUserTasks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerId = _data["ownerId"];
            this.agendaType = _data["agendaType"];
            this.title = _data["title"];
            this.isHide = _data["isHide"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isSeen = _data["isSeen"];
            this.isNewlyAssigned = _data["isNewlyAssigned"];
            this.assignedByUserId = _data["assignedByUserId"];
            this.assignedByUser = _data["assignedByUser"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"];
            this.assignedToUserProfilePictureUrl = _data["assignedToUserProfilePictureUrl"];
            this.assignedTime = _data["assignedTime"];
            this.completedOn = _data["completedOn"];
            this.isAddedOnMyDay = _data["isAddedOnMyDay"];
            this.endDate = _data["endDate"];
            this.eventCreatedByUserId = _data["eventCreatedByUserId"];
            this.eventCreatedByUser = _data["eventCreatedByUser"];
            this.integrationId = _data["integrationId"];
            this.integratedFrom = _data["integratedFrom"];
            this.integrationIcon = _data["integrationIcon"];
            this.integrationCode = _data["integrationCode"];
            this.projectName = _data["projectName"];
            this.isPrivateProject = _data["isPrivateProject"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.tag1 = _data["tag1"];
            this.tag2 = _data["tag2"];
            this.tag3 = _data["tag3"];
            this.color = _data["color"];
            this.keyId = _data["keyId"];
            this.webUrl = _data["webUrl"];
            this.assignes = _data["assignes"];
            this.projectId = _data["projectId"];
            this.taskProjectName = _data["taskProjectName"];
            this.projectSectionId = _data["projectSectionId"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.resourceName = _data["resourceName"];
            this.resourceIconUrl = _data["resourceIconUrl"];
            this.resourceGreyIconUrl = _data["resourceGreyIconUrl"];
            this.resourceAppIntegrationId = _data["resourceAppIntegrationId"];
            this.resourceAppUrl = _data["resourceAppUrl"];
            this.isCustom = _data["isCustom"];
            this.hasUnreadComments = _data["hasUnreadComments"];
            this.isPrivate = _data["isPrivate"];
            this.isAssignedToProject = _data["isAssignedToProject"];
            this.priority = _data["priority"];
            this.tags = _data["tags"];
            if (Array.isArray(_data["projectTags"])) {
                (this as any).projectTags = [] as any;
                for (let item of _data["projectTags"])
                    (this as any).projectTags!.push(ProjectTag.fromJS(item, _mappings));
            }
            this.statusCode = _data["statusCode"];
            this.entityType = _data["entityType"];
            this.taskType = _data["taskType"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactCompanyId = _data["contactCompanyId"];
            this.contactCompanyName = _data["contactCompanyName"];
            this.contactTypeColor = _data["contactTypeColor"];
            this.taskAssociationsAsJson = _data["taskAssociationsAsJson"];
            if (Array.isArray(_data["taskAssociations"])) {
                (this as any).taskAssociations = [] as any;
                for (let item of _data["taskAssociations"])
                    (this as any).taskAssociations!.push(TaskAssociation.fromJS(item, _mappings));
            }
            this.parentId = _data["parentId"];
            this.isPartOfTaskTree = _data["isPartOfTaskTree"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserTasks | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserTasks>(data, _mappings, GetUserTasks);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerId"] = this.ownerId;
        data["agendaType"] = this.agendaType;
        data["title"] = this.title;
        data["isHide"] = this.isHide;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isSeen"] = this.isSeen;
        data["isNewlyAssigned"] = this.isNewlyAssigned;
        data["assignedByUserId"] = this.assignedByUserId;
        data["assignedByUser"] = this.assignedByUser;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser;
        data["assignedToUserProfilePictureUrl"] = this.assignedToUserProfilePictureUrl;
        data["assignedTime"] = this.assignedTime;
        data["completedOn"] = this.completedOn;
        data["isAddedOnMyDay"] = this.isAddedOnMyDay;
        data["endDate"] = this.endDate;
        data["eventCreatedByUserId"] = this.eventCreatedByUserId;
        data["eventCreatedByUser"] = this.eventCreatedByUser;
        data["integrationId"] = this.integrationId;
        data["integratedFrom"] = this.integratedFrom;
        data["integrationIcon"] = this.integrationIcon;
        data["integrationCode"] = this.integrationCode;
        data["projectName"] = this.projectName;
        data["isPrivateProject"] = this.isPrivateProject;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["tag1"] = this.tag1;
        data["tag2"] = this.tag2;
        data["tag3"] = this.tag3;
        data["color"] = this.color;
        data["keyId"] = this.keyId;
        data["webUrl"] = this.webUrl;
        data["assignes"] = this.assignes;
        data["projectId"] = this.projectId;
        data["taskProjectName"] = this.taskProjectName;
        data["projectSectionId"] = this.projectSectionId;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["resourceName"] = this.resourceName;
        data["resourceIconUrl"] = this.resourceIconUrl;
        data["resourceGreyIconUrl"] = this.resourceGreyIconUrl;
        data["resourceAppIntegrationId"] = this.resourceAppIntegrationId;
        data["resourceAppUrl"] = this.resourceAppUrl;
        data["isCustom"] = this.isCustom;
        data["hasUnreadComments"] = this.hasUnreadComments;
        data["isPrivate"] = this.isPrivate;
        data["isAssignedToProject"] = this.isAssignedToProject;
        data["priority"] = this.priority;
        data["tags"] = this.tags;
        if (Array.isArray(this.projectTags)) {
            data["projectTags"] = [];
            for (let item of this.projectTags)
                data["projectTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["statusCode"] = this.statusCode;
        data["entityType"] = this.entityType;
        data["taskType"] = this.taskType;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactCompanyId"] = this.contactCompanyId;
        data["contactCompanyName"] = this.contactCompanyName;
        data["contactTypeColor"] = this.contactTypeColor;
        data["taskAssociationsAsJson"] = this.taskAssociationsAsJson;
        if (Array.isArray(this.taskAssociations)) {
            data["taskAssociations"] = [];
            for (let item of this.taskAssociations)
                data["taskAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentId"] = this.parentId;
        data["isPartOfTaskTree"] = this.isPartOfTaskTree;
        return data;
    }
}

export interface IGetUserTasks {
    id: number | undefined;
    ownerId: number | undefined;
    agendaType: AgendaType | undefined;
    title: string | undefined;
    isHide: boolean | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isDueDatePassed: boolean | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    code: number | undefined;
    name: string | undefined;
    sortOrder: number | undefined;
    isSeen: boolean | undefined;
    isNewlyAssigned: boolean | undefined;
    assignedByUserId: number | undefined;
    assignedByUser: string | undefined;
    assignedToUserId: number | undefined;
    assignedToUser: string | undefined;
    assignedToUserProfilePictureUrl: string | undefined;
    assignedTime: string | undefined;
    completedOn: string | undefined;
    isAddedOnMyDay: boolean | undefined;
    endDate: string | undefined;
    eventCreatedByUserId: number | undefined;
    eventCreatedByUser: string | undefined;
    integrationId: string | undefined;
    integratedFrom: string | undefined;
    integrationIcon: string | undefined;
    integrationCode: number | undefined;
    projectName: string | undefined;
    isPrivateProject: boolean | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    tag1: string | undefined;
    tag2: string | undefined;
    tag3: string | undefined;
    color: string | undefined;
    keyId: string | undefined;
    webUrl: string | undefined;
    assignes: string | undefined;
    projectId: number | undefined;
    taskProjectName: string | undefined;
    projectSectionId: number | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    pinnedEntityId: number | undefined;
    resourceName: string | undefined;
    resourceIconUrl: string | undefined;
    resourceGreyIconUrl: string | undefined;
    resourceAppIntegrationId: number | undefined;
    resourceAppUrl: string | undefined;
    isCustom: boolean | undefined;
    hasUnreadComments: boolean | undefined;
    isPrivate: boolean | undefined;
    isAssignedToProject: boolean | undefined;
    priority: TaskPriority | undefined;
    tags: string | undefined;
    projectTags: ProjectTag[] | undefined;
    statusCode: number | undefined;
    entityType: TaskEntityType | undefined;
    taskType: TaskTypes | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactCompanyId: number | undefined;
    contactCompanyName: string | undefined;
    contactTypeColor: string | undefined;
    taskAssociationsAsJson: string | undefined;
    taskAssociations: TaskAssociation[] | undefined;
    parentId: number | undefined;
    isPartOfTaskTree: boolean | undefined;
}

export class ProjectSectionDto implements IProjectSectionDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    dueDate!: string | undefined;
    startDate!: string | undefined;
    projectProgress!: number | undefined;
    code!: number | undefined;
    pinnedEntityId!: number | undefined;
    isPrivate!: boolean | undefined;
    isSuggestAiTasks!: boolean | undefined;
    companyId!: number | undefined;
    companyName!: string | undefined;
    associationId!: number | undefined;
    associationName!: string | undefined;
    healthScore!: number | undefined;
    scoreExplanation!: string | undefined;
    scoreLastUpdated!: string | undefined;
    statusId!: number | undefined;
    projectStageId!: number | undefined;
    projectSectionText!: string | undefined;
    readonly projectSections!: any[] | undefined;
    projectMembersAsJson!: string | undefined;
    readonly projectMembers!: ProjectMembers[] | undefined;
    description!: string | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    bgColor!: string | undefined;
    tasksInJson!: string | undefined;
    agendaType!: number | undefined;
    sortOrder!: number | undefined;
    isHide!: boolean | undefined;
    isEditing!: boolean | undefined;
    isExpanded!: boolean | undefined;
    readonly totalCompetedTasks!: number | undefined;
    readonly totalInCompetedTasks!: number | undefined;
    readonly tasks!: GetUserTasks[] | undefined;
    requireProjectDetails!: boolean | undefined;

    constructor(data?: IProjectSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.dueDate = _data["dueDate"];
            this.startDate = _data["startDate"];
            this.projectProgress = _data["projectProgress"];
            this.code = _data["code"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.isPrivate = _data["isPrivate"];
            this.isSuggestAiTasks = _data["isSuggestAiTasks"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.associationId = _data["associationId"];
            this.associationName = _data["associationName"];
            this.healthScore = _data["healthScore"];
            this.scoreExplanation = _data["scoreExplanation"];
            this.scoreLastUpdated = _data["scoreLastUpdated"];
            this.statusId = _data["statusId"];
            this.projectStageId = _data["projectStageId"];
            this.projectSectionText = _data["projectSectionText"];
            if (Array.isArray(_data["projectSections"])) {
                (this as any).projectSections = [] as any;
                for (let item of _data["projectSections"])
                    (this as any).projectSections!.push(item);
            }
            this.projectMembersAsJson = _data["projectMembersAsJson"];
            if (Array.isArray(_data["projectMembers"])) {
                (this as any).projectMembers = [] as any;
                for (let item of _data["projectMembers"])
                    (this as any).projectMembers!.push(ProjectMembers.fromJS(item, _mappings));
            }
            this.description = _data["description"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.bgColor = _data["bgColor"];
            this.tasksInJson = _data["tasksInJson"];
            this.agendaType = _data["agendaType"];
            this.sortOrder = _data["sortOrder"];
            this.isHide = _data["isHide"];
            this.isEditing = _data["isEditing"];
            this.isExpanded = _data["isExpanded"];
            (this as any).totalCompetedTasks = _data["totalCompetedTasks"];
            (this as any).totalInCompetedTasks = _data["totalInCompetedTasks"];
            if (Array.isArray(_data["tasks"])) {
                (this as any).tasks = [] as any;
                for (let item of _data["tasks"])
                    (this as any).tasks!.push(GetUserTasks.fromJS(item, _mappings));
            }
            this.requireProjectDetails = _data["requireProjectDetails"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectSectionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectSectionDto>(data, _mappings, ProjectSectionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["dueDate"] = this.dueDate;
        data["startDate"] = this.startDate;
        data["projectProgress"] = this.projectProgress;
        data["code"] = this.code;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["isPrivate"] = this.isPrivate;
        data["isSuggestAiTasks"] = this.isSuggestAiTasks;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["associationId"] = this.associationId;
        data["associationName"] = this.associationName;
        data["healthScore"] = this.healthScore;
        data["scoreExplanation"] = this.scoreExplanation;
        data["scoreLastUpdated"] = this.scoreLastUpdated;
        data["statusId"] = this.statusId;
        data["projectStageId"] = this.projectStageId;
        data["projectSectionText"] = this.projectSectionText;
        if (Array.isArray(this.projectSections)) {
            data["projectSections"] = [];
            for (let item of this.projectSections)
                data["projectSections"].push(item);
        }
        data["projectMembersAsJson"] = this.projectMembersAsJson;
        if (Array.isArray(this.projectMembers)) {
            data["projectMembers"] = [];
            for (let item of this.projectMembers)
                data["projectMembers"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["bgColor"] = this.bgColor;
        data["tasksInJson"] = this.tasksInJson;
        data["agendaType"] = this.agendaType;
        data["sortOrder"] = this.sortOrder;
        data["isHide"] = this.isHide;
        data["isEditing"] = this.isEditing;
        data["isExpanded"] = this.isExpanded;
        data["totalCompetedTasks"] = this.totalCompetedTasks;
        data["totalInCompetedTasks"] = this.totalInCompetedTasks;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        data["requireProjectDetails"] = this.requireProjectDetails;
        return data;
    }
}

export interface IProjectSectionDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    dueDate: string | undefined;
    startDate: string | undefined;
    projectProgress: number | undefined;
    code: number | undefined;
    pinnedEntityId: number | undefined;
    isPrivate: boolean | undefined;
    isSuggestAiTasks: boolean | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    associationId: number | undefined;
    associationName: string | undefined;
    healthScore: number | undefined;
    scoreExplanation: string | undefined;
    scoreLastUpdated: string | undefined;
    statusId: number | undefined;
    projectStageId: number | undefined;
    projectSectionText: string | undefined;
    projectSections: any[] | undefined;
    projectMembersAsJson: string | undefined;
    projectMembers: ProjectMembers[] | undefined;
    description: string | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    bgColor: string | undefined;
    tasksInJson: string | undefined;
    agendaType: number | undefined;
    sortOrder: number | undefined;
    isHide: boolean | undefined;
    isEditing: boolean | undefined;
    isExpanded: boolean | undefined;
    totalCompetedTasks: number | undefined;
    totalInCompetedTasks: number | undefined;
    tasks: GetUserTasks[] | undefined;
    requireProjectDetails: boolean | undefined;
}

export class ProjectDto implements IProjectDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    dueDate!: string | undefined;
    startDate!: string | undefined;
    projectProgress!: number | undefined;
    code!: number | undefined;
    pinnedEntityId!: number | undefined;
    isPrivate!: boolean | undefined;
    isSuggestAiTasks!: boolean | undefined;
    companyId!: number | undefined;
    companyName!: string | undefined;
    associationId!: number | undefined;
    associationName!: string | undefined;
    healthScore!: number | undefined;
    scoreExplanation!: string | undefined;
    scoreLastUpdated!: string | undefined;
    statusId!: number | undefined;
    projectStageId!: number | undefined;
    projectSectionText!: string | undefined;
    readonly projectSections!: ProjectSectionDto[] | undefined;
    projectMembersAsJson!: string | undefined;
    readonly projectMembers!: ProjectMembers[] | undefined;
    description!: string | undefined;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.dueDate = _data["dueDate"];
            this.startDate = _data["startDate"];
            this.projectProgress = _data["projectProgress"];
            this.code = _data["code"];
            this.pinnedEntityId = _data["pinnedEntityId"];
            this.isPrivate = _data["isPrivate"];
            this.isSuggestAiTasks = _data["isSuggestAiTasks"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.associationId = _data["associationId"];
            this.associationName = _data["associationName"];
            this.healthScore = _data["healthScore"];
            this.scoreExplanation = _data["scoreExplanation"];
            this.scoreLastUpdated = _data["scoreLastUpdated"];
            this.statusId = _data["statusId"];
            this.projectStageId = _data["projectStageId"];
            this.projectSectionText = _data["projectSectionText"];
            if (Array.isArray(_data["projectSections"])) {
                (this as any).projectSections = [] as any;
                for (let item of _data["projectSections"])
                    (this as any).projectSections!.push(ProjectSectionDto.fromJS(item, _mappings));
            }
            this.projectMembersAsJson = _data["projectMembersAsJson"];
            if (Array.isArray(_data["projectMembers"])) {
                (this as any).projectMembers = [] as any;
                for (let item of _data["projectMembers"])
                    (this as any).projectMembers!.push(ProjectMembers.fromJS(item, _mappings));
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectDto>(data, _mappings, ProjectDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["dueDate"] = this.dueDate;
        data["startDate"] = this.startDate;
        data["projectProgress"] = this.projectProgress;
        data["code"] = this.code;
        data["pinnedEntityId"] = this.pinnedEntityId;
        data["isPrivate"] = this.isPrivate;
        data["isSuggestAiTasks"] = this.isSuggestAiTasks;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["associationId"] = this.associationId;
        data["associationName"] = this.associationName;
        data["healthScore"] = this.healthScore;
        data["scoreExplanation"] = this.scoreExplanation;
        data["scoreLastUpdated"] = this.scoreLastUpdated;
        data["statusId"] = this.statusId;
        data["projectStageId"] = this.projectStageId;
        data["projectSectionText"] = this.projectSectionText;
        if (Array.isArray(this.projectSections)) {
            data["projectSections"] = [];
            for (let item of this.projectSections)
                data["projectSections"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectMembersAsJson"] = this.projectMembersAsJson;
        if (Array.isArray(this.projectMembers)) {
            data["projectMembers"] = [];
            for (let item of this.projectMembers)
                data["projectMembers"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description;
        return data;
    }
}

export interface IProjectDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    dueDate: string | undefined;
    startDate: string | undefined;
    projectProgress: number | undefined;
    code: number | undefined;
    pinnedEntityId: number | undefined;
    isPrivate: boolean | undefined;
    isSuggestAiTasks: boolean | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    associationId: number | undefined;
    associationName: string | undefined;
    healthScore: number | undefined;
    scoreExplanation: string | undefined;
    scoreLastUpdated: string | undefined;
    statusId: number | undefined;
    projectStageId: number | undefined;
    projectSectionText: string | undefined;
    projectSections: ProjectSectionDto[] | undefined;
    projectMembersAsJson: string | undefined;
    projectMembers: ProjectMembers[] | undefined;
    description: string | undefined;
}

export class ProjectDtoIHandleError implements IProjectDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectDto | undefined;
    listOfEntities!: ProjectDto[] | undefined;

    constructor(data?: IProjectDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProjectDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProjectDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectDtoIHandleError>(data, _mappings, ProjectDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectDto | undefined;
    listOfEntities: ProjectDto[] | undefined;
}

export class ProjectLinksFromTemplateInput implements IProjectLinksFromTemplateInput {
    projectId!: number | undefined;
    defaultFolder!: string | undefined;
    filesLinks!: FileLinkTemplate[] | undefined;
    skipAttachingLinks!: boolean | undefined;
    templateId!: number | undefined;

    constructor(data?: IProjectLinksFromTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.defaultFolder = _data["defaultFolder"];
            if (Array.isArray(_data["filesLinks"])) {
                this.filesLinks = [] as any;
                for (let item of _data["filesLinks"])
                    this.filesLinks!.push(FileLinkTemplate.fromJS(item, _mappings));
            }
            this.skipAttachingLinks = _data["skipAttachingLinks"];
            this.templateId = _data["templateId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectLinksFromTemplateInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectLinksFromTemplateInput>(data, _mappings, ProjectLinksFromTemplateInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["defaultFolder"] = this.defaultFolder;
        if (Array.isArray(this.filesLinks)) {
            data["filesLinks"] = [];
            for (let item of this.filesLinks)
                data["filesLinks"].push(item ? item.toJSON() : undefined as any);
        }
        data["skipAttachingLinks"] = this.skipAttachingLinks;
        data["templateId"] = this.templateId;
        return data;
    }
}

export interface IProjectLinksFromTemplateInput {
    projectId: number | undefined;
    defaultFolder: string | undefined;
    filesLinks: FileLinkTemplate[] | undefined;
    skipAttachingLinks: boolean | undefined;
    templateId: number | undefined;
}

export class FolderProvisioningErrorDto implements IFolderProvisioningErrorDto {
    code!: string | undefined;
    reason!: string | undefined;
    supportRef!: string | undefined;
    retryable!: boolean | undefined;
    targetName!: string | undefined;

    constructor(data?: IFolderProvisioningErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.code = _data["code"];
            this.reason = _data["reason"];
            this.supportRef = _data["supportRef"];
            this.retryable = _data["retryable"];
            this.targetName = _data["targetName"];
        }
    }

    static fromJS(data: any, _mappings?: any): FolderProvisioningErrorDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FolderProvisioningErrorDto>(data, _mappings, FolderProvisioningErrorDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["reason"] = this.reason;
        data["supportRef"] = this.supportRef;
        data["retryable"] = this.retryable;
        data["targetName"] = this.targetName;
        return data;
    }
}

export interface IFolderProvisioningErrorDto {
    code: string | undefined;
    reason: string | undefined;
    supportRef: string | undefined;
    retryable: boolean | undefined;
    targetName: string | undefined;
}

export class TemplateFileCopyFailureDto implements ITemplateFileCopyFailureDto {
    name!: string | undefined;
    msFileId!: string | undefined;
    msDriveId!: string | undefined;
    msSiteId!: string | undefined;
    code!: string | undefined;
    reason!: string | undefined;
    supportRef!: string | undefined;
    retryable!: boolean | undefined;

    constructor(data?: ITemplateFileCopyFailureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.msFileId = _data["msFileId"];
            this.msDriveId = _data["msDriveId"];
            this.msSiteId = _data["msSiteId"];
            this.code = _data["code"];
            this.reason = _data["reason"];
            this.supportRef = _data["supportRef"];
            this.retryable = _data["retryable"];
        }
    }

    static fromJS(data: any, _mappings?: any): TemplateFileCopyFailureDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TemplateFileCopyFailureDto>(data, _mappings, TemplateFileCopyFailureDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["msFileId"] = this.msFileId;
        data["msDriveId"] = this.msDriveId;
        data["msSiteId"] = this.msSiteId;
        data["code"] = this.code;
        data["reason"] = this.reason;
        data["supportRef"] = this.supportRef;
        data["retryable"] = this.retryable;
        return data;
    }
}

export interface ITemplateFileCopyFailureDto {
    name: string | undefined;
    msFileId: string | undefined;
    msDriveId: string | undefined;
    msSiteId: string | undefined;
    code: string | undefined;
    reason: string | undefined;
    supportRef: string | undefined;
    retryable: boolean | undefined;
}

export class TemplateSubfolderFailureDto implements ITemplateSubfolderFailureDto {
    folderPath!: string | undefined;
    code!: string | undefined;
    reason!: string | undefined;
    supportRef!: string | undefined;
    retryable!: boolean | undefined;

    constructor(data?: ITemplateSubfolderFailureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.folderPath = _data["folderPath"];
            this.code = _data["code"];
            this.reason = _data["reason"];
            this.supportRef = _data["supportRef"];
            this.retryable = _data["retryable"];
        }
    }

    static fromJS(data: any, _mappings?: any): TemplateSubfolderFailureDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TemplateSubfolderFailureDto>(data, _mappings, TemplateSubfolderFailureDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderPath"] = this.folderPath;
        data["code"] = this.code;
        data["reason"] = this.reason;
        data["supportRef"] = this.supportRef;
        data["retryable"] = this.retryable;
        return data;
    }
}

export interface ITemplateSubfolderFailureDto {
    folderPath: string | undefined;
    code: string | undefined;
    reason: string | undefined;
    supportRef: string | undefined;
    retryable: boolean | undefined;
}

export class ProjectLinksFromTemplateResultDto implements IProjectLinksFromTemplateResultDto {
    folderCreated!: boolean | undefined;
    folderName!: string | undefined;
    folderId!: string | undefined;
    driveId!: string | undefined;
    folderError!: FolderProvisioningErrorDto | undefined;
    copyFailures!: TemplateFileCopyFailureDto[] | undefined;
    copiedCount!: number | undefined;
    linksAttached!: number | undefined;
    subfoldersCreated!: number | undefined;
    subfolderFailures!: TemplateSubfolderFailureDto[] | undefined;

    constructor(data?: IProjectLinksFromTemplateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.folderCreated = _data["folderCreated"];
            this.folderName = _data["folderName"];
            this.folderId = _data["folderId"];
            this.driveId = _data["driveId"];
            this.folderError = _data["folderError"] ? FolderProvisioningErrorDto.fromJS(_data["folderError"], _mappings) : undefined as any;
            if (Array.isArray(_data["copyFailures"])) {
                this.copyFailures = [] as any;
                for (let item of _data["copyFailures"])
                    this.copyFailures!.push(TemplateFileCopyFailureDto.fromJS(item, _mappings));
            }
            this.copiedCount = _data["copiedCount"];
            this.linksAttached = _data["linksAttached"];
            this.subfoldersCreated = _data["subfoldersCreated"];
            if (Array.isArray(_data["subfolderFailures"])) {
                this.subfolderFailures = [] as any;
                for (let item of _data["subfolderFailures"])
                    this.subfolderFailures!.push(TemplateSubfolderFailureDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectLinksFromTemplateResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectLinksFromTemplateResultDto>(data, _mappings, ProjectLinksFromTemplateResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderCreated"] = this.folderCreated;
        data["folderName"] = this.folderName;
        data["folderId"] = this.folderId;
        data["driveId"] = this.driveId;
        data["folderError"] = this.folderError ? this.folderError.toJSON() : undefined as any;
        if (Array.isArray(this.copyFailures)) {
            data["copyFailures"] = [];
            for (let item of this.copyFailures)
                data["copyFailures"].push(item ? item.toJSON() : undefined as any);
        }
        data["copiedCount"] = this.copiedCount;
        data["linksAttached"] = this.linksAttached;
        data["subfoldersCreated"] = this.subfoldersCreated;
        if (Array.isArray(this.subfolderFailures)) {
            data["subfolderFailures"] = [];
            for (let item of this.subfolderFailures)
                data["subfolderFailures"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectLinksFromTemplateResultDto {
    folderCreated: boolean | undefined;
    folderName: string | undefined;
    folderId: string | undefined;
    driveId: string | undefined;
    folderError: FolderProvisioningErrorDto | undefined;
    copyFailures: TemplateFileCopyFailureDto[] | undefined;
    copiedCount: number | undefined;
    linksAttached: number | undefined;
    subfoldersCreated: number | undefined;
    subfolderFailures: TemplateSubfolderFailureDto[] | undefined;
}

export class ProjectLinksFromTemplateResultDtoIHandleError implements IProjectLinksFromTemplateResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectLinksFromTemplateResultDto | undefined;
    listOfEntities!: ProjectLinksFromTemplateResultDto[] | undefined;

    constructor(data?: IProjectLinksFromTemplateResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProjectLinksFromTemplateResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProjectLinksFromTemplateResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectLinksFromTemplateResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectLinksFromTemplateResultDtoIHandleError>(data, _mappings, ProjectLinksFromTemplateResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectLinksFromTemplateResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectLinksFromTemplateResultDto | undefined;
    listOfEntities: ProjectLinksFromTemplateResultDto[] | undefined;
}

export class SuggestedChecklistOutputDto implements ISuggestedChecklistOutputDto {
    title!: string | undefined;

    constructor(data?: ISuggestedChecklistOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
        }
    }

    static fromJS(data: any, _mappings?: any): SuggestedChecklistOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SuggestedChecklistOutputDto>(data, _mappings, SuggestedChecklistOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        return data;
    }
}

export interface ISuggestedChecklistOutputDto {
    title: string | undefined;
}

export class SuggestedChecklistOutputDtoListIHandleError implements ISuggestedChecklistOutputDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SuggestedChecklistOutputDto[] | undefined;
    listOfEntities!: SuggestedChecklistOutputDto[][] | undefined;

    constructor(data?: ISuggestedChecklistOutputDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(SuggestedChecklistOutputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SuggestedChecklistOutputDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SuggestedChecklistOutputDtoListIHandleError>(data, _mappings, SuggestedChecklistOutputDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ISuggestedChecklistOutputDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SuggestedChecklistOutputDto[] | undefined;
    listOfEntities: SuggestedChecklistOutputDto[][] | undefined;
}

export class AiProjectGeneratedChecklist implements IAiProjectGeneratedChecklist {
    inputType!: number | undefined;
    content!: string | undefined;
    isAddPersonPlaceholder!: boolean | undefined;
    isIncludeInstructions!: boolean | undefined;

    constructor(data?: IAiProjectGeneratedChecklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.inputType = _data["inputType"];
            this.content = _data["content"];
            this.isAddPersonPlaceholder = _data["isAddPersonPlaceholder"];
            this.isIncludeInstructions = _data["isIncludeInstructions"];
        }
    }

    static fromJS(data: any, _mappings?: any): AiProjectGeneratedChecklist | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiProjectGeneratedChecklist>(data, _mappings, AiProjectGeneratedChecklist);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputType"] = this.inputType;
        data["content"] = this.content;
        data["isAddPersonPlaceholder"] = this.isAddPersonPlaceholder;
        data["isIncludeInstructions"] = this.isIncludeInstructions;
        return data;
    }
}

export interface IAiProjectGeneratedChecklist {
    inputType: number | undefined;
    content: string | undefined;
    isAddPersonPlaceholder: boolean | undefined;
    isIncludeInstructions: boolean | undefined;
}

export class AiChecklistOutput implements IAiChecklistOutput {
    title!: string | undefined;
    description!: string | undefined;
    note!: string | undefined;

    constructor(data?: IAiChecklistOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any, _mappings?: any): AiChecklistOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiChecklistOutput>(data, _mappings, AiChecklistOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["note"] = this.note;
        return data;
    }
}

export interface IAiChecklistOutput {
    title: string | undefined;
    description: string | undefined;
    note: string | undefined;
}

export class AiChecklistOutputListIHandleError implements IAiChecklistOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: AiChecklistOutput[] | undefined;
    listOfEntities!: AiChecklistOutput[][] | undefined;

    constructor(data?: IAiChecklistOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(AiChecklistOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AiChecklistOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiChecklistOutputListIHandleError>(data, _mappings, AiChecklistOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IAiChecklistOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: AiChecklistOutput[] | undefined;
    listOfEntities: AiChecklistOutput[][] | undefined;
}

export class CreateSuggestedProjectTasks implements ICreateSuggestedProjectTasks {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    description!: string | undefined;
    tasks!: string[] | undefined;

    constructor(data?: ICreateSuggestedProjectTasks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.description = _data["description"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateSuggestedProjectTasks | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateSuggestedProjectTasks>(data, _mappings, CreateSuggestedProjectTasks);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["description"] = this.description;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item);
        }
        return data;
    }
}

export interface ICreateSuggestedProjectTasks {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    description: string | undefined;
    tasks: string[] | undefined;
}

export class SuggestedProjectTaskOutputDto implements ISuggestedProjectTaskOutputDto {
    id!: number | undefined;
    title!: string | undefined;

    constructor(data?: ISuggestedProjectTaskOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any, _mappings?: any): SuggestedProjectTaskOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SuggestedProjectTaskOutputDto>(data, _mappings, SuggestedProjectTaskOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface ISuggestedProjectTaskOutputDto {
    id: number | undefined;
    title: string | undefined;
}

export class SuggestedProjectTaskOutputDtoListIHandleError implements ISuggestedProjectTaskOutputDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SuggestedProjectTaskOutputDto[] | undefined;
    listOfEntities!: SuggestedProjectTaskOutputDto[][] | undefined;

    constructor(data?: ISuggestedProjectTaskOutputDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(SuggestedProjectTaskOutputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SuggestedProjectTaskOutputDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SuggestedProjectTaskOutputDtoListIHandleError>(data, _mappings, SuggestedProjectTaskOutputDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ISuggestedProjectTaskOutputDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SuggestedProjectTaskOutputDto[] | undefined;
    listOfEntities: SuggestedProjectTaskOutputDto[][] | undefined;
}

export class AiSuggestedSectionsListAiSuggestedTasksListValueTuple implements IAiSuggestedSectionsListAiSuggestedTasksListValueTuple {

    constructor(data?: IAiSuggestedSectionsListAiSuggestedTasksListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): AiSuggestedSectionsListAiSuggestedTasksListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiSuggestedSectionsListAiSuggestedTasksListValueTuple>(data, _mappings, AiSuggestedSectionsListAiSuggestedTasksListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAiSuggestedSectionsListAiSuggestedTasksListValueTuple {
}

export class AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError implements IAiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: AiSuggestedSectionsListAiSuggestedTasksListValueTuple | undefined;
    listOfEntities!: AiSuggestedSectionsListAiSuggestedTasksListValueTuple[] | undefined;

    constructor(data?: IAiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? AiSuggestedSectionsListAiSuggestedTasksListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(AiSuggestedSectionsListAiSuggestedTasksListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError>(data, _mappings, AiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAiSuggestedSectionsListAiSuggestedTasksListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: AiSuggestedSectionsListAiSuggestedTasksListValueTuple | undefined;
    listOfEntities: AiSuggestedSectionsListAiSuggestedTasksListValueTuple[] | undefined;
}

export class TodosOnGoingTask implements ITodosOnGoingTask {
    id!: number | undefined;
    ownerId!: number | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isDueDatePassed!: boolean | undefined;
    isActive!: boolean | undefined;
    code!: number | undefined;
    name!: string | undefined;
    sortOrder!: number | undefined;
    isSeen!: boolean | undefined;
    isNewlyAssigned!: boolean | undefined;
    assignedByUserId!: number | undefined;
    assignedByUser!: string | undefined;
    assignedToUserId!: number | undefined;
    assignedToUser!: string | undefined;
    assignedTime!: string | undefined;
    completedOn!: string | undefined;
    endDate!: string | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    color!: string | undefined;
    keyId!: string | undefined;
    webUrl!: string | undefined;
    priority!: TaskPriority | undefined;
    tags!: string | undefined;
    readonly projectTags!: ProjectTag[] | undefined;
    statusCode!: number | undefined;
    entityType!: TaskEntityType | undefined;
    entityId!: number | undefined;
    taskType!: TaskTypes | undefined;
    isReAssigned!: boolean | undefined;
    isPrivate!: boolean | undefined;
    taskAssociationsAsJson!: string | undefined;
    readonly taskAssociations!: TaskAssociation[] | undefined;
    parentId!: number | undefined;
    isPartOfTaskTree!: boolean | undefined;

    constructor(data?: ITodosOnGoingTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerId = _data["ownerId"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isSeen = _data["isSeen"];
            this.isNewlyAssigned = _data["isNewlyAssigned"];
            this.assignedByUserId = _data["assignedByUserId"];
            this.assignedByUser = _data["assignedByUser"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"];
            this.assignedTime = _data["assignedTime"];
            this.completedOn = _data["completedOn"];
            this.endDate = _data["endDate"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.color = _data["color"];
            this.keyId = _data["keyId"];
            this.webUrl = _data["webUrl"];
            this.priority = _data["priority"];
            this.tags = _data["tags"];
            if (Array.isArray(_data["projectTags"])) {
                (this as any).projectTags = [] as any;
                for (let item of _data["projectTags"])
                    (this as any).projectTags!.push(ProjectTag.fromJS(item, _mappings));
            }
            this.statusCode = _data["statusCode"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.taskType = _data["taskType"];
            this.isReAssigned = _data["isReAssigned"];
            this.isPrivate = _data["isPrivate"];
            this.taskAssociationsAsJson = _data["taskAssociationsAsJson"];
            if (Array.isArray(_data["taskAssociations"])) {
                (this as any).taskAssociations = [] as any;
                for (let item of _data["taskAssociations"])
                    (this as any).taskAssociations!.push(TaskAssociation.fromJS(item, _mappings));
            }
            this.parentId = _data["parentId"];
            this.isPartOfTaskTree = _data["isPartOfTaskTree"];
        }
    }

    static fromJS(data: any, _mappings?: any): TodosOnGoingTask | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosOnGoingTask>(data, _mappings, TodosOnGoingTask);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerId"] = this.ownerId;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isSeen"] = this.isSeen;
        data["isNewlyAssigned"] = this.isNewlyAssigned;
        data["assignedByUserId"] = this.assignedByUserId;
        data["assignedByUser"] = this.assignedByUser;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser;
        data["assignedTime"] = this.assignedTime;
        data["completedOn"] = this.completedOn;
        data["endDate"] = this.endDate;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["color"] = this.color;
        data["keyId"] = this.keyId;
        data["webUrl"] = this.webUrl;
        data["priority"] = this.priority;
        data["tags"] = this.tags;
        if (Array.isArray(this.projectTags)) {
            data["projectTags"] = [];
            for (let item of this.projectTags)
                data["projectTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["statusCode"] = this.statusCode;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["taskType"] = this.taskType;
        data["isReAssigned"] = this.isReAssigned;
        data["isPrivate"] = this.isPrivate;
        data["taskAssociationsAsJson"] = this.taskAssociationsAsJson;
        if (Array.isArray(this.taskAssociations)) {
            data["taskAssociations"] = [];
            for (let item of this.taskAssociations)
                data["taskAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentId"] = this.parentId;
        data["isPartOfTaskTree"] = this.isPartOfTaskTree;
        return data;
    }
}

export interface ITodosOnGoingTask {
    id: number | undefined;
    ownerId: number | undefined;
    title: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isDueDatePassed: boolean | undefined;
    isActive: boolean | undefined;
    code: number | undefined;
    name: string | undefined;
    sortOrder: number | undefined;
    isSeen: boolean | undefined;
    isNewlyAssigned: boolean | undefined;
    assignedByUserId: number | undefined;
    assignedByUser: string | undefined;
    assignedToUserId: number | undefined;
    assignedToUser: string | undefined;
    assignedTime: string | undefined;
    completedOn: string | undefined;
    endDate: string | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    color: string | undefined;
    keyId: string | undefined;
    webUrl: string | undefined;
    priority: TaskPriority | undefined;
    tags: string | undefined;
    projectTags: ProjectTag[] | undefined;
    statusCode: number | undefined;
    entityType: TaskEntityType | undefined;
    entityId: number | undefined;
    taskType: TaskTypes | undefined;
    isReAssigned: boolean | undefined;
    isPrivate: boolean | undefined;
    taskAssociationsAsJson: string | undefined;
    taskAssociations: TaskAssociation[] | undefined;
    parentId: number | undefined;
    isPartOfTaskTree: boolean | undefined;
}

export class TodosOnGoingTaskListIHandleError implements ITodosOnGoingTaskListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TodosOnGoingTask[] | undefined;
    listOfEntities!: TodosOnGoingTask[][] | undefined;

    constructor(data?: ITodosOnGoingTaskListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TodosOnGoingTask.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TodosOnGoingTaskListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosOnGoingTaskListIHandleError>(data, _mappings, TodosOnGoingTaskListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITodosOnGoingTaskListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TodosOnGoingTask[] | undefined;
    listOfEntities: TodosOnGoingTask[][] | undefined;
}

export class GetAiAssistedProjectOutputDto implements IGetAiAssistedProjectOutputDto {
    projectName!: string | undefined;
    projectDescription!: string | undefined;

    constructor(data?: IGetAiAssistedProjectOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            this.projectDescription = _data["projectDescription"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetAiAssistedProjectOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetAiAssistedProjectOutputDto>(data, _mappings, GetAiAssistedProjectOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["projectDescription"] = this.projectDescription;
        return data;
    }
}

export interface IGetAiAssistedProjectOutputDto {
    projectName: string | undefined;
    projectDescription: string | undefined;
}

export class GetAiAssistedProjectOutputDtoListIHandleError implements IGetAiAssistedProjectOutputDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetAiAssistedProjectOutputDto[] | undefined;
    listOfEntities!: GetAiAssistedProjectOutputDto[][] | undefined;

    constructor(data?: IGetAiAssistedProjectOutputDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(GetAiAssistedProjectOutputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetAiAssistedProjectOutputDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetAiAssistedProjectOutputDtoListIHandleError>(data, _mappings, GetAiAssistedProjectOutputDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IGetAiAssistedProjectOutputDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetAiAssistedProjectOutputDto[] | undefined;
    listOfEntities: GetAiAssistedProjectOutputDto[][] | undefined;
}

export class AiGrammarChecklist implements IAiGrammarChecklist {
    title!: string | undefined;
    description!: string | undefined;

    constructor(data?: IAiGrammarChecklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any, _mappings?: any): AiGrammarChecklist | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiGrammarChecklist>(data, _mappings, AiGrammarChecklist);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface IAiGrammarChecklist {
    title: string | undefined;
    description: string | undefined;
}

export class AiChecklistOutputIHandleError implements IAiChecklistOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: AiChecklistOutput | undefined;
    listOfEntities!: AiChecklistOutput[] | undefined;

    constructor(data?: IAiChecklistOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? AiChecklistOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(AiChecklistOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AiChecklistOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiChecklistOutputIHandleError>(data, _mappings, AiChecklistOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAiChecklistOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: AiChecklistOutput | undefined;
    listOfEntities: AiChecklistOutput[] | undefined;
}

export enum ProofreadEntityType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ProofreadTextInput implements IProofreadTextInput {
    title!: string | undefined;
    description!: string | undefined;
    type!: ProofreadEntityType | undefined;

    constructor(data?: IProofreadTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProofreadTextInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProofreadTextInput>(data, _mappings, ProofreadTextInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["type"] = this.type;
        return data;
    }
}

export interface IProofreadTextInput {
    title: string | undefined;
    description: string | undefined;
    type: ProofreadEntityType | undefined;
}

export class ProofreadTextOutput implements IProofreadTextOutput {
    title!: string | undefined;
    description!: string | undefined;

    constructor(data?: IProofreadTextOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProofreadTextOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProofreadTextOutput>(data, _mappings, ProofreadTextOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface IProofreadTextOutput {
    title: string | undefined;
    description: string | undefined;
}

export class ProofreadTextOutputIHandleError implements IProofreadTextOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProofreadTextOutput | undefined;
    listOfEntities!: ProofreadTextOutput[] | undefined;

    constructor(data?: IProofreadTextOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProofreadTextOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProofreadTextOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProofreadTextOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProofreadTextOutputIHandleError>(data, _mappings, ProofreadTextOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProofreadTextOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProofreadTextOutput | undefined;
    listOfEntities: ProofreadTextOutput[] | undefined;
}

export class AiOptimizeWordingChecklist implements IAiOptimizeWordingChecklist {
    title!: string | undefined;
    description!: string | undefined;
    isIncludeTimeEstimate!: boolean | undefined;
    isIncludeSubtasks!: boolean | undefined;
    isAddPersonPlaceholder!: boolean | undefined;

    constructor(data?: IAiOptimizeWordingChecklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.isIncludeTimeEstimate = _data["isIncludeTimeEstimate"];
            this.isIncludeSubtasks = _data["isIncludeSubtasks"];
            this.isAddPersonPlaceholder = _data["isAddPersonPlaceholder"];
        }
    }

    static fromJS(data: any, _mappings?: any): AiOptimizeWordingChecklist | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiOptimizeWordingChecklist>(data, _mappings, AiOptimizeWordingChecklist);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["isIncludeTimeEstimate"] = this.isIncludeTimeEstimate;
        data["isIncludeSubtasks"] = this.isIncludeSubtasks;
        data["isAddPersonPlaceholder"] = this.isAddPersonPlaceholder;
        return data;
    }
}

export interface IAiOptimizeWordingChecklist {
    title: string | undefined;
    description: string | undefined;
    isIncludeTimeEstimate: boolean | undefined;
    isIncludeSubtasks: boolean | undefined;
    isAddPersonPlaceholder: boolean | undefined;
}

export class AiTaskGenerateDescription implements IAiTaskGenerateDescription {
    actionType!: number | undefined;
    userInput!: string | undefined;
    lengthOption!: number | undefined;
    toneOption!: number | undefined;
    isAddChecklist!: boolean | undefined;
    isSuggestTaskName!: boolean | undefined;

    constructor(data?: IAiTaskGenerateDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.actionType = _data["actionType"];
            this.userInput = _data["userInput"];
            this.lengthOption = _data["lengthOption"];
            this.toneOption = _data["toneOption"];
            this.isAddChecklist = _data["isAddChecklist"];
            this.isSuggestTaskName = _data["isSuggestTaskName"];
        }
    }

    static fromJS(data: any, _mappings?: any): AiTaskGenerateDescription | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiTaskGenerateDescription>(data, _mappings, AiTaskGenerateDescription);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType;
        data["userInput"] = this.userInput;
        data["lengthOption"] = this.lengthOption;
        data["toneOption"] = this.toneOption;
        data["isAddChecklist"] = this.isAddChecklist;
        data["isSuggestTaskName"] = this.isSuggestTaskName;
        return data;
    }
}

export interface IAiTaskGenerateDescription {
    actionType: number | undefined;
    userInput: string | undefined;
    lengthOption: number | undefined;
    toneOption: number | undefined;
    isAddChecklist: boolean | undefined;
    isSuggestTaskName: boolean | undefined;
}

export class AiTaskDetails implements IAiTaskDetails {
    title!: string | undefined;
    description!: string | undefined;
    checklists!: string[] | undefined;

    constructor(data?: IAiTaskDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AiTaskDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiTaskDetails>(data, _mappings, AiTaskDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item);
        }
        return data;
    }
}

export interface IAiTaskDetails {
    title: string | undefined;
    description: string | undefined;
    checklists: string[] | undefined;
}

export class AiTaskDetailsIHandleError implements IAiTaskDetailsIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: AiTaskDetails | undefined;
    listOfEntities!: AiTaskDetails[] | undefined;

    constructor(data?: IAiTaskDetailsIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? AiTaskDetails.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(AiTaskDetails.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AiTaskDetailsIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiTaskDetailsIHandleError>(data, _mappings, AiTaskDetailsIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAiTaskDetailsIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: AiTaskDetails | undefined;
    listOfEntities: AiTaskDetails[] | undefined;
}

export class ProjectListInputDto implements IProjectListInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    isActive!: boolean | undefined;
    isInActive!: boolean | undefined;
    isOverdue!: boolean | undefined;
    searchText!: string | undefined;
    filterCompanyIds!: number[] | undefined;
    filterPersonIds!: number[] | undefined;
    filterProjManagerIds!: number[] | undefined;
    filterProjStageIds!: number[] | undefined;
    includeProjWithoutStages!: boolean | undefined;
    filterDueDate!: number | undefined;
    filterStartDate!: number | undefined;
    filterHealthScore!: number | undefined;
    includeManagers!: boolean | undefined;

    constructor(data?: IProjectListInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.isActive = _data["isActive"];
            this.isInActive = _data["isInActive"];
            this.isOverdue = _data["isOverdue"];
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["filterCompanyIds"])) {
                this.filterCompanyIds = [] as any;
                for (let item of _data["filterCompanyIds"])
                    this.filterCompanyIds!.push(item);
            }
            if (Array.isArray(_data["filterPersonIds"])) {
                this.filterPersonIds = [] as any;
                for (let item of _data["filterPersonIds"])
                    this.filterPersonIds!.push(item);
            }
            if (Array.isArray(_data["filterProjManagerIds"])) {
                this.filterProjManagerIds = [] as any;
                for (let item of _data["filterProjManagerIds"])
                    this.filterProjManagerIds!.push(item);
            }
            if (Array.isArray(_data["filterProjStageIds"])) {
                this.filterProjStageIds = [] as any;
                for (let item of _data["filterProjStageIds"])
                    this.filterProjStageIds!.push(item);
            }
            this.includeProjWithoutStages = _data["includeProjWithoutStages"];
            this.filterDueDate = _data["filterDueDate"];
            this.filterStartDate = _data["filterStartDate"];
            this.filterHealthScore = _data["filterHealthScore"];
            this.includeManagers = _data["includeManagers"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectListInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectListInputDto>(data, _mappings, ProjectListInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["isActive"] = this.isActive;
        data["isInActive"] = this.isInActive;
        data["isOverdue"] = this.isOverdue;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.filterCompanyIds)) {
            data["filterCompanyIds"] = [];
            for (let item of this.filterCompanyIds)
                data["filterCompanyIds"].push(item);
        }
        if (Array.isArray(this.filterPersonIds)) {
            data["filterPersonIds"] = [];
            for (let item of this.filterPersonIds)
                data["filterPersonIds"].push(item);
        }
        if (Array.isArray(this.filterProjManagerIds)) {
            data["filterProjManagerIds"] = [];
            for (let item of this.filterProjManagerIds)
                data["filterProjManagerIds"].push(item);
        }
        if (Array.isArray(this.filterProjStageIds)) {
            data["filterProjStageIds"] = [];
            for (let item of this.filterProjStageIds)
                data["filterProjStageIds"].push(item);
        }
        data["includeProjWithoutStages"] = this.includeProjWithoutStages;
        data["filterDueDate"] = this.filterDueDate;
        data["filterStartDate"] = this.filterStartDate;
        data["filterHealthScore"] = this.filterHealthScore;
        data["includeManagers"] = this.includeManagers;
        return data;
    }
}

export interface IProjectListInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    isActive: boolean | undefined;
    isInActive: boolean | undefined;
    isOverdue: boolean | undefined;
    searchText: string | undefined;
    filterCompanyIds: number[] | undefined;
    filterPersonIds: number[] | undefined;
    filterProjManagerIds: number[] | undefined;
    filterProjStageIds: number[] | undefined;
    includeProjWithoutStages: boolean | undefined;
    filterDueDate: number | undefined;
    filterStartDate: number | undefined;
    filterHealthScore: number | undefined;
    includeManagers: boolean | undefined;
}

export class AiProjectsHealthScoreOuput implements IAiProjectsHealthScoreOuput {
    projectId!: number | undefined;
    score!: number | undefined;
    explanation!: string | undefined;
    scheduleVariance!: number | undefined;

    constructor(data?: IAiProjectsHealthScoreOuput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.score = _data["score"];
            this.explanation = _data["explanation"];
            this.scheduleVariance = _data["scheduleVariance"];
        }
    }

    static fromJS(data: any, _mappings?: any): AiProjectsHealthScoreOuput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiProjectsHealthScoreOuput>(data, _mappings, AiProjectsHealthScoreOuput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["score"] = this.score;
        data["explanation"] = this.explanation;
        data["scheduleVariance"] = this.scheduleVariance;
        return data;
    }
}

export interface IAiProjectsHealthScoreOuput {
    projectId: number | undefined;
    score: number | undefined;
    explanation: string | undefined;
    scheduleVariance: number | undefined;
}

export class AiProjectsHealthScoreOuputListIHandleError implements IAiProjectsHealthScoreOuputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: AiProjectsHealthScoreOuput[] | undefined;
    listOfEntities!: AiProjectsHealthScoreOuput[][] | undefined;

    constructor(data?: IAiProjectsHealthScoreOuputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(AiProjectsHealthScoreOuput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AiProjectsHealthScoreOuputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiProjectsHealthScoreOuputListIHandleError>(data, _mappings, AiProjectsHealthScoreOuputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IAiProjectsHealthScoreOuputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: AiProjectsHealthScoreOuput[] | undefined;
    listOfEntities: AiProjectsHealthScoreOuput[][] | undefined;
}

export class TaskTagInputDto implements ITaskTagInputDto {
    id!: number | undefined;
    taskId!: number | undefined;
    tagId!: number | undefined;
    tag!: string | undefined;
    userId!: number | undefined;

    constructor(data?: ITaskTagInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.tagId = _data["tagId"];
            this.tag = _data["tag"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskTagInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskTagInputDto>(data, _mappings, TaskTagInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["tagId"] = this.tagId;
        data["tag"] = this.tag;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ITaskTagInputDto {
    id: number | undefined;
    taskId: number | undefined;
    tagId: number | undefined;
    tag: string | undefined;
    userId: number | undefined;
}

export class TaskChecklist implements ITaskChecklist {
    title!: string | undefined;
    description!: string | undefined;
    code!: number | undefined;
    assignedToId!: number | undefined;

    constructor(data?: ITaskChecklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.code = _data["code"];
            this.assignedToId = _data["assignedToId"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskChecklist | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskChecklist>(data, _mappings, TaskChecklist);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["code"] = this.code;
        data["assignedToId"] = this.assignedToId;
        return data;
    }
}

export interface ITaskChecklist {
    title: string | undefined;
    description: string | undefined;
    code: number | undefined;
    assignedToId: number | undefined;
}

export enum RecurrenceType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum WeeklyDays {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
}

export enum MonthlyType {
    _1 = 1,
    _2 = 2,
}

export enum MonthlyWeekOrdinal {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum MonthlyDayOfWeek {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class CreateTaskAndRecurrenceSeriesInput implements ICreateTaskAndRecurrenceSeriesInput {
    id!: number | undefined;
    taskName!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    ownerId!: number | undefined;
    code!: number | undefined;
    assignedToUserId!: number | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    projectId!: number | undefined;
    sectionId!: number | undefined;
    isFromDrop!: boolean | undefined;
    isPrivate!: boolean | undefined;
    tenantId!: number | undefined;
    priority!: TaskPriority | undefined;
    tagList!: TaskTagInputDto[] | undefined;
    checkLists!: TaskChecklist[] | undefined;
    attachments!: CommonAttachment[] | undefined;
    entityType!: TaskEntityType | undefined;
    taskType!: TaskTypes | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactCompanyId!: number | undefined;
    contactCompanyName!: string | undefined;
    selectedMyDayDate!: string | undefined;
    actionPerformed!: string | undefined;
    parentId!: number | undefined;
    startDelay!: number | undefined;
    duration!: number | undefined;
    taskWatchersIds!: number[] | undefined;
    recurrenceType!: RecurrenceType | undefined;
    intervalValue!: number | undefined;
    weeklyDays!: WeeklyDays | undefined;
    monthlyType!: MonthlyType | undefined;
    monthlyDayOfMonth!: number | undefined;
    monthlyWeekOrdinal!: MonthlyWeekOrdinal | undefined;
    monthlyDayOfWeek!: MonthlyDayOfWeek | undefined;
    recurrenceStartDate!: string | undefined;
    recurrenceEndDate!: string | undefined;
    lookAheadDays!: number | undefined;
    generationTime!: TimeSpan | undefined;
    isGenUsingUserTimezone!: boolean | undefined;

    constructor(data?: ICreateTaskAndRecurrenceSeriesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.ownerId = _data["ownerId"];
            this.code = _data["code"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.projectId = _data["projectId"];
            this.sectionId = _data["sectionId"];
            this.isFromDrop = _data["isFromDrop"];
            this.isPrivate = _data["isPrivate"];
            this.tenantId = _data["tenantId"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["tagList"])) {
                this.tagList = [] as any;
                for (let item of _data["tagList"])
                    this.tagList!.push(TaskTagInputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["checkLists"])) {
                this.checkLists = [] as any;
                for (let item of _data["checkLists"])
                    this.checkLists!.push(TaskChecklist.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CommonAttachment.fromJS(item, _mappings));
            }
            this.entityType = _data["entityType"];
            this.taskType = _data["taskType"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactCompanyId = _data["contactCompanyId"];
            this.contactCompanyName = _data["contactCompanyName"];
            this.selectedMyDayDate = _data["selectedMyDayDate"];
            this.actionPerformed = _data["actionPerformed"];
            this.parentId = _data["parentId"];
            this.startDelay = _data["startDelay"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["taskWatchersIds"])) {
                this.taskWatchersIds = [] as any;
                for (let item of _data["taskWatchersIds"])
                    this.taskWatchersIds!.push(item);
            }
            this.recurrenceType = _data["recurrenceType"];
            this.intervalValue = _data["intervalValue"];
            this.weeklyDays = _data["weeklyDays"];
            this.monthlyType = _data["monthlyType"];
            this.monthlyDayOfMonth = _data["monthlyDayOfMonth"];
            this.monthlyWeekOrdinal = _data["monthlyWeekOrdinal"];
            this.monthlyDayOfWeek = _data["monthlyDayOfWeek"];
            this.recurrenceStartDate = _data["recurrenceStartDate"];
            this.recurrenceEndDate = _data["recurrenceEndDate"];
            this.lookAheadDays = _data["lookAheadDays"];
            this.generationTime = _data["generationTime"] ? TimeSpan.fromJS(_data["generationTime"], _mappings) : undefined as any;
            this.isGenUsingUserTimezone = _data["isGenUsingUserTimezone"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateTaskAndRecurrenceSeriesInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateTaskAndRecurrenceSeriesInput>(data, _mappings, CreateTaskAndRecurrenceSeriesInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["ownerId"] = this.ownerId;
        data["code"] = this.code;
        data["assignedToUserId"] = this.assignedToUserId;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["projectId"] = this.projectId;
        data["sectionId"] = this.sectionId;
        data["isFromDrop"] = this.isFromDrop;
        data["isPrivate"] = this.isPrivate;
        data["tenantId"] = this.tenantId;
        data["priority"] = this.priority;
        if (Array.isArray(this.tagList)) {
            data["tagList"] = [];
            for (let item of this.tagList)
                data["tagList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.checkLists)) {
            data["checkLists"] = [];
            for (let item of this.checkLists)
                data["checkLists"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["entityType"] = this.entityType;
        data["taskType"] = this.taskType;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactCompanyId"] = this.contactCompanyId;
        data["contactCompanyName"] = this.contactCompanyName;
        data["selectedMyDayDate"] = this.selectedMyDayDate;
        data["actionPerformed"] = this.actionPerformed;
        data["parentId"] = this.parentId;
        data["startDelay"] = this.startDelay;
        data["duration"] = this.duration;
        if (Array.isArray(this.taskWatchersIds)) {
            data["taskWatchersIds"] = [];
            for (let item of this.taskWatchersIds)
                data["taskWatchersIds"].push(item);
        }
        data["recurrenceType"] = this.recurrenceType;
        data["intervalValue"] = this.intervalValue;
        data["weeklyDays"] = this.weeklyDays;
        data["monthlyType"] = this.monthlyType;
        data["monthlyDayOfMonth"] = this.monthlyDayOfMonth;
        data["monthlyWeekOrdinal"] = this.monthlyWeekOrdinal;
        data["monthlyDayOfWeek"] = this.monthlyDayOfWeek;
        data["recurrenceStartDate"] = this.recurrenceStartDate;
        data["recurrenceEndDate"] = this.recurrenceEndDate;
        data["lookAheadDays"] = this.lookAheadDays;
        data["generationTime"] = this.generationTime ? this.generationTime.toJSON() : undefined as any;
        data["isGenUsingUserTimezone"] = this.isGenUsingUserTimezone;
        return data;
    }
}

export interface ICreateTaskAndRecurrenceSeriesInput {
    id: number | undefined;
    taskName: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    ownerId: number | undefined;
    code: number | undefined;
    assignedToUserId: number | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    projectId: number | undefined;
    sectionId: number | undefined;
    isFromDrop: boolean | undefined;
    isPrivate: boolean | undefined;
    tenantId: number | undefined;
    priority: TaskPriority | undefined;
    tagList: TaskTagInputDto[] | undefined;
    checkLists: TaskChecklist[] | undefined;
    attachments: CommonAttachment[] | undefined;
    entityType: TaskEntityType | undefined;
    taskType: TaskTypes | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactCompanyId: number | undefined;
    contactCompanyName: string | undefined;
    selectedMyDayDate: string | undefined;
    actionPerformed: string | undefined;
    parentId: number | undefined;
    startDelay: number | undefined;
    duration: number | undefined;
    taskWatchersIds: number[] | undefined;
    recurrenceType: RecurrenceType | undefined;
    intervalValue: number | undefined;
    weeklyDays: WeeklyDays | undefined;
    monthlyType: MonthlyType | undefined;
    monthlyDayOfMonth: number | undefined;
    monthlyWeekOrdinal: MonthlyWeekOrdinal | undefined;
    monthlyDayOfWeek: MonthlyDayOfWeek | undefined;
    recurrenceStartDate: string | undefined;
    recurrenceEndDate: string | undefined;
    lookAheadDays: number | undefined;
    generationTime: TimeSpan | undefined;
    isGenUsingUserTimezone: boolean | undefined;
}

export class CreateTaskWithRecurrenceSeriesOutput implements ICreateTaskWithRecurrenceSeriesOutput {
    seriesId!: number | undefined;
    seedTaskId!: number | undefined;
    success!: boolean | undefined;
    message!: string | undefined;
    createdDate!: string | undefined;
    taskId!: number | undefined;

    constructor(data?: ICreateTaskWithRecurrenceSeriesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.seriesId = _data["seriesId"];
            this.seedTaskId = _data["seedTaskId"];
            this.success = _data["success"];
            this.message = _data["message"];
            this.createdDate = _data["createdDate"];
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateTaskWithRecurrenceSeriesOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateTaskWithRecurrenceSeriesOutput>(data, _mappings, CreateTaskWithRecurrenceSeriesOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seriesId"] = this.seriesId;
        data["seedTaskId"] = this.seedTaskId;
        data["success"] = this.success;
        data["message"] = this.message;
        data["createdDate"] = this.createdDate;
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface ICreateTaskWithRecurrenceSeriesOutput {
    seriesId: number | undefined;
    seedTaskId: number | undefined;
    success: boolean | undefined;
    message: string | undefined;
    createdDate: string | undefined;
    taskId: number | undefined;
}

export class CreateTaskWithRecurrenceSeriesOutputIHandleError implements ICreateTaskWithRecurrenceSeriesOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CreateTaskWithRecurrenceSeriesOutput | undefined;
    listOfEntities!: CreateTaskWithRecurrenceSeriesOutput[] | undefined;

    constructor(data?: ICreateTaskWithRecurrenceSeriesOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CreateTaskWithRecurrenceSeriesOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CreateTaskWithRecurrenceSeriesOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateTaskWithRecurrenceSeriesOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateTaskWithRecurrenceSeriesOutputIHandleError>(data, _mappings, CreateTaskWithRecurrenceSeriesOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateTaskWithRecurrenceSeriesOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CreateTaskWithRecurrenceSeriesOutput | undefined;
    listOfEntities: CreateTaskWithRecurrenceSeriesOutput[] | undefined;
}

export class CreateMyDayTaskAndRecurrenceSeriesInput implements ICreateMyDayTaskAndRecurrenceSeriesInput {
    id!: number | undefined;
    taskName!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    ownerId!: number | undefined;
    code!: number | undefined;
    assignedToUserId!: number | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    projectId!: number | undefined;
    sectionId!: number | undefined;
    isFromDrop!: boolean | undefined;
    isPrivate!: boolean | undefined;
    tenantId!: number | undefined;
    priority!: TaskPriority | undefined;
    tagList!: TaskTagInputDto[] | undefined;
    checkLists!: TaskChecklist[] | undefined;
    attachments!: CommonAttachment[] | undefined;
    entityType!: TaskEntityType | undefined;
    taskType!: TaskTypes | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactCompanyId!: number | undefined;
    contactCompanyName!: string | undefined;
    selectedMyDayDate!: string | undefined;
    actionPerformed!: string | undefined;
    parentId!: number | undefined;
    startDelay!: number | undefined;
    duration!: number | undefined;
    taskWatchersIds!: number[] | undefined;
    resourceAppName!: string | undefined;
    resourceAppUrl!: string | undefined;
    plannerCategoryId!: number | undefined;
    userSectionId!: number | undefined;
    recurrenceType!: RecurrenceType | undefined;
    intervalValue!: number | undefined;
    weeklyDays!: WeeklyDays | undefined;
    monthlyType!: MonthlyType | undefined;
    monthlyDayOfMonth!: number | undefined;
    monthlyWeekOrdinal!: MonthlyWeekOrdinal | undefined;
    monthlyDayOfWeek!: MonthlyDayOfWeek | undefined;
    recurrenceStartDate!: string | undefined;
    recurrenceEndDate!: string | undefined;
    lookAheadDays!: number | undefined;
    generationTime!: TimeSpan | undefined;
    isGenUsingUserTimezone!: boolean | undefined;

    constructor(data?: ICreateMyDayTaskAndRecurrenceSeriesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.ownerId = _data["ownerId"];
            this.code = _data["code"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.projectId = _data["projectId"];
            this.sectionId = _data["sectionId"];
            this.isFromDrop = _data["isFromDrop"];
            this.isPrivate = _data["isPrivate"];
            this.tenantId = _data["tenantId"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["tagList"])) {
                this.tagList = [] as any;
                for (let item of _data["tagList"])
                    this.tagList!.push(TaskTagInputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["checkLists"])) {
                this.checkLists = [] as any;
                for (let item of _data["checkLists"])
                    this.checkLists!.push(TaskChecklist.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CommonAttachment.fromJS(item, _mappings));
            }
            this.entityType = _data["entityType"];
            this.taskType = _data["taskType"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactCompanyId = _data["contactCompanyId"];
            this.contactCompanyName = _data["contactCompanyName"];
            this.selectedMyDayDate = _data["selectedMyDayDate"];
            this.actionPerformed = _data["actionPerformed"];
            this.parentId = _data["parentId"];
            this.startDelay = _data["startDelay"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["taskWatchersIds"])) {
                this.taskWatchersIds = [] as any;
                for (let item of _data["taskWatchersIds"])
                    this.taskWatchersIds!.push(item);
            }
            this.resourceAppName = _data["resourceAppName"];
            this.resourceAppUrl = _data["resourceAppUrl"];
            this.plannerCategoryId = _data["plannerCategoryId"];
            this.userSectionId = _data["userSectionId"];
            this.recurrenceType = _data["recurrenceType"];
            this.intervalValue = _data["intervalValue"];
            this.weeklyDays = _data["weeklyDays"];
            this.monthlyType = _data["monthlyType"];
            this.monthlyDayOfMonth = _data["monthlyDayOfMonth"];
            this.monthlyWeekOrdinal = _data["monthlyWeekOrdinal"];
            this.monthlyDayOfWeek = _data["monthlyDayOfWeek"];
            this.recurrenceStartDate = _data["recurrenceStartDate"];
            this.recurrenceEndDate = _data["recurrenceEndDate"];
            this.lookAheadDays = _data["lookAheadDays"];
            this.generationTime = _data["generationTime"] ? TimeSpan.fromJS(_data["generationTime"], _mappings) : undefined as any;
            this.isGenUsingUserTimezone = _data["isGenUsingUserTimezone"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateMyDayTaskAndRecurrenceSeriesInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateMyDayTaskAndRecurrenceSeriesInput>(data, _mappings, CreateMyDayTaskAndRecurrenceSeriesInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["ownerId"] = this.ownerId;
        data["code"] = this.code;
        data["assignedToUserId"] = this.assignedToUserId;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["projectId"] = this.projectId;
        data["sectionId"] = this.sectionId;
        data["isFromDrop"] = this.isFromDrop;
        data["isPrivate"] = this.isPrivate;
        data["tenantId"] = this.tenantId;
        data["priority"] = this.priority;
        if (Array.isArray(this.tagList)) {
            data["tagList"] = [];
            for (let item of this.tagList)
                data["tagList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.checkLists)) {
            data["checkLists"] = [];
            for (let item of this.checkLists)
                data["checkLists"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["entityType"] = this.entityType;
        data["taskType"] = this.taskType;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactCompanyId"] = this.contactCompanyId;
        data["contactCompanyName"] = this.contactCompanyName;
        data["selectedMyDayDate"] = this.selectedMyDayDate;
        data["actionPerformed"] = this.actionPerformed;
        data["parentId"] = this.parentId;
        data["startDelay"] = this.startDelay;
        data["duration"] = this.duration;
        if (Array.isArray(this.taskWatchersIds)) {
            data["taskWatchersIds"] = [];
            for (let item of this.taskWatchersIds)
                data["taskWatchersIds"].push(item);
        }
        data["resourceAppName"] = this.resourceAppName;
        data["resourceAppUrl"] = this.resourceAppUrl;
        data["plannerCategoryId"] = this.plannerCategoryId;
        data["userSectionId"] = this.userSectionId;
        data["recurrenceType"] = this.recurrenceType;
        data["intervalValue"] = this.intervalValue;
        data["weeklyDays"] = this.weeklyDays;
        data["monthlyType"] = this.monthlyType;
        data["monthlyDayOfMonth"] = this.monthlyDayOfMonth;
        data["monthlyWeekOrdinal"] = this.monthlyWeekOrdinal;
        data["monthlyDayOfWeek"] = this.monthlyDayOfWeek;
        data["recurrenceStartDate"] = this.recurrenceStartDate;
        data["recurrenceEndDate"] = this.recurrenceEndDate;
        data["lookAheadDays"] = this.lookAheadDays;
        data["generationTime"] = this.generationTime ? this.generationTime.toJSON() : undefined as any;
        data["isGenUsingUserTimezone"] = this.isGenUsingUserTimezone;
        return data;
    }
}

export interface ICreateMyDayTaskAndRecurrenceSeriesInput {
    id: number | undefined;
    taskName: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    ownerId: number | undefined;
    code: number | undefined;
    assignedToUserId: number | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    projectId: number | undefined;
    sectionId: number | undefined;
    isFromDrop: boolean | undefined;
    isPrivate: boolean | undefined;
    tenantId: number | undefined;
    priority: TaskPriority | undefined;
    tagList: TaskTagInputDto[] | undefined;
    checkLists: TaskChecklist[] | undefined;
    attachments: CommonAttachment[] | undefined;
    entityType: TaskEntityType | undefined;
    taskType: TaskTypes | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactCompanyId: number | undefined;
    contactCompanyName: string | undefined;
    selectedMyDayDate: string | undefined;
    actionPerformed: string | undefined;
    parentId: number | undefined;
    startDelay: number | undefined;
    duration: number | undefined;
    taskWatchersIds: number[] | undefined;
    resourceAppName: string | undefined;
    resourceAppUrl: string | undefined;
    plannerCategoryId: number | undefined;
    userSectionId: number | undefined;
    recurrenceType: RecurrenceType | undefined;
    intervalValue: number | undefined;
    weeklyDays: WeeklyDays | undefined;
    monthlyType: MonthlyType | undefined;
    monthlyDayOfMonth: number | undefined;
    monthlyWeekOrdinal: MonthlyWeekOrdinal | undefined;
    monthlyDayOfWeek: MonthlyDayOfWeek | undefined;
    recurrenceStartDate: string | undefined;
    recurrenceEndDate: string | undefined;
    lookAheadDays: number | undefined;
    generationTime: TimeSpan | undefined;
    isGenUsingUserTimezone: boolean | undefined;
}

export class CreateRecurrenceSeriesInputDto implements ICreateRecurrenceSeriesInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    taskId!: number | undefined;
    recurrenceType!: RecurrenceType | undefined;
    intervalValue!: number | undefined;
    weeklyDays!: WeeklyDays | undefined;
    monthlyType!: MonthlyType | undefined;
    monthlyDayOfMonth!: number | undefined;
    monthlyWeekOrdinal!: MonthlyWeekOrdinal | undefined;
    monthlyDayOfWeek!: MonthlyDayOfWeek | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    lookAheadDays!: number | undefined;
    generationTime!: TimeSpan | undefined;
    isGenUsingUserTimezone!: boolean | undefined;

    constructor(data?: ICreateRecurrenceSeriesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.taskId = _data["taskId"];
            this.recurrenceType = _data["recurrenceType"];
            this.intervalValue = _data["intervalValue"];
            this.weeklyDays = _data["weeklyDays"];
            this.monthlyType = _data["monthlyType"];
            this.monthlyDayOfMonth = _data["monthlyDayOfMonth"];
            this.monthlyWeekOrdinal = _data["monthlyWeekOrdinal"];
            this.monthlyDayOfWeek = _data["monthlyDayOfWeek"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.lookAheadDays = _data["lookAheadDays"];
            this.generationTime = _data["generationTime"] ? TimeSpan.fromJS(_data["generationTime"], _mappings) : undefined as any;
            this.isGenUsingUserTimezone = _data["isGenUsingUserTimezone"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateRecurrenceSeriesInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateRecurrenceSeriesInputDto>(data, _mappings, CreateRecurrenceSeriesInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["taskId"] = this.taskId;
        data["recurrenceType"] = this.recurrenceType;
        data["intervalValue"] = this.intervalValue;
        data["weeklyDays"] = this.weeklyDays;
        data["monthlyType"] = this.monthlyType;
        data["monthlyDayOfMonth"] = this.monthlyDayOfMonth;
        data["monthlyWeekOrdinal"] = this.monthlyWeekOrdinal;
        data["monthlyDayOfWeek"] = this.monthlyDayOfWeek;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["lookAheadDays"] = this.lookAheadDays;
        data["generationTime"] = this.generationTime ? this.generationTime.toJSON() : undefined as any;
        data["isGenUsingUserTimezone"] = this.isGenUsingUserTimezone;
        return data;
    }
}

export interface ICreateRecurrenceSeriesInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    taskId: number | undefined;
    recurrenceType: RecurrenceType | undefined;
    intervalValue: number | undefined;
    weeklyDays: WeeklyDays | undefined;
    monthlyType: MonthlyType | undefined;
    monthlyDayOfMonth: number | undefined;
    monthlyWeekOrdinal: MonthlyWeekOrdinal | undefined;
    monthlyDayOfWeek: MonthlyDayOfWeek | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    lookAheadDays: number | undefined;
    generationTime: TimeSpan | undefined;
    isGenUsingUserTimezone: boolean | undefined;
}

export class CreateRecurrenceSeriesOutputDto implements ICreateRecurrenceSeriesOutputDto {
    seriesId!: number | undefined;
    seedTaskId!: number | undefined;
    success!: boolean | undefined;
    message!: string | undefined;
    createdDate!: string | undefined;

    constructor(data?: ICreateRecurrenceSeriesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.seriesId = _data["seriesId"];
            this.seedTaskId = _data["seedTaskId"];
            this.success = _data["success"];
            this.message = _data["message"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateRecurrenceSeriesOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateRecurrenceSeriesOutputDto>(data, _mappings, CreateRecurrenceSeriesOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seriesId"] = this.seriesId;
        data["seedTaskId"] = this.seedTaskId;
        data["success"] = this.success;
        data["message"] = this.message;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface ICreateRecurrenceSeriesOutputDto {
    seriesId: number | undefined;
    seedTaskId: number | undefined;
    success: boolean | undefined;
    message: string | undefined;
    createdDate: string | undefined;
}

export class CreateRecurrenceSeriesOutputDtoIHandleError implements ICreateRecurrenceSeriesOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CreateRecurrenceSeriesOutputDto | undefined;
    listOfEntities!: CreateRecurrenceSeriesOutputDto[] | undefined;

    constructor(data?: ICreateRecurrenceSeriesOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CreateRecurrenceSeriesOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CreateRecurrenceSeriesOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateRecurrenceSeriesOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateRecurrenceSeriesOutputDtoIHandleError>(data, _mappings, CreateRecurrenceSeriesOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateRecurrenceSeriesOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CreateRecurrenceSeriesOutputDto | undefined;
    listOfEntities: CreateRecurrenceSeriesOutputDto[] | undefined;
}

export class UpdateRecurrenceSeriesInputDto implements IUpdateRecurrenceSeriesInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    seriesId!: number | undefined;
    recurrenceType!: RecurrenceType | undefined;
    intervalValue!: number | undefined;
    weeklyDays!: WeeklyDays | undefined;
    monthlyType!: MonthlyType | undefined;
    monthlyDayOfMonth!: number | undefined;
    monthlyWeekOrdinal!: MonthlyWeekOrdinal | undefined;
    monthlyDayOfWeek!: MonthlyDayOfWeek | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    lookAheadDays!: number | undefined;
    generationTime!: TimeSpan | undefined;
    isGenUsingUserTimezone!: boolean | undefined;

    constructor(data?: IUpdateRecurrenceSeriesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.seriesId = _data["seriesId"];
            this.recurrenceType = _data["recurrenceType"];
            this.intervalValue = _data["intervalValue"];
            this.weeklyDays = _data["weeklyDays"];
            this.monthlyType = _data["monthlyType"];
            this.monthlyDayOfMonth = _data["monthlyDayOfMonth"];
            this.monthlyWeekOrdinal = _data["monthlyWeekOrdinal"];
            this.monthlyDayOfWeek = _data["monthlyDayOfWeek"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.lookAheadDays = _data["lookAheadDays"];
            this.generationTime = _data["generationTime"] ? TimeSpan.fromJS(_data["generationTime"], _mappings) : undefined as any;
            this.isGenUsingUserTimezone = _data["isGenUsingUserTimezone"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateRecurrenceSeriesInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateRecurrenceSeriesInputDto>(data, _mappings, UpdateRecurrenceSeriesInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["seriesId"] = this.seriesId;
        data["recurrenceType"] = this.recurrenceType;
        data["intervalValue"] = this.intervalValue;
        data["weeklyDays"] = this.weeklyDays;
        data["monthlyType"] = this.monthlyType;
        data["monthlyDayOfMonth"] = this.monthlyDayOfMonth;
        data["monthlyWeekOrdinal"] = this.monthlyWeekOrdinal;
        data["monthlyDayOfWeek"] = this.monthlyDayOfWeek;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["lookAheadDays"] = this.lookAheadDays;
        data["generationTime"] = this.generationTime ? this.generationTime.toJSON() : undefined as any;
        data["isGenUsingUserTimezone"] = this.isGenUsingUserTimezone;
        return data;
    }
}

export interface IUpdateRecurrenceSeriesInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    seriesId: number | undefined;
    recurrenceType: RecurrenceType | undefined;
    intervalValue: number | undefined;
    weeklyDays: WeeklyDays | undefined;
    monthlyType: MonthlyType | undefined;
    monthlyDayOfMonth: number | undefined;
    monthlyWeekOrdinal: MonthlyWeekOrdinal | undefined;
    monthlyDayOfWeek: MonthlyDayOfWeek | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    lookAheadDays: number | undefined;
    generationTime: TimeSpan | undefined;
    isGenUsingUserTimezone: boolean | undefined;
}

export class UpdateRecurrenceSeriesOutputDto implements IUpdateRecurrenceSeriesOutputDto {
    seriesId!: number | undefined;
    success!: boolean | undefined;
    message!: string | undefined;
    updatedDate!: string | undefined;
    futureInstancesAffected!: number | undefined;

    constructor(data?: IUpdateRecurrenceSeriesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.seriesId = _data["seriesId"];
            this.success = _data["success"];
            this.message = _data["message"];
            this.updatedDate = _data["updatedDate"];
            this.futureInstancesAffected = _data["futureInstancesAffected"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateRecurrenceSeriesOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateRecurrenceSeriesOutputDto>(data, _mappings, UpdateRecurrenceSeriesOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seriesId"] = this.seriesId;
        data["success"] = this.success;
        data["message"] = this.message;
        data["updatedDate"] = this.updatedDate;
        data["futureInstancesAffected"] = this.futureInstancesAffected;
        return data;
    }
}

export interface IUpdateRecurrenceSeriesOutputDto {
    seriesId: number | undefined;
    success: boolean | undefined;
    message: string | undefined;
    updatedDate: string | undefined;
    futureInstancesAffected: number | undefined;
}

export class UpdateRecurrenceSeriesOutputDtoIHandleError implements IUpdateRecurrenceSeriesOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UpdateRecurrenceSeriesOutputDto | undefined;
    listOfEntities!: UpdateRecurrenceSeriesOutputDto[] | undefined;

    constructor(data?: IUpdateRecurrenceSeriesOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UpdateRecurrenceSeriesOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UpdateRecurrenceSeriesOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateRecurrenceSeriesOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateRecurrenceSeriesOutputDtoIHandleError>(data, _mappings, UpdateRecurrenceSeriesOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateRecurrenceSeriesOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UpdateRecurrenceSeriesOutputDto | undefined;
    listOfEntities: UpdateRecurrenceSeriesOutputDto[] | undefined;
}

export class StopRecurrenceSeriesOutputDto implements IStopRecurrenceSeriesOutputDto {
    seriesId!: number | undefined;
    success!: boolean | undefined;
    message!: string | undefined;
    stoppedDate!: string | undefined;
    existingInstancesCount!: number | undefined;

    constructor(data?: IStopRecurrenceSeriesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.seriesId = _data["seriesId"];
            this.success = _data["success"];
            this.message = _data["message"];
            this.stoppedDate = _data["stoppedDate"];
            this.existingInstancesCount = _data["existingInstancesCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): StopRecurrenceSeriesOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StopRecurrenceSeriesOutputDto>(data, _mappings, StopRecurrenceSeriesOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seriesId"] = this.seriesId;
        data["success"] = this.success;
        data["message"] = this.message;
        data["stoppedDate"] = this.stoppedDate;
        data["existingInstancesCount"] = this.existingInstancesCount;
        return data;
    }
}

export interface IStopRecurrenceSeriesOutputDto {
    seriesId: number | undefined;
    success: boolean | undefined;
    message: string | undefined;
    stoppedDate: string | undefined;
    existingInstancesCount: number | undefined;
}

export class StopRecurrenceSeriesOutputDtoIHandleError implements IStopRecurrenceSeriesOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: StopRecurrenceSeriesOutputDto | undefined;
    listOfEntities!: StopRecurrenceSeriesOutputDto[] | undefined;

    constructor(data?: IStopRecurrenceSeriesOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? StopRecurrenceSeriesOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(StopRecurrenceSeriesOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): StopRecurrenceSeriesOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StopRecurrenceSeriesOutputDtoIHandleError>(data, _mappings, StopRecurrenceSeriesOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStopRecurrenceSeriesOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: StopRecurrenceSeriesOutputDto | undefined;
    listOfEntities: StopRecurrenceSeriesOutputDto[] | undefined;
}

export class GetRecurrenceDetailsOutputDto implements IGetRecurrenceDetailsOutputDto {
    seriesId!: number | undefined;
    taskId!: number | undefined;
    isRecurring!: boolean | undefined;
    recurrenceType!: RecurrenceType | undefined;
    intervalValue!: number | undefined;
    weeklyDays!: WeeklyDays | undefined;
    monthlyType!: MonthlyType | undefined;
    monthlyDayOfMonth!: number | undefined;
    monthlyWeekOrdinal!: MonthlyWeekOrdinal | undefined;
    monthlyDayOfWeek!: MonthlyDayOfWeek | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    lookAheadDays!: number | undefined;
    generationTime!: TimeSpan | undefined;
    isActive!: boolean | undefined;
    createdDate!: string | undefined;
    nextOccurrences!: string[] | undefined;
    isGenUsingUserTimezone!: boolean | undefined;

    constructor(data?: IGetRecurrenceDetailsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.seriesId = _data["seriesId"];
            this.taskId = _data["taskId"];
            this.isRecurring = _data["isRecurring"];
            this.recurrenceType = _data["recurrenceType"];
            this.intervalValue = _data["intervalValue"];
            this.weeklyDays = _data["weeklyDays"];
            this.monthlyType = _data["monthlyType"];
            this.monthlyDayOfMonth = _data["monthlyDayOfMonth"];
            this.monthlyWeekOrdinal = _data["monthlyWeekOrdinal"];
            this.monthlyDayOfWeek = _data["monthlyDayOfWeek"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.lookAheadDays = _data["lookAheadDays"];
            this.generationTime = _data["generationTime"] ? TimeSpan.fromJS(_data["generationTime"], _mappings) : undefined as any;
            this.isActive = _data["isActive"];
            this.createdDate = _data["createdDate"];
            if (Array.isArray(_data["nextOccurrences"])) {
                this.nextOccurrences = [] as any;
                for (let item of _data["nextOccurrences"])
                    this.nextOccurrences!.push(item);
            }
            this.isGenUsingUserTimezone = _data["isGenUsingUserTimezone"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetRecurrenceDetailsOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetRecurrenceDetailsOutputDto>(data, _mappings, GetRecurrenceDetailsOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seriesId"] = this.seriesId;
        data["taskId"] = this.taskId;
        data["isRecurring"] = this.isRecurring;
        data["recurrenceType"] = this.recurrenceType;
        data["intervalValue"] = this.intervalValue;
        data["weeklyDays"] = this.weeklyDays;
        data["monthlyType"] = this.monthlyType;
        data["monthlyDayOfMonth"] = this.monthlyDayOfMonth;
        data["monthlyWeekOrdinal"] = this.monthlyWeekOrdinal;
        data["monthlyDayOfWeek"] = this.monthlyDayOfWeek;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["lookAheadDays"] = this.lookAheadDays;
        data["generationTime"] = this.generationTime ? this.generationTime.toJSON() : undefined as any;
        data["isActive"] = this.isActive;
        data["createdDate"] = this.createdDate;
        if (Array.isArray(this.nextOccurrences)) {
            data["nextOccurrences"] = [];
            for (let item of this.nextOccurrences)
                data["nextOccurrences"].push(item);
        }
        data["isGenUsingUserTimezone"] = this.isGenUsingUserTimezone;
        return data;
    }
}

export interface IGetRecurrenceDetailsOutputDto {
    seriesId: number | undefined;
    taskId: number | undefined;
    isRecurring: boolean | undefined;
    recurrenceType: RecurrenceType | undefined;
    intervalValue: number | undefined;
    weeklyDays: WeeklyDays | undefined;
    monthlyType: MonthlyType | undefined;
    monthlyDayOfMonth: number | undefined;
    monthlyWeekOrdinal: MonthlyWeekOrdinal | undefined;
    monthlyDayOfWeek: MonthlyDayOfWeek | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    lookAheadDays: number | undefined;
    generationTime: TimeSpan | undefined;
    isActive: boolean | undefined;
    createdDate: string | undefined;
    nextOccurrences: string[] | undefined;
    isGenUsingUserTimezone: boolean | undefined;
}

export class GetRecurrenceDetailsOutputDtoIHandleError implements IGetRecurrenceDetailsOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetRecurrenceDetailsOutputDto | undefined;
    listOfEntities!: GetRecurrenceDetailsOutputDto[] | undefined;

    constructor(data?: IGetRecurrenceDetailsOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetRecurrenceDetailsOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetRecurrenceDetailsOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetRecurrenceDetailsOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetRecurrenceDetailsOutputDtoIHandleError>(data, _mappings, GetRecurrenceDetailsOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetRecurrenceDetailsOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetRecurrenceDetailsOutputDto | undefined;
    listOfEntities: GetRecurrenceDetailsOutputDto[] | undefined;
}

export class SeriesInstanceDto implements ISeriesInstanceDto {
    instanceId!: number | undefined;
    taskId!: number | undefined;
    taskTitle!: string | undefined;
    occurrenceDate!: string | undefined;
    generatedDate!: string | undefined;
    taskStartDate!: string | undefined;
    taskDueDate!: string | undefined;
    isTaskCompleted!: boolean | undefined;
    isTaskDeleted!: boolean | undefined;
    taskStatus!: string | undefined;
    progressCompleted!: number | undefined;

    constructor(data?: ISeriesInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.instanceId = _data["instanceId"];
            this.taskId = _data["taskId"];
            this.taskTitle = _data["taskTitle"];
            this.occurrenceDate = _data["occurrenceDate"];
            this.generatedDate = _data["generatedDate"];
            this.taskStartDate = _data["taskStartDate"];
            this.taskDueDate = _data["taskDueDate"];
            this.isTaskCompleted = _data["isTaskCompleted"];
            this.isTaskDeleted = _data["isTaskDeleted"];
            this.taskStatus = _data["taskStatus"];
            this.progressCompleted = _data["progressCompleted"];
        }
    }

    static fromJS(data: any, _mappings?: any): SeriesInstanceDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SeriesInstanceDto>(data, _mappings, SeriesInstanceDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceId"] = this.instanceId;
        data["taskId"] = this.taskId;
        data["taskTitle"] = this.taskTitle;
        data["occurrenceDate"] = this.occurrenceDate;
        data["generatedDate"] = this.generatedDate;
        data["taskStartDate"] = this.taskStartDate;
        data["taskDueDate"] = this.taskDueDate;
        data["isTaskCompleted"] = this.isTaskCompleted;
        data["isTaskDeleted"] = this.isTaskDeleted;
        data["taskStatus"] = this.taskStatus;
        data["progressCompleted"] = this.progressCompleted;
        return data;
    }
}

export interface ISeriesInstanceDto {
    instanceId: number | undefined;
    taskId: number | undefined;
    taskTitle: string | undefined;
    occurrenceDate: string | undefined;
    generatedDate: string | undefined;
    taskStartDate: string | undefined;
    taskDueDate: string | undefined;
    isTaskCompleted: boolean | undefined;
    isTaskDeleted: boolean | undefined;
    taskStatus: string | undefined;
    progressCompleted: number | undefined;
}

export class GetSeriesInstancesOutputDto implements IGetSeriesInstancesOutputDto {
    seriesId!: number | undefined;
    instances!: SeriesInstanceDto[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IGetSeriesInstancesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.seriesId = _data["seriesId"];
            if (Array.isArray(_data["instances"])) {
                this.instances = [] as any;
                for (let item of _data["instances"])
                    this.instances!.push(SeriesInstanceDto.fromJS(item, _mappings));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetSeriesInstancesOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetSeriesInstancesOutputDto>(data, _mappings, GetSeriesInstancesOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seriesId"] = this.seriesId;
        if (Array.isArray(this.instances)) {
            data["instances"] = [];
            for (let item of this.instances)
                data["instances"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IGetSeriesInstancesOutputDto {
    seriesId: number | undefined;
    instances: SeriesInstanceDto[] | undefined;
    totalCount: number | undefined;
}

export class GetSeriesInstancesOutputDtoIHandleError implements IGetSeriesInstancesOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetSeriesInstancesOutputDto | undefined;
    listOfEntities!: GetSeriesInstancesOutputDto[] | undefined;

    constructor(data?: IGetSeriesInstancesOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetSeriesInstancesOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetSeriesInstancesOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetSeriesInstancesOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetSeriesInstancesOutputDtoIHandleError>(data, _mappings, GetSeriesInstancesOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetSeriesInstancesOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetSeriesInstancesOutputDto | undefined;
    listOfEntities: GetSeriesInstancesOutputDto[] | undefined;
}

export class GetUpcomingOccurrencesInputDto implements IGetUpcomingOccurrencesInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    seriesId!: number | undefined;
    count!: number | undefined;
    startDate!: string | undefined;

    constructor(data?: IGetUpcomingOccurrencesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.seriesId = _data["seriesId"];
            this.count = _data["count"];
            this.startDate = _data["startDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetUpcomingOccurrencesInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUpcomingOccurrencesInputDto>(data, _mappings, GetUpcomingOccurrencesInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["seriesId"] = this.seriesId;
        data["count"] = this.count;
        data["startDate"] = this.startDate;
        return data;
    }
}

export interface IGetUpcomingOccurrencesInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    seriesId: number | undefined;
    count: number | undefined;
    startDate: string | undefined;
}

export class GetUpcomingOccurrencesOutputDto implements IGetUpcomingOccurrencesOutputDto {
    seriesId!: number | undefined;
    upcomingOccurrences!: string[] | undefined;
    recurrenceType!: RecurrenceType | undefined;
    recurrenceDescription!: string | undefined;

    constructor(data?: IGetUpcomingOccurrencesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.seriesId = _data["seriesId"];
            if (Array.isArray(_data["upcomingOccurrences"])) {
                this.upcomingOccurrences = [] as any;
                for (let item of _data["upcomingOccurrences"])
                    this.upcomingOccurrences!.push(item);
            }
            this.recurrenceType = _data["recurrenceType"];
            this.recurrenceDescription = _data["recurrenceDescription"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetUpcomingOccurrencesOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUpcomingOccurrencesOutputDto>(data, _mappings, GetUpcomingOccurrencesOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seriesId"] = this.seriesId;
        if (Array.isArray(this.upcomingOccurrences)) {
            data["upcomingOccurrences"] = [];
            for (let item of this.upcomingOccurrences)
                data["upcomingOccurrences"].push(item);
        }
        data["recurrenceType"] = this.recurrenceType;
        data["recurrenceDescription"] = this.recurrenceDescription;
        return data;
    }
}

export interface IGetUpcomingOccurrencesOutputDto {
    seriesId: number | undefined;
    upcomingOccurrences: string[] | undefined;
    recurrenceType: RecurrenceType | undefined;
    recurrenceDescription: string | undefined;
}

export class GetUpcomingOccurrencesOutputDtoIHandleError implements IGetUpcomingOccurrencesOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetUpcomingOccurrencesOutputDto | undefined;
    listOfEntities!: GetUpcomingOccurrencesOutputDto[] | undefined;

    constructor(data?: IGetUpcomingOccurrencesOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetUpcomingOccurrencesOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetUpcomingOccurrencesOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetUpcomingOccurrencesOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUpcomingOccurrencesOutputDtoIHandleError>(data, _mappings, GetUpcomingOccurrencesOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetUpcomingOccurrencesOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetUpcomingOccurrencesOutputDto | undefined;
    listOfEntities: GetUpcomingOccurrencesOutputDto[] | undefined;
}

export class GenerateSeriesInstancesInputDto implements IGenerateSeriesInstancesInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    seriesId!: number | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;

    constructor(data?: IGenerateSeriesInstancesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.seriesId = _data["seriesId"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): GenerateSeriesInstancesInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GenerateSeriesInstancesInputDto>(data, _mappings, GenerateSeriesInstancesInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["seriesId"] = this.seriesId;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IGenerateSeriesInstancesInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    seriesId: number | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
}

export class GenerateSeriesInstancesOutputDto implements IGenerateSeriesInstancesOutputDto {
    seriesId!: number | undefined;
    generatedCount!: number | undefined;
    skippedCount!: number | undefined;
    generatedTaskIds!: number[] | undefined;
    success!: boolean | undefined;
    message!: string | undefined;
    generationDate!: string | undefined;

    constructor(data?: IGenerateSeriesInstancesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.seriesId = _data["seriesId"];
            this.generatedCount = _data["generatedCount"];
            this.skippedCount = _data["skippedCount"];
            if (Array.isArray(_data["generatedTaskIds"])) {
                this.generatedTaskIds = [] as any;
                for (let item of _data["generatedTaskIds"])
                    this.generatedTaskIds!.push(item);
            }
            this.success = _data["success"];
            this.message = _data["message"];
            this.generationDate = _data["generationDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): GenerateSeriesInstancesOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GenerateSeriesInstancesOutputDto>(data, _mappings, GenerateSeriesInstancesOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seriesId"] = this.seriesId;
        data["generatedCount"] = this.generatedCount;
        data["skippedCount"] = this.skippedCount;
        if (Array.isArray(this.generatedTaskIds)) {
            data["generatedTaskIds"] = [];
            for (let item of this.generatedTaskIds)
                data["generatedTaskIds"].push(item);
        }
        data["success"] = this.success;
        data["message"] = this.message;
        data["generationDate"] = this.generationDate;
        return data;
    }
}

export interface IGenerateSeriesInstancesOutputDto {
    seriesId: number | undefined;
    generatedCount: number | undefined;
    skippedCount: number | undefined;
    generatedTaskIds: number[] | undefined;
    success: boolean | undefined;
    message: string | undefined;
    generationDate: string | undefined;
}

export class GenerateSeriesInstancesOutputDtoIHandleError implements IGenerateSeriesInstancesOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GenerateSeriesInstancesOutputDto | undefined;
    listOfEntities!: GenerateSeriesInstancesOutputDto[] | undefined;

    constructor(data?: IGenerateSeriesInstancesOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GenerateSeriesInstancesOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GenerateSeriesInstancesOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GenerateSeriesInstancesOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GenerateSeriesInstancesOutputDtoIHandleError>(data, _mappings, GenerateSeriesInstancesOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGenerateSeriesInstancesOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GenerateSeriesInstancesOutputDto | undefined;
    listOfEntities: GenerateSeriesInstancesOutputDto[] | undefined;
}

export class GetTaskSeriesOutputDto implements IGetTaskSeriesOutputDto {
    seriesId!: number | undefined;
    isPartOfSeries!: boolean | undefined;
    seedTaskId!: number | undefined;
    seedTaskTitle!: string | undefined;
    recurrenceType!: RecurrenceType | undefined;
    recurrenceDescription!: string | undefined;
    seriesStartDate!: string | undefined;
    seriesEndDate!: string | undefined;
    isSeriesActive!: boolean | undefined;
    totalInstancesGenerated!: number | undefined;

    constructor(data?: IGetTaskSeriesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.seriesId = _data["seriesId"];
            this.isPartOfSeries = _data["isPartOfSeries"];
            this.seedTaskId = _data["seedTaskId"];
            this.seedTaskTitle = _data["seedTaskTitle"];
            this.recurrenceType = _data["recurrenceType"];
            this.recurrenceDescription = _data["recurrenceDescription"];
            this.seriesStartDate = _data["seriesStartDate"];
            this.seriesEndDate = _data["seriesEndDate"];
            this.isSeriesActive = _data["isSeriesActive"];
            this.totalInstancesGenerated = _data["totalInstancesGenerated"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetTaskSeriesOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetTaskSeriesOutputDto>(data, _mappings, GetTaskSeriesOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seriesId"] = this.seriesId;
        data["isPartOfSeries"] = this.isPartOfSeries;
        data["seedTaskId"] = this.seedTaskId;
        data["seedTaskTitle"] = this.seedTaskTitle;
        data["recurrenceType"] = this.recurrenceType;
        data["recurrenceDescription"] = this.recurrenceDescription;
        data["seriesStartDate"] = this.seriesStartDate;
        data["seriesEndDate"] = this.seriesEndDate;
        data["isSeriesActive"] = this.isSeriesActive;
        data["totalInstancesGenerated"] = this.totalInstancesGenerated;
        return data;
    }
}

export interface IGetTaskSeriesOutputDto {
    seriesId: number | undefined;
    isPartOfSeries: boolean | undefined;
    seedTaskId: number | undefined;
    seedTaskTitle: string | undefined;
    recurrenceType: RecurrenceType | undefined;
    recurrenceDescription: string | undefined;
    seriesStartDate: string | undefined;
    seriesEndDate: string | undefined;
    isSeriesActive: boolean | undefined;
    totalInstancesGenerated: number | undefined;
}

export class GetTaskSeriesOutputDtoIHandleError implements IGetTaskSeriesOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetTaskSeriesOutputDto | undefined;
    listOfEntities!: GetTaskSeriesOutputDto[] | undefined;

    constructor(data?: IGetTaskSeriesOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetTaskSeriesOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetTaskSeriesOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetTaskSeriesOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetTaskSeriesOutputDtoIHandleError>(data, _mappings, GetTaskSeriesOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTaskSeriesOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetTaskSeriesOutputDto | undefined;
    listOfEntities: GetTaskSeriesOutputDto[] | undefined;
}

export class ValidateRecurrenceRuleInputDto implements IValidateRecurrenceRuleInputDto {
    recurrenceType!: RecurrenceType | undefined;
    intervalValue!: number | undefined;
    weeklyDays!: WeeklyDays | undefined;
    monthlyType!: MonthlyType | undefined;
    monthlyDayOfMonth!: number | undefined;
    monthlyWeekOrdinal!: MonthlyWeekOrdinal | undefined;
    monthlyDayOfWeek!: MonthlyDayOfWeek | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    lookAheadDays!: number | undefined;
    generationTime!: TimeSpan | undefined;

    constructor(data?: IValidateRecurrenceRuleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.recurrenceType = _data["recurrenceType"];
            this.intervalValue = _data["intervalValue"];
            this.weeklyDays = _data["weeklyDays"];
            this.monthlyType = _data["monthlyType"];
            this.monthlyDayOfMonth = _data["monthlyDayOfMonth"];
            this.monthlyWeekOrdinal = _data["monthlyWeekOrdinal"];
            this.monthlyDayOfWeek = _data["monthlyDayOfWeek"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.lookAheadDays = _data["lookAheadDays"];
            this.generationTime = _data["generationTime"] ? TimeSpan.fromJS(_data["generationTime"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): ValidateRecurrenceRuleInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValidateRecurrenceRuleInputDto>(data, _mappings, ValidateRecurrenceRuleInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recurrenceType"] = this.recurrenceType;
        data["intervalValue"] = this.intervalValue;
        data["weeklyDays"] = this.weeklyDays;
        data["monthlyType"] = this.monthlyType;
        data["monthlyDayOfMonth"] = this.monthlyDayOfMonth;
        data["monthlyWeekOrdinal"] = this.monthlyWeekOrdinal;
        data["monthlyDayOfWeek"] = this.monthlyDayOfWeek;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["lookAheadDays"] = this.lookAheadDays;
        data["generationTime"] = this.generationTime ? this.generationTime.toJSON() : undefined as any;
        return data;
    }
}

export interface IValidateRecurrenceRuleInputDto {
    recurrenceType: RecurrenceType | undefined;
    intervalValue: number | undefined;
    weeklyDays: WeeklyDays | undefined;
    monthlyType: MonthlyType | undefined;
    monthlyDayOfMonth: number | undefined;
    monthlyWeekOrdinal: MonthlyWeekOrdinal | undefined;
    monthlyDayOfWeek: MonthlyDayOfWeek | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    lookAheadDays: number | undefined;
    generationTime: TimeSpan | undefined;
}

export class ValidateRecurrenceRuleOutputDto implements IValidateRecurrenceRuleOutputDto {
    isValid!: boolean | undefined;
    validationErrors!: string[] | undefined;
    recurrenceDescription!: string | undefined;

    constructor(data?: IValidateRecurrenceRuleOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(item);
            }
            this.recurrenceDescription = _data["recurrenceDescription"];
        }
    }

    static fromJS(data: any, _mappings?: any): ValidateRecurrenceRuleOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValidateRecurrenceRuleOutputDto>(data, _mappings, ValidateRecurrenceRuleOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        data["recurrenceDescription"] = this.recurrenceDescription;
        return data;
    }
}

export interface IValidateRecurrenceRuleOutputDto {
    isValid: boolean | undefined;
    validationErrors: string[] | undefined;
    recurrenceDescription: string | undefined;
}

export class ValidateRecurrenceRuleOutputDtoIHandleError implements IValidateRecurrenceRuleOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ValidateRecurrenceRuleOutputDto | undefined;
    listOfEntities!: ValidateRecurrenceRuleOutputDto[] | undefined;

    constructor(data?: IValidateRecurrenceRuleOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ValidateRecurrenceRuleOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ValidateRecurrenceRuleOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ValidateRecurrenceRuleOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ValidateRecurrenceRuleOutputDtoIHandleError>(data, _mappings, ValidateRecurrenceRuleOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidateRecurrenceRuleOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ValidateRecurrenceRuleOutputDto | undefined;
    listOfEntities: ValidateRecurrenceRuleOutputDto[] | undefined;
}

export class TaskAssigneOutput implements ITaskAssigneOutput {
    toUserId!: number | undefined;
    toUserFullName!: string | undefined;
    toUserEmail!: string | undefined;
    byUserId!: number | undefined;
    byUserFullName!: string | undefined;
    byUserEmail!: string | undefined;
    isSeen!: boolean | undefined;
    isNewlyAssigned!: boolean | undefined;
    toProfilePictureId!: string | undefined;
    toProfilePictureUrl!: string | undefined;
    byProfilePictureId!: string | undefined;
    byProfilePictureUrl!: string | undefined;
    toUserName!: string | undefined;
    byUserName!: string | undefined;

    constructor(data?: ITaskAssigneOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.toUserId = _data["toUserId"];
            this.toUserFullName = _data["toUserFullName"];
            this.toUserEmail = _data["toUserEmail"];
            this.byUserId = _data["byUserId"];
            this.byUserFullName = _data["byUserFullName"];
            this.byUserEmail = _data["byUserEmail"];
            this.isSeen = _data["isSeen"];
            this.isNewlyAssigned = _data["isNewlyAssigned"];
            this.toProfilePictureId = _data["toProfilePictureId"];
            this.toProfilePictureUrl = _data["toProfilePictureUrl"];
            this.byProfilePictureId = _data["byProfilePictureId"];
            this.byProfilePictureUrl = _data["byProfilePictureUrl"];
            this.toUserName = _data["toUserName"];
            this.byUserName = _data["byUserName"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskAssigneOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskAssigneOutput>(data, _mappings, TaskAssigneOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toUserId"] = this.toUserId;
        data["toUserFullName"] = this.toUserFullName;
        data["toUserEmail"] = this.toUserEmail;
        data["byUserId"] = this.byUserId;
        data["byUserFullName"] = this.byUserFullName;
        data["byUserEmail"] = this.byUserEmail;
        data["isSeen"] = this.isSeen;
        data["isNewlyAssigned"] = this.isNewlyAssigned;
        data["toProfilePictureId"] = this.toProfilePictureId;
        data["toProfilePictureUrl"] = this.toProfilePictureUrl;
        data["byProfilePictureId"] = this.byProfilePictureId;
        data["byProfilePictureUrl"] = this.byProfilePictureUrl;
        data["toUserName"] = this.toUserName;
        data["byUserName"] = this.byUserName;
        return data;
    }
}

export interface ITaskAssigneOutput {
    toUserId: number | undefined;
    toUserFullName: string | undefined;
    toUserEmail: string | undefined;
    byUserId: number | undefined;
    byUserFullName: string | undefined;
    byUserEmail: string | undefined;
    isSeen: boolean | undefined;
    isNewlyAssigned: boolean | undefined;
    toProfilePictureId: string | undefined;
    toProfilePictureUrl: string | undefined;
    byProfilePictureId: string | undefined;
    byProfilePictureUrl: string | undefined;
    toUserName: string | undefined;
    byUserName: string | undefined;
}

export class CheckLists implements ICheckLists {
    id!: number | undefined;
    title!: string | undefined;
    dueDate!: string | undefined;
    description!: string | undefined;
    ownerId!: number | undefined;
    code!: number | undefined;
    taskId!: number | undefined;
    keyId!: string | undefined;
    sortOrder!: number | undefined;
    agendaType!: AgendaType | undefined;
    isCompleted!: boolean | undefined;
    hasDescription!: boolean | undefined;
    isStrikeThrough!: string | undefined;
    actionPerformed!: string | undefined;
    isSeen!: boolean | undefined;
    assignedToId!: number | undefined;

    constructor(data?: ICheckLists) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.dueDate = _data["dueDate"];
            this.description = _data["description"];
            this.ownerId = _data["ownerId"];
            this.code = _data["code"];
            this.taskId = _data["taskId"];
            this.keyId = _data["keyId"];
            this.sortOrder = _data["sortOrder"];
            this.agendaType = _data["agendaType"];
            this.isCompleted = _data["isCompleted"];
            this.hasDescription = _data["hasDescription"];
            this.isStrikeThrough = _data["isStrikeThrough"];
            this.actionPerformed = _data["actionPerformed"];
            this.isSeen = _data["isSeen"];
            this.assignedToId = _data["assignedToId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CheckLists | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckLists>(data, _mappings, CheckLists);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["dueDate"] = this.dueDate;
        data["description"] = this.description;
        data["ownerId"] = this.ownerId;
        data["code"] = this.code;
        data["taskId"] = this.taskId;
        data["keyId"] = this.keyId;
        data["sortOrder"] = this.sortOrder;
        data["agendaType"] = this.agendaType;
        data["isCompleted"] = this.isCompleted;
        data["hasDescription"] = this.hasDescription;
        data["isStrikeThrough"] = this.isStrikeThrough;
        data["actionPerformed"] = this.actionPerformed;
        data["isSeen"] = this.isSeen;
        data["assignedToId"] = this.assignedToId;
        return data;
    }
}

export interface ICheckLists {
    id: number | undefined;
    title: string | undefined;
    dueDate: string | undefined;
    description: string | undefined;
    ownerId: number | undefined;
    code: number | undefined;
    taskId: number | undefined;
    keyId: string | undefined;
    sortOrder: number | undefined;
    agendaType: AgendaType | undefined;
    isCompleted: boolean | undefined;
    hasDescription: boolean | undefined;
    isStrikeThrough: string | undefined;
    actionPerformed: string | undefined;
    isSeen: boolean | undefined;
    assignedToId: number | undefined;
}

export class TaskHistoryDto implements ITaskHistoryDto {
    history!: string | undefined;
    createdBy!: string | undefined;
    userImg!: string | undefined;
    userInitials!: string | undefined;
    creationTime!: string | undefined;

    constructor(data?: ITaskHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.history = _data["history"];
            this.createdBy = _data["createdBy"];
            this.userImg = _data["userImg"];
            this.userInitials = _data["userInitials"];
            this.creationTime = _data["creationTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskHistoryDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskHistoryDto>(data, _mappings, TaskHistoryDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["history"] = this.history;
        data["createdBy"] = this.createdBy;
        data["userImg"] = this.userImg;
        data["userInitials"] = this.userInitials;
        data["creationTime"] = this.creationTime;
        return data;
    }
}

export interface ITaskHistoryDto {
    history: string | undefined;
    createdBy: string | undefined;
    userImg: string | undefined;
    userInitials: string | undefined;
    creationTime: string | undefined;
}

export class BotProjectSectionDto implements IBotProjectSectionDto {
    value!: number | undefined;
    title!: string | undefined;

    constructor(data?: IBotProjectSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.value = _data["value"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any, _mappings?: any): BotProjectSectionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BotProjectSectionDto>(data, _mappings, BotProjectSectionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["title"] = this.title;
        return data;
    }
}

export interface IBotProjectSectionDto {
    value: number | undefined;
    title: string | undefined;
}

export class TaskDetails implements ITaskDetails {
    id!: number | undefined;
    title!: string | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    userName!: string | undefined;
    userSurName!: string | undefined;
    statusCode!: number | undefined;
    profilePictureUrl!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    completedOn!: string | undefined;
    predecessor!: number | undefined;
    startDelay!: number | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    progressCompleted!: number | undefined;
    ownerId!: number | undefined;
    code!: number | undefined;
    agendaType!: AgendaType | undefined;
    integrationId!: string | undefined;
    integratedFrom!: string | undefined;
    integrationIcon!: string | undefined;
    integrationCode!: number | undefined;
    projectName!: string | undefined;
    tag1!: string | undefined;
    tag2!: string | undefined;
    tag3!: string | undefined;
    color!: string | undefined;
    webUrl!: string | undefined;
    assignes!: string | undefined;
    taskAssignes!: TaskAssigneOutput[] | undefined;
    keyId!: string | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    bucketId!: string | undefined;
    checkLists!: string | undefined;
    taskCheckLists!: CheckLists[] | undefined;
    attachments!: string | undefined;
    taskAttachments!: TaskAttachment[] | undefined;
    history!: string | undefined;
    taskHistory!: TaskHistoryDto[] | undefined;
    comment!: string | undefined;
    taskComments!: TaskCommentDto[] | undefined;
    projectAttachmentCount!: number | undefined;
    projectId!: number | undefined;
    isPrivateProject!: boolean | undefined;
    taskProjectName!: string | undefined;
    projectSectionId!: number | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    bgColor!: string | undefined;
    projectColor!: string | undefined;
    resourceAppUrl!: string | undefined;
    resourceName!: string | undefined;
    resourceIconUrl!: string | undefined;
    resourceAppIntegrationId!: number | undefined;
    isPrivate!: boolean | undefined;
    isAssignedToProject!: boolean | undefined;
    isAssignedToPrivateProject!: boolean | undefined;
    isReAssigned!: boolean | undefined;
    assignedToUserId!: number | undefined;
    assignedToUserName!: string | undefined;
    assignedToProfPic!: string | undefined;
    taskCommentCount!: number | undefined;
    sections!: string | undefined;
    projectSections!: BotProjectSectionDto[] | undefined;
    apiKey!: string | undefined;
    priority!: TaskPriority | undefined;
    entityType!: TaskEntityType | undefined;
    entityName!: string | undefined;
    taskType!: TaskTypes | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactEmail!: string | undefined;
    contactCompanyId!: number | undefined;
    contactCompanyName!: string | undefined;
    contactTypeColor!: string | undefined;
    isAddedOnMyDay!: boolean | undefined;
    isSuggestAiTasks!: boolean | undefined;
    isDueDatePassed!: boolean | undefined;
    taskAssociationsAsJson!: string | undefined;
    taskAssociations!: TaskAssociation[] | undefined;
    userSectionId!: number | undefined;
    isProjectHaveChecklist!: boolean | undefined;
    parentId!: number | undefined;
    duration!: number | undefined;
    isBlocked!: boolean | undefined;
    blockedByCount!: number | undefined;
    nextCount!: number | undefined;
    blockerTaskId!: number | undefined;
    blockerTitle!: string | undefined;
    blockerAssigneeName!: string | undefined;
    blockerDueDate!: string | undefined;
    isPartOfTaskTree!: boolean | undefined;
    recurringSeriesId!: number | undefined;
    hasRecurringSeries!: boolean | undefined;
    tenantId!: number | undefined;
    isSeen!: boolean | undefined;
    toUserEmail!: string | undefined;
    byUserEmail!: string | undefined;
    byUserFullName!: string | undefined;
    byUserId!: number | undefined;
    contributors!: TaskContributorDto[] | undefined;
    actionPerformed!: string | undefined;

    constructor(data?: ITaskDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.userName = _data["userName"];
            this.userSurName = _data["userSurName"];
            this.statusCode = _data["statusCode"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.completedOn = _data["completedOn"];
            this.predecessor = _data["predecessor"];
            this.startDelay = _data["startDelay"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.progressCompleted = _data["progressCompleted"];
            this.ownerId = _data["ownerId"];
            this.code = _data["code"];
            this.agendaType = _data["agendaType"];
            this.integrationId = _data["integrationId"];
            this.integratedFrom = _data["integratedFrom"];
            this.integrationIcon = _data["integrationIcon"];
            this.integrationCode = _data["integrationCode"];
            this.projectName = _data["projectName"];
            this.tag1 = _data["tag1"];
            this.tag2 = _data["tag2"];
            this.tag3 = _data["tag3"];
            this.color = _data["color"];
            this.webUrl = _data["webUrl"];
            this.assignes = _data["assignes"];
            if (Array.isArray(_data["taskAssignes"])) {
                this.taskAssignes = [] as any;
                for (let item of _data["taskAssignes"])
                    this.taskAssignes!.push(TaskAssigneOutput.fromJS(item, _mappings));
            }
            this.keyId = _data["keyId"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.bucketId = _data["bucketId"];
            this.checkLists = _data["checkLists"];
            if (Array.isArray(_data["taskCheckLists"])) {
                this.taskCheckLists = [] as any;
                for (let item of _data["taskCheckLists"])
                    this.taskCheckLists!.push(CheckLists.fromJS(item, _mappings));
            }
            this.attachments = _data["attachments"];
            if (Array.isArray(_data["taskAttachments"])) {
                this.taskAttachments = [] as any;
                for (let item of _data["taskAttachments"])
                    this.taskAttachments!.push(TaskAttachment.fromJS(item, _mappings));
            }
            this.history = _data["history"];
            if (Array.isArray(_data["taskHistory"])) {
                this.taskHistory = [] as any;
                for (let item of _data["taskHistory"])
                    this.taskHistory!.push(TaskHistoryDto.fromJS(item, _mappings));
            }
            this.comment = _data["comment"];
            if (Array.isArray(_data["taskComments"])) {
                this.taskComments = [] as any;
                for (let item of _data["taskComments"])
                    this.taskComments!.push(TaskCommentDto.fromJS(item, _mappings));
            }
            this.projectAttachmentCount = _data["projectAttachmentCount"];
            this.projectId = _data["projectId"];
            this.isPrivateProject = _data["isPrivateProject"];
            this.taskProjectName = _data["taskProjectName"];
            this.projectSectionId = _data["projectSectionId"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.bgColor = _data["bgColor"];
            this.projectColor = _data["projectColor"];
            this.resourceAppUrl = _data["resourceAppUrl"];
            this.resourceName = _data["resourceName"];
            this.resourceIconUrl = _data["resourceIconUrl"];
            this.resourceAppIntegrationId = _data["resourceAppIntegrationId"];
            this.isPrivate = _data["isPrivate"];
            this.isAssignedToProject = _data["isAssignedToProject"];
            this.isAssignedToPrivateProject = _data["isAssignedToPrivateProject"];
            this.isReAssigned = _data["isReAssigned"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUserName = _data["assignedToUserName"];
            this.assignedToProfPic = _data["assignedToProfPic"];
            this.taskCommentCount = _data["taskCommentCount"];
            this.sections = _data["sections"];
            if (Array.isArray(_data["projectSections"])) {
                this.projectSections = [] as any;
                for (let item of _data["projectSections"])
                    this.projectSections!.push(BotProjectSectionDto.fromJS(item, _mappings));
            }
            this.apiKey = _data["apiKey"];
            this.priority = _data["priority"];
            this.entityType = _data["entityType"];
            this.entityName = _data["entityName"];
            this.taskType = _data["taskType"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactCompanyId = _data["contactCompanyId"];
            this.contactCompanyName = _data["contactCompanyName"];
            this.contactTypeColor = _data["contactTypeColor"];
            this.isAddedOnMyDay = _data["isAddedOnMyDay"];
            this.isSuggestAiTasks = _data["isSuggestAiTasks"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.taskAssociationsAsJson = _data["taskAssociationsAsJson"];
            if (Array.isArray(_data["taskAssociations"])) {
                this.taskAssociations = [] as any;
                for (let item of _data["taskAssociations"])
                    this.taskAssociations!.push(TaskAssociation.fromJS(item, _mappings));
            }
            this.userSectionId = _data["userSectionId"];
            this.isProjectHaveChecklist = _data["isProjectHaveChecklist"];
            this.parentId = _data["parentId"];
            this.duration = _data["duration"];
            this.isBlocked = _data["isBlocked"];
            this.blockedByCount = _data["blockedByCount"];
            this.nextCount = _data["nextCount"];
            this.blockerTaskId = _data["blockerTaskId"];
            this.blockerTitle = _data["blockerTitle"];
            this.blockerAssigneeName = _data["blockerAssigneeName"];
            this.blockerDueDate = _data["blockerDueDate"];
            this.isPartOfTaskTree = _data["isPartOfTaskTree"];
            this.recurringSeriesId = _data["recurringSeriesId"];
            this.hasRecurringSeries = _data["hasRecurringSeries"];
            this.tenantId = _data["tenantId"];
            this.isSeen = _data["isSeen"];
            this.toUserEmail = _data["toUserEmail"];
            this.byUserEmail = _data["byUserEmail"];
            this.byUserFullName = _data["byUserFullName"];
            this.byUserId = _data["byUserId"];
            if (Array.isArray(_data["contributors"])) {
                this.contributors = [] as any;
                for (let item of _data["contributors"])
                    this.contributors!.push(TaskContributorDto.fromJS(item, _mappings));
            }
            this.actionPerformed = _data["actionPerformed"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskDetails>(data, _mappings, TaskDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["userName"] = this.userName;
        data["userSurName"] = this.userSurName;
        data["statusCode"] = this.statusCode;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["completedOn"] = this.completedOn;
        data["predecessor"] = this.predecessor;
        data["startDelay"] = this.startDelay;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["progressCompleted"] = this.progressCompleted;
        data["ownerId"] = this.ownerId;
        data["code"] = this.code;
        data["agendaType"] = this.agendaType;
        data["integrationId"] = this.integrationId;
        data["integratedFrom"] = this.integratedFrom;
        data["integrationIcon"] = this.integrationIcon;
        data["integrationCode"] = this.integrationCode;
        data["projectName"] = this.projectName;
        data["tag1"] = this.tag1;
        data["tag2"] = this.tag2;
        data["tag3"] = this.tag3;
        data["color"] = this.color;
        data["webUrl"] = this.webUrl;
        data["assignes"] = this.assignes;
        if (Array.isArray(this.taskAssignes)) {
            data["taskAssignes"] = [];
            for (let item of this.taskAssignes)
                data["taskAssignes"].push(item ? item.toJSON() : undefined as any);
        }
        data["keyId"] = this.keyId;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["bucketId"] = this.bucketId;
        data["checkLists"] = this.checkLists;
        if (Array.isArray(this.taskCheckLists)) {
            data["taskCheckLists"] = [];
            for (let item of this.taskCheckLists)
                data["taskCheckLists"].push(item ? item.toJSON() : undefined as any);
        }
        data["attachments"] = this.attachments;
        if (Array.isArray(this.taskAttachments)) {
            data["taskAttachments"] = [];
            for (let item of this.taskAttachments)
                data["taskAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["history"] = this.history;
        if (Array.isArray(this.taskHistory)) {
            data["taskHistory"] = [];
            for (let item of this.taskHistory)
                data["taskHistory"].push(item ? item.toJSON() : undefined as any);
        }
        data["comment"] = this.comment;
        if (Array.isArray(this.taskComments)) {
            data["taskComments"] = [];
            for (let item of this.taskComments)
                data["taskComments"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectAttachmentCount"] = this.projectAttachmentCount;
        data["projectId"] = this.projectId;
        data["isPrivateProject"] = this.isPrivateProject;
        data["taskProjectName"] = this.taskProjectName;
        data["projectSectionId"] = this.projectSectionId;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["bgColor"] = this.bgColor;
        data["projectColor"] = this.projectColor;
        data["resourceAppUrl"] = this.resourceAppUrl;
        data["resourceName"] = this.resourceName;
        data["resourceIconUrl"] = this.resourceIconUrl;
        data["resourceAppIntegrationId"] = this.resourceAppIntegrationId;
        data["isPrivate"] = this.isPrivate;
        data["isAssignedToProject"] = this.isAssignedToProject;
        data["isAssignedToPrivateProject"] = this.isAssignedToPrivateProject;
        data["isReAssigned"] = this.isReAssigned;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUserName"] = this.assignedToUserName;
        data["assignedToProfPic"] = this.assignedToProfPic;
        data["taskCommentCount"] = this.taskCommentCount;
        data["sections"] = this.sections;
        if (Array.isArray(this.projectSections)) {
            data["projectSections"] = [];
            for (let item of this.projectSections)
                data["projectSections"].push(item ? item.toJSON() : undefined as any);
        }
        data["apiKey"] = this.apiKey;
        data["priority"] = this.priority;
        data["entityType"] = this.entityType;
        data["entityName"] = this.entityName;
        data["taskType"] = this.taskType;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactCompanyId"] = this.contactCompanyId;
        data["contactCompanyName"] = this.contactCompanyName;
        data["contactTypeColor"] = this.contactTypeColor;
        data["isAddedOnMyDay"] = this.isAddedOnMyDay;
        data["isSuggestAiTasks"] = this.isSuggestAiTasks;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["taskAssociationsAsJson"] = this.taskAssociationsAsJson;
        if (Array.isArray(this.taskAssociations)) {
            data["taskAssociations"] = [];
            for (let item of this.taskAssociations)
                data["taskAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        data["userSectionId"] = this.userSectionId;
        data["isProjectHaveChecklist"] = this.isProjectHaveChecklist;
        data["parentId"] = this.parentId;
        data["duration"] = this.duration;
        data["isBlocked"] = this.isBlocked;
        data["blockedByCount"] = this.blockedByCount;
        data["nextCount"] = this.nextCount;
        data["blockerTaskId"] = this.blockerTaskId;
        data["blockerTitle"] = this.blockerTitle;
        data["blockerAssigneeName"] = this.blockerAssigneeName;
        data["blockerDueDate"] = this.blockerDueDate;
        data["isPartOfTaskTree"] = this.isPartOfTaskTree;
        data["recurringSeriesId"] = this.recurringSeriesId;
        data["hasRecurringSeries"] = this.hasRecurringSeries;
        data["tenantId"] = this.tenantId;
        data["isSeen"] = this.isSeen;
        data["toUserEmail"] = this.toUserEmail;
        data["byUserEmail"] = this.byUserEmail;
        data["byUserFullName"] = this.byUserFullName;
        data["byUserId"] = this.byUserId;
        if (Array.isArray(this.contributors)) {
            data["contributors"] = [];
            for (let item of this.contributors)
                data["contributors"].push(item ? item.toJSON() : undefined as any);
        }
        data["actionPerformed"] = this.actionPerformed;
        return data;
    }
}

export interface ITaskDetails {
    id: number | undefined;
    title: string | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    userName: string | undefined;
    userSurName: string | undefined;
    statusCode: number | undefined;
    profilePictureUrl: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    completedOn: string | undefined;
    predecessor: number | undefined;
    startDelay: number | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    progressCompleted: number | undefined;
    ownerId: number | undefined;
    code: number | undefined;
    agendaType: AgendaType | undefined;
    integrationId: string | undefined;
    integratedFrom: string | undefined;
    integrationIcon: string | undefined;
    integrationCode: number | undefined;
    projectName: string | undefined;
    tag1: string | undefined;
    tag2: string | undefined;
    tag3: string | undefined;
    color: string | undefined;
    webUrl: string | undefined;
    assignes: string | undefined;
    taskAssignes: TaskAssigneOutput[] | undefined;
    keyId: string | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    bucketId: string | undefined;
    checkLists: string | undefined;
    taskCheckLists: CheckLists[] | undefined;
    attachments: string | undefined;
    taskAttachments: TaskAttachment[] | undefined;
    history: string | undefined;
    taskHistory: TaskHistoryDto[] | undefined;
    comment: string | undefined;
    taskComments: TaskCommentDto[] | undefined;
    projectAttachmentCount: number | undefined;
    projectId: number | undefined;
    isPrivateProject: boolean | undefined;
    taskProjectName: string | undefined;
    projectSectionId: number | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    bgColor: string | undefined;
    projectColor: string | undefined;
    resourceAppUrl: string | undefined;
    resourceName: string | undefined;
    resourceIconUrl: string | undefined;
    resourceAppIntegrationId: number | undefined;
    isPrivate: boolean | undefined;
    isAssignedToProject: boolean | undefined;
    isAssignedToPrivateProject: boolean | undefined;
    isReAssigned: boolean | undefined;
    assignedToUserId: number | undefined;
    assignedToUserName: string | undefined;
    assignedToProfPic: string | undefined;
    taskCommentCount: number | undefined;
    sections: string | undefined;
    projectSections: BotProjectSectionDto[] | undefined;
    apiKey: string | undefined;
    priority: TaskPriority | undefined;
    entityType: TaskEntityType | undefined;
    entityName: string | undefined;
    taskType: TaskTypes | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactEmail: string | undefined;
    contactCompanyId: number | undefined;
    contactCompanyName: string | undefined;
    contactTypeColor: string | undefined;
    isAddedOnMyDay: boolean | undefined;
    isSuggestAiTasks: boolean | undefined;
    isDueDatePassed: boolean | undefined;
    taskAssociationsAsJson: string | undefined;
    taskAssociations: TaskAssociation[] | undefined;
    userSectionId: number | undefined;
    isProjectHaveChecklist: boolean | undefined;
    parentId: number | undefined;
    duration: number | undefined;
    isBlocked: boolean | undefined;
    blockedByCount: number | undefined;
    nextCount: number | undefined;
    blockerTaskId: number | undefined;
    blockerTitle: string | undefined;
    blockerAssigneeName: string | undefined;
    blockerDueDate: string | undefined;
    isPartOfTaskTree: boolean | undefined;
    recurringSeriesId: number | undefined;
    hasRecurringSeries: boolean | undefined;
    tenantId: number | undefined;
    isSeen: boolean | undefined;
    toUserEmail: string | undefined;
    byUserEmail: string | undefined;
    byUserFullName: string | undefined;
    byUserId: number | undefined;
    contributors: TaskContributorDto[] | undefined;
    actionPerformed: string | undefined;
}

export enum Crud {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class SendSignalRInput implements ISendSignalRInput {
    tsk!: TaskDetails | undefined;
    action!: string | undefined;
    isReAssigned!: boolean | undefined;
    assignedToUserName!: string | undefined;
    isSeen!: boolean | undefined;
    state!: Crud | undefined;

    constructor(data?: ISendSignalRInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tsk = _data["tsk"] ? TaskDetails.fromJS(_data["tsk"], _mappings) : undefined as any;
            this.action = _data["action"];
            this.isReAssigned = _data["isReAssigned"];
            this.assignedToUserName = _data["assignedToUserName"];
            this.isSeen = _data["isSeen"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any, _mappings?: any): SendSignalRInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SendSignalRInput>(data, _mappings, SendSignalRInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tsk"] = this.tsk ? this.tsk.toJSON() : undefined as any;
        data["action"] = this.action;
        data["isReAssigned"] = this.isReAssigned;
        data["assignedToUserName"] = this.assignedToUserName;
        data["isSeen"] = this.isSeen;
        data["state"] = this.state;
        return data;
    }
}

export interface ISendSignalRInput {
    tsk: TaskDetails | undefined;
    action: string | undefined;
    isReAssigned: boolean | undefined;
    assignedToUserName: string | undefined;
    isSeen: boolean | undefined;
    state: Crud | undefined;
}

export class GetDependentTaskOutputDto implements IGetDependentTaskOutputDto {
    parentTitle!: string | undefined;
    taskId!: number | undefined;
    title!: string | undefined;
    parentId!: number | undefined;
    startDelay!: number | undefined;
    duration!: number | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    sectionName!: string | undefined;
    stageCode!: number | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    completedOn!: string | undefined;
    isParentDueDatePassed!: boolean | undefined;
    parentDueDate!: string | undefined;
    assignedToUserId!: number | undefined;
    assignedToUserName!: string | undefined;
    assignedToUserInitials!: string | undefined;

    constructor(data?: IGetDependentTaskOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.parentTitle = _data["parentTitle"];
            this.taskId = _data["taskId"];
            this.title = _data["title"];
            this.parentId = _data["parentId"];
            this.startDelay = _data["startDelay"];
            this.duration = _data["duration"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.sectionName = _data["sectionName"];
            this.stageCode = _data["stageCode"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.completedOn = _data["completedOn"];
            this.isParentDueDatePassed = _data["isParentDueDatePassed"];
            this.parentDueDate = _data["parentDueDate"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUserName = _data["assignedToUserName"];
            this.assignedToUserInitials = _data["assignedToUserInitials"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetDependentTaskOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetDependentTaskOutputDto>(data, _mappings, GetDependentTaskOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentTitle"] = this.parentTitle;
        data["taskId"] = this.taskId;
        data["title"] = this.title;
        data["parentId"] = this.parentId;
        data["startDelay"] = this.startDelay;
        data["duration"] = this.duration;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["sectionName"] = this.sectionName;
        data["stageCode"] = this.stageCode;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["completedOn"] = this.completedOn;
        data["isParentDueDatePassed"] = this.isParentDueDatePassed;
        data["parentDueDate"] = this.parentDueDate;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUserName"] = this.assignedToUserName;
        data["assignedToUserInitials"] = this.assignedToUserInitials;
        return data;
    }
}

export interface IGetDependentTaskOutputDto {
    parentTitle: string | undefined;
    taskId: number | undefined;
    title: string | undefined;
    parentId: number | undefined;
    startDelay: number | undefined;
    duration: number | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    sectionName: string | undefined;
    stageCode: number | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    completedOn: string | undefined;
    isParentDueDatePassed: boolean | undefined;
    parentDueDate: string | undefined;
    assignedToUserId: number | undefined;
    assignedToUserName: string | undefined;
    assignedToUserInitials: string | undefined;
}

export class GetDependentTaskOutputDtoListIHandleError implements IGetDependentTaskOutputDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetDependentTaskOutputDto[] | undefined;
    listOfEntities!: GetDependentTaskOutputDto[][] | undefined;

    constructor(data?: IGetDependentTaskOutputDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(GetDependentTaskOutputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetDependentTaskOutputDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetDependentTaskOutputDtoListIHandleError>(data, _mappings, GetDependentTaskOutputDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IGetDependentTaskOutputDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetDependentTaskOutputDto[] | undefined;
    listOfEntities: GetDependentTaskOutputDto[][] | undefined;
}

export class TaskBlockerDto implements ITaskBlockerDto {
    dependencyId!: number | undefined;
    blockerTaskId!: number | undefined;
    blockerTitle!: string | undefined;
    blockerStartDate!: string | undefined;
    blockerDueDate!: string | undefined;
    blockerStatusCode!: number | undefined;
    startDelay!: number | undefined;
    sortOrder!: number | undefined;
    blockerProjectId!: number | undefined;
    blockerProjectName!: string | undefined;
    blockerSectionName!: string | undefined;
    blockerAssignedToUserId!: number | undefined;
    blockerAssignedToUserName!: string | undefined;
    blockerAssignedToUserInitials!: string | undefined;
    blockerCompletedOn!: string | undefined;
    isBlockerDueDatePassed!: boolean | undefined;
    isCascadeLocked!: boolean | undefined;
    conflictProposedStartDate!: string | undefined;
    conflictProposedDueDate!: string | undefined;

    constructor(data?: ITaskBlockerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.dependencyId = _data["dependencyId"];
            this.blockerTaskId = _data["blockerTaskId"];
            this.blockerTitle = _data["blockerTitle"];
            this.blockerStartDate = _data["blockerStartDate"];
            this.blockerDueDate = _data["blockerDueDate"];
            this.blockerStatusCode = _data["blockerStatusCode"];
            this.startDelay = _data["startDelay"];
            this.sortOrder = _data["sortOrder"];
            this.blockerProjectId = _data["blockerProjectId"];
            this.blockerProjectName = _data["blockerProjectName"];
            this.blockerSectionName = _data["blockerSectionName"];
            this.blockerAssignedToUserId = _data["blockerAssignedToUserId"];
            this.blockerAssignedToUserName = _data["blockerAssignedToUserName"];
            this.blockerAssignedToUserInitials = _data["blockerAssignedToUserInitials"];
            this.blockerCompletedOn = _data["blockerCompletedOn"];
            this.isBlockerDueDatePassed = _data["isBlockerDueDatePassed"];
            this.isCascadeLocked = _data["isCascadeLocked"];
            this.conflictProposedStartDate = _data["conflictProposedStartDate"];
            this.conflictProposedDueDate = _data["conflictProposedDueDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskBlockerDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskBlockerDto>(data, _mappings, TaskBlockerDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dependencyId"] = this.dependencyId;
        data["blockerTaskId"] = this.blockerTaskId;
        data["blockerTitle"] = this.blockerTitle;
        data["blockerStartDate"] = this.blockerStartDate;
        data["blockerDueDate"] = this.blockerDueDate;
        data["blockerStatusCode"] = this.blockerStatusCode;
        data["startDelay"] = this.startDelay;
        data["sortOrder"] = this.sortOrder;
        data["blockerProjectId"] = this.blockerProjectId;
        data["blockerProjectName"] = this.blockerProjectName;
        data["blockerSectionName"] = this.blockerSectionName;
        data["blockerAssignedToUserId"] = this.blockerAssignedToUserId;
        data["blockerAssignedToUserName"] = this.blockerAssignedToUserName;
        data["blockerAssignedToUserInitials"] = this.blockerAssignedToUserInitials;
        data["blockerCompletedOn"] = this.blockerCompletedOn;
        data["isBlockerDueDatePassed"] = this.isBlockerDueDatePassed;
        data["isCascadeLocked"] = this.isCascadeLocked;
        data["conflictProposedStartDate"] = this.conflictProposedStartDate;
        data["conflictProposedDueDate"] = this.conflictProposedDueDate;
        return data;
    }
}

export interface ITaskBlockerDto {
    dependencyId: number | undefined;
    blockerTaskId: number | undefined;
    blockerTitle: string | undefined;
    blockerStartDate: string | undefined;
    blockerDueDate: string | undefined;
    blockerStatusCode: number | undefined;
    startDelay: number | undefined;
    sortOrder: number | undefined;
    blockerProjectId: number | undefined;
    blockerProjectName: string | undefined;
    blockerSectionName: string | undefined;
    blockerAssignedToUserId: number | undefined;
    blockerAssignedToUserName: string | undefined;
    blockerAssignedToUserInitials: string | undefined;
    blockerCompletedOn: string | undefined;
    isBlockerDueDatePassed: boolean | undefined;
    isCascadeLocked: boolean | undefined;
    conflictProposedStartDate: string | undefined;
    conflictProposedDueDate: string | undefined;
}

export class TaskBlockerDtoListIHandleError implements ITaskBlockerDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskBlockerDto[] | undefined;
    listOfEntities!: TaskBlockerDto[][] | undefined;

    constructor(data?: ITaskBlockerDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TaskBlockerDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskBlockerDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskBlockerDtoListIHandleError>(data, _mappings, TaskBlockerDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITaskBlockerDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskBlockerDto[] | undefined;
    listOfEntities: TaskBlockerDto[][] | undefined;
}

export class TaskBlockedByDto implements ITaskBlockedByDto {
    dependencyId!: number | undefined;
    taskId!: number | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    statusCode!: number | undefined;
    startDelay!: number | undefined;
    sortOrder!: number | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    sectionName!: string | undefined;
    assignedToUserId!: number | undefined;
    assignedToUserName!: string | undefined;
    assignedToUserInitials!: string | undefined;
    completedOn!: string | undefined;
    isCascadeLocked!: boolean | undefined;
    conflictProposedStartDate!: string | undefined;
    conflictProposedDueDate!: string | undefined;

    constructor(data?: ITaskBlockedByDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.dependencyId = _data["dependencyId"];
            this.taskId = _data["taskId"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.statusCode = _data["statusCode"];
            this.startDelay = _data["startDelay"];
            this.sortOrder = _data["sortOrder"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.sectionName = _data["sectionName"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUserName = _data["assignedToUserName"];
            this.assignedToUserInitials = _data["assignedToUserInitials"];
            this.completedOn = _data["completedOn"];
            this.isCascadeLocked = _data["isCascadeLocked"];
            this.conflictProposedStartDate = _data["conflictProposedStartDate"];
            this.conflictProposedDueDate = _data["conflictProposedDueDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskBlockedByDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskBlockedByDto>(data, _mappings, TaskBlockedByDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dependencyId"] = this.dependencyId;
        data["taskId"] = this.taskId;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["statusCode"] = this.statusCode;
        data["startDelay"] = this.startDelay;
        data["sortOrder"] = this.sortOrder;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["sectionName"] = this.sectionName;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUserName"] = this.assignedToUserName;
        data["assignedToUserInitials"] = this.assignedToUserInitials;
        data["completedOn"] = this.completedOn;
        data["isCascadeLocked"] = this.isCascadeLocked;
        data["conflictProposedStartDate"] = this.conflictProposedStartDate;
        data["conflictProposedDueDate"] = this.conflictProposedDueDate;
        return data;
    }
}

export interface ITaskBlockedByDto {
    dependencyId: number | undefined;
    taskId: number | undefined;
    title: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    statusCode: number | undefined;
    startDelay: number | undefined;
    sortOrder: number | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    sectionName: string | undefined;
    assignedToUserId: number | undefined;
    assignedToUserName: string | undefined;
    assignedToUserInitials: string | undefined;
    completedOn: string | undefined;
    isCascadeLocked: boolean | undefined;
    conflictProposedStartDate: string | undefined;
    conflictProposedDueDate: string | undefined;
}

export class TaskBlockedByDtoListIHandleError implements ITaskBlockedByDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskBlockedByDto[] | undefined;
    listOfEntities!: TaskBlockedByDto[][] | undefined;

    constructor(data?: ITaskBlockedByDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TaskBlockedByDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskBlockedByDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskBlockedByDtoListIHandleError>(data, _mappings, TaskBlockedByDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITaskBlockedByDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskBlockedByDto[] | undefined;
    listOfEntities: TaskBlockedByDto[][] | undefined;
}

export class ProjectDependencyEdgeDto implements IProjectDependencyEdgeDto {
    dependencyId!: number | undefined;
    blockerTaskId!: number | undefined;
    blockedTaskId!: number | undefined;
    startDelay!: number | undefined;
    sortOrder!: number | undefined;

    constructor(data?: IProjectDependencyEdgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.dependencyId = _data["dependencyId"];
            this.blockerTaskId = _data["blockerTaskId"];
            this.blockedTaskId = _data["blockedTaskId"];
            this.startDelay = _data["startDelay"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectDependencyEdgeDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectDependencyEdgeDto>(data, _mappings, ProjectDependencyEdgeDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dependencyId"] = this.dependencyId;
        data["blockerTaskId"] = this.blockerTaskId;
        data["blockedTaskId"] = this.blockedTaskId;
        data["startDelay"] = this.startDelay;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IProjectDependencyEdgeDto {
    dependencyId: number | undefined;
    blockerTaskId: number | undefined;
    blockedTaskId: number | undefined;
    startDelay: number | undefined;
    sortOrder: number | undefined;
}

export class ProjectDependencyEdgeDtoListIHandleError implements IProjectDependencyEdgeDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectDependencyEdgeDto[] | undefined;
    listOfEntities!: ProjectDependencyEdgeDto[][] | undefined;

    constructor(data?: IProjectDependencyEdgeDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectDependencyEdgeDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectDependencyEdgeDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectDependencyEdgeDtoListIHandleError>(data, _mappings, ProjectDependencyEdgeDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectDependencyEdgeDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectDependencyEdgeDto[] | undefined;
    listOfEntities: ProjectDependencyEdgeDto[][] | undefined;
}

export class ProjectTasksDtoListIHandleError implements IProjectTasksDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectTasksDto[] | undefined;
    listOfEntities!: ProjectTasksDto[][] | undefined;

    constructor(data?: IProjectTasksDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectTasksDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTasksDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTasksDtoListIHandleError>(data, _mappings, ProjectTasksDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectTasksDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectTasksDto[] | undefined;
    listOfEntities: ProjectTasksDto[][] | undefined;
}

export class DependentTaskEditDto implements IDependentTaskEditDto {
    id!: number | undefined;
    parentId!: number | undefined;
    startDelay!: number | undefined;
    duration!: number | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;

    constructor(data?: IDependentTaskEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.startDelay = _data["startDelay"];
            this.duration = _data["duration"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): DependentTaskEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DependentTaskEditDto>(data, _mappings, DependentTaskEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["startDelay"] = this.startDelay;
        data["duration"] = this.duration;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        return data;
    }
}

export interface IDependentTaskEditDto {
    id: number | undefined;
    parentId: number | undefined;
    startDelay: number | undefined;
    duration: number | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
}

export class TaskProjectSectionDto implements ITaskProjectSectionDto {
    taskId!: number | undefined;
    projectId!: number | undefined;
    sectionId!: number | undefined;

    constructor(data?: ITaskProjectSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.projectId = _data["projectId"];
            this.sectionId = _data["sectionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskProjectSectionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskProjectSectionDto>(data, _mappings, TaskProjectSectionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["projectId"] = this.projectId;
        data["sectionId"] = this.sectionId;
        return data;
    }
}

export interface ITaskProjectSectionDto {
    taskId: number | undefined;
    projectId: number | undefined;
    sectionId: number | undefined;
}

export class UpdateTaskDatesDto implements IUpdateTaskDatesDto {
    taskIds!: number[] | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;

    constructor(data?: IUpdateTaskDatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["taskIds"])) {
                this.taskIds = [] as any;
                for (let item of _data["taskIds"])
                    this.taskIds!.push(item);
            }
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateTaskDatesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateTaskDatesDto>(data, _mappings, UpdateTaskDatesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskIds)) {
            data["taskIds"] = [];
            for (let item of this.taskIds)
                data["taskIds"].push(item);
        }
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        return data;
    }
}

export interface IUpdateTaskDatesDto {
    taskIds: number[] | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
}

export class UndoMultipleTasksDateUpdateDto implements IUndoMultipleTasksDateUpdateDto {
    taskId!: number | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;

    constructor(data?: IUndoMultipleTasksDateUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): UndoMultipleTasksDateUpdateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UndoMultipleTasksDateUpdateDto>(data, _mappings, UndoMultipleTasksDateUpdateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        return data;
    }
}

export interface IUndoMultipleTasksDateUpdateDto {
    taskId: number | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
}

export class MultipleTasksTagDto implements IMultipleTasksTagDto {
    taskId!: number | undefined;
    tagId!: number | undefined;

    constructor(data?: IMultipleTasksTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.tagId = _data["tagId"];
        }
    }

    static fromJS(data: any, _mappings?: any): MultipleTasksTagDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MultipleTasksTagDto>(data, _mappings, MultipleTasksTagDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["tagId"] = this.tagId;
        return data;
    }
}

export interface IMultipleTasksTagDto {
    taskId: number | undefined;
    tagId: number | undefined;
}

export class DeleteTasksInput implements IDeleteTasksInput {
    taskIds!: number[] | undefined;
    isDeleted!: boolean | undefined;

    constructor(data?: IDeleteTasksInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["taskIds"])) {
                this.taskIds = [] as any;
                for (let item of _data["taskIds"])
                    this.taskIds!.push(item);
            }
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any, _mappings?: any): DeleteTasksInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DeleteTasksInput>(data, _mappings, DeleteTasksInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskIds)) {
            data["taskIds"] = [];
            for (let item of this.taskIds)
                data["taskIds"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IDeleteTasksInput {
    taskIds: number[] | undefined;
    isDeleted: boolean | undefined;
}

export class SkippedTaskDto implements ISkippedTaskDto {
    taskId!: number | undefined;
    reason!: string | undefined;
    message!: string | undefined;

    constructor(data?: ISkippedTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.reason = _data["reason"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any, _mappings?: any): SkippedTaskDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SkippedTaskDto>(data, _mappings, SkippedTaskDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["reason"] = this.reason;
        data["message"] = this.message;
        return data;
    }
}

export interface ISkippedTaskDto {
    taskId: number | undefined;
    reason: string | undefined;
    message: string | undefined;
}

export class DeleteTasksResultDto implements IDeleteTasksResultDto {
    deletedTaskIds!: number[] | undefined;
    skipped!: SkippedTaskDto[] | undefined;

    constructor(data?: IDeleteTasksResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedTaskIds"])) {
                this.deletedTaskIds = [] as any;
                for (let item of _data["deletedTaskIds"])
                    this.deletedTaskIds!.push(item);
            }
            if (Array.isArray(_data["skipped"])) {
                this.skipped = [] as any;
                for (let item of _data["skipped"])
                    this.skipped!.push(SkippedTaskDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DeleteTasksResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DeleteTasksResultDto>(data, _mappings, DeleteTasksResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedTaskIds)) {
            data["deletedTaskIds"] = [];
            for (let item of this.deletedTaskIds)
                data["deletedTaskIds"].push(item);
        }
        if (Array.isArray(this.skipped)) {
            data["skipped"] = [];
            for (let item of this.skipped)
                data["skipped"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDeleteTasksResultDto {
    deletedTaskIds: number[] | undefined;
    skipped: SkippedTaskDto[] | undefined;
}

export class DeleteTasksResultDtoIHandleError implements IDeleteTasksResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: DeleteTasksResultDto | undefined;
    listOfEntities!: DeleteTasksResultDto[] | undefined;

    constructor(data?: IDeleteTasksResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? DeleteTasksResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(DeleteTasksResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): DeleteTasksResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DeleteTasksResultDtoIHandleError>(data, _mappings, DeleteTasksResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDeleteTasksResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: DeleteTasksResultDto | undefined;
    listOfEntities: DeleteTasksResultDto[] | undefined;
}

export class UpdateTasksAssociationsInput implements IUpdateTasksAssociationsInput {
    taskIds!: number[] | undefined;
    associationType!: TaskAssociationType | undefined;
    associationId!: string | undefined;
    associationUrl!: string | undefined;

    constructor(data?: IUpdateTasksAssociationsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["taskIds"])) {
                this.taskIds = [] as any;
                for (let item of _data["taskIds"])
                    this.taskIds!.push(item);
            }
            this.associationType = _data["associationType"];
            this.associationId = _data["associationId"];
            this.associationUrl = _data["associationUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateTasksAssociationsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateTasksAssociationsInput>(data, _mappings, UpdateTasksAssociationsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskIds)) {
            data["taskIds"] = [];
            for (let item of this.taskIds)
                data["taskIds"].push(item);
        }
        data["associationType"] = this.associationType;
        data["associationId"] = this.associationId;
        data["associationUrl"] = this.associationUrl;
        return data;
    }
}

export interface IUpdateTasksAssociationsInput {
    taskIds: number[] | undefined;
    associationType: TaskAssociationType | undefined;
    associationId: string | undefined;
    associationUrl: string | undefined;
}

export class MultipleTasksInput implements IMultipleTasksInput {
    taskName!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    code!: number | undefined;
    assignedTo!: number | undefined;

    constructor(data?: IMultipleTasksInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskName = _data["taskName"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.code = _data["code"];
            this.assignedTo = _data["assignedTo"];
        }
    }

    static fromJS(data: any, _mappings?: any): MultipleTasksInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MultipleTasksInput>(data, _mappings, MultipleTasksInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskName"] = this.taskName;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["code"] = this.code;
        data["assignedTo"] = this.assignedTo;
        return data;
    }
}

export interface IMultipleTasksInput {
    taskName: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    code: number | undefined;
    assignedTo: number | undefined;
}

export class CreateMultipleTasksInput implements ICreateMultipleTasksInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    tasks!: MultipleTasksInput[] | undefined;

    constructor(data?: ICreateMultipleTasksInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(MultipleTasksInput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateMultipleTasksInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateMultipleTasksInput>(data, _mappings, CreateMultipleTasksInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateMultipleTasksInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    tasks: MultipleTasksInput[] | undefined;
}

export class ProjectListDtoListProjectCountsListValueTuple implements IProjectListDtoListProjectCountsListValueTuple {

    constructor(data?: IProjectListDtoListProjectCountsListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): ProjectListDtoListProjectCountsListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectListDtoListProjectCountsListValueTuple>(data, _mappings, ProjectListDtoListProjectCountsListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IProjectListDtoListProjectCountsListValueTuple {
}

export class ProjectListDtoListProjectCountsListValueTupleIHandleError implements IProjectListDtoListProjectCountsListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectListDtoListProjectCountsListValueTuple | undefined;
    listOfEntities!: ProjectListDtoListProjectCountsListValueTuple[] | undefined;

    constructor(data?: IProjectListDtoListProjectCountsListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProjectListDtoListProjectCountsListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProjectListDtoListProjectCountsListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectListDtoListProjectCountsListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectListDtoListProjectCountsListValueTupleIHandleError>(data, _mappings, ProjectListDtoListProjectCountsListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectListDtoListProjectCountsListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectListDtoListProjectCountsListValueTuple | undefined;
    listOfEntities: ProjectListDtoListProjectCountsListValueTuple[] | undefined;
}

export class ProjectAssociationDto implements IProjectAssociationDto {
    proAssoId!: number | undefined;
    associationId!: number | undefined;
    associationName!: string | undefined;
    associationType!: ProjectAssociationType | undefined;
    profilePictureUrl!: string | undefined;
    roleId!: number | undefined;
    roleName!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IProjectAssociationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.proAssoId = _data["proAssoId"];
            this.associationId = _data["associationId"];
            this.associationName = _data["associationName"];
            this.associationType = _data["associationType"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectAssociationDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectAssociationDto>(data, _mappings, ProjectAssociationDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proAssoId"] = this.proAssoId;
        data["associationId"] = this.associationId;
        data["associationName"] = this.associationName;
        data["associationType"] = this.associationType;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IProjectAssociationDto {
    proAssoId: number | undefined;
    associationId: number | undefined;
    associationName: string | undefined;
    associationType: ProjectAssociationType | undefined;
    profilePictureUrl: string | undefined;
    roleId: number | undefined;
    roleName: string | undefined;
    emailAddress: string | undefined;
}

export class ProjectChecklist implements IProjectChecklist {
    id!: number | undefined;
    title!: string | undefined;
    description!: string | undefined;
    sortOrder!: number | undefined;
    assigneeId!: number | undefined;
    assigneeName!: string | undefined;
    assigneeProfilePictureUrl!: string | undefined;

    constructor(data?: IProjectChecklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.assigneeId = _data["assigneeId"];
            this.assigneeName = _data["assigneeName"];
            this.assigneeProfilePictureUrl = _data["assigneeProfilePictureUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectChecklist | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectChecklist>(data, _mappings, ProjectChecklist);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["assigneeId"] = this.assigneeId;
        data["assigneeName"] = this.assigneeName;
        data["assigneeProfilePictureUrl"] = this.assigneeProfilePictureUrl;
        return data;
    }
}

export interface IProjectChecklist {
    id: number | undefined;
    title: string | undefined;
    description: string | undefined;
    sortOrder: number | undefined;
    assigneeId: number | undefined;
    assigneeName: string | undefined;
    assigneeProfilePictureUrl: string | undefined;
}

export class CreateProjectInputDto implements ICreateProjectInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectName!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isPrivate!: boolean | undefined;
    isSuggestAiTasks!: boolean | undefined;
    description!: string | undefined;
    isAutoAddChecklist!: boolean | undefined;
    msTeamId!: string | undefined;
    msChannelId!: string | undefined;
    stageId!: number | undefined;
    projectMembers!: ProjectMembers[] | undefined;
    projectContacts!: ProjectAssociationDto[] | undefined;
    projectFiles!: CommonAttachment[] | undefined;
    projectChecklist!: ProjectChecklist[] | undefined;
    tasks!: TaskTemplate[] | undefined;
    sections!: SectionTemplate[] | undefined;
    leadCycleId!: number | undefined;
    caseValueFieldOnForm!: boolean | undefined;

    constructor(data?: ICreateProjectInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectName = _data["projectName"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isPrivate = _data["isPrivate"];
            this.isSuggestAiTasks = _data["isSuggestAiTasks"];
            this.description = _data["description"];
            this.isAutoAddChecklist = _data["isAutoAddChecklist"];
            this.msTeamId = _data["msTeamId"];
            this.msChannelId = _data["msChannelId"];
            this.stageId = _data["stageId"];
            if (Array.isArray(_data["projectMembers"])) {
                this.projectMembers = [] as any;
                for (let item of _data["projectMembers"])
                    this.projectMembers!.push(ProjectMembers.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["projectContacts"])) {
                this.projectContacts = [] as any;
                for (let item of _data["projectContacts"])
                    this.projectContacts!.push(ProjectAssociationDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["projectFiles"])) {
                this.projectFiles = [] as any;
                for (let item of _data["projectFiles"])
                    this.projectFiles!.push(CommonAttachment.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["projectChecklist"])) {
                this.projectChecklist = [] as any;
                for (let item of _data["projectChecklist"])
                    this.projectChecklist!.push(ProjectChecklist.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskTemplate.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SectionTemplate.fromJS(item, _mappings));
            }
            this.leadCycleId = _data["leadCycleId"];
            this.caseValueFieldOnForm = _data["caseValueFieldOnForm"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateProjectInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateProjectInputDto>(data, _mappings, CreateProjectInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectName"] = this.projectName;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isPrivate"] = this.isPrivate;
        data["isSuggestAiTasks"] = this.isSuggestAiTasks;
        data["description"] = this.description;
        data["isAutoAddChecklist"] = this.isAutoAddChecklist;
        data["msTeamId"] = this.msTeamId;
        data["msChannelId"] = this.msChannelId;
        data["stageId"] = this.stageId;
        if (Array.isArray(this.projectMembers)) {
            data["projectMembers"] = [];
            for (let item of this.projectMembers)
                data["projectMembers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectContacts)) {
            data["projectContacts"] = [];
            for (let item of this.projectContacts)
                data["projectContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectFiles)) {
            data["projectFiles"] = [];
            for (let item of this.projectFiles)
                data["projectFiles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectChecklist)) {
            data["projectChecklist"] = [];
            for (let item of this.projectChecklist)
                data["projectChecklist"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        data["leadCycleId"] = this.leadCycleId;
        data["caseValueFieldOnForm"] = this.caseValueFieldOnForm;
        return data;
    }
}

export interface ICreateProjectInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectName: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isPrivate: boolean | undefined;
    isSuggestAiTasks: boolean | undefined;
    description: string | undefined;
    isAutoAddChecklist: boolean | undefined;
    msTeamId: string | undefined;
    msChannelId: string | undefined;
    stageId: number | undefined;
    projectMembers: ProjectMembers[] | undefined;
    projectContacts: ProjectAssociationDto[] | undefined;
    projectFiles: CommonAttachment[] | undefined;
    projectChecklist: ProjectChecklist[] | undefined;
    tasks: TaskTemplate[] | undefined;
    sections: SectionTemplate[] | undefined;
    leadCycleId: number | undefined;
    caseValueFieldOnForm: boolean | undefined;
}

export class CreateUpdateProjMemberInput implements ICreateUpdateProjMemberInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    memberIds!: number[] | undefined;
    memberType!: ProjectMemberType | undefined;
    roleId!: number | undefined;
    isDeleted!: boolean | undefined;
    primaryUserId!: number | undefined;

    constructor(data?: ICreateUpdateProjMemberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["memberIds"])) {
                this.memberIds = [] as any;
                for (let item of _data["memberIds"])
                    this.memberIds!.push(item);
            }
            this.memberType = _data["memberType"];
            this.roleId = _data["roleId"];
            this.isDeleted = _data["isDeleted"];
            this.primaryUserId = _data["primaryUserId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateUpdateProjMemberInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateUpdateProjMemberInput>(data, _mappings, CreateUpdateProjMemberInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.memberIds)) {
            data["memberIds"] = [];
            for (let item of this.memberIds)
                data["memberIds"].push(item);
        }
        data["memberType"] = this.memberType;
        data["roleId"] = this.roleId;
        data["isDeleted"] = this.isDeleted;
        data["primaryUserId"] = this.primaryUserId;
        return data;
    }
}

export interface ICreateUpdateProjMemberInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    memberIds: number[] | undefined;
    memberType: ProjectMemberType | undefined;
    roleId: number | undefined;
    isDeleted: boolean | undefined;
    primaryUserId: number | undefined;
}

export class ProjectMembersListIHandleError implements IProjectMembersListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectMembers[] | undefined;
    listOfEntities!: ProjectMembers[][] | undefined;

    constructor(data?: IProjectMembersListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectMembers.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectMembersListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectMembersListIHandleError>(data, _mappings, ProjectMembersListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectMembersListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectMembers[] | undefined;
    listOfEntities: ProjectMembers[][] | undefined;
}

export class CreateProjectSectionDto implements ICreateProjectSectionDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    projectId!: number | undefined;
    addOnTopBottom!: number | undefined;
    bgColor!: string | undefined;

    constructor(data?: ICreateProjectSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.projectId = _data["projectId"];
            this.addOnTopBottom = _data["addOnTopBottom"];
            this.bgColor = _data["bgColor"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateProjectSectionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateProjectSectionDto>(data, _mappings, CreateProjectSectionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["projectId"] = this.projectId;
        data["addOnTopBottom"] = this.addOnTopBottom;
        data["bgColor"] = this.bgColor;
        return data;
    }
}

export interface ICreateProjectSectionDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    projectId: number | undefined;
    addOnTopBottom: number | undefined;
    bgColor: string | undefined;
}

export class SectionDto implements ISectionDto {
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    projectId!: number | undefined;

    constructor(data?: ISectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any, _mappings?: any): SectionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SectionDto>(data, _mappings, SectionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ISectionDto {
    sectionId: number | undefined;
    sectionName: string | undefined;
    projectId: number | undefined;
}

export class SectionDtoIHandleError implements ISectionDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SectionDto | undefined;
    listOfEntities!: SectionDto[] | undefined;

    constructor(data?: ISectionDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SectionDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SectionDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SectionDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SectionDtoIHandleError>(data, _mappings, SectionDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISectionDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SectionDto | undefined;
    listOfEntities: SectionDto[] | undefined;
}

export class ProjectStatusOutput implements IProjectStatusOutput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    name!: string | undefined;
    code!: number | undefined;

    constructor(data?: IProjectStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectStatusOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectStatusOutput>(data, _mappings, ProjectStatusOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IProjectStatusOutput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    name: string | undefined;
    code: number | undefined;
}

export class ProjectStatusOutputListIHandleError implements IProjectStatusOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectStatusOutput[] | undefined;
    listOfEntities!: ProjectStatusOutput[][] | undefined;

    constructor(data?: IProjectStatusOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectStatusOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectStatusOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectStatusOutputListIHandleError>(data, _mappings, ProjectStatusOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectStatusOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectStatusOutput[] | undefined;
    listOfEntities: ProjectStatusOutput[][] | undefined;
}

export class ProjectDetailOutputDtoIHandleError implements IProjectDetailOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectDetailOutputDto | undefined;
    listOfEntities!: ProjectDetailOutputDto[] | undefined;

    constructor(data?: IProjectDetailOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProjectDetailOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProjectDetailOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectDetailOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectDetailOutputDtoIHandleError>(data, _mappings, ProjectDetailOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectDetailOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectDetailOutputDto | undefined;
    listOfEntities: ProjectDetailOutputDto[] | undefined;
}

export class ProjectTasksFlatDto implements IProjectTasksFlatDto {
    associationId!: number | undefined;
    associationName!: string | undefined;
    associationType!: ProjectAssociationType | undefined;
    id!: number | undefined;
    creationTime!: string | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    code!: number | undefined;
    assignedToUserId!: number | undefined;
    assignedToUser!: string | undefined;
    assignedToUserProfilePictureUrl!: string | undefined;
    isDueDatePassed!: boolean | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    bgColor!: string | undefined;
    priority!: TaskPriority | undefined;
    projectTags!: ProjectTag[] | undefined;
    taskType!: TaskTypes | undefined;
    isBlocked!: boolean | undefined;
    isSeen!: boolean | undefined;
    lastModificationTime!: string | undefined;
    createdByName!: string | undefined;
    lastModifiedByName!: string | undefined;
    totalTimeMinutes!: number | undefined;
    lastLoggedTime!: string | undefined;
    lastEntryMinutes!: number | undefined;
    taskNotes!: string | undefined;
    contributors!: TaskContributorDto[] | undefined;

    constructor(data?: IProjectTasksFlatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.associationId = _data["associationId"];
            this.associationName = _data["associationName"];
            this.associationType = _data["associationType"];
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.code = _data["code"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"];
            this.assignedToUserProfilePictureUrl = _data["assignedToUserProfilePictureUrl"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.bgColor = _data["bgColor"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["projectTags"])) {
                this.projectTags = [] as any;
                for (let item of _data["projectTags"])
                    this.projectTags!.push(ProjectTag.fromJS(item, _mappings));
            }
            this.taskType = _data["taskType"];
            this.isBlocked = _data["isBlocked"];
            this.isSeen = _data["isSeen"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.createdByName = _data["createdByName"];
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.totalTimeMinutes = _data["totalTimeMinutes"];
            this.lastLoggedTime = _data["lastLoggedTime"];
            this.lastEntryMinutes = _data["lastEntryMinutes"];
            this.taskNotes = _data["taskNotes"];
            if (Array.isArray(_data["contributors"])) {
                this.contributors = [] as any;
                for (let item of _data["contributors"])
                    this.contributors!.push(TaskContributorDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTasksFlatDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTasksFlatDto>(data, _mappings, ProjectTasksFlatDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["associationId"] = this.associationId;
        data["associationName"] = this.associationName;
        data["associationType"] = this.associationType;
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["code"] = this.code;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser;
        data["assignedToUserProfilePictureUrl"] = this.assignedToUserProfilePictureUrl;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["bgColor"] = this.bgColor;
        data["priority"] = this.priority;
        if (Array.isArray(this.projectTags)) {
            data["projectTags"] = [];
            for (let item of this.projectTags)
                data["projectTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["taskType"] = this.taskType;
        data["isBlocked"] = this.isBlocked;
        data["isSeen"] = this.isSeen;
        data["lastModificationTime"] = this.lastModificationTime;
        data["createdByName"] = this.createdByName;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["totalTimeMinutes"] = this.totalTimeMinutes;
        data["lastLoggedTime"] = this.lastLoggedTime;
        data["lastEntryMinutes"] = this.lastEntryMinutes;
        data["taskNotes"] = this.taskNotes;
        if (Array.isArray(this.contributors)) {
            data["contributors"] = [];
            for (let item of this.contributors)
                data["contributors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTasksFlatDto {
    associationId: number | undefined;
    associationName: string | undefined;
    associationType: ProjectAssociationType | undefined;
    id: number | undefined;
    creationTime: string | undefined;
    title: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    code: number | undefined;
    assignedToUserId: number | undefined;
    assignedToUser: string | undefined;
    assignedToUserProfilePictureUrl: string | undefined;
    isDueDatePassed: boolean | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    bgColor: string | undefined;
    priority: TaskPriority | undefined;
    projectTags: ProjectTag[] | undefined;
    taskType: TaskTypes | undefined;
    isBlocked: boolean | undefined;
    isSeen: boolean | undefined;
    lastModificationTime: string | undefined;
    createdByName: string | undefined;
    lastModifiedByName: string | undefined;
    totalTimeMinutes: number | undefined;
    lastLoggedTime: string | undefined;
    lastEntryMinutes: number | undefined;
    taskNotes: string | undefined;
    contributors: TaskContributorDto[] | undefined;
}

export class ProjectTasksFlatDtoListIHandleError implements IProjectTasksFlatDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectTasksFlatDto[] | undefined;
    listOfEntities!: ProjectTasksFlatDto[][] | undefined;

    constructor(data?: IProjectTasksFlatDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectTasksFlatDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTasksFlatDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTasksFlatDtoListIHandleError>(data, _mappings, ProjectTasksFlatDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectTasksFlatDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectTasksFlatDto[] | undefined;
    listOfEntities: ProjectTasksFlatDto[][] | undefined;
}

export class CascadeShiftResult implements ICascadeShiftResult {
    taskId!: number | undefined;
    title!: string | undefined;
    oldStartDate!: string | undefined;
    oldDueDate!: string | undefined;
    newStartDate!: string | undefined;
    newDueDate!: string | undefined;

    constructor(data?: ICascadeShiftResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.title = _data["title"];
            this.oldStartDate = _data["oldStartDate"];
            this.oldDueDate = _data["oldDueDate"];
            this.newStartDate = _data["newStartDate"];
            this.newDueDate = _data["newDueDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): CascadeShiftResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CascadeShiftResult>(data, _mappings, CascadeShiftResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["title"] = this.title;
        data["oldStartDate"] = this.oldStartDate;
        data["oldDueDate"] = this.oldDueDate;
        data["newStartDate"] = this.newStartDate;
        data["newDueDate"] = this.newDueDate;
        return data;
    }
}

export interface ICascadeShiftResult {
    taskId: number | undefined;
    title: string | undefined;
    oldStartDate: string | undefined;
    oldDueDate: string | undefined;
    newStartDate: string | undefined;
    newDueDate: string | undefined;
}

export class MoveToProjectResultDto implements IMoveToProjectResultDto {
    movedTaskIds!: number[] | undefined;
    skipped!: SkippedTaskDto[] | undefined;

    constructor(data?: IMoveToProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["movedTaskIds"])) {
                this.movedTaskIds = [] as any;
                for (let item of _data["movedTaskIds"])
                    this.movedTaskIds!.push(item);
            }
            if (Array.isArray(_data["skipped"])) {
                this.skipped = [] as any;
                for (let item of _data["skipped"])
                    this.skipped!.push(SkippedTaskDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MoveToProjectResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MoveToProjectResultDto>(data, _mappings, MoveToProjectResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.movedTaskIds)) {
            data["movedTaskIds"] = [];
            for (let item of this.movedTaskIds)
                data["movedTaskIds"].push(item);
        }
        if (Array.isArray(this.skipped)) {
            data["skipped"] = [];
            for (let item of this.skipped)
                data["skipped"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMoveToProjectResultDto {
    movedTaskIds: number[] | undefined;
    skipped: SkippedTaskDto[] | undefined;
}

export class MoveToProjectResultDtoIHandleError implements IMoveToProjectResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MoveToProjectResultDto | undefined;
    listOfEntities!: MoveToProjectResultDto[] | undefined;

    constructor(data?: IMoveToProjectResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? MoveToProjectResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(MoveToProjectResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MoveToProjectResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MoveToProjectResultDtoIHandleError>(data, _mappings, MoveToProjectResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMoveToProjectResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MoveToProjectResultDto | undefined;
    listOfEntities: MoveToProjectResultDto[] | undefined;
}

export class MarkCompleteBulkInput implements IMarkCompleteBulkInput {
    tasksIds!: number[] | undefined;
    code!: number | undefined;

    constructor(data?: IMarkCompleteBulkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["tasksIds"])) {
                this.tasksIds = [] as any;
                for (let item of _data["tasksIds"])
                    this.tasksIds!.push(item);
            }
            this.code = _data["code"];
        }
    }

    static fromJS(data: any, _mappings?: any): MarkCompleteBulkInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MarkCompleteBulkInput>(data, _mappings, MarkCompleteBulkInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasksIds)) {
            data["tasksIds"] = [];
            for (let item of this.tasksIds)
                data["tasksIds"].push(item);
        }
        data["code"] = this.code;
        return data;
    }
}

export interface IMarkCompleteBulkInput {
    tasksIds: number[] | undefined;
    code: number | undefined;
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any, _mappings?: any): FileDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FileDto>(data, _mappings, FileDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class FileDtoIHandleError implements IFileDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: FileDto | undefined;
    listOfEntities!: FileDto[] | undefined;

    constructor(data?: IFileDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? FileDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(FileDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): FileDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FileDtoIHandleError>(data, _mappings, FileDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFileDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: FileDto | undefined;
    listOfEntities: FileDto[] | undefined;
}

export class ProjectInputDto implements IProjectInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    code!: number | undefined;

    constructor(data?: IProjectInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectInputDto>(data, _mappings, ProjectInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        data["code"] = this.code;
        return data;
    }
}

export interface IProjectInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    code: number | undefined;
}

export class GetUserTasksListIHandleError implements IGetUserTasksListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetUserTasks[] | undefined;
    listOfEntities!: GetUserTasks[][] | undefined;

    constructor(data?: IGetUserTasksListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(GetUserTasks.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserTasksListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserTasksListIHandleError>(data, _mappings, GetUserTasksListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IGetUserTasksListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetUserTasks[] | undefined;
    listOfEntities: GetUserTasks[][] | undefined;
}

export class ProjectTagInputDto implements IProjectTagInputDto {
    id!: number | undefined;
    projectId!: number | undefined;
    tag!: string | undefined;
    userId!: number | undefined;

    constructor(data?: IProjectTagInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.tag = _data["tag"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTagInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTagInputDto>(data, _mappings, ProjectTagInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["tag"] = this.tag;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IProjectTagInputDto {
    id: number | undefined;
    projectId: number | undefined;
    tag: string | undefined;
    userId: number | undefined;
}

export class ProjectTagDto implements IProjectTagDto {
    id!: number | undefined;
    projectId!: number | undefined;
    tag!: string | undefined;
    creationTime!: string | undefined;
    creatorName!: string | undefined;

    constructor(data?: IProjectTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.tag = _data["tag"];
            this.creationTime = _data["creationTime"];
            this.creatorName = _data["creatorName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTagDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTagDto>(data, _mappings, ProjectTagDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["tag"] = this.tag;
        data["creationTime"] = this.creationTime;
        data["creatorName"] = this.creatorName;
        return data;
    }
}

export interface IProjectTagDto {
    id: number | undefined;
    projectId: number | undefined;
    tag: string | undefined;
    creationTime: string | undefined;
    creatorName: string | undefined;
}

export class ProjectTagDtoListIHandleError implements IProjectTagDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectTagDto[] | undefined;
    listOfEntities!: ProjectTagDto[][] | undefined;

    constructor(data?: IProjectTagDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectTagDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTagDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTagDtoListIHandleError>(data, _mappings, ProjectTagDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectTagDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectTagDto[] | undefined;
    listOfEntities: ProjectTagDto[][] | undefined;
}

export class ProjectProgressOutputDto implements IProjectProgressOutputDto {
    projectId!: number | undefined;
    projectProgress!: number | undefined;

    constructor(data?: IProjectProgressOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectProgress = _data["projectProgress"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectProgressOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectProgressOutputDto>(data, _mappings, ProjectProgressOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectProgress"] = this.projectProgress;
        return data;
    }
}

export interface IProjectProgressOutputDto {
    projectId: number | undefined;
    projectProgress: number | undefined;
}

export class ProjectProgressOutputDtoIHandleError implements IProjectProgressOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectProgressOutputDto | undefined;
    listOfEntities!: ProjectProgressOutputDto[] | undefined;

    constructor(data?: IProjectProgressOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProjectProgressOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProjectProgressOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectProgressOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectProgressOutputDtoIHandleError>(data, _mappings, ProjectProgressOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectProgressOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectProgressOutputDto | undefined;
    listOfEntities: ProjectProgressOutputDto[] | undefined;
}

export class AddSuggestedTaskToProjectInputDto implements IAddSuggestedTaskToProjectInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    projectId!: number | undefined;
    suggestedTaskId!: number | undefined;
    isAddAll!: boolean | undefined;

    constructor(data?: IAddSuggestedTaskToProjectInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.suggestedTaskId = _data["suggestedTaskId"];
            this.isAddAll = _data["isAddAll"];
        }
    }

    static fromJS(data: any, _mappings?: any): AddSuggestedTaskToProjectInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddSuggestedTaskToProjectInputDto>(data, _mappings, AddSuggestedTaskToProjectInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["suggestedTaskId"] = this.suggestedTaskId;
        data["isAddAll"] = this.isAddAll;
        return data;
    }
}

export interface IAddSuggestedTaskToProjectInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    projectId: number | undefined;
    suggestedTaskId: number | undefined;
    isAddAll: boolean | undefined;
}

export class CopyProjectInputDto implements ICopyProjectInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    originalProjectId!: number | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    projectName!: string | undefined;
    description!: string | undefined;
    isPrivate!: boolean | undefined;
    projectMembers!: ProjectMembers[] | undefined;
    projectContacts!: ProjectAssociationDto[] | undefined;
    projectFiles!: CommonAttachment[] | undefined;
    copyTask!: boolean | undefined;
    copyTaskRelativeDate!: boolean | undefined;
    copyTaskAssignee!: boolean | undefined;
    copyTaskDescription!: boolean | undefined;
    copyTaskCheckList!: boolean | undefined;
    copyTaskCheckListDes!: boolean | undefined;
    copyTaskFilesAndLink!: boolean | undefined;
    copyProjectSections!: boolean | undefined;
    copyProjectTags!: boolean | undefined;
    copyProjectChecklists!: boolean | undefined;

    constructor(data?: ICopyProjectInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.originalProjectId = _data["originalProjectId"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.projectName = _data["projectName"];
            this.description = _data["description"];
            this.isPrivate = _data["isPrivate"];
            if (Array.isArray(_data["projectMembers"])) {
                this.projectMembers = [] as any;
                for (let item of _data["projectMembers"])
                    this.projectMembers!.push(ProjectMembers.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["projectContacts"])) {
                this.projectContacts = [] as any;
                for (let item of _data["projectContacts"])
                    this.projectContacts!.push(ProjectAssociationDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["projectFiles"])) {
                this.projectFiles = [] as any;
                for (let item of _data["projectFiles"])
                    this.projectFiles!.push(CommonAttachment.fromJS(item, _mappings));
            }
            this.copyTask = _data["copyTask"];
            this.copyTaskRelativeDate = _data["copyTaskRelativeDate"];
            this.copyTaskAssignee = _data["copyTaskAssignee"];
            this.copyTaskDescription = _data["copyTaskDescription"];
            this.copyTaskCheckList = _data["copyTaskCheckList"];
            this.copyTaskCheckListDes = _data["copyTaskCheckListDes"];
            this.copyTaskFilesAndLink = _data["copyTaskFilesAndLink"];
            this.copyProjectSections = _data["copyProjectSections"];
            this.copyProjectTags = _data["copyProjectTags"];
            this.copyProjectChecklists = _data["copyProjectChecklists"];
        }
    }

    static fromJS(data: any, _mappings?: any): CopyProjectInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CopyProjectInputDto>(data, _mappings, CopyProjectInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["originalProjectId"] = this.originalProjectId;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["projectName"] = this.projectName;
        data["description"] = this.description;
        data["isPrivate"] = this.isPrivate;
        if (Array.isArray(this.projectMembers)) {
            data["projectMembers"] = [];
            for (let item of this.projectMembers)
                data["projectMembers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectContacts)) {
            data["projectContacts"] = [];
            for (let item of this.projectContacts)
                data["projectContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectFiles)) {
            data["projectFiles"] = [];
            for (let item of this.projectFiles)
                data["projectFiles"].push(item ? item.toJSON() : undefined as any);
        }
        data["copyTask"] = this.copyTask;
        data["copyTaskRelativeDate"] = this.copyTaskRelativeDate;
        data["copyTaskAssignee"] = this.copyTaskAssignee;
        data["copyTaskDescription"] = this.copyTaskDescription;
        data["copyTaskCheckList"] = this.copyTaskCheckList;
        data["copyTaskCheckListDes"] = this.copyTaskCheckListDes;
        data["copyTaskFilesAndLink"] = this.copyTaskFilesAndLink;
        data["copyProjectSections"] = this.copyProjectSections;
        data["copyProjectTags"] = this.copyProjectTags;
        data["copyProjectChecklists"] = this.copyProjectChecklists;
        return data;
    }
}

export interface ICopyProjectInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    originalProjectId: number | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    projectName: string | undefined;
    description: string | undefined;
    isPrivate: boolean | undefined;
    projectMembers: ProjectMembers[] | undefined;
    projectContacts: ProjectAssociationDto[] | undefined;
    projectFiles: CommonAttachment[] | undefined;
    copyTask: boolean | undefined;
    copyTaskRelativeDate: boolean | undefined;
    copyTaskAssignee: boolean | undefined;
    copyTaskDescription: boolean | undefined;
    copyTaskCheckList: boolean | undefined;
    copyTaskCheckListDes: boolean | undefined;
    copyTaskFilesAndLink: boolean | undefined;
    copyProjectSections: boolean | undefined;
    copyProjectTags: boolean | undefined;
    copyProjectChecklists: boolean | undefined;
}

export class CopyProjectOutputDto implements ICopyProjectOutputDto {
    projectId!: number | undefined;
    projectName!: string | undefined;

    constructor(data?: ICopyProjectOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any, _mappings?: any): CopyProjectOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CopyProjectOutputDto>(data, _mappings, CopyProjectOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface ICopyProjectOutputDto {
    projectId: number | undefined;
    projectName: string | undefined;
}

export class CopyProjectOutputDtoIHandleError implements ICopyProjectOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CopyProjectOutputDto | undefined;
    listOfEntities!: CopyProjectOutputDto[] | undefined;

    constructor(data?: ICopyProjectOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CopyProjectOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CopyProjectOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CopyProjectOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CopyProjectOutputDtoIHandleError>(data, _mappings, CopyProjectOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICopyProjectOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CopyProjectOutputDto | undefined;
    listOfEntities: CopyProjectOutputDto[] | undefined;
}

export class ProjectAssociationDtoListIHandleError implements IProjectAssociationDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectAssociationDto[] | undefined;
    listOfEntities!: ProjectAssociationDto[][] | undefined;

    constructor(data?: IProjectAssociationDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectAssociationDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectAssociationDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectAssociationDtoListIHandleError>(data, _mappings, ProjectAssociationDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectAssociationDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectAssociationDto[] | undefined;
    listOfEntities: ProjectAssociationDto[][] | undefined;
}

export class ProjectAssociationInputDto implements IProjectAssociationInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    associationIds!: number[] | undefined;
    associationType!: ProjectAssociationType | undefined;
    roleId!: number | undefined;

    constructor(data?: IProjectAssociationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["associationIds"])) {
                this.associationIds = [] as any;
                for (let item of _data["associationIds"])
                    this.associationIds!.push(item);
            }
            this.associationType = _data["associationType"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectAssociationInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectAssociationInputDto>(data, _mappings, ProjectAssociationInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.associationIds)) {
            data["associationIds"] = [];
            for (let item of this.associationIds)
                data["associationIds"].push(item);
        }
        data["associationType"] = this.associationType;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IProjectAssociationInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    associationIds: number[] | undefined;
    associationType: ProjectAssociationType | undefined;
    roleId: number | undefined;
}

export class ProjectSampleDescDtoListSampleTitleDescriptionListValueTuple implements IProjectSampleDescDtoListSampleTitleDescriptionListValueTuple {

    constructor(data?: IProjectSampleDescDtoListSampleTitleDescriptionListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): ProjectSampleDescDtoListSampleTitleDescriptionListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectSampleDescDtoListSampleTitleDescriptionListValueTuple>(data, _mappings, ProjectSampleDescDtoListSampleTitleDescriptionListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IProjectSampleDescDtoListSampleTitleDescriptionListValueTuple {
}

export class ProjectSampleDescDtoListSampleTitleDescriptionListValueTupleIHandleError implements IProjectSampleDescDtoListSampleTitleDescriptionListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectSampleDescDtoListSampleTitleDescriptionListValueTuple | undefined;
    listOfEntities!: ProjectSampleDescDtoListSampleTitleDescriptionListValueTuple[] | undefined;

    constructor(data?: IProjectSampleDescDtoListSampleTitleDescriptionListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProjectSampleDescDtoListSampleTitleDescriptionListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProjectSampleDescDtoListSampleTitleDescriptionListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectSampleDescDtoListSampleTitleDescriptionListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectSampleDescDtoListSampleTitleDescriptionListValueTupleIHandleError>(data, _mappings, ProjectSampleDescDtoListSampleTitleDescriptionListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectSampleDescDtoListSampleTitleDescriptionListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectSampleDescDtoListSampleTitleDescriptionListValueTuple | undefined;
    listOfEntities: ProjectSampleDescDtoListSampleTitleDescriptionListValueTuple[] | undefined;
}

export class AiSuggestedSections implements IAiSuggestedSections {
    sectionId!: number | undefined;
    section!: string | undefined;

    constructor(data?: IAiSuggestedSections) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.section = _data["section"];
        }
    }

    static fromJS(data: any, _mappings?: any): AiSuggestedSections | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiSuggestedSections>(data, _mappings, AiSuggestedSections);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["section"] = this.section;
        return data;
    }
}

export interface IAiSuggestedSections {
    sectionId: number | undefined;
    section: string | undefined;
}

export class AiSuggestedTasks implements IAiSuggestedTasks {
    title!: string | undefined;
    description!: string | undefined;
    priority!: string | undefined;
    sectionId!: number | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    assignedTo!: number | undefined;
    code!: number | undefined;

    constructor(data?: IAiSuggestedTasks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.priority = _data["priority"];
            this.sectionId = _data["sectionId"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.assignedTo = _data["assignedTo"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any, _mappings?: any): AiSuggestedTasks | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiSuggestedTasks>(data, _mappings, AiSuggestedTasks);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["priority"] = this.priority;
        data["sectionId"] = this.sectionId;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["assignedTo"] = this.assignedTo;
        data["code"] = this.code;
        return data;
    }
}

export interface IAiSuggestedTasks {
    title: string | undefined;
    description: string | undefined;
    priority: string | undefined;
    sectionId: number | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    assignedTo: number | undefined;
    code: number | undefined;
}

export class CreateProjectBulkSectionTaskInput implements ICreateProjectBulkSectionTaskInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    projectId!: number | undefined;
    sections!: AiSuggestedSections[] | undefined;
    tasks!: AiSuggestedTasks[] | undefined;

    constructor(data?: ICreateProjectBulkSectionTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(AiSuggestedSections.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(AiSuggestedTasks.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateProjectBulkSectionTaskInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateProjectBulkSectionTaskInput>(data, _mappings, CreateProjectBulkSectionTaskInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateProjectBulkSectionTaskInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    projectId: number | undefined;
    sections: AiSuggestedSections[] | undefined;
    tasks: AiSuggestedTasks[] | undefined;
}

export class ProjectChecklistDetailsProjectChecklistListValueTuple implements IProjectChecklistDetailsProjectChecklistListValueTuple {

    constructor(data?: IProjectChecklistDetailsProjectChecklistListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): ProjectChecklistDetailsProjectChecklistListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectChecklistDetailsProjectChecklistListValueTuple>(data, _mappings, ProjectChecklistDetailsProjectChecklistListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IProjectChecklistDetailsProjectChecklistListValueTuple {
}

export class ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError implements IProjectChecklistDetailsProjectChecklistListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectChecklistDetailsProjectChecklistListValueTuple | undefined;
    listOfEntities!: ProjectChecklistDetailsProjectChecklistListValueTuple[] | undefined;

    constructor(data?: IProjectChecklistDetailsProjectChecklistListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProjectChecklistDetailsProjectChecklistListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProjectChecklistDetailsProjectChecklistListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError>(data, _mappings, ProjectChecklistDetailsProjectChecklistListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectChecklistDetailsProjectChecklistListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectChecklistDetailsProjectChecklistListValueTuple | undefined;
    listOfEntities: ProjectChecklistDetailsProjectChecklistListValueTuple[] | undefined;
}

export class CreateUpdateProjectChecklists implements ICreateUpdateProjectChecklists {
    userId!: number | undefined;
    projectId!: number | undefined;
    checklistId!: number | undefined;
    title!: string | undefined;
    description!: string | undefined;
    isAutoAdd!: boolean | undefined;
    addOnTopBottom!: number | undefined;
    assigneeId!: number | undefined;

    constructor(data?: ICreateUpdateProjectChecklists) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.checklistId = _data["checklistId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.isAutoAdd = _data["isAutoAdd"];
            this.addOnTopBottom = _data["addOnTopBottom"];
            this.assigneeId = _data["assigneeId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateUpdateProjectChecklists | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateUpdateProjectChecklists>(data, _mappings, CreateUpdateProjectChecklists);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["checklistId"] = this.checklistId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["isAutoAdd"] = this.isAutoAdd;
        data["addOnTopBottom"] = this.addOnTopBottom;
        data["assigneeId"] = this.assigneeId;
        return data;
    }
}

export interface ICreateUpdateProjectChecklists {
    userId: number | undefined;
    projectId: number | undefined;
    checklistId: number | undefined;
    title: string | undefined;
    description: string | undefined;
    isAutoAdd: boolean | undefined;
    addOnTopBottom: number | undefined;
    assigneeId: number | undefined;
}

export class CreateMultipleProjectChecklists implements ICreateMultipleProjectChecklists {
    userId!: number | undefined;
    projectId!: number | undefined;
    projectChecklists!: ProjectChecklist[] | undefined;

    constructor(data?: ICreateMultipleProjectChecklists) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["projectChecklists"])) {
                this.projectChecklists = [] as any;
                for (let item of _data["projectChecklists"])
                    this.projectChecklists!.push(ProjectChecklist.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateMultipleProjectChecklists | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateMultipleProjectChecklists>(data, _mappings, CreateMultipleProjectChecklists);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.projectChecklists)) {
            data["projectChecklists"] = [];
            for (let item of this.projectChecklists)
                data["projectChecklists"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateMultipleProjectChecklists {
    userId: number | undefined;
    projectId: number | undefined;
    projectChecklists: ProjectChecklist[] | undefined;
}

export class CreateUpdateRoleInput implements ICreateUpdateRoleInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    roleId!: number | undefined;
    roleName!: string | undefined;
    roleType!: RoleType | undefined;

    constructor(data?: ICreateUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleType = _data["roleType"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateUpdateRoleInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateUpdateRoleInput>(data, _mappings, CreateUpdateRoleInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleType"] = this.roleType;
        return data;
    }
}

export interface ICreateUpdateRoleInput {
    userId: number | undefined;
    tenantId: number | undefined;
    roleId: number | undefined;
    roleName: string | undefined;
    roleType: RoleType | undefined;
}

export class MembersAndRolesOutput implements IMembersAndRolesOutput {
    type!: number | undefined;
    id!: number | undefined;
    name!: string | undefined;
    firstName!: string | undefined;
    email!: string | undefined;
    cssClass!: string | undefined;
    profilePictureId!: string | undefined;
    profilePictureUrl!: string | undefined;
    roleType!: RoleType | undefined;

    constructor(data?: IMembersAndRolesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.email = _data["email"];
            this.cssClass = _data["cssClass"];
            this.profilePictureId = _data["profilePictureId"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.roleType = _data["roleType"];
        }
    }

    static fromJS(data: any, _mappings?: any): MembersAndRolesOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MembersAndRolesOutput>(data, _mappings, MembersAndRolesOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["email"] = this.email;
        data["cssClass"] = this.cssClass;
        data["profilePictureId"] = this.profilePictureId;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["roleType"] = this.roleType;
        return data;
    }
}

export interface IMembersAndRolesOutput {
    type: number | undefined;
    id: number | undefined;
    name: string | undefined;
    firstName: string | undefined;
    email: string | undefined;
    cssClass: string | undefined;
    profilePictureId: string | undefined;
    profilePictureUrl: string | undefined;
    roleType: RoleType | undefined;
}

export class MembersAndRolesOutputListIHandleError implements IMembersAndRolesOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: MembersAndRolesOutput[] | undefined;
    listOfEntities!: MembersAndRolesOutput[][] | undefined;

    constructor(data?: IMembersAndRolesOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(MembersAndRolesOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MembersAndRolesOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MembersAndRolesOutputListIHandleError>(data, _mappings, MembersAndRolesOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IMembersAndRolesOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: MembersAndRolesOutput[] | undefined;
    listOfEntities: MembersAndRolesOutput[][] | undefined;
}

export class AddProjectMembersToMsChannel implements IAddProjectMembersToMsChannel {
    teamId!: string | undefined;
    channelId!: string | undefined;
    channelType!: number | undefined;
    memberEmails!: string[] | undefined;

    constructor(data?: IAddProjectMembersToMsChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.channelId = _data["channelId"];
            this.channelType = _data["channelType"];
            if (Array.isArray(_data["memberEmails"])) {
                this.memberEmails = [] as any;
                for (let item of _data["memberEmails"])
                    this.memberEmails!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): AddProjectMembersToMsChannel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddProjectMembersToMsChannel>(data, _mappings, AddProjectMembersToMsChannel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["channelId"] = this.channelId;
        data["channelType"] = this.channelType;
        if (Array.isArray(this.memberEmails)) {
            data["memberEmails"] = [];
            for (let item of this.memberEmails)
                data["memberEmails"].push(item);
        }
        return data;
    }
}

export interface IAddProjectMembersToMsChannel {
    teamId: string | undefined;
    channelId: string | undefined;
    channelType: number | undefined;
    memberEmails: string[] | undefined;
}

export class ProjectSectionsDashboardDto implements IProjectSectionsDashboardDto {
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    completedTasks!: number | undefined;
    inProgressTasks!: number | undefined;
    notStartedTasks!: number | undefined;

    constructor(data?: IProjectSectionsDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.completedTasks = _data["completedTasks"];
            this.inProgressTasks = _data["inProgressTasks"];
            this.notStartedTasks = _data["notStartedTasks"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectSectionsDashboardDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectSectionsDashboardDto>(data, _mappings, ProjectSectionsDashboardDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["completedTasks"] = this.completedTasks;
        data["inProgressTasks"] = this.inProgressTasks;
        data["notStartedTasks"] = this.notStartedTasks;
        return data;
    }
}

export interface IProjectSectionsDashboardDto {
    sectionId: number | undefined;
    sectionName: string | undefined;
    completedTasks: number | undefined;
    inProgressTasks: number | undefined;
    notStartedTasks: number | undefined;
}

export class ProjectTeamDashboardDto implements IProjectTeamDashboardDto {
    userId!: number | undefined;
    userName!: string | undefined;
    profilePictureUrl!: string | undefined;
    competedTasks!: number | undefined;
    inProgressTasks!: number | undefined;
    notStartedTasks!: number | undefined;

    constructor(data?: IProjectTeamDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.competedTasks = _data["competedTasks"];
            this.inProgressTasks = _data["inProgressTasks"];
            this.notStartedTasks = _data["notStartedTasks"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTeamDashboardDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTeamDashboardDto>(data, _mappings, ProjectTeamDashboardDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["competedTasks"] = this.competedTasks;
        data["inProgressTasks"] = this.inProgressTasks;
        data["notStartedTasks"] = this.notStartedTasks;
        return data;
    }
}

export interface IProjectTeamDashboardDto {
    userId: number | undefined;
    userName: string | undefined;
    profilePictureUrl: string | undefined;
    competedTasks: number | undefined;
    inProgressTasks: number | undefined;
    notStartedTasks: number | undefined;
}

export class ProjectDashboardOutputDto implements IProjectDashboardOutputDto {
    projectId!: number | undefined;
    projectName!: string | undefined;
    statusName!: string | undefined;
    statusId!: number | undefined;
    code!: number | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isPrivate!: boolean | undefined;
    healthScore!: number | undefined;
    healthType!: string | undefined;
    scoreExplanation!: string | undefined;
    scoreLastUpdated!: string | undefined;
    currentProgress!: number | undefined;
    expectedProgress!: number | undefined;
    taskCompletionPercentage!: number | undefined;
    percentLeft!: number | undefined;
    variance!: number | undefined;
    varianceString!: string | undefined;
    daysRemaining!: number | undefined;
    daysRemainingString!: string | undefined;
    tasksPerWeek!: number | undefined;
    weeklyTrend!: number | undefined;
    averageCheckIn!: number | undefined;
    teamActivityPercent!: number | undefined;
    totalTasks!: number | undefined;
    totalCompletedTasks!: number | undefined;
    totalInProgressTasks!: number | undefined;
    totalNotStartedTasks!: number | undefined;
    totalOverdueTasks!: number | undefined;
    projectSectionAsJson!: string | undefined;
    readonly projectSections!: ProjectSectionsDashboardDto[] | undefined;
    projectTeamAsJson!: string | undefined;
    readonly projectTeam!: ProjectTeamDashboardDto[] | undefined;
    projectActiveTeamAsJson!: string | undefined;
    readonly projectActiveTeam!: ProjectTeamDashboardDto[] | undefined;

    constructor(data?: IProjectDashboardOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.statusName = _data["statusName"];
            this.statusId = _data["statusId"];
            this.code = _data["code"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isPrivate = _data["isPrivate"];
            this.healthScore = _data["healthScore"];
            this.healthType = _data["healthType"];
            this.scoreExplanation = _data["scoreExplanation"];
            this.scoreLastUpdated = _data["scoreLastUpdated"];
            this.currentProgress = _data["currentProgress"];
            this.expectedProgress = _data["expectedProgress"];
            this.taskCompletionPercentage = _data["taskCompletionPercentage"];
            this.percentLeft = _data["percentLeft"];
            this.variance = _data["variance"];
            this.varianceString = _data["varianceString"];
            this.daysRemaining = _data["daysRemaining"];
            this.daysRemainingString = _data["daysRemainingString"];
            this.tasksPerWeek = _data["tasksPerWeek"];
            this.weeklyTrend = _data["weeklyTrend"];
            this.averageCheckIn = _data["averageCheckIn"];
            this.teamActivityPercent = _data["teamActivityPercent"];
            this.totalTasks = _data["totalTasks"];
            this.totalCompletedTasks = _data["totalCompletedTasks"];
            this.totalInProgressTasks = _data["totalInProgressTasks"];
            this.totalNotStartedTasks = _data["totalNotStartedTasks"];
            this.totalOverdueTasks = _data["totalOverdueTasks"];
            this.projectSectionAsJson = _data["projectSectionAsJson"];
            if (Array.isArray(_data["projectSections"])) {
                (this as any).projectSections = [] as any;
                for (let item of _data["projectSections"])
                    (this as any).projectSections!.push(ProjectSectionsDashboardDto.fromJS(item, _mappings));
            }
            this.projectTeamAsJson = _data["projectTeamAsJson"];
            if (Array.isArray(_data["projectTeam"])) {
                (this as any).projectTeam = [] as any;
                for (let item of _data["projectTeam"])
                    (this as any).projectTeam!.push(ProjectTeamDashboardDto.fromJS(item, _mappings));
            }
            this.projectActiveTeamAsJson = _data["projectActiveTeamAsJson"];
            if (Array.isArray(_data["projectActiveTeam"])) {
                (this as any).projectActiveTeam = [] as any;
                for (let item of _data["projectActiveTeam"])
                    (this as any).projectActiveTeam!.push(ProjectTeamDashboardDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectDashboardOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectDashboardOutputDto>(data, _mappings, ProjectDashboardOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["statusName"] = this.statusName;
        data["statusId"] = this.statusId;
        data["code"] = this.code;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isPrivate"] = this.isPrivate;
        data["healthScore"] = this.healthScore;
        data["healthType"] = this.healthType;
        data["scoreExplanation"] = this.scoreExplanation;
        data["scoreLastUpdated"] = this.scoreLastUpdated;
        data["currentProgress"] = this.currentProgress;
        data["expectedProgress"] = this.expectedProgress;
        data["taskCompletionPercentage"] = this.taskCompletionPercentage;
        data["percentLeft"] = this.percentLeft;
        data["variance"] = this.variance;
        data["varianceString"] = this.varianceString;
        data["daysRemaining"] = this.daysRemaining;
        data["daysRemainingString"] = this.daysRemainingString;
        data["tasksPerWeek"] = this.tasksPerWeek;
        data["weeklyTrend"] = this.weeklyTrend;
        data["averageCheckIn"] = this.averageCheckIn;
        data["teamActivityPercent"] = this.teamActivityPercent;
        data["totalTasks"] = this.totalTasks;
        data["totalCompletedTasks"] = this.totalCompletedTasks;
        data["totalInProgressTasks"] = this.totalInProgressTasks;
        data["totalNotStartedTasks"] = this.totalNotStartedTasks;
        data["totalOverdueTasks"] = this.totalOverdueTasks;
        data["projectSectionAsJson"] = this.projectSectionAsJson;
        if (Array.isArray(this.projectSections)) {
            data["projectSections"] = [];
            for (let item of this.projectSections)
                data["projectSections"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectTeamAsJson"] = this.projectTeamAsJson;
        if (Array.isArray(this.projectTeam)) {
            data["projectTeam"] = [];
            for (let item of this.projectTeam)
                data["projectTeam"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectActiveTeamAsJson"] = this.projectActiveTeamAsJson;
        if (Array.isArray(this.projectActiveTeam)) {
            data["projectActiveTeam"] = [];
            for (let item of this.projectActiveTeam)
                data["projectActiveTeam"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectDashboardOutputDto {
    projectId: number | undefined;
    projectName: string | undefined;
    statusName: string | undefined;
    statusId: number | undefined;
    code: number | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isPrivate: boolean | undefined;
    healthScore: number | undefined;
    healthType: string | undefined;
    scoreExplanation: string | undefined;
    scoreLastUpdated: string | undefined;
    currentProgress: number | undefined;
    expectedProgress: number | undefined;
    taskCompletionPercentage: number | undefined;
    percentLeft: number | undefined;
    variance: number | undefined;
    varianceString: string | undefined;
    daysRemaining: number | undefined;
    daysRemainingString: string | undefined;
    tasksPerWeek: number | undefined;
    weeklyTrend: number | undefined;
    averageCheckIn: number | undefined;
    teamActivityPercent: number | undefined;
    totalTasks: number | undefined;
    totalCompletedTasks: number | undefined;
    totalInProgressTasks: number | undefined;
    totalNotStartedTasks: number | undefined;
    totalOverdueTasks: number | undefined;
    projectSectionAsJson: string | undefined;
    projectSections: ProjectSectionsDashboardDto[] | undefined;
    projectTeamAsJson: string | undefined;
    projectTeam: ProjectTeamDashboardDto[] | undefined;
    projectActiveTeamAsJson: string | undefined;
    projectActiveTeam: ProjectTeamDashboardDto[] | undefined;
}

export class ProjectDashboardOutputDtoIHandleError implements IProjectDashboardOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectDashboardOutputDto | undefined;
    listOfEntities!: ProjectDashboardOutputDto[] | undefined;

    constructor(data?: IProjectDashboardOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ProjectDashboardOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ProjectDashboardOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectDashboardOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectDashboardOutputDtoIHandleError>(data, _mappings, ProjectDashboardOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectDashboardOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectDashboardOutputDto | undefined;
    listOfEntities: ProjectDashboardOutputDto[] | undefined;
}

export class UpdateProjectFieldsInputDto implements IUpdateProjectFieldsInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;

    constructor(data?: IUpdateProjectFieldsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateProjectFieldsInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateProjectFieldsInputDto>(data, _mappings, UpdateProjectFieldsInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        return data;
    }
}

export interface IUpdateProjectFieldsInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
}

export class SetProjectStageInputDto implements ISetProjectStageInputDto {
    projectId!: number | undefined;
    projectStageId!: number | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;

    constructor(data?: ISetProjectStageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectStageId = _data["projectStageId"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetProjectStageInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetProjectStageInputDto>(data, _mappings, SetProjectStageInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectStageId"] = this.projectStageId;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ISetProjectStageInputDto {
    projectId: number | undefined;
    projectStageId: number | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
}

export class GetProjectStagesConfigurationDto implements IGetProjectStagesConfigurationDto {
    isStagesEnabled!: boolean | undefined;
    isHealthColumnDefaultVisible!: boolean | undefined;
    stages!: ProjectStageDto[] | undefined;

    constructor(data?: IGetProjectStagesConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isStagesEnabled = _data["isStagesEnabled"];
            this.isHealthColumnDefaultVisible = _data["isHealthColumnDefaultVisible"];
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(ProjectStageDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetProjectStagesConfigurationDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetProjectStagesConfigurationDto>(data, _mappings, GetProjectStagesConfigurationDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isStagesEnabled"] = this.isStagesEnabled;
        data["isHealthColumnDefaultVisible"] = this.isHealthColumnDefaultVisible;
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetProjectStagesConfigurationDto {
    isStagesEnabled: boolean | undefined;
    isHealthColumnDefaultVisible: boolean | undefined;
    stages: ProjectStageDto[] | undefined;
}

export class GetProjectStagesConfigurationDtoIHandleError implements IGetProjectStagesConfigurationDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetProjectStagesConfigurationDto | undefined;
    listOfEntities!: GetProjectStagesConfigurationDto[] | undefined;

    constructor(data?: IGetProjectStagesConfigurationDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetProjectStagesConfigurationDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetProjectStagesConfigurationDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetProjectStagesConfigurationDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetProjectStagesConfigurationDtoIHandleError>(data, _mappings, GetProjectStagesConfigurationDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetProjectStagesConfigurationDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetProjectStagesConfigurationDto | undefined;
    listOfEntities: GetProjectStagesConfigurationDto[] | undefined;
}

export class SetProjectStagesConfigurationDto implements ISetProjectStagesConfigurationDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    isStagesEnabled!: boolean | undefined;
    stages!: ProjectStageDto[] | undefined;

    constructor(data?: ISetProjectStagesConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.isStagesEnabled = _data["isStagesEnabled"];
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(ProjectStageDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SetProjectStagesConfigurationDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetProjectStagesConfigurationDto>(data, _mappings, SetProjectStagesConfigurationDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["isStagesEnabled"] = this.isStagesEnabled;
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISetProjectStagesConfigurationDto {
    userId: number | undefined;
    tenantId: number | undefined;
    isStagesEnabled: boolean | undefined;
    stages: ProjectStageDto[] | undefined;
}

export class SpecificStageOrderDto implements ISpecificStageOrderDto {
    projectStageId!: number | undefined;
    userSpecificOrderNumber!: number | undefined;

    constructor(data?: ISpecificStageOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectStageId = _data["projectStageId"];
            this.userSpecificOrderNumber = _data["userSpecificOrderNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): SpecificStageOrderDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SpecificStageOrderDto>(data, _mappings, SpecificStageOrderDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectStageId"] = this.projectStageId;
        data["userSpecificOrderNumber"] = this.userSpecificOrderNumber;
        return data;
    }
}

export interface ISpecificStageOrderDto {
    projectStageId: number | undefined;
    userSpecificOrderNumber: number | undefined;
}

export class SetProjectStageSpecificOrder implements ISetProjectStageSpecificOrder {
    userId!: number | undefined;
    specificStageOrder!: SpecificStageOrderDto[] | undefined;

    constructor(data?: ISetProjectStageSpecificOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["specificStageOrder"])) {
                this.specificStageOrder = [] as any;
                for (let item of _data["specificStageOrder"])
                    this.specificStageOrder!.push(SpecificStageOrderDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SetProjectStageSpecificOrder | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetProjectStageSpecificOrder>(data, _mappings, SetProjectStageSpecificOrder);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.specificStageOrder)) {
            data["specificStageOrder"] = [];
            for (let item of this.specificStageOrder)
                data["specificStageOrder"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISetProjectStageSpecificOrder {
    userId: number | undefined;
    specificStageOrder: SpecificStageOrderDto[] | undefined;
}

export class CreateTaskFromAgendaInput implements ICreateTaskFromAgendaInput {
    id!: number | undefined;
    taskName!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    ownerId!: number | undefined;
    code!: number | undefined;
    assignedToUserId!: number | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    projectId!: number | undefined;
    sectionId!: number | undefined;
    isFromDrop!: boolean | undefined;
    isPrivate!: boolean | undefined;
    tenantId!: number | undefined;
    priority!: TaskPriority | undefined;
    tagList!: TaskTagInputDto[] | undefined;
    checkLists!: TaskChecklist[] | undefined;
    attachments!: CommonAttachment[] | undefined;
    entityType!: TaskEntityType | undefined;
    taskType!: TaskTypes | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactCompanyId!: number | undefined;
    contactCompanyName!: string | undefined;
    selectedMyDayDate!: string | undefined;
    actionPerformed!: string | undefined;
    parentId!: number | undefined;
    startDelay!: number | undefined;
    duration!: number | undefined;
    taskWatchersIds!: number[] | undefined;
    resourceAppName!: string | undefined;
    resourceAppUrl!: string | undefined;
    plannerCategoryId!: number | undefined;
    userSectionId!: number | undefined;

    constructor(data?: ICreateTaskFromAgendaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.ownerId = _data["ownerId"];
            this.code = _data["code"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.projectId = _data["projectId"];
            this.sectionId = _data["sectionId"];
            this.isFromDrop = _data["isFromDrop"];
            this.isPrivate = _data["isPrivate"];
            this.tenantId = _data["tenantId"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["tagList"])) {
                this.tagList = [] as any;
                for (let item of _data["tagList"])
                    this.tagList!.push(TaskTagInputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["checkLists"])) {
                this.checkLists = [] as any;
                for (let item of _data["checkLists"])
                    this.checkLists!.push(TaskChecklist.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CommonAttachment.fromJS(item, _mappings));
            }
            this.entityType = _data["entityType"];
            this.taskType = _data["taskType"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactCompanyId = _data["contactCompanyId"];
            this.contactCompanyName = _data["contactCompanyName"];
            this.selectedMyDayDate = _data["selectedMyDayDate"];
            this.actionPerformed = _data["actionPerformed"];
            this.parentId = _data["parentId"];
            this.startDelay = _data["startDelay"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["taskWatchersIds"])) {
                this.taskWatchersIds = [] as any;
                for (let item of _data["taskWatchersIds"])
                    this.taskWatchersIds!.push(item);
            }
            this.resourceAppName = _data["resourceAppName"];
            this.resourceAppUrl = _data["resourceAppUrl"];
            this.plannerCategoryId = _data["plannerCategoryId"];
            this.userSectionId = _data["userSectionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateTaskFromAgendaInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateTaskFromAgendaInput>(data, _mappings, CreateTaskFromAgendaInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["ownerId"] = this.ownerId;
        data["code"] = this.code;
        data["assignedToUserId"] = this.assignedToUserId;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["projectId"] = this.projectId;
        data["sectionId"] = this.sectionId;
        data["isFromDrop"] = this.isFromDrop;
        data["isPrivate"] = this.isPrivate;
        data["tenantId"] = this.tenantId;
        data["priority"] = this.priority;
        if (Array.isArray(this.tagList)) {
            data["tagList"] = [];
            for (let item of this.tagList)
                data["tagList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.checkLists)) {
            data["checkLists"] = [];
            for (let item of this.checkLists)
                data["checkLists"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["entityType"] = this.entityType;
        data["taskType"] = this.taskType;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactCompanyId"] = this.contactCompanyId;
        data["contactCompanyName"] = this.contactCompanyName;
        data["selectedMyDayDate"] = this.selectedMyDayDate;
        data["actionPerformed"] = this.actionPerformed;
        data["parentId"] = this.parentId;
        data["startDelay"] = this.startDelay;
        data["duration"] = this.duration;
        if (Array.isArray(this.taskWatchersIds)) {
            data["taskWatchersIds"] = [];
            for (let item of this.taskWatchersIds)
                data["taskWatchersIds"].push(item);
        }
        data["resourceAppName"] = this.resourceAppName;
        data["resourceAppUrl"] = this.resourceAppUrl;
        data["plannerCategoryId"] = this.plannerCategoryId;
        data["userSectionId"] = this.userSectionId;
        return data;
    }
}

export interface ICreateTaskFromAgendaInput {
    id: number | undefined;
    taskName: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    ownerId: number | undefined;
    code: number | undefined;
    assignedToUserId: number | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    projectId: number | undefined;
    sectionId: number | undefined;
    isFromDrop: boolean | undefined;
    isPrivate: boolean | undefined;
    tenantId: number | undefined;
    priority: TaskPriority | undefined;
    tagList: TaskTagInputDto[] | undefined;
    checkLists: TaskChecklist[] | undefined;
    attachments: CommonAttachment[] | undefined;
    entityType: TaskEntityType | undefined;
    taskType: TaskTypes | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactCompanyId: number | undefined;
    contactCompanyName: string | undefined;
    selectedMyDayDate: string | undefined;
    actionPerformed: string | undefined;
    parentId: number | undefined;
    startDelay: number | undefined;
    duration: number | undefined;
    taskWatchersIds: number[] | undefined;
    resourceAppName: string | undefined;
    resourceAppUrl: string | undefined;
    plannerCategoryId: number | undefined;
    userSectionId: number | undefined;
}

export class CreateTaskFromAgendaOutputDto implements ICreateTaskFromAgendaOutputDto {
    id!: number | undefined;
    title!: string | undefined;
    isDueDatePassed!: boolean | undefined;
    progressCompleted!: number | undefined;
    resourceName!: string | undefined;
    resourceAppUrl!: string | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    projectColor!: string | undefined;
    sectionName!: string | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactCompanyId!: number | undefined;
    contactCompanyName!: string | undefined;
    contactTypeColor!: string | undefined;
    entityType!: TaskEntityType | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isPrivate!: boolean | undefined;
    priority!: TaskPriority | undefined;
    userSectionId!: number | undefined;

    constructor(data?: ICreateTaskFromAgendaOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.progressCompleted = _data["progressCompleted"];
            this.resourceName = _data["resourceName"];
            this.resourceAppUrl = _data["resourceAppUrl"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectColor = _data["projectColor"];
            this.sectionName = _data["sectionName"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactCompanyId = _data["contactCompanyId"];
            this.contactCompanyName = _data["contactCompanyName"];
            this.contactTypeColor = _data["contactTypeColor"];
            this.entityType = _data["entityType"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isPrivate = _data["isPrivate"];
            this.priority = _data["priority"];
            this.userSectionId = _data["userSectionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateTaskFromAgendaOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateTaskFromAgendaOutputDto>(data, _mappings, CreateTaskFromAgendaOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["progressCompleted"] = this.progressCompleted;
        data["resourceName"] = this.resourceName;
        data["resourceAppUrl"] = this.resourceAppUrl;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectColor"] = this.projectColor;
        data["sectionName"] = this.sectionName;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactCompanyId"] = this.contactCompanyId;
        data["contactCompanyName"] = this.contactCompanyName;
        data["contactTypeColor"] = this.contactTypeColor;
        data["entityType"] = this.entityType;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isPrivate"] = this.isPrivate;
        data["priority"] = this.priority;
        data["userSectionId"] = this.userSectionId;
        return data;
    }
}

export interface ICreateTaskFromAgendaOutputDto {
    id: number | undefined;
    title: string | undefined;
    isDueDatePassed: boolean | undefined;
    progressCompleted: number | undefined;
    resourceName: string | undefined;
    resourceAppUrl: string | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    projectColor: string | undefined;
    sectionName: string | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactCompanyId: number | undefined;
    contactCompanyName: string | undefined;
    contactTypeColor: string | undefined;
    entityType: TaskEntityType | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isPrivate: boolean | undefined;
    priority: TaskPriority | undefined;
    userSectionId: number | undefined;
}

export class CreateTaskFromAgendaOutputDtoIHandleError implements ICreateTaskFromAgendaOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CreateTaskFromAgendaOutputDto | undefined;
    listOfEntities!: CreateTaskFromAgendaOutputDto[] | undefined;

    constructor(data?: ICreateTaskFromAgendaOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CreateTaskFromAgendaOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CreateTaskFromAgendaOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateTaskFromAgendaOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateTaskFromAgendaOutputDtoIHandleError>(data, _mappings, CreateTaskFromAgendaOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateTaskFromAgendaOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CreateTaskFromAgendaOutputDto | undefined;
    listOfEntities: CreateTaskFromAgendaOutputDto[] | undefined;
}

export class CreateEmailTaskInput implements ICreateEmailTaskInput {
    id!: number | undefined;
    taskName!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    ownerId!: number | undefined;
    code!: number | undefined;
    assignedToUserId!: number | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    projectId!: number | undefined;
    sectionId!: number | undefined;
    isFromDrop!: boolean | undefined;
    isPrivate!: boolean | undefined;
    tenantId!: number | undefined;
    priority!: TaskPriority | undefined;
    tagList!: TaskTagInputDto[] | undefined;
    checkLists!: TaskChecklist[] | undefined;
    attachments!: CommonAttachment[] | undefined;
    entityType!: TaskEntityType | undefined;
    taskType!: TaskTypes | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactCompanyId!: number | undefined;
    contactCompanyName!: string | undefined;
    selectedMyDayDate!: string | undefined;
    actionPerformed!: string | undefined;
    parentId!: number | undefined;
    startDelay!: number | undefined;
    duration!: number | undefined;
    taskWatchersIds!: number[] | undefined;
    associationId!: string | undefined;
    associationAppName!: string | undefined;
    associationAppUrl!: string | undefined;

    constructor(data?: ICreateEmailTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.ownerId = _data["ownerId"];
            this.code = _data["code"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.projectId = _data["projectId"];
            this.sectionId = _data["sectionId"];
            this.isFromDrop = _data["isFromDrop"];
            this.isPrivate = _data["isPrivate"];
            this.tenantId = _data["tenantId"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["tagList"])) {
                this.tagList = [] as any;
                for (let item of _data["tagList"])
                    this.tagList!.push(TaskTagInputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["checkLists"])) {
                this.checkLists = [] as any;
                for (let item of _data["checkLists"])
                    this.checkLists!.push(TaskChecklist.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CommonAttachment.fromJS(item, _mappings));
            }
            this.entityType = _data["entityType"];
            this.taskType = _data["taskType"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactCompanyId = _data["contactCompanyId"];
            this.contactCompanyName = _data["contactCompanyName"];
            this.selectedMyDayDate = _data["selectedMyDayDate"];
            this.actionPerformed = _data["actionPerformed"];
            this.parentId = _data["parentId"];
            this.startDelay = _data["startDelay"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["taskWatchersIds"])) {
                this.taskWatchersIds = [] as any;
                for (let item of _data["taskWatchersIds"])
                    this.taskWatchersIds!.push(item);
            }
            this.associationId = _data["associationId"];
            this.associationAppName = _data["associationAppName"];
            this.associationAppUrl = _data["associationAppUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateEmailTaskInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateEmailTaskInput>(data, _mappings, CreateEmailTaskInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["ownerId"] = this.ownerId;
        data["code"] = this.code;
        data["assignedToUserId"] = this.assignedToUserId;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["projectId"] = this.projectId;
        data["sectionId"] = this.sectionId;
        data["isFromDrop"] = this.isFromDrop;
        data["isPrivate"] = this.isPrivate;
        data["tenantId"] = this.tenantId;
        data["priority"] = this.priority;
        if (Array.isArray(this.tagList)) {
            data["tagList"] = [];
            for (let item of this.tagList)
                data["tagList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.checkLists)) {
            data["checkLists"] = [];
            for (let item of this.checkLists)
                data["checkLists"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["entityType"] = this.entityType;
        data["taskType"] = this.taskType;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactCompanyId"] = this.contactCompanyId;
        data["contactCompanyName"] = this.contactCompanyName;
        data["selectedMyDayDate"] = this.selectedMyDayDate;
        data["actionPerformed"] = this.actionPerformed;
        data["parentId"] = this.parentId;
        data["startDelay"] = this.startDelay;
        data["duration"] = this.duration;
        if (Array.isArray(this.taskWatchersIds)) {
            data["taskWatchersIds"] = [];
            for (let item of this.taskWatchersIds)
                data["taskWatchersIds"].push(item);
        }
        data["associationId"] = this.associationId;
        data["associationAppName"] = this.associationAppName;
        data["associationAppUrl"] = this.associationAppUrl;
        return data;
    }
}

export interface ICreateEmailTaskInput {
    id: number | undefined;
    taskName: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    ownerId: number | undefined;
    code: number | undefined;
    assignedToUserId: number | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    projectId: number | undefined;
    sectionId: number | undefined;
    isFromDrop: boolean | undefined;
    isPrivate: boolean | undefined;
    tenantId: number | undefined;
    priority: TaskPriority | undefined;
    tagList: TaskTagInputDto[] | undefined;
    checkLists: TaskChecklist[] | undefined;
    attachments: CommonAttachment[] | undefined;
    entityType: TaskEntityType | undefined;
    taskType: TaskTypes | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactCompanyId: number | undefined;
    contactCompanyName: string | undefined;
    selectedMyDayDate: string | undefined;
    actionPerformed: string | undefined;
    parentId: number | undefined;
    startDelay: number | undefined;
    duration: number | undefined;
    taskWatchersIds: number[] | undefined;
    associationId: string | undefined;
    associationAppName: string | undefined;
    associationAppUrl: string | undefined;
}

export class CreateOrUpdateManualTaskInput implements ICreateOrUpdateManualTaskInput {
    id!: number | undefined;
    taskName!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    ownerId!: number | undefined;
    code!: number | undefined;
    assignedToUserId!: number | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    projectId!: number | undefined;
    sectionId!: number | undefined;
    isFromDrop!: boolean | undefined;
    isPrivate!: boolean | undefined;
    tenantId!: number | undefined;
    priority!: TaskPriority | undefined;
    tagList!: TaskTagInputDto[] | undefined;
    checkLists!: TaskChecklist[] | undefined;
    attachments!: CommonAttachment[] | undefined;
    entityType!: TaskEntityType | undefined;
    taskType!: TaskTypes | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactCompanyId!: number | undefined;
    contactCompanyName!: string | undefined;
    selectedMyDayDate!: string | undefined;
    actionPerformed!: string | undefined;
    parentId!: number | undefined;
    startDelay!: number | undefined;
    duration!: number | undefined;
    taskWatchersIds!: number[] | undefined;

    constructor(data?: ICreateOrUpdateManualTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.ownerId = _data["ownerId"];
            this.code = _data["code"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.projectId = _data["projectId"];
            this.sectionId = _data["sectionId"];
            this.isFromDrop = _data["isFromDrop"];
            this.isPrivate = _data["isPrivate"];
            this.tenantId = _data["tenantId"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["tagList"])) {
                this.tagList = [] as any;
                for (let item of _data["tagList"])
                    this.tagList!.push(TaskTagInputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["checkLists"])) {
                this.checkLists = [] as any;
                for (let item of _data["checkLists"])
                    this.checkLists!.push(TaskChecklist.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CommonAttachment.fromJS(item, _mappings));
            }
            this.entityType = _data["entityType"];
            this.taskType = _data["taskType"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactCompanyId = _data["contactCompanyId"];
            this.contactCompanyName = _data["contactCompanyName"];
            this.selectedMyDayDate = _data["selectedMyDayDate"];
            this.actionPerformed = _data["actionPerformed"];
            this.parentId = _data["parentId"];
            this.startDelay = _data["startDelay"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["taskWatchersIds"])) {
                this.taskWatchersIds = [] as any;
                for (let item of _data["taskWatchersIds"])
                    this.taskWatchersIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateOrUpdateManualTaskInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateOrUpdateManualTaskInput>(data, _mappings, CreateOrUpdateManualTaskInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["ownerId"] = this.ownerId;
        data["code"] = this.code;
        data["assignedToUserId"] = this.assignedToUserId;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["projectId"] = this.projectId;
        data["sectionId"] = this.sectionId;
        data["isFromDrop"] = this.isFromDrop;
        data["isPrivate"] = this.isPrivate;
        data["tenantId"] = this.tenantId;
        data["priority"] = this.priority;
        if (Array.isArray(this.tagList)) {
            data["tagList"] = [];
            for (let item of this.tagList)
                data["tagList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.checkLists)) {
            data["checkLists"] = [];
            for (let item of this.checkLists)
                data["checkLists"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["entityType"] = this.entityType;
        data["taskType"] = this.taskType;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactCompanyId"] = this.contactCompanyId;
        data["contactCompanyName"] = this.contactCompanyName;
        data["selectedMyDayDate"] = this.selectedMyDayDate;
        data["actionPerformed"] = this.actionPerformed;
        data["parentId"] = this.parentId;
        data["startDelay"] = this.startDelay;
        data["duration"] = this.duration;
        if (Array.isArray(this.taskWatchersIds)) {
            data["taskWatchersIds"] = [];
            for (let item of this.taskWatchersIds)
                data["taskWatchersIds"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateManualTaskInput {
    id: number | undefined;
    taskName: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    ownerId: number | undefined;
    code: number | undefined;
    assignedToUserId: number | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    projectId: number | undefined;
    sectionId: number | undefined;
    isFromDrop: boolean | undefined;
    isPrivate: boolean | undefined;
    tenantId: number | undefined;
    priority: TaskPriority | undefined;
    tagList: TaskTagInputDto[] | undefined;
    checkLists: TaskChecklist[] | undefined;
    attachments: CommonAttachment[] | undefined;
    entityType: TaskEntityType | undefined;
    taskType: TaskTypes | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactCompanyId: number | undefined;
    contactCompanyName: string | undefined;
    selectedMyDayDate: string | undefined;
    actionPerformed: string | undefined;
    parentId: number | undefined;
    startDelay: number | undefined;
    duration: number | undefined;
    taskWatchersIds: number[] | undefined;
}

export class GetUserTasksListTaskCountsListValueTuple implements IGetUserTasksListTaskCountsListValueTuple {

    constructor(data?: IGetUserTasksListTaskCountsListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): GetUserTasksListTaskCountsListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserTasksListTaskCountsListValueTuple>(data, _mappings, GetUserTasksListTaskCountsListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetUserTasksListTaskCountsListValueTuple {
}

export class GetUserTasksListTaskCountsListValueTupleIHandleError implements IGetUserTasksListTaskCountsListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetUserTasksListTaskCountsListValueTuple | undefined;
    listOfEntities!: GetUserTasksListTaskCountsListValueTuple[] | undefined;

    constructor(data?: IGetUserTasksListTaskCountsListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetUserTasksListTaskCountsListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetUserTasksListTaskCountsListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserTasksListTaskCountsListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserTasksListTaskCountsListValueTupleIHandleError>(data, _mappings, GetUserTasksListTaskCountsListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetUserTasksListTaskCountsListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetUserTasksListTaskCountsListValueTuple | undefined;
    listOfEntities: GetUserTasksListTaskCountsListValueTuple[] | undefined;
}

export class TaskHistoryDtoListIHandleError implements ITaskHistoryDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskHistoryDto[] | undefined;
    listOfEntities!: TaskHistoryDto[][] | undefined;

    constructor(data?: ITaskHistoryDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TaskHistoryDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskHistoryDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskHistoryDtoListIHandleError>(data, _mappings, TaskHistoryDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITaskHistoryDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskHistoryDto[] | undefined;
    listOfEntities: TaskHistoryDto[][] | undefined;
}

export class LookupTableOutputDtoListIHandleError implements ILookupTableOutputDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LookupTableOutputDto[] | undefined;
    listOfEntities!: LookupTableOutputDto[][] | undefined;

    constructor(data?: ILookupTableOutputDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(LookupTableOutputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LookupTableOutputDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LookupTableOutputDtoListIHandleError>(data, _mappings, LookupTableOutputDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ILookupTableOutputDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LookupTableOutputDto[] | undefined;
    listOfEntities: LookupTableOutputDto[][] | undefined;
}

export class TaskDetailsIHandleError implements ITaskDetailsIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskDetails | undefined;
    listOfEntities!: TaskDetails[] | undefined;

    constructor(data?: ITaskDetailsIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TaskDetails.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TaskDetails.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskDetailsIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskDetailsIHandleError>(data, _mappings, TaskDetailsIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskDetailsIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskDetails | undefined;
    listOfEntities: TaskDetails[] | undefined;
}

export class ParentTaskDetails implements IParentTaskDetails {
    id!: number | undefined;
    title!: string | undefined;
    dueDate!: string | undefined;
    completedOn!: string | undefined;
    stageId!: number | undefined;
    stageCode!: number | undefined;

    constructor(data?: IParentTaskDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.dueDate = _data["dueDate"];
            this.completedOn = _data["completedOn"];
            this.stageId = _data["stageId"];
            this.stageCode = _data["stageCode"];
        }
    }

    static fromJS(data: any, _mappings?: any): ParentTaskDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ParentTaskDetails>(data, _mappings, ParentTaskDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["dueDate"] = this.dueDate;
        data["completedOn"] = this.completedOn;
        data["stageId"] = this.stageId;
        data["stageCode"] = this.stageCode;
        return data;
    }
}

export interface IParentTaskDetails {
    id: number | undefined;
    title: string | undefined;
    dueDate: string | undefined;
    completedOn: string | undefined;
    stageId: number | undefined;
    stageCode: number | undefined;
}

export class ParentTaskDetailsIHandleError implements IParentTaskDetailsIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ParentTaskDetails | undefined;
    listOfEntities!: ParentTaskDetails[] | undefined;

    constructor(data?: IParentTaskDetailsIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ParentTaskDetails.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ParentTaskDetails.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ParentTaskDetailsIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ParentTaskDetailsIHandleError>(data, _mappings, ParentTaskDetailsIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParentTaskDetailsIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ParentTaskDetails | undefined;
    listOfEntities: ParentTaskDetails[] | undefined;
}

export enum StepOwner {
    _1 = 1,
    _2 = 2,
}

export class StepDetailsOutput implements IStepDetailsOutput {
    id!: number | undefined;
    owner!: StepOwner | undefined;
    ownerId!: number | undefined;
    title!: string | undefined;
    description!: string | undefined;
    sortOrder!: number | undefined;
    dueDate!: string | undefined;
    code!: number | undefined;
    isCompleted!: boolean | undefined;
    assignedToId!: number | undefined;
    isAutoAdd!: boolean | undefined;

    constructor(data?: IStepDetailsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.owner = _data["owner"];
            this.ownerId = _data["ownerId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.dueDate = _data["dueDate"];
            this.code = _data["code"];
            this.isCompleted = _data["isCompleted"];
            this.assignedToId = _data["assignedToId"];
            this.isAutoAdd = _data["isAutoAdd"];
        }
    }

    static fromJS(data: any, _mappings?: any): StepDetailsOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StepDetailsOutput>(data, _mappings, StepDetailsOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["owner"] = this.owner;
        data["ownerId"] = this.ownerId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["dueDate"] = this.dueDate;
        data["code"] = this.code;
        data["isCompleted"] = this.isCompleted;
        data["assignedToId"] = this.assignedToId;
        data["isAutoAdd"] = this.isAutoAdd;
        return data;
    }
}

export interface IStepDetailsOutput {
    id: number | undefined;
    owner: StepOwner | undefined;
    ownerId: number | undefined;
    title: string | undefined;
    description: string | undefined;
    sortOrder: number | undefined;
    dueDate: string | undefined;
    code: number | undefined;
    isCompleted: boolean | undefined;
    assignedToId: number | undefined;
    isAutoAdd: boolean | undefined;
}

export class StepDetailsOutputIHandleError implements IStepDetailsOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: StepDetailsOutput | undefined;
    listOfEntities!: StepDetailsOutput[] | undefined;

    constructor(data?: IStepDetailsOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? StepDetailsOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(StepDetailsOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): StepDetailsOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StepDetailsOutputIHandleError>(data, _mappings, StepDetailsOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStepDetailsOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: StepDetailsOutput | undefined;
    listOfEntities: StepDetailsOutput[] | undefined;
}

export class CheckListOutputDto implements ICheckListOutputDto {
    taskCheckListId!: number | undefined;
    taskProgress!: number | undefined;
    currentDate!: string | undefined;

    constructor(data?: ICheckListOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskCheckListId = _data["taskCheckListId"];
            this.taskProgress = _data["taskProgress"];
            this.currentDate = _data["currentDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): CheckListOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckListOutputDto>(data, _mappings, CheckListOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskCheckListId"] = this.taskCheckListId;
        data["taskProgress"] = this.taskProgress;
        data["currentDate"] = this.currentDate;
        return data;
    }
}

export interface ICheckListOutputDto {
    taskCheckListId: number | undefined;
    taskProgress: number | undefined;
    currentDate: string | undefined;
}

export class CheckListOutputDtoIHandleError implements ICheckListOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CheckListOutputDto | undefined;
    listOfEntities!: CheckListOutputDto[] | undefined;

    constructor(data?: ICheckListOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CheckListOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CheckListOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CheckListOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckListOutputDtoIHandleError>(data, _mappings, CheckListOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICheckListOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CheckListOutputDto | undefined;
    listOfEntities: CheckListOutputDto[] | undefined;
}

export class CheckListsListIHandleError implements ICheckListsListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CheckLists[] | undefined;
    listOfEntities!: CheckLists[][] | undefined;

    constructor(data?: ICheckListsListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(CheckLists.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CheckListsListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckListsListIHandleError>(data, _mappings, CheckListsListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ICheckListsListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CheckLists[] | undefined;
    listOfEntities: CheckLists[][] | undefined;
}

export class TaskPrivacyInput implements ITaskPrivacyInput {
    taskId!: number | undefined;
    isPrivate!: boolean | undefined;

    constructor(data?: ITaskPrivacyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.isPrivate = _data["isPrivate"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskPrivacyInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskPrivacyInput>(data, _mappings, TaskPrivacyInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["isPrivate"] = this.isPrivate;
        return data;
    }
}

export interface ITaskPrivacyInput {
    taskId: number | undefined;
    isPrivate: boolean | undefined;
}

export class TaskCopyInput implements ITaskCopyInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    taskId!: number | undefined;
    taskName!: string | undefined;
    assignTo!: number | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    selectedMyDayDate!: string | undefined;
    projectId!: number | undefined;
    sectionId!: number | undefined;
    code!: number | undefined;
    tagList!: TaskTagInputDto[] | undefined;
    isCopyDescription!: boolean | undefined;
    isCopyChecklist!: boolean | undefined;
    isCopyChecklistDesc!: boolean | undefined;
    isCopyFileLink!: boolean | undefined;
    taskType!: TaskTypes | undefined;

    constructor(data?: ITaskCopyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.assignTo = _data["assignTo"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.selectedMyDayDate = _data["selectedMyDayDate"];
            this.projectId = _data["projectId"];
            this.sectionId = _data["sectionId"];
            this.code = _data["code"];
            if (Array.isArray(_data["tagList"])) {
                this.tagList = [] as any;
                for (let item of _data["tagList"])
                    this.tagList!.push(TaskTagInputDto.fromJS(item, _mappings));
            }
            this.isCopyDescription = _data["isCopyDescription"];
            this.isCopyChecklist = _data["isCopyChecklist"];
            this.isCopyChecklistDesc = _data["isCopyChecklistDesc"];
            this.isCopyFileLink = _data["isCopyFileLink"];
            this.taskType = _data["taskType"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskCopyInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskCopyInput>(data, _mappings, TaskCopyInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["assignTo"] = this.assignTo;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["selectedMyDayDate"] = this.selectedMyDayDate;
        data["projectId"] = this.projectId;
        data["sectionId"] = this.sectionId;
        data["code"] = this.code;
        if (Array.isArray(this.tagList)) {
            data["tagList"] = [];
            for (let item of this.tagList)
                data["tagList"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCopyDescription"] = this.isCopyDescription;
        data["isCopyChecklist"] = this.isCopyChecklist;
        data["isCopyChecklistDesc"] = this.isCopyChecklistDesc;
        data["isCopyFileLink"] = this.isCopyFileLink;
        data["taskType"] = this.taskType;
        return data;
    }
}

export interface ITaskCopyInput {
    userId: number | undefined;
    tenantId: number | undefined;
    taskId: number | undefined;
    taskName: string | undefined;
    assignTo: number | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    selectedMyDayDate: string | undefined;
    projectId: number | undefined;
    sectionId: number | undefined;
    code: number | undefined;
    tagList: TaskTagInputDto[] | undefined;
    isCopyDescription: boolean | undefined;
    isCopyChecklist: boolean | undefined;
    isCopyChecklistDesc: boolean | undefined;
    isCopyFileLink: boolean | undefined;
    taskType: TaskTypes | undefined;
}

export class CommentMentionLists implements ICommentMentionLists {
    id!: number | undefined;
    name!: string | undefined;

    constructor(data?: ICommentMentionLists) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): CommentMentionLists | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CommentMentionLists>(data, _mappings, CommentMentionLists);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICommentMentionLists {
    id: number | undefined;
    name: string | undefined;
}

export class UpdateTaskCommentInputDto implements IUpdateTaskCommentInputDto {
    comment!: string | undefined;
    taskId!: number | undefined;
    currentUserId!: number | undefined;
    creationTime!: string | undefined;
    commentMentionLists!: CommentMentionLists[] | undefined;
    parentCommentId!: number | undefined;
    anchorQuote!: string | undefined;
    anchorRangeJson!: string | undefined;
    id!: number | undefined;

    constructor(data?: IUpdateTaskCommentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.taskId = _data["taskId"];
            this.currentUserId = _data["currentUserId"];
            this.creationTime = _data["creationTime"];
            if (Array.isArray(_data["commentMentionLists"])) {
                this.commentMentionLists = [] as any;
                for (let item of _data["commentMentionLists"])
                    this.commentMentionLists!.push(CommentMentionLists.fromJS(item, _mappings));
            }
            this.parentCommentId = _data["parentCommentId"];
            this.anchorQuote = _data["anchorQuote"];
            this.anchorRangeJson = _data["anchorRangeJson"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateTaskCommentInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateTaskCommentInputDto>(data, _mappings, UpdateTaskCommentInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["taskId"] = this.taskId;
        data["currentUserId"] = this.currentUserId;
        data["creationTime"] = this.creationTime;
        if (Array.isArray(this.commentMentionLists)) {
            data["commentMentionLists"] = [];
            for (let item of this.commentMentionLists)
                data["commentMentionLists"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentCommentId"] = this.parentCommentId;
        data["anchorQuote"] = this.anchorQuote;
        data["anchorRangeJson"] = this.anchorRangeJson;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTaskCommentInputDto {
    comment: string | undefined;
    taskId: number | undefined;
    currentUserId: number | undefined;
    creationTime: string | undefined;
    commentMentionLists: CommentMentionLists[] | undefined;
    parentCommentId: number | undefined;
    anchorQuote: string | undefined;
    anchorRangeJson: string | undefined;
    id: number | undefined;
}

export class TaskCommentInputDto implements ITaskCommentInputDto {
    comment!: string | undefined;
    taskId!: number | undefined;
    currentUserId!: number | undefined;
    creationTime!: string | undefined;
    commentMentionLists!: CommentMentionLists[] | undefined;
    parentCommentId!: number | undefined;
    anchorQuote!: string | undefined;
    anchorRangeJson!: string | undefined;

    constructor(data?: ITaskCommentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.taskId = _data["taskId"];
            this.currentUserId = _data["currentUserId"];
            this.creationTime = _data["creationTime"];
            if (Array.isArray(_data["commentMentionLists"])) {
                this.commentMentionLists = [] as any;
                for (let item of _data["commentMentionLists"])
                    this.commentMentionLists!.push(CommentMentionLists.fromJS(item, _mappings));
            }
            this.parentCommentId = _data["parentCommentId"];
            this.anchorQuote = _data["anchorQuote"];
            this.anchorRangeJson = _data["anchorRangeJson"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskCommentInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskCommentInputDto>(data, _mappings, TaskCommentInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["taskId"] = this.taskId;
        data["currentUserId"] = this.currentUserId;
        data["creationTime"] = this.creationTime;
        if (Array.isArray(this.commentMentionLists)) {
            data["commentMentionLists"] = [];
            for (let item of this.commentMentionLists)
                data["commentMentionLists"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentCommentId"] = this.parentCommentId;
        data["anchorQuote"] = this.anchorQuote;
        data["anchorRangeJson"] = this.anchorRangeJson;
        return data;
    }
}

export interface ITaskCommentInputDto {
    comment: string | undefined;
    taskId: number | undefined;
    currentUserId: number | undefined;
    creationTime: string | undefined;
    commentMentionLists: CommentMentionLists[] | undefined;
    parentCommentId: number | undefined;
    anchorQuote: string | undefined;
    anchorRangeJson: string | undefined;
}

export class ResolveCommentInputDto implements IResolveCommentInputDto {
    commentId!: number | undefined;
    resolved!: boolean | undefined;
    currentUserId!: number | undefined;

    constructor(data?: IResolveCommentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.commentId = _data["commentId"];
            this.resolved = _data["resolved"];
            this.currentUserId = _data["currentUserId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ResolveCommentInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ResolveCommentInputDto>(data, _mappings, ResolveCommentInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentId"] = this.commentId;
        data["resolved"] = this.resolved;
        data["currentUserId"] = this.currentUserId;
        return data;
    }
}

export interface IResolveCommentInputDto {
    commentId: number | undefined;
    resolved: boolean | undefined;
    currentUserId: number | undefined;
}

export class UpdateTaskCommentTextInputDto implements IUpdateTaskCommentTextInputDto {
    commentId!: number | undefined;
    comment!: string | undefined;

    constructor(data?: IUpdateTaskCommentTextInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.commentId = _data["commentId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateTaskCommentTextInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateTaskCommentTextInputDto>(data, _mappings, UpdateTaskCommentTextInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentId"] = this.commentId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateTaskCommentTextInputDto {
    commentId: number | undefined;
    comment: string | undefined;
}

export class TaskCommentResetInputDto implements ITaskCommentResetInputDto {
    taskId!: number | undefined;
    currentUserId!: number | undefined;

    constructor(data?: ITaskCommentResetInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.currentUserId = _data["currentUserId"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskCommentResetInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskCommentResetInputDto>(data, _mappings, TaskCommentResetInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["currentUserId"] = this.currentUserId;
        return data;
    }
}

export interface ITaskCommentResetInputDto {
    taskId: number | undefined;
    currentUserId: number | undefined;
}

export class UpgradeSubscriptionTaskInput implements IUpgradeSubscriptionTaskInput {
    id!: number | undefined;
    taskName!: string | undefined;
    description!: string | undefined;
    taskCheckLists!: CheckLists[] | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isActive!: boolean | undefined;
    ownerId!: number | undefined;
    code!: number | undefined;
    assignedToUserId!: number | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    projectId!: number | undefined;
    sectionId!: number | undefined;
    currentUserId!: number | undefined;
    tenantId!: number | undefined;
    licenseUsers!: number | undefined;
    subscriptionType!: string | undefined;
    additionalQuestions!: string | undefined;

    constructor(data?: IUpgradeSubscriptionTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.description = _data["description"];
            if (Array.isArray(_data["taskCheckLists"])) {
                this.taskCheckLists = [] as any;
                for (let item of _data["taskCheckLists"])
                    this.taskCheckLists!.push(CheckLists.fromJS(item, _mappings));
            }
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isActive = _data["isActive"];
            this.ownerId = _data["ownerId"];
            this.code = _data["code"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.projectId = _data["projectId"];
            this.sectionId = _data["sectionId"];
            this.currentUserId = _data["currentUserId"];
            this.tenantId = _data["tenantId"];
            this.licenseUsers = _data["licenseUsers"];
            this.subscriptionType = _data["subscriptionType"];
            this.additionalQuestions = _data["additionalQuestions"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpgradeSubscriptionTaskInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpgradeSubscriptionTaskInput>(data, _mappings, UpgradeSubscriptionTaskInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["description"] = this.description;
        if (Array.isArray(this.taskCheckLists)) {
            data["taskCheckLists"] = [];
            for (let item of this.taskCheckLists)
                data["taskCheckLists"].push(item ? item.toJSON() : undefined as any);
        }
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isActive"] = this.isActive;
        data["ownerId"] = this.ownerId;
        data["code"] = this.code;
        data["assignedToUserId"] = this.assignedToUserId;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["projectId"] = this.projectId;
        data["sectionId"] = this.sectionId;
        data["currentUserId"] = this.currentUserId;
        data["tenantId"] = this.tenantId;
        data["licenseUsers"] = this.licenseUsers;
        data["subscriptionType"] = this.subscriptionType;
        data["additionalQuestions"] = this.additionalQuestions;
        return data;
    }
}

export interface IUpgradeSubscriptionTaskInput {
    id: number | undefined;
    taskName: string | undefined;
    description: string | undefined;
    taskCheckLists: CheckLists[] | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isActive: boolean | undefined;
    ownerId: number | undefined;
    code: number | undefined;
    assignedToUserId: number | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    projectId: number | undefined;
    sectionId: number | undefined;
    currentUserId: number | undefined;
    tenantId: number | undefined;
    licenseUsers: number | undefined;
    subscriptionType: string | undefined;
    additionalQuestions: string | undefined;
}

export class TaskPriorityInput implements ITaskPriorityInput {
    taskId!: number | undefined;
    priority!: TaskPriority | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    actionPerformed!: string | undefined;

    constructor(data?: ITaskPriorityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.priority = _data["priority"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.actionPerformed = _data["actionPerformed"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskPriorityInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskPriorityInput>(data, _mappings, TaskPriorityInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["priority"] = this.priority;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["actionPerformed"] = this.actionPerformed;
        return data;
    }
}

export interface ITaskPriorityInput {
    taskId: number | undefined;
    priority: TaskPriority | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    actionPerformed: string | undefined;
}

export class UpdateTaskNameInput implements IUpdateTaskNameInput {
    taskId!: number;
    taskName!: string;

    constructor(data?: IUpdateTaskNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateTaskNameInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateTaskNameInput>(data, _mappings, UpdateTaskNameInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        return data;
    }
}

export interface IUpdateTaskNameInput {
    taskId: number;
    taskName: string;
}

export class TaskTagDto implements ITaskTagDto {
    id!: number | undefined;
    taskId!: number | undefined;
    tagId!: number | undefined;
    tag!: string | undefined;

    constructor(data?: ITaskTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.tagId = _data["tagId"];
            this.tag = _data["tag"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskTagDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskTagDto>(data, _mappings, TaskTagDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["tagId"] = this.tagId;
        data["tag"] = this.tag;
        return data;
    }
}

export interface ITaskTagDto {
    id: number | undefined;
    taskId: number | undefined;
    tagId: number | undefined;
    tag: string | undefined;
}

export class TaskTagDtoListIHandleError implements ITaskTagDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskTagDto[] | undefined;
    listOfEntities!: TaskTagDto[][] | undefined;

    constructor(data?: ITaskTagDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TaskTagDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskTagDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskTagDtoListIHandleError>(data, _mappings, TaskTagDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITaskTagDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskTagDto[] | undefined;
    listOfEntities: TaskTagDto[][] | undefined;
}

export class ChecklistDto implements IChecklistDto {
    title!: string | undefined;
    description!: string | undefined;

    constructor(data?: IChecklistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any, _mappings?: any): ChecklistDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChecklistDto>(data, _mappings, ChecklistDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface IChecklistDto {
    title: string | undefined;
    description: string | undefined;
}

export class BulkChecklistInputDto implements IBulkChecklistInputDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    taskId!: number | undefined;
    checklists!: ChecklistDto[] | undefined;

    constructor(data?: IBulkChecklistInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.taskId = _data["taskId"];
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(ChecklistDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): BulkChecklistInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BulkChecklistInputDto>(data, _mappings, BulkChecklistInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["taskId"] = this.taskId;
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBulkChecklistInputDto {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    taskId: number | undefined;
    checklists: ChecklistDto[] | undefined;
}

export class TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTuple implements ITodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTuple {

    constructor(data?: ITodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTuple>(data, _mappings, TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTuple {
}

export class TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError implements ITodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTuple | undefined;
    listOfEntities!: TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTuple[] | undefined;

    constructor(data?: ITodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError>(data, _mappings, TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTuple | undefined;
    listOfEntities: TodosTaskMonthGroupDtoListTodosTaskGroupDtoListTodosTaskListValueTuple[] | undefined;
}

export class TodosTaskByProjectGroupDtoListTodosTaskListValueTuple implements ITodosTaskByProjectGroupDtoListTodosTaskListValueTuple {

    constructor(data?: ITodosTaskByProjectGroupDtoListTodosTaskListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): TodosTaskByProjectGroupDtoListTodosTaskListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTaskByProjectGroupDtoListTodosTaskListValueTuple>(data, _mappings, TodosTaskByProjectGroupDtoListTodosTaskListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITodosTaskByProjectGroupDtoListTodosTaskListValueTuple {
}

export class TodosTaskByProjectGroupDtoListTodosTaskListValueTupleIHandleError implements ITodosTaskByProjectGroupDtoListTodosTaskListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TodosTaskByProjectGroupDtoListTodosTaskListValueTuple | undefined;
    listOfEntities!: TodosTaskByProjectGroupDtoListTodosTaskListValueTuple[] | undefined;

    constructor(data?: ITodosTaskByProjectGroupDtoListTodosTaskListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TodosTaskByProjectGroupDtoListTodosTaskListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TodosTaskByProjectGroupDtoListTodosTaskListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TodosTaskByProjectGroupDtoListTodosTaskListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTaskByProjectGroupDtoListTodosTaskListValueTupleIHandleError>(data, _mappings, TodosTaskByProjectGroupDtoListTodosTaskListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITodosTaskByProjectGroupDtoListTodosTaskListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TodosTaskByProjectGroupDtoListTodosTaskListValueTuple | undefined;
    listOfEntities: TodosTaskByProjectGroupDtoListTodosTaskListValueTuple[] | undefined;
}

export class TodosTask implements ITodosTask {
    id!: number | undefined;
    ownerId!: number | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isDueDatePassed!: boolean | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    code!: number | undefined;
    name!: string | undefined;
    sortOrder!: number | undefined;
    isSeen!: boolean | undefined;
    isNewlyAssigned!: boolean | undefined;
    assignedByUserId!: number | undefined;
    assignedByUser!: string | undefined;
    assignedToUserId!: number | undefined;
    assignedToUser!: string | undefined;
    assignedToUserProfilePictureUrl!: string | undefined;
    assignedTime!: string | undefined;
    completedOn!: string | undefined;
    endDate!: string | undefined;
    integrationId!: string | undefined;
    integratedFrom!: string | undefined;
    integrationIcon!: string | undefined;
    integrationCode!: number | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    color!: string | undefined;
    keyId!: string | undefined;
    webUrl!: string | undefined;
    resourceAppUrl!: string | undefined;
    projectId!: number | undefined;
    isPrivateProject!: boolean | undefined;
    taskProjectName!: string | undefined;
    projectSectionId!: number | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    resourceName!: string | undefined;
    resourceIconUrl!: string | undefined;
    resourceGreyIconUrl!: string | undefined;
    resourceAppIntegrationId!: number | undefined;
    isAssignedToProject!: boolean | undefined;
    priority!: TaskPriority | undefined;
    tags!: string | undefined;
    readonly projectTags!: ProjectTag[] | undefined;
    statusCode!: number | undefined;
    entityType!: TaskEntityType | undefined;
    entityId!: number | undefined;
    taskType!: TaskTypes | undefined;
    groupId!: number | undefined;
    isReAssigned!: boolean | undefined;
    isPrivate!: boolean | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactCompanyId!: number | undefined;
    contactCompanyName!: string | undefined;
    contactTypeColor!: string | undefined;
    projectColor!: string | undefined;
    isAISuggestedTask!: boolean | undefined;
    aiSuggestedText!: string | undefined;
    latestAttachmentAsJson!: string | undefined;
    taskAssociationsAsJson!: string | undefined;
    readonly taskAssociations!: TaskAssociation[] | undefined;
    parentId!: number | undefined;
    parentTitle!: string | undefined;
    duration!: number | undefined;
    startDelay!: number | undefined;
    parentDueDate!: string | undefined;
    parentCompletedOn!: string | undefined;
    parentStatusCode!: number | undefined;
    isParentDueDatePassed!: boolean | undefined;
    isParentCompleted!: boolean | undefined;
    readonly isBlocked!: boolean | undefined;
    isPartOfTaskTree!: boolean | undefined;
    totalTimeMinutes!: number | undefined;
    lastLoggedTime!: string | undefined;
    lastEntryMinutes!: number | undefined;
    taskNotes!: string | undefined;

    constructor(data?: ITodosTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerId = _data["ownerId"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isSeen = _data["isSeen"];
            this.isNewlyAssigned = _data["isNewlyAssigned"];
            this.assignedByUserId = _data["assignedByUserId"];
            this.assignedByUser = _data["assignedByUser"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"];
            this.assignedToUserProfilePictureUrl = _data["assignedToUserProfilePictureUrl"];
            this.assignedTime = _data["assignedTime"];
            this.completedOn = _data["completedOn"];
            this.endDate = _data["endDate"];
            this.integrationId = _data["integrationId"];
            this.integratedFrom = _data["integratedFrom"];
            this.integrationIcon = _data["integrationIcon"];
            this.integrationCode = _data["integrationCode"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.color = _data["color"];
            this.keyId = _data["keyId"];
            this.webUrl = _data["webUrl"];
            this.resourceAppUrl = _data["resourceAppUrl"];
            this.projectId = _data["projectId"];
            this.isPrivateProject = _data["isPrivateProject"];
            this.taskProjectName = _data["taskProjectName"];
            this.projectSectionId = _data["projectSectionId"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.resourceName = _data["resourceName"];
            this.resourceIconUrl = _data["resourceIconUrl"];
            this.resourceGreyIconUrl = _data["resourceGreyIconUrl"];
            this.resourceAppIntegrationId = _data["resourceAppIntegrationId"];
            this.isAssignedToProject = _data["isAssignedToProject"];
            this.priority = _data["priority"];
            this.tags = _data["tags"];
            if (Array.isArray(_data["projectTags"])) {
                (this as any).projectTags = [] as any;
                for (let item of _data["projectTags"])
                    (this as any).projectTags!.push(ProjectTag.fromJS(item, _mappings));
            }
            this.statusCode = _data["statusCode"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.taskType = _data["taskType"];
            this.groupId = _data["groupId"];
            this.isReAssigned = _data["isReAssigned"];
            this.isPrivate = _data["isPrivate"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactCompanyId = _data["contactCompanyId"];
            this.contactCompanyName = _data["contactCompanyName"];
            this.contactTypeColor = _data["contactTypeColor"];
            this.projectColor = _data["projectColor"];
            this.isAISuggestedTask = _data["isAISuggestedTask"];
            this.aiSuggestedText = _data["aiSuggestedText"];
            this.latestAttachmentAsJson = _data["latestAttachmentAsJson"];
            this.taskAssociationsAsJson = _data["taskAssociationsAsJson"];
            if (Array.isArray(_data["taskAssociations"])) {
                (this as any).taskAssociations = [] as any;
                for (let item of _data["taskAssociations"])
                    (this as any).taskAssociations!.push(TaskAssociation.fromJS(item, _mappings));
            }
            this.parentId = _data["parentId"];
            this.parentTitle = _data["parentTitle"];
            this.duration = _data["duration"];
            this.startDelay = _data["startDelay"];
            this.parentDueDate = _data["parentDueDate"];
            this.parentCompletedOn = _data["parentCompletedOn"];
            this.parentStatusCode = _data["parentStatusCode"];
            this.isParentDueDatePassed = _data["isParentDueDatePassed"];
            this.isParentCompleted = _data["isParentCompleted"];
            (this as any).isBlocked = _data["isBlocked"];
            this.isPartOfTaskTree = _data["isPartOfTaskTree"];
            this.totalTimeMinutes = _data["totalTimeMinutes"];
            this.lastLoggedTime = _data["lastLoggedTime"];
            this.lastEntryMinutes = _data["lastEntryMinutes"];
            this.taskNotes = _data["taskNotes"];
        }
    }

    static fromJS(data: any, _mappings?: any): TodosTask | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTask>(data, _mappings, TodosTask);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerId"] = this.ownerId;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isSeen"] = this.isSeen;
        data["isNewlyAssigned"] = this.isNewlyAssigned;
        data["assignedByUserId"] = this.assignedByUserId;
        data["assignedByUser"] = this.assignedByUser;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser;
        data["assignedToUserProfilePictureUrl"] = this.assignedToUserProfilePictureUrl;
        data["assignedTime"] = this.assignedTime;
        data["completedOn"] = this.completedOn;
        data["endDate"] = this.endDate;
        data["integrationId"] = this.integrationId;
        data["integratedFrom"] = this.integratedFrom;
        data["integrationIcon"] = this.integrationIcon;
        data["integrationCode"] = this.integrationCode;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["color"] = this.color;
        data["keyId"] = this.keyId;
        data["webUrl"] = this.webUrl;
        data["resourceAppUrl"] = this.resourceAppUrl;
        data["projectId"] = this.projectId;
        data["isPrivateProject"] = this.isPrivateProject;
        data["taskProjectName"] = this.taskProjectName;
        data["projectSectionId"] = this.projectSectionId;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["resourceName"] = this.resourceName;
        data["resourceIconUrl"] = this.resourceIconUrl;
        data["resourceGreyIconUrl"] = this.resourceGreyIconUrl;
        data["resourceAppIntegrationId"] = this.resourceAppIntegrationId;
        data["isAssignedToProject"] = this.isAssignedToProject;
        data["priority"] = this.priority;
        data["tags"] = this.tags;
        if (Array.isArray(this.projectTags)) {
            data["projectTags"] = [];
            for (let item of this.projectTags)
                data["projectTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["statusCode"] = this.statusCode;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["taskType"] = this.taskType;
        data["groupId"] = this.groupId;
        data["isReAssigned"] = this.isReAssigned;
        data["isPrivate"] = this.isPrivate;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactCompanyId"] = this.contactCompanyId;
        data["contactCompanyName"] = this.contactCompanyName;
        data["contactTypeColor"] = this.contactTypeColor;
        data["projectColor"] = this.projectColor;
        data["isAISuggestedTask"] = this.isAISuggestedTask;
        data["aiSuggestedText"] = this.aiSuggestedText;
        data["latestAttachmentAsJson"] = this.latestAttachmentAsJson;
        data["taskAssociationsAsJson"] = this.taskAssociationsAsJson;
        if (Array.isArray(this.taskAssociations)) {
            data["taskAssociations"] = [];
            for (let item of this.taskAssociations)
                data["taskAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentId"] = this.parentId;
        data["parentTitle"] = this.parentTitle;
        data["duration"] = this.duration;
        data["startDelay"] = this.startDelay;
        data["parentDueDate"] = this.parentDueDate;
        data["parentCompletedOn"] = this.parentCompletedOn;
        data["parentStatusCode"] = this.parentStatusCode;
        data["isParentDueDatePassed"] = this.isParentDueDatePassed;
        data["isParentCompleted"] = this.isParentCompleted;
        data["isBlocked"] = this.isBlocked;
        data["isPartOfTaskTree"] = this.isPartOfTaskTree;
        data["totalTimeMinutes"] = this.totalTimeMinutes;
        data["lastLoggedTime"] = this.lastLoggedTime;
        data["lastEntryMinutes"] = this.lastEntryMinutes;
        data["taskNotes"] = this.taskNotes;
        return data;
    }
}

export interface ITodosTask {
    id: number | undefined;
    ownerId: number | undefined;
    title: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isDueDatePassed: boolean | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    code: number | undefined;
    name: string | undefined;
    sortOrder: number | undefined;
    isSeen: boolean | undefined;
    isNewlyAssigned: boolean | undefined;
    assignedByUserId: number | undefined;
    assignedByUser: string | undefined;
    assignedToUserId: number | undefined;
    assignedToUser: string | undefined;
    assignedToUserProfilePictureUrl: string | undefined;
    assignedTime: string | undefined;
    completedOn: string | undefined;
    endDate: string | undefined;
    integrationId: string | undefined;
    integratedFrom: string | undefined;
    integrationIcon: string | undefined;
    integrationCode: number | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    color: string | undefined;
    keyId: string | undefined;
    webUrl: string | undefined;
    resourceAppUrl: string | undefined;
    projectId: number | undefined;
    isPrivateProject: boolean | undefined;
    taskProjectName: string | undefined;
    projectSectionId: number | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    resourceName: string | undefined;
    resourceIconUrl: string | undefined;
    resourceGreyIconUrl: string | undefined;
    resourceAppIntegrationId: number | undefined;
    isAssignedToProject: boolean | undefined;
    priority: TaskPriority | undefined;
    tags: string | undefined;
    projectTags: ProjectTag[] | undefined;
    statusCode: number | undefined;
    entityType: TaskEntityType | undefined;
    entityId: number | undefined;
    taskType: TaskTypes | undefined;
    groupId: number | undefined;
    isReAssigned: boolean | undefined;
    isPrivate: boolean | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactCompanyId: number | undefined;
    contactCompanyName: string | undefined;
    contactTypeColor: string | undefined;
    projectColor: string | undefined;
    isAISuggestedTask: boolean | undefined;
    aiSuggestedText: string | undefined;
    latestAttachmentAsJson: string | undefined;
    taskAssociationsAsJson: string | undefined;
    taskAssociations: TaskAssociation[] | undefined;
    parentId: number | undefined;
    parentTitle: string | undefined;
    duration: number | undefined;
    startDelay: number | undefined;
    parentDueDate: string | undefined;
    parentCompletedOn: string | undefined;
    parentStatusCode: number | undefined;
    isParentDueDatePassed: boolean | undefined;
    isParentCompleted: boolean | undefined;
    isBlocked: boolean | undefined;
    isPartOfTaskTree: boolean | undefined;
    totalTimeMinutes: number | undefined;
    lastLoggedTime: string | undefined;
    lastEntryMinutes: number | undefined;
    taskNotes: string | undefined;
}

export class TodosTaskListIHandleError implements ITodosTaskListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TodosTask[] | undefined;
    listOfEntities!: TodosTask[][] | undefined;

    constructor(data?: ITodosTaskListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TodosTask.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TodosTaskListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTaskListIHandleError>(data, _mappings, TodosTaskListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITodosTaskListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TodosTask[] | undefined;
    listOfEntities: TodosTask[][] | undefined;
}

export class TodosTaskCounts implements ITodosTaskCounts {
    todaysTasks!: number | undefined;
    thisWeekTasks!: number | undefined;
    noDatesTasks!: number | undefined;
    dueTasks!: number | undefined;
    highPriorityTasks!: number | undefined;
    newTasks!: number | undefined;
    totalTasks!: number | undefined;

    constructor(data?: ITodosTaskCounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.todaysTasks = _data["todaysTasks"];
            this.thisWeekTasks = _data["thisWeekTasks"];
            this.noDatesTasks = _data["noDatesTasks"];
            this.dueTasks = _data["dueTasks"];
            this.highPriorityTasks = _data["highPriorityTasks"];
            this.newTasks = _data["newTasks"];
            this.totalTasks = _data["totalTasks"];
        }
    }

    static fromJS(data: any, _mappings?: any): TodosTaskCounts | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTaskCounts>(data, _mappings, TodosTaskCounts);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["todaysTasks"] = this.todaysTasks;
        data["thisWeekTasks"] = this.thisWeekTasks;
        data["noDatesTasks"] = this.noDatesTasks;
        data["dueTasks"] = this.dueTasks;
        data["highPriorityTasks"] = this.highPriorityTasks;
        data["newTasks"] = this.newTasks;
        data["totalTasks"] = this.totalTasks;
        return data;
    }
}

export interface ITodosTaskCounts {
    todaysTasks: number | undefined;
    thisWeekTasks: number | undefined;
    noDatesTasks: number | undefined;
    dueTasks: number | undefined;
    highPriorityTasks: number | undefined;
    newTasks: number | undefined;
    totalTasks: number | undefined;
}

export class TodosTaskCountsIHandleError implements ITodosTaskCountsIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TodosTaskCounts | undefined;
    listOfEntities!: TodosTaskCounts[] | undefined;

    constructor(data?: ITodosTaskCountsIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TodosTaskCounts.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TodosTaskCounts.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TodosTaskCountsIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTaskCountsIHandleError>(data, _mappings, TodosTaskCountsIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITodosTaskCountsIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TodosTaskCounts | undefined;
    listOfEntities: TodosTaskCounts[] | undefined;
}

export class TodosFollowUpTask implements ITodosFollowUpTask {
    id!: number | undefined;
    ownerId!: number | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isDueDatePassed!: boolean | undefined;
    isActive!: boolean | undefined;
    code!: number | undefined;
    name!: string | undefined;
    sortOrder!: number | undefined;
    isSeen!: boolean | undefined;
    isNewlyAssigned!: boolean | undefined;
    assignedByUserId!: number | undefined;
    assignedByUser!: string | undefined;
    assignedToUserId!: number | undefined;
    assignedToUser!: string | undefined;
    assignedTime!: string | undefined;
    completedOn!: string | undefined;
    endDate!: string | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    color!: string | undefined;
    keyId!: string | undefined;
    webUrl!: string | undefined;
    priority!: TaskPriority | undefined;
    tags!: string | undefined;
    readonly projectTags!: ProjectTag[] | undefined;
    statusCode!: number | undefined;
    entityType!: TaskEntityType | undefined;
    entityId!: number | undefined;
    taskType!: TaskTypes | undefined;
    isReAssigned!: boolean | undefined;
    isPrivate!: boolean | undefined;
    taskAssociationsAsJson!: string | undefined;
    readonly taskAssociations!: TaskAssociation[] | undefined;
    parentId!: number | undefined;
    isPartOfTaskTree!: boolean | undefined;

    constructor(data?: ITodosFollowUpTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerId = _data["ownerId"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isSeen = _data["isSeen"];
            this.isNewlyAssigned = _data["isNewlyAssigned"];
            this.assignedByUserId = _data["assignedByUserId"];
            this.assignedByUser = _data["assignedByUser"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"];
            this.assignedTime = _data["assignedTime"];
            this.completedOn = _data["completedOn"];
            this.endDate = _data["endDate"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.color = _data["color"];
            this.keyId = _data["keyId"];
            this.webUrl = _data["webUrl"];
            this.priority = _data["priority"];
            this.tags = _data["tags"];
            if (Array.isArray(_data["projectTags"])) {
                (this as any).projectTags = [] as any;
                for (let item of _data["projectTags"])
                    (this as any).projectTags!.push(ProjectTag.fromJS(item, _mappings));
            }
            this.statusCode = _data["statusCode"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.taskType = _data["taskType"];
            this.isReAssigned = _data["isReAssigned"];
            this.isPrivate = _data["isPrivate"];
            this.taskAssociationsAsJson = _data["taskAssociationsAsJson"];
            if (Array.isArray(_data["taskAssociations"])) {
                (this as any).taskAssociations = [] as any;
                for (let item of _data["taskAssociations"])
                    (this as any).taskAssociations!.push(TaskAssociation.fromJS(item, _mappings));
            }
            this.parentId = _data["parentId"];
            this.isPartOfTaskTree = _data["isPartOfTaskTree"];
        }
    }

    static fromJS(data: any, _mappings?: any): TodosFollowUpTask | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosFollowUpTask>(data, _mappings, TodosFollowUpTask);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerId"] = this.ownerId;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isSeen"] = this.isSeen;
        data["isNewlyAssigned"] = this.isNewlyAssigned;
        data["assignedByUserId"] = this.assignedByUserId;
        data["assignedByUser"] = this.assignedByUser;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser;
        data["assignedTime"] = this.assignedTime;
        data["completedOn"] = this.completedOn;
        data["endDate"] = this.endDate;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["color"] = this.color;
        data["keyId"] = this.keyId;
        data["webUrl"] = this.webUrl;
        data["priority"] = this.priority;
        data["tags"] = this.tags;
        if (Array.isArray(this.projectTags)) {
            data["projectTags"] = [];
            for (let item of this.projectTags)
                data["projectTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["statusCode"] = this.statusCode;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["taskType"] = this.taskType;
        data["isReAssigned"] = this.isReAssigned;
        data["isPrivate"] = this.isPrivate;
        data["taskAssociationsAsJson"] = this.taskAssociationsAsJson;
        if (Array.isArray(this.taskAssociations)) {
            data["taskAssociations"] = [];
            for (let item of this.taskAssociations)
                data["taskAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentId"] = this.parentId;
        data["isPartOfTaskTree"] = this.isPartOfTaskTree;
        return data;
    }
}

export interface ITodosFollowUpTask {
    id: number | undefined;
    ownerId: number | undefined;
    title: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isDueDatePassed: boolean | undefined;
    isActive: boolean | undefined;
    code: number | undefined;
    name: string | undefined;
    sortOrder: number | undefined;
    isSeen: boolean | undefined;
    isNewlyAssigned: boolean | undefined;
    assignedByUserId: number | undefined;
    assignedByUser: string | undefined;
    assignedToUserId: number | undefined;
    assignedToUser: string | undefined;
    assignedTime: string | undefined;
    completedOn: string | undefined;
    endDate: string | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    color: string | undefined;
    keyId: string | undefined;
    webUrl: string | undefined;
    priority: TaskPriority | undefined;
    tags: string | undefined;
    projectTags: ProjectTag[] | undefined;
    statusCode: number | undefined;
    entityType: TaskEntityType | undefined;
    entityId: number | undefined;
    taskType: TaskTypes | undefined;
    isReAssigned: boolean | undefined;
    isPrivate: boolean | undefined;
    taskAssociationsAsJson: string | undefined;
    taskAssociations: TaskAssociation[] | undefined;
    parentId: number | undefined;
    isPartOfTaskTree: boolean | undefined;
}

export class TodosFollowUpTaskListIHandleError implements ITodosFollowUpTaskListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TodosFollowUpTask[] | undefined;
    listOfEntities!: TodosFollowUpTask[][] | undefined;

    constructor(data?: ITodosFollowUpTaskListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TodosFollowUpTask.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TodosFollowUpTaskListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosFollowUpTaskListIHandleError>(data, _mappings, TodosFollowUpTaskListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITodosFollowUpTaskListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TodosFollowUpTask[] | undefined;
    listOfEntities: TodosFollowUpTask[][] | undefined;
}

export class TodosPastDueTask implements ITodosPastDueTask {
    id!: number | undefined;
    ownerId!: number | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isDueDatePassed!: boolean | undefined;
    isActive!: boolean | undefined;
    code!: number | undefined;
    name!: string | undefined;
    sortOrder!: number | undefined;
    isSeen!: boolean | undefined;
    isNewlyAssigned!: boolean | undefined;
    assignedByUserId!: number | undefined;
    assignedByUser!: string | undefined;
    assignedToUserId!: number | undefined;
    assignedToUser!: string | undefined;
    assignedTime!: string | undefined;
    completedOn!: string | undefined;
    endDate!: string | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    color!: string | undefined;
    keyId!: string | undefined;
    webUrl!: string | undefined;
    isAssignedToProject!: boolean | undefined;
    priority!: TaskPriority | undefined;
    tags!: string | undefined;
    readonly projectTags!: ProjectTag[] | undefined;
    statusCode!: number | undefined;
    entityType!: TaskEntityType | undefined;
    entityId!: number | undefined;
    taskType!: TaskTypes | undefined;
    isReAssigned!: boolean | undefined;
    isPrivate!: boolean | undefined;
    taskAssociationsAsJson!: string | undefined;
    readonly taskAssociations!: TaskAssociation[] | undefined;
    parentId!: number | undefined;
    isPartOfTaskTree!: boolean | undefined;

    constructor(data?: ITodosPastDueTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerId = _data["ownerId"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isSeen = _data["isSeen"];
            this.isNewlyAssigned = _data["isNewlyAssigned"];
            this.assignedByUserId = _data["assignedByUserId"];
            this.assignedByUser = _data["assignedByUser"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"];
            this.assignedTime = _data["assignedTime"];
            this.completedOn = _data["completedOn"];
            this.endDate = _data["endDate"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.color = _data["color"];
            this.keyId = _data["keyId"];
            this.webUrl = _data["webUrl"];
            this.isAssignedToProject = _data["isAssignedToProject"];
            this.priority = _data["priority"];
            this.tags = _data["tags"];
            if (Array.isArray(_data["projectTags"])) {
                (this as any).projectTags = [] as any;
                for (let item of _data["projectTags"])
                    (this as any).projectTags!.push(ProjectTag.fromJS(item, _mappings));
            }
            this.statusCode = _data["statusCode"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.taskType = _data["taskType"];
            this.isReAssigned = _data["isReAssigned"];
            this.isPrivate = _data["isPrivate"];
            this.taskAssociationsAsJson = _data["taskAssociationsAsJson"];
            if (Array.isArray(_data["taskAssociations"])) {
                (this as any).taskAssociations = [] as any;
                for (let item of _data["taskAssociations"])
                    (this as any).taskAssociations!.push(TaskAssociation.fromJS(item, _mappings));
            }
            this.parentId = _data["parentId"];
            this.isPartOfTaskTree = _data["isPartOfTaskTree"];
        }
    }

    static fromJS(data: any, _mappings?: any): TodosPastDueTask | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosPastDueTask>(data, _mappings, TodosPastDueTask);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerId"] = this.ownerId;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isSeen"] = this.isSeen;
        data["isNewlyAssigned"] = this.isNewlyAssigned;
        data["assignedByUserId"] = this.assignedByUserId;
        data["assignedByUser"] = this.assignedByUser;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser;
        data["assignedTime"] = this.assignedTime;
        data["completedOn"] = this.completedOn;
        data["endDate"] = this.endDate;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["color"] = this.color;
        data["keyId"] = this.keyId;
        data["webUrl"] = this.webUrl;
        data["isAssignedToProject"] = this.isAssignedToProject;
        data["priority"] = this.priority;
        data["tags"] = this.tags;
        if (Array.isArray(this.projectTags)) {
            data["projectTags"] = [];
            for (let item of this.projectTags)
                data["projectTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["statusCode"] = this.statusCode;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["taskType"] = this.taskType;
        data["isReAssigned"] = this.isReAssigned;
        data["isPrivate"] = this.isPrivate;
        data["taskAssociationsAsJson"] = this.taskAssociationsAsJson;
        if (Array.isArray(this.taskAssociations)) {
            data["taskAssociations"] = [];
            for (let item of this.taskAssociations)
                data["taskAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentId"] = this.parentId;
        data["isPartOfTaskTree"] = this.isPartOfTaskTree;
        return data;
    }
}

export interface ITodosPastDueTask {
    id: number | undefined;
    ownerId: number | undefined;
    title: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isDueDatePassed: boolean | undefined;
    isActive: boolean | undefined;
    code: number | undefined;
    name: string | undefined;
    sortOrder: number | undefined;
    isSeen: boolean | undefined;
    isNewlyAssigned: boolean | undefined;
    assignedByUserId: number | undefined;
    assignedByUser: string | undefined;
    assignedToUserId: number | undefined;
    assignedToUser: string | undefined;
    assignedTime: string | undefined;
    completedOn: string | undefined;
    endDate: string | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    color: string | undefined;
    keyId: string | undefined;
    webUrl: string | undefined;
    isAssignedToProject: boolean | undefined;
    priority: TaskPriority | undefined;
    tags: string | undefined;
    projectTags: ProjectTag[] | undefined;
    statusCode: number | undefined;
    entityType: TaskEntityType | undefined;
    entityId: number | undefined;
    taskType: TaskTypes | undefined;
    isReAssigned: boolean | undefined;
    isPrivate: boolean | undefined;
    taskAssociationsAsJson: string | undefined;
    taskAssociations: TaskAssociation[] | undefined;
    parentId: number | undefined;
    isPartOfTaskTree: boolean | undefined;
}

export class TodosPastDueTaskListIHandleError implements ITodosPastDueTaskListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TodosPastDueTask[] | undefined;
    listOfEntities!: TodosPastDueTask[][] | undefined;

    constructor(data?: ITodosPastDueTaskListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TodosPastDueTask.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TodosPastDueTaskListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosPastDueTaskListIHandleError>(data, _mappings, TodosPastDueTaskListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITodosPastDueTaskListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TodosPastDueTask[] | undefined;
    listOfEntities: TodosPastDueTask[][] | undefined;
}

export class MoveTodoTasksToMyDayInputDto implements IMoveTodoTasksToMyDayInputDto {
    userSectionId!: number | undefined;
    taskIds!: number[] | undefined;

    constructor(data?: IMoveTodoTasksToMyDayInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userSectionId = _data["userSectionId"];
            if (Array.isArray(_data["taskIds"])) {
                this.taskIds = [] as any;
                for (let item of _data["taskIds"])
                    this.taskIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MoveTodoTasksToMyDayInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MoveTodoTasksToMyDayInputDto>(data, _mappings, MoveTodoTasksToMyDayInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSectionId"] = this.userSectionId;
        if (Array.isArray(this.taskIds)) {
            data["taskIds"] = [];
            for (let item of this.taskIds)
                data["taskIds"].push(item);
        }
        return data;
    }
}

export interface IMoveTodoTasksToMyDayInputDto {
    userSectionId: number | undefined;
    taskIds: number[] | undefined;
}

export class TodosTasksByViewCountsOutputDto implements ITodosTasksByViewCountsOutputDto {
    tasksTodayCount!: number | undefined;
    tasksThisWeekCount!: number | undefined;
    highPriorityCount!: number | undefined;
    pastDueCount!: number | undefined;
    newTasksCount!: number | undefined;
    totalTasksCount!: number | undefined;

    constructor(data?: ITodosTasksByViewCountsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tasksTodayCount = _data["tasksTodayCount"];
            this.tasksThisWeekCount = _data["tasksThisWeekCount"];
            this.highPriorityCount = _data["highPriorityCount"];
            this.pastDueCount = _data["pastDueCount"];
            this.newTasksCount = _data["newTasksCount"];
            this.totalTasksCount = _data["totalTasksCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): TodosTasksByViewCountsOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTasksByViewCountsOutputDto>(data, _mappings, TodosTasksByViewCountsOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tasksTodayCount"] = this.tasksTodayCount;
        data["tasksThisWeekCount"] = this.tasksThisWeekCount;
        data["highPriorityCount"] = this.highPriorityCount;
        data["pastDueCount"] = this.pastDueCount;
        data["newTasksCount"] = this.newTasksCount;
        data["totalTasksCount"] = this.totalTasksCount;
        return data;
    }
}

export interface ITodosTasksByViewCountsOutputDto {
    tasksTodayCount: number | undefined;
    tasksThisWeekCount: number | undefined;
    highPriorityCount: number | undefined;
    pastDueCount: number | undefined;
    newTasksCount: number | undefined;
    totalTasksCount: number | undefined;
}

export class TodosTasksByViewCountsOutputDtoIHandleError implements ITodosTasksByViewCountsOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TodosTasksByViewCountsOutputDto | undefined;
    listOfEntities!: TodosTasksByViewCountsOutputDto[] | undefined;

    constructor(data?: ITodosTasksByViewCountsOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TodosTasksByViewCountsOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TodosTasksByViewCountsOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TodosTasksByViewCountsOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTasksByViewCountsOutputDtoIHandleError>(data, _mappings, TodosTasksByViewCountsOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITodosTasksByViewCountsOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TodosTasksByViewCountsOutputDto | undefined;
    listOfEntities: TodosTasksByViewCountsOutputDto[] | undefined;
}

export class ProjectTagDetails implements IProjectTagDetails {
    tagId!: number | undefined;
    tag!: string | undefined;
    taskId!: number | undefined;

    constructor(data?: IProjectTagDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.tag = _data["tag"];
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTagDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTagDetails>(data, _mappings, ProjectTagDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["tag"] = this.tag;
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface IProjectTagDetails {
    tagId: number | undefined;
    tag: string | undefined;
    taskId: number | undefined;
}

export class TodoTaskAssociation implements ITodoTaskAssociation {
    id!: number | undefined;
    taskId!: number | undefined;
    associationName!: string | undefined;
    associationSubName!: string | undefined;
    associationSubId!: number | undefined;
    extension!: string | undefined;
    isLink!: boolean | undefined;
    keyId!: string | undefined;
    associationType!: number | undefined;
    associationId!: number | undefined;
    associationUrl!: string | undefined;
    sortOrder!: number | undefined;
    driveId!: string | undefined;
    resourceUrl!: string | undefined;

    constructor(data?: ITodoTaskAssociation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.associationName = _data["associationName"];
            this.associationSubName = _data["associationSubName"];
            this.associationSubId = _data["associationSubId"];
            this.extension = _data["extension"];
            this.isLink = _data["isLink"];
            this.keyId = _data["keyId"];
            this.associationType = _data["associationType"];
            this.associationId = _data["associationId"];
            this.associationUrl = _data["associationUrl"];
            this.sortOrder = _data["sortOrder"];
            this.driveId = _data["driveId"];
            this.resourceUrl = _data["resourceUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): TodoTaskAssociation | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodoTaskAssociation>(data, _mappings, TodoTaskAssociation);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["associationName"] = this.associationName;
        data["associationSubName"] = this.associationSubName;
        data["associationSubId"] = this.associationSubId;
        data["extension"] = this.extension;
        data["isLink"] = this.isLink;
        data["keyId"] = this.keyId;
        data["associationType"] = this.associationType;
        data["associationId"] = this.associationId;
        data["associationUrl"] = this.associationUrl;
        data["sortOrder"] = this.sortOrder;
        data["driveId"] = this.driveId;
        data["resourceUrl"] = this.resourceUrl;
        return data;
    }
}

export interface ITodoTaskAssociation {
    id: number | undefined;
    taskId: number | undefined;
    associationName: string | undefined;
    associationSubName: string | undefined;
    associationSubId: number | undefined;
    extension: string | undefined;
    isLink: boolean | undefined;
    keyId: string | undefined;
    associationType: number | undefined;
    associationId: number | undefined;
    associationUrl: string | undefined;
    sortOrder: number | undefined;
    driveId: string | undefined;
    resourceUrl: string | undefined;
}

export class TodoTaskByView implements ITodoTaskByView {
    id!: number | undefined;
    ownerId!: number | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isActive!: boolean | undefined;
    code!: number | undefined;
    name!: string | undefined;
    isSeen!: boolean | undefined;
    isNewlyAssigned!: boolean | undefined;
    assignedByUserId!: number | undefined;
    assignedByUser!: string | undefined;
    assignedByUserProfilePictureUrl!: string | undefined;
    assignedByUserStatus!: number | undefined;
    assignedToUserId!: number | undefined;
    assignedToUser!: string | undefined;
    progressCompleted!: number | undefined;
    projectId!: number | undefined;
    taskProjectName!: string | undefined;
    projectSectionId!: number | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    isAssignedToProject!: boolean | undefined;
    priority!: number | undefined;
    projectTags!: ProjectTagDetails[] | undefined;
    taskAssociations!: TodoTaskAssociation[] | undefined;
    entityType!: number | undefined;
    taskType!: number | undefined;
    isReAssigned!: boolean | undefined;
    isPrivate!: boolean | undefined;
    parentId!: number | undefined;
    parentTitle!: string | undefined;
    parentDueDate!: string | undefined;
    isParentCompleted!: boolean | undefined;
    isPartOfTaskTree!: boolean | undefined;
    isHighPriority!: boolean | undefined;
    isDueDatePassed!: boolean | undefined;

    constructor(data?: ITodoTaskByView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerId = _data["ownerId"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isSeen = _data["isSeen"];
            this.isNewlyAssigned = _data["isNewlyAssigned"];
            this.assignedByUserId = _data["assignedByUserId"];
            this.assignedByUser = _data["assignedByUser"];
            this.assignedByUserProfilePictureUrl = _data["assignedByUserProfilePictureUrl"];
            this.assignedByUserStatus = _data["assignedByUserStatus"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"];
            this.progressCompleted = _data["progressCompleted"];
            this.projectId = _data["projectId"];
            this.taskProjectName = _data["taskProjectName"];
            this.projectSectionId = _data["projectSectionId"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            this.isAssignedToProject = _data["isAssignedToProject"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["projectTags"])) {
                this.projectTags = [] as any;
                for (let item of _data["projectTags"])
                    this.projectTags!.push(ProjectTagDetails.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["taskAssociations"])) {
                this.taskAssociations = [] as any;
                for (let item of _data["taskAssociations"])
                    this.taskAssociations!.push(TodoTaskAssociation.fromJS(item, _mappings));
            }
            this.entityType = _data["entityType"];
            this.taskType = _data["taskType"];
            this.isReAssigned = _data["isReAssigned"];
            this.isPrivate = _data["isPrivate"];
            this.parentId = _data["parentId"];
            this.parentTitle = _data["parentTitle"];
            this.parentDueDate = _data["parentDueDate"];
            this.isParentCompleted = _data["isParentCompleted"];
            this.isPartOfTaskTree = _data["isPartOfTaskTree"];
            this.isHighPriority = _data["isHighPriority"];
            this.isDueDatePassed = _data["isDueDatePassed"];
        }
    }

    static fromJS(data: any, _mappings?: any): TodoTaskByView | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodoTaskByView>(data, _mappings, TodoTaskByView);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerId"] = this.ownerId;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isSeen"] = this.isSeen;
        data["isNewlyAssigned"] = this.isNewlyAssigned;
        data["assignedByUserId"] = this.assignedByUserId;
        data["assignedByUser"] = this.assignedByUser;
        data["assignedByUserProfilePictureUrl"] = this.assignedByUserProfilePictureUrl;
        data["assignedByUserStatus"] = this.assignedByUserStatus;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser;
        data["progressCompleted"] = this.progressCompleted;
        data["projectId"] = this.projectId;
        data["taskProjectName"] = this.taskProjectName;
        data["projectSectionId"] = this.projectSectionId;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["isAssignedToProject"] = this.isAssignedToProject;
        data["priority"] = this.priority;
        if (Array.isArray(this.projectTags)) {
            data["projectTags"] = [];
            for (let item of this.projectTags)
                data["projectTags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.taskAssociations)) {
            data["taskAssociations"] = [];
            for (let item of this.taskAssociations)
                data["taskAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        data["entityType"] = this.entityType;
        data["taskType"] = this.taskType;
        data["isReAssigned"] = this.isReAssigned;
        data["isPrivate"] = this.isPrivate;
        data["parentId"] = this.parentId;
        data["parentTitle"] = this.parentTitle;
        data["parentDueDate"] = this.parentDueDate;
        data["isParentCompleted"] = this.isParentCompleted;
        data["isPartOfTaskTree"] = this.isPartOfTaskTree;
        data["isHighPriority"] = this.isHighPriority;
        data["isDueDatePassed"] = this.isDueDatePassed;
        return data;
    }
}

export interface ITodoTaskByView {
    id: number | undefined;
    ownerId: number | undefined;
    title: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isActive: boolean | undefined;
    code: number | undefined;
    name: string | undefined;
    isSeen: boolean | undefined;
    isNewlyAssigned: boolean | undefined;
    assignedByUserId: number | undefined;
    assignedByUser: string | undefined;
    assignedByUserProfilePictureUrl: string | undefined;
    assignedByUserStatus: number | undefined;
    assignedToUserId: number | undefined;
    assignedToUser: string | undefined;
    progressCompleted: number | undefined;
    projectId: number | undefined;
    taskProjectName: string | undefined;
    projectSectionId: number | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    isAssignedToProject: boolean | undefined;
    priority: number | undefined;
    projectTags: ProjectTagDetails[] | undefined;
    taskAssociations: TodoTaskAssociation[] | undefined;
    entityType: number | undefined;
    taskType: number | undefined;
    isReAssigned: boolean | undefined;
    isPrivate: boolean | undefined;
    parentId: number | undefined;
    parentTitle: string | undefined;
    parentDueDate: string | undefined;
    isParentCompleted: boolean | undefined;
    isPartOfTaskTree: boolean | undefined;
    isHighPriority: boolean | undefined;
    isDueDatePassed: boolean | undefined;
}

export class ProjectGroupDto implements IProjectGroupDto {
    projectId!: number | undefined;
    projectName!: string | undefined;
    taskCount!: number | undefined;
    tasks!: TodoTaskByView[] | undefined;

    constructor(data?: IProjectGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.taskCount = _data["taskCount"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TodoTaskByView.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectGroupDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectGroupDto>(data, _mappings, ProjectGroupDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["taskCount"] = this.taskCount;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectGroupDto {
    projectId: number | undefined;
    projectName: string | undefined;
    taskCount: number | undefined;
    tasks: TodoTaskByView[] | undefined;
}

export class TimeframeGroupDto implements ITimeframeGroupDto {
    timeframeName!: string | undefined;
    taskCount!: number | undefined;
    projects!: ProjectGroupDto[] | undefined;

    constructor(data?: ITimeframeGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.timeframeName = _data["timeframeName"];
            this.taskCount = _data["taskCount"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectGroupDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TimeframeGroupDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TimeframeGroupDto>(data, _mappings, TimeframeGroupDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeframeName"] = this.timeframeName;
        data["taskCount"] = this.taskCount;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITimeframeGroupDto {
    timeframeName: string | undefined;
    taskCount: number | undefined;
    projects: ProjectGroupDto[] | undefined;
}

export class TodosTasksByViewOutputDto implements ITodosTasksByViewOutputDto {
    timeframes!: TimeframeGroupDto[] | undefined;
    view!: string | undefined;

    constructor(data?: ITodosTasksByViewOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["timeframes"])) {
                this.timeframes = [] as any;
                for (let item of _data["timeframes"])
                    this.timeframes!.push(TimeframeGroupDto.fromJS(item, _mappings));
            }
            this.view = _data["view"];
        }
    }

    static fromJS(data: any, _mappings?: any): TodosTasksByViewOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTasksByViewOutputDto>(data, _mappings, TodosTasksByViewOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.timeframes)) {
            data["timeframes"] = [];
            for (let item of this.timeframes)
                data["timeframes"].push(item ? item.toJSON() : undefined as any);
        }
        data["view"] = this.view;
        return data;
    }
}

export interface ITodosTasksByViewOutputDto {
    timeframes: TimeframeGroupDto[] | undefined;
    view: string | undefined;
}

export class TodosTasksByViewOutputDtoIHandleError implements ITodosTasksByViewOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TodosTasksByViewOutputDto | undefined;
    listOfEntities!: TodosTasksByViewOutputDto[] | undefined;

    constructor(data?: ITodosTasksByViewOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TodosTasksByViewOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TodosTasksByViewOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TodosTasksByViewOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTasksByViewOutputDtoIHandleError>(data, _mappings, TodosTasksByViewOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITodosTasksByViewOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TodosTasksByViewOutputDto | undefined;
    listOfEntities: TodosTasksByViewOutputDto[] | undefined;
}

export class TodoTaskProjectDto implements ITodoTaskProjectDto {
    projectId!: number | undefined;
    projectName!: string | undefined;

    constructor(data?: ITodoTaskProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any, _mappings?: any): TodoTaskProjectDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodoTaskProjectDto>(data, _mappings, TodoTaskProjectDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface ITodoTaskProjectDto {
    projectId: number | undefined;
    projectName: string | undefined;
}

export class TodosTasksProjectsByViewOutputDto implements ITodosTasksProjectsByViewOutputDto {
    projects!: TodoTaskProjectDto[] | undefined;

    constructor(data?: ITodosTasksProjectsByViewOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(TodoTaskProjectDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TodosTasksProjectsByViewOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTasksProjectsByViewOutputDto>(data, _mappings, TodosTasksProjectsByViewOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITodosTasksProjectsByViewOutputDto {
    projects: TodoTaskProjectDto[] | undefined;
}

export class TodosTasksProjectsByViewOutputDtoIHandleError implements ITodosTasksProjectsByViewOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TodosTasksProjectsByViewOutputDto | undefined;
    listOfEntities!: TodosTasksProjectsByViewOutputDto[] | undefined;

    constructor(data?: ITodosTasksProjectsByViewOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TodosTasksProjectsByViewOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TodosTasksProjectsByViewOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TodosTasksProjectsByViewOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TodosTasksProjectsByViewOutputDtoIHandleError>(data, _mappings, TodosTasksProjectsByViewOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITodosTasksProjectsByViewOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TodosTasksProjectsByViewOutputDto | undefined;
    listOfEntities: TodosTasksProjectsByViewOutputDto[] | undefined;
}

export class GanttTaskDto implements IGanttTaskDto {
    taskId!: number | undefined;
    taskName!: string | undefined;
    creationDate!: string | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    duration!: number | undefined;
    startDelay!: number | undefined;
    progress!: number | undefined;
    predecessor!: string | undefined;
    assignee!: string | undefined;
    assignedToUserId!: number | undefined;
    assignedToUserStatusCode!: string | undefined;
    assignedToProfPic!: string | undefined;
    isAddedOnMyDay!: boolean | undefined;
    priority!: number | undefined;
    bgColor!: string | undefined;
    sectionName!: string | undefined;
    subtasks!: any[] | undefined;

    constructor(data?: IGanttTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.creationDate = _data["creationDate"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.duration = _data["duration"];
            this.startDelay = _data["startDelay"];
            this.progress = _data["progress"];
            this.predecessor = _data["predecessor"];
            this.assignee = _data["assignee"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUserStatusCode = _data["assignedToUserStatusCode"];
            this.assignedToProfPic = _data["assignedToProfPic"];
            this.isAddedOnMyDay = _data["isAddedOnMyDay"];
            this.priority = _data["priority"];
            this.bgColor = _data["bgColor"];
            this.sectionName = _data["sectionName"];
            if (Array.isArray(_data["subtasks"])) {
                this.subtasks = [] as any;
                for (let item of _data["subtasks"])
                    this.subtasks!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GanttTaskDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GanttTaskDto>(data, _mappings, GanttTaskDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["creationDate"] = this.creationDate;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["duration"] = this.duration;
        data["startDelay"] = this.startDelay;
        data["progress"] = this.progress;
        data["predecessor"] = this.predecessor;
        data["assignee"] = this.assignee;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUserStatusCode"] = this.assignedToUserStatusCode;
        data["assignedToProfPic"] = this.assignedToProfPic;
        data["isAddedOnMyDay"] = this.isAddedOnMyDay;
        data["priority"] = this.priority;
        data["bgColor"] = this.bgColor;
        data["sectionName"] = this.sectionName;
        if (Array.isArray(this.subtasks)) {
            data["subtasks"] = [];
            for (let item of this.subtasks)
                data["subtasks"].push(item);
        }
        return data;
    }
}

export interface IGanttTaskDto {
    taskId: number | undefined;
    taskName: string | undefined;
    creationDate: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    duration: number | undefined;
    startDelay: number | undefined;
    progress: number | undefined;
    predecessor: string | undefined;
    assignee: string | undefined;
    assignedToUserId: number | undefined;
    assignedToUserStatusCode: string | undefined;
    assignedToProfPic: string | undefined;
    isAddedOnMyDay: boolean | undefined;
    priority: number | undefined;
    bgColor: string | undefined;
    sectionName: string | undefined;
    subtasks: any[] | undefined;
}

export class GanttTaskDtoListIHandleError implements IGanttTaskDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GanttTaskDto[] | undefined;
    listOfEntities!: GanttTaskDto[][] | undefined;

    constructor(data?: IGanttTaskDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(GanttTaskDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GanttTaskDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GanttTaskDtoListIHandleError>(data, _mappings, GanttTaskDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IGanttTaskDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GanttTaskDto[] | undefined;
    listOfEntities: GanttTaskDto[][] | undefined;
}

export class SearchGlobalTaskInputDto implements ISearchGlobalTaskInputDto {
    searchText!: string | undefined;
    filterStatusType!: TaskFilterStatusType | undefined;
    projectIds!: number[] | undefined;
    assigneeIds!: number[] | undefined;
    skipCount!: number | undefined;
    takeCount!: number | undefined;

    constructor(data?: ISearchGlobalTaskInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            this.filterStatusType = _data["filterStatusType"];
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
            if (Array.isArray(_data["assigneeIds"])) {
                this.assigneeIds = [] as any;
                for (let item of _data["assigneeIds"])
                    this.assigneeIds!.push(item);
            }
            this.skipCount = _data["skipCount"];
            this.takeCount = _data["takeCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): SearchGlobalTaskInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SearchGlobalTaskInputDto>(data, _mappings, SearchGlobalTaskInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["filterStatusType"] = this.filterStatusType;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        if (Array.isArray(this.assigneeIds)) {
            data["assigneeIds"] = [];
            for (let item of this.assigneeIds)
                data["assigneeIds"].push(item);
        }
        data["skipCount"] = this.skipCount;
        data["takeCount"] = this.takeCount;
        return data;
    }
}

export interface ISearchGlobalTaskInputDto {
    searchText: string | undefined;
    filterStatusType: TaskFilterStatusType | undefined;
    projectIds: number[] | undefined;
    assigneeIds: number[] | undefined;
    skipCount: number | undefined;
    takeCount: number | undefined;
}

export class Int32TodosTaskListValueTuple implements IInt32TodosTaskListValueTuple {

    constructor(data?: IInt32TodosTaskListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): Int32TodosTaskListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32TodosTaskListValueTuple>(data, _mappings, Int32TodosTaskListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IInt32TodosTaskListValueTuple {
}

export class Int32TodosTaskListValueTupleIHandleError implements IInt32TodosTaskListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: Int32TodosTaskListValueTuple | undefined;
    listOfEntities!: Int32TodosTaskListValueTuple[] | undefined;

    constructor(data?: IInt32TodosTaskListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? Int32TodosTaskListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(Int32TodosTaskListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32TodosTaskListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32TodosTaskListValueTupleIHandleError>(data, _mappings, Int32TodosTaskListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInt32TodosTaskListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: Int32TodosTaskListValueTuple | undefined;
    listOfEntities: Int32TodosTaskListValueTuple[] | undefined;
}

export class GetUserActivityTaskOutput implements IGetUserActivityTaskOutput {
    id!: number | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isDueDatePassed!: boolean | undefined;
    isActive!: boolean | undefined;
    code!: number | undefined;
    sortOrder!: number | undefined;
    assignedToUserId!: number | undefined;
    assignedToUser!: string | undefined;
    priority!: TaskPriority | undefined;
    isReAssigned!: boolean | undefined;
    isPrivate!: boolean | undefined;
    taskAssociationsAsJson!: string | undefined;
    readonly taskAssociations!: TaskAssociation[] | undefined;
    parentId!: number | undefined;
    isPartOfTaskTree!: boolean | undefined;

    constructor(data?: IGetUserActivityTaskOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isDueDatePassed = _data["isDueDatePassed"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.sortOrder = _data["sortOrder"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"];
            this.priority = _data["priority"];
            this.isReAssigned = _data["isReAssigned"];
            this.isPrivate = _data["isPrivate"];
            this.taskAssociationsAsJson = _data["taskAssociationsAsJson"];
            if (Array.isArray(_data["taskAssociations"])) {
                (this as any).taskAssociations = [] as any;
                for (let item of _data["taskAssociations"])
                    (this as any).taskAssociations!.push(TaskAssociation.fromJS(item, _mappings));
            }
            this.parentId = _data["parentId"];
            this.isPartOfTaskTree = _data["isPartOfTaskTree"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserActivityTaskOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserActivityTaskOutput>(data, _mappings, GetUserActivityTaskOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isDueDatePassed"] = this.isDueDatePassed;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["sortOrder"] = this.sortOrder;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser;
        data["priority"] = this.priority;
        data["isReAssigned"] = this.isReAssigned;
        data["isPrivate"] = this.isPrivate;
        data["taskAssociationsAsJson"] = this.taskAssociationsAsJson;
        if (Array.isArray(this.taskAssociations)) {
            data["taskAssociations"] = [];
            for (let item of this.taskAssociations)
                data["taskAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentId"] = this.parentId;
        data["isPartOfTaskTree"] = this.isPartOfTaskTree;
        return data;
    }
}

export interface IGetUserActivityTaskOutput {
    id: number | undefined;
    title: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isDueDatePassed: boolean | undefined;
    isActive: boolean | undefined;
    code: number | undefined;
    sortOrder: number | undefined;
    assignedToUserId: number | undefined;
    assignedToUser: string | undefined;
    priority: TaskPriority | undefined;
    isReAssigned: boolean | undefined;
    isPrivate: boolean | undefined;
    taskAssociationsAsJson: string | undefined;
    taskAssociations: TaskAssociation[] | undefined;
    parentId: number | undefined;
    isPartOfTaskTree: boolean | undefined;
}

export class GetUserActivityTaskOutputListIHandleError implements IGetUserActivityTaskOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetUserActivityTaskOutput[] | undefined;
    listOfEntities!: GetUserActivityTaskOutput[][] | undefined;

    constructor(data?: IGetUserActivityTaskOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(GetUserActivityTaskOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserActivityTaskOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserActivityTaskOutputListIHandleError>(data, _mappings, GetUserActivityTaskOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IGetUserActivityTaskOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetUserActivityTaskOutput[] | undefined;
    listOfEntities: GetUserActivityTaskOutput[][] | undefined;
}

export class ActivityTaskCounts implements IActivityTaskCounts {
    todayTaskCounts!: number | undefined;
    upComingTaskCounts!: number | undefined;
    upcomingMeetingCounts!: number | undefined;

    constructor(data?: IActivityTaskCounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.todayTaskCounts = _data["todayTaskCounts"];
            this.upComingTaskCounts = _data["upComingTaskCounts"];
            this.upcomingMeetingCounts = _data["upcomingMeetingCounts"];
        }
    }

    static fromJS(data: any, _mappings?: any): ActivityTaskCounts | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ActivityTaskCounts>(data, _mappings, ActivityTaskCounts);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["todayTaskCounts"] = this.todayTaskCounts;
        data["upComingTaskCounts"] = this.upComingTaskCounts;
        data["upcomingMeetingCounts"] = this.upcomingMeetingCounts;
        return data;
    }
}

export interface IActivityTaskCounts {
    todayTaskCounts: number | undefined;
    upComingTaskCounts: number | undefined;
    upcomingMeetingCounts: number | undefined;
}

export class ActivityTaskCountsIHandleError implements IActivityTaskCountsIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ActivityTaskCounts | undefined;
    listOfEntities!: ActivityTaskCounts[] | undefined;

    constructor(data?: IActivityTaskCountsIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ActivityTaskCounts.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ActivityTaskCounts.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ActivityTaskCountsIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ActivityTaskCountsIHandleError>(data, _mappings, ActivityTaskCountsIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IActivityTaskCountsIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ActivityTaskCounts | undefined;
    listOfEntities: ActivityTaskCounts[] | undefined;
}

export class CreateFileTask implements ICreateFileTask {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    entityId!: number | undefined;
    entity!: LookUpTables | undefined;
    id!: number | undefined;
    keyId!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    fileType!: string | undefined;
    webLink!: string | undefined;
    isLink!: boolean | undefined;
    isShareFile!: boolean | undefined;
    isAddToShortcut!: boolean | undefined;
    isDefault!: boolean | undefined;
    msDriveId!: string | undefined;
    msSiteId!: string | undefined;
    msFolderId!: string | undefined;
    startDate!: string | undefined;
    description!: string | undefined;
    code!: number | undefined;
    userSectionId!: number | undefined;

    constructor(data?: ICreateFileTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.entityId = _data["entityId"];
            this.entity = _data["entity"];
            this.id = _data["id"];
            this.keyId = _data["keyId"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.webLink = _data["webLink"];
            this.isLink = _data["isLink"];
            this.isShareFile = _data["isShareFile"];
            this.isAddToShortcut = _data["isAddToShortcut"];
            this.isDefault = _data["isDefault"];
            this.msDriveId = _data["msDriveId"];
            this.msSiteId = _data["msSiteId"];
            this.msFolderId = _data["msFolderId"];
            this.startDate = _data["startDate"];
            this.description = _data["description"];
            this.code = _data["code"];
            this.userSectionId = _data["userSectionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateFileTask | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateFileTask>(data, _mappings, CreateFileTask);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["entityId"] = this.entityId;
        data["entity"] = this.entity;
        data["id"] = this.id;
        data["keyId"] = this.keyId;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["webLink"] = this.webLink;
        data["isLink"] = this.isLink;
        data["isShareFile"] = this.isShareFile;
        data["isAddToShortcut"] = this.isAddToShortcut;
        data["isDefault"] = this.isDefault;
        data["msDriveId"] = this.msDriveId;
        data["msSiteId"] = this.msSiteId;
        data["msFolderId"] = this.msFolderId;
        data["startDate"] = this.startDate;
        data["description"] = this.description;
        data["code"] = this.code;
        data["userSectionId"] = this.userSectionId;
        return data;
    }
}

export interface ICreateFileTask {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    entityId: number | undefined;
    entity: LookUpTables | undefined;
    id: number | undefined;
    keyId: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    webLink: string | undefined;
    isLink: boolean | undefined;
    isShareFile: boolean | undefined;
    isAddToShortcut: boolean | undefined;
    isDefault: boolean | undefined;
    msDriveId: string | undefined;
    msSiteId: string | undefined;
    msFolderId: string | undefined;
    startDate: string | undefined;
    description: string | undefined;
    code: number | undefined;
    userSectionId: number | undefined;
}

export class UpdateTaskProjectSection implements IUpdateTaskProjectSection {
    userId!: number | undefined;
    taskId!: number | undefined;
    projectId!: number | undefined;
    sectionId!: number | undefined;

    constructor(data?: IUpdateTaskProjectSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.taskId = _data["taskId"];
            this.projectId = _data["projectId"];
            this.sectionId = _data["sectionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateTaskProjectSection | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateTaskProjectSection>(data, _mappings, UpdateTaskProjectSection);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["taskId"] = this.taskId;
        data["projectId"] = this.projectId;
        data["sectionId"] = this.sectionId;
        return data;
    }
}

export interface IUpdateTaskProjectSection {
    userId: number | undefined;
    taskId: number | undefined;
    projectId: number | undefined;
    sectionId: number | undefined;
}

export class UndoTaskCompletionInput implements IUndoTaskCompletionInput {
    taskId!: number | undefined;
    completedAtUtc!: string | undefined;

    constructor(data?: IUndoTaskCompletionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.completedAtUtc = _data["completedAtUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): UndoTaskCompletionInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UndoTaskCompletionInput>(data, _mappings, UndoTaskCompletionInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["completedAtUtc"] = this.completedAtUtc;
        return data;
    }
}

export interface IUndoTaskCompletionInput {
    taskId: number | undefined;
    completedAtUtc: string | undefined;
}

export enum BulkCompletionClass {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum CompletionBlockReason {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

export class AiNextActionDto implements IAiNextActionDto {
    text!: string | undefined;

    constructor(data?: IAiNextActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any, _mappings?: any): AiNextActionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AiNextActionDto>(data, _mappings, AiNextActionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }
}

export interface IAiNextActionDto {
    text: string | undefined;
}

export class TaskContextFactsDto implements ITaskContextFactsDto {
    taskId!: number | undefined;
    found!: boolean | undefined;
    taskType!: TaskTypes | undefined;
    code!: number | undefined;
    isCompleted!: boolean | undefined;
    projectId!: number | undefined;
    assigneeUserId!: number | undefined;
    callerIsContributor!: boolean | undefined;
    callerHasAccess!: boolean | undefined;
    isBlocked!: boolean | undefined;
    blockerCount!: number | undefined;
    firstBlockerTitle!: string | undefined;
    linkedPersonId!: number | undefined;
    linkedPersonFirstName!: string | undefined;
    linkedPersonFullName!: string | undefined;
    linkedClientDisplayName!: string | undefined;
    linkedClientIsCompany!: boolean | undefined;
    hasClientLink!: boolean | undefined;
    linkedPersonIsLead!: boolean | undefined;
    linkedClientStageAct!: ClientStageAct | undefined;
    isPrimaryLeadTask!: boolean | undefined;
    leadContactId!: number | undefined;
    leadFirstName!: string | undefined;
    leadStageId!: number | undefined;
    leadStageName!: string | undefined;
    leadStageAct!: ClientStageAct | undefined;
    leadStageOrder!: number | undefined;
    stageEnteredAtUtc!: string | undefined;
    nextOpenStageId!: number | undefined;
    nextOpenStageName!: string | undefined;
    stageSuggestFollowUpDays!: number | undefined;
    stageChangedFromTaskRail!: boolean | undefined;
    railStageChangedAtUtc!: string | undefined;
    openReviewKind!: number | undefined;
    openReviewId!: number | undefined;
    reviewCreatedAtUtc!: string | undefined;
    hasThread!: boolean | undefined;
    latestEmailSubject!: string | undefined;
    hasUnansweredReply!: boolean | undefined;
    lastInboundAtUtc!: string | undefined;
    lastOutboundAtUtc!: string | undefined;
    lastActivityAtUtc!: string | undefined;
    hasActiveFollowUp!: boolean | undefined;
    activeFollowUpDate!: string | undefined;
    isNewLead!: boolean | undefined;
    leadSinceUtc!: string | undefined;
    leadHandledAtUtc!: string | undefined;
    leadDecisionAtUtc!: string | undefined;
    createdAtUtc!: string | undefined;
    isCaseHandoffTask!: boolean | undefined;
    classification!: BulkCompletionClass | undefined;
    reason!: CompletionBlockReason | undefined;
    aiNextAction!: AiNextActionDto | undefined;
    aiNextActionPendingMs!: number | undefined;
    schedulingReason!: number | undefined;
    schedulingReasonName!: string | undefined;

    constructor(data?: ITaskContextFactsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.found = _data["found"];
            this.taskType = _data["taskType"];
            this.code = _data["code"];
            this.isCompleted = _data["isCompleted"];
            this.projectId = _data["projectId"];
            this.assigneeUserId = _data["assigneeUserId"];
            this.callerIsContributor = _data["callerIsContributor"];
            this.callerHasAccess = _data["callerHasAccess"];
            this.isBlocked = _data["isBlocked"];
            this.blockerCount = _data["blockerCount"];
            this.firstBlockerTitle = _data["firstBlockerTitle"];
            this.linkedPersonId = _data["linkedPersonId"];
            this.linkedPersonFirstName = _data["linkedPersonFirstName"];
            this.linkedPersonFullName = _data["linkedPersonFullName"];
            this.linkedClientDisplayName = _data["linkedClientDisplayName"];
            this.linkedClientIsCompany = _data["linkedClientIsCompany"];
            this.hasClientLink = _data["hasClientLink"];
            this.linkedPersonIsLead = _data["linkedPersonIsLead"];
            this.linkedClientStageAct = _data["linkedClientStageAct"];
            this.isPrimaryLeadTask = _data["isPrimaryLeadTask"];
            this.leadContactId = _data["leadContactId"];
            this.leadFirstName = _data["leadFirstName"];
            this.leadStageId = _data["leadStageId"];
            this.leadStageName = _data["leadStageName"];
            this.leadStageAct = _data["leadStageAct"];
            this.leadStageOrder = _data["leadStageOrder"];
            this.stageEnteredAtUtc = _data["stageEnteredAtUtc"];
            this.nextOpenStageId = _data["nextOpenStageId"];
            this.nextOpenStageName = _data["nextOpenStageName"];
            this.stageSuggestFollowUpDays = _data["stageSuggestFollowUpDays"];
            this.stageChangedFromTaskRail = _data["stageChangedFromTaskRail"];
            this.railStageChangedAtUtc = _data["railStageChangedAtUtc"];
            this.openReviewKind = _data["openReviewKind"];
            this.openReviewId = _data["openReviewId"];
            this.reviewCreatedAtUtc = _data["reviewCreatedAtUtc"];
            this.hasThread = _data["hasThread"];
            this.latestEmailSubject = _data["latestEmailSubject"];
            this.hasUnansweredReply = _data["hasUnansweredReply"];
            this.lastInboundAtUtc = _data["lastInboundAtUtc"];
            this.lastOutboundAtUtc = _data["lastOutboundAtUtc"];
            this.lastActivityAtUtc = _data["lastActivityAtUtc"];
            this.hasActiveFollowUp = _data["hasActiveFollowUp"];
            this.activeFollowUpDate = _data["activeFollowUpDate"];
            this.isNewLead = _data["isNewLead"];
            this.leadSinceUtc = _data["leadSinceUtc"];
            this.leadHandledAtUtc = _data["leadHandledAtUtc"];
            this.leadDecisionAtUtc = _data["leadDecisionAtUtc"];
            this.createdAtUtc = _data["createdAtUtc"];
            this.isCaseHandoffTask = _data["isCaseHandoffTask"];
            this.classification = _data["classification"];
            this.reason = _data["reason"];
            this.aiNextAction = _data["aiNextAction"] ? AiNextActionDto.fromJS(_data["aiNextAction"], _mappings) : undefined as any;
            this.aiNextActionPendingMs = _data["aiNextActionPendingMs"];
            this.schedulingReason = _data["schedulingReason"];
            this.schedulingReasonName = _data["schedulingReasonName"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskContextFactsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskContextFactsDto>(data, _mappings, TaskContextFactsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["found"] = this.found;
        data["taskType"] = this.taskType;
        data["code"] = this.code;
        data["isCompleted"] = this.isCompleted;
        data["projectId"] = this.projectId;
        data["assigneeUserId"] = this.assigneeUserId;
        data["callerIsContributor"] = this.callerIsContributor;
        data["callerHasAccess"] = this.callerHasAccess;
        data["isBlocked"] = this.isBlocked;
        data["blockerCount"] = this.blockerCount;
        data["firstBlockerTitle"] = this.firstBlockerTitle;
        data["linkedPersonId"] = this.linkedPersonId;
        data["linkedPersonFirstName"] = this.linkedPersonFirstName;
        data["linkedPersonFullName"] = this.linkedPersonFullName;
        data["linkedClientDisplayName"] = this.linkedClientDisplayName;
        data["linkedClientIsCompany"] = this.linkedClientIsCompany;
        data["hasClientLink"] = this.hasClientLink;
        data["linkedPersonIsLead"] = this.linkedPersonIsLead;
        data["linkedClientStageAct"] = this.linkedClientStageAct;
        data["isPrimaryLeadTask"] = this.isPrimaryLeadTask;
        data["leadContactId"] = this.leadContactId;
        data["leadFirstName"] = this.leadFirstName;
        data["leadStageId"] = this.leadStageId;
        data["leadStageName"] = this.leadStageName;
        data["leadStageAct"] = this.leadStageAct;
        data["leadStageOrder"] = this.leadStageOrder;
        data["stageEnteredAtUtc"] = this.stageEnteredAtUtc;
        data["nextOpenStageId"] = this.nextOpenStageId;
        data["nextOpenStageName"] = this.nextOpenStageName;
        data["stageSuggestFollowUpDays"] = this.stageSuggestFollowUpDays;
        data["stageChangedFromTaskRail"] = this.stageChangedFromTaskRail;
        data["railStageChangedAtUtc"] = this.railStageChangedAtUtc;
        data["openReviewKind"] = this.openReviewKind;
        data["openReviewId"] = this.openReviewId;
        data["reviewCreatedAtUtc"] = this.reviewCreatedAtUtc;
        data["hasThread"] = this.hasThread;
        data["latestEmailSubject"] = this.latestEmailSubject;
        data["hasUnansweredReply"] = this.hasUnansweredReply;
        data["lastInboundAtUtc"] = this.lastInboundAtUtc;
        data["lastOutboundAtUtc"] = this.lastOutboundAtUtc;
        data["lastActivityAtUtc"] = this.lastActivityAtUtc;
        data["hasActiveFollowUp"] = this.hasActiveFollowUp;
        data["activeFollowUpDate"] = this.activeFollowUpDate;
        data["isNewLead"] = this.isNewLead;
        data["leadSinceUtc"] = this.leadSinceUtc;
        data["leadHandledAtUtc"] = this.leadHandledAtUtc;
        data["leadDecisionAtUtc"] = this.leadDecisionAtUtc;
        data["createdAtUtc"] = this.createdAtUtc;
        data["isCaseHandoffTask"] = this.isCaseHandoffTask;
        data["classification"] = this.classification;
        data["reason"] = this.reason;
        data["aiNextAction"] = this.aiNextAction ? this.aiNextAction.toJSON() : undefined as any;
        data["aiNextActionPendingMs"] = this.aiNextActionPendingMs;
        data["schedulingReason"] = this.schedulingReason;
        data["schedulingReasonName"] = this.schedulingReasonName;
        return data;
    }
}

export interface ITaskContextFactsDto {
    taskId: number | undefined;
    found: boolean | undefined;
    taskType: TaskTypes | undefined;
    code: number | undefined;
    isCompleted: boolean | undefined;
    projectId: number | undefined;
    assigneeUserId: number | undefined;
    callerIsContributor: boolean | undefined;
    callerHasAccess: boolean | undefined;
    isBlocked: boolean | undefined;
    blockerCount: number | undefined;
    firstBlockerTitle: string | undefined;
    linkedPersonId: number | undefined;
    linkedPersonFirstName: string | undefined;
    linkedPersonFullName: string | undefined;
    linkedClientDisplayName: string | undefined;
    linkedClientIsCompany: boolean | undefined;
    hasClientLink: boolean | undefined;
    linkedPersonIsLead: boolean | undefined;
    linkedClientStageAct: ClientStageAct | undefined;
    isPrimaryLeadTask: boolean | undefined;
    leadContactId: number | undefined;
    leadFirstName: string | undefined;
    leadStageId: number | undefined;
    leadStageName: string | undefined;
    leadStageAct: ClientStageAct | undefined;
    leadStageOrder: number | undefined;
    stageEnteredAtUtc: string | undefined;
    nextOpenStageId: number | undefined;
    nextOpenStageName: string | undefined;
    stageSuggestFollowUpDays: number | undefined;
    stageChangedFromTaskRail: boolean | undefined;
    railStageChangedAtUtc: string | undefined;
    openReviewKind: number | undefined;
    openReviewId: number | undefined;
    reviewCreatedAtUtc: string | undefined;
    hasThread: boolean | undefined;
    latestEmailSubject: string | undefined;
    hasUnansweredReply: boolean | undefined;
    lastInboundAtUtc: string | undefined;
    lastOutboundAtUtc: string | undefined;
    lastActivityAtUtc: string | undefined;
    hasActiveFollowUp: boolean | undefined;
    activeFollowUpDate: string | undefined;
    isNewLead: boolean | undefined;
    leadSinceUtc: string | undefined;
    leadHandledAtUtc: string | undefined;
    leadDecisionAtUtc: string | undefined;
    createdAtUtc: string | undefined;
    isCaseHandoffTask: boolean | undefined;
    classification: BulkCompletionClass | undefined;
    reason: CompletionBlockReason | undefined;
    aiNextAction: AiNextActionDto | undefined;
    aiNextActionPendingMs: number | undefined;
    schedulingReason: number | undefined;
    schedulingReasonName: string | undefined;
}

export class UndoTaskCompletionResultDto implements IUndoTaskCompletionResultDto {
    taskId!: number | undefined;
    reopened!: boolean | undefined;
    wasAlreadyOpen!: boolean | undefined;
    followUpRestored!: boolean | undefined;
    facts!: TaskContextFactsDto | undefined;

    constructor(data?: IUndoTaskCompletionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.reopened = _data["reopened"];
            this.wasAlreadyOpen = _data["wasAlreadyOpen"];
            this.followUpRestored = _data["followUpRestored"];
            this.facts = _data["facts"] ? TaskContextFactsDto.fromJS(_data["facts"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): UndoTaskCompletionResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UndoTaskCompletionResultDto>(data, _mappings, UndoTaskCompletionResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["reopened"] = this.reopened;
        data["wasAlreadyOpen"] = this.wasAlreadyOpen;
        data["followUpRestored"] = this.followUpRestored;
        data["facts"] = this.facts ? this.facts.toJSON() : undefined as any;
        return data;
    }
}

export interface IUndoTaskCompletionResultDto {
    taskId: number | undefined;
    reopened: boolean | undefined;
    wasAlreadyOpen: boolean | undefined;
    followUpRestored: boolean | undefined;
    facts: TaskContextFactsDto | undefined;
}

export class UndoTaskCompletionResultDtoIHandleError implements IUndoTaskCompletionResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UndoTaskCompletionResultDto | undefined;
    listOfEntities!: UndoTaskCompletionResultDto[] | undefined;

    constructor(data?: IUndoTaskCompletionResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UndoTaskCompletionResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UndoTaskCompletionResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UndoTaskCompletionResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UndoTaskCompletionResultDtoIHandleError>(data, _mappings, UndoTaskCompletionResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUndoTaskCompletionResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UndoTaskCompletionResultDto | undefined;
    listOfEntities: UndoTaskCompletionResultDto[] | undefined;
}

export class PreflightBulkCompletionInput implements IPreflightBulkCompletionInput {
    taskIds!: number[] | undefined;

    constructor(data?: IPreflightBulkCompletionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["taskIds"])) {
                this.taskIds = [] as any;
                for (let item of _data["taskIds"])
                    this.taskIds!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PreflightBulkCompletionInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PreflightBulkCompletionInput>(data, _mappings, PreflightBulkCompletionInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskIds)) {
            data["taskIds"] = [];
            for (let item of this.taskIds)
                data["taskIds"].push(item);
        }
        return data;
    }
}

export interface IPreflightBulkCompletionInput {
    taskIds: number[] | undefined;
}

export class BulkCompletionPreflightItemDto implements IBulkCompletionPreflightItemDto {
    taskId!: number | undefined;
    class!: BulkCompletionClass | undefined;
    reason!: CompletionBlockReason | undefined;
    message!: string | undefined;
    clientStageAct!: ClientStageAct | undefined;

    constructor(data?: IBulkCompletionPreflightItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.class = _data["class"];
            this.reason = _data["reason"];
            this.message = _data["message"];
            this.clientStageAct = _data["clientStageAct"];
        }
    }

    static fromJS(data: any, _mappings?: any): BulkCompletionPreflightItemDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BulkCompletionPreflightItemDto>(data, _mappings, BulkCompletionPreflightItemDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["class"] = this.class;
        data["reason"] = this.reason;
        data["message"] = this.message;
        data["clientStageAct"] = this.clientStageAct;
        return data;
    }
}

export interface IBulkCompletionPreflightItemDto {
    taskId: number | undefined;
    class: BulkCompletionClass | undefined;
    reason: CompletionBlockReason | undefined;
    message: string | undefined;
    clientStageAct: ClientStageAct | undefined;
}

export class PreflightBulkCompletionResultDto implements IPreflightBulkCompletionResultDto {
    items!: BulkCompletionPreflightItemDto[] | undefined;
    safeCount!: number | undefined;
    reviewCount!: number | undefined;
    cannotCount!: number | undefined;
    checkCount!: number | undefined;
    checkedAtUtc!: string | undefined;

    constructor(data?: IPreflightBulkCompletionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BulkCompletionPreflightItemDto.fromJS(item, _mappings));
            }
            this.safeCount = _data["safeCount"];
            this.reviewCount = _data["reviewCount"];
            this.cannotCount = _data["cannotCount"];
            this.checkCount = _data["checkCount"];
            this.checkedAtUtc = _data["checkedAtUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): PreflightBulkCompletionResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PreflightBulkCompletionResultDto>(data, _mappings, PreflightBulkCompletionResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["safeCount"] = this.safeCount;
        data["reviewCount"] = this.reviewCount;
        data["cannotCount"] = this.cannotCount;
        data["checkCount"] = this.checkCount;
        data["checkedAtUtc"] = this.checkedAtUtc;
        return data;
    }
}

export interface IPreflightBulkCompletionResultDto {
    items: BulkCompletionPreflightItemDto[] | undefined;
    safeCount: number | undefined;
    reviewCount: number | undefined;
    cannotCount: number | undefined;
    checkCount: number | undefined;
    checkedAtUtc: string | undefined;
}

export class PreflightBulkCompletionResultDtoIHandleError implements IPreflightBulkCompletionResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: PreflightBulkCompletionResultDto | undefined;
    listOfEntities!: PreflightBulkCompletionResultDto[] | undefined;

    constructor(data?: IPreflightBulkCompletionResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? PreflightBulkCompletionResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(PreflightBulkCompletionResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PreflightBulkCompletionResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PreflightBulkCompletionResultDtoIHandleError>(data, _mappings, PreflightBulkCompletionResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPreflightBulkCompletionResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: PreflightBulkCompletionResultDto | undefined;
    listOfEntities: PreflightBulkCompletionResultDto[] | undefined;
}

export class ReadTaskContextsInput implements IReadTaskContextsInput {
    taskIds!: number[] | undefined;
    includeAiNextAction!: boolean | undefined;

    constructor(data?: IReadTaskContextsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["taskIds"])) {
                this.taskIds = [] as any;
                for (let item of _data["taskIds"])
                    this.taskIds!.push(item);
            }
            this.includeAiNextAction = _data["includeAiNextAction"];
        }
    }

    static fromJS(data: any, _mappings?: any): ReadTaskContextsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReadTaskContextsInput>(data, _mappings, ReadTaskContextsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskIds)) {
            data["taskIds"] = [];
            for (let item of this.taskIds)
                data["taskIds"].push(item);
        }
        data["includeAiNextAction"] = this.includeAiNextAction;
        return data;
    }
}

export interface IReadTaskContextsInput {
    taskIds: number[] | undefined;
    includeAiNextAction: boolean | undefined;
}

export class TaskContextFactsDtoListIHandleError implements ITaskContextFactsDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskContextFactsDto[] | undefined;
    listOfEntities!: TaskContextFactsDto[][] | undefined;

    constructor(data?: ITaskContextFactsDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TaskContextFactsDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskContextFactsDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskContextFactsDtoListIHandleError>(data, _mappings, TaskContextFactsDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITaskContextFactsDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskContextFactsDto[] | undefined;
    listOfEntities: TaskContextFactsDto[][] | undefined;
}

export class CalloutSourceMessageDto implements ICalloutSourceMessageDto {
    id!: string | undefined;
    hasAttachments!: boolean | undefined;

    constructor(data?: ICalloutSourceMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasAttachments = _data["hasAttachments"];
        }
    }

    static fromJS(data: any, _mappings?: any): CalloutSourceMessageDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CalloutSourceMessageDto>(data, _mappings, CalloutSourceMessageDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasAttachments"] = this.hasAttachments;
        return data;
    }
}

export interface ICalloutSourceMessageDto {
    id: string | undefined;
    hasAttachments: boolean | undefined;
}

export class RefreshTaskConversationCalloutsInput implements IRefreshTaskConversationCalloutsInput {
    taskId!: number | undefined;
    messages!: CalloutSourceMessageDto[] | undefined;

    constructor(data?: IRefreshTaskConversationCalloutsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(CalloutSourceMessageDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RefreshTaskConversationCalloutsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RefreshTaskConversationCalloutsInput>(data, _mappings, RefreshTaskConversationCalloutsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRefreshTaskConversationCalloutsInput {
    taskId: number | undefined;
    messages: CalloutSourceMessageDto[] | undefined;
}

export class ConversationCalloutDto implements IConversationCalloutDto {
    key!: string | undefined;
    kind!: string | undefined;
    fact!: string | undefined;
    inference!: string | undefined;
    basis!: string | undefined;
    date!: string | undefined;
    evidence!: string | undefined;
    sourceKind!: string | undefined;
    sourceId!: string | undefined;
    sourceDate!: string | undefined;

    constructor(data?: IConversationCalloutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.key = _data["key"];
            this.kind = _data["kind"];
            this.fact = _data["fact"];
            this.inference = _data["inference"];
            this.basis = _data["basis"];
            this.date = _data["date"];
            this.evidence = _data["evidence"];
            this.sourceKind = _data["sourceKind"];
            this.sourceId = _data["sourceId"];
            this.sourceDate = _data["sourceDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationCalloutDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationCalloutDto>(data, _mappings, ConversationCalloutDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["kind"] = this.kind;
        data["fact"] = this.fact;
        data["inference"] = this.inference;
        data["basis"] = this.basis;
        data["date"] = this.date;
        data["evidence"] = this.evidence;
        data["sourceKind"] = this.sourceKind;
        data["sourceId"] = this.sourceId;
        data["sourceDate"] = this.sourceDate;
        return data;
    }
}

export interface IConversationCalloutDto {
    key: string | undefined;
    kind: string | undefined;
    fact: string | undefined;
    inference: string | undefined;
    basis: string | undefined;
    date: string | undefined;
    evidence: string | undefined;
    sourceKind: string | undefined;
    sourceId: string | undefined;
    sourceDate: string | undefined;
}

export class ConversationCalloutsDto implements IConversationCalloutsDto {
    status!: string | undefined;
    callouts!: ConversationCalloutDto[] | undefined;

    constructor(data?: IConversationCalloutsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["callouts"])) {
                this.callouts = [] as any;
                for (let item of _data["callouts"])
                    this.callouts!.push(ConversationCalloutDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationCalloutsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationCalloutsDto>(data, _mappings, ConversationCalloutsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.callouts)) {
            data["callouts"] = [];
            for (let item of this.callouts)
                data["callouts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConversationCalloutsDto {
    status: string | undefined;
    callouts: ConversationCalloutDto[] | undefined;
}

export class ConversationCalloutsDtoIHandleError implements IConversationCalloutsDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ConversationCalloutsDto | undefined;
    listOfEntities!: ConversationCalloutsDto[] | undefined;

    constructor(data?: IConversationCalloutsDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ConversationCalloutsDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ConversationCalloutsDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ConversationCalloutsDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConversationCalloutsDtoIHandleError>(data, _mappings, ConversationCalloutsDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConversationCalloutsDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ConversationCalloutsDto | undefined;
    listOfEntities: ConversationCalloutsDto[] | undefined;
}

export class DismissConversationCalloutInput implements IDismissConversationCalloutInput {
    taskId!: number | undefined;
    calloutKey!: string;

    constructor(data?: IDismissConversationCalloutInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.calloutKey = _data["calloutKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): DismissConversationCalloutInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DismissConversationCalloutInput>(data, _mappings, DismissConversationCalloutInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["calloutKey"] = this.calloutKey;
        return data;
    }
}

export interface IDismissConversationCalloutInput {
    taskId: number | undefined;
    calloutKey: string;
}

export enum LeadStageChangeSource {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ChangeLeadStageFromTaskInput implements IChangeLeadStageFromTaskInput {
    taskId!: number | undefined;
    personId!: number | undefined;
    stageId!: number | undefined;
    source!: LeadStageChangeSource | undefined;
    lostReason!: string | undefined;
    lostReasonId!: number | undefined;
    lostReasonNote!: string | undefined;
    userPicksFollowUp!: boolean | undefined;

    constructor(data?: IChangeLeadStageFromTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.personId = _data["personId"];
            this.stageId = _data["stageId"];
            this.source = _data["source"];
            this.lostReason = _data["lostReason"];
            this.lostReasonId = _data["lostReasonId"];
            this.lostReasonNote = _data["lostReasonNote"];
            this.userPicksFollowUp = _data["userPicksFollowUp"];
        }
    }

    static fromJS(data: any, _mappings?: any): ChangeLeadStageFromTaskInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangeLeadStageFromTaskInput>(data, _mappings, ChangeLeadStageFromTaskInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["personId"] = this.personId;
        data["stageId"] = this.stageId;
        data["source"] = this.source;
        data["lostReason"] = this.lostReason;
        data["lostReasonId"] = this.lostReasonId;
        data["lostReasonNote"] = this.lostReasonNote;
        data["userPicksFollowUp"] = this.userPicksFollowUp;
        return data;
    }
}

export interface IChangeLeadStageFromTaskInput {
    taskId: number | undefined;
    personId: number | undefined;
    stageId: number | undefined;
    source: LeadStageChangeSource | undefined;
    lostReason: string | undefined;
    lostReasonId: number | undefined;
    lostReasonNote: string | undefined;
    userPicksFollowUp: boolean | undefined;
}

export class ChangeLeadStageFromTaskResultDto implements IChangeLeadStageFromTaskResultDto {
    transition!: ClientStageTransitionDto | undefined;
    facts!: TaskContextFactsDto | undefined;

    constructor(data?: IChangeLeadStageFromTaskResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transition = _data["transition"] ? ClientStageTransitionDto.fromJS(_data["transition"], _mappings) : undefined as any;
            this.facts = _data["facts"] ? TaskContextFactsDto.fromJS(_data["facts"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): ChangeLeadStageFromTaskResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangeLeadStageFromTaskResultDto>(data, _mappings, ChangeLeadStageFromTaskResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transition"] = this.transition ? this.transition.toJSON() : undefined as any;
        data["facts"] = this.facts ? this.facts.toJSON() : undefined as any;
        return data;
    }
}

export interface IChangeLeadStageFromTaskResultDto {
    transition: ClientStageTransitionDto | undefined;
    facts: TaskContextFactsDto | undefined;
}

export class ChangeLeadStageFromTaskResultDtoIHandleError implements IChangeLeadStageFromTaskResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ChangeLeadStageFromTaskResultDto | undefined;
    listOfEntities!: ChangeLeadStageFromTaskResultDto[] | undefined;

    constructor(data?: IChangeLeadStageFromTaskResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ChangeLeadStageFromTaskResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ChangeLeadStageFromTaskResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ChangeLeadStageFromTaskResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ChangeLeadStageFromTaskResultDtoIHandleError>(data, _mappings, ChangeLeadStageFromTaskResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IChangeLeadStageFromTaskResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ChangeLeadStageFromTaskResultDto | undefined;
    listOfEntities: ChangeLeadStageFromTaskResultDto[] | undefined;
}

export class SetLostReasonInput implements ISetLostReasonInput {
    transitionId!: number | undefined;
    lostReason!: string | undefined;

    constructor(data?: ISetLostReasonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transitionId = _data["transitionId"];
            this.lostReason = _data["lostReason"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetLostReasonInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetLostReasonInput>(data, _mappings, SetLostReasonInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transitionId"] = this.transitionId;
        data["lostReason"] = this.lostReason;
        return data;
    }
}

export interface ISetLostReasonInput {
    transitionId: number | undefined;
    lostReason: string | undefined;
}

export class SetLostReasonResultDto implements ISetLostReasonResultDto {
    transitionId!: number | undefined;
    lostReason!: string | undefined;

    constructor(data?: ISetLostReasonResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transitionId = _data["transitionId"];
            this.lostReason = _data["lostReason"];
        }
    }

    static fromJS(data: any, _mappings?: any): SetLostReasonResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetLostReasonResultDto>(data, _mappings, SetLostReasonResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transitionId"] = this.transitionId;
        data["lostReason"] = this.lostReason;
        return data;
    }
}

export interface ISetLostReasonResultDto {
    transitionId: number | undefined;
    lostReason: string | undefined;
}

export class SetLostReasonResultDtoIHandleError implements ISetLostReasonResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: SetLostReasonResultDto | undefined;
    listOfEntities!: SetLostReasonResultDto[] | undefined;

    constructor(data?: ISetLostReasonResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? SetLostReasonResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(SetLostReasonResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SetLostReasonResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SetLostReasonResultDtoIHandleError>(data, _mappings, SetLostReasonResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISetLostReasonResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: SetLostReasonResultDto | undefined;
    listOfEntities: SetLostReasonResultDto[] | undefined;
}

export class UndoWonInput implements IUndoWonInput {
    transitionId!: number | undefined;

    constructor(data?: IUndoWonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transitionId = _data["transitionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UndoWonInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UndoWonInput>(data, _mappings, UndoWonInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transitionId"] = this.transitionId;
        return data;
    }
}

export interface IUndoWonInput {
    transitionId: number | undefined;
}

export class UndoWonResultDto implements IUndoWonResultDto {
    transitionId!: number | undefined;
    undoTransitionId!: number | undefined;
    contactId!: number | undefined;
    stageId!: number | undefined;
    stageName!: string | undefined;
    stageAct!: ClientStageAct | undefined;
    typeRestored!: boolean | undefined;
    restoredContactTypeId!: number | undefined;
    leadTaskRedesignated!: boolean | undefined;
    reopenedTaskId!: number | undefined;
    followUpRestored!: boolean | undefined;
    facts!: TaskContextFactsDto | undefined;

    constructor(data?: IUndoWonResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transitionId = _data["transitionId"];
            this.undoTransitionId = _data["undoTransitionId"];
            this.contactId = _data["contactId"];
            this.stageId = _data["stageId"];
            this.stageName = _data["stageName"];
            this.stageAct = _data["stageAct"];
            this.typeRestored = _data["typeRestored"];
            this.restoredContactTypeId = _data["restoredContactTypeId"];
            this.leadTaskRedesignated = _data["leadTaskRedesignated"];
            this.reopenedTaskId = _data["reopenedTaskId"];
            this.followUpRestored = _data["followUpRestored"];
            this.facts = _data["facts"] ? TaskContextFactsDto.fromJS(_data["facts"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): UndoWonResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UndoWonResultDto>(data, _mappings, UndoWonResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transitionId"] = this.transitionId;
        data["undoTransitionId"] = this.undoTransitionId;
        data["contactId"] = this.contactId;
        data["stageId"] = this.stageId;
        data["stageName"] = this.stageName;
        data["stageAct"] = this.stageAct;
        data["typeRestored"] = this.typeRestored;
        data["restoredContactTypeId"] = this.restoredContactTypeId;
        data["leadTaskRedesignated"] = this.leadTaskRedesignated;
        data["reopenedTaskId"] = this.reopenedTaskId;
        data["followUpRestored"] = this.followUpRestored;
        data["facts"] = this.facts ? this.facts.toJSON() : undefined as any;
        return data;
    }
}

export interface IUndoWonResultDto {
    transitionId: number | undefined;
    undoTransitionId: number | undefined;
    contactId: number | undefined;
    stageId: number | undefined;
    stageName: string | undefined;
    stageAct: ClientStageAct | undefined;
    typeRestored: boolean | undefined;
    restoredContactTypeId: number | undefined;
    leadTaskRedesignated: boolean | undefined;
    reopenedTaskId: number | undefined;
    followUpRestored: boolean | undefined;
    facts: TaskContextFactsDto | undefined;
}

export class UndoWonResultDtoIHandleError implements IUndoWonResultDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UndoWonResultDto | undefined;
    listOfEntities!: UndoWonResultDto[] | undefined;

    constructor(data?: IUndoWonResultDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UndoWonResultDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UndoWonResultDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UndoWonResultDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UndoWonResultDtoIHandleError>(data, _mappings, UndoWonResultDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUndoWonResultDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UndoWonResultDto | undefined;
    listOfEntities: UndoWonResultDto[] | undefined;
}

export class PersonLeadFollowUpDto implements IPersonLeadFollowUpDto {
    contactId!: number | undefined;
    hasActivePrimary!: boolean | undefined;
    primaryTaskId!: number | undefined;
    personName!: string | undefined;

    constructor(data?: IPersonLeadFollowUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.hasActivePrimary = _data["hasActivePrimary"];
            this.primaryTaskId = _data["primaryTaskId"];
            this.personName = _data["personName"];
        }
    }

    static fromJS(data: any, _mappings?: any): PersonLeadFollowUpDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PersonLeadFollowUpDto>(data, _mappings, PersonLeadFollowUpDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["hasActivePrimary"] = this.hasActivePrimary;
        data["primaryTaskId"] = this.primaryTaskId;
        data["personName"] = this.personName;
        return data;
    }
}

export interface IPersonLeadFollowUpDto {
    contactId: number | undefined;
    hasActivePrimary: boolean | undefined;
    primaryTaskId: number | undefined;
    personName: string | undefined;
}

export class PersonLeadFollowUpDtoIHandleError implements IPersonLeadFollowUpDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: PersonLeadFollowUpDto | undefined;
    listOfEntities!: PersonLeadFollowUpDto[] | undefined;

    constructor(data?: IPersonLeadFollowUpDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? PersonLeadFollowUpDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(PersonLeadFollowUpDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PersonLeadFollowUpDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PersonLeadFollowUpDtoIHandleError>(data, _mappings, PersonLeadFollowUpDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPersonLeadFollowUpDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: PersonLeadFollowUpDto | undefined;
    listOfEntities: PersonLeadFollowUpDto[] | undefined;
}

export class TagDTO implements ITagDTO {
    id!: number | undefined;
    name!: string | undefined;

    constructor(data?: ITagDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): TagDTO | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TagDTO>(data, _mappings, TagDTO);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITagDTO {
    id: number | undefined;
    name: string | undefined;
}

export class TaskAssociationDTO implements ITaskAssociationDTO {
    id!: number | undefined;
    taskId!: number | undefined;
    associationName!: string | undefined;
    associationSubId!: number | undefined;
    associationSubName!: string | undefined;
    extension!: string | undefined;
    isLink!: boolean | undefined;
    keyId!: string | undefined;
    fileType!: string | undefined;
    projectStageId!: number | undefined;
    associationType!: TaskAssociationType | undefined;
    associationId!: string | undefined;
    associationUrl!: string | undefined;
    sortOrder!: number | undefined;
    driveId!: string | undefined;
    resourceUrl!: string | undefined;
    color!: string | undefined;

    constructor(data?: ITaskAssociationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.associationName = _data["associationName"];
            this.associationSubId = _data["associationSubId"];
            this.associationSubName = _data["associationSubName"];
            this.extension = _data["extension"];
            this.isLink = _data["isLink"];
            this.keyId = _data["keyId"];
            this.fileType = _data["fileType"];
            this.projectStageId = _data["projectStageId"];
            this.associationType = _data["associationType"];
            this.associationId = _data["associationId"];
            this.associationUrl = _data["associationUrl"];
            this.sortOrder = _data["sortOrder"];
            this.driveId = _data["driveId"];
            this.resourceUrl = _data["resourceUrl"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskAssociationDTO | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskAssociationDTO>(data, _mappings, TaskAssociationDTO);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["associationName"] = this.associationName;
        data["associationSubId"] = this.associationSubId;
        data["associationSubName"] = this.associationSubName;
        data["extension"] = this.extension;
        data["isLink"] = this.isLink;
        data["keyId"] = this.keyId;
        data["fileType"] = this.fileType;
        data["projectStageId"] = this.projectStageId;
        data["associationType"] = this.associationType;
        data["associationId"] = this.associationId;
        data["associationUrl"] = this.associationUrl;
        data["sortOrder"] = this.sortOrder;
        data["driveId"] = this.driveId;
        data["resourceUrl"] = this.resourceUrl;
        data["color"] = this.color;
        return data;
    }
}

export interface ITaskAssociationDTO {
    id: number | undefined;
    taskId: number | undefined;
    associationName: string | undefined;
    associationSubId: number | undefined;
    associationSubName: string | undefined;
    extension: string | undefined;
    isLink: boolean | undefined;
    keyId: string | undefined;
    fileType: string | undefined;
    projectStageId: number | undefined;
    associationType: TaskAssociationType | undefined;
    associationId: string | undefined;
    associationUrl: string | undefined;
    sortOrder: number | undefined;
    driveId: string | undefined;
    resourceUrl: string | undefined;
    color: string | undefined;
}

export class WatchedTaskDTO implements IWatchedTaskDTO {
    id!: number | undefined;
    title!: string | undefined;
    startDate!: string | undefined;
    dueDate!: string | undefined;
    isActive!: boolean | undefined;
    sortOrder!: number | undefined;
    progressCompleted!: number | undefined;
    isMeasureProgressByChecklist!: boolean | undefined;
    isPrivate!: boolean | undefined;
    priority!: TaskPriority | undefined;
    assignedToUserId!: number | undefined;
    assignedToUserName!: string | undefined;
    assignedToPictureUrl!: string | undefined;
    sectionId!: number | undefined;
    sectionName!: string | undefined;
    tags!: TagDTO[] | undefined;
    projectId!: number | undefined;
    projectName!: string | undefined;
    parentId!: number | undefined;
    isPartOfTaskTree!: boolean | undefined;
    watchedAt!: string | undefined;
    taskAssociations!: TaskAssociationDTO[] | undefined;
    isLeadContact!: boolean | undefined;
    isPrimaryLeadTask!: boolean | undefined;
    leadContactId!: number | undefined;
    leadStageId!: number | undefined;
    leadStageName!: string | undefined;
    leadStageAct!: ClientStageAct | undefined;
    leadStageOrder!: number | undefined;
    hasActiveFollowUp!: boolean | undefined;
    isNewLead!: boolean | undefined;
    leadSinceUtc!: string | undefined;
    openReviewKind!: number | undefined;
    reviewCreatedAtUtc!: string | undefined;
    isCaseHandoffTask!: boolean | undefined;
    createdAtUtc!: string | undefined;
    lastOutboundAtUtc!: string | undefined;
    lastActivityAtUtc!: string | undefined;

    constructor(data?: IWatchedTaskDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.startDate = _data["startDate"];
            this.dueDate = _data["dueDate"];
            this.isActive = _data["isActive"];
            this.sortOrder = _data["sortOrder"];
            this.progressCompleted = _data["progressCompleted"];
            this.isMeasureProgressByChecklist = _data["isMeasureProgressByChecklist"];
            this.isPrivate = _data["isPrivate"];
            this.priority = _data["priority"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUserName = _data["assignedToUserName"];
            this.assignedToPictureUrl = _data["assignedToPictureUrl"];
            this.sectionId = _data["sectionId"];
            this.sectionName = _data["sectionName"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDTO.fromJS(item, _mappings));
            }
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.parentId = _data["parentId"];
            this.isPartOfTaskTree = _data["isPartOfTaskTree"];
            this.watchedAt = _data["watchedAt"];
            if (Array.isArray(_data["taskAssociations"])) {
                this.taskAssociations = [] as any;
                for (let item of _data["taskAssociations"])
                    this.taskAssociations!.push(TaskAssociationDTO.fromJS(item, _mappings));
            }
            this.isLeadContact = _data["isLeadContact"];
            this.isPrimaryLeadTask = _data["isPrimaryLeadTask"];
            this.leadContactId = _data["leadContactId"];
            this.leadStageId = _data["leadStageId"];
            this.leadStageName = _data["leadStageName"];
            this.leadStageAct = _data["leadStageAct"];
            this.leadStageOrder = _data["leadStageOrder"];
            this.hasActiveFollowUp = _data["hasActiveFollowUp"];
            this.isNewLead = _data["isNewLead"];
            this.leadSinceUtc = _data["leadSinceUtc"];
            this.openReviewKind = _data["openReviewKind"];
            this.reviewCreatedAtUtc = _data["reviewCreatedAtUtc"];
            this.isCaseHandoffTask = _data["isCaseHandoffTask"];
            this.createdAtUtc = _data["createdAtUtc"];
            this.lastOutboundAtUtc = _data["lastOutboundAtUtc"];
            this.lastActivityAtUtc = _data["lastActivityAtUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): WatchedTaskDTO | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<WatchedTaskDTO>(data, _mappings, WatchedTaskDTO);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["startDate"] = this.startDate;
        data["dueDate"] = this.dueDate;
        data["isActive"] = this.isActive;
        data["sortOrder"] = this.sortOrder;
        data["progressCompleted"] = this.progressCompleted;
        data["isMeasureProgressByChecklist"] = this.isMeasureProgressByChecklist;
        data["isPrivate"] = this.isPrivate;
        data["priority"] = this.priority;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUserName"] = this.assignedToUserName;
        data["assignedToPictureUrl"] = this.assignedToPictureUrl;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["parentId"] = this.parentId;
        data["isPartOfTaskTree"] = this.isPartOfTaskTree;
        data["watchedAt"] = this.watchedAt;
        if (Array.isArray(this.taskAssociations)) {
            data["taskAssociations"] = [];
            for (let item of this.taskAssociations)
                data["taskAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        data["isLeadContact"] = this.isLeadContact;
        data["isPrimaryLeadTask"] = this.isPrimaryLeadTask;
        data["leadContactId"] = this.leadContactId;
        data["leadStageId"] = this.leadStageId;
        data["leadStageName"] = this.leadStageName;
        data["leadStageAct"] = this.leadStageAct;
        data["leadStageOrder"] = this.leadStageOrder;
        data["hasActiveFollowUp"] = this.hasActiveFollowUp;
        data["isNewLead"] = this.isNewLead;
        data["leadSinceUtc"] = this.leadSinceUtc;
        data["openReviewKind"] = this.openReviewKind;
        data["reviewCreatedAtUtc"] = this.reviewCreatedAtUtc;
        data["isCaseHandoffTask"] = this.isCaseHandoffTask;
        data["createdAtUtc"] = this.createdAtUtc;
        data["lastOutboundAtUtc"] = this.lastOutboundAtUtc;
        data["lastActivityAtUtc"] = this.lastActivityAtUtc;
        return data;
    }
}

export interface IWatchedTaskDTO {
    id: number | undefined;
    title: string | undefined;
    startDate: string | undefined;
    dueDate: string | undefined;
    isActive: boolean | undefined;
    sortOrder: number | undefined;
    progressCompleted: number | undefined;
    isMeasureProgressByChecklist: boolean | undefined;
    isPrivate: boolean | undefined;
    priority: TaskPriority | undefined;
    assignedToUserId: number | undefined;
    assignedToUserName: string | undefined;
    assignedToPictureUrl: string | undefined;
    sectionId: number | undefined;
    sectionName: string | undefined;
    tags: TagDTO[] | undefined;
    projectId: number | undefined;
    projectName: string | undefined;
    parentId: number | undefined;
    isPartOfTaskTree: boolean | undefined;
    watchedAt: string | undefined;
    taskAssociations: TaskAssociationDTO[] | undefined;
    isLeadContact: boolean | undefined;
    isPrimaryLeadTask: boolean | undefined;
    leadContactId: number | undefined;
    leadStageId: number | undefined;
    leadStageName: string | undefined;
    leadStageAct: ClientStageAct | undefined;
    leadStageOrder: number | undefined;
    hasActiveFollowUp: boolean | undefined;
    isNewLead: boolean | undefined;
    leadSinceUtc: string | undefined;
    openReviewKind: number | undefined;
    reviewCreatedAtUtc: string | undefined;
    isCaseHandoffTask: boolean | undefined;
    createdAtUtc: string | undefined;
    lastOutboundAtUtc: string | undefined;
    lastActivityAtUtc: string | undefined;
}

export class WatchedTaskDTOListIHandleError implements IWatchedTaskDTOListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: WatchedTaskDTO[] | undefined;
    listOfEntities!: WatchedTaskDTO[][] | undefined;

    constructor(data?: IWatchedTaskDTOListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(WatchedTaskDTO.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): WatchedTaskDTOListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<WatchedTaskDTOListIHandleError>(data, _mappings, WatchedTaskDTOListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IWatchedTaskDTOListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: WatchedTaskDTO[] | undefined;
    listOfEntities: WatchedTaskDTO[][] | undefined;
}

export class TaskWatcherDTO implements ITaskWatcherDTO {
    userId!: number | undefined;
    username!: string | undefined;
    profilePictureUrl!: string | undefined;

    constructor(data?: ITaskWatcherDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.profilePictureUrl = _data["profilePictureUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): TaskWatcherDTO | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskWatcherDTO>(data, _mappings, TaskWatcherDTO);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["profilePictureUrl"] = this.profilePictureUrl;
        return data;
    }
}

export interface ITaskWatcherDTO {
    userId: number | undefined;
    username: string | undefined;
    profilePictureUrl: string | undefined;
}

export class TaskWatcherDTOListIHandleError implements ITaskWatcherDTOListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TaskWatcherDTO[] | undefined;
    listOfEntities!: TaskWatcherDTO[][] | undefined;

    constructor(data?: ITaskWatcherDTOListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TaskWatcherDTO.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TaskWatcherDTOListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TaskWatcherDTOListIHandleError>(data, _mappings, TaskWatcherDTOListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITaskWatcherDTOListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TaskWatcherDTO[] | undefined;
    listOfEntities: TaskWatcherDTO[][] | undefined;
}

export class Int32TeamsDtoListValueTuple implements IInt32TeamsDtoListValueTuple {

    constructor(data?: IInt32TeamsDtoListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): Int32TeamsDtoListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32TeamsDtoListValueTuple>(data, _mappings, Int32TeamsDtoListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IInt32TeamsDtoListValueTuple {
}

export class Int32TeamsDtoListValueTupleIHandleError implements IInt32TeamsDtoListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: Int32TeamsDtoListValueTuple | undefined;
    listOfEntities!: Int32TeamsDtoListValueTuple[] | undefined;

    constructor(data?: IInt32TeamsDtoListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? Int32TeamsDtoListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(Int32TeamsDtoListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32TeamsDtoListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32TeamsDtoListValueTupleIHandleError>(data, _mappings, Int32TeamsDtoListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInt32TeamsDtoListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: Int32TeamsDtoListValueTuple | undefined;
    listOfEntities: Int32TeamsDtoListValueTuple[] | undefined;
}

export class TeamUsersDto implements ITeamUsersDto {
    id!: number | undefined;
    userId!: number | undefined;
    memberName!: string | undefined;
    profilePictureUrl!: string | undefined;
    allowDelete!: boolean | undefined;
    isDeleted!: boolean | undefined;
    statusCode!: number | undefined;

    constructor(data?: ITeamUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.memberName = _data["memberName"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.allowDelete = _data["allowDelete"];
            this.isDeleted = _data["isDeleted"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any, _mappings?: any): TeamUsersDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TeamUsersDto>(data, _mappings, TeamUsersDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["memberName"] = this.memberName;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["allowDelete"] = this.allowDelete;
        data["isDeleted"] = this.isDeleted;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface ITeamUsersDto {
    id: number | undefined;
    userId: number | undefined;
    memberName: string | undefined;
    profilePictureUrl: string | undefined;
    allowDelete: boolean | undefined;
    isDeleted: boolean | undefined;
    statusCode: number | undefined;
}

export class CreateOrUpdateTeamInputDto implements ICreateOrUpdateTeamInputDto {
    id!: number | undefined;
    name!: string | undefined;
    color!: string | undefined;
    colorCode!: string | undefined;
    description!: string | undefined;
    members!: TeamUsersDto[] | undefined;

    constructor(data?: ICreateOrUpdateTeamInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.colorCode = _data["colorCode"];
            this.description = _data["description"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(TeamUsersDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateOrUpdateTeamInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateOrUpdateTeamInputDto>(data, _mappings, CreateOrUpdateTeamInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["colorCode"] = this.colorCode;
        data["description"] = this.description;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateOrUpdateTeamInputDto {
    id: number | undefined;
    name: string | undefined;
    color: string | undefined;
    colorCode: string | undefined;
    description: string | undefined;
    members: TeamUsersDto[] | undefined;
}

export class TenantListDto implements ITenantListDto {
    id!: number | undefined;
    tenancyName!: string | undefined;
    name!: string | undefined;
    editionDisplayName!: string | undefined;
    connectionString!: string | undefined;
    isActive!: boolean | undefined;
    creationTime!: string | undefined;
    subscriptionEndDateUtc!: string | undefined;
    editionId!: number | undefined;
    isInTrialPeriod!: boolean | undefined;
    subscriptionStartDateUtc!: string | undefined;
    abbreviation!: string | undefined;
    licenseUsers!: number | undefined;
    isDeleted!: boolean | undefined;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"];
            this.editionId = _data["editionId"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.subscriptionStartDateUtc = _data["subscriptionStartDateUtc"];
            this.abbreviation = _data["abbreviation"];
            this.licenseUsers = _data["licenseUsers"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any, _mappings?: any): TenantListDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantListDto>(data, _mappings, TenantListDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionStartDateUtc"] = this.subscriptionStartDateUtc;
        data["abbreviation"] = this.abbreviation;
        data["licenseUsers"] = this.licenseUsers;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ITenantListDto {
    id: number | undefined;
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean | undefined;
    creationTime: string | undefined;
    subscriptionEndDateUtc: string | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean | undefined;
    subscriptionStartDateUtc: string | undefined;
    abbreviation: string | undefined;
    licenseUsers: number | undefined;
    isDeleted: boolean | undefined;
}

export class TenantListDtoPagedResultDto implements ITenantListDtoPagedResultDto {
    items!: TenantListDto[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: ITenantListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantListDto.fromJS(item, _mappings));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): TenantListDtoPagedResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantListDtoPagedResultDto>(data, _mappings, TenantListDtoPagedResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ITenantListDtoPagedResultDto {
    items: TenantListDto[] | undefined;
    totalCount: number | undefined;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    connectionString!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean | undefined;
    sendActivationEmail!: boolean | undefined;
    editionId!: number | undefined;
    isActive!: boolean | undefined;
    subscriptionEndDateUtc!: string | undefined;
    isInTrialPeriod!: boolean | undefined;
    subscriptionStartDateUtc!: string | undefined;
    abbreviation!: string | undefined;
    licenseUsers!: number | undefined;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.connectionString = _data["connectionString"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.subscriptionStartDateUtc = _data["subscriptionStartDateUtc"];
            this.abbreviation = _data["abbreviation"];
            this.licenseUsers = _data["licenseUsers"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateTenantInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateTenantInput>(data, _mappings, CreateTenantInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionStartDateUtc"] = this.subscriptionStartDateUtc;
        data["abbreviation"] = this.abbreviation;
        data["licenseUsers"] = this.licenseUsers;
        return data;
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean | undefined;
    sendActivationEmail: boolean | undefined;
    editionId: number | undefined;
    isActive: boolean | undefined;
    subscriptionEndDateUtc: string | undefined;
    isInTrialPeriod: boolean | undefined;
    subscriptionStartDateUtc: string | undefined;
    abbreviation: string | undefined;
    licenseUsers: number | undefined;
}

export enum CompanySize {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum PrimaryTarget {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantEditDto implements ITenantEditDto {
    id!: number | undefined;
    name!: string;
    companyWorkdays!: string | undefined;
    timezoneId!: number | undefined;
    isWorkSummaryRequired!: boolean | undefined;
    isLimitTeamDirectory!: boolean | undefined;
    companySize!: CompanySize | undefined;
    primaryTarget!: PrimaryTarget | undefined;
    mainProductService!: string | undefined;
    projectLabelSingular!: string | undefined;
    projectLabelPlural!: string | undefined;
    projectLabelPreset!: string | undefined;
    projectLabelCustomOptions!: string | undefined;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyWorkdays = _data["companyWorkdays"];
            this.timezoneId = _data["timezoneId"];
            this.isWorkSummaryRequired = _data["isWorkSummaryRequired"];
            this.isLimitTeamDirectory = _data["isLimitTeamDirectory"];
            this.companySize = _data["companySize"];
            this.primaryTarget = _data["primaryTarget"];
            this.mainProductService = _data["mainProductService"];
            this.projectLabelSingular = _data["projectLabelSingular"];
            this.projectLabelPlural = _data["projectLabelPlural"];
            this.projectLabelPreset = _data["projectLabelPreset"];
            this.projectLabelCustomOptions = _data["projectLabelCustomOptions"];
        }
    }

    static fromJS(data: any, _mappings?: any): TenantEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantEditDto>(data, _mappings, TenantEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyWorkdays"] = this.companyWorkdays;
        data["timezoneId"] = this.timezoneId;
        data["isWorkSummaryRequired"] = this.isWorkSummaryRequired;
        data["isLimitTeamDirectory"] = this.isLimitTeamDirectory;
        data["companySize"] = this.companySize;
        data["primaryTarget"] = this.primaryTarget;
        data["mainProductService"] = this.mainProductService;
        data["projectLabelSingular"] = this.projectLabelSingular;
        data["projectLabelPlural"] = this.projectLabelPlural;
        data["projectLabelPreset"] = this.projectLabelPreset;
        data["projectLabelCustomOptions"] = this.projectLabelCustomOptions;
        return data;
    }
}

export interface ITenantEditDto {
    id: number | undefined;
    name: string;
    companyWorkdays: string | undefined;
    timezoneId: number | undefined;
    isWorkSummaryRequired: boolean | undefined;
    isLimitTeamDirectory: boolean | undefined;
    companySize: CompanySize | undefined;
    primaryTarget: PrimaryTarget | undefined;
    mainProductService: string | undefined;
    projectLabelSingular: string | undefined;
    projectLabelPlural: string | undefined;
    projectLabelPreset: string | undefined;
    projectLabelCustomOptions: string | undefined;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetTenantFeaturesEditOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetTenantFeaturesEditOutput>(data, _mappings, GetTenantFeaturesEditOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id!: number | undefined;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateTenantFeaturesInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateTenantFeaturesInput>(data, _mappings, UpdateTenantFeaturesInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number | undefined;
    featureValues: NameValueDto[];
}

export class Edition implements IEdition {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    name!: string;
    displayName!: string;

    constructor(data?: IEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any, _mappings?: any): Edition | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Edition>(data, _mappings, Edition);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IEdition {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    name: string;
    displayName: string;
}

export class UserLogin implements IUserLogin {
    id!: number | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    loginProvider!: string;
    providerKey!: string;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserLogin | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserLogin>(data, _mappings, UserLogin);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        return data;
    }
}

export interface IUserLogin {
    id: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    loginProvider: string;
    providerKey: string;
}

export class UserRole implements IUserRole {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    roleId!: number | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserRole | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserRole>(data, _mappings, UserRole);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IUserRole {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    roleId: number | undefined;
}

export class UserClaim implements IUserClaim {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    claimType!: string | undefined;
    claimValue!: string | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserClaim | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserClaim>(data, _mappings, UserClaim);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }
}

export interface IUserClaim {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    claimType: string | undefined;
    claimValue: string | undefined;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    name!: string;
    isGranted!: boolean | undefined;
    userId!: number | undefined;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserPermissionSetting | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserPermissionSetting>(data, _mappings, UserPermissionSetting);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUserPermissionSetting {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean | undefined;
    userId: number | undefined;
}

export class Setting implements ISetting {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    name!: string;
    value!: string | undefined;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any, _mappings?: any): Setting | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Setting>(data, _mappings, Setting);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ISetting {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
}

export class UserToken implements IUserToken {
    id!: number | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    loginProvider!: string | undefined;
    name!: string | undefined;
    value!: string | undefined;
    expireDate!: string | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserToken | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserToken>(data, _mappings, UserToken);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate;
        return data;
    }
}

export interface IUserToken {
    id: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: string | undefined;
}

export class SrcMood implements ISrcMood {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    tenantId!: number | undefined;
    tenant!: Tenant | undefined;
    moodName!: string | undefined;
    moodIcon!: string | undefined;
    moodClass!: string | undefined;

    constructor(data?: ISrcMood) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"], _mappings) : undefined as any;
            this.moodName = _data["moodName"];
            this.moodIcon = _data["moodIcon"];
            this.moodClass = _data["moodClass"];
        }
    }

    static fromJS(data: any, _mappings?: any): SrcMood | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SrcMood>(data, _mappings, SrcMood);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        data["moodName"] = this.moodName;
        data["moodIcon"] = this.moodIcon;
        data["moodClass"] = this.moodClass;
        return data;
    }
}

export interface ISrcMood {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    tenantId: number | undefined;
    tenant: Tenant | undefined;
    moodName: string | undefined;
    moodIcon: string | undefined;
    moodClass: string | undefined;
}

export class SrcCountry implements ISrcCountry {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    name!: string | undefined;
    code!: number | undefined;
    abbreviation!: string | undefined;
    flagIconUrl!: string | undefined;
    countryCode!: number | undefined;

    constructor(data?: ISrcCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.abbreviation = _data["abbreviation"];
            this.flagIconUrl = _data["flagIconUrl"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any, _mappings?: any): SrcCountry | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SrcCountry>(data, _mappings, SrcCountry);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["name"] = this.name;
        data["code"] = this.code;
        data["abbreviation"] = this.abbreviation;
        data["flagIconUrl"] = this.flagIconUrl;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface ISrcCountry {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    name: string | undefined;
    code: number | undefined;
    abbreviation: string | undefined;
    flagIconUrl: string | undefined;
    countryCode: number | undefined;
}

export class TrWorkSite implements ITrWorkSite {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    tenantId!: number | undefined;
    tenant!: Tenant | undefined;
    name!: string | undefined;
    address!: string | undefined;
    state!: string | undefined;
    city!: string | undefined;
    zip!: string | undefined;
    countryId!: number | undefined;
    country!: SrcCountry | undefined;
    isDefault!: boolean | undefined;

    constructor(data?: ITrWorkSite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"], _mappings) : undefined as any;
            this.name = _data["name"];
            this.address = _data["address"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.zip = _data["zip"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? SrcCountry.fromJS(_data["country"], _mappings) : undefined as any;
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any, _mappings?: any): TrWorkSite | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TrWorkSite>(data, _mappings, TrWorkSite);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        data["name"] = this.name;
        data["address"] = this.address;
        data["state"] = this.state;
        data["city"] = this.city;
        data["zip"] = this.zip;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface ITrWorkSite {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    tenantId: number | undefined;
    tenant: Tenant | undefined;
    name: string | undefined;
    address: string | undefined;
    state: string | undefined;
    city: string | undefined;
    zip: string | undefined;
    countryId: number | undefined;
    country: SrcCountry | undefined;
    isDefault: boolean | undefined;
}

export class TrShift implements ITrShift {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    tenantId!: number | undefined;
    shiftName!: string | undefined;
    startTime!: TimeSpan | undefined;
    endTime!: TimeSpan | undefined;
    breakStartTime!: TimeSpan | undefined;
    duration!: number | undefined;
    isShiftSpanMultiDays!: boolean | undefined;
    isDefault!: boolean | undefined;
    workDays!: string | undefined;
    isBreakRequired!: boolean | undefined;

    constructor(data?: ITrShift) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.tenantId = _data["tenantId"];
            this.shiftName = _data["shiftName"];
            this.startTime = _data["startTime"] ? TimeSpan.fromJS(_data["startTime"], _mappings) : undefined as any;
            this.endTime = _data["endTime"] ? TimeSpan.fromJS(_data["endTime"], _mappings) : undefined as any;
            this.breakStartTime = _data["breakStartTime"] ? TimeSpan.fromJS(_data["breakStartTime"], _mappings) : undefined as any;
            this.duration = _data["duration"];
            this.isShiftSpanMultiDays = _data["isShiftSpanMultiDays"];
            this.isDefault = _data["isDefault"];
            this.workDays = _data["workDays"];
            this.isBreakRequired = _data["isBreakRequired"];
        }
    }

    static fromJS(data: any, _mappings?: any): TrShift | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TrShift>(data, _mappings, TrShift);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["tenantId"] = this.tenantId;
        data["shiftName"] = this.shiftName;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toJSON() : undefined as any;
        data["breakStartTime"] = this.breakStartTime ? this.breakStartTime.toJSON() : undefined as any;
        data["duration"] = this.duration;
        data["isShiftSpanMultiDays"] = this.isShiftSpanMultiDays;
        data["isDefault"] = this.isDefault;
        data["workDays"] = this.workDays;
        data["isBreakRequired"] = this.isBreakRequired;
        return data;
    }
}

export interface ITrShift {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    tenantId: number | undefined;
    shiftName: string | undefined;
    startTime: TimeSpan | undefined;
    endTime: TimeSpan | undefined;
    breakStartTime: TimeSpan | undefined;
    duration: number | undefined;
    isShiftSpanMultiDays: boolean | undefined;
    isDefault: boolean | undefined;
    workDays: string | undefined;
    isBreakRequired: boolean | undefined;
}

export class SrcTimeZone implements ISrcTimeZone {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    tenantId!: number | undefined;
    timeZoneName!: string | undefined;
    timeZone!: string | undefined;
    abbreviation!: string | undefined;
    currentOffset!: string | undefined;

    constructor(data?: ISrcTimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.tenantId = _data["tenantId"];
            this.timeZoneName = _data["timeZoneName"];
            this.timeZone = _data["timeZone"];
            this.abbreviation = _data["abbreviation"];
            this.currentOffset = _data["currentOffset"];
        }
    }

    static fromJS(data: any, _mappings?: any): SrcTimeZone | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SrcTimeZone>(data, _mappings, SrcTimeZone);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["tenantId"] = this.tenantId;
        data["timeZoneName"] = this.timeZoneName;
        data["timeZone"] = this.timeZone;
        data["abbreviation"] = this.abbreviation;
        data["currentOffset"] = this.currentOffset;
        return data;
    }
}

export interface ISrcTimeZone {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    tenantId: number | undefined;
    timeZoneName: string | undefined;
    timeZone: string | undefined;
    abbreviation: string | undefined;
    currentOffset: string | undefined;
}

export class User implements IUser {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    authenticationSource!: string | undefined;
    tenantId!: number | undefined;
    emailAddress!: string;
    name!: string;
    surname!: string;
    readonly fullName!: string | undefined;
    password!: string;
    emailConfirmationCode!: string | undefined;
    passwordResetCode!: string | undefined;
    lockoutEndDateUtc!: string | undefined;
    accessFailedCount!: number | undefined;
    isLockoutEnabled!: boolean | undefined;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean | undefined;
    securityStamp!: string | undefined;
    isTwoFactorEnabled!: boolean | undefined;
    logins!: UserLogin[] | undefined;
    roles!: UserRole[] | undefined;
    claims!: UserClaim[] | undefined;
    permissions!: UserPermissionSetting[] | undefined;
    settings!: Setting[] | undefined;
    isEmailConfirmed!: boolean | undefined;
    isActive!: boolean | undefined;
    normalizedUserName!: string;
    normalizedEmailAddress!: string;
    concurrencyStamp!: string | undefined;
    tokens!: UserToken[] | undefined;
    deleterUser!: any | undefined;
    creatorUser!: any | undefined;
    lastModifierUser!: any | undefined;
    lastLoginTime!: string | undefined;
    profilePictureId!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean | undefined;
    signInTokenExpireTimeUtc!: string | undefined;
    signInToken!: string | undefined;
    googleAuthenticatorKey!: string | undefined;
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    employeeId!: string | undefined;
    manager!: any | undefined;
    managerId!: number | undefined;
    mood!: SrcMood | undefined;
    moodId!: number | undefined;
    workSite!: TrWorkSite | undefined;
    workSiteId!: number | undefined;
    profilePictureUrl!: string | undefined;
    userName!: string;
    shift!: TrShift | undefined;
    shiftId!: number | undefined;
    jobTitle!: string | undefined;
    countryId!: number | undefined;
    country!: SrcCountry | undefined;
    timeZone!: SrcTimeZone | undefined;
    timeZoneId!: number | undefined;
    city!: string | undefined;
    dateHired!: string | undefined;
    birthDate!: string | undefined;
    birthMonth!: string | undefined;
    isEmailNotificationActivated!: boolean | undefined;
    isTeamsNotificationActivated!: boolean | undefined;
    isPromoVisited!: boolean | undefined;
    isProjectPromoVisited!: boolean | undefined;
    myDayListSort!: DayListSorting | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.authenticationSource = _data["authenticationSource"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (this as any).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins!.push(UserLogin.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRole.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(UserClaim.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(UserPermissionSetting.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(Setting.fromJS(item, _mappings));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(UserToken.fromJS(item, _mappings));
            }
            this.deleterUser = _data["deleterUser"];
            this.creatorUser = _data["creatorUser"];
            this.lastModifierUser = _data["lastModifierUser"];
            this.lastLoginTime = _data["lastLoginTime"];
            this.profilePictureId = _data["profilePictureId"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.signInTokenExpireTimeUtc = _data["signInTokenExpireTimeUtc"];
            this.signInToken = _data["signInToken"];
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.employeeId = _data["employeeId"];
            this.manager = _data["manager"];
            this.managerId = _data["managerId"];
            this.mood = _data["mood"] ? SrcMood.fromJS(_data["mood"], _mappings) : undefined as any;
            this.moodId = _data["moodId"];
            this.workSite = _data["workSite"] ? TrWorkSite.fromJS(_data["workSite"], _mappings) : undefined as any;
            this.workSiteId = _data["workSiteId"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.userName = _data["userName"];
            this.shift = _data["shift"] ? TrShift.fromJS(_data["shift"], _mappings) : undefined as any;
            this.shiftId = _data["shiftId"];
            this.jobTitle = _data["jobTitle"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? SrcCountry.fromJS(_data["country"], _mappings) : undefined as any;
            this.timeZone = _data["timeZone"] ? SrcTimeZone.fromJS(_data["timeZone"], _mappings) : undefined as any;
            this.timeZoneId = _data["timeZoneId"];
            this.city = _data["city"];
            this.dateHired = _data["dateHired"];
            this.birthDate = _data["birthDate"];
            this.birthMonth = _data["birthMonth"];
            this.isEmailNotificationActivated = _data["isEmailNotificationActivated"];
            this.isTeamsNotificationActivated = _data["isTeamsNotificationActivated"];
            this.isPromoVisited = _data["isPromoVisited"];
            this.isProjectPromoVisited = _data["isProjectPromoVisited"];
            this.myDayListSort = _data["myDayListSort"];
        }
    }

    static fromJS(data: any, _mappings?: any): User | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<User>(data, _mappings, User);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["authenticationSource"] = this.authenticationSource;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item ? item.toJSON() : undefined as any);
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item ? item.toJSON() : undefined as any);
        }
        data["deleterUser"] = this.deleterUser;
        data["creatorUser"] = this.creatorUser;
        data["lastModifierUser"] = this.lastModifierUser;
        data["lastLoginTime"] = this.lastLoginTime;
        data["profilePictureId"] = this.profilePictureId;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["signInTokenExpireTimeUtc"] = this.signInTokenExpireTimeUtc;
        data["signInToken"] = this.signInToken;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["employeeId"] = this.employeeId;
        data["manager"] = this.manager;
        data["managerId"] = this.managerId;
        data["mood"] = this.mood ? this.mood.toJSON() : undefined as any;
        data["moodId"] = this.moodId;
        data["workSite"] = this.workSite ? this.workSite.toJSON() : undefined as any;
        data["workSiteId"] = this.workSiteId;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["userName"] = this.userName;
        data["shift"] = this.shift ? this.shift.toJSON() : undefined as any;
        data["shiftId"] = this.shiftId;
        data["jobTitle"] = this.jobTitle;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : undefined as any;
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : undefined as any;
        data["timeZoneId"] = this.timeZoneId;
        data["city"] = this.city;
        data["dateHired"] = this.dateHired;
        data["birthDate"] = this.birthDate;
        data["birthMonth"] = this.birthMonth;
        data["isEmailNotificationActivated"] = this.isEmailNotificationActivated;
        data["isTeamsNotificationActivated"] = this.isTeamsNotificationActivated;
        data["isPromoVisited"] = this.isPromoVisited;
        data["isProjectPromoVisited"] = this.isProjectPromoVisited;
        data["myDayListSort"] = this.myDayListSort;
        return data;
    }
}

export interface IUser {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    authenticationSource: string | undefined;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: string | undefined;
    accessFailedCount: number | undefined;
    isLockoutEnabled: boolean | undefined;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean | undefined;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean | undefined;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean | undefined;
    isActive: boolean | undefined;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: any | undefined;
    creatorUser: any | undefined;
    lastModifierUser: any | undefined;
    lastLoginTime: string | undefined;
    profilePictureId: string | undefined;
    shouldChangePasswordOnNextLogin: boolean | undefined;
    signInTokenExpireTimeUtc: string | undefined;
    signInToken: string | undefined;
    googleAuthenticatorKey: string | undefined;
    errorMessage: string | undefined;
    isError: boolean | undefined;
    employeeId: string | undefined;
    manager: any | undefined;
    managerId: number | undefined;
    mood: SrcMood | undefined;
    moodId: number | undefined;
    workSite: TrWorkSite | undefined;
    workSiteId: number | undefined;
    profilePictureUrl: string | undefined;
    userName: string;
    shift: TrShift | undefined;
    shiftId: number | undefined;
    jobTitle: string | undefined;
    countryId: number | undefined;
    country: SrcCountry | undefined;
    timeZone: SrcTimeZone | undefined;
    timeZoneId: number | undefined;
    city: string | undefined;
    dateHired: string | undefined;
    birthDate: string | undefined;
    birthMonth: string | undefined;
    isEmailNotificationActivated: boolean | undefined;
    isTeamsNotificationActivated: boolean | undefined;
    isPromoVisited: boolean | undefined;
    isProjectPromoVisited: boolean | undefined;
    myDayListSort: DayListSorting | undefined;
}

export enum TenantWorkType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class Tenant implements ITenant {
    id!: number | undefined;
    creationTime!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: string | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: string | undefined;
    tenancyName!: string;
    name!: string;
    connectionString!: string | undefined;
    isActive!: boolean | undefined;
    edition!: Edition | undefined;
    editionId!: number | undefined;
    creatorUser!: User | undefined;
    lastModifierUser!: User | undefined;
    deleterUser!: User | undefined;
    subscriptionEndDateUtc!: string | undefined;
    isInTrialPeriod!: boolean | undefined;
    customCssId!: string | undefined;
    logoId!: string | undefined;
    logoFileType!: string | undefined;
    subscriptionStartDateUtc!: string | undefined;
    abbreviation!: string | undefined;
    licenseUsers!: number | undefined;
    companyWorkDays!: string | undefined;
    checkInTime!: TimeSpan | undefined;
    reminderFrequency!: ReminderFrequency | undefined;
    isSendEmail!: boolean | undefined;
    isSendSms!: boolean | undefined;
    isStagesEnabled!: boolean | undefined;
    isHealthColumnDefaultVisible!: boolean | undefined;
    terms!: string | undefined;
    timeZoneId!: number | undefined;
    timeZone!: SrcTimeZone | undefined;
    companyId!: number | undefined;
    contactId!: number | undefined;
    groupId!: string | undefined;
    minLateMinutes!: number | undefined;
    isWorkSummaryRequired!: boolean | undefined;
    isLimitTeamDirectory!: boolean | undefined;
    industry!: string | undefined;
    referralSource!: string | undefined;
    workType!: TenantWorkType | undefined;
    companySize!: CompanySize | undefined;
    primaryTarget!: PrimaryTarget | undefined;
    clientDisplayFormat!: TenantClientDisplay | undefined;
    mainProductService!: string | undefined;
    shiftBeforeHrs!: number | undefined;
    isGetStartedCompleted!: boolean | undefined;
    referredFrom!: string | undefined;
    ownerId!: number | undefined;
    projectLabelSingular!: string | undefined;
    projectLabelPlural!: string | undefined;
    projectLabelPreset!: string | undefined;
    projectLabelCustomOptions!: string | undefined;
    apiKey!: string | undefined;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"];
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.edition = _data["edition"] ? Edition.fromJS(_data["edition"], _mappings) : undefined as any;
            this.editionId = _data["editionId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"], _mappings) : undefined as any;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"], _mappings) : undefined as any;
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"], _mappings) : undefined as any;
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.customCssId = _data["customCssId"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.subscriptionStartDateUtc = _data["subscriptionStartDateUtc"];
            this.abbreviation = _data["abbreviation"];
            this.licenseUsers = _data["licenseUsers"];
            this.companyWorkDays = _data["companyWorkDays"];
            this.checkInTime = _data["checkInTime"] ? TimeSpan.fromJS(_data["checkInTime"], _mappings) : undefined as any;
            this.reminderFrequency = _data["reminderFrequency"];
            this.isSendEmail = _data["isSendEmail"];
            this.isSendSms = _data["isSendSms"];
            this.isStagesEnabled = _data["isStagesEnabled"];
            this.isHealthColumnDefaultVisible = _data["isHealthColumnDefaultVisible"];
            this.terms = _data["terms"];
            this.timeZoneId = _data["timeZoneId"];
            this.timeZone = _data["timeZone"] ? SrcTimeZone.fromJS(_data["timeZone"], _mappings) : undefined as any;
            this.companyId = _data["companyId"];
            this.contactId = _data["contactId"];
            this.groupId = _data["groupId"];
            this.minLateMinutes = _data["minLateMinutes"];
            this.isWorkSummaryRequired = _data["isWorkSummaryRequired"];
            this.isLimitTeamDirectory = _data["isLimitTeamDirectory"];
            this.industry = _data["industry"];
            this.referralSource = _data["referralSource"];
            this.workType = _data["workType"];
            this.companySize = _data["companySize"];
            this.primaryTarget = _data["primaryTarget"];
            this.clientDisplayFormat = _data["clientDisplayFormat"];
            this.mainProductService = _data["mainProductService"];
            this.shiftBeforeHrs = _data["shiftBeforeHrs"];
            this.isGetStartedCompleted = _data["isGetStartedCompleted"];
            this.referredFrom = _data["referredFrom"];
            this.ownerId = _data["ownerId"];
            this.projectLabelSingular = _data["projectLabelSingular"];
            this.projectLabelPlural = _data["projectLabelPlural"];
            this.projectLabelPreset = _data["projectLabelPreset"];
            this.projectLabelCustomOptions = _data["projectLabelCustomOptions"];
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any, _mappings?: any): Tenant | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Tenant>(data, _mappings, Tenant);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        data["editionId"] = this.editionId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : undefined as any;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : undefined as any;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : undefined as any;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["customCssId"] = this.customCssId;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["subscriptionStartDateUtc"] = this.subscriptionStartDateUtc;
        data["abbreviation"] = this.abbreviation;
        data["licenseUsers"] = this.licenseUsers;
        data["companyWorkDays"] = this.companyWorkDays;
        data["checkInTime"] = this.checkInTime ? this.checkInTime.toJSON() : undefined as any;
        data["reminderFrequency"] = this.reminderFrequency;
        data["isSendEmail"] = this.isSendEmail;
        data["isSendSms"] = this.isSendSms;
        data["isStagesEnabled"] = this.isStagesEnabled;
        data["isHealthColumnDefaultVisible"] = this.isHealthColumnDefaultVisible;
        data["terms"] = this.terms;
        data["timeZoneId"] = this.timeZoneId;
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : undefined as any;
        data["companyId"] = this.companyId;
        data["contactId"] = this.contactId;
        data["groupId"] = this.groupId;
        data["minLateMinutes"] = this.minLateMinutes;
        data["isWorkSummaryRequired"] = this.isWorkSummaryRequired;
        data["isLimitTeamDirectory"] = this.isLimitTeamDirectory;
        data["industry"] = this.industry;
        data["referralSource"] = this.referralSource;
        data["workType"] = this.workType;
        data["companySize"] = this.companySize;
        data["primaryTarget"] = this.primaryTarget;
        data["clientDisplayFormat"] = this.clientDisplayFormat;
        data["mainProductService"] = this.mainProductService;
        data["shiftBeforeHrs"] = this.shiftBeforeHrs;
        data["isGetStartedCompleted"] = this.isGetStartedCompleted;
        data["referredFrom"] = this.referredFrom;
        data["ownerId"] = this.ownerId;
        data["projectLabelSingular"] = this.projectLabelSingular;
        data["projectLabelPlural"] = this.projectLabelPlural;
        data["projectLabelPreset"] = this.projectLabelPreset;
        data["projectLabelCustomOptions"] = this.projectLabelCustomOptions;
        data["apiKey"] = this.apiKey;
        return data;
    }
}

export interface ITenant {
    id: number | undefined;
    creationTime: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: string | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: string | undefined;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    isActive: boolean | undefined;
    edition: Edition | undefined;
    editionId: number | undefined;
    creatorUser: User | undefined;
    lastModifierUser: User | undefined;
    deleterUser: User | undefined;
    subscriptionEndDateUtc: string | undefined;
    isInTrialPeriod: boolean | undefined;
    customCssId: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    subscriptionStartDateUtc: string | undefined;
    abbreviation: string | undefined;
    licenseUsers: number | undefined;
    companyWorkDays: string | undefined;
    checkInTime: TimeSpan | undefined;
    reminderFrequency: ReminderFrequency | undefined;
    isSendEmail: boolean | undefined;
    isSendSms: boolean | undefined;
    isStagesEnabled: boolean | undefined;
    isHealthColumnDefaultVisible: boolean | undefined;
    terms: string | undefined;
    timeZoneId: number | undefined;
    timeZone: SrcTimeZone | undefined;
    companyId: number | undefined;
    contactId: number | undefined;
    groupId: string | undefined;
    minLateMinutes: number | undefined;
    isWorkSummaryRequired: boolean | undefined;
    isLimitTeamDirectory: boolean | undefined;
    industry: string | undefined;
    referralSource: string | undefined;
    workType: TenantWorkType | undefined;
    companySize: CompanySize | undefined;
    primaryTarget: PrimaryTarget | undefined;
    clientDisplayFormat: TenantClientDisplay | undefined;
    mainProductService: string | undefined;
    shiftBeforeHrs: number | undefined;
    isGetStartedCompleted: boolean | undefined;
    referredFrom: string | undefined;
    ownerId: number | undefined;
    projectLabelSingular: string | undefined;
    projectLabelPlural: string | undefined;
    projectLabelPreset: string | undefined;
    projectLabelCustomOptions: string | undefined;
    apiKey: string | undefined;
}

export class MemberActivity implements IMemberActivity {
    name!: string | undefined;
    earnings!: string | undefined;
    cases!: number | undefined;
    closed!: number | undefined;
    rate!: string | undefined;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.earnings = _data["earnings"];
            this.cases = _data["cases"];
            this.closed = _data["closed"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any, _mappings?: any): MemberActivity | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MemberActivity>(data, _mappings, MemberActivity);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IMemberActivity {
    name: string | undefined;
    earnings: string | undefined;
    cases: number | undefined;
    closed: number | undefined;
    rate: string | undefined;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities!: MemberActivity[] | undefined;

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["memberActivities"])) {
                this.memberActivities = [] as any;
                for (let item of _data["memberActivities"])
                    this.memberActivities!.push(MemberActivity.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetMemberActivityOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetMemberActivityOutput>(data, _mappings, GetMemberActivityOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberActivities)) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[] | undefined;
}

export enum SalesSummaryDatePeriod {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class SalesSummaryData implements ISalesSummaryData {
    period!: string | undefined;
    sales!: number | undefined;
    profit!: number | undefined;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.period = _data["period"];
            this.sales = _data["sales"];
            this.profit = _data["profit"];
        }
    }

    static fromJS(data: any, _mappings?: any): SalesSummaryData | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SalesSummaryData>(data, _mappings, SalesSummaryData);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data;
    }
}

export interface ISalesSummaryData {
    period: string | undefined;
    sales: number | undefined;
    profit: number | undefined;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit!: number | undefined;
    newFeedbacks!: number | undefined;
    newOrders!: number | undefined;
    newUsers!: number | undefined;
    salesSummary!: SalesSummaryData[] | undefined;
    totalSales!: number | undefined;
    revenue!: number | undefined;
    expenses!: number | undefined;
    growth!: number | undefined;
    transactionPercent!: number | undefined;
    newVisitPercent!: number | undefined;
    bouncePercent!: number | undefined;
    dailySales!: number[] | undefined;
    profitShares!: number[] | undefined;

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item, _mappings));
            }
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetDashboardDataOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetDashboardDataOutput>(data, _mappings, GetDashboardDataOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number | undefined;
    newFeedbacks: number | undefined;
    newOrders: number | undefined;
    newUsers: number | undefined;
    salesSummary: SalesSummaryData[] | undefined;
    totalSales: number | undefined;
    revenue: number | undefined;
    expenses: number | undefined;
    growth: number | undefined;
    transactionPercent: number | undefined;
    newVisitPercent: number | undefined;
    bouncePercent: number | undefined;
    dailySales: number[] | undefined;
    profitShares: number[] | undefined;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    salesSummary!: SalesSummaryData[] | undefined;

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetSalesSummaryOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetSalesSummaryOutput>(data, _mappings, GetSalesSummaryOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetSalesSummaryOutput {
    salesSummary: SalesSummaryData[] | undefined;
}

export class GetRegionalStatsInput implements IGetRegionalStatsInput {

    constructor(data?: IGetRegionalStatsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): GetRegionalStatsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetRegionalStatsInput>(data, _mappings, GetRegionalStatsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRegionalStatsInput {
}

export class RegionalStatCountry implements IRegionalStatCountry {
    countryName!: string | undefined;
    sales!: number | undefined;
    change!: number[] | undefined;
    averagePrice!: number | undefined;
    totalPrice!: number | undefined;

    constructor(data?: IRegionalStatCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.countryName = _data["countryName"];
            this.sales = _data["sales"];
            if (Array.isArray(_data["change"])) {
                this.change = [] as any;
                for (let item of _data["change"])
                    this.change!.push(item);
            }
            this.averagePrice = _data["averagePrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any, _mappings?: any): RegionalStatCountry | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RegionalStatCountry>(data, _mappings, RegionalStatCountry);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["sales"] = this.sales;
        if (Array.isArray(this.change)) {
            data["change"] = [];
            for (let item of this.change)
                data["change"].push(item);
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IRegionalStatCountry {
    countryName: string | undefined;
    sales: number | undefined;
    change: number[] | undefined;
    averagePrice: number | undefined;
    totalPrice: number | undefined;
}

export class GetRegionalStatsOutput implements IGetRegionalStatsOutput {
    stats!: RegionalStatCountry[] | undefined;

    constructor(data?: IGetRegionalStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats!.push(RegionalStatCountry.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetRegionalStatsOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetRegionalStatsOutput>(data, _mappings, GetRegionalStatsOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetRegionalStatsOutput {
    stats: RegionalStatCountry[] | undefined;
}

export class GetGeneralStatsInput implements IGetGeneralStatsInput {

    constructor(data?: IGetGeneralStatsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): GetGeneralStatsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetGeneralStatsInput>(data, _mappings, GetGeneralStatsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGeneralStatsInput {
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent!: number | undefined;
    newVisitPercent!: number | undefined;
    bouncePercent!: number | undefined;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetGeneralStatsOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetGeneralStatsOutput>(data, _mappings, GetGeneralStatsOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data;
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number | undefined;
    newVisitPercent: number | undefined;
    bouncePercent: number | undefined;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    industry!: string | undefined;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.industry = _data["industry"];
        }
    }

    static fromJS(data: any, _mappings?: any): RegisterTenantInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RegisterTenantInput>(data, _mappings, RegisterTenantInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["industry"] = this.industry;
        return data;
    }
}

export interface IRegisterTenantInput {
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    industry: string | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId!: number | undefined;
    name!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    isTenantActive!: boolean | undefined;
    isActive!: boolean | undefined;
    isEmailConfirmationRequired!: boolean | undefined;
    isActivationEmailSent!: boolean | undefined;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.isTenantActive = _data["isTenantActive"];
            this.isActive = _data["isActive"];
            this.isEmailConfirmationRequired = _data["isEmailConfirmationRequired"];
            this.isActivationEmailSent = _data["isActivationEmailSent"];
        }
    }

    static fromJS(data: any, _mappings?: any): RegisterTenantOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RegisterTenantOutput>(data, _mappings, RegisterTenantOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        data["isActivationEmailSent"] = this.isActivationEmailSent;
        return data;
    }
}

export interface IRegisterTenantOutput {
    tenantId: number | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean | undefined;
    isActive: boolean | undefined;
    isEmailConfirmationRequired: boolean | undefined;
    isActivationEmailSent: boolean | undefined;
}

export class RegisterTenantOutputIHandleError implements IRegisterTenantOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: RegisterTenantOutput | undefined;
    listOfEntities!: RegisterTenantOutput[] | undefined;

    constructor(data?: IRegisterTenantOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? RegisterTenantOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(RegisterTenantOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RegisterTenantOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RegisterTenantOutputIHandleError>(data, _mappings, RegisterTenantOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegisterTenantOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: RegisterTenantOutput | undefined;
    listOfEntities: RegisterTenantOutput[] | undefined;
}

export class RegisterTenantStep1Input implements IRegisterTenantStep1Input {
    tenantId!: number | undefined;
    userId!: number | undefined;
    avatarId!: number | undefined;

    constructor(data?: IRegisterTenantStep1Input) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.avatarId = _data["avatarId"];
        }
    }

    static fromJS(data: any, _mappings?: any): RegisterTenantStep1Input | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RegisterTenantStep1Input>(data, _mappings, RegisterTenantStep1Input);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["avatarId"] = this.avatarId;
        return data;
    }
}

export interface IRegisterTenantStep1Input {
    tenantId: number | undefined;
    userId: number | undefined;
    avatarId: number | undefined;
}

export class RegisterTenantStep2Input implements IRegisterTenantStep2Input {
    tenantId!: number | undefined;
    userId!: number | undefined;
    city!: string | undefined;
    countryId!: number | undefined;
    birthDate!: string | undefined;
    birthMonth!: string | undefined;

    constructor(data?: IRegisterTenantStep2Input) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.birthDate = _data["birthDate"];
            this.birthMonth = _data["birthMonth"];
        }
    }

    static fromJS(data: any, _mappings?: any): RegisterTenantStep2Input | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RegisterTenantStep2Input>(data, _mappings, RegisterTenantStep2Input);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["birthDate"] = this.birthDate;
        data["birthMonth"] = this.birthMonth;
        return data;
    }
}

export interface IRegisterTenantStep2Input {
    tenantId: number | undefined;
    userId: number | undefined;
    city: string | undefined;
    countryId: number | undefined;
    birthDate: string | undefined;
    birthMonth: string | undefined;
}

export class RegisterTenantStep3Input implements IRegisterTenantStep3Input {
    tenantId!: number | undefined;
    timezoneId!: number | undefined;
    id!: number | undefined;
    shiftName!: string | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    breakStartTime!: string | undefined;
    duration!: number | undefined;
    workDays!: number[] | undefined;

    constructor(data?: IRegisterTenantStep3Input) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.timezoneId = _data["timezoneId"];
            this.id = _data["id"];
            this.shiftName = _data["shiftName"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.breakStartTime = _data["breakStartTime"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["workDays"])) {
                this.workDays = [] as any;
                for (let item of _data["workDays"])
                    this.workDays!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RegisterTenantStep3Input | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RegisterTenantStep3Input>(data, _mappings, RegisterTenantStep3Input);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["timezoneId"] = this.timezoneId;
        data["id"] = this.id;
        data["shiftName"] = this.shiftName;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["breakStartTime"] = this.breakStartTime;
        data["duration"] = this.duration;
        if (Array.isArray(this.workDays)) {
            data["workDays"] = [];
            for (let item of this.workDays)
                data["workDays"].push(item);
        }
        return data;
    }
}

export interface IRegisterTenantStep3Input {
    tenantId: number | undefined;
    timezoneId: number | undefined;
    id: number | undefined;
    shiftName: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    breakStartTime: string | undefined;
    duration: number | undefined;
    workDays: number[] | undefined;
}

export class TraceTenantRegistrationInput implements ITraceTenantRegistrationInput {
    tenantId!: number | undefined;

    constructor(data?: ITraceTenantRegistrationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any, _mappings?: any): TraceTenantRegistrationInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TraceTenantRegistrationInput>(data, _mappings, TraceTenantRegistrationInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ITraceTenantRegistrationInput {
    tenantId: number | undefined;
}

export class TraceTenantRegistrationOutput implements ITraceTenantRegistrationOutput {
    isStep1Completed!: boolean | undefined;
    isStep2Completed!: boolean | undefined;
    isStep3Completed!: boolean | undefined;
    emailAddress!: string | undefined;

    constructor(data?: ITraceTenantRegistrationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isStep1Completed = _data["isStep1Completed"];
            this.isStep2Completed = _data["isStep2Completed"];
            this.isStep3Completed = _data["isStep3Completed"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any, _mappings?: any): TraceTenantRegistrationOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TraceTenantRegistrationOutput>(data, _mappings, TraceTenantRegistrationOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isStep1Completed"] = this.isStep1Completed;
        data["isStep2Completed"] = this.isStep2Completed;
        data["isStep3Completed"] = this.isStep3Completed;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ITraceTenantRegistrationOutput {
    isStep1Completed: boolean | undefined;
    isStep2Completed: boolean | undefined;
    isStep3Completed: boolean | undefined;
    emailAddress: string | undefined;
}

export class IInputType implements IIInputType {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator | undefined;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            if (_data["attributes"]) {
                (this as any).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        ((this as any).attributes as any)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): IInputType | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IInputType>(data, _mappings, IInputType);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (data["attributes"] as any)[key] = (this.attributes as any)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : undefined as any;
        return data;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator | undefined;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: IInputType | undefined;
    textHtmlColor!: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"], _mappings) : undefined as any;
            this.textHtmlColor = _data["textHtmlColor"];
        }
    }

    static fromJS(data: any, _mappings?: any): FlatFeatureSelectDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FlatFeatureSelectDto>(data, _mappings, FlatFeatureSelectDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined as any;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType | undefined;
    textHtmlColor: string | undefined;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition!: EditionSelectDto | undefined;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"], _mappings) : undefined as any;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): EditionWithFeaturesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EditionWithFeaturesDto>(data, _mappings, EditionWithFeaturesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined as any;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto | undefined;
    featureValues: NameValueDto[] | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures!: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;
    tenantEditionId!: number | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["allFeatures"])) {
                this.allFeatures = [] as any;
                for (let item of _data["allFeatures"])
                    this.allFeatures!.push(FlatFeatureSelectDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["editionsWithFeatures"])) {
                this.editionsWithFeatures = [] as any;
                for (let item of _data["editionsWithFeatures"])
                    this.editionsWithFeatures!.push(EditionWithFeaturesDto.fromJS(item, _mappings));
            }
            this.tenantEditionId = _data["tenantEditionId"];
        }
    }

    static fromJS(data: any, _mappings?: any): EditionsSelectOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EditionsSelectOutput>(data, _mappings, EditionsSelectOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item ? item.toJSON() : undefined as any);
        }
        data["tenantEditionId"] = this.tenantEditionId;
        return data;
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
    tenantEditionId: number | undefined;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration!: boolean | undefined;
    isNewRegisteredUserActiveByDefault!: boolean | undefined;
    isEmailConfirmationRequiredForLogin!: boolean | undefined;
    useCaptchaOnRegistration!: boolean | undefined;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = _data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
        }
    }

    static fromJS(data: any, _mappings?: any): TenantUserManagementSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantUserManagementSettingsEditDto>(data, _mappings, TenantUserManagementSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        return data;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean | undefined;
    isNewRegisteredUserActiveByDefault: boolean | undefined;
    isEmailConfirmationRequiredForLogin: boolean | undefined;
    useCaptchaOnRegistration: boolean | undefined;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled!: boolean | undefined;
    isEnabled!: boolean | undefined;
    domain!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.isModuleEnabled = _data["isModuleEnabled"];
            this.isEnabled = _data["isEnabled"];
            this.domain = _data["domain"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any, _mappings?: any): LdapSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LdapSettingsEditDto>(data, _mappings, LdapSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean | undefined;
    isEnabled: boolean | undefined;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;
    taxVatNo!: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
            this.taxVatNo = _data["taxVatNo"];
        }
    }

    static fromJS(data: any, _mappings?: any): TenantBillingSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantBillingSettingsEditDto>(data, _mappings, TenantBillingSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general!: GeneralSettingsEditDto | undefined;
    userManagement!: TenantUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto | undefined;
    ldap!: LdapSettingsEditDto | undefined;
    security!: SecuritySettingsEditDto;
    billing!: TenantBillingSettingsEditDto | undefined;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"], _mappings) : undefined as any;
            this.userManagement = _data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(_data["userManagement"], _mappings) : new TenantUserManagementSettingsEditDto();
            this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"], _mappings) : undefined as any;
            this.ldap = _data["ldap"] ? LdapSettingsEditDto.fromJS(_data["ldap"], _mappings) : undefined as any;
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"], _mappings) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? TenantBillingSettingsEditDto.fromJS(_data["billing"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): TenantSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantSettingsEditDto>(data, _mappings, TenantSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : undefined as any;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : undefined as any;
        data["email"] = this.email ? this.email.toJSON() : undefined as any;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : undefined as any;
        data["security"] = this.security ? this.security.toJSON() : undefined as any;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined as any;
        return data;
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto | undefined;
    userManagement: TenantUserManagementSettingsEditDto;
    email: EmailSettingsEditDto | undefined;
    ldap: LdapSettingsEditDto | undefined;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto | undefined;
}

export class CreateTicketInput implements ICreateTicketInput {
    id!: number | undefined;
    problemTypeId!: number | undefined;
    problemOverview!: string | undefined;
    problemDescription!: string | undefined;
    taskId!: number | undefined;
    attachments!: CommonAttachment[] | undefined;

    constructor(data?: ICreateTicketInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.problemTypeId = _data["problemTypeId"];
            this.problemOverview = _data["problemOverview"];
            this.problemDescription = _data["problemDescription"];
            this.taskId = _data["taskId"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CommonAttachment.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateTicketInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateTicketInput>(data, _mappings, CreateTicketInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["problemTypeId"] = this.problemTypeId;
        data["problemOverview"] = this.problemOverview;
        data["problemDescription"] = this.problemDescription;
        data["taskId"] = this.taskId;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateTicketInput {
    id: number | undefined;
    problemTypeId: number | undefined;
    problemOverview: string | undefined;
    problemDescription: string | undefined;
    taskId: number | undefined;
    attachments: CommonAttachment[] | undefined;
}

export class StartTimerInputDto implements IStartTimerInputDto {
    taskId!: number | undefined;
    projectId!: number | undefined;

    constructor(data?: IStartTimerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any, _mappings?: any): StartTimerInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StartTimerInputDto>(data, _mappings, StartTimerInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IStartTimerInputDto {
    taskId: number | undefined;
    projectId: number | undefined;
}

export class ActiveTimerDto implements IActiveTimerDto {
    id!: number | undefined;
    taskId!: number | undefined;
    taskName!: string | undefined;
    startTime!: string | undefined;
    userId!: number | undefined;
    userFullName!: string | undefined;

    constructor(data?: IActiveTimerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.startTime = _data["startTime"];
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ActiveTimerDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ActiveTimerDto>(data, _mappings, ActiveTimerDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["startTime"] = this.startTime;
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        return data;
    }
}

export interface IActiveTimerDto {
    id: number | undefined;
    taskId: number | undefined;
    taskName: string | undefined;
    startTime: string | undefined;
    userId: number | undefined;
    userFullName: string | undefined;
}

export class ActiveTimerDtoIHandleError implements IActiveTimerDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ActiveTimerDto | undefined;
    listOfEntities!: ActiveTimerDto[] | undefined;

    constructor(data?: IActiveTimerDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? ActiveTimerDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(ActiveTimerDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ActiveTimerDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ActiveTimerDtoIHandleError>(data, _mappings, ActiveTimerDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IActiveTimerDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ActiveTimerDto | undefined;
    listOfEntities: ActiveTimerDto[] | undefined;
}

export class StopTimerInputDto implements IStopTimerInputDto {
    entryId!: number | undefined;

    constructor(data?: IStopTimerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.entryId = _data["entryId"];
        }
    }

    static fromJS(data: any, _mappings?: any): StopTimerInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StopTimerInputDto>(data, _mappings, StopTimerInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entryId"] = this.entryId;
        return data;
    }
}

export interface IStopTimerInputDto {
    entryId: number | undefined;
}

export class TimeEntryDto implements ITimeEntryDto {
    id!: number | undefined;
    taskId!: number | undefined;
    taskName!: string | undefined;
    projectId!: number | undefined;
    userId!: number | undefined;
    userFullName!: string | undefined;
    userInitials!: string | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    durationMinutes!: number | undefined;
    notes!: string | undefined;
    isActive!: boolean | undefined;

    constructor(data?: ITimeEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
            this.userInitials = _data["userInitials"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.durationMinutes = _data["durationMinutes"];
            this.notes = _data["notes"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any, _mappings?: any): TimeEntryDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TimeEntryDto>(data, _mappings, TimeEntryDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        data["userInitials"] = this.userInitials;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["durationMinutes"] = this.durationMinutes;
        data["notes"] = this.notes;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITimeEntryDto {
    id: number | undefined;
    taskId: number | undefined;
    taskName: string | undefined;
    projectId: number | undefined;
    userId: number | undefined;
    userFullName: string | undefined;
    userInitials: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    durationMinutes: number | undefined;
    notes: string | undefined;
    isActive: boolean | undefined;
}

export class TimeEntryDtoIHandleError implements ITimeEntryDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TimeEntryDto | undefined;
    listOfEntities!: TimeEntryDto[] | undefined;

    constructor(data?: ITimeEntryDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? TimeEntryDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(TimeEntryDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TimeEntryDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TimeEntryDtoIHandleError>(data, _mappings, TimeEntryDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITimeEntryDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TimeEntryDto | undefined;
    listOfEntities: TimeEntryDto[] | undefined;
}

export class TimeEntryDtoListIHandleError implements ITimeEntryDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TimeEntryDto[] | undefined;
    listOfEntities!: TimeEntryDto[][] | undefined;

    constructor(data?: ITimeEntryDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TimeEntryDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TimeEntryDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TimeEntryDtoListIHandleError>(data, _mappings, TimeEntryDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITimeEntryDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TimeEntryDto[] | undefined;
    listOfEntities: TimeEntryDto[][] | undefined;
}

export class ProjectTimeEntryDto implements IProjectTimeEntryDto {
    id!: number | undefined;
    taskId!: number | undefined;
    taskName!: string | undefined;
    userId!: number | undefined;
    userFullName!: string | undefined;
    userInitials!: string | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    durationMinutes!: number | undefined;
    notes!: string | undefined;

    constructor(data?: IProjectTimeEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
            this.userInitials = _data["userInitials"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.durationMinutes = _data["durationMinutes"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTimeEntryDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTimeEntryDto>(data, _mappings, ProjectTimeEntryDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        data["userInitials"] = this.userInitials;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["durationMinutes"] = this.durationMinutes;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IProjectTimeEntryDto {
    id: number | undefined;
    taskId: number | undefined;
    taskName: string | undefined;
    userId: number | undefined;
    userFullName: string | undefined;
    userInitials: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    durationMinutes: number | undefined;
    notes: string | undefined;
}

export class ProjectTimeEntryDtoListIHandleError implements IProjectTimeEntryDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ProjectTimeEntryDto[] | undefined;
    listOfEntities!: ProjectTimeEntryDto[][] | undefined;

    constructor(data?: IProjectTimeEntryDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ProjectTimeEntryDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProjectTimeEntryDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProjectTimeEntryDtoListIHandleError>(data, _mappings, ProjectTimeEntryDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IProjectTimeEntryDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ProjectTimeEntryDto[] | undefined;
    listOfEntities: ProjectTimeEntryDto[][] | undefined;
}

export class AddTimeEntryInputDto implements IAddTimeEntryInputDto {
    taskId!: number | undefined;
    projectId!: number | undefined;
    userId!: number | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    notes!: string | undefined;

    constructor(data?: IAddTimeEntryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any, _mappings?: any): AddTimeEntryInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddTimeEntryInputDto>(data, _mappings, AddTimeEntryInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IAddTimeEntryInputDto {
    taskId: number | undefined;
    projectId: number | undefined;
    userId: number | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    notes: string | undefined;
}

export class UpdateTimeEntryInputDto implements IUpdateTimeEntryInputDto {
    id!: number | undefined;
    userId!: number | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateTimeEntryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateTimeEntryInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateTimeEntryInputDto>(data, _mappings, UpdateTimeEntryInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateTimeEntryInputDto {
    id: number | undefined;
    userId: number | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    notes: string | undefined;
}

export enum SettingScopes {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _7 = 7,
}

export class NameValueDtoListResultDto implements INameValueDtoListResultDto {
    items!: NameValueDto[] | undefined;

    constructor(data?: INameValueDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): NameValueDtoListResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NameValueDtoListResultDto>(data, _mappings, NameValueDtoListResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INameValueDtoListResultDto {
    items: NameValueDto[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean | undefined;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.singleSignIn = _data["singleSignIn"];
            this.returnUrl = _data["returnUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): AuthenticateModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AuthenticateModel>(data, _mappings, AuthenticateModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean | undefined;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number | undefined;
    shouldResetPassword!: boolean | undefined;
    passwordResetCode!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    requiresTwoFactorVerification!: boolean | undefined;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    fieldName!: string | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.fieldName = _data["fieldName"];
        }
    }

    static fromJS(data: any, _mappings?: any): AuthenticateResultModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AuthenticateResultModel>(data, _mappings, AuthenticateResultModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["fieldName"] = this.fieldName;
        return data;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    shouldResetPassword: boolean | undefined;
    passwordResetCode: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    requiresTwoFactorVerification: boolean | undefined;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    errorMessage: string | undefined;
    isError: boolean | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    fieldName: string | undefined;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId!: number | undefined;
    provider!: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any, _mappings?: any): SendTwoFactorAuthCodeModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SendTwoFactorAuthCodeModel>(data, _mappings, SendTwoFactorAuthCodeModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data;
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number | undefined;
    provider: string;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number | undefined;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any, _mappings?: any): ImpersonatedAuthenticateResultModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ImpersonatedAuthenticateResultModel>(data, _mappings, ImpersonatedAuthenticateResultModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number | undefined;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any, _mappings?: any): SwitchedAccountAuthenticateResultModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SwitchedAccountAuthenticateResultModel>(data, _mappings, SwitchedAccountAuthenticateResultModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;
    clientSecret!: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any, _mappings?: any): ExternalLoginProviderInfoModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ExternalLoginProviderInfoModel>(data, _mappings, ExternalLoginProviderInfoModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    clientSecret: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;
    emailAddress!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    authCodeToGetToken!: string | undefined;
    idToken!: string | undefined;
    refreshToken!: string | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.authCodeToGetToken = _data["authCodeToGetToken"];
            this.idToken = _data["idToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any, _mappings?: any): ExternalAuthenticateModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ExternalAuthenticateModel>(data, _mappings, ExternalAuthenticateModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["authCodeToGetToken"] = this.authCodeToGetToken;
        data["idToken"] = this.idToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
    emailAddress: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    authCodeToGetToken: string | undefined;
    idToken: string | undefined;
    refreshToken: string | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number | undefined;
    waitingForActivation!: boolean | undefined;
    userNotExists!: boolean | undefined;
    isM365AccountLinked!: boolean | undefined;
    isPublicDomain!: boolean | undefined;
    signUpFailed!: boolean | undefined;
    returnUrl!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    apiOptions!: ApiOptions | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
            this.userNotExists = _data["userNotExists"];
            this.isM365AccountLinked = _data["isM365AccountLinked"];
            this.isPublicDomain = _data["isPublicDomain"];
            this.signUpFailed = _data["signUpFailed"];
            this.returnUrl = _data["returnUrl"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.apiOptions = _data["apiOptions"] ? ApiOptions.fromJS(_data["apiOptions"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): ExternalAuthenticateResultModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ExternalAuthenticateResultModel>(data, _mappings, ExternalAuthenticateResultModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["userNotExists"] = this.userNotExists;
        data["isM365AccountLinked"] = this.isM365AccountLinked;
        data["isPublicDomain"] = this.isPublicDomain;
        data["signUpFailed"] = this.signUpFailed;
        data["returnUrl"] = this.returnUrl;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["apiOptions"] = this.apiOptions ? this.apiOptions.toJSON() : undefined as any;
        return data;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    waitingForActivation: boolean | undefined;
    userNotExists: boolean | undefined;
    isM365AccountLinked: boolean | undefined;
    isPublicDomain: boolean | undefined;
    signUpFailed: boolean | undefined;
    returnUrl: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    apiOptions: ApiOptions | undefined;
}

export class UiCustomizationLayoutSettingsEditDto implements IUiCustomizationLayoutSettingsEditDto {
    layoutType!: string | undefined;
    contentSkin!: string | undefined;
    theme!: string | undefined;

    constructor(data?: IUiCustomizationLayoutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.layoutType = _data["layoutType"];
            this.contentSkin = _data["contentSkin"];
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any, _mappings?: any): UiCustomizationLayoutSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UiCustomizationLayoutSettingsEditDto>(data, _mappings, UiCustomizationLayoutSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        data["contentSkin"] = this.contentSkin;
        data["theme"] = this.theme;
        return data;
    }
}

export interface IUiCustomizationLayoutSettingsEditDto {
    layoutType: string | undefined;
    contentSkin: string | undefined;
    theme: string | undefined;
}

export class UiCustomizationHeaderSettingsEditDto implements IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader!: boolean | undefined;
    desktopMinimizeMode!: string | undefined;
    mobileFixedHeader!: boolean | undefined;
    headerSkin!: string | undefined;
    displaySubmenuArrowDesktop!: boolean | undefined;

    constructor(data?: IUiCustomizationHeaderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.desktopFixedHeader = _data["desktopFixedHeader"];
            this.desktopMinimizeMode = _data["desktopMinimizeMode"];
            this.mobileFixedHeader = _data["mobileFixedHeader"];
            this.headerSkin = _data["headerSkin"];
            this.displaySubmenuArrowDesktop = _data["displaySubmenuArrowDesktop"];
        }
    }

    static fromJS(data: any, _mappings?: any): UiCustomizationHeaderSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UiCustomizationHeaderSettingsEditDto>(data, _mappings, UiCustomizationHeaderSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["desktopMinimizeMode"] = this.desktopMinimizeMode;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["displaySubmenuArrowDesktop"] = this.displaySubmenuArrowDesktop;
        return data;
    }
}

export interface IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader: boolean | undefined;
    desktopMinimizeMode: string | undefined;
    mobileFixedHeader: boolean | undefined;
    headerSkin: string | undefined;
    displaySubmenuArrowDesktop: boolean | undefined;
}

export class UiCustomizationMenuSettingsEditDto implements IUiCustomizationMenuSettingsEditDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean | undefined;
    allowAsideMinimizing!: boolean | undefined;
    defaultMinimizedAside!: boolean | undefined;
    allowAsideHiding!: boolean | undefined;
    defaultHiddenAside!: boolean | undefined;
    submenuToggle!: string | undefined;
    dropdownSubmenuSkin!: string | undefined;
    dropdownSubmenuArrow!: boolean | undefined;

    constructor(data?: IUiCustomizationMenuSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.position = _data["position"];
            this.asideSkin = _data["asideSkin"];
            this.fixedAside = _data["fixedAside"];
            this.allowAsideMinimizing = _data["allowAsideMinimizing"];
            this.defaultMinimizedAside = _data["defaultMinimizedAside"];
            this.allowAsideHiding = _data["allowAsideHiding"];
            this.defaultHiddenAside = _data["defaultHiddenAside"];
            this.submenuToggle = _data["submenuToggle"];
            this.dropdownSubmenuSkin = _data["dropdownSubmenuSkin"];
            this.dropdownSubmenuArrow = _data["dropdownSubmenuArrow"];
        }
    }

    static fromJS(data: any, _mappings?: any): UiCustomizationMenuSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UiCustomizationMenuSettingsEditDto>(data, _mappings, UiCustomizationMenuSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["allowAsideHiding"] = this.allowAsideHiding;
        data["defaultHiddenAside"] = this.defaultHiddenAside;
        data["submenuToggle"] = this.submenuToggle;
        data["dropdownSubmenuSkin"] = this.dropdownSubmenuSkin;
        data["dropdownSubmenuArrow"] = this.dropdownSubmenuArrow;
        return data;
    }
}

export interface IUiCustomizationMenuSettingsEditDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean | undefined;
    allowAsideMinimizing: boolean | undefined;
    defaultMinimizedAside: boolean | undefined;
    allowAsideHiding: boolean | undefined;
    defaultHiddenAside: boolean | undefined;
    submenuToggle: string | undefined;
    dropdownSubmenuSkin: string | undefined;
    dropdownSubmenuArrow: boolean | undefined;
}

export class UiCustomizationFooterSettingsEditDto implements IUiCustomizationFooterSettingsEditDto {
    fixedFooter!: boolean | undefined;

    constructor(data?: IUiCustomizationFooterSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.fixedFooter = _data["fixedFooter"];
        }
    }

    static fromJS(data: any, _mappings?: any): UiCustomizationFooterSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UiCustomizationFooterSettingsEditDto>(data, _mappings, UiCustomizationFooterSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    }
}

export interface IUiCustomizationFooterSettingsEditDto {
    fixedFooter: boolean | undefined;
}

export class UiCustomizationSettingsEditDto implements IUiCustomizationSettingsEditDto {
    layout!: UiCustomizationLayoutSettingsEditDto | undefined;
    header!: UiCustomizationHeaderSettingsEditDto | undefined;
    menu!: UiCustomizationMenuSettingsEditDto | undefined;
    footer!: UiCustomizationFooterSettingsEditDto | undefined;

    constructor(data?: IUiCustomizationSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.layout = _data["layout"] ? UiCustomizationLayoutSettingsEditDto.fromJS(_data["layout"], _mappings) : undefined as any;
            this.header = _data["header"] ? UiCustomizationHeaderSettingsEditDto.fromJS(_data["header"], _mappings) : undefined as any;
            this.menu = _data["menu"] ? UiCustomizationMenuSettingsEditDto.fromJS(_data["menu"], _mappings) : undefined as any;
            this.footer = _data["footer"] ? UiCustomizationFooterSettingsEditDto.fromJS(_data["footer"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): UiCustomizationSettingsEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UiCustomizationSettingsEditDto>(data, _mappings, UiCustomizationSettingsEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layout"] = this.layout ? this.layout.toJSON() : undefined as any;
        data["header"] = this.header ? this.header.toJSON() : undefined as any;
        data["menu"] = this.menu ? this.menu.toJSON() : undefined as any;
        data["footer"] = this.footer ? this.footer.toJSON() : undefined as any;
        return data;
    }
}

export interface IUiCustomizationSettingsEditDto {
    layout: UiCustomizationLayoutSettingsEditDto | undefined;
    header: UiCustomizationHeaderSettingsEditDto | undefined;
    menu: UiCustomizationMenuSettingsEditDto | undefined;
    footer: UiCustomizationFooterSettingsEditDto | undefined;
}

export class Int32UserListDtoIEnumerableValueTuple implements IInt32UserListDtoIEnumerableValueTuple {

    constructor(data?: IInt32UserListDtoIEnumerableValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): Int32UserListDtoIEnumerableValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32UserListDtoIEnumerableValueTuple>(data, _mappings, Int32UserListDtoIEnumerableValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IInt32UserListDtoIEnumerableValueTuple {
}

export class Int32UserListDtoIEnumerableValueTupleIHandleError implements IInt32UserListDtoIEnumerableValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: Int32UserListDtoIEnumerableValueTuple | undefined;
    listOfEntities!: Int32UserListDtoIEnumerableValueTuple[] | undefined;

    constructor(data?: IInt32UserListDtoIEnumerableValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? Int32UserListDtoIEnumerableValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(Int32UserListDtoIEnumerableValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32UserListDtoIEnumerableValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32UserListDtoIEnumerableValueTupleIHandleError>(data, _mappings, Int32UserListDtoIEnumerableValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInt32UserListDtoIEnumerableValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: Int32UserListDtoIEnumerableValueTuple | undefined;
    listOfEntities: Int32UserListDtoIEnumerableValueTuple[] | undefined;
}

export class ActiveUsers implements IActiveUsers {
    userId!: number | undefined;
    fullname!: string | undefined;
    email!: string | undefined;
    isDeleted!: boolean | undefined;
    isActive!: boolean | undefined;
    profilePictureUrl!: string | undefined;

    constructor(data?: IActiveUsers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.fullname = _data["fullname"];
            this.email = _data["email"];
            this.isDeleted = _data["isDeleted"];
            this.isActive = _data["isActive"];
            this.profilePictureUrl = _data["profilePictureUrl"];
        }
    }

    static fromJS(data: any, _mappings?: any): ActiveUsers | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ActiveUsers>(data, _mappings, ActiveUsers);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["fullname"] = this.fullname;
        data["email"] = this.email;
        data["isDeleted"] = this.isDeleted;
        data["isActive"] = this.isActive;
        data["profilePictureUrl"] = this.profilePictureUrl;
        return data;
    }
}

export interface IActiveUsers {
    userId: number | undefined;
    fullname: string | undefined;
    email: string | undefined;
    isDeleted: boolean | undefined;
    isActive: boolean | undefined;
    profilePictureUrl: string | undefined;
}

export class ActiveUsersListIHandleError implements IActiveUsersListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: ActiveUsers[] | undefined;
    listOfEntities!: ActiveUsers[][] | undefined;

    constructor(data?: IActiveUsersListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(ActiveUsers.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ActiveUsersListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ActiveUsersListIHandleError>(data, _mappings, ActiveUsersListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IActiveUsersListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: ActiveUsers[] | undefined;
    listOfEntities: ActiveUsers[][] | undefined;
}

export class CategoriesDto implements ICategoriesDto {
    id!: number | undefined;

    constructor(data?: ICategoriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): CategoriesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CategoriesDto>(data, _mappings, CategoriesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICategoriesDto {
    id: number | undefined;
}

export class UserEditDto implements IUserEditDto {
    id!: number | undefined;
    name!: string;
    surname!: string | undefined;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    password!: string | undefined;
    isActive!: boolean | undefined;
    shouldChangePasswordOnNextLogin!: boolean | undefined;
    isTwoFactorEnabled!: boolean | undefined;
    isLockoutEnabled!: boolean | undefined;
    roleId!: number | undefined;
    isOwner!: boolean | undefined;
    employeeId!: string | undefined;
    managerId!: number | undefined;
    managerName!: string | undefined;
    teamsId!: number[] | undefined;
    teamName!: string | undefined;
    workSiteId!: number | undefined;
    shiftId!: number | undefined;
    languageId!: number | undefined;
    workSiteName!: string | undefined;
    countryId!: number | undefined;
    isCanWorkFromHome!: boolean | undefined;
    isRequireCheckin!: boolean | undefined;
    industryId!: number | undefined;
    jobTitle!: string | undefined;
    timezoneId!: number | undefined;
    city!: string | undefined;
    profilePictureUrl!: string | undefined;
    dateHired!: string | undefined;
    birthDate!: string | undefined;
    birthMonth!: string | undefined;
    categories!: CategoriesDto[] | undefined;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.roleId = _data["roleId"];
            this.isOwner = _data["isOwner"];
            this.employeeId = _data["employeeId"];
            this.managerId = _data["managerId"];
            this.managerName = _data["managerName"];
            if (Array.isArray(_data["teamsId"])) {
                this.teamsId = [] as any;
                for (let item of _data["teamsId"])
                    this.teamsId!.push(item);
            }
            this.teamName = _data["teamName"];
            this.workSiteId = _data["workSiteId"];
            this.shiftId = _data["shiftId"];
            this.languageId = _data["languageId"];
            this.workSiteName = _data["workSiteName"];
            this.countryId = _data["countryId"];
            this.isCanWorkFromHome = _data["isCanWorkFromHome"];
            this.isRequireCheckin = _data["isRequireCheckin"];
            this.industryId = _data["industryId"];
            this.jobTitle = _data["jobTitle"];
            this.timezoneId = _data["timezoneId"];
            this.city = _data["city"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.dateHired = _data["dateHired"];
            this.birthDate = _data["birthDate"];
            this.birthMonth = _data["birthMonth"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategoriesDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserEditDto>(data, _mappings, UserEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["roleId"] = this.roleId;
        data["isOwner"] = this.isOwner;
        data["employeeId"] = this.employeeId;
        data["managerId"] = this.managerId;
        data["managerName"] = this.managerName;
        if (Array.isArray(this.teamsId)) {
            data["teamsId"] = [];
            for (let item of this.teamsId)
                data["teamsId"].push(item);
        }
        data["teamName"] = this.teamName;
        data["workSiteId"] = this.workSiteId;
        data["shiftId"] = this.shiftId;
        data["languageId"] = this.languageId;
        data["workSiteName"] = this.workSiteName;
        data["countryId"] = this.countryId;
        data["isCanWorkFromHome"] = this.isCanWorkFromHome;
        data["isRequireCheckin"] = this.isRequireCheckin;
        data["industryId"] = this.industryId;
        data["jobTitle"] = this.jobTitle;
        data["timezoneId"] = this.timezoneId;
        data["city"] = this.city;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["dateHired"] = this.dateHired;
        data["birthDate"] = this.birthDate;
        data["birthMonth"] = this.birthMonth;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string;
    surname: string | undefined;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean | undefined;
    shouldChangePasswordOnNextLogin: boolean | undefined;
    isTwoFactorEnabled: boolean | undefined;
    isLockoutEnabled: boolean | undefined;
    roleId: number | undefined;
    isOwner: boolean | undefined;
    employeeId: string | undefined;
    managerId: number | undefined;
    managerName: string | undefined;
    teamsId: number[] | undefined;
    teamName: string | undefined;
    workSiteId: number | undefined;
    shiftId: number | undefined;
    languageId: number | undefined;
    workSiteName: string | undefined;
    countryId: number | undefined;
    isCanWorkFromHome: boolean | undefined;
    isRequireCheckin: boolean | undefined;
    industryId: number | undefined;
    jobTitle: string | undefined;
    timezoneId: number | undefined;
    city: string | undefined;
    profilePictureUrl: string | undefined;
    dateHired: string | undefined;
    birthDate: string | undefined;
    birthMonth: string | undefined;
    categories: CategoriesDto[] | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserPermissionsForEditOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserPermissionsForEditOutput>(data, _mappings, GetUserPermissionsForEditOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class Int64EntityDto implements IInt64EntityDto {
    id!: number | undefined;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Int64EntityDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int64EntityDto>(data, _mappings, Int64EntityDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IInt64EntityDto {
    id: number | undefined;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id!: number | undefined;
    grantedPermissionNames!: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UpdateUserPermissionsInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UpdateUserPermissionsInput>(data, _mappings, UpdateUserPermissionsInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number | undefined;
    grantedPermissionNames: string[];
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[];
    sendActivationEmail!: boolean | undefined;
    setRandomPassword!: boolean | undefined;
    organizationUnits!: number[] | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"], _mappings) : new UserEditDto();
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.setRandomPassword = _data["setRandomPassword"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateOrUpdateUserInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateOrUpdateUserInput>(data, _mappings, CreateOrUpdateUserInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean | undefined;
    setRandomPassword: boolean | undefined;
    organizationUnits: number[] | undefined;
}

export class GetUserTimezoneInfo implements IGetUserTimezoneInfo {
    currentTimeAsUserTz!: string | undefined;
    currentTimeAsCompanyTz!: string | undefined;

    constructor(data?: IGetUserTimezoneInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.currentTimeAsUserTz = _data["currentTimeAsUserTz"];
            this.currentTimeAsCompanyTz = _data["currentTimeAsCompanyTz"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserTimezoneInfo | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserTimezoneInfo>(data, _mappings, GetUserTimezoneInfo);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentTimeAsUserTz"] = this.currentTimeAsUserTz;
        data["currentTimeAsCompanyTz"] = this.currentTimeAsCompanyTz;
        return data;
    }
}

export interface IGetUserTimezoneInfo {
    currentTimeAsUserTz: string | undefined;
    currentTimeAsCompanyTz: string | undefined;
}

export class GetUserTimezoneInfoIHandleError implements IGetUserTimezoneInfoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetUserTimezoneInfo | undefined;
    listOfEntities!: GetUserTimezoneInfo[] | undefined;

    constructor(data?: IGetUserTimezoneInfoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetUserTimezoneInfo.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetUserTimezoneInfo.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserTimezoneInfoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserTimezoneInfoIHandleError>(data, _mappings, GetUserTimezoneInfoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetUserTimezoneInfoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetUserTimezoneInfo | undefined;
    listOfEntities: GetUserTimezoneInfo[] | undefined;
}

export class RelinkUserOutputDto implements IRelinkUserOutputDto {
    userId!: number | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IRelinkUserOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any, _mappings?: any): RelinkUserOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RelinkUserOutputDto>(data, _mappings, RelinkUserOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IRelinkUserOutputDto {
    userId: number | undefined;
    emailAddress: string | undefined;
}

export class RelinkUserOutputDtoListIHandleError implements IRelinkUserOutputDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: RelinkUserOutputDto[] | undefined;
    listOfEntities!: RelinkUserOutputDto[][] | undefined;

    constructor(data?: IRelinkUserOutputDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(RelinkUserOutputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RelinkUserOutputDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RelinkUserOutputDtoListIHandleError>(data, _mappings, RelinkUserOutputDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IRelinkUserOutputDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: RelinkUserOutputDto[] | undefined;
    listOfEntities: RelinkUserOutputDto[][] | undefined;
}

export class UserHoverDetailsIHandleError implements IUserHoverDetailsIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserHoverDetails | undefined;
    listOfEntities!: UserHoverDetails[] | undefined;

    constructor(data?: IUserHoverDetailsIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserHoverDetails.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserHoverDetails.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserHoverDetailsIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserHoverDetailsIHandleError>(data, _mappings, UserHoverDetailsIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserHoverDetailsIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserHoverDetails | undefined;
    listOfEntities: UserHoverDetails[] | undefined;
}

export class GetUserTimeDetails implements IGetUserTimeDetails {
    workShiftUserTz!: string | undefined;
    workShiftCompanyTz!: string | undefined;
    breakUserTz!: string | undefined;
    breakCompanyTz!: string | undefined;
    breakStatus!: number | undefined;
    loginUserTz!: string | undefined;
    loginCompanyTz!: string | undefined;

    constructor(data?: IGetUserTimeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.workShiftUserTz = _data["workShiftUserTz"];
            this.workShiftCompanyTz = _data["workShiftCompanyTz"];
            this.breakUserTz = _data["breakUserTz"];
            this.breakCompanyTz = _data["breakCompanyTz"];
            this.breakStatus = _data["breakStatus"];
            this.loginUserTz = _data["loginUserTz"];
            this.loginCompanyTz = _data["loginCompanyTz"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserTimeDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserTimeDetails>(data, _mappings, GetUserTimeDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workShiftUserTz"] = this.workShiftUserTz;
        data["workShiftCompanyTz"] = this.workShiftCompanyTz;
        data["breakUserTz"] = this.breakUserTz;
        data["breakCompanyTz"] = this.breakCompanyTz;
        data["breakStatus"] = this.breakStatus;
        data["loginUserTz"] = this.loginUserTz;
        data["loginCompanyTz"] = this.loginCompanyTz;
        return data;
    }
}

export interface IGetUserTimeDetails {
    workShiftUserTz: string | undefined;
    workShiftCompanyTz: string | undefined;
    breakUserTz: string | undefined;
    breakCompanyTz: string | undefined;
    breakStatus: number | undefined;
    loginUserTz: string | undefined;
    loginCompanyTz: string | undefined;
}

export class GetUserTimeDetailsIHandleError implements IGetUserTimeDetailsIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetUserTimeDetails | undefined;
    listOfEntities!: GetUserTimeDetails[] | undefined;

    constructor(data?: IGetUserTimeDetailsIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetUserTimeDetails.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetUserTimeDetails.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetUserTimeDetailsIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetUserTimeDetailsIHandleError>(data, _mappings, GetUserTimeDetailsIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetUserTimeDetailsIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetUserTimeDetails | undefined;
    listOfEntities: GetUserTimeDetails[] | undefined;
}

export class EmployeeEditDto implements IEmployeeEditDto {
    id!: number | undefined;
    name!: string;
    surname!: string;
    emailAddress!: string;
    userName!: string | undefined;
    phoneNumber!: string | undefined;
    roleId!: number | undefined;
    employeeId!: string | undefined;
    managerId!: number | undefined;
    teamId!: number | undefined;
    workSiteId!: number | undefined;
    workStatusId!: number | undefined;
    riskId!: number | undefined;
    employeeStateId!: number | undefined;
    isCanWorkFromHome!: boolean | undefined;
    isRequireCheckin!: boolean | undefined;
    riskName!: string | undefined;
    riskColor!: string | undefined;
    lastCheckedIn!: string | undefined;
    isCaseCreated!: boolean | undefined;
    assignedRoleNames!: string[] | undefined;

    constructor(data?: IEmployeeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.userName = _data["userName"];
            this.phoneNumber = _data["phoneNumber"];
            this.roleId = _data["roleId"];
            this.employeeId = _data["employeeId"];
            this.managerId = _data["managerId"];
            this.teamId = _data["teamId"];
            this.workSiteId = _data["workSiteId"];
            this.workStatusId = _data["workStatusId"];
            this.riskId = _data["riskId"];
            this.employeeStateId = _data["employeeStateId"];
            this.isCanWorkFromHome = _data["isCanWorkFromHome"];
            this.isRequireCheckin = _data["isRequireCheckin"];
            this.riskName = _data["riskName"];
            this.riskColor = _data["riskColor"];
            this.lastCheckedIn = _data["lastCheckedIn"];
            this.isCaseCreated = _data["isCaseCreated"];
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): EmployeeEditDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmployeeEditDto>(data, _mappings, EmployeeEditDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        data["roleId"] = this.roleId;
        data["employeeId"] = this.employeeId;
        data["managerId"] = this.managerId;
        data["teamId"] = this.teamId;
        data["workSiteId"] = this.workSiteId;
        data["workStatusId"] = this.workStatusId;
        data["riskId"] = this.riskId;
        data["employeeStateId"] = this.employeeStateId;
        data["isCanWorkFromHome"] = this.isCanWorkFromHome;
        data["isRequireCheckin"] = this.isRequireCheckin;
        data["riskName"] = this.riskName;
        data["riskColor"] = this.riskColor;
        data["lastCheckedIn"] = this.lastCheckedIn;
        data["isCaseCreated"] = this.isCaseCreated;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        return data;
    }
}

export interface IEmployeeEditDto {
    id: number | undefined;
    name: string;
    surname: string;
    emailAddress: string;
    userName: string | undefined;
    phoneNumber: string | undefined;
    roleId: number | undefined;
    employeeId: string | undefined;
    managerId: number | undefined;
    teamId: number | undefined;
    workSiteId: number | undefined;
    workStatusId: number | undefined;
    riskId: number | undefined;
    employeeStateId: number | undefined;
    isCanWorkFromHome: boolean | undefined;
    isRequireCheckin: boolean | undefined;
    riskName: string | undefined;
    riskColor: string | undefined;
    lastCheckedIn: string | undefined;
    isCaseCreated: boolean | undefined;
    assignedRoleNames: string[] | undefined;
}

export class InviteMemberEmail implements IInviteMemberEmail {
    emailAddress!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    userName!: string | undefined;
    passwordResetCode!: string | undefined;

    constructor(data?: IInviteMemberEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.userName = _data["userName"];
            this.passwordResetCode = _data["passwordResetCode"];
        }
    }

    static fromJS(data: any, _mappings?: any): InviteMemberEmail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InviteMemberEmail>(data, _mappings, InviteMemberEmail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["userName"] = this.userName;
        data["passwordResetCode"] = this.passwordResetCode;
        return data;
    }
}

export interface IInviteMemberEmail {
    emailAddress: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    userName: string | undefined;
    passwordResetCode: string | undefined;
}

export class InviteMember implements IInviteMember {
    invites!: InviteMemberEmail[] | undefined;
    categories!: CategoriesDto[] | undefined;
    teamIds!: number[] | undefined;
    managerId!: number | undefined;
    tenantId!: number | undefined;
    roleId!: number | undefined;
    workScheduleId!: number | undefined;
    currentUserId!: number | undefined;
    readonly execGetAllCmdText!: string | undefined;
    readonly execCrudCmdText!: string | undefined;

    constructor(data?: IInviteMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["invites"])) {
                this.invites = [] as any;
                for (let item of _data["invites"])
                    this.invites!.push(InviteMemberEmail.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategoriesDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["teamIds"])) {
                this.teamIds = [] as any;
                for (let item of _data["teamIds"])
                    this.teamIds!.push(item);
            }
            this.managerId = _data["managerId"];
            this.tenantId = _data["tenantId"];
            this.roleId = _data["roleId"];
            this.workScheduleId = _data["workScheduleId"];
            this.currentUserId = _data["currentUserId"];
            (this as any).execGetAllCmdText = _data["execGetAllCmdText"];
            (this as any).execCrudCmdText = _data["execCrudCmdText"];
        }
    }

    static fromJS(data: any, _mappings?: any): InviteMember | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InviteMember>(data, _mappings, InviteMember);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invites)) {
            data["invites"] = [];
            for (let item of this.invites)
                data["invites"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.teamIds)) {
            data["teamIds"] = [];
            for (let item of this.teamIds)
                data["teamIds"].push(item);
        }
        data["managerId"] = this.managerId;
        data["tenantId"] = this.tenantId;
        data["roleId"] = this.roleId;
        data["workScheduleId"] = this.workScheduleId;
        data["currentUserId"] = this.currentUserId;
        data["execGetAllCmdText"] = this.execGetAllCmdText;
        data["execCrudCmdText"] = this.execCrudCmdText;
        return data;
    }
}

export interface IInviteMember {
    invites: InviteMemberEmail[] | undefined;
    categories: CategoriesDto[] | undefined;
    teamIds: number[] | undefined;
    managerId: number | undefined;
    tenantId: number | undefined;
    roleId: number | undefined;
    workScheduleId: number | undefined;
    currentUserId: number | undefined;
    execGetAllCmdText: string | undefined;
    execCrudCmdText: string | undefined;
}

export class InviteMemberStatusOutput implements IInviteMemberStatusOutput {
    emailAddress!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    userName!: string | undefined;
    lastLoginTime!: string | undefined;
    tenancyName!: string | undefined;
    fullName!: string | undefined;
    passwordResetCode!: string | undefined;

    constructor(data?: IInviteMemberStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.userName = _data["userName"];
            this.lastLoginTime = _data["lastLoginTime"];
            this.tenancyName = _data["tenancyName"];
            this.fullName = _data["fullName"];
            this.passwordResetCode = _data["passwordResetCode"];
        }
    }

    static fromJS(data: any, _mappings?: any): InviteMemberStatusOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InviteMemberStatusOutput>(data, _mappings, InviteMemberStatusOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["userName"] = this.userName;
        data["lastLoginTime"] = this.lastLoginTime;
        data["tenancyName"] = this.tenancyName;
        data["fullName"] = this.fullName;
        data["passwordResetCode"] = this.passwordResetCode;
        return data;
    }
}

export interface IInviteMemberStatusOutput {
    emailAddress: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    userName: string | undefined;
    lastLoginTime: string | undefined;
    tenancyName: string | undefined;
    fullName: string | undefined;
    passwordResetCode: string | undefined;
}

export class InviteMemberStatusOutputListIHandleError implements IInviteMemberStatusOutputListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: InviteMemberStatusOutput[] | undefined;
    listOfEntities!: InviteMemberStatusOutput[][] | undefined;

    constructor(data?: IInviteMemberStatusOutputListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(InviteMemberStatusOutput.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): InviteMemberStatusOutputListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InviteMemberStatusOutputListIHandleError>(data, _mappings, InviteMemberStatusOutputListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IInviteMemberStatusOutputListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: InviteMemberStatusOutput[] | undefined;
    listOfEntities: InviteMemberStatusOutput[][] | undefined;
}

export class UserPresence implements IUserPresence {
    presenceId!: number | undefined;
    statusCode!: number | undefined;
    reason!: string | undefined;
    willRightBack!: string | undefined;
    wrbDateTime!: string | undefined;
    color!: string | undefined;

    constructor(data?: IUserPresence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.presenceId = _data["presenceId"];
            this.statusCode = _data["statusCode"];
            this.reason = _data["reason"];
            this.willRightBack = _data["willRightBack"];
            this.wrbDateTime = _data["wrbDateTime"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserPresence | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserPresence>(data, _mappings, UserPresence);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["presenceId"] = this.presenceId;
        data["statusCode"] = this.statusCode;
        data["reason"] = this.reason;
        data["willRightBack"] = this.willRightBack;
        data["wrbDateTime"] = this.wrbDateTime;
        data["color"] = this.color;
        return data;
    }
}

export interface IUserPresence {
    presenceId: number | undefined;
    statusCode: number | undefined;
    reason: string | undefined;
    willRightBack: string | undefined;
    wrbDateTime: string | undefined;
    color: string | undefined;
}

export class Int32GetUsersWithPresenceListValueTuple implements IInt32GetUsersWithPresenceListValueTuple {

    constructor(data?: IInt32GetUsersWithPresenceListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): Int32GetUsersWithPresenceListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32GetUsersWithPresenceListValueTuple>(data, _mappings, Int32GetUsersWithPresenceListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IInt32GetUsersWithPresenceListValueTuple {
}

export class Int32GetUsersWithPresenceListValueTupleIHandleError implements IInt32GetUsersWithPresenceListValueTupleIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: Int32GetUsersWithPresenceListValueTuple | undefined;
    listOfEntities!: Int32GetUsersWithPresenceListValueTuple[] | undefined;

    constructor(data?: IInt32GetUsersWithPresenceListValueTupleIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? Int32GetUsersWithPresenceListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(Int32GetUsersWithPresenceListValueTuple.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): Int32GetUsersWithPresenceListValueTupleIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Int32GetUsersWithPresenceListValueTupleIHandleError>(data, _mappings, Int32GetUsersWithPresenceListValueTupleIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInt32GetUsersWithPresenceListValueTupleIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: Int32GetUsersWithPresenceListValueTuple | undefined;
    listOfEntities: Int32GetUsersWithPresenceListValueTuple[] | undefined;
}

export class GetStartedUserDto implements IGetStartedUserDto {
    firstName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    timeZoneId!: number | undefined;
    companyName!: string | undefined;
    shiftStartTime!: string | undefined;
    companySize!: CompanySize | undefined;
    primaryTarget!: PrimaryTarget | undefined;
    mainProductService!: string | undefined;
    referredFrom!: string | undefined;

    constructor(data?: IGetStartedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.timeZoneId = _data["timeZoneId"];
            this.companyName = _data["companyName"];
            this.shiftStartTime = _data["shiftStartTime"];
            this.companySize = _data["companySize"];
            this.primaryTarget = _data["primaryTarget"];
            this.mainProductService = _data["mainProductService"];
            this.referredFrom = _data["referredFrom"];
        }
    }

    static fromJS(data: any, _mappings?: any): GetStartedUserDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetStartedUserDto>(data, _mappings, GetStartedUserDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["timeZoneId"] = this.timeZoneId;
        data["companyName"] = this.companyName;
        data["shiftStartTime"] = this.shiftStartTime;
        data["companySize"] = this.companySize;
        data["primaryTarget"] = this.primaryTarget;
        data["mainProductService"] = this.mainProductService;
        data["referredFrom"] = this.referredFrom;
        return data;
    }
}

export interface IGetStartedUserDto {
    firstName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    timeZoneId: number | undefined;
    companyName: string | undefined;
    shiftStartTime: string | undefined;
    companySize: CompanySize | undefined;
    primaryTarget: PrimaryTarget | undefined;
    mainProductService: string | undefined;
    referredFrom: string | undefined;
}

export class GetStartedUserDtoIHandleError implements IGetStartedUserDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: GetStartedUserDto | undefined;
    listOfEntities!: GetStartedUserDto[] | undefined;

    constructor(data?: IGetStartedUserDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? GetStartedUserDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(GetStartedUserDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetStartedUserDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetStartedUserDtoIHandleError>(data, _mappings, GetStartedUserDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetStartedUserDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: GetStartedUserDto | undefined;
    listOfEntities: GetStartedUserDto[] | undefined;
}

export class TenantIndustries implements ITenantIndustries {
    id!: number | undefined;
    industry!: string | undefined;
    folderStructure!: string | undefined;

    constructor(data?: ITenantIndustries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.industry = _data["industry"];
            this.folderStructure = _data["folderStructure"];
        }
    }

    static fromJS(data: any, _mappings?: any): TenantIndustries | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantIndustries>(data, _mappings, TenantIndustries);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["industry"] = this.industry;
        data["folderStructure"] = this.folderStructure;
        return data;
    }
}

export interface ITenantIndustries {
    id: number | undefined;
    industry: string | undefined;
    folderStructure: string | undefined;
}

export class TenantIndustriesListIHandleError implements ITenantIndustriesListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: TenantIndustries[] | undefined;
    listOfEntities!: TenantIndustries[][] | undefined;

    constructor(data?: ITenantIndustriesListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(TenantIndustries.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TenantIndustriesListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TenantIndustriesListIHandleError>(data, _mappings, TenantIndustriesListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface ITenantIndustriesListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: TenantIndustries[] | undefined;
    listOfEntities: TenantIndustries[][] | undefined;
}

export class CheckinUserOutputIHandleError implements ICheckinUserOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CheckinUserOutput | undefined;
    listOfEntities!: CheckinUserOutput[] | undefined;

    constructor(data?: ICheckinUserOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CheckinUserOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CheckinUserOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CheckinUserOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckinUserOutputIHandleError>(data, _mappings, CheckinUserOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICheckinUserOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CheckinUserOutput | undefined;
    listOfEntities: CheckinUserOutput[] | undefined;
}

export enum CheckinType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class CheckinUserStageOutput implements ICheckinUserStageOutput {
    userId!: number | undefined;
    userName!: string | undefined;
    tenantId!: number | undefined;
    thoughtOfTheDay!: string | undefined;
    writtenBy!: string | undefined;
    moodId!: number | undefined;
    moodName!: string | undefined;
    moodIcon!: string | undefined;
    moodClass!: string | undefined;
    checkinStage!: CheckinUserStage | undefined;
    activeOn!: string | undefined;
    shiftEndDateTime!: string | undefined;
    utcShiftEndDateTime!: string | undefined;
    checkinType!: CheckinType | undefined;
    announcement!: string | undefined;
    subject!: string | undefined;

    constructor(data?: ICheckinUserStageOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.thoughtOfTheDay = _data["thoughtOfTheDay"];
            this.writtenBy = _data["writtenBy"];
            this.moodId = _data["moodId"];
            this.moodName = _data["moodName"];
            this.moodIcon = _data["moodIcon"];
            this.moodClass = _data["moodClass"];
            this.checkinStage = _data["checkinStage"];
            this.activeOn = _data["activeOn"];
            this.shiftEndDateTime = _data["shiftEndDateTime"];
            this.utcShiftEndDateTime = _data["utcShiftEndDateTime"];
            this.checkinType = _data["checkinType"];
            this.announcement = _data["announcement"];
            this.subject = _data["subject"];
        }
    }

    static fromJS(data: any, _mappings?: any): CheckinUserStageOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckinUserStageOutput>(data, _mappings, CheckinUserStageOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["thoughtOfTheDay"] = this.thoughtOfTheDay;
        data["writtenBy"] = this.writtenBy;
        data["moodId"] = this.moodId;
        data["moodName"] = this.moodName;
        data["moodIcon"] = this.moodIcon;
        data["moodClass"] = this.moodClass;
        data["checkinStage"] = this.checkinStage;
        data["activeOn"] = this.activeOn;
        data["shiftEndDateTime"] = this.shiftEndDateTime;
        data["utcShiftEndDateTime"] = this.utcShiftEndDateTime;
        data["checkinType"] = this.checkinType;
        data["announcement"] = this.announcement;
        data["subject"] = this.subject;
        return data;
    }
}

export interface ICheckinUserStageOutput {
    userId: number | undefined;
    userName: string | undefined;
    tenantId: number | undefined;
    thoughtOfTheDay: string | undefined;
    writtenBy: string | undefined;
    moodId: number | undefined;
    moodName: string | undefined;
    moodIcon: string | undefined;
    moodClass: string | undefined;
    checkinStage: CheckinUserStage | undefined;
    activeOn: string | undefined;
    shiftEndDateTime: string | undefined;
    utcShiftEndDateTime: string | undefined;
    checkinType: CheckinType | undefined;
    announcement: string | undefined;
    subject: string | undefined;
}

export class CheckinUserStageOutputIHandleError implements ICheckinUserStageOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: CheckinUserStageOutput | undefined;
    listOfEntities!: CheckinUserStageOutput[] | undefined;

    constructor(data?: ICheckinUserStageOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? CheckinUserStageOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(CheckinUserStageOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CheckinUserStageOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckinUserStageOutputIHandleError>(data, _mappings, CheckinUserStageOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICheckinUserStageOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: CheckinUserStageOutput | undefined;
    listOfEntities: CheckinUserStageOutput[] | undefined;
}

export class TimeRangeList implements ITimeRangeList {
    index!: number | undefined;
    timeStamp!: string | undefined;
    endTime!: string | undefined;

    constructor(data?: ITimeRangeList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.index = _data["index"];
            this.timeStamp = _data["timeStamp"];
            this.endTime = _data["endTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): TimeRangeList | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TimeRangeList>(data, _mappings, TimeRangeList);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["timeStamp"] = this.timeStamp;
        data["endTime"] = this.endTime;
        return data;
    }
}

export interface ITimeRangeList {
    index: number | undefined;
    timeStamp: string | undefined;
    endTime: string | undefined;
}

export class UserBreakTimeOutput implements IUserBreakTimeOutput {
    userId!: number | undefined;
    userName!: string | undefined;
    tenantId!: number | undefined;
    breakStartTime!: string | undefined;
    breakEndTime!: string | undefined;
    breakDurationAsString!: string | undefined;
    duration!: number | undefined;
    startTimeDuration!: number | undefined;
    userTimeZoneCurrentDateTime!: string | undefined;
    shiftStartDateTime!: string | undefined;
    shiftEndDateTime!: string | undefined;
    rangeStartDt!: string | undefined;
    rangeEndDt!: string | undefined;
    timeRangeList!: TimeRangeList[] | undefined;
    sortOrder!: number | undefined;
    id!: number | undefined;
    isDefault!: boolean | undefined;
    breakMeetingId!: string | undefined;
    startMeetingDate!: string | undefined;
    endMeetingDate!: string | undefined;
    startMeetingTime!: string | undefined;
    endMeetingTime!: string | undefined;
    currentBreakLeft!: number | undefined;
    isOldBreakNow!: boolean | undefined;
    isPromoVisited!: boolean | undefined;
    isProjectPromoVisited!: boolean | undefined;

    constructor(data?: IUserBreakTimeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.breakStartTime = _data["breakStartTime"];
            this.breakEndTime = _data["breakEndTime"];
            this.breakDurationAsString = _data["breakDurationAsString"];
            this.duration = _data["duration"];
            this.startTimeDuration = _data["startTimeDuration"];
            this.userTimeZoneCurrentDateTime = _data["userTimeZoneCurrentDateTime"];
            this.shiftStartDateTime = _data["shiftStartDateTime"];
            this.shiftEndDateTime = _data["shiftEndDateTime"];
            this.rangeStartDt = _data["rangeStartDt"];
            this.rangeEndDt = _data["rangeEndDt"];
            if (Array.isArray(_data["timeRangeList"])) {
                this.timeRangeList = [] as any;
                for (let item of _data["timeRangeList"])
                    this.timeRangeList!.push(TimeRangeList.fromJS(item, _mappings));
            }
            this.sortOrder = _data["sortOrder"];
            this.id = _data["id"];
            this.isDefault = _data["isDefault"];
            this.breakMeetingId = _data["breakMeetingId"];
            this.startMeetingDate = _data["startMeetingDate"];
            this.endMeetingDate = _data["endMeetingDate"];
            this.startMeetingTime = _data["startMeetingTime"];
            this.endMeetingTime = _data["endMeetingTime"];
            this.currentBreakLeft = _data["currentBreakLeft"];
            this.isOldBreakNow = _data["isOldBreakNow"];
            this.isPromoVisited = _data["isPromoVisited"];
            this.isProjectPromoVisited = _data["isProjectPromoVisited"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserBreakTimeOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserBreakTimeOutput>(data, _mappings, UserBreakTimeOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["breakStartTime"] = this.breakStartTime;
        data["breakEndTime"] = this.breakEndTime;
        data["breakDurationAsString"] = this.breakDurationAsString;
        data["duration"] = this.duration;
        data["startTimeDuration"] = this.startTimeDuration;
        data["userTimeZoneCurrentDateTime"] = this.userTimeZoneCurrentDateTime;
        data["shiftStartDateTime"] = this.shiftStartDateTime;
        data["shiftEndDateTime"] = this.shiftEndDateTime;
        data["rangeStartDt"] = this.rangeStartDt;
        data["rangeEndDt"] = this.rangeEndDt;
        if (Array.isArray(this.timeRangeList)) {
            data["timeRangeList"] = [];
            for (let item of this.timeRangeList)
                data["timeRangeList"].push(item ? item.toJSON() : undefined as any);
        }
        data["sortOrder"] = this.sortOrder;
        data["id"] = this.id;
        data["isDefault"] = this.isDefault;
        data["breakMeetingId"] = this.breakMeetingId;
        data["startMeetingDate"] = this.startMeetingDate;
        data["endMeetingDate"] = this.endMeetingDate;
        data["startMeetingTime"] = this.startMeetingTime;
        data["endMeetingTime"] = this.endMeetingTime;
        data["currentBreakLeft"] = this.currentBreakLeft;
        data["isOldBreakNow"] = this.isOldBreakNow;
        data["isPromoVisited"] = this.isPromoVisited;
        data["isProjectPromoVisited"] = this.isProjectPromoVisited;
        return data;
    }
}

export interface IUserBreakTimeOutput {
    userId: number | undefined;
    userName: string | undefined;
    tenantId: number | undefined;
    breakStartTime: string | undefined;
    breakEndTime: string | undefined;
    breakDurationAsString: string | undefined;
    duration: number | undefined;
    startTimeDuration: number | undefined;
    userTimeZoneCurrentDateTime: string | undefined;
    shiftStartDateTime: string | undefined;
    shiftEndDateTime: string | undefined;
    rangeStartDt: string | undefined;
    rangeEndDt: string | undefined;
    timeRangeList: TimeRangeList[] | undefined;
    sortOrder: number | undefined;
    id: number | undefined;
    isDefault: boolean | undefined;
    breakMeetingId: string | undefined;
    startMeetingDate: string | undefined;
    endMeetingDate: string | undefined;
    startMeetingTime: string | undefined;
    endMeetingTime: string | undefined;
    currentBreakLeft: number | undefined;
    isOldBreakNow: boolean | undefined;
    isPromoVisited: boolean | undefined;
    isProjectPromoVisited: boolean | undefined;
}

export class UserBreakTimeOutputIHandleError implements IUserBreakTimeOutputIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserBreakTimeOutput | undefined;
    listOfEntities!: UserBreakTimeOutput[] | undefined;

    constructor(data?: IUserBreakTimeOutputIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserBreakTimeOutput.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserBreakTimeOutput.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserBreakTimeOutputIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserBreakTimeOutputIHandleError>(data, _mappings, UserBreakTimeOutputIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserBreakTimeOutputIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserBreakTimeOutput | undefined;
    listOfEntities: UserBreakTimeOutput[] | undefined;
}

export class UserMeetingsIHandleError implements IUserMeetingsIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserMeetings | undefined;
    listOfEntities!: UserMeetings[] | undefined;

    constructor(data?: IUserMeetingsIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserMeetings.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserMeetings.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserMeetingsIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserMeetingsIHandleError>(data, _mappings, UserMeetingsIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserMeetingsIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserMeetings | undefined;
    listOfEntities: UserMeetings[] | undefined;
}

export class CurrentUserBreakInput implements ICurrentUserBreakInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    timeStamp!: string | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    id!: number | undefined;
    isDefault!: boolean | undefined;
    breakMeetingId!: string | undefined;
    isAddToMyDay!: boolean | undefined;

    constructor(data?: ICurrentUserBreakInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.timeStamp = _data["timeStamp"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.id = _data["id"];
            this.isDefault = _data["isDefault"];
            this.breakMeetingId = _data["breakMeetingId"];
            this.isAddToMyDay = _data["isAddToMyDay"];
        }
    }

    static fromJS(data: any, _mappings?: any): CurrentUserBreakInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CurrentUserBreakInput>(data, _mappings, CurrentUserBreakInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["timeStamp"] = this.timeStamp;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["id"] = this.id;
        data["isDefault"] = this.isDefault;
        data["breakMeetingId"] = this.breakMeetingId;
        data["isAddToMyDay"] = this.isAddToMyDay;
        return data;
    }
}

export interface ICurrentUserBreakInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    timeStamp: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    id: number | undefined;
    isDefault: boolean | undefined;
    breakMeetingId: string | undefined;
    isAddToMyDay: boolean | undefined;
}

export class UserBreakDto implements IUserBreakDto {
    id!: number | undefined;
    isActive!: boolean | undefined;

    constructor(data?: IUserBreakDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserBreakDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserBreakDto>(data, _mappings, UserBreakDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUserBreakDto {
    id: number | undefined;
    isActive: boolean | undefined;
}

export class CheckInOutUserInput implements ICheckInOutUserInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    checkinId!: number | undefined;
    checkInOutType!: InOutType | undefined;
    isAutoCheckoutNotified!: boolean | undefined;
    comment!: string | undefined;
    autoCheckOutTime!: string | undefined;
    autoCheckOutInterval!: number | undefined;

    constructor(data?: ICheckInOutUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.checkinId = _data["checkinId"];
            this.checkInOutType = _data["checkInOutType"];
            this.isAutoCheckoutNotified = _data["isAutoCheckoutNotified"];
            this.comment = _data["comment"];
            this.autoCheckOutTime = _data["autoCheckOutTime"];
            this.autoCheckOutInterval = _data["autoCheckOutInterval"];
        }
    }

    static fromJS(data: any, _mappings?: any): CheckInOutUserInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CheckInOutUserInput>(data, _mappings, CheckInOutUserInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["checkinId"] = this.checkinId;
        data["checkInOutType"] = this.checkInOutType;
        data["isAutoCheckoutNotified"] = this.isAutoCheckoutNotified;
        data["comment"] = this.comment;
        data["autoCheckOutTime"] = this.autoCheckOutTime;
        data["autoCheckOutInterval"] = this.autoCheckOutInterval;
        return data;
    }
}

export interface ICheckInOutUserInput {
    userId: number | undefined;
    tenantId: number | undefined;
    checkinId: number | undefined;
    checkInOutType: InOutType | undefined;
    isAutoCheckoutNotified: boolean | undefined;
    comment: string | undefined;
    autoCheckOutTime: string | undefined;
    autoCheckOutInterval: number | undefined;
}

export class LicenseSeatsCountDto implements ILicenseSeatsCountDto {
    usedLicenseSeats!: number | undefined;
    totalLicensePurchase!: number | undefined;

    constructor(data?: ILicenseSeatsCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.usedLicenseSeats = _data["usedLicenseSeats"];
            this.totalLicensePurchase = _data["totalLicensePurchase"];
        }
    }

    static fromJS(data: any, _mappings?: any): LicenseSeatsCountDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LicenseSeatsCountDto>(data, _mappings, LicenseSeatsCountDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usedLicenseSeats"] = this.usedLicenseSeats;
        data["totalLicensePurchase"] = this.totalLicensePurchase;
        return data;
    }
}

export interface ILicenseSeatsCountDto {
    usedLicenseSeats: number | undefined;
    totalLicensePurchase: number | undefined;
}

export class LicenseSeatsCountDtoIHandleError implements ILicenseSeatsCountDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: LicenseSeatsCountDto | undefined;
    listOfEntities!: LicenseSeatsCountDto[] | undefined;

    constructor(data?: ILicenseSeatsCountDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? LicenseSeatsCountDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(LicenseSeatsCountDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LicenseSeatsCountDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LicenseSeatsCountDtoIHandleError>(data, _mappings, LicenseSeatsCountDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILicenseSeatsCountDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: LicenseSeatsCountDto | undefined;
    listOfEntities: LicenseSeatsCountDto[] | undefined;
}

export class UserMoodDto implements IUserMoodDto {
    id!: number | undefined;
    moodId!: number | undefined;
    comment!: string | undefined;

    constructor(data?: IUserMoodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moodId = _data["moodId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserMoodDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserMoodDto>(data, _mappings, UserMoodDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moodId"] = this.moodId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUserMoodDto {
    id: number | undefined;
    moodId: number | undefined;
    comment: string | undefined;
}

export enum Favourite {
    _0 = 0,
}

export class UserFavouritesDto implements IUserFavouritesDto {
    id!: number | undefined;
    userId!: number | undefined;
    favouriteType!: Favourite | undefined;
    isFavourite!: boolean | undefined;

    constructor(data?: IUserFavouritesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.favouriteType = _data["favouriteType"];
            this.isFavourite = _data["isFavourite"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserFavouritesDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserFavouritesDto>(data, _mappings, UserFavouritesDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["favouriteType"] = this.favouriteType;
        data["isFavourite"] = this.isFavourite;
        return data;
    }
}

export interface IUserFavouritesDto {
    id: number | undefined;
    userId: number | undefined;
    favouriteType: Favourite | undefined;
    isFavourite: boolean | undefined;
}

export class UserSummaryOutputDto implements IUserSummaryOutputDto {
    checkinId!: number | undefined;
    productivityId!: number | undefined;
    rating!: number | undefined;
    personalNote!: string | undefined;
    checkinTime!: string | undefined;
    checkoutTime!: string | undefined;
    hoursWorked!: number | undefined;
    plannedTasks!: number | undefined;
    completedTasks!: number | undefined;
    allTasks!: number | undefined;
    totalMeetings!: number | undefined;
    hoursMeetings!: string | undefined;
    meetingPercentage!: string | undefined;
    taskCompletedPercentage!: number | undefined;
    percentTaskProgress!: number | undefined;
    workChallenges!: string | undefined;
    futureNotes!: string | undefined;
    byMe!: number | undefined;
    withTeam!: number | undefined;
    currentTimeAsUserTz!: string | undefined;
    onAverageCompleted!: number | undefined;
    youCompletedMessage!: string | undefined;
    completedTaskTrend!: number | undefined;

    constructor(data?: IUserSummaryOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.checkinId = _data["checkinId"];
            this.productivityId = _data["productivityId"];
            this.rating = _data["rating"];
            this.personalNote = _data["personalNote"];
            this.checkinTime = _data["checkinTime"];
            this.checkoutTime = _data["checkoutTime"];
            this.hoursWorked = _data["hoursWorked"];
            this.plannedTasks = _data["plannedTasks"];
            this.completedTasks = _data["completedTasks"];
            this.allTasks = _data["allTasks"];
            this.totalMeetings = _data["totalMeetings"];
            this.hoursMeetings = _data["hoursMeetings"];
            this.meetingPercentage = _data["meetingPercentage"];
            this.taskCompletedPercentage = _data["taskCompletedPercentage"];
            this.percentTaskProgress = _data["percentTaskProgress"];
            this.workChallenges = _data["workChallenges"];
            this.futureNotes = _data["futureNotes"];
            this.byMe = _data["byMe"];
            this.withTeam = _data["withTeam"];
            this.currentTimeAsUserTz = _data["currentTimeAsUserTz"];
            this.onAverageCompleted = _data["onAverageCompleted"];
            this.youCompletedMessage = _data["youCompletedMessage"];
            this.completedTaskTrend = _data["completedTaskTrend"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserSummaryOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserSummaryOutputDto>(data, _mappings, UserSummaryOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkinId"] = this.checkinId;
        data["productivityId"] = this.productivityId;
        data["rating"] = this.rating;
        data["personalNote"] = this.personalNote;
        data["checkinTime"] = this.checkinTime;
        data["checkoutTime"] = this.checkoutTime;
        data["hoursWorked"] = this.hoursWorked;
        data["plannedTasks"] = this.plannedTasks;
        data["completedTasks"] = this.completedTasks;
        data["allTasks"] = this.allTasks;
        data["totalMeetings"] = this.totalMeetings;
        data["hoursMeetings"] = this.hoursMeetings;
        data["meetingPercentage"] = this.meetingPercentage;
        data["taskCompletedPercentage"] = this.taskCompletedPercentage;
        data["percentTaskProgress"] = this.percentTaskProgress;
        data["workChallenges"] = this.workChallenges;
        data["futureNotes"] = this.futureNotes;
        data["byMe"] = this.byMe;
        data["withTeam"] = this.withTeam;
        data["currentTimeAsUserTz"] = this.currentTimeAsUserTz;
        data["onAverageCompleted"] = this.onAverageCompleted;
        data["youCompletedMessage"] = this.youCompletedMessage;
        data["completedTaskTrend"] = this.completedTaskTrend;
        return data;
    }
}

export interface IUserSummaryOutputDto {
    checkinId: number | undefined;
    productivityId: number | undefined;
    rating: number | undefined;
    personalNote: string | undefined;
    checkinTime: string | undefined;
    checkoutTime: string | undefined;
    hoursWorked: number | undefined;
    plannedTasks: number | undefined;
    completedTasks: number | undefined;
    allTasks: number | undefined;
    totalMeetings: number | undefined;
    hoursMeetings: string | undefined;
    meetingPercentage: string | undefined;
    taskCompletedPercentage: number | undefined;
    percentTaskProgress: number | undefined;
    workChallenges: string | undefined;
    futureNotes: string | undefined;
    byMe: number | undefined;
    withTeam: number | undefined;
    currentTimeAsUserTz: string | undefined;
    onAverageCompleted: number | undefined;
    youCompletedMessage: string | undefined;
    completedTaskTrend: number | undefined;
}

export class UserSummaryOutputDtoIHandleError implements IUserSummaryOutputDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserSummaryOutputDto | undefined;
    listOfEntities!: UserSummaryOutputDto[] | undefined;

    constructor(data?: IUserSummaryOutputDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserSummaryOutputDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserSummaryOutputDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserSummaryOutputDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserSummaryOutputDtoIHandleError>(data, _mappings, UserSummaryOutputDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserSummaryOutputDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserSummaryOutputDto | undefined;
    listOfEntities: UserSummaryOutputDto[] | undefined;
}

export class UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListValueTuple implements IUserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListValueTuple {

    constructor(data?: IUserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListValueTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
    }

    static fromJS(data: any, _mappings?: any): UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListValueTuple | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListValueTuple>(data, _mappings, UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListValueTuple);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListValueTuple {
}

export class UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListIHandleError implements IUserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    message_Info!: string | undefined;
    responseData!: UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListValueTuple | undefined;

    constructor(data?: IUserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListValueTuple.fromJS(_data["responseData"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListIHandleError>(data, _mappings, UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    message_Info: string | undefined;
    responseData: UserCheckInDetailDtoCheckinUserStageOutputHolidaysAndBirthdaysDtoListValueTuple | undefined;
}

export class UserProductivityDto implements IUserProductivityDto {
    currentUserId!: number | undefined;
    productivityId!: number | undefined;
    productivityRate!: number | undefined;
    personalNote!: string | undefined;
    workChallenges!: string | undefined;
    futureNotes!: string | undefined;

    constructor(data?: IUserProductivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.currentUserId = _data["currentUserId"];
            this.productivityId = _data["productivityId"];
            this.productivityRate = _data["productivityRate"];
            this.personalNote = _data["personalNote"];
            this.workChallenges = _data["workChallenges"];
            this.futureNotes = _data["futureNotes"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserProductivityDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserProductivityDto>(data, _mappings, UserProductivityDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentUserId"] = this.currentUserId;
        data["productivityId"] = this.productivityId;
        data["productivityRate"] = this.productivityRate;
        data["personalNote"] = this.personalNote;
        data["workChallenges"] = this.workChallenges;
        data["futureNotes"] = this.futureNotes;
        return data;
    }
}

export interface IUserProductivityDto {
    currentUserId: number | undefined;
    productivityId: number | undefined;
    productivityRate: number | undefined;
    personalNote: string | undefined;
    workChallenges: string | undefined;
    futureNotes: string | undefined;
}

export class UserProductivityDtoIHandleError implements IUserProductivityDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserProductivityDto | undefined;
    listOfEntities!: UserProductivityDto[] | undefined;

    constructor(data?: IUserProductivityDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserProductivityDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserProductivityDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserProductivityDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserProductivityDtoIHandleError>(data, _mappings, UserProductivityDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserProductivityDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserProductivityDto | undefined;
    listOfEntities: UserProductivityDto[] | undefined;
}

export enum ExportType {
    _1 = 1,
    _2 = 2,
}

export class UserPlannerCategoryDto implements IUserPlannerCategoryDto {
    plannerCategoryId!: number | undefined;
    plannerCategoryName!: string | undefined;
    categoryId!: number | undefined;
    isShow!: boolean | undefined;
    showReset!: boolean | undefined;

    constructor(data?: IUserPlannerCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.plannerCategoryId = _data["plannerCategoryId"];
            this.plannerCategoryName = _data["plannerCategoryName"];
            this.categoryId = _data["categoryId"];
            this.isShow = _data["isShow"];
            this.showReset = _data["showReset"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserPlannerCategoryDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserPlannerCategoryDto>(data, _mappings, UserPlannerCategoryDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannerCategoryId"] = this.plannerCategoryId;
        data["plannerCategoryName"] = this.plannerCategoryName;
        data["categoryId"] = this.categoryId;
        data["isShow"] = this.isShow;
        data["showReset"] = this.showReset;
        return data;
    }
}

export interface IUserPlannerCategoryDto {
    plannerCategoryId: number | undefined;
    plannerCategoryName: string | undefined;
    categoryId: number | undefined;
    isShow: boolean | undefined;
    showReset: boolean | undefined;
}

export class UserPlannerCategoryDtoListIHandleError implements IUserPlannerCategoryDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserPlannerCategoryDto[] | undefined;
    listOfEntities!: UserPlannerCategoryDto[][] | undefined;

    constructor(data?: IUserPlannerCategoryDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(UserPlannerCategoryDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserPlannerCategoryDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserPlannerCategoryDtoListIHandleError>(data, _mappings, UserPlannerCategoryDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IUserPlannerCategoryDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserPlannerCategoryDto[] | undefined;
    listOfEntities: UserPlannerCategoryDto[][] | undefined;
}

export class CreateUpdateUserPlannerCategoryInputDto implements ICreateUpdateUserPlannerCategoryInputDto {
    plannerCategoryId!: number | undefined;
    showInFuture!: boolean | undefined;

    constructor(data?: ICreateUpdateUserPlannerCategoryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.plannerCategoryId = _data["plannerCategoryId"];
            this.showInFuture = _data["showInFuture"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateUpdateUserPlannerCategoryInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateUpdateUserPlannerCategoryInputDto>(data, _mappings, CreateUpdateUserPlannerCategoryInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannerCategoryId"] = this.plannerCategoryId;
        data["showInFuture"] = this.showInFuture;
        return data;
    }
}

export interface ICreateUpdateUserPlannerCategoryInputDto {
    plannerCategoryId: number | undefined;
    showInFuture: boolean | undefined;
}

export class UserEmailSettingsDto implements IUserEmailSettingsDto {
    id!: number | undefined;
    isFromMyContactsOnly!: boolean | undefined;
    isFromMyManagerOnly!: boolean | undefined;
    isFromSpecificSenders!: boolean | undefined;
    useAi!: boolean | undefined;
    senders!: string | undefined;
    keyWords!: string | undefined;

    constructor(data?: IUserEmailSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isFromMyContactsOnly = _data["isFromMyContactsOnly"];
            this.isFromMyManagerOnly = _data["isFromMyManagerOnly"];
            this.isFromSpecificSenders = _data["isFromSpecificSenders"];
            this.useAi = _data["useAi"];
            this.senders = _data["senders"];
            this.keyWords = _data["keyWords"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserEmailSettingsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserEmailSettingsDto>(data, _mappings, UserEmailSettingsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isFromMyContactsOnly"] = this.isFromMyContactsOnly;
        data["isFromMyManagerOnly"] = this.isFromMyManagerOnly;
        data["isFromSpecificSenders"] = this.isFromSpecificSenders;
        data["useAi"] = this.useAi;
        data["senders"] = this.senders;
        data["keyWords"] = this.keyWords;
        return data;
    }
}

export interface IUserEmailSettingsDto {
    id: number | undefined;
    isFromMyContactsOnly: boolean | undefined;
    isFromMyManagerOnly: boolean | undefined;
    isFromSpecificSenders: boolean | undefined;
    useAi: boolean | undefined;
    senders: string | undefined;
    keyWords: string | undefined;
}

export class UserSettingsDto implements IUserSettingsDto {
    id!: number | undefined;
    userId!: number | undefined;
    planMyDayManually!: boolean | undefined;
    autoMoveDueTodaysTaskToMyDay!: boolean | undefined;
    autoMoveOverDueTodaysTaskToMyDay!: boolean | undefined;
    showAiSuggestedBreak!: boolean | undefined;
    showBreak!: boolean | undefined;
    showUnreadEmails!: boolean | undefined;
    showRecentFiles!: boolean | undefined;
    showRecentNotes!: boolean | undefined;
    moveDueTodaysTaskToMyDayManually!: boolean | undefined;
    moveOverDueTodaysTaskToMyDayManually!: boolean | undefined;
    useAiToPlanMyDay!: boolean | undefined;
    showCatchUnreadEmails!: boolean | undefined;
    showDonePlanning!: boolean | undefined;
    doSmartPrioritization!: boolean | undefined;
    showImportantEmails!: boolean | undefined;
    donePlanningCategoryId!: number | undefined;
    catchUnreadEmailsCategoryId!: number | undefined;
    userEmailSettingsAsJson!: string | undefined;
    userEmailSettings!: UserEmailSettingsDto | undefined;

    constructor(data?: IUserSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.planMyDayManually = _data["planMyDayManually"];
            this.autoMoveDueTodaysTaskToMyDay = _data["autoMoveDueTodaysTaskToMyDay"];
            this.autoMoveOverDueTodaysTaskToMyDay = _data["autoMoveOverDueTodaysTaskToMyDay"];
            this.showAiSuggestedBreak = _data["showAiSuggestedBreak"];
            this.showBreak = _data["showBreak"];
            this.showUnreadEmails = _data["showUnreadEmails"];
            this.showRecentFiles = _data["showRecentFiles"];
            this.showRecentNotes = _data["showRecentNotes"];
            this.moveDueTodaysTaskToMyDayManually = _data["moveDueTodaysTaskToMyDayManually"];
            this.moveOverDueTodaysTaskToMyDayManually = _data["moveOverDueTodaysTaskToMyDayManually"];
            this.useAiToPlanMyDay = _data["useAiToPlanMyDay"];
            this.showCatchUnreadEmails = _data["showCatchUnreadEmails"];
            this.showDonePlanning = _data["showDonePlanning"];
            this.doSmartPrioritization = _data["doSmartPrioritization"];
            this.showImportantEmails = _data["showImportantEmails"];
            this.donePlanningCategoryId = _data["donePlanningCategoryId"];
            this.catchUnreadEmailsCategoryId = _data["catchUnreadEmailsCategoryId"];
            this.userEmailSettingsAsJson = _data["userEmailSettingsAsJson"];
            this.userEmailSettings = _data["userEmailSettings"] ? UserEmailSettingsDto.fromJS(_data["userEmailSettings"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): UserSettingsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserSettingsDto>(data, _mappings, UserSettingsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["planMyDayManually"] = this.planMyDayManually;
        data["autoMoveDueTodaysTaskToMyDay"] = this.autoMoveDueTodaysTaskToMyDay;
        data["autoMoveOverDueTodaysTaskToMyDay"] = this.autoMoveOverDueTodaysTaskToMyDay;
        data["showAiSuggestedBreak"] = this.showAiSuggestedBreak;
        data["showBreak"] = this.showBreak;
        data["showUnreadEmails"] = this.showUnreadEmails;
        data["showRecentFiles"] = this.showRecentFiles;
        data["showRecentNotes"] = this.showRecentNotes;
        data["moveDueTodaysTaskToMyDayManually"] = this.moveDueTodaysTaskToMyDayManually;
        data["moveOverDueTodaysTaskToMyDayManually"] = this.moveOverDueTodaysTaskToMyDayManually;
        data["useAiToPlanMyDay"] = this.useAiToPlanMyDay;
        data["showCatchUnreadEmails"] = this.showCatchUnreadEmails;
        data["showDonePlanning"] = this.showDonePlanning;
        data["doSmartPrioritization"] = this.doSmartPrioritization;
        data["showImportantEmails"] = this.showImportantEmails;
        data["donePlanningCategoryId"] = this.donePlanningCategoryId;
        data["catchUnreadEmailsCategoryId"] = this.catchUnreadEmailsCategoryId;
        data["userEmailSettingsAsJson"] = this.userEmailSettingsAsJson;
        data["userEmailSettings"] = this.userEmailSettings ? this.userEmailSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserSettingsDto {
    id: number | undefined;
    userId: number | undefined;
    planMyDayManually: boolean | undefined;
    autoMoveDueTodaysTaskToMyDay: boolean | undefined;
    autoMoveOverDueTodaysTaskToMyDay: boolean | undefined;
    showAiSuggestedBreak: boolean | undefined;
    showBreak: boolean | undefined;
    showUnreadEmails: boolean | undefined;
    showRecentFiles: boolean | undefined;
    showRecentNotes: boolean | undefined;
    moveDueTodaysTaskToMyDayManually: boolean | undefined;
    moveOverDueTodaysTaskToMyDayManually: boolean | undefined;
    useAiToPlanMyDay: boolean | undefined;
    showCatchUnreadEmails: boolean | undefined;
    showDonePlanning: boolean | undefined;
    doSmartPrioritization: boolean | undefined;
    showImportantEmails: boolean | undefined;
    donePlanningCategoryId: number | undefined;
    catchUnreadEmailsCategoryId: number | undefined;
    userEmailSettingsAsJson: string | undefined;
    userEmailSettings: UserEmailSettingsDto | undefined;
}

export class UserSettingsDtoIHandleError implements IUserSettingsDtoIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserSettingsDto | undefined;
    listOfEntities!: UserSettingsDto[] | undefined;

    constructor(data?: IUserSettingsDtoIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            this.responseData = _data["responseData"] ? UserSettingsDto.fromJS(_data["responseData"], _mappings) : undefined as any;
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(UserSettingsDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserSettingsDtoIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserSettingsDtoIHandleError>(data, _mappings, UserSettingsDtoIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : undefined as any;
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserSettingsDtoIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserSettingsDto | undefined;
    listOfEntities: UserSettingsDto[] | undefined;
}

export class UserRecentNotesOutputDto implements IUserRecentNotesOutputDto {
    noteId!: number | undefined;
    note!: string | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    isCheckOutNote!: boolean | undefined;
    lastModificationTimeAsString!: string | undefined;
    lastModificationTime!: string | undefined;
    contactTypeId!: number | undefined;
    contactType!: string | undefined;
    companyId!: number | undefined;
    companyName!: string | undefined;

    constructor(data?: IUserRecentNotesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.noteId = _data["noteId"];
            this.note = _data["note"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.isCheckOutNote = _data["isCheckOutNote"];
            this.lastModificationTimeAsString = _data["lastModificationTimeAsString"];
            this.lastModificationTime = _data["lastModificationTime"];
            this.contactTypeId = _data["contactTypeId"];
            this.contactType = _data["contactType"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserRecentNotesOutputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserRecentNotesOutputDto>(data, _mappings, UserRecentNotesOutputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteId"] = this.noteId;
        data["note"] = this.note;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["isCheckOutNote"] = this.isCheckOutNote;
        data["lastModificationTimeAsString"] = this.lastModificationTimeAsString;
        data["lastModificationTime"] = this.lastModificationTime;
        data["contactTypeId"] = this.contactTypeId;
        data["contactType"] = this.contactType;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IUserRecentNotesOutputDto {
    noteId: number | undefined;
    note: string | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    isCheckOutNote: boolean | undefined;
    lastModificationTimeAsString: string | undefined;
    lastModificationTime: string | undefined;
    contactTypeId: number | undefined;
    contactType: string | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
}

export class UserRecentNotesOutputDtoListIHandleError implements IUserRecentNotesOutputDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserRecentNotesOutputDto[] | undefined;
    listOfEntities!: UserRecentNotesOutputDto[][] | undefined;

    constructor(data?: IUserRecentNotesOutputDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(UserRecentNotesOutputDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserRecentNotesOutputDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserRecentNotesOutputDtoListIHandleError>(data, _mappings, UserRecentNotesOutputDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IUserRecentNotesOutputDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserRecentNotesOutputDto[] | undefined;
    listOfEntities: UserRecentNotesOutputDto[][] | undefined;
}

export class ShareFileByEmailInput implements IShareFileByEmailInput {
    to!: string[] | undefined;
    fileName!: string | undefined;
    htmlEmailBody!: string | undefined;
    message!: string | undefined;
    fileId!: string | undefined;
    driveId!: string | undefined;
    accessLevel!: string | undefined;
    permission!: string | undefined;
    preventsDownload!: boolean | undefined;
    recipients!: string[] | undefined;

    constructor(data?: IShareFileByEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            this.fileName = _data["fileName"];
            this.htmlEmailBody = _data["htmlEmailBody"];
            this.message = _data["message"];
            this.fileId = _data["fileId"];
            this.driveId = _data["driveId"];
            this.accessLevel = _data["accessLevel"];
            this.permission = _data["permission"];
            this.preventsDownload = _data["preventsDownload"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ShareFileByEmailInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ShareFileByEmailInput>(data, _mappings, ShareFileByEmailInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        data["fileName"] = this.fileName;
        data["htmlEmailBody"] = this.htmlEmailBody;
        data["message"] = this.message;
        data["fileId"] = this.fileId;
        data["driveId"] = this.driveId;
        data["accessLevel"] = this.accessLevel;
        data["permission"] = this.permission;
        data["preventsDownload"] = this.preventsDownload;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        return data;
    }
}

export interface IShareFileByEmailInput {
    to: string[] | undefined;
    fileName: string | undefined;
    htmlEmailBody: string | undefined;
    message: string | undefined;
    fileId: string | undefined;
    driveId: string | undefined;
    accessLevel: string | undefined;
    permission: string | undefined;
    preventsDownload: boolean | undefined;
    recipients: string[] | undefined;
}

export class CreateUserHistoryInput implements ICreateUserHistoryInput {
    userId!: number | undefined;
    tenantId!: number | undefined;
    keyId!: number | undefined;
    tblId!: number | undefined;
    type!: number | undefined;

    constructor(data?: ICreateUserHistoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.keyId = _data["keyId"];
            this.tblId = _data["tblId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateUserHistoryInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateUserHistoryInput>(data, _mappings, CreateUserHistoryInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["keyId"] = this.keyId;
        data["tblId"] = this.tblId;
        data["type"] = this.type;
        return data;
    }
}

export interface ICreateUserHistoryInput {
    userId: number | undefined;
    tenantId: number | undefined;
    keyId: number | undefined;
    tblId: number | undefined;
    type: number | undefined;
}

export class UserSuggestedProjectDto implements IUserSuggestedProjectDto {
    projectId!: number | undefined;
    projectName!: string | undefined;
    haveChecklistTemplate!: boolean | undefined;
    isAutoAdd!: boolean | undefined;
    associationName!: string | undefined;

    constructor(data?: IUserSuggestedProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.haveChecklistTemplate = _data["haveChecklistTemplate"];
            this.isAutoAdd = _data["isAutoAdd"];
            this.associationName = _data["associationName"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserSuggestedProjectDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserSuggestedProjectDto>(data, _mappings, UserSuggestedProjectDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["haveChecklistTemplate"] = this.haveChecklistTemplate;
        data["isAutoAdd"] = this.isAutoAdd;
        data["associationName"] = this.associationName;
        return data;
    }
}

export interface IUserSuggestedProjectDto {
    projectId: number | undefined;
    projectName: string | undefined;
    haveChecklistTemplate: boolean | undefined;
    isAutoAdd: boolean | undefined;
    associationName: string | undefined;
}

export class UserSuggestedProjectDtoListIHandleError implements IUserSuggestedProjectDtoListIHandleError {
    errorMessage!: string | undefined;
    isError!: boolean | undefined;
    errorType!: ErrorTypes | undefined;
    entityId!: number | undefined;
    longTypeEntityId!: number | undefined;
    message_Info!: string | undefined;
    responseData!: UserSuggestedProjectDto[] | undefined;
    listOfEntities!: UserSuggestedProjectDto[][] | undefined;

    constructor(data?: IUserSuggestedProjectDtoListIHandleError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isError = _data["isError"];
            this.errorType = _data["errorType"];
            this.entityId = _data["entityId"];
            this.longTypeEntityId = _data["longTypeEntityId"];
            this.message_Info = _data["message_Info"];
            if (Array.isArray(_data["responseData"])) {
                this.responseData = [] as any;
                for (let item of _data["responseData"])
                    this.responseData!.push(UserSuggestedProjectDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["listOfEntities"])) {
                this.listOfEntities = [] as any;
                for (let item of _data["listOfEntities"])
                    this.listOfEntities!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserSuggestedProjectDtoListIHandleError | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserSuggestedProjectDtoListIHandleError>(data, _mappings, UserSuggestedProjectDtoListIHandleError);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["errorType"] = this.errorType;
        data["entityId"] = this.entityId;
        data["longTypeEntityId"] = this.longTypeEntityId;
        data["message_Info"] = this.message_Info;
        if (Array.isArray(this.responseData)) {
            data["responseData"] = [];
            for (let item of this.responseData)
                data["responseData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.listOfEntities)) {
            data["listOfEntities"] = [];
            for (let item of this.listOfEntities)
                data["listOfEntities"].push(item);
        }
        return data;
    }
}

export interface IUserSuggestedProjectDtoListIHandleError {
    errorMessage: string | undefined;
    isError: boolean | undefined;
    errorType: ErrorTypes | undefined;
    entityId: number | undefined;
    longTypeEntityId: number | undefined;
    message_Info: string | undefined;
    responseData: UserSuggestedProjectDto[] | undefined;
    listOfEntities: UserSuggestedProjectDto[][] | undefined;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName!: string | undefined;
    userNameOrEmail!: string | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    result!: string | undefined;
    creationTime!: string | undefined;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userNameOrEmail = _data["userNameOrEmail"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.result = _data["result"];
            this.creationTime = _data["creationTime"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserLoginAttemptDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserLoginAttemptDto>(data, _mappings, UserLoginAttemptDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime;
        return data;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: string | undefined;
}

export class UserLoginAttemptDtoListResultDto implements IUserLoginAttemptDtoListResultDto {
    items!: UserLoginAttemptDto[] | undefined;

    constructor(data?: IUserLoginAttemptDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserLoginAttemptDto.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserLoginAttemptDtoListResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserLoginAttemptDtoListResultDto>(data, _mappings, UserLoginAttemptDtoListResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserLoginAttemptDtoListResultDto {
    items: UserLoginAttemptDto[] | undefined;
}

export class KeysInputDto implements IKeysInputDto {
    auth!: string | undefined;
    p256dh!: string | undefined;

    constructor(data?: IKeysInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.auth = _data["auth"];
            this.p256dh = _data["p256dh"];
        }
    }

    static fromJS(data: any, _mappings?: any): KeysInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<KeysInputDto>(data, _mappings, KeysInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auth"] = this.auth;
        data["p256dh"] = this.p256dh;
        return data;
    }
}

export interface IKeysInputDto {
    auth: string | undefined;
    p256dh: string | undefined;
}

export class UserNotificationSubscriptionInputDto implements IUserNotificationSubscriptionInputDto {
    userId!: number | undefined;
    endPoint!: string | undefined;
    keys!: KeysInputDto | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;

    constructor(data?: IUserNotificationSubscriptionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.endPoint = _data["endPoint"];
            this.keys = _data["keys"] ? KeysInputDto.fromJS(_data["keys"], _mappings) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserNotificationSubscriptionInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserNotificationSubscriptionInputDto>(data, _mappings, UserNotificationSubscriptionInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["endPoint"] = this.endPoint;
        data["keys"] = this.keys ? this.keys.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        return data;
    }
}

export interface IUserNotificationSubscriptionInputDto {
    userId: number | undefined;
    endPoint: string | undefined;
    keys: KeysInputDto | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
}

export enum UserNotificationType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class ResponseNotificationDto implements IResponseNotificationDto {
    taskTitle!: string | undefined;
    fullName!: string | undefined;
    dueDate!: string | undefined;
    projectName!: string | undefined;
    firstName!: string | undefined;
    userId!: number | undefined;

    constructor(data?: IResponseNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.taskTitle = _data["taskTitle"];
            this.fullName = _data["fullName"];
            this.dueDate = _data["dueDate"];
            this.projectName = _data["projectName"];
            this.firstName = _data["firstName"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ResponseNotificationDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ResponseNotificationDto>(data, _mappings, ResponseNotificationDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskTitle"] = this.taskTitle;
        data["fullName"] = this.fullName;
        data["dueDate"] = this.dueDate;
        data["projectName"] = this.projectName;
        data["firstName"] = this.firstName;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IResponseNotificationDto {
    taskTitle: string | undefined;
    fullName: string | undefined;
    dueDate: string | undefined;
    projectName: string | undefined;
    firstName: string | undefined;
    userId: number | undefined;
}

export class NotifyUserInput implements INotifyUserInput {
    notifType!: UserNotificationType | undefined;
    notificationDto!: ResponseNotificationDto | undefined;

    constructor(data?: INotifyUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.notifType = _data["notifType"];
            this.notificationDto = _data["notificationDto"] ? ResponseNotificationDto.fromJS(_data["notificationDto"], _mappings) : undefined as any;
        }
    }

    static fromJS(data: any, _mappings?: any): NotifyUserInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<NotifyUserInput>(data, _mappings, NotifyUserInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notifType"] = this.notifType;
        data["notificationDto"] = this.notificationDto ? this.notificationDto.toJSON() : undefined as any;
        return data;
    }
}

export interface INotifyUserInput {
    notifType: UserNotificationType | undefined;
    notificationDto: ResponseNotificationDto | undefined;
}

export class UserProductivityInputDto implements IUserProductivityInputDto {
    id!: number | undefined;
    checkInId!: number | undefined;
    productivityRate!: number | undefined;
    personalNote!: string | undefined;
    workChallenges!: string | undefined;
    futureNotes!: string | undefined;

    constructor(data?: IUserProductivityInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.checkInId = _data["checkInId"];
            this.productivityRate = _data["productivityRate"];
            this.personalNote = _data["personalNote"];
            this.workChallenges = _data["workChallenges"];
            this.futureNotes = _data["futureNotes"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserProductivityInputDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserProductivityInputDto>(data, _mappings, UserProductivityInputDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["checkInId"] = this.checkInId;
        data["productivityRate"] = this.productivityRate;
        data["personalNote"] = this.personalNote;
        data["workChallenges"] = this.workChallenges;
        data["futureNotes"] = this.futureNotes;
        return data;
    }
}

export interface IUserProductivityInputDto {
    id: number | undefined;
    checkInId: number | undefined;
    productivityRate: number | undefined;
    personalNote: string | undefined;
    workChallenges: string | undefined;
    futureNotes: string | undefined;
}

export class StringStringValuesKeyValuePair implements IStringStringValuesKeyValuePair {
    readonly key!: string | undefined;
    readonly value!: string[] | undefined;

    constructor(data?: IStringStringValuesKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            (this as any).key = _data["key"];
            if (Array.isArray(_data["value"])) {
                (this as any).value = [] as any;
                for (let item of _data["value"])
                    (this as any).value!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): StringStringValuesKeyValuePair | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<StringStringValuesKeyValuePair>(data, _mappings, StringStringValuesKeyValuePair);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IStringStringValuesKeyValuePair {
    key: string | undefined;
    value: string[] | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of _data["latestWebLogLines"])
                    this.latestWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): GetLatestWebLogsOutput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<GetLatestWebLogsOutput>(data, _mappings, GetLatestWebLogsOutput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class WorkspaceGridLayoutDto implements IWorkspaceGridLayoutDto {
    gridName!: string | undefined;
    hasDefault!: boolean | undefined;
    layoutJson!: string | undefined;
    updatedAtUtc!: string | undefined;

    constructor(data?: IWorkspaceGridLayoutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.gridName = _data["gridName"];
            this.hasDefault = _data["hasDefault"];
            this.layoutJson = _data["layoutJson"];
            this.updatedAtUtc = _data["updatedAtUtc"];
        }
    }

    static fromJS(data: any, _mappings?: any): WorkspaceGridLayoutDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<WorkspaceGridLayoutDto>(data, _mappings, WorkspaceGridLayoutDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gridName"] = this.gridName;
        data["hasDefault"] = this.hasDefault;
        data["layoutJson"] = this.layoutJson;
        data["updatedAtUtc"] = this.updatedAtUtc;
        return data;
    }
}

export interface IWorkspaceGridLayoutDto {
    gridName: string | undefined;
    hasDefault: boolean | undefined;
    layoutJson: string | undefined;
    updatedAtUtc: string | undefined;
}

export class SaveWorkspaceGridLayoutInput implements ISaveWorkspaceGridLayoutInput {
    gridName!: string;
    layoutJson!: string;

    constructor(data?: ISaveWorkspaceGridLayoutInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.gridName = _data["gridName"];
            this.layoutJson = _data["layoutJson"];
        }
    }

    static fromJS(data: any, _mappings?: any): SaveWorkspaceGridLayoutInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveWorkspaceGridLayoutInput>(data, _mappings, SaveWorkspaceGridLayoutInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gridName"] = this.gridName;
        data["layoutJson"] = this.layoutJson;
        return data;
    }
}

export interface ISaveWorkspaceGridLayoutInput {
    gridName: string;
    layoutJson: string;
}

export class ResetWorkspaceGridLayoutInput implements IResetWorkspaceGridLayoutInput {
    gridName!: string;

    constructor(data?: IResetWorkspaceGridLayoutInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.gridName = _data["gridName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ResetWorkspaceGridLayoutInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ResetWorkspaceGridLayoutInput>(data, _mappings, ResetWorkspaceGridLayoutInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gridName"] = this.gridName;
        return data;
    }
}

export interface IResetWorkspaceGridLayoutInput {
    gridName: string;
}

function jsonParse(json: any, reviver?: any) {
    json = JSON.parse(json, reviver);

    var byid: any = {};
    var refs: any = [];
    json = (function recurse(obj: any, prop?: any, parent?: any) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        
        if ("$ref" in obj) {
            let ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        } else if ("$id" in obj) {
            let id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        
        if (Array.isArray(obj)) {
            obj = obj.map((v, i) => recurse(v, i, obj));
        } else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }

        return obj;
    })(json);

    for (let i = 0; i < refs.length; i++) {
        const ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }

    return json;
}

function createInstance<T>(data: any, mappings: any, type: any): T | null {
  if (!mappings)
    mappings = [];
  if (!data)
    return null;

  const mappingIndexName = "__mappingIndex";
  if (data[mappingIndexName])
    return <T>mappings[data[mappingIndexName]].target;

  data[mappingIndexName] = mappings.length;

  let result: any = new type();
  mappings.push({ source: data, target: result });
  result.init(data, mappings);
  // Copy any data properties that init() didn't map (fixes empty ValueTuple classes)
  for (const key of Object.keys(data)) {
    if (key !== mappingIndexName && result[key] === undefined) {
      result[key] = data[key];
    }
  }
  return result;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}